function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref53f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref53f"] = parcelRequire;
}
parcelRequire.register("kjyEk", function(module, exports) {
"use strict";

});

parcelRequire.register("8vghX", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $630dda8d81b1b9e8$require$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");

var $59kwG = parcelRequire("59kwG");

var $ccDAZ = parcelRequire("ccDAZ");

var $5UUfm = parcelRequire("5UUfm");

var $igpJr = parcelRequire("igpJr");
const $630dda8d81b1b9e8$var$version = $igpJr.version;
const $630dda8d81b1b9e8$var$LINE = /(?:^|^)\s*(?:export\s+)?([\w.-]+)(?:\s*=\s*?|:\s+?)(\s*'(?:\\'|[^'])*'|\s*"(?:\\"|[^"])*"|\s*`(?:\\`|[^`])*`|[^#\r\n]+)?\s*(?:#.*)?(?:$|$)/mg;
// Parse src into an Object
function $630dda8d81b1b9e8$var$parse(src) {
    const obj = {};
    // Convert buffer to string
    let lines = src.toString();
    // Convert line breaks to same format
    lines = lines.replace(/\r\n?/mg, "\n");
    let match;
    while((match = $630dda8d81b1b9e8$var$LINE.exec(lines)) != null){
        const key = match[1];
        // Default undefined or null to empty string
        let value = match[2] || "";
        // Remove whitespace
        value = value.trim();
        // Check if double quoted
        const maybeQuote = value[0];
        // Remove surrounding quotes
        value = value.replace(/^(['"`])([\s\S]*)\1$/mg, "$2");
        // Expand newlines if double quoted
        if (maybeQuote === '"') {
            value = value.replace(/\\n/g, "\n");
            value = value.replace(/\\r/g, "\r");
        }
        // Add to object
        obj[key] = value;
    }
    return obj;
}
function $630dda8d81b1b9e8$var$_parseVault(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // Parse .env.vault
    const result = $630dda8d81b1b9e8$var$DotenvModule.configDotenv({
        path: vaultPath
    });
    if (!result.parsed) throw new Error(`MISSING_DATA: Cannot parse ${vaultPath} for an unknown reason`);
    // handle scenario for comma separated keys - for use with key rotation
    // example: DOTENV_KEY="dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=prod,dotenv://:key_7890@dotenv.org/vault/.env.vault?environment=prod"
    const keys = $630dda8d81b1b9e8$var$_dotenvKey(options).split(",");
    const length = keys.length;
    let decrypted;
    for(let i = 0; i < length; i++)try {
        // Get full key
        const key = keys[i].trim();
        // Get instructions for decrypt
        const attrs = $630dda8d81b1b9e8$var$_instructions(result, key);
        // Decrypt
        decrypted = $630dda8d81b1b9e8$var$DotenvModule.decrypt(attrs.ciphertext, attrs.key);
        break;
    } catch (error) {
        // last key
        if (i + 1 >= length) throw error;
    // try next key
    }
    // Parse decrypted .env string
    return $630dda8d81b1b9e8$var$DotenvModule.parse(decrypted);
}
function $630dda8d81b1b9e8$var$_log(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][INFO] ${message}`);
}
function $630dda8d81b1b9e8$var$_warn(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][WARN] ${message}`);
}
function $630dda8d81b1b9e8$var$_debug(message) {
    console.log(`[dotenv@${$630dda8d81b1b9e8$var$version}][DEBUG] ${message}`);
}
function $630dda8d81b1b9e8$var$_dotenvKey(options) {
    // prioritize developer directly setting options.DOTENV_KEY
    if (options && options.DOTENV_KEY && options.DOTENV_KEY.length > 0) return options.DOTENV_KEY;
    // fallback to empty string
    return "";
}
function $630dda8d81b1b9e8$var$_instructions(result, dotenvKey) {
    // Parse DOTENV_KEY. Format is a URI
    let uri;
    try {
        uri = new URL(dotenvKey);
    } catch (error) {
        if (error.code === "ERR_INVALID_URL") throw new Error("INVALID_DOTENV_KEY: Wrong format. Must be in valid uri format like dotenv://:key_1234@dotenv.org/vault/.env.vault?environment=development");
        throw error;
    }
    // Get decrypt key
    const key = uri.password;
    if (!key) throw new Error("INVALID_DOTENV_KEY: Missing key part");
    // Get environment
    const environment = uri.searchParams.get("environment");
    if (!environment) throw new Error("INVALID_DOTENV_KEY: Missing environment part");
    // Get ciphertext payload
    const environmentKey = `DOTENV_VAULT_${environment.toUpperCase()}`;
    const ciphertext = result.parsed[environmentKey] // DOTENV_VAULT_PRODUCTION
    ;
    if (!ciphertext) throw new Error(`NOT_FOUND_DOTENV_ENVIRONMENT: Cannot locate environment ${environmentKey} in your .env.vault file.`);
    return {
        ciphertext: ciphertext,
        key: key
    };
}
function $630dda8d81b1b9e8$var$_vaultPath(options) {
    let dotenvPath = $59kwG.resolve($hPtJY.cwd(), ".env");
    if (options && options.path && options.path.length > 0) dotenvPath = options.path;
    // Locate .env.vault
    return dotenvPath.endsWith(".vault") ? dotenvPath : `${dotenvPath}.vault`;
}
function $630dda8d81b1b9e8$var$_resolveHome(envPath) {
    return envPath[0] === "~" ? $59kwG.join($ccDAZ.homedir(), envPath.slice(1)) : envPath;
}
function $630dda8d81b1b9e8$var$_configVault(options) {
    $630dda8d81b1b9e8$var$_log("Loading env from encrypted .env.vault");
    const parsed = $630dda8d81b1b9e8$var$DotenvModule._parseVault(options);
    let processEnv = {};
    if (options && options.processEnv != null) processEnv = options.processEnv;
    $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
    return {
        parsed: parsed
    };
}
function $630dda8d81b1b9e8$var$configDotenv(options) {
    let dotenvPath = $59kwG.resolve($hPtJY.cwd(), ".env");
    let encoding = "utf8";
    const debug = Boolean(options && options.debug);
    if (options) {
        if (options.path != null) dotenvPath = $630dda8d81b1b9e8$var$_resolveHome(options.path);
        if (options.encoding != null) encoding = options.encoding;
    }
    try {
        // Specifying an encoding returns a string instead of a buffer
        const parsed = $630dda8d81b1b9e8$var$DotenvModule.parse($kjyEk.readFileSync(dotenvPath, {
            encoding: encoding
        }));
        let processEnv = {};
        if (options && options.processEnv != null) processEnv = options.processEnv;
        $630dda8d81b1b9e8$var$DotenvModule.populate(processEnv, parsed, options);
        return {
            parsed: parsed
        };
    } catch (e) {
        if (debug) $630dda8d81b1b9e8$var$_debug(`Failed to load ${dotenvPath} ${e.message}`);
        return {
            error: e
        };
    }
}
// Populates process.env from .env file
function $630dda8d81b1b9e8$var$config(options) {
    const vaultPath = $630dda8d81b1b9e8$var$_vaultPath(options);
    // fallback to original dotenv if DOTENV_KEY is not set
    if ($630dda8d81b1b9e8$var$_dotenvKey(options).length === 0) return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    // dotenvKey exists but .env.vault file does not exist
    if (!$kjyEk.existsSync(vaultPath)) {
        $630dda8d81b1b9e8$var$_warn(`You set DOTENV_KEY but you are missing a .env.vault file at ${vaultPath}. Did you forget to build it?`);
        return $630dda8d81b1b9e8$var$DotenvModule.configDotenv(options);
    }
    return $630dda8d81b1b9e8$var$DotenvModule._configVault(options);
}
function $630dda8d81b1b9e8$var$decrypt(encrypted, keyStr) {
    const key = $630dda8d81b1b9e8$require$Buffer.from(keyStr.slice(-64), "hex");
    let ciphertext = $630dda8d81b1b9e8$require$Buffer.from(encrypted, "base64");
    const nonce = ciphertext.slice(0, 12);
    const authTag = ciphertext.slice(-16);
    ciphertext = ciphertext.slice(12, -16);
    try {
        const aesgcm = $5UUfm.createDecipheriv("aes-256-gcm", key, nonce);
        aesgcm.setAuthTag(authTag);
        return `${aesgcm.update(ciphertext)}${aesgcm.final()}`;
    } catch (error) {
        const isRange = error instanceof RangeError;
        const invalidKeyLength = error.message === "Invalid key length";
        const decryptionFailed = error.message === "Unsupported state or unable to authenticate data";
        if (isRange || invalidKeyLength) {
            const msg = "INVALID_DOTENV_KEY: It must be 64 characters long (or more)";
            throw new Error(msg);
        } else if (decryptionFailed) {
            const msg = "DECRYPTION_FAILED: Please check your DOTENV_KEY";
            throw new Error(msg);
        } else {
            console.error("Error: ", error.code);
            console.error("Error: ", error.message);
            throw error;
        }
    }
}
// Populate process.env with parsed values
function $630dda8d81b1b9e8$var$populate(processEnv, parsed, options = {}) {
    const debug = Boolean(options && options.debug);
    const override = Boolean(options && options.override);
    if (typeof parsed !== "object") throw new Error("OBJECT_REQUIRED: Please check the processEnv argument being passed to populate");
    // Set process.env
    for (const key of Object.keys(parsed))if (Object.prototype.hasOwnProperty.call(processEnv, key)) {
        if (override === true) processEnv[key] = parsed[key];
        if (debug) {
            if (override === true) $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and WAS overwritten`);
            else $630dda8d81b1b9e8$var$_debug(`"${key}" is already defined and was NOT overwritten`);
        }
    } else processEnv[key] = parsed[key];
}
const $630dda8d81b1b9e8$var$DotenvModule = {
    configDotenv: $630dda8d81b1b9e8$var$configDotenv,
    _configVault: $630dda8d81b1b9e8$var$_configVault,
    _parseVault: $630dda8d81b1b9e8$var$_parseVault,
    config: $630dda8d81b1b9e8$var$config,
    decrypt: $630dda8d81b1b9e8$var$decrypt,
    parse: $630dda8d81b1b9e8$var$parse,
    populate: $630dda8d81b1b9e8$var$populate
};
module.exports.configDotenv = $630dda8d81b1b9e8$var$DotenvModule.configDotenv;
module.exports._configVault = $630dda8d81b1b9e8$var$DotenvModule._configVault;
module.exports._parseVault = $630dda8d81b1b9e8$var$DotenvModule._parseVault;
module.exports.config = $630dda8d81b1b9e8$var$DotenvModule.config;
module.exports.decrypt = $630dda8d81b1b9e8$var$DotenvModule.decrypt;
module.exports.parse = $630dda8d81b1b9e8$var$DotenvModule.parse;
module.exports.populate = $630dda8d81b1b9e8$var$DotenvModule.populate;
module.exports = $630dda8d81b1b9e8$var$DotenvModule;

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("59kwG", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $3bfdb7183e8721d6$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $3bfdb7183e8721d6$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $3bfdb7183e8721d6$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $3bfdb7183e8721d6$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $hPtJY.cwd();
                path = cwd;
            }
            $3bfdb7183e8721d6$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $3bfdb7183e8721d6$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $3bfdb7183e8721d6$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $3bfdb7183e8721d6$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $3bfdb7183e8721d6$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $3bfdb7183e8721d6$var$assertPath(from);
        $3bfdb7183e8721d6$var$assertPath(to);
        if (from === to) return "";
        from = $3bfdb7183e8721d6$var$posix.resolve(from);
        to = $3bfdb7183e8721d6$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $3bfdb7183e8721d6$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $3bfdb7183e8721d6$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $3bfdb7183e8721d6$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$3bfdb7183e8721d6$var$posix.posix = $3bfdb7183e8721d6$var$posix;
module.exports = $3bfdb7183e8721d6$var$posix;

});

parcelRequire.register("ccDAZ", function(module, exports) {

$parcel$export(module.exports, "homedir", () => $8e2551e033e95cb5$export$c1d46b5ea6262c0b, (v) => $8e2551e033e95cb5$export$c1d46b5ea6262c0b = v);
var $8e2551e033e95cb5$export$edf525f30916fbb8;
var $8e2551e033e95cb5$export$640106f6dc7d2706;
var $8e2551e033e95cb5$export$3ea386628068cf62;
var $8e2551e033e95cb5$export$749d472264fad440;
var $8e2551e033e95cb5$export$8b931a48d9488767;
var $8e2551e033e95cb5$export$9123f37609399513;
var $8e2551e033e95cb5$export$9b60beb643db4d69;
var $8e2551e033e95cb5$export$bf9fb029d174d554;
var $8e2551e033e95cb5$export$23d3fad09dc44362;
var $8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5;
var $8e2551e033e95cb5$export$3bf7c33313eba0fe;
var $8e2551e033e95cb5$export$7925d89f138dad5b;
var $8e2551e033e95cb5$export$722a64dea1b767dc;
var $8e2551e033e95cb5$export$9e6c06a7d47f9af7;
var $8e2551e033e95cb5$export$6b76988456c0292f;
var $8e2551e033e95cb5$export$266d3b9babd1fc45;
var $8e2551e033e95cb5$export$c1d46b5ea6262c0b;
$8e2551e033e95cb5$export$edf525f30916fbb8 = function() {
    return "LE";
};
$8e2551e033e95cb5$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$8e2551e033e95cb5$export$3ea386628068cf62 = function() {
    return [];
};
$8e2551e033e95cb5$export$749d472264fad440 = function() {
    return 0;
};
$8e2551e033e95cb5$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$8e2551e033e95cb5$export$9b60beb643db4d69 = function() {
    return [];
};
$8e2551e033e95cb5$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$8e2551e033e95cb5$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$8e2551e033e95cb5$export$d2f3c2f7e0c7dcf5 = $8e2551e033e95cb5$export$3bf7c33313eba0fe = function() {
    return {};
};
$8e2551e033e95cb5$export$7925d89f138dad5b = function() {
    return "javascript";
};
$8e2551e033e95cb5$export$722a64dea1b767dc = function() {
    return "browser";
};
$8e2551e033e95cb5$export$9e6c06a7d47f9af7 = $8e2551e033e95cb5$export$6b76988456c0292f = function() {
    return "/tmp";
};
$8e2551e033e95cb5$export$266d3b9babd1fc45 = "\n";
$8e2551e033e95cb5$export$c1d46b5ea6262c0b = function() {
    return "/";
};

});

parcelRequire.register("5UUfm", function(module, exports) {

$parcel$export(module.exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRequire.register("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRequire.register("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRequire.register("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRequire.register("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRequire.register("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRequire.register("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $abf00c68ae11d39d$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRequire.register("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRequire.register("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRequire.register("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRequire.register("04a3B", function(module, exports) {
"use strict";

var $6JySE = parcelRequire("6JySE");
var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = $6JySE.codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRequire.register("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRequire.register("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $6JySE = parcelRequire("6JySE");
var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = $6JySE.codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRequire.register("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});




parcelRequire.register("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRequire.register("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRequire.register("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRequire.register("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRequire.register("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRequire.register("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRequire.register("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRequire.register("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRequire.register("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRequire.register("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRequire.register("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRequire.register("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRequire.register("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRequire.register("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRequire.register("eFSIF", function(module, exports) {

module.exports = (parcelRequire("6swAi"));

});
parcelRequire.register("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRequire.register("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRequire.register("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRequire.register("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRequire.register("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRequire.register("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRequire.register("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRequire.register("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRequire.register("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede3": $8SeDJ.EDE,
    "des-ede-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede": $8SeDJ.EDE,
    "des-cbc": $8SeDJ.CBC.instantiate($8SeDJ.DES),
    "des-ecb": $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRequire.register("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRequire.register("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRequire.register("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRequire.register("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRequire.register("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRequire.register("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRequire.register("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRequire.register("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRequire.register("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRequire.register("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRequire.register("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRequire.register("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRequire.register("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRequire.register("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRequire.register("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRequire.register("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRequire.register("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRequire.register("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRequire.register("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRequire.register("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRequire.register("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRequire.register("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRequire.register("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRequire.register("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRequire.register("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRequire.register("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, "hex");
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRequire.register("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRequire.register("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("g2bJL", function(module, exports) {

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRequire.register("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRequire.register("kGErQ", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRequire.register("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRequire.register("4zMFU", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $3550302076d9e62e$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $3550302076d9e62e$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sig, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRequire.register("6E9kG", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRequire.register("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});
parcelRequire.register("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRequire.register("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRequire.register("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRequire.register("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRequire.register("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRequire.register("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRequire.register("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRequire.register("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRequire.register("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRequire.register("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRequire.register("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRequire.register("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRequire.register("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRequire.register("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRequire.register("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRequire.register("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRequire.register("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRequire.register("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRequire.register("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRequire.register("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRequire.register("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRequire.register("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRequire.register("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRequire.register("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRequire.register("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRequire.register("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRequire.register("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRequire.register("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRequire.register("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRequire.register("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $9qVGS = parcelRequire("9qVGS");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $9qVGS(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRequire.register("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRequire.register("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRequire.register("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});


parcelRequire.register("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRequire.register("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRequire.register("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRequire.register("aYksR", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRequire.register("fQdau", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRequire.register("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRequire.register("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRequire.register("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRequire.register("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRequire.register("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRequire.register("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRequire.register("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRequire.register("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});


parcelRequire.register("igpJr", function(module, exports) {
module.exports = JSON.parse('{"name":"dotenv","version":"16.3.1","description":"Loads environment variables from .env file","main":"lib/main.js","types":"lib/main.d.ts","exports":{".":{"types":"./lib/main.d.ts","require":"./lib/main.js","default":"./lib/main.js"},"./config":"./config.js","./config.js":"./config.js","./lib/env-options":"./lib/env-options.js","./lib/env-options.js":"./lib/env-options.js","./lib/cli-options":"./lib/cli-options.js","./lib/cli-options.js":"./lib/cli-options.js","./package.json":"./package.json"},"scripts":{"dts-check":"tsc --project tests/types/tsconfig.json","lint":"standard","lint-readme":"standard-markdown","pretest":"npm run lint && npm run dts-check","test":"tap tests/*.js --100 -Rspec","prerelease":"npm test","release":"standard-version"},"repository":{"type":"git","url":"git://github.com/motdotla/dotenv.git"},"funding":"https://github.com/motdotla/dotenv?sponsor=1","keywords":["dotenv","env",".env","environment","variables","config","settings"],"readmeFilename":"README.md","license":"BSD-2-Clause","devDependencies":{"@definitelytyped/dtslint":"^0.0.133","@types/node":"^18.11.3","decache":"^4.6.1","sinon":"^14.0.1","standard":"^17.0.0","standard-markdown":"^7.1.0","standard-version":"^9.5.0","tap":"^16.3.0","tar":"^6.1.11","typescript":"^4.8.4"},"engines":{"node":">=12"},"browser":{"fs":false}}');

});


var $d47795690082d4de$exports = {};
/* build: `node build.js modules=ALL exclude=gestures,accessors,erasing requirejs minifier=uglifyjs` */ /*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $d47795690082d4de$require$Buffer = $6ZWSX.Buffer;
var $d47795690082d4de$var$fabric = $d47795690082d4de$var$fabric || {
    version: "5.3.0"
};
$d47795690082d4de$exports.fabric = $d47795690082d4de$var$fabric;



/* _AMD_END_ */ if (typeof document !== "undefined" && typeof window !== "undefined") {
    if (document instanceof (typeof HTMLDocument !== "undefined" ? HTMLDocument : Document)) $d47795690082d4de$var$fabric.document = document;
    else $d47795690082d4de$var$fabric.document = document.implementation.createHTMLDocument("");
    $d47795690082d4de$var$fabric.window = window;
} else {
    // assume we're running under node.js when document/window are not present
    var $d47795690082d4de$var$jsdom = (parcelRequire("kjyEk"));
    var $d47795690082d4de$var$virtualWindow = new $d47795690082d4de$var$jsdom.JSDOM(decodeURIComponent("%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E"), {
        features: {
            FetchExternalResources: [
                "img"
            ]
        },
        resources: "usable"
    }).window;
    $d47795690082d4de$var$fabric.document = $d47795690082d4de$var$virtualWindow.document;
    $d47795690082d4de$var$fabric.jsdomImplForWrapper = (parcelRequire("kjyEk")).implForWrapper;
    $d47795690082d4de$var$fabric.nodeCanvas = (parcelRequire("kjyEk")).Canvas;
    $d47795690082d4de$var$fabric.window = $d47795690082d4de$var$virtualWindow;
    DOMParser = $d47795690082d4de$var$fabric.window.DOMParser;
}
/**
 * True when in environment that supports touch events
 * @type boolean
 */ $d47795690082d4de$var$fabric.isTouchSupported = "ontouchstart" in $d47795690082d4de$var$fabric.window || "ontouchstart" in $d47795690082d4de$var$fabric.document || $d47795690082d4de$var$fabric.window && $d47795690082d4de$var$fabric.window.navigator && $d47795690082d4de$var$fabric.window.navigator.maxTouchPoints > 0;
/**
 * True when in environment that's probably Node.js
 * @type boolean
 */ $d47795690082d4de$var$fabric.isLikelyNode = typeof $d47795690082d4de$require$Buffer !== "undefined" && typeof window === "undefined";
/* _FROM_SVG_START_ */ /**
 * Attributes parsed from all SVG elements
 * @type array
 */ $d47795690082d4de$var$fabric.SHARED_ATTRIBUTES = [
    "display",
    "transform",
    "fill",
    "fill-opacity",
    "fill-rule",
    "opacity",
    "stroke",
    "stroke-dasharray",
    "stroke-linecap",
    "stroke-dashoffset",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "id",
    "paint-order",
    "vector-effect",
    "instantiated_by_use",
    "clip-path"
];
/* _FROM_SVG_END_ */ /**
 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
 */ $d47795690082d4de$var$fabric.DPI = 96;
$d47795690082d4de$var$fabric.reNum = "(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)";
$d47795690082d4de$var$fabric.commaWsp = "(?:\\s+,?\\s*|,\\s*)";
$d47795690082d4de$var$fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/ig;
$d47795690082d4de$var$fabric.reNonWord = /[ \n\.,;!\?\-]/;
$d47795690082d4de$var$fabric.fontPaths = {};
$d47795690082d4de$var$fabric.iMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
];
$d47795690082d4de$var$fabric.svgNS = "http://www.w3.org/2000/svg";
/**
 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
 * @since 1.7.14
 * @type Number
 * @default
 */ $d47795690082d4de$var$fabric.perfLimitSizeTotal = 2097152;
/**
 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
 * @since 1.7.14
 * @type Number
 * @default
 */ $d47795690082d4de$var$fabric.maxCacheSideLimit = 4096;
/**
 * Lowest pixel limit for cache canvases, set at 256PX
 * @since 1.7.14
 * @type Number
 * @default
 */ $d47795690082d4de$var$fabric.minCacheSideLimit = 256;
/**
 * Cache Object for widths of chars in text rendering.
 */ $d47795690082d4de$var$fabric.charWidthsCache = {};
/**
 * if webgl is enabled and available, textureSize will determine the size
 * of the canvas backend
 * @since 2.0.0
 * @type Number
 * @default
 */ $d47795690082d4de$var$fabric.textureSize = 2048;
/**
 * When 'true', style information is not retained when copy/pasting text, making
 * pasted text use destination style.
 * Defaults to 'false'.
 * @type Boolean
 * @default
 */ $d47795690082d4de$var$fabric.disableStyleCopyPaste = false;
/**
 * Enable webgl for filtering picture is available
 * A filtering backend will be initialized, this will both take memory and
 * time since a default 2048x2048 canvas will be created for the gl context
 * @since 2.0.0
 * @type Boolean
 * @default
 */ $d47795690082d4de$var$fabric.enableGLFiltering = true;
/**
 * Device Pixel Ratio
 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
 */ $d47795690082d4de$var$fabric.devicePixelRatio = $d47795690082d4de$var$fabric.window.devicePixelRatio || $d47795690082d4de$var$fabric.window.webkitDevicePixelRatio || $d47795690082d4de$var$fabric.window.mozDevicePixelRatio || 1;
/**
 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
 * which is unitless and not rendered equally across browsers.
 *
 * Values that work quite well (as of October 2017) are:
 * - Chrome: 1.5
 * - Edge: 1.75
 * - Firefox: 0.9
 * - Safari: 0.95
 *
 * @since 2.0.0
 * @type Number
 * @default 1
 */ $d47795690082d4de$var$fabric.browserShadowBlurConstant = 1;
/**
 * This object contains the result of arc to bezier conversion for faster retrieving if the same arc needs to be converted again.
 * It was an internal variable, is accessible since version 2.3.4
 */ $d47795690082d4de$var$fabric.arcToSegmentsCache = {};
/**
 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
 * you do not get any speed benefit and you get a big object in memory.
 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
 * can eventually clear it.
 * It was an internal variable, is accessible since version 2.3.4
 */ $d47795690082d4de$var$fabric.boundsOfCurveCache = {};
/**
 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
 * @default true
 */ $d47795690082d4de$var$fabric.cachesBoundsOfCurve = true;
/**
 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
 * this has to be set before instantiating the filtering backend ( before filtering the first image )
 * @type Boolean
 * @default false
 */ $d47795690082d4de$var$fabric.forceGLPutImageData = false;
$d47795690082d4de$var$fabric.initFilterBackend = function() {
    if ($d47795690082d4de$var$fabric.enableGLFiltering && $d47795690082d4de$var$fabric.isWebglSupported && $d47795690082d4de$var$fabric.isWebglSupported($d47795690082d4de$var$fabric.textureSize)) {
        console.log("max texture size: " + $d47795690082d4de$var$fabric.maxTextureSize);
        return new $d47795690082d4de$var$fabric.WebglFilterBackend({
            tileSize: $d47795690082d4de$var$fabric.textureSize
        });
    } else if ($d47795690082d4de$var$fabric.Canvas2dFilterBackend) return new $d47795690082d4de$var$fabric.Canvas2dFilterBackend();
};
if (typeof document !== "undefined" && typeof window !== "undefined") // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
window.fabric = $d47795690082d4de$var$fabric;
(function() {
    /**
   * @private
   * @param {String} eventName
   * @param {Function} handler
   */ function _removeEventListener(eventName, handler) {
        if (!this.__eventListeners[eventName]) return;
        var eventListener = this.__eventListeners[eventName];
        if (handler) eventListener[eventListener.indexOf(handler)] = false;
        else $d47795690082d4de$var$fabric.util.array.fill(eventListener, false);
    }
    /**
   * Observes specified event
   * @memberOf fabric.Observable
   * @alias on
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Self} thisArg
   * @chainable
   */ function on(eventName, handler) {
        if (!this.__eventListeners) this.__eventListeners = {};
        // one object with key/value pairs was passed
        if (arguments.length === 1) for(var prop in eventName)this.on(prop, eventName[prop]);
        else {
            if (!this.__eventListeners[eventName]) this.__eventListeners[eventName] = [];
            this.__eventListeners[eventName].push(handler);
        }
        return this;
    }
    function _once(eventName, handler) {
        var _handler = (function() {
            handler.apply(this, arguments);
            this.off(eventName, _handler);
        }).bind(this);
        this.on(eventName, _handler);
    }
    function once(eventName, handler) {
        // one object with key/value pairs was passed
        if (arguments.length === 1) for(var prop in eventName)_once.call(this, prop, eventName[prop]);
        else _once.call(this, eventName, handler);
        return this;
    }
    /**
   * Stops event observing for a particular event handler. Calling this method
   * without arguments removes all handlers for all events
   * @memberOf fabric.Observable
   * @alias off
   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function to be deleted from EventListeners
   * @return {Self} thisArg
   * @chainable
   */ function off(eventName, handler) {
        if (!this.__eventListeners) return this;
        // remove all key/value pairs (event name -> event handler)
        if (arguments.length === 0) for(eventName in this.__eventListeners)_removeEventListener.call(this, eventName);
        else if (arguments.length === 1 && typeof arguments[0] === "object") for(var prop in eventName)_removeEventListener.call(this, prop, eventName[prop]);
        else _removeEventListener.call(this, eventName, handler);
        return this;
    }
    /**
   * Fires event with an optional options object
   * @memberOf fabric.Observable
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   * @return {Self} thisArg
   * @chainable
   */ function fire(eventName, options) {
        if (!this.__eventListeners) return this;
        var listenersForEvent = this.__eventListeners[eventName];
        if (!listenersForEvent) return this;
        for(var i = 0, len = listenersForEvent.length; i < len; i++)listenersForEvent[i] && listenersForEvent[i].call(this, options || {});
        this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
            return value !== false;
        });
        return this;
    }
    /**
   * @namespace fabric.Observable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */ $d47795690082d4de$var$fabric.Observable = {
        fire: fire,
        on: on,
        once: once,
        off: off
    };
})();
/**
 * @namespace fabric.Collection
 */ $d47795690082d4de$var$fabric.Collection = {
    _objects: [],
    /**
   * Adds objects to collection, Canvas or Group, then renders canvas
   * (if `renderOnAddRemove` is not `false`).
   * in case of Group no changes to bounding box are made.
   * Objects should be instances of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the add method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */ add: function() {
        this._objects.push.apply(this._objects, arguments);
        if (this._onObjectAdded) for(var i = 0, length = arguments.length; i < length; i++)this._onObjectAdded(arguments[i]);
        this.renderOnAddRemove && this.requestRenderAll();
        return this;
    },
    /**
   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
   * An object should be an instance of (or inherit from) fabric.Object
   * Use of this function is highly discouraged for groups.
   * you can add a bunch of objects with the insertAt method but then you NEED
   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
   * @param {Object} object Object to insert
   * @param {Number} index Index to insert object at
   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
   * @return {Self} thisArg
   * @chainable
   */ insertAt: function(object, index, nonSplicing) {
        var objects = this._objects;
        if (nonSplicing) objects[index] = object;
        else objects.splice(index, 0, object);
        this._onObjectAdded && this._onObjectAdded(object);
        this.renderOnAddRemove && this.requestRenderAll();
        return this;
    },
    /**
   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
   * @param {...fabric.Object} object Zero or more fabric instances
   * @return {Self} thisArg
   * @chainable
   */ remove: function() {
        var objects = this._objects, index, somethingRemoved = false;
        for(var i = 0, length = arguments.length; i < length; i++){
            index = objects.indexOf(arguments[i]);
            // only call onObjectRemoved if an object was actually removed
            if (index !== -1) {
                somethingRemoved = true;
                objects.splice(index, 1);
                this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
            }
        }
        this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
        return this;
    },
    /**
   * Executes given function for each object in this group
   * @param {Function} callback
   *                   Callback invoked with current object as first argument,
   *                   index - as second and an array of all objects - as third.
   *                   Callback is invoked in a context of Global Object (e.g. `window`)
   *                   when no `context` argument is given
   *
   * @param {Object} context Context (aka thisObject)
   * @return {Self} thisArg
   * @chainable
   */ forEachObject: function(callback, context) {
        var objects = this.getObjects();
        for(var i = 0, len = objects.length; i < len; i++)callback.call(context, objects[i], i, objects);
        return this;
    },
    /**
   * Returns an array of children objects of this instance
   * Type parameter introduced in 1.3.10
   * since 2.3.5 this method return always a COPY of the array;
   * @param {String} [type] When specified, only objects of this type are returned
   * @return {Array}
   */ getObjects: function(type) {
        if (typeof type === "undefined") return this._objects.concat();
        return this._objects.filter(function(o) {
            return o.type === type;
        });
    },
    /**
   * Returns object at specified index
   * @param {Number} index
   * @return {Self} thisArg
   */ item: function(index) {
        return this._objects[index];
    },
    /**
   * Returns true if collection contains no objects
   * @return {Boolean} true if collection is empty
   */ isEmpty: function() {
        return this._objects.length === 0;
    },
    /**
   * Returns a size of a collection (i.e: length of an array containing its objects)
   * @return {Number} Collection size
   */ size: function() {
        return this._objects.length;
    },
    /**
   * Returns true if collection contains an object
   * @param {Object} object Object to check against
   * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
   * @return {Boolean} `true` if collection contains an object
   */ contains: function(object, deep) {
        if (this._objects.indexOf(object) > -1) return true;
        else if (deep) return this._objects.some(function(obj) {
            return typeof obj.contains === "function" && obj.contains(object, true);
        });
        return false;
    },
    /**
   * Returns number representation of a collection complexity
   * @return {Number} complexity
   */ complexity: function() {
        return this._objects.reduce(function(memo, current) {
            memo += current.complexity ? current.complexity() : 0;
            return memo;
        }, 0);
    }
};
/**
 * @namespace fabric.CommonMethods
 */ $d47795690082d4de$var$fabric.CommonMethods = {
    /**
   * Sets object's properties from options
   * @param {Object} [options] Options object
   */ _setOptions: function(options) {
        for(var prop in options)this.set(prop, options[prop]);
    },
    /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Gradient to
   */ _initGradient: function(filler, property) {
        if (filler && filler.colorStops && !(filler instanceof $d47795690082d4de$var$fabric.Gradient)) this.set(property, new $d47795690082d4de$var$fabric.Gradient(filler));
    },
    /**
   * @private
   * @param {Object} [filler] Options object
   * @param {String} [property] property to set the Pattern to
   * @param {Function} [callback] callback to invoke after pattern load
   */ _initPattern: function(filler, property, callback) {
        if (filler && filler.source && !(filler instanceof $d47795690082d4de$var$fabric.Pattern)) this.set(property, new $d47795690082d4de$var$fabric.Pattern(filler, callback));
        else callback && callback();
    },
    /**
   * @private
   */ _setObject: function(obj) {
        for(var prop in obj)this._set(prop, obj[prop]);
    },
    /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   * @return {fabric.Object} thisArg
   * @chainable
   */ set: function(key, value) {
        if (typeof key === "object") this._setObject(key);
        else this._set(key, value);
        return this;
    },
    _set: function(key, value) {
        this[key] = value;
    },
    /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   * @return {fabric.Object} thisArg
   * @chainable
   */ toggle: function(property) {
        var value = this.get(property);
        if (typeof value === "boolean") this.set(property, !value);
        return this;
    },
    /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */ get: function(property) {
        return this[property];
    }
};
(function(global) {
    var sqrt = Math.sqrt, atan2 = Math.atan2, pow = Math.pow, PiBy180 = Math.PI / 180, PiBy2 = Math.PI / 2;
    /**
   * @namespace fabric.util
   */ $d47795690082d4de$var$fabric.util = {
        /**
     * Calculate the cos of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */ cos: function(angle) {
            if (angle === 0) return 1;
            if (angle < 0) // cos(a) = cos(-a)
            angle = -angle;
            var angleSlice = angle / PiBy2;
            switch(angleSlice){
                case 1:
                case 3:
                    return 0;
                case 2:
                    return -1;
            }
            return Math.cos(angle);
        },
        /**
     * Calculate the sin of an angle, avoiding returning floats for known results
     * @static
     * @memberOf fabric.util
     * @param {Number} angle the angle in radians or in degree
     * @return {Number}
     */ sin: function(angle) {
            if (angle === 0) return 0;
            var angleSlice = angle / PiBy2, sign = 1;
            if (angle < 0) // sin(-a) = -sin(a)
            sign = -1;
            switch(angleSlice){
                case 1:
                    return sign;
                case 2:
                    return 0;
                case 3:
                    return -sign;
            }
            return Math.sin(angle);
        },
        /**
     * Removes value from an array.
     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
     * @static
     * @memberOf fabric.util
     * @param {Array} array
     * @param {*} value
     * @return {Array} original array
     */ removeFromArray: function(array, value) {
            var idx = array.indexOf(value);
            if (idx !== -1) array.splice(idx, 1);
            return array;
        },
        /**
     * Returns random number between 2 specified ones.
     * @static
     * @memberOf fabric.util
     * @param {Number} min lower limit
     * @param {Number} max upper limit
     * @return {Number} random value (between min and max)
     */ getRandomInt: function(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        },
        /**
     * Transforms degrees to radians.
     * @static
     * @memberOf fabric.util
     * @param {Number} degrees value in degrees
     * @return {Number} value in radians
     */ degreesToRadians: function(degrees) {
            return degrees * PiBy180;
        },
        /**
     * Transforms radians to degrees.
     * @static
     * @memberOf fabric.util
     * @param {Number} radians value in radians
     * @return {Number} value in degrees
     */ radiansToDegrees: function(radians) {
            return radians / PiBy180;
        },
        /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {fabric.Point} point The point to rotate
     * @param {fabric.Point} origin The origin of the rotation
     * @param {Number} radians The radians of the angle for the rotation
     * @return {fabric.Point} The new rotated point
     */ rotatePoint: function(point, origin, radians) {
            var newPoint = new $d47795690082d4de$var$fabric.Point(point.x - origin.x, point.y - origin.y), v = $d47795690082d4de$var$fabric.util.rotateVector(newPoint, radians);
            return new $d47795690082d4de$var$fabric.Point(v.x, v.y).addEquals(origin);
        },
        /**
     * Rotates `vector` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {Object} vector The vector to rotate (x and y)
     * @param {Number} radians The radians of the angle for the rotation
     * @return {Object} The new rotated point
     */ rotateVector: function(vector, radians) {
            var sin = $d47795690082d4de$var$fabric.util.sin(radians), cos = $d47795690082d4de$var$fabric.util.cos(radians), rx = vector.x * cos - vector.y * sin, ry = vector.x * sin + vector.y * cos;
            return {
                x: rx,
                y: ry
            };
        },
        /**
     * Creates a vetor from points represented as a point
     * @static
     * @memberOf fabric.util
     *
     * @typedef {Object} Point
     * @property {number} x
     * @property {number} y
     *
     * @param {Point} from
     * @param {Point} to
     * @returns {Point} vector
     */ createVector: function(from, to) {
            return new $d47795690082d4de$var$fabric.Point(to.x - from.x, to.y - from.y);
        },
        /**
     * Calculates angle between 2 vectors using dot product
     * @static
     * @memberOf fabric.util
     * @param {Point} a
     * @param {Point} b
     * @returns the angle in radian between the vectors
     */ calcAngleBetweenVectors: function(a, b) {
            return Math.acos((a.x * b.x + a.y * b.y) / (Math.hypot(a.x, a.y) * Math.hypot(b.x, b.y)));
        },
        /**
     * @static
     * @memberOf fabric.util
     * @param {Point} v
     * @returns {Point} vector representing the unit vector of pointing to the direction of `v`
     */ getHatVector: function(v) {
            return new $d47795690082d4de$var$fabric.Point(v.x, v.y).multiply(1 / Math.hypot(v.x, v.y));
        },
        /**
     * @static
     * @memberOf fabric.util
     * @param {Point} A
     * @param {Point} B
     * @param {Point} C
     * @returns {{ vector: Point, angle: number }} vector representing the bisector of A and A's angle
     */ getBisector: function(A, B, C) {
            var AB = $d47795690082d4de$var$fabric.util.createVector(A, B), AC = $d47795690082d4de$var$fabric.util.createVector(A, C);
            var alpha = $d47795690082d4de$var$fabric.util.calcAngleBetweenVectors(AB, AC);
            //  check if alpha is relative to AB->BC
            var ro = $d47795690082d4de$var$fabric.util.calcAngleBetweenVectors($d47795690082d4de$var$fabric.util.rotateVector(AB, alpha), AC);
            var phi = alpha * (ro === 0 ? 1 : -1) / 2;
            return {
                vector: $d47795690082d4de$var$fabric.util.getHatVector($d47795690082d4de$var$fabric.util.rotateVector(AB, phi)),
                angle: alpha
            };
        },
        /**
     * Project stroke width on points returning 2 projections for each point as follows:
     * - `miter`: 2 points corresponding to the outer boundary and the inner boundary of stroke.
     * - `bevel`: 2 points corresponding to the bevel boundaries, tangent to the bisector.
     * - `round`: same as `bevel`
     * Used to calculate object's bounding box
     * @static
     * @memberOf fabric.util
     * @param {Point[]} points
     * @param {Object} options
     * @param {number} options.strokeWidth
     * @param {'miter'|'bevel'|'round'} options.strokeLineJoin
     * @param {number} options.strokeMiterLimit https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
     * @param {boolean} options.strokeUniform
     * @param {number} options.scaleX
     * @param {number} options.scaleY
     * @param {boolean} [openPath] whether the shape is open or not, affects the calculations of the first and last points
     * @returns {fabric.Point[]} array of size 2n/4n of all suspected points
     */ projectStrokeOnPoints: function(points, options, openPath) {
            var coords = [], s = options.strokeWidth / 2, strokeUniformScalar = options.strokeUniform ? new $d47795690082d4de$var$fabric.Point(1 / options.scaleX, 1 / options.scaleY) : new $d47795690082d4de$var$fabric.Point(1, 1), getStrokeHatVector = function(v) {
                var scalar = s / Math.hypot(v.x, v.y);
                return new $d47795690082d4de$var$fabric.Point(v.x * scalar * strokeUniformScalar.x, v.y * scalar * strokeUniformScalar.y);
            };
            if (points.length <= 1) return coords;
            points.forEach(function(p, index) {
                var A = new $d47795690082d4de$var$fabric.Point(p.x, p.y), B, C;
                if (index === 0) {
                    C = points[index + 1];
                    B = openPath ? getStrokeHatVector($d47795690082d4de$var$fabric.util.createVector(C, A)).addEquals(A) : points[points.length - 1];
                } else if (index === points.length - 1) {
                    B = points[index - 1];
                    C = openPath ? getStrokeHatVector($d47795690082d4de$var$fabric.util.createVector(B, A)).addEquals(A) : points[0];
                } else {
                    B = points[index - 1];
                    C = points[index + 1];
                }
                var bisector = $d47795690082d4de$var$fabric.util.getBisector(A, B, C), bisectorVector = bisector.vector, alpha = bisector.angle, scalar, miterVector;
                if (options.strokeLineJoin === "miter") {
                    scalar = -s / Math.sin(alpha / 2);
                    miterVector = new $d47795690082d4de$var$fabric.Point(bisectorVector.x * scalar * strokeUniformScalar.x, bisectorVector.y * scalar * strokeUniformScalar.y);
                    if (Math.hypot(miterVector.x, miterVector.y) / s <= options.strokeMiterLimit) {
                        coords.push(A.add(miterVector));
                        coords.push(A.subtract(miterVector));
                        return;
                    }
                }
                scalar = -s * Math.SQRT2;
                miterVector = new $d47795690082d4de$var$fabric.Point(bisectorVector.x * scalar * strokeUniformScalar.x, bisectorVector.y * scalar * strokeUniformScalar.y);
                coords.push(A.add(miterVector));
                coords.push(A.subtract(miterVector));
            });
            return coords;
        },
        /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Point} p The point to transform
     * @param  {Array} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {fabric.Point} The transformed point
     */ transformPoint: function(p, t, ignoreOffset) {
            if (ignoreOffset) return new $d47795690082d4de$var$fabric.Point(t[0] * p.x + t[2] * p.y, t[1] * p.x + t[3] * p.y);
            return new $d47795690082d4de$var$fabric.Point(t[0] * p.x + t[2] * p.y + t[4], t[1] * p.x + t[3] * p.y + t[5]);
        },
        /**
     * Returns coordinates of points's bounding rectangle (left, top, width, height)
     * @param {Array} points 4 points array
     * @param {Array} [transform] an array of 6 numbers representing a 2x3 transform matrix
     * @return {Object} Object with left, top, width, height properties
     */ makeBoundingBoxFromPoints: function(points, transform) {
            if (transform) for(var i = 0; i < points.length; i++)points[i] = $d47795690082d4de$var$fabric.util.transformPoint(points[i], transform);
            var xPoints = [
                points[0].x,
                points[1].x,
                points[2].x,
                points[3].x
            ], minX = $d47795690082d4de$var$fabric.util.array.min(xPoints), maxX = $d47795690082d4de$var$fabric.util.array.max(xPoints), width = maxX - minX, yPoints = [
                points[0].y,
                points[1].y,
                points[2].y,
                points[3].y
            ], minY = $d47795690082d4de$var$fabric.util.array.min(yPoints), maxY = $d47795690082d4de$var$fabric.util.array.max(yPoints), height = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: width,
                height: height
            };
        },
        /**
     * Invert transformation t
     * @static
     * @memberOf fabric.util
     * @param {Array} t The transform
     * @return {Array} The inverted transform
     */ invertTransform: function(t) {
            var a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [
                a * t[3],
                -a * t[1],
                -a * t[2],
                a * t[0]
            ], o = $d47795690082d4de$var$fabric.util.transformPoint({
                x: t[4],
                y: t[5]
            }, r, true);
            r[4] = -o.x;
            r[5] = -o.y;
            return r;
        },
        /**
     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
     * @static
     * @memberOf fabric.util
     * @param {Number|String} number number to operate on
     * @param {Number} fractionDigits number of fraction digits to "leave"
     * @return {Number}
     */ toFixed: function(number, fractionDigits) {
            return parseFloat(Number(number).toFixed(fractionDigits));
        },
        /**
     * Converts from attribute value to pixel value if applicable.
     * Returns converted pixels or original value not converted.
     * @param {Number|String} value number to operate on
     * @param {Number} fontSize
     * @return {Number|String}
     */ parseUnit: function(value, fontSize) {
            var unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
            if (!fontSize) fontSize = $d47795690082d4de$var$fabric.Text.DEFAULT_SVG_FONT_SIZE;
            switch(unit[0]){
                case "mm":
                    return number * $d47795690082d4de$var$fabric.DPI / 25.4;
                case "cm":
                    return number * $d47795690082d4de$var$fabric.DPI / 2.54;
                case "in":
                    return number * $d47795690082d4de$var$fabric.DPI;
                case "pt":
                    return number * $d47795690082d4de$var$fabric.DPI / 72; // or * 4 / 3
                case "pc":
                    return number * $d47795690082d4de$var$fabric.DPI / 72 * 12; // or * 16
                case "em":
                    return number * fontSize;
                default:
                    return number;
            }
        },
        /**
     * Function which always returns `false`.
     * @static
     * @memberOf fabric.util
     * @return {Boolean}
     */ falseFunction: function() {
            return false;
        },
        /**
     * Returns klass "Class" object of given namespace
     * @memberOf fabric.util
     * @param {String} type Type of object (eg. 'circle')
     * @param {String} namespace Namespace to get klass "Class" object from
     * @return {Object} klass "Class"
     */ getKlass: function(type, namespace) {
            // capitalize first letter only
            type = $d47795690082d4de$var$fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
            return $d47795690082d4de$var$fabric.util.resolveNamespace(namespace)[type];
        },
        /**
     * Returns array of attributes for given svg that fabric parses
     * @memberOf fabric.util
     * @param {String} type Type of svg element (eg. 'circle')
     * @return {Array} string names of supported attributes
     */ getSvgAttributes: function(type) {
            var attributes = [
                "instantiated_by_use",
                "style",
                "id",
                "class"
            ];
            switch(type){
                case "linearGradient":
                    attributes = attributes.concat([
                        "x1",
                        "y1",
                        "x2",
                        "y2",
                        "gradientUnits",
                        "gradientTransform"
                    ]);
                    break;
                case "radialGradient":
                    attributes = attributes.concat([
                        "gradientUnits",
                        "gradientTransform",
                        "cx",
                        "cy",
                        "r",
                        "fx",
                        "fy",
                        "fr"
                    ]);
                    break;
                case "stop":
                    attributes = attributes.concat([
                        "offset",
                        "stop-color",
                        "stop-opacity"
                    ]);
                    break;
            }
            return attributes;
        },
        /**
     * Returns object of given namespace
     * @memberOf fabric.util
     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
     * @return {Object} Object for given namespace (default fabric)
     */ resolveNamespace: function(namespace) {
            if (!namespace) return $d47795690082d4de$var$fabric;
            var parts = namespace.split("."), len = parts.length, i, obj = global || $d47795690082d4de$var$fabric.window;
            for(i = 0; i < len; ++i)obj = obj[parts[i]];
            return obj;
        },
        /**
     * Loads image element from given url and passes it to a callback
     * @memberOf fabric.util
     * @param {String} url URL representing an image
     * @param {Function} callback Callback; invoked with loaded image
     * @param {*} [context] Context to invoke callback in
     * @param {Object} [crossOrigin] crossOrigin value to set image element to
     */ loadImage: function(url, callback, context, crossOrigin) {
            if (!url) {
                callback && callback.call(context, url);
                return;
            }
            var img = $d47795690082d4de$var$fabric.util.createImage();
            /** @ignore */ var onLoadCallback = function() {
                callback && callback.call(context, img, false);
                img = img.onload = img.onerror = null;
            };
            img.onload = onLoadCallback;
            /** @ignore */ img.onerror = function() {
                $d47795690082d4de$var$fabric.log("Error loading " + img.src);
                callback && callback.call(context, null, true);
                img = img.onload = img.onerror = null;
            };
            // data-urls appear to be buggy with crossOrigin
            // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
            // see https://code.google.com/p/chromium/issues/detail?id=315152
            //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
            // crossOrigin null is the same as not set.
            if (url.indexOf("data") !== 0 && crossOrigin !== undefined && crossOrigin !== null) img.crossOrigin = crossOrigin;
            // IE10 / IE11-Fix: SVG contents from data: URI
            // will only be available if the IMG is present
            // in the DOM (and visible)
            if (url.substring(0, 14) === "data:image/svg") {
                img.onload = null;
                $d47795690082d4de$var$fabric.util.loadImageInDom(img, onLoadCallback);
            }
            img.src = url;
        },
        /**
     * Attaches SVG image with data: URL to the dom
     * @memberOf fabric.util
     * @param {Object} img Image object with data:image/svg src
     * @param {Function} callback Callback; invoked with loaded image
     * @return {Object} DOM element (div containing the SVG image)
     */ loadImageInDom: function(img, onLoadCallback) {
            var div = $d47795690082d4de$var$fabric.document.createElement("div");
            div.style.width = div.style.height = "1px";
            div.style.left = div.style.top = "-100%";
            div.style.position = "absolute";
            div.appendChild(img);
            $d47795690082d4de$var$fabric.document.querySelector("body").appendChild(div);
            /**
       * Wrap in function to:
       *   1. Call existing callback
       *   2. Cleanup DOM
       */ img.onload = function() {
                onLoadCallback();
                div.parentNode.removeChild(div);
                div = null;
            };
        },
        /**
     * Creates corresponding fabric instances from their object representations
     * @static
     * @memberOf fabric.util
     * @param {Array} objects Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * @param {String} namespace Namespace to get klass "Class" object from
     * @param {Function} reviver Method for further parsing of object elements,
     * called after each fabric object created.
     */ enlivenObjects: function(objects, callback, namespace, reviver) {
            objects = objects || [];
            var enlivenedObjects = [], numLoadedObjects = 0, numTotalObjects = objects.length;
            function onLoaded() {
                if (++numLoadedObjects === numTotalObjects) callback && callback(enlivenedObjects.filter(function(obj) {
                    // filter out undefined objects (objects that gave error)
                    return obj;
                }));
            }
            if (!numTotalObjects) {
                callback && callback(enlivenedObjects);
                return;
            }
            objects.forEach(function(o, index) {
                // if sparse array
                if (!o || !o.type) {
                    onLoaded();
                    return;
                }
                var klass = $d47795690082d4de$var$fabric.util.getKlass(o.type, namespace);
                klass.fromObject(o, function(obj, error) {
                    error || (enlivenedObjects[index] = obj);
                    reviver && reviver(o, obj, error);
                    onLoaded();
                });
            });
        },
        /**
     * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
     * @see {@link fabric.Object.ENLIVEN_PROPS}
     * @param {Object} object
     * @param {Object} [context] assign enlived props to this object (pass null to skip this)
     * @param {(objects:fabric.Object[]) => void} callback
     */ enlivenObjectEnlivables: function(object, context, callback) {
            var enlivenProps = $d47795690082d4de$var$fabric.Object.ENLIVEN_PROPS.filter(function(key) {
                return !!object[key];
            });
            $d47795690082d4de$var$fabric.util.enlivenObjects(enlivenProps.map(function(key) {
                return object[key];
            }), function(enlivedProps) {
                var objects = {};
                enlivenProps.forEach(function(key, index) {
                    objects[key] = enlivedProps[index];
                    context && (context[key] = enlivedProps[index]);
                });
                callback && callback(objects);
            });
        },
        /**
     * Create and wait for loading of patterns
     * @static
     * @memberOf fabric.util
     * @param {Array} patterns Objects to enliven
     * @param {Function} callback Callback to invoke when all objects are created
     * called after each fabric object created.
     */ enlivenPatterns: function(patterns, callback) {
            patterns = patterns || [];
            function onLoaded() {
                if (++numLoadedPatterns === numPatterns) callback && callback(enlivenedPatterns);
            }
            var enlivenedPatterns = [], numLoadedPatterns = 0, numPatterns = patterns.length;
            if (!numPatterns) {
                callback && callback(enlivenedPatterns);
                return;
            }
            patterns.forEach(function(p, index) {
                if (p && p.source) new $d47795690082d4de$var$fabric.Pattern(p, function(pattern) {
                    enlivenedPatterns[index] = pattern;
                    onLoaded();
                });
                else {
                    enlivenedPatterns[index] = p;
                    onLoaded();
                }
            });
        },
        /**
     * Groups SVG elements (usually those retrieved from SVG document)
     * @static
     * @memberOf fabric.util
     * @param {Array} elements SVG elements to group
     * @param {Object} [options] Options object
     * @param {String} path Value to set sourcePath to
     * @return {fabric.Object|fabric.Group}
     */ groupSVGElements: function(elements, options, path) {
            var object;
            if (elements && elements.length === 1) {
                if (typeof path !== "undefined") elements[0].sourcePath = path;
                return elements[0];
            }
            if (options) {
                if (options.width && options.height) options.centerPoint = {
                    x: options.width / 2,
                    y: options.height / 2
                };
                else {
                    delete options.width;
                    delete options.height;
                }
            }
            object = new $d47795690082d4de$var$fabric.Group(elements, options);
            if (typeof path !== "undefined") object.sourcePath = path;
            return object;
        },
        /**
     * Populates an object with properties of another object
     * @static
     * @memberOf fabric.util
     * @param {Object} source Source object
     * @param {Object} destination Destination object
     * @return {Array} properties Properties names to include
     */ populateWithProperties: function(source, destination, properties) {
            if (properties && Array.isArray(properties)) {
                for(var i = 0, len = properties.length; i < len; i++)if (properties[i] in source) destination[properties[i]] = source[properties[i]];
            }
        },
        /**
     * Creates canvas element
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */ createCanvasElement: function() {
            return $d47795690082d4de$var$fabric.document.createElement("canvas");
        },
        /**
     * Creates a canvas element that is a copy of another and is also painted
     * @param {CanvasElement} canvas to copy size and content of
     * @static
     * @memberOf fabric.util
     * @return {CanvasElement} initialized canvas element
     */ copyCanvasElement: function(canvas) {
            var newCanvas = $d47795690082d4de$var$fabric.util.createCanvasElement();
            newCanvas.width = canvas.width;
            newCanvas.height = canvas.height;
            newCanvas.getContext("2d").drawImage(canvas, 0, 0);
            return newCanvas;
        },
        /**
     * since 2.6.0 moved from canvas instance to utility.
     * @param {CanvasElement} canvasEl to copy size and content of
     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
     * @param {Number} quality <= 1 and > 0
     * @static
     * @memberOf fabric.util
     * @return {String} data url
     */ toDataURL: function(canvasEl, format, quality) {
            return canvasEl.toDataURL("image/" + format, quality);
        },
        /**
     * Creates image element (works on client and node)
     * @static
     * @memberOf fabric.util
     * @return {HTMLImageElement} HTML image element
     */ createImage: function() {
            return $d47795690082d4de$var$fabric.document.createElement("img");
        },
        /**
     * Multiply matrix A by matrix B to nest transformations
     * @static
     * @memberOf fabric.util
     * @param  {Array} a First transformMatrix
     * @param  {Array} b Second transformMatrix
     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
     * @return {Array} The product of the two transform matrices
     */ multiplyTransformMatrices: function(a, b, is2x2) {
            // Matrix multiply a * b
            return [
                a[0] * b[0] + a[2] * b[1],
                a[1] * b[0] + a[3] * b[1],
                a[0] * b[2] + a[2] * b[3],
                a[1] * b[2] + a[3] * b[3],
                is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
                is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
            ];
        },
        /**
     * Decomposes standard 2x3 matrix into transform components
     * @static
     * @memberOf fabric.util
     * @param  {Array} a transformMatrix
     * @return {Object} Components of transform
     */ qrDecompose: function(a) {
            var angle = atan2(a[1], a[0]), denom = pow(a[0], 2) + pow(a[1], 2), scaleX = sqrt(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = atan2(a[0] * a[2] + a[1] * a[3], denom);
            return {
                angle: angle / PiBy180,
                scaleX: scaleX,
                scaleY: scaleY,
                skewX: skewX / PiBy180,
                skewY: 0,
                translateX: a[4],
                translateY: a[5]
            };
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle] angle in degrees
     * @return {Number[]} transform matrix
     */ calcRotateMatrix: function(options) {
            if (!options.angle) return $d47795690082d4de$var$fabric.iMatrix.concat();
            var theta = $d47795690082d4de$var$fabric.util.degreesToRadians(options.angle), cos = $d47795690082d4de$var$fabric.util.cos(theta), sin = $d47795690082d4de$var$fabric.util.sin(theta);
            return [
                cos,
                sin,
                -sin,
                cos,
                0,
                0
            ];
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet.
     * is called DimensionsTransformMatrix because those properties are the one that influence
     * the size of the resulting box of the object.
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewY]
     * @return {Number[]} transform matrix
     */ calcDimensionsMatrix: function(options) {
            var scaleX = typeof options.scaleX === "undefined" ? 1 : options.scaleX, scaleY = typeof options.scaleY === "undefined" ? 1 : options.scaleY, scaleMatrix = [
                options.flipX ? -scaleX : scaleX,
                0,
                0,
                options.flipY ? -scaleY : scaleY,
                0,
                0
            ], multiply = $d47795690082d4de$var$fabric.util.multiplyTransformMatrices, degreesToRadians = $d47795690082d4de$var$fabric.util.degreesToRadians;
            if (options.skewX) scaleMatrix = multiply(scaleMatrix, [
                1,
                0,
                Math.tan(degreesToRadians(options.skewX)),
                1
            ], true);
            if (options.skewY) scaleMatrix = multiply(scaleMatrix, [
                1,
                Math.tan(degreesToRadians(options.skewY)),
                0,
                1
            ], true);
            return scaleMatrix;
        },
        /**
     * Returns a transform matrix starting from an object of the same kind of
     * the one returned from qrDecompose, useful also if you want to calculate some
     * transformations from an object that is not enlived yet
     * @static
     * @memberOf fabric.util
     * @param  {Object} options
     * @param  {Number} [options.angle]
     * @param  {Number} [options.scaleX]
     * @param  {Number} [options.scaleY]
     * @param  {Boolean} [options.flipX]
     * @param  {Boolean} [options.flipY]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.skewX]
     * @param  {Number} [options.translateX]
     * @param  {Number} [options.translateY]
     * @return {Number[]} transform matrix
     */ composeMatrix: function(options) {
            var matrix = [
                1,
                0,
                0,
                1,
                options.translateX || 0,
                options.translateY || 0
            ], multiply = $d47795690082d4de$var$fabric.util.multiplyTransformMatrices;
            if (options.angle) matrix = multiply(matrix, $d47795690082d4de$var$fabric.util.calcRotateMatrix(options));
            if (options.scaleX !== 1 || options.scaleY !== 1 || options.skewX || options.skewY || options.flipX || options.flipY) matrix = multiply(matrix, $d47795690082d4de$var$fabric.util.calcDimensionsMatrix(options));
            return matrix;
        },
        /**
     * reset an object transform state to neutral. Top and left are not accounted for
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to transform
     */ resetObjectTransform: function(target) {
            target.scaleX = 1;
            target.scaleY = 1;
            target.skewX = 0;
            target.skewY = 0;
            target.flipX = false;
            target.flipY = false;
            target.rotate(0);
        },
        /**
     * Extract Object transform values
     * @static
     * @memberOf fabric.util
     * @param  {fabric.Object} target object to read from
     * @return {Object} Components of transform
     */ saveObjectTransform: function(target) {
            return {
                scaleX: target.scaleX,
                scaleY: target.scaleY,
                skewX: target.skewX,
                skewY: target.skewY,
                angle: target.angle,
                left: target.left,
                flipX: target.flipX,
                flipY: target.flipY,
                top: target.top
            };
        },
        /**
     * Returns true if context has transparent pixel
     * at specified location (taking tolerance into account)
     * @param {CanvasRenderingContext2D} ctx context
     * @param {Number} x x coordinate
     * @param {Number} y y coordinate
     * @param {Number} tolerance Tolerance
     */ isTransparent: function(ctx, x, y, tolerance) {
            // If tolerance is > 0 adjust start coords to take into account.
            // If moves off Canvas fix to 0
            if (tolerance > 0) {
                if (x > tolerance) x -= tolerance;
                else x = 0;
                if (y > tolerance) y -= tolerance;
                else y = 0;
            }
            var _isTransparent = true, i, temp, imageData = ctx.getImageData(x, y, tolerance * 2 || 1, tolerance * 2 || 1), l = imageData.data.length;
            // Split image data - for tolerance > 1, pixelDataSize = 4;
            for(i = 3; i < l; i += 4){
                temp = imageData.data[i];
                _isTransparent = temp <= 0;
                if (_isTransparent === false) break; // Stop if colour found
            }
            imageData = null;
            return _isTransparent;
        },
        /**
     * Parse preserveAspectRatio attribute from element
     * @param {string} attribute to be parsed
     * @return {Object} an object containing align and meetOrSlice attribute
     */ parsePreserveAspectRatioAttribute: function(attribute) {
            var meetOrSlice = "meet", alignX = "Mid", alignY = "Mid", aspectRatioAttrs = attribute.split(" "), align;
            if (aspectRatioAttrs && aspectRatioAttrs.length) {
                meetOrSlice = aspectRatioAttrs.pop();
                if (meetOrSlice !== "meet" && meetOrSlice !== "slice") {
                    align = meetOrSlice;
                    meetOrSlice = "meet";
                } else if (aspectRatioAttrs.length) align = aspectRatioAttrs.pop();
            }
            //divide align in alignX and alignY
            alignX = align !== "none" ? align.slice(1, 4) : "none";
            alignY = align !== "none" ? align.slice(5, 8) : "none";
            return {
                meetOrSlice: meetOrSlice,
                alignX: alignX,
                alignY: alignY
            };
        },
        /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @memberOf fabric.util
     * @param {String} [fontFamily] font family to clear
     */ clearFabricFontCache: function(fontFamily) {
            fontFamily = (fontFamily || "").toLowerCase();
            if (!fontFamily) $d47795690082d4de$var$fabric.charWidthsCache = {};
            else if ($d47795690082d4de$var$fabric.charWidthsCache[fontFamily]) delete $d47795690082d4de$var$fabric.charWidthsCache[fontFamily];
        },
        /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Number} ar aspect ratio
     * @param {Number} maximumArea Maximum area you want to achieve
     * @return {Object.x} Limited dimensions by X
     * @return {Object.y} Limited dimensions by Y
     */ limitDimsByArea: function(ar, maximumArea) {
            var roughWidth = Math.sqrt(maximumArea * ar), perfLimitSizeY = Math.floor(maximumArea / roughWidth);
            return {
                x: Math.floor(roughWidth),
                y: perfLimitSizeY
            };
        },
        capValue: function(min, value, max) {
            return Math.max(min, Math.min(value, max));
        },
        /**
     * Finds the scale for the object source to fit inside the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to fit into destination
     */ findScaleToFit: function(source, destination) {
            return Math.min(destination.width / source.width, destination.height / source.height);
        },
        /**
     * Finds the scale for the object source to cover entirely the object destination,
     * keeping aspect ratio intact.
     * respect the total allowed area for the cache.
     * @memberOf fabric.util
     * @param {Object | fabric.Object} source
     * @param {Number} source.height natural unscaled height of the object
     * @param {Number} source.width natural unscaled width of the object
     * @param {Object | fabric.Object} destination
     * @param {Number} destination.height natural unscaled height of the object
     * @param {Number} destination.width natural unscaled width of the object
     * @return {Number} scale factor to apply to source to cover destination
     */ findScaleToCover: function(source, destination) {
            return Math.max(destination.width / source.width, destination.height / source.height);
        },
        /**
     * given an array of 6 number returns something like `"matrix(...numbers)"`
     * @memberOf fabric.util
     * @param {Array} transform an array with 6 numbers
     * @return {String} transform matrix for svg
     * @return {Object.y} Limited dimensions by Y
     */ matrixToSVG: function(transform) {
            return "matrix(" + transform.map(function(value) {
                return $d47795690082d4de$var$fabric.util.toFixed(value, $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS);
            }).join(" ") + ")";
        },
        /**
     * given an object and a transform, apply the inverse transform to the object,
     * this is equivalent to remove from that object that transformation, so that
     * added in a space with the removed transform, the object will be the same as before.
     * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
     * Removing from an object a transfrom that rotate by 30deg is like rotating by 30deg
     * in the opposite direction.
     * This util is used to add objects inside transformed groups or nested groups.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ removeTransformFromObject: function(object, transform) {
            var inverted = $d47795690082d4de$var$fabric.util.invertTransform(transform), finalTransform = $d47795690082d4de$var$fabric.util.multiplyTransformMatrices(inverted, object.calcOwnMatrix());
            $d47795690082d4de$var$fabric.util.applyTransformToObject(object, finalTransform);
        },
        /**
     * given an object and a transform, apply the transform to the object.
     * this is equivalent to change the space where the object is drawn.
     * Adding to an object a transform that scale by 2 is like scaling it by 2.
     * This is used when removing an object from an active selection for example.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ addTransformToObject: function(object, transform) {
            $d47795690082d4de$var$fabric.util.applyTransformToObject(object, $d47795690082d4de$var$fabric.util.multiplyTransformMatrices(transform, object.calcOwnMatrix()));
        },
        /**
     * discard an object transform state and apply the one from the matrix.
     * @memberOf fabric.util
     * @param {fabric.Object} object the object you want to transform
     * @param {Array} transform the destination transform
     */ applyTransformToObject: function(object, transform) {
            var options = $d47795690082d4de$var$fabric.util.qrDecompose(transform), center = new $d47795690082d4de$var$fabric.Point(options.translateX, options.translateY);
            object.flipX = false;
            object.flipY = false;
            object.set("scaleX", options.scaleX);
            object.set("scaleY", options.scaleY);
            object.skewX = options.skewX;
            object.skewY = options.skewY;
            object.angle = options.angle;
            object.setPositionByOrigin(center, "center", "center");
        },
        /**
     * given a width and height, return the size of the bounding box
     * that can contains the box with width/height with applied transform
     * described in options.
     * Use to calculate the boxes around objects for controls.
     * @memberOf fabric.util
     * @param {Number} width
     * @param {Number} height
     * @param {Object} options
     * @param {Number} options.scaleX
     * @param {Number} options.scaleY
     * @param {Number} options.skewX
     * @param {Number} options.skewY
     * @return {Object.x} width of containing
     * @return {Object.y} height of containing
     */ sizeAfterTransform: function(width, height, options) {
            var dimX = width / 2, dimY = height / 2, points = [
                {
                    x: -dimX,
                    y: -dimY
                },
                {
                    x: dimX,
                    y: -dimY
                },
                {
                    x: -dimX,
                    y: dimY
                },
                {
                    x: dimX,
                    y: dimY
                }
            ], transformMatrix = $d47795690082d4de$var$fabric.util.calcDimensionsMatrix(options), bbox = $d47795690082d4de$var$fabric.util.makeBoundingBoxFromPoints(points, transformMatrix);
            return {
                x: bbox.width,
                y: bbox.height
            };
        },
        /**
     * Merges 2 clip paths into one visually equal clip path
     *
     * **IMPORTANT**:\
     * Does **NOT** clone the arguments, clone them proir if necessary.
     *
     * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
     * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
     *
     * In order to handle the `inverted` property we follow logic described in the following cases:\
     * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
     * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
     * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
     *
     * @memberOf fabric.util
     * @param {fabric.Object} c1
     * @param {fabric.Object} c2
     * @returns {fabric.Object} merged clip path
     */ mergeClipPaths: function(c1, c2) {
            var a = c1, b = c2;
            if (a.inverted && !b.inverted) {
                //  case (2)
                a = c2;
                b = c1;
            }
            //  `b` becomes `a`'s clip path so we transform `b` to `a` coordinate plane
            $d47795690082d4de$var$fabric.util.applyTransformToObject(b, $d47795690082d4de$var$fabric.util.multiplyTransformMatrices($d47795690082d4de$var$fabric.util.invertTransform(a.calcTransformMatrix()), b.calcTransformMatrix()));
            //  assign the `inverted` prop to the wrapping group
            var inverted = a.inverted && b.inverted;
            if (inverted) //  case (1)
            a.inverted = b.inverted = false;
            return new $d47795690082d4de$var$fabric.Group([
                a
            ], {
                clipPath: b,
                inverted: inverted
            });
        },
        /**
     * @memberOf fabric.util
     * @param {Object} prevStyle first style to compare
     * @param {Object} thisStyle second style to compare
     * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
     * @return {boolean} true if the style changed
     */ hasStyleChanged: function(prevStyle, thisStyle, forTextSpans) {
            forTextSpans = forTextSpans || false;
            return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
        },
        /**
     * Returns the array form of a text object's inline styles property with styles grouped in ranges
     * rather than per character. This format is less verbose, and is better suited for storage
     * so it is used in serialization (not during runtime).
     * @memberOf fabric.util
     * @param {object} styles per character styles for a text object
     * @param {String} text the text string that the styles are applied to
     * @return {{start: number, end: number, style: object}[]}
     */ stylesToArray: function(styles, text) {
            // clone style structure to prevent mutation
            var styles = $d47795690082d4de$var$fabric.util.object.clone(styles, true), textLines = text.split("\n"), charIndex = -1, prevStyle = {}, stylesArray = [];
            //loop through each textLine
            for(var i = 0; i < textLines.length; i++){
                if (!styles[i]) {
                    //no styles exist for this line, so add the line's length to the charIndex total
                    charIndex += textLines[i].length;
                    continue;
                }
                //loop through each character of the current line
                for(var c = 0; c < textLines[i].length; c++){
                    charIndex++;
                    var thisStyle = styles[i][c];
                    //check if style exists for this character
                    if (thisStyle && Object.keys(thisStyle).length > 0) {
                        var styleChanged = $d47795690082d4de$var$fabric.util.hasStyleChanged(prevStyle, thisStyle, true);
                        if (styleChanged) stylesArray.push({
                            start: charIndex,
                            end: charIndex + 1,
                            style: thisStyle
                        });
                        else //if style is the same as previous character, increase end index
                        stylesArray[stylesArray.length - 1].end++;
                    }
                    prevStyle = thisStyle || {};
                }
            }
            return stylesArray;
        },
        /**
     * Returns the object form of the styles property with styles that are assigned per
     * character rather than grouped by range. This format is more verbose, and is
     * only used during runtime (not for serialization/storage)
     * @memberOf fabric.util
     * @param {Array} styles the serialized form of a text object's styles
     * @param {String} text the text string that the styles are applied to
     * @return {Object}
     */ stylesFromArray: function(styles, text) {
            if (!Array.isArray(styles)) return styles;
            var textLines = text.split("\n"), charIndex = -1, styleIndex = 0, stylesObject = {};
            //loop through each textLine
            for(var i = 0; i < textLines.length; i++)//loop through each character of the current line
            for(var c = 0; c < textLines[i].length; c++){
                charIndex++;
                //check if there's a style collection that includes the current character
                if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
                    //create object for line index if it doesn't exist
                    stylesObject[i] = stylesObject[i] || {};
                    //assign a style at this character's index
                    stylesObject[i][c] = Object.assign({}, styles[styleIndex].style);
                    //if character is at the end of the current style collection, move to the next
                    if (charIndex === styles[styleIndex].end - 1) styleIndex++;
                }
            }
            return stylesObject;
        }
    };
})($d47795690082d4de$exports);
(function() {
    var _join = Array.prototype.join, commandLengths = {
        m: 2,
        l: 2,
        h: 1,
        v: 1,
        c: 6,
        s: 4,
        q: 4,
        t: 2,
        a: 7
    }, repeatedCommands = {
        m: "l",
        M: "L"
    };
    function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
        var costh2 = $d47795690082d4de$var$fabric.util.cos(th2), sinth2 = $d47795690082d4de$var$fabric.util.sin(th2), costh3 = $d47795690082d4de$var$fabric.util.cos(th3), sinth3 = $d47795690082d4de$var$fabric.util.sin(th3), toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1, toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1, cp1X = fromX + mT * (-cosTh * rx * sinth2 - sinTh * ry * costh2), cp1Y = fromY + mT * (-sinTh * rx * sinth2 + cosTh * ry * costh2), cp2X = toX + mT * (cosTh * rx * sinth3 + sinTh * ry * costh3), cp2Y = toY + mT * (sinTh * rx * sinth3 - cosTh * ry * costh3);
        return [
            "C",
            cp1X,
            cp1Y,
            cp2X,
            cp2Y,
            toX,
            toY
        ];
    }
    /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   */ function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
        var PI = Math.PI, th = rotateX * PI / 180, sinTh = $d47795690082d4de$var$fabric.util.sin(th), cosTh = $d47795690082d4de$var$fabric.util.cos(th), fromX = 0, fromY = 0;
        rx = Math.abs(rx);
        ry = Math.abs(ry);
        var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5, py = -cosTh * toY * 0.5 + sinTh * toX * 0.5, rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2, root = 0;
        if (pl < 0) {
            var s = Math.sqrt(1 - pl / (rx2 * ry2));
            rx *= s;
            ry *= s;
        } else root = (large === sweep ? -1 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
        var cx = root * rx * py / ry, cy = -root * ry * px / rx, cx1 = cosTh * cx - sinTh * cy + toX * 0.5, cy1 = sinTh * cx + cosTh * cy + toY * 0.5, mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry), dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);
        if (sweep === 0 && dtheta > 0) dtheta -= 2 * PI;
        else if (sweep === 1 && dtheta < 0) dtheta += 2 * PI;
        // Convert into cubic bezier segments <= 90deg
        var segments = Math.ceil(Math.abs(dtheta / PI * 2)), result = [], mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2), th3 = mTheta + mDelta;
        for(var i = 0; i < segments; i++){
            result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
            fromX = result[i][5];
            fromY = result[i][6];
            mTheta = th3;
            th3 += mDelta;
        }
        return result;
    }
    /*
   * Private
   */ function calcVectorAngle(ux, uy, vx, vy) {
        var ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
        if (tb >= ta) return tb - ta;
        else return 2 * Math.PI - (ta - tb);
    }
    /**
   * Calculate bounding box of a beziercurve
   * @param {Number} x0 starting point
   * @param {Number} y0
   * @param {Number} x1 first control point
   * @param {Number} y1
   * @param {Number} x2 secondo control point
   * @param {Number} y2
   * @param {Number} x3 end of bezier
   * @param {Number} y3
   */ // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
    // TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
    function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
        var argsString;
        if ($d47795690082d4de$var$fabric.cachesBoundsOfCurve) {
            argsString = _join.call(arguments);
            if ($d47795690082d4de$var$fabric.boundsOfCurveCache[argsString]) return $d47795690082d4de$var$fabric.boundsOfCurveCache[argsString];
        }
        var sqrt = Math.sqrt, min = Math.min, max = Math.max, abs = Math.abs, tvalues = [], bounds = [
            [],
            []
        ], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        b = 6 * x0 - 12 * x1 + 6 * x2;
        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
        c = 3 * x1 - 3 * x0;
        for(var i = 0; i < 2; ++i){
            if (i > 0) {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) continue;
                t = -c / b;
                if (0 < t && t < 1) tvalues.push(t);
                continue;
            }
            b2ac = b * b - 4 * c * a;
            if (b2ac < 0) continue;
            sqrtb2ac = sqrt(b2ac);
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) tvalues.push(t1);
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) tvalues.push(t2);
        }
        var x, y, j = tvalues.length, jlen = j, mt;
        while(j--){
            t = tvalues[j];
            mt = 1 - t;
            x = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[0][j] = x;
            y = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
            bounds[1][j] = y;
        }
        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        var result = [
            {
                x: min.apply(null, bounds[0]),
                y: min.apply(null, bounds[1])
            },
            {
                x: max.apply(null, bounds[0]),
                y: max.apply(null, bounds[1])
            }
        ];
        if ($d47795690082d4de$var$fabric.cachesBoundsOfCurve) $d47795690082d4de$var$fabric.boundsOfCurveCache[argsString] = result;
        return result;
    }
    /**
   * Converts arc to a bunch of bezier curves
   * @param {Number} fx starting point x
   * @param {Number} fy starting point y
   * @param {Array} coords Arc command
   */ function fromArcToBeziers(fx, fy, coords) {
        var rx = coords[1], ry = coords[2], rot = coords[3], large = coords[4], sweep = coords[5], tx = coords[6], ty = coords[7], segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
        for(var i = 0, len = segsNorm.length; i < len; i++){
            segsNorm[i][1] += fx;
            segsNorm[i][2] += fy;
            segsNorm[i][3] += fx;
            segsNorm[i][4] += fy;
            segsNorm[i][5] += fx;
            segsNorm[i][6] += fy;
        }
        return segsNorm;
    }
    /**
   * This function take a parsed SVG path and make it simpler for fabricJS logic.
   * simplification consist of: only UPPERCASE absolute commands ( relative converted to absolute )
   * S converted in C, T converted in Q, A converted in C.
   * @param {Array} path the array of commands of a parsed svg path for fabric.Path
   * @return {Array} the simplified array of commands of a parsed svg path for fabric.Path
   */ function makePathSimpler(path) {
        // x and y represent the last point of the path. the previous command point.
        // we add them to each relative command to make it an absolute comment.
        // we also swap the v V h H with L, because are easier to transform.
        var x = 0, y = 0, len = path.length, // x1 and y1 represent the last point of the subpath. the subpath is started with
        // m or M command. When a z or Z command is drawn, x and y need to be resetted to
        // the last x1 and y1.
        x1 = 0, y1 = 0, current, i, converted, // previous will host the letter of the previous command, to handle S and T.
        // controlX and controlY will host the previous reflected control point
        destinationPath = [], previous, controlX, controlY;
        for(i = 0; i < len; ++i){
            converted = false;
            current = path[i].slice(0);
            switch(current[0]){
                case "l":
                    current[0] = "L";
                    current[1] += x;
                    current[2] += y;
                // falls through
                case "L":
                    x = current[1];
                    y = current[2];
                    break;
                case "h":
                    current[1] += x;
                // falls through
                case "H":
                    current[0] = "L";
                    current[2] = y;
                    x = current[1];
                    break;
                case "v":
                    current[1] += y;
                // falls through
                case "V":
                    current[0] = "L";
                    y = current[1];
                    current[1] = x;
                    current[2] = y;
                    break;
                case "m":
                    current[0] = "M";
                    current[1] += x;
                    current[2] += y;
                // falls through
                case "M":
                    x = current[1];
                    y = current[2];
                    x1 = current[1];
                    y1 = current[2];
                    break;
                case "c":
                    current[0] = "C";
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                    current[5] += x;
                    current[6] += y;
                // falls through
                case "C":
                    controlX = current[3];
                    controlY = current[4];
                    x = current[5];
                    y = current[6];
                    break;
                case "s":
                    current[0] = "S";
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                // falls through
                case "S":
                    // would be sScC but since we are swapping sSc for C, we check just that.
                    if (previous === "C") {
                        // calculate reflection of previous control points
                        controlX = 2 * x - controlX;
                        controlY = 2 * y - controlY;
                    } else {
                        // If there is no previous command or if the previous command was not a C, c, S, or s,
                        // the control point is coincident with the current point
                        controlX = x;
                        controlY = y;
                    }
                    x = current[3];
                    y = current[4];
                    current[0] = "C";
                    current[5] = current[3];
                    current[6] = current[4];
                    current[3] = current[1];
                    current[4] = current[2];
                    current[1] = controlX;
                    current[2] = controlY;
                    // current[3] and current[4] are NOW the second control point.
                    // we keep it for the next reflection.
                    controlX = current[3];
                    controlY = current[4];
                    break;
                case "q":
                    current[0] = "Q";
                    current[1] += x;
                    current[2] += y;
                    current[3] += x;
                    current[4] += y;
                // falls through
                case "Q":
                    controlX = current[1];
                    controlY = current[2];
                    x = current[3];
                    y = current[4];
                    break;
                case "t":
                    current[0] = "T";
                    current[1] += x;
                    current[2] += y;
                // falls through
                case "T":
                    if (previous === "Q") {
                        // calculate reflection of previous control point
                        controlX = 2 * x - controlX;
                        controlY = 2 * y - controlY;
                    } else {
                        // If there is no previous command or if the previous command was not a Q, q, T or t,
                        // assume the control point is coincident with the current point
                        controlX = x;
                        controlY = y;
                    }
                    current[0] = "Q";
                    x = current[1];
                    y = current[2];
                    current[1] = controlX;
                    current[2] = controlY;
                    current[3] = x;
                    current[4] = y;
                    break;
                case "a":
                    current[0] = "A";
                    current[6] += x;
                    current[7] += y;
                // falls through
                case "A":
                    converted = true;
                    destinationPath = destinationPath.concat(fromArcToBeziers(x, y, current));
                    x = current[6];
                    y = current[7];
                    break;
                case "z":
                case "Z":
                    x = x1;
                    y = y1;
                    break;
                default:
            }
            if (!converted) destinationPath.push(current);
            previous = current[0];
        }
        return destinationPath;
    }
    /**
   * Calc length from point x1,y1 to x2,y2
   * @param {Number} x1 starting point x
   * @param {Number} y1 starting point y
   * @param {Number} x2 starting point x
   * @param {Number} y2 starting point y
   * @return {Number} length of segment
   */ function calcLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    // functions for the Cubic beizer
    // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
    function CB1(t) {
        return t * t * t;
    }
    function CB2(t) {
        return 3 * t * t * (1 - t);
    }
    function CB3(t) {
        return 3 * t * (1 - t) * (1 - t);
    }
    function CB4(t) {
        return (1 - t) * (1 - t) * (1 - t);
    }
    function getPointOnCubicBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        return function(pct) {
            var c1 = CB1(pct), c2 = CB2(pct), c3 = CB3(pct), c4 = CB4(pct);
            return {
                x: p4x * c1 + p3x * c2 + p2x * c3 + p1x * c4,
                y: p4y * c1 + p3y * c2 + p2y * c3 + p1y * c4
            };
        };
    }
    function getTangentCubicIterator(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
        return function(pct) {
            var invT = 1 - pct, tangentX = 3 * invT * invT * (p2x - p1x) + 6 * invT * pct * (p3x - p2x) + 3 * pct * pct * (p4x - p3x), tangentY = 3 * invT * invT * (p2y - p1y) + 6 * invT * pct * (p3y - p2y) + 3 * pct * pct * (p4y - p3y);
            return Math.atan2(tangentY, tangentX);
        };
    }
    function QB1(t) {
        return t * t;
    }
    function QB2(t) {
        return 2 * t * (1 - t);
    }
    function QB3(t) {
        return (1 - t) * (1 - t);
    }
    function getPointOnQuadraticBezierIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
        return function(pct) {
            var c1 = QB1(pct), c2 = QB2(pct), c3 = QB3(pct);
            return {
                x: p3x * c1 + p2x * c2 + p1x * c3,
                y: p3y * c1 + p2y * c2 + p1y * c3
            };
        };
    }
    function getTangentQuadraticIterator(p1x, p1y, p2x, p2y, p3x, p3y) {
        return function(pct) {
            var invT = 1 - pct, tangentX = 2 * invT * (p2x - p1x) + 2 * pct * (p3x - p2x), tangentY = 2 * invT * (p2y - p1y) + 2 * pct * (p3y - p2y);
            return Math.atan2(tangentY, tangentX);
        };
    }
    // this will run over a path segment ( a cubic or quadratic segment) and approximate it
    // with 100 segemnts. This will good enough to calculate the length of the curve
    function pathIterator(iterator, x1, y1) {
        var tempP = {
            x: x1,
            y: y1
        }, p, tmpLen = 0, perc;
        for(perc = 1; perc <= 100; perc += 1){
            p = iterator(perc / 100);
            tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
            tempP = p;
        }
        return tmpLen;
    }
    /**
   * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
   * that correspond to that pixels run over the path.
   * The percentage will be then used to find the correct point on the canvas for the path.
   * @param {Array} segInfo fabricJS collection of information on a parsed path
   * @param {Number} distance from starting point, in pixels.
   * @return {Object} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
   */ function findPercentageForDistance(segInfo, distance) {
        var perc = 0, tmpLen = 0, iterator = segInfo.iterator, tempP = {
            x: segInfo.x,
            y: segInfo.y
        }, p, nextLen, nextStep = 0.01, angleFinder = segInfo.angleFinder, lastPerc;
        // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
        // the path
        while(tmpLen < distance && nextStep > 0.0001){
            p = iterator(perc);
            lastPerc = perc;
            nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y);
            // compare tmpLen each cycle with distance, decide next perc to test.
            if (nextLen + tmpLen > distance) {
                // we discard this step and we make smaller steps.
                perc -= nextStep;
                nextStep /= 2;
            } else {
                tempP = p;
                perc += nextStep;
                tmpLen += nextLen;
            }
        }
        p.angle = angleFinder(lastPerc);
        return p;
    }
    /**
   * Run over a parsed and simplifed path and extrac some informations.
   * informations are length of each command and starting point
   * @param {Array} path fabricJS parsed path commands
   * @return {Array} path commands informations
   */ function getPathSegmentsInfo(path) {
        var totalLength = 0, len = path.length, current, //x2 and y2 are the coords of segment start
        //x1 and y1 are the coords of the current point
        x1 = 0, y1 = 0, x2 = 0, y2 = 0, info = [], iterator, tempInfo, angleFinder;
        for(var i = 0; i < len; i++){
            current = path[i];
            tempInfo = {
                x: x1,
                y: y1,
                command: current[0]
            };
            switch(current[0]){
                case "M":
                    tempInfo.length = 0;
                    x2 = x1 = current[1];
                    y2 = y1 = current[2];
                    break;
                case "L":
                    tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
                    x1 = current[1];
                    y1 = current[2];
                    break;
                case "C":
                    iterator = getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                    angleFinder = getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                    tempInfo.iterator = iterator;
                    tempInfo.angleFinder = angleFinder;
                    tempInfo.length = pathIterator(iterator, x1, y1);
                    x1 = current[5];
                    y1 = current[6];
                    break;
                case "Q":
                    iterator = getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
                    angleFinder = getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
                    tempInfo.iterator = iterator;
                    tempInfo.angleFinder = angleFinder;
                    tempInfo.length = pathIterator(iterator, x1, y1);
                    x1 = current[3];
                    y1 = current[4];
                    break;
                case "Z":
                case "z":
                    // we add those in order to ease calculations later
                    tempInfo.destX = x2;
                    tempInfo.destY = y2;
                    tempInfo.length = calcLineLength(x1, y1, x2, y2);
                    x1 = x2;
                    y1 = y2;
                    break;
            }
            totalLength += tempInfo.length;
            info.push(tempInfo);
        }
        info.push({
            length: totalLength,
            x: x1,
            y: y1
        });
        return info;
    }
    function getPointOnPath(path, distance, infos) {
        if (!infos) infos = getPathSegmentsInfo(path);
        var i = 0;
        while(distance - infos[i].length > 0 && i < infos.length - 2){
            distance -= infos[i].length;
            i++;
        }
        // var distance = infos[infos.length - 1] * perc;
        var segInfo = infos[i], segPercent = distance / segInfo.length, command = segInfo.command, segment = path[i], info;
        switch(command){
            case "M":
                return {
                    x: segInfo.x,
                    y: segInfo.y,
                    angle: 0
                };
            case "Z":
            case "z":
                info = new $d47795690082d4de$var$fabric.Point(segInfo.x, segInfo.y).lerp(new $d47795690082d4de$var$fabric.Point(segInfo.destX, segInfo.destY), segPercent);
                info.angle = Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x);
                return info;
            case "L":
                info = new $d47795690082d4de$var$fabric.Point(segInfo.x, segInfo.y).lerp(new $d47795690082d4de$var$fabric.Point(segment[1], segment[2]), segPercent);
                info.angle = Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x);
                return info;
            case "C":
                return findPercentageForDistance(segInfo, distance);
            case "Q":
                return findPercentageForDistance(segInfo, distance);
        }
    }
    /**
   *
   * @param {string} pathString
   * @return {(string|number)[][]} An array of SVG path commands
   * @example <caption>Usage</caption>
   * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
   *   ['M', 3, 4],
   *   ['Q', 3, 5, 2, 1, 4, 0],
   *   ['Q', 9, 12, 2, 1, 4, 0],
   * ];
   *
   */ function parsePath(pathString) {
        var result = [], coords = [], currentPath, parsed, re = $d47795690082d4de$var$fabric.rePathCommand, rNumber = "[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?\\s*", rNumberCommaWsp = "(" + rNumber + ")" + $d47795690082d4de$var$fabric.commaWsp, rFlagCommaWsp = "([01])" + $d47795690082d4de$var$fabric.commaWsp + "?", rArcSeq = rNumberCommaWsp + "?" + rNumberCommaWsp + "?" + rNumberCommaWsp + rFlagCommaWsp + rFlagCommaWsp + rNumberCommaWsp + "?(" + rNumber + ")", regArcArgumentSequence = new RegExp(rArcSeq, "g"), match, coordsStr, // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
        path;
        if (!pathString || !pathString.match) return result;
        path = pathString.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);
        for(var i = 0, coordsParsed, len = path.length; i < len; i++){
            currentPath = path[i];
            coordsStr = currentPath.slice(1).trim();
            coords.length = 0;
            var command = currentPath.charAt(0);
            coordsParsed = [
                command
            ];
            if (command.toLowerCase() === "a") {
                // arcs have special flags that apparently don't require spaces so handle special
                for(var args; args = regArcArgumentSequence.exec(coordsStr);)for(var j = 1; j < args.length; j++)coords.push(args[j]);
            } else while(match = re.exec(coordsStr))coords.push(match[0]);
            for(var j = 0, jlen = coords.length; j < jlen; j++){
                parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) coordsParsed.push(parsed);
            }
            var commandLength = commandLengths[command.toLowerCase()], repeatedCommand = repeatedCommands[command] || command;
            if (coordsParsed.length - 1 > commandLength) for(var k = 1, klen = coordsParsed.length; k < klen; k += commandLength){
                result.push([
                    command
                ].concat(coordsParsed.slice(k, k + commandLength)));
                command = repeatedCommand;
            }
            else result.push(coordsParsed);
        }
        return result;
    }
    /**
   *
   * Converts points to a smooth SVG path
   * @param {{ x: number,y: number }[]} points Array of points
   * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
   * @return {(string|number)[][]} An array of SVG path commands
   */ function getSmoothPathFromPoints(points, correction) {
        var path = [], i, p1 = new $d47795690082d4de$var$fabric.Point(points[0].x, points[0].y), p2 = new $d47795690082d4de$var$fabric.Point(points[1].x, points[1].y), len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;
        correction = correction || 0;
        if (manyPoints) {
            multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
            multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
        }
        path.push([
            "M",
            p1.x - multSignX * correction,
            p1.y - multSignY * correction
        ]);
        for(i = 1; i < len; i++){
            if (!p1.eq(p2)) {
                var midPoint = p1.midPointFrom(p2);
                // p1 is our bezier control point
                // midpoint is our endpoint
                // start point is p(i-1) value.
                path.push([
                    "Q",
                    p1.x,
                    p1.y,
                    midPoint.x,
                    midPoint.y
                ]);
            }
            p1 = points[i];
            if (i + 1 < points.length) p2 = points[i + 1];
        }
        if (manyPoints) {
            multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
            multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
        }
        path.push([
            "L",
            p1.x + multSignX * correction,
            p1.y + multSignY * correction
        ]);
        return path;
    }
    /**
   * Transform a path by transforming each segment.
   * it has to be a simplified path or it won't work.
   * WARNING: this depends from pathOffset for correct operation
   * @param {Array} path fabricJS parsed and simplified path commands
   * @param {Array} transform matrix that represent the transformation
   * @param {Object} [pathOffset] the fabric.Path pathOffset
   * @param {Number} pathOffset.x
   * @param {Number} pathOffset.y
   * @returns {Array} the transformed path
   */ function transformPath(path, transform, pathOffset) {
        if (pathOffset) transform = $d47795690082d4de$var$fabric.util.multiplyTransformMatrices(transform, [
            1,
            0,
            0,
            1,
            -pathOffset.x,
            -pathOffset.y
        ]);
        return path.map(function(pathSegment) {
            var newSegment = pathSegment.slice(0), point = {};
            for(var i = 1; i < pathSegment.length - 1; i += 2){
                point.x = pathSegment[i];
                point.y = pathSegment[i + 1];
                point = $d47795690082d4de$var$fabric.util.transformPoint(point, transform);
                newSegment[i] = point.x;
                newSegment[i + 1] = point.y;
            }
            return newSegment;
        });
    }
    /**
   * Join path commands to go back to svg format
   * @param {Array} pathData fabricJS parsed path commands
   * @return {String} joined path 'M 0 0 L 20 30'
   */ $d47795690082d4de$var$fabric.util.joinPath = function(pathData) {
        return pathData.map(function(segment) {
            return segment.join(" ");
        }).join(" ");
    };
    $d47795690082d4de$var$fabric.util.parsePath = parsePath;
    $d47795690082d4de$var$fabric.util.makePathSimpler = makePathSimpler;
    $d47795690082d4de$var$fabric.util.getSmoothPathFromPoints = getSmoothPathFromPoints;
    $d47795690082d4de$var$fabric.util.getPathSegmentsInfo = getPathSegmentsInfo;
    $d47795690082d4de$var$fabric.util.getBoundsOfCurve = getBoundsOfCurve;
    $d47795690082d4de$var$fabric.util.getPointOnPath = getPointOnPath;
    $d47795690082d4de$var$fabric.util.transformPath = transformPath;
})();
(function() {
    var slice = Array.prototype.slice;
    /**
   * Invokes method on all items in a given array
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} method Name of a method to invoke
   * @return {Array}
   */ function invoke(array, method) {
        var args = slice.call(arguments, 2), result = [];
        for(var i = 0, len = array.length; i < len; i++)result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
        return result;
    }
    /**
   * Finds maximum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */ function max(array, byProperty) {
        return find(array, byProperty, function(value1, value2) {
            return value1 >= value2;
        });
    }
    /**
   * Finds minimum value in array (not necessarily "first" one)
   * @memberOf fabric.util.array
   * @param {Array} array Array to iterate over
   * @param {String} byProperty
   * @return {*}
   */ function min(array, byProperty) {
        return find(array, byProperty, function(value1, value2) {
            return value1 < value2;
        });
    }
    /**
   * @private
   */ function fill(array, value) {
        var k = array.length;
        while(k--)array[k] = value;
        return array;
    }
    /**
   * @private
   */ function find(array, byProperty, condition) {
        if (!array || array.length === 0) return;
        var i = array.length - 1, result = byProperty ? array[i][byProperty] : array[i];
        if (byProperty) {
            while(i--)if (condition(array[i][byProperty], result)) result = array[i][byProperty];
        } else {
            while(i--)if (condition(array[i], result)) result = array[i];
        }
        return result;
    }
    /**
   * @namespace fabric.util.array
   */ $d47795690082d4de$var$fabric.util.array = {
        fill: fill,
        invoke: invoke,
        min: min,
        max: max
    };
})();
(function() {
    /**
   * Copies all enumerable properties of one js object to another
   * this does not and cannot compete with generic utils.
   * Does not clone or extend fabric.Object subclasses.
   * This is mostly for internal use and has extra handling for fabricJS objects
   * it skips the canvas and group properties in deep cloning.
   * @memberOf fabric.util.object
   * @param {Object} destination Where to copy to
   * @param {Object} source Where to copy from
   * @param {Boolean} [deep] Whether to extend nested objects
   * @return {Object}
   */ function extend(destination, source, deep) {
        // JScript DontEnum bug is not taken care of
        // the deep clone is for internal use, is not meant to avoid
        // javascript traps or cloning html element or self referenced objects.
        if (deep) {
            if (!$d47795690082d4de$var$fabric.isLikelyNode && source instanceof Element) // avoid cloning deep images, canvases,
            destination = source;
            else if (source instanceof Array) {
                destination = [];
                for(var i = 0, len = source.length; i < len; i++)destination[i] = extend({}, source[i], deep);
            } else if (source && typeof source === "object") for(var property in source){
                if (property === "canvas" || property === "group") // we do not want to clone this props at all.
                // we want to keep the keys in the copy
                destination[property] = null;
                else if (source.hasOwnProperty(property)) destination[property] = extend({}, source[property], deep);
            }
            else // this sounds odd for an extend but is ok for recursive use
            destination = source;
        } else for(var property in source)destination[property] = source[property];
        return destination;
    }
    /**
   * Creates an empty object and copies all enumerable properties of another object to it
   * This method is mostly for internal use, and not intended for duplicating shapes in canvas. 
   * @memberOf fabric.util.object
   * @param {Object} object Object to clone
   * @param {Boolean} [deep] Whether to clone nested objects
   * @return {Object}
   */ //TODO: this function return an empty object if you try to clone null
    function clone(object, deep) {
        return extend({}, object, deep);
    }
    /** @namespace fabric.util.object */ $d47795690082d4de$var$fabric.util.object = {
        extend: extend,
        clone: clone
    };
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.util, $d47795690082d4de$var$fabric.Observable);
})();
(function() {
    /**
   * Camelizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to camelize
   * @return {String} Camelized version of a string
   */ function camelize(string) {
        return string.replace(/-+(.)?/g, function(match, character) {
            return character ? character.toUpperCase() : "";
        });
    }
    /**
   * Capitalizes a string
   * @memberOf fabric.util.string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */ function capitalize(string, firstLetterOnly) {
        return string.charAt(0).toUpperCase() + (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
    }
    /**
   * Escapes XML in a string
   * @memberOf fabric.util.string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */ function escapeXml(string) {
        return string.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    /**
   * Divide a string in the user perceived single units
   * @memberOf fabric.util.string
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */ function graphemeSplit(textstring) {
        var i = 0, chr, graphemes = [];
        for(i = 0, chr; i < textstring.length; i++){
            if ((chr = getWholeChar(textstring, i)) === false) continue;
            graphemes.push(chr);
        }
        return graphemes;
    }
    // taken from mdn in the charAt doc page.
    function getWholeChar(str, i) {
        var code = str.charCodeAt(i);
        if (isNaN(code)) return ""; // Position not found
        if (code < 0xD800 || code > 0xDFFF) return str.charAt(i);
        // High surrogate (could change last hex to 0xDB7F to treat high private
        // surrogates as single characters)
        if (0xD800 <= code && code <= 0xDBFF) {
            if (str.length <= i + 1) throw "High surrogate without following low surrogate";
            var next = str.charCodeAt(i + 1);
            if (0xDC00 > next || next > 0xDFFF) throw "High surrogate without following low surrogate";
            return str.charAt(i) + str.charAt(i + 1);
        }
        // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
        if (i === 0) throw "Low surrogate without preceding high surrogate";
        var prev = str.charCodeAt(i - 1);
        // (could change last hex to 0xDB7F to treat high private
        // surrogates as single characters)
        if (0xD800 > prev || prev > 0xDBFF) throw "Low surrogate without preceding high surrogate";
        // We can pass over low surrogates now as the second component
        // in a pair which we have already processed
        return false;
    }
    /**
   * String utilities
   * @namespace fabric.util.string
   */ $d47795690082d4de$var$fabric.util.string = {
        camelize: camelize,
        capitalize: capitalize,
        escapeXml: escapeXml,
        graphemeSplit: graphemeSplit
    };
})();
(function() {
    var slice = Array.prototype.slice, emptyFunction = function() {}, IS_DONTENUM_BUGGY = function() {
        for(var p in {
            toString: 1
        }){
            if (p === "toString") return false;
        }
        return true;
    }(), /** @ignore */ addMethods = function(klass, source, parent) {
        for(var property in source){
            if (property in klass.prototype && typeof klass.prototype[property] === "function" && (source[property] + "").indexOf("callSuper") > -1) klass.prototype[property] = function(property) {
                return function() {
                    var superclass = this.constructor.superclass;
                    this.constructor.superclass = parent;
                    var returnValue = source[property].apply(this, arguments);
                    this.constructor.superclass = superclass;
                    if (property !== "initialize") return returnValue;
                };
            }(property);
            else klass.prototype[property] = source[property];
            if (IS_DONTENUM_BUGGY) {
                if (source.toString !== Object.prototype.toString) klass.prototype.toString = source.toString;
                if (source.valueOf !== Object.prototype.valueOf) klass.prototype.valueOf = source.valueOf;
            }
        }
    };
    function Subclass() {}
    function callSuper(methodName) {
        var parentMethod = null, _this = this;
        // climb prototype chain to find method not equal to callee's method
        while(_this.constructor.superclass){
            var superClassMethod = _this.constructor.superclass.prototype[methodName];
            if (_this[methodName] !== superClassMethod) {
                parentMethod = superClassMethod;
                break;
            }
            // eslint-disable-next-line
            _this = _this.constructor.superclass.prototype;
        }
        if (!parentMethod) return console.log("tried to callSuper " + methodName + ", method not found in prototype chain", this);
        return arguments.length > 1 ? parentMethod.apply(this, slice.call(arguments, 1)) : parentMethod.call(this);
    }
    /**
   * Helper for creation of "classes".
   * @memberOf fabric.util
   * @param {Function} [parent] optional "Class" to inherit from
   * @param {Object} [properties] Properties shared by all instances of this class
   *                  (be careful modifying objects defined here as this would affect all instances)
   */ function createClass() {
        var parent = null, properties = slice.call(arguments, 0);
        if (typeof properties[0] === "function") parent = properties.shift();
        function klass() {
            this.initialize.apply(this, arguments);
        }
        klass.superclass = parent;
        klass.subclasses = [];
        if (parent) {
            Subclass.prototype = parent.prototype;
            klass.prototype = new Subclass();
            parent.subclasses.push(klass);
        }
        for(var i = 0, length = properties.length; i < length; i++)addMethods(klass, properties[i], parent);
        if (!klass.prototype.initialize) klass.prototype.initialize = emptyFunction;
        klass.prototype.constructor = klass;
        klass.prototype.callSuper = callSuper;
        return klass;
    }
    $d47795690082d4de$var$fabric.util.createClass = createClass;
})();
(function() {
    // since ie11 can use addEventListener but they do not support options, i need to check
    var couldUseAttachEvent = !!$d47795690082d4de$var$fabric.document.createElement("div").attachEvent, touchEvents = [
        "touchstart",
        "touchmove",
        "touchend"
    ];
    /**
   * Adds an event listener to an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */ $d47795690082d4de$var$fabric.util.addListener = function(element, eventName, handler, options) {
        element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    /**
   * Removes an event listener from an element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {String} eventName
   * @param {Function} handler
   */ $d47795690082d4de$var$fabric.util.removeListener = function(element, eventName, handler, options) {
        element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
    };
    function getTouchInfo(event) {
        var touchProp = event.changedTouches;
        if (touchProp && touchProp[0]) return touchProp[0];
        return event;
    }
    $d47795690082d4de$var$fabric.util.getPointer = function(event) {
        var element = event.target, scroll = $d47795690082d4de$var$fabric.util.getScrollLeftTop(element), _evt = getTouchInfo(event);
        return {
            x: _evt.clientX + scroll.left,
            y: _evt.clientY + scroll.top
        };
    };
    $d47795690082d4de$var$fabric.util.isTouchEvent = function(event) {
        return touchEvents.indexOf(event.type) > -1 || event.pointerType === "touch";
    };
})();
(function() {
    /**
   * Cross-browser wrapper for setting element's style
   * @memberOf fabric.util
   * @param {HTMLElement} element
   * @param {Object} styles
   * @return {HTMLElement} Element that was passed as a first argument
   */ function setStyle(element, styles) {
        var elementStyle = element.style;
        if (!elementStyle) return element;
        if (typeof styles === "string") {
            element.style.cssText += ";" + styles;
            return styles.indexOf("opacity") > -1 ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1]) : element;
        }
        for(var property in styles)if (property === "opacity") setOpacity(element, styles[property]);
        else {
            var normalizedProperty = property === "float" || property === "cssFloat" ? typeof elementStyle.styleFloat === "undefined" ? "cssFloat" : "styleFloat" : property;
            elementStyle.setProperty(normalizedProperty, styles[property]);
        }
        return element;
    }
    var parseEl = $d47795690082d4de$var$fabric.document.createElement("div"), supportsOpacity = typeof parseEl.style.opacity === "string", supportsFilters = typeof parseEl.style.filter === "string", reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/, /** @ignore */ setOpacity = function(element) {
        return element;
    };
    if (supportsOpacity) /** @ignore */ setOpacity = function(element, value) {
        element.style.opacity = value;
        return element;
    };
    else if (supportsFilters) /** @ignore */ setOpacity = function(element, value) {
        var es = element.style;
        if (element.currentStyle && !element.currentStyle.hasLayout) es.zoom = 1;
        if (reOpacity.test(es.filter)) {
            value = value >= 0.9999 ? "" : "alpha(opacity=" + value * 100 + ")";
            es.filter = es.filter.replace(reOpacity, value);
        } else es.filter += " alpha(opacity=" + value * 100 + ")";
        return element;
    };
    $d47795690082d4de$var$fabric.util.setStyle = setStyle;
})();
(function() {
    var _slice = Array.prototype.slice;
    /**
   * Takes id and returns an element with that id (if one exists in a document)
   * @memberOf fabric.util
   * @param {String|HTMLElement} id
   * @return {HTMLElement|null}
   */ function getById(id) {
        return typeof id === "string" ? $d47795690082d4de$var$fabric.document.getElementById(id) : id;
    }
    var sliceCanConvertNodelists, /**
       * Converts an array-like object (e.g. arguments or NodeList) to an array
       * @memberOf fabric.util
       * @param {Object} arrayLike
       * @return {Array}
       */ toArray = function(arrayLike) {
        return _slice.call(arrayLike, 0);
    };
    try {
        sliceCanConvertNodelists = toArray($d47795690082d4de$var$fabric.document.childNodes) instanceof Array;
    } catch (err) {}
    if (!sliceCanConvertNodelists) toArray = function(arrayLike) {
        var arr = new Array(arrayLike.length), i = arrayLike.length;
        while(i--)arr[i] = arrayLike[i];
        return arr;
    };
    /**
   * Creates specified element with specified attributes
   * @memberOf fabric.util
   * @param {String} tagName Type of an element to create
   * @param {Object} [attributes] Attributes to set on an element
   * @return {HTMLElement} Newly created element
   */ function makeElement(tagName, attributes) {
        var el = $d47795690082d4de$var$fabric.document.createElement(tagName);
        for(var prop in attributes){
            if (prop === "class") el.className = attributes[prop];
            else if (prop === "for") el.htmlFor = attributes[prop];
            else el.setAttribute(prop, attributes[prop]);
        }
        return el;
    }
    /**
   * Adds class to an element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to add class to
   * @param {String} className Class to add to an element
   */ function addClass(element, className) {
        if (element && (" " + element.className + " ").indexOf(" " + className + " ") === -1) element.className += (element.className ? " " : "") + className;
    }
    /**
   * Wraps element with another element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to wrap
   * @param {HTMLElement|String} wrapper Element to wrap with
   * @param {Object} [attributes] Attributes to set on a wrapper
   * @return {HTMLElement} wrapper
   */ function wrapElement(element, wrapper, attributes) {
        if (typeof wrapper === "string") wrapper = makeElement(wrapper, attributes);
        if (element.parentNode) element.parentNode.replaceChild(wrapper, element);
        wrapper.appendChild(element);
        return wrapper;
    }
    /**
   * Returns element scroll offsets
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */ function getScrollLeftTop(element) {
        var left = 0, top = 0, docElement = $d47795690082d4de$var$fabric.document.documentElement, body = $d47795690082d4de$var$fabric.document.body || {
            scrollLeft: 0,
            scrollTop: 0
        };
        // While loop checks (and then sets element to) .parentNode OR .host
        //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
        //  but the .parentNode of a root ShadowDOM node will always be null, instead
        //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
        while(element && (element.parentNode || element.host)){
            // Set element to element parent, or 'host' in case of ShadowDOM
            element = element.parentNode || element.host;
            if (element === $d47795690082d4de$var$fabric.document) {
                left = body.scrollLeft || docElement.scrollLeft || 0;
                top = body.scrollTop || docElement.scrollTop || 0;
            } else {
                left += element.scrollLeft || 0;
                top += element.scrollTop || 0;
            }
            if (element.nodeType === 1 && element.style.position === "fixed") break;
        }
        return {
            left: left,
            top: top
        };
    }
    /**
   * Returns offset for a given element
   * @function
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */ function getElementOffset(element) {
        var docElem, doc = element && element.ownerDocument, box = {
            left: 0,
            top: 0
        }, offset = {
            left: 0,
            top: 0
        }, scrollLeftTop, offsetAttributes = {
            borderLeftWidth: "left",
            borderTopWidth: "top",
            paddingLeft: "left",
            paddingTop: "top"
        };
        if (!doc) return offset;
        for(var attr in offsetAttributes)offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
        docElem = doc.documentElement;
        if (typeof element.getBoundingClientRect !== "undefined") box = element.getBoundingClientRect();
        scrollLeftTop = getScrollLeftTop(element);
        return {
            left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
            top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
        };
    }
    /**
   * Returns style attribute value of a given element
   * @memberOf fabric.util
   * @param {HTMLElement} element Element to get style attribute for
   * @param {String} attr Style attribute to get for element
   * @return {String} Style attribute value of the given element.
   */ var getElementStyle;
    if ($d47795690082d4de$var$fabric.document.defaultView && $d47795690082d4de$var$fabric.document.defaultView.getComputedStyle) getElementStyle = function(element, attr) {
        var style = $d47795690082d4de$var$fabric.document.defaultView.getComputedStyle(element, null);
        return style ? style[attr] : undefined;
    };
    else getElementStyle = function(element, attr) {
        var value = element.style[attr];
        if (!value && element.currentStyle) value = element.currentStyle[attr];
        return value;
    };
    (function() {
        var style = $d47795690082d4de$var$fabric.document.documentElement.style, selectProp = "userSelect" in style ? "userSelect" : "MozUserSelect" in style ? "MozUserSelect" : "WebkitUserSelect" in style ? "WebkitUserSelect" : "KhtmlUserSelect" in style ? "KhtmlUserSelect" : "";
        /**
     * Makes element unselectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make unselectable
     * @return {HTMLElement} Element that was passed in
     */ function makeElementUnselectable(element) {
            if (typeof element.onselectstart !== "undefined") element.onselectstart = $d47795690082d4de$var$fabric.util.falseFunction;
            if (selectProp) element.style[selectProp] = "none";
            else if (typeof element.unselectable === "string") element.unselectable = "on";
            return element;
        }
        /**
     * Makes element selectable
     * @memberOf fabric.util
     * @param {HTMLElement} element Element to make selectable
     * @return {HTMLElement} Element that was passed in
     */ function makeElementSelectable(element) {
            if (typeof element.onselectstart !== "undefined") element.onselectstart = null;
            if (selectProp) element.style[selectProp] = "";
            else if (typeof element.unselectable === "string") element.unselectable = "";
            return element;
        }
        $d47795690082d4de$var$fabric.util.makeElementUnselectable = makeElementUnselectable;
        $d47795690082d4de$var$fabric.util.makeElementSelectable = makeElementSelectable;
    })();
    function getNodeCanvas(element) {
        var impl = $d47795690082d4de$var$fabric.jsdomImplForWrapper(element);
        return impl._canvas || impl._image;
    }
    function cleanUpJsdomNode(element) {
        if (!$d47795690082d4de$var$fabric.isLikelyNode) return;
        var impl = $d47795690082d4de$var$fabric.jsdomImplForWrapper(element);
        if (impl) {
            impl._image = null;
            impl._canvas = null;
            // unsure if necessary
            impl._currentSrc = null;
            impl._attributes = null;
            impl._classList = null;
        }
    }
    function setImageSmoothing(ctx, value) {
        ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
        ctx.imageSmoothingEnabled = value;
    }
    /**
   * setImageSmoothing sets the context imageSmoothingEnabled property.
   * Used by canvas and by ImageObject.
   * @memberOf fabric.util
   * @since 4.0.0
   * @param {HTMLRenderingContext2D} ctx to set on
   * @param {Boolean} value true or false
   */ $d47795690082d4de$var$fabric.util.setImageSmoothing = setImageSmoothing;
    $d47795690082d4de$var$fabric.util.getById = getById;
    $d47795690082d4de$var$fabric.util.toArray = toArray;
    $d47795690082d4de$var$fabric.util.addClass = addClass;
    $d47795690082d4de$var$fabric.util.makeElement = makeElement;
    $d47795690082d4de$var$fabric.util.wrapElement = wrapElement;
    $d47795690082d4de$var$fabric.util.getScrollLeftTop = getScrollLeftTop;
    $d47795690082d4de$var$fabric.util.getElementOffset = getElementOffset;
    $d47795690082d4de$var$fabric.util.getNodeCanvas = getNodeCanvas;
    $d47795690082d4de$var$fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;
})();
(function() {
    function addParamToUrl(url, param) {
        return url + (/\?/.test(url) ? "&" : "?") + param;
    }
    function emptyFn() {}
    /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @memberOf fabric.util
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {String} [options.method="GET"]
   * @param {String} [options.parameters] parameters to append to url in GET or in body
   * @param {String} [options.body] body to send with POST or PUT request
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */ function request(url, options) {
        options || (options = {});
        var method = options.method ? options.method.toUpperCase() : "GET", onComplete = options.onComplete || function() {}, xhr = new $d47795690082d4de$var$fabric.window.XMLHttpRequest(), body = options.body || options.parameters;
        /** @ignore */ xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                onComplete(xhr);
                xhr.onreadystatechange = emptyFn;
            }
        };
        if (method === "GET") {
            body = null;
            if (typeof options.parameters === "string") url = addParamToUrl(url, options.parameters);
        }
        xhr.open(method, url, true);
        if (method === "POST" || method === "PUT") xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(body);
        return xhr;
    }
    $d47795690082d4de$var$fabric.util.request = request;
})();
/**
 * Wrapper around `console.log` (when available)
 * @param {*} [values] Values to log
 */ $d47795690082d4de$var$fabric.log = console.log;
/**
 * Wrapper around `console.warn` (when available)
 * @param {*} [values] Values to log as a warning
 */ $d47795690082d4de$var$fabric.warn = console.warn;
(function() {
    var extend = $d47795690082d4de$var$fabric.util.object.extend, clone = $d47795690082d4de$var$fabric.util.object.clone;
    /**
   * @typedef {Object} AnimationOptions
   * Animation of a value or list of values.
   * When using lists, think of something like this:
   * fabric.util.animate({
   *   startValue: [1, 2, 3],
   *   endValue: [2, 4, 6],
   *   onChange: function([a, b, c]) {
   *     canvas.zoomToPoint({x: b, y: c}, a)
   *     canvas.renderAll()
   *   }
   * });
   * @example
   * @property {Function} [onChange] Callback; invoked on every value change
   * @property {Function} [onComplete] Callback; invoked when value change is completed
   * @example
   * // Note: startValue, endValue, and byValue must match the type
   * var animationOptions = { startValue: 0, endValue: 1, byValue: 0.25 }
   * var animationOptions = { startValue: [0, 1], endValue: [1, 2], byValue: [0.25, 0.25] }
   * @property {number | number[]} [startValue=0] Starting value
   * @property {number | number[]} [endValue=100] Ending value
   * @property {number | number[]} [byValue=100] Value to modify the property by
   * @property {Function} [easing] Easing function
   * @property {Number} [duration=500] Duration of change (in ms)
   * @property {Function} [abort] Additional function with logic. If returns true, animation aborts.
   *
   * @typedef {() => void} CancelFunction
   *
   * @typedef {Object} AnimationCurrentState
   * @property {number | number[]} currentValue value in range [`startValue`, `endValue`]
   * @property {number} completionRate value in range [0, 1]
   * @property {number} durationRate value in range [0, 1]
   *
   * @typedef {(AnimationOptions & AnimationCurrentState & { cancel: CancelFunction }} AnimationContext
   */ /**
   * Array holding all running animations
   * @memberof fabric
   * @type {AnimationContext[]}
   */ var RUNNING_ANIMATIONS = [];
    $d47795690082d4de$var$fabric.util.object.extend(RUNNING_ANIMATIONS, {
        /**
     * cancel all running animations at the next requestAnimFrame
     * @returns {AnimationContext[]}
     */ cancelAll: function() {
            var animations = this.splice(0);
            animations.forEach(function(animation) {
                animation.cancel();
            });
            return animations;
        },
        /**
     * cancel all running animations attached to canvas at the next requestAnimFrame
     * @param {fabric.Canvas} canvas
     * @returns {AnimationContext[]}
     */ cancelByCanvas: function(canvas) {
            if (!canvas) return [];
            var cancelled = this.filter(function(animation) {
                return typeof animation.target === "object" && animation.target.canvas === canvas;
            });
            cancelled.forEach(function(animation) {
                animation.cancel();
            });
            return cancelled;
        },
        /**
     * cancel all running animations for target at the next requestAnimFrame
     * @param {*} target
     * @returns {AnimationContext[]}
     */ cancelByTarget: function(target) {
            var cancelled = this.findAnimationsByTarget(target);
            cancelled.forEach(function(animation) {
                animation.cancel();
            });
            return cancelled;
        },
        /**
     *
     * @param {CancelFunction} cancelFunc the function returned by animate
     * @returns {number}
     */ findAnimationIndex: function(cancelFunc) {
            return this.indexOf(this.findAnimation(cancelFunc));
        },
        /**
     *
     * @param {CancelFunction} cancelFunc the function returned by animate
     * @returns {AnimationContext | undefined} animation's options object
     */ findAnimation: function(cancelFunc) {
            return this.find(function(animation) {
                return animation.cancel === cancelFunc;
            });
        },
        /**
     *
     * @param {*} target the object that is assigned to the target property of the animation context
     * @returns {AnimationContext[]} array of animation options object associated with target
     */ findAnimationsByTarget: function(target) {
            if (!target) return [];
            return this.filter(function(animation) {
                return animation.target === target;
            });
        }
    });
    function noop() {
        return false;
    }
    function defaultEasing(t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    /**
   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {AnimationOptions} [options] Animation options
   * @example
   * // Note: startValue, endValue, and byValue must match the type
   * fabric.util.animate({ startValue: 0, endValue: 1, byValue: 0.25 })
   * fabric.util.animate({ startValue: [0, 1], endValue: [1, 2], byValue: [0.25, 0.25] })
   * @returns {CancelFunction} cancel function
   */ function animate(options) {
        options || (options = {});
        var cancel = false, context, removeFromRegistry = function() {
            var index = $d47795690082d4de$var$fabric.runningAnimations.indexOf(context);
            return index > -1 && $d47795690082d4de$var$fabric.runningAnimations.splice(index, 1)[0];
        };
        context = extend(clone(options), {
            cancel: function() {
                cancel = true;
                return removeFromRegistry();
            },
            currentValue: "startValue" in options ? options.startValue : 0,
            completionRate: 0,
            durationRate: 0
        });
        $d47795690082d4de$var$fabric.runningAnimations.push(context);
        requestAnimFrame(function(timestamp) {
            var start = timestamp || +new Date(), duration = options.duration || 500, finish = start + duration, time, onChange = options.onChange || noop, abort = options.abort || noop, onComplete = options.onComplete || noop, easing = options.easing || defaultEasing, isMany = "startValue" in options ? options.startValue.length > 0 : false, startValue = "startValue" in options ? options.startValue : 0, endValue = "endValue" in options ? options.endValue : 100, byValue = options.byValue || (isMany ? startValue.map(function(value, i) {
                return endValue[i] - startValue[i];
            }) : endValue - startValue);
            options.onStart && options.onStart();
            (function tick(ticktime) {
                time = ticktime || +new Date();
                var currentTime = time > finish ? duration : time - start, timePerc = currentTime / duration, current = isMany ? startValue.map(function(_value, i) {
                    return easing(currentTime, startValue[i], byValue[i], duration);
                }) : easing(currentTime, startValue, byValue, duration), valuePerc = isMany ? Math.abs((current[0] - startValue[0]) / byValue[0]) : Math.abs((current - startValue) / byValue);
                //  update context
                context.currentValue = isMany ? current.slice() : current;
                context.completionRate = valuePerc;
                context.durationRate = timePerc;
                if (cancel) return;
                if (abort(current, valuePerc, timePerc)) {
                    removeFromRegistry();
                    return;
                }
                if (time > finish) {
                    //  update context
                    context.currentValue = isMany ? endValue.slice() : endValue;
                    context.completionRate = 1;
                    context.durationRate = 1;
                    //  execute callbacks
                    onChange(isMany ? endValue.slice() : endValue, 1, 1);
                    onComplete(endValue, 1, 1);
                    removeFromRegistry();
                    return;
                } else {
                    onChange(current, valuePerc, timePerc);
                    requestAnimFrame(tick);
                }
            })(start);
        });
        return context.cancel;
    }
    var _requestAnimFrame = $d47795690082d4de$var$fabric.window.requestAnimationFrame || $d47795690082d4de$var$fabric.window.webkitRequestAnimationFrame || $d47795690082d4de$var$fabric.window.mozRequestAnimationFrame || $d47795690082d4de$var$fabric.window.oRequestAnimationFrame || $d47795690082d4de$var$fabric.window.msRequestAnimationFrame || function(callback) {
        return $d47795690082d4de$var$fabric.window.setTimeout(callback, 1000 / 60);
    };
    var _cancelAnimFrame = $d47795690082d4de$var$fabric.window.cancelAnimationFrame || $d47795690082d4de$var$fabric.window.clearTimeout;
    /**
   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
   * @memberOf fabric.util
   * @param {Function} callback Callback to invoke
   * @param {DOMElement} element optional Element to associate with animation
   */ function requestAnimFrame() {
        return _requestAnimFrame.apply($d47795690082d4de$var$fabric.window, arguments);
    }
    function cancelAnimFrame() {
        return _cancelAnimFrame.apply($d47795690082d4de$var$fabric.window, arguments);
    }
    $d47795690082d4de$var$fabric.util.animate = animate;
    $d47795690082d4de$var$fabric.util.requestAnimFrame = requestAnimFrame;
    $d47795690082d4de$var$fabric.util.cancelAnimFrame = cancelAnimFrame;
    $d47795690082d4de$var$fabric.runningAnimations = RUNNING_ANIMATIONS;
})();
(function() {
    // Calculate an in-between color. Returns a "rgba()" string.
    // Credit: Edwin Martin <edwin@bitstorm.org>
    //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
    function calculateColor(begin, end, pos) {
        var color = "rgba(" + parseInt(begin[0] + pos * (end[0] - begin[0]), 10) + "," + parseInt(begin[1] + pos * (end[1] - begin[1]), 10) + "," + parseInt(begin[2] + pos * (end[2] - begin[2]), 10);
        color += "," + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
        color += ")";
        return color;
    }
    /**
   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
   * @memberOf fabric.util
   * @param {String} fromColor The starting color in hex or rgb(a) format.
   * @param {String} toColor The starting color in hex or rgb(a) format.
   * @param {Number} [duration] Duration of change (in ms).
   * @param {Object} [options] Animation options
   * @param {Function} [options.onChange] Callback; invoked on every value change
   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
   * @returns {Function} abort function
   */ function animateColor(fromColor, toColor, duration, options) {
        var startColor = new $d47795690082d4de$var$fabric.Color(fromColor).getSource(), endColor = new $d47795690082d4de$var$fabric.Color(toColor).getSource(), originalOnComplete = options.onComplete, originalOnChange = options.onChange;
        options = options || {};
        return $d47795690082d4de$var$fabric.util.animate($d47795690082d4de$var$fabric.util.object.extend(options, {
            duration: duration || 500,
            startValue: startColor,
            endValue: endColor,
            byValue: endColor,
            easing: function(currentTime, startValue, byValue, duration) {
                var posValue = options.colorEasing ? options.colorEasing(currentTime, duration) : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
                return calculateColor(startValue, byValue, posValue);
            },
            // has to take in account for color restoring;
            onComplete: function(current, valuePerc, timePerc) {
                if (originalOnComplete) return originalOnComplete(calculateColor(endColor, endColor, 0), valuePerc, timePerc);
            },
            onChange: function(current, valuePerc, timePerc) {
                if (originalOnChange) {
                    if (Array.isArray(current)) return originalOnChange(calculateColor(current, current, 0), valuePerc, timePerc);
                    originalOnChange(current, valuePerc, timePerc);
                }
            }
        }));
    }
    $d47795690082d4de$var$fabric.util.animateColor = animateColor;
})();
(function() {
    function normalize(a, c, p, s) {
        if (a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else //handle the 0/0 case:
        if (c === 0 && a === 0) s = p / (2 * Math.PI) * Math.asin(1);
        else s = p / (2 * Math.PI) * Math.asin(c / a);
        return {
            a: a,
            c: c,
            p: p,
            s: s
        };
    }
    function elastic(opts, t, d) {
        return opts.a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p);
    }
    /**
   * Cubic easing out
   * @memberOf fabric.util.ease
   */ function easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    /**
   * Cubic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutCubic(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
    /**
   * Quartic easing in
   * @memberOf fabric.util.ease
   */ function easeInQuart(t, b, c, d) {
        return c * (t /= d) * t * t * t + b;
    }
    /**
   * Quartic easing out
   * @memberOf fabric.util.ease
   */ function easeOutQuart(t, b, c, d) {
        return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    }
    /**
   * Quartic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutQuart(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t + b;
        return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
    }
    /**
   * Quintic easing in
   * @memberOf fabric.util.ease
   */ function easeInQuint(t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    }
    /**
   * Quintic easing out
   * @memberOf fabric.util.ease
   */ function easeOutQuint(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    }
    /**
   * Quintic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutQuint(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    }
    /**
   * Sinusoidal easing in
   * @memberOf fabric.util.ease
   */ function easeInSine(t, b, c, d) {
        return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
    }
    /**
   * Sinusoidal easing out
   * @memberOf fabric.util.ease
   */ function easeOutSine(t, b, c, d) {
        return c * Math.sin(t / d * (Math.PI / 2)) + b;
    }
    /**
   * Sinusoidal easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutSine(t, b, c, d) {
        return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    }
    /**
   * Exponential easing in
   * @memberOf fabric.util.ease
   */ function easeInExpo(t, b, c, d) {
        return t === 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
    }
    /**
   * Exponential easing out
   * @memberOf fabric.util.ease
   */ function easeOutExpo(t, b, c, d) {
        return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
    /**
   * Exponential easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutExpo(t, b, c, d) {
        if (t === 0) return b;
        if (t === d) return b + c;
        t /= d / 2;
        if (t < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
        return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
    /**
   * Circular easing in
   * @memberOf fabric.util.ease
   */ function easeInCirc(t, b, c, d) {
        return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
    }
    /**
   * Circular easing out
   * @memberOf fabric.util.ease
   */ function easeOutCirc(t, b, c, d) {
        return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    }
    /**
   * Circular easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutCirc(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
        return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
    }
    /**
   * Elastic easing in
   * @memberOf fabric.util.ease
   */ function easeInElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d;
        if (t === 1) return b + c;
        if (!p) p = d * 0.3;
        var opts = normalize(a, c, p, s);
        return -elastic(opts, t, d) + b;
    }
    /**
   * Elastic easing out
   * @memberOf fabric.util.ease
   */ function easeOutElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d;
        if (t === 1) return b + c;
        if (!p) p = d * 0.3;
        var opts = normalize(a, c, p, s);
        return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) + opts.c + b;
    }
    /**
   * Elastic easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutElastic(t, b, c, d) {
        var s = 1.70158, p = 0, a = c;
        if (t === 0) return b;
        t /= d / 2;
        if (t === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        var opts = normalize(a, c, p, s);
        if (t < 1) return -0.5 * elastic(opts, t, d) + b;
        return opts.a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p) * 0.5 + opts.c + b;
    }
    /**
   * Backwards easing in
   * @memberOf fabric.util.ease
   */ function easeInBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    }
    /**
   * Backwards easing out
   * @memberOf fabric.util.ease
   */ function easeOutBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    }
    /**
   * Backwards easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutBack(t, b, c, d, s) {
        if (s === undefined) s = 1.70158;
        t /= d / 2;
        if (t < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    }
    /**
   * Bouncing easing in
   * @memberOf fabric.util.ease
   */ function easeInBounce(t, b, c, d) {
        return c - easeOutBounce(d - t, 0, c, d) + b;
    }
    /**
   * Bouncing easing out
   * @memberOf fabric.util.ease
   */ function easeOutBounce(t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
    /**
   * Bouncing easing in and out
   * @memberOf fabric.util.ease
   */ function easeInOutBounce(t, b, c, d) {
        if (t < d / 2) return easeInBounce(t * 2, 0, c, d) * 0.5 + b;
        return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    }
    /**
   * Easing functions
   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
   * @namespace fabric.util.ease
   */ $d47795690082d4de$var$fabric.util.ease = {
        /**
     * Quadratic easing in
     * @memberOf fabric.util.ease
     */ easeInQuad: function(t, b, c, d) {
            return c * (t /= d) * t + b;
        },
        /**
     * Quadratic easing out
     * @memberOf fabric.util.ease
     */ easeOutQuad: function(t, b, c, d) {
            return -c * (t /= d) * (t - 2) + b;
        },
        /**
     * Quadratic easing in and out
     * @memberOf fabric.util.ease
     */ easeInOutQuad: function(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            return -c / 2 * (--t * (t - 2) - 1) + b;
        },
        /**
     * Cubic easing in
     * @memberOf fabric.util.ease
     */ easeInCubic: function(t, b, c, d) {
            return c * (t /= d) * t * t + b;
        },
        easeOutCubic: easeOutCubic,
        easeInOutCubic: easeInOutCubic,
        easeInQuart: easeInQuart,
        easeOutQuart: easeOutQuart,
        easeInOutQuart: easeInOutQuart,
        easeInQuint: easeInQuint,
        easeOutQuint: easeOutQuint,
        easeInOutQuint: easeInOutQuint,
        easeInSine: easeInSine,
        easeOutSine: easeOutSine,
        easeInOutSine: easeInOutSine,
        easeInExpo: easeInExpo,
        easeOutExpo: easeOutExpo,
        easeInOutExpo: easeInOutExpo,
        easeInCirc: easeInCirc,
        easeOutCirc: easeOutCirc,
        easeInOutCirc: easeInOutCirc,
        easeInElastic: easeInElastic,
        easeOutElastic: easeOutElastic,
        easeInOutElastic: easeInOutElastic,
        easeInBack: easeInBack,
        easeOutBack: easeOutBack,
        easeInOutBack: easeInOutBack,
        easeInBounce: easeInBounce,
        easeOutBounce: easeOutBounce,
        easeInOutBounce: easeInOutBounce
    };
})();
(function(global) {
    "use strict";
    /**
   * @name fabric
   * @namespace
   */ var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed, parseUnit = fabric.util.parseUnit, multiplyTransformMatrices = fabric.util.multiplyTransformMatrices, svgValidTagNames = [
        "path",
        "circle",
        "polygon",
        "polyline",
        "ellipse",
        "rect",
        "line",
        "image",
        "text"
    ], svgViewBoxElements = [
        "symbol",
        "image",
        "marker",
        "pattern",
        "view",
        "svg"
    ], svgInvalidAncestors = [
        "pattern",
        "defs",
        "symbol",
        "metadata",
        "clipPath",
        "mask",
        "desc"
    ], svgValidParents = [
        "symbol",
        "g",
        "a",
        "svg",
        "clipPath",
        "defs"
    ], attributesMap = {
        cx: "left",
        x: "left",
        r: "radius",
        cy: "top",
        y: "top",
        display: "visible",
        visibility: "visible",
        transform: "transformMatrix",
        "fill-opacity": "fillOpacity",
        "fill-rule": "fillRule",
        "font-family": "fontFamily",
        "font-size": "fontSize",
        "font-style": "fontStyle",
        "font-weight": "fontWeight",
        "letter-spacing": "charSpacing",
        "paint-order": "paintFirst",
        "stroke-dasharray": "strokeDashArray",
        "stroke-dashoffset": "strokeDashOffset",
        "stroke-linecap": "strokeLineCap",
        "stroke-linejoin": "strokeLineJoin",
        "stroke-miterlimit": "strokeMiterLimit",
        "stroke-opacity": "strokeOpacity",
        "stroke-width": "strokeWidth",
        "text-decoration": "textDecoration",
        "text-anchor": "textAnchor",
        opacity: "opacity",
        "clip-path": "clipPath",
        "clip-rule": "clipRule",
        "vector-effect": "strokeUniform",
        "image-rendering": "imageSmoothing"
    }, colorAttributes = {
        stroke: "strokeOpacity",
        fill: "fillOpacity"
    }, fSize = "font-size", cPath = "clip-path";
    fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
    fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
    fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
    fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);
    fabric.cssRules = {};
    fabric.gradientDefs = {};
    fabric.clipPaths = {};
    function normalizeAttr(attr) {
        // transform attribute names
        if (attr in attributesMap) return attributesMap[attr];
        return attr;
    }
    function normalizeValue(attr, value, parentAttributes, fontSize) {
        var isArray = Array.isArray(value), parsed;
        if ((attr === "fill" || attr === "stroke") && value === "none") value = "";
        else if (attr === "strokeUniform") return value === "non-scaling-stroke";
        else if (attr === "strokeDashArray") {
            if (value === "none") value = null;
            else value = value.replace(/,/g, " ").split(/\s+/).map(parseFloat);
        } else if (attr === "transformMatrix") {
            if (parentAttributes && parentAttributes.transformMatrix) value = multiplyTransformMatrices(parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
            else value = fabric.parseTransformAttribute(value);
        } else if (attr === "visible") {
            value = value !== "none" && value !== "hidden";
            // display=none on parent element always takes precedence over child element
            if (parentAttributes && parentAttributes.visible === false) value = false;
        } else if (attr === "opacity") {
            value = parseFloat(value);
            if (parentAttributes && typeof parentAttributes.opacity !== "undefined") value *= parentAttributes.opacity;
        } else if (attr === "textAnchor" /* text-anchor */ ) value = value === "start" ? "left" : value === "end" ? "right" : "center";
        else if (attr === "charSpacing") // parseUnit returns px and we convert it to em
        parsed = parseUnit(value, fontSize) / fontSize * 1000;
        else if (attr === "paintFirst") {
            var fillIndex = value.indexOf("fill");
            var strokeIndex = value.indexOf("stroke");
            var value = "fill";
            if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) value = "stroke";
            else if (fillIndex === -1 && strokeIndex > -1) value = "stroke";
        } else if (attr === "href" || attr === "xlink:href" || attr === "font") return value;
        else if (attr === "imageSmoothing") return value === "optimizeQuality";
        else parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
        return !isArray && isNaN(parsed) ? value : parsed;
    }
    /**
    * @private
    */ function getSvgRegex(arr) {
        return new RegExp("^(" + arr.join("|") + ")\\b", "i");
    }
    /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */ function _setStrokeFillOpacity(attributes) {
        for(var attr in colorAttributes){
            if (typeof attributes[colorAttributes[attr]] === "undefined" || attributes[attr] === "") continue;
            if (typeof attributes[attr] === "undefined") {
                if (!fabric.Object.prototype[attr]) continue;
                attributes[attr] = fabric.Object.prototype[attr];
            }
            if (attributes[attr].indexOf("url(") === 0) continue;
            var color = new fabric.Color(attributes[attr]);
            attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
        }
        return attributes;
    }
    /**
   * @private
   */ function _getMultipleNodes(doc, nodeNames) {
        var nodeName, nodeArray = [], nodeList, i, len;
        for(i = 0, len = nodeNames.length; i < len; i++){
            nodeName = nodeNames[i];
            nodeList = doc.getElementsByTagName(nodeName);
            nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
        }
        return nodeArray;
    }
    /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {Array} Array of 6 elements representing transformation matrix
   */ fabric.parseTransformAttribute = function() {
        function rotateMatrix(matrix, args) {
            var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]), x = 0, y = 0;
            if (args.length === 3) {
                x = args[1];
                y = args[2];
            }
            matrix[0] = cos;
            matrix[1] = sin;
            matrix[2] = -sin;
            matrix[3] = cos;
            matrix[4] = x - (cos * x - sin * y);
            matrix[5] = y - (sin * x + cos * y);
        }
        function scaleMatrix(matrix, args) {
            var multiplierX = args[0], multiplierY = args.length === 2 ? args[1] : args[0];
            matrix[0] = multiplierX;
            matrix[3] = multiplierY;
        }
        function skewMatrix(matrix, args, pos) {
            matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
        }
        function translateMatrix(matrix, args) {
            matrix[4] = args[0];
            if (args.length === 2) matrix[5] = args[1];
        }
        // identity matrix
        var iMatrix = fabric.iMatrix, // == begin transform regexp
        number = fabric.reNum, commaWsp = fabric.commaWsp, skewX = "(?:(skewX)\\s*\\(\\s*(" + number + ")\\s*\\))", skewY = "(?:(skewY)\\s*\\(\\s*(" + number + ")\\s*\\))", rotate = "(?:(rotate)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + "))?\\s*\\))", scale = "(?:(scale)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + "))?\\s*\\))", translate = "(?:(translate)\\s*\\(\\s*(" + number + ")(?:" + commaWsp + "(" + number + "))?\\s*\\))", matrix = "(?:(matrix)\\s*\\(\\s*(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + commaWsp + "(" + number + ")" + "\\s*\\))", transform = "(?:" + matrix + "|" + translate + "|" + scale + "|" + rotate + "|" + skewX + "|" + skewY + ")", transforms = "(?:" + transform + "(?:" + commaWsp + "*" + transform + ")*" + ")", transformList = "^\\s*(?:" + transforms + "?)\\s*$", // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
        reTransformList = new RegExp(transformList), // == end transform regexp
        reTransform = new RegExp(transform, "g");
        return function(attributeValue) {
            // start with identity matrix
            var matrix = iMatrix.concat(), matrices = [];
            // return if no argument was given or
            // an argument does not match transform attribute regexp
            if (!attributeValue || attributeValue && !reTransformList.test(attributeValue)) return matrix;
            attributeValue.replace(reTransform, function(match) {
                var m = new RegExp(transform).exec(match).filter(function(match) {
                    // match !== '' && match != null
                    return !!match;
                }), operation = m[1], args = m.slice(2).map(parseFloat);
                switch(operation){
                    case "translate":
                        translateMatrix(matrix, args);
                        break;
                    case "rotate":
                        args[0] = fabric.util.degreesToRadians(args[0]);
                        rotateMatrix(matrix, args);
                        break;
                    case "scale":
                        scaleMatrix(matrix, args);
                        break;
                    case "skewX":
                        skewMatrix(matrix, args, 2);
                        break;
                    case "skewY":
                        skewMatrix(matrix, args, 1);
                        break;
                    case "matrix":
                        matrix = args;
                        break;
                }
                // snapshot current matrix into matrices array
                matrices.push(matrix.concat());
                // reset
                matrix = iMatrix.concat();
            });
            var combinedMatrix = matrices[0];
            while(matrices.length > 1){
                matrices.shift();
                combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
            }
            return combinedMatrix;
        };
    }();
    /**
   * @private
   */ function parseStyleString(style, oStyle) {
        var attr, value;
        style.replace(/;\s*$/, "").split(";").forEach(function(chunk) {
            var pair = chunk.split(":");
            attr = pair[0].trim().toLowerCase();
            value = pair[1].trim();
            oStyle[attr] = value;
        });
    }
    /**
   * @private
   */ function parseStyleObject(style, oStyle) {
        var attr, value;
        for(var prop in style){
            if (typeof style[prop] === "undefined") continue;
            attr = prop.toLowerCase();
            value = style[prop];
            oStyle[attr] = value;
        }
    }
    /**
   * @private
   */ function getGlobalStylesForElement(element, svgUid) {
        var styles = {};
        for(var rule in fabric.cssRules[svgUid]){
            if (elementMatchesRule(element, rule.split(" "))) for(var property in fabric.cssRules[svgUid][rule])styles[property] = fabric.cssRules[svgUid][rule][property];
        }
        return styles;
    }
    /**
   * @private
   */ function elementMatchesRule(element, selectors) {
        var firstMatching, parentMatching = true;
        //start from rightmost selector.
        firstMatching = selectorMatches(element, selectors.pop());
        if (firstMatching && selectors.length) parentMatching = doesSomeParentMatch(element, selectors);
        return firstMatching && parentMatching && selectors.length === 0;
    }
    function doesSomeParentMatch(element, selectors) {
        var selector, parentMatching = true;
        while(element.parentNode && element.parentNode.nodeType === 1 && selectors.length){
            if (parentMatching) selector = selectors.pop();
            element = element.parentNode;
            parentMatching = selectorMatches(element, selector);
        }
        return selectors.length === 0;
    }
    /**
   * @private
   */ function selectorMatches(element, selector) {
        var nodeName = element.nodeName, classNames = element.getAttribute("class"), id = element.getAttribute("id"), matcher, i;
        // i check if a selector matches slicing away part from it.
        // if i get empty string i should match
        matcher = new RegExp("^" + nodeName, "i");
        selector = selector.replace(matcher, "");
        if (id && selector.length) {
            matcher = new RegExp("#" + id + "(?![a-zA-Z\\-]+)", "i");
            selector = selector.replace(matcher, "");
        }
        if (classNames && selector.length) {
            classNames = classNames.split(" ");
            for(i = classNames.length; i--;){
                matcher = new RegExp("\\." + classNames[i] + "(?![a-zA-Z\\-]+)", "i");
                selector = selector.replace(matcher, "");
            }
        }
        return selector.length === 0;
    }
    /**
   * @private
   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
   */ function elementById(doc, id) {
        var el;
        doc.getElementById && (el = doc.getElementById(id));
        if (el) return el;
        var node, i, len, nodelist = doc.getElementsByTagName("*");
        for(i = 0, len = nodelist.length; i < len; i++){
            node = nodelist[i];
            if (id === node.getAttribute("id")) return node;
        }
    }
    /**
   * @private
   */ function parseUseDirectives(doc) {
        var nodelist = _getMultipleNodes(doc, [
            "use",
            "svg:use"
        ]), i = 0;
        while(nodelist.length && i < nodelist.length){
            var el = nodelist[i], xlinkAttribute = el.getAttribute("xlink:href") || el.getAttribute("href");
            if (xlinkAttribute === null) return;
            var xlink = xlinkAttribute.slice(1), x = el.getAttribute("x") || 0, y = el.getAttribute("y") || 0, el2 = elementById(doc, xlink).cloneNode(true), currentTrans = (el2.getAttribute("transform") || "") + " translate(" + x + ", " + y + ")", parentNode, oldLength = nodelist.length, attr, j, attrs, len, namespace = fabric.svgNS;
            applyViewboxTransform(el2);
            if (/^svg$/i.test(el2.nodeName)) {
                var el3 = el2.ownerDocument.createElementNS(namespace, "g");
                for(j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++){
                    attr = attrs.item(j);
                    el3.setAttributeNS(namespace, attr.nodeName, attr.nodeValue);
                }
                // el2.firstChild != null
                while(el2.firstChild)el3.appendChild(el2.firstChild);
                el2 = el3;
            }
            for(j = 0, attrs = el.attributes, len = attrs.length; j < len; j++){
                attr = attrs.item(j);
                if (attr.nodeName === "x" || attr.nodeName === "y" || attr.nodeName === "xlink:href" || attr.nodeName === "href") continue;
                if (attr.nodeName === "transform") currentTrans = attr.nodeValue + " " + currentTrans;
                else el2.setAttribute(attr.nodeName, attr.nodeValue);
            }
            el2.setAttribute("transform", currentTrans);
            el2.setAttribute("instantiated_by_use", "1");
            el2.removeAttribute("id");
            parentNode = el.parentNode;
            parentNode.replaceChild(el2, el);
            // some browsers do not shorten nodelist after replaceChild (IE8)
            if (nodelist.length === oldLength) i++;
        }
    }
    // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
    // matches, e.g.: +14.56e-12, etc.
    var reViewBoxAttrValue = new RegExp("^\\s*(" + fabric.reNum + "+)\\s*,?" + "\\s*(" + fabric.reNum + "+)\\s*,?" + "\\s*(" + fabric.reNum + "+)\\s*,?" + "\\s*(" + fabric.reNum + "+)\\s*" + "$");
    /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */ function applyViewboxTransform(element) {
        if (!fabric.svgViewBoxElementsRegEx.test(element.nodeName)) return {};
        var viewBoxAttr = element.getAttribute("viewBox"), scaleX = 1, scaleY = 1, minX = 0, minY = 0, viewBoxWidth, viewBoxHeight, matrix, el, widthAttr = element.getAttribute("width"), heightAttr = element.getAttribute("height"), x = element.getAttribute("x") || 0, y = element.getAttribute("y") || 0, preserveAspectRatio = element.getAttribute("preserveAspectRatio") || "", missingViewBox = !viewBoxAttr || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue)), missingDimAttr = !widthAttr || !heightAttr || widthAttr === "100%" || heightAttr === "100%", toBeParsed = missingViewBox && missingDimAttr, parsedDim = {}, translateMatrix = "", widthDiff = 0, heightDiff = 0;
        parsedDim.width = 0;
        parsedDim.height = 0;
        parsedDim.toBeParsed = toBeParsed;
        if (missingViewBox) {
            if ((x || y) && element.parentNode && element.parentNode.nodeName !== "#document") {
                translateMatrix = " translate(" + parseUnit(x) + " " + parseUnit(y) + ") ";
                matrix = (element.getAttribute("transform") || "") + translateMatrix;
                element.setAttribute("transform", matrix);
                element.removeAttribute("x");
                element.removeAttribute("y");
            }
        }
        if (toBeParsed) return parsedDim;
        if (missingViewBox) {
            parsedDim.width = parseUnit(widthAttr);
            parsedDim.height = parseUnit(heightAttr);
            // set a transform for elements that have x y and are inner(only) SVGs
            return parsedDim;
        }
        minX = -parseFloat(viewBoxAttr[1]);
        minY = -parseFloat(viewBoxAttr[2]);
        viewBoxWidth = parseFloat(viewBoxAttr[3]);
        viewBoxHeight = parseFloat(viewBoxAttr[4]);
        parsedDim.minX = minX;
        parsedDim.minY = minY;
        parsedDim.viewBoxWidth = viewBoxWidth;
        parsedDim.viewBoxHeight = viewBoxHeight;
        if (!missingDimAttr) {
            parsedDim.width = parseUnit(widthAttr);
            parsedDim.height = parseUnit(heightAttr);
            scaleX = parsedDim.width / viewBoxWidth;
            scaleY = parsedDim.height / viewBoxHeight;
        } else {
            parsedDim.width = viewBoxWidth;
            parsedDim.height = viewBoxHeight;
        }
        // default is to preserve aspect ratio
        preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
        if (preserveAspectRatio.alignX !== "none") {
            //translate all container for the effect of Mid, Min, Max
            if (preserveAspectRatio.meetOrSlice === "meet") scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
            if (preserveAspectRatio.meetOrSlice === "slice") scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
            widthDiff = parsedDim.width - viewBoxWidth * scaleX;
            heightDiff = parsedDim.height - viewBoxHeight * scaleX;
            if (preserveAspectRatio.alignX === "Mid") widthDiff /= 2;
            if (preserveAspectRatio.alignY === "Mid") heightDiff /= 2;
            if (preserveAspectRatio.alignX === "Min") widthDiff = 0;
            if (preserveAspectRatio.alignY === "Min") heightDiff = 0;
        }
        if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) return parsedDim;
        if ((x || y) && element.parentNode.nodeName !== "#document") translateMatrix = " translate(" + parseUnit(x) + " " + parseUnit(y) + ") ";
        matrix = translateMatrix + " matrix(" + scaleX + " 0" + " 0 " + scaleY + " " + (minX * scaleX + widthDiff) + " " + (minY * scaleY + heightDiff) + ") ";
        // seems unused.
        // parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
        if (element.nodeName === "svg") {
            el = element.ownerDocument.createElementNS(fabric.svgNS, "g");
            // element.firstChild != null
            while(element.firstChild)el.appendChild(element.firstChild);
            element.appendChild(el);
        } else {
            el = element;
            el.removeAttribute("x");
            el.removeAttribute("y");
            matrix = el.getAttribute("transform") + matrix;
        }
        el.setAttribute("transform", matrix);
        return parsedDim;
    }
    function hasAncestorWithNodeName(element, nodeName) {
        while(element && (element = element.parentNode)){
            if (element.nodeName && nodeName.test(element.nodeName.replace("svg:", "")) && !element.getAttribute("instantiated_by_use")) return true;
        }
        return false;
    }
    /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {SVGDocument} doc SVG document to parse
   * @param {Function} callback Callback to call when parsing is finished;
   * It's being passed an array of elements (parsed from a document).
   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
   * @param {Object} [parsingOptions] options for parsing document
   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
   */ fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
        if (!doc) return;
        parseUseDirectives(doc);
        var svgUid = fabric.Object.__uid++, i, len, options = applyViewboxTransform(doc), descendants = fabric.util.toArray(doc.getElementsByTagName("*"));
        options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
        options.svgUid = svgUid;
        if (descendants.length === 0 && fabric.isLikelyNode) {
            // we're likely in node, where "o3-xml" library fails to gEBTN("*")
            // https://github.com/ajaxorg/node-o3-xml/issues/21
            descendants = doc.selectNodes('//*[name(.)!="svg"]');
            var arr = [];
            for(i = 0, len = descendants.length; i < len; i++)arr[i] = descendants[i];
            descendants = arr;
        }
        var elements = descendants.filter(function(el) {
            applyViewboxTransform(el);
            return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace("svg:", "")) && !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
        });
        if (!elements || elements && !elements.length) {
            callback && callback([], {});
            return;
        }
        var clipPaths = {};
        descendants.filter(function(el) {
            return el.nodeName.replace("svg:", "") === "clipPath";
        }).forEach(function(el) {
            var id = el.getAttribute("id");
            clipPaths[id] = fabric.util.toArray(el.getElementsByTagName("*")).filter(function(el) {
                return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace("svg:", ""));
            });
        });
        fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
        fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
        fabric.clipPaths[svgUid] = clipPaths;
        // Precedence of rules:   style > class > attribute
        fabric.parseElements(elements, function(instances, elements) {
            if (callback) {
                callback(instances, options, elements, descendants);
                delete fabric.gradientDefs[svgUid];
                delete fabric.cssRules[svgUid];
                delete fabric.clipPaths[svgUid];
            }
        }, clone(options), reviver, parsingOptions);
    };
    function recursivelyParseGradientsXlink(doc, gradient) {
        var gradientsAttrs = [
            "gradientTransform",
            "x1",
            "x2",
            "y1",
            "y2",
            "gradientUnits",
            "cx",
            "cy",
            "r",
            "fx",
            "fy"
        ], xlinkAttr = "xlink:href", xLink = gradient.getAttribute(xlinkAttr).slice(1), referencedGradient = elementById(doc, xLink);
        if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) recursivelyParseGradientsXlink(doc, referencedGradient);
        gradientsAttrs.forEach(function(attr) {
            if (referencedGradient && !gradient.hasAttribute(attr) && referencedGradient.hasAttribute(attr)) gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
        });
        if (!gradient.children.length) {
            var referenceClone = referencedGradient.cloneNode(true);
            while(referenceClone.firstChild)gradient.appendChild(referenceClone.firstChild);
        }
        gradient.removeAttribute(xlinkAttr);
    }
    var reFontDeclaration = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + fabric.reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + fabric.reNum + "))?\\s+(.*)");
    extend(fabric, {
        /**
     * Parses a short font declaration, building adding its properties to a style object
     * @static
     * @function
     * @memberOf fabric
     * @param {String} value font declaration
     * @param {Object} oStyle definition
     */ parseFontDeclaration: function(value, oStyle) {
            var match = value.match(reFontDeclaration);
            if (!match) return;
            var fontStyle = match[1], // font variant is not used
            // fontVariant = match[2],
            fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
            if (fontStyle) oStyle.fontStyle = fontStyle;
            if (fontWeight) oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
            if (fontSize) oStyle.fontSize = parseUnit(fontSize);
            if (fontFamily) oStyle.fontFamily = fontFamily;
            if (lineHeight) oStyle.lineHeight = lineHeight === "normal" ? 1 : lineHeight;
        },
        /**
     * Parses an SVG document, returning all of the gradient declarations found in it
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
     */ getGradientDefs: function(doc) {
            var tagArray = [
                "linearGradient",
                "radialGradient",
                "svg:linearGradient",
                "svg:radialGradient"
            ], elList = _getMultipleNodes(doc, tagArray), el, j = 0, gradientDefs = {};
            j = elList.length;
            while(j--){
                el = elList[j];
                if (el.getAttribute("xlink:href")) recursivelyParseGradientsXlink(doc, el);
                gradientDefs[el.getAttribute("id")] = el;
            }
            return gradientDefs;
        },
        /**
     * Returns an object of attributes' name/value, given element and an array of attribute names;
     * Parses parent "g" nodes recursively upwards.
     * @static
     * @memberOf fabric
     * @param {DOMElement} element Element to parse
     * @param {Array} attributes Array of attributes to parse
     * @return {Object} object containing parsed attributes' names/values
     */ parseAttributes: function(element, attributes, svgUid) {
            if (!element) return;
            var value, parentAttributes = {}, fontSize, parentFontSize;
            if (typeof svgUid === "undefined") svgUid = element.getAttribute("svgUid");
            // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
            if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
            var ownAttributes = attributes.reduce(function(memo, attr) {
                value = element.getAttribute(attr);
                if (value) memo[attr] = value;
                return memo;
            }, {});
            // add values parsed from style, which take precedence over attributes
            // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
            var cssAttrs = extend(getGlobalStylesForElement(element, svgUid), fabric.parseStyleAttribute(element));
            ownAttributes = extend(ownAttributes, cssAttrs);
            if (cssAttrs[cPath]) element.setAttribute(cPath, cssAttrs[cPath]);
            fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
            if (ownAttributes[fSize]) // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
            ownAttributes[fSize] = fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
            var normalizedAttr, normalizedValue, normalizedStyle = {};
            for(var attr in ownAttributes){
                normalizedAttr = normalizeAttr(attr);
                normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
                normalizedStyle[normalizedAttr] = normalizedValue;
            }
            if (normalizedStyle && normalizedStyle.font) fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
            var mergedAttrs = extend(parentAttributes, normalizedStyle);
            return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
        },
        /**
     * Transforms an array of svg elements to corresponding fabric.* instances
     * @static
     * @memberOf fabric
     * @param {Array} elements Array of elements to parse
     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
     * @param {Object} [options] Options object
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     */ parseElements: function(elements, callback, options, reviver, parsingOptions) {
            new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
        },
        /**
     * Parses "style" attribute, retuning an object with values
     * @static
     * @memberOf fabric
     * @param {SVGElement} element Element to parse
     * @return {Object} Objects with values parsed from style attribute of an element
     */ parseStyleAttribute: function(element) {
            var oStyle = {}, style = element.getAttribute("style");
            if (!style) return oStyle;
            if (typeof style === "string") parseStyleString(style, oStyle);
            else parseStyleObject(style, oStyle);
            return oStyle;
        },
        /**
     * Parses "points" attribute, returning an array of values
     * @static
     * @memberOf fabric
     * @param {String} points points attribute string
     * @return {Array} array of points
     */ parsePointsAttribute: function(points) {
            // points attribute is required and must not be empty
            if (!points) return null;
            // replace commas with whitespace and remove bookending whitespace
            points = points.replace(/,/g, " ").trim();
            points = points.split(/\s+/);
            var parsedPoints = [], i, len;
            for(i = 0, len = points.length; i < len; i += 2)parsedPoints.push({
                x: parseFloat(points[i]),
                y: parseFloat(points[i + 1])
            });
            // odd number of points is an error
            // if (parsedPoints.length % 2 !== 0) {
            //   return null;
            // }
            return parsedPoints;
        },
        /**
     * Returns CSS rules for a given SVG document
     * @static
     * @function
     * @memberOf fabric
     * @param {SVGDocument} doc SVG document to parse
     * @return {Object} CSS rules of this document
     */ getCSSRules: function(doc) {
            var styles = doc.getElementsByTagName("style"), i, len, allRules = {}, rules;
            // very crude parsing of style contents
            for(i = 0, len = styles.length; i < len; i++){
                var styleContents = styles[i].textContent;
                // remove comments
                styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, "");
                if (styleContents.trim() === "") continue;
                // recovers all the rule in this form `body { style code... }`
                // rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
                rules = styleContents.split("}");
                // remove empty rules.
                rules = rules.filter(function(rule) {
                    return rule.trim();
                });
                // at this point we have hopefully an array of rules `body { style code... `
                // eslint-disable-next-line no-loop-func
                rules.forEach(function(rule) {
                    var match = rule.split("{"), ruleObj = {}, declaration = match[1].trim(), propertyValuePairs = declaration.split(";").filter(function(pair) {
                        return pair.trim();
                    });
                    for(i = 0, len = propertyValuePairs.length; i < len; i++){
                        var pair = propertyValuePairs[i].split(":"), property = pair[0].trim(), value = pair[1].trim();
                        ruleObj[property] = value;
                    }
                    rule = match[0].trim();
                    rule.split(",").forEach(function(_rule) {
                        _rule = _rule.replace(/^svg/i, "").trim();
                        if (_rule === "") return;
                        if (allRules[_rule]) fabric.util.object.extend(allRules[_rule], ruleObj);
                        else allRules[_rule] = fabric.util.object.clone(ruleObj);
                    });
                });
            }
            return allRules;
        },
        /**
     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
     * @memberOf fabric
     * @param {String} url
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */ loadSVGFromURL: function(url, callback, reviver, options) {
            url = url.replace(/^\n\s*/, "").trim();
            new fabric.util.request(url, {
                method: "get",
                onComplete: onComplete
            });
            function onComplete(r) {
                var xml = r.responseXML;
                if (!xml || !xml.documentElement) {
                    callback && callback(null);
                    return false;
                }
                fabric.parseSVGDocument(xml.documentElement, function(results, _options, elements, allElements) {
                    callback && callback(results, _options, elements, allElements);
                }, reviver, options);
            }
        },
        /**
     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
     * @memberOf fabric
     * @param {String} string
     * @param {Function} callback
     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
     * @param {Object} [options] Object containing options for parsing
     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
     */ loadSVGFromString: function(string, callback, reviver, options) {
            var parser = new fabric.window.DOMParser(), doc = parser.parseFromString(string.trim(), "text/xml");
            fabric.parseSVGDocument(doc.documentElement, function(results, _options, elements, allElements) {
                callback(results, _options, elements, allElements);
            }, reviver, options);
        }
    });
})($d47795690082d4de$exports);
$d47795690082d4de$var$fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions, doc) {
    this.elements = elements;
    this.callback = callback;
    this.options = options;
    this.reviver = reviver;
    this.svgUid = options && options.svgUid || 0;
    this.parsingOptions = parsingOptions;
    this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
    this.doc = doc;
};
(function(proto) {
    proto.parse = function() {
        this.instances = new Array(this.elements.length);
        this.numElements = this.elements.length;
        this.createObjects();
    };
    proto.createObjects = function() {
        var _this = this;
        this.elements.forEach(function(element, i) {
            element.setAttribute("svgUid", _this.svgUid);
            _this.createObject(element, i);
        });
    };
    proto.findTag = function(el) {
        return $d47795690082d4de$var$fabric[$d47795690082d4de$var$fabric.util.string.capitalize(el.tagName.replace("svg:", ""))];
    };
    proto.createObject = function(el, index) {
        var klass = this.findTag(el);
        if (klass && klass.fromElement) try {
            klass.fromElement(el, this.createCallback(index, el), this.options);
        } catch (err) {
            $d47795690082d4de$var$fabric.log(err);
        }
        else this.checkIfDone();
    };
    proto.createCallback = function(index, el) {
        var _this = this;
        return function(obj) {
            var _options;
            _this.resolveGradient(obj, el, "fill");
            _this.resolveGradient(obj, el, "stroke");
            if (obj instanceof $d47795690082d4de$var$fabric.Image && obj._originalElement) _options = obj.parsePreserveAspectRatioAttribute(el);
            obj._removeTransformMatrix(_options);
            _this.resolveClipPath(obj, el);
            _this.reviver && _this.reviver(el, obj);
            _this.instances[index] = obj;
            _this.checkIfDone();
        };
    };
    proto.extractPropertyDefinition = function(obj, property, storage) {
        var value = obj[property], regex = this.regexUrl;
        if (!regex.test(value)) return;
        regex.lastIndex = 0;
        var id = regex.exec(value)[1];
        regex.lastIndex = 0;
        return $d47795690082d4de$var$fabric[storage][this.svgUid][id];
    };
    proto.resolveGradient = function(obj, el, property) {
        var gradientDef = this.extractPropertyDefinition(obj, property, "gradientDefs");
        if (gradientDef) {
            var opacityAttr = el.getAttribute(property + "-opacity");
            var gradient = $d47795690082d4de$var$fabric.Gradient.fromElement(gradientDef, obj, opacityAttr, this.options);
            obj.set(property, gradient);
        }
    };
    proto.createClipPathCallback = function(obj, container) {
        return function(_newObj) {
            _newObj._removeTransformMatrix();
            _newObj.fillRule = _newObj.clipRule;
            container.push(_newObj);
        };
    };
    proto.resolveClipPath = function(obj, usingElement) {
        var clipPath = this.extractPropertyDefinition(obj, "clipPath", "clipPaths"), element, klass, objTransformInv, container, gTransform, options;
        if (clipPath) {
            container = [];
            objTransformInv = $d47795690082d4de$var$fabric.util.invertTransform(obj.calcTransformMatrix());
            // move the clipPath tag as sibling to the real element that is using it
            var clipPathTag = clipPath[0].parentNode;
            var clipPathOwner = usingElement;
            while(clipPathOwner.parentNode && clipPathOwner.getAttribute("clip-path") !== obj.clipPath)clipPathOwner = clipPathOwner.parentNode;
            clipPathOwner.parentNode.appendChild(clipPathTag);
            for(var i = 0; i < clipPath.length; i++){
                element = clipPath[i];
                klass = this.findTag(element);
                klass.fromElement(element, this.createClipPathCallback(obj, container), this.options);
            }
            if (container.length === 1) clipPath = container[0];
            else clipPath = new $d47795690082d4de$var$fabric.Group(container);
            gTransform = $d47795690082d4de$var$fabric.util.multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
            if (clipPath.clipPath) this.resolveClipPath(clipPath, clipPathOwner);
            var options = $d47795690082d4de$var$fabric.util.qrDecompose(gTransform);
            clipPath.flipX = false;
            clipPath.flipY = false;
            clipPath.set("scaleX", options.scaleX);
            clipPath.set("scaleY", options.scaleY);
            clipPath.angle = options.angle;
            clipPath.skewX = options.skewX;
            clipPath.skewY = 0;
            clipPath.setPositionByOrigin({
                x: options.translateX,
                y: options.translateY
            }, "center", "center");
            obj.clipPath = clipPath;
        } else // if clip-path does not resolve to any element, delete the property.
        delete obj.clipPath;
    };
    proto.checkIfDone = function() {
        if (--this.numElements === 0) {
            this.instances = this.instances.filter(function(el) {
                // eslint-disable-next-line no-eq-null, eqeqeq
                return el != null;
            });
            this.callback(this.instances, this.elements);
        }
    };
})($d47795690082d4de$var$fabric.ElementsParser.prototype);
(function(global) {
    "use strict";
    /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ var fabric = global.fabric || (global.fabric = {});
    if (fabric.Point) {
        fabric.warn("fabric.Point is already defined");
        return;
    }
    fabric.Point = Point;
    /**
   * Point class
   * @class fabric.Point
   * @memberOf fabric
   * @constructor
   * @param {Number} x
   * @param {Number} y
   * @return {fabric.Point} thisArg
   */ function Point(x, y) {
        this.x = x;
        this.y = y;
    }
    Point.prototype = /** @lends fabric.Point.prototype */ {
        type: "point",
        constructor: Point,
        /**
     * Adds another point to this one and returns another one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point instance with added values
     */ add: function(that) {
            return new Point(this.x + that.x, this.y + that.y);
        },
        /**
     * Adds another point to this one
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */ addEquals: function(that) {
            this.x += that.x;
            this.y += that.y;
            return this;
        },
        /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point} new Point with added value
     */ scalarAdd: function(scalar) {
            return new Point(this.x + scalar, this.y + scalar);
        },
        /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ scalarAddEquals: function(scalar) {
            this.x += scalar;
            this.y += scalar;
            return this;
        },
        /**
     * Subtracts another point from this point and returns a new one
     * @param {fabric.Point} that
     * @return {fabric.Point} new Point object with subtracted values
     */ subtract: function(that) {
            return new Point(this.x - that.x, this.y - that.y);
        },
        /**
     * Subtracts another point from this point
     * @param {fabric.Point} that
     * @return {fabric.Point} thisArg
     * @chainable
     */ subtractEquals: function(that) {
            this.x -= that.x;
            this.y -= that.y;
            return this;
        },
        /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {fabric.Point}
     */ scalarSubtract: function(scalar) {
            return new Point(this.x - scalar, this.y - scalar);
        },
        /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ scalarSubtractEquals: function(scalar) {
            this.x -= scalar;
            this.y -= scalar;
            return this;
        },
        /**
     * Multiplies this point by a value and returns a new one
     * TODO: rename in scalarMultiply in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */ multiply: function(scalar) {
            return new Point(this.x * scalar, this.y * scalar);
        },
        /**
     * Multiplies this point by a value
     * TODO: rename in scalarMultiplyEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ multiplyEquals: function(scalar) {
            this.x *= scalar;
            this.y *= scalar;
            return this;
        },
        /**
     * Divides this point by a value and returns a new one
     * TODO: rename in scalarDivide in 2.0
     * @param {Number} scalar
     * @return {fabric.Point}
     */ divide: function(scalar) {
            return new Point(this.x / scalar, this.y / scalar);
        },
        /**
     * Divides this point by a value
     * TODO: rename in scalarDivideEquals in 2.0
     * @param {Number} scalar
     * @return {fabric.Point} thisArg
     * @chainable
     */ divideEquals: function(scalar) {
            this.x /= scalar;
            this.y /= scalar;
            return this;
        },
        /**
     * Returns true if this point is equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ eq: function(that) {
            return this.x === that.x && this.y === that.y;
        },
        /**
     * Returns true if this point is less than another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ lt: function(that) {
            return this.x < that.x && this.y < that.y;
        },
        /**
     * Returns true if this point is less than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ lte: function(that) {
            return this.x <= that.x && this.y <= that.y;
        },
        /**

     * Returns true if this point is greater another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ gt: function(that) {
            return this.x > that.x && this.y > that.y;
        },
        /**
     * Returns true if this point is greater than or equal to another one
     * @param {fabric.Point} that
     * @return {Boolean}
     */ gte: function(that) {
            return this.x >= that.x && this.y >= that.y;
        },
        /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {fabric.Point} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {fabric.Point}
     */ lerp: function(that, t) {
            if (typeof t === "undefined") t = 0.5;
            t = Math.max(Math.min(1, t), 0);
            return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
        },
        /**
     * Returns distance from this point and another one
     * @param {fabric.Point} that
     * @return {Number}
     */ distanceFrom: function(that) {
            var dx = this.x - that.x, dy = this.y - that.y;
            return Math.sqrt(dx * dx + dy * dy);
        },
        /**
     * Returns the point between this point and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ midPointFrom: function(that) {
            return this.lerp(that);
        },
        /**
     * Returns a new point which is the min of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ min: function(that) {
            return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
        },
        /**
     * Returns a new point which is the max of this and another one
     * @param {fabric.Point} that
     * @return {fabric.Point}
     */ max: function(that) {
            return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
        },
        /**
     * Returns string representation of this point
     * @return {String}
     */ toString: function() {
            return this.x + "," + this.y;
        },
        /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */ setXY: function(x, y) {
            this.x = x;
            this.y = y;
            return this;
        },
        /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */ setX: function(x) {
            this.x = x;
            return this;
        },
        /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */ setY: function(y) {
            this.y = y;
            return this;
        },
        /**
     * Sets x/y of this point from another point
     * @param {fabric.Point} that
     * @chainable
     */ setFromPoint: function(that) {
            this.x = that.x;
            this.y = that.y;
            return this;
        },
        /**
     * Swaps x/y of this point and another point
     * @param {fabric.Point} that
     */ swap: function(that) {
            var x = this.x, y = this.y;
            this.x = that.x;
            this.y = that.y;
            that.x = x;
            that.y = y;
        },
        /**
     * return a cloned instance of the point
     * @return {fabric.Point}
     */ clone: function() {
            return new Point(this.x, this.y);
        }
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ var fabric = global.fabric || (global.fabric = {});
    if (fabric.Intersection) {
        fabric.warn("fabric.Intersection is already defined");
        return;
    }
    /**
   * Intersection class
   * @class fabric.Intersection
   * @memberOf fabric
   * @constructor
   */ function Intersection(status) {
        this.status = status;
        this.points = [];
    }
    fabric.Intersection = Intersection;
    fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {
        constructor: Intersection,
        /**
     * Appends a point to intersection
     * @param {fabric.Point} point
     * @return {fabric.Intersection} thisArg
     * @chainable
     */ appendPoint: function(point) {
            this.points.push(point);
            return this;
        },
        /**
     * Appends points to intersection
     * @param {Array} points
     * @return {fabric.Intersection} thisArg
     * @chainable
     */ appendPoints: function(points) {
            this.points = this.points.concat(points);
            return this;
        }
    };
    /**
   * Checks if one line intersects another
   * TODO: rename in intersectSegmentSegment
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {fabric.Point} b1
   * @param {fabric.Point} b2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectLineLine = function(a1, a2, b1, b2) {
        var result, uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x), ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x), uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
        if (uB !== 0) {
            var ua = uaT / uB, ub = ubT / uB;
            if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
                result = new Intersection("Intersection");
                result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
            } else result = new Intersection();
        } else if (uaT === 0 || ubT === 0) result = new Intersection("Coincident");
        else result = new Intersection("Parallel");
        return result;
    };
    /**
   * Checks if line intersects polygon
   * TODO: rename in intersectSegmentPolygon
   * fix detection of coincident
   * @static
   * @param {fabric.Point} a1
   * @param {fabric.Point} a2
   * @param {Array} points
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
        var result = new Intersection(), length = points.length, b1, b2, inter, i;
        for(i = 0; i < length; i++){
            b1 = points[i];
            b2 = points[(i + 1) % length];
            inter = Intersection.intersectLineLine(a1, a2, b1, b2);
            result.appendPoints(inter.points);
        }
        if (result.points.length > 0) result.status = "Intersection";
        return result;
    };
    /**
   * Checks if polygon intersects another polygon
   * @static
   * @param {Array} points1
   * @param {Array} points2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectPolygonPolygon = function(points1, points2) {
        var result = new Intersection(), length = points1.length, i;
        for(i = 0; i < length; i++){
            var a1 = points1[i], a2 = points1[(i + 1) % length], inter = Intersection.intersectLinePolygon(a1, a2, points2);
            result.appendPoints(inter.points);
        }
        if (result.points.length > 0) result.status = "Intersection";
        return result;
    };
    /**
   * Checks if polygon intersects rectangle
   * @static
   * @param {Array} points
   * @param {fabric.Point} r1
   * @param {fabric.Point} r2
   * @return {fabric.Intersection}
   */ fabric.Intersection.intersectPolygonRectangle = function(points, r1, r2) {
        var min = r1.min(r2), max = r1.max(r2), topRight = new fabric.Point(max.x, min.y), bottomLeft = new fabric.Point(min.x, max.y), inter1 = Intersection.intersectLinePolygon(min, topRight, points), inter2 = Intersection.intersectLinePolygon(topRight, max, points), inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points), inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points), result = new Intersection();
        result.appendPoints(inter1.points);
        result.appendPoints(inter2.points);
        result.appendPoints(inter3.points);
        result.appendPoints(inter4.points);
        if (result.points.length > 0) result.status = "Intersection";
        return result;
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.Color) {
        fabric.warn("fabric.Color is already defined.");
        return;
    }
    /**
   * Color class
   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
   *
   * @class fabric.Color
   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
   * @return {fabric.Color} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
   */ function Color(color) {
        if (!color) this.setSource([
            0,
            0,
            0,
            1
        ]);
        else this._tryParsingColor(color);
    }
    fabric.Color = Color;
    fabric.Color.prototype = /** @lends fabric.Color.prototype */ {
        /**
     * @private
     * @param {String|Array} color Color value to parse
     */ _tryParsingColor: function(color) {
            var source;
            if (color in Color.colorNameMap) color = Color.colorNameMap[color];
            if (color === "transparent") source = [
                255,
                255,
                255,
                0
            ];
            if (!source) source = Color.sourceFromHex(color);
            if (!source) source = Color.sourceFromRgb(color);
            if (!source) source = Color.sourceFromHsl(color);
            if (!source) //if color is not recognize let's make black as canvas does
            source = [
                0,
                0,
                0,
                1
            ];
            if (source) this.setSource(source);
        },
        /**
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @private
     * @param {Number} r Red color value
     * @param {Number} g Green color value
     * @param {Number} b Blue color value
     * @return {Array} Hsl color
     */ _rgbToHsl: function(r, g, b) {
            r /= 255;
            g /= 255;
            b /= 255;
            var h, s, l, max = fabric.util.array.max([
                r,
                g,
                b
            ]), min = fabric.util.array.min([
                r,
                g,
                b
            ]);
            l = (max + min) / 2;
            if (max === min) h = s = 0; // achromatic
            else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return [
                Math.round(h * 360),
                Math.round(s * 100),
                Math.round(l * 100)
            ];
        },
        /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {Array}
     */ getSource: function() {
            return this._source;
        },
        /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {Array} source
     */ setSource: function(source) {
            this._source = source;
        },
        /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */ toRgb: function() {
            var source = this.getSource();
            return "rgb(" + source[0] + "," + source[1] + "," + source[2] + ")";
        },
        /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */ toRgba: function() {
            var source = this.getSource();
            return "rgba(" + source[0] + "," + source[1] + "," + source[2] + "," + source[3] + ")";
        },
        /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */ toHsl: function() {
            var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
            return "hsl(" + hsl[0] + "," + hsl[1] + "%," + hsl[2] + "%)";
        },
        /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */ toHsla: function() {
            var source = this.getSource(), hsl = this._rgbToHsl(source[0], source[1], source[2]);
            return "hsla(" + hsl[0] + "," + hsl[1] + "%," + hsl[2] + "%," + source[3] + ")";
        },
        /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */ toHex: function() {
            var source = this.getSource(), r, g, b;
            r = source[0].toString(16);
            r = r.length === 1 ? "0" + r : r;
            g = source[1].toString(16);
            g = g.length === 1 ? "0" + g : g;
            b = source[2].toString(16);
            b = b.length === 1 ? "0" + b : b;
            return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
        },
        /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */ toHexa: function() {
            var source = this.getSource(), a;
            a = Math.round(source[3] * 255);
            a = a.toString(16);
            a = a.length === 1 ? "0" + a : a;
            return this.toHex() + a.toUpperCase();
        },
        /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */ getAlpha: function() {
            return this.getSource()[3];
        },
        /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {fabric.Color} thisArg
     */ setAlpha: function(alpha) {
            var source = this.getSource();
            source[3] = alpha;
            this.setSource(source);
            return this;
        },
        /**
     * Transforms color to its grayscale representation
     * @return {fabric.Color} thisArg
     */ toGrayscale: function() {
            var source = this.getSource(), average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10), currentAlpha = source[3];
            this.setSource([
                average,
                average,
                average,
                currentAlpha
            ]);
            return this;
        },
        /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {fabric.Color} thisArg
     */ toBlackWhite: function(threshold) {
            var source = this.getSource(), average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), currentAlpha = source[3];
            threshold = threshold || 127;
            average = Number(average) < Number(threshold) ? 0 : 255;
            this.setSource([
                average,
                average,
                average,
                currentAlpha
            ]);
            return this;
        },
        /**
     * Overlays color with another color
     * @param {String|fabric.Color} otherColor
     * @return {fabric.Color} thisArg
     */ overlayWith: function(otherColor) {
            if (!(otherColor instanceof Color)) otherColor = new Color(otherColor);
            var result = [], alpha = this.getAlpha(), otherAlpha = 0.5, source = this.getSource(), otherSource = otherColor.getSource(), i;
            for(i = 0; i < 3; i++)result.push(Math.round(source[i] * (1 - otherAlpha) + otherSource[i] * otherAlpha));
            result[3] = alpha;
            this.setSource(result);
            return this;
        }
    };
    /**
   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * @static
   * @field
   * @memberOf fabric.Color
   */ // eslint-disable-next-line max-len
    fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
    /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
   * @static
   * @field
   * @memberOf fabric.Color
   */ fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
    /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   * @static
   * @field
   * @memberOf fabric.Color
   */ fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
    /**
   * Map of the 148 color names with HEX code
   * @static
   * @field
   * @memberOf fabric.Color
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */ fabric.Color.colorNameMap = {
        aliceblue: "#F0F8FF",
        antiquewhite: "#FAEBD7",
        aqua: "#00FFFF",
        aquamarine: "#7FFFD4",
        azure: "#F0FFFF",
        beige: "#F5F5DC",
        bisque: "#FFE4C4",
        black: "#000000",
        blanchedalmond: "#FFEBCD",
        blue: "#0000FF",
        blueviolet: "#8A2BE2",
        brown: "#A52A2A",
        burlywood: "#DEB887",
        cadetblue: "#5F9EA0",
        chartreuse: "#7FFF00",
        chocolate: "#D2691E",
        coral: "#FF7F50",
        cornflowerblue: "#6495ED",
        cornsilk: "#FFF8DC",
        crimson: "#DC143C",
        cyan: "#00FFFF",
        darkblue: "#00008B",
        darkcyan: "#008B8B",
        darkgoldenrod: "#B8860B",
        darkgray: "#A9A9A9",
        darkgrey: "#A9A9A9",
        darkgreen: "#006400",
        darkkhaki: "#BDB76B",
        darkmagenta: "#8B008B",
        darkolivegreen: "#556B2F",
        darkorange: "#FF8C00",
        darkorchid: "#9932CC",
        darkred: "#8B0000",
        darksalmon: "#E9967A",
        darkseagreen: "#8FBC8F",
        darkslateblue: "#483D8B",
        darkslategray: "#2F4F4F",
        darkslategrey: "#2F4F4F",
        darkturquoise: "#00CED1",
        darkviolet: "#9400D3",
        deeppink: "#FF1493",
        deepskyblue: "#00BFFF",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1E90FF",
        firebrick: "#B22222",
        floralwhite: "#FFFAF0",
        forestgreen: "#228B22",
        fuchsia: "#FF00FF",
        gainsboro: "#DCDCDC",
        ghostwhite: "#F8F8FF",
        gold: "#FFD700",
        goldenrod: "#DAA520",
        gray: "#808080",
        grey: "#808080",
        green: "#008000",
        greenyellow: "#ADFF2F",
        honeydew: "#F0FFF0",
        hotpink: "#FF69B4",
        indianred: "#CD5C5C",
        indigo: "#4B0082",
        ivory: "#FFFFF0",
        khaki: "#F0E68C",
        lavender: "#E6E6FA",
        lavenderblush: "#FFF0F5",
        lawngreen: "#7CFC00",
        lemonchiffon: "#FFFACD",
        lightblue: "#ADD8E6",
        lightcoral: "#F08080",
        lightcyan: "#E0FFFF",
        lightgoldenrodyellow: "#FAFAD2",
        lightgray: "#D3D3D3",
        lightgrey: "#D3D3D3",
        lightgreen: "#90EE90",
        lightpink: "#FFB6C1",
        lightsalmon: "#FFA07A",
        lightseagreen: "#20B2AA",
        lightskyblue: "#87CEFA",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#B0C4DE",
        lightyellow: "#FFFFE0",
        lime: "#00FF00",
        limegreen: "#32CD32",
        linen: "#FAF0E6",
        magenta: "#FF00FF",
        maroon: "#800000",
        mediumaquamarine: "#66CDAA",
        mediumblue: "#0000CD",
        mediumorchid: "#BA55D3",
        mediumpurple: "#9370DB",
        mediumseagreen: "#3CB371",
        mediumslateblue: "#7B68EE",
        mediumspringgreen: "#00FA9A",
        mediumturquoise: "#48D1CC",
        mediumvioletred: "#C71585",
        midnightblue: "#191970",
        mintcream: "#F5FFFA",
        mistyrose: "#FFE4E1",
        moccasin: "#FFE4B5",
        navajowhite: "#FFDEAD",
        navy: "#000080",
        oldlace: "#FDF5E6",
        olive: "#808000",
        olivedrab: "#6B8E23",
        orange: "#FFA500",
        orangered: "#FF4500",
        orchid: "#DA70D6",
        palegoldenrod: "#EEE8AA",
        palegreen: "#98FB98",
        paleturquoise: "#AFEEEE",
        palevioletred: "#DB7093",
        papayawhip: "#FFEFD5",
        peachpuff: "#FFDAB9",
        peru: "#CD853F",
        pink: "#FFC0CB",
        plum: "#DDA0DD",
        powderblue: "#B0E0E6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#FF0000",
        rosybrown: "#BC8F8F",
        royalblue: "#4169E1",
        saddlebrown: "#8B4513",
        salmon: "#FA8072",
        sandybrown: "#F4A460",
        seagreen: "#2E8B57",
        seashell: "#FFF5EE",
        sienna: "#A0522D",
        silver: "#C0C0C0",
        skyblue: "#87CEEB",
        slateblue: "#6A5ACD",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#FFFAFA",
        springgreen: "#00FF7F",
        steelblue: "#4682B4",
        tan: "#D2B48C",
        teal: "#008080",
        thistle: "#D8BFD8",
        tomato: "#FF6347",
        turquoise: "#40E0D0",
        violet: "#EE82EE",
        wheat: "#F5DEB3",
        white: "#FFFFFF",
        whitesmoke: "#F5F5F5",
        yellow: "#FFFF00",
        yellowgreen: "#9ACD32"
    };
    /**
   * @private
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */ function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    /**
   * Returns new color object, when given a color in RGB format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {fabric.Color}
   */ fabric.Color.fromRgb = function(color) {
        return Color.fromSource(Color.sourceFromRgb(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf fabric.Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {Array} source
   */ fabric.Color.sourceFromRgb = function(color) {
        var match = color.match(Color.reRGBa);
        if (match) {
            var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1), g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1), b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);
            return [
                parseInt(r, 10),
                parseInt(g, 10),
                parseInt(b, 10),
                match[4] ? parseFloat(match[4]) : 1
            ];
        }
    };
    /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */ fabric.Color.fromRgba = Color.fromRgb;
    /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf fabric.Color
   * @return {fabric.Color}
   */ fabric.Color.fromHsl = function(color) {
        return Color.fromSource(Color.sourceFromHsl(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf fabric.Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {Array} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */ fabric.Color.sourceFromHsl = function(color) {
        var match = color.match(Color.reHSLa);
        if (!match) return;
        var h = (parseFloat(match[1]) % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1), l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1), r, g, b;
        if (s === 0) r = g = b = l;
        else {
            var q = l <= 0.5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255),
            match[4] ? parseFloat(match[4]) : 1
        ];
    };
    /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf fabric.Color
   * @param {String} color
   * @return {fabric.Color}
   */ fabric.Color.fromHsla = Color.fromHsl;
    /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color Color value ex: FF5555
   * @return {fabric.Color}
   */ fabric.Color.fromHex = function(color) {
        return Color.fromSource(Color.sourceFromHex(color));
    };
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf fabric.Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {Array} source
   */ fabric.Color.sourceFromHex = function(color) {
        if (color.match(Color.reHex)) {
            var value = color.slice(color.indexOf("#") + 1), isShortNotation = value.length === 3 || value.length === 4, isRGBa = value.length === 8 || value.length === 4, r = isShortNotation ? value.charAt(0) + value.charAt(0) : value.substring(0, 2), g = isShortNotation ? value.charAt(1) + value.charAt(1) : value.substring(2, 4), b = isShortNotation ? value.charAt(2) + value.charAt(2) : value.substring(4, 6), a = isRGBa ? isShortNotation ? value.charAt(3) + value.charAt(3) : value.substring(6, 8) : "FF";
            return [
                parseInt(r, 16),
                parseInt(g, 16),
                parseInt(b, 16),
                parseFloat((parseInt(a, 16) / 255).toFixed(2))
            ];
        }
    };
    /**
   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
   * @static
   * @memberOf fabric.Color
   * @param {Array} source
   * @return {fabric.Color}
   */ fabric.Color.fromSource = function(source) {
        var oColor = new Color();
        oColor.setSource(source);
        return oColor;
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), scaleMap = [
        "e",
        "se",
        "s",
        "sw",
        "w",
        "nw",
        "n",
        "ne",
        "e"
    ], skewMap = [
        "ns",
        "nesw",
        "ew",
        "nwse"
    ], controls = {}, LEFT = "left", TOP = "top", RIGHT = "right", BOTTOM = "bottom", CENTER = "center", opposite = {
        top: BOTTOM,
        bottom: TOP,
        left: RIGHT,
        right: LEFT,
        center: CENTER
    }, radiansToDegrees = fabric.util.radiansToDegrees, sign = Math.sign || function(x) {
        return (x > 0) - (x < 0) || +x;
    };
    /**
   * Combine control position and object angle to find the control direction compared
   * to the object center.
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   * @param {fabric.Control} control the control class
   * @return {Number} 0 - 7 a quadrant number
   */ function findCornerQuadrant(fabricObject, control) {
        var cornerAngle = fabricObject.angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
        return Math.round(cornerAngle % 360 / 45);
    }
    function fireEvent(eventName, options) {
        var target = options.transform.target, canvas = target.canvas, canvasOptions = fabric.util.object.clone(options);
        canvasOptions.target = target;
        canvas && canvas.fire("object:" + eventName, canvasOptions);
        target.fire(eventName, options);
    }
    /**
   * Inspect event and fabricObject properties to understand if the scaling action
   * @param {Event} eventData from the user action
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @return {Boolean} true if scale is proportional
   */ function scaleIsProportional(eventData, fabricObject) {
        var canvas = fabricObject.canvas, uniScaleKey = canvas.uniScaleKey, uniformIsToggled = eventData[uniScaleKey];
        return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
    }
    /**
   * Checks if transform is centered
   * @param {Object} transform transform data
   * @return {Boolean} true if transform is centered
   */ function isTransformCentered(transform) {
        return transform.originX === CENTER && transform.originY === CENTER;
    }
    /**
   * Inspect fabricObject to understand if the current scaling action is allowed
   * @param {fabric.Object} fabricObject the fabric object about to scale
   * @param {String} by 'x' or 'y' or ''
   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
   * @return {Boolean} true if scaling is not allowed at current conditions
   */ function scalingIsForbidden(fabricObject, by, scaleProportionally) {
        var lockX = fabricObject.lockScalingX, lockY = fabricObject.lockScalingY;
        if (lockX && lockY) return true;
        if (!by && (lockX || lockY) && scaleProportionally) return true;
        if (lockX && by === "x") return true;
        if (lockY && by === "y") return true;
        return false;
    }
    /**
   * return the correct cursor style for the scale action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function scaleCursorStyleHandler(eventData, control, fabricObject) {
        var notAllowed = "not-allowed", scaleProportionally = scaleIsProportional(eventData, fabricObject), by = "";
        if (control.x !== 0 && control.y === 0) by = "x";
        else if (control.x === 0 && control.y !== 0) by = "y";
        if (scalingIsForbidden(fabricObject, by, scaleProportionally)) return notAllowed;
        var n = findCornerQuadrant(fabricObject, control);
        return scaleMap[n] + "-resize";
    }
    /**
   * return the correct cursor style for the skew action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function skewCursorStyleHandler(eventData, control, fabricObject) {
        var notAllowed = "not-allowed";
        if (control.x !== 0 && fabricObject.lockSkewingY) return notAllowed;
        if (control.y !== 0 && fabricObject.lockSkewingX) return notAllowed;
        var n = findCornerQuadrant(fabricObject, control) % 4;
        return skewMap[n] + "-resize";
    }
    /**
   * Combine skew and scale style handlers to cover fabric standard use case
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function scaleSkewCursorStyleHandler(eventData, control, fabricObject) {
        if (eventData[fabricObject.canvas.altActionKey]) return controls.skewCursorStyleHandler(eventData, control, fabricObject);
        return controls.scaleCursorStyleHandler(eventData, control, fabricObject);
    }
    /**
   * Inspect event, control and fabricObject to return the correct action name
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} an action name
   */ function scaleOrSkewActionName(eventData, control, fabricObject) {
        var isAlternative = eventData[fabricObject.canvas.altActionKey];
        if (control.x === 0) // then is scaleY or skewX
        return isAlternative ? "skewX" : "scaleY";
        if (control.y === 0) // then is scaleY or skewX
        return isAlternative ? "skewY" : "scaleX";
    }
    /**
   * Find the correct style for the control that is used for rotation.
   * this function is very simple and it just take care of not-allowed or standard cursor
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {fabric.Control} control the control that is interested in the action
   * @param {fabric.Object} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */ function rotationStyleHandler(eventData, control, fabricObject) {
        if (fabricObject.lockRotation) return "not-allowed";
        return control.cursorStyle;
    }
    function commonEventInfo(eventData, transform, x, y) {
        return {
            e: eventData,
            transform: transform,
            pointer: {
                x: x,
                y: y
            }
        };
    }
    /**
   * Wrap an action handler with saving/restoring object position on the transform.
   * this is the code that permits to objects to keep their position while transforming.
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */ function wrapWithFixedAnchor(actionHandler) {
        return function(eventData, transform, x, y) {
            var target = transform.target, centerPoint = target.getCenterPoint(), constraint = target.translateToOriginPoint(centerPoint, transform.originX, transform.originY), actionPerformed = actionHandler(eventData, transform, x, y);
            target.setPositionByOrigin(constraint, transform.originX, transform.originY);
            return actionPerformed;
        };
    }
    /**
   * Wrap an action handler with firing an event if the action is performed
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */ function wrapWithFireEvent(eventName, actionHandler) {
        return function(eventData, transform, x, y) {
            var actionPerformed = actionHandler(eventData, transform, x, y);
            if (actionPerformed) fireEvent(eventName, commonEventInfo(eventData, transform, x, y));
            return actionPerformed;
        };
    }
    /**
   * Transforms a point described by x and y in a distance from the top left corner of the object
   * bounding box.
   * @param {Object} transform
   * @param {String} originX
   * @param {String} originY
   * @param {number} x
   * @param {number} y
   * @return {Fabric.Point} the normalized point
   */ function getLocalPoint(transform, originX, originY, x, y) {
        var target = transform.target, control = target.controls[transform.corner], zoom = target.canvas.getZoom(), padding = target.padding / zoom, localPoint = target.toLocalPoint(new fabric.Point(x, y), originX, originY);
        if (localPoint.x >= padding) localPoint.x -= padding;
        if (localPoint.x <= -padding) localPoint.x += padding;
        if (localPoint.y >= padding) localPoint.y -= padding;
        if (localPoint.y <= padding) localPoint.y += padding;
        localPoint.x -= control.offsetX;
        localPoint.y -= control.offsetY;
        return localPoint;
    }
    /**
   * Detect if the fabric object is flipped on one side.
   * @param {fabric.Object} target
   * @return {Boolean} true if one flip, but not two.
   */ function targetHasOneFlip(target) {
        return target.flipX !== target.flipY;
    }
    /**
   * Utility function to compensate the scale factor when skew is applied on both axes
   * @private
   */ function compensateScaleForSkew(target, oppositeSkew, scaleToCompensate, axis, reference) {
        if (target[oppositeSkew] !== 0) {
            var newDim = target._getTransformedDimensions()[axis];
            var newValue = reference / newDim * target[scaleToCompensate];
            target.set(scaleToCompensate, newValue);
        }
    }
    /**
   * Action handler for skewing on the X axis
   * @private
   */ function skewObjectX(eventData, transform, x, y) {
        var target = transform.target, // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(0, target.skewY), localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.x * 2) - dimNoSkew.x, currentSkew = target.skewX, newSkew;
        if (totalSkewSize < 2) // let's make it easy to go back to position 0.
        newSkew = 0;
        else {
            newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleX, dimNoSkew.y / target.scaleY));
            // now we have to find the sign of the skew.
            // it mostly depend on the origin of transformation.
            if (transform.originX === LEFT && transform.originY === BOTTOM) newSkew = -newSkew;
            if (transform.originX === RIGHT && transform.originY === TOP) newSkew = -newSkew;
            if (targetHasOneFlip(target)) newSkew = -newSkew;
        }
        var hasSkewed = currentSkew !== newSkew;
        if (hasSkewed) {
            var dimBeforeSkewing = target._getTransformedDimensions().y;
            target.set("skewX", newSkew);
            compensateScaleForSkew(target, "skewY", "scaleY", "y", dimBeforeSkewing);
        }
        return hasSkewed;
    }
    /**
   * Action handler for skewing on the Y axis
   * @private
   */ function skewObjectY(eventData, transform, x, y) {
        var target = transform.target, // find how big the object would be, if there was no skewX. takes in account scaling
        dimNoSkew = target._getTransformedDimensions(target.skewX, 0), localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), // the mouse is in the center of the object, and we want it to stay there.
        // so the object will grow twice as much as the mouse.
        // this makes the skew growth to localPoint * 2 - dimNoSkew.
        totalSkewSize = Math.abs(localPoint.y * 2) - dimNoSkew.y, currentSkew = target.skewY, newSkew;
        if (totalSkewSize < 2) // let's make it easy to go back to position 0.
        newSkew = 0;
        else {
            newSkew = radiansToDegrees(Math.atan2(totalSkewSize / target.scaleY, dimNoSkew.x / target.scaleX));
            // now we have to find the sign of the skew.
            // it mostly depend on the origin of transformation.
            if (transform.originX === LEFT && transform.originY === BOTTOM) newSkew = -newSkew;
            if (transform.originX === RIGHT && transform.originY === TOP) newSkew = -newSkew;
            if (targetHasOneFlip(target)) newSkew = -newSkew;
        }
        var hasSkewed = currentSkew !== newSkew;
        if (hasSkewed) {
            var dimBeforeSkewing = target._getTransformedDimensions().x;
            target.set("skewY", newSkew);
            compensateScaleForSkew(target, "skewX", "scaleX", "x", dimBeforeSkewing);
        }
        return hasSkewed;
    }
    /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function skewHandlerX(eventData, transform, x, y) {
        // step1 figure out and change transform origin.
        // if skewX > 0 and originY bottom we anchor on right
        // if skewX > 0 and originY top we anchor on left
        // if skewX < 0 and originY bottom we anchor on left
        // if skewX < 0 and originY top we anchor on right
        // if skewX is 0, we look for mouse position to understand where are we going.
        var target = transform.target, currentSkew = target.skewX, originX, originY = transform.originY;
        if (target.lockSkewingX) return false;
        if (currentSkew === 0) {
            var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
            if (localPointFromCenter.x > 0) // we are pulling right, anchor left;
            originX = LEFT;
            else // we are pulling right, anchor right
            originX = RIGHT;
        } else {
            if (currentSkew > 0) originX = originY === TOP ? LEFT : RIGHT;
            if (currentSkew < 0) originX = originY === TOP ? RIGHT : LEFT;
            // is the object flipped on one side only? swap the origin.
            if (targetHasOneFlip(target)) originX = originX === LEFT ? RIGHT : LEFT;
        }
        // once we have the origin, we find the anchor point
        transform.originX = originX;
        var finalHandler = wrapWithFireEvent("skewing", wrapWithFixedAnchor(skewObjectX));
        return finalHandler(eventData, transform, x, y);
    }
    /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determine the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function skewHandlerY(eventData, transform, x, y) {
        // step1 figure out and change transform origin.
        // if skewY > 0 and originX left we anchor on top
        // if skewY > 0 and originX right we anchor on bottom
        // if skewY < 0 and originX left we anchor on bottom
        // if skewY < 0 and originX right we anchor on top
        // if skewY is 0, we look for mouse position to understand where are we going.
        var target = transform.target, currentSkew = target.skewY, originY, originX = transform.originX;
        if (target.lockSkewingY) return false;
        if (currentSkew === 0) {
            var localPointFromCenter = getLocalPoint(transform, CENTER, CENTER, x, y);
            if (localPointFromCenter.y > 0) // we are pulling down, anchor up;
            originY = TOP;
            else // we are pulling up, anchor down
            originY = BOTTOM;
        } else {
            if (currentSkew > 0) originY = originX === LEFT ? TOP : BOTTOM;
            if (currentSkew < 0) originY = originX === LEFT ? BOTTOM : TOP;
            // is the object flipped on one side only? swap the origin.
            if (targetHasOneFlip(target)) originY = originY === TOP ? BOTTOM : TOP;
        }
        // once we have the origin, we find the anchor point
        transform.originY = originY;
        var finalHandler = wrapWithFireEvent("skewing", wrapWithFixedAnchor(skewObjectY));
        return finalHandler(eventData, transform, x, y);
    }
    /**
   * Action handler for rotation and snapping, without anchor point.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   * @private
   */ function rotationWithSnapping(eventData, transform, x, y) {
        var t = transform, target = t.target, pivotPoint = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);
        if (target.lockRotation) return false;
        var lastAngle = Math.atan2(t.ey - pivotPoint.y, t.ex - pivotPoint.x), curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x), angle = radiansToDegrees(curAngle - lastAngle + t.theta), hasRotated = true;
        if (target.snapAngle > 0) {
            var snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
            if (Math.abs(angle - leftAngleLocked) < snapThreshold) angle = leftAngleLocked;
            else if (Math.abs(angle - rightAngleLocked) < snapThreshold) angle = rightAngleLocked;
        }
        // normalize angle to positive value
        if (angle < 0) angle = 360 + angle;
        angle %= 360;
        hasRotated = target.angle !== angle;
        target.angle = angle;
        return hasRotated;
    }
    /**
   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @param {Object} options additional information for scaling
   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
   * @return {Boolean} true if some change happened
   * @private
   */ function scaleObject(eventData, transform, x, y, options) {
        options = options || {};
        var target = transform.target, lockScalingX = target.lockScalingX, lockScalingY = target.lockScalingY, by = options.by, newPoint, scaleX, scaleY, dim, scaleProportionally = scaleIsProportional(eventData, target), forbidScaling = scalingIsForbidden(target, by, scaleProportionally), signX, signY, gestureScale = transform.gestureScale;
        if (forbidScaling) return false;
        if (gestureScale) {
            scaleX = transform.scaleX * gestureScale;
            scaleY = transform.scaleY * gestureScale;
        } else {
            newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
            // use of sign: We use sign to detect change of direction of an action. sign usually change when
            // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
            // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
            // cross many time the origin point and flip the object. so we need a way to filter out the noise.
            // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
            signX = by !== "y" ? sign(newPoint.x) : 1;
            signY = by !== "x" ? sign(newPoint.y) : 1;
            if (!transform.signX) transform.signX = signX;
            if (!transform.signY) transform.signY = signY;
            if (target.lockScalingFlip && (transform.signX !== signX || transform.signY !== signY)) return false;
            dim = target._getTransformedDimensions();
            // missing detection of flip and logic to switch the origin
            if (scaleProportionally && !by) {
                // uniform scaling
                var distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), original = transform.original, originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY), scale = distance / originalDistance;
                scaleX = original.scaleX * scale;
                scaleY = original.scaleY * scale;
            } else {
                scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
                scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
            }
            // if we are scaling by center, we need to double the scale
            if (isTransformCentered(transform)) {
                scaleX *= 2;
                scaleY *= 2;
            }
            if (transform.signX !== signX && by !== "y") {
                transform.originX = opposite[transform.originX];
                scaleX *= -1;
                transform.signX = signX;
            }
            if (transform.signY !== signY && by !== "x") {
                transform.originY = opposite[transform.originY];
                scaleY *= -1;
                transform.signY = signY;
            }
        }
        // minScale is taken are in the setter.
        var oldScaleX = target.scaleX, oldScaleY = target.scaleY;
        if (!by) {
            !lockScalingX && target.set("scaleX", scaleX);
            !lockScalingY && target.set("scaleY", scaleY);
        } else {
            // forbidden cases already handled on top here.
            by === "x" && target.set("scaleX", scaleX);
            by === "y" && target.set("scaleY", scaleY);
        }
        return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
    }
    /**
   * Generic scaling logic, to scale from corners either equally or freely.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectFromCorner(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y);
    }
    /**
   * Scaling logic for the X axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectX(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y, {
            by: "x"
        });
    }
    /**
   * Scaling logic for the Y axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scaleObjectY(eventData, transform, x, y) {
        return scaleObject(eventData, transform, x, y, {
            by: "y"
        });
    }
    /**
   * Composed action handler to either scale Y or skew X
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scalingYOrSkewingX(eventData, transform, x, y) {
        // ok some safety needed here.
        if (eventData[transform.target.canvas.altActionKey]) return controls.skewHandlerX(eventData, transform, x, y);
        return controls.scalingY(eventData, transform, x, y);
    }
    /**
   * Composed action handler to either scale X or skew Y
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function scalingXOrSkewingY(eventData, transform, x, y) {
        // ok some safety needed here.
        if (eventData[transform.target.canvas.altActionKey]) return controls.skewHandlerY(eventData, transform, x, y);
        return controls.scalingX(eventData, transform, x, y);
    }
    /**
   * Action handler to change textbox width
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */ function changeWidth(eventData, transform, x, y) {
        var target = transform.target, localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y), strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1), multiplier = isTransformCentered(transform) ? 2 : 1, oldWidth = target.width, newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
        target.set("width", Math.max(newWidth, 0));
        return oldWidth !== newWidth;
    }
    /**
   * Action handler
   * @private
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if the translation occurred
   */ function dragHandler(eventData, transform, x, y) {
        var target = transform.target, newLeft = x - transform.offsetX, newTop = y - transform.offsetY, moveX = !target.get("lockMovementX") && target.left !== newLeft, moveY = !target.get("lockMovementY") && target.top !== newTop;
        moveX && target.set("left", newLeft);
        moveY && target.set("top", newTop);
        if (moveX || moveY) fireEvent("moving", commonEventInfo(eventData, transform, x, y));
        return moveX || moveY;
    }
    controls.scaleCursorStyleHandler = scaleCursorStyleHandler;
    controls.skewCursorStyleHandler = skewCursorStyleHandler;
    controls.scaleSkewCursorStyleHandler = scaleSkewCursorStyleHandler;
    controls.rotationWithSnapping = wrapWithFireEvent("rotating", wrapWithFixedAnchor(rotationWithSnapping));
    controls.scalingEqually = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectFromCorner));
    controls.scalingX = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectX));
    controls.scalingY = wrapWithFireEvent("scaling", wrapWithFixedAnchor(scaleObjectY));
    controls.scalingYOrSkewingX = scalingYOrSkewingX;
    controls.scalingXOrSkewingY = scalingXOrSkewingY;
    controls.changeWidth = wrapWithFireEvent("resizing", wrapWithFixedAnchor(changeWidth));
    controls.skewHandlerX = skewHandlerX;
    controls.skewHandlerY = skewHandlerY;
    controls.dragHandler = dragHandler;
    controls.scaleOrSkewActionName = scaleOrSkewActionName;
    controls.rotationStyleHandler = rotationStyleHandler;
    controls.fireEvent = fireEvent;
    controls.wrapWithFixedAnchor = wrapWithFixedAnchor;
    controls.wrapWithFireEvent = wrapWithFireEvent;
    controls.getLocalPoint = getLocalPoint;
    fabric.controlsUtils = controls;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), degreesToRadians = fabric.util.degreesToRadians, controls = fabric.controlsUtils;
    /**
   * Render a round control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */ function renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? "stroke" : "fill", stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), myLeft = left, myTop = top, size;
        ctx.save();
        ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
        ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
        // as soon as fabric react v5, remove ie11, use proper ellipse code.
        if (xSize > ySize) {
            size = xSize;
            ctx.scale(1.0, ySize / xSize);
            myTop = top * xSize / ySize;
        } else if (ySize > xSize) {
            size = ySize;
            ctx.scale(xSize / ySize, 1.0);
            myLeft = left * ySize / xSize;
        } else size = xSize;
        // this is still wrong
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(myLeft, myTop, size / 2, 0, 2 * Math.PI, false);
        ctx[methodName]();
        if (stroke) ctx.stroke();
        ctx.restore();
    }
    /**
   * Render a square control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for fabric.Object controls style
   * @param {fabric.Object} fabricObject the fabric object for which we are rendering controls
   */ function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        var xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== "undefined" ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? "stroke" : "fill", stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
        ctx.save();
        ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor;
        ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor;
        // this is still wrong
        ctx.lineWidth = 1;
        ctx.translate(left, top);
        ctx.rotate(degreesToRadians(fabricObject.angle));
        // this does not work, and fixed with ( && ) does not make sense.
        // to have real transparent corners we need the controls on upperCanvas
        // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
        ctx[methodName + "Rect"](-xSizeBy2, -ySizeBy2, xSize, ySize);
        if (stroke) ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
        ctx.restore();
    }
    controls.renderCircleControl = renderCircleControl;
    controls.renderSquareControl = renderSquareControl;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {});
    function Control(options) {
        for(var i in options)this[i] = options[i];
    }
    fabric.Control = Control;
    fabric.Control.prototype = /** @lends fabric.Control.prototype */ {
        /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the controlset.
     * @type {Boolean}
     * @default true
     */ visible: true,
        /**
     * Name of the action that the control will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */ actionName: "scale",
        /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */ angle: 0,
        /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ x: 0,
        /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ y: 0,
        /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundindbox, with an offset of 30 pixels vertically. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ offsetX: 0,
        /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */ offsetY: 0,
        /**
     * Sets the length of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ sizeX: null,
        /**
     * Sets the height of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ sizeY: null,
        /**
     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ touchSizeX: null,
        /**
     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ touchSizeY: null,
        /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */ cursorStyle: "crosshair",
        /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */ withConnection: false,
        /**
     * The control actionHandler, provide one to handle action ( control being moved )
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ actionHandler: function() {},
        /**
     * The control handler for mouse down, provide one to handle mouse down on control
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ mouseDownHandler: function() {},
        /**
     * The control mouseUpHandler, provide one to handle an effect on mouse up.
     * @param {Event} eventData the native mouse event
     * @param {Object} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */ mouseUpHandler: function() {},
        /**
     * Returns control actionHandler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getActionHandler: function() {
            return this.actionHandler;
        },
        /**
     * Returns control mouseDown handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getMouseDownHandler: function() {
            return this.mouseDownHandler;
        },
        /**
     * Returns control mouseUp handler
     * @param {Event} eventData the native mouse event
     * @param {fabric.Object} fabricObject on which the control is displayed
     * @param {fabric.Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */ getMouseUpHandler: function() {
            return this.mouseUpHandler;
        },
        /**
     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
     * function you can pass one in the constructor
     * the cursorStyle property
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */ cursorStyleHandler: function(eventData, control /* fabricObject */ ) {
            return control.cursorStyle;
        },
        /**
     * Returns the action name. The basic implementation just return the actionName property.
     * @param {Event} eventData the native mouse event
     * @param {fabric.Control} control the current control ( likely this)
     * @param {fabric.Object} object on which the control is displayed
     * @return {String}
     */ getActionName: function(eventData, control /* fabricObject */ ) {
            return control.actionName;
        },
        /**
     * Returns controls visibility
     * @param {fabric.Object} object on which the control is displayed
     * @param {String} controlKey key where the control is memorized on the
     * @return {Boolean}
     */ getVisibility: function(fabricObject, controlKey) {
            var objectVisibility = fabricObject._controlsVisibility;
            if (objectVisibility && typeof objectVisibility[controlKey] !== "undefined") return objectVisibility[controlKey];
            return this.visible;
        },
        /**
     * Sets controls visibility
     * @param {Boolean} visibility for the object
     * @return {Void}
     */ setVisibility: function(visibility /* name, fabricObject */ ) {
            this.visible = visibility;
        },
        positionHandler: function(dim, finalMatrix /*, fabricObject, currentControl */ ) {
            var point = fabric.util.transformPoint({
                x: this.x * dim.x + this.offsetX,
                y: this.y * dim.y + this.offsetY
            }, finalMatrix);
            return point;
        },
        /**
     * Returns the coords for this control based on object values.
     * @param {Number} objectAngle angle from the fabric object holding the control
     * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
     *   isTouch is true)
     * @param {Number} centerX x coordinate where the control center should be
     * @param {Number} centerY y coordinate where the control center should be
     * @param {boolean} isTouch true if touch corner, false if normal corner
     */ calcCornerCoords: function(objectAngle, objectCornerSize, centerX, centerY, isTouch) {
            var cosHalfOffset, sinHalfOffset, cosHalfOffsetComp, sinHalfOffsetComp, xSize = isTouch ? this.touchSizeX : this.sizeX, ySize = isTouch ? this.touchSizeY : this.sizeY;
            if (xSize && ySize && xSize !== ySize) {
                // handle rectangular corners
                var controlTriangleAngle = Math.atan2(ySize, xSize);
                var cornerHypotenuse = Math.sqrt(xSize * xSize + ySize * ySize) / 2;
                var newTheta = controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
                var newThetaComp = Math.PI / 2 - controlTriangleAngle - fabric.util.degreesToRadians(objectAngle);
                cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta);
                sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta);
                // use complementary angle for two corners
                cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newThetaComp);
                sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newThetaComp);
            } else {
                // handle square corners
                // use default object corner size unless size is defined
                var cornerSize = xSize && ySize ? xSize : objectCornerSize;
                /* 0.7071067812 stands for sqrt(2)/2 */ cornerHypotenuse = cornerSize * 0.7071067812;
                // complementary angles are equal since they're both 45 degrees
                var newTheta = fabric.util.degreesToRadians(45 - objectAngle);
                cosHalfOffset = cosHalfOffsetComp = cornerHypotenuse * fabric.util.cos(newTheta);
                sinHalfOffset = sinHalfOffsetComp = cornerHypotenuse * fabric.util.sin(newTheta);
            }
            return {
                tl: {
                    x: centerX - sinHalfOffsetComp,
                    y: centerY - cosHalfOffsetComp
                },
                tr: {
                    x: centerX + cosHalfOffset,
                    y: centerY - sinHalfOffset
                },
                bl: {
                    x: centerX - cosHalfOffset,
                    y: centerY + sinHalfOffset
                },
                br: {
                    x: centerX + sinHalfOffsetComp,
                    y: centerY + cosHalfOffsetComp
                }
            };
        },
        /**
    * Render function for the control.
    * When this function runs the context is unscaled. unrotate. Just retina scaled.
    * all the functions will have to translate to the point left,top before starting Drawing
    * if they want to draw a control where the position is detected.
    * left and top are the result of the positionHandler function
    * @param {RenderingContext2D} ctx the context where the control will be drawn
    * @param {Number} left position of the canvas where we are about to render the control.
    * @param {Number} top position of the canvas where we are about to render the control.
    * @param {Object} styleOverride
    * @param {fabric.Object} fabricObject the object where the control is about to be rendered
    */ render: function(ctx, left, top, styleOverride, fabricObject) {
            styleOverride = styleOverride || {};
            switch(styleOverride.cornerStyle || fabricObject.cornerStyle){
                case "circle":
                    fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
                    break;
                default:
                    fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
            }
        }
    };
})($d47795690082d4de$exports);
(function() {
    /* _FROM_SVG_START_ */ function getColorStop(el, multiplier) {
        var style = el.getAttribute("style"), offset = el.getAttribute("offset") || 0, color, colorAlpha, opacity, i;
        // convert percents to absolute values
        offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
        offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
        if (style) {
            var keyValuePairs = style.split(/\s*;\s*/);
            if (keyValuePairs[keyValuePairs.length - 1] === "") keyValuePairs.pop();
            for(i = keyValuePairs.length; i--;){
                var split = keyValuePairs[i].split(/\s*:\s*/), key = split[0].trim(), value = split[1].trim();
                if (key === "stop-color") color = value;
                else if (key === "stop-opacity") opacity = value;
            }
        }
        if (!color) color = el.getAttribute("stop-color") || "rgb(0,0,0)";
        if (!opacity) opacity = el.getAttribute("stop-opacity");
        color = new $d47795690082d4de$var$fabric.Color(color);
        colorAlpha = color.getAlpha();
        opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
        opacity *= colorAlpha * multiplier;
        return {
            offset: offset,
            color: color.toRgb(),
            opacity: opacity
        };
    }
    function getLinearCoords(el) {
        return {
            x1: el.getAttribute("x1") || 0,
            y1: el.getAttribute("y1") || 0,
            x2: el.getAttribute("x2") || "100%",
            y2: el.getAttribute("y2") || 0
        };
    }
    function getRadialCoords(el) {
        return {
            x1: el.getAttribute("fx") || el.getAttribute("cx") || "50%",
            y1: el.getAttribute("fy") || el.getAttribute("cy") || "50%",
            r1: 0,
            x2: el.getAttribute("cx") || "50%",
            y2: el.getAttribute("cy") || "50%",
            r2: el.getAttribute("r") || "50%"
        };
    }
    /* _FROM_SVG_END_ */ var clone = $d47795690082d4de$var$fabric.util.object.clone;
    /**
   * Gradient class
   * @class fabric.Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   * @see {@link fabric.Gradient#initialize} for constructor definition
   */ $d47795690082d4de$var$fabric.Gradient = $d47795690082d4de$var$fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {
        /**
     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */ offsetX: 0,
        /**
     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
     * @type Number
     * @default 0
     */ offsetY: 0,
        /**
     * A transform matrix to apply to the gradient before painting.
     * Imported from svg gradients, is not applied with the current transform in the center.
     * Before this transform is applied, the origin point is at the top left corner of the object
     * plus the addition of offsetY and offsetX.
     * @type Number[]
     * @default null
     */ gradientTransform: null,
        /**
     * coordinates units for coords.
     * If `pixels`, the number of coords are in the same unit of width / height.
     * If set as `percentage` the coords are still a number, but 1 means 100% of width
     * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
     * allowed values pixels or percentage.
     * @type String
     * @default 'pixels'
     */ gradientUnits: "pixels",
        /**
     * Gradient type linear or radial
     * @type String
     * @default 'pixels'
     */ type: "linear",
        /**
     * Constructor
     * @param {Object} options Options object with type, coords, gradientUnits and colorStops
     * @param {Object} [options.type] gradient type linear or radial
     * @param {Object} [options.gradientUnits] gradient units
     * @param {Object} [options.offsetX] SVG import compatibility
     * @param {Object} [options.offsetY] SVG import compatibility
     * @param {Object[]} options.colorStops contains the colorstops.
     * @param {Object} options.coords contains the coords of the gradient
     * @param {Number} [options.coords.x1] X coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.y1] Y coordiante of the first point for linear or of the focal point for radial
     * @param {Number} [options.coords.x2] X coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.y2] Y coordiante of the second point for linear or of the center point for radial
     * @param {Number} [options.coords.r1] only for radial gradient, radius of the inner circle
     * @param {Number} [options.coords.r2] only for radial gradient, radius of the external circle
     * @return {fabric.Gradient} thisArg
     */ initialize: function(options) {
            options || (options = {});
            options.coords || (options.coords = {});
            var coords, _this = this;
            // sets everything, then coords and colorstops get sets again
            Object.keys(options).forEach(function(option) {
                _this[option] = options[option];
            });
            if (this.id) this.id += "_" + $d47795690082d4de$var$fabric.Object.__uid++;
            else this.id = $d47795690082d4de$var$fabric.Object.__uid++;
            coords = {
                x1: options.coords.x1 || 0,
                y1: options.coords.y1 || 0,
                x2: options.coords.x2 || 0,
                y2: options.coords.y2 || 0
            };
            if (this.type === "radial") {
                coords.r1 = options.coords.r1 || 0;
                coords.r2 = options.coords.r2 || 0;
            }
            this.coords = coords;
            this.colorStops = options.colorStops.slice();
        },
        /**
     * Adds another colorStop
     * @param {Object} colorStop Object with offset and color
     * @return {fabric.Gradient} thisArg
     */ addColorStop: function(colorStops) {
            for(var position in colorStops){
                var color = new $d47795690082d4de$var$fabric.Color(colorStops[position]);
                this.colorStops.push({
                    offset: parseFloat(position),
                    color: color.toRgb(),
                    opacity: color.getAlpha()
                });
            }
            return this;
        },
        /**
     * Returns object representation of a gradient
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object}
     */ toObject: function(propertiesToInclude) {
            var object = {
                type: this.type,
                coords: this.coords,
                colorStops: this.colorStops,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                gradientUnits: this.gradientUnits,
                gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
            };
            $d47795690082d4de$var$fabric.util.populateWithProperties(this, object, propertiesToInclude);
            return object;
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of an gradient
     * @param {Object} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */ toSVG: function(object, options) {
            var coords = clone(this.coords, true), i, len, options = options || {}, markup, commonAttributes, colorStops = clone(this.colorStops, true), needsSwap = coords.r1 > coords.r2, transform = this.gradientTransform ? this.gradientTransform.concat() : $d47795690082d4de$var$fabric.iMatrix.concat(), offsetX = -this.offsetX, offsetY = -this.offsetY, withViewport = !!options.additionalTransform, gradientUnits = this.gradientUnits === "pixels" ? "userSpaceOnUse" : "objectBoundingBox";
            // colorStops must be sorted ascending
            colorStops.sort(function(a, b) {
                return a.offset - b.offset;
            });
            if (gradientUnits === "objectBoundingBox") {
                offsetX /= object.width;
                offsetY /= object.height;
            } else {
                offsetX += object.width / 2;
                offsetY += object.height / 2;
            }
            if (object.type === "path" && this.gradientUnits !== "percentage") {
                offsetX -= object.pathOffset.x;
                offsetY -= object.pathOffset.y;
            }
            transform[4] -= offsetX;
            transform[5] -= offsetY;
            commonAttributes = 'id="SVGID_' + this.id + '" gradientUnits="' + gradientUnits + '"';
            commonAttributes += ' gradientTransform="' + (withViewport ? options.additionalTransform + " " : "") + $d47795690082d4de$var$fabric.util.matrixToSVG(transform) + '" ';
            if (this.type === "linear") markup = [
                "<linearGradient ",
                commonAttributes,
                ' x1="',
                coords.x1,
                '" y1="',
                coords.y1,
                '" x2="',
                coords.x2,
                '" y2="',
                coords.y2,
                '">\n'
            ];
            else if (this.type === "radial") // svg radial gradient has just 1 radius. the biggest.
            markup = [
                "<radialGradient ",
                commonAttributes,
                ' cx="',
                needsSwap ? coords.x1 : coords.x2,
                '" cy="',
                needsSwap ? coords.y1 : coords.y2,
                '" r="',
                needsSwap ? coords.r1 : coords.r2,
                '" fx="',
                needsSwap ? coords.x2 : coords.x1,
                '" fy="',
                needsSwap ? coords.y2 : coords.y1,
                '">\n'
            ];
            if (this.type === "radial") {
                if (needsSwap) {
                    // svg goes from internal to external radius. if radius are inverted, swap color stops.
                    colorStops = colorStops.concat();
                    colorStops.reverse();
                    for(i = 0, len = colorStops.length; i < len; i++)colorStops[i].offset = 1 - colorStops[i].offset;
                }
                var minRadius = Math.min(coords.r1, coords.r2);
                if (minRadius > 0) {
                    // i have to shift all colorStops and add new one in 0.
                    var maxRadius = Math.max(coords.r1, coords.r2), percentageShift = minRadius / maxRadius;
                    for(i = 0, len = colorStops.length; i < len; i++)colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
                }
            }
            for(i = 0, len = colorStops.length; i < len; i++){
                var colorStop = colorStops[i];
                markup.push("<stop ", 'offset="', colorStop.offset * 100 + "%", '" style="stop-color:', colorStop.color, typeof colorStop.opacity !== "undefined" ? ";stop-opacity: " + colorStop.opacity : ";", '"/>\n');
            }
            markup.push(this.type === "linear" ? "</linearGradient>\n" : "</radialGradient>\n");
            return markup.join("");
        },
        /* _TO_SVG_END_ */ /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {CanvasGradient}
     */ toLive: function(ctx) {
            var gradient, coords = $d47795690082d4de$var$fabric.util.object.clone(this.coords), i, len;
            if (!this.type) return;
            if (this.type === "linear") gradient = ctx.createLinearGradient(coords.x1, coords.y1, coords.x2, coords.y2);
            else if (this.type === "radial") gradient = ctx.createRadialGradient(coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
            for(i = 0, len = this.colorStops.length; i < len; i++){
                var color = this.colorStops[i].color, opacity = this.colorStops[i].opacity, offset = this.colorStops[i].offset;
                if (typeof opacity !== "undefined") color = new $d47795690082d4de$var$fabric.Color(color).setAlpha(opacity).toRgba();
                gradient.addColorStop(offset, color);
            }
            return gradient;
        }
    });
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Gradient, {
        /* _FROM_SVG_START_ */ /**
     * Returns {@link fabric.Gradient} instance from an SVG element
     * @static
     * @memberOf fabric.Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {fabric.Object} instance
     * @param {String} opacityAttr A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {Object} svgOptions an object containing the size of the SVG in order to parse correctly gradients
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @param {Object.number} viewBoxWidth width part of the viewBox attribute on svg
     * @param {Object.number} viewBoxHeight height part of the viewBox attribute on svg
     * @param {Object.number} width width part of the svg tag if viewBox is not specified
     * @param {Object.number} height height part of the svg tag if viewBox is not specified
     * @return {fabric.Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     */ fromElement: function(el, instance, opacityAttr, svgOptions) {
            /**
       *  @example:
       *
       *  <linearGradient id="linearGrad1">
       *    <stop offset="0%" stop-color="white"/>
       *    <stop offset="100%" stop-color="black"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <linearGradient id="linearGrad2">
       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
       *  </linearGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad1">
       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
       *  </radialGradient>
       *
       *  OR
       *
       *  <radialGradient id="radialGrad2">
       *    <stop offset="0" stop-color="rgb(255,255,255)" />
       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
       *    <stop offset="1" stop-color="rgb(255,255,255)" />
       *  </radialGradient>
       *
       */ var multiplier = parseFloat(opacityAttr) / (/%$/.test(opacityAttr) ? 100 : 1);
            multiplier = multiplier < 0 ? 0 : multiplier > 1 ? 1 : multiplier;
            if (isNaN(multiplier)) multiplier = 1;
            var colorStopEls = el.getElementsByTagName("stop"), type, gradientUnits = el.getAttribute("gradientUnits") === "userSpaceOnUse" ? "pixels" : "percentage", gradientTransform = el.getAttribute("gradientTransform") || "", colorStops = [], coords, i, offsetX = 0, offsetY = 0, transformMatrix;
            if (el.nodeName === "linearGradient" || el.nodeName === "LINEARGRADIENT") {
                type = "linear";
                coords = getLinearCoords(el);
            } else {
                type = "radial";
                coords = getRadialCoords(el);
            }
            for(i = colorStopEls.length; i--;)colorStops.push(getColorStop(colorStopEls[i], multiplier));
            transformMatrix = $d47795690082d4de$var$fabric.parseTransformAttribute(gradientTransform);
            __convertPercentUnitsToValues(instance, coords, svgOptions, gradientUnits);
            if (gradientUnits === "pixels") {
                offsetX = -instance.left;
                offsetY = -instance.top;
            }
            var gradient = new $d47795690082d4de$var$fabric.Gradient({
                id: el.getAttribute("id"),
                type: type,
                coords: coords,
                colorStops: colorStops,
                gradientUnits: gradientUnits,
                gradientTransform: transformMatrix,
                offsetX: offsetX,
                offsetY: offsetY
            });
            return gradient;
        }
    });
    /**
   * @private
   */ function __convertPercentUnitsToValues(instance, options, svgOptions, gradientUnits) {
        var propValue, finalValue;
        Object.keys(options).forEach(function(prop) {
            propValue = options[prop];
            if (propValue === "Infinity") finalValue = 1;
            else if (propValue === "-Infinity") finalValue = 0;
            else {
                finalValue = parseFloat(options[prop], 10);
                if (typeof propValue === "string" && /^(\d+\.\d+)%|(\d+)%$/.test(propValue)) {
                    finalValue *= 0.01;
                    if (gradientUnits === "pixels") {
                        // then we need to fix those percentages here in svg parsing
                        if (prop === "x1" || prop === "x2" || prop === "r2") finalValue *= svgOptions.viewBoxWidth || svgOptions.width;
                        if (prop === "y1" || prop === "y2") finalValue *= svgOptions.viewBoxHeight || svgOptions.height;
                    }
                }
            }
            options[prop] = finalValue;
        });
    }
})();
(function() {
    "use strict";
    var toFixed = $d47795690082d4de$var$fabric.util.toFixed;
    /**
   * Pattern class
   * @class fabric.Pattern
   * @see {@link http://fabricjs.com/patterns|Pattern demo}
   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
   * @see {@link fabric.Pattern#initialize} for constructor definition
   */ $d47795690082d4de$var$fabric.Pattern = $d47795690082d4de$var$fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {
        /**
     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
     * @type String
     * @default
     */ repeat: "repeat",
        /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */ offsetX: 0,
        /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */ offsetY: 0,
        /**
     * crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @type String
     * @default
     */ crossOrigin: "",
        /**
     * transform matrix to change the pattern, imported from svgs.
     * @type Array
     * @default
     */ patternTransform: null,
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {Function} [callback] function to invoke after callback init.
     * @return {fabric.Pattern} thisArg
     */ initialize: function(options, callback) {
            options || (options = {});
            this.id = $d47795690082d4de$var$fabric.Object.__uid++;
            this.setOptions(options);
            if (!options.source || options.source && typeof options.source !== "string") {
                callback && callback(this);
                return;
            } else {
                // img src string
                var _this = this;
                this.source = $d47795690082d4de$var$fabric.util.createImage();
                $d47795690082d4de$var$fabric.util.loadImage(options.source, function(img, isError) {
                    _this.source = img;
                    callback && callback(_this, isError);
                }, null, this.crossOrigin);
            }
        },
        /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of a pattern instance
     */ toObject: function(propertiesToInclude) {
            var NUM_FRACTION_DIGITS = $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS, source, object;
            // <img> element
            if (typeof this.source.src === "string") source = this.source.src;
            else if (typeof this.source === "object" && this.source.toDataURL) source = this.source.toDataURL();
            object = {
                type: "pattern",
                source: source,
                repeat: this.repeat,
                crossOrigin: this.crossOrigin,
                offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
                offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
                patternTransform: this.patternTransform ? this.patternTransform.concat() : null
            };
            $d47795690082d4de$var$fabric.util.populateWithProperties(this, object, propertiesToInclude);
            return object;
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of a pattern
     * @param {fabric.Object} object
     * @return {String} SVG representation of a pattern
     */ toSVG: function(object) {
            var patternSource = typeof this.source === "function" ? this.source() : this.source, patternWidth = patternSource.width / object.width, patternHeight = patternSource.height / object.height, patternOffsetX = this.offsetX / object.width, patternOffsetY = this.offsetY / object.height, patternImgSrc = "";
            if (this.repeat === "repeat-x" || this.repeat === "no-repeat") {
                patternHeight = 1;
                if (patternOffsetY) patternHeight += Math.abs(patternOffsetY);
            }
            if (this.repeat === "repeat-y" || this.repeat === "no-repeat") {
                patternWidth = 1;
                if (patternOffsetX) patternWidth += Math.abs(patternOffsetX);
            }
            if (patternSource.src) patternImgSrc = patternSource.src;
            else if (patternSource.toDataURL) patternImgSrc = patternSource.toDataURL();
            return '<pattern id="SVGID_' + this.id + '" x="' + patternOffsetX + '" y="' + patternOffsetY + '" width="' + patternWidth + '" height="' + patternHeight + '">\n' + '<image x="0" y="0"' + ' width="' + patternSource.width + '" height="' + patternSource.height + '" xlink:href="' + patternImgSrc + '"></image>\n' + "</pattern>\n";
        },
        /* _TO_SVG_END_ */ setOptions: function(options) {
            for(var prop in options)this[prop] = options[prop];
        },
        /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */ toLive: function(ctx) {
            var source = this.source;
            // if the image failed to load, return, and allow rest to continue loading
            if (!source) return "";
            // if an image
            if (typeof source.src !== "undefined") {
                if (!source.complete) return "";
                if (source.naturalWidth === 0 || source.naturalHeight === 0) return "";
            }
            return ctx.createPattern(source, this.repeat);
        }
    });
})();
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), toFixed = fabric.util.toFixed;
    if (fabric.Shadow) {
        fabric.warn("fabric.Shadow is already defined.");
        return;
    }
    /**
   * Shadow class
   * @class fabric.Shadow
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @see {@link fabric.Shadow#initialize} for constructor definition
   */ fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {
        /**
     * Shadow color
     * @type String
     * @default
     */ color: "rgb(0,0,0)",
        /**
     * Shadow blur
     * @type Number
     */ blur: 0,
        /**
     * Shadow horizontal offset
     * @type Number
     * @default
     */ offsetX: 0,
        /**
     * Shadow vertical offset
     * @type Number
     * @default
     */ offsetY: 0,
        /**
     * Whether the shadow should affect stroke operations
     * @type Boolean
     * @default
     */ affectStroke: false,
        /**
     * Indicates whether toObject should include default values
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * When `false`, the shadow will scale with the object.
     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
     * default to false
     * @type Boolean
     * @default
     */ nonScaling: false,
        /**
     * Constructor
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     * @return {fabric.Shadow} thisArg
     */ initialize: function(options) {
            if (typeof options === "string") options = this._parseShadow(options);
            for(var prop in options)this[prop] = options[prop];
            this.id = fabric.Object.__uid++;
        },
        /**
     * @private
     * @param {String} shadow Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */ _parseShadow: function(shadow) {
            var shadowStr = shadow.trim(), offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [], color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, "") || "rgb(0,0,0)";
            return {
                color: color.trim(),
                offsetX: parseFloat(offsetsAndBlur[1], 10) || 0,
                offsetY: parseFloat(offsetsAndBlur[2], 10) || 0,
                blur: parseFloat(offsetsAndBlur[3], 10) || 0
            };
        },
        /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */ toString: function() {
            return [
                this.offsetX,
                this.offsetY,
                this.blur,
                this.color
            ].join("px ");
        },
        /* _TO_SVG_START_ */ /**
     * Returns SVG representation of a shadow
     * @param {fabric.Object} object
     * @return {String} SVG representation of a shadow
     */ toSVG: function(object) {
            var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS, offset = fabric.util.rotateVector({
                x: this.offsetX,
                y: this.offsetY
            }, fabric.util.degreesToRadians(-object.angle)), BLUR_BOX = 20, color = new fabric.Color(this.color);
            if (object.width && object.height) {
                //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
                // we add some extra space to filter box to contain the blur ( 20 )
                fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
                fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            }
            if (object.flipX) offset.x *= -1;
            if (object.flipY) offset.y *= -1;
            return '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' + 'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + ">\n" + '	<feGaussianBlur in="SourceAlpha" stdDeviation="' + toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' + '	<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) + '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' + '	<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' + '	<feComposite in2="oBlur" operator="in" />\n' + "	<feMerge>\n" + "		<feMergeNode></feMergeNode>\n" + '		<feMergeNode in="SourceGraphic"></feMergeNode>\n' + "	</feMerge>\n" + "</filter>\n";
        },
        /* _TO_SVG_END_ */ /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */ toObject: function() {
            if (this.includeDefaultValues) return {
                color: this.color,
                blur: this.blur,
                offsetX: this.offsetX,
                offsetY: this.offsetY,
                affectStroke: this.affectStroke,
                nonScaling: this.nonScaling
            };
            var obj = {}, proto = fabric.Shadow.prototype;
            [
                "color",
                "blur",
                "offsetX",
                "offsetY",
                "affectStroke",
                "nonScaling"
            ].forEach(function(prop) {
                if (this[prop] !== proto[prop]) obj[prop] = this[prop];
            }, this);
            return obj;
        }
    });
    /**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * @static
   * @field
   * @memberOf fabric.Shadow
   */ // eslint-disable-next-line max-len
    fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?(\d+(?:\.\d*)?(?:px)?)?(?:\s?|$)(?:$|\s)/;
})($d47795690082d4de$exports);
(function() {
    "use strict";
    if ($d47795690082d4de$var$fabric.StaticCanvas) {
        $d47795690082d4de$var$fabric.warn("fabric.StaticCanvas is already defined.");
        return;
    }
    // aliases for faster resolution
    var extend = $d47795690082d4de$var$fabric.util.object.extend, getElementOffset = $d47795690082d4de$var$fabric.util.getElementOffset, removeFromArray = $d47795690082d4de$var$fabric.util.removeFromArray, toFixed = $d47795690082d4de$var$fabric.util.toFixed, transformPoint = $d47795690082d4de$var$fabric.util.transformPoint, invertTransform = $d47795690082d4de$var$fabric.util.invertTransform, getNodeCanvas = $d47795690082d4de$var$fabric.util.getNodeCanvas, createCanvasElement = $d47795690082d4de$var$fabric.util.createCanvasElement, CANVAS_INIT_ERROR = new Error("Could not initialize `canvas` element");
    /**
   * Static canvas class
   * @class fabric.StaticCanvas
   * @mixes fabric.Collection
   * @mixes fabric.Observable
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */ $d47795690082d4de$var$fabric.StaticCanvas = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {
        /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(el, options) {
            options || (options = {});
            this.renderAndResetBound = this.renderAndReset.bind(this);
            this.requestRenderAllBound = this.requestRenderAll.bind(this);
            this._initStatic(el, options);
        },
        /**
     * Background color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
     * @type {(String|fabric.Pattern)}
     * @default
     */ backgroundColor: "",
        /**
     * Background image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as background, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */ backgroundImage: null,
        /**
     * Overlay color of canvas instance.
     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
     * @since 1.3.9
     * @type {(String|fabric.Pattern)}
     * @default
     */ overlayColor: "",
        /**
     * Overlay image of canvas instance.
     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
     * vale. As an alternative you can disable image objectCaching
     * @type fabric.Image
     * @default
     */ overlayImage: null,
        /**
     * Indicates whether toObject/toDatalessObject should include default values
     * if set to false, takes precedence over the object value.
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * Indicates whether objects' state should be saved
     * @type Boolean
     * @default
     */ stateful: false,
        /**
     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
     * since the renders are quequed and executed one per frame.
     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
     * Left default to true to do not break documentation and old app, fiddles.
     * @type Boolean
     * @default
     */ renderOnAddRemove: true,
        /**
     * Indicates whether object controls (borders/controls) are rendered above overlay image
     * @type Boolean
     * @default
     */ controlsAboveOverlay: false,
        /**
     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
     * @type Boolean
     * @default
     */ allowTouchScrolling: false,
        /**
     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
     * @type Boolean
     * @default
     */ imageSmoothingEnabled: true,
        /**
     * The transformation (a Canvas 2D API transform matrix) which focuses the viewport
     * @type Array
     * @example <caption>Default transform</caption>
     * canvas.viewportTransform = [1, 0, 0, 1, 0, 0];
     * @example <caption>Scale by 70% and translate toward bottom-right by 50, without skewing</caption>
     * canvas.viewportTransform = [0.7, 0, 0, 0.7, 50, 50];
     * @default
     */ viewportTransform: $d47795690082d4de$var$fabric.iMatrix.concat(),
        /**
     * if set to false background image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */ backgroundVpt: true,
        /**
     * if set to false overlya image is not affected by viewport transform
     * @since 1.6.3
     * @type Boolean
     * @default
     */ overlayVpt: true,
        /**
     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
     * @type Boolean
     * @default
     */ enableRetinaScaling: true,
        /**
     * Describe canvas element extension over design
     * properties are tl,tr,bl,br.
     * if canvas is not zoomed/panned those points are the four corner of canvas
     * if canvas is viewportTransformed you those points indicate the extension
     * of canvas element in plain untrasformed coordinates
     * The coordinates get updated with @method calcViewportBoundaries.
     * @memberOf fabric.StaticCanvas.prototype
     */ vptCoords: {},
        /**
     * Based on vptCoords and object.aCoords, skip rendering of objects that
     * are not included in current viewport.
     * May greatly help in applications with crowded canvas and use of zoom/pan
     * If One of the corner of the bounding box of the object is on the canvas
     * the objects get rendered.
     * @memberOf fabric.StaticCanvas.prototype
     * @type Boolean
     * @default
     */ skipOffscreen: true,
        /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
     * top left corner of the canvas.
     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
     * @type fabric.Object
     */ clipPath: undefined,
        /**
     * @private
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     */ _initStatic: function(el, options) {
            var cb = this.requestRenderAllBound;
            this._objects = [];
            this._createLowerCanvas(el);
            this._initOptions(options);
            // only initialize retina scaling once
            if (!this.interactive) this._initRetinaScaling();
            if (options.overlayImage) this.setOverlayImage(options.overlayImage, cb);
            if (options.backgroundImage) this.setBackgroundImage(options.backgroundImage, cb);
            if (options.backgroundColor) this.setBackgroundColor(options.backgroundColor, cb);
            if (options.overlayColor) this.setOverlayColor(options.overlayColor, cb);
            this.calcOffset();
        },
        /**
     * @private
     */ _isRetinaScaling: function() {
            return $d47795690082d4de$var$fabric.devicePixelRatio > 1 && this.enableRetinaScaling;
        },
        /**
     * @private
     * @return {Number} retinaScaling if applied, otherwise 1;
     */ getRetinaScaling: function() {
            return this._isRetinaScaling() ? Math.max(1, $d47795690082d4de$var$fabric.devicePixelRatio) : 1;
        },
        /**
     * @private
     */ _initRetinaScaling: function() {
            if (!this._isRetinaScaling()) return;
            var scaleRatio = $d47795690082d4de$var$fabric.devicePixelRatio;
            this.__initRetinaScaling(scaleRatio, this.lowerCanvasEl, this.contextContainer);
            if (this.upperCanvasEl) this.__initRetinaScaling(scaleRatio, this.upperCanvasEl, this.contextTop);
        },
        __initRetinaScaling: function(scaleRatio, canvas, context) {
            canvas.setAttribute("width", this.width * scaleRatio);
            canvas.setAttribute("height", this.height * scaleRatio);
            context.scale(scaleRatio, scaleRatio);
        },
        /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     * @return {fabric.Canvas} instance
     * @chainable
     */ calcOffset: function() {
            this._offset = getElementOffset(this.lowerCanvasEl);
            return this;
        },
        /**
     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
     * @example <caption>Normal overlayImage with left/top = 0</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage with different properties</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position overlayImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>overlayImage loaded from cross-origin</caption>
     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */ setOverlayImage: function(image, callback, options) {
            return this.__setBgOverlayImage("overlayImage", image, callback, options);
        },
        /**
     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
     * @param {Function} callback Callback to invoke when image is loaded and set as background
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
     * @example <caption>Normal backgroundImage with left/top = 0</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage with different properties</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img, isError) {
     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
     * });
     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   width: canvas.width,
     *   height: canvas.height,
     *   // Needed to position backgroundImage at 0/0
     *   originX: 'left',
     *   originY: 'top'
     * });
     * @example <caption>backgroundImage loaded from cross-origin</caption>
     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
     *   opacity: 0.5,
     *   angle: 45,
     *   left: 400,
     *   top: 400,
     *   originX: 'left',
     *   originY: 'top',
     *   crossOrigin: 'anonymous'
     * });
     */ // TODO: fix stretched examples
        setBackgroundImage: function(image, callback, options) {
            return this.__setBgOverlayImage("backgroundImage", image, callback, options);
        },
        /**
     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
     * @param {Function} callback Callback to invoke when foreground color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
     * @example <caption>Normal overlayColor - color value</caption>
     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
     * canvas.setOverlayColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */ setOverlayColor: function(overlayColor, callback) {
            return this.__setBgOverlayColor("overlayColor", overlayColor, callback);
        },
        /**
     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
     * @param {Function} callback Callback to invoke when background color is set
     * @return {fabric.Canvas} thisArg
     * @chainable
     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
     * @example <caption>Normal backgroundColor - color value</caption>
     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
     * }, canvas.renderAll.bind(canvas));
     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
     * canvas.setBackgroundColor({
     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
     *   repeat: 'repeat',
     *   offsetX: 200,
     *   offsetY: 100
     * }, canvas.renderAll.bind(canvas));
     */ setBackgroundColor: function(backgroundColor, callback) {
            return this.__setBgOverlayColor("backgroundColor", backgroundColor, callback);
        },
        /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay. The first argument is the created image, the second argument is a flag indicating whether an error occurred or not.
     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
     */ __setBgOverlayImage: function(property, image, callback, options) {
            if (typeof image === "string") $d47795690082d4de$var$fabric.util.loadImage(image, function(img, isError) {
                if (img) {
                    var instance = new $d47795690082d4de$var$fabric.Image(img, options);
                    this[property] = instance;
                    instance.canvas = this;
                }
                callback && callback(img, isError);
            }, this, options && options.crossOrigin);
            else {
                options && image.setOptions(options);
                this[property] = image;
                image && (image.canvas = this);
                callback && callback(image, false);
            }
            return this;
        },
        /**
     * @private
     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
     * @param {(Object|String|null)} color Object with pattern information, color value or null
     * @param {Function} [callback] Callback is invoked when color is set
     */ __setBgOverlayColor: function(property, color, callback) {
            this[property] = color;
            this._initGradient(color, property);
            this._initPattern(color, property, callback);
            return this;
        },
        /**
     * @private
     */ _createCanvasElement: function() {
            var element = createCanvasElement();
            if (!element) throw CANVAS_INIT_ERROR;
            if (!element.style) element.style = {};
            if (typeof element.getContext === "undefined") throw CANVAS_INIT_ERROR;
            return element;
        },
        /**
     * @private
     * @param {Object} [options] Options object
     */ _initOptions: function(options) {
            var lowerCanvasEl = this.lowerCanvasEl;
            this._setOptions(options);
            this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
            this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;
            if (!this.lowerCanvasEl.style) return;
            lowerCanvasEl.width = this.width;
            lowerCanvasEl.height = this.height;
            lowerCanvasEl.style.width = this.width + "px";
            lowerCanvasEl.style.height = this.height + "px";
            this.viewportTransform = this.viewportTransform.slice();
        },
        /**
     * Creates a bottom canvas
     * @private
     * @param {HTMLElement} [canvasEl]
     */ _createLowerCanvas: function(canvasEl) {
            // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
            if (canvasEl && canvasEl.getContext) this.lowerCanvasEl = canvasEl;
            else this.lowerCanvasEl = $d47795690082d4de$var$fabric.util.getById(canvasEl) || this._createCanvasElement();
            $d47795690082d4de$var$fabric.util.addClass(this.lowerCanvasEl, "lower-canvas");
            this._originalCanvasStyle = this.lowerCanvasEl.style;
            if (this.interactive) this._applyCanvasStyle(this.lowerCanvasEl);
            this.contextContainer = this.lowerCanvasEl.getContext("2d");
        },
        /**
     * Returns canvas width (in px)
     * @return {Number}
     */ getWidth: function() {
            return this.width;
        },
        /**
     * Returns canvas height (in px)
     * @return {Number}
     */ getHeight: function() {
            return this.height;
        },
        /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setWidth: function(value, options) {
            return this.setDimensions({
                width: value
            }, options);
        },
        /**
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setHeight: function(value, options) {
            return this.setDimensions({
                height: value
            }, options);
        },
        /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ setDimensions: function(dimensions, options) {
            var cssValue;
            options = options || {};
            for(var prop in dimensions){
                cssValue = dimensions[prop];
                if (!options.cssOnly) {
                    this._setBackstoreDimension(prop, dimensions[prop]);
                    cssValue += "px";
                    this.hasLostContext = true;
                }
                if (!options.backstoreOnly) this._setCssDimension(prop, cssValue);
            }
            if (this._isCurrentlyDrawing) this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
            this._initRetinaScaling();
            this.calcOffset();
            if (!options.cssOnly) this.requestRenderAll();
            return this;
        },
        /**
     * Helper for setting width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {Number} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ _setBackstoreDimension: function(prop, value) {
            this.lowerCanvasEl[prop] = value;
            if (this.upperCanvasEl) this.upperCanvasEl[prop] = value;
            if (this.cacheCanvasEl) this.cacheCanvasEl[prop] = value;
            this[prop] = value;
            return this;
        },
        /**
     * Helper for setting css width/height
     * @private
     * @param {String} prop property (width|height)
     * @param {String} value value to set property to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ _setCssDimension: function(prop, value) {
            this.lowerCanvasEl.style[prop] = value;
            if (this.upperCanvasEl) this.upperCanvasEl.style[prop] = value;
            if (this.wrapperEl) this.wrapperEl.style[prop] = value;
            return this;
        },
        /**
     * Returns canvas zoom level
     * @return {Number}
     */ getZoom: function() {
            return this.viewportTransform[0];
        },
        /**
     * Sets viewport transformation of this canvas instance
     * @param {Array} vpt a Canvas 2D API transform matrix
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setViewportTransform: function(vpt) {
            var activeObject = this._activeObject, backgroundObject = this.backgroundImage, overlayObject = this.overlayImage, object, i, len;
            this.viewportTransform = vpt;
            for(i = 0, len = this._objects.length; i < len; i++){
                object = this._objects[i];
                object.group || object.setCoords(true);
            }
            if (activeObject) activeObject.setCoords();
            if (backgroundObject) backgroundObject.setCoords(true);
            if (overlayObject) overlayObject.setCoords(true);
            this.calcViewportBoundaries();
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Sets zoom level of this canvas instance, the zoom centered around point
     * meaning that following zoom to point with the same point will have the visual
     * effect of the zoom originating from that point. The point won't move.
     * It has nothing to do with canvas center or visual center of the viewport.
     * @param {fabric.Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */ zoomToPoint: function(point, value) {
            // TODO: just change the scale, preserve other transformations
            var before = point, vpt = this.viewportTransform.slice(0);
            point = transformPoint(point, invertTransform(this.viewportTransform));
            vpt[0] = value;
            vpt[3] = value;
            var after = transformPoint(point, vpt);
            vpt[4] += before.x - after.x;
            vpt[5] += before.y - after.y;
            return this.setViewportTransform(vpt);
        },
        /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     * @return {fabric.Canvas} instance
     * @chainable true
     */ setZoom: function(value) {
            this.zoomToPoint(new $d47795690082d4de$var$fabric.Point(0, 0), value);
            return this;
        },
        /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {fabric.Point} point to move to
     * @return {fabric.Canvas} instance
     * @chainable true
     */ absolutePan: function(point) {
            var vpt = this.viewportTransform.slice(0);
            vpt[4] = -point.x;
            vpt[5] = -point.y;
            return this.setViewportTransform(vpt);
        },
        /**
     * Pans viewpoint relatively
     * @param {fabric.Point} point (position vector) to move by
     * @return {fabric.Canvas} instance
     * @chainable true
     */ relativePan: function(point) {
            return this.absolutePan(new $d47795690082d4de$var$fabric.Point(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
        },
        /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */ getElement: function() {
            return this.lowerCanvasEl;
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was added
     */ _onObjectAdded: function(obj) {
            this.stateful && obj.setupState();
            obj._set("canvas", this);
            obj.setCoords();
            this.fire("object:added", {
                target: obj
            });
            obj.fire("added");
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */ _onObjectRemoved: function(obj) {
            this.fire("object:removed", {
                target: obj
            });
            obj.fire("removed");
            delete obj.canvas;
        },
        /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clearContext: function(ctx) {
            ctx.clearRect(0, 0, this.width, this.height);
            return this;
        },
        /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */ getContext: function() {
            return this.contextContainer;
        },
        /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clear: function() {
            this.remove.apply(this, this.getObjects());
            this.backgroundImage = null;
            this.overlayImage = null;
            this.backgroundColor = "";
            this.overlayColor = "";
            if (this._hasITextHandlers) {
                this.off("mouse:up", this._mouseUpITextHandler);
                this._iTextInstances = null;
                this._hasITextHandlers = false;
            }
            this.clearContext(this.contextContainer);
            this.fire("canvas:cleared");
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Renders the canvas
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAll: function() {
            var canvasToDrawOn = this.contextContainer;
            this.renderCanvas(canvasToDrawOn, this._objects);
            return this;
        },
        /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAndReset: function() {
            this.isRendering = 0;
            this.renderAll();
        },
        /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     * @return {fabric.Canvas} instance
     * @chainable
     */ requestRenderAll: function() {
            if (!this.isRendering) this.isRendering = $d47795690082d4de$var$fabric.util.requestAnimFrame(this.renderAndResetBound);
            return this;
        },
        /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport using
     * object absolute coordinates ( aCoords )
     * @return {Object} points.tl
     * @chainable
     */ calcViewportBoundaries: function() {
            var points = {}, width = this.width, height = this.height, iVpt = invertTransform(this.viewportTransform);
            points.tl = transformPoint({
                x: 0,
                y: 0
            }, iVpt);
            points.br = transformPoint({
                x: width,
                y: height
            }, iVpt);
            points.tr = new $d47795690082d4de$var$fabric.Point(points.br.x, points.tl.y);
            points.bl = new $d47795690082d4de$var$fabric.Point(points.tl.x, points.br.y);
            this.vptCoords = points;
            return points;
        },
        cancelRequestedRender: function() {
            if (this.isRendering) {
                $d47795690082d4de$var$fabric.util.cancelAnimFrame(this.isRendering);
                this.isRendering = 0;
            }
        },
        /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderCanvas: function(ctx, objects) {
            var v = this.viewportTransform, path = this.clipPath;
            this.cancelRequestedRender();
            this.calcViewportBoundaries();
            this.clearContext(ctx);
            $d47795690082d4de$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothingEnabled);
            this.fire("before:render", {
                ctx: ctx
            });
            this._renderBackground(ctx);
            ctx.save();
            //apply viewport transform once for all rendering process
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            this._renderObjects(ctx, objects);
            ctx.restore();
            if (!this.controlsAboveOverlay && this.interactive) this.drawControls(ctx);
            if (path) {
                path.canvas = this;
                // needed to setup a couple of variables
                path.shouldCache();
                path._transformDone = true;
                path.renderCache({
                    forClipping: true
                });
                this.drawClipPathOnCanvas(ctx);
            }
            this._renderOverlay(ctx);
            if (this.controlsAboveOverlay && this.interactive) this.drawControls(ctx);
            this.fire("after:render", {
                ctx: ctx
            });
        },
        /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawClipPathOnCanvas: function(ctx) {
            var v = this.viewportTransform, path = this.clipPath;
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            // DEBUG: uncomment this line, comment the following
            // ctx.globalAlpha = 0.4;
            ctx.globalCompositeOperation = "destination-in";
            path.transform(ctx);
            ctx.scale(1 / path.zoomX, 1 / path.zoomY);
            ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */ _renderObjects: function(ctx, objects) {
            var i, len;
            for(i = 0, len = objects.length; i < len; ++i)objects[i] && objects[i].render(ctx);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */ _renderBackgroundOrOverlay: function(ctx, property) {
            var fill = this[property + "Color"], object = this[property + "Image"], v = this.viewportTransform, needsVpt = this[property + "Vpt"];
            if (!fill && !object) return;
            if (fill) {
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(this.width, 0);
                ctx.lineTo(this.width, this.height);
                ctx.lineTo(0, this.height);
                ctx.closePath();
                ctx.fillStyle = fill.toLive ? fill.toLive(ctx, this) : fill;
                if (needsVpt) ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
                ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
                var m = fill.gradientTransform || fill.patternTransform;
                m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
                ctx.fill();
                ctx.restore();
            }
            if (object) {
                ctx.save();
                if (needsVpt) ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
                object.render(ctx);
                ctx.restore();
            }
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderBackground: function(ctx) {
            this._renderBackgroundOrOverlay(ctx, "background");
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderOverlay: function(ctx) {
            this._renderBackgroundOrOverlay(ctx, "overlay");
        },
        /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     * @deprecated migrate to `getCenterPoint`
     */ getCenter: function() {
            return {
                top: this.height / 2,
                left: this.width / 2
            };
        },
        /**
     * Returns coordinates of a center of canvas.
     * @return {fabric.Point} 
     */ getCenterPoint: function() {
            return new $d47795690082d4de$var$fabric.Point(this.width / 2, this.height / 2);
        },
        /**
     * Centers object horizontally in the canvas
     * @param {fabric.Object} object Object to center horizontally
     * @return {fabric.Canvas} thisArg
     */ centerObjectH: function(object) {
            return this._centerObject(object, new $d47795690082d4de$var$fabric.Point(this.getCenterPoint().x, object.getCenterPoint().y));
        },
        /**
     * Centers object vertically in the canvas
     * @param {fabric.Object} object Object to center vertically
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ centerObjectV: function(object) {
            return this._centerObject(object, new $d47795690082d4de$var$fabric.Point(object.getCenterPoint().x, this.getCenterPoint().y));
        },
        /**
     * Centers object vertically and horizontally in the canvas
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ centerObject: function(object) {
            var center = this.getCenterPoint();
            return this._centerObject(object, center);
        },
        /**
     * Centers object vertically and horizontally in the viewport
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObject: function(object) {
            var vpCenter = this.getVpCenter();
            return this._centerObject(object, vpCenter);
        },
        /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObjectH: function(object) {
            var vpCenter = this.getVpCenter();
            this._centerObject(object, new $d47795690082d4de$var$fabric.Point(vpCenter.x, object.getCenterPoint().y));
            return this;
        },
        /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {fabric.Object} object Object to center vertically and horizontally
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ viewportCenterObjectV: function(object) {
            var vpCenter = this.getVpCenter();
            return this._centerObject(object, new $d47795690082d4de$var$fabric.Point(object.getCenterPoint().x, vpCenter.y));
        },
        /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {fabric.Point} vpCenter, viewport center
     * @chainable
     */ getVpCenter: function() {
            var center = this.getCenterPoint(), iVpt = invertTransform(this.viewportTransform);
            return transformPoint(center, iVpt);
        },
        /**
     * @private
     * @param {fabric.Object} object Object to center
     * @param {fabric.Point} center Center point
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ _centerObject: function(object, center) {
            object.setPositionByOrigin(center, "center", "center");
            object.setCoords();
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Returns dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */ toDatalessJSON: function(propertiesToInclude) {
            return this.toDatalessObject(propertiesToInclude);
        },
        /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this._toObjectMethod("toObject", propertiesToInclude);
        },
        /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            return this._toObjectMethod("toDatalessObject", propertiesToInclude);
        },
        /**
     * @private
     */ _toObjectMethod: function(methodName, propertiesToInclude) {
            var clipPath = this.clipPath, data = {
                version: $d47795690082d4de$var$fabric.version,
                objects: this._toObjects(methodName, propertiesToInclude)
            };
            if (clipPath && !clipPath.excludeFromExport) data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
            extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));
            $d47795690082d4de$var$fabric.util.populateWithProperties(this, data, propertiesToInclude);
            return data;
        },
        /**
     * @private
     */ _toObjects: function(methodName, propertiesToInclude) {
            return this._objects.filter(function(object) {
                return !object.excludeFromExport;
            }).map(function(instance) {
                return this._toObject(instance, methodName, propertiesToInclude);
            }, this);
        },
        /**
     * @private
     */ _toObject: function(instance, methodName, propertiesToInclude) {
            var originalValue;
            if (!this.includeDefaultValues) {
                originalValue = instance.includeDefaultValues;
                instance.includeDefaultValues = false;
            }
            var object = instance[methodName](propertiesToInclude);
            if (!this.includeDefaultValues) instance.includeDefaultValues = originalValue;
            return object;
        },
        /**
     * @private
     */ __serializeBgOverlay: function(methodName, propertiesToInclude) {
            var data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
            if (bgColor && bgColor.toObject) {
                if (!bgColor.excludeFromExport) data.background = bgColor.toObject(propertiesToInclude);
            } else if (bgColor) data.background = bgColor;
            if (overlayColor && overlayColor.toObject) {
                if (!overlayColor.excludeFromExport) data.overlay = overlayColor.toObject(propertiesToInclude);
            } else if (overlayColor) data.overlay = overlayColor;
            if (bgImage && !bgImage.excludeFromExport) data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
            if (overlayImage && !overlayImage.excludeFromExport) data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
            return data;
        },
        /* _TO_SVG_START_ */ /**
     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
     * a zoomed canvas will then produce zoomed SVG output.
     * @type Boolean
     * @default
     */ svgViewportTransformation: true,
        /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-coordinate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */ toSVG: function(options, reviver) {
            options || (options = {});
            options.reviver = reviver;
            var markup = [];
            this._setSVGPreamble(markup, options);
            this._setSVGHeader(markup, options);
            if (this.clipPath) markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
            this._setSVGBgOverlayColor(markup, "background");
            this._setSVGBgOverlayImage(markup, "backgroundImage", reviver);
            this._setSVGObjects(markup, reviver);
            if (this.clipPath) markup.push("</g>\n");
            this._setSVGBgOverlayColor(markup, "overlay");
            this._setSVGBgOverlayImage(markup, "overlayImage", reviver);
            markup.push("</svg>");
            return markup.join("");
        },
        /**
     * @private
     */ _setSVGPreamble: function(markup, options) {
            if (options.suppressPreamble) return;
            markup.push('<?xml version="1.0" encoding="', options.encoding || "UTF-8", '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
        },
        /**
     * @private
     */ _setSVGHeader: function(markup, options) {
            var width = options.width || this.width, height = options.height || this.height, vpt, viewBox = 'viewBox="0 0 ' + this.width + " " + this.height + '" ', NUM_FRACTION_DIGITS = $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS;
            if (options.viewBox) viewBox = 'viewBox="' + options.viewBox.x + " " + options.viewBox.y + " " + options.viewBox.width + " " + options.viewBox.height + '" ';
            else if (this.svgViewportTransformation) {
                vpt = this.viewportTransform;
                viewBox = 'viewBox="' + toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + " " + toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + " " + toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + " " + toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
            }
            markup.push("<svg ", 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', "<desc>Created with Fabric.js ", $d47795690082d4de$var$fabric.version, "</desc>\n", "<defs>\n", this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), "</defs>\n");
        },
        createSVGClipPathMarkup: function(options) {
            var clipPath = this.clipPath;
            if (clipPath) {
                clipPath.clipPathId = "CLIPPATH_" + $d47795690082d4de$var$fabric.Object.__uid++;
                return '<clipPath id="' + clipPath.clipPathId + '" >\n' + this.clipPath.toClipPathSVG(options.reviver) + "</clipPath>\n";
            }
            return "";
        },
        /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */ createSVGRefElementsMarkup: function() {
            var _this = this, markup = [
                "background",
                "overlay"
            ].map(function(prop) {
                var fill = _this[prop + "Color"];
                if (fill && fill.toLive) {
                    var shouldTransform = _this[prop + "Vpt"], vpt = _this.viewportTransform, object = {
                        width: _this.width / (shouldTransform ? vpt[0] : 1),
                        height: _this.height / (shouldTransform ? vpt[3] : 1)
                    };
                    return fill.toSVG(object, {
                        additionalTransform: shouldTransform ? $d47795690082d4de$var$fabric.util.matrixToSVG(vpt) : ""
                    });
                }
            });
            return markup.join("");
        },
        /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */ createSVGFontFacesMarkup: function() {
            var markup = "", fontList = {}, obj, fontFamily, style, row, rowIndex, _char, charIndex, i, len, fontPaths = $d47795690082d4de$var$fabric.fontPaths, objects = [];
            this._objects.forEach(function add(object) {
                objects.push(object);
                if (object._objects) object._objects.forEach(add);
            });
            for(i = 0, len = objects.length; i < len; i++){
                obj = objects[i];
                fontFamily = obj.fontFamily;
                if (obj.type.indexOf("text") === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) continue;
                fontList[fontFamily] = true;
                if (!obj.styles) continue;
                style = obj.styles;
                for(rowIndex in style){
                    row = style[rowIndex];
                    for(charIndex in row){
                        _char = row[charIndex];
                        fontFamily = _char.fontFamily;
                        if (!fontList[fontFamily] && fontPaths[fontFamily]) fontList[fontFamily] = true;
                    }
                }
            }
            for(var j in fontList)markup += [
                "		@font-face {\n",
                "			font-family: '",
                j,
                "';\n",
                "			src: url('",
                fontPaths[j],
                "');\n",
                "		}\n"
            ].join("");
            if (markup) markup = [
                '	<style type="text/css">',
                "<![CDATA[\n",
                markup,
                "]]>",
                "</style>\n"
            ].join("");
            return markup;
        },
        /**
     * @private
     */ _setSVGObjects: function(markup, reviver) {
            var instance, i, len, objects = this._objects;
            for(i = 0, len = objects.length; i < len; i++){
                instance = objects[i];
                if (instance.excludeFromExport) continue;
                this._setSVGObject(markup, instance, reviver);
            }
        },
        /**
     * @private
     */ _setSVGObject: function(markup, instance, reviver) {
            markup.push(instance.toSVG(reviver));
        },
        /**
     * @private
     */ _setSVGBgOverlayImage: function(markup, property, reviver) {
            if (this[property] && !this[property].excludeFromExport && this[property].toSVG) markup.push(this[property].toSVG(reviver));
        },
        /**
     * @private
     */ _setSVGBgOverlayColor: function(markup, property) {
            var filler = this[property + "Color"], vpt = this.viewportTransform, finalWidth = this.width, finalHeight = this.height;
            if (!filler) return;
            if (filler.toLive) {
                var repeat = filler.repeat, iVpt = $d47795690082d4de$var$fabric.util.invertTransform(vpt), shouldInvert = this[property + "Vpt"], additionalTransform = shouldInvert ? $d47795690082d4de$var$fabric.util.matrixToSVG(iVpt) : "";
                markup.push('<rect transform="' + additionalTransform + " translate(", finalWidth / 2, ",", finalHeight / 2, ')"', ' x="', filler.offsetX - finalWidth / 2, '" y="', filler.offsetY - finalHeight / 2, '" ', 'width="', repeat === "repeat-y" || repeat === "no-repeat" ? filler.source.width : finalWidth, '" height="', repeat === "repeat-x" || repeat === "no-repeat" ? filler.source.height : finalHeight, '" fill="url(#SVGID_' + filler.id + ')"', "></rect>\n");
            } else markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', "></rect>\n");
        },
        /* _TO_SVG_END_ */ /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ sendToBack: function(object) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, objs;
            if (object === activeSelection && object.type === "activeSelection") {
                objs = activeSelection._objects;
                for(i = objs.length; i--;){
                    obj = objs[i];
                    removeFromArray(this._objects, obj);
                    this._objects.unshift(obj);
                }
            } else {
                removeFromArray(this._objects, object);
                this._objects.unshift(object);
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ bringToFront: function(object) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, objs;
            if (object === activeSelection && object.type === "activeSelection") {
                objs = activeSelection._objects;
                for(i = 0; i < objs.length; i++){
                    obj = objs[i];
                    removeFromArray(this._objects, obj);
                    this._objects.push(obj);
                }
            } else {
                removeFromArray(this._objects, object);
                this._objects.push(object);
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ sendBackwards: function(object, intersecting) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
            if (object === activeSelection && object.type === "activeSelection") {
                objs = activeSelection._objects;
                for(i = 0; i < objs.length; i++){
                    obj = objs[i];
                    idx = this._objects.indexOf(obj);
                    if (idx > 0 + objsMoved) {
                        newIdx = idx - 1;
                        removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                    objsMoved++;
                }
            } else {
                idx = this._objects.indexOf(object);
                if (idx !== 0) {
                    // if object is not on the bottom of stack
                    newIdx = this._findNewLowerIndex(object, idx, intersecting);
                    removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * @private
     */ _findNewLowerIndex: function(object, idx, intersecting) {
            var newIdx, i;
            if (intersecting) {
                newIdx = idx;
                // traverse down the stack looking for the nearest intersecting object
                for(i = idx - 1; i >= 0; --i){
                    var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
                    if (isIntersecting) {
                        newIdx = i;
                        break;
                    }
                }
            } else newIdx = idx - 1;
            return newIdx;
        },
        /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ bringForward: function(object, intersecting) {
            if (!object) return this;
            var activeSelection = this._activeObject, i, obj, idx, newIdx, objs, objsMoved = 0;
            if (object === activeSelection && object.type === "activeSelection") {
                objs = activeSelection._objects;
                for(i = objs.length; i--;){
                    obj = objs[i];
                    idx = this._objects.indexOf(obj);
                    if (idx < this._objects.length - 1 - objsMoved) {
                        newIdx = idx + 1;
                        removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                    objsMoved++;
                }
            } else {
                idx = this._objects.indexOf(object);
                if (idx !== this._objects.length - 1) {
                    // if object is not on top of stack (last item in an array)
                    newIdx = this._findNewUpperIndex(object, idx, intersecting);
                    removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }
            this.renderOnAddRemove && this.requestRenderAll();
            return this;
        },
        /**
     * @private
     */ _findNewUpperIndex: function(object, idx, intersecting) {
            var newIdx, i, len;
            if (intersecting) {
                newIdx = idx;
                // traverse up the stack looking for the nearest intersecting object
                for(i = idx + 1, len = this._objects.length; i < len; ++i){
                    var isIntersecting = object.intersectsWithObject(this._objects[i]) || object.isContainedWithinObject(this._objects[i]) || this._objects[i].isContainedWithinObject(object);
                    if (isIntersecting) {
                        newIdx = i;
                        break;
                    }
                }
            } else newIdx = idx + 1;
            return newIdx;
        },
        /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {Number} index Position to move to
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ moveTo: function(object, index) {
            removeFromArray(this._objects, object);
            this._objects.splice(index, 0, object);
            return this.renderOnAddRemove && this.requestRenderAll();
        },
        /**
     * Clears a canvas element and dispose objects
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ dispose: function() {
            // cancel eventually ongoing renders
            if (this.isRendering) {
                $d47795690082d4de$var$fabric.util.cancelAnimFrame(this.isRendering);
                this.isRendering = 0;
            }
            this.forEachObject(function(object) {
                object.dispose && object.dispose();
            });
            this._objects = [];
            if (this.backgroundImage && this.backgroundImage.dispose) this.backgroundImage.dispose();
            this.backgroundImage = null;
            if (this.overlayImage && this.overlayImage.dispose) this.overlayImage.dispose();
            this.overlayImage = null;
            this._iTextInstances = null;
            this.contextContainer = null;
            // restore canvas style
            this.lowerCanvasEl.classList.remove("lower-canvas");
            $d47795690082d4de$var$fabric.util.setStyle(this.lowerCanvasEl, this._originalCanvasStyle);
            delete this._originalCanvasStyle;
            // restore canvas size to original size in case retina scaling was applied
            this.lowerCanvasEl.setAttribute("width", this.width);
            this.lowerCanvasEl.setAttribute("height", this.height);
            $d47795690082d4de$var$fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
            this.lowerCanvasEl = undefined;
            return this;
        },
        /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */ toString: function() {
            return "#<fabric.Canvas (" + this.complexity() + "): " + "{ objects: " + this._objects.length + " }>";
        }
    });
    extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, $d47795690082d4de$var$fabric.Observable);
    extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, $d47795690082d4de$var$fabric.Collection);
    extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, $d47795690082d4de$var$fabric.DataURLExporter);
    extend($d47795690082d4de$var$fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {
        /**
     * @static
     * @type String
     * @default
     */ EMPTY_JSON: '{"objects": [], "background": "white"}',
        /**
     * Provides a way to check support of some of the canvas methods
     * (either those of HTMLCanvasElement itself, or rendering context)
     *
     * @param {String} methodName Method to check support for;
     *                            Could be one of "setLineDash"
     * @return {Boolean | null} `true` if method is supported (or at least exists),
     *                          `null` if canvas element or context can not be initialized
     */ supports: function(methodName) {
            var el = createCanvasElement();
            if (!el || !el.getContext) return null;
            var ctx = el.getContext("2d");
            if (!ctx) return null;
            switch(methodName){
                case "setLineDash":
                    return typeof ctx.setLineDash !== "undefined";
                default:
                    return null;
            }
        }
    });
    /**
   * Returns Object representation of canvas
   * this alias is provided because if you call JSON.stringify on an instance,
   * the toJSON object will be invoked if it exists.
   * Having a toJSON method means you can do JSON.stringify(myCanvas)
   * @function
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} JSON compatible object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * canvas.includeDefaultValues = false;
   * var json = canvas.toJSON();
   */ $d47795690082d4de$var$fabric.StaticCanvas.prototype.toJSON = $d47795690082d4de$var$fabric.StaticCanvas.prototype.toObject;
    if ($d47795690082d4de$var$fabric.isLikelyNode) {
        $d47795690082d4de$var$fabric.StaticCanvas.prototype.createPNGStream = function() {
            var impl = getNodeCanvas(this.lowerCanvasEl);
            return impl && impl.createPNGStream();
        };
        $d47795690082d4de$var$fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
            var impl = getNodeCanvas(this.lowerCanvasEl);
            return impl && impl.createJPEGStream(opts);
        };
    }
})();
/**
 * BaseBrush class
 * @class fabric.BaseBrush
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */ $d47795690082d4de$var$fabric.BaseBrush = $d47795690082d4de$var$fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {
    /**
   * Color of a brush
   * @type String
   * @default
   */ color: "rgb(0, 0, 0)",
    /**
   * Width of a brush, has to be a Number, no string literals
   * @type Number
   * @default
   */ width: 1,
    /**
   * Shadow object representing shadow of this shape.
   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
   * @type fabric.Shadow
   * @default
   */ shadow: null,
    /**
   * Line endings style of a brush (one of "butt", "round", "square")
   * @type String
   * @default
   */ strokeLineCap: "round",
    /**
   * Corner style of a brush (one of "bevel", "round", "miter")
   * @type String
   * @default
   */ strokeLineJoin: "round",
    /**
   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
   * @type Number
   * @default
   */ strokeMiterLimit: 10,
    /**
   * Stroke Dash Array.
   * @type Array
   * @default
   */ strokeDashArray: null,
    /**
   * When `true`, the free drawing is limited to the whiteboard size. Default to false.
   * @type Boolean
   * @default false
  */ limitedToCanvasSize: false,
    /**
   * Sets brush styles
   * @private
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles: function(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
    },
    /**
   * Sets the transformation on given context
   * @param {RenderingContext2d} ctx context to render on
   * @private
   */ _saveAndTransform: function(ctx) {
        var v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    },
    /**
   * Sets brush shadow styles
   * @private
   */ _setShadow: function() {
        if (!this.shadow) return;
        var canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom();
        if (canvas && canvas._isRetinaScaling()) zoom *= $d47795690082d4de$var$fabric.devicePixelRatio;
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
    },
    needsFullRender: function() {
        var color = new $d47795690082d4de$var$fabric.Color(this.color);
        return color.getAlpha() < 1 || !!this.shadow;
    },
    /**
   * Removes brush shadow styles
   * @private
   */ _resetShadow: function() {
        var ctx = this.canvas.contextTop;
        ctx.shadowColor = "";
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    },
    /**
   * Check is pointer is outside canvas boundaries
   * @param {Object} pointer
   * @private
  */ _isOutSideCanvas: function(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
});
(function() {
    /**
   * PencilBrush class
   * @class fabric.PencilBrush
   * @extends fabric.BaseBrush
   */ $d47795690082d4de$var$fabric.PencilBrush = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {
        /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */ decimate: 0.4,
        /**
     * Draws a straight line between last recorded point to current pointer
     * Used for `shift` functionality
     *
     * @type boolean
     * @default false
     */ drawStraightLine: false,
        /**
     * The event modifier key that makes the brush draw a straight line.
     * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
     * @type {'altKey' | 'shiftKey' | 'ctrlKey' | 'none' | undefined | null}
     */ straightLineKey: "shiftKey",
        /**
     * Constructor
     * @param {fabric.Canvas} canvas
     * @return {fabric.PencilBrush} Instance of a pencil brush
     */ initialize: function(canvas) {
            this.canvas = canvas;
            this._points = [];
        },
        needsFullRender: function() {
            return this.callSuper("needsFullRender") || this._hasStraightLine;
        },
        /**
     * Invoked inside on mouse down and mouse move
     * @param {Object} pointer
     */ _drawSegment: function(ctx, p1, p2) {
            var midPoint = p1.midPointFrom(p2);
            ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
            return midPoint;
        },
        /**
     * Invoked on mouse down
     * @param {Object} pointer
     */ onMouseDown: function(pointer, options) {
            if (!this.canvas._isMainEvent(options.e)) return;
            this.drawStraightLine = options.e[this.straightLineKey];
            this._prepareForDrawing(pointer);
            // capture coordinates immediately
            // this allows to draw dots (when movement never occurs)
            this._captureDrawingPath(pointer);
            this._render();
        },
        /**
     * Invoked on mouse move
     * @param {Object} pointer
     */ onMouseMove: function(pointer, options) {
            if (!this.canvas._isMainEvent(options.e)) return;
            this.drawStraightLine = options.e[this.straightLineKey];
            if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
            if (this._captureDrawingPath(pointer) && this._points.length > 1) {
                if (this.needsFullRender()) {
                    // redraw curve
                    // clear top canvas
                    this.canvas.clearContext(this.canvas.contextTop);
                    this._render();
                } else {
                    var points = this._points, length = points.length, ctx = this.canvas.contextTop;
                    // draw the curve update
                    this._saveAndTransform(ctx);
                    if (this.oldEnd) {
                        ctx.beginPath();
                        ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                    }
                    this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
                    ctx.stroke();
                    ctx.restore();
                }
            }
        },
        /**
     * Invoked on mouse up
     */ onMouseUp: function(options) {
            if (!this.canvas._isMainEvent(options.e)) return true;
            this.drawStraightLine = false;
            this.oldEnd = undefined;
            this._finalizeAndAddPath();
            return false;
        },
        /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */ _prepareForDrawing: function(pointer) {
            var p = new $d47795690082d4de$var$fabric.Point(pointer.x, pointer.y);
            this._reset();
            this._addPoint(p);
            this.canvas.contextTop.moveTo(p.x, p.y);
        },
        /**
     * @private
     * @param {fabric.Point} point Point to be added to points array
     */ _addPoint: function(point) {
            if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) return false;
            if (this.drawStraightLine && this._points.length > 1) {
                this._hasStraightLine = true;
                this._points.pop();
            }
            this._points.push(point);
            return true;
        },
        /**
     * Clear points array and set contextTop canvas style.
     * @private
     */ _reset: function() {
            this._points = [];
            this._setBrushStyles(this.canvas.contextTop);
            this._setShadow();
            this._hasStraightLine = false;
        },
        /**
     * @private
     * @param {Object} pointer Actual mouse position related to the canvas.
     */ _captureDrawingPath: function(pointer) {
            var pointerPoint = new $d47795690082d4de$var$fabric.Point(pointer.x, pointer.y);
            return this._addPoint(pointerPoint);
        },
        /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     * @param {CanvasRenderingContext2D} [ctx]
     */ _render: function(ctx) {
            var i, len, p1 = this._points[0], p2 = this._points[1];
            ctx = ctx || this.canvas.contextTop;
            this._saveAndTransform(ctx);
            ctx.beginPath();
            //if we only have 2 points in the path and they are the same
            //it means that the user only clicked the canvas without moving the mouse
            //then we should be drawing a dot. A path isn't drawn between two identical dots
            //that's why we set them apart a bit
            if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
                var width = this.width / 1000;
                p1 = new $d47795690082d4de$var$fabric.Point(p1.x, p1.y);
                p2 = new $d47795690082d4de$var$fabric.Point(p2.x, p2.y);
                p1.x -= width;
                p2.x += width;
            }
            ctx.moveTo(p1.x, p1.y);
            for(i = 1, len = this._points.length; i < len; i++){
                // we pick the point between pi + 1 & pi + 2 as the
                // end point and p1 as our control point.
                this._drawSegment(ctx, p1, p2);
                p1 = this._points[i];
                p2 = this._points[i + 1];
            }
            // Draw last line as a straight line while
            // we wait for the next point to be able to calculate
            // the bezier control point
            ctx.lineTo(p1.x, p1.y);
            ctx.stroke();
            ctx.restore();
        },
        /**
     * Converts points to SVG path
     * @param {Array} points Array of points
     * @return {(string|number)[][]} SVG path commands
     */ convertPointsToSVGPath: function(points) {
            var correction = this.width / 1000;
            return $d47795690082d4de$var$fabric.util.getSmoothPathFromPoints(points, correction);
        },
        /**
     * @private
     * @param {(string|number)[][]} pathData SVG path commands
     * @returns {boolean}
     */ _isEmptySVGPath: function(pathData) {
            var pathString = $d47795690082d4de$var$fabric.util.joinPath(pathData);
            return pathString === "M 0 0 Q 0 0 0 0 L 0 0";
        },
        /**
     * Creates fabric.Path object to add on canvas
     * @param {(string|number)[][]} pathData Path data
     * @return {fabric.Path} Path to add on canvas
     */ createPath: function(pathData) {
            var path = new $d47795690082d4de$var$fabric.Path(pathData, {
                fill: null,
                stroke: this.color,
                strokeWidth: this.width,
                strokeLineCap: this.strokeLineCap,
                strokeMiterLimit: this.strokeMiterLimit,
                strokeLineJoin: this.strokeLineJoin,
                strokeDashArray: this.strokeDashArray
            });
            if (this.shadow) {
                this.shadow.affectStroke = true;
                path.shadow = new $d47795690082d4de$var$fabric.Shadow(this.shadow);
            }
            return path;
        },
        /**
     * Decimate points array with the decimate value
     */ decimatePoints: function(points, distance) {
            if (points.length <= 2) return points;
            var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), i, l = points.length - 1, lastPoint = points[0], newPoints = [
                lastPoint
            ], cDistance;
            for(i = 1; i < l - 1; i++){
                cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
                if (cDistance >= adjustedDistance) {
                    lastPoint = points[i];
                    newPoints.push(lastPoint);
                }
            }
            /**
       * Add the last point from the original line to the end of the array.
       * This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
       */ newPoints.push(points[l]);
            return newPoints;
        },
        /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new fabric path object
     * and add it to the fabric canvas.
     */ _finalizeAndAddPath: function() {
            var ctx = this.canvas.contextTop;
            ctx.closePath();
            if (this.decimate) this._points = this.decimatePoints(this._points, this.decimate);
            var pathData = this.convertPointsToSVGPath(this._points);
            if (this._isEmptySVGPath(pathData)) {
                // do not create 0 width/height paths, as they are
                // rendered inconsistently across browsers
                // Firefox 4, for example, renders a dot,
                // whereas Chrome 10 renders nothing
                this.canvas.requestRenderAll();
                return;
            }
            var path = this.createPath(pathData);
            this.canvas.clearContext(this.canvas.contextTop);
            this.canvas.fire("before:path:created", {
                path: path
            });
            this.canvas.add(path);
            this.canvas.requestRenderAll();
            path.setCoords();
            this._resetShadow();
            // fire event 'path' created
            this.canvas.fire("path:created", {
                path: path
            });
        }
    });
})();
/**
 * CircleBrush class
 * @class fabric.CircleBrush
 */ $d47795690082d4de$var$fabric.CircleBrush = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {
    /**
   * Width of a brush
   * @type Number
   * @default
   */ width: 10,
    /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.CircleBrush} Instance of a circle brush
   */ initialize: function(canvas) {
        this.canvas = canvas;
        this.points = [];
    },
    /**
   * Invoked inside on mouse down and mouse move
   * @param {Object} pointer
   */ drawDot: function(pointer) {
        var point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
    },
    dot: function(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
    },
    /**
   * Invoked on mouse down
   */ onMouseDown: function(pointer) {
        this.points.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
    },
    /**
   * Render the full state of the brush
   * @private
   */ _render: function() {
        var ctx = this.canvas.contextTop, i, len, points = this.points;
        this._saveAndTransform(ctx);
        for(i = 0, len = points.length; i < len; i++)this.dot(ctx, points[i]);
        ctx.restore();
    },
    /**
   * Invoked on mouse move
   * @param {Object} pointer
   */ onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this.needsFullRender()) {
            this.canvas.clearContext(this.canvas.contextTop);
            this.addPoint(pointer);
            this._render();
        } else this.drawDot(pointer);
    },
    /**
   * Invoked on mouse up
   */ onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
        this.canvas.renderOnAddRemove = false;
        var circles = [];
        for(i = 0, len = this.points.length; i < len; i++){
            var point = this.points[i], circle = new $d47795690082d4de$var$fabric.Circle({
                radius: point.radius,
                left: point.x,
                top: point.y,
                originX: "center",
                originY: "center",
                fill: point.fill
            });
            this.shadow && (circle.shadow = new $d47795690082d4de$var$fabric.Shadow(this.shadow));
            circles.push(circle);
        }
        var group = new $d47795690082d4de$var$fabric.Group(circles);
        group.canvas = this.canvas;
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    },
    /**
   * @param {Object} pointer
   * @return {fabric.Point} Just added pointer point
   */ addPoint: function(pointer) {
        var pointerPoint = new $d47795690082d4de$var$fabric.Point(pointer.x, pointer.y), circleRadius = $d47795690082d4de$var$fabric.util.getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2, circleColor = new $d47795690082d4de$var$fabric.Color(this.color).setAlpha($d47795690082d4de$var$fabric.util.getRandomInt(0, 100) / 100).toRgba();
        pointerPoint.radius = circleRadius;
        pointerPoint.fill = circleColor;
        this.points.push(pointerPoint);
        return pointerPoint;
    }
});
/**
 * SprayBrush class
 * @class fabric.SprayBrush
 */ $d47795690082d4de$var$fabric.SprayBrush = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {
    /**
   * Width of a spray
   * @type Number
   * @default
   */ width: 10,
    /**
   * Density of a spray (number of dots per chunk)
   * @type Number
   * @default
   */ density: 20,
    /**
   * Width of spray dots
   * @type Number
   * @default
   */ dotWidth: 1,
    /**
   * Width variance of spray dots
   * @type Number
   * @default
   */ dotWidthVariance: 1,
    /**
   * Whether opacity of a dot should be random
   * @type Boolean
   * @default
   */ randomOpacity: false,
    /**
   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
   * @type Boolean
   * @default
   */ optimizeOverlapping: true,
    /**
   * Constructor
   * @param {fabric.Canvas} canvas
   * @return {fabric.SprayBrush} Instance of a spray brush
   */ initialize: function(canvas) {
        this.canvas = canvas;
        this.sprayChunks = [];
    },
    /**
   * Invoked on mouse down
   * @param {Object} pointer
   */ onMouseDown: function(pointer) {
        this.sprayChunks.length = 0;
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
    },
    /**
   * Invoked on mouse move
   * @param {Object} pointer
   */ onMouseMove: function(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        this.addSprayChunk(pointer);
        this.render(this.sprayChunkPoints);
    },
    /**
   * Invoked on mouse up
   */ onMouseUp: function() {
        var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        var rects = [];
        for(var i = 0, ilen = this.sprayChunks.length; i < ilen; i++){
            var sprayChunk = this.sprayChunks[i];
            for(var j = 0, jlen = sprayChunk.length; j < jlen; j++){
                var rect = new $d47795690082d4de$var$fabric.Rect({
                    width: sprayChunk[j].width,
                    height: sprayChunk[j].width,
                    left: sprayChunk[j].x + 1,
                    top: sprayChunk[j].y + 1,
                    originX: "center",
                    originY: "center",
                    fill: this.color
                });
                rects.push(rect);
            }
        }
        if (this.optimizeOverlapping) rects = this._getOptimizedRects(rects);
        var group = new $d47795690082d4de$var$fabric.Group(rects);
        this.shadow && group.set("shadow", new $d47795690082d4de$var$fabric.Shadow(this.shadow));
        this.canvas.fire("before:path:created", {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire("path:created", {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    },
    /**
   * @private
   * @param {Array} rects
   */ _getOptimizedRects: function(rects) {
        // avoid creating duplicate rects at the same coordinates
        var uniqueRects = {}, key, i, len;
        for(i = 0, len = rects.length; i < len; i++){
            key = rects[i].left + "" + rects[i].top;
            if (!uniqueRects[key]) uniqueRects[key] = rects[i];
        }
        var uniqueRectsArray = [];
        for(key in uniqueRects)uniqueRectsArray.push(uniqueRects[key]);
        return uniqueRectsArray;
    },
    /**
   * Render new chunk of spray brush
   */ render: function(sprayChunk) {
        var ctx = this.canvas.contextTop, i, len;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(i = 0, len = sprayChunk.length; i < len; i++){
            var point = sprayChunk[i];
            if (typeof point.opacity !== "undefined") ctx.globalAlpha = point.opacity;
            ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
    },
    /**
   * Render all spray chunks
   */ _render: function() {
        var ctx = this.canvas.contextTop, i, ilen;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(i = 0, ilen = this.sprayChunks.length; i < ilen; i++)this.render(this.sprayChunks[i]);
        ctx.restore();
    },
    /**
   * @param {Object} pointer
   */ addSprayChunk: function(pointer) {
        this.sprayChunkPoints = [];
        var x, y, width, radius = this.width / 2, i;
        for(i = 0; i < this.density; i++){
            x = $d47795690082d4de$var$fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
            y = $d47795690082d4de$var$fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);
            if (this.dotWidthVariance) width = $d47795690082d4de$var$fabric.util.getRandomInt(// bottom clamp width to 1
            Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance);
            else width = this.dotWidth;
            var point = new $d47795690082d4de$var$fabric.Point(x, y);
            point.width = width;
            if (this.randomOpacity) point.opacity = $d47795690082d4de$var$fabric.util.getRandomInt(0, 100) / 100;
            this.sprayChunkPoints.push(point);
        }
        this.sprayChunks.push(this.sprayChunkPoints);
    }
});
/**
 * PatternBrush class
 * @class fabric.PatternBrush
 * @extends fabric.BaseBrush
 */ $d47795690082d4de$var$fabric.PatternBrush = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {
    getPatternSrc: function() {
        var dotWidth = 20, dotDistance = 5, patternCanvas = $d47795690082d4de$var$fabric.util.createCanvasElement(), patternCtx = patternCanvas.getContext("2d");
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        patternCtx.fillStyle = this.color;
        patternCtx.beginPath();
        patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
        patternCtx.closePath();
        patternCtx.fill();
        return patternCanvas;
    },
    getPatternSrcFunction: function() {
        return String(this.getPatternSrc).replace("this.color", '"' + this.color + '"');
    },
    /**
   * Creates "pattern" instance property
   * @param {CanvasRenderingContext2D} ctx
   */ getPattern: function(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), "repeat");
    },
    /**
   * Sets brush styles
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles: function(ctx) {
        this.callSuper("_setBrushStyles", ctx);
        ctx.strokeStyle = this.getPattern(ctx);
    },
    /**
   * Creates path
   */ createPath: function(pathData) {
        var path = this.callSuper("createPath", pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new $d47795690082d4de$var$fabric.Pattern({
            source: this.source || this.getPatternSrcFunction(),
            offsetX: -topLeft.x,
            offsetY: -topLeft.y
        });
        return path;
    }
});
(function() {
    var getPointer = $d47795690082d4de$var$fabric.util.getPointer, degreesToRadians = $d47795690082d4de$var$fabric.util.degreesToRadians, isTouchEvent = $d47795690082d4de$var$fabric.util.isTouchEvent;
    /**
   * Canvas class
   * @class fabric.Canvas
   * @extends fabric.StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   * @see {@link fabric.Canvas#initialize} for constructor definition
   *
   * @fires object:modified at the end of a transform or any change when statefull is true
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop:before before drop event. same native event. This is added to handle edge cases
   * @fires drop
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   */ $d47795690082d4de$var$fabric.Canvas = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {
        /**
     * Constructor
     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(el, options) {
            options || (options = {});
            this.renderAndResetBound = this.renderAndReset.bind(this);
            this.requestRenderAllBound = this.requestRenderAll.bind(this);
            this._initStatic(el, options);
            this._initInteractive();
            this._createCacheCanvas();
        },
        /**
     * When true, objects can be transformed by one side (unproportionally)
     * when dragged on the corners that normally would not do that.
     * @type Boolean
     * @default
     * @since fabric 4.0 // changed name and default value
     */ uniformScaling: true,
        /**
     * Indicates which key switches uniform scaling.
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * totally wrong named. this sounds like `uniform scaling`
     * if Canvas.uniformScaling is true, pressing this will set it to false
     * and viceversa.
     * @since 1.6.2
     * @type String
     * @default
     */ uniScaleKey: "shiftKey",
        /**
     * When true, objects use center point as the origin of scale transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredScaling: false,
        /**
     * When true, objects use center point as the origin of rotate transformation.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredRotation: false,
        /**
     * Indicates which key enable centered Transform
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */ centeredKey: "altKey",
        /**
     * Indicates which key enable alternate action on corner
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled feature disabled.
     * @since 1.6.2
     * @type String
     * @default
     */ altActionKey: "shiftKey",
        /**
     * Indicates that canvas is interactive. This property should not be changed.
     * @type Boolean
     * @default
     */ interactive: true,
        /**
     * Indicates whether group selection should be enabled
     * @type Boolean
     * @default
     */ selection: true,
        /**
     * Indicates which key or keys enable multiple click selection
     * Pass value as a string or array of strings
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * If `null` or empty or containing any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.2
     * @type String|Array
     * @default
     */ selectionKey: "shiftKey",
        /**
     * Indicates which key enable alternative selection
     * in case of target overlapping with active object
     * values: 'altKey', 'shiftKey', 'ctrlKey'.
     * For a series of reason that come from the general expectations on how
     * things should work, this feature works only for preserveObjectStacking true.
     * If `null` or 'none' or any other string that is not a modifier key
     * feature is disabled.
     * @since 1.6.5
     * @type null|String
     * @default
     */ altSelectionKey: null,
        /**
     * Color of selection
     * @type String
     * @default
     */ selectionColor: "rgba(100, 100, 255, 0.3)",
        /**
     * Default dash array pattern
     * If not empty the selection border is dashed
     * @type Array
     */ selectionDashArray: [],
        /**
     * Color of the border of selection (usually slightly darker than color of selection itself)
     * @type String
     * @default
     */ selectionBorderColor: "rgba(255, 255, 255, 0.3)",
        /**
     * Width of a line used in object/group selection
     * @type Number
     * @default
     */ selectionLineWidth: 1,
        /**
     * Select only shapes that are fully contained in the dragged selection rectangle.
     * @type Boolean
     * @default
     */ selectionFullyContained: false,
        /**
     * Default cursor value used when hovering over an object on canvas
     * @type String
     * @default
     */ hoverCursor: "move",
        /**
     * Default cursor value used when moving an object on canvas
     * @type String
     * @default
     */ moveCursor: "move",
        /**
     * Default cursor value used for the entire canvas
     * @type String
     * @default
     */ defaultCursor: "default",
        /**
     * Cursor value used during free drawing
     * @type String
     * @default
     */ freeDrawingCursor: "crosshair",
        /**
     * Cursor value used for disabled elements ( corners with disabled action )
     * @type String
     * @since 2.0.0
     * @default
     */ notAllowedCursor: "not-allowed",
        /**
     * Default element class that's given to wrapper (div) element of canvas
     * @type String
     * @default
     */ containerClass: "canvas-container",
        /**
     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
     * @type Boolean
     * @default
     */ perPixelTargetFind: false,
        /**
     * Number of pixels around target pixel to tolerate (consider active) during object detection
     * @type Number
     * @default
     */ targetFindTolerance: 0,
        /**
     * When true, target detection is skipped. Target detection will return always undefined.
     * click selection won't work anymore, events will fire with no targets.
     * if something is selected before setting it to true, it will be deselected at the first click.
     * area selection will still work. check the `selection` property too.
     * if you deactivate both, you should look into staticCanvas.
     * @type Boolean
     * @default
     */ skipTargetFind: false,
        /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */ isDrawingMode: false,
        /**
     * Indicates whether objects should remain in current stack position when selected.
     * When false objects are brought to top and rendered as part of the selection group
     * @type Boolean
     * @default
     */ preserveObjectStacking: false,
        /**
     * Indicates the angle that an object will lock to while rotating.
     * @type Number
     * @since 1.6.7
     * @default
     */ snapAngle: 0,
        /**
     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
     * When `null`, the snapThreshold will default to the snapAngle.
     * @type null|Number
     * @since 1.6.7
     * @default
     */ snapThreshold: null,
        /**
     * Indicates if the right click on canvas can output the context menu or not
     * @type Boolean
     * @since 1.6.5
     * @default
     */ stopContextMenu: false,
        /**
     * Indicates if the canvas can fire right click events
     * @type Boolean
     * @since 1.6.5
     * @default
     */ fireRightClick: false,
        /**
     * Indicates if the canvas can fire middle click events
     * @type Boolean
     * @since 1.7.8
     * @default
     */ fireMiddleClick: false,
        /**
     * Keep track of the subTargets for Mouse Events
     * @type fabric.Object[]
     */ targets: [],
        /**
     * When the option is enabled, PointerEvent is used instead of MouseEvent.
     * @type Boolean
     * @default
     */ enablePointerEvents: false,
        /**
     * Keep track of the hovered target
     * @type fabric.Object
     * @private
     */ _hoveredTarget: null,
        /**
     * hold the list of nested targets hovered
     * @type fabric.Object[]
     * @private
     */ _hoveredTargets: [],
        /**
     * @private
     */ _initInteractive: function() {
            this._currentTransform = null;
            this._groupSelector = null;
            this._initWrapperElement();
            this._createUpperCanvas();
            this._initEventListeners();
            this._initRetinaScaling();
            this.freeDrawingBrush = $d47795690082d4de$var$fabric.PencilBrush && new $d47795690082d4de$var$fabric.PencilBrush(this);
            this.calcOffset();
        },
        /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */ _chooseObjectsToRender: function() {
            var activeObjects = this.getActiveObjects(), object, objsToRender, activeGroupObjects;
            if (activeObjects.length > 0 && !this.preserveObjectStacking) {
                objsToRender = [];
                activeGroupObjects = [];
                for(var i = 0, length = this._objects.length; i < length; i++){
                    object = this._objects[i];
                    if (activeObjects.indexOf(object) === -1) objsToRender.push(object);
                    else activeGroupObjects.push(object);
                }
                if (activeObjects.length > 1) this._activeObject._objects = activeGroupObjects;
                objsToRender.push.apply(objsToRender, activeGroupObjects);
            } else objsToRender = this._objects;
            return objsToRender;
        },
        /**
     * Renders both the top canvas and the secondary container canvas.
     * @return {fabric.Canvas} instance
     * @chainable
     */ renderAll: function() {
            if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
                this.clearContext(this.contextTop);
                this.contextTopDirty = false;
            }
            if (this.hasLostContext) {
                this.renderTopLayer(this.contextTop);
                this.hasLostContext = false;
            }
            var canvasToDrawOn = this.contextContainer;
            this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
            return this;
        },
        renderTopLayer: function(ctx) {
            ctx.save();
            if (this.isDrawingMode && this._isCurrentlyDrawing) {
                this.freeDrawingBrush && this.freeDrawingBrush._render();
                this.contextTopDirty = true;
            }
            // we render the top context - last object
            if (this.selection && this._groupSelector) {
                this._drawSelection(ctx);
                this.contextTopDirty = true;
            }
            ctx.restore();
        },
        /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ renderTop: function() {
            var ctx = this.contextTop;
            this.clearContext(ctx);
            this.renderTopLayer(ctx);
            this.fire("after:render");
            return this;
        },
        /**
     * @private
     */ _normalizePointer: function(object, pointer) {
            var m = object.calcTransformMatrix(), invertedM = $d47795690082d4de$var$fabric.util.invertTransform(m), vptPointer = this.restorePointerVpt(pointer);
            return $d47795690082d4de$var$fabric.util.transformPoint(vptPointer, invertedM);
        },
        /**
     * Returns true if object is transparent at a certain location
     * @param {fabric.Object} target Object to check
     * @param {Number} x Left coordinate
     * @param {Number} y Top coordinate
     * @return {Boolean}
     */ isTargetTransparent: function(target, x, y) {
            // in case the target is the activeObject, we cannot execute this optimization
            // because we need to draw controls too.
            if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
                var normalizedPointer = this._normalizePointer(target, {
                    x: x,
                    y: y
                }), targetRelativeX = Math.max(target.cacheTranslationX + normalizedPointer.x * target.zoomX, 0), targetRelativeY = Math.max(target.cacheTranslationY + normalizedPointer.y * target.zoomY, 0);
                var isTransparent = $d47795690082d4de$var$fabric.util.isTransparent(target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);
                return isTransparent;
            }
            var ctx = this.contextCache, originalColor = target.selectionBackgroundColor, v = this.viewportTransform;
            target.selectionBackgroundColor = "";
            this.clearContext(ctx);
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            target.render(ctx);
            ctx.restore();
            target.selectionBackgroundColor = originalColor;
            var isTransparent = $d47795690082d4de$var$fabric.util.isTransparent(ctx, x, y, this.targetFindTolerance);
            return isTransparent;
        },
        /**
     * takes an event and determines if selection key has been pressed
     * @private
     * @param {Event} e Event object
     */ _isSelectionKeyPressed: function(e) {
            var selectionKeyPressed = false;
            if (Array.isArray(this.selectionKey)) selectionKeyPressed = !!this.selectionKey.find(function(key) {
                return e[key] === true;
            });
            else selectionKeyPressed = e[this.selectionKey];
            return selectionKeyPressed;
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _shouldClearSelection: function(e, target) {
            var activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
            return !target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target;
        },
        /**
     * centeredScaling from object can't override centeredScaling from canvas.
     * this should be fixed, since object setting should take precedence over canvas.
     * also this should be something that will be migrated in the control properties.
     * as ability to define the origin of the transformation that the control provide.
     * @private
     * @param {fabric.Object} target
     * @param {String} action
     * @param {Boolean} altKey
     */ _shouldCenterTransform: function(target, action, altKey) {
            if (!target) return;
            var centerTransform;
            if (action === "scale" || action === "scaleX" || action === "scaleY" || action === "resizing") centerTransform = this.centeredScaling || target.centeredScaling;
            else if (action === "rotate") centerTransform = this.centeredRotation || target.centeredRotation;
            return centerTransform ? !altKey : altKey;
        },
        /**
     * should disappear before release 4.0
     * @private
     */ _getOriginFromCorner: function(target, corner) {
            var origin = {
                x: target.originX,
                y: target.originY
            };
            if (corner === "ml" || corner === "tl" || corner === "bl") origin.x = "right";
            else if (corner === "mr" || corner === "tr" || corner === "br") origin.x = "left";
            if (corner === "tl" || corner === "mt" || corner === "tr") origin.y = "bottom";
            else if (corner === "bl" || corner === "mb" || corner === "br") origin.y = "top";
            return origin;
        },
        /**
     * @private
     * @param {Boolean} alreadySelected true if target is already selected
     * @param {String} corner a string representing the corner ml, mr, tl ...
     * @param {Event} e Event object
     * @param {fabric.Object} [target] inserted back to help overriding. Unused
     */ _getActionFromCorner: function(alreadySelected, corner, e, target) {
            if (!corner || !alreadySelected) return "drag";
            var control = target.controls[corner];
            return control.getActionName(e, control, target);
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _setupCurrentTransform: function(e, target, alreadySelected) {
            if (!target) return;
            var pointer = this.getPointer(e), corner = target.__corner, control = target.controls[corner], actionHandler = alreadySelected && corner ? control.getActionHandler(e, target, control) : $d47795690082d4de$var$fabric.controlsUtils.dragHandler, action = this._getActionFromCorner(alreadySelected, corner, e, target), origin = this._getOriginFromCorner(target, corner), altKey = e[this.centeredKey], transform = {
                target: target,
                action: action,
                actionHandler: actionHandler,
                corner: corner,
                scaleX: target.scaleX,
                scaleY: target.scaleY,
                skewX: target.skewX,
                skewY: target.skewY,
                // used by transation
                offsetX: pointer.x - target.left,
                offsetY: pointer.y - target.top,
                originX: origin.x,
                originY: origin.y,
                ex: pointer.x,
                ey: pointer.y,
                lastX: pointer.x,
                lastY: pointer.y,
                // unsure they are useful anymore.
                // left: target.left,
                // top: target.top,
                theta: degreesToRadians(target.angle),
                // end of unsure
                width: target.width * target.scaleX,
                shiftKey: e.shiftKey,
                altKey: altKey,
                original: $d47795690082d4de$var$fabric.util.saveObjectTransform(target)
            };
            if (this._shouldCenterTransform(target, action, altKey)) {
                transform.originX = "center";
                transform.originY = "center";
            }
            transform.original.originX = origin.x;
            transform.original.originY = origin.y;
            this._currentTransform = transform;
            this._beforeTransform(e);
        },
        /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */ setCursor: function(value) {
            this.upperCanvasEl.style.cursor = value;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */ _drawSelection: function(ctx) {
            var selector = this._groupSelector, viewportStart = new $d47795690082d4de$var$fabric.Point(selector.ex, selector.ey), start = $d47795690082d4de$var$fabric.util.transformPoint(viewportStart, this.viewportTransform), viewportExtent = new $d47795690082d4de$var$fabric.Point(selector.ex + selector.left, selector.ey + selector.top), extent = $d47795690082d4de$var$fabric.util.transformPoint(viewportExtent, this.viewportTransform), minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y), strokeOffset = this.selectionLineWidth / 2;
            if (this.selectionColor) {
                ctx.fillStyle = this.selectionColor;
                ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
            }
            if (!this.selectionLineWidth || !this.selectionBorderColor) return;
            ctx.lineWidth = this.selectionLineWidth;
            ctx.strokeStyle = this.selectionBorderColor;
            minX += strokeOffset;
            minY += strokeOffset;
            maxX -= strokeOffset;
            maxY -= strokeOffset;
            // selection border
            $d47795690082d4de$var$fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
            ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
        },
        /**
     * Method that determines what object we are clicking on
     * the skipGroup parameter is for internal use, is needed for shift+click action
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
     * @return {fabric.Object} the target found
     */ findTarget: function(e, skipGroup) {
            if (this.skipTargetFind) return;
            var ignoreZoom = true, pointer = this.getPointer(e, ignoreZoom), activeObject = this._activeObject, aObjects = this.getActiveObjects(), activeTarget, activeTargetSubs, isTouch = isTouchEvent(e), shouldLookForActive = aObjects.length > 1 && !skipGroup || aObjects.length === 1;
            // first check current group (if one exists)
            // active group does not check sub targets like normal groups.
            // if active group just exits.
            this.targets = [];
            // if we hit the corner of an activeObject, let's return that.
            if (shouldLookForActive && activeObject._findTargetCorner(pointer, isTouch)) return activeObject;
            if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([
                activeObject
            ], pointer)) return activeObject;
            if (aObjects.length === 1 && activeObject === this._searchPossibleTargets([
                activeObject
            ], pointer)) {
                if (!this.preserveObjectStacking) return activeObject;
                else {
                    activeTarget = activeObject;
                    activeTargetSubs = this.targets;
                    this.targets = [];
                }
            }
            var target = this._searchPossibleTargets(this._objects, pointer);
            if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
                target = activeTarget;
                this.targets = activeTargetSubs;
            }
            return target;
        },
        /**
     * Checks point is inside the object.
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @param {fabric.Object} obj Object to test against
     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */ _checkTarget: function(pointer, obj, globalPointer) {
            if (obj && obj.visible && obj.evented && // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
            // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
            obj.containsPoint(pointer)) {
                if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
                    var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
                    if (!isTransparent) return true;
                } else return true;
            }
        },
        /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {fabric.Object} object that contains pointer
     * @private
     */ _searchPossibleTargets: function(objects, pointer) {
            // Cache all targets where their bounding box contains point.
            var target, i = objects.length, subTarget;
            // Do not check for currently grouped objects, since we check the parent group itself.
            // until we call this function specifically to search inside the activeGroup
            while(i--){
                var objToCheck = objects[i];
                var pointerToUse = objToCheck.group ? this._normalizePointer(objToCheck.group, pointer) : pointer;
                if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
                    target = objects[i];
                    if (target.subTargetCheck && target instanceof $d47795690082d4de$var$fabric.Group) {
                        subTarget = this._searchPossibleTargets(target._objects, pointer);
                        subTarget && this.targets.push(subTarget);
                    }
                    break;
                }
            }
            return target;
        },
        /**
     * Returns pointer coordinates without the effect of the viewport
     * @param {Object} pointer with "x" and "y" number values
     * @return {Object} object with "x" and "y" number values
     */ restorePointerVpt: function(pointer) {
            return $d47795690082d4de$var$fabric.util.transformPoint(pointer, $d47795690082d4de$var$fabric.util.invertTransform(this.viewportTransform));
        },
        /**
     * Returns pointer coordinates relative to canvas.
     * Can return coordinates with or without viewportTransform.
     * ignoreZoom false gives back coordinates that represent
     * the point clicked on canvas element.
     * ignoreZoom true gives back coordinates after being processed
     * by the viewportTransform ( sort of coordinates of what is displayed
     * on the canvas where you are clicking.
     * ignoreZoom true = HTMLElement coordinates relative to top,left
     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
     * To interact with your shapes top and left you want to use ignoreZoom true
     * most of the time, while ignoreZoom false will give you coordinates
     * compatible with the object.oCoords system.
     * of the time.
     * @param {Event} e
     * @param {Boolean} ignoreZoom
     * @return {Object} object with "x" and "y" number values
     */ getPointer: function(e, ignoreZoom) {
            // return cached values if we are in the event processing chain
            if (this._absolutePointer && !ignoreZoom) return this._absolutePointer;
            if (this._pointer && ignoreZoom) return this._pointer;
            var pointer = getPointer(e), upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect(), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0, cssScale;
            if (!boundsWidth || !boundsHeight) {
                if ("top" in bounds && "bottom" in bounds) boundsHeight = Math.abs(bounds.top - bounds.bottom);
                if ("right" in bounds && "left" in bounds) boundsWidth = Math.abs(bounds.right - bounds.left);
            }
            this.calcOffset();
            pointer.x = pointer.x - this._offset.left;
            pointer.y = pointer.y - this._offset.top;
            if (!ignoreZoom) pointer = this.restorePointerVpt(pointer);
            var retinaScaling = this.getRetinaScaling();
            if (retinaScaling !== 1) {
                pointer.x /= retinaScaling;
                pointer.y /= retinaScaling;
            }
            if (boundsWidth === 0 || boundsHeight === 0) // If bounds are not available (i.e. not visible), do not apply scale.
            cssScale = {
                width: 1,
                height: 1
            };
            else cssScale = {
                width: upperCanvasEl.width / boundsWidth,
                height: upperCanvasEl.height / boundsHeight
            };
            return {
                x: pointer.x * cssScale.width,
                y: pointer.y * cssScale.height
            };
        },
        /**
     * @private
     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
     */ _createUpperCanvas: function() {
            var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ""), lowerCanvasEl = this.lowerCanvasEl, upperCanvasEl = this.upperCanvasEl;
            // there is no need to create a new upperCanvas element if we have already one.
            if (upperCanvasEl) upperCanvasEl.className = "";
            else {
                upperCanvasEl = this._createCanvasElement();
                this.upperCanvasEl = upperCanvasEl;
            }
            $d47795690082d4de$var$fabric.util.addClass(upperCanvasEl, "upper-canvas " + lowerCanvasClass);
            this.wrapperEl.appendChild(upperCanvasEl);
            this._copyCanvasStyle(lowerCanvasEl, upperCanvasEl);
            this._applyCanvasStyle(upperCanvasEl);
            this.contextTop = upperCanvasEl.getContext("2d");
        },
        /**
     * Returns context of top canvas where interactions are drawn
     * @returns {CanvasRenderingContext2D}
     */ getTopContext: function() {
            return this.contextTop;
        },
        /**
     * @private
     */ _createCacheCanvas: function() {
            this.cacheCanvasEl = this._createCanvasElement();
            this.cacheCanvasEl.setAttribute("width", this.width);
            this.cacheCanvasEl.setAttribute("height", this.height);
            this.contextCache = this.cacheCanvasEl.getContext("2d");
        },
        /**
     * @private
     */ _initWrapperElement: function() {
            this.wrapperEl = $d47795690082d4de$var$fabric.util.wrapElement(this.lowerCanvasEl, "div", {
                "class": this.containerClass
            });
            $d47795690082d4de$var$fabric.util.setStyle(this.wrapperEl, {
                width: this.width + "px",
                height: this.height + "px",
                position: "relative"
            });
            $d47795690082d4de$var$fabric.util.makeElementUnselectable(this.wrapperEl);
        },
        /**
     * @private
     * @param {HTMLElement} element canvas element to apply styles on
     */ _applyCanvasStyle: function(element) {
            var width = this.width || element.width, height = this.height || element.height;
            $d47795690082d4de$var$fabric.util.setStyle(element, {
                position: "absolute",
                width: width + "px",
                height: height + "px",
                left: 0,
                top: 0,
                "touch-action": this.allowTouchScrolling ? "manipulation" : "none",
                "-ms-touch-action": this.allowTouchScrolling ? "manipulation" : "none"
            });
            element.width = width;
            element.height = height;
            $d47795690082d4de$var$fabric.util.makeElementUnselectable(element);
        },
        /**
     * Copy the entire inline style from one element (fromEl) to another (toEl)
     * @private
     * @param {Element} fromEl Element style is copied from
     * @param {Element} toEl Element copied style is applied to
     */ _copyCanvasStyle: function(fromEl, toEl) {
            toEl.style.cssText = fromEl.style.cssText;
        },
        /**
     * Returns context of canvas where object selection is drawn
     * @return {CanvasRenderingContext2D}
     */ getSelectionContext: function() {
            return this.contextTop;
        },
        /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */ getSelectionElement: function() {
            return this.upperCanvasEl;
        },
        /**
     * Returns currently active object
     * @return {fabric.Object} active object
     */ getActiveObject: function() {
            return this._activeObject;
        },
        /**
     * Returns an array with the current selected objects
     * @return {fabric.Object} active object
     */ getActiveObjects: function() {
            var active = this._activeObject;
            if (active) {
                if (active.type === "activeSelection" && active._objects) return active._objects.slice(0);
                else return [
                    active
                ];
            }
            return [];
        },
        /**
     * @private
     * @param {fabric.Object} obj Object that was removed
     */ _onObjectRemoved: function(obj) {
            // removing active object should fire "selection:cleared" events
            if (obj === this._activeObject) {
                this.fire("before:selection:cleared", {
                    target: obj
                });
                this._discardActiveObject();
                this.fire("selection:cleared", {
                    target: obj
                });
                obj.fire("deselected");
            }
            if (obj === this._hoveredTarget) {
                this._hoveredTarget = null;
                this._hoveredTargets = [];
            }
            this.callSuper("_onObjectRemoved", obj);
        },
        /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {fabric.Object} obj old activeObject
     */ _fireSelectionEvents: function(oldObjects, e) {
            var somethingChanged = false, objects = this.getActiveObjects(), added = [], removed = [];
            oldObjects.forEach(function(oldObject) {
                if (objects.indexOf(oldObject) === -1) {
                    somethingChanged = true;
                    oldObject.fire("deselected", {
                        e: e,
                        target: oldObject
                    });
                    removed.push(oldObject);
                }
            });
            objects.forEach(function(object) {
                if (oldObjects.indexOf(object) === -1) {
                    somethingChanged = true;
                    object.fire("selected", {
                        e: e,
                        target: object
                    });
                    added.push(object);
                }
            });
            if (oldObjects.length > 0 && objects.length > 0) somethingChanged && this.fire("selection:updated", {
                e: e,
                selected: added,
                deselected: removed
            });
            else if (objects.length > 0) this.fire("selection:created", {
                e: e,
                selected: added
            });
            else if (oldObjects.length > 0) this.fire("selection:cleared", {
                e: e,
                deselected: removed
            });
        },
        /**
     * Sets given object as the only active object on canvas
     * @param {fabric.Object} object Object to set as an active one
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ setActiveObject: function(object, e) {
            var currentActives = this.getActiveObjects();
            this._setActiveObject(object, e);
            this._fireSelectionEvents(currentActives, e);
            return this;
        },
        /**
     * This is a private method for now.
     * This is supposed to be equivalent to setActiveObject but without firing
     * any event. There is commitment to have this stay this way.
     * This is the functional part of setActiveObject.
     * @private
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the selection happened
     */ _setActiveObject: function(object, e) {
            if (this._activeObject === object) return false;
            if (!this._discardActiveObject(e, object)) return false;
            if (object.onSelect({
                e: e
            })) return false;
            this._activeObject = object;
            return true;
        },
        /**
     * This is a private method for now.
     * This is supposed to be equivalent to discardActiveObject but without firing
     * any events. There is commitment to have this stay this way.
     * This is the functional part of discardActiveObject.
     * @param {Event} [e] Event (passed along when firing "object:deselected")
     * @param {Object} object to set as active
     * @return {Boolean} true if the selection happened
     * @private
     */ _discardActiveObject: function(e, object) {
            var obj = this._activeObject;
            if (obj) {
                // onDeselect return TRUE to cancel selection;
                if (obj.onDeselect({
                    e: e,
                    object: object
                })) return false;
                this._activeObject = null;
            }
            return true;
        },
        /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ discardActiveObject: function(e) {
            var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
            if (currentActives.length) this.fire("before:selection:cleared", {
                target: activeObject,
                e: e
            });
            this._discardActiveObject(e);
            this._fireSelectionEvents(currentActives, e);
            return this;
        },
        /**
     * Clears a canvas element and removes all event listeners
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ dispose: function() {
            var wrapper = this.wrapperEl;
            this.removeListeners();
            wrapper.removeChild(this.upperCanvasEl);
            wrapper.removeChild(this.lowerCanvasEl);
            this.contextCache = null;
            this.contextTop = null;
            [
                "upperCanvasEl",
                "cacheCanvasEl"
            ].forEach((function(element) {
                $d47795690082d4de$var$fabric.util.cleanUpJsdomNode(this[element]);
                this[element] = undefined;
            }).bind(this));
            if (wrapper.parentNode) wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
            delete this.wrapperEl;
            $d47795690082d4de$var$fabric.StaticCanvas.prototype.dispose.call(this);
            return this;
        },
        /**
     * Clears all contexts (background, main, top) of an instance
     * @return {fabric.Canvas} thisArg
     * @chainable
     */ clear: function() {
            // this.discardActiveGroup();
            this.discardActiveObject();
            this.clearContext(this.contextTop);
            return this.callSuper("clear");
        },
        /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */ drawControls: function(ctx) {
            var activeObject = this._activeObject;
            if (activeObject) activeObject._renderControls(ctx);
        },
        /**
     * @private
     */ _toObject: function(instance, methodName, propertiesToInclude) {
            //If the object is part of the current selection group, it should
            //be transformed appropriately
            //i.e. it should be serialised as it would appear if the selection group
            //were to be destroyed.
            var originalProperties = this._realizeGroupTransformOnObject(instance), object = this.callSuper("_toObject", instance, methodName, propertiesToInclude);
            //Undo the damage we did by changing all of its properties
            this._unwindGroupTransformOnObject(instance, originalProperties);
            return object;
        },
        /**
     * Realises an object's group transformation on it
     * @private
     * @param {fabric.Object} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */ _realizeGroupTransformOnObject: function(instance) {
            if (instance.group && instance.group.type === "activeSelection" && this._activeObject === instance.group) {
                var layoutProps = [
                    "angle",
                    "flipX",
                    "flipY",
                    "left",
                    "scaleX",
                    "scaleY",
                    "skewX",
                    "skewY",
                    "top"
                ];
                //Copy all the positionally relevant properties across now
                var originalValues = {};
                layoutProps.forEach(function(prop) {
                    originalValues[prop] = instance[prop];
                });
                $d47795690082d4de$var$fabric.util.addTransformToObject(instance, this._activeObject.calcOwnMatrix());
                return originalValues;
            } else return null;
        },
        /**
     * Restores the changed properties of instance
     * @private
     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
     */ _unwindGroupTransformOnObject: function(instance, originalValues) {
            if (originalValues) instance.set(originalValues);
        },
        /**
     * @private
     */ _setSVGObject: function(markup, instance, reviver) {
            //If the object is in a selection group, simulate what would happen to that
            //object when the group is deselected
            var originalProperties = this._realizeGroupTransformOnObject(instance);
            this.callSuper("_setSVGObject", markup, instance, reviver);
            this._unwindGroupTransformOnObject(instance, originalProperties);
        },
        setViewportTransform: function(vpt) {
            if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) this._activeObject.clearContextTop();
            $d47795690082d4de$var$fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
        }
    });
    // copying static properties manually to work around Opera's bug,
    // where "prototype" property is enumerable and overrides existing prototype
    for(var prop in $d47795690082d4de$var$fabric.StaticCanvas)if (prop !== "prototype") $d47795690082d4de$var$fabric.Canvas[prop] = $d47795690082d4de$var$fabric.StaticCanvas[prop];
})();
(function() {
    var addListener = $d47795690082d4de$var$fabric.util.addListener, removeListener = $d47795690082d4de$var$fabric.util.removeListener, RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1, addEventOptions = {
        passive: false
    };
    function checkClick(e, value) {
        return e.button && e.button === value - 1;
    }
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
        /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */ mainTouchId: null,
        /**
     * Adds mouse listeners to canvas
     * @private
     */ _initEventListeners: function() {
            // in case we initialized the class twice. This should not happen normally
            // but in some kind of applications where the canvas element may be changed
            // this is a workaround to having double listeners.
            this.removeListeners();
            this._bindEvents();
            this.addOrRemove(addListener, "add");
        },
        /**
     * return an event prefix pointer or mouse.
     * @private
     */ _getEventPrefix: function() {
            return this.enablePointerEvents ? "pointer" : "mouse";
        },
        addOrRemove: function(functor, eventjsFunctor) {
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            functor($d47795690082d4de$var$fabric.window, "resize", this._onResize);
            functor(canvasElement, eventTypePrefix + "down", this._onMouseDown);
            functor(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
            functor(canvasElement, eventTypePrefix + "out", this._onMouseOut);
            functor(canvasElement, eventTypePrefix + "enter", this._onMouseEnter);
            functor(canvasElement, "wheel", this._onMouseWheel);
            functor(canvasElement, "contextmenu", this._onContextMenu);
            functor(canvasElement, "dblclick", this._onDoubleClick);
            functor(canvasElement, "dragover", this._onDragOver);
            functor(canvasElement, "dragenter", this._onDragEnter);
            functor(canvasElement, "dragleave", this._onDragLeave);
            functor(canvasElement, "drop", this._onDrop);
            if (!this.enablePointerEvents) functor(canvasElement, "touchstart", this._onTouchStart, addEventOptions);
            if (typeof eventjs !== "undefined" && eventjsFunctor in eventjs) {
                eventjs[eventjsFunctor](canvasElement, "gesture", this._onGesture);
                eventjs[eventjsFunctor](canvasElement, "drag", this._onDrag);
                eventjs[eventjsFunctor](canvasElement, "orientation", this._onOrientationChange);
                eventjs[eventjsFunctor](canvasElement, "shake", this._onShake);
                eventjs[eventjsFunctor](canvasElement, "longpress", this._onLongPress);
            }
        },
        /**
     * Removes all event listeners
     */ removeListeners: function() {
            this.addOrRemove(removeListener, "remove");
            // if you dispose on a mouseDown, before mouse up, you need to clean document to...
            var eventTypePrefix = this._getEventPrefix();
            removeListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "up", this._onMouseUp);
            removeListener($d47795690082d4de$var$fabric.document, "touchend", this._onTouchEnd, addEventOptions);
            removeListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
            removeListener($d47795690082d4de$var$fabric.document, "touchmove", this._onMouseMove, addEventOptions);
        },
        /**
     * @private
     */ _bindEvents: function() {
            if (this.eventsBound) // for any reason we pass here twice we do not want to bind events twice.
            return;
            this._onMouseDown = this._onMouseDown.bind(this);
            this._onTouchStart = this._onTouchStart.bind(this);
            this._onMouseMove = this._onMouseMove.bind(this);
            this._onMouseUp = this._onMouseUp.bind(this);
            this._onTouchEnd = this._onTouchEnd.bind(this);
            this._onResize = this._onResize.bind(this);
            this._onGesture = this._onGesture.bind(this);
            this._onDrag = this._onDrag.bind(this);
            this._onShake = this._onShake.bind(this);
            this._onLongPress = this._onLongPress.bind(this);
            this._onOrientationChange = this._onOrientationChange.bind(this);
            this._onMouseWheel = this._onMouseWheel.bind(this);
            this._onMouseOut = this._onMouseOut.bind(this);
            this._onMouseEnter = this._onMouseEnter.bind(this);
            this._onContextMenu = this._onContextMenu.bind(this);
            this._onDoubleClick = this._onDoubleClick.bind(this);
            this._onDragOver = this._onDragOver.bind(this);
            this._onDragEnter = this._simpleEventHandler.bind(this, "dragenter");
            this._onDragLeave = this._simpleEventHandler.bind(this, "dragleave");
            this._onDrop = this._onDrop.bind(this);
            this.eventsBound = true;
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js gesture
     * @param {Event} [self] Inner Event object
     */ _onGesture: function(e, self) {
            this.__onTransformGesture && this.__onTransformGesture(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js drag
     * @param {Event} [self] Inner Event object
     */ _onDrag: function(e, self) {
            this.__onDrag && this.__onDrag(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */ _onMouseWheel: function(e) {
            this.__onMouseWheel(e);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseOut: function(e) {
            var target = this._hoveredTarget;
            this.fire("mouse:out", {
                target: target,
                e: e
            });
            this._hoveredTarget = null;
            target && target.fire("mouseout", {
                e: e
            });
            var _this = this;
            this._hoveredTargets.forEach(function(_target) {
                _this.fire("mouse:out", {
                    target: target,
                    e: e
                });
                _target && target.fire("mouseout", {
                    e: e
                });
            });
            this._hoveredTargets = [];
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */ _onMouseEnter: function(e) {
            // This find target and consequent 'mouse:over' is used to
            // clear old instances on hovered target.
            // calling findTarget has the side effect of killing target.__corner.
            // as a short term fix we are not firing this if we are currently transforming.
            // as a long term fix we need to separate the action of finding a target with the
            // side effects we added to it.
            if (!this._currentTransform && !this.findTarget(e)) {
                this.fire("mouse:over", {
                    target: null,
                    e: e
                });
                this._hoveredTarget = null;
                this._hoveredTargets = [];
            }
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js orientation change
     * @param {Event} [self] Inner Event object
     */ _onOrientationChange: function(e, self) {
            this.__onOrientationChange && this.__onOrientationChange(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */ _onShake: function(e, self) {
            this.__onShake && this.__onShake(e, self);
        },
        /**
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     * @param {Event} [self] Inner Event object
     */ _onLongPress: function(e, self) {
            this.__onLongPress && this.__onLongPress(e, self);
        },
        /**
     * prevent default to allow drop event to be fired
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */ _onDragOver: function(e) {
            e.preventDefault();
            var target = this._simpleEventHandler("dragover", e);
            this._fireEnterLeaveEvents(target, e);
        },
        /**
     * `drop:before` is a an event that allow you to schedule logic
     * before the `drop` event. Prefer `drop` event always, but if you need
     * to run some drop-disabling logic on an event, since there is no way
     * to handle event handlers ordering, use `drop:before`
     * @param {Event} e
     */ _onDrop: function(e) {
            this._simpleEventHandler("drop:before", e);
            return this._simpleEventHandler("drop", e);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onContextMenu: function(e) {
            if (this.stopContextMenu) {
                e.stopPropagation();
                e.preventDefault();
            }
            return false;
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onDoubleClick: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, "dblclick");
            this._resetTransformEventData(e);
        },
        /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */ getPointerId: function(evt) {
            var changedTouches = evt.changedTouches;
            if (changedTouches) return changedTouches[0] && changedTouches[0].identifier;
            if (this.enablePointerEvents) return evt.pointerId;
            return -1;
        },
        /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */ _isMainEvent: function(evt) {
            if (evt.isPrimary === true) return true;
            if (evt.isPrimary === false) return false;
            if (evt.type === "touchend" && evt.touches.length === 0) return true;
            if (evt.changedTouches) return evt.changedTouches[0].identifier === this.mainTouchId;
            return true;
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onTouchStart: function(e) {
            e.preventDefault();
            if (this.mainTouchId === null) this.mainTouchId = this.getPointerId(e);
            this.__onMouseDown(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            addListener($d47795690082d4de$var$fabric.document, "touchend", this._onTouchEnd, addEventOptions);
            addListener($d47795690082d4de$var$fabric.document, "touchmove", this._onMouseMove, addEventOptions);
            // Unbind mousedown to prevent double triggers from touch devices
            removeListener(canvasElement, eventTypePrefix + "down", this._onMouseDown);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseDown: function(e) {
            this.__onMouseDown(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            removeListener(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
            addListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "up", this._onMouseUp);
            addListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onTouchEnd: function(e) {
            if (e.touches.length > 0) // if there are still touches stop here
            return;
            this.__onMouseUp(e);
            this._resetTransformEventData();
            this.mainTouchId = null;
            var eventTypePrefix = this._getEventPrefix();
            removeListener($d47795690082d4de$var$fabric.document, "touchend", this._onTouchEnd, addEventOptions);
            removeListener($d47795690082d4de$var$fabric.document, "touchmove", this._onMouseMove, addEventOptions);
            var _this = this;
            if (this._willAddMouseDown) clearTimeout(this._willAddMouseDown);
            this._willAddMouseDown = setTimeout(function() {
                // Wait 400ms before rebinding mousedown to prevent double triggers
                // from touch devices
                addListener(_this.upperCanvasEl, eventTypePrefix + "down", _this._onMouseDown);
                _this._willAddMouseDown = 0;
            }, 400);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */ _onMouseUp: function(e) {
            this.__onMouseUp(e);
            this._resetTransformEventData();
            var canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
            if (this._isMainEvent(e)) {
                removeListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "up", this._onMouseUp);
                removeListener($d47795690082d4de$var$fabric.document, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
                addListener(canvasElement, eventTypePrefix + "move", this._onMouseMove, addEventOptions);
            }
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */ _onMouseMove: function(e) {
            !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
            this.__onMouseMove(e);
        },
        /**
     * @private
     */ _onResize: function() {
            this.calcOffset();
        },
        /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */ _shouldRender: function(target) {
            var activeObject = this._activeObject;
            if (!!activeObject !== !!target || activeObject && target && activeObject !== target) // this covers: switch of target, from target to no target, selection of target
            // multiSelection with key and mouse
            return true;
            else if (activeObject && activeObject.isEditing) // if we mouse up/down over a editing textbox a cursor change,
            // there is no need to re render
            return false;
            return false;
        },
        /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */ __onMouseUp: function(e) {
            var target, transform = this._currentTransform, groupSelector = this._groupSelector, shouldRender = false, isClick = !groupSelector || groupSelector.left === 0 && groupSelector.top === 0;
            this._cacheTransformEventData(e);
            target = this._target;
            this._handleEvent(e, "up:before");
            // if right/middle click just fire events and return
            // target undefined will make the _handleEvent search the target
            if (checkClick(e, RIGHT_CLICK)) {
                if (this.fireRightClick) this._handleEvent(e, "up", RIGHT_CLICK, isClick);
                return;
            }
            if (checkClick(e, MIDDLE_CLICK)) {
                if (this.fireMiddleClick) this._handleEvent(e, "up", MIDDLE_CLICK, isClick);
                this._resetTransformEventData();
                return;
            }
            if (this.isDrawingMode && this._isCurrentlyDrawing) {
                this._onMouseUpInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            if (transform) {
                this._finalizeCurrentTransform(e);
                shouldRender = transform.actionPerformed;
            }
            if (!isClick) {
                var targetWasActive = target === this._activeObject;
                this._maybeGroupObjects(e);
                if (!shouldRender) shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
            }
            var corner, pointer;
            if (target) {
                corner = target._findTargetCorner(this.getPointer(e, true), $d47795690082d4de$var$fabric.util.isTouchEvent(e));
                if (target.selectable && target !== this._activeObject && target.activeOn === "up") {
                    this.setActiveObject(target, e);
                    shouldRender = true;
                } else {
                    var control = target.controls[corner], mouseUpHandler = control && control.getMouseUpHandler(e, target, control);
                    if (mouseUpHandler) {
                        pointer = this.getPointer(e);
                        mouseUpHandler(e, transform, pointer.x, pointer.y);
                    }
                }
                target.isMoving = false;
            }
            // if we are ending up a transform on a different control or a new object
            // fire the original mouse up from the corner that started the transform
            if (transform && (transform.target !== target || transform.corner !== corner)) {
                var originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, target, control);
                pointer = pointer || this.getPointer(e);
                originalMouseUpHandler && originalMouseUpHandler(e, transform, pointer.x, pointer.y);
            }
            this._setCursorFromEvent(e, target);
            this._handleEvent(e, "up", LEFT_CLICK, isClick);
            this._groupSelector = null;
            this._currentTransform = null;
            // reset the target information about which corner is selected
            target && (target.__corner = 0);
            if (shouldRender) this.requestRenderAll();
            else if (!isClick) this.renderTop();
        },
        /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @return {Fabric.Object} target return the the target found, for internal reasons.
     */ _simpleEventHandler: function(eventType, e) {
            var target = this.findTarget(e), targets = this.targets, options = {
                e: e,
                target: target,
                subTargets: targets
            };
            this.fire(eventType, options);
            target && target.fire(eventType, options);
            if (!targets) return target;
            for(var i = 0; i < targets.length; i++)targets[i].fire(eventType, options);
            return target;
        },
        /**
     * @private
     * Handle event firing for target and subtargets
     * @param {Event} e event from mouse
     * @param {String} eventType event to fire (up, down or move)
     * @param {fabric.Object} targetObj receiving event
     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
     */ _handleEvent: function(e, eventType, button, isClick) {
            var target = this._target, targets = this.targets || [], options = {
                e: e,
                target: target,
                subTargets: targets,
                button: button || LEFT_CLICK,
                isClick: isClick || false,
                pointer: this._pointer,
                absolutePointer: this._absolutePointer,
                transform: this._currentTransform
            };
            if (eventType === "up") {
                options.currentTarget = this.findTarget(e);
                options.currentSubTargets = this.targets;
            }
            this.fire("mouse:" + eventType, options);
            target && target.fire("mouse" + eventType, options);
            for(var i = 0; i < targets.length; i++)targets[i].fire("mouse" + eventType, options);
        },
        /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */ _finalizeCurrentTransform: function(e) {
            var transform = this._currentTransform, target = transform.target, options = {
                e: e,
                target: target,
                transform: transform,
                action: transform.action
            };
            if (target._scaling) target._scaling = false;
            target.setCoords();
            if (transform.actionPerformed || this.stateful && target.hasStateChanged()) this._fire("modified", options);
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */ _onMouseDownInDrawingMode: function(e) {
            this._isCurrentlyDrawing = true;
            if (this.getActiveObject()) this.discardActiveObject(e).requestRenderAll();
            var pointer = this.getPointer(e);
            this.freeDrawingBrush.onMouseDown(pointer, {
                e: e,
                pointer: pointer
            });
            this._handleEvent(e, "down");
        },
        /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */ _onMouseMoveInDrawingMode: function(e) {
            if (this._isCurrentlyDrawing) {
                var pointer = this.getPointer(e);
                this.freeDrawingBrush.onMouseMove(pointer, {
                    e: e,
                    pointer: pointer
                });
            }
            this.setCursor(this.freeDrawingCursor);
            this._handleEvent(e, "move");
        },
        /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */ _onMouseUpInDrawingMode: function(e) {
            var pointer = this.getPointer(e);
            this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({
                e: e,
                pointer: pointer
            });
            this._handleEvent(e, "up");
        },
        /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */ __onMouseDown: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, "down:before");
            var target = this._target;
            // if right click just fire events
            if (checkClick(e, RIGHT_CLICK)) {
                if (this.fireRightClick) this._handleEvent(e, "down", RIGHT_CLICK);
                return;
            }
            if (checkClick(e, MIDDLE_CLICK)) {
                if (this.fireMiddleClick) this._handleEvent(e, "down", MIDDLE_CLICK);
                return;
            }
            if (this.isDrawingMode) {
                this._onMouseDownInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            // ignore if some object is being transformed at this moment
            if (this._currentTransform) return;
            var pointer = this._pointer;
            // save pointer for check in __onMouseUp event
            this._previousPointer = pointer;
            var shouldRender = this._shouldRender(target), shouldGroup = this._shouldGroup(e, target);
            if (this._shouldClearSelection(e, target)) this.discardActiveObject(e);
            else if (shouldGroup) {
                this._handleGrouping(e, target);
                target = this._activeObject;
            }
            if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) this._groupSelector = {
                ex: this._absolutePointer.x,
                ey: this._absolutePointer.y,
                top: 0,
                left: 0
            };
            if (target) {
                var alreadySelected = target === this._activeObject;
                if (target.selectable && target.activeOn === "down") this.setActiveObject(target, e);
                var corner = target._findTargetCorner(this.getPointer(e, true), $d47795690082d4de$var$fabric.util.isTouchEvent(e));
                target.__corner = corner;
                if (target === this._activeObject && (corner || !shouldGroup)) {
                    this._setupCurrentTransform(e, target, alreadySelected);
                    var control = target.controls[corner], pointer = this.getPointer(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
                    if (mouseDownHandler) mouseDownHandler(e, this._currentTransform, pointer.x, pointer.y);
                }
            }
            this._handleEvent(e, "down");
            // we must renderAll so that we update the visuals
            (shouldRender || shouldGroup) && this.requestRenderAll();
        },
        /**
     * reset cache form common information needed during event processing
     * @private
     */ _resetTransformEventData: function() {
            this._target = null;
            this._pointer = null;
            this._absolutePointer = null;
        },
        /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */ _cacheTransformEventData: function(e) {
            // reset in order to avoid stale caching
            this._resetTransformEventData();
            this._pointer = this.getPointer(e, true);
            this._absolutePointer = this.restorePointerVpt(this._pointer);
            this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
        },
        /**
     * @private
     */ _beforeTransform: function(e) {
            var t = this._currentTransform;
            this.stateful && t.target.saveState();
            this.fire("before:transform", {
                e: e,
                transform: t
            });
        },
        /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */ __onMouseMove: function(e) {
            this._handleEvent(e, "move:before");
            this._cacheTransformEventData(e);
            var target, pointer;
            if (this.isDrawingMode) {
                this._onMouseMoveInDrawingMode(e);
                return;
            }
            if (!this._isMainEvent(e)) return;
            var groupSelector = this._groupSelector;
            // We initially clicked in an empty area, so we draw a box for multiple selection
            if (groupSelector) {
                pointer = this._absolutePointer;
                groupSelector.left = pointer.x - groupSelector.ex;
                groupSelector.top = pointer.y - groupSelector.ey;
                this.renderTop();
            } else if (!this._currentTransform) {
                target = this.findTarget(e) || null;
                this._setCursorFromEvent(e, target);
                this._fireOverOutEvents(target, e);
            } else this._transformObject(e);
            this._handleEvent(e, "move");
            this._resetTransformEventData();
        },
        /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */ _fireOverOutEvents: function(target, e) {
            var _hoveredTarget = this._hoveredTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
            this.fireSyntheticInOutEvents(target, e, {
                oldTarget: _hoveredTarget,
                evtOut: "mouseout",
                canvasEvtOut: "mouse:out",
                evtIn: "mouseover",
                canvasEvtIn: "mouse:over"
            });
            for(var i = 0; i < length; i++)this.fireSyntheticInOutEvents(targets[i], e, {
                oldTarget: _hoveredTargets[i],
                evtOut: "mouseout",
                evtIn: "mouseover"
            });
            this._hoveredTarget = target;
            this._hoveredTargets = this.targets.concat();
        },
        /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Event} e Event object fired on ondrag
     * @private
     */ _fireEnterLeaveEvents: function(target, e) {
            var _draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
            this.fireSyntheticInOutEvents(target, e, {
                oldTarget: _draggedoverTarget,
                evtOut: "dragleave",
                evtIn: "dragenter"
            });
            for(var i = 0; i < length; i++)this.fireSyntheticInOutEvents(targets[i], e, {
                oldTarget: _hoveredTargets[i],
                evtOut: "dragleave",
                evtIn: "dragenter"
            });
            this._draggedoverTarget = target;
        },
        /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Event} e Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */ fireSyntheticInOutEvents: function(target, e, config) {
            var inOpt, outOpt, oldTarget = config.oldTarget, outFires, inFires, targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
            if (targetChanged) {
                inOpt = {
                    e: e,
                    target: target,
                    previousTarget: oldTarget
                };
                outOpt = {
                    e: e,
                    target: oldTarget,
                    nextTarget: target
                };
            }
            inFires = target && targetChanged;
            outFires = oldTarget && targetChanged;
            if (outFires) {
                canvasEvtOut && this.fire(canvasEvtOut, outOpt);
                oldTarget.fire(config.evtOut, outOpt);
            }
            if (inFires) {
                canvasEvtIn && this.fire(canvasEvtIn, inOpt);
                target.fire(config.evtIn, inOpt);
            }
        },
        /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */ __onMouseWheel: function(e) {
            this._cacheTransformEventData(e);
            this._handleEvent(e, "wheel");
            this._resetTransformEventData();
        },
        /**
     * @private
     * @param {Event} e Event fired on mousemove
     */ _transformObject: function(e) {
            var pointer = this.getPointer(e), transform = this._currentTransform;
            transform.reset = false;
            transform.shiftKey = e.shiftKey;
            transform.altKey = e[this.centeredKey];
            this._performTransformAction(e, transform, pointer);
            transform.actionPerformed && this.requestRenderAll();
        },
        /**
     * @private
     */ _performTransformAction: function(e, transform, pointer) {
            var x = pointer.x, y = pointer.y, action = transform.action, actionPerformed = false, actionHandler = transform.actionHandler;
            // this object could be created from the function in the control handlers
            if (actionHandler) actionPerformed = actionHandler(e, transform, x, y);
            if (action === "drag" && actionPerformed) {
                transform.target.isMoving = true;
                this.setCursor(transform.target.moveCursor || this.moveCursor);
            }
            transform.actionPerformed = transform.actionPerformed || actionPerformed;
        },
        /**
     * @private
     */ _fire: $d47795690082d4de$var$fabric.controlsUtils.fireEvent,
        /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */ _setCursorFromEvent: function(e, target) {
            if (!target) {
                this.setCursor(this.defaultCursor);
                return false;
            }
            var hoverCursor = target.hoverCursor || this.hoverCursor, activeSelection = this._activeObject && this._activeObject.type === "activeSelection" ? this._activeObject : null, // only show proper corner when group selection is not active
            corner = (!activeSelection || !activeSelection.contains(target)) && target._findTargetCorner(this.getPointer(e, true));
            if (!corner) {
                if (target.subTargetCheck) // hoverCursor should come from top-most subTarget,
                // so we walk the array backwards
                this.targets.concat().reverse().map(function(_target) {
                    hoverCursor = _target.hoverCursor || hoverCursor;
                });
                this.setCursor(hoverCursor);
            } else this.setCursor(this.getCornerCursor(corner, target, e));
        },
        /**
     * @private
     */ getCornerCursor: function(corner, target, e) {
            var control = target.controls[corner];
            return control.cursorStyleHandler(e, control, target);
        }
    });
})();
(function() {
    var min = Math.min, max = Math.max;
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     * @return {Boolean}
     */ _shouldGroup: function(e, target) {
            var activeObject = this._activeObject;
            return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection && (activeObject !== target || activeObject.type === "activeSelection") && !target.onSelect({
                e: e
            });
        },
        /**
     * @private
     * @param {Event} e Event object
     * @param {fabric.Object} target
     */ _handleGrouping: function(e, target) {
            var activeObject = this._activeObject;
            // avoid multi select when shift click on a corner
            if (activeObject.__corner) return;
            if (target === activeObject) {
                // if it's a group, find target again, using activeGroup objects
                target = this.findTarget(e, true);
                // if even object is not found or we are on activeObjectCorner, bail out
                if (!target || !target.selectable) return;
            }
            if (activeObject && activeObject.type === "activeSelection") this._updateActiveSelection(target, e);
            else this._createActiveSelection(target, e);
        },
        /**
     * @private
     */ _updateActiveSelection: function(target, e) {
            var activeSelection = this._activeObject, currentActiveObjects = activeSelection._objects.slice(0);
            if (activeSelection.contains(target)) {
                activeSelection.removeWithUpdate(target);
                this._hoveredTarget = target;
                this._hoveredTargets = this.targets.concat();
                if (activeSelection.size() === 1) // activate last remaining object
                this._setActiveObject(activeSelection.item(0), e);
            } else {
                activeSelection.addWithUpdate(target);
                this._hoveredTarget = activeSelection;
                this._hoveredTargets = this.targets.concat();
            }
            this._fireSelectionEvents(currentActiveObjects, e);
        },
        /**
     * @private
     */ _createActiveSelection: function(target, e) {
            var currentActives = this.getActiveObjects(), group = this._createGroup(target);
            this._hoveredTarget = group;
            // ISSUE 4115: should we consider subTargets here?
            // this._hoveredTargets = [];
            // this._hoveredTargets = this.targets.concat();
            this._setActiveObject(group, e);
            this._fireSelectionEvents(currentActives, e);
        },
        /**
     * @private
     * @param {Object} target
     */ _createGroup: function(target) {
            var objects = this._objects, isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target), groupObjects = isActiveLower ? [
                this._activeObject,
                target
            ] : [
                target,
                this._activeObject
            ];
            this._activeObject.isEditing && this._activeObject.exitEditing();
            return new $d47795690082d4de$var$fabric.ActiveSelection(groupObjects, {
                canvas: this
            });
        },
        /**
     * @private
     * @param {Event} e mouse event
     */ _groupSelectedObjects: function(e) {
            var group = this._collectObjects(e), aGroup;
            // do not create group for 1 element only
            if (group.length === 1) this.setActiveObject(group[0], e);
            else if (group.length > 1) {
                aGroup = new $d47795690082d4de$var$fabric.ActiveSelection(group.reverse(), {
                    canvas: this
                });
                this.setActiveObject(aGroup, e);
            }
        },
        /**
     * @private
     */ _collectObjects: function(e) {
            var group = [], currentObject, x1 = this._groupSelector.ex, y1 = this._groupSelector.ey, x2 = x1 + this._groupSelector.left, y2 = y1 + this._groupSelector.top, selectionX1Y1 = new $d47795690082d4de$var$fabric.Point(min(x1, x2), min(y1, y2)), selectionX2Y2 = new $d47795690082d4de$var$fabric.Point(max(x1, x2), max(y1, y2)), allowIntersect = !this.selectionFullyContained, isClick = x1 === x2 && y1 === y2;
            // we iterate reverse order to collect top first in case of click.
            for(var i = this._objects.length; i--;){
                currentObject = this._objects[i];
                if (!currentObject || !currentObject.selectable || !currentObject.visible) continue;
                if (allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2, true) || currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2, true) || allowIntersect && currentObject.containsPoint(selectionX1Y1, null, true) || allowIntersect && currentObject.containsPoint(selectionX2Y2, null, true)) {
                    group.push(currentObject);
                    // only add one object if it's a click
                    if (isClick) break;
                }
            }
            if (group.length > 1) group = group.filter(function(object) {
                return !object.onSelect({
                    e: e
                });
            });
            return group;
        },
        /**
     * @private
     */ _maybeGroupObjects: function(e) {
            if (this.selection && this._groupSelector) this._groupSelectedObjects(e);
            this.setCursor(this.defaultCursor);
            // clear selection and current transformation
            this._groupSelector = null;
        }
    });
})();
(function() {
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
        /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     */ toDataURL: function(options) {
            options || (options = {});
            var format = options.format || "png", quality = options.quality || 1, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1), canvasEl = this.toCanvasElement(multiplier, options);
            return $d47795690082d4de$var$fabric.util.toDataURL(canvasEl, format, quality);
        },
        /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [cropping] Cropping informations
     * @param {Number} [cropping.left] Cropping left offset.
     * @param {Number} [cropping.top] Cropping top offset.
     * @param {Number} [cropping.width] Cropping width.
     * @param {Number} [cropping.height] Cropping height.
     */ toCanvasElement: function(multiplier, cropping) {
            multiplier = multiplier || 1;
            cropping = cropping || {};
            var scaledWidth = (cropping.width || this.width) * multiplier, scaledHeight = (cropping.height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, newZoom = zoom * multiplier, vp = this.viewportTransform, translateX = (vp[4] - (cropping.left || 0)) * multiplier, translateY = (vp[5] - (cropping.top || 0)) * multiplier, originalInteractive = this.interactive, newVp = [
                newZoom,
                0,
                0,
                newZoom,
                translateX,
                translateY
            ], originalRetina = this.enableRetinaScaling, canvasEl = $d47795690082d4de$var$fabric.util.createCanvasElement(), originalContextTop = this.contextTop;
            canvasEl.width = scaledWidth;
            canvasEl.height = scaledHeight;
            this.contextTop = null;
            this.enableRetinaScaling = false;
            this.interactive = false;
            this.viewportTransform = newVp;
            this.width = scaledWidth;
            this.height = scaledHeight;
            this.calcViewportBoundaries();
            this.renderCanvas(canvasEl.getContext("2d"), this._objects);
            this.viewportTransform = vp;
            this.width = originalWidth;
            this.height = originalHeight;
            this.calcViewportBoundaries();
            this.interactive = originalInteractive;
            this.enableRetinaScaling = originalRetina;
            this.contextTop = originalContextTop;
            return canvasEl;
        }
    });
})();
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   * @param {String|Object} json JSON string or object
   * @param {Function} callback Callback, invoked when json is parsed
   *                            and corresponding objects (e.g: {@link fabric.Image})
   *                            are initialized
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @return {fabric.Canvas} instance
   * @chainable
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * });
   */ loadFromJSON: function(json, callback, reviver) {
        if (!json) return;
        // serialize if it wasn't already
        var serialized = typeof json === "string" ? JSON.parse(json) : $d47795690082d4de$var$fabric.util.object.clone(json);
        var _this = this, clipPath = serialized.clipPath, renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        delete serialized.clipPath;
        this._enlivenObjects(serialized.objects, function(enlivenedObjects) {
            _this.clear();
            _this._setBgOverlay(serialized, function() {
                if (clipPath) _this._enlivenObjects([
                    clipPath
                ], function(enlivenedCanvasClip) {
                    _this.clipPath = enlivenedCanvasClip[0];
                    _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
                });
                else _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
            });
        }, reviver);
        return this;
    },
    /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Array} restored canvas objects
   * @param {Function} cached renderOnAddRemove callback
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */ __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
        var _this = this;
        enlivenedObjects.forEach(function(obj, index) {
            // we splice the array just in case some custom classes restored from JSON
            // will add more object to canvas at canvas init.
            _this.insertAt(obj, index);
        });
        this.renderOnAddRemove = renderOnAddRemove;
        // remove parts i cannot set as options
        delete serialized.objects;
        delete serialized.backgroundImage;
        delete serialized.overlayImage;
        delete serialized.background;
        delete serialized.overlay;
        // this._initOptions does too many things to just
        // call it. Normally loading an Object from JSON
        // create the Object instance. Here the Canvas is
        // already an instance and we are just loading things over it
        this._setOptions(serialized);
        this.renderAll();
        callback && callback();
    },
    /**
   * @private
   * @param {Object} serialized Object with background and overlay information
   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
   */ _setBgOverlay: function(serialized, callback) {
        var loaded = {
            backgroundColor: false,
            overlayColor: false,
            backgroundImage: false,
            overlayImage: false
        };
        if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
            callback && callback();
            return;
        }
        var cbIfLoaded = function() {
            if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) callback && callback();
        };
        this.__setBgOverlay("backgroundImage", serialized.backgroundImage, loaded, cbIfLoaded);
        this.__setBgOverlay("overlayImage", serialized.overlayImage, loaded, cbIfLoaded);
        this.__setBgOverlay("backgroundColor", serialized.background, loaded, cbIfLoaded);
        this.__setBgOverlay("overlayColor", serialized.overlay, loaded, cbIfLoaded);
    },
    /**
   * @private
   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
   * @param {(Object|String)} value Value to set
   * @param {Object} loaded Set loaded property to true if property is set
   * @param {Object} callback Callback function to invoke after property is set
   */ __setBgOverlay: function(property, value, loaded, callback) {
        var _this = this;
        if (!value) {
            loaded[property] = true;
            callback && callback();
            return;
        }
        if (property === "backgroundImage" || property === "overlayImage") $d47795690082d4de$var$fabric.util.enlivenObjects([
            value
        ], function(enlivedObject) {
            _this[property] = enlivedObject[0];
            loaded[property] = true;
            callback && callback();
        });
        else this["set" + $d47795690082d4de$var$fabric.util.string.capitalize(property, true)](value, function() {
            loaded[property] = true;
            callback && callback();
        });
    },
    /**
   * @private
   * @param {Array} objects
   * @param {Function} callback
   * @param {Function} [reviver]
   */ _enlivenObjects: function(objects, callback, reviver) {
        if (!objects || objects.length === 0) {
            callback && callback([]);
            return;
        }
        $d47795690082d4de$var$fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
            callback && callback(enlivenedObjects);
        }, null, reviver);
    },
    /**
   * @private
   * @param {String} format
   * @param {Function} callback
   */ _toDataURL: function(format, callback) {
        this.clone(function(clone) {
            callback(clone.toDataURL(format));
        });
    },
    /**
   * @private
   * @param {String} format
   * @param {Number} multiplier
   * @param {Function} callback
   */ _toDataURLWithMultiplier: function(format, multiplier, callback) {
        this.clone(function(clone) {
            callback(clone.toDataURLWithMultiplier(format, multiplier));
        });
    },
    /**
   * Clones canvas instance
   * @param {Object} [callback] Receives cloned instance as a first argument
   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
   */ clone: function(callback, properties) {
        var data = JSON.stringify(this.toJSON(properties));
        this.cloneWithoutData(function(clone) {
            clone.loadFromJSON(data, function() {
                callback && callback(clone);
            });
        });
    },
    /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions, clipping properties, etc.
   * but leaves data empty (so that you can populate it with your own)
   * @param {Object} [callback] Receives cloned instance as a first argument
   */ cloneWithoutData: function(callback) {
        var el = $d47795690082d4de$var$fabric.util.createCanvasElement();
        el.width = this.width;
        el.height = this.height;
        var clone = new $d47795690082d4de$var$fabric.Canvas(el);
        if (this.backgroundImage) {
            clone.setBackgroundImage(this.backgroundImage.src, function() {
                clone.renderAll();
                callback && callback(clone);
            });
            clone.backgroundImageOpacity = this.backgroundImageOpacity;
            clone.backgroundImageStretch = this.backgroundImageStretch;
        } else callback && callback(clone);
    }
});
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed, capitalize = fabric.util.string.capitalize, degreesToRadians = fabric.util.degreesToRadians, objectCaching = !fabric.isLikelyNode, ALIASING_LIMIT = 2;
    if (fabric.Object) return;
    /**
   * Root object class from which all 2d shape classes inherit from
   * @class fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   * @see {@link fabric.Object#initialize} for constructor definition
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   * @fires modified
   * @fires modified
   * @fires moved
   * @fires scaled
   * @fires rotated
   * @fires skewed
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */ fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {
        /**
     * Type of an object (rect, circle, path, etc.).
     * Note that this property is meant to be read-only and not meant to be modified.
     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
     * @type String
     * @default
     */ type: "object",
        /**
     * Horizontal origin of transformation of an object (one of "left", "right", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */ originX: "left",
        /**
     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
     * @type String
     * @default
     */ originY: "top",
        /**
     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
     * @type Number
     * @default
     */ top: 0,
        /**
     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
     * @type Number
     * @default
     */ left: 0,
        /**
     * Object width
     * @type Number
     * @default
     */ width: 0,
        /**
     * Object height
     * @type Number
     * @default
     */ height: 0,
        /**
     * Object scale factor (horizontal)
     * @type Number
     * @default
     */ scaleX: 1,
        /**
     * Object scale factor (vertical)
     * @type Number
     * @default
     */ scaleY: 1,
        /**
     * When true, an object is rendered as flipped horizontally
     * @type Boolean
     * @default
     */ flipX: false,
        /**
     * When true, an object is rendered as flipped vertically
     * @type Boolean
     * @default
     */ flipY: false,
        /**
     * Opacity of an object
     * @type Number
     * @default
     */ opacity: 1,
        /**
     * Angle of rotation of an object (in degrees)
     * @type Number
     * @default
     */ angle: 0,
        /**
     * Angle of skew on x axes of an object (in degrees)
     * @type Number
     * @default
     */ skewX: 0,
        /**
     * Angle of skew on y axes of an object (in degrees)
     * @type Number
     * @default
     */ skewY: 0,
        /**
     * Size of object's controlling corners (in pixels)
     * @type Number
     * @default
     */ cornerSize: 13,
        /**
     * Size of object's controlling corners when touch interaction is detected
     * @type Number
     * @default
     */ touchCornerSize: 24,
        /**
     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
     * @type Boolean
     * @default
     */ transparentCorners: true,
        /**
     * Default cursor value used when hovering over this object on canvas
     * @type String
     * @default
     */ hoverCursor: null,
        /**
     * Default cursor value used when moving this object on canvas
     * @type String
     * @default
     */ moveCursor: null,
        /**
     * Padding between object and its controlling borders (in pixels)
     * @type Number
     * @default
     */ padding: 0,
        /**
     * Color of controlling borders of an object (when it's active)
     * @type String
     * @default
     */ borderColor: "rgb(178,204,255)",
        /**
     * Array specifying dash pattern of an object's borders (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */ borderDashArray: null,
        /**
     * Color of controlling corners of an object (when it's active)
     * @type String
     * @default
     */ cornerColor: "rgb(178,204,255)",
        /**
     * Color of controlling corners of an object (when it's active and transparentCorners false)
     * @since 1.6.2
     * @type String
     * @default
     */ cornerStrokeColor: null,
        /**
     * Specify style of control, 'rect' or 'circle'
     * @since 1.6.2
     * @type String
     */ cornerStyle: "rect",
        /**
     * Array specifying dash pattern of an object's control (hasBorder must be true)
     * @since 1.6.2
     * @type Array
     */ cornerDashArray: null,
        /**
     * When true, this object will use center point as the origin of transformation
     * when being scaled via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredScaling: false,
        /**
     * When true, this object will use center point as the origin of transformation
     * when being rotated via the controls.
     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
     * @since 1.3.4
     * @type Boolean
     * @default
     */ centeredRotation: true,
        /**
     * Color of object's fill
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ fill: "rgb(0,0,0)",
        /**
     * Fill rule used to fill an object
     * accepted values are nonzero, evenodd
     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
     * @type String
     * @default
     */ fillRule: "nonzero",
        /**
     * Composite rule used for canvas globalCompositeOperation
     * @type String
     * @default
     */ globalCompositeOperation: "source-over",
        /**
     * Background color of an object.
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ backgroundColor: "",
        /**
     * Selection Background color of an object. colored layer behind the object when it is active.
     * does not mix good with globalCompositeOperation methods.
     * @type String
     * @default
     */ selectionBackgroundColor: "",
        /**
     * When defined, an object is rendered via stroke and this property specifies its color
     * takes css colors https://www.w3.org/TR/css-color-3/
     * @type String
     * @default
     */ stroke: null,
        /**
     * Width of a stroke used to render this object
     * @type Number
     * @default
     */ strokeWidth: 1,
        /**
     * Array specifying dash pattern of an object's stroke (stroke must be defined)
     * @type Array
     */ strokeDashArray: null,
        /**
     * Line offset of an object's stroke
     * @type Number
     * @default
     */ strokeDashOffset: 0,
        /**
     * Line endings style of an object's stroke (one of "butt", "round", "square")
     * @type String
     * @default
     */ strokeLineCap: "butt",
        /**
     * Corner style of an object's stroke (one of "bevel", "round", "miter")
     * @type String
     * @default
     */ strokeLineJoin: "miter",
        /**
     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
     * @type Number
     * @default
     */ strokeMiterLimit: 4,
        /**
     * Shadow object representing shadow of this shape
     * @type fabric.Shadow
     * @default
     */ shadow: null,
        /**
     * Opacity of object's controlling borders when object is active and moving
     * @type Number
     * @default
     */ borderOpacityWhenMoving: 0.4,
        /**
     * Scale factor of object's controlling borders
     * bigger number will make a thicker border
     * border is 1, so this is basically a border thickness
     * since there is no way to change the border itself.
     * @type Number
     * @default
     */ borderScaleFactor: 1,
        /**
     * Minimum allowed scale value of an object
     * @type Number
     * @default
     */ minScaleLimit: 0,
        /**
     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
     * But events still fire on it.
     * @type Boolean
     * @default
     */ selectable: true,
        /**
     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
     * @type Boolean
     * @default
     */ evented: true,
        /**
     * When set to `false`, an object is not rendered on canvas
     * @type Boolean
     * @default
     */ visible: true,
        /**
     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
     * @type Boolean
     * @default
     */ hasControls: true,
        /**
     * When set to `false`, object's controlling borders are not rendered
     * @type Boolean
     * @default
     */ hasBorders: true,
        /**
     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
     * @type Boolean
     * @default
     */ perPixelTargetFind: false,
        /**
     * When `false`, default object's values are not included in its serialization
     * @type Boolean
     * @default
     */ includeDefaultValues: true,
        /**
     * When `true`, object horizontal movement is locked
     * @type Boolean
     * @default
     */ lockMovementX: false,
        /**
     * When `true`, object vertical movement is locked
     * @type Boolean
     * @default
     */ lockMovementY: false,
        /**
     * When `true`, object rotation is locked
     * @type Boolean
     * @default
     */ lockRotation: false,
        /**
     * When `true`, object horizontal scaling is locked
     * @type Boolean
     * @default
     */ lockScalingX: false,
        /**
     * When `true`, object vertical scaling is locked
     * @type Boolean
     * @default
     */ lockScalingY: false,
        /**
     * When `true`, object horizontal skewing is locked
     * @type Boolean
     * @default
     */ lockSkewingX: false,
        /**
     * When `true`, object vertical skewing is locked
     * @type Boolean
     * @default
     */ lockSkewingY: false,
        /**
     * When `true`, object cannot be flipped by scaling into negative values
     * @type Boolean
     * @default
     */ lockScalingFlip: false,
        /**
     * When `true`, object is not exported in OBJECT/JSON
     * @since 1.6.3
     * @type Boolean
     * @default
     */ excludeFromExport: false,
        /**
     * When `true`, object is cached on an additional canvas.
     * When `false`, object is not cached unless necessary ( clipPath )
     * default to true
     * @since 1.7.0
     * @type Boolean
     * @default true
     */ objectCaching: objectCaching,
        /**
     * When `true`, object properties are checked for cache invalidation. In some particular
     * situation you may want this to be disabled ( spray brush, very big, groups)
     * or if your application does not allow you to modify properties for groups child you want
     * to disable it for groups.
     * default to false
     * since 1.7.0
     * @type Boolean
     * @default false
     */ statefullCache: false,
        /**
     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
     * too much and will be redrawn with correct details at the end of scaling.
     * this setting is performance and application dependant.
     * default to true
     * since 1.7.0
     * @type Boolean
     * @default true
     */ noScaleCache: true,
        /**
     * When `false`, the stoke width will scale with the object.
     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
     * this Property does not work on Text classes or drawing call that uses strokeText,fillText methods
     * default to false
     * @since 2.6.0
     * @type Boolean
     * @default false
     * @type Boolean
     * @default false
     */ strokeUniform: false,
        /**
     * When set to `true`, object's cache will be rerendered next render call.
     * since 1.7.0
     * @type Boolean
     * @default true
     */ dirty: true,
        /**
     * keeps the value of the last hovered corner during mouse move.
     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
     * It should be private, but there is no harm in using it as
     * a read-only property.
     * @type number|string|any
     * @default 0
     */ __corner: 0,
        /**
     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
     * @type String
     * @default
     */ paintFirst: "fill",
        /**
     * When 'down', object is set to active on mousedown/touchstart
     * When 'up', object is set to active on mouseup/touchend
     * Experimental. Let's see if this breaks anything before supporting officially
     * @private
     * since 4.4.0
     * @type String
     * @default 'down'
     */ activeOn: "down",
        /**
     * List of properties to consider when checking if state
     * of an object is changed (fabric.Object#hasStateChanged)
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: "top left width height scaleX scaleY flipX flipY originX originY transformMatrix stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit angle opacity fill globalCompositeOperation shadow visible backgroundColor skewX skewY fillRule paintFirst clipPath strokeUniform".split(" "),
        /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */ cacheProperties: "fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath".split(" "),
        /**
     * List of properties to consider for animating colors.
     * @type Array
     */ colorProperties: "fill stroke backgroundColor".split(" "),
        /**
     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
     * the clipPath object gets used when the object has rendered, and the context is placed in the center
     * of the object cacheCanvas.
     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
     * @type fabric.Object
     */ clipPath: undefined,
        /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will make the object clip to the outside of the clipPath
     * since 2.4.0
     * @type boolean
     * @default false
     */ inverted: false,
        /**
     * Meaningful ONLY when the object is used as clipPath.
     * if true, the clipPath will have its top and left relative to canvas, and will
     * not be influenced by the object transform. This will make the clipPath relative
     * to the canvas, but clipping just a particular object.
     * WARNING this is beta, this feature may change or be renamed.
     * since 2.4.0
     * @type boolean
     * @default false
     */ absolutePositioned: false,
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            if (options) this.setOptions(options);
        },
        /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */ _createCacheCanvas: function() {
            this._cacheProperties = {};
            this._cacheCanvas = fabric.util.createCanvasElement();
            this._cacheContext = this._cacheCanvas.getContext("2d");
            this._updateCacheCanvas();
            // if canvas gets created, is empty, so dirty.
            this.dirty = true;
        },
        /**
     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _limitCacheSize: function(dims) {
            var perfLimitSizeTotal = fabric.perfLimitSizeTotal, width = dims.width, height = dims.height, max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
            if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
                if (width < min) dims.width = min;
                if (height < min) dims.height = min;
                return dims;
            }
            var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal), capValue = fabric.util.capValue, x = capValue(min, limitedDims.x, max), y = capValue(min, limitedDims.y, max);
            if (width > x) {
                dims.zoomX /= width / x;
                dims.width = x;
                dims.capped = true;
            }
            if (height > y) {
                dims.zoomY /= height / y;
                dims.height = y;
                dims.capped = true;
            }
            return dims;
        },
        /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _getCacheCanvasDimensions: function() {
            var objectScale = this.getTotalObjectScaling(), // caculate dimensions without skewing
            dim = this._getTransformedDimensions(0, 0), neededX = dim.x * objectScale.scaleX / this.scaleX, neededY = dim.y * objectScale.scaleY / this.scaleY;
            return {
                // for sure this ALIASING_LIMIT is slightly creating problem
                // in situation in which the cache canvas gets an upper limit
                // also objectScale contains already scaleX and scaleY
                width: neededX + ALIASING_LIMIT,
                height: neededY + ALIASING_LIMIT,
                zoomX: objectScale.scaleX,
                zoomY: objectScale.scaleY,
                x: neededX,
                y: neededY
            };
        },
        /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */ _updateCacheCanvas: function() {
            var targetCanvas = this.canvas;
            if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
                var target = targetCanvas._currentTransform.target, action = targetCanvas._currentTransform.action;
                if (this === target && action.slice && action.slice(0, 5) === "scale") return false;
            }
            var canvas = this._cacheCanvas, dims = this._limitCacheSize(this._getCacheCanvasDimensions()), minCacheSize = fabric.minCacheSideLimit, width = dims.width, height = dims.height, drawingWidth, drawingHeight, zoomX = dims.zoomX, zoomY = dims.zoomY, dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY, shouldRedraw = dimensionsChanged || zoomChanged, additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
            if (dimensionsChanged) {
                var canvasWidth = this._cacheCanvas.width, canvasHeight = this._cacheCanvas.height, sizeGrowing = width > canvasWidth || height > canvasHeight, sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) && canvasWidth > minCacheSize && canvasHeight > minCacheSize;
                shouldResizeCanvas = sizeGrowing || sizeShrinking;
                if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
                    additionalWidth = width * 0.1;
                    additionalHeight = height * 0.1;
                }
            }
            if (this instanceof fabric.Text && this.path) {
                shouldRedraw = true;
                shouldResizeCanvas = true;
                additionalWidth += this.getHeightOfLine(0) * this.zoomX;
                additionalHeight += this.getHeightOfLine(0) * this.zoomY;
            }
            if (shouldRedraw) {
                if (shouldResizeCanvas) {
                    canvas.width = Math.ceil(width + additionalWidth);
                    canvas.height = Math.ceil(height + additionalHeight);
                } else {
                    this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
                    this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
                }
                drawingWidth = dims.x / 2;
                drawingHeight = dims.y / 2;
                this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
                this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
                this.cacheWidth = width;
                this.cacheHeight = height;
                this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
                this._cacheContext.scale(zoomX, zoomY);
                this.zoomX = zoomX;
                this.zoomY = zoomY;
                return true;
            }
            return false;
        },
        /**
     * Sets object's properties from options
     * @param {Object} [options] Options object
     */ setOptions: function(options) {
            this._setOptions(options);
            this._initGradient(options.fill, "fill");
            this._initGradient(options.stroke, "stroke");
            this._initPattern(options.fill, "fill");
            this._initPattern(options.stroke, "stroke");
        },
        /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */ transform: function(ctx) {
            var needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
            var m = this.calcTransformMatrix(!needFullTransform);
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        },
        /**
     * Returns an object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS, object = {
                type: this.type,
                version: fabric.version,
                originX: this.originX,
                originY: this.originY,
                left: toFixed(this.left, NUM_FRACTION_DIGITS),
                top: toFixed(this.top, NUM_FRACTION_DIGITS),
                width: toFixed(this.width, NUM_FRACTION_DIGITS),
                height: toFixed(this.height, NUM_FRACTION_DIGITS),
                fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
                stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
                strokeWidth: toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
                strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
                strokeLineCap: this.strokeLineCap,
                strokeDashOffset: this.strokeDashOffset,
                strokeLineJoin: this.strokeLineJoin,
                strokeUniform: this.strokeUniform,
                strokeMiterLimit: toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
                scaleX: toFixed(this.scaleX, NUM_FRACTION_DIGITS),
                scaleY: toFixed(this.scaleY, NUM_FRACTION_DIGITS),
                angle: toFixed(this.angle, NUM_FRACTION_DIGITS),
                flipX: this.flipX,
                flipY: this.flipY,
                opacity: toFixed(this.opacity, NUM_FRACTION_DIGITS),
                shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
                visible: this.visible,
                backgroundColor: this.backgroundColor,
                fillRule: this.fillRule,
                paintFirst: this.paintFirst,
                globalCompositeOperation: this.globalCompositeOperation,
                skewX: toFixed(this.skewX, NUM_FRACTION_DIGITS),
                skewY: toFixed(this.skewY, NUM_FRACTION_DIGITS)
            };
            if (this.clipPath && !this.clipPath.excludeFromExport) {
                object.clipPath = this.clipPath.toObject(propertiesToInclude);
                object.clipPath.inverted = this.clipPath.inverted;
                object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
            }
            fabric.util.populateWithProperties(this, object, propertiesToInclude);
            if (!this.includeDefaultValues) object = this._removeDefaultValues(object);
            return object;
        },
        /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            // will be overwritten by subclasses
            return this.toObject(propertiesToInclude);
        },
        /**
     * @private
     * @param {Object} object
     */ _removeDefaultValues: function(object) {
            var prototype = fabric.util.getKlass(object.type).prototype, stateProperties = prototype.stateProperties;
            stateProperties.forEach(function(prop) {
                if (prop === "left" || prop === "top") return;
                if (object[prop] === prototype[prop]) delete object[prop];
                // basically a check for [] === []
                if (Array.isArray(object[prop]) && Array.isArray(prototype[prop]) && object[prop].length === 0 && prototype[prop].length === 0) delete object[prop];
            });
            return object;
        },
        /**
     * Returns a string representation of an instance
     * @return {String}
     */ toString: function() {
            return "#<fabric." + capitalize(this.type) + ">";
        },
        /**
     * Return the object scale factor counting also the group scaling
     * @return {Object} object with scaleX and scaleY properties
     */ getObjectScaling: function() {
            // if the object is a top level one, on the canvas, we go for simple aritmetic
            // otherwise the complex method with angles will return approximations and decimals
            // and will likely kill the cache when not needed
            // https://github.com/fabricjs/fabric.js/issues/7157
            if (!this.group) return {
                scaleX: this.scaleX,
                scaleY: this.scaleY
            };
            // if we are inside a group total zoom calculation is complex, we defer to generic matrices
            var options = fabric.util.qrDecompose(this.calcTransformMatrix());
            return {
                scaleX: Math.abs(options.scaleX),
                scaleY: Math.abs(options.scaleY)
            };
        },
        /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */ getTotalObjectScaling: function() {
            var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
            if (this.canvas) {
                var zoom = this.canvas.getZoom();
                var retina = this.canvas.getRetinaScaling();
                scaleX *= zoom * retina;
                scaleY *= zoom * retina;
            }
            return {
                scaleX: scaleX,
                scaleY: scaleY
            };
        },
        /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */ getObjectOpacity: function() {
            var opacity = this.opacity;
            if (this.group) opacity *= this.group.getObjectOpacity();
            return opacity;
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Object} thisArg
     */ _set: function(key, value) {
            var shouldConstrainValue = key === "scaleX" || key === "scaleY", isChanged = this[key] !== value, groupNeedsUpdate = false;
            if (shouldConstrainValue) value = this._constrainScale(value);
            if (key === "scaleX" && value < 0) {
                this.flipX = !this.flipX;
                value *= -1;
            } else if (key === "scaleY" && value < 0) {
                this.flipY = !this.flipY;
                value *= -1;
            } else if (key === "shadow" && value && !(value instanceof fabric.Shadow)) value = new fabric.Shadow(value);
            else if (key === "dirty" && this.group) this.group.set("dirty", value);
            this[key] = value;
            if (isChanged) {
                groupNeedsUpdate = this.group && this.group.isOnACache();
                if (this.cacheProperties.indexOf(key) > -1) {
                    this.dirty = true;
                    groupNeedsUpdate && this.group.set("dirty", true);
                } else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) this.group.set("dirty", true);
            }
            return this;
        },
        /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */ setOnGroup: function() {
        // implemented by sub-classes, as needed.
        },
        /**
     * Retrieves viewportTransform from Object's canvas if possible
     * @method getViewportTransform
     * @memberOf fabric.Object.prototype
     * @return {Array}
     */ getViewportTransform: function() {
            if (this.canvas && this.canvas.viewportTransform) return this.canvas.viewportTransform;
            return fabric.iMatrix.concat();
        },
        /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf fabric.Object.prototype
     * @return {Boolean}
     */ isNotVisible: function() {
            return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
        },
        /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            // do not render if width/height are zeros or object is not visible
            if (this.isNotVisible()) return;
            if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
            ctx.save();
            this._setupCompositeOperation(ctx);
            this.drawSelectionBackground(ctx);
            this.transform(ctx);
            this._setOpacity(ctx);
            this._setShadow(ctx, this);
            if (this.shouldCache()) {
                this.renderCache();
                this.drawCacheOnCanvas(ctx);
            } else {
                this._removeCacheCanvas();
                this.dirty = false;
                this.drawObject(ctx);
                if (this.objectCaching && this.statefullCache) this.saveState({
                    propertySet: "cacheProperties"
                });
            }
            ctx.restore();
        },
        renderCache: function(options) {
            options = options || {};
            if (!this._cacheCanvas || !this._cacheContext) this._createCacheCanvas();
            if (this.isCacheDirty()) {
                this.statefullCache && this.saveState({
                    propertySet: "cacheProperties"
                });
                this.drawObject(this._cacheContext, options.forClipping);
                this.dirty = false;
            }
        },
        /**
     * Remove cacheCanvas and its dimensions from the objects
     */ _removeCacheCanvas: function() {
            this._cacheCanvas = null;
            this._cacheContext = null;
            this.cacheWidth = 0;
            this.cacheHeight = 0;
        },
        /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */ hasStroke: function() {
            return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
        },
        /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */ hasFill: function() {
            return this.fill && this.fill !== "transparent";
        },
        /**
     * When set to `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */ needsItsOwnCache: function() {
            if (this.paintFirst === "stroke" && this.hasFill() && this.hasStroke() && typeof this.shadow === "object") return true;
            if (this.clipPath) return true;
            return false;
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */ shouldCache: function() {
            this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache());
            return this.ownCaching;
        },
        /**
     * Check if this object or a child object will cast a shadow
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     */ willDrawShadow: function() {
            return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
        },
        /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Object} clipPath
     */ drawClipPathOnCache: function(ctx, clipPath) {
            ctx.save();
            // DEBUG: uncomment this line, comment the following
            // ctx.globalAlpha = 0.4
            if (clipPath.inverted) ctx.globalCompositeOperation = "destination-out";
            else ctx.globalCompositeOperation = "destination-in";
            //ctx.scale(1 / 2, 1 / 2);
            if (clipPath.absolutePositioned) {
                var m = fabric.util.invertTransform(this.calcTransformMatrix());
                ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            }
            clipPath.transform(ctx);
            ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
            ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
            ctx.restore();
        },
        /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawObject: function(ctx, forClipping) {
            var originalFill = this.fill, originalStroke = this.stroke;
            if (forClipping) {
                this.fill = "black";
                this.stroke = "";
                this._setClippingProperties(ctx);
            } else this._renderBackground(ctx);
            this._render(ctx);
            this._drawClipPath(ctx, this.clipPath);
            this.fill = originalFill;
            this.stroke = originalStroke;
        },
        /**
     * Prepare clipPath state and cache and draw it on instance's cache
     * @param {CanvasRenderingContext2D} ctx
     * @param {fabric.Object} clipPath
     */ _drawClipPath: function(ctx, clipPath) {
            if (!clipPath) return;
            // needed to setup a couple of variables
            // path canvas gets overridden with this one.
            // TODO find a better solution?
            clipPath.canvas = this.canvas;
            clipPath.shouldCache();
            clipPath._transformDone = true;
            clipPath.renderCache({
                forClipping: true
            });
            this.drawClipPathOnCache(ctx, clipPath);
        },
        /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawCacheOnCanvas: function(ctx) {
            ctx.scale(1 / this.zoomX, 1 / this.zoomY);
            ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
        },
        /**
     * Check if cache is dirty
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */ isCacheDirty: function(skipCanvas) {
            if (this.isNotVisible()) return false;
            if (this._cacheCanvas && this._cacheContext && !skipCanvas && this._updateCacheCanvas()) // in this case the context is already cleared.
            return true;
            else if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged("cacheProperties")) {
                if (this._cacheCanvas && this._cacheContext && !skipCanvas) {
                    var width = this.cacheWidth / this.zoomX;
                    var height = this.cacheHeight / this.zoomY;
                    this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
                }
                return true;
            }
            return false;
        },
        /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderBackground: function(ctx) {
            if (!this.backgroundColor) return;
            var dim = this._getNonTransformedDimensions();
            ctx.fillStyle = this.backgroundColor;
            ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
            // if there is background color no other shadows
            // should be casted
            this._removeShadow(ctx);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _setOpacity: function(ctx) {
            if (this.group && !this.group._transformDone) ctx.globalAlpha = this.getObjectOpacity();
            else ctx.globalAlpha *= this.opacity;
        },
        _setStrokeStyles: function(ctx, decl) {
            var stroke = decl.stroke;
            if (stroke) {
                ctx.lineWidth = decl.strokeWidth;
                ctx.lineCap = decl.strokeLineCap;
                ctx.lineDashOffset = decl.strokeDashOffset;
                ctx.lineJoin = decl.strokeLineJoin;
                ctx.miterLimit = decl.strokeMiterLimit;
                if (stroke.toLive) {
                    if (stroke.gradientUnits === "percentage" || stroke.gradientTransform || stroke.patternTransform) // need to transform gradient in a pattern.
                    // this is a slow process. If you are hitting this codepath, and the object
                    // is not using caching, you should consider switching it on.
                    // we need a canvas as big as the current object caching canvas.
                    this._applyPatternForTransformedGradient(ctx, stroke);
                    else {
                        // is a simple gradient or pattern
                        ctx.strokeStyle = stroke.toLive(ctx, this);
                        this._applyPatternGradientTransform(ctx, stroke);
                    }
                } else // is a color
                ctx.strokeStyle = decl.stroke;
            }
        },
        _setFillStyles: function(ctx, decl) {
            var fill = decl.fill;
            if (fill) {
                if (fill.toLive) {
                    ctx.fillStyle = fill.toLive(ctx, this);
                    this._applyPatternGradientTransform(ctx, decl.fill);
                } else ctx.fillStyle = fill;
            }
        },
        _setClippingProperties: function(ctx) {
            ctx.globalAlpha = 1;
            ctx.strokeStyle = "transparent";
            ctx.fillStyle = "#000000";
        },
        /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     */ _setLineDash: function(ctx, dashArray) {
            if (!dashArray || dashArray.length === 0) return;
            // Spec requires the concatenation of two copies the dash list when the number of elements is odd
            if (1 & dashArray.length) dashArray.push.apply(dashArray, dashArray);
            ctx.setLineDash(dashArray);
        },
        /**
     * Renders controls and borders for the object
     * the context here is not transformed
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     */ _renderControls: function(ctx, styleOverride) {
            var vpt = this.getViewportTransform(), matrix = this.calcTransformMatrix(), options, drawBorders, drawControls;
            styleOverride = styleOverride || {};
            drawBorders = typeof styleOverride.hasBorders !== "undefined" ? styleOverride.hasBorders : this.hasBorders;
            drawControls = typeof styleOverride.hasControls !== "undefined" ? styleOverride.hasControls : this.hasControls;
            matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
            options = fabric.util.qrDecompose(matrix);
            ctx.save();
            ctx.translate(options.translateX, options.translateY);
            ctx.lineWidth = 1 * this.borderScaleFactor;
            if (!this.group) ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
            if (this.flipX) options.angle -= 180;
            ctx.rotate(degreesToRadians(this.group ? options.angle : this.angle));
            if (styleOverride.forActiveSelection || this.group) drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
            else drawBorders && this.drawBorders(ctx, styleOverride);
            drawControls && this.drawControls(ctx, styleOverride);
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _setShadow: function(ctx) {
            if (!this.shadow) return;
            var shadow = this.shadow, canvas = this.canvas, scaling, multX = canvas && canvas.viewportTransform[0] || 1, multY = canvas && canvas.viewportTransform[3] || 1;
            if (shadow.nonScaling) scaling = {
                scaleX: 1,
                scaleY: 1
            };
            else scaling = this.getObjectScaling();
            if (canvas && canvas._isRetinaScaling()) {
                multX *= fabric.devicePixelRatio;
                multY *= fabric.devicePixelRatio;
            }
            ctx.shadowColor = shadow.color;
            ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant * (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
            ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
            ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _removeShadow: function(ctx) {
            if (!this.shadow) return;
            ctx.shadowColor = "";
            ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} filler fabric.Pattern or fabric.Gradient
     * @return {Object} offset.offsetX offset for text rendering
     * @return {Object} offset.offsetY offset for text rendering
     */ _applyPatternGradientTransform: function(ctx, filler) {
            if (!filler || !filler.toLive) return {
                offsetX: 0,
                offsetY: 0
            };
            var t = filler.gradientTransform || filler.patternTransform;
            var offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
            if (filler.gradientUnits === "percentage") ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
            else ctx.transform(1, 0, 0, 1, offsetX, offsetY);
            if (t) ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
            return {
                offsetX: offsetX,
                offsetY: offsetY
            };
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderPaintInOrder: function(ctx) {
            if (this.paintFirst === "stroke") {
                this._renderStroke(ctx);
                this._renderFill(ctx);
            } else {
                this._renderFill(ctx);
                this._renderStroke(ctx);
            }
        },
        /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function() {},
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderFill: function(ctx) {
            if (!this.fill) return;
            ctx.save();
            this._setFillStyles(ctx, this);
            if (this.fillRule === "evenodd") ctx.fill("evenodd");
            else ctx.fill();
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderStroke: function(ctx) {
            if (!this.stroke || this.strokeWidth === 0) return;
            if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
            ctx.save();
            if (this.strokeUniform && this.group) {
                var scaling = this.getObjectScaling();
                ctx.scale(1 / scaling.scaleX, 1 / scaling.scaleY);
            } else if (this.strokeUniform) ctx.scale(1 / this.scaleX, 1 / this.scaleY);
            this._setLineDash(ctx, this.strokeDashArray);
            this._setStrokeStyles(ctx, this);
            ctx.stroke();
            ctx.restore();
        },
        /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drwabacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {fabric.Gradient} filler a fabric gradient instance
     */ _applyPatternForTransformedGradient: function(ctx, filler) {
            var dims = this._limitCacheSize(this._getCacheCanvasDimensions()), pCanvas = fabric.util.createCanvasElement(), pCtx, retinaScaling = this.canvas.getRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling;
            pCanvas.width = width;
            pCanvas.height = height;
            pCtx = pCanvas.getContext("2d");
            pCtx.beginPath();
            pCtx.moveTo(0, 0);
            pCtx.lineTo(width, 0);
            pCtx.lineTo(width, height);
            pCtx.lineTo(0, height);
            pCtx.closePath();
            pCtx.translate(width / 2, height / 2);
            pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
            this._applyPatternGradientTransform(pCtx, filler);
            pCtx.fillStyle = filler.toLive(ctx);
            pCtx.fill();
            ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
            ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
            ctx.strokeStyle = pCtx.createPattern(pCanvas, "no-repeat");
        },
        /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */ _findCenterFromElement: function() {
            return {
                x: this.left + this.width / 2,
                y: this.top + this.height / 2
            };
        },
        /**
     * This function is an helper for svg import. it decompose the transformMatrix
     * and assign properties to object.
     * untransformed coordinates
     * @private
     * @chainable
     */ _assignTransformMatrixProps: function() {
            if (this.transformMatrix) {
                var options = fabric.util.qrDecompose(this.transformMatrix);
                this.flipX = false;
                this.flipY = false;
                this.set("scaleX", options.scaleX);
                this.set("scaleY", options.scaleY);
                this.angle = options.angle;
                this.skewX = options.skewX;
                this.skewY = 0;
            }
        },
        /**
     * This function is an helper for svg import. it removes the transform matrix
     * and set to object properties that fabricjs can handle
     * @private
     * @param {Object} preserveAspectRatioOptions
     * @return {thisArg}
     */ _removeTransformMatrix: function(preserveAspectRatioOptions) {
            var center = this._findCenterFromElement();
            if (this.transformMatrix) {
                this._assignTransformMatrixProps();
                center = fabric.util.transformPoint(center, this.transformMatrix);
            }
            this.transformMatrix = null;
            if (preserveAspectRatioOptions) {
                this.scaleX *= preserveAspectRatioOptions.scaleX;
                this.scaleY *= preserveAspectRatioOptions.scaleY;
                this.cropX = preserveAspectRatioOptions.cropX;
                this.cropY = preserveAspectRatioOptions.cropY;
                center.x += preserveAspectRatioOptions.offsetLeft;
                center.y += preserveAspectRatioOptions.offsetTop;
                this.width = preserveAspectRatioOptions.width;
                this.height = preserveAspectRatioOptions.height;
            }
            this.setPositionByOrigin(center, "center", "center");
        },
        /**
     * Clones an instance, using a callback method will work for every object.
     * @param {Function} callback Callback is invoked with a clone as a first argument
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     */ clone: function(callback, propertiesToInclude) {
            var objectForm = this.toObject(propertiesToInclude);
            if (this.constructor.fromObject) this.constructor.fromObject(objectForm, callback);
            else fabric.Object._fromObject("Object", objectForm, callback);
        },
        /**
     * Creates an instance of fabric.Image out of an object
     * makes use of toCanvasElement.
     * Once this method was based on toDataUrl and loadImage, so it also had a quality
     * and format option. toCanvasElement is faster and produce no loss of quality.
     * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
     * toCanvasElement and then toBlob from the obtained canvas is also a good option.
     * This method is sync now, but still support the callback because we did not want to break.
     * When fabricJS 5.0 will be planned, this will probably be changed to not have a callback.
     * @param {Function} callback callback, invoked with an instance as a first argument
     * @param {Object} [options] for clone as image, passed to toDataURL
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {fabric.Object} thisArg
     */ cloneAsImage: function(callback, options) {
            var canvasEl = this.toCanvasElement(options);
            if (callback) callback(new fabric.Image(canvasEl));
            return this;
        },
        /**
     * Converts an object into a HTMLCanvas element
     * @param {Object} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the fabric.Object
     */ toCanvasElement: function(options) {
            options || (options = {});
            var utils = fabric.util, origParams = utils.saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs = Math.abs, multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
            delete this.group;
            if (options.withoutTransform) utils.resetObjectTransform(this);
            if (options.withoutShadow) this.shadow = null;
            var el = fabric.util.createCanvasElement(), // skip canvas zoom and calculate with setCoords now.
            boundingRect = this.getBoundingRect(true, true), shadow = this.shadow, scaling, shadowOffset = {
                x: 0,
                y: 0
            }, shadowBlur, width, height;
            if (shadow) {
                shadowBlur = shadow.blur;
                if (shadow.nonScaling) scaling = {
                    scaleX: 1,
                    scaleY: 1
                };
                else scaling = this.getObjectScaling();
                // consider non scaling shadow.
                shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.scaleX);
                shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.scaleY);
            }
            width = boundingRect.width + shadowOffset.x;
            height = boundingRect.height + shadowOffset.y;
            // if the current width/height is not an integer
            // we need to make it so.
            el.width = Math.ceil(width);
            el.height = Math.ceil(height);
            var canvas = new fabric.StaticCanvas(el, {
                enableRetinaScaling: false,
                renderOnAddRemove: false,
                skipOffscreen: false
            });
            if (options.format === "jpeg") canvas.backgroundColor = "#fff";
            this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), "center", "center");
            var originalCanvas = this.canvas;
            canvas.add(this);
            var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
            this.shadow = originalShadow;
            this.set("canvas", originalCanvas);
            if (originalGroup) this.group = originalGroup;
            this.set(origParams).setCoords();
            // canvas.dispose will call image.dispose that will nullify the elements
            // since this canvas is a simple element for the process, we remove references
            // to objects in this way in order to avoid object trashing.
            canvas._objects = [];
            canvas.dispose();
            canvas = null;
            return canvasEl;
        },
        /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */ toDataURL: function(options) {
            options || (options = {});
            return fabric.util.toDataURL(this.toCanvasElement(options), options.format || "png", options.quality || 1);
        },
        /**
     * Returns true if specified type is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */ isType: function(type) {
            return arguments.length > 1 ? Array.from(arguments).includes(this.type) : this.type === type;
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */ complexity: function() {
            return 1;
        },
        /**
     * Returns a JSON representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} JSON
     */ toJSON: function(propertiesToInclude) {
            // delegate, not alias
            return this.toObject(propertiesToInclude);
        },
        /**
     * Sets "angle" of an instance with centered rotation
     * @param {Number} angle Angle value (in degrees)
     * @return {fabric.Object} thisArg
     * @chainable
     */ rotate: function(angle) {
            var shouldCenterOrigin = (this.originX !== "center" || this.originY !== "center") && this.centeredRotation;
            if (shouldCenterOrigin) this._setOriginToCenter();
            this.set("angle", angle);
            if (shouldCenterOrigin) this._resetOrigin();
            return this;
        },
        /**
     * Centers object horizontally on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ centerH: function() {
            this.canvas && this.canvas.centerObjectH(this);
            return this;
        },
        /**
     * Centers object horizontally on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenterH: function() {
            this.canvas && this.canvas.viewportCenterObjectH(this);
            return this;
        },
        /**
     * Centers object vertically on canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ centerV: function() {
            this.canvas && this.canvas.centerObjectV(this);
            return this;
        },
        /**
     * Centers object vertically on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenterV: function() {
            this.canvas && this.canvas.viewportCenterObjectV(this);
            return this;
        },
        /**
     * Centers object vertically and horizontally on canvas to which is was added last
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ center: function() {
            this.canvas && this.canvas.centerObject(this);
            return this;
        },
        /**
     * Centers object on current viewport of canvas to which it was added last.
     * You might need to call `setCoords` on an object after centering, to update controls area.
     * @return {fabric.Object} thisArg
     * @chainable
     */ viewportCenter: function() {
            this.canvas && this.canvas.viewportCenterObject(this);
            return this;
        },
        /**
     * Returns coordinates of a pointer relative to an object
     * @param {Event} e Event to operate upon
     * @param {Object} [pointer] Pointer to operate upon (instead of event)
     * @return {Object} Coordinates of a pointer (x, y)
     */ getLocalPointer: function(e, pointer) {
            pointer = pointer || this.canvas.getPointer(e);
            var pClicked = new fabric.Point(pointer.x, pointer.y), objectLeftTop = this._getLeftTopCoords();
            if (this.angle) pClicked = fabric.util.rotatePoint(pClicked, objectLeftTop, degreesToRadians(-this.angle));
            return {
                x: pClicked.x - objectLeftTop.x,
                y: pClicked.y - objectLeftTop.y
            };
        },
        /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */ _setupCompositeOperation: function(ctx) {
            if (this.globalCompositeOperation) ctx.globalCompositeOperation = this.globalCompositeOperation;
        },
        /**
     * cancel instance's running animations
     * override if necessary to dispose artifacts such as `clipPath`
     */ dispose: function() {
            if (fabric.runningAnimations) fabric.runningAnimations.cancelByTarget(this);
        }
    });
    fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);
    extend(fabric.Object.prototype, fabric.Observable);
    /**
   * Defines the number of fraction digits to use when serializing object values.
   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type Number
   */ fabric.Object.NUM_FRACTION_DIGITS = 2;
    /**
   * Defines which properties should be enlivened from the object passed to {@link fabric.Object._fromObject}
   * @static
   * @memberOf fabric.Object
   * @constant
   * @type string[]
   */ fabric.Object.ENLIVEN_PROPS = [
        "clipPath"
    ];
    fabric.Object._fromObject = function(className, object, callback, extraParam) {
        var klass = fabric[className];
        object = clone(object, true);
        fabric.util.enlivenPatterns([
            object.fill,
            object.stroke
        ], function(patterns) {
            if (typeof patterns[0] !== "undefined") object.fill = patterns[0];
            if (typeof patterns[1] !== "undefined") object.stroke = patterns[1];
            fabric.util.enlivenObjectEnlivables(object, object, function() {
                var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
                callback && callback(instance);
            });
        });
    };
    /**
   * Unique id used internally when creating SVG elements
   * @static
   * @memberOf fabric.Object
   * @type Number
   */ fabric.Object.__uid = 0;
})($d47795690082d4de$exports);
(function() {
    var degreesToRadians = $d47795690082d4de$var$fabric.util.degreesToRadians, originXOffset = {
        left: -0.5,
        center: 0,
        right: 0.5
    }, originYOffset = {
        top: -0.5,
        center: 0,
        bottom: 0.5
    };
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
            var x = point.x, y = point.y, offsetX, offsetY, dim;
            if (typeof fromOriginX === "string") fromOriginX = originXOffset[fromOriginX];
            else fromOriginX -= 0.5;
            if (typeof toOriginX === "string") toOriginX = originXOffset[toOriginX];
            else toOriginX -= 0.5;
            offsetX = toOriginX - fromOriginX;
            if (typeof fromOriginY === "string") fromOriginY = originYOffset[fromOriginY];
            else fromOriginY -= 0.5;
            if (typeof toOriginY === "string") toOriginY = originYOffset[toOriginY];
            else toOriginY -= 0.5;
            offsetY = toOriginY - fromOriginY;
            if (offsetX || offsetY) {
                dim = this._getTransformedDimensions();
                x = point.x + offsetX * dim.x;
                y = point.y + offsetY * dim.y;
            }
            return new $d47795690082d4de$var$fabric.Point(x, y);
        },
        /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToCenterPoint: function(point, originX, originY) {
            var p = this.translateToGivenOrigin(point, originX, originY, "center", "center");
            if (this.angle) return $d47795690082d4de$var$fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
            return p;
        },
        /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {fabric.Point} center The point which corresponds to center of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ translateToOriginPoint: function(center, originX, originY) {
            var p = this.translateToGivenOrigin(center, "center", "center", originX, originY);
            if (this.angle) return $d47795690082d4de$var$fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
            return p;
        },
        /**
     * Returns the real center coordinates of the object
     * @return {fabric.Point}
     */ getCenterPoint: function() {
            var leftTop = new $d47795690082d4de$var$fabric.Point(this.left, this.top);
            return this.translateToCenterPoint(leftTop, this.originX, this.originY);
        },
        /**
     * Returns the coordinates of the object based on center coordinates
     * @param {fabric.Point} point The point which corresponds to the originX and originY params
     * @return {fabric.Point}
     */ // getOriginPoint: function(center) {
        //   return this.translateToOriginPoint(center, this.originX, this.originY);
        // },
        /**
     * Returns the coordinates of the object as if it has a different origin
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ getPointByOrigin: function(originX, originY) {
            var center = this.getCenterPoint();
            return this.translateToOriginPoint(center, originX, originY);
        },
        /**
     * Returns the point in local coordinates
     * @param {fabric.Point} point The point relative to the global coordinate system
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {fabric.Point}
     */ toLocalPoint: function(point, originX, originY) {
            var center = this.getCenterPoint(), p, p2;
            if (typeof originX !== "undefined" && typeof originY !== "undefined") p = this.translateToGivenOrigin(center, "center", "center", originX, originY);
            else p = new $d47795690082d4de$var$fabric.Point(this.left, this.top);
            p2 = new $d47795690082d4de$var$fabric.Point(point.x, point.y);
            if (this.angle) p2 = $d47795690082d4de$var$fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
            return p2.subtractEquals(p);
        },
        /**
     * Returns the point in global coordinates
     * @param {fabric.Point} The point relative to the local coordinate system
     * @return {fabric.Point}
     */ // toGlobalPoint: function(point) {
        //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
        // },
        /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {fabric.Point} pos The new position of the object
     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */ setPositionByOrigin: function(pos, originX, originY) {
            var center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
            this.set("left", position.x);
            this.set("top", position.y);
        },
        /**
     * @param {String} to One of 'left', 'center', 'right'
     */ adjustPosition: function(to) {
            var angle = degreesToRadians(this.angle), hypotFull = this.getScaledWidth(), xFull = $d47795690082d4de$var$fabric.util.cos(angle) * hypotFull, yFull = $d47795690082d4de$var$fabric.util.sin(angle) * hypotFull, offsetFrom, offsetTo;
            //TODO: this function does not consider mixed situation like top, center.
            if (typeof this.originX === "string") offsetFrom = originXOffset[this.originX];
            else offsetFrom = this.originX - 0.5;
            if (typeof to === "string") offsetTo = originXOffset[to];
            else offsetTo = to - 0.5;
            this.left += xFull * (offsetTo - offsetFrom);
            this.top += yFull * (offsetTo - offsetFrom);
            this.setCoords();
            this.originX = to;
        },
        /**
     * Sets the origin/position of the object to it's center point
     * @private
     * @return {void}
     */ _setOriginToCenter: function() {
            this._originalOriginX = this.originX;
            this._originalOriginY = this.originY;
            var center = this.getCenterPoint();
            this.originX = "center";
            this.originY = "center";
            this.left = center.x;
            this.top = center.y;
        },
        /**
     * Resets the origin/position of the object to it's original origin
     * @private
     * @return {void}
     */ _resetOrigin: function() {
            var originPoint = this.translateToOriginPoint(this.getCenterPoint(), this._originalOriginX, this._originalOriginY);
            this.originX = this._originalOriginX;
            this.originY = this._originalOriginY;
            this.left = originPoint.x;
            this.top = originPoint.y;
            this._originalOriginX = null;
            this._originalOriginY = null;
        },
        /**
     * @private
     */ _getLeftTopCoords: function() {
            return this.translateToOriginPoint(this.getCenterPoint(), "left", "top");
        }
    });
})();
(function() {
    function arrayFromCoords(coords) {
        return [
            new $d47795690082d4de$var$fabric.Point(coords.tl.x, coords.tl.y),
            new $d47795690082d4de$var$fabric.Point(coords.tr.x, coords.tr.y),
            new $d47795690082d4de$var$fabric.Point(coords.br.x, coords.br.y),
            new $d47795690082d4de$var$fabric.Point(coords.bl.x, coords.bl.y)
        ];
    }
    var util = $d47795690082d4de$var$fabric.util, degreesToRadians = util.degreesToRadians, multiplyMatrices = util.multiplyTransformMatrices, transformPoint = util.transformPoint;
    util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Describe object's corner position in canvas element coordinates.
     * properties are depending on control keys and padding the main controls.
     * each property is an object with x, y and corner.
     * The `corner` property contains in a similar manner the 4 points of the
     * interactive area of the corner.
     * The coordinates depends from the controls positionHandler and are used
     * to draw and locate controls
     * @memberOf fabric.Object.prototype
     */ oCoords: null,
        /**
     * Describe object's corner position in canvas object absolute coordinates
     * properties are tl,tr,bl,br and describe the four main corner.
     * each property is an object with x, y, instance of Fabric.Point.
     * The coordinates depends from this properties: width, height, scaleX, scaleY
     * skewX, skewY, angle, strokeWidth, top, left.
     * Those coordinates are useful to understand where an object is. They get updated
     * with oCoords but they do not need to be updated when zoom or panning change.
     * The coordinates get updated with @method setCoords.
     * You can calculate them without updating with @method calcACoords();
     * @memberOf fabric.Object.prototype
     */ aCoords: null,
        /**
     * Describe object's corner position in canvas element coordinates.
     * includes padding. Used of object detection.
     * set and refreshed with setCoords.
     * @memberOf fabric.Object.prototype
     */ lineCoords: null,
        /**
     * storage for object transform matrix
     */ ownMatrixCache: null,
        /**
     * storage for object full transform matrix
     */ matrixCache: null,
        /**
     * custom controls interface
     * controls are added by default_controls.js
     */ controls: {},
        /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * @param {Boolean} absolute will return aCoords if true or lineCoords
     * @return {Object} {tl, tr, br, bl} points
     */ _getCoords: function(absolute, calculate) {
            if (calculate) return absolute ? this.calcACoords() : this.calcLineCoords();
            if (!this.aCoords || !this.lineCoords) this.setCoords(true);
            return absolute ? this.aCoords : this.lineCoords;
        },
        /**
     * return correct set of coordinates for intersection
     * this will return either aCoords or lineCoords.
     * The coords are returned in an array.
     * @return {Array} [tl, tr, br, bl] of points
     */ getCoords: function(absolute, calculate) {
            return arrayFromCoords(this._getCoords(absolute, calculate));
        },
        /**
     * Checks if object intersects with an area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with an area formed by 2 points
     */ intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
            var coords = this.getCoords(absolute, calculate), intersection = $d47795690082d4de$var$fabric.Intersection.intersectPolygonRectangle(coords, pointTL, pointBR);
            return intersection.status === "Intersection";
        },
        /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object intersects with another object
     */ intersectsWithObject: function(other, absolute, calculate) {
            var intersection = $d47795690082d4de$var$fabric.Intersection.intersectPolygonPolygon(this.getCoords(absolute, calculate), other.getCoords(absolute, calculate));
            return intersection.status === "Intersection" || other.isContainedWithinObject(this, absolute, calculate) || this.isContainedWithinObject(other, absolute, calculate);
        },
        /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area of another object
     */ isContainedWithinObject: function(other, absolute, calculate) {
            var points = this.getCoords(absolute, calculate), otherCoords = absolute ? other.aCoords : other.lineCoords, i = 0, lines = other._getImageLines(otherCoords);
            for(; i < 4; i++){
                if (!other.containsPoint(points[i], lines)) return false;
            }
            return true;
        },
        /**
     * Checks if object is fully contained within area formed by 2 points
     * @param {Object} pointTL top-left point of area
     * @param {Object} pointBR bottom-right point of area
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is fully contained within area formed by 2 points
     */ isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
            var boundingRect = this.getBoundingRect(absolute, calculate);
            return boundingRect.left >= pointTL.x && boundingRect.left + boundingRect.width <= pointBR.x && boundingRect.top >= pointTL.y && boundingRect.top + boundingRect.height <= pointBR.y;
        },
        /**
     * Checks if point is inside the object
     * @param {fabric.Point} point Point to check against
     * @param {Object} [lines] object returned from @method _getImageLines
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if point is inside the object
     */ containsPoint: function(point, lines, absolute, calculate) {
            var coords = this._getCoords(absolute, calculate), lines = lines || this._getImageLines(coords), xPoints = this._findCrossPoints(point, lines);
            // if xPoints is odd then point is inside the object
            return xPoints !== 0 && xPoints % 2 === 1;
        },
        /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
     * @return {Boolean} true if object is fully or partially contained within canvas
     */ isOnScreen: function(calculate) {
            if (!this.canvas) return false;
            var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
            var points = this.getCoords(true, calculate);
            // if some point is on screen, the object is on screen.
            if (points.some(function(point) {
                return point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y;
            })) return true;
            // no points on screen, check intersection with absolute coordinates
            if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) return true;
            return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
     * Checks if the object contains the midpoint between canvas extremities
     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
     * @private
     * @param {Fabric.Point} pointTL Top Left point
     * @param {Fabric.Point} pointBR Top Right point
     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
     * @return {Boolean} true if the object contains the point
     */ _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
            // worst case scenario the object is so big that contains the screen
            var centerPoint = {
                x: (pointTL.x + pointBR.x) / 2,
                y: (pointTL.y + pointBR.y) / 2
            };
            if (this.containsPoint(centerPoint, null, true, calculate)) return true;
            return false;
        },
        /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
     * @return {Boolean} true if object is partially contained within canvas
     */ isPartiallyOnScreen: function(calculate) {
            if (!this.canvas) return false;
            var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
            if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) return true;
            var allPointsAreOutside = this.getCoords(true, calculate).every(function(point) {
                return (point.x >= pointBR.x || point.x <= pointTL.x) && (point.y >= pointBR.y || point.y <= pointTL.y);
            });
            return allPointsAreOutside && this._containsCenterOfCanvas(pointTL, pointBR, calculate);
        },
        /**
     * Method that returns an object with the object edges in it, given the coordinates of the corners
     * @private
     * @param {Object} oCoords Coordinates of the object corners
     */ _getImageLines: function(oCoords) {
            var lines = {
                topline: {
                    o: oCoords.tl,
                    d: oCoords.tr
                },
                rightline: {
                    o: oCoords.tr,
                    d: oCoords.br
                },
                bottomline: {
                    o: oCoords.br,
                    d: oCoords.bl
                },
                leftline: {
                    o: oCoords.bl,
                    d: oCoords.tl
                }
            };
            // // debugging
            // if (this.canvas.contextTop) {
            //   this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
            //
            //   this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
            //   this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
            // }
            return lines;
        },
        /**
     * Helper method to determine how many cross points are between the 4 object edges
     * and the horizontal line determined by a point on canvas
     * @private
     * @param {fabric.Point} point Point to check
     * @param {Object} lines Coordinates of the object being evaluated
     */ // remove yi, not used but left code here just in case.
        _findCrossPoints: function(point, lines) {
            var b1, b2, a1, a2, xi, xcount = 0, iLine;
            for(var lineKey in lines){
                iLine = lines[lineKey];
                // optimisation 1: line below point. no cross
                if (iLine.o.y < point.y && iLine.d.y < point.y) continue;
                // optimisation 2: line above point. no cross
                if (iLine.o.y >= point.y && iLine.d.y >= point.y) continue;
                // optimisation 3: vertical line case
                if (iLine.o.x === iLine.d.x && iLine.o.x >= point.x) xi = iLine.o.x;
                else {
                    b1 = 0;
                    b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
                    a1 = point.y - b1 * point.x;
                    a2 = iLine.o.y - b2 * iLine.o.x;
                    xi = -(a1 - a2) / (b1 - b2);
                // yi = a1 + b1 * xi;
                }
                // dont count xi < point.x cases
                if (xi >= point.x) xcount += 1;
                // optimisation 4: specific for square images
                if (xcount === 2) break;
            }
            return xcount;
        },
        /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @param {Boolean} [absolute] use coordinates without viewportTransform
     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
     * @return {Object} Object with left, top, width, height properties
     */ getBoundingRect: function(absolute, calculate) {
            var coords = this.getCoords(absolute, calculate);
            return util.makeBoundingBoxFromPoints(coords);
        },
        /**
     * Returns width of an object's bounding box counting transformations
     * before 2.0 it was named getWidth();
     * @return {Number} width value
     */ getScaledWidth: function() {
            return this._getTransformedDimensions().x;
        },
        /**
     * Returns height of an object bounding box counting transformations
     * before 2.0 it was named getHeight();
     * @return {Number} height value
     */ getScaledHeight: function() {
            return this._getTransformedDimensions().y;
        },
        /**
     * Makes sure the scale is valid and modifies it if necessary
     * @private
     * @param {Number} value
     * @return {Number}
     */ _constrainScale: function(value) {
            if (Math.abs(value) < this.minScaleLimit) {
                if (value < 0) return -this.minScaleLimit;
                else return this.minScaleLimit;
            } else if (value === 0) return 0.0001;
            return value;
        },
        /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {fabric.Object} thisArg
     * @chainable
     */ scale: function(value) {
            this._set("scaleX", value);
            this._set("scaleY", value);
            return this.setCoords();
        },
        /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */ scaleToWidth: function(value, absolute) {
            // adjust to bounding rect factor so that rotated shapes would fit as well
            var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
            return this.scale(value / this.width / boundingRectFactor);
        },
        /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @param {Boolean} absolute ignore viewport
     * @return {fabric.Object} thisArg
     * @chainable
     */ scaleToHeight: function(value, absolute) {
            // adjust to bounding rect factor so that rotated shapes would fit as well
            var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
            return this.scale(value / this.height / boundingRectFactor);
        },
        calcLineCoords: function() {
            var vpt = this.getViewportTransform(), padding = this.padding, angle = degreesToRadians(this.angle), cos = util.cos(angle), sin = util.sin(angle), cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP, aCoords = this.calcACoords();
            var lineCoords = {
                tl: transformPoint(aCoords.tl, vpt),
                tr: transformPoint(aCoords.tr, vpt),
                bl: transformPoint(aCoords.bl, vpt),
                br: transformPoint(aCoords.br, vpt)
            };
            if (padding) {
                lineCoords.tl.x -= cosPMinusSinP;
                lineCoords.tl.y -= cosPSinP;
                lineCoords.tr.x += cosPSinP;
                lineCoords.tr.y -= cosPMinusSinP;
                lineCoords.bl.x -= cosPSinP;
                lineCoords.bl.y += cosPMinusSinP;
                lineCoords.br.x += cosPMinusSinP;
                lineCoords.br.y += cosPSinP;
            }
            return lineCoords;
        },
        calcOCoords: function() {
            var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), vpt = this.getViewportTransform(), startMatrix = multiplyMatrices(vpt, translateMatrix), finalMatrix = multiplyMatrices(startMatrix, rotateMatrix), finalMatrix = multiplyMatrices(finalMatrix, [
                1 / vpt[0],
                0,
                0,
                1 / vpt[3],
                0,
                0
            ]), dim = this._calculateCurrentDimensions(), coords = {};
            this.forEachControl(function(control, key, fabricObject) {
                coords[key] = control.positionHandler(dim, finalMatrix, fabricObject);
            });
            // debug code
            // var canvas = this.canvas;
            // setTimeout(function() {
            //   canvas.contextTop.clearRect(0, 0, 700, 700);
            //   canvas.contextTop.fillStyle = 'green';
            //   Object.keys(coords).forEach(function(key) {
            //     var control = coords[key];
            //     canvas.contextTop.fillRect(control.x, control.y, 3, 3);
            //   });
            // }, 50);
            return coords;
        },
        calcACoords: function() {
            var rotateMatrix = this._calcRotateMatrix(), translateMatrix = this._calcTranslateMatrix(), finalMatrix = multiplyMatrices(translateMatrix, rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
            return {
                // corners
                tl: transformPoint({
                    x: -w,
                    y: -h
                }, finalMatrix),
                tr: transformPoint({
                    x: w,
                    y: -h
                }, finalMatrix),
                bl: transformPoint({
                    x: -w,
                    y: h
                }, finalMatrix),
                br: transformPoint({
                    x: w,
                    y: h
                }, finalMatrix)
            };
        },
        /**
     * Sets corner and controls position coordinates based on current angle, width and height, left and top.
     * oCoords are used to find the corners
     * aCoords are used to quickly find an object on the canvas
     * lineCoords are used to quickly find object during pointer events.
     * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
     *
     * @param {Boolean} [skipCorners] skip calculation of oCoords.
     * @return {fabric.Object} thisArg
     * @chainable
     */ setCoords: function(skipCorners) {
            this.aCoords = this.calcACoords();
            // in case we are in a group, for how the inner group target check works,
            // lineCoords are exactly aCoords. Since the vpt gets absorbed by the normalized pointer.
            this.lineCoords = this.group ? this.aCoords : this.calcLineCoords();
            if (skipCorners) return this;
            // set coordinates of the draggable boxes in the corners used to scale/rotate the image
            this.oCoords = this.calcOCoords();
            this._setCornerCoords && this._setCornerCoords();
            return this;
        },
        /**
     * calculate rotation matrix of an object
     * @return {Array} rotation matrix for the object
     */ _calcRotateMatrix: function() {
            return util.calcRotateMatrix(this);
        },
        /**
     * calculate the translation matrix for an object transform
     * @return {Array} rotation matrix for the object
     */ _calcTranslateMatrix: function() {
            var center = this.getCenterPoint();
            return [
                1,
                0,
                0,
                1,
                center.x,
                center.y
            ];
        },
        transformMatrixKey: function(skipGroup) {
            var sep = "_", prefix = "";
            if (!skipGroup && this.group) prefix = this.group.transformMatrixKey(skipGroup) + sep;
            return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY + sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY + sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
        },
        /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * There are some situation in which this is useful to avoid the fake rotation.
     * @return {Array} transform matrix for the object
     */ calcTransformMatrix: function(skipGroup) {
            var matrix = this.calcOwnMatrix();
            if (skipGroup || !this.group) return matrix;
            var key = this.transformMatrixKey(skipGroup), cache = this.matrixCache || (this.matrixCache = {});
            if (cache.key === key) return cache.value;
            if (this.group) matrix = multiplyMatrices(this.group.calcTransformMatrix(false), matrix);
            cache.key = key;
            cache.value = matrix;
            return matrix;
        },
        /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {Array} transform matrix for the object
     */ calcOwnMatrix: function() {
            var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
            if (cache.key === key) return cache.value;
            var tMatrix = this._calcTranslateMatrix(), options = {
                angle: this.angle,
                translateX: tMatrix[4],
                translateY: tMatrix[5],
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                skewX: this.skewX,
                skewY: this.skewY,
                flipX: this.flipX,
                flipY: this.flipY
            };
            cache.key = key;
            cache.value = util.composeMatrix(options);
            return cache.value;
        },
        /*
     * Calculate object dimensions from its properties
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */ _getNonTransformedDimensions: function() {
            var strokeWidth = this.strokeWidth, w = this.width + strokeWidth, h = this.height + strokeWidth;
            return {
                x: w,
                y: h
            };
        },
        /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param {Number} skewX, a value to override current skewX
     * @param {Number} skewY, a value to override current skewY
     * @private
     * @return {Object} .x width dimension
     * @return {Object} .y height dimension
     */ _getTransformedDimensions: function(skewX, skewY) {
            if (typeof skewX === "undefined") skewX = this.skewX;
            if (typeof skewY === "undefined") skewY = this.skewY;
            var dimensions, dimX, dimY, noSkew = skewX === 0 && skewY === 0;
            if (this.strokeUniform) {
                dimX = this.width;
                dimY = this.height;
            } else {
                dimensions = this._getNonTransformedDimensions();
                dimX = dimensions.x;
                dimY = dimensions.y;
            }
            if (noSkew) return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
            var bbox = util.sizeAfterTransform(dimX, dimY, {
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                skewX: skewX,
                skewY: skewY
            });
            return this._finalizeDimensions(bbox.x, bbox.y);
        },
        /*
     * Calculate object bounding box dimensions from its properties scale, skew.
     * @param Number width width of the bbox
     * @param Number height height of the bbox
     * @private
     * @return {Object} .x finalized width dimension
     * @return {Object} .y finalized height dimension
     */ _finalizeDimensions: function(width, height) {
            return this.strokeUniform ? {
                x: width + this.strokeWidth,
                y: height + this.strokeWidth
            } : {
                x: width,
                y: height
            };
        },
        /*
     * Calculate object dimensions for controls box, including padding and canvas zoom.
     * and active selection
     * private
     */ _calculateCurrentDimensions: function() {
            var vpt = this.getViewportTransform(), dim = this._getTransformedDimensions(), p = transformPoint(dim, vpt, true);
            return p.scalarAdd(2 * this.padding);
        }
    });
})();
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * Moves an object to the bottom of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */ sendToBack: function() {
        if (this.group) $d47795690082d4de$var$fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
        else if (this.canvas) this.canvas.sendToBack(this);
        return this;
    },
    /**
   * Moves an object to the top of the stack of drawn objects
   * @return {fabric.Object} thisArg
   * @chainable
   */ bringToFront: function() {
        if (this.group) $d47795690082d4de$var$fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
        else if (this.canvas) this.canvas.bringToFront(this);
        return this;
    },
    /**
   * Moves an object down in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */ sendBackwards: function(intersecting) {
        if (this.group) $d47795690082d4de$var$fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
        else if (this.canvas) this.canvas.sendBackwards(this, intersecting);
        return this;
    },
    /**
   * Moves an object up in stack of drawn objects
   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
   * @return {fabric.Object} thisArg
   * @chainable
   */ bringForward: function(intersecting) {
        if (this.group) $d47795690082d4de$var$fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
        else if (this.canvas) this.canvas.bringForward(this, intersecting);
        return this;
    },
    /**
   * Moves an object to specified level in stack of drawn objects
   * @param {Number} index New position of object
   * @return {fabric.Object} thisArg
   * @chainable
   */ moveTo: function(index) {
        if (this.group && this.group.type !== "activeSelection") $d47795690082d4de$var$fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
        else if (this.canvas) this.canvas.moveTo(this, index);
        return this;
    }
});
/* _TO_SVG_START_ */ (function() {
    function getSvgColorString(prop, value) {
        if (!value) return prop + ": none; ";
        else if (value.toLive) return prop + ": url(#SVGID_" + value.id + "); ";
        else {
            var color = new $d47795690082d4de$var$fabric.Color(value), str = prop + ": " + color.toRgb() + "; ", opacity = color.getAlpha();
            if (opacity !== 1) //change the color in rgb + opacity
            str += prop + "-opacity: " + opacity.toString() + "; ";
            return str;
        }
    }
    var toFixed = $d47795690082d4de$var$fabric.util.toFixed;
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */ getSvgStyles: function(skipShadow) {
            var fillRule = this.fillRule ? this.fillRule : "nonzero", strokeWidth = this.strokeWidth ? this.strokeWidth : "0", strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(" ") : "none", strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : "0", strokeLineCap = this.strokeLineCap ? this.strokeLineCap : "butt", strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : "miter", strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : "4", opacity = typeof this.opacity !== "undefined" ? this.opacity : "1", visibility = this.visible ? "" : " visibility: hidden;", filter = skipShadow ? "" : this.getSvgFilter(), fill = getSvgColorString("fill", this.fill), stroke = getSvgColorString("stroke", this.stroke);
            return [
                stroke,
                "stroke-width: ",
                strokeWidth,
                "; ",
                "stroke-dasharray: ",
                strokeDashArray,
                "; ",
                "stroke-linecap: ",
                strokeLineCap,
                "; ",
                "stroke-dashoffset: ",
                strokeDashOffset,
                "; ",
                "stroke-linejoin: ",
                strokeLineJoin,
                "; ",
                "stroke-miterlimit: ",
                strokeMiterLimit,
                "; ",
                fill,
                "fill-rule: ",
                fillRule,
                "; ",
                "opacity: ",
                opacity,
                ";",
                filter,
                visibility
            ].join("");
        },
        /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */ getSvgSpanStyles: function(style, useWhiteSpace) {
            var term = "; ";
            var fontFamily = style.fontFamily ? "font-family: " + (style.fontFamily.indexOf("'") === -1 && style.fontFamily.indexOf('"') === -1 ? "'" + style.fontFamily + "'" : style.fontFamily) + term : "";
            var strokeWidth = style.strokeWidth ? "stroke-width: " + style.strokeWidth + term : "", fontFamily = fontFamily, fontSize = style.fontSize ? "font-size: " + style.fontSize + "px" + term : "", fontStyle = style.fontStyle ? "font-style: " + style.fontStyle + term : "", fontWeight = style.fontWeight ? "font-weight: " + style.fontWeight + term : "", fill = style.fill ? getSvgColorString("fill", style.fill) : "", stroke = style.stroke ? getSvgColorString("stroke", style.stroke) : "", textDecoration = this.getSvgTextDecoration(style), deltaY = style.deltaY ? "baseline-shift: " + -style.deltaY + "; " : "";
            if (textDecoration) textDecoration = "text-decoration: " + textDecoration + term;
            return [
                stroke,
                strokeWidth,
                fontFamily,
                fontSize,
                fontStyle,
                fontWeight,
                textDecoration,
                fill,
                deltaY,
                useWhiteSpace ? "white-space: pre; " : ""
            ].join("");
        },
        /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */ getSvgTextDecoration: function(style) {
            return [
                "overline",
                "underline",
                "line-through"
            ].filter(function(decoration) {
                return style[decoration.replace("-", "")];
            }).join(" ");
        },
        /**
     * Returns filter for svg shadow
     * @return {String}
     */ getSvgFilter: function() {
            return this.shadow ? "filter: url(#SVGID_" + this.shadow.id + ");" : "";
        },
        /**
     * Returns id attribute for svg output
     * @return {String}
     */ getSvgCommons: function() {
            return [
                this.id ? 'id="' + this.id + '" ' : "",
                this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : ""
            ].join("");
        },
        /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */ getSvgTransform: function(full, additionalTransform) {
            var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(), svgTransform = 'transform="' + $d47795690082d4de$var$fabric.util.matrixToSVG(transform);
            return svgTransform + (additionalTransform || "") + '" ';
        },
        _setSVGBg: function(textBgRects) {
            if (this.backgroundColor) {
                var NUM_FRACTION_DIGITS = $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS;
                textBgRects.push("		<rect ", this._getFillAttributes(this.backgroundColor), ' x="', toFixed(-this.width / 2, NUM_FRACTION_DIGITS), '" y="', toFixed(-this.height / 2, NUM_FRACTION_DIGITS), '" width="', toFixed(this.width, NUM_FRACTION_DIGITS), '" height="', toFixed(this.height, NUM_FRACTION_DIGITS), '"></rect>\n');
            }
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            return this._createBaseSVGMarkup(this._toSVG(reviver), {
                reviver: reviver
            });
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
                reviver: reviver
            });
        },
        /**
     * @private
     */ _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
            options = options || {};
            var reviver = options.reviver, additionalTransform = options.additionalTransform || "", commonPieces = [
                this.getSvgTransform(true, additionalTransform),
                this.getSvgCommons()
            ].join(""), // insert commons in the markup, style and svgCommons
            index = objectMarkup.indexOf("COMMON_PARTS");
            objectMarkup[index] = commonPieces;
            return reviver ? reviver(objectMarkup.join("")) : objectMarkup.join("");
        },
        /**
     * @private
     */ _createBaseSVGMarkup: function(objectMarkup, options) {
            options = options || {};
            var noStyle = options.noStyle, reviver = options.reviver, styleInfo = noStyle ? "" : 'style="' + this.getSvgStyles() + '" ', shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : "", clipPath = this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : "", absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, commonPieces, markup = [], clipPathMarkup, // insert commons in the markup, style and svgCommons
            index = objectMarkup.indexOf("COMMON_PARTS"), additionalTransform = options.additionalTransform;
            if (clipPath) {
                clipPath.clipPathId = "CLIPPATH_" + $d47795690082d4de$var$fabric.Object.__uid++;
                clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' + clipPath.toClipPathSVG(reviver) + "</clipPath>\n";
            }
            if (absoluteClipPath) markup.push("<g ", shadowInfo, this.getSvgCommons(), " >\n");
            markup.push("<g ", this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : "", " >\n");
            commonPieces = [
                styleInfo,
                vectorEffect,
                noStyle ? "" : this.addPaintOrder(),
                " ",
                additionalTransform ? 'transform="' + additionalTransform + '" ' : ""
            ].join("");
            objectMarkup[index] = commonPieces;
            if (fill && fill.toLive) markup.push(fill.toSVG(this));
            if (stroke && stroke.toLive) markup.push(stroke.toSVG(this));
            if (shadow) markup.push(shadow.toSVG(this));
            if (clipPath) markup.push(clipPathMarkup);
            markup.push(objectMarkup.join(""));
            markup.push("</g>\n");
            absoluteClipPath && markup.push("</g>\n");
            return reviver ? reviver(markup.join("")) : markup.join("");
        },
        addPaintOrder: function() {
            return this.paintFirst !== "fill" ? ' paint-order="' + this.paintFirst + '" ' : "";
        }
    });
})();
/* _TO_SVG_END_ */ (function() {
    var extend = $d47795690082d4de$var$fabric.util.object.extend, originalSet = "stateProperties";
    /*
    Depends on `stateProperties`
  */ function saveProps(origin, destination, props) {
        var tmpObj = {}, deep = true;
        props.forEach(function(prop) {
            tmpObj[prop] = origin[prop];
        });
        extend(origin[destination], tmpObj, deep);
    }
    function _isEqual(origValue, currentValue, firstPass) {
        if (origValue === currentValue) // if the objects are identical, return
        return true;
        else if (Array.isArray(origValue)) {
            if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) return false;
            for(var i = 0, len = origValue.length; i < len; i++){
                if (!_isEqual(origValue[i], currentValue[i])) return false;
            }
            return true;
        } else if (origValue && typeof origValue === "object") {
            var keys = Object.keys(origValue), key;
            if (!currentValue || typeof currentValue !== "object" || !firstPass && keys.length !== Object.keys(currentValue).length) return false;
            for(var i = 0, len = keys.length; i < len; i++){
                key = keys[i];
                // since clipPath is in the statefull cache list and the clipPath objects
                // would be iterated as an object, this would lead to possible infinite recursion
                // we do not want to compare those.
                if (key === "canvas" || key === "group") continue;
                if (!_isEqual(origValue[key], currentValue[key])) return false;
            }
            return true;
        }
    }
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Returns true if object state (one of its state properties) was changed
     * @param {String} [propertySet] optional name for the set of property we want to save
     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
     */ hasStateChanged: function(propertySet) {
            propertySet = propertySet || originalSet;
            var dashedPropertySet = "_" + propertySet;
            if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) return true;
            return !_isEqual(this[dashedPropertySet], this, true);
        },
        /**
     * Saves state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */ saveState: function(options) {
            var propertySet = options && options.propertySet || originalSet, destination = "_" + propertySet;
            if (!this[destination]) return this.setupState(options);
            saveProps(this, destination, this[propertySet]);
            if (options && options.stateProperties) saveProps(this, destination, options.stateProperties);
            return this;
        },
        /**
     * Setups state of an object
     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
     * @return {fabric.Object} thisArg
     */ setupState: function(options) {
            options = options || {};
            var propertySet = options.propertySet || originalSet;
            options.propertySet = propertySet;
            this["_" + propertySet] = {};
            this.saveState(options);
            return this;
        }
    });
})();
(function() {
    var degreesToRadians = $d47795690082d4de$var$fabric.util.degreesToRadians;
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
        /**
     * Determines which corner has been clicked
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
     */ _findTargetCorner: function(pointer, forTouch) {
            // objects in group, anykind, are not self modificable,
            // must not return an hovered corner.
            if (!this.hasControls || this.group || !this.canvas || this.canvas._activeObject !== this) return false;
            var ex = pointer.x, ey = pointer.y, xPoints, lines, keys = Object.keys(this.oCoords), j = keys.length - 1, i;
            this.__corner = 0;
            // cycle in reverse order so we pick first the one on top
            for(; j >= 0; j--){
                i = keys[j];
                if (!this.isControlVisible(i)) continue;
                lines = this._getImageLines(forTouch ? this.oCoords[i].touchCorner : this.oCoords[i].corner);
                // // debugging
                //
                // this.canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
                //
                // this.canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
                // this.canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
                xPoints = this._findCrossPoints({
                    x: ex,
                    y: ey
                }, lines);
                if (xPoints !== 0 && xPoints % 2 === 1) {
                    this.__corner = i;
                    return i;
                }
            }
            return false;
        },
        /**
     * Calls a function for each control. The function gets called,
     * with the control, the object that is calling the iterator and the control's key
     * @param {Function} fn function to iterate over the controls over
     */ forEachControl: function(fn) {
            for(var i in this.controls)fn(this.controls[i], i, this);
        },
        /**
     * Sets the coordinates of the draggable boxes in the corners of
     * the image used to scale/rotate it.
     * note: if we would switch to ROUND corner area, all of this would disappear.
     * everything would resolve to a single point and a pythagorean theorem for the distance
     * @private
     */ _setCornerCoords: function() {
            var coords = this.oCoords;
            for(var control in coords){
                var controlObject = this.controls[control];
                coords[control].corner = controlObject.calcCornerCoords(this.angle, this.cornerSize, coords[control].x, coords[control].y, false);
                coords[control].touchCorner = controlObject.calcCornerCoords(this.angle, this.touchCornerSize, coords[control].x, coords[control].y, true);
            }
        },
        /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawSelectionBackground: function(ctx) {
            if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) return this;
            ctx.save();
            var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.canvas.viewportTransform;
            ctx.translate(center.x, center.y);
            ctx.scale(1 / vpt[0], 1 / vpt[3]);
            ctx.rotate(degreesToRadians(this.angle));
            ctx.fillStyle = this.selectionBackgroundColor;
            ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
            ctx.restore();
            return this;
        },
        /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawBorders: function(ctx, styleOverride) {
            styleOverride = styleOverride || {};
            var wh = this._calculateCurrentDimensions(), strokeWidth = this.borderScaleFactor, width = wh.x + strokeWidth, height = wh.y + strokeWidth, hasControls = typeof styleOverride.hasControls !== "undefined" ? styleOverride.hasControls : this.hasControls, shouldStroke = false;
            ctx.save();
            ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
            this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
            ctx.strokeRect(-width / 2, -height / 2, width, height);
            if (hasControls) {
                ctx.beginPath();
                this.forEachControl(function(control, key, fabricObject) {
                    // in this moment, the ctx is centered on the object.
                    // width and height of the above function are the size of the bbox.
                    if (control.withConnection && control.getVisibility(fabricObject, key)) {
                        // reset movement for each control
                        shouldStroke = true;
                        ctx.moveTo(control.x * width, control.y * height);
                        ctx.lineTo(control.x * width + control.offsetX, control.y * height + control.offsetY);
                    }
                });
                if (shouldStroke) ctx.stroke();
            }
            ctx.restore();
            return this;
        },
        /**
     * Draws borders of an object's bounding box when it is inside a group.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawBordersInGroup: function(ctx, options, styleOverride) {
            styleOverride = styleOverride || {};
            var bbox = $d47795690082d4de$var$fabric.util.sizeAfterTransform(this.width, this.height, options), strokeWidth = this.strokeWidth, strokeUniform = this.strokeUniform, borderScaleFactor = this.borderScaleFactor, width = bbox.x + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleX) + borderScaleFactor, height = bbox.y + strokeWidth * (strokeUniform ? this.canvas.getZoom() : options.scaleY) + borderScaleFactor;
            ctx.save();
            this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray);
            ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
            ctx.strokeRect(-width / 2, -height / 2, width, height);
            ctx.restore();
            return this;
        },
        /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Object} styleOverride object to override the object style
     * @return {fabric.Object} thisArg
     * @chainable
     */ drawControls: function(ctx, styleOverride) {
            styleOverride = styleOverride || {};
            ctx.save();
            var retinaScaling = this.canvas.getRetinaScaling(), matrix, p;
            ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
            ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
            if (!this.transparentCorners) ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
            this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray);
            this.setCoords();
            if (this.group) // fabricJS does not really support drawing controls inside groups,
            // this piece of code here helps having at least the control in places.
            // If an application needs to show some objects as selected because of some UI state
            // can still call Object._renderControls() on any object they desire, independently of groups.
            // using no padding, circular controls and hiding the rotating cursor is higly suggested,
            matrix = this.group.calcTransformMatrix();
            this.forEachControl(function(control, key, fabricObject) {
                p = fabricObject.oCoords[key];
                if (control.getVisibility(fabricObject, key)) {
                    if (matrix) p = $d47795690082d4de$var$fabric.util.transformPoint(p, matrix);
                    control.render(ctx, p.x, p.y, styleOverride, fabricObject);
                }
            });
            ctx.restore();
            return this;
        },
        /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @returns {Boolean} true if the specified control is visible, false otherwise
     */ isControlVisible: function(controlKey) {
            return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
        },
        /**
     * Sets the visibility of the specified control.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @return {fabric.Object} thisArg
     * @chainable
     */ setControlVisible: function(controlKey, visible) {
            if (!this._controlsVisibility) this._controlsVisibility = {};
            this._controlsVisibility[controlKey] = visible;
            return this;
        },
        /**
     * Sets the visibility state of object controls.
     * @param {Object} [options] Options object
     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
     * @return {fabric.Object} thisArg
     * @chainable
     */ setControlsVisibility: function(options) {
            options || (options = {});
            for(var p in options)this.setControlVisible(p, options[p]);
            return this;
        },
        /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */ onDeselect: function() {
        // implemented by sub-classes, as needed.
        },
        /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [options] options sent from the upper functions
     * @param {Event} [options.e] event if the process is generated by an event
     */ onSelect: function() {
        // implemented by sub-classes, as needed.
        }
    });
})();
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Animation duration (in ms) for fx* methods
   * @type Number
   * @default
   */ FX_DURATION: 500,
    /**
   * Centers object horizontally with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxCenterObjectH: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $d47795690082d4de$var$fabric.util.animate({
            target: this,
            startValue: object.left,
            endValue: this.getCenterPoint().x,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set("left", value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                object.setCoords();
                onComplete();
            }
        });
    },
    /**
   * Centers object vertically with animation.
   * @param {fabric.Object} object Object to center
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxCenterObjectV: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $d47795690082d4de$var$fabric.util.animate({
            target: this,
            startValue: object.top,
            endValue: this.getCenterPoint().y,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set("top", value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                object.setCoords();
                onComplete();
            }
        });
    },
    /**
   * Same as `fabric.Canvas#remove` but animated
   * @param {fabric.Object} object Object to remove
   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.AnimationContext} context
   */ fxRemove: function(object, callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $d47795690082d4de$var$fabric.util.animate({
            target: this,
            startValue: object.opacity,
            endValue: 0,
            duration: this.FX_DURATION,
            onChange: function(value) {
                object.set("opacity", value);
                _this.requestRenderAll();
                onChange();
            },
            onComplete: function() {
                _this.remove(object);
                onComplete();
            }
        });
    }
});
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * Animates object's properties
   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
   * @return {fabric.Object} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @return {fabric.AnimationContext | fabric.AnimationContext[]} animation context (or an array if passed multiple properties)
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   *
   * As string — one property
   *
   * object.animate('left', ...);
   * object.animate('left', { duration: ... });
   *
   */ animate: function() {
        if (arguments[0] && typeof arguments[0] === "object") {
            var propsToAnimate = [], prop, skipCallbacks, out = [];
            for(prop in arguments[0])propsToAnimate.push(prop);
            for(var i = 0, len = propsToAnimate.length; i < len; i++){
                prop = propsToAnimate[i];
                skipCallbacks = i !== len - 1;
                out.push(this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks));
            }
            return out;
        } else return this._animate.apply(this, arguments);
    },
    /**
   * @private
   * @param {String} property Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
   */ _animate: function(property, to, options, skipCallbacks) {
        var _this = this, propPair;
        to = to.toString();
        if (!options) options = {};
        else options = $d47795690082d4de$var$fabric.util.object.clone(options);
        if (~property.indexOf(".")) propPair = property.split(".");
        var propIsColor = _this.colorProperties.indexOf(property) > -1 || propPair && _this.colorProperties.indexOf(propPair[1]) > -1;
        var currentValue = propPair ? this.get(propPair[0])[propPair[1]] : this.get(property);
        if (!("from" in options)) options.from = currentValue;
        if (!propIsColor) {
            if (~to.indexOf("=")) to = currentValue + parseFloat(to.replace("=", ""));
            else to = parseFloat(to);
        }
        var _options = {
            target: this,
            startValue: options.from,
            endValue: to,
            byValue: options.by,
            easing: options.easing,
            duration: options.duration,
            abort: options.abort && function(value, valueProgress, timeProgress) {
                return options.abort.call(_this, value, valueProgress, timeProgress);
            },
            onChange: function(value, valueProgress, timeProgress) {
                if (propPair) _this[propPair[0]][propPair[1]] = value;
                else _this.set(property, value);
                if (skipCallbacks) return;
                options.onChange && options.onChange(value, valueProgress, timeProgress);
            },
            onComplete: function(value, valueProgress, timeProgress) {
                if (skipCallbacks) return;
                _this.setCoords();
                options.onComplete && options.onComplete(value, valueProgress, timeProgress);
            }
        };
        if (propIsColor) return $d47795690082d4de$var$fabric.util.animateColor(_options.startValue, _options.endValue, _options.duration, _options);
        else return $d47795690082d4de$var$fabric.util.animate(_options);
    }
});
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, clone = fabric.util.object.clone, coordProps = {
        x1: 1,
        x2: 1,
        y1: 1,
        y2: 1
    };
    if (fabric.Line) {
        fabric.warn("fabric.Line is already defined");
        return;
    }
    /**
   * Line class
   * @class fabric.Line
   * @extends fabric.Object
   * @see {@link fabric.Line#initialize} for constructor definition
   */ fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "line",
        /**
     * x value or first line edge
     * @type Number
     * @default
     */ x1: 0,
        /**
     * y value or first line edge
     * @type Number
     * @default
     */ y1: 0,
        /**
     * x value or second line edge
     * @type Number
     * @default
     */ x2: 0,
        /**
     * y value or second line edge
     * @type Number
     * @default
     */ y2: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("x1", "x2", "y1", "y2"),
        /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {fabric.Line} thisArg
     */ initialize: function(points, options) {
            if (!points) points = [
                0,
                0,
                0,
                0
            ];
            this.callSuper("initialize", options);
            this.set("x1", points[0]);
            this.set("y1", points[1]);
            this.set("x2", points[2]);
            this.set("y2", points[3]);
            this._setWidthHeight(options);
        },
        /**
     * @private
     * @param {Object} [options] Options
     */ _setWidthHeight: function(options) {
            options || (options = {});
            this.width = Math.abs(this.x2 - this.x1);
            this.height = Math.abs(this.y2 - this.y1);
            this.left = "left" in options ? options.left : this._getLeftToOriginX();
            this.top = "top" in options ? options.top : this._getTopToOriginY();
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     */ _set: function(key, value) {
            this.callSuper("_set", key, value);
            if (typeof coordProps[key] !== "undefined") this._setWidthHeight();
            return this;
        },
        /**
     * @private
     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
     */ _getLeftToOriginX: makeEdgeToOriginGetter({
            origin: "originX",
            axis1: "x1",
            axis2: "x2",
            dimension: "width"
        }, {
            nearest: "left",
            center: "center",
            farthest: "right"
        }),
        /**
     * @private
     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
     */ _getTopToOriginY: makeEdgeToOriginGetter({
            origin: "originY",
            axis1: "y1",
            axis2: "y2",
            dimension: "height"
        }, {
            nearest: "top",
            center: "center",
            farthest: "bottom"
        }),
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            var p = this.calcLinePoints();
            ctx.moveTo(p.x1, p.y1);
            ctx.lineTo(p.x2, p.y2);
            ctx.lineWidth = this.strokeWidth;
            // TODO: test this
            // make sure setting "fill" changes color of a line
            // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
            var origStrokeStyle = ctx.strokeStyle;
            ctx.strokeStyle = this.stroke || ctx.fillStyle;
            this.stroke && this._renderStroke(ctx);
            ctx.strokeStyle = origStrokeStyle;
        },
        /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Object} center point from element coordinates
     */ _findCenterFromElement: function() {
            return {
                x: (this.x1 + this.x2) / 2,
                y: (this.y1 + this.y2) / 2
            };
        },
        /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper("toObject", propertiesToInclude), this.calcLinePoints());
        },
        /*
     * Calculate object dimensions from its properties
     * @private
     */ _getNonTransformedDimensions: function() {
            var dim = this.callSuper("_getNonTransformedDimensions");
            if (this.strokeLineCap === "butt") {
                if (this.width === 0) dim.y -= this.strokeWidth;
                if (this.height === 0) dim.x -= this.strokeWidth;
            }
            return dim;
        },
        /**
     * Recalculates line points given width and height
     * @private
     */ calcLinePoints: function() {
            var xMult = this.x1 <= this.x2 ? -1 : 1, yMult = this.y1 <= this.y2 ? -1 : 1, x1 = xMult * this.width * 0.5, y1 = yMult * this.height * 0.5, x2 = xMult * this.width * -0.5, y2 = yMult * this.height * -0.5;
            return {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var p = this.calcLinePoints();
            return [
                "<line ",
                "COMMON_PARTS",
                'x1="',
                p.x1,
                '" y1="',
                p.y1,
                '" x2="',
                p.x2,
                '" y2="',
                p.y2,
                '" />\n'
            ];
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
   * @static
   * @memberOf fabric.Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */ fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat("x1 y1 x2 y2".split(" "));
    /**
   * Returns fabric.Line instance from an SVG element
   * @static
   * @memberOf fabric.Line
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */ fabric.Line.fromElement = function(element, callback, options) {
        options = options || {};
        var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES), points = [
            parsedAttributes.x1 || 0,
            parsedAttributes.y1 || 0,
            parsedAttributes.x2 || 0,
            parsedAttributes.y2 || 0
        ];
        callback(new fabric.Line(points, extend(parsedAttributes, options)));
    };
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Line instance from an object representation
   * @static
   * @memberOf fabric.Line
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */ fabric.Line.fromObject = function(object, callback) {
        function _callback(instance) {
            delete instance.points;
            callback && callback(instance);
        }
        var options = clone(object, true);
        options.points = [
            object.x1,
            object.y1,
            object.x2,
            object.y2
        ];
        fabric.Object._fromObject("Line", options, _callback, "points");
    };
    /**
   * Produces a function that calculates distance from canvas edge to Line origin.
   */ function makeEdgeToOriginGetter(propertyNames, originValues) {
        var origin = propertyNames.origin, axis1 = propertyNames.axis1, axis2 = propertyNames.axis2, dimension = propertyNames.dimension, nearest = originValues.nearest, center = originValues.center, farthest = originValues.farthest;
        return function() {
            switch(this.get(origin)){
                case nearest:
                    return Math.min(this.get(axis1), this.get(axis2));
                case center:
                    return Math.min(this.get(axis1), this.get(axis2)) + 0.5 * this.get(dimension);
                case farthest:
                    return Math.max(this.get(axis1), this.get(axis2));
            }
        };
    }
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), degreesToRadians = fabric.util.degreesToRadians;
    if (fabric.Circle) {
        fabric.warn("fabric.Circle is already defined.");
        return;
    }
    /**
   * Circle class
   * @class fabric.Circle
   * @extends fabric.Object
   * @see {@link fabric.Circle#initialize} for constructor definition
   */ fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "circle",
        /**
     * Radius of this circle
     * @type Number
     * @default
     */ radius: 0,
        /**
     * degrees of start of the circle.
     * probably will change to degrees in next major version
     * @type Number 0 - 359
     * @default 0
     */ startAngle: 0,
        /**
     * End angle of the circle
     * probably will change to degrees in next major version
     * @type Number 1 - 360
     * @default 360
     */ endAngle: 360,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("radius", "startAngle", "endAngle"),
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Circle} thisArg
     */ _set: function(key, value) {
            this.callSuper("_set", key, value);
            if (key === "radius") this.setRadius(value);
            return this;
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper("toObject", [
                "radius",
                "startAngle",
                "endAngle"
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var svgString, x = 0, y = 0, angle = (this.endAngle - this.startAngle) % 360;
            if (angle === 0) svgString = [
                "<circle ",
                "COMMON_PARTS",
                'cx="' + x + '" cy="' + y + '" ',
                'r="',
                this.radius,
                '" />\n'
            ];
            else {
                var start = degreesToRadians(this.startAngle), end = degreesToRadians(this.endAngle), radius = this.radius, startX = fabric.util.cos(start) * radius, startY = fabric.util.sin(start) * radius, endX = fabric.util.cos(end) * radius, endY = fabric.util.sin(end) * radius, largeFlag = angle > 180 ? "1" : "0";
                svgString = [
                    '<path d="M ' + startX + " " + startY,
                    " A " + radius + " " + radius,
                    " 0 ",
                    +largeFlag + " 1",
                    " " + endX + " " + endY,
                    '" ',
                    "COMMON_PARTS",
                    " />\n"
                ];
            }
            return svgString;
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            ctx.arc(0, 0, this.radius, degreesToRadians(this.startAngle), degreesToRadians(this.endAngle), false);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRadiusX: function() {
            return this.get("radius") * this.get("scaleX");
        },
        /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRadiusY: function() {
            return this.get("radius") * this.get("scaleY");
        },
        /**
     * Sets radius of an object (and updates width accordingly)
     * @return {fabric.Circle} thisArg
     */ setRadius: function(value) {
            this.radius = value;
            return this.set("width", value * 2).set("height", value * 2);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
   * @static
   * @memberOf fabric.Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */ fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat("cx cy r".split(" "));
    /**
   * Returns {@link fabric.Circle} instance from an SVG element
   * @static
   * @memberOf fabric.Circle
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @param {Object} [options] Options object
   * @throws {Error} If value of `r` attribute is missing or invalid
   */ fabric.Circle.fromElement = function(element, callback) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);
        if (!isValidRadius(parsedAttributes)) throw new Error("value of `r` attribute is required and can not be negative");
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
        callback(new fabric.Circle(parsedAttributes));
    };
    /**
   * @private
   */ function isValidRadius(attributes) {
        return "radius" in attributes && attributes.radius >= 0;
    }
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Circle} instance from an object representation
   * @static
   * @memberOf fabric.Circle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {void}
   */ fabric.Circle.fromObject = function(object, callback) {
        fabric.Object._fromObject("Circle", object, callback);
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.Triangle) {
        fabric.warn("fabric.Triangle is already defined");
        return;
    }
    /**
   * Triangle class
   * @class fabric.Triangle
   * @extends fabric.Object
   * @return {fabric.Triangle} thisArg
   * @see {@link fabric.Triangle#initialize} for constructor definition
   */ fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "triangle",
        /**
     * Width is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */ width: 100,
        /**
     * Height is set to 100 to compensate the old initialize code that was setting it to 100
     * @type Number
     * @default
     */ height: 100,
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            var widthBy2 = this.width / 2, heightBy2 = this.height / 2;
            ctx.beginPath();
            ctx.moveTo(-widthBy2, heightBy2);
            ctx.lineTo(0, -heightBy2);
            ctx.lineTo(widthBy2, heightBy2);
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var widthBy2 = this.width / 2, heightBy2 = this.height / 2, points = [
                -widthBy2 + " " + heightBy2,
                "0 " + -heightBy2,
                widthBy2 + " " + heightBy2
            ].join(",");
            return [
                "<polygon ",
                "COMMON_PARTS",
                'points="',
                points,
                '" />'
            ];
        }
    });
    /**
   * Returns {@link fabric.Triangle} instance from an object representation
   * @static
   * @memberOf fabric.Triangle
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   */ fabric.Triangle.fromObject = function(object, callback) {
        return fabric.Object._fromObject("Triangle", object, callback);
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), piBy2 = Math.PI * 2;
    if (fabric.Ellipse) {
        fabric.warn("fabric.Ellipse is already defined.");
        return;
    }
    /**
   * Ellipse class
   * @class fabric.Ellipse
   * @extends fabric.Object
   * @return {fabric.Ellipse} thisArg
   * @see {@link fabric.Ellipse#initialize} for constructor definition
   */ fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "ellipse",
        /**
     * Horizontal radius
     * @type Number
     * @default
     */ rx: 0,
        /**
     * Vertical radius
     * @type Number
     * @default
     */ ry: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("rx", "ry"),
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {fabric.Ellipse} thisArg
     */ initialize: function(options) {
            this.callSuper("initialize", options);
            this.set("rx", options && options.rx || 0);
            this.set("ry", options && options.ry || 0);
        },
        /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {fabric.Ellipse} thisArg
     */ _set: function(key, value) {
            this.callSuper("_set", key, value);
            switch(key){
                case "rx":
                    this.rx = value;
                    this.set("width", value * 2);
                    break;
                case "ry":
                    this.ry = value;
                    this.set("height", value * 2);
                    break;
            }
            return this;
        },
        /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRx: function() {
            return this.get("rx") * this.get("scaleX");
        },
        /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */ getRy: function() {
            return this.get("ry") * this.get("scaleY");
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper("toObject", [
                "rx",
                "ry"
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            return [
                "<ellipse ",
                "COMMON_PARTS",
                'cx="0" cy="0" ',
                'rx="',
                this.rx,
                '" ry="',
                this.ry,
                '" />\n'
            ];
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */ _render: function(ctx) {
            ctx.beginPath();
            ctx.save();
            ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
            ctx.arc(0, 0, this.rx, 0, piBy2, false);
            ctx.restore();
            this._renderPaintInOrder(ctx);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
   * @static
   * @memberOf fabric.Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */ fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat("cx cy rx ry".split(" "));
    /**
   * Returns {@link fabric.Ellipse} instance from an SVG element
   * @static
   * @memberOf fabric.Ellipse
   * @param {SVGElement} element Element to parse
   * @param {Function} [callback] Options callback invoked after parsing is finished
   * @return {fabric.Ellipse}
   */ fabric.Ellipse.fromElement = function(element, callback) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
        callback(new fabric.Ellipse(parsedAttributes));
    };
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Ellipse} instance from an object representation
   * @static
   * @memberOf fabric.Ellipse
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as first argument
   * @return {void}
   */ fabric.Ellipse.fromObject = function(object, callback) {
        fabric.Object._fromObject("Ellipse", object, callback);
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend;
    if (fabric.Rect) {
        fabric.warn("fabric.Rect is already defined");
        return;
    }
    /**
   * Rectangle class
   * @class fabric.Rect
   * @extends fabric.Object
   * @return {fabric.Rect} thisArg
   * @see {@link fabric.Rect#initialize} for constructor definition
   */ fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {
        /**
     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: fabric.Object.prototype.stateProperties.concat("rx", "ry"),
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "rect",
        /**
     * Horizontal border radius
     * @type Number
     * @default
     */ rx: 0,
        /**
     * Vertical border radius
     * @type Number
     * @default
     */ ry: 0,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("rx", "ry"),
        /**
     * Constructor
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(options) {
            this.callSuper("initialize", options);
            this._initRxRy();
        },
        /**
     * Initializes rx/ry attributes
     * @private
     */ _initRxRy: function() {
            if (this.rx && !this.ry) this.ry = this.rx;
            else if (this.ry && !this.rx) this.rx = this.ry;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            // 1x1 case (used in spray brush) optimization was removed because
            // with caching and higher zoom level this makes more damage than help
            var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0, ry = this.ry ? Math.min(this.ry, this.height / 2) : 0, w = this.width, h = this.height, x = -this.width / 2, y = -this.height / 2, isRounded = rx !== 0 || ry !== 0, /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */ k = 0.4477152502;
            ctx.beginPath();
            ctx.moveTo(x + rx, y);
            ctx.lineTo(x + w - rx, y);
            isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
            ctx.lineTo(x + w, y + h - ry);
            isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
            ctx.lineTo(x + rx, y + h);
            isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
            ctx.lineTo(x, y + ry);
            isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper("toObject", [
                "rx",
                "ry"
            ].concat(propertiesToInclude));
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var x = -this.width / 2, y = -this.height / 2;
            return [
                "<rect ",
                "COMMON_PARTS",
                'x="',
                x,
                '" y="',
                y,
                '" rx="',
                this.rx,
                '" ry="',
                this.ry,
                '" width="',
                this.width,
                '" height="',
                this.height,
                '" />\n'
            ];
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
   * @static
   * @memberOf fabric.Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */ fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat("x y rx ry width height".split(" "));
    /**
   * Returns {@link fabric.Rect} instance from an SVG element
   * @static
   * @memberOf fabric.Rect
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Rect.fromElement = function(element, callback, options) {
        if (!element) return callback(null);
        options = options || {};
        var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
        parsedAttributes.left = parsedAttributes.left || 0;
        parsedAttributes.top = parsedAttributes.top || 0;
        parsedAttributes.height = parsedAttributes.height || 0;
        parsedAttributes.width = parsedAttributes.width || 0;
        var rect = new fabric.Rect(extend(options ? fabric.util.object.clone(options) : {}, parsedAttributes));
        rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
        callback(rect);
    };
    /* _FROM_SVG_END_ */ /**
   * Returns {@link fabric.Rect} instance from an object representation
   * @static
   * @memberOf fabric.Rect
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
   */ fabric.Rect.fromObject = function(object, callback) {
        return fabric.Object._fromObject("Rect", object, callback);
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, min = fabric.util.array.min, max = fabric.util.array.max, toFixed = fabric.util.toFixed, projectStrokeOnPoints = fabric.util.projectStrokeOnPoints;
    if (fabric.Polyline) {
        fabric.warn("fabric.Polyline is already defined");
        return;
    }
    /**
   * Polyline class
   * @class fabric.Polyline
   * @extends fabric.Object
   * @see {@link fabric.Polyline#initialize} for constructor definition
   */ fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "polyline",
        /**
     * Points array
     * @type Array
     * @default
     */ points: null,
        /**
     * WARNING: Feature in progress
     * Calculate the exact bounding box taking in account strokeWidth on acute angles
     * this will be turned to true by default on fabric 6.0
     * maybe will be left in as an optimization since calculations may be slow
     * @deprecated
     * @type Boolean
     * @default false
     */ exactBoundingBox: false,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("points"),
        /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {fabric.Polyline} thisArg
     * @example
     * var poly = new fabric.Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */ initialize: function(points, options) {
            options = options || {};
            this.points = points || [];
            this.callSuper("initialize", options);
            this._setPositionDimensions(options);
        },
        /**
     * @private
     */ _projectStrokeOnPoints: function() {
            return projectStrokeOnPoints(this.points, this, true);
        },
        _setPositionDimensions: function(options) {
            var calcDim = this._calcDimensions(options), correctLeftTop, correctSize = this.exactBoundingBox ? this.strokeWidth : 0;
            this.width = calcDim.width - correctSize;
            this.height = calcDim.height - correctSize;
            if (!options.fromSVG) correctLeftTop = this.translateToGivenOrigin({
                // this looks bad, but is one way to keep it optional for now.
                x: calcDim.left - this.strokeWidth / 2 + correctSize / 2,
                y: calcDim.top - this.strokeWidth / 2 + correctSize / 2
            }, "left", "top", this.originX, this.originY);
            if (typeof options.left === "undefined") this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
            if (typeof options.top === "undefined") this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
            this.pathOffset = {
                x: calcDim.left + this.width / 2 + correctSize / 2,
                y: calcDim.top + this.height / 2 + correctSize / 2
            };
        },
        /**
     * Calculate the polygon min and max point from points array,
     * returning an object with left, top, width, height to measure the
     * polygon size
     * @return {Object} object.left X coordinate of the polygon leftmost point
     * @return {Object} object.top Y coordinate of the polygon topmost point
     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
     * @private
     */ _calcDimensions: function() {
            var points = this.exactBoundingBox ? this._projectStrokeOnPoints() : this.points, minX = min(points, "x") || 0, minY = min(points, "y") || 0, maxX = max(points, "x") || 0, maxY = max(points, "y") || 0, width = maxX - minX, height = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: width,
                height: height
            };
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper("toObject", propertiesToInclude), {
                points: this.points.concat()
            });
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
            for(var i = 0, len = this.points.length; i < len; i++)points.push(toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ",", toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), " ");
            return [
                "<" + this.type + " ",
                "COMMON_PARTS",
                'points="',
                points.join(""),
                '" />\n'
            ];
        },
        /* _TO_SVG_END_ */ /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ commonRender: function(ctx) {
            var point, len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
            if (!len || isNaN(this.points[len - 1].y)) // do not draw if no points or odd points
            // NaN comes from parseFloat of a empty string in parser
            return false;
            ctx.beginPath();
            ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
            for(var i = 0; i < len; i++){
                point = this.points[i];
                ctx.lineTo(point.x - x, point.y - y);
            }
            return true;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            if (!this.commonRender(ctx)) return;
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */ complexity: function() {
            return this.get("points").length;
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
   * @static
   * @memberOf fabric.Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */ fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
    /**
   * Returns fabric.Polyline instance from an SVG element
   * @static
   * @memberOf fabric.Polyline
   * @param {SVGElement} element Element to parser
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Polyline.fromElementGenerator = function(_class) {
        return function(element, callback, options) {
            if (!element) return callback(null);
            options || (options = {});
            var points = fabric.parsePointsAttribute(element.getAttribute("points")), parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
            parsedAttributes.fromSVG = true;
            callback(new fabric[_class](points, extend(parsedAttributes, options)));
        };
    };
    fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator("Polyline");
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Polyline instance from an object representation
   * @static
   * @memberOf fabric.Polyline
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */ fabric.Polyline.fromObject = function(object, callback) {
        return fabric.Object._fromObject("Polyline", object, callback, "points");
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), projectStrokeOnPoints = fabric.util.projectStrokeOnPoints;
    if (fabric.Polygon) {
        fabric.warn("fabric.Polygon is already defined");
        return;
    }
    /**
   * Polygon class
   * @class fabric.Polygon
   * @extends fabric.Polyline
   * @see {@link fabric.Polygon#initialize} for constructor definition
   */ fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "polygon",
        /**
     * @private
     */ _projectStrokeOnPoints: function() {
            return projectStrokeOnPoints(this.points, this);
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            if (!this.commonRender(ctx)) return;
            ctx.closePath();
            this._renderPaintInOrder(ctx);
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
   * @static
   * @memberOf fabric.Polygon
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
   */ fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
    /**
   * Returns {@link fabric.Polygon} instance from an SVG element
   * @static
   * @memberOf fabric.Polygon
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator("Polygon");
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Polygon instance from an object representation
   * @static
   * @memberOf fabric.Polygon
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   * @return {void}
   */ fabric.Polygon.fromObject = function(object, callback) {
        fabric.Object._fromObject("Polygon", object, callback, "points");
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), min = fabric.util.array.min, max = fabric.util.array.max, extend = fabric.util.object.extend, clone = fabric.util.object.clone, toFixed = fabric.util.toFixed;
    if (fabric.Path) {
        fabric.warn("fabric.Path is already defined");
        return;
    }
    /**
   * Path class
   * @class fabric.Path
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
   * @see {@link fabric.Path#initialize} for constructor definition
   */ fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "path",
        /**
     * Array of path points
     * @type Array
     * @default
     */ path: null,
        cacheProperties: fabric.Object.prototype.cacheProperties.concat("path", "fillRule"),
        stateProperties: fabric.Object.prototype.stateProperties.concat("path"),
        /**
     * Constructor
     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Object} [options] Options object
     * @return {fabric.Path} thisArg
     */ initialize: function(path, options) {
            options = clone(options || {});
            delete options.path;
            this.callSuper("initialize", options);
            this._setPath(path || [], options);
        },
        /**
    * @private
    * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
    * @param {Object} [options] Options object
    */ _setPath: function(path, options) {
            this.path = fabric.util.makePathSimpler(Array.isArray(path) ? path : fabric.util.parsePath(path));
            fabric.Polyline.prototype._setPositionDimensions.call(this, options || {});
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */ _renderPathCommands: function(ctx) {
            var current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, controlX = 0, controlY = 0, l = -this.pathOffset.x, t = -this.pathOffset.y;
            ctx.beginPath();
            for(var i = 0, len = this.path.length; i < len; ++i){
                current = this.path[i];
                switch(current[0]){
                    case "L":
                        x = current[1];
                        y = current[2];
                        ctx.lineTo(x + l, y + t);
                        break;
                    case "M":
                        x = current[1];
                        y = current[2];
                        subpathStartX = x;
                        subpathStartY = y;
                        ctx.moveTo(x + l, y + t);
                        break;
                    case "C":
                        x = current[5];
                        y = current[6];
                        controlX = current[3];
                        controlY = current[4];
                        ctx.bezierCurveTo(current[1] + l, current[2] + t, controlX + l, controlY + t, x + l, y + t);
                        break;
                    case "Q":
                        ctx.quadraticCurveTo(current[1] + l, current[2] + t, current[3] + l, current[4] + t);
                        x = current[3];
                        y = current[4];
                        controlX = current[1];
                        controlY = current[2];
                        break;
                    case "z":
                    case "Z":
                        x = subpathStartX;
                        y = subpathStartY;
                        ctx.closePath();
                        break;
                }
            }
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */ _render: function(ctx) {
            this._renderPathCommands(ctx);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Returns string representation of an instance
     * @return {String} string representation of an instance
     */ toString: function() {
            return "#<fabric.Path (" + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + " }>";
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return extend(this.callSuper("toObject", propertiesToInclude), {
                path: this.path.map(function(item) {
                    return item.slice();
                })
            });
        },
        /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            var o = this.toObject([
                "sourcePath"
            ].concat(propertiesToInclude));
            if (o.sourcePath) delete o.path;
            return o;
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var path = fabric.util.joinPath(this.path);
            return [
                "<path ",
                "COMMON_PARTS",
                'd="',
                path,
                '" stroke-linecap="round" ',
                "/>\n"
            ];
        },
        _getOffsetTransform: function() {
            var digits = fabric.Object.NUM_FRACTION_DIGITS;
            return " translate(" + toFixed(-this.pathOffset.x, digits) + ", " + toFixed(-this.pathOffset.y, digits) + ")";
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            var additionalTransform = this._getOffsetTransform();
            return "	" + this._createBaseClipPathSVGMarkup(this._toSVG(), {
                reviver: reviver,
                additionalTransform: additionalTransform
            });
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            var additionalTransform = this._getOffsetTransform();
            return this._createBaseSVGMarkup(this._toSVG(), {
                reviver: reviver,
                additionalTransform: additionalTransform
            });
        },
        /* _TO_SVG_END_ */ /**
     * Returns number representation of an instance complexity
     * @return {Number} complexity of this instance
     */ complexity: function() {
            return this.path.length;
        },
        /**
     * @private
     */ _calcDimensions: function() {
            var aX = [], aY = [], current, subpathStartX = 0, subpathStartY = 0, x = 0, y = 0, bounds;
            for(var i = 0, len = this.path.length; i < len; ++i){
                current = this.path[i];
                switch(current[0]){
                    case "L":
                        x = current[1];
                        y = current[2];
                        bounds = [];
                        break;
                    case "M":
                        x = current[1];
                        y = current[2];
                        subpathStartX = x;
                        subpathStartY = y;
                        bounds = [];
                        break;
                    case "C":
                        bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[3], current[4], current[5], current[6]);
                        x = current[5];
                        y = current[6];
                        break;
                    case "Q":
                        bounds = fabric.util.getBoundsOfCurve(x, y, current[1], current[2], current[1], current[2], current[3], current[4]);
                        x = current[3];
                        y = current[4];
                        break;
                    case "z":
                    case "Z":
                        x = subpathStartX;
                        y = subpathStartY;
                        break;
                }
                bounds.forEach(function(point) {
                    aX.push(point.x);
                    aY.push(point.y);
                });
                aX.push(x);
                aY.push(y);
            }
            var minX = min(aX) || 0, minY = min(aY) || 0, maxX = max(aX) || 0, maxY = max(aY) || 0, deltaX = maxX - minX, deltaY = maxY - minY;
            return {
                left: minX,
                top: minY,
                width: deltaX,
                height: deltaY
            };
        }
    });
    /**
   * Creates an instance of fabric.Path from an object
   * @static
   * @memberOf fabric.Path
   * @param {Object} object
   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
   */ fabric.Path.fromObject = function(object, callback) {
        if (typeof object.sourcePath === "string") {
            var pathUrl = object.sourcePath;
            fabric.loadSVGFromURL(pathUrl, function(elements) {
                var path = elements[0];
                path.setOptions(object);
                if (object.clipPath) fabric.util.enlivenObjects([
                    object.clipPath
                ], function(elivenedObjects) {
                    path.clipPath = elivenedObjects[0];
                    callback && callback(path);
                });
                else callback && callback(path);
            });
        } else fabric.Object._fromObject("Path", object, callback, "path");
    };
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
   * @static
   * @memberOf fabric.Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */ fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat([
        "d"
    ]);
    /**
   * Creates an instance of fabric.Path from an SVG <path> element
   * @static
   * @memberOf fabric.Path
   * @param {SVGElement} element to parse
   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
   * @param {Object} [options] Options object
   * @param {Function} [callback] Options callback invoked after parsing is finished
   */ fabric.Path.fromElement = function(element, callback, options) {
        var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
        parsedAttributes.fromSVG = true;
        callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
    };
/* _FROM_SVG_END_ */ })($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), min = fabric.util.array.min, max = fabric.util.array.max;
    if (fabric.Group) return;
    /**
   * Group class
   * @class fabric.Group
   * @extends fabric.Object
   * @mixes fabric.Collection
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.Group#initialize} for constructor definition
   */ fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "group",
        /**
     * Width of stroke
     * @type Number
     * @default
     */ strokeWidth: 0,
        /**
     * Indicates if click, mouseover, mouseout events & hoverCursor should also check for subtargets
     * @type Boolean
     * @default
     */ subTargetCheck: false,
        /**
     * Groups are container, do not render anything on theyr own, ence no cache properties
     * @type Array
     * @default
     */ cacheProperties: [],
        /**
     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
     * available setting this boolean to true.
     * @type Boolean
     * @since 2.0.0
     * @default
     */ useSetOnGroup: false,
        /**
     * Constructor
     * @param {Object} objects Group objects
     * @param {Object} [options] Options object
     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
     * @return {Object} thisArg
     */ initialize: function(objects, options, isAlreadyGrouped) {
            options = options || {};
            this._objects = [];
            // if objects enclosed in a group have been grouped already,
            // we cannot change properties of objects.
            // Thus we need to set options to group without objects,
            isAlreadyGrouped && this.callSuper("initialize", options);
            this._objects = objects || [];
            for(var i = this._objects.length; i--;)this._objects[i].group = this;
            if (!isAlreadyGrouped) {
                var center = options && options.centerPoint;
                // we want to set origins before calculating the bounding box.
                // so that the topleft can be set with that in mind.
                // if specific top and left are passed, are overwritten later
                // with the callSuper('initialize', options)
                if (options.originX !== undefined) this.originX = options.originX;
                if (options.originY !== undefined) this.originY = options.originY;
                // if coming from svg i do not want to calc bounds.
                // i assume width and height are passed along options
                center || this._calcBounds();
                this._updateObjectsCoords(center);
                delete options.centerPoint;
                this.callSuper("initialize", options);
            } else this._updateObjectsACoords();
            this.setCoords();
        },
        /**
     * @private
     */ _updateObjectsACoords: function() {
            var skipControls = true;
            for(var i = this._objects.length; i--;)this._objects[i].setCoords(skipControls);
        },
        /**
     * @private
     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
     */ _updateObjectsCoords: function(center) {
            var center = center || this.getCenterPoint();
            for(var i = this._objects.length; i--;)this._updateObjectCoords(this._objects[i], center);
        },
        /**
     * @private
     * @param {Object} object
     * @param {fabric.Point} center, current center of group.
     */ _updateObjectCoords: function(object, center) {
            var objectLeft = object.left, objectTop = object.top, skipControls = true;
            object.set({
                left: objectLeft - center.x,
                top: objectTop - center.y
            });
            object.group = this;
            object.setCoords(skipControls);
        },
        /**
     * Returns string represenation of a group
     * @return {String}
     */ toString: function() {
            return "#<fabric.Group: (" + this.complexity() + ")>";
        },
        /**
     * Adds an object to a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */ addWithUpdate: function(object) {
            var nested = !!this.group;
            this._restoreObjectsState();
            fabric.util.resetObjectTransform(this);
            if (object) {
                if (nested) // if this group is inside another group, we need to pre transform the object
                fabric.util.removeTransformFromObject(object, this.group.calcTransformMatrix());
                this._objects.push(object);
                object.group = this;
                object._set("canvas", this.canvas);
            }
            this._calcBounds();
            this._updateObjectsCoords();
            this.dirty = true;
            if (nested) this.group.addWithUpdate();
            else this.setCoords();
            return this;
        },
        /**
     * Removes an object from a group; Then recalculates group's dimension, position.
     * @param {Object} object
     * @return {fabric.Group} thisArg
     * @chainable
     */ removeWithUpdate: function(object) {
            this._restoreObjectsState();
            fabric.util.resetObjectTransform(this);
            this.remove(object);
            this._calcBounds();
            this._updateObjectsCoords();
            this.setCoords();
            this.dirty = true;
            return this;
        },
        /**
     * @private
     */ _onObjectAdded: function(object) {
            this.dirty = true;
            object.group = this;
            object._set("canvas", this.canvas);
        },
        /**
     * @private
     */ _onObjectRemoved: function(object) {
            this.dirty = true;
            delete object.group;
        },
        /**
     * @private
     */ _set: function(key, value) {
            var i = this._objects.length;
            if (this.useSetOnGroup) while(i--)this._objects[i].setOnGroup(key, value);
            if (key === "canvas") while(i--)this._objects[i]._set(key, value);
            fabric.Object.prototype._set.call(this, key, value);
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var _includeDefaultValues = this.includeDefaultValues;
            var objsToObject = this._objects.filter(function(obj) {
                return !obj.excludeFromExport;
            }).map(function(obj) {
                var originalDefaults = obj.includeDefaultValues;
                obj.includeDefaultValues = _includeDefaultValues;
                var _obj = obj.toObject(propertiesToInclude);
                obj.includeDefaultValues = originalDefaults;
                return _obj;
            });
            var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
            obj.objects = objsToObject;
            return obj;
        },
        /**
     * Returns object representation of an instance, in dataless mode.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toDatalessObject: function(propertiesToInclude) {
            var objsToObject, sourcePath = this.sourcePath;
            if (sourcePath) objsToObject = sourcePath;
            else {
                var _includeDefaultValues = this.includeDefaultValues;
                objsToObject = this._objects.map(function(obj) {
                    var originalDefaults = obj.includeDefaultValues;
                    obj.includeDefaultValues = _includeDefaultValues;
                    var _obj = obj.toDatalessObject(propertiesToInclude);
                    obj.includeDefaultValues = originalDefaults;
                    return _obj;
                });
            }
            var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
            obj.objects = objsToObject;
            return obj;
        },
        /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */ render: function(ctx) {
            this._transformDone = true;
            this.callSuper("render", ctx);
            this._transformDone = false;
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */ shouldCache: function() {
            var ownCache = fabric.Object.prototype.shouldCache.call(this);
            if (ownCache) {
                for(var i = 0, len = this._objects.length; i < len; i++)if (this._objects[i].willDrawShadow()) {
                    this.ownCaching = false;
                    return false;
                }
            }
            return ownCache;
        },
        /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */ willDrawShadow: function() {
            if (fabric.Object.prototype.willDrawShadow.call(this)) return true;
            for(var i = 0, len = this._objects.length; i < len; i++){
                if (this._objects[i].willDrawShadow()) return true;
            }
            return false;
        },
        /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */ isOnACache: function() {
            return this.ownCaching || this.group && this.group.isOnACache();
        },
        /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawObject: function(ctx) {
            for(var i = 0, len = this._objects.length; i < len; i++)this._objects[i].render(ctx);
            this._drawClipPath(ctx, this.clipPath);
        },
        /**
     * Check if cache is dirty
     */ isCacheDirty: function(skipCanvas) {
            if (this.callSuper("isCacheDirty", skipCanvas)) return true;
            if (!this.statefullCache) return false;
            for(var i = 0, len = this._objects.length; i < len; i++)if (this._objects[i].isCacheDirty(true)) {
                if (this._cacheCanvas) {
                    // if this group has not a cache canvas there is nothing to clean
                    var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
                    this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
                }
                return true;
            }
            return false;
        },
        /**
     * Restores original state of each of group objects (original state is that which was before group was created).
     * if the nested boolean is true, the original state will be restored just for the
     * first group and not for all the group chain
     * @private
     * @param {Boolean} nested tell the function to restore object state up to the parent group and not more
     * @return {fabric.Group} thisArg
     * @chainable
     */ _restoreObjectsState: function() {
            var groupMatrix = this.calcOwnMatrix();
            this._objects.forEach(function(object) {
                // instead of using _this = this;
                fabric.util.addTransformToObject(object, groupMatrix);
                delete object.group;
                object.setCoords();
            });
            return this;
        },
        /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */ destroy: function() {
            // when group is destroyed objects needs to get a repaint to be eventually
            // displayed on canvas.
            this._objects.forEach(function(object) {
                object.set("dirty", true);
            });
            return this._restoreObjectsState();
        },
        dispose: function() {
            this.callSuper("dispose");
            this.forEachObject(function(object) {
                object.dispose && object.dispose();
            });
            this._objects = [];
        },
        /**
     * make a group an active selection, remove the group from canvas
     * the group has to be on canvas for this to work.
     * @return {fabric.ActiveSelection} thisArg
     * @chainable
     */ toActiveSelection: function() {
            if (!this.canvas) return;
            var objects = this._objects, canvas = this.canvas;
            this._objects = [];
            var options = this.toObject();
            delete options.objects;
            var activeSelection = new fabric.ActiveSelection([]);
            activeSelection.set(options);
            activeSelection.type = "activeSelection";
            canvas.remove(this);
            objects.forEach(function(object) {
                object.group = activeSelection;
                object.dirty = true;
                canvas.add(object);
            });
            activeSelection.canvas = canvas;
            activeSelection._objects = objects;
            canvas._activeObject = activeSelection;
            activeSelection.setCoords();
            return activeSelection;
        },
        /**
     * Destroys a group (restoring state of its objects)
     * @return {fabric.Group} thisArg
     * @chainable
     */ ungroupOnCanvas: function() {
            return this._restoreObjectsState();
        },
        /**
     * Sets coordinates of all objects inside group
     * @return {fabric.Group} thisArg
     * @chainable
     */ setObjectsCoords: function() {
            var skipControls = true;
            this.forEachObject(function(object) {
                object.setCoords(skipControls);
            });
            return this;
        },
        /**
     * @private
     */ _calcBounds: function(onlyWidthHeight) {
            var aX = [], aY = [], o, prop, coords, props = [
                "tr",
                "br",
                "bl",
                "tl"
            ], i = 0, iLen = this._objects.length, j, jLen = props.length;
            for(; i < iLen; ++i){
                o = this._objects[i];
                coords = o.calcACoords();
                for(j = 0; j < jLen; j++){
                    prop = props[j];
                    aX.push(coords[prop].x);
                    aY.push(coords[prop].y);
                }
                o.aCoords = coords;
            }
            this._getBounds(aX, aY, onlyWidthHeight);
        },
        /**
     * @private
     */ _getBounds: function(aX, aY, onlyWidthHeight) {
            var minXY = new fabric.Point(min(aX), min(aY)), maxXY = new fabric.Point(max(aX), max(aY)), top = minXY.y || 0, left = minXY.x || 0, width = maxXY.x - minXY.x || 0, height = maxXY.y - minXY.y || 0;
            this.width = width;
            this.height = height;
            if (!onlyWidthHeight) // the bounding box always finds the topleft most corner.
            // whatever is the group origin, we set up here the left/top position.
            this.setPositionByOrigin({
                x: left,
                y: top
            }, "left", "top");
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ _toSVG: function(reviver) {
            var svgString = [
                "<g ",
                "COMMON_PARTS",
                " >\n"
            ];
            for(var i = 0, len = this._objects.length; i < len; i++)svgString.push("		", this._objects[i].toSVG(reviver));
            svgString.push("</g>\n");
            return svgString;
        },
        /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */ getSvgStyles: function() {
            var opacity = typeof this.opacity !== "undefined" && this.opacity !== 1 ? "opacity: " + this.opacity + ";" : "", visibility = this.visible ? "" : " visibility: hidden;";
            return [
                opacity,
                this.getSvgFilter(),
                visibility
            ].join("");
        },
        /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toClipPathSVG: function(reviver) {
            var svgString = [];
            for(var i = 0, len = this._objects.length; i < len; i++)svgString.push("	", this._objects[i].toClipPathSVG(reviver));
            return this._createBaseClipPathSVGMarkup(svgString, {
                reviver: reviver
            });
        }
    });
    /**
   * Returns {@link fabric.Group} instance from an object representation
   * @static
   * @memberOf fabric.Group
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an group instance is created
   */ fabric.Group.fromObject = function(object, callback) {
        var objects = object.objects, options = fabric.util.object.clone(object, true);
        delete options.objects;
        if (typeof objects === "string") {
            // it has to be an url or something went wrong.
            fabric.loadSVGFromURL(objects, function(elements) {
                var group = fabric.util.groupSVGElements(elements, object, objects);
                var clipPath = options.clipPath;
                delete options.clipPath;
                group.set(options);
                if (clipPath) fabric.util.enlivenObjects([
                    clipPath
                ], function(elivenedObjects) {
                    group.clipPath = elivenedObjects[0];
                    callback && callback(group);
                });
                else callback && callback(group);
            });
            return;
        }
        fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
            fabric.util.enlivenObjectEnlivables(object, options, function() {
                callback && callback(new fabric.Group(enlivenedObjects, options, true));
            });
        });
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {});
    if (fabric.ActiveSelection) return;
    /**
   * Group class
   * @class fabric.ActiveSelection
   * @extends fabric.Group
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
   */ fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "activeSelection",
        /**
     * Constructor
     * @param {Object} objects ActiveSelection objects
     * @param {Object} [options] Options object
     * @return {Object} thisArg
     */ initialize: function(objects, options) {
            options = options || {};
            this._objects = objects || [];
            for(var i = this._objects.length; i--;)this._objects[i].group = this;
            if (options.originX) this.originX = options.originX;
            if (options.originY) this.originY = options.originY;
            this._calcBounds();
            this._updateObjectsCoords();
            fabric.Object.prototype.initialize.call(this, options);
            this.setCoords();
        },
        /**
     * Change te activeSelection to a normal group,
     * High level function that automatically adds it to canvas as
     * active object. no events fired.
     * @since 2.0.0
     * @return {fabric.Group}
     */ toGroup: function() {
            var objects = this._objects.concat();
            this._objects = [];
            var options = fabric.Object.prototype.toObject.call(this);
            var newGroup = new fabric.Group([]);
            delete options.type;
            newGroup.set(options);
            objects.forEach(function(object) {
                object.canvas.remove(object);
                object.group = newGroup;
            });
            newGroup._objects = objects;
            if (!this.canvas) return newGroup;
            var canvas = this.canvas;
            canvas.add(newGroup);
            canvas._activeObject = newGroup;
            newGroup.setCoords();
            return newGroup;
        },
        /**
     * If returns true, deselection is cancelled.
     * @since 2.0.0
     * @return {Boolean} [cancel]
     */ onDeselect: function() {
            this.destroy();
            return false;
        },
        /**
     * Returns string representation of a group
     * @return {String}
     */ toString: function() {
            return "#<fabric.ActiveSelection: (" + this.complexity() + ")>";
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * @return {Boolean}
     */ shouldCache: function() {
            return false;
        },
        /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */ isOnACache: function() {
            return false;
        },
        /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */ _renderControls: function(ctx, styleOverride, childrenOverride) {
            ctx.save();
            ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
            this.callSuper("_renderControls", ctx, styleOverride);
            childrenOverride = childrenOverride || {};
            if (typeof childrenOverride.hasControls === "undefined") childrenOverride.hasControls = false;
            childrenOverride.forActiveSelection = true;
            for(var i = 0, len = this._objects.length; i < len; i++)this._objects[i]._renderControls(ctx, childrenOverride);
            ctx.restore();
        }
    });
    /**
   * Returns {@link fabric.ActiveSelection} instance from an object representation
   * @static
   * @memberOf fabric.ActiveSelection
   * @param {Object} object Object to create a group from
   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
   */ fabric.ActiveSelection.fromObject = function(object, callback) {
        fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
            delete object.objects;
            callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
        });
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var extend = $d47795690082d4de$var$fabric.util.object.extend;
    if (!global.fabric) global.fabric = {};
    if (global.fabric.Image) {
        $d47795690082d4de$var$fabric.warn("fabric.Image is already defined.");
        return;
    }
    /**
   * Image class
   * @class fabric.Image
   * @extends fabric.Object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   * @see {@link fabric.Image#initialize} for constructor definition
   */ $d47795690082d4de$var$fabric.Image = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.Object, /** @lends fabric.Image.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "image",
        /**
     * Width of a stroke.
     * For image quality a stroke multiple of 2 gives better results.
     * @type Number
     * @default
     */ strokeWidth: 0,
        /**
     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default
     */ srcFromAttribute: false,
        /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */ _lastScaleX: 1,
        /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */ _lastScaleY: 1,
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ _filterScalingX: 1,
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ _filterScalingY: 1,
        /**
     * minimum scale factor under which any resizeFilter is triggered to resize the image
     * 0 will disable the automatic resize. 1 will trigger automatically always.
     * number bigger than 1 are not implemented yet.
     * @type Number
     */ minimumScaleTrigger: 0.5,
        /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: $d47795690082d4de$var$fabric.Object.prototype.stateProperties.concat("cropX", "cropY"),
        /**
     * List of properties to consider when checking if cache needs refresh
     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
     * and refreshed at the next render
     * @type Array
     */ cacheProperties: $d47795690082d4de$var$fabric.Object.prototype.cacheProperties.concat("cropX", "cropY"),
        /**
     * key used to retrieve the texture representing this image
     * @since 2.0.0
     * @type String
     * @default
     */ cacheKey: "",
        /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */ cropX: 0,
        /**
     * Image crop in pixels from original image size.
     * @since 2.0.0
     * @type Number
     * @default
     */ cropY: 0,
        /**
     * Indicates whether this canvas will use image smoothing when painting this image.
     * Also influence if the cacheCanvas for this image uses imageSmoothing
     * @since 4.0.0-beta.11
     * @type Boolean
     * @default
     */ imageSmoothing: true,
        /**
     * Constructor
     * Image can be initialized with any canvas drawable or a string.
     * The string should be a url and will be loaded as an image.
     * Canvas and Image element work out of the box, while videos require extra code to work.
     * Please check video element events for seeking.
     * @param {HTMLImageElement | HTMLCanvasElement | HTMLVideoElement | String} element Image element
     * @param {Object} [options] Options object
     * @param {function} [callback] callback function to call after eventual filters applied.
     * @return {fabric.Image} thisArg
     */ initialize: function(element, options) {
            options || (options = {});
            this.filters = [];
            this.cacheKey = "texture" + $d47795690082d4de$var$fabric.Object.__uid++;
            this.callSuper("initialize", options);
            this._initElement(element, options);
        },
        /**
     * Returns image element which this instance if based on
     * @return {HTMLImageElement} Image element
     */ getElement: function() {
            return this._element || {};
        },
        /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Object} [options] Options object
     * @return {fabric.Image} thisArg
     * @chainable
     */ setElement: function(element, options) {
            this.removeTexture(this.cacheKey);
            this.removeTexture(this.cacheKey + "_filtered");
            this._element = element;
            this._originalElement = element;
            this._initConfig(options);
            if (this.filters.length !== 0) this.applyFilters();
            // resizeFilters work on the already filtered copy.
            // we need to apply resizeFilters AFTER normal filters.
            // applyResizeFilters is run more often than normal filters
            // and is triggered by user interactions rather than dev code
            if (this.resizeFilter) this.applyResizeFilters();
            return this;
        },
        /**
     * Delete a single texture if in webgl mode
     */ removeTexture: function(key) {
            var backend = $d47795690082d4de$var$fabric.filterBackend;
            if (backend && backend.evictCachesForKey) backend.evictCachesForKey(key);
        },
        /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */ dispose: function() {
            this.callSuper("dispose");
            this.removeTexture(this.cacheKey);
            this.removeTexture(this.cacheKey + "_filtered");
            this._cacheContext = undefined;
            [
                "_originalElement",
                "_element",
                "_filteredEl",
                "_cacheCanvas"
            ].forEach((function(element) {
                $d47795690082d4de$var$fabric.util.cleanUpJsdomNode(this[element]);
                this[element] = undefined;
            }).bind(this));
        },
        /**
     * Get the crossOrigin value (of the corresponding image element)
     */ getCrossOrigin: function() {
            return this._originalElement && (this._originalElement.crossOrigin || null);
        },
        /**
     * Returns original size of an image
     * @return {Object} Object with "width" and "height" properties
     */ getOriginalSize: function() {
            var element = this.getElement();
            return {
                width: element.naturalWidth || element.width,
                height: element.naturalHeight || element.height
            };
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _stroke: function(ctx) {
            if (!this.stroke || this.strokeWidth === 0) return;
            var w = this.width / 2, h = this.height / 2;
            ctx.beginPath();
            ctx.moveTo(-w, -h);
            ctx.lineTo(w, -h);
            ctx.lineTo(w, h);
            ctx.lineTo(-w, h);
            ctx.lineTo(-w, -h);
            ctx.closePath();
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var filters = [];
            this.filters.forEach(function(filterObj) {
                if (filterObj) filters.push(filterObj.toObject());
            });
            var object = extend(this.callSuper("toObject", [
                "cropX",
                "cropY"
            ].concat(propertiesToInclude)), {
                src: this.getSrc(),
                crossOrigin: this.getCrossOrigin(),
                filters: filters
            });
            if (this.resizeFilter) object.resizeFilter = this.resizeFilter.toObject();
            return object;
        },
        /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
     * @return {Boolean}
     */ hasCrop: function() {
            return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
        },
        /* _TO_SVG_START_ */ /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */ _toSVG: function() {
            var svgString = [], imageMarkup = [], strokeSvg, element = this._element, x = -this.width / 2, y = -this.height / 2, clipPath = "", imageRendering = "";
            if (!element) return [];
            if (this.hasCrop()) {
                var clipPathId = $d47795690082d4de$var$fabric.Object.__uid++;
                svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '	<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', "</clipPath>\n");
                clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
            }
            if (!this.imageSmoothing) imageRendering = '" image-rendering="optimizeSpeed';
            imageMarkup.push("	<image ", "COMMON_PARTS", 'xlink:href="', this.getSvgSrc(true), '" x="', x - this.cropX, '" y="', y - this.cropY, // we're essentially moving origin of transformation from top/left corner to the center of the shape
            // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
            // so that object's center aligns with container's left/top
            '" width="', element.width || element.naturalWidth, '" height="', element.height || element.height, imageRendering, '"', clipPath, "></image>\n");
            if (this.stroke || this.strokeDashArray) {
                var origFill = this.fill;
                this.fill = null;
                strokeSvg = [
                    "	<rect ",
                    'x="',
                    x,
                    '" y="',
                    y,
                    '" width="',
                    this.width,
                    '" height="',
                    this.height,
                    '" style="',
                    this.getSvgStyles(),
                    '"/>\n'
                ];
                this.fill = origFill;
            }
            if (this.paintFirst !== "fill") svgString = svgString.concat(strokeSvg, imageMarkup);
            else svgString = svgString.concat(imageMarkup, strokeSvg);
            return svgString;
        },
        /* _TO_SVG_END_ */ /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */ getSrc: function(filtered) {
            var element = filtered ? this._element : this._originalElement;
            if (element) {
                if (element.toDataURL) return element.toDataURL();
                if (this.srcFromAttribute) return element.getAttribute("src");
                else return element.src;
            } else return this.src || "";
        },
        /**
     * Sets source of an image
     * @param {String} src Source string (URL)
     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
     * @param {Object} [options] Options object
     * @param {String} [options.crossOrigin] crossOrigin value (one of "", "anonymous", "use-credentials")
     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
     * @return {fabric.Image} thisArg
     * @chainable
     */ setSrc: function(src, callback, options) {
            $d47795690082d4de$var$fabric.util.loadImage(src, function(img, isError) {
                this.setElement(img, options);
                this._setWidthHeight();
                callback && callback(this, isError);
            }, this, options && options.crossOrigin);
            return this;
        },
        /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */ toString: function() {
            return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
        },
        applyResizeFilters: function() {
            var filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.scaleX, scaleY = objectScale.scaleY, elementToFilter = this._filteredEl || this._originalElement;
            if (this.group) this.set("dirty", true);
            if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
                this._element = elementToFilter;
                this._filterScalingX = 1;
                this._filterScalingY = 1;
                this._lastScaleX = scaleX;
                this._lastScaleY = scaleY;
                return;
            }
            if (!$d47795690082d4de$var$fabric.filterBackend) $d47795690082d4de$var$fabric.filterBackend = $d47795690082d4de$var$fabric.initFilterBackend();
            var canvasEl = $d47795690082d4de$var$fabric.util.createCanvasElement(), cacheKey = this._filteredEl ? this.cacheKey + "_filtered" : this.cacheKey, sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
            canvasEl.width = sourceWidth;
            canvasEl.height = sourceHeight;
            this._element = canvasEl;
            this._lastScaleX = filter.scaleX = scaleX;
            this._lastScaleY = filter.scaleY = scaleY;
            $d47795690082d4de$var$fabric.filterBackend.applyFilters([
                filter
            ], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
            this._filterScalingX = canvasEl.width / this._originalElement.width;
            this._filterScalingY = canvasEl.height / this._originalElement.height;
        },
        /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     * @return {thisArg} return the fabric.Image object
     * @chainable
     */ applyFilters: function(filters) {
            filters = filters || this.filters || [];
            filters = filters.filter(function(filter) {
                return filter && !filter.isNeutralState();
            });
            this.set("dirty", true);
            // needs to clear out or WEBGL will not resize correctly
            this.removeTexture(this.cacheKey + "_filtered");
            if (filters.length === 0) {
                this._element = this._originalElement;
                this._filteredEl = null;
                this._filterScalingX = 1;
                this._filterScalingY = 1;
                return this;
            }
            var imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
            if (this._element === this._originalElement) {
                // if the element is the same we need to create a new element
                var canvasEl = $d47795690082d4de$var$fabric.util.createCanvasElement();
                canvasEl.width = sourceWidth;
                canvasEl.height = sourceHeight;
                this._element = canvasEl;
                this._filteredEl = canvasEl;
            } else {
                // clear the existing element to get new filter data
                // also dereference the eventual resized _element
                this._element = this._filteredEl;
                this._filteredEl.getContext("2d").clearRect(0, 0, sourceWidth, sourceHeight);
                // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
                this._lastScaleX = 1;
                this._lastScaleY = 1;
            }
            if (!$d47795690082d4de$var$fabric.filterBackend) $d47795690082d4de$var$fabric.filterBackend = $d47795690082d4de$var$fabric.initFilterBackend();
            $d47795690082d4de$var$fabric.filterBackend.applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
            if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
                this._filterScalingX = this._element.width / this._originalElement.width;
                this._filterScalingY = this._element.height / this._originalElement.height;
            }
            return this;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            $d47795690082d4de$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
            if (this.isMoving !== true && this.resizeFilter && this._needsResize()) this.applyResizeFilters();
            this._stroke(ctx);
            this._renderPaintInOrder(ctx);
        },
        /**
     * Paint the cached copy of the object on the target context.
     * it will set the imageSmoothing for the draw operation
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ drawCacheOnCanvas: function(ctx) {
            $d47795690082d4de$var$fabric.util.setImageSmoothing(ctx, this.imageSmoothing);
            $d47795690082d4de$var$fabric.Object.prototype.drawCacheOnCanvas.call(this, ctx);
        },
        /**
     * Decide if the object should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step. None of the fabric classes requires it.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */ shouldCache: function() {
            return this.needsItsOwnCache();
        },
        _renderFill: function(ctx) {
            var elementToDraw = this._element;
            if (!elementToDraw) return;
            var scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, min = Math.min, max = Math.max, // crop values cannot be lesser than 0.
            cropX = max(this.cropX, 0), cropY = max(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, // the width height cannot exceed element width/height, starting from the crop offset.
            sW = min(w * scaleX, elWidth - sX), sH = min(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = min(w, elWidth / scaleX - cropX), maxDestH = min(h, elHeight / scaleY - cropY);
            elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
        },
        /**
     * needed to check if image needs resize
     * @private
     */ _needsResize: function() {
            var scale = this.getTotalObjectScaling();
            return scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY;
        },
        /**
     * @private
     */ _resetWidthHeight: function() {
            this.set(this.getOriginalSize());
        },
        /**
     * The Image class's initialization method. This method is automatically
     * called by the constructor.
     * @private
     * @param {HTMLImageElement|String} element The element representing the image
     * @param {Object} [options] Options object
     */ _initElement: function(element, options) {
            this.setElement($d47795690082d4de$var$fabric.util.getById(element), options);
            $d47795690082d4de$var$fabric.util.addClass(this.getElement(), $d47795690082d4de$var$fabric.Image.CSS_CANVAS);
        },
        /**
     * @private
     * @param {Object} [options] Options object
     */ _initConfig: function(options) {
            options || (options = {});
            this.setOptions(options);
            this._setWidthHeight(options);
        },
        /**
     * @private
     * @param {Array} filters to be initialized
     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
     */ _initFilters: function(filters, callback) {
            if (filters && filters.length) $d47795690082d4de$var$fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
                callback && callback(enlivenedObjects);
            }, "fabric.Image.filters");
            else callback && callback();
        },
        /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     * @param {Object} [options] Object with width/height properties
     */ _setWidthHeight: function(options) {
            options || (options = {});
            var el = this.getElement();
            this.width = options.width || el.naturalWidth || el.width || 0;
            this.height = options.height || el.naturalHeight || el.height || 0;
        },
        /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     * @return {Object}
     */ parsePreserveAspectRatioAttribute: function() {
            var pAR = $d47795690082d4de$var$fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""), rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset, pWidth = this.width, pHeight = this.height, parsedAttributes = {
                width: pWidth,
                height: pHeight
            };
            if (pAR && (pAR.alignX !== "none" || pAR.alignY !== "none")) {
                if (pAR.meetOrSlice === "meet") {
                    scaleX = scaleY = $d47795690082d4de$var$fabric.util.findScaleToFit(this._element, parsedAttributes);
                    offset = (pWidth - rWidth * scaleX) / 2;
                    if (pAR.alignX === "Min") offsetLeft = -offset;
                    if (pAR.alignX === "Max") offsetLeft = offset;
                    offset = (pHeight - rHeight * scaleY) / 2;
                    if (pAR.alignY === "Min") offsetTop = -offset;
                    if (pAR.alignY === "Max") offsetTop = offset;
                }
                if (pAR.meetOrSlice === "slice") {
                    scaleX = scaleY = $d47795690082d4de$var$fabric.util.findScaleToCover(this._element, parsedAttributes);
                    offset = rWidth - pWidth / scaleX;
                    if (pAR.alignX === "Mid") cropX = offset / 2;
                    if (pAR.alignX === "Max") cropX = offset;
                    offset = rHeight - pHeight / scaleY;
                    if (pAR.alignY === "Mid") cropY = offset / 2;
                    if (pAR.alignY === "Max") cropY = offset;
                    rWidth = pWidth / scaleX;
                    rHeight = pHeight / scaleY;
                }
            } else {
                scaleX = pWidth / rWidth;
                scaleY = pHeight / rHeight;
            }
            return {
                width: rWidth,
                height: rHeight,
                scaleX: scaleX,
                scaleY: scaleY,
                offsetLeft: offsetLeft,
                offsetTop: offsetTop,
                cropX: cropX,
                cropY: cropY
            };
        }
    });
    /**
   * Default CSS class name for canvas
   * @static
   * @type String
   * @default
   */ $d47795690082d4de$var$fabric.Image.CSS_CANVAS = "canvas-img";
    /**
   * Alias for getSrc
   * @static
   */ $d47795690082d4de$var$fabric.Image.prototype.getSvgSrc = $d47795690082d4de$var$fabric.Image.prototype.getSrc;
    /**
   * Creates an instance of fabric.Image from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} callback Callback to invoke when an image instance is created
   */ $d47795690082d4de$var$fabric.Image.fromObject = function(_object, callback) {
        var object = $d47795690082d4de$var$fabric.util.object.clone(_object);
        $d47795690082d4de$var$fabric.util.loadImage(object.src, function(img, isError) {
            if (isError) {
                callback && callback(null, true);
                return;
            }
            $d47795690082d4de$var$fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
                object.filters = filters || [];
                $d47795690082d4de$var$fabric.Image.prototype._initFilters.call(object, [
                    object.resizeFilter
                ], function(resizeFilters) {
                    object.resizeFilter = resizeFilters[0];
                    $d47795690082d4de$var$fabric.util.enlivenObjectEnlivables(object, object, function() {
                        var image = new $d47795690082d4de$var$fabric.Image(img, object);
                        callback(image, false);
                    });
                });
            });
        }, null, object.crossOrigin);
    };
    /**
   * Creates an instance of fabric.Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument). Second argument is a boolean indicating if an error occurred or not.
   * @param {Object} [imgOptions] Options object
   */ $d47795690082d4de$var$fabric.Image.fromURL = function(url, callback, imgOptions) {
        $d47795690082d4de$var$fabric.util.loadImage(url, function(img, isError) {
            callback && callback(new $d47795690082d4de$var$fabric.Image(img, imgOptions), isError);
        }, null, imgOptions && imgOptions.crossOrigin);
    };
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */ $d47795690082d4de$var$fabric.Image.ATTRIBUTE_NAMES = $d47795690082d4de$var$fabric.SHARED_ATTRIBUTES.concat("x y width height preserveAspectRatio xlink:href crossOrigin image-rendering".split(" "));
    /**
   * Returns {@link fabric.Image} instance from an SVG element
   * @static
   * @param {SVGElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} callback Callback to execute when fabric.Image object is created
   * @return {fabric.Image} Instance of fabric.Image
   */ $d47795690082d4de$var$fabric.Image.fromElement = function(element, callback, options) {
        var parsedAttributes = $d47795690082d4de$var$fabric.parseAttributes(element, $d47795690082d4de$var$fabric.Image.ATTRIBUTE_NAMES);
        $d47795690082d4de$var$fabric.Image.fromURL(parsedAttributes["xlink:href"], callback, extend(options ? $d47795690082d4de$var$fabric.util.object.clone(options) : {}, parsedAttributes));
    };
/* _FROM_SVG_END_ */ })($d47795690082d4de$exports);
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
    /**
   * @private
   * @return {Number} angle value
   */ _getAngleValueForStraighten: function() {
        var angle = this.angle % 360;
        if (angle > 0) return Math.round((angle - 1) / 90) * 90;
        return Math.round(angle / 90) * 90;
    },
    /**
   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
   * @return {fabric.Object} thisArg
   * @chainable
   */ straighten: function() {
        return this.rotate(this._getAngleValueForStraighten());
    },
    /**
   * Same as {@link fabric.Object.prototype.straighten} but with animation
   * @param {Object} callbacks Object with callback functions
   * @param {Function} [callbacks.onComplete] Invoked on completion
   * @param {Function} [callbacks.onChange] Invoked on every step of animation
   * @return {fabric.Object} thisArg
   */ fxStraighten: function(callbacks) {
        callbacks = callbacks || {};
        var empty = function() {}, onComplete = callbacks.onComplete || empty, onChange = callbacks.onChange || empty, _this = this;
        return $d47795690082d4de$var$fabric.util.animate({
            target: this,
            startValue: this.get("angle"),
            endValue: this._getAngleValueForStraighten(),
            duration: this.FX_DURATION,
            onChange: function(value) {
                _this.rotate(value);
                onChange();
            },
            onComplete: function() {
                _this.setCoords();
                onComplete();
            }
        });
    }
});
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
    /**
   * Straightens object, then rerenders canvas
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   * @chainable
   */ straightenObject: function(object) {
        object.straighten();
        this.requestRenderAll();
        return this;
    },
    /**
   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
   * @param {fabric.Object} object Object to straighten
   * @return {fabric.Canvas} thisArg
   */ fxStraightenObject: function(object) {
        return object.fxStraighten({
            onChange: this.requestRenderAllBound
        });
    }
});
(function() {
    "use strict";
    /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */ function testPrecision(gl, precision) {
        var fragmentSource = "precision " + precision + " float;\nvoid main(){}";
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) return false;
        return true;
    }
    /**
   * Indicate whether this filtering backend is supported by the user's browser.
   * @param {Number} tileSize check if the tileSize is supported
   * @returns {Boolean} Whether the user's browser supports WebGL.
   */ $d47795690082d4de$var$fabric.isWebglSupported = function(tileSize) {
        if ($d47795690082d4de$var$fabric.isLikelyNode) return false;
        tileSize = tileSize || $d47795690082d4de$var$fabric.WebglFilterBackend.prototype.tileSize;
        var canvas = document.createElement("canvas");
        var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        var isSupported = false;
        // eslint-disable-next-line
        if (gl) {
            $d47795690082d4de$var$fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
            isSupported = $d47795690082d4de$var$fabric.maxTextureSize >= tileSize;
            var precisions = [
                "highp",
                "mediump",
                "lowp"
            ];
            for(var i = 0; i < 3; i++)if (testPrecision(gl, precisions[i])) {
                $d47795690082d4de$var$fabric.webGlPrecision = precisions[i];
                break;
            }
        }
        this.isSupported = isSupported;
        return isSupported;
    };
    $d47795690082d4de$var$fabric.WebglFilterBackend = WebglFilterBackend;
    /**
   * WebGL filter backend.
   */ function WebglFilterBackend(options) {
        if (options && options.tileSize) this.tileSize = options.tileSize;
        this.setupGLContext(this.tileSize, this.tileSize);
        this.captureGPUInfo();
    }
    WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {
        tileSize: 2048,
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ resources: {},
        /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */ setupGLContext: function(width, height) {
            this.dispose();
            this.createWebGLCanvas(width, height);
            // eslint-disable-next-line
            this.aPosition = new Float32Array([
                0,
                0,
                0,
                1,
                1,
                0,
                1,
                1
            ]);
            this.chooseFastestCopyGLTo2DMethod(width, height);
        },
        /**
     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
     * putImageData is faster than drawImage for that specific operation.
     */ chooseFastestCopyGLTo2DMethod: function(width, height) {
            var canMeasurePerf = typeof window.performance !== "undefined", canUseImageData;
            try {
                new ImageData(1, 1);
                canUseImageData = true;
            } catch (e) {
                canUseImageData = false;
            }
            // eslint-disable-next-line no-undef
            var canUseArrayBuffer = typeof ArrayBuffer !== "undefined";
            // eslint-disable-next-line no-undef
            var canUseUint8Clamped = typeof Uint8ClampedArray !== "undefined";
            if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) return;
            var targetCanvas = $d47795690082d4de$var$fabric.util.createCanvasElement();
            // eslint-disable-next-line no-undef
            var imageBuffer = new ArrayBuffer(width * height * 4);
            if ($d47795690082d4de$var$fabric.forceGLPutImageData) {
                this.imageBuffer = imageBuffer;
                this.copyGLTo2D = $d47795690082d4de$var$copyGLTo2DPutImageData;
                return;
            }
            var testContext = {
                imageBuffer: imageBuffer,
                destinationWidth: width,
                destinationHeight: height,
                targetCanvas: targetCanvas
            };
            var startTime, drawImageTime, putImageDataTime;
            targetCanvas.width = width;
            targetCanvas.height = height;
            startTime = window.performance.now();
            $d47795690082d4de$var$copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
            drawImageTime = window.performance.now() - startTime;
            startTime = window.performance.now();
            $d47795690082d4de$var$copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
            putImageDataTime = window.performance.now() - startTime;
            if (drawImageTime > putImageDataTime) {
                this.imageBuffer = imageBuffer;
                this.copyGLTo2D = $d47795690082d4de$var$copyGLTo2DPutImageData;
            } else this.copyGLTo2D = $d47795690082d4de$var$copyGLTo2DDrawImage;
        },
        /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */ createWebGLCanvas: function(width, height) {
            var canvas = $d47795690082d4de$var$fabric.util.createCanvasElement();
            canvas.width = width;
            canvas.height = height;
            var glOptions = {
                alpha: true,
                premultipliedAlpha: false,
                depth: false,
                stencil: false,
                antialias: false
            }, gl = canvas.getContext("webgl", glOptions);
            if (!gl) gl = canvas.getContext("experimental-webgl", glOptions);
            if (!gl) return;
            gl.clearColor(0, 0, 0, 0);
            // this canvas can fire webglcontextlost and webglcontextrestored
            this.canvas = canvas;
            this.gl = gl;
        },
        /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */ applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
            var gl = this.gl;
            var cachedTexture;
            if (cacheKey) cachedTexture = this.getCachedTexture(cacheKey, source);
            var pipelineState = {
                originalWidth: source.width || source.originalWidth,
                originalHeight: source.height || source.originalHeight,
                sourceWidth: width,
                sourceHeight: height,
                destinationWidth: width,
                destinationHeight: height,
                context: gl,
                sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
                targetTexture: this.createTexture(gl, width, height),
                originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture && source),
                passes: filters.length,
                webgl: true,
                aPosition: this.aPosition,
                programCache: this.programCache,
                pass: 0,
                filterBackend: this,
                targetCanvas: targetCanvas
            };
            var tempFbo = gl.createFramebuffer();
            gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
            filters.forEach(function(filter) {
                filter && filter.applyTo(pipelineState);
            });
            $d47795690082d4de$var$resizeCanvasIfNeeded(pipelineState);
            this.copyGLTo2D(gl, pipelineState);
            gl.bindTexture(gl.TEXTURE_2D, null);
            gl.deleteTexture(pipelineState.sourceTexture);
            gl.deleteTexture(pipelineState.targetTexture);
            gl.deleteFramebuffer(tempFbo);
            targetCanvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);
            return pipelineState;
        },
        /**
     * Detach event listeners, remove references, and clean up caches.
     */ dispose: function() {
            if (this.canvas) {
                this.canvas = null;
                this.gl = null;
            }
            this.clearWebGLCaches();
        },
        /**
     * Wipe out WebGL-related caches.
     */ clearWebGLCaches: function() {
            this.programCache = {};
            this.textureCache = {};
        },
        /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the texture to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {Number} width The width to initialize the texture at.
     * @param {Number} height The height to initialize the texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
     * @param {Number} filterType gl.NEAREST or gl.LINEAR usually, webgl numeri constants
     * @returns {WebGLTexture}
     */ createTexture: function(gl, width, height, textureImageSource, filterType) {
            var texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filterType || gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filterType || gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            if (textureImageSource) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
            else gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
            return texture;
        },
        /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */ getCachedTexture: function(uniqueId, textureImageSource) {
            if (this.textureCache[uniqueId]) return this.textureCache[uniqueId];
            else {
                var texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
                this.textureCache[uniqueId] = texture;
                return texture;
            }
        },
        /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */ evictCachesForKey: function(cacheKey) {
            if (this.textureCache[cacheKey]) {
                this.gl.deleteTexture(this.textureCache[cacheKey]);
                delete this.textureCache[cacheKey];
            }
        },
        copyGLTo2D: $d47795690082d4de$var$copyGLTo2DDrawImage,
        /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */ captureGPUInfo: function() {
            if (this.gpuInfo) return this.gpuInfo;
            var gl = this.gl, gpuInfo = {
                renderer: "",
                vendor: ""
            };
            if (!gl) return gpuInfo;
            var ext = gl.getExtension("WEBGL_debug_renderer_info");
            if (ext) {
                var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
                var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
                if (renderer) gpuInfo.renderer = renderer.toLowerCase();
                if (vendor) gpuInfo.vendor = vendor.toLowerCase();
            }
            this.gpuInfo = gpuInfo;
            return gpuInfo;
        }
    };
})();
function $d47795690082d4de$var$resizeCanvasIfNeeded(pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
        targetCanvas.width = dWidth;
        targetCanvas.height = dHeight;
    }
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas.
 *
 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
 * desired output image appearing in the bottom-left corner of the WebGL canvas.
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */ function $d47795690082d4de$var$copyGLTo2DDrawImage(gl, pipelineState) {
    var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d");
    ctx.translate(0, targetCanvas.height); // move it down again
    ctx.scale(1, -1); // vertical flip
    // where is my image on the big glcanvas?
    var sourceY = glCanvas.height - targetCanvas.height;
    ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
}
/**
 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
 *
 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
 * @param {Object} pipelineState The 2D target canvas to copy on to.
 */ function $d47795690082d4de$var$copyGLTo2DPutImageData(gl, pipelineState) {
    var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext("2d"), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
    // eslint-disable-next-line no-undef
    var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
    // eslint-disable-next-line no-undef
    var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
    gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
    var imgData = new ImageData(u8Clamped, dWidth, dHeight);
    ctx.putImageData(imgData, 0, 0);
}
(function() {
    "use strict";
    var noop = function() {};
    $d47795690082d4de$var$fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;
    /**
   * Canvas 2D filter backend.
   */ function Canvas2dFilterBackend() {}
    Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
        evictCachesForKey: noop,
        dispose: noop,
        clearWebGLCaches: noop,
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ resources: {},
        /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */ applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
            var ctx = targetCanvas.getContext("2d");
            ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
            var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
            var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
            var pipelineState = {
                sourceWidth: sourceWidth,
                sourceHeight: sourceHeight,
                imageData: imageData,
                originalEl: sourceElement,
                originalImageData: originalImageData,
                canvasEl: targetCanvas,
                ctx: ctx,
                filterBackend: this
            };
            filters.forEach(function(filter) {
                filter.applyTo(pipelineState);
            });
            if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
                targetCanvas.width = pipelineState.imageData.width;
                targetCanvas.height = pipelineState.imageData.height;
            }
            ctx.putImageData(pipelineState.imageData, 0, 0);
            return pipelineState;
        }
    };
})();
/**
 * @namespace fabric.Image.filters
 * @memberOf fabric.Image
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
 */ $d47795690082d4de$var$fabric.Image = $d47795690082d4de$var$fabric.Image || {};
$d47795690082d4de$var$fabric.Image.filters = $d47795690082d4de$var$fabric.Image.filters || {};
/**
 * Root filter class from which all filter classes inherit from
 * @class fabric.Image.filters.BaseFilter
 * @memberOf fabric.Image.filters
 */ $d47795690082d4de$var$fabric.Image.filters.BaseFilter = $d47795690082d4de$var$fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {
    /**
   * Filter type
   * @param {String} type
   * @default
   */ type: "BaseFilter",
    /**
   * Array of attributes to send with buffers. do not modify
   * @private
   */ vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvoid main() {\nvTexCoord = aPosition;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
    fragmentSource: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D uTexture;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\n}",
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ initialize: function(options) {
        if (options) this.setOptions(options);
    },
    /**
   * Sets filter's properties from options
   * @param {Object} [options] Options object
   */ setOptions: function(options) {
        for(var prop in options)this[prop] = options[prop];
    },
    /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */ createProgram: function(gl, fragmentSource, vertexSource) {
        fragmentSource = fragmentSource || this.fragmentSource;
        vertexSource = vertexSource || this.vertexSource;
        if ($d47795690082d4de$var$fabric.webGlPrecision !== "highp") fragmentSource = fragmentSource.replace(/precision highp float/g, "precision " + $d47795690082d4de$var$fabric.webGlPrecision + " float");
        var vertexShader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        "Vertex shader compile error for " + this.type + ": " + gl.getShaderInfoLog(vertexShader));
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        "Fragment shader compile error for " + this.type + ": " + gl.getShaderInfoLog(fragmentShader));
        var program = gl.createProgram();
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(// eslint-disable-next-line prefer-template
        'Shader link error for "${this.type}" ' + gl.getProgramInfoLog(program));
        var attributeLocations = this.getAttributeLocations(gl, program);
        var uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, "uStepW");
        uniformLocations.uStepH = gl.getUniformLocation(program, "uStepH");
        return {
            program: program,
            attributeLocations: attributeLocations,
            uniformLocations: uniformLocations
        };
    },
    /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */ getAttributeLocations: function(gl, program) {
        return {
            aPosition: gl.getAttribLocation(program, "aPosition")
        };
    },
    /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */ getUniformLocations: function() {
        // in case i do not need any special uniform i need to return an empty object
        return {};
    },
    /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */ sendAttributeData: function(gl, attributeLocations, aPositionData) {
        var attributeLocation = attributeLocations.aPosition;
        var buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    },
    _setupFrameBuffer: function(options) {
        var gl = options.context, width, height;
        if (options.passes > 1) {
            width = options.destinationWidth;
            height = options.destinationHeight;
            if (options.sourceWidth !== width || options.sourceHeight !== height) {
                gl.deleteTexture(options.targetTexture);
                options.targetTexture = options.filterBackend.createTexture(gl, width, height);
            }
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
        } else {
            // draw last filter on canvas and not to framebuffer.
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.finish();
        }
    },
    _swapTextures: function(options) {
        options.passes--;
        options.pass++;
        var temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
    },
    /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/ isNeutralState: function() {
        var main = this.mainParameter, _class = $d47795690082d4de$var$fabric.Image.filters[this.type].prototype;
        if (main) {
            if (Array.isArray(_class[main])) {
                for(var i = _class[main].length; i--;){
                    if (this[main][i] !== _class[main][i]) return false;
                }
                return true;
            } else return _class[main] === this[main];
        } else return false;
    },
    /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo: function(options) {
        if (options.webgl) {
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    },
    /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ retrieveShader: function(options) {
        if (!options.programCache.hasOwnProperty(this.type)) options.programCache[this.type] = this.createProgram(options.context);
        return options.programCache[this.type];
    },
    /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyToWebGL: function(options) {
        var gl = options.context;
        var shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        else gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    },
    bindAdditionalTexture: function(gl, texture, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // reset active texture to 0 as usual
        gl.activeTexture(gl.TEXTURE0);
    },
    unbindAdditionalTexture: function(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
    },
    getMainParameter: function() {
        return this[this.mainParameter];
    },
    setMainParameter: function(value) {
        this[this.mainParameter] = value;
    },
    /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} uniformLocations A map of shader uniform names to their locations.
   */ sendUniformData: function() {
    // Intentionally left blank.  Override me in subclasses.
    },
    /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */ createHelpLayer: function(options) {
        if (!options.helpLayer) {
            var helpLayer = document.createElement("canvas");
            helpLayer.width = options.sourceWidth;
            helpLayer.height = options.sourceHeight;
            options.helpLayer = helpLayer;
        }
    },
    /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */ toObject: function() {
        var object = {
            type: this.type
        }, mainP = this.mainParameter;
        if (mainP) object[mainP] = this[mainP];
        return object;
    },
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON: function() {
        // delegate, not alias
        return this.toObject();
    }
});
$d47795690082d4de$var$fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
    var filter = new $d47795690082d4de$var$fabric.Image.filters[object.type](object);
    callback && callback(filter);
    return filter;
};
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Color Matrix filter class
   * @class fabric.Image.filters.ColorMatrix
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
   * @example <caption>Kodachrome filter</caption>
   * var filter = new fabric.Image.filters.ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "ColorMatrix",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nuniform mat4 uColorMatrix;\nuniform vec4 uConstants;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor *= uColorMatrix;\ncolor += uConstants;\ngl_FragColor = color;\n}",
        /**
     * Colormatrix for pixels.
     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
     * outside the -1, 1 range.
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Array} matrix array of 20 numbers.
     * @default
     */ matrix: [
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        mainParameter: "matrix",
        /**
     * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
     * to save some calculation
     * @type Boolean
     * @default true
     */ colorsOnly: true,
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.callSuper("initialize", options);
            // create a new array instead mutating the prototype with push
            this.matrix = this.matrix.slice(0);
        },
        /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = data.length, m = this.matrix, r, g, b, a, i, colorsOnly = this.colorsOnly;
            for(i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                if (colorsOnly) {
                    data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
                    data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
                    data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
                } else {
                    a = data[i + 3];
                    data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
                    data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
                    data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
                    data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uColorMatrix: gl.getUniformLocation(program, "uColorMatrix"),
                uConstants: gl.getUniformLocation(program, "uConstants")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var m = this.matrix, matrix = [
                m[0],
                m[1],
                m[2],
                m[3],
                m[5],
                m[6],
                m[7],
                m[8],
                m[10],
                m[11],
                m[12],
                m[13],
                m[15],
                m[16],
                m[17],
                m[18]
            ], constants = [
                m[4],
                m[9],
                m[14],
                m[19]
            ];
            gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
            gl.uniform4fv(uniformLocations.uConstants, constants);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] function to invoke after filter creation
   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
   */ fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Brightness filter class
   * @class fabric.Image.filters.Brightness
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Brightness",
        /**
     * Fragment source for the brightness program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBrightness;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += uBrightness;\ngl_FragColor = color;\n}",
        /**
     * Brightness value, from -1 to 1.
     * translated to -255 to 255 for 2d
     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
     * @param {Number} brightness
     * @default
     */ brightness: 0,
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: "brightness",
        /**
    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
    *
    * @param {Object} options
    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
    */ applyTo2d: function(options) {
            if (this.brightness === 0) return;
            var imageData = options.imageData, data = imageData.data, i, len = data.length, brightness = Math.round(this.brightness * 255);
            for(i = 0; i < len; i += 4){
                data[i] = data[i] + brightness;
                data[i + 1] = data[i + 1] + brightness;
                data[i + 2] = data[i + 2] + brightness;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uBrightness: gl.getUniformLocation(program, "uBrightness")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uBrightness, this.brightness);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
   */ fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @class fabric.Image.filters.Convolute
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example <caption>Sharpen filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * var filter = new fabric.Image.filters.Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Convolute",
        /*
     * Opaque value (true/false)
     */ opaque: false,
        /*
     * matrix for the filter, max 9x9
     */ matrix: [
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0
        ],
        /**
     * Fragment source for the brightness program
     */ fragmentSource: {
            Convolute_3_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_3_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[9];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 3.0; h+=1.0) {\nfor (float w = 0.0; w < 3.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_5_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_5_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[25];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 5.0; h+=1.0) {\nfor (float w = 0.0; w < 5.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_7_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_7_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[49];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 7.0; h+=1.0) {\nfor (float w = 0.0; w < 7.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}",
            Convolute_9_1: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 0);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n}\n}\ngl_FragColor = color;\n}",
            Convolute_9_0: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uMatrix[81];\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = vec4(0, 0, 0, 1);\nfor (float h = 0.0; h < 9.0; h+=1.0) {\nfor (float w = 0.0; w < 9.0; w+=1.0) {\nvec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\ncolor.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n}\n}\nfloat alpha = texture2D(uTexture, vTexCoord).a;\ngl_FragColor = color;\ngl_FragColor.a = alpha;\n}"
        },
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Convolute.prototype
     * @param {Object} [options] Options object
     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
     * @param {Array} [options.matrix] Filter matrix
     */ /**
    * Retrieves the cached shader.
    * @param {Object} options
    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
    */ retrieveShader: function(options) {
            var size = Math.sqrt(this.matrix.length);
            var cacheKey = this.type + "_" + size + "_" + (this.opaque ? 1 : 0);
            var shaderSource = this.fragmentSource[cacheKey];
            if (!options.programCache.hasOwnProperty(cacheKey)) options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            return options.programCache[cacheKey];
        },
        /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, // go through the destination image pixels
            alphaFac = this.opaque ? 1 : 0, r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
            for(y = 0; y < sh; y++)for(x = 0; x < sw; x++){
                dstOff = (y * sw + x) * 4;
                // calculate the weighed sum of the source image pixels that
                // fall under the convolution matrix
                r = 0;
                g = 0;
                b = 0;
                a = 0;
                for(cy = 0; cy < side; cy++)for(cx = 0; cx < side; cx++){
                    scy = y + cy - halfSide;
                    scx = x + cx - halfSide;
                    // eslint-disable-next-line max-depth
                    if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) continue;
                    srcOff = (scy * sw + scx) * 4;
                    wt = weights[cy * side + cx];
                    r += data[srcOff] * wt;
                    g += data[srcOff + 1] * wt;
                    b += data[srcOff + 2] * wt;
                    // eslint-disable-next-line max-depth
                    if (!alphaFac) a += data[srcOff + 3] * wt;
                }
                dst[dstOff] = r;
                dst[dstOff + 1] = g;
                dst[dstOff + 2] = b;
                if (!alphaFac) dst[dstOff + 3] = a;
                else dst[dstOff + 3] = data[dstOff + 3];
            }
            options.imageData = output;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uMatrix: gl.getUniformLocation(program, "uMatrix"),
                uOpaque: gl.getUniformLocation(program, "uOpaque"),
                uHalfSize: gl.getUniformLocation(program, "uHalfSize"),
                uSize: gl.getUniformLocation(program, "uSize")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper("toObject"), {
                opaque: this.opaque,
                matrix: this.matrix
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
   */ fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Grayscale image filter class
   * @class fabric.Image.filters.Grayscale
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Grayscale",
        fragmentSource: {
            average: "precision highp float;\nuniform sampler2D uTexture;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat average = (color.r + color.b + color.g) / 3.0;\ngl_FragColor = vec4(average, average, average, color.a);\n}",
            lightness: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\ngl_FragColor = vec4(average, average, average, col.a);\n}",
            luminosity: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uMode;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 col = texture2D(uTexture, vTexCoord);\nfloat average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\ngl_FragColor = vec4(average, average, average, col.a);\n}"
        },
        /**
     * Grayscale mode, between 'average', 'lightness', 'luminosity'
     * @param {String} type
     * @default
     */ mode: "average",
        mainParameter: "mode",
        /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length, value, mode = this.mode;
            for(i = 0; i < len; i += 4){
                if (mode === "average") value = (data[i] + data[i + 1] + data[i + 2]) / 3;
                else if (mode === "lightness") value = (Math.min(data[i], data[i + 1], data[i + 2]) + Math.max(data[i], data[i + 1], data[i + 2])) / 2;
                else if (mode === "luminosity") value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
                data[i] = value;
                data[i + 1] = value;
                data[i + 2] = value;
            }
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + "_" + this.mode;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                var shaderSource = this.fragmentSource[this.mode];
                options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            }
            return options.programCache[cacheKey];
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uMode: gl.getUniformLocation(program, "uMode")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            // default average mode.
            var mode = 1;
            gl.uniform1i(uniformLocations.uMode, mode);
        },
        /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/ isNeutralState: function() {
            return false;
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
   */ fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Invert filter class
   * @class fabric.Image.filters.Invert
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */ filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Invert",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform int uInvert;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nif (uInvert == 1) {\ngl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n} else {\ngl_FragColor = color;\n}\n}",
        /**
     * Filter invert. if false, does nothing
     * @param {Boolean} invert
     * @default
     */ invert: true,
        mainParameter: "invert",
        /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, len = data.length;
            for(i = 0; i < len; i += 4){
                data[i] = 255 - data[i];
                data[i + 1] = 255 - data[i + 1];
                data[i + 2] = 255 - data[i + 2];
            }
        },
        /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/ isNeutralState: function() {
            return !this.invert;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uInvert: gl.getUniformLocation(program, "uInvert")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1i(uniformLocations.uInvert, this.invert);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
   */ fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Noise filter class
   * @class fabric.Image.filters.Noise
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Noise",
        /**
     * Fragment source for the noise program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uStepH;\nuniform float uNoise;\nuniform float uSeed;\nvarying vec2 vTexCoord;\nfloat rand(vec2 co, float seed, float vScale) {\nreturn fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n}\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ncolor.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\ngl_FragColor = color;\n}",
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: "noise",
        /**
     * Noise value, from
     * @param {Number} noise
     * @default
     */ noise: 0,
        /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.noise === 0) return;
            var imageData = options.imageData, data = imageData.data, i, len = data.length, noise = this.noise, rand;
            for(i = 0, len = data.length; i < len; i += 4){
                rand = (0.5 - Math.random()) * noise;
                data[i] += rand;
                data[i + 1] += rand;
                data[i + 2] += rand;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uNoise: gl.getUniformLocation(program, "uNoise"),
                uSeed: gl.getUniformLocation(program, "uSeed")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
            gl.uniform1f(uniformLocations.uSeed, Math.random());
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper("toObject"), {
                noise: this.noise
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
   */ fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Pixelate filter class
   * @class fabric.Image.filters.Pixelate
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Pixelate",
        blocksize: 4,
        mainParameter: "blocksize",
        /**
     * Fragment source for the Pixelate program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uBlocksize;\nuniform float uStepW;\nuniform float uStepH;\nvarying vec2 vTexCoord;\nvoid main() {\nfloat blockW = uBlocksize * uStepW;\nfloat blockH = uBlocksize * uStepW;\nint posX = int(vTexCoord.x / blockW);\nint posY = int(vTexCoord.y / blockH);\nfloat fposX = float(posX);\nfloat fposY = float(posY);\nvec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\nvec4 color = texture2D(uTexture, squareCoords);\ngl_FragColor = color;\n}",
        /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = imageData.height, jLen = imageData.width, index, i, j, r, g, b, a, _i, _j, _iLen, _jLen;
            for(i = 0; i < iLen; i += this.blocksize)for(j = 0; j < jLen; j += this.blocksize){
                index = i * 4 * jLen + j * 4;
                r = data[index];
                g = data[index + 1];
                b = data[index + 2];
                a = data[index + 3];
                _iLen = Math.min(i + this.blocksize, iLen);
                _jLen = Math.min(j + this.blocksize, jLen);
                for(_i = i; _i < _iLen; _i++)for(_j = j; _j < _jLen; _j++){
                    index = _i * 4 * jLen + _j * 4;
                    data[index] = r;
                    data[index + 1] = g;
                    data[index + 2] = b;
                    data[index + 3] = a;
                }
            }
        },
        /**
     * Indicate when the filter is not gonna apply changes to the image
     **/ isNeutralState: function() {
            return this.blocksize === 1;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uBlocksize: gl.getUniformLocation(program, "uBlocksize"),
                uStepW: gl.getUniformLocation(program, "uStepW"),
                uStepH: gl.getUniformLocation(program, "uStepH")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
   */ fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), extend = fabric.util.object.extend, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Remove white filter class
   * @class fabric.Image.filters.RemoveColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "RemoveColor",
        /**
     * Color to remove, in any format understood by fabric.Color.
     * @param {String} type
     * @default
     */ color: "#FFFFFF",
        /**
     * Fragment source for the brightness program
     */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\ngl_FragColor = texture2D(uTexture, vTexCoord);\nif(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\ngl_FragColor.a = 0.0;\n}\n}",
        /**
     * distance to actual color, as value up or down from each r,g,b
     * between 0 and 1
     **/ distance: 0.02,
        /**
     * For color to remove inside distance, use alpha channel for a smoother deletion
     * NOT IMPLEMENTED YET
     **/ useAlpha: false,
        /**
     * Constructor
     * @memberOf fabric.Image.filters.RemoveWhite.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.color=#RRGGBB] Threshold value
     * @param {Number} [options.distance=10] Distance value
     */ /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, i, distance = this.distance * 255, r, g, b, source = new fabric.Color(this.color).getSource(), lowC = [
                source[0] - distance,
                source[1] - distance,
                source[2] - distance
            ], highC = [
                source[0] + distance,
                source[1] + distance,
                source[2] + distance
            ];
            for(i = 0; i < data.length; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) data[i + 3] = 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uLow: gl.getUniformLocation(program, "uLow"),
                uHigh: gl.getUniformLocation(program, "uHigh")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource(), distance = parseFloat(this.distance), lowC = [
                0 + source[0] / 255 - distance,
                0 + source[1] / 255 - distance,
                0 + source[2] / 255 - distance,
                1
            ], highC = [
                source[0] / 255 + distance,
                source[1] / 255 + distance,
                source[2] / 255 + distance,
                1
            ];
            gl.uniform4fv(uniformLocations.uLow, lowC);
            gl.uniform4fv(uniformLocations.uHigh, highC);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return extend(this.callSuper("toObject"), {
                color: this.color,
                distance: this.distance
            });
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
   */ fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    var matrices = {
        Brownie: [
            0.59970,
            0.34553,
            -0.27082,
            0,
            0.186,
            -0.0377,
            0.86095,
            0.15059,
            0,
            -0.1449,
            0.24113,
            -0.07441,
            0.44972,
            0,
            -0.02965,
            0,
            0,
            0,
            1,
            0
        ],
        Vintage: [
            0.62793,
            0.32021,
            -0.03965,
            0,
            0.03784,
            0.02578,
            0.64411,
            0.03259,
            0,
            0.02926,
            0.04660,
            -0.08512,
            0.52416,
            0,
            0.02023,
            0,
            0,
            0,
            1,
            0
        ],
        Kodachrome: [
            1.12855,
            -0.39673,
            -0.03992,
            0,
            0.24991,
            -0.16404,
            1.08352,
            -0.05498,
            0,
            0.09698,
            -0.16786,
            -0.56034,
            1.60148,
            0,
            0.13972,
            0,
            0,
            0,
            1,
            0
        ],
        Technicolor: [
            1.91252,
            -0.85453,
            -0.09155,
            0,
            0.04624,
            -0.30878,
            1.76589,
            -0.10601,
            0,
            -0.27589,
            -0.2311,
            -0.75018,
            1.84759,
            0,
            0.12137,
            0,
            0,
            0,
            1,
            0
        ],
        Polaroid: [
            1.438,
            -0.062,
            -0.062,
            0,
            0,
            -0.122,
            1.378,
            -0.122,
            0,
            0,
            -0.016,
            -0.016,
            1.483,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        Sepia: [
            0.393,
            0.769,
            0.189,
            0,
            0,
            0.349,
            0.686,
            0.168,
            0,
            0,
            0.272,
            0.534,
            0.131,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ],
        BlackWhite: [
            1.5,
            1.5,
            1.5,
            0,
            -1,
            1.5,
            1.5,
            1.5,
            0,
            -1,
            1.5,
            1.5,
            1.5,
            0,
            -1,
            0,
            0,
            0,
            1,
            0
        ]
    };
    for(var key in matrices){
        filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {
            /**
       * Filter type
       * @param {String} type
       * @default
       */ type: key,
            /**
       * Colormatrix for the effect
       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
       * outside the -1, 1 range.
       * @param {Array} matrix array of 20 numbers.
       * @default
       */ matrix: matrices[key],
            /**
       * Lock the matrix export for this kind of static, parameter less filters.
       */ mainParameter: false,
            /**
       * Lock the colormatrix on the color part, skipping alpha
       */ colorsOnly: true
        });
        fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
    }
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Color Blend filter class
   * @class fabric.Image.filter.BlendColor
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
        type: "BlendColor",
        /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     * @type String
     * @default
     **/ color: "#F95C63",
        /**
     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
     * darken, lighten, overlay, exclusion, tint.
     * @type String
     * @default
     **/ mode: "multiply",
        /**
     * alpha value. represent the strength of the blend color operation.
     * @type Number
     * @default
     **/ alpha: 1,
        /**
     * Fragment source for the Multiply program
     */ fragmentSource: {
            multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
            screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
            add: "gl_FragColor.rgb += uColor.rgb;\n",
            diff: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
            subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
            lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
            darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
            exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
            overlay: "if (uColor.r < 0.5) {\ngl_FragColor.r *= 2.0 * uColor.r;\n} else {\ngl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n}\nif (uColor.g < 0.5) {\ngl_FragColor.g *= 2.0 * uColor.g;\n} else {\ngl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n}\nif (uColor.b < 0.5) {\ngl_FragColor.b *= 2.0 * uColor.b;\n} else {\ngl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n}\n",
            tint: "gl_FragColor.rgb *= (1.0 - uColor.a);\ngl_FragColor.rgb += uColor.rgb;\n"
        },
        /**
     * build the fragment source for the filters, joining the common part with
     * the specific one.
     * @param {String} mode the mode of the filter, a key of this.fragmentSource
     * @return {String} the source to be compiled
     * @private
     */ buildSource: function(mode) {
            return "precision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\ngl_FragColor = color;\nif (color.a > 0.0) {\n" + this.fragmentSource[mode] + "}\n" + "}";
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + "_" + this.mode, shaderSource;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                shaderSource = this.buildSource(this.mode);
                options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            }
            return options.programCache[cacheKey];
        },
        /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, iLen = data.length, tr, tg, tb, r, g, b, source, alpha1 = 1 - this.alpha;
            source = new fabric.Color(this.color).getSource();
            tr = source[0] * this.alpha;
            tg = source[1] * this.alpha;
            tb = source[2] * this.alpha;
            for(var i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                switch(this.mode){
                    case "multiply":
                        data[i] = r * tr / 255;
                        data[i + 1] = g * tg / 255;
                        data[i + 2] = b * tb / 255;
                        break;
                    case "screen":
                        data[i] = 255 - (255 - r) * (255 - tr) / 255;
                        data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
                        data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
                        break;
                    case "add":
                        data[i] = r + tr;
                        data[i + 1] = g + tg;
                        data[i + 2] = b + tb;
                        break;
                    case "diff":
                    case "difference":
                        data[i] = Math.abs(r - tr);
                        data[i + 1] = Math.abs(g - tg);
                        data[i + 2] = Math.abs(b - tb);
                        break;
                    case "subtract":
                        data[i] = r - tr;
                        data[i + 1] = g - tg;
                        data[i + 2] = b - tb;
                        break;
                    case "darken":
                        data[i] = Math.min(r, tr);
                        data[i + 1] = Math.min(g, tg);
                        data[i + 2] = Math.min(b, tb);
                        break;
                    case "lighten":
                        data[i] = Math.max(r, tr);
                        data[i + 1] = Math.max(g, tg);
                        data[i + 2] = Math.max(b, tb);
                        break;
                    case "overlay":
                        data[i] = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                        data[i + 1] = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                        data[i + 2] = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                        break;
                    case "exclusion":
                        data[i] = tr + r - 2 * tr * r / 255;
                        data[i + 1] = tg + g - 2 * tg * g / 255;
                        data[i + 2] = tb + b - 2 * tb * b / 255;
                        break;
                    case "tint":
                        data[i] = tr + r * alpha1;
                        data[i + 1] = tg + g * alpha1;
                        data[i + 2] = tb + b * alpha1;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uColor: gl.getUniformLocation(program, "uColor")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var source = new fabric.Color(this.color).getSource();
            source[0] = this.alpha * source[0] / 255;
            source[1] = this.alpha * source[1] / 255;
            source[2] = this.alpha * source[2] / 255;
            source[3] = this.alpha;
            gl.uniform4fv(uniformLocations.uColor, source);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                color: this.color,
                mode: this.mode,
                alpha: this.alpha
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
   */ fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Image Blend filter class
   * @class fabric.Image.filter.BlendImage
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @example
   * var filter = new fabric.Image.filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * var filter = new fabric.Image.filters.BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply',
   *  alpha: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
        type: "BlendImage",
        /**
     * Color to make the blend operation with. default to a reddish color since black or white
     * gives always strong result.
     **/ image: null,
        /**
     * Blend mode for the filter (one of "multiply", "mask")
     * @type String
     * @default
     **/ mode: "multiply",
        /**
     * alpha value. represent the strength of the blend image operation.
     * not implemented.
     **/ alpha: 1,
        vertexSource: "attribute vec2 aPosition;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nuniform mat3 uTransformMatrix;\nvoid main() {\nvTexCoord = aPosition;\nvTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\ngl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n}",
        /**
     * Fragment source for the Multiply program
     */ fragmentSource: {
            multiply: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.rgba *= color2.rgba;\ngl_FragColor = color;\n}",
            mask: "precision highp float;\nuniform sampler2D uTexture;\nuniform sampler2D uImage;\nuniform vec4 uColor;\nvarying vec2 vTexCoord;\nvarying vec2 vTexCoord2;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec4 color2 = texture2D(uImage, vTexCoord2);\ncolor.a = color2.a;\ngl_FragColor = color;\n}"
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var cacheKey = this.type + "_" + this.mode;
            var shaderSource = this.fragmentSource[this.mode];
            if (!options.programCache.hasOwnProperty(cacheKey)) options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
            return options.programCache[cacheKey];
        },
        applyToWebGL: function(options) {
            // load texture to blend.
            var gl = options.context, texture = this.createTexture(options.filterBackend, this.image);
            this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
            this.callSuper("applyToWebGL", options);
            this.unbindAdditionalTexture(gl, gl.TEXTURE1);
        },
        createTexture: function(backend, image) {
            return backend.getCachedTexture(image.cacheKey, image._element);
        },
        /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ calculateMatrix: function() {
            var image = this.image, width = image._element.width, height = image._element.height;
            return [
                1 / image.scaleX,
                0,
                0,
                0,
                1 / image.scaleY,
                0,
                -image.left / width,
                -image.top / height,
                1
            ];
        },
        /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, resources = options.filterBackend.resources, data = imageData.data, iLen = data.length, width = imageData.width, height = imageData.height, tr, tg, tb, ta, r, g, b, a, canvas1, context, image = this.image, blendData;
            if (!resources.blendImage) resources.blendImage = fabric.util.createCanvasElement();
            canvas1 = resources.blendImage;
            context = canvas1.getContext("2d");
            if (canvas1.width !== width || canvas1.height !== height) {
                canvas1.width = width;
                canvas1.height = height;
            } else context.clearRect(0, 0, width, height);
            context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
            context.drawImage(image._element, 0, 0, width, height);
            blendData = context.getImageData(0, 0, width, height).data;
            for(var i = 0; i < iLen; i += 4){
                r = data[i];
                g = data[i + 1];
                b = data[i + 2];
                a = data[i + 3];
                tr = blendData[i];
                tg = blendData[i + 1];
                tb = blendData[i + 2];
                ta = blendData[i + 3];
                switch(this.mode){
                    case "multiply":
                        data[i] = r * tr / 255;
                        data[i + 1] = g * tg / 255;
                        data[i + 2] = b * tb / 255;
                        data[i + 3] = a * ta / 255;
                        break;
                    case "mask":
                        data[i + 3] = ta;
                        break;
                }
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uTransformMatrix: gl.getUniformLocation(program, "uTransformMatrix"),
                uImage: gl.getUniformLocation(program, "uImage")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var matrix = this.calculateMatrix();
            gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
            gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                image: this.image && this.image.toObject(),
                mode: this.mode,
                alpha: this.alpha
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} callback to be invoked after filter creation
   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
   */ fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
        fabric.Image.fromObject(object.image, function(image) {
            var options = fabric.util.object.clone(object);
            options.image = image;
            callback(new fabric.Image.filters.BlendImage(options));
        });
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), pow = Math.pow, floor = Math.floor, sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin, ceil = Math.ceil, filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Resize image filter class
   * @class fabric.Image.filters.Resize
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */ filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Resize",
        /**
     * Resize type
     * for webgl resizeType is just lanczos, for canvas2d can be:
     * bilinear, hermite, sliceHack, lanczos.
     * @param {String} resizeType
     * @default
     */ resizeType: "hermite",
        /**
     * Scale factor for resizing, x axis
     * @param {Number} scaleX
     * @default
     */ scaleX: 1,
        /**
     * Scale factor for resizing, y axis
     * @param {Number} scaleY
     * @default
     */ scaleY: 1,
        /**
     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
     * @param {Number} lanczosLobes
     * @default
     */ lanczosLobes: 3,
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uDelta: gl.getUniformLocation(program, "uDelta"),
                uTaps: gl.getUniformLocation(program, "uTaps")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [
                1 / this.width,
                0
            ] : [
                0,
                1 / this.height
            ]);
            gl.uniform1fv(uniformLocations.uTaps, this.taps);
        },
        /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ retrieveShader: function(options) {
            var filterWindow = this.getFilterWindow(), cacheKey = this.type + "_" + filterWindow;
            if (!options.programCache.hasOwnProperty(cacheKey)) {
                var fragmentShader = this.generateShader(filterWindow);
                options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
            }
            return options.programCache[cacheKey];
        },
        getFilterWindow: function() {
            var scale = this.tempScale;
            return Math.ceil(this.lanczosLobes / scale);
        },
        getTaps: function() {
            var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
            for(var i = 1; i <= filterWindow; i++)taps[i - 1] = lobeFunction(i * scale);
            return taps;
        },
        /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */ generateShader: function(filterWindow) {
            var offsets = new Array(filterWindow), fragmentShader = this.fragmentSourceTOP, filterWindow;
            for(var i = 1; i <= filterWindow; i++)offsets[i - 1] = i + ".0 * uDelta";
            fragmentShader += "uniform float uTaps[" + filterWindow + "];\n";
            fragmentShader += "void main() {\n";
            fragmentShader += "  vec4 color = texture2D(uTexture, vTexCoord);\n";
            fragmentShader += "  float sum = 1.0;\n";
            offsets.forEach(function(offset, i) {
                fragmentShader += "  color += texture2D(uTexture, vTexCoord + " + offset + ") * uTaps[" + i + "];\n";
                fragmentShader += "  color += texture2D(uTexture, vTexCoord - " + offset + ") * uTaps[" + i + "];\n";
                fragmentShader += "  sum += 2.0 * uTaps[" + i + "];\n";
            });
            fragmentShader += "  gl_FragColor = color / sum;\n";
            fragmentShader += "}";
            return fragmentShader;
        },
        fragmentSourceTOP: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\n",
        /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ applyTo: function(options) {
            if (options.webgl) {
                options.passes++;
                this.width = options.sourceWidth;
                this.horizontal = true;
                this.dW = Math.round(this.width * this.scaleX);
                this.dH = options.sourceHeight;
                this.tempScale = this.dW / this.width;
                this.taps = this.getTaps();
                options.destinationWidth = this.dW;
                this._setupFrameBuffer(options);
                this.applyToWebGL(options);
                this._swapTextures(options);
                options.sourceWidth = options.destinationWidth;
                this.height = options.sourceHeight;
                this.horizontal = false;
                this.dH = Math.round(this.height * this.scaleY);
                this.tempScale = this.dH / this.height;
                this.taps = this.getTaps();
                options.destinationHeight = this.dH;
                this._setupFrameBuffer(options);
                this.applyToWebGL(options);
                this._swapTextures(options);
                options.sourceHeight = options.destinationHeight;
            } else this.applyTo2d(options);
        },
        isNeutralState: function() {
            return this.scaleX === 1 && this.scaleY === 1;
        },
        lanczosCreate: function(lobes) {
            return function(x) {
                if (x >= lobes || x <= -lobes) return 0.0;
                if (x < 1.19209290E-07 && x > -0.00000011920929) return 1.0;
                x *= Math.PI;
                var xx = x / lobes;
                return sin(x) / x * sin(xx) / xx;
            };
        },
        /**
     * Applies filter to canvas element
     * @memberOf fabric.Image.filters.Resize.prototype
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} scaleX
     * @param {Number} scaleY
     */ applyTo2d: function(options) {
            var imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
            this.rcpScaleX = 1 / scaleX;
            this.rcpScaleY = 1 / scaleY;
            var oW = imageData.width, oH = imageData.height, dW = round(oW * scaleX), dH = round(oH * scaleY), newData;
            if (this.resizeType === "sliceHack") newData = this.sliceByTwo(options, oW, oH, dW, dH);
            else if (this.resizeType === "hermite") newData = this.hermiteFastResize(options, oW, oH, dW, dH);
            else if (this.resizeType === "bilinear") newData = this.bilinearFiltering(options, oW, oH, dW, dH);
            else if (this.resizeType === "lanczos") newData = this.lanczosResize(options, oW, oH, dW, dH);
            options.imageData = newData;
        },
        /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ sliceByTwo: function(options, oW, oH, dW, dH) {
            var imageData = options.imageData, mult = 0.5, doneW = false, doneH = false, stepW = oW * mult, stepH = oH * mult, resources = fabric.filterBackend.resources, tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
            if (!resources.sliceByTwo) resources.sliceByTwo = document.createElement("canvas");
            tmpCanvas = resources.sliceByTwo;
            if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
                tmpCanvas.width = oW * 1.5;
                tmpCanvas.height = oH;
            }
            ctx = tmpCanvas.getContext("2d");
            ctx.clearRect(0, 0, oW * 1.5, oH);
            ctx.putImageData(imageData, 0, 0);
            dW = floor(dW);
            dH = floor(dH);
            while(!doneW || !doneH){
                oW = stepW;
                oH = stepH;
                if (dW < floor(stepW * mult)) stepW = floor(stepW * mult);
                else {
                    stepW = dW;
                    doneW = true;
                }
                if (dH < floor(stepH * mult)) stepH = floor(stepH * mult);
                else {
                    stepH = dH;
                    doneH = true;
                }
                ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
                sX = dX;
                sY = dY;
                dY += stepH;
            }
            return ctx.getImageData(sX, sY, dW, dH);
        },
        /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ lanczosResize: function(options, oW, oH, dW, dH) {
            function process(u) {
                var v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
                center.x = (u + 0.5) * ratioX;
                icenter.x = floor(center.x);
                for(v = 0; v < dH; v++){
                    center.y = (v + 0.5) * ratioY;
                    icenter.y = floor(center.y);
                    a = 0;
                    red = 0;
                    green = 0;
                    blue = 0;
                    alpha = 0;
                    for(i = icenter.x - range2X; i <= icenter.x + range2X; i++){
                        if (i < 0 || i >= oW) continue;
                        fX = floor(1000 * abs(i - center.x));
                        if (!cacheLanc[fX]) cacheLanc[fX] = {};
                        for(var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++){
                            if (j < 0 || j >= oH) continue;
                            fY = floor(1000 * abs(j - center.y));
                            if (!cacheLanc[fX][fY]) cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
                            weight = cacheLanc[fX][fY];
                            if (weight > 0) {
                                idx = (j * oW + i) * 4;
                                a += weight;
                                red += weight * srcData[idx];
                                green += weight * srcData[idx + 1];
                                blue += weight * srcData[idx + 2];
                                alpha += weight * srcData[idx + 3];
                            }
                        }
                    }
                    idx = (v * dW + u) * 4;
                    destData[idx] = red / a;
                    destData[idx + 1] = green / a;
                    destData[idx + 2] = blue / a;
                    destData[idx + 3] = alpha / a;
                }
                if (++u < dW) return process(u);
                else return destImg;
            }
            var srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = ceil(ratioX * this.lanczosLobes / 2), range2Y = ceil(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {}, icenter = {};
            return process(0);
        },
        /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ bilinearFiltering: function(options, oW, oH, dW, dH) {
            var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl, color, offset = 0, origPix, ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, w4 = 4 * (oW - 1), img = options.imageData, pixels = img.data, destImage = options.ctx.createImageData(dW, dH), destPixels = destImage.data;
            for(i = 0; i < dH; i++)for(j = 0; j < dW; j++){
                x = floor(ratioX * j);
                y = floor(ratioY * i);
                xDiff = ratioX * j - x;
                yDiff = ratioY * i - y;
                origPix = 4 * (y * oW + x);
                for(chnl = 0; chnl < 4; chnl++){
                    a = pixels[origPix + chnl];
                    b = pixels[origPix + 4 + chnl];
                    c = pixels[origPix + w4 + chnl];
                    d = pixels[origPix + w4 + 4 + chnl];
                    color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                    destPixels[offset++] = color;
                }
            }
            return destImage;
        },
        /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */ hermiteFastResize: function(options, oW, oH, dW, dH) {
            var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = ceil(ratioW / 2), ratioHHalf = ceil(ratioH / 2), img = options.imageData, data = img.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
            for(var j = 0; j < dH; j++)for(var i = 0; i < dW; i++){
                var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0, gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
                for(var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++){
                    var dy = abs(centerY - (yy + 0.5)) / ratioHHalf, centerX = (i + 0.5) * ratioW, w0 = dy * dy;
                    for(var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++){
                        var dx = abs(centerX - (xx + 0.5)) / ratioWHalf, w = sqrt(w0 + dx * dx);
                        /* eslint-disable max-depth */ if (w > 1 && w < -1) continue;
                        //hermite filter
                        weight = 2 * w * w * w - 3 * w * w + 1;
                        if (weight > 0) {
                            dx = 4 * (xx + yy * oW);
                            //alpha
                            gxA += weight * data[dx + 3];
                            weightsAlpha += weight;
                            //colors
                            if (data[dx + 3] < 255) weight = weight * data[dx + 3] / 250;
                            gxR += weight * data[dx];
                            gxG += weight * data[dx + 1];
                            gxB += weight * data[dx + 2];
                            weights += weight;
                        }
                    /* eslint-enable max-depth */ }
                }
                data2[x2] = gxR / weights;
                data2[x2 + 1] = gxG / weights;
                data2[x2 + 2] = gxB / weights;
                data2[x2 + 3] = gxA / weightsAlpha;
            }
            return img2;
        },
        /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */ toObject: function() {
            return {
                type: this.type,
                scaleX: this.scaleX,
                scaleY: this.scaleY,
                resizeType: this.resizeType,
                lanczosLobes: this.lanczosLobes
            };
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
   */ fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Contrast filter class
   * @class fabric.Image.filters.Contrast
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Contrast",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uContrast;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\ncolor.rgb = contrastF * (color.rgb - 0.5) + 0.5;\ngl_FragColor = color;\n}",
        /**
     * contrast value, range from -1 to 1.
     * @param {Number} contrast
     * @default 0
     */ contrast: 0,
        mainParameter: "contrast",
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Contrast.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
     */ /**
      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
      *
      * @param {Object} options
      * @param {ImageData} options.imageData The Uint8Array to be filtered.
      */ applyTo2d: function(options) {
            if (this.contrast === 0) return;
            var imageData = options.imageData, i, len, data = imageData.data, len = data.length, contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
            for(i = 0; i < len; i += 4){
                data[i] = contrastF * (data[i] - 128) + 128;
                data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
                data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uContrast: gl.getUniformLocation(program, "uContrast")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uContrast, this.contrast);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
   */ fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Saturate filter class
   * @class fabric.Image.filters.Saturation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Saturation({
   *   saturation: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Saturation",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uSaturation;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat rgMax = max(color.r, color.g);\nfloat rgbMax = max(rgMax, color.b);\ncolor.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\ncolor.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\ncolor.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\ngl_FragColor = color;\n}",
        /**
     * Saturation value, from -1 to 1.
     * Increases/decreases the color saturation.
     * A value of 0 has no effect.
     * 
     * @param {Number} saturation
     * @default
     */ saturation: 0,
        mainParameter: "saturation",
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Saturate.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
     */ /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.saturation === 0) return;
            var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.saturation, i, max;
            for(i = 0; i < len; i += 4){
                max = Math.max(data[i], data[i + 1], data[i + 2]);
                data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
                data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
                data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uSaturation: gl.getUniformLocation(program, "uSaturation")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
   */ fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Vibrance filter class
   * @class fabric.Image.filters.Vibrance
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Vibrance#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Vibrance({
   *   vibrance: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Vibrance = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Vibrance.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Vibrance",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform float uVibrance;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nfloat max = max(color.r, max(color.g, color.b));\nfloat avg = (color.r + color.g + color.b) / 3.0;\nfloat amt = (abs(max - avg) * 2.0) * uVibrance;\ncolor.r += max != color.r ? (max - color.r) * amt : 0.00;\ncolor.g += max != color.g ? (max - color.g) * amt : 0.00;\ncolor.b += max != color.b ? (max - color.b) * amt : 0.00;\ngl_FragColor = color;\n}",
        /**
     * Vibrance value, from -1 to 1.
     * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
     * A value of 0 has no effect.
     * 
     * @param {Number} vibrance
     * @default
     */ vibrance: 0,
        mainParameter: "vibrance",
        /**
     * Constructor
     * @memberOf fabric.Image.filters.Vibrance.prototype
     * @param {Object} [options] Options object
     * @param {Number} [options.vibrance=0] Vibrance value for the image (between -1 and 1)
     */ /**
     * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */ applyTo2d: function(options) {
            if (this.vibrance === 0) return;
            var imageData = options.imageData, data = imageData.data, len = data.length, adjust = -this.vibrance, i, max, avg, amt;
            for(i = 0; i < len; i += 4){
                max = Math.max(data[i], data[i + 1], data[i + 2]);
                avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
                amt = Math.abs(max - avg) * 2 / 255 * adjust;
                data[i] += max !== data[i] ? (max - data[i]) * amt : 0;
                data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * amt : 0;
                data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * amt : 0;
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uVibrance: gl.getUniformLocation(program, "uVibrance")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Vibrance} Instance of fabric.Image.filters.Vibrance
   */ fabric.Image.filters.Vibrance.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Blur filter class
   * @class fabric.Image.filters.Blur
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */ filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {
        type: "Blur",
        /*
'gl_FragColor = vec4(0.0);',
'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
*/ /* eslint-disable max-len */ fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec2 uDelta;\nvarying vec2 vTexCoord;\nconst float nSamples = 15.0;\nvec3 v3offset = vec3(12.9898, 78.233, 151.7182);\nfloat random(vec3 scale) {\nreturn fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n}\nvoid main() {\nvec4 color = vec4(0.0);\nfloat total = 0.0;\nfloat offset = random(v3offset);\nfor (float t = -nSamples; t <= nSamples; t++) {\nfloat percent = (t + offset - 0.5) / nSamples;\nfloat weight = 1.0 - abs(percent);\ncolor += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\ntotal += weight;\n}\ngl_FragColor = color / total;\n}",
        /* eslint-enable max-len */ /**
     * blur value, in percentage of image dimensions.
     * specific to keep the image blur constant at different resolutions
     * range between 0 and 1.
     * @type Number
     * @default
     */ blur: 0,
        mainParameter: "blur",
        applyTo: function(options) {
            if (options.webgl) {
                // this aspectRatio is used to give the same blur to vertical and horizontal
                this.aspectRatio = options.sourceWidth / options.sourceHeight;
                options.passes++;
                this._setupFrameBuffer(options);
                this.horizontal = true;
                this.applyToWebGL(options);
                this._swapTextures(options);
                this._setupFrameBuffer(options);
                this.horizontal = false;
                this.applyToWebGL(options);
                this._swapTextures(options);
            } else this.applyTo2d(options);
        },
        applyTo2d: function(options) {
            // paint canvasEl with current image data.
            //options.ctx.putImageData(options.imageData, 0, 0);
            options.imageData = this.simpleBlur(options);
        },
        simpleBlur: function(options) {
            var resources = options.filterBackend.resources, canvas1, canvas2, width = options.imageData.width, height = options.imageData.height;
            if (!resources.blurLayer1) {
                resources.blurLayer1 = fabric.util.createCanvasElement();
                resources.blurLayer2 = fabric.util.createCanvasElement();
            }
            canvas1 = resources.blurLayer1;
            canvas2 = resources.blurLayer2;
            if (canvas1.width !== width || canvas1.height !== height) {
                canvas2.width = canvas1.width = width;
                canvas2.height = canvas1.height = height;
            }
            var ctx1 = canvas1.getContext("2d"), ctx2 = canvas2.getContext("2d"), nSamples = 15, random, percent, j, i, blur = this.blur * 0.03;
            // load first canvas
            ctx1.putImageData(options.imageData, 0, 0);
            ctx2.clearRect(0, 0, width, height);
            for(i = -nSamples; i <= nSamples; i++){
                random = (Math.random() - 0.5) / 4;
                percent = i / nSamples;
                j = blur * percent * width + random;
                ctx2.globalAlpha = 1 - Math.abs(percent);
                ctx2.drawImage(canvas1, j, random);
                ctx1.drawImage(canvas2, 0, 0);
                ctx2.globalAlpha = 1;
                ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
            }
            for(i = -nSamples; i <= nSamples; i++){
                random = (Math.random() - 0.5) / 4;
                percent = i / nSamples;
                j = blur * percent * height + random;
                ctx2.globalAlpha = 1 - Math.abs(percent);
                ctx2.drawImage(canvas1, random, j);
                ctx1.drawImage(canvas2, 0, 0);
                ctx2.globalAlpha = 1;
                ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
            }
            options.ctx.drawImage(canvas1, 0, 0);
            var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
            ctx1.globalAlpha = 1;
            ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
            return newImageData;
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                delta: gl.getUniformLocation(program, "uDelta")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            var delta = this.chooseRightDelta();
            gl.uniform2fv(uniformLocations.delta, delta);
        },
        /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */ chooseRightDelta: function() {
            var blurScale = 1, delta = [
                0,
                0
            ], blur;
            if (this.horizontal) {
                if (this.aspectRatio > 1) // image is wide, i want to shrink radius horizontal
                blurScale = 1 / this.aspectRatio;
            } else if (this.aspectRatio < 1) // image is tall, i want to shrink radius vertical
            blurScale = this.aspectRatio;
            blur = blurScale * this.blur * 0.12;
            if (this.horizontal) delta[0] = blur;
            else delta[1] = blur;
            return delta;
        }
    });
    /**
   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
   */ filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * Gamma filter class
   * @class fabric.Image.filters.Gamma
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.Gamma({
   *   gamma: [1, 0.5, 2.1]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "Gamma",
        fragmentSource: "precision highp float;\nuniform sampler2D uTexture;\nuniform vec3 uGamma;\nvarying vec2 vTexCoord;\nvoid main() {\nvec4 color = texture2D(uTexture, vTexCoord);\nvec3 correction = (1.0 / uGamma);\ncolor.r = pow(color.r, correction.r);\ncolor.g = pow(color.g, correction.g);\ncolor.b = pow(color.b, correction.b);\ngl_FragColor = color;\ngl_FragColor.rgb *= color.a;\n}",
        /**
     * Gamma array value, from 0.01 to 2.2.
     * @param {Array} gamma
     * @default
     */ gamma: [
            1,
            1,
            1
        ],
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: "gamma",
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.gamma = [
                1,
                1,
                1
            ];
            filters.BaseFilter.prototype.initialize.call(this, options);
        },
        /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */ applyTo2d: function(options) {
            var imageData = options.imageData, data = imageData.data, gamma = this.gamma, len = data.length, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2], i;
            if (!this.rVals) {
                // eslint-disable-next-line
                this.rVals = new Uint8Array(256);
                // eslint-disable-next-line
                this.gVals = new Uint8Array(256);
                // eslint-disable-next-line
                this.bVals = new Uint8Array(256);
            }
            // This is an optimization - pre-compute a look-up table for each color channel
            // instead of performing these pow calls for each pixel in the image.
            for(i = 0, len = 256; i < len; i++){
                this.rVals[i] = Math.pow(i / 255, rInv) * 255;
                this.gVals[i] = Math.pow(i / 255, gInv) * 255;
                this.bVals[i] = Math.pow(i / 255, bInv) * 255;
            }
            for(i = 0, len = data.length; i < len; i += 4){
                data[i] = this.rVals[data[i]];
                data[i + 1] = this.gVals[data[i + 1]];
                data[i + 2] = this.bVals[data[i + 2]];
            }
        },
        /**
     * Return WebGL uniform locations for this filter's shader.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {WebGLShaderProgram} program This filter's compiled shader program.
     */ getUniformLocations: function(gl, program) {
            return {
                uGamma: gl.getUniformLocation(program, "uGamma")
            };
        },
        /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */ sendUniformData: function(gl, uniformLocations) {
            gl.uniform3fv(uniformLocations.uGamma, this.gamma);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
   */ fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */ filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {
        type: "Composed",
        /**
     * A non sparse array of filters to apply
     */ subFilters: [],
        /**
     * Constructor
     * @param {Object} [options] Options object
     */ initialize: function(options) {
            this.callSuper("initialize", options);
            // create a new array instead mutating the prototype with push
            this.subFilters = this.subFilters.slice(0);
        },
        /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */ applyTo: function(options) {
            options.passes += this.subFilters.length - 1;
            this.subFilters.forEach(function(filter) {
                filter.applyTo(options);
            });
        },
        /**
     * Serialize this filter into JSON.
     *
     * @returns {Object} A JSON representation of this filter.
     */ toObject: function() {
            return fabric.util.object.extend(this.callSuper("toObject"), {
                subFilters: this.subFilters.map(function(filter) {
                    return filter.toObject();
                })
            });
        },
        isNeutralState: function() {
            return !this.subFilters.some(function(filter) {
                return !filter.isNeutralState();
            });
        }
    });
    /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   */ fabric.Image.filters.Composed.fromObject = function(object, callback) {
        var filters = object.subFilters || [], subFilters = filters.map(function(filter) {
            return new fabric.Image.filters[filter.type](filter);
        }), instance = new fabric.Image.filters.Composed({
            subFilters: subFilters
        });
        callback && callback(instance);
        return instance;
    };
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), filters = fabric.Image.filters, createClass = fabric.util.createClass;
    /**
   * HueRotation filter class
   * @class fabric.Image.filters.HueRotation
   * @memberOf fabric.Image.filters
   * @extends fabric.Image.filters.BaseFilter
   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @example
   * var filter = new fabric.Image.filters.HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {
        /**
     * Filter type
     * @param {String} type
     * @default
     */ type: "HueRotation",
        /**
     * HueRotation value, from -1 to 1.
     * the unit is radians
     * @param {Number} myParameter
     * @default
     */ rotation: 0,
        /**
     * Describe the property that is the filter parameter
     * @param {String} m
     * @default
     */ mainParameter: "rotation",
        calculateMatrix: function() {
            var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
            this.matrix = [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0
            ];
            this.matrix[0] = cos + OneMinusCos / 3;
            this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[6] = cos + aThird * OneMinusCos;
            this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
            this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
            this.matrix[12] = cos + aThird * OneMinusCos;
        },
        /**
     * HueRotation isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/ isNeutralState: function(options) {
            this.calculateMatrix();
            return filters.BaseFilter.prototype.isNeutralState.call(this, options);
        },
        /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */ applyTo: function(options) {
            this.calculateMatrix();
            filters.BaseFilter.prototype.applyTo.call(this, options);
        }
    });
    /**
   * Returns filter instance from an object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] to be invoked after filter creation
   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
   */ fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
})($d47795690082d4de$exports);
(function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {}), clone = fabric.util.object.clone;
    if (fabric.Text) {
        fabric.warn("fabric.Text is already defined");
        return;
    }
    var additionalProps = "fontFamily fontWeight fontSize text underline overline linethrough textAlign fontStyle lineHeight textBackgroundColor charSpacing styles direction path pathStartOffset pathSide pathAlign".split(" ");
    /**
   * Text class
   * @class fabric.Text
   * @extends fabric.Object
   * @return {fabric.Text} thisArg
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   * @see {@link fabric.Text#initialize} for constructor definition
   */ fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {
        /**
     * Properties which when set cause object to change dimensions
     * @type Array
     * @private
     */ _dimensionAffectingProps: [
            "fontSize",
            "fontWeight",
            "fontFamily",
            "fontStyle",
            "lineHeight",
            "text",
            "charSpacing",
            "textAlign",
            "styles",
            "path",
            "pathStartOffset",
            "pathSide",
            "pathAlign"
        ],
        /**
     * @private
     */ _reNewline: /\r?\n/,
        /**
     * Use this regular expression to filter for whitespaces that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reSpacesAndTabs: /[ \t\r]/g,
        /**
     * Use this regular expression to filter for whitespace that is not a new line.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reSpaceAndTab: /[ \t\r]/,
        /**
     * Use this regular expression to filter consecutive groups of non spaces.
     * Mostly used when text is 'justify' aligned.
     * @private
     */ _reWords: /\S+/g,
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "text",
        /**
     * Font size (in pixels)
     * @type Number
     * @default
     */ fontSize: 40,
        /**
     * Font weight (e.g. bold, normal, 400, 600, 800)
     * @type {(Number|String)}
     * @default
     */ fontWeight: "normal",
        /**
     * Font family
     * @type String
     * @default
     */ fontFamily: "Times New Roman",
        /**
     * Text decoration underline.
     * @type Boolean
     * @default
     */ underline: false,
        /**
     * Text decoration overline.
     * @type Boolean
     * @default
     */ overline: false,
        /**
     * Text decoration linethrough.
     * @type Boolean
     * @default
     */ linethrough: false,
        /**
     * Text alignment. Possible values: "left", "center", "right", "justify",
     * "justify-left", "justify-center" or "justify-right".
     * @type String
     * @default
     */ textAlign: "left",
        /**
     * Font style . Possible values: "", "normal", "italic" or "oblique".
     * @type String
     * @default
     */ fontStyle: "normal",
        /**
     * Line height
     * @type Number
     * @default
     */ lineHeight: 1.16,
        /**
     * Superscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */ superscript: {
            size: 0.60,
            baseline: -0.35 // baseline-shift factor (upwards)
        },
        /**
     * Subscript schema object (minimum overlap)
     * @type {Object}
     * @default
     */ subscript: {
            size: 0.60,
            baseline: 0.11 // baseline-shift factor (downwards)
        },
        /**
     * Background color of text lines
     * @type String
     * @default
     */ textBackgroundColor: "",
        /**
     * List of properties to consider when checking if
     * state of an object is changed ({@link fabric.Object#hasStateChanged})
     * as well as for history (undo/redo) purposes
     * @type Array
     */ stateProperties: fabric.Object.prototype.stateProperties.concat(additionalProps),
        /**
     * List of properties to consider when checking if cache needs refresh
     * @type Array
     */ cacheProperties: fabric.Object.prototype.cacheProperties.concat(additionalProps),
        /**
     * When defined, an object is rendered via stroke and this property specifies its color.
     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
     * @type String
     * @default
     */ stroke: null,
        /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
     * @type fabric.Shadow
     * @default
     */ shadow: null,
        /**
     * fabric.Path that the text should follow.
     * since 4.6.0 the path will be drawn automatically.
     * if you want to make the path visible, give it a stroke and strokeWidth or fill value
     * if you want it to be hidden, assign visible = false to the path.
     * This feature is in BETA, and SVG import/export is not yet supported.
     * @type fabric.Path
     * @example
     * var textPath = new fabric.Text('Text on a path', {
     *     top: 150,
     *     left: 150,
     *     textAlign: 'center',
     *     charSpacing: -50,
     *     path: new fabric.Path('M 0 0 C 50 -100 150 -100 200 0', {
     *         strokeWidth: 1,
     *         visible: false
     *     }),
     *     pathSide: 'left',
     *     pathStartOffset: 0
     * });
     * @default
     */ path: null,
        /**
     * Offset amount for text path starting position
     * Only used when text has a path
     * @type Number
     * @default
     */ pathStartOffset: 0,
        /**
     * Which side of the path the text should be drawn on.
     * Only used when text has a path
     * @type {String} 'left|right'
     * @default
     */ pathSide: "left",
        /**
     * How text is aligned to the path. This property determines
     * the perpendicular position of each character relative to the path.
     * (one of "baseline", "center", "ascender", "descender")
     * This feature is in BETA, and its behavior may change
     * @type String
     * @default
     */ pathAlign: "baseline",
        /**
     * @private
     */ _fontSizeFraction: 0.222,
        /**
     * @private
     */ offsets: {
            underline: 0.10,
            linethrough: -0.315,
            overline: -0.88
        },
        /**
     * Text Line proportion to font Size (in pixels)
     * @type Number
     * @default
     */ _fontSizeMult: 1.13,
        /**
     * additional space between characters
     * expressed in thousands of em unit
     * @type Number
     * @default
     */ charSpacing: 0,
        /**
     * Object containing character styles - top-level properties -> line numbers,
     * 2nd-level properties - character numbers
     * @type Object
     * @default
     */ styles: null,
        /**
     * Reference to a context to measure text char or couple of chars
     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
     * once created it will be referenced on fabric._measuringContext to avoid creating a canvas for every
     * text object created.
     * @type {CanvasRenderingContext2D}
     * @default
     */ _measuringContext: null,
        /**
     * Baseline shift, styles only, keep at 0 for the main text object
     * @type {Number}
     * @default
     */ deltaY: 0,
        /**
     * WARNING: EXPERIMENTAL. NOT SUPPORTED YET
     * determine the direction of the text.
     * This has to be set manually together with textAlign and originX for proper
     * experience.
     * some interesting link for the future
     * https://www.w3.org/International/questions/qa-bidi-unicode-controls
     * @since 4.5.0
     * @type {String} 'ltr|rtl'
     * @default
     */ direction: "ltr",
        /**
     * Array of properties that define a style unit (of 'styles').
     * @type {Array}
     * @default
     */ _styleProperties: [
            "stroke",
            "strokeWidth",
            "fill",
            "fontFamily",
            "fontSize",
            "fontWeight",
            "fontStyle",
            "underline",
            "overline",
            "linethrough",
            "deltaY",
            "textBackgroundColor"
        ],
        /**
     * contains characters bounding boxes
     */ __charBounds: [],
        /**
     * use this size when measuring text. To avoid IE11 rounding errors
     * @type {Number}
     * @default
     * @readonly
     * @private
     */ CACHE_FONT_SIZE: 400,
        /**
     * contains the min text width to avoid getting 0
     * @type {Number}
     * @default
     */ MIN_TEXT_WIDTH: 2,
        /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */ initialize: function(text, options) {
            this.styles = options ? options.styles || {} : {};
            this.text = text;
            this.__skipDimension = true;
            this.callSuper("initialize", options);
            if (this.path) this.setPathInfo();
            this.__skipDimension = false;
            this.initDimensions();
            this.setCoords();
            this.setupState({
                propertySet: "_dimensionAffectingProps"
            });
        },
        /**
     * If text has a path, it will add the extra information needed
     * for path and text calculations
     * @return {fabric.Text} thisArg
     */ setPathInfo: function() {
            var path = this.path;
            if (path) path.segmentsInfo = fabric.util.getPathSegmentsInfo(path.path);
        },
        /**
     * Return a context for measurement of text string.
     * if created it gets stored for reuse
     * this is for internal use, please do not use it
     * @private
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.Text} thisArg
     */ getMeasuringContext: function() {
            // if we did not return we have to measure something.
            if (!fabric._measuringContext) fabric._measuringContext = this.canvas && this.canvas.contextCache || fabric.util.createCanvasElement().getContext("2d");
            return fabric._measuringContext;
        },
        /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */ _splitText: function() {
            var newLines = this._splitTextIntoLines(this.text);
            this.textLines = newLines.lines;
            this._textLines = newLines.graphemeLines;
            this._unwrappedTextLines = newLines._unwrappedLines;
            this._text = newLines.graphemeText;
            return newLines;
        },
        /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */ initDimensions: function() {
            if (this.__skipDimension) return;
            this._splitText();
            this._clearCache();
            if (this.path) {
                this.width = this.path.width;
                this.height = this.path.height;
            } else {
                this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
                this.height = this.calcTextHeight();
            }
            if (this.textAlign.indexOf("justify") !== -1) // once text is measured we need to make space fatter to make justified text.
            this.enlargeSpaces();
            this.saveState({
                propertySet: "_dimensionAffectingProps"
            });
        },
        /**
     * Enlarge space boxes and shift the others
     */ enlargeSpaces: function() {
            var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                if (this.textAlign !== "justify" && (i === len - 1 || this.isEndOfWrapping(i))) continue;
                accumulatedSpace = 0;
                line = this._textLines[i];
                currentLineWidth = this.getLineWidth(i);
                if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
                    numberOfSpaces = spaces.length;
                    diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
                    for(var j = 0, jlen = line.length; j <= jlen; j++){
                        charBound = this.__charBounds[i][j];
                        if (this._reSpaceAndTab.test(line[j])) {
                            charBound.width += diffSpace;
                            charBound.kernedWidth += diffSpace;
                            charBound.left += accumulatedSpace;
                            accumulatedSpace += diffSpace;
                        } else charBound.left += accumulatedSpace;
                    }
                }
            }
        },
        /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */ isEndOfWrapping: function(lineIndex) {
            return lineIndex === this._textLines.length - 1;
        },
        /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always for text and Itext.
     * @return Number
     */ missingNewlineOffset: function() {
            return 1;
        },
        /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */ toString: function() {
            return "#<fabric.Text (" + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
        },
        /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */ _getCacheCanvasDimensions: function() {
            var dims = this.callSuper("_getCacheCanvasDimensions");
            var fontSize = this.fontSize;
            dims.width += fontSize * dims.zoomX;
            dims.height += fontSize * dims.zoomY;
            return dims;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            var path = this.path;
            path && !path.isNotVisible() && path._render(ctx);
            this._setTextStyles(ctx);
            this._renderTextLinesBackground(ctx);
            this._renderTextDecoration(ctx, "underline");
            this._renderText(ctx);
            this._renderTextDecoration(ctx, "overline");
            this._renderTextDecoration(ctx, "linethrough");
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderText: function(ctx) {
            if (this.paintFirst === "stroke") {
                this._renderTextStroke(ctx);
                this._renderTextFill(ctx);
            } else {
                this._renderTextFill(ctx);
                this._renderTextStroke(ctx);
            }
        },
        /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */ _setTextStyles: function(ctx, charStyle, forMeasuring) {
            ctx.textBaseline = "alphabetical";
            if (this.path) switch(this.pathAlign){
                case "center":
                    ctx.textBaseline = "middle";
                    break;
                case "ascender":
                    ctx.textBaseline = "top";
                    break;
                case "descender":
                    ctx.textBaseline = "bottom";
                    break;
            }
            ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
        },
        /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of fabric.Text object
     */ calcTextWidth: function() {
            var maxWidth = this.getLineWidth(0);
            for(var i = 1, len = this._textLines.length; i < len; i++){
                var currentLineWidth = this.getLineWidth(i);
                if (currentLineWidth > maxWidth) maxWidth = currentLineWidth;
            }
            return maxWidth;
        },
        /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */ _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
            this._renderChars(method, ctx, line, left, top, lineIndex);
        },
        /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextLinesBackground: function(ctx) {
            if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) return;
            var heightOfLine, lineLeftOffset, originalFill = ctx.fillStyle, line, lastColor, leftOffset = this._getLeftOffset(), lineTopOffset = this._getTopOffset(), boxStart = 0, boxWidth = 0, charBox, currentColor, path = this.path, drawStart;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                heightOfLine = this.getHeightOfLine(i);
                if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", i)) {
                    lineTopOffset += heightOfLine;
                    continue;
                }
                line = this._textLines[i];
                lineLeftOffset = this._getLineLeftOffset(i);
                boxWidth = 0;
                boxStart = 0;
                lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
                for(var j = 0, jlen = line.length; j < jlen; j++){
                    charBox = this.__charBounds[i][j];
                    currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
                    if (path) {
                        ctx.save();
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        ctx.fillStyle = currentColor;
                        currentColor && ctx.fillRect(-charBox.width / 2, -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction), charBox.width, heightOfLine / this.lineHeight);
                        ctx.restore();
                    } else if (currentColor !== lastColor) {
                        drawStart = leftOffset + lineLeftOffset + boxStart;
                        if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                        ctx.fillStyle = lastColor;
                        lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
                        boxStart = charBox.left;
                        boxWidth = charBox.width;
                        lastColor = currentColor;
                    } else boxWidth += charBox.kernedWidth;
                }
                if (currentColor && !path) {
                    drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                    ctx.fillStyle = currentColor;
                    ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
                }
                lineTopOffset += heightOfLine;
            }
            ctx.fillStyle = originalFill;
            // if there is text background color no
            // other shadows should be casted
            this._removeShadow(ctx);
        },
        /**
     * @private
     * @param {Object} decl style declaration for cache
     * @param {String} decl.fontFamily fontFamily
     * @param {String} decl.fontStyle fontStyle
     * @param {String} decl.fontWeight fontWeight
     * @return {Object} reference to cache
     */ getFontCache: function(decl) {
            var fontFamily = decl.fontFamily.toLowerCase();
            if (!fabric.charWidthsCache[fontFamily]) fabric.charWidthsCache[fontFamily] = {};
            var cache = fabric.charWidthsCache[fontFamily], cacheProp = decl.fontStyle.toLowerCase() + "_" + (decl.fontWeight + "").toLowerCase();
            if (!cache[cacheProp]) cache[cacheProp] = {};
            return cache[cacheProp];
        },
        /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */ _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
            // first i try to return from cache
            var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char, stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth, fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;
            if (previousChar && fontCache[previousChar] !== undefined) previousWidth = fontCache[previousChar];
            if (fontCache[_char] !== undefined) kernedWidth = width = fontCache[_char];
            if (stylesAreEqual && fontCache[couple] !== undefined) {
                coupleWidth = fontCache[couple];
                kernedWidth = coupleWidth - previousWidth;
            }
            if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
                var ctx = this.getMeasuringContext();
                // send a TRUE to specify measuring font size CACHE_FONT_SIZE
                this._setTextStyles(ctx, charStyle, true);
            }
            if (width === undefined) {
                kernedWidth = width = ctx.measureText(_char).width;
                fontCache[_char] = width;
            }
            if (previousWidth === undefined && stylesAreEqual && previousChar) {
                previousWidth = ctx.measureText(previousChar).width;
                fontCache[previousChar] = previousWidth;
            }
            if (stylesAreEqual && coupleWidth === undefined) {
                // we can measure the kerning couple and subtract the width of the previous character
                coupleWidth = ctx.measureText(couple).width;
                fontCache[couple] = coupleWidth;
                kernedWidth = coupleWidth - previousWidth;
            }
            return {
                width: width * fontMultiplier,
                kernedWidth: kernedWidth * fontMultiplier
            };
        },
        /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */ getHeightOfChar: function(line, _char) {
            return this.getValueOfPropertyAt(line, _char, "fontSize");
        },
        /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */ measureLine: function(lineIndex) {
            var lineInfo = this._measureLine(lineIndex);
            if (this.charSpacing !== 0) lineInfo.width -= this._getWidthOfCharSpacing();
            if (lineInfo.width < 0) lineInfo.width = 0;
            return lineInfo;
        },
        /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
     */ _measureLine: function(lineIndex) {
            var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme, graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length), positionInPath = 0, startingPoint, totalPathLength, path = this.path, reverse = this.pathSide === "right";
            this.__charBounds[lineIndex] = lineBounds;
            for(i = 0; i < line.length; i++){
                grapheme = line[i];
                graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
                lineBounds[i] = graphemeInfo;
                width += graphemeInfo.kernedWidth;
                prevGrapheme = grapheme;
            }
            // this latest bound box represent the last character of the line
            // to simplify cursor handling in interactive mode.
            lineBounds[i] = {
                left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
                width: 0,
                kernedWidth: 0,
                height: this.fontSize
            };
            if (path) {
                totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
                startingPoint = fabric.util.getPointOnPath(path.path, 0, path.segmentsInfo);
                startingPoint.x += path.pathOffset.x;
                startingPoint.y += path.pathOffset.y;
                switch(this.textAlign){
                    case "left":
                        positionInPath = reverse ? totalPathLength - width : 0;
                        break;
                    case "center":
                        positionInPath = (totalPathLength - width) / 2;
                        break;
                    case "right":
                        positionInPath = reverse ? 0 : totalPathLength - width;
                        break;
                }
                positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
                for(i = reverse ? line.length - 1 : 0; reverse ? i >= 0 : i < line.length; reverse ? i-- : i++){
                    graphemeInfo = lineBounds[i];
                    if (positionInPath > totalPathLength) positionInPath %= totalPathLength;
                    else if (positionInPath < 0) positionInPath += totalPathLength;
                    // it would probably much faster to send all the grapheme position for a line
                    // and calculate path position/angle at once.
                    this._setGraphemeOnPath(positionInPath, graphemeInfo, startingPoint);
                    positionInPath += graphemeInfo.kernedWidth;
                }
            }
            return {
                width: width,
                numOfSpaces: numOfSpaces
            };
        },
        /**
     * Calculate the angle  and the left,top position of the char that follow a path.
     * It appends it to graphemeInfo to be reused later at rendering
     * @private
     * @param {Number} positionInPath to be measured
     * @param {Object} graphemeInfo current grapheme box information
     * @param {Object} startingPoint position of the point
     */ _setGraphemeOnPath: function(positionInPath, graphemeInfo, startingPoint) {
            var centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
            // we are at currentPositionOnPath. we want to know what point on the path is.
            var info = fabric.util.getPointOnPath(path.path, centerPosition, path.segmentsInfo);
            graphemeInfo.renderLeft = info.x - startingPoint.x;
            graphemeInfo.renderTop = info.y - startingPoint.y;
            graphemeInfo.angle = info.angle + (this.pathSide === "right" ? Math.PI : 0);
        },
        /**
     * Measure and return the info of a single grapheme.
     * needs the the info of previous graphemes already filled
     * @private
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     */ _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
            var style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle), kernedWidth = info.kernedWidth, width = info.width, charSpacing;
            if (this.charSpacing !== 0) {
                charSpacing = this._getWidthOfCharSpacing();
                width += charSpacing;
                kernedWidth += charSpacing;
            }
            var box = {
                width: width,
                left: 0,
                height: style.fontSize,
                kernedWidth: kernedWidth,
                deltaY: style.deltaY
            };
            if (charIndex > 0 && !skipLeft) {
                var previousBox = this.__charBounds[lineIndex][charIndex - 1];
                box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
            }
            return box;
        },
        /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */ getHeightOfLine: function(lineIndex) {
            if (this.__lineHeights[lineIndex]) return this.__lineHeights[lineIndex];
            var line = this._textLines[lineIndex], // char 0 is measured before the line cycle because it nneds to char
            // emptylines
            maxHeight = this.getHeightOfChar(lineIndex, 0);
            for(var i = 1, len = line.length; i < len; i++)maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
            return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
        },
        /**
     * Calculate text box height
     */ calcTextHeight: function() {
            var lineHeight, height = 0;
            for(var i = 0, len = this._textLines.length; i < len; i++){
                lineHeight = this.getHeightOfLine(i);
                height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
            }
            return height;
        },
        /**
     * @private
     * @return {Number} Left offset
     */ _getLeftOffset: function() {
            return this.direction === "ltr" ? -this.width / 2 : this.width / 2;
        },
        /**
     * @private
     * @return {Number} Top offset
     */ _getTopOffset: function() {
            return -this.height / 2;
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */ _renderTextCommon: function(ctx, method) {
            ctx.save();
            var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset();
            for(var i = 0, len = this._textLines.length; i < len; i++){
                var heightOfLine = this.getHeightOfLine(i), maxHeight = heightOfLine / this.lineHeight, leftOffset = this._getLineLeftOffset(i);
                this._renderTextLine(method, ctx, this._textLines[i], left + leftOffset, top + lineHeights + maxHeight, i);
                lineHeights += heightOfLine;
            }
            ctx.restore();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextFill: function(ctx) {
            if (!this.fill && !this.styleHas("fill")) return;
            this._renderTextCommon(ctx, "fillText");
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextStroke: function(ctx) {
            if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) return;
            if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
            ctx.save();
            this._setLineDash(ctx, this.strokeDashArray);
            ctx.beginPath();
            this._renderTextCommon(ctx, "strokeText");
            ctx.closePath();
            ctx.restore();
        },
        /**
     * @private
     * @param {String} method fillText or strokeText.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} line Content of the line, splitted in an array by grapheme
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */ _renderChars: function(method, ctx, line, left, top, lineIndex) {
            // set proper line offset
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf("justify") !== -1, actualStyle, nextStyle, charsToRender = "", charBox, boxWidth = 0, timeToRender, path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === "ltr", sign = this.direction === "ltr" ? 1 : -1, drawingLeft, currentDirection = ctx.canvas.getAttribute("dir");
            ctx.save();
            if (currentDirection !== this.direction) {
                ctx.canvas.setAttribute("dir", isLtr ? "ltr" : "rtl");
                ctx.direction = isLtr ? "ltr" : "rtl";
                ctx.textAlign = isLtr ? "left" : "right";
            }
            top -= lineHeight * this._fontSizeFraction / this.lineHeight;
            if (shortCut) {
                // render all the line in one pass without checking
                // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
                this._renderChar(method, ctx, lineIndex, 0, line.join(""), left, top, lineHeight);
                ctx.restore();
                return;
            }
            for(var i = 0, len = line.length - 1; i <= len; i++){
                timeToRender = i === len || this.charSpacing || path;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    left += sign * (charBox.kernedWidth - charBox.width);
                    boxWidth += charBox.width;
                } else boxWidth += charBox.kernedWidth;
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
                }
                if (!timeToRender) {
                    // if we have charSpacing, we render char by char
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = fabric.util.hasStyleChanged(actualStyle, nextStyle, false);
                }
                if (timeToRender) {
                    if (path) {
                        ctx.save();
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0, lineHeight);
                        ctx.restore();
                    } else {
                        drawingLeft = left;
                        this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top, lineHeight);
                    }
                    charsToRender = "";
                    actualStyle = nextStyle;
                    left += sign * boxWidth;
                    boxWidth = 0;
                }
            }
            ctx.restore();
        },
        /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {fabric.Gradient} filler a fabric gradient instance
     * @return {CanvasPattern} a pattern to use as fill/stroke style
     */ _applyPatternGradientTransformText: function(filler) {
            var pCanvas = fabric.util.createCanvasElement(), pCtx, // TODO: verify compatibility with strokeUniform
            width = this.width + this.strokeWidth, height = this.height + this.strokeWidth;
            pCanvas.width = width;
            pCanvas.height = height;
            pCtx = pCanvas.getContext("2d");
            pCtx.beginPath();
            pCtx.moveTo(0, 0);
            pCtx.lineTo(width, 0);
            pCtx.lineTo(width, height);
            pCtx.lineTo(0, height);
            pCtx.closePath();
            pCtx.translate(width / 2, height / 2);
            pCtx.fillStyle = filler.toLive(pCtx);
            this._applyPatternGradientTransform(pCtx, filler);
            pCtx.fill();
            return pCtx.createPattern(pCanvas, "no-repeat");
        },
        handleFiller: function(ctx, property, filler) {
            var offsetX, offsetY;
            if (filler.toLive) {
                if (filler.gradientUnits === "percentage" || filler.gradientTransform || filler.patternTransform) {
                    // need to transform gradient in a pattern.
                    // this is a slow process. If you are hitting this codepath, and the object
                    // is not using caching, you should consider switching it on.
                    // we need a canvas as big as the current object caching canvas.
                    offsetX = -this.width / 2;
                    offsetY = -this.height / 2;
                    ctx.translate(offsetX, offsetY);
                    ctx[property] = this._applyPatternGradientTransformText(filler);
                    return {
                        offsetX: offsetX,
                        offsetY: offsetY
                    };
                } else {
                    // is a simple gradient or pattern
                    ctx[property] = filler.toLive(ctx, this);
                    return this._applyPatternGradientTransform(ctx, filler);
                }
            } else // is a color
            ctx[property] = filler;
            return {
                offsetX: 0,
                offsetY: 0
            };
        },
        _setStrokeStyles: function(ctx, decl) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = this.strokeLineCap;
            ctx.lineDashOffset = this.strokeDashOffset;
            ctx.lineJoin = this.strokeLineJoin;
            ctx.miterLimit = this.strokeMiterLimit;
            return this.handleFiller(ctx, "strokeStyle", decl.stroke);
        },
        _setFillStyles: function(ctx, decl) {
            return this.handleFiller(ctx, "fillStyle", decl.fill);
        },
        /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */ _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
            var decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === "fillText" && fullDecl.fill, shouldStroke = method === "strokeText" && fullDecl.stroke && fullDecl.strokeWidth, fillOffsets, strokeOffsets;
            if (!shouldStroke && !shouldFill) return;
            ctx.save();
            shouldFill && (fillOffsets = this._setFillStyles(ctx, fullDecl));
            shouldStroke && (strokeOffsets = this._setStrokeStyles(ctx, fullDecl));
            ctx.font = this._getFontDeclaration(fullDecl);
            if (decl && decl.textBackgroundColor) this._removeShadow(ctx);
            if (decl && decl.deltaY) top += decl.deltaY;
            shouldFill && ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
            shouldStroke && ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
            ctx.restore();
        },
        /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */ setSuperscript: function(start, end) {
            return this._setScript(start, end, this.superscript);
        },
        /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @returns {fabric.Text} thisArg
     * @chainable
     */ setSubscript: function(start, end) {
            return this._setScript(start, end, this.subscript);
        },
        /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     * @returns {fabric.Text} thisArg
     * @chainable
     */ _setScript: function(start, end, schema) {
            var loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "fontSize"), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, "deltaY"), style = {
                fontSize: fontSize * schema.size,
                deltaY: dy + fontSize * schema.baseline
            };
            this.setSelectionStyles(style, start, end);
            return this;
        },
        /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */ _getLineLeftOffset: function(lineIndex) {
            var lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping, leftOffset = 0, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
            if (textAlign === "justify" || textAlign === "justify-center" && !isEndOfWrapping || textAlign === "justify-right" && !isEndOfWrapping || textAlign === "justify-left" && !isEndOfWrapping) return 0;
            if (textAlign === "center") leftOffset = lineDiff / 2;
            if (textAlign === "right") leftOffset = lineDiff;
            if (textAlign === "justify-center") leftOffset = lineDiff / 2;
            if (textAlign === "justify-right") leftOffset = lineDiff;
            if (direction === "rtl") leftOffset -= lineDiff;
            return leftOffset;
        },
        /**
     * @private
     */ _clearCache: function() {
            this.__lineWidths = [];
            this.__lineHeights = [];
            this.__charBounds = [];
        },
        /**
     * @private
     */ _shouldClearDimensionCache: function() {
            var shouldClear = this._forceClearCache;
            shouldClear || (shouldClear = this.hasStateChanged("_dimensionAffectingProps"));
            if (shouldClear) {
                this.dirty = true;
                this._forceClearCache = false;
            }
            return shouldClear;
        },
        /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */ getLineWidth: function(lineIndex) {
            if (this.__lineWidths[lineIndex] !== undefined) return this.__lineWidths[lineIndex];
            var lineInfo = this.measureLine(lineIndex);
            var width = lineInfo.width;
            this.__lineWidths[lineIndex] = width;
            return width;
        },
        _getWidthOfCharSpacing: function() {
            if (this.charSpacing !== 0) return this.fontSize * this.charSpacing / 1000;
            return 0;
        },
        /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the character number
     * @param {String} property the property name
     * @returns the value of 'property'
     */ getValueOfPropertyAt: function(lineIndex, charIndex, property) {
            var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
            if (charStyle && typeof charStyle[property] !== "undefined") return charStyle[property];
            return this[property];
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _renderTextDecoration: function(ctx, type) {
            if (!this[type] && !this.styleHas(type)) return;
            var heightOfLine, size, _size, lineLeftOffset, dy, _dy, line, lastDecoration, leftOffset = this._getLeftOffset(), topOffset = this._getTopOffset(), top, boxStart, boxWidth, charBox, currentDecoration, maxHeight, currentFill, lastFill, path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetY = this.offsets[type];
            for(var i = 0, len = this._textLines.length; i < len; i++){
                heightOfLine = this.getHeightOfLine(i);
                if (!this[type] && !this.styleHas(type, i)) {
                    topOffset += heightOfLine;
                    continue;
                }
                line = this._textLines[i];
                maxHeight = heightOfLine / this.lineHeight;
                lineLeftOffset = this._getLineLeftOffset(i);
                boxStart = 0;
                boxWidth = 0;
                lastDecoration = this.getValueOfPropertyAt(i, 0, type);
                lastFill = this.getValueOfPropertyAt(i, 0, "fill");
                top = topOffset + maxHeight * (1 - this._fontSizeFraction);
                size = this.getHeightOfChar(i, 0);
                dy = this.getValueOfPropertyAt(i, 0, "deltaY");
                for(var j = 0, jlen = line.length; j < jlen; j++){
                    charBox = this.__charBounds[i][j];
                    currentDecoration = this.getValueOfPropertyAt(i, j, type);
                    currentFill = this.getValueOfPropertyAt(i, j, "fill");
                    _size = this.getHeightOfChar(i, j);
                    _dy = this.getValueOfPropertyAt(i, j, "deltaY");
                    if (path && currentDecoration && currentFill) {
                        ctx.save();
                        ctx.fillStyle = lastFill;
                        ctx.translate(charBox.renderLeft, charBox.renderTop);
                        ctx.rotate(charBox.angle);
                        ctx.fillRect(-charBox.kernedWidth / 2, offsetY * _size + _dy, charBox.kernedWidth, this.fontSize / 15);
                        ctx.restore();
                    } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) && boxWidth > 0) {
                        var drawStart = leftOffset + lineLeftOffset + boxStart;
                        if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                        if (lastDecoration && lastFill) {
                            ctx.fillStyle = lastFill;
                            ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth, this.fontSize / 15);
                        }
                        boxStart = charBox.left;
                        boxWidth = charBox.width;
                        lastDecoration = currentDecoration;
                        lastFill = currentFill;
                        size = _size;
                        dy = _dy;
                    } else boxWidth += charBox.kernedWidth;
                }
                var drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === "rtl") drawStart = this.width - drawStart - boxWidth;
                ctx.fillStyle = currentFill;
                currentDecoration && currentFill && ctx.fillRect(drawStart, top + offsetY * size + dy, boxWidth - charSpacing, this.fontSize / 15);
                topOffset += heightOfLine;
            }
            // if there is text background color no
            // other shadows should be casted
            this._removeShadow(ctx);
        },
        /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */ _getFontDeclaration: function(styleObject, forMeasuring) {
            var style = styleObject || this, family = this.fontFamily, fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
            var fontFamily = family === undefined || family.indexOf("'") > -1 || family.indexOf(",") > -1 || family.indexOf('"') > -1 || fontIsGeneric ? style.fontFamily : '"' + style.fontFamily + '"';
            return [
                // node-canvas needs "weight style", while browsers need "style weight"
                // verify if this can be fixed in JSDOM
                fabric.isLikelyNode ? style.fontWeight : style.fontStyle,
                fabric.isLikelyNode ? style.fontStyle : style.fontWeight,
                forMeasuring ? this.CACHE_FONT_SIZE + "px" : style.fontSize + "px",
                fontFamily
            ].join(" ");
        },
        /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            // do not render if object is not visible
            if (!this.visible) return;
            if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
            if (this._shouldClearDimensionCache()) this.initDimensions();
            this.callSuper("render", ctx);
        },
        /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns {Array} Lines in the text
     */ _splitTextIntoLines: function(text) {
            var lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = [
                "\n"
            ], newText = [];
            for(var i = 0; i < lines.length; i++){
                newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
                newText = newText.concat(newLines[i], newLine);
            }
            newText.pop();
            return {
                _unwrappedLines: newLines,
                lines: lines,
                graphemeText: newText,
                graphemeLines: newLines
            };
        },
        /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */ toObject: function(propertiesToInclude) {
            var allProperties = additionalProps.concat(propertiesToInclude);
            var obj = this.callSuper("toObject", allProperties);
            obj.styles = fabric.util.stylesToArray(this.styles, this.text);
            if (obj.path) obj.path = this.path.toObject();
            return obj;
        },
        /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     * @return {fabric.Object} thisArg
     * @chainable
     */ set: function(key, value) {
            this.callSuper("set", key, value);
            var needsDims = false;
            var isAddingPath = false;
            if (typeof key === "object") for(var _key in key){
                if (_key === "path") this.setPathInfo();
                needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
                isAddingPath = isAddingPath || _key === "path";
            }
            else {
                needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
                isAddingPath = key === "path";
            }
            if (isAddingPath) this.setPathInfo();
            if (needsDims) {
                this.initDimensions();
                this.setCoords();
            }
            return this;
        },
        /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */ complexity: function() {
            return 1;
        }
    });
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
   * @static
   * @memberOf fabric.Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */ fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat("x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor".split(" "));
    /**
   * Default SVG font size
   * @static
   * @memberOf fabric.Text
   */ fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;
    /**
   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf fabric.Text
   * @param {SVGElement} element Element to parse
   * @param {Function} callback callback function invoked after parsing
   * @param {Object} [options] Options object
   */ fabric.Text.fromElement = function(element, callback, options) {
        if (!element) return callback(null);
        var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES), parsedAnchor = parsedAttributes.textAnchor || "left";
        options = fabric.util.object.extend(options ? clone(options) : {}, parsedAttributes);
        options.top = options.top || 0;
        options.left = options.left || 0;
        if (parsedAttributes.textDecoration) {
            var textDecoration = parsedAttributes.textDecoration;
            if (textDecoration.indexOf("underline") !== -1) options.underline = true;
            if (textDecoration.indexOf("overline") !== -1) options.overline = true;
            if (textDecoration.indexOf("line-through") !== -1) options.linethrough = true;
            delete options.textDecoration;
        }
        if ("dx" in parsedAttributes) options.left += parsedAttributes.dx;
        if ("dy" in parsedAttributes) options.top += parsedAttributes.dy;
        if (!("fontSize" in options)) options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
        var textContent = "";
        // The XML is not properly parsed in IE9 so a workaround to get
        // textContent is through firstChild.data. Another workaround would be
        // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
        if (!("textContent" in element)) {
            if ("firstChild" in element && element.firstChild !== null) {
                if ("data" in element.firstChild && element.firstChild.data !== null) textContent = element.firstChild.data;
            }
        } else textContent = element.textContent;
        textContent = textContent.replace(/^\s+|\s+$|\n+/g, "").replace(/\s+/g, " ");
        var originalStrokeWidth = options.strokeWidth;
        options.strokeWidth = 0;
        var text = new fabric.Text(textContent, options), textHeightScaleFactor = text.getScaledHeight() / text.height, lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height, scaledDiff = lineHeightDiff * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff, offX = 0;
        /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */ if (parsedAnchor === "center") offX = text.getScaledWidth() / 2;
        if (parsedAnchor === "right") offX = text.getScaledWidth();
        text.set({
            left: text.left - offX,
            top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
            strokeWidth: typeof originalStrokeWidth !== "undefined" ? originalStrokeWidth : 1
        });
        callback(text);
    };
    /* _FROM_SVG_END_ */ /**
   * Returns fabric.Text instance from an object representation
   * @static
   * @memberOf fabric.Text
   * @param {Object} object plain js Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
   */ fabric.Text.fromObject = function(object, callback) {
        var objectCopy = clone(object), path = object.path;
        delete objectCopy.path;
        return fabric.Object._fromObject("Text", objectCopy, function(textInstance) {
            textInstance.styles = fabric.util.stylesFromArray(object.styles, object.text);
            if (path) fabric.Object._fromObject("Path", path, function(pathInstance) {
                textInstance.set("path", pathInstance);
                callback(textInstance);
            }, "path");
            else callback(textInstance);
        }, "text");
    };
    fabric.Text.genericFonts = [
        "sans-serif",
        "serif",
        "cursive",
        "fantasy",
        "monospace"
    ];
    fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);
})($d47795690082d4de$exports);
(function() {
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
        /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */ isEmptyStyles: function(lineIndex) {
            if (!this.styles) return true;
            if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return true;
            var obj = typeof lineIndex === "undefined" ? this.styles : {
                line: this.styles[lineIndex]
            };
            for(var p1 in obj)for(var p2 in obj[p1]){
                // eslint-disable-next-line no-unused-vars
                for(var p3 in obj[p1][p2])return false;
            }
            return true;
        },
        /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */ styleHas: function(property, lineIndex) {
            if (!this.styles || !property || property === "") return false;
            if (typeof lineIndex !== "undefined" && !this.styles[lineIndex]) return false;
            var obj = typeof lineIndex === "undefined" ? this.styles : {
                0: this.styles[lineIndex]
            };
            // eslint-disable-next-line
            for(var p1 in obj)// eslint-disable-next-line
            for(var p2 in obj[p1]){
                if (typeof obj[p1][p2][property] !== "undefined") return true;
            }
            return false;
        },
        /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     *
     * @param {string} property The property to compare between characters and text.
     */ cleanStyle: function(property) {
            if (!this.styles || !property || property === "") return false;
            var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
            // eslint-disable-next-line
            for(var p1 in obj){
                letterCount = 0;
                // eslint-disable-next-line
                for(var p2 in obj[p1]){
                    var styleObject = obj[p1][p2], stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);
                    stylesCount++;
                    if (stylePropertyHasBeenSet) {
                        if (!stylePropertyValue) stylePropertyValue = styleObject[property];
                        else if (styleObject[property] !== stylePropertyValue) allStyleObjectPropertiesMatch = false;
                        if (styleObject[property] === this[property]) delete styleObject[property];
                    } else allStyleObjectPropertiesMatch = false;
                    if (Object.keys(styleObject).length !== 0) letterCount++;
                    else delete obj[p1][p2];
                }
                if (letterCount === 0) delete obj[p1];
            }
            // if every grapheme has the same style set then
            // delete those styles and set it on the parent
            for(var i = 0; i < this._textLines.length; i++)graphemeCount += this._textLines[i].length;
            if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
                this[property] = stylePropertyValue;
                this.removeStyle(property);
            }
        },
        /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */ removeStyle: function(property) {
            if (!this.styles || !property || property === "") return;
            var obj = this.styles, line, lineNum, charNum;
            for(lineNum in obj){
                line = obj[lineNum];
                for(charNum in line){
                    delete line[charNum][property];
                    if (Object.keys(line[charNum]).length === 0) delete line[charNum];
                }
                if (Object.keys(line).length === 0) delete obj[lineNum];
            }
        },
        /**
     * @private
     */ _extendStyles: function(index, styles) {
            var loc = this.get2DCursorLocation(index);
            if (!this._getLineStyle(loc.lineIndex)) this._setLineStyle(loc.lineIndex);
            if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
            $d47795690082d4de$var$fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
        },
        /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */ get2DCursorLocation: function(selectionStart, skipWrapping) {
            if (typeof selectionStart === "undefined") selectionStart = this.selectionStart;
            var lines = skipWrapping ? this._unwrappedTextLines : this._textLines, len = lines.length;
            for(var i = 0; i < len; i++){
                if (selectionStart <= lines[i].length) return {
                    lineIndex: i,
                    charIndex: selectionStart
                };
                selectionStart -= lines[i].length + this.missingNewlineOffset(i);
            }
            return {
                lineIndex: i - 1,
                charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
            };
        },
        /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */ getSelectionStyles: function(startIndex, endIndex, complete) {
            if (typeof startIndex === "undefined") startIndex = this.selectionStart || 0;
            if (typeof endIndex === "undefined") endIndex = this.selectionEnd || startIndex;
            var styles = [];
            for(var i = startIndex; i < endIndex; i++)styles.push(this.getStyleAtPosition(i, complete));
            return styles;
        },
        /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */ getStyleAtPosition: function(position, complete) {
            var loc = this.get2DCursorLocation(position), style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) : this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
            return style || {};
        },
        /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @return {fabric.IText} thisArg
     * @chainable
     */ setSelectionStyles: function(styles, startIndex, endIndex) {
            if (typeof startIndex === "undefined") startIndex = this.selectionStart || 0;
            if (typeof endIndex === "undefined") endIndex = this.selectionEnd || startIndex;
            for(var i = startIndex; i < endIndex; i++)this._extendStyles(i, styles);
            /* not included in _extendStyles to avoid clearing cache more than once */ this._forceClearCache = true;
            return this;
        },
        /**
     * get the reference, not a clone, of the style object for a given character
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Object} style object
     */ _getStyleDeclaration: function(lineIndex, charIndex) {
            var lineStyle = this.styles && this.styles[lineIndex];
            if (!lineStyle) return null;
            return lineStyle[charIndex];
        },
        /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */ getCompleteStyleDeclaration: function(lineIndex, charIndex) {
            var style = this._getStyleDeclaration(lineIndex, charIndex) || {}, styleObject = {}, prop;
            for(var i = 0; i < this._styleProperties.length; i++){
                prop = this._styleProperties[i];
                styleObject[prop] = typeof style[prop] === "undefined" ? this[prop] : style[prop];
            }
            return styleObject;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */ _setStyleDeclaration: function(lineIndex, charIndex, style) {
            this.styles[lineIndex][charIndex] = style;
        },
        /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _deleteStyleDeclaration: function(lineIndex, charIndex) {
            delete this.styles[lineIndex][charIndex];
        },
        /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */ _getLineStyle: function(lineIndex) {
            return !!this.styles[lineIndex];
        },
        /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */ _setLineStyle: function(lineIndex) {
            this.styles[lineIndex] = {};
        },
        /**
     * @param {Number} lineIndex
     * @private
     */ _deleteLineStyle: function(lineIndex) {
            delete this.styles[lineIndex];
        }
    });
})();
(function() {
    function parseDecoration(object) {
        if (object.textDecoration) {
            object.textDecoration.indexOf("underline") > -1 && (object.underline = true);
            object.textDecoration.indexOf("line-through") > -1 && (object.linethrough = true);
            object.textDecoration.indexOf("overline") > -1 && (object.overline = true);
            delete object.textDecoration;
        }
    }
    /**
   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
   * prefix when observing canvas.
   * @class fabric.IText
   * @extends fabric.Text
   * @mixes fabric.Observable
   *
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   *
   * @return {fabric.IText} thisArg
   * @see {@link fabric.IText#initialize} for constructor definition
   *
   * <p>Supported key combinations:</p>
   * <pre>
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * </pre>
   *
   * <p>Supported mouse/touch combination</p>
   * <pre>
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * </pre>
   */ $d47795690082d4de$var$fabric.IText = $d47795690082d4de$var$fabric.util.createClass($d47795690082d4de$var$fabric.Text, $d47795690082d4de$var$fabric.Observable, /** @lends fabric.IText.prototype */ {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "i-text",
        /**
     * Index where text selection starts (or where cursor is when there is no selection)
     * @type Number
     * @default
     */ selectionStart: 0,
        /**
     * Index where text selection ends
     * @type Number
     * @default
     */ selectionEnd: 0,
        /**
     * Color of text selection
     * @type String
     * @default
     */ selectionColor: "rgba(17,119,255,0.3)",
        /**
     * Indicates whether text is in editing mode
     * @type Boolean
     * @default
     */ isEditing: false,
        /**
     * Indicates whether a text can be edited
     * @type Boolean
     * @default
     */ editable: true,
        /**
     * Border color of text object while it's in editing mode
     * @type String
     * @default
     */ editingBorderColor: "rgba(102,153,255,0.25)",
        /**
     * Width of cursor (in px)
     * @type Number
     * @default
     */ cursorWidth: 2,
        /**
     * Color of text cursor color in editing mode.
     * if not set (default) will take color from the text.
     * if set to a color value that fabric can understand, it will
     * be used instead of the color of the text at the current position.
     * @type String
     * @default
     */ cursorColor: "",
        /**
     * Delay between cursor blink (in ms)
     * @type Number
     * @default
     */ cursorDelay: 1000,
        /**
     * Duration of cursor fadein (in ms)
     * @type Number
     * @default
     */ cursorDuration: 600,
        /**
     * Indicates whether internal text char widths can be cached
     * @type Boolean
     * @default
     */ caching: true,
        /**
     * DOM container to append the hiddenTextarea.
     * An alternative to attaching to the document.body.
     * Useful to reduce laggish redraw of the full document.body tree and
     * also with modals event capturing that won't let the textarea take focus.
     * @type HTMLElement
     * @default
     */ hiddenTextareaContainer: null,
        /**
     * @private
     */ _reSpace: /\s|\n/,
        /**
     * @private
     */ _currentCursorOpacity: 0,
        /**
     * @private
     */ _selectionDirection: null,
        /**
     * @private
     */ _abortCursorAnimation: false,
        /**
     * @private
     */ __widthOfSpace: [],
        /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */ inCompositionMode: false,
        /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     * @return {fabric.IText} thisArg
     */ initialize: function(text, options) {
            this.callSuper("initialize", text, options);
            this.initBehavior();
        },
        /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */ setSelectionStart: function(index) {
            index = Math.max(index, 0);
            this._updateAndFire("selectionStart", index);
        },
        /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */ setSelectionEnd: function(index) {
            index = Math.min(index, this.text.length);
            this._updateAndFire("selectionEnd", index);
        },
        /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */ _updateAndFire: function(property, index) {
            if (this[property] !== index) {
                this._fireSelectionChanged();
                this[property] = index;
            }
            this._updateTextarea();
        },
        /**
     * Fires the even of selection changed
     * @private
     */ _fireSelectionChanged: function() {
            this.fire("selection:changed");
            this.canvas && this.canvas.fire("text:selection:changed", {
                target: this
            });
        },
        /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */ initDimensions: function() {
            this.isEditing && this.initDelayedCursor();
            this.clearContextTop();
            this.callSuper("initDimensions");
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ render: function(ctx) {
            this.clearContextTop();
            this.callSuper("render", ctx);
            // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
            // the correct position but not at every cursor animation.
            this.cursorOffsetCache = {};
            this.renderCursorOrSelection();
        },
        /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */ _render: function(ctx) {
            this.callSuper("_render", ctx);
        },
        /**
     * Prepare and clean the contextTop
     */ clearContextTop: function(skipRestore) {
            if (!this.isEditing || !this.canvas || !this.canvas.contextTop) return;
            var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
            ctx.save();
            ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
            this.transform(ctx);
            this._clearTextArea(ctx);
            skipRestore || ctx.restore();
        },
        /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */ renderCursorOrSelection: function() {
            if (!this.isEditing || !this.canvas || !this.canvas.contextTop) return;
            var boundaries = this._getCursorBoundaries(), ctx = this.canvas.contextTop;
            this.clearContextTop(true);
            if (this.selectionStart === this.selectionEnd) this.renderCursor(boundaries, ctx);
            else this.renderSelection(boundaries, ctx);
            ctx.restore();
        },
        _clearTextArea: function(ctx) {
            // we add 4 pixel, to be sure to do not leave any pixel out
            var width = this.width + 4, height = this.height + 4;
            ctx.clearRect(-width / 2, -height / 2, width, height);
        },
        /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * @private
     * @param {Array} chars Array of characters
     * @param {String} typeOfBoundaries
     */ _getCursorBoundaries: function(position) {
            // left/top are left/top of entire text box
            // leftOffset/topOffset are offset from that left/top point of a text box
            if (typeof position === "undefined") position = this.selectionStart;
            var left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(position);
            return {
                left: left,
                top: top,
                leftOffset: offsets.left,
                topOffset: offsets.top
            };
        },
        /**
     * @private
     */ _getCursorBoundariesOffsets: function(position) {
            if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) return this.cursorOffsetCache;
            var lineLeftOffset, lineIndex, charIndex, topOffset = 0, leftOffset = 0, boundaries, cursorPosition = this.get2DCursorLocation(position);
            charIndex = cursorPosition.charIndex;
            lineIndex = cursorPosition.lineIndex;
            for(var i = 0; i < lineIndex; i++)topOffset += this.getHeightOfLine(i);
            lineLeftOffset = this._getLineLeftOffset(lineIndex);
            var bound = this.__charBounds[lineIndex][charIndex];
            bound && (leftOffset = bound.left);
            if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) leftOffset -= this._getWidthOfCharSpacing();
            boundaries = {
                top: topOffset,
                left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
            };
            if (this.direction === "rtl") boundaries.left *= -1;
            this.cursorOffsetCache = boundaries;
            return this.cursorOffsetCache;
        },
        /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */ renderCursor: function(boundaries, ctx) {
            var cursorLocation = this.get2DCursorLocation(), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize"), multiplier = this.scaleX * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, topOffset = boundaries.topOffset, dy = this.getValueOfPropertyAt(lineIndex, charIndex, "deltaY");
            topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
            if (this.inCompositionMode) this.renderSelection(boundaries, ctx);
            ctx.fillStyle = this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, "fill");
            ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
            ctx.fillRect(boundaries.left + boundaries.leftOffset - cursorWidth / 2, topOffset + boundaries.top + dy, cursorWidth, charHeight);
        },
        /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */ renderSelection: function(boundaries, ctx) {
            var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart, selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd, isJustify = this.textAlign.indexOf("justify") !== -1, start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
            for(var i = startLine; i <= endLine; i++){
                var lineOffset = this._getLineLeftOffset(i) || 0, lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
                if (i === startLine) boxStart = this.__charBounds[startLine][startChar].left;
                if (i >= startLine && i < endLine) boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
                else if (i === endLine) {
                    if (endChar === 0) boxEnd = this.__charBounds[endLine][endChar].left;
                    else {
                        var charSpacing = this._getWidthOfCharSpacing();
                        boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
                    }
                }
                realLineHeight = lineHeight;
                if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) lineHeight /= this.lineHeight;
                var drawStart = boundaries.left + lineOffset + boxStart, drawWidth = boxEnd - boxStart, drawHeight = lineHeight, extraTop = 0;
                if (this.inCompositionMode) {
                    ctx.fillStyle = this.compositionColor || "black";
                    drawHeight = 1;
                    extraTop = lineHeight;
                } else ctx.fillStyle = this.selectionColor;
                if (this.direction === "rtl") drawStart = this.width - drawStart - drawWidth;
                ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
                boundaries.topOffset += realLineHeight;
            }
        },
        /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */ getCurrentCharFontSize: function() {
            var cp = this._getCurrentCharIndex();
            return this.getValueOfPropertyAt(cp.l, cp.c, "fontSize");
        },
        /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * if the text object has a pattern or gradient for filler, it will return that.
     * Unused by the library, is for the end user
     * @return {String | fabric.Gradient | fabric.Pattern} Character color (fill)
     */ getCurrentCharColor: function() {
            var cp = this._getCurrentCharIndex();
            return this.getValueOfPropertyAt(cp.l, cp.c, "fill");
        },
        /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */ _getCurrentCharIndex: function() {
            var cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
            return {
                l: cursorPosition.lineIndex,
                c: charIndex
            };
        }
    });
    /**
   * Returns fabric.IText instance from an object representation
   * @static
   * @memberOf fabric.IText
   * @param {Object} object Object to create an instance from
   * @param {function} [callback] invoked with new instance as argument
   */ $d47795690082d4de$var$fabric.IText.fromObject = function(object, callback) {
        var styles = $d47795690082d4de$var$fabric.util.stylesFromArray(object.styles, object.text);
        //copy object to prevent mutation
        var objCopy = Object.assign({}, object, {
            styles: styles
        });
        parseDecoration(objCopy);
        if (objCopy.styles) {
            for(var i in objCopy.styles)for(var j in objCopy.styles[i])parseDecoration(objCopy.styles[i][j]);
        }
        $d47795690082d4de$var$fabric.Object._fromObject("IText", objCopy, callback, "text");
    };
})();
(function() {
    var clone = $d47795690082d4de$var$fabric.util.object.clone;
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
        /**
     * Initializes all the interactive behavior of IText
     */ initBehavior: function() {
            this.initAddedHandler();
            this.initRemovedHandler();
            this.initCursorSelectionHandlers();
            this.initDoubleClickSimulation();
            this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
        },
        onDeselect: function() {
            this.isEditing && this.exitEditing();
            this.selected = false;
        },
        /**
     * Initializes "added" event handler
     */ initAddedHandler: function() {
            var _this = this;
            this.on("added", function() {
                var canvas = _this.canvas;
                if (canvas) {
                    if (!canvas._hasITextHandlers) {
                        canvas._hasITextHandlers = true;
                        _this._initCanvasHandlers(canvas);
                    }
                    canvas._iTextInstances = canvas._iTextInstances || [];
                    canvas._iTextInstances.push(_this);
                }
            });
        },
        initRemovedHandler: function() {
            var _this = this;
            this.on("removed", function() {
                var canvas = _this.canvas;
                if (canvas) {
                    canvas._iTextInstances = canvas._iTextInstances || [];
                    $d47795690082d4de$var$fabric.util.removeFromArray(canvas._iTextInstances, _this);
                    if (canvas._iTextInstances.length === 0) {
                        canvas._hasITextHandlers = false;
                        _this._removeCanvasHandlers(canvas);
                    }
                }
            });
        },
        /**
     * register canvas event to manage exiting on other instances
     * @private
     */ _initCanvasHandlers: function(canvas) {
            canvas._mouseUpITextHandler = function() {
                if (canvas._iTextInstances) canvas._iTextInstances.forEach(function(obj) {
                    obj.__isMousedown = false;
                });
            };
            canvas.on("mouse:up", canvas._mouseUpITextHandler);
        },
        /**
     * remove canvas event to manage exiting on other instances
     * @private
     */ _removeCanvasHandlers: function(canvas) {
            canvas.off("mouse:up", canvas._mouseUpITextHandler);
        },
        /**
     * @private
     */ _tick: function() {
            this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, "_onTickComplete");
        },
        /**
     * @private
     */ _animateCursor: function(obj, targetOpacity, duration, completeMethod) {
            var tickState;
            tickState = {
                isAborted: false,
                abort: function() {
                    this.isAborted = true;
                }
            };
            obj.animate("_currentCursorOpacity", targetOpacity, {
                duration: duration,
                onComplete: function() {
                    if (!tickState.isAborted) obj[completeMethod]();
                },
                onChange: function() {
                    // we do not want to animate a selection, only cursor
                    if (obj.canvas && obj.selectionStart === obj.selectionEnd) obj.renderCursorOrSelection();
                },
                abort: function() {
                    return tickState.isAborted;
                }
            });
            return tickState;
        },
        /**
     * @private
     */ _onTickComplete: function() {
            var _this = this;
            if (this._cursorTimeout1) clearTimeout(this._cursorTimeout1);
            this._cursorTimeout1 = setTimeout(function() {
                _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, "_tick");
            }, 100);
        },
        /**
     * Initializes delayed cursor
     */ initDelayedCursor: function(restart) {
            var _this = this, delay = restart ? 0 : this.cursorDelay;
            this.abortCursorAnimation();
            this._currentCursorOpacity = 1;
            this._cursorTimeout2 = setTimeout(function() {
                _this._tick();
            }, delay);
        },
        /**
     * Aborts cursor animation and clears all timeouts
     */ abortCursorAnimation: function() {
            var shouldClear = this._currentTickState || this._currentTickCompleteState, canvas = this.canvas;
            this._currentTickState && this._currentTickState.abort();
            this._currentTickCompleteState && this._currentTickCompleteState.abort();
            clearTimeout(this._cursorTimeout1);
            clearTimeout(this._cursorTimeout2);
            this._currentCursorOpacity = 0;
            // to clear just itext area we need to transform the context
            // it may not be worth it
            if (shouldClear && canvas) canvas.clearContext(canvas.contextTop || canvas.contextContainer);
        },
        /**
     * Selects entire text
     * @return {fabric.IText} thisArg
     * @chainable
     */ selectAll: function() {
            this.selectionStart = 0;
            this.selectionEnd = this._text.length;
            this._fireSelectionChanged();
            this._updateTextarea();
            return this;
        },
        /**
     * Returns selected text
     * @return {String}
     */ getSelectedText: function() {
            return this._text.slice(this.selectionStart, this.selectionEnd).join("");
        },
        /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findWordBoundaryLeft: function(startFrom) {
            var offset = 0, index = startFrom - 1;
            // remove space before cursor first
            if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
                offset++;
                index--;
            }
            while(/\S/.test(this._text[index]) && index > -1){
                offset++;
                index--;
            }
            return startFrom - offset;
        },
        /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findWordBoundaryRight: function(startFrom) {
            var offset = 0, index = startFrom;
            // remove space after cursor first
            if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
                offset++;
                index++;
            }
            while(/\S/.test(this._text[index]) && index < this._text.length){
                offset++;
                index++;
            }
            return startFrom + offset;
        },
        /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findLineBoundaryLeft: function(startFrom) {
            var offset = 0, index = startFrom - 1;
            while(!/\n/.test(this._text[index]) && index > -1){
                offset++;
                index--;
            }
            return startFrom - offset;
        },
        /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */ findLineBoundaryRight: function(startFrom) {
            var offset = 0, index = startFrom;
            while(!/\n/.test(this._text[index]) && index < this._text.length){
                offset++;
                index++;
            }
            return startFrom + offset;
        },
        /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */ searchWordBoundary: function(selectionStart, direction) {
            var text = this._text, index = this._reSpace.test(text[selectionStart]) ? selectionStart - 1 : selectionStart, _char = text[index], // wrong
            reNonWord = $d47795690082d4de$var$fabric.reNonWord;
            while(!reNonWord.test(_char) && index > 0 && index < text.length){
                index += direction;
                _char = text[index];
            }
            if (reNonWord.test(_char)) index += direction === 1 ? 0 : 1;
            return index;
        },
        /**
     * Selects a word based on the index
     * @param {Number} selectionStart Index of a character
     */ selectWord: function(selectionStart) {
            selectionStart = selectionStart || this.selectionStart;
            var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */ newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */ 
            this.selectionStart = newSelectionStart;
            this.selectionEnd = newSelectionEnd;
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
        },
        /**
     * Selects a line based on the index
     * @param {Number} selectionStart Index of a character
     * @return {fabric.IText} thisArg
     * @chainable
     */ selectLine: function(selectionStart) {
            selectionStart = selectionStart || this.selectionStart;
            var newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
            this.selectionStart = newSelectionStart;
            this.selectionEnd = newSelectionEnd;
            this._fireSelectionChanged();
            this._updateTextarea();
            return this;
        },
        /**
     * Enters editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */ enterEditing: function(e) {
            if (this.isEditing || !this.editable) return;
            if (this.canvas) {
                this.canvas.calcOffset();
                this.exitEditingOnOthers(this.canvas);
            }
            this.isEditing = true;
            this.initHiddenTextarea(e);
            this.hiddenTextarea.focus();
            this.hiddenTextarea.value = this.text;
            this._updateTextarea();
            this._saveEditingProps();
            this._setEditingProps();
            this._textBeforeEdit = this.text;
            this._tick();
            this.fire("editing:entered");
            this._fireSelectionChanged();
            if (!this.canvas) return this;
            this.canvas.fire("text:editing:entered", {
                target: this
            });
            this.initMouseMoveHandler();
            this.canvas.requestRenderAll();
            return this;
        },
        exitEditingOnOthers: function(canvas) {
            if (canvas._iTextInstances) canvas._iTextInstances.forEach(function(obj) {
                obj.selected = false;
                if (obj.isEditing) obj.exitEditing();
            });
        },
        /**
     * Initializes "mousemove" event handler
     */ initMouseMoveHandler: function() {
            this.canvas.on("mouse:move", this.mouseMoveHandler);
        },
        /**
     * @private
     */ mouseMoveHandler: function(options) {
            if (!this.__isMousedown || !this.isEditing) return;
            // regain focus
            document.activeElement !== this.hiddenTextarea && this.hiddenTextarea.focus();
            var newSelectionStart = this.getSelectionStartFromPointer(options.e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
            if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) return;
            if (newSelectionStart > this.__selectionStartOnMouseDown) {
                this.selectionStart = this.__selectionStartOnMouseDown;
                this.selectionEnd = newSelectionStart;
            } else {
                this.selectionStart = newSelectionStart;
                this.selectionEnd = this.__selectionStartOnMouseDown;
            }
            if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
                this.restartCursorIfNeeded();
                this._fireSelectionChanged();
                this._updateTextarea();
                this.renderCursorOrSelection();
            }
        },
        /**
     * @private
     */ _setEditingProps: function() {
            this.hoverCursor = "text";
            if (this.canvas) this.canvas.defaultCursor = this.canvas.moveCursor = "text";
            this.borderColor = this.editingBorderColor;
            this.hasControls = this.selectable = false;
            this.lockMovementX = this.lockMovementY = true;
        },
        /**
     * convert from textarea to grapheme indexes
     */ fromStringToGraphemeSelection: function(start, end, text) {
            var smallerTextStart = text.slice(0, start), graphemeStart = $d47795690082d4de$var$fabric.util.string.graphemeSplit(smallerTextStart).length;
            if (start === end) return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart
            };
            var smallerTextEnd = text.slice(start, end), graphemeEnd = $d47795690082d4de$var$fabric.util.string.graphemeSplit(smallerTextEnd).length;
            return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart + graphemeEnd
            };
        },
        /**
     * convert from fabric to textarea values
     */ fromGraphemeToStringSelection: function(start, end, _text) {
            var smallerTextStart = _text.slice(0, start), graphemeStart = smallerTextStart.join("").length;
            if (start === end) return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart
            };
            var smallerTextEnd = _text.slice(start, end), graphemeEnd = smallerTextEnd.join("").length;
            return {
                selectionStart: graphemeStart,
                selectionEnd: graphemeStart + graphemeEnd
            };
        },
        /**
     * @private
     */ _updateTextarea: function() {
            this.cursorOffsetCache = {};
            if (!this.hiddenTextarea) return;
            if (!this.inCompositionMode) {
                var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
                this.hiddenTextarea.selectionStart = newSelection.selectionStart;
                this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
            }
            this.updateTextareaPosition();
        },
        /**
     * @private
     */ updateFromTextArea: function() {
            if (!this.hiddenTextarea) return;
            this.cursorOffsetCache = {};
            this.text = this.hiddenTextarea.value;
            if (this._shouldClearDimensionCache()) {
                this.initDimensions();
                this.setCoords();
            }
            var newSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
            this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
            if (!this.inCompositionMode) this.selectionStart = newSelection.selectionStart;
            this.updateTextareaPosition();
        },
        /**
     * @private
     */ updateTextareaPosition: function() {
            if (this.selectionStart === this.selectionEnd) {
                var style = this._calcTextareaPosition();
                this.hiddenTextarea.style.left = style.left;
                this.hiddenTextarea.style.top = style.top;
            }
        },
        /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */ _calcTextareaPosition: function() {
            if (!this.canvas) return {
                x: 1,
                y: 1
            };
            var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, "fontSize") * this.lineHeight, leftOffset = boundaries.leftOffset, m = this.calcTransformMatrix(), p = {
                x: boundaries.left + leftOffset,
                y: boundaries.top + boundaries.topOffset + charHeight
            }, retinaScaling = this.canvas.getRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight, scaleX = upperCanvas.clientWidth / upperCanvasWidth, scaleY = upperCanvas.clientHeight / upperCanvasHeight;
            p = $d47795690082d4de$var$fabric.util.transformPoint(p, m);
            p = $d47795690082d4de$var$fabric.util.transformPoint(p, this.canvas.viewportTransform);
            p.x *= scaleX;
            p.y *= scaleY;
            if (p.x < 0) p.x = 0;
            if (p.x > maxWidth) p.x = maxWidth;
            if (p.y < 0) p.y = 0;
            if (p.y > maxHeight) p.y = maxHeight;
            // add canvas offset on document
            p.x += this.canvas._offset.left;
            p.y += this.canvas._offset.top;
            return {
                left: p.x + "px",
                top: p.y + "px",
                fontSize: charHeight + "px",
                charHeight: charHeight
            };
        },
        /**
     * @private
     */ _saveEditingProps: function() {
            this._savedProps = {
                hasControls: this.hasControls,
                borderColor: this.borderColor,
                lockMovementX: this.lockMovementX,
                lockMovementY: this.lockMovementY,
                hoverCursor: this.hoverCursor,
                selectable: this.selectable,
                defaultCursor: this.canvas && this.canvas.defaultCursor,
                moveCursor: this.canvas && this.canvas.moveCursor
            };
        },
        /**
     * @private
     */ _restoreEditingProps: function() {
            if (!this._savedProps) return;
            this.hoverCursor = this._savedProps.hoverCursor;
            this.hasControls = this._savedProps.hasControls;
            this.borderColor = this._savedProps.borderColor;
            this.selectable = this._savedProps.selectable;
            this.lockMovementX = this._savedProps.lockMovementX;
            this.lockMovementY = this._savedProps.lockMovementY;
            if (this.canvas) {
                this.canvas.defaultCursor = this._savedProps.defaultCursor;
                this.canvas.moveCursor = this._savedProps.moveCursor;
            }
        },
        /**
     * Exits from editing state
     * @return {fabric.IText} thisArg
     * @chainable
     */ exitEditing: function() {
            var isTextChanged = this._textBeforeEdit !== this.text;
            var hiddenTextarea = this.hiddenTextarea;
            this.selected = false;
            this.isEditing = false;
            this.selectionEnd = this.selectionStart;
            if (hiddenTextarea) {
                hiddenTextarea.blur && hiddenTextarea.blur();
                hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
            }
            this.hiddenTextarea = null;
            this.abortCursorAnimation();
            this._restoreEditingProps();
            this._currentCursorOpacity = 0;
            if (this._shouldClearDimensionCache()) {
                this.initDimensions();
                this.setCoords();
            }
            this.fire("editing:exited");
            isTextChanged && this.fire("modified");
            if (this.canvas) {
                this.canvas.off("mouse:move", this.mouseMoveHandler);
                this.canvas.fire("text:editing:exited", {
                    target: this
                });
                isTextChanged && this.canvas.fire("object:modified", {
                    target: this
                });
            }
            return this;
        },
        /**
     * @private
     */ _removeExtraneousStyles: function() {
            for(var prop in this.styles)if (!this._textLines[prop]) delete this.styles[prop];
        },
        /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */ removeStyleFromTo: function(start, end) {
            var cursorStart = this.get2DCursorLocation(start, true), cursorEnd = this.get2DCursorLocation(end, true), lineStart = cursorStart.lineIndex, charStart = cursorStart.charIndex, lineEnd = cursorEnd.lineIndex, charEnd = cursorEnd.charIndex, i, styleObj;
            if (lineStart !== lineEnd) {
                // step1 remove the trailing of lineStart
                if (this.styles[lineStart]) for(i = charStart; i < this._unwrappedTextLines[lineStart].length; i++)delete this.styles[lineStart][i];
                // step2 move the trailing of lineEnd to lineStart if needed
                if (this.styles[lineEnd]) for(i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++){
                    styleObj = this.styles[lineEnd][i];
                    if (styleObj) {
                        this.styles[lineStart] || (this.styles[lineStart] = {});
                        this.styles[lineStart][charStart + i - charEnd] = styleObj;
                    }
                }
                // step3 detects lines will be completely removed.
                for(i = lineStart + 1; i <= lineEnd; i++)delete this.styles[i];
                // step4 shift remaining lines.
                this.shiftLineStyles(lineEnd, lineStart - lineEnd);
            } else // remove and shift left on the same line
            if (this.styles[lineStart]) {
                styleObj = this.styles[lineStart];
                var diff = charEnd - charStart, numericChar, _char;
                for(i = charStart; i < charEnd; i++)delete styleObj[i];
                for(_char in this.styles[lineStart]){
                    numericChar = parseInt(_char, 10);
                    if (numericChar >= charEnd) {
                        styleObj[numericChar - diff] = styleObj[_char];
                        delete styleObj[_char];
                    }
                }
            }
        },
        /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */ shiftLineStyles: function(lineIndex, offset) {
            // shift all line styles by offset upward or downward
            // do not clone deep. we need new array, not new style objects
            var clonedStyles = clone(this.styles);
            for(var line in this.styles){
                var numericLine = parseInt(line, 10);
                if (numericLine > lineIndex) {
                    this.styles[numericLine + offset] = clonedStyles[numericLine];
                    if (!clonedStyles[numericLine - offset]) delete this.styles[numericLine];
                }
            }
        },
        restartCursorIfNeeded: function() {
            if (!this._currentTickState || this._currentTickState.isAborted || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted) this.initDelayedCursor();
        },
        /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */ insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
            var currentCharStyle, newLineStyles = {}, somethingAdded = false, isEndOfLine = this._unwrappedTextLines[lineIndex].length === charIndex;
            qty || (qty = 1);
            this.shiftLineStyles(lineIndex, qty);
            if (this.styles[lineIndex]) currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
            // we clone styles of all chars
            // after cursor onto the current line
            for(var index in this.styles[lineIndex]){
                var numIndex = parseInt(index, 10);
                if (numIndex >= charIndex) {
                    somethingAdded = true;
                    newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
                    // remove lines from the previous line since they're on a new line now
                    if (!(isEndOfLine && charIndex === 0)) delete this.styles[lineIndex][index];
                }
            }
            var styleCarriedOver = false;
            if (somethingAdded && !isEndOfLine) {
                // if is end of line, the extra style we copied
                // is probably not something we want
                this.styles[lineIndex + qty] = newLineStyles;
                styleCarriedOver = true;
            }
            if (styleCarriedOver) // skip the last line of since we already prepared it.
            qty--;
            // for the all the lines or all the other lines
            // we clone current char style onto the next (otherwise empty) line
            while(qty > 0){
                if (copiedStyle && copiedStyle[qty - 1]) this.styles[lineIndex + qty] = {
                    0: clone(copiedStyle[qty - 1])
                };
                else if (currentCharStyle) this.styles[lineIndex + qty] = {
                    0: clone(currentCharStyle)
                };
                else delete this.styles[lineIndex + qty];
                qty--;
            }
            this._forceClearCache = true;
        },
        /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */ insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
            if (!this.styles) this.styles = {};
            var currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};
            quantity || (quantity = 1);
            // shift all char styles by quantity forward
            // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
            for(var index in currentLineStylesCloned){
                var numericIndex = parseInt(index, 10);
                if (numericIndex >= charIndex) {
                    currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                    // only delete the style if there was nothing moved there
                    if (!currentLineStylesCloned[numericIndex - quantity]) delete currentLineStyles[numericIndex];
                }
            }
            this._forceClearCache = true;
            if (copiedStyle) {
                while(quantity--){
                    if (!Object.keys(copiedStyle[quantity]).length) continue;
                    if (!this.styles[lineIndex]) this.styles[lineIndex] = {};
                    this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
                }
                return;
            }
            if (!currentLineStyles) return;
            var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
            while(newStyle && quantity--)this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
        },
        /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */ insertNewStyleBlock: function(insertedText, start, copiedStyle) {
            var cursorLoc = this.get2DCursorLocation(start, true), addedLines = [
                0
            ], linesLength = 0;
            // get an array of how many char per lines are being added.
            for(var i = 0; i < insertedText.length; i++)if (insertedText[i] === "\n") {
                linesLength++;
                addedLines[linesLength] = 0;
            } else addedLines[linesLength]++;
            // for the first line copy the style from the current char position.
            if (addedLines[0] > 0) {
                this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
                copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
            }
            linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
            for(var i = 1; i < linesLength; i++){
                if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
                else if (copiedStyle) // this test is required in order to close #6841
                // when a pasted buffer begins with a newline then
                // this.styles[cursorLoc.lineIndex + i] and copiedStyle[0]
                // may be undefined for some reason
                {
                    if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
                }
                copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
            }
            // we use i outside the loop to get it like linesLength
            if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        },
        /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */ setSelectionStartEndWithShift: function(start, end, newSelection) {
            if (newSelection <= start) {
                if (end === start) this._selectionDirection = "left";
                else if (this._selectionDirection === "right") {
                    this._selectionDirection = "left";
                    this.selectionEnd = start;
                }
                this.selectionStart = newSelection;
            } else if (newSelection > start && newSelection < end) {
                if (this._selectionDirection === "right") this.selectionEnd = newSelection;
                else this.selectionStart = newSelection;
            } else {
                // newSelection is > selection start and end
                if (end === start) this._selectionDirection = "right";
                else if (this._selectionDirection === "left") {
                    this._selectionDirection = "right";
                    this.selectionStart = end;
                }
                this.selectionEnd = newSelection;
            }
        },
        setSelectionInBoundaries: function() {
            var length = this.text.length;
            if (this.selectionStart > length) this.selectionStart = length;
            else if (this.selectionStart < 0) this.selectionStart = 0;
            if (this.selectionEnd > length) this.selectionEnd = length;
            else if (this.selectionEnd < 0) this.selectionEnd = 0;
        }
    });
})();
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
    /**
   * Initializes "dbclick" event handler
   */ initDoubleClickSimulation: function() {
        // for double click
        this.__lastClickTime = +new Date();
        // for triple click
        this.__lastLastClickTime = +new Date();
        this.__lastPointer = {};
        this.on("mousedown", this.onMouseDown);
    },
    /**
   * Default event handler to simulate triple click
   * @private
   */ onMouseDown: function(options) {
        if (!this.canvas) return;
        this.__newClickTime = +new Date();
        var newPointer = options.pointer;
        if (this.isTripleClick(newPointer)) {
            this.fire("tripleclick", options);
            this._stopEvent(options.e);
        }
        this.__lastLastClickTime = this.__lastClickTime;
        this.__lastClickTime = this.__newClickTime;
        this.__lastPointer = newPointer;
        this.__lastIsEditing = this.isEditing;
        this.__lastSelected = this.selected;
    },
    isTripleClick: function(newPointer) {
        return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === newPointer.x && this.__lastPointer.y === newPointer.y;
    },
    /**
   * @private
   */ _stopEvent: function(e) {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
    },
    /**
   * Initializes event handlers related to cursor or selection
   */ initCursorSelectionHandlers: function() {
        this.initMousedownHandler();
        this.initMouseupHandler();
        this.initClicks();
    },
    /**
   * Default handler for double click, select a word
   */ doubleClickHandler: function(options) {
        if (!this.isEditing) return;
        this.selectWord(this.getSelectionStartFromPointer(options.e));
    },
    /**
   * Default handler for triple click, select a line
   */ tripleClickHandler: function(options) {
        if (!this.isEditing) return;
        this.selectLine(this.getSelectionStartFromPointer(options.e));
    },
    /**
   * Initializes double and triple click event handlers
   */ initClicks: function() {
        this.on("mousedblclick", this.doubleClickHandler);
        this.on("tripleclick", this.tripleClickHandler);
    },
    /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */ _mouseDownHandler: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) return;
        this.__isMousedown = true;
        if (this.selected) {
            this.inCompositionMode = false;
            this.setCursorByClick(options.e);
        }
        if (this.isEditing) {
            this.__selectionStartOnMouseDown = this.selectionStart;
            if (this.selectionStart === this.selectionEnd) this.abortCursorAnimation();
            this.renderCursorOrSelection();
        }
    },
    /**
   * Default event handler for the basic functionalities needed on mousedown:before
   * can be overridden to do something different.
   * Scope of this implementation is: verify the object is already selected when mousing down
   */ _mouseDownHandlerBefore: function(options) {
        if (!this.canvas || !this.editable || options.e.button && options.e.button !== 1) return;
        // we want to avoid that an object that was selected and then becomes unselectable,
        // may trigger editing mode in some way.
        this.selected = this === this.canvas._activeObject;
    },
    /**
   * Initializes "mousedown" event handler
   */ initMousedownHandler: function() {
        this.on("mousedown", this._mouseDownHandler);
        this.on("mousedown:before", this._mouseDownHandlerBefore);
    },
    /**
   * Initializes "mouseup" event handler
   */ initMouseupHandler: function() {
        this.on("mouseup", this.mouseUpHandler);
    },
    /**
   * standard handler for mouse up, overridable
   * @private
   */ mouseUpHandler: function(options) {
        this.__isMousedown = false;
        if (!this.editable || this.group || options.transform && options.transform.actionPerformed || options.e.button && options.e.button !== 1) return;
        if (this.canvas) {
            var currentActive = this.canvas._activeObject;
            if (currentActive && currentActive !== this) // avoid running this logic when there is an active object
            // this because is possible with shift click and fast clicks,
            // to rapidly deselect and reselect this object and trigger an enterEdit
            return;
        }
        if (this.__lastSelected && !this.__corner) {
            this.selected = false;
            this.__lastSelected = false;
            this.enterEditing(options.e);
            if (this.selectionStart === this.selectionEnd) this.initDelayedCursor(true);
            else this.renderCursorOrSelection();
        } else this.selected = true;
    },
    /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {Event} e Event object
   */ setCursorByClick: function(e) {
        var newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) this.setSelectionStartEndWithShift(start, end, newSelection);
        else {
            this.selectionStart = newSelection;
            this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {Event} e Event object
   * @return {Number} Index of a character
   */ getSelectionStartFromPointer: function(e) {
        var mouseOffset = this.getLocalPointer(e), prevWidth = 0, width = 0, height = 0, charIndex = 0, lineIndex = 0, lineLeftOffset, line;
        for(var i = 0, len = this._textLines.length; i < len; i++){
            if (height <= mouseOffset.y) {
                height += this.getHeightOfLine(i) * this.scaleY;
                lineIndex = i;
                if (i > 0) charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
            } else break;
        }
        lineLeftOffset = this._getLineLeftOffset(lineIndex);
        width = lineLeftOffset * this.scaleX;
        line = this._textLines[lineIndex];
        // handling of RTL: in order to get things work correctly,
        // we assume RTL writing is mirrored compared to LTR writing.
        // so in position detection we mirror the X offset, and when is time
        // of rendering it, we mirror it again.
        if (this.direction === "rtl") mouseOffset.x = this.width * this.scaleX - mouseOffset.x + width;
        for(var j = 0, jlen = line.length; j < jlen; j++){
            prevWidth = width;
            // i removed something about flipX here, check.
            width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
            if (width <= mouseOffset.x) charIndex++;
            else break;
        }
        return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
    },
    /**
   * @private
   */ _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
        // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
        var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth, distanceBtwNextCharAndCursor = width - mouseOffset.x, offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor || distanceBtwNextCharAndCursor < 0 ? 0 : 1, newSelectionStart = index + offset;
        // if object is horizontally flipped, mirror cursor location from the end
        if (this.flipX) newSelectionStart = jlen - newSelectionStart;
        if (newSelectionStart > this._text.length) newSelectionStart = this._text.length;
        return newSelectionStart;
    }
});
$d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
    /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */ initHiddenTextarea: function() {
        this.hiddenTextarea = $d47795690082d4de$var$fabric.document.createElement("textarea");
        this.hiddenTextarea.setAttribute("autocapitalize", "off");
        this.hiddenTextarea.setAttribute("autocorrect", "off");
        this.hiddenTextarea.setAttribute("autocomplete", "off");
        this.hiddenTextarea.setAttribute("spellcheck", "false");
        this.hiddenTextarea.setAttribute("data-fabric-hiddentextarea", "");
        this.hiddenTextarea.setAttribute("wrap", "off");
        var style = this._calcTextareaPosition();
        // line-height: 1px; was removed from the style to fix this:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
        this.hiddenTextarea.style.cssText = "position: absolute; top: " + style.top + "; left: " + style.left + "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;" + " padding-top: " + style.fontSize + ";";
        if (this.hiddenTextareaContainer) this.hiddenTextareaContainer.appendChild(this.hiddenTextarea);
        else $d47795690082d4de$var$fabric.document.body.appendChild(this.hiddenTextarea);
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "keydown", this.onKeyDown.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "keyup", this.onKeyUp.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "input", this.onInput.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "copy", this.copy.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "cut", this.copy.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "paste", this.paste.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "compositionstart", this.onCompositionStart.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "compositionupdate", this.onCompositionUpdate.bind(this));
        $d47795690082d4de$var$fabric.util.addListener(this.hiddenTextarea, "compositionend", this.onCompositionEnd.bind(this));
        if (!this._clickHandlerInitialized && this.canvas) {
            $d47795690082d4de$var$fabric.util.addListener(this.canvas.upperCanvasEl, "click", this.onClick.bind(this));
            this._clickHandlerInitialized = true;
        }
    },
    /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behaviour for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the fabric.Itext or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = fabric.util.object.clone(this.keysMap);
   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
   */ keysMap: {
        9: "exitEditing",
        27: "exitEditing",
        33: "moveCursorUp",
        34: "moveCursorDown",
        35: "moveCursorRight",
        36: "moveCursorLeft",
        37: "moveCursorLeft",
        38: "moveCursorUp",
        39: "moveCursorRight",
        40: "moveCursorDown"
    },
    keysMapRtl: {
        9: "exitEditing",
        27: "exitEditing",
        33: "moveCursorUp",
        34: "moveCursorDown",
        35: "moveCursorLeft",
        36: "moveCursorRight",
        37: "moveCursorRight",
        38: "moveCursorUp",
        39: "moveCursorLeft",
        40: "moveCursorDown"
    },
    /**
   * For functionalities on keyUp + ctrl || cmd
   */ ctrlKeysMapUp: {
        67: "copy",
        88: "cut"
    },
    /**
   * For functionalities on keyDown + ctrl || cmd
   */ ctrlKeysMapDown: {
        65: "selectAll"
    },
    onClick: function() {
        // No need to trigger click event here, focus is enough to have the keyboard appear on Android
        this.hiddenTextarea && this.hiddenTextarea.focus();
    },
    /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {Event} e Event object
   */ onKeyDown: function(e) {
        if (!this.isEditing) return;
        var keyMap = this.direction === "rtl" ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) this[keyMap[e.keyCode]](e);
        else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapDown[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
            // if i press an arrow key just update selection
            this.inCompositionMode = false;
            this.clearContextTop();
            this.renderCursorOrSelection();
        } else this.canvas && this.canvas.requestRenderAll();
    },
    /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {Event} e Event object
   */ onKeyUp: function(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
            this._copyDone = false;
            return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapUp[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
    },
    /**
   * Handles onInput event
   * @param {Event} e Event object
   */ onInput: function(e) {
        var fromPaste = this.fromPaste;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) return;
        // decisions about style changes.
        var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, removedText, insertedText, charDiff = nextCharCount - charCount, selectionStart = this.selectionStart, selectionEnd = this.selectionEnd, selection = selectionStart !== selectionEnd, copiedStyle, removeFrom, removeTo;
        if (this.hiddenTextarea.value === "") {
            this.styles = {};
            this.updateFromTextArea();
            this.fire("changed");
            if (this.canvas) {
                this.canvas.fire("text:changed", {
                    target: this
                });
                this.canvas.requestRenderAll();
            }
            return;
        }
        var textareaSelection = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
        var backDelete = selectionStart > textareaSelection.selectionStart;
        if (selection) {
            removedText = this._text.slice(selectionStart, selectionEnd);
            charDiff += selectionEnd - selectionStart;
        } else if (nextCharCount < charCount) {
            if (backDelete) removedText = this._text.slice(selectionEnd + charDiff, selectionEnd);
            else removedText = this._text.slice(selectionStart, selectionStart - charDiff);
        }
        insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
            if (insertedText.length) {
                // let's copy some style before deleting.
                // we want to copy the style before the cursor OR the style at the cursor if selection
                // is bigger than 0.
                copiedStyle = this.getSelectionStyles(selectionStart, selectionStart + 1, false);
                // now duplicate the style one for each inserted text.
                copiedStyle = insertedText.map(function() {
                    // this return an array of references, but that is fine since we are
                    // copying the style later.
                    return copiedStyle[0];
                });
            }
            if (selection) {
                removeFrom = selectionStart;
                removeTo = selectionEnd;
            } else if (backDelete) {
                // detect differences between forwardDelete and backDelete
                removeFrom = selectionEnd - removedText.length;
                removeTo = selectionEnd;
            } else {
                removeFrom = selectionEnd;
                removeTo = selectionEnd + removedText.length;
            }
            this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
            if (fromPaste && insertedText.join("") === $d47795690082d4de$var$fabric.copiedText && !$d47795690082d4de$var$fabric.disableStyleCopyPaste) copiedStyle = $d47795690082d4de$var$fabric.copiedTextStyle;
            this.insertNewStyleBlock(insertedText, selectionStart, copiedStyle);
        }
        this.updateFromTextArea();
        this.fire("changed");
        if (this.canvas) {
            this.canvas.fire("text:changed", {
                target: this
            });
            this.canvas.requestRenderAll();
        }
    },
    /**
   * Composition start
   */ onCompositionStart: function() {
        this.inCompositionMode = true;
    },
    /**
   * Composition end
   */ onCompositionEnd: function() {
        this.inCompositionMode = false;
    },
    // /**
    //  * Composition update
    //  */
    onCompositionUpdate: function(e) {
        this.compositionStart = e.target.selectionStart;
        this.compositionEnd = e.target.selectionEnd;
        this.updateTextareaPosition();
    },
    /**
   * Copies selected text
   * @param {Event} e Event object
   */ copy: function() {
        if (this.selectionStart === this.selectionEnd) //do not cut-copy if no selection
        return;
        $d47795690082d4de$var$fabric.copiedText = this.getSelectedText();
        if (!$d47795690082d4de$var$fabric.disableStyleCopyPaste) $d47795690082d4de$var$fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        else $d47795690082d4de$var$fabric.copiedTextStyle = null;
        this._copyDone = true;
    },
    /**
   * Pastes text
   * @param {Event} e Event object
   */ paste: function() {
        this.fromPaste = true;
    },
    /**
   * @private
   * @param {Event} e Event object
   * @return {Object} Clipboard data object
   */ _getClipboardData: function(e) {
        return e && e.clipboardData || $d47795690082d4de$var$fabric.window.clipboardData;
    },
    /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */ _getWidthBeforeCursor: function(lineIndex, charIndex) {
        var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
            bound = this.__charBounds[lineIndex][charIndex - 1];
            widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
    },
    /**
   * Gets start offset of a selection
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getDownCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        // if on last line, down cursor goes to end of line
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) // move to the end of a text
        return this._text.length - selectionProp;
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor), textAfterCursor = this._textLines[lineIndex].slice(charIndex);
        return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    },
    /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ _getSelectionForOffset: function(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) return this.selectionEnd;
        else return this.selectionStart;
    },
    /**
   * @param {Event} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getUpCursorOffset: function(e, isRight) {
        var selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) // if on first line, up cursor goes to start of line
        return -selectionProp;
        var charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        // return a negative offset
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    },
    /**
   * for a given width it founds the matching character.
   * @private
   */ _getIndexOnLine: function(lineIndex, width) {
        var line = this._textLines[lineIndex], lineLeftOffset = this._getLineLeftOffset(lineIndex), widthOfCharsOnLine = lineLeftOffset, indexOnLine = 0, charWidth, foundMatch;
        for(var j = 0, jlen = line.length; j < jlen; j++){
            charWidth = this.__charBounds[lineIndex][j].width;
            widthOfCharsOnLine += charWidth;
            if (widthOfCharsOnLine > width) {
                foundMatch = true;
                var leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width), offsetFromRightEdge = Math.abs(rightEdge - width);
                indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
                break;
            }
        }
        // reached end
        if (!foundMatch) indexOnLine = line.length - 1;
        return indexOnLine;
    },
    /**
   * Moves cursor down
   * @param {Event} e Event object
   */ moveCursorDown: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorUpOrDown("Down", e);
    },
    /**
   * Moves cursor up
   * @param {Event} e Event object
   */ moveCursorUp: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorUpOrDown("Up", e);
    },
    /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {Event} e Event object
   */ _moveCursorUpOrDown: function(direction, e) {
        // getUpCursorOffset
        // getDownCursorOffset
        var action = "get" + direction + "CursorOffset", offset = this[action](e, this._selectionDirection === "right");
        if (e.shiftKey) this.moveCursorWithShift(offset);
        else this.moveCursorWithoutShift(offset);
        if (offset !== 0) {
            this.setSelectionInBoundaries();
            this.abortCursorAnimation();
            this._currentCursorOpacity = 1;
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Moves cursor with shift
   * @param {Number} offset
   */ moveCursorWithShift: function(offset) {
        var newSelection = this._selectionDirection === "left" ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
    },
    /**
   * Moves cursor up without shift
   * @param {Number} offset
   */ moveCursorWithoutShift: function(offset) {
        if (offset < 0) {
            this.selectionStart += offset;
            this.selectionEnd = this.selectionStart;
        } else {
            this.selectionEnd += offset;
            this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
    },
    /**
   * Moves cursor left
   * @param {Event} e Event object
   */ moveCursorLeft: function(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorLeftOrRight("Left", e);
    },
    /**
   * @private
   * @return {Boolean} true if a change happened
   */ _move: function(e, prop, direction) {
        var newValue;
        if (e.altKey) newValue = this["findWordBoundary" + direction](this[prop]);
        else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) newValue = this["findLineBoundary" + direction](this[prop]);
        else {
            this[prop] += direction === "Left" ? -1 : 1;
            return true;
        }
        if (typeof newValue !== "undefined" && this[prop] !== newValue) {
            this[prop] = newValue;
            return true;
        }
    },
    /**
   * @private
   */ _moveLeft: function(e, prop) {
        return this._move(e, prop, "Left");
    },
    /**
   * @private
   */ _moveRight: function(e, prop) {
        return this._move(e, prop, "Right");
    },
    /**
   * Moves cursor left without keeping selection
   * @param {Event} e
   */ moveCursorLeftWithoutShift: function(e) {
        var change = true;
        this._selectionDirection = "left";
        // only move cursor when there is no selection,
        // otherwise we discard it, and leave cursor on same place
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) change = this._moveLeft(e, "selectionStart");
        this.selectionEnd = this.selectionStart;
        return change;
    },
    /**
   * Moves cursor left while keeping selection
   * @param {Event} e
   */ moveCursorLeftWithShift: function(e) {
        if (this._selectionDirection === "right" && this.selectionStart !== this.selectionEnd) return this._moveLeft(e, "selectionEnd");
        else if (this.selectionStart !== 0) {
            this._selectionDirection = "left";
            return this._moveLeft(e, "selectionStart");
        }
    },
    /**
   * Moves cursor right
   * @param {Event} e Event object
   */ moveCursorRight: function(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorLeftOrRight("Right", e);
    },
    /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {Event} e Event object
   */ _moveCursorLeftOrRight: function(direction, e) {
        var actionName = "moveCursor" + direction + "With";
        this._currentCursorOpacity = 1;
        if (e.shiftKey) actionName += "Shift";
        else actionName += "outShift";
        if (this[actionName](e)) {
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    },
    /**
   * Moves cursor right while keeping selection
   * @param {Event} e
   */ moveCursorRightWithShift: function(e) {
        if (this._selectionDirection === "left" && this.selectionStart !== this.selectionEnd) return this._moveRight(e, "selectionStart");
        else if (this.selectionEnd !== this._text.length) {
            this._selectionDirection = "right";
            return this._moveRight(e, "selectionEnd");
        }
    },
    /**
   * Moves cursor right without keeping selection
   * @param {Event} e Event object
   */ moveCursorRightWithoutShift: function(e) {
        var changed = true;
        this._selectionDirection = "right";
        if (this.selectionStart === this.selectionEnd) {
            changed = this._moveRight(e, "selectionStart");
            this.selectionEnd = this.selectionStart;
        } else this.selectionStart = this.selectionEnd;
        return changed;
    },
    /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ removeChars: function(start, end) {
        if (typeof end === "undefined") end = start + 1;
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join("");
        this.set("dirty", true);
        if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
        }
        this._removeExtraneousStyles();
    },
    /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ insertChars: function(text, style, start, end) {
        if (typeof end === "undefined") end = start;
        if (end > start) this.removeStyleFromTo(start, end);
        var graphemes = $d47795690082d4de$var$fabric.util.string.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
        this.text = this._text.join("");
        this.set("dirty", true);
        if (this._shouldClearDimensionCache()) {
            this.initDimensions();
            this.setCoords();
        }
        this._removeExtraneousStyles();
    }
});
/* _TO_SVG_START_ */ (function() {
    var toFixed = $d47795690082d4de$var$fabric.util.toFixed, multipleSpacesRegex = /  +/g;
    $d47795690082d4de$var$fabric.util.object.extend($d47795690082d4de$var$fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
        /**
     * Returns SVG representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ _toSVG: function() {
            var offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
            return this._wrapSVGTextAndBg(textAndBg);
        },
        /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */ toSVG: function(reviver) {
            return this._createBaseSVGMarkup(this._toSVG(), {
                reviver: reviver,
                noStyle: true,
                withShadow: true
            });
        },
        /**
     * @private
     */ _getSVGLeftTopOffsets: function() {
            return {
                textLeft: -this.width / 2,
                textTop: -this.height / 2,
                lineTop: this.getHeightOfLine(0)
            };
        },
        /**
     * @private
     */ _wrapSVGTextAndBg: function(textAndBg) {
            var noShadow = true, textDecoration = this.getSvgTextDecoration(this);
            return [
                textAndBg.textBgRects.join(""),
                '		<text xml:space="preserve" ',
                this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, "'") + '" ' : "",
                this.fontSize ? 'font-size="' + this.fontSize + '" ' : "",
                this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : "",
                this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : "",
                textDecoration ? 'text-decoration="' + textDecoration + '" ' : "",
                'style="',
                this.getSvgStyles(noShadow),
                '"',
                this.addPaintOrder(),
                " >",
                textAndBg.textSpans.join(""),
                "</text>\n"
            ];
        },
        /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */ _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
            var textSpans = [], textBgRects = [], height = textTopOffset, lineOffset;
            // bounding-box background
            this._setSVGBg(textBgRects);
            // text and text-background
            for(var i = 0, len = this._textLines.length; i < len; i++){
                lineOffset = this._getLineLeftOffset(i);
                if (this.textBackgroundColor || this.styleHas("textBackgroundColor", i)) this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
                this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
                height += this.getHeightOfLine(i);
            }
            return {
                textSpans: textSpans,
                textBgRects: textBgRects
            };
        },
        /**
     * @private
     */ _createTextCharSpan: function(_char, styleDecl, left, top) {
            var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex), styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace), fillStyles = styleProps ? 'style="' + styleProps + '"' : "", dy = styleDecl.deltaY, dySpan = "", NUM_FRACTION_DIGITS = $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS;
            if (dy) dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
            return [
                '<tspan x="',
                toFixed(left, NUM_FRACTION_DIGITS),
                '" y="',
                toFixed(top, NUM_FRACTION_DIGITS),
                '" ',
                dySpan,
                fillStyles,
                ">",
                $d47795690082d4de$var$fabric.util.string.escapeXml(_char),
                "</tspan>"
            ].join("");
        },
        _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
            // set proper line offset
            var lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.indexOf("justify") !== -1, actualStyle, nextStyle, charsToRender = "", charBox, style, boxWidth = 0, line = this._textLines[lineIndex], timeToRender;
            textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
            for(var i = 0, len = line.length - 1; i <= len; i++){
                timeToRender = i === len || this.charSpacing;
                charsToRender += line[i];
                charBox = this.__charBounds[lineIndex][i];
                if (boxWidth === 0) {
                    textLeftOffset += charBox.kernedWidth - charBox.width;
                    boxWidth += charBox.width;
                } else boxWidth += charBox.kernedWidth;
                if (isJustify && !timeToRender) {
                    if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
                }
                if (!timeToRender) {
                    // if we have charSpacing, we render char by char
                    actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                    nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                    timeToRender = $d47795690082d4de$var$fabric.util.hasStyleChanged(actualStyle, nextStyle, true);
                }
                if (timeToRender) {
                    style = this._getStyleDeclaration(lineIndex, i) || {};
                    textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
                    charsToRender = "";
                    actualStyle = nextStyle;
                    textLeftOffset += boxWidth;
                    boxWidth = 0;
                }
            }
        },
        _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
            var NUM_FRACTION_DIGITS = $d47795690082d4de$var$fabric.Object.NUM_FRACTION_DIGITS;
            textBgRects.push("		<rect ", this._getFillAttributes(color), ' x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="', toFixed(top, NUM_FRACTION_DIGITS), '" width="', toFixed(width, NUM_FRACTION_DIGITS), '" height="', toFixed(height, NUM_FRACTION_DIGITS), '"></rect>\n');
        },
        _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
            var line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight, boxWidth = 0, boxStart = 0, charBox, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, "textBackgroundColor");
            for(var j = 0, jlen = line.length; j < jlen; j++){
                charBox = this.__charBounds[i][j];
                currentColor = this.getValueOfPropertyAt(i, j, "textBackgroundColor");
                if (currentColor !== lastColor) {
                    lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastColor = currentColor;
                } else boxWidth += charBox.kernedWidth;
            }
            currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine);
        },
        /**
     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
     *
     * @private
     * @param {*} value
     * @return {String}
     */ _getFillAttributes: function(value) {
            var fillColor = value && typeof value === "string" ? new $d47795690082d4de$var$fabric.Color(value) : "";
            if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) return 'fill="' + value + '"';
            return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
        },
        /**
     * @private
     */ _getSVGLineTopOffset: function(lineIndex) {
            var lineTopOffset = 0, lastHeight = 0;
            for(var j = 0; j < lineIndex; j++)lineTopOffset += this.getHeightOfLine(j);
            lastHeight = this.getHeightOfLine(j);
            return {
                lineTop: lineTopOffset,
                offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
            };
        },
        /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */ getSvgStyles: function(skipShadow) {
            var svgStyle = $d47795690082d4de$var$fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
            return svgStyle + " white-space: pre;";
        }
    });
})();
/* _TO_SVG_END_ */ (function(global) {
    "use strict";
    var fabric = global.fabric || (global.fabric = {});
    /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   * @class fabric.Textbox
   * @extends fabric.IText
   * @mixes fabric.Observable
   * @return {fabric.Textbox} thisArg
   * @see {@link fabric.Textbox#initialize} for constructor definition
   */ fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {
        /**
     * Type of an object
     * @type String
     * @default
     */ type: "textbox",
        /**
     * Minimum width of textbox, in pixels.
     * @type Number
     * @default
     */ minWidth: 20,
        /**
     * Minimum calculated width of a textbox, in pixels.
     * fixed to 2 so that an empty textbox cannot go to 0
     * and is still selectable without text.
     * @type Number
     * @default
     */ dynamicMinWidth: 2,
        /**
     * Cached array of text wrapping.
     * @type Array
     */ __cachedLines: null,
        /**
     * Override standard Object class values
     */ lockScalingFlip: true,
        /**
     * Override standard Object class values
     * Textbox needs this on false
     */ noScaleCache: false,
        /**
     * Properties which when set cause object to change dimensions
     * @type Object
     * @private
     */ _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat("width"),
        /**
     * Use this regular expression to split strings in breakable lines
     * @private
     */ _wordJoiners: /[ \t\r]/,
        /**
     * Use this boolean property in order to split strings that have no white space concept.
     * this is a cheap way to help with chinese/japanese
     * @type Boolean
     * @since 2.6.0
     */ splitByGrapheme: false,
        /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */ initDimensions: function() {
            if (this.__skipDimension) return;
            this.isEditing && this.initDelayedCursor();
            this.clearContextTop();
            this._clearCache();
            // clear dynamicMinWidth as it will be different after we re-wrap line
            this.dynamicMinWidth = 0;
            // wrap lines
            this._styleMap = this._generateStyleMap(this._splitText());
            // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
            if (this.dynamicMinWidth > this.width) this._set("width", this.dynamicMinWidth);
            if (this.textAlign.indexOf("justify") !== -1) // once text is measured we need to make space fatter to make justified text.
            this.enlargeSpaces();
            // clear cache and re-calculate height
            this.height = this.calcTextHeight();
            this.saveState({
                propertySet: "_dimensionAffectingProps"
            });
        },
        /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */ _generateStyleMap: function(textInfo) {
            var realLineCount = 0, realLineCharCount = 0, charCount = 0, map = {};
            for(var i = 0; i < textInfo.graphemeLines.length; i++){
                if (textInfo.graphemeText[charCount] === "\n" && i > 0) {
                    realLineCharCount = 0;
                    charCount++;
                    realLineCount++;
                } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
                    // this case deals with space's that are removed from end of lines when wrapping
                    realLineCharCount++;
                    charCount++;
                }
                map[i] = {
                    line: realLineCount,
                    offset: realLineCharCount
                };
                charCount += textInfo.graphemeLines[i].length;
                realLineCharCount += textInfo.graphemeLines[i].length;
            }
            return map;
        },
        /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */ styleHas: function(property, lineIndex) {
            if (this._styleMap && !this.isWrapping) {
                var map = this._styleMap[lineIndex];
                if (map) lineIndex = map.line;
            }
            return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
        },
        /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */ isEmptyStyles: function(lineIndex) {
            if (!this.styles) return true;
            var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false, map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
            if (map) {
                lineIndex = map.line;
                offset = map.offset;
            }
            if (mapNextLine) {
                nextLineIndex = mapNextLine.line;
                shouldLimit = nextLineIndex === lineIndex;
                nextOffset = mapNextLine.offset;
            }
            obj = typeof lineIndex === "undefined" ? this.styles : {
                line: this.styles[lineIndex]
            };
            for(var p1 in obj){
                for(var p2 in obj[p1])if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
                    // eslint-disable-next-line no-unused-vars
                    for(var p3 in obj[p1][p2])return false;
                }
            }
            return true;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _getStyleDeclaration: function(lineIndex, charIndex) {
            if (this._styleMap && !this.isWrapping) {
                var map = this._styleMap[lineIndex];
                if (!map) return null;
                lineIndex = map.line;
                charIndex = map.offset + charIndex;
            }
            return this.callSuper("_getStyleDeclaration", lineIndex, charIndex);
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */ _setStyleDeclaration: function(lineIndex, charIndex, style) {
            var map = this._styleMap[lineIndex];
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
            this.styles[lineIndex][charIndex] = style;
        },
        /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */ _deleteStyleDeclaration: function(lineIndex, charIndex) {
            var map = this._styleMap[lineIndex];
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
            delete this.styles[lineIndex][charIndex];
        },
        /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */ _getLineStyle: function(lineIndex) {
            var map = this._styleMap[lineIndex];
            return !!this.styles[map.line];
        },
        /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */ _setLineStyle: function(lineIndex) {
            var map = this._styleMap[lineIndex];
            this.styles[map.line] = {};
        },
        /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */ _wrapText: function(lines, desiredWidth) {
            var wrapped = [], i;
            this.isWrapping = true;
            for(i = 0; i < lines.length; i++)wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
            this.isWrapping = false;
            return wrapped;
        },
        /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * it gets called when charBounds are not available yet.
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     * @private
     */ _measureWord: function(word, lineIndex, charOffset) {
            var width = 0, prevGrapheme, skipLeft = true;
            charOffset = charOffset || 0;
            for(var i = 0, len = word.length; i < len; i++){
                var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
                width += box.kernedWidth;
                prevGrapheme = word[i];
            }
            return width;
        },
        /**
     * Wraps a line of text using the width of the Textbox and a context.
     * @param {Array} line The grapheme array that represent the line
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */ _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
            var lineWidth = 0, splitByGrapheme = this.splitByGrapheme, graphemeLines = [], line = [], // spaces in different languages?
            words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners), word = "", offset = 0, infix = splitByGrapheme ? "" : " ", wordWidth = 0, infixWidth = 0, largestWordWidth = 0, lineJustStarted = true, additionalSpace = this._getWidthOfCharSpacing(), reservedSpace = reservedSpace || 0;
            // fix a difference between split and graphemeSplit
            if (words.length === 0) words.push([]);
            desiredWidth -= reservedSpace;
            for(var i = 0; i < words.length; i++){
                // if using splitByGrapheme words are already in graphemes.
                word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
                wordWidth = this._measureWord(word, lineIndex, offset);
                offset += word.length;
                lineWidth += infixWidth + wordWidth - additionalSpace;
                if (lineWidth > desiredWidth && !lineJustStarted) {
                    graphemeLines.push(line);
                    line = [];
                    lineWidth = wordWidth;
                    lineJustStarted = true;
                } else lineWidth += additionalSpace;
                if (!lineJustStarted && !splitByGrapheme) line.push(infix);
                line = line.concat(word);
                infixWidth = splitByGrapheme ? 0 : this._measureWord([
                    infix
                ], lineIndex, offset);
                offset++;
                lineJustStarted = false;
                // keep track of largest word
                if (wordWidth > largestWordWidth) largestWordWidth = wordWidth;
            }
            i && graphemeLines.push(line);
            if (largestWordWidth + reservedSpace > this.dynamicMinWidth) this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
            return graphemeLines;
        },
        /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */ isEndOfWrapping: function(lineIndex) {
            if (!this._styleMap[lineIndex + 1]) // is last line, return true;
            return true;
            if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) // this is last line before a line break, return true;
            return true;
            return false;
        },
        /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * @return Number
     */ missingNewlineOffset: function(lineIndex) {
            if (this.splitByGrapheme) return this.isEndOfWrapping(lineIndex) ? 1 : 0;
            return 1;
        },
        /**
    * Gets lines of text to render in the Textbox. This function calculates
    * text wrapping on the fly every time it is called.
    * @param {String} text text to split
    * @returns {Array} Array of lines in the Textbox.
    * @override
    */ _splitTextIntoLines: function(text) {
            var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
            for(var i = 0; i < graphemeLines.length; i++)lines[i] = graphemeLines[i].join("");
            newText.lines = lines;
            newText.graphemeLines = graphemeLines;
            return newText;
        },
        getMinWidth: function() {
            return Math.max(this.minWidth, this.dynamicMinWidth);
        },
        _removeExtraneousStyles: function() {
            var linesToKeep = {};
            for(var prop in this._styleMap)if (this._textLines[prop]) linesToKeep[this._styleMap[prop].line] = 1;
            for(var prop in this.styles)if (!linesToKeep[prop]) delete this.styles[prop];
        },
        /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */ toObject: function(propertiesToInclude) {
            return this.callSuper("toObject", [
                "minWidth",
                "splitByGrapheme"
            ].concat(propertiesToInclude));
        }
    });
    /**
   * Returns fabric.Textbox instance from an object representation
   * @static
   * @memberOf fabric.Textbox
   * @param {Object} object Object to create an instance from
   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
   */ fabric.Textbox.fromObject = function(object, callback) {
        var styles = fabric.util.stylesFromArray(object.styles, object.text);
        //copy object to prevent mutation
        var objCopy = Object.assign({}, object, {
            styles: styles
        });
        return fabric.Object._fromObject("Textbox", objCopy, callback, "text");
    };
})($d47795690082d4de$exports);
(function() {
    var controlsUtils = $d47795690082d4de$var$fabric.controlsUtils, scaleSkewStyleHandler = controlsUtils.scaleSkewCursorStyleHandler, scaleStyleHandler = controlsUtils.scaleCursorStyleHandler, scalingEqually = controlsUtils.scalingEqually, scalingYOrSkewingX = controlsUtils.scalingYOrSkewingX, scalingXOrSkewingY = controlsUtils.scalingXOrSkewingY, scaleOrSkewActionName = controlsUtils.scaleOrSkewActionName, objectControls = $d47795690082d4de$var$fabric.Object.prototype.controls;
    objectControls.ml = new $d47795690082d4de$var$fabric.Control({
        x: -0.5,
        y: 0,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingXOrSkewingY,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mr = new $d47795690082d4de$var$fabric.Control({
        x: 0.5,
        y: 0,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingXOrSkewingY,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mb = new $d47795690082d4de$var$fabric.Control({
        x: 0,
        y: 0.5,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingYOrSkewingX,
        getActionName: scaleOrSkewActionName
    });
    objectControls.mt = new $d47795690082d4de$var$fabric.Control({
        x: 0,
        y: -0.5,
        cursorStyleHandler: scaleSkewStyleHandler,
        actionHandler: scalingYOrSkewingX,
        getActionName: scaleOrSkewActionName
    });
    objectControls.tl = new $d47795690082d4de$var$fabric.Control({
        x: -0.5,
        y: -0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.tr = new $d47795690082d4de$var$fabric.Control({
        x: 0.5,
        y: -0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.bl = new $d47795690082d4de$var$fabric.Control({
        x: -0.5,
        y: 0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.br = new $d47795690082d4de$var$fabric.Control({
        x: 0.5,
        y: 0.5,
        cursorStyleHandler: scaleStyleHandler,
        actionHandler: scalingEqually
    });
    objectControls.mtr = new $d47795690082d4de$var$fabric.Control({
        x: 0,
        y: -0.5,
        actionHandler: controlsUtils.rotationWithSnapping,
        cursorStyleHandler: controlsUtils.rotationStyleHandler,
        offsetY: -40,
        withConnection: true,
        actionName: "rotate"
    });
    if ($d47795690082d4de$var$fabric.Textbox) {
        // this is breaking the prototype inheritance, no time / ideas to fix it.
        // is important to document that if you want to have all objects to have a
        // specific custom control, you have to add it to Object prototype and to Textbox
        // prototype. The controls are shared as references. So changes to control `tr`
        // can still apply to all objects if needed.
        var textBoxControls = $d47795690082d4de$var$fabric.Textbox.prototype.controls = {};
        textBoxControls.mtr = objectControls.mtr;
        textBoxControls.tr = objectControls.tr;
        textBoxControls.br = objectControls.br;
        textBoxControls.tl = objectControls.tl;
        textBoxControls.bl = objectControls.bl;
        textBoxControls.mt = objectControls.mt;
        textBoxControls.mb = objectControls.mb;
        textBoxControls.mr = new $d47795690082d4de$var$fabric.Control({
            x: 0.5,
            y: 0,
            actionHandler: controlsUtils.changeWidth,
            cursorStyleHandler: scaleSkewStyleHandler,
            actionName: "resizing"
        });
        textBoxControls.ml = new $d47795690082d4de$var$fabric.Control({
            x: -0.5,
            y: 0,
            actionHandler: controlsUtils.changeWidth,
            cursorStyleHandler: scaleSkewStyleHandler,
            actionName: "resizing"
        });
    }
})();


const $ebeb53aaa150c8a5$export$3fea9e4a2e457811 = {
    CELL_SIZE: 32,
    GRID_COLOR: "#333",
    BACKGROUND_COLOR: "#000",
    ID: "polygon"
};
const $ebeb53aaa150c8a5$export$724cfc3c1832d401 = {
    STAGE2_ACTIVATION: 3200,
    STAGE3_STAGE1_ACTIVATION: 9000,
    STAGE3_STAGE2_ACTIVATION: 25000
};
const $ebeb53aaa150c8a5$export$2b0b8facff24bd81 = 10;




const $21f5148a80ac224a$export$6f57813fe9f31bf9 = {
    selectedSquare: null,
    colorPicker: [
        "#FFD700",
        "#8B4513"
    ],
    canvas: new (0, $d47795690082d4de$exports.fabric).Canvas("c", {
        selection: false
    })
};
function $21f5148a80ac224a$export$23be2efcbc791729(square) {
    $21f5148a80ac224a$export$6f57813fe9f31bf9.selectedSquare = square;
}


var $42f5864281cc433e$exports = {};
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $42f5864281cc433e$exports) $42f5864281cc433e$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($42f5864281cc433e$exports);


const $b25678c505cad7eb$export$65957730cfdf9e4a = (value)=>{
    if (!value) return;
    const gweiValue = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(value.toString());
    const maticValue = gweiValue.dividedBy(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(10).pow(9));
    return maticValue.toString();
};
const $b25678c505cad7eb$export$462d8f843f9309b = (value)=>{
    const maticValue = value.dividedBy(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(10).pow(18));
    return maticValue.toString();
};
const $b25678c505cad7eb$export$52fb33e3b26411c = (value)=>{
    const maticValue = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(value);
    const weiValue = maticValue.multipliedBy(new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(10).pow(18));
    return weiValue.toString();
};
const $b25678c505cad7eb$export$d6ac4b4f164d4064 = (hex)=>{
    if (hex.length === 4) {
        const r = hex[1];
        const g = hex[2];
        const b = hex[3];
        return `#${r}${r}${g}${g}${b}${b}`;
    }
    return hex;
};
const $b25678c505cad7eb$export$b416d5a4e0e94cd = (num)=>{
    if (num === 0) return 0;
    const magnitude = Math.floor(Math.log10(Math.abs(num)));
    const scale = Math.pow(10, magnitude - 1);
    return parseFloat((Math.round(num / scale) * scale).toPrecision(2));
};






const $a7e5cc371a81d091$var$ITEMS_PER_PAGE = 5;
function $a7e5cc371a81d091$var$displayHistoryForPage(pageNumber, pixelData) {
    const startIndex = (pageNumber - 1) * $a7e5cc371a81d091$var$ITEMS_PER_PAGE;
    const endIndex = startIndex + $a7e5cc371a81d091$var$ITEMS_PER_PAGE;
    const itemsToDisplay = pixelData.slice(startIndex, endIndex);
    const historyElement = document.getElementById("history");
    historyElement.innerHTML = "";
    itemsToDisplay.forEach((data)=>{
        const liElement = document.createElement("li");
        const colorCircle = document.createElement("div");
        colorCircle.classList.add("color-circle");
        colorCircle.style.backgroundColor = data.color;
        liElement.appendChild(colorCircle);
        const purchaseInfo = document.createElement("div");
        purchaseInfo.classList.add("purchase-info");
        const formattedAddress = `${data.contractAddress.slice(0, 4)}...${data.contractAddress.slice(-4)}`;
        purchaseInfo.innerHTML = `Value: ${data.value} <br/> ${formattedAddress}`;
        liElement.appendChild(purchaseInfo);
        historyElement.appendChild(liElement);
    });
    const prevButton = document.getElementById("prev-button");
    const nextButton = document.getElementById("next-button");
    if (prevButton && nextButton) {
        prevButton.disabled = pageNumber <= 1;
        nextButton.disabled = pageNumber >= Math.ceil(pixelData.length / $a7e5cc371a81d091$var$ITEMS_PER_PAGE);
    }
}
function $a7e5cc371a81d091$export$a104c684a09de9be(currentPage) {
    const pixelData = [
        ...(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareLayers
    ].reverse().map((layer, index)=>({
            color: layer.color ? layer.color : "#000",
            value: (0, $b25678c505cad7eb$export$b416d5a4e0e94cd)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareValue * ((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareLayers.length - index)),
            contractAddress: layer.owner
        }));
    $a7e5cc371a81d091$var$displayHistoryForPage(currentPage, pixelData);
    const prevButton = document.getElementById("prev-button");
    const nextButton = document.getElementById("next-button");
    if (prevButton && nextButton) {
        prevButton.addEventListener("click", ()=>{
            currentPage--;
            $a7e5cc371a81d091$var$displayHistoryForPage(currentPage, pixelData);
        });
        nextButton.addEventListener("click", ()=>{
            currentPage++;
            $a7e5cc371a81d091$var$displayHistoryForPage(currentPage, pixelData);
        });
    }
}


var $d68fe5b824f21b3a$exports = {};
$d68fe5b824f21b3a$exports = JSON.parse('["#FF6A00","#A8E063","#00653F","#00B3B3","#0081FF","#592D8D","#750839"]');





/**
 *  The Interface class is a low-level class that accepts an
 *  ABI and provides all the necessary functionality to encode
 *  and decode paramaters to and results from methods, events
 *  and errors.
 *
 *  It also provides several convenience methods to automatically
 *  search and find matching transactions and events to parse them.
 *
 *  @_subsection api/abi:Interfaces  [interfaces]
 */ /**
 *  A fundamental building block of Ethereum is the underlying
 *  cryptographic primitives.
 *
 *  @_section: api/crypto:Cryptographic Functions   [about-crypto]
 */ /**
 *  An **HMAC** enables verification that a given key was used
 *  to authenticate a payload.
 *
 *  See: [[link-wiki-hmac]]
 *
 *  @_subsection: api/crypto:HMAC  [about-hmac]
 */ /* Browser Crypto Shims */ var $51b6b372898f65c0$exports = {};
"use strict";
Object.defineProperty($51b6b372898f65c0$exports, "__esModule", {
    value: true
});
$51b6b372898f65c0$exports.hmac = void 0;
var $a0ae23f5901291b4$exports = {};
"use strict";
Object.defineProperty($a0ae23f5901291b4$exports, "__esModule", {
    value: true
});
$a0ae23f5901291b4$exports.output = $a0ae23f5901291b4$exports.exists = $a0ae23f5901291b4$exports.hash = $a0ae23f5901291b4$exports.bytes = $a0ae23f5901291b4$exports.bool = $a0ae23f5901291b4$exports.number = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
$a0ae23f5901291b4$exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
$a0ae23f5901291b4$exports.bool = $a0ae23f5901291b4$var$bool;
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new TypeError(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
$a0ae23f5901291b4$exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(hash.outputLen);
    $a0ae23f5901291b4$var$number(hash.blockLen);
}
$a0ae23f5901291b4$exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
$a0ae23f5901291b4$exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
$a0ae23f5901291b4$exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
$a0ae23f5901291b4$exports.default = $a0ae23f5901291b4$var$assert;


var $29ee4d3171d9809b$exports = {};
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty($29ee4d3171d9809b$exports, "__esModule", {
    value: true
});
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$exports.isLE = $29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$exports.u8 = void 0;
var $2045a8b4f28795b8$exports = {};
"use strict";
Object.defineProperty($2045a8b4f28795b8$exports, "__esModule", {
    value: true
});
$2045a8b4f28795b8$exports.crypto = void 0;
$2045a8b4f28795b8$exports.crypto = {
    node: undefined,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};


// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
$29ee4d3171d9809b$exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
$29ee4d3171d9809b$exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
$29ee4d3171d9809b$exports.rotr = $29ee4d3171d9809b$var$rotr;
$29ee4d3171d9809b$exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// There is almost no big endian hardware, but js typed arrays uses platform specific endianness.
// So, just to be sure not to corrupt anything.
if (!$29ee4d3171d9809b$exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $29ee4d3171d9809b$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xde, 0xad, 0xbe, 0xef]))
 */ function $29ee4d3171d9809b$var$bytesToHex(uint8a) {
    // pre-caching improves the speed 6x
    if (!(uint8a instanceof Uint8Array)) throw new Error("Uint8Array expected");
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $29ee4d3171d9809b$var$hexes[uint8a[i]];
    return hex;
}
$29ee4d3171d9809b$exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
/**
 * @example hexToBytes('deadbeef')
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
$29ee4d3171d9809b$exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow. However, call to async function will return Promise
// which will be fullfiled only on next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
$29ee4d3171d9809b$exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, $29ee4d3171d9809b$exports.nextTick)();
        ts += diff;
    }
}
$29ee4d3171d9809b$exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new TypeError(`utf8ToBytes expected string, got ${typeof str}`);
    return new TextEncoder().encode(str);
}
$29ee4d3171d9809b$exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    if (!(data instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof data})`);
    return data;
}
$29ee4d3171d9809b$exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Concats Uint8Array-s into one; like `Buffer.concat([buf1, buf2])`
 * @example concatBytes(buf1, buf2)
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    if (!arrays.every((a)=>a instanceof Uint8Array)) throw new Error("Uint8Array list expected");
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
$29ee4d3171d9809b$exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
$29ee4d3171d9809b$exports.Hash = $29ee4d3171d9809b$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $29ee4d3171d9809b$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$29ee4d3171d9809b$var$isPlainObject(opts))) throw new TypeError("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
$29ee4d3171d9809b$exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashConstructor) {
    const hashC = (message)=>hashConstructor().update($29ee4d3171d9809b$var$toBytes(message)).digest();
    const tmp = hashConstructor();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashConstructor();
    return hashC;
}
$29ee4d3171d9809b$exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
$29ee4d3171d9809b$exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
/**
 * Secure PRNG
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($2045a8b4f28795b8$exports.crypto.web) return $2045a8b4f28795b8$exports.crypto.web.getRandomValues(new Uint8Array(bytesLength));
    else if ($2045a8b4f28795b8$exports.crypto.node) return new Uint8Array($2045a8b4f28795b8$exports.crypto.node.randomBytes(bytesLength).buffer);
    else throw new Error("The environment doesn't have randomBytes function");
}
$29ee4d3171d9809b$exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;


// HMAC (RFC 2104)
class $51b6b372898f65c0$var$HMAC extends $29ee4d3171d9809b$exports.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        $a0ae23f5901291b4$exports.default.hash(hash);
        const key = (0, $29ee4d3171d9809b$exports.toBytes)(_key);
        this.iHash = hash.create();
        if (!(this.iHash instanceof $29ee4d3171d9809b$exports.Hash)) throw new TypeError("Expected instance of class which extends utils.Hash");
        const blockLen = this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > this.iHash.blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        $a0ae23f5901291b4$exports.default.exists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        $a0ae23f5901291b4$exports.default.exists(this);
        $a0ae23f5901291b4$exports.default.bytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$var$hmac;
$51b6b372898f65c0$exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);


var $8c2f54a153cf1baf$exports = {};
"use strict";
Object.defineProperty($8c2f54a153cf1baf$exports, "__esModule", {
    value: true
});
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$exports.pbkdf2 = void 0;



// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    $a0ae23f5901291b4$exports.default.hash(hash);
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    $a0ae23f5901291b4$exports.default.number(c);
    $a0ae23f5901291b4$exports.default.number(dkLen);
    $a0ae23f5901291b4$exports.default.number(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $29ee4d3171d9809b$exports.toBytes)(_password);
    const salt = (0, $29ee4d3171d9809b$exports.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $51b6b372898f65c0$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$8c2f54a153cf1baf$exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $29ee4d3171d9809b$exports.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(c - 1, asyncTick, (i)=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;


var $510ad3657d73a9d2$exports = {};
"use strict";
Object.defineProperty($510ad3657d73a9d2$exports, "__esModule", {
    value: true
});
$510ad3657d73a9d2$exports.sha256 = void 0;
var $bc3a993d7d38a7a0$exports = {};
"use strict";
Object.defineProperty($bc3a993d7d38a7a0$exports, "__esModule", {
    value: true
});
$bc3a993d7d38a7a0$exports.SHA2 = void 0;


// Polyfill for Safari 14
function $bc3a993d7d38a7a0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bc3a993d7d38a7a0$var$SHA2 extends $29ee4d3171d9809b$exports.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $29ee4d3171d9809b$exports.createView)(this.buffer);
    }
    update(data) {
        $a0ae23f5901291b4$exports.default.exists(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $29ee4d3171d9809b$exports.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        $a0ae23f5901291b4$exports.default.exists(this);
        $a0ae23f5901291b4$exports.default.output(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bc3a993d7d38a7a0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $29ee4d3171d9809b$exports.createView)(out);
        this.get().forEach((v, i)=>oview.setUint32(4 * i, v, isLE));
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
$bc3a993d7d38a7a0$exports.SHA2 = $bc3a993d7d38a7a0$var$SHA2;



// Choice: a ? b : c
const $510ad3657d73a9d2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $510ad3657d73a9d2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $510ad3657d73a9d2$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $29ee4d3171d9809b$exports.rotr)(W15, 7) ^ (0, $29ee4d3171d9809b$exports.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $29ee4d3171d9809b$exports.rotr)(W2, 17) ^ (0, $29ee4d3171d9809b$exports.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $29ee4d3171d9809b$exports.rotr)(E, 6) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 11) ^ (0, $29ee4d3171d9809b$exports.rotr)(E, 25);
            const T1 = H + sigma1 + $510ad3657d73a9d2$var$Chi(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $29ee4d3171d9809b$exports.rotr)(A, 2) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 13) ^ (0, $29ee4d3171d9809b$exports.rotr)(A, 22);
            const T2 = sigma0 + $510ad3657d73a9d2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ $510ad3657d73a9d2$exports.sha256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());


var $2579977b4e52adba$exports = {};
"use strict";
Object.defineProperty($2579977b4e52adba$exports, "__esModule", {
    value: true
});
$2579977b4e52adba$exports.sha384 = $2579977b4e52adba$exports.sha512_256 = $2579977b4e52adba$exports.sha512 = $2579977b4e52adba$exports.SHA512 = void 0;

var $aa71b30d36adb919$exports = {};
"use strict";
Object.defineProperty($aa71b30d36adb919$exports, "__esModule", {
    value: true
});
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$exports.split = $aa71b30d36adb919$exports.fromBig = void 0;
const $aa71b30d36adb919$var$U32_MASK64 = BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
$aa71b30d36adb919$exports.fromBig = $aa71b30d36adb919$var$fromBig;
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
$aa71b30d36adb919$exports.split = $aa71b30d36adb919$var$split;
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, l, s)=>h >>> s;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (h, l)=>l;
const $aa71b30d36adb919$var$rotr32L = (h, l)=>h;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$var$add;
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$exports.toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
$aa71b30d36adb919$exports.default = $aa71b30d36adb919$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = $aa71b30d36adb919$exports.default.split([
    "0x428a2f98d728ae22",
    "0x7137449123ef65cd",
    "0xb5c0fbcfec4d3b2f",
    "0xe9b5dba58189dbbc",
    "0x3956c25bf348b538",
    "0x59f111f1b605d019",
    "0x923f82a4af194f9b",
    "0xab1c5ed5da6d8118",
    "0xd807aa98a3030242",
    "0x12835b0145706fbe",
    "0x243185be4ee4b28c",
    "0x550c7dc3d5ffb4e2",
    "0x72be5d74f27b896f",
    "0x80deb1fe3b1696b1",
    "0x9bdc06a725c71235",
    "0xc19bf174cf692694",
    "0xe49b69c19ef14ad2",
    "0xefbe4786384f25e3",
    "0x0fc19dc68b8cd5b5",
    "0x240ca1cc77ac9c65",
    "0x2de92c6f592b0275",
    "0x4a7484aa6ea6e483",
    "0x5cb0a9dcbd41fbd4",
    "0x76f988da831153b5",
    "0x983e5152ee66dfab",
    "0xa831c66d2db43210",
    "0xb00327c898fb213f",
    "0xbf597fc7beef0ee4",
    "0xc6e00bf33da88fc2",
    "0xd5a79147930aa725",
    "0x06ca6351e003826f",
    "0x142929670a0e6e70",
    "0x27b70a8546d22ffc",
    "0x2e1b21385c26c926",
    "0x4d2c6dfc5ac42aed",
    "0x53380d139d95b3df",
    "0x650a73548baf63de",
    "0x766a0abb3c77b2a8",
    "0x81c2c92e47edaee6",
    "0x92722c851482353b",
    "0xa2bfe8a14cf10364",
    "0xa81a664bbc423001",
    "0xc24b8b70d0f89791",
    "0xc76c51a30654be30",
    "0xd192e819d6ef5218",
    "0xd69906245565a910",
    "0xf40e35855771202a",
    "0x106aa07032bbd1b8",
    "0x19a4c116b8d2d0c8",
    "0x1e376c085141ab53",
    "0x2748774cdf8eeb99",
    "0x34b0bcb5e19b48a8",
    "0x391c0cb3c5c95a63",
    "0x4ed8aa4ae3418acb",
    "0x5b9cca4f7763e373",
    "0x682e6ff3d6b2b8a3",
    "0x748f82ee5defb2fc",
    "0x78a5636f43172f60",
    "0x84c87814a1f0ab72",
    "0x8cc702081a6439ec",
    "0x90befffa23631e28",
    "0xa4506cebde82bde9",
    "0xbef9a3f7b2c67915",
    "0xc67178f2e372532b",
    "0xca273eceea26619c",
    "0xd186b8c721c0c207",
    "0xeada7dd6cde0eb1e",
    "0xf57d4f7fee6ed178",
    "0x06f067aa72176fba",
    "0x0a637dc5a2c898a6",
    "0x113f9804bef90dae",
    "0x1b710b35131c471b",
    "0x28db77f523047d84",
    "0x32caab7b40c72493",
    "0x3c9ebe0a15c9bebc",
    "0x431d67c49c100d4c",
    "0x4cc5d4becb3e42b6",
    "0x597f299cfc657e2a",
    "0x5fcb6fab3ad6faec",
    "0x6c44198c4a475817"
].map((n)=>BigInt(n)));
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $aa71b30d36adb919$exports.default.rotrSH(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBH(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $aa71b30d36adb919$exports.default.rotrSL(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBL(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $aa71b30d36adb919$exports.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $aa71b30d36adb919$exports.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $aa71b30d36adb919$exports.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $aa71b30d36adb919$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $aa71b30d36adb919$exports.default.rotrSH(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $aa71b30d36adb919$exports.default.rotrSL(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $aa71b30d36adb919$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $aa71b30d36adb919$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $aa71b30d36adb919$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $aa71b30d36adb919$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $aa71b30d36adb919$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $aa71b30d36adb919$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $aa71b30d36adb919$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $aa71b30d36adb919$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$2579977b4e52adba$exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$2579977b4e52adba$exports.sha512 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
$2579977b4e52adba$exports.sha512_256 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
$2579977b4e52adba$exports.sha384 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());


/**
 *  All errors in ethers include properties to ensure they are both
 *  human-readable (i.e. ``.message``) and machine-readable (i.e. ``.code``).
 *
 *  The [[isError]] function can be used to check the error ``code`` and
 *  provide a type guard for the properties present on that error interface.
 *
 *  @_section: api/utils/errors:Errors  [about-errors]
 */ /* Do NOT modify this file; see /src.ts/_admin/update-version.ts */ /**
 *  The current version of Ethers.
 */ const $9f7bf65ddafc81a6$export$83d89fbfd8236492 = "6.7.1";


/**
 *  Property helper functions.
 *
 *  @_subsection api/utils:Properties  [about-properties]
 */ function $5ac0677dd70fe0c6$var$checkType(value, type, name) {
    const types = type.split("|").map((t)=>t.trim());
    for(let i = 0; i < types.length; i++)switch(type){
        case "any":
            return;
        case "bigint":
        case "boolean":
        case "number":
        case "string":
            if (typeof value === type) return;
    }
    const error = new Error(`invalid value for type ${type}`);
    error.code = "INVALID_ARGUMENT";
    error.argument = `value.${name}`;
    error.value = value;
    throw error;
}
async function $5ac0677dd70fe0c6$export$d503dd157d963b60(value) {
    const keys = Object.keys(value);
    const results = await Promise.all(keys.map((k)=>Promise.resolve(value[k])));
    return results.reduce((accum, v, index)=>{
        accum[keys[index]] = v;
        return accum;
    }, {});
}
function $5ac0677dd70fe0c6$export$b61bda4fbca264f2(target, values, types) {
    for(let key in values){
        let value = values[key];
        const type = types ? types[key] : null;
        if (type) $5ac0677dd70fe0c6$var$checkType(value, type, key);
        Object.defineProperty(target, key, {
            enumerable: true,
            value: value,
            writable: false
        });
    }
}


function $634aa51198273feb$var$stringify(value) {
    if (value == null) return "null";
    if (Array.isArray(value)) return "[ " + value.map($634aa51198273feb$var$stringify).join(", ") + " ]";
    if (value instanceof Uint8Array) {
        const HEX = "0123456789abcdef";
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            result += HEX[value[i] >> 4];
            result += HEX[value[i] & 0xf];
        }
        return result;
    }
    if (typeof value === "object" && typeof value.toJSON === "function") return $634aa51198273feb$var$stringify(value.toJSON());
    switch(typeof value){
        case "boolean":
        case "symbol":
            return value.toString();
        case "bigint":
            return BigInt(value).toString();
        case "number":
            return value.toString();
        case "string":
            return JSON.stringify(value);
        case "object":
            {
                const keys = Object.keys(value);
                keys.sort();
                return "{ " + keys.map((k)=>`${$634aa51198273feb$var$stringify(k)}: ${$634aa51198273feb$var$stringify(value[k])}`).join(", ") + " }";
            }
    }
    return `[ COULD NOT SERIALIZE ]`;
}
function $634aa51198273feb$export$e6127cc7fe7395c3(error, code) {
    return error && error.code === code;
}
function $634aa51198273feb$export$748c4fa78f31ff35(error) {
    return $634aa51198273feb$export$e6127cc7fe7395c3(error, "CALL_EXCEPTION");
}
function $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info) {
    {
        const details = [];
        if (info) {
            if ("message" in info || "code" in info || "name" in info) throw new Error(`value will overwrite populated values: ${$634aa51198273feb$var$stringify(info)}`);
            for(const key in info){
                const value = info[key];
                //                try {
                details.push(key + "=" + $634aa51198273feb$var$stringify(value));
            //                } catch (error: any) {
            //                console.log("MMM", error.message);
            //                    details.push(key + "=[could not serialize object]");
            //                }
            }
        }
        details.push(`code=${code}`);
        details.push(`version=${(0, $9f7bf65ddafc81a6$export$83d89fbfd8236492)}`);
        if (details.length) message += " (" + details.join(", ") + ")";
    }
    let error;
    switch(code){
        case "INVALID_ARGUMENT":
            error = new TypeError(message);
            break;
        case "NUMERIC_FAULT":
        case "BUFFER_OVERRUN":
            error = new RangeError(message);
            break;
        default:
            error = new Error(message);
    }
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
        code: code
    });
    if (info) Object.assign(error, info);
    return error;
}
function $634aa51198273feb$export$a7a9523472993e97(check, message, code, info) {
    if (!check) throw $634aa51198273feb$export$5a4bb2b1c89bdce7(message, code, info);
}
function $634aa51198273feb$export$c3d31707e5030f5e(check, message, name, value) {
    $634aa51198273feb$export$a7a9523472993e97(check, message, "INVALID_ARGUMENT", {
        argument: name,
        value: value
    });
}
function $634aa51198273feb$export$d228410a8a77e4fa(count, expectedCount, message) {
    if (message == null) message = "";
    if (message) message = ": " + message;
    $634aa51198273feb$export$a7a9523472993e97(count >= expectedCount, "missing arguemnt" + message, "MISSING_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
    $634aa51198273feb$export$a7a9523472993e97(count <= expectedCount, "too many arguemnts" + message, "UNEXPECTED_ARGUMENT", {
        count: count,
        expectedCount: expectedCount
    });
}
const $634aa51198273feb$var$_normalizeForms = [
    "NFD",
    "NFC",
    "NFKD",
    "NFKC"
].reduce((accum, form)=>{
    try {
        // General test for normalize
        /* c8 ignore start */ if ("test".normalize(form) !== "test") throw new Error("bad");
        /* c8 ignore stop */ if (form === "NFD") {
            const check = String.fromCharCode(0xe9).normalize("NFD");
            const expected = String.fromCharCode(0x65, 0x0301);
            /* c8 ignore start */ if (check !== expected) throw new Error("broken");
        /* c8 ignore stop */ }
        accum.push(form);
    } catch (error) {}
    return accum;
}, []);
function $634aa51198273feb$export$d993e67fefdfecda(form) {
    $634aa51198273feb$export$a7a9523472993e97($634aa51198273feb$var$_normalizeForms.indexOf(form) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
        operation: "String.prototype.normalize",
        info: {
            form: form
        }
    });
}
function $634aa51198273feb$export$ac1a938d48ec8c7b(givenGuard, guard, className) {
    if (className == null) className = "";
    if (givenGuard !== guard) {
        let method = className, operation = "new";
        if (className) {
            method += ".";
            operation += " " + className;
        }
        $634aa51198273feb$export$a7a9523472993e97(false, `private constructor; use ${method}from* methods`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
}


function $15a6e7f1608663ad$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $15a6e7f1608663ad$var$anyGlobal = $15a6e7f1608663ad$var$getGlobal();
const $15a6e7f1608663ad$var$crypto = $15a6e7f1608663ad$var$anyGlobal.crypto || $15a6e7f1608663ad$var$anyGlobal.msCrypto;
function $15a6e7f1608663ad$export$2fb37efbf6ae0c0e(algo) {
    switch(algo){
        case "sha256":
            return (0, $510ad3657d73a9d2$exports.sha256).create();
        case "sha512":
            return (0, $2579977b4e52adba$exports.sha512).create();
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid hashing algorithm name", "algorithm", algo);
}
function $15a6e7f1608663ad$export$da39cf97e1eb7c91(_algo, key) {
    const algo = {
        sha256: $510ad3657d73a9d2$exports.sha256,
        sha512: $2579977b4e52adba$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid hmac algorithm", "algorithm", _algo);
    return (0, $51b6b372898f65c0$exports.hmac).create(algo, key);
}
function $15a6e7f1608663ad$export$b80c7ba289c8fa56(password, salt, iterations, keylen, _algo) {
    const algo = {
        sha256: $510ad3657d73a9d2$exports.sha256,
        sha512: $2579977b4e52adba$exports.sha512
    }[_algo];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(algo != null, "invalid pbkdf2 algorithm", "algorithm", _algo);
    return (0, $8c2f54a153cf1baf$exports.pbkdf2)(algo, password, salt, {
        c: iterations,
        dkLen: keylen
    });
}
function $15a6e7f1608663ad$export$5f828d93ff035aa8(length) {
    (0, $634aa51198273feb$export$a7a9523472993e97)($15a6e7f1608663ad$var$crypto != null, "platform does not support secure random numbers", "UNSUPPORTED_OPERATION", {
        operation: "randomBytes"
    });
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(length) && length > 0 && length <= 1024, "invalid length", "length", length);
    const result = new Uint8Array(length);
    $15a6e7f1608663ad$var$crypto.getRandomValues(result);
    return result;
}


/**
 *  Some data helpers.
 *
 *
 *  @_subsection api/utils:Data Helpers  [about-data]
 */ 
function $fd3872da8feed9cb$var$_getBytes(value, name, copy) {
    if (value instanceof Uint8Array) {
        if (copy) return new Uint8Array(value);
        return value;
    }
    if (typeof value === "string" && value.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
        const result = new Uint8Array((value.length - 2) / 2);
        let offset = 2;
        for(let i = 0; i < result.length; i++){
            result[i] = parseInt(value.substring(offset, offset + 2), 16);
            offset += 2;
        }
        return result;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BytesLike value", name || "value", value);
}
function $fd3872da8feed9cb$export$a3521add2594f3c8(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, false);
}
function $fd3872da8feed9cb$export$37110e7fee0af4ad(value, name) {
    return $fd3872da8feed9cb$var$_getBytes(value, name, true);
}
function $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length === "number" && value.length !== 2 + 2 * length) return false;
    if (length === true && value.length % 2 !== 0) return false;
    return true;
}
function $fd3872da8feed9cb$export$9a14abb1a440cd5e(value) {
    return $fd3872da8feed9cb$export$b02a40aff8e4ad18(value, true) || value instanceof Uint8Array;
}
const $fd3872da8feed9cb$var$HexCharacters = "0123456789abcdef";
function $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    let result = "0x";
    for(let i = 0; i < bytes.length; i++){
        const v = bytes[i];
        result += $fd3872da8feed9cb$var$HexCharacters[(v & 0xf0) >> 4] + $fd3872da8feed9cb$var$HexCharacters[v & 0x0f];
    }
    return result;
}
function $fd3872da8feed9cb$export$ee1b3e54f0441b22(datas) {
    return "0x" + datas.map((d)=>$fd3872da8feed9cb$export$2b0d6b5fbe698c70(d).substring(2)).join("");
}
function $fd3872da8feed9cb$export$2321cd91b99770ff(data) {
    if ($fd3872da8feed9cb$export$b02a40aff8e4ad18(data, true)) return (data.length - 2) / 2;
    return $fd3872da8feed9cb$export$a3521add2594f3c8(data).length;
}
function $fd3872da8feed9cb$export$f6d845ffb449edc9(data, start, end) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    if (end != null && end > bytes.length) (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: bytes.length,
        offset: end
    });
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(bytes.slice(start == null ? 0 : start, end == null ? bytes.length : end));
}
function $fd3872da8feed9cb$export$9c854001a22ebaa2(data) {
    let bytes = $fd3872da8feed9cb$export$2b0d6b5fbe698c70(data).substring(2);
    while(bytes.startsWith("00"))bytes = bytes.substring(2);
    return "0x" + bytes;
}
function $fd3872da8feed9cb$var$zeroPad(data, length, left) {
    const bytes = $fd3872da8feed9cb$export$a3521add2594f3c8(data);
    (0, $634aa51198273feb$export$a7a9523472993e97)(length >= bytes.length, "padding exceeds data length", "BUFFER_OVERRUN", {
        buffer: new Uint8Array(bytes),
        length: length,
        offset: length + 1
    });
    const result = new Uint8Array(length);
    result.fill(0);
    if (left) result.set(bytes, length - bytes.length);
    else result.set(bytes, 0);
    return $fd3872da8feed9cb$export$2b0d6b5fbe698c70(result);
}
function $fd3872da8feed9cb$export$4473860254365feb(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, true);
}
function $fd3872da8feed9cb$export$1dc7fbe1b8738fe7(data, length) {
    return $fd3872da8feed9cb$var$zeroPad(data, length, false);
}


let $be13a0f2e0d9ad05$var$locked = false;
const $be13a0f2e0d9ad05$var$_computeHmac = function(algorithm, key, data) {
    return (0, $15a6e7f1608663ad$export$da39cf97e1eb7c91)(algorithm, key).update(data).digest();
};
let $be13a0f2e0d9ad05$var$__computeHmac = $be13a0f2e0d9ad05$var$_computeHmac;
function $be13a0f2e0d9ad05$export$967075d2f3b8e7ff(algorithm, _key, _data) {
    const key = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_key, "key");
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($be13a0f2e0d9ad05$var$__computeHmac(algorithm, key, data));
}
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff._ = $be13a0f2e0d9ad05$var$_computeHmac;
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.lock = function() {
    $be13a0f2e0d9ad05$var$locked = true;
};
$be13a0f2e0d9ad05$export$967075d2f3b8e7ff.register = function(func) {
    if ($be13a0f2e0d9ad05$var$locked) throw new Error("computeHmac is locked");
    $be13a0f2e0d9ad05$var$__computeHmac = func;
};
Object.freeze($be13a0f2e0d9ad05$export$967075d2f3b8e7ff);


/**
 *  Cryptographic hashing functions
 *
 *  @_subsection: api/crypto:Hash Functions [about-crypto-hashing]
 */ var $08748f983f07956b$exports = {};
"use strict";
Object.defineProperty($08748f983f07956b$exports, "__esModule", {
    value: true
});
$08748f983f07956b$exports.shake256 = $08748f983f07956b$exports.shake128 = $08748f983f07956b$exports.keccak_512 = $08748f983f07956b$exports.keccak_384 = $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$exports.keccak_224 = $08748f983f07956b$exports.sha3_512 = $08748f983f07956b$exports.sha3_384 = $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$exports.sha3_224 = $08748f983f07956b$exports.Keccak = $08748f983f07956b$exports.keccakP = void 0;



// Various per round constants calculations
const [$08748f983f07956b$var$SHA3_PI, $08748f983f07956b$var$SHA3_ROTL, $08748f983f07956b$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $08748f983f07956b$var$_0n = BigInt(0);
const $08748f983f07956b$var$_1n = BigInt(1);
const $08748f983f07956b$var$_2n = BigInt(2);
const $08748f983f07956b$var$_7n = BigInt(7);
const $08748f983f07956b$var$_256n = BigInt(256);
const $08748f983f07956b$var$_0x71n = BigInt(0x71);
for(let round = 0, R = $08748f983f07956b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $08748f983f07956b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $08748f983f07956b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $08748f983f07956b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $08748f983f07956b$var$_1n ^ (R >> $08748f983f07956b$var$_7n) * $08748f983f07956b$var$_0x71n) % $08748f983f07956b$var$_256n;
        if (R & $08748f983f07956b$var$_2n) t ^= $08748f983f07956b$var$_1n << ($08748f983f07956b$var$_1n << BigInt(j)) - $08748f983f07956b$var$_1n;
    }
    $08748f983f07956b$var$_SHA3_IOTA.push(t);
}
const [$08748f983f07956b$var$SHA3_IOTA_H, $08748f983f07956b$var$SHA3_IOTA_L] = $aa71b30d36adb919$exports.default.split($08748f983f07956b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $08748f983f07956b$var$rotlH = (h, l, s)=>s > 32 ? $aa71b30d36adb919$exports.default.rotlBH(h, l, s) : $aa71b30d36adb919$exports.default.rotlSH(h, l, s);
const $08748f983f07956b$var$rotlL = (h, l, s)=>s > 32 ? $aa71b30d36adb919$exports.default.rotlBL(h, l, s) : $aa71b30d36adb919$exports.default.rotlSL(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $08748f983f07956b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $08748f983f07956b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $08748f983f07956b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $08748f983f07956b$var$SHA3_ROTL[t];
            const Th = $08748f983f07956b$var$rotlH(curH, curL, shift);
            const Tl = $08748f983f07956b$var$rotlL(curH, curL, shift);
            const PI = $08748f983f07956b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $08748f983f07956b$var$SHA3_IOTA_H[round];
        s[1] ^= $08748f983f07956b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
$08748f983f07956b$exports.keccakP = $08748f983f07956b$var$keccakP;
class $08748f983f07956b$var$Keccak extends $29ee4d3171d9809b$exports.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        $a0ae23f5901291b4$exports.default.number(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $29ee4d3171d9809b$exports.u32)(this.state);
    }
    keccak() {
        $08748f983f07956b$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        $a0ae23f5901291b4$exports.default.exists(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $29ee4d3171d9809b$exports.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        $a0ae23f5901291b4$exports.default.exists(this, false);
        $a0ae23f5901291b4$exports.default.bytes(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        $a0ae23f5901291b4$exports.default.number(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        $a0ae23f5901291b4$exports.default.output(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
$08748f983f07956b$exports.Keccak = $08748f983f07956b$var$Keccak;
const $08748f983f07956b$var$gen = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $08748f983f07956b$var$Keccak(blockLen, suffix, outputLen));
$08748f983f07956b$exports.sha3_224 = $08748f983f07956b$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ $08748f983f07956b$exports.sha3_256 = $08748f983f07956b$var$gen(0x06, 136, 32);
$08748f983f07956b$exports.sha3_384 = $08748f983f07956b$var$gen(0x06, 104, 48);
$08748f983f07956b$exports.sha3_512 = $08748f983f07956b$var$gen(0x06, 72, 64);
$08748f983f07956b$exports.keccak_224 = $08748f983f07956b$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ $08748f983f07956b$exports.keccak_256 = $08748f983f07956b$var$gen(0x01, 136, 32);
$08748f983f07956b$exports.keccak_384 = $08748f983f07956b$var$gen(0x01, 104, 48);
$08748f983f07956b$exports.keccak_512 = $08748f983f07956b$var$gen(0x01, 72, 64);
const $08748f983f07956b$var$genShake = (suffix, blockLen, outputLen)=>(0, $29ee4d3171d9809b$exports.wrapConstructorWithOpts)((opts = {})=>new $08748f983f07956b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
$08748f983f07956b$exports.shake128 = $08748f983f07956b$var$genShake(0x1f, 168, 16);
$08748f983f07956b$exports.shake256 = $08748f983f07956b$var$genShake(0x1f, 136, 32);



let $9bdec2813ce7c52b$var$locked = false;
const $9bdec2813ce7c52b$var$_keccak256 = function(data) {
    return (0, $08748f983f07956b$exports.keccak_256)(data);
};
let $9bdec2813ce7c52b$var$__keccak256 = $9bdec2813ce7c52b$var$_keccak256;
function $9bdec2813ce7c52b$export$f8151fce47ad1c35(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9bdec2813ce7c52b$var$__keccak256(data));
}
$9bdec2813ce7c52b$export$f8151fce47ad1c35._ = $9bdec2813ce7c52b$var$_keccak256;
$9bdec2813ce7c52b$export$f8151fce47ad1c35.lock = function() {
    $9bdec2813ce7c52b$var$locked = true;
};
$9bdec2813ce7c52b$export$f8151fce47ad1c35.register = function(func) {
    if ($9bdec2813ce7c52b$var$locked) throw new TypeError("keccak256 is locked");
    $9bdec2813ce7c52b$var$__keccak256 = func;
};
Object.freeze($9bdec2813ce7c52b$export$f8151fce47ad1c35);


var $de58877bbb165fd5$exports = {};
"use strict";
Object.defineProperty($de58877bbb165fd5$exports, "__esModule", {
    value: true
});
$de58877bbb165fd5$exports.ripemd160 = $de58877bbb165fd5$exports.RIPEMD160 = void 0;


// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $de58877bbb165fd5$var$Rho = new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $de58877bbb165fd5$var$Pi = $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $de58877bbb165fd5$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$BUF = new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $bc3a993d7d38a7a0$exports.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $de58877bbb165fd5$var$rotl(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $de58877bbb165fd5$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $de58877bbb165fd5$var$rotl(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $de58877bbb165fd5$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
$de58877bbb165fd5$exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ $de58877bbb165fd5$exports.ripemd160 = (0, $29ee4d3171d9809b$exports.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());



let $76bdf8351c5898c8$var$locked = false;
const $76bdf8351c5898c8$var$_ripemd160 = function(data) {
    return (0, $de58877bbb165fd5$exports.ripemd160)(data);
};
let $76bdf8351c5898c8$var$__ripemd160 = $76bdf8351c5898c8$var$_ripemd160;
function $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($76bdf8351c5898c8$var$__ripemd160(data));
}
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e._ = $76bdf8351c5898c8$var$_ripemd160;
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.lock = function() {
    $76bdf8351c5898c8$var$locked = true;
};
$76bdf8351c5898c8$export$d1cea0ee4e3f0d3e.register = function(func) {
    if ($76bdf8351c5898c8$var$locked) throw new TypeError("ripemd160 is locked");
    $76bdf8351c5898c8$var$__ripemd160 = func;
};
Object.freeze($76bdf8351c5898c8$export$d1cea0ee4e3f0d3e);


/**
 *  A **Password-Based Key-Derivation Function** is designed to create
 *  a sequence of bytes suitible as a **key** from a human-rememberable
 *  password.
 *
 *  @_subsection: api/crypto:Passwords  [about-pbkdf]
 */ 

let $9092348e8cf65603$var$locked = false;
const $9092348e8cf65603$var$_pbkdf2 = function(password, salt, iterations, keylen, algo) {
    return (0, $15a6e7f1608663ad$export$b80c7ba289c8fa56)(password, salt, iterations, keylen, algo);
};
let $9092348e8cf65603$var$__pbkdf2 = $9092348e8cf65603$var$_pbkdf2;
function $9092348e8cf65603$export$448fa22aedc9dbca(_password, _salt, iterations, keylen, algo) {
    const password = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_password, "password");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($9092348e8cf65603$var$__pbkdf2(password, salt, iterations, keylen, algo));
}
$9092348e8cf65603$export$448fa22aedc9dbca._ = $9092348e8cf65603$var$_pbkdf2;
$9092348e8cf65603$export$448fa22aedc9dbca.lock = function() {
    $9092348e8cf65603$var$locked = true;
};
$9092348e8cf65603$export$448fa22aedc9dbca.register = function(func) {
    if ($9092348e8cf65603$var$locked) throw new Error("pbkdf2 is locked");
    $9092348e8cf65603$var$__pbkdf2 = func;
};
Object.freeze($9092348e8cf65603$export$448fa22aedc9dbca);


/**
 *  A **Cryptographically Secure Random Value** is one that has been
 *  generated with additional care take to prevent side-channels
 *  from allowing others to detect it and prevent others from through
 *  coincidence generate the same values.
 *
 *  @_subsection: api/crypto:Random Values  [about-crypto-random]
 */ 
let $90bc03290273a6e1$var$locked = false;
const $90bc03290273a6e1$var$_randomBytes = function(length) {
    return new Uint8Array((0, $15a6e7f1608663ad$export$5f828d93ff035aa8)(length));
};
let $90bc03290273a6e1$var$__randomBytes = $90bc03290273a6e1$var$_randomBytes;
function $90bc03290273a6e1$export$5f828d93ff035aa8(length) {
    return $90bc03290273a6e1$var$__randomBytes(length);
}
$90bc03290273a6e1$export$5f828d93ff035aa8._ = $90bc03290273a6e1$var$_randomBytes;
$90bc03290273a6e1$export$5f828d93ff035aa8.lock = function() {
    $90bc03290273a6e1$var$locked = true;
};
$90bc03290273a6e1$export$5f828d93ff035aa8.register = function(func) {
    if ($90bc03290273a6e1$var$locked) throw new Error("randomBytes is locked");
    $90bc03290273a6e1$var$__randomBytes = func;
};
Object.freeze($90bc03290273a6e1$export$5f828d93ff035aa8);


var $dd94f1d283dd7b2d$exports = {};
"use strict";
Object.defineProperty($dd94f1d283dd7b2d$exports, "__esModule", {
    value: true
});
$dd94f1d283dd7b2d$exports.scryptAsync = $dd94f1d283dd7b2d$exports.scrypt = void 0;




// RFC 7914 Scrypt KDF
// Left rotate for uint32
const $dd94f1d283dd7b2d$var$rotl = (a, b)=>a << b | a >>> 32 - b;
// The main Scrypt loop: uses Salsa extensively.
// Six versions of the function were tried, this is the fastest one.
// prettier-ignore
function $dd94f1d283dd7b2d$var$XorAndSalsa(prev, pi, input, ii, out, oi) {
    // Based on https://cr.yp.to/salsa20.html
    // Xor blocks
    let y00 = prev[pi++] ^ input[ii++], y01 = prev[pi++] ^ input[ii++];
    let y02 = prev[pi++] ^ input[ii++], y03 = prev[pi++] ^ input[ii++];
    let y04 = prev[pi++] ^ input[ii++], y05 = prev[pi++] ^ input[ii++];
    let y06 = prev[pi++] ^ input[ii++], y07 = prev[pi++] ^ input[ii++];
    let y08 = prev[pi++] ^ input[ii++], y09 = prev[pi++] ^ input[ii++];
    let y10 = prev[pi++] ^ input[ii++], y11 = prev[pi++] ^ input[ii++];
    let y12 = prev[pi++] ^ input[ii++], y13 = prev[pi++] ^ input[ii++];
    let y14 = prev[pi++] ^ input[ii++], y15 = prev[pi++] ^ input[ii++];
    // Save state to temporary variables (salsa)
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    // Main loop (salsa)
    for(let i = 0; i < 8; i += 2){
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x12 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x00 | 0, 9);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x04 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x08 | 0, 18);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x01 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x05 | 0, 9);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x09 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x13 | 0, 18);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x06 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x10 | 0, 9);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x14 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x02 | 0, 18);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x11 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x15 | 0, 9);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x03 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x07 | 0, 18);
        x01 ^= $dd94f1d283dd7b2d$var$rotl(x00 + x03 | 0, 7);
        x02 ^= $dd94f1d283dd7b2d$var$rotl(x01 + x00 | 0, 9);
        x03 ^= $dd94f1d283dd7b2d$var$rotl(x02 + x01 | 0, 13);
        x00 ^= $dd94f1d283dd7b2d$var$rotl(x03 + x02 | 0, 18);
        x06 ^= $dd94f1d283dd7b2d$var$rotl(x05 + x04 | 0, 7);
        x07 ^= $dd94f1d283dd7b2d$var$rotl(x06 + x05 | 0, 9);
        x04 ^= $dd94f1d283dd7b2d$var$rotl(x07 + x06 | 0, 13);
        x05 ^= $dd94f1d283dd7b2d$var$rotl(x04 + x07 | 0, 18);
        x11 ^= $dd94f1d283dd7b2d$var$rotl(x10 + x09 | 0, 7);
        x08 ^= $dd94f1d283dd7b2d$var$rotl(x11 + x10 | 0, 9);
        x09 ^= $dd94f1d283dd7b2d$var$rotl(x08 + x11 | 0, 13);
        x10 ^= $dd94f1d283dd7b2d$var$rotl(x09 + x08 | 0, 18);
        x12 ^= $dd94f1d283dd7b2d$var$rotl(x15 + x14 | 0, 7);
        x13 ^= $dd94f1d283dd7b2d$var$rotl(x12 + x15 | 0, 9);
        x14 ^= $dd94f1d283dd7b2d$var$rotl(x13 + x12 | 0, 13);
        x15 ^= $dd94f1d283dd7b2d$var$rotl(x14 + x13 | 0, 18);
    }
    // Write output (salsa)
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $dd94f1d283dd7b2d$var$BlockMix(input, ii, out, oi, r) {
    // The block B is r 128-byte chunks (which is equivalent of 2r 64-byte chunks)
    let head = oi + 0;
    let tail = oi + 16 * r;
    for(let i = 0; i < 16; i++)out[tail + i] = input[ii + (2 * r - 1) * 16 + i]; // X ← B[2r−1]
    for(let i = 0; i < r; i++, head += 16, ii += 16){
        // We write odd & even Yi at same time. Even: 0bXXXXX0 Odd:  0bXXXXX1
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, tail, input, ii, out, head); // head[i] = Salsa(blockIn[2*i] ^ tail[i-1])
        if (i > 0) tail += 16; // First iteration overwrites tmp value in tail
        $dd94f1d283dd7b2d$var$XorAndSalsa(out, head, input, ii += 16, out, tail); // tail[i] = Salsa(blockIn[2*i+1] ^ head[i])
    }
}
// Common prologue and epilogue for sync/async functions
function $dd94f1d283dd7b2d$var$scryptInit(password, salt, _opts) {
    // Maxmem - 1GB+1KB by default
    const opts = (0, $29ee4d3171d9809b$exports.checkOpts)({
        dkLen: 32,
        asyncTick: 10,
        maxmem: 1024 ** 3 + 1024
    }, _opts);
    const { N: N, r: r, p: p, dkLen: dkLen, asyncTick: asyncTick, maxmem: maxmem, onProgress: onProgress } = opts;
    $a0ae23f5901291b4$exports.default.number(N);
    $a0ae23f5901291b4$exports.default.number(r);
    $a0ae23f5901291b4$exports.default.number(p);
    $a0ae23f5901291b4$exports.default.number(dkLen);
    $a0ae23f5901291b4$exports.default.number(asyncTick);
    $a0ae23f5901291b4$exports.default.number(maxmem);
    if (onProgress !== undefined && typeof onProgress !== "function") throw new Error("progressCb should be function");
    const blockSize = 128 * r;
    const blockSize32 = blockSize / 4;
    if (N <= 1 || (N & N - 1) !== 0 || N >= 2 ** (blockSize / 8) || N > 2 ** 32) // NOTE: we limit N to be less than 2**32 because of 32 bit variant of Integrify function
    // There is no JS engines that allows alocate more than 4GB per single Uint8Array for now, but can change in future.
    throw new Error("Scrypt: N must be larger than 1, a power of 2, less than 2^(128 * r / 8) and less than 2^32");
    if (p < 0 || p > (2 ** 32 - 1) * 32 / blockSize) throw new Error("Scrypt: p must be a positive integer less than or equal to ((2^32 - 1) * 32) / (128 * r)");
    if (dkLen < 0 || dkLen > (2 ** 32 - 1) * 32) throw new Error("Scrypt: dkLen should be positive integer less than or equal to (2^32 - 1) * 32");
    const memUsed = blockSize * (N + p);
    if (memUsed > maxmem) throw new Error(`Scrypt: parameters too large, ${memUsed} (128 * r * (N + p)) > ${maxmem} (maxmem)`);
    // [B0...Bp−1] ← PBKDF2HMAC-SHA256(Passphrase, Salt, 1, blockSize*ParallelizationFactor)
    // Since it has only one iteration there is no reason to use async variant
    const B = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, salt, {
        c: 1,
        dkLen: blockSize * p
    });
    const B32 = (0, $29ee4d3171d9809b$exports.u32)(B);
    // Re-used between parallel iterations. Array(iterations) of B
    const V = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize * N));
    const tmp = (0, $29ee4d3171d9809b$exports.u32)(new Uint8Array(blockSize));
    let blockMixCb = ()=>{};
    if (onProgress) {
        const totalBlockMix = 2 * N * p;
        // Invoke callback if progress changes from 10.01 to 10.02
        // Allows to draw smooth progress bar on up to 8K screen
        const callbackPer = Math.max(Math.floor(totalBlockMix / 10000), 1);
        let blockMixCnt = 0;
        blockMixCb = ()=>{
            blockMixCnt++;
            if (onProgress && (!(blockMixCnt % callbackPer) || blockMixCnt === totalBlockMix)) onProgress(blockMixCnt / totalBlockMix);
        };
    }
    return {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        blockSize32: blockSize32,
        V: V,
        B32: B32,
        B: B,
        tmp: tmp,
        blockMixCb: blockMixCb,
        asyncTick: asyncTick
    };
}
function $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp) {
    const res = (0, $8c2f54a153cf1baf$exports.pbkdf2)($510ad3657d73a9d2$exports.sha256, password, B, {
        c: 1,
        dkLen: dkLen
    });
    B.fill(0);
    V.fill(0);
    tmp.fill(0);
    return res;
}
/**
 * Scrypt KDF from RFC 7914.
 * @param password - pass
 * @param salt - salt
 * @param opts - parameters
 * - `N` is cpu/mem work factor (power of 2 e.g. 2**18)
 * - `r` is block size (8 is common), fine-tunes sequential memory read size and performance
 * - `p` is parallelization factor (1 is common)
 * - `dkLen` is output key length in bytes e.g. 32.
 * - `asyncTick` - (default: 10) max time in ms for which async function can block execution
 * - `maxmem` - (default: `1024 ** 3 + 1024` aka 1GB+1KB). A limit that the app could use for scrypt
 * - `onProgress` - callback function that would be executed for progress report
 * @returns Derived key
 */ function $dd94f1d283dd7b2d$var$scrypt(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        for(let i = 0, pos = 0; i < N - 1; i++){
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        }
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        for(let i = 0; i < N; i++){
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        }
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
$dd94f1d283dd7b2d$exports.scrypt = $dd94f1d283dd7b2d$var$scrypt;
/**
 * Scrypt KDF from RFC 7914.
 */ async function $dd94f1d283dd7b2d$var$scryptAsync(password, salt, opts) {
    const { N: N, r: r, p: p, dkLen: dkLen, blockSize32: blockSize32, V: V, B32: B32, B: B, tmp: tmp, blockMixCb: blockMixCb, asyncTick: asyncTick } = $dd94f1d283dd7b2d$var$scryptInit(password, salt, opts);
    for(let pi = 0; pi < p; pi++){
        const Pi = blockSize32 * pi;
        for(let i = 0; i < blockSize32; i++)V[i] = B32[Pi + i]; // V[0] = B[i]
        let pos = 0;
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N - 1, asyncTick, (i)=>{
            $dd94f1d283dd7b2d$var$BlockMix(V, pos, V, pos += blockSize32, r); // V[i] = BlockMix(V[i-1]);
            blockMixCb();
        });
        $dd94f1d283dd7b2d$var$BlockMix(V, (N - 1) * blockSize32, B32, Pi, r); // Process last element
        blockMixCb();
        await (0, $29ee4d3171d9809b$exports.asyncLoop)(N, asyncTick, (i)=>{
            // First u32 of the last 64-byte block (u32 is LE)
            const j = B32[Pi + blockSize32 - 16] % N; // j = Integrify(X) % iterations
            for(let k = 0; k < blockSize32; k++)tmp[k] = B32[Pi + k] ^ V[j * blockSize32 + k]; // tmp = B ^ V[j]
            $dd94f1d283dd7b2d$var$BlockMix(tmp, 0, B32, Pi, r); // B = BlockMix(B ^ V[j])
            blockMixCb();
        });
    }
    return $dd94f1d283dd7b2d$var$scryptOutput(password, dkLen, B, V, tmp);
}
$dd94f1d283dd7b2d$exports.scryptAsync = $dd94f1d283dd7b2d$var$scryptAsync;



let $e794241b1cb9b0d3$var$lockedSync = false, $e794241b1cb9b0d3$var$lockedAsync = false;
const $e794241b1cb9b0d3$var$_scryptAsync = async function(passwd, salt, N, r, p, dkLen, onProgress) {
    return await (0, $dd94f1d283dd7b2d$exports.scryptAsync)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen,
        onProgress: onProgress
    });
};
const $e794241b1cb9b0d3$var$_scryptSync = function(passwd, salt, N, r, p, dkLen) {
    return (0, $dd94f1d283dd7b2d$exports.scrypt)(passwd, salt, {
        N: N,
        r: r,
        p: p,
        dkLen: dkLen
    });
};
let $e794241b1cb9b0d3$var$__scryptAsync = $e794241b1cb9b0d3$var$_scryptAsync;
let $e794241b1cb9b0d3$var$__scryptSync = $e794241b1cb9b0d3$var$_scryptSync;
async function $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3(_passwd, _salt, N, r, p, dkLen, progress) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await $e794241b1cb9b0d3$var$__scryptAsync(passwd, salt, N, r, p, dkLen, progress));
}
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3._ = $e794241b1cb9b0d3$var$_scryptAsync;
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.lock = function() {
    $e794241b1cb9b0d3$var$lockedAsync = true;
};
$e794241b1cb9b0d3$export$7cf7c2f1ec457bf3.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedAsync) throw new Error("scrypt is locked");
    $e794241b1cb9b0d3$var$__scryptAsync = func;
};
Object.freeze($e794241b1cb9b0d3$export$7cf7c2f1ec457bf3);
function $e794241b1cb9b0d3$export$86c79e0734c26a76(_passwd, _salt, N, r, p, dkLen) {
    const passwd = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_passwd, "passwd");
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($e794241b1cb9b0d3$var$__scryptSync(passwd, salt, N, r, p, dkLen));
}
$e794241b1cb9b0d3$export$86c79e0734c26a76._ = $e794241b1cb9b0d3$var$_scryptSync;
$e794241b1cb9b0d3$export$86c79e0734c26a76.lock = function() {
    $e794241b1cb9b0d3$var$lockedSync = true;
};
$e794241b1cb9b0d3$export$86c79e0734c26a76.register = function(func) {
    if ($e794241b1cb9b0d3$var$lockedSync) throw new Error("scryptSync is locked");
    $e794241b1cb9b0d3$var$__scryptSync = func;
};
Object.freeze($e794241b1cb9b0d3$export$86c79e0734c26a76);




const $c1049352abb4e7c6$var$_sha256 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha256").update(data).digest();
};
const $c1049352abb4e7c6$var$_sha512 = function(data) {
    return (0, $15a6e7f1608663ad$export$2fb37efbf6ae0c0e)("sha512").update(data).digest();
};
let $c1049352abb4e7c6$var$__sha256 = $c1049352abb4e7c6$var$_sha256;
let $c1049352abb4e7c6$var$__sha512 = $c1049352abb4e7c6$var$_sha512;
let $c1049352abb4e7c6$var$locked256 = false, $c1049352abb4e7c6$var$locked512 = false;
function $c1049352abb4e7c6$export$bced8d2aada2d1c9(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha256(data));
}
$c1049352abb4e7c6$export$bced8d2aada2d1c9._ = $c1049352abb4e7c6$var$_sha256;
$c1049352abb4e7c6$export$bced8d2aada2d1c9.lock = function() {
    $c1049352abb4e7c6$var$locked256 = true;
};
$c1049352abb4e7c6$export$bced8d2aada2d1c9.register = function(func) {
    if ($c1049352abb4e7c6$var$locked256) throw new Error("sha256 is locked");
    $c1049352abb4e7c6$var$__sha256 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);
function $c1049352abb4e7c6$export$a888d2532e6dc7bb(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($c1049352abb4e7c6$var$__sha512(data));
}
$c1049352abb4e7c6$export$a888d2532e6dc7bb._ = $c1049352abb4e7c6$var$_sha512;
$c1049352abb4e7c6$export$a888d2532e6dc7bb.lock = function() {
    $c1049352abb4e7c6$var$locked512 = true;
};
$c1049352abb4e7c6$export$a888d2532e6dc7bb.register = function(func) {
    if ($c1049352abb4e7c6$var$locked512) throw new Error("sha512 is locked");
    $c1049352abb4e7c6$var$__sha512 = func;
};
Object.freeze($c1049352abb4e7c6$export$bced8d2aada2d1c9);


/**
 *  Add details about signing here.
 *
 *  @_subsection: api/crypto:Signing  [about-signing]
 */ /*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */ 
var $kjyEk = parcelRequire("kjyEk");
const $5b8ab42334210395$var$_0n = BigInt(0);
const $5b8ab42334210395$var$_1n = BigInt(1);
const $5b8ab42334210395$var$_2n = BigInt(2);
const $5b8ab42334210395$var$_3n = BigInt(3);
const $5b8ab42334210395$var$_8n = BigInt(8);
const $5b8ab42334210395$export$8ff8607b70325343 = Object.freeze({
    a: $5b8ab42334210395$var$_0n,
    b: BigInt(7),
    P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
    n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
    h: $5b8ab42334210395$var$_1n,
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
});
const $5b8ab42334210395$var$divNearest = (a, b)=>(a + b / $5b8ab42334210395$var$_2n) / b;
const $5b8ab42334210395$var$endo = {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar (k) {
        const { n: n } = $5b8ab42334210395$export$8ff8607b70325343;
        const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
        const b1 = -$5b8ab42334210395$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
        const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
        const b2 = a1;
        const POW_2_128 = BigInt("0x100000000000000000000000000000000");
        const c1 = $5b8ab42334210395$var$divNearest(b2 * k, n);
        const c2 = $5b8ab42334210395$var$divNearest(-b1 * k, n);
        let k1 = $5b8ab42334210395$var$mod(k - c1 * a1 - c2 * a2, n);
        let k2 = $5b8ab42334210395$var$mod(-c1 * b1 - c2 * b2, n);
        const k1neg = k1 > POW_2_128;
        const k2neg = k2 > POW_2_128;
        if (k1neg) k1 = n - k1;
        if (k2neg) k2 = n - k2;
        if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalarEndo: Endomorphism failed, k=" + k);
        return {
            k1neg: k1neg,
            k1: k1,
            k2neg: k2neg,
            k2: k2
        };
    }
};
const $5b8ab42334210395$var$fieldLen = 32;
const $5b8ab42334210395$var$groupLen = 32;
const $5b8ab42334210395$var$hashLen = 32;
const $5b8ab42334210395$var$compressedLen = $5b8ab42334210395$var$fieldLen + 1;
const $5b8ab42334210395$var$uncompressedLen = 2 * $5b8ab42334210395$var$fieldLen + 1;
function $5b8ab42334210395$var$weierstrass(x) {
    const { a: a, b: b } = $5b8ab42334210395$export$8ff8607b70325343;
    const x2 = $5b8ab42334210395$var$mod(x * x);
    const x3 = $5b8ab42334210395$var$mod(x2 * x);
    return $5b8ab42334210395$var$mod(x3 + a * x + b);
}
const $5b8ab42334210395$var$USE_ENDOMORPHISM = $5b8ab42334210395$export$8ff8607b70325343.a === $5b8ab42334210395$var$_0n;
class $5b8ab42334210395$var$ShaError extends Error {
    constructor(message){
        super(message);
    }
}
function $5b8ab42334210395$var$assertJacPoint(other) {
    if (!(other instanceof $5b8ab42334210395$var$JacobianPoint)) throw new TypeError("JacobianPoint expected");
}
class $5b8ab42334210395$var$JacobianPoint {
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static fromAffine(p) {
        if (!(p instanceof $5b8ab42334210395$export$baf26146a414f24a)) throw new TypeError("JacobianPoint#fromAffine: expected Point");
        if (p.equals($5b8ab42334210395$export$baf26146a414f24a.ZERO)) return $5b8ab42334210395$var$JacobianPoint.ZERO;
        return new $5b8ab42334210395$var$JacobianPoint(p.x, p.y, $5b8ab42334210395$var$_1n);
    }
    static toAffineBatch(points) {
        const toInv = $5b8ab42334210395$var$invertBatch(points.map((p)=>p.z));
        return points.map((p, i)=>p.toAffine(toInv[i]));
    }
    static normalizeZ(points) {
        return $5b8ab42334210395$var$JacobianPoint.toAffineBatch(points).map($5b8ab42334210395$var$JacobianPoint.fromAffine);
    }
    equals(other) {
        $5b8ab42334210395$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        const Z1Z1 = $5b8ab42334210395$var$mod(Z1 * Z1);
        const Z2Z2 = $5b8ab42334210395$var$mod(Z2 * Z2);
        const U1 = $5b8ab42334210395$var$mod(X1 * Z2Z2);
        const U2 = $5b8ab42334210395$var$mod(X2 * Z1Z1);
        const S1 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$mod(Y2 * Z1) * Z1Z1);
        return U1 === U2 && S1 === S2;
    }
    negate() {
        return new $5b8ab42334210395$var$JacobianPoint(this.x, $5b8ab42334210395$var$mod(-this.y), this.z);
    }
    double() {
        const { x: X1, y: Y1, z: Z1 } = this;
        const A = $5b8ab42334210395$var$mod(X1 * X1);
        const B = $5b8ab42334210395$var$mod(Y1 * Y1);
        const C = $5b8ab42334210395$var$mod(B * B);
        const x1b = X1 + B;
        const D = $5b8ab42334210395$var$mod($5b8ab42334210395$var$_2n * ($5b8ab42334210395$var$mod(x1b * x1b) - A - C));
        const E = $5b8ab42334210395$var$mod($5b8ab42334210395$var$_3n * A);
        const F = $5b8ab42334210395$var$mod(E * E);
        const X3 = $5b8ab42334210395$var$mod(F - $5b8ab42334210395$var$_2n * D);
        const Y3 = $5b8ab42334210395$var$mod(E * (D - X3) - $5b8ab42334210395$var$_8n * C);
        const Z3 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$_2n * Y1 * Z1);
        return new $5b8ab42334210395$var$JacobianPoint(X3, Y3, Z3);
    }
    add(other) {
        $5b8ab42334210395$var$assertJacPoint(other);
        const { x: X1, y: Y1, z: Z1 } = this;
        const { x: X2, y: Y2, z: Z2 } = other;
        if (X2 === $5b8ab42334210395$var$_0n || Y2 === $5b8ab42334210395$var$_0n) return this;
        if (X1 === $5b8ab42334210395$var$_0n || Y1 === $5b8ab42334210395$var$_0n) return other;
        const Z1Z1 = $5b8ab42334210395$var$mod(Z1 * Z1);
        const Z2Z2 = $5b8ab42334210395$var$mod(Z2 * Z2);
        const U1 = $5b8ab42334210395$var$mod(X1 * Z2Z2);
        const U2 = $5b8ab42334210395$var$mod(X2 * Z1Z1);
        const S1 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$mod(Y1 * Z2) * Z2Z2);
        const S2 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$mod(Y2 * Z1) * Z1Z1);
        const H = $5b8ab42334210395$var$mod(U2 - U1);
        const r = $5b8ab42334210395$var$mod(S2 - S1);
        if (H === $5b8ab42334210395$var$_0n) {
            if (r === $5b8ab42334210395$var$_0n) return this.double();
            else return $5b8ab42334210395$var$JacobianPoint.ZERO;
        }
        const HH = $5b8ab42334210395$var$mod(H * H);
        const HHH = $5b8ab42334210395$var$mod(H * HH);
        const V = $5b8ab42334210395$var$mod(U1 * HH);
        const X3 = $5b8ab42334210395$var$mod(r * r - HHH - $5b8ab42334210395$var$_2n * V);
        const Y3 = $5b8ab42334210395$var$mod(r * (V - X3) - S1 * HHH);
        const Z3 = $5b8ab42334210395$var$mod(Z1 * Z2 * H);
        return new $5b8ab42334210395$var$JacobianPoint(X3, Y3, Z3);
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiplyUnsafe(scalar) {
        const P0 = $5b8ab42334210395$var$JacobianPoint.ZERO;
        if (typeof scalar === "bigint" && scalar === $5b8ab42334210395$var$_0n) return P0;
        let n = $5b8ab42334210395$var$normalizeScalar(scalar);
        if (n === $5b8ab42334210395$var$_1n) return this;
        if (!$5b8ab42334210395$var$USE_ENDOMORPHISM) {
            let p = P0;
            let d = this;
            while(n > $5b8ab42334210395$var$_0n){
                if (n & $5b8ab42334210395$var$_1n) p = p.add(d);
                d = d.double();
                n >>= $5b8ab42334210395$var$_1n;
            }
            return p;
        }
        let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $5b8ab42334210395$var$endo.splitScalar(n);
        let k1p = P0;
        let k2p = P0;
        let d = this;
        while(k1 > $5b8ab42334210395$var$_0n || k2 > $5b8ab42334210395$var$_0n){
            if (k1 & $5b8ab42334210395$var$_1n) k1p = k1p.add(d);
            if (k2 & $5b8ab42334210395$var$_1n) k2p = k2p.add(d);
            d = d.double();
            k1 >>= $5b8ab42334210395$var$_1n;
            k2 >>= $5b8ab42334210395$var$_1n;
        }
        if (k1neg) k1p = k1p.negate();
        if (k2neg) k2p = k2p.negate();
        k2p = new $5b8ab42334210395$var$JacobianPoint($5b8ab42334210395$var$mod(k2p.x * $5b8ab42334210395$var$endo.beta), k2p.y, k2p.z);
        return k1p.add(k2p);
    }
    precomputeWindow(W) {
        const windows = $5b8ab42334210395$var$USE_ENDOMORPHISM ? 128 / W + 1 : 256 / W + 1;
        const points = [];
        let p = this;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            for(let i = 1; i < 2 ** (W - 1); i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    wNAF(n, affinePoint) {
        if (!affinePoint && this.equals($5b8ab42334210395$var$JacobianPoint.BASE)) affinePoint = $5b8ab42334210395$export$baf26146a414f24a.BASE;
        const W = affinePoint && affinePoint._WINDOW_SIZE || 1;
        if (256 % W) throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
        let precomputes = affinePoint && $5b8ab42334210395$var$pointPrecomputes.get(affinePoint);
        if (!precomputes) {
            precomputes = this.precomputeWindow(W);
            if (affinePoint && W !== 1) {
                precomputes = $5b8ab42334210395$var$JacobianPoint.normalizeZ(precomputes);
                $5b8ab42334210395$var$pointPrecomputes.set(affinePoint, precomputes);
            }
        }
        let p = $5b8ab42334210395$var$JacobianPoint.ZERO;
        let f = $5b8ab42334210395$var$JacobianPoint.BASE;
        const windows = 1 + ($5b8ab42334210395$var$USE_ENDOMORPHISM ? 128 / W : 256 / W);
        const windowSize = 2 ** (W - 1);
        const mask = BigInt(2 ** W - 1);
        const maxNumber = 2 ** W;
        const shiftBy = BigInt(W);
        for(let window = 0; window < windows; window++){
            const offset = window * windowSize;
            let wbits = Number(n & mask);
            n >>= shiftBy;
            if (wbits > windowSize) {
                wbits -= maxNumber;
                n += $5b8ab42334210395$var$_1n;
            }
            const offset1 = offset;
            const offset2 = offset + Math.abs(wbits) - 1;
            const cond1 = window % 2 !== 0;
            const cond2 = wbits < 0;
            if (wbits === 0) f = f.add($5b8ab42334210395$var$constTimeNegate(cond1, precomputes[offset1]));
            else p = p.add($5b8ab42334210395$var$constTimeNegate(cond2, precomputes[offset2]));
        }
        return {
            p: p,
            f: f
        };
    }
    multiply(scalar, affinePoint) {
        let n = $5b8ab42334210395$var$normalizeScalar(scalar);
        let point;
        let fake;
        if ($5b8ab42334210395$var$USE_ENDOMORPHISM) {
            const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = $5b8ab42334210395$var$endo.splitScalar(n);
            let { p: k1p, f: f1p } = this.wNAF(k1, affinePoint);
            let { p: k2p, f: f2p } = this.wNAF(k2, affinePoint);
            k1p = $5b8ab42334210395$var$constTimeNegate(k1neg, k1p);
            k2p = $5b8ab42334210395$var$constTimeNegate(k2neg, k2p);
            k2p = new $5b8ab42334210395$var$JacobianPoint($5b8ab42334210395$var$mod(k2p.x * $5b8ab42334210395$var$endo.beta), k2p.y, k2p.z);
            point = k1p.add(k2p);
            fake = f1p.add(f2p);
        } else {
            const { p: p, f: f } = this.wNAF(n, affinePoint);
            point = p;
            fake = f;
        }
        return $5b8ab42334210395$var$JacobianPoint.normalizeZ([
            point,
            fake
        ])[0];
    }
    toAffine(invZ) {
        const { x: x, y: y, z: z } = this;
        const is0 = this.equals($5b8ab42334210395$var$JacobianPoint.ZERO);
        if (invZ == null) invZ = is0 ? $5b8ab42334210395$var$_8n : $5b8ab42334210395$var$invert(z);
        const iz1 = invZ;
        const iz2 = $5b8ab42334210395$var$mod(iz1 * iz1);
        const iz3 = $5b8ab42334210395$var$mod(iz2 * iz1);
        const ax = $5b8ab42334210395$var$mod(x * iz2);
        const ay = $5b8ab42334210395$var$mod(y * iz3);
        const zz = $5b8ab42334210395$var$mod(z * iz1);
        if (is0) return $5b8ab42334210395$export$baf26146a414f24a.ZERO;
        if (zz !== $5b8ab42334210395$var$_1n) throw new Error("invZ was invalid");
        return new $5b8ab42334210395$export$baf26146a414f24a(ax, ay);
    }
}
$5b8ab42334210395$var$JacobianPoint.BASE = new $5b8ab42334210395$var$JacobianPoint($5b8ab42334210395$export$8ff8607b70325343.Gx, $5b8ab42334210395$export$8ff8607b70325343.Gy, $5b8ab42334210395$var$_1n);
$5b8ab42334210395$var$JacobianPoint.ZERO = new $5b8ab42334210395$var$JacobianPoint($5b8ab42334210395$var$_0n, $5b8ab42334210395$var$_1n, $5b8ab42334210395$var$_0n);
function $5b8ab42334210395$var$constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
const $5b8ab42334210395$var$pointPrecomputes = new WeakMap();
class $5b8ab42334210395$export$baf26146a414f24a {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    _setWindowSize(windowSize) {
        this._WINDOW_SIZE = windowSize;
        $5b8ab42334210395$var$pointPrecomputes.delete(this);
    }
    hasEvenY() {
        return this.y % $5b8ab42334210395$var$_2n === $5b8ab42334210395$var$_0n;
    }
    static fromCompressedHex(bytes) {
        const isShort = bytes.length === 32;
        const x = $5b8ab42334210395$var$bytesToNumber(isShort ? bytes : bytes.subarray(1));
        if (!$5b8ab42334210395$var$isValidFieldElement(x)) throw new Error("Point is not on curve");
        const y2 = $5b8ab42334210395$var$weierstrass(x);
        let y = $5b8ab42334210395$var$sqrtMod(y2);
        const isYOdd = (y & $5b8ab42334210395$var$_1n) === $5b8ab42334210395$var$_1n;
        if (isShort) {
            if (isYOdd) y = $5b8ab42334210395$var$mod(-y);
        } else {
            const isFirstByteOdd = (bytes[0] & 1) === 1;
            if (isFirstByteOdd !== isYOdd) y = $5b8ab42334210395$var$mod(-y);
        }
        const point = new $5b8ab42334210395$export$baf26146a414f24a(x, y);
        point.assertValidity();
        return point;
    }
    static fromUncompressedHex(bytes) {
        const x = $5b8ab42334210395$var$bytesToNumber(bytes.subarray(1, $5b8ab42334210395$var$fieldLen + 1));
        const y = $5b8ab42334210395$var$bytesToNumber(bytes.subarray($5b8ab42334210395$var$fieldLen + 1, $5b8ab42334210395$var$fieldLen * 2 + 1));
        const point = new $5b8ab42334210395$export$baf26146a414f24a(x, y);
        point.assertValidity();
        return point;
    }
    static fromHex(hex) {
        const bytes = $5b8ab42334210395$var$ensureBytes(hex);
        const len = bytes.length;
        const header = bytes[0];
        if (len === $5b8ab42334210395$var$fieldLen) return this.fromCompressedHex(bytes);
        if (len === $5b8ab42334210395$var$compressedLen && (header === 0x02 || header === 0x03)) return this.fromCompressedHex(bytes);
        if (len === $5b8ab42334210395$var$uncompressedLen && header === 0x04) return this.fromUncompressedHex(bytes);
        throw new Error(`Point.fromHex: received invalid point. Expected 32-${$5b8ab42334210395$var$compressedLen} compressed bytes or ${$5b8ab42334210395$var$uncompressedLen} uncompressed bytes, not ${len}`);
    }
    static fromPrivateKey(privateKey) {
        return $5b8ab42334210395$export$baf26146a414f24a.BASE.multiply($5b8ab42334210395$var$normalizePrivateKey(privateKey));
    }
    static fromSignature(msgHash, signature, recovery) {
        const { r: r, s: s } = $5b8ab42334210395$var$normalizeSignature(signature);
        if (![
            0,
            1,
            2,
            3
        ].includes(recovery)) throw new Error("Cannot recover: invalid recovery bit");
        const h = $5b8ab42334210395$var$truncateHash($5b8ab42334210395$var$ensureBytes(msgHash));
        const { n: n } = $5b8ab42334210395$export$8ff8607b70325343;
        const radj = recovery === 2 || recovery === 3 ? r + n : r;
        const rinv = $5b8ab42334210395$var$invert(radj, n);
        const u1 = $5b8ab42334210395$var$mod(-h * rinv, n);
        const u2 = $5b8ab42334210395$var$mod(s * rinv, n);
        const prefix = recovery & 1 ? "03" : "02";
        const R = $5b8ab42334210395$export$baf26146a414f24a.fromHex(prefix + $5b8ab42334210395$var$numTo32bStr(radj));
        const Q = $5b8ab42334210395$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(R, u1, u2);
        if (!Q) throw new Error("Cannot recover signature: point at infinify");
        Q.assertValidity();
        return Q;
    }
    toRawBytes(isCompressed = false) {
        return $5b8ab42334210395$var$hexToBytes(this.toHex(isCompressed));
    }
    toHex(isCompressed = false) {
        const x = $5b8ab42334210395$var$numTo32bStr(this.x);
        if (isCompressed) {
            const prefix = this.hasEvenY() ? "02" : "03";
            return `${prefix}${x}`;
        } else return `04${x}${$5b8ab42334210395$var$numTo32bStr(this.y)}`;
    }
    toHexX() {
        return this.toHex(true).slice(2);
    }
    toRawX() {
        return this.toRawBytes(true).slice(1);
    }
    assertValidity() {
        const msg = "Point is not on elliptic curve";
        const { x: x, y: y } = this;
        if (!$5b8ab42334210395$var$isValidFieldElement(x) || !$5b8ab42334210395$var$isValidFieldElement(y)) throw new Error(msg);
        const left = $5b8ab42334210395$var$mod(y * y);
        const right = $5b8ab42334210395$var$weierstrass(x);
        if ($5b8ab42334210395$var$mod(left - right) !== $5b8ab42334210395$var$_0n) throw new Error(msg);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y;
    }
    negate() {
        return new $5b8ab42334210395$export$baf26146a414f24a(this.x, $5b8ab42334210395$var$mod(-this.y));
    }
    double() {
        return $5b8ab42334210395$var$JacobianPoint.fromAffine(this).double().toAffine();
    }
    add(other) {
        return $5b8ab42334210395$var$JacobianPoint.fromAffine(this).add($5b8ab42334210395$var$JacobianPoint.fromAffine(other)).toAffine();
    }
    subtract(other) {
        return this.add(other.negate());
    }
    multiply(scalar) {
        return $5b8ab42334210395$var$JacobianPoint.fromAffine(this).multiply(scalar, this).toAffine();
    }
    multiplyAndAddUnsafe(Q, a, b) {
        const P = $5b8ab42334210395$var$JacobianPoint.fromAffine(this);
        const aP = a === $5b8ab42334210395$var$_0n || a === $5b8ab42334210395$var$_1n || this !== $5b8ab42334210395$export$baf26146a414f24a.BASE ? P.multiplyUnsafe(a) : P.multiply(a);
        const bQ = $5b8ab42334210395$var$JacobianPoint.fromAffine(Q).multiplyUnsafe(b);
        const sum = aP.add(bQ);
        return sum.equals($5b8ab42334210395$var$JacobianPoint.ZERO) ? undefined : sum.toAffine();
    }
}
$5b8ab42334210395$export$baf26146a414f24a.BASE = new $5b8ab42334210395$export$baf26146a414f24a($5b8ab42334210395$export$8ff8607b70325343.Gx, $5b8ab42334210395$export$8ff8607b70325343.Gy);
$5b8ab42334210395$export$baf26146a414f24a.ZERO = new $5b8ab42334210395$export$baf26146a414f24a($5b8ab42334210395$var$_0n, $5b8ab42334210395$var$_0n);
function $5b8ab42334210395$var$sliceDER(s) {
    return Number.parseInt(s[0], 16) >= 8 ? "00" + s : s;
}
function $5b8ab42334210395$var$parseDERInt(data) {
    if (data.length < 2 || data[0] !== 0x02) throw new Error(`Invalid signature integer tag: ${$5b8ab42334210395$var$bytesToHex(data)}`);
    const len = data[1];
    const res = data.subarray(2, len + 2);
    if (!len || res.length !== len) throw new Error(`Invalid signature integer: wrong length`);
    if (res[0] === 0x00 && res[1] <= 0x7f) throw new Error("Invalid signature integer: trailing length");
    return {
        data: $5b8ab42334210395$var$bytesToNumber(res),
        left: data.subarray(len + 2)
    };
}
function $5b8ab42334210395$var$parseDERSignature(data) {
    if (data.length < 2 || data[0] != 0x30) throw new Error(`Invalid signature tag: ${$5b8ab42334210395$var$bytesToHex(data)}`);
    if (data[1] !== data.length - 2) throw new Error("Invalid signature: incorrect length");
    const { data: r, left: sBytes } = $5b8ab42334210395$var$parseDERInt(data.subarray(2));
    const { data: s, left: rBytesLeft } = $5b8ab42334210395$var$parseDERInt(sBytes);
    if (rBytesLeft.length) throw new Error(`Invalid signature: left bytes after parsing: ${$5b8ab42334210395$var$bytesToHex(rBytesLeft)}`);
    return {
        r: r,
        s: s
    };
}
class $5b8ab42334210395$export$848620f5f2f26e86 {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromCompact(hex) {
        const arr = hex instanceof Uint8Array;
        const name = "Signature.fromCompact";
        if (typeof hex !== "string" && !arr) throw new TypeError(`${name}: Expected string or Uint8Array`);
        const str = arr ? $5b8ab42334210395$var$bytesToHex(hex) : hex;
        if (str.length !== 128) throw new Error(`${name}: Expected 64-byte hex`);
        return new $5b8ab42334210395$export$848620f5f2f26e86($5b8ab42334210395$var$hexToNumber(str.slice(0, 64)), $5b8ab42334210395$var$hexToNumber(str.slice(64, 128)));
    }
    static fromDER(hex) {
        const arr = hex instanceof Uint8Array;
        if (typeof hex !== "string" && !arr) throw new TypeError(`Signature.fromDER: Expected string or Uint8Array`);
        const { r: r, s: s } = $5b8ab42334210395$var$parseDERSignature(arr ? hex : $5b8ab42334210395$var$hexToBytes(hex));
        return new $5b8ab42334210395$export$848620f5f2f26e86(r, s);
    }
    static fromHex(hex) {
        return this.fromDER(hex);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$5b8ab42334210395$var$isWithinCurveOrder(r)) throw new Error("Invalid Signature: r must be 0 < r < n");
        if (!$5b8ab42334210395$var$isWithinCurveOrder(s)) throw new Error("Invalid Signature: s must be 0 < s < n");
    }
    hasHighS() {
        const HALF = $5b8ab42334210395$export$8ff8607b70325343.n >> $5b8ab42334210395$var$_1n;
        return this.s > HALF;
    }
    normalizeS() {
        return this.hasHighS() ? new $5b8ab42334210395$export$848620f5f2f26e86(this.r, $5b8ab42334210395$var$mod(-this.s, $5b8ab42334210395$export$8ff8607b70325343.n)) : this;
    }
    toDERRawBytes() {
        return $5b8ab42334210395$var$hexToBytes(this.toDERHex());
    }
    toDERHex() {
        const sHex = $5b8ab42334210395$var$sliceDER($5b8ab42334210395$var$numberToHexUnpadded(this.s));
        const rHex = $5b8ab42334210395$var$sliceDER($5b8ab42334210395$var$numberToHexUnpadded(this.r));
        const sHexL = sHex.length / 2;
        const rHexL = rHex.length / 2;
        const sLen = $5b8ab42334210395$var$numberToHexUnpadded(sHexL);
        const rLen = $5b8ab42334210395$var$numberToHexUnpadded(rHexL);
        const length = $5b8ab42334210395$var$numberToHexUnpadded(rHexL + sHexL + 4);
        return `30${length}02${rLen}${rHex}02${sLen}${sHex}`;
    }
    toRawBytes() {
        return this.toDERRawBytes();
    }
    toHex() {
        return this.toDERHex();
    }
    toCompactRawBytes() {
        return $5b8ab42334210395$var$hexToBytes(this.toCompactHex());
    }
    toCompactHex() {
        return $5b8ab42334210395$var$numTo32bStr(this.r) + $5b8ab42334210395$var$numTo32bStr(this.s);
    }
}
function $5b8ab42334210395$var$concatBytes(...arrays) {
    if (!arrays.every((b)=>b instanceof Uint8Array)) throw new Error("Uint8Array list expected");
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
const $5b8ab42334210395$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
function $5b8ab42334210395$var$bytesToHex(uint8a) {
    if (!(uint8a instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $5b8ab42334210395$var$hexes[uint8a[i]];
    return hex;
}
const $5b8ab42334210395$var$POW_2_256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function $5b8ab42334210395$var$numTo32bStr(num) {
    if (typeof num !== "bigint") throw new Error("Expected bigint");
    if (!($5b8ab42334210395$var$_0n <= num && num < $5b8ab42334210395$var$POW_2_256)) throw new Error("Expected number 0 <= n < 2^256");
    return num.toString(16).padStart(64, "0");
}
function $5b8ab42334210395$var$numTo32b(num) {
    const b = $5b8ab42334210395$var$hexToBytes($5b8ab42334210395$var$numTo32bStr(num));
    if (b.length !== 32) throw new Error("Error: expected 32 bytes");
    return b;
}
function $5b8ab42334210395$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $5b8ab42334210395$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToNumber: expected string, got " + typeof hex);
    return BigInt(`0x${hex}`);
}
function $5b8ab42334210395$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex" + hex.length);
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
function $5b8ab42334210395$var$bytesToNumber(bytes) {
    return $5b8ab42334210395$var$hexToNumber($5b8ab42334210395$var$bytesToHex(bytes));
}
function $5b8ab42334210395$var$ensureBytes(hex) {
    return hex instanceof Uint8Array ? Uint8Array.from(hex) : $5b8ab42334210395$var$hexToBytes(hex);
}
function $5b8ab42334210395$var$normalizeScalar(num) {
    if (typeof num === "number" && Number.isSafeInteger(num) && num > 0) return BigInt(num);
    if (typeof num === "bigint" && $5b8ab42334210395$var$isWithinCurveOrder(num)) return num;
    throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function $5b8ab42334210395$var$mod(a, b = $5b8ab42334210395$export$8ff8607b70325343.P) {
    const result = a % b;
    return result >= $5b8ab42334210395$var$_0n ? result : b + result;
}
function $5b8ab42334210395$var$pow2(x, power) {
    const { P: P } = $5b8ab42334210395$export$8ff8607b70325343;
    let res = x;
    while(power-- > $5b8ab42334210395$var$_0n){
        res *= res;
        res %= P;
    }
    return res;
}
function $5b8ab42334210395$var$sqrtMod(x) {
    const { P: P } = $5b8ab42334210395$export$8ff8607b70325343;
    const _6n = BigInt(6);
    const _11n = BigInt(11);
    const _22n = BigInt(22);
    const _23n = BigInt(23);
    const _44n = BigInt(44);
    const _88n = BigInt(88);
    const b2 = x * x * x % P;
    const b3 = b2 * b2 * x % P;
    const b6 = $5b8ab42334210395$var$pow2(b3, $5b8ab42334210395$var$_3n) * b3 % P;
    const b9 = $5b8ab42334210395$var$pow2(b6, $5b8ab42334210395$var$_3n) * b3 % P;
    const b11 = $5b8ab42334210395$var$pow2(b9, $5b8ab42334210395$var$_2n) * b2 % P;
    const b22 = $5b8ab42334210395$var$pow2(b11, _11n) * b11 % P;
    const b44 = $5b8ab42334210395$var$pow2(b22, _22n) * b22 % P;
    const b88 = $5b8ab42334210395$var$pow2(b44, _44n) * b44 % P;
    const b176 = $5b8ab42334210395$var$pow2(b88, _88n) * b88 % P;
    const b220 = $5b8ab42334210395$var$pow2(b176, _44n) * b44 % P;
    const b223 = $5b8ab42334210395$var$pow2(b220, $5b8ab42334210395$var$_3n) * b3 % P;
    const t1 = $5b8ab42334210395$var$pow2(b223, _23n) * b22 % P;
    const t2 = $5b8ab42334210395$var$pow2(t1, _6n) * b2 % P;
    const rt = $5b8ab42334210395$var$pow2(t2, $5b8ab42334210395$var$_2n);
    const xc = rt * rt % P;
    if (xc !== x) throw new Error("Cannot find square root");
    return rt;
}
function $5b8ab42334210395$var$invert(number, modulo = $5b8ab42334210395$export$8ff8607b70325343.P) {
    if (number === $5b8ab42334210395$var$_0n || modulo <= $5b8ab42334210395$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    let a = $5b8ab42334210395$var$mod(number, modulo);
    let b = modulo;
    let x = $5b8ab42334210395$var$_0n, y = $5b8ab42334210395$var$_1n, u = $5b8ab42334210395$var$_1n, v = $5b8ab42334210395$var$_0n;
    while(a !== $5b8ab42334210395$var$_0n){
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $5b8ab42334210395$var$_1n) throw new Error("invert: does not exist");
    return $5b8ab42334210395$var$mod(x, modulo);
}
function $5b8ab42334210395$var$invertBatch(nums, p = $5b8ab42334210395$export$8ff8607b70325343.P) {
    const scratch = new Array(nums.length);
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (num === $5b8ab42334210395$var$_0n) return acc;
        scratch[i] = acc;
        return $5b8ab42334210395$var$mod(acc * num, p);
    }, $5b8ab42334210395$var$_1n);
    const inverted = $5b8ab42334210395$var$invert(lastMultiplied, p);
    nums.reduceRight((acc, num, i)=>{
        if (num === $5b8ab42334210395$var$_0n) return acc;
        scratch[i] = $5b8ab42334210395$var$mod(acc * scratch[i], p);
        return $5b8ab42334210395$var$mod(acc * num, p);
    }, inverted);
    return scratch;
}
function $5b8ab42334210395$var$bits2int_2(bytes) {
    const delta = bytes.length * 8 - $5b8ab42334210395$var$groupLen * 8;
    const num = $5b8ab42334210395$var$bytesToNumber(bytes);
    return delta > 0 ? num >> BigInt(delta) : num;
}
function $5b8ab42334210395$var$truncateHash(hash, truncateOnly = false) {
    const h = $5b8ab42334210395$var$bits2int_2(hash);
    if (truncateOnly) return h;
    const { n: n } = $5b8ab42334210395$export$8ff8607b70325343;
    return h >= n ? h - n : h;
}
let $5b8ab42334210395$var$_sha256Sync;
let $5b8ab42334210395$var$_hmacSha256Sync;
class $5b8ab42334210395$var$HmacDrbg {
    constructor(hashLen, qByteLen){
        this.hashLen = hashLen;
        this.qByteLen = qByteLen;
        if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
        if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
        this.v = new Uint8Array(hashLen).fill(1);
        this.k = new Uint8Array(hashLen).fill(0);
        this.counter = 0;
    }
    hmac(...values) {
        return $5b8ab42334210395$export$eab97d15b1788b8d.hmacSha256(this.k, ...values);
    }
    hmacSync(...values) {
        return $5b8ab42334210395$var$_hmacSha256Sync(this.k, ...values);
    }
    checkSync() {
        if (typeof $5b8ab42334210395$var$_hmacSha256Sync !== "function") throw new $5b8ab42334210395$var$ShaError("hmacSha256Sync needs to be set");
    }
    incr() {
        if (this.counter >= 1000) throw new Error("Tried 1,000 k values for sign(), all were invalid");
        this.counter += 1;
    }
    async reseed(seed = new Uint8Array()) {
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = await this.hmac(this.v);
        if (seed.length === 0) return;
        this.k = await this.hmac(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = await this.hmac(this.v);
    }
    reseedSync(seed = new Uint8Array()) {
        this.checkSync();
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x00
        ]), seed);
        this.v = this.hmacSync(this.v);
        if (seed.length === 0) return;
        this.k = this.hmacSync(this.v, Uint8Array.from([
            0x01
        ]), seed);
        this.v = this.hmacSync(this.v);
    }
    async generate() {
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = await this.hmac(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $5b8ab42334210395$var$concatBytes(...out);
    }
    generateSync() {
        this.checkSync();
        this.incr();
        let len = 0;
        const out = [];
        while(len < this.qByteLen){
            this.v = this.hmacSync(this.v);
            const sl = this.v.slice();
            out.push(sl);
            len += this.v.length;
        }
        return $5b8ab42334210395$var$concatBytes(...out);
    }
}
function $5b8ab42334210395$var$isWithinCurveOrder(num) {
    return $5b8ab42334210395$var$_0n < num && num < $5b8ab42334210395$export$8ff8607b70325343.n;
}
function $5b8ab42334210395$var$isValidFieldElement(num) {
    return $5b8ab42334210395$var$_0n < num && num < $5b8ab42334210395$export$8ff8607b70325343.P;
}
function $5b8ab42334210395$var$kmdToSig(kBytes, m, d, lowS = true) {
    const { n: n } = $5b8ab42334210395$export$8ff8607b70325343;
    const k = $5b8ab42334210395$var$truncateHash(kBytes, true);
    if (!$5b8ab42334210395$var$isWithinCurveOrder(k)) return;
    const kinv = $5b8ab42334210395$var$invert(k, n);
    const q = $5b8ab42334210395$export$baf26146a414f24a.BASE.multiply(k);
    const r = $5b8ab42334210395$var$mod(q.x, n);
    if (r === $5b8ab42334210395$var$_0n) return;
    const s = $5b8ab42334210395$var$mod(kinv * $5b8ab42334210395$var$mod(m + d * r, n), n);
    if (s === $5b8ab42334210395$var$_0n) return;
    let sig = new $5b8ab42334210395$export$848620f5f2f26e86(r, s);
    let recovery = (q.x === sig.r ? 0 : 2) | Number(q.y & $5b8ab42334210395$var$_1n);
    if (lowS && sig.hasHighS()) {
        sig = sig.normalizeS();
        recovery ^= 1;
    }
    return {
        sig: sig,
        recovery: recovery
    };
}
function $5b8ab42334210395$var$normalizePrivateKey(key) {
    let num;
    if (typeof key === "bigint") num = key;
    else if (typeof key === "number" && Number.isSafeInteger(key) && key > 0) num = BigInt(key);
    else if (typeof key === "string") {
        if (key.length !== 2 * $5b8ab42334210395$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $5b8ab42334210395$var$hexToNumber(key);
    } else if (key instanceof Uint8Array) {
        if (key.length !== $5b8ab42334210395$var$groupLen) throw new Error("Expected 32 bytes of private key");
        num = $5b8ab42334210395$var$bytesToNumber(key);
    } else throw new TypeError("Expected valid private key");
    if (!$5b8ab42334210395$var$isWithinCurveOrder(num)) throw new Error("Expected private key: 0 < key < n");
    return num;
}
function $5b8ab42334210395$var$normalizePublicKey(publicKey) {
    if (publicKey instanceof $5b8ab42334210395$export$baf26146a414f24a) {
        publicKey.assertValidity();
        return publicKey;
    } else return $5b8ab42334210395$export$baf26146a414f24a.fromHex(publicKey);
}
function $5b8ab42334210395$var$normalizeSignature(signature) {
    if (signature instanceof $5b8ab42334210395$export$848620f5f2f26e86) {
        signature.assertValidity();
        return signature;
    }
    try {
        return $5b8ab42334210395$export$848620f5f2f26e86.fromDER(signature);
    } catch (error) {
        return $5b8ab42334210395$export$848620f5f2f26e86.fromCompact(signature);
    }
}
function $5b8ab42334210395$export$889def73691f9837(privateKey, isCompressed = false) {
    return $5b8ab42334210395$export$baf26146a414f24a.fromPrivateKey(privateKey).toRawBytes(isCompressed);
}
function $5b8ab42334210395$export$952dd09fbe0232b7(msgHash, signature, recovery, isCompressed = false) {
    return $5b8ab42334210395$export$baf26146a414f24a.fromSignature(msgHash, signature, recovery).toRawBytes(isCompressed);
}
function $5b8ab42334210395$var$isProbPub(item) {
    const arr = item instanceof Uint8Array;
    const str = typeof item === "string";
    const len = (arr || str) && item.length;
    if (arr) return len === $5b8ab42334210395$var$compressedLen || len === $5b8ab42334210395$var$uncompressedLen;
    if (str) return len === $5b8ab42334210395$var$compressedLen * 2 || len === $5b8ab42334210395$var$uncompressedLen * 2;
    if (item instanceof $5b8ab42334210395$export$baf26146a414f24a) return true;
    return false;
}
function $5b8ab42334210395$export$151f26f9d84a2c64(privateA, publicB, isCompressed = false) {
    if ($5b8ab42334210395$var$isProbPub(privateA)) throw new TypeError("getSharedSecret: first arg must be private key");
    if (!$5b8ab42334210395$var$isProbPub(publicB)) throw new TypeError("getSharedSecret: second arg must be public key");
    const b = $5b8ab42334210395$var$normalizePublicKey(publicB);
    b.assertValidity();
    return b.multiply($5b8ab42334210395$var$normalizePrivateKey(privateA)).toRawBytes(isCompressed);
}
function $5b8ab42334210395$var$bits2int(bytes) {
    const slice = bytes.length > $5b8ab42334210395$var$fieldLen ? bytes.slice(0, $5b8ab42334210395$var$fieldLen) : bytes;
    return $5b8ab42334210395$var$bytesToNumber(slice);
}
function $5b8ab42334210395$var$bits2octets(bytes) {
    const z1 = $5b8ab42334210395$var$bits2int(bytes);
    const z2 = $5b8ab42334210395$var$mod(z1, $5b8ab42334210395$export$8ff8607b70325343.n);
    return $5b8ab42334210395$var$int2octets(z2 < $5b8ab42334210395$var$_0n ? z1 : z2);
}
function $5b8ab42334210395$var$int2octets(num) {
    return $5b8ab42334210395$var$numTo32b(num);
}
function $5b8ab42334210395$var$initSigArgs(msgHash, privateKey, extraEntropy) {
    if (msgHash == null) throw new Error(`sign: expected valid message hash, not "${msgHash}"`);
    const h1 = $5b8ab42334210395$var$ensureBytes(msgHash);
    const d = $5b8ab42334210395$var$normalizePrivateKey(privateKey);
    const seedArgs = [
        $5b8ab42334210395$var$int2octets(d),
        $5b8ab42334210395$var$bits2octets(h1)
    ];
    if (extraEntropy != null) {
        if (extraEntropy === true) extraEntropy = $5b8ab42334210395$export$eab97d15b1788b8d.randomBytes($5b8ab42334210395$var$fieldLen);
        const e = $5b8ab42334210395$var$ensureBytes(extraEntropy);
        if (e.length !== $5b8ab42334210395$var$fieldLen) throw new Error(`sign: Expected ${$5b8ab42334210395$var$fieldLen} bytes of extra data`);
        seedArgs.push(e);
    }
    const seed = $5b8ab42334210395$var$concatBytes(...seedArgs);
    const m = $5b8ab42334210395$var$bits2int(h1);
    return {
        seed: seed,
        m: m,
        d: d
    };
}
function $5b8ab42334210395$var$finalizeSig(recSig, opts) {
    const { sig: sig, recovery: recovery } = recSig;
    const { der: der, recovered: recovered } = Object.assign({
        canonical: true,
        der: true
    }, opts);
    const hashed = der ? sig.toDERRawBytes() : sig.toCompactRawBytes();
    return recovered ? [
        hashed,
        recovery
    ] : hashed;
}
async function $5b8ab42334210395$export$c5552dfdbc7cec71(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $5b8ab42334210395$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $5b8ab42334210395$var$HmacDrbg($5b8ab42334210395$var$hashLen, $5b8ab42334210395$var$groupLen);
    await drbg.reseed(seed);
    let sig;
    while(!(sig = $5b8ab42334210395$var$kmdToSig(await drbg.generate(), m, d, opts.canonical)))await drbg.reseed();
    return $5b8ab42334210395$var$finalizeSig(sig, opts);
}
function $5b8ab42334210395$export$6ff6692656050317(msgHash, privKey, opts = {}) {
    const { seed: seed, m: m, d: d } = $5b8ab42334210395$var$initSigArgs(msgHash, privKey, opts.extraEntropy);
    const drbg = new $5b8ab42334210395$var$HmacDrbg($5b8ab42334210395$var$hashLen, $5b8ab42334210395$var$groupLen);
    drbg.reseedSync(seed);
    let sig;
    while(!(sig = $5b8ab42334210395$var$kmdToSig(drbg.generateSync(), m, d, opts.canonical)))drbg.reseedSync();
    return $5b8ab42334210395$var$finalizeSig(sig, opts);
}
const $5b8ab42334210395$var$vopts = {
    strict: true
};
function $5b8ab42334210395$export$532244b5b8b0b4b6(signature, msgHash, publicKey, opts = $5b8ab42334210395$var$vopts) {
    let sig;
    try {
        sig = $5b8ab42334210395$var$normalizeSignature(signature);
        msgHash = $5b8ab42334210395$var$ensureBytes(msgHash);
    } catch (error) {
        return false;
    }
    const { r: r, s: s } = sig;
    if (opts.strict && sig.hasHighS()) return false;
    const h = $5b8ab42334210395$var$truncateHash(msgHash);
    let P;
    try {
        P = $5b8ab42334210395$var$normalizePublicKey(publicKey);
    } catch (error) {
        return false;
    }
    const { n: n } = $5b8ab42334210395$export$8ff8607b70325343;
    const sinv = $5b8ab42334210395$var$invert(s, n);
    const u1 = $5b8ab42334210395$var$mod(h * sinv, n);
    const u2 = $5b8ab42334210395$var$mod(r * sinv, n);
    const R = $5b8ab42334210395$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(P, u1, u2);
    if (!R) return false;
    const v = $5b8ab42334210395$var$mod(R.x, n);
    return v === r;
}
function $5b8ab42334210395$var$schnorrChallengeFinalize(ch) {
    return $5b8ab42334210395$var$mod($5b8ab42334210395$var$bytesToNumber(ch), $5b8ab42334210395$export$8ff8607b70325343.n);
}
class $5b8ab42334210395$var$SchnorrSignature {
    constructor(r, s){
        this.r = r;
        this.s = s;
        this.assertValidity();
    }
    static fromHex(hex) {
        const bytes = $5b8ab42334210395$var$ensureBytes(hex);
        if (bytes.length !== 64) throw new TypeError(`SchnorrSignature.fromHex: expected 64 bytes, not ${bytes.length}`);
        const r = $5b8ab42334210395$var$bytesToNumber(bytes.subarray(0, 32));
        const s = $5b8ab42334210395$var$bytesToNumber(bytes.subarray(32, 64));
        return new $5b8ab42334210395$var$SchnorrSignature(r, s);
    }
    assertValidity() {
        const { r: r, s: s } = this;
        if (!$5b8ab42334210395$var$isValidFieldElement(r) || !$5b8ab42334210395$var$isWithinCurveOrder(s)) throw new Error("Invalid signature");
    }
    toHex() {
        return $5b8ab42334210395$var$numTo32bStr(this.r) + $5b8ab42334210395$var$numTo32bStr(this.s);
    }
    toRawBytes() {
        return $5b8ab42334210395$var$hexToBytes(this.toHex());
    }
}
function $5b8ab42334210395$var$schnorrGetPublicKey(privateKey) {
    return $5b8ab42334210395$export$baf26146a414f24a.fromPrivateKey(privateKey).toRawX();
}
class $5b8ab42334210395$var$InternalSchnorrSignature {
    constructor(message, privateKey, auxRand = $5b8ab42334210395$export$eab97d15b1788b8d.randomBytes()){
        if (message == null) throw new TypeError(`sign: Expected valid message, not "${message}"`);
        this.m = $5b8ab42334210395$var$ensureBytes(message);
        const { x: x, scalar: scalar } = this.getScalar($5b8ab42334210395$var$normalizePrivateKey(privateKey));
        this.px = x;
        this.d = scalar;
        this.rand = $5b8ab42334210395$var$ensureBytes(auxRand);
        if (this.rand.length !== 32) throw new TypeError("sign: Expected 32 bytes of aux randomness");
    }
    getScalar(priv) {
        const point = $5b8ab42334210395$export$baf26146a414f24a.fromPrivateKey(priv);
        const scalar = point.hasEvenY() ? priv : $5b8ab42334210395$export$8ff8607b70325343.n - priv;
        return {
            point: point,
            scalar: scalar,
            x: point.toRawX()
        };
    }
    initNonce(d, t0h) {
        return $5b8ab42334210395$var$numTo32b(d ^ $5b8ab42334210395$var$bytesToNumber(t0h));
    }
    finalizeNonce(k0h) {
        const k0 = $5b8ab42334210395$var$mod($5b8ab42334210395$var$bytesToNumber(k0h), $5b8ab42334210395$export$8ff8607b70325343.n);
        if (k0 === $5b8ab42334210395$var$_0n) throw new Error("sign: Creation of signature failed. k is zero");
        const { point: R, x: rx, scalar: k } = this.getScalar(k0);
        return {
            R: R,
            rx: rx,
            k: k
        };
    }
    finalizeSig(R, k, e, d) {
        return new $5b8ab42334210395$var$SchnorrSignature(R.x, $5b8ab42334210395$var$mod(k + e * d, $5b8ab42334210395$export$8ff8607b70325343.n)).toRawBytes();
    }
    error() {
        throw new Error("sign: Invalid signature produced");
    }
    async calc() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = $5b8ab42334210395$export$eab97d15b1788b8d.taggedHash;
        const t = this.initNonce(d, await tag($5b8ab42334210395$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(await tag($5b8ab42334210395$var$TAGS.nonce, t, px, m));
        const e = $5b8ab42334210395$var$schnorrChallengeFinalize(await tag($5b8ab42334210395$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!await $5b8ab42334210395$var$schnorrVerify(sig, m, px)) this.error();
        return sig;
    }
    calcSync() {
        const { m: m, d: d, px: px, rand: rand } = this;
        const tag = $5b8ab42334210395$export$eab97d15b1788b8d.taggedHashSync;
        const t = this.initNonce(d, tag($5b8ab42334210395$var$TAGS.aux, rand));
        const { R: R, rx: rx, k: k } = this.finalizeNonce(tag($5b8ab42334210395$var$TAGS.nonce, t, px, m));
        const e = $5b8ab42334210395$var$schnorrChallengeFinalize(tag($5b8ab42334210395$var$TAGS.challenge, rx, px, m));
        const sig = this.finalizeSig(R, k, e, d);
        if (!$5b8ab42334210395$var$schnorrVerifySync(sig, m, px)) this.error();
        return sig;
    }
}
async function $5b8ab42334210395$var$schnorrSign(msg, privKey, auxRand) {
    return new $5b8ab42334210395$var$InternalSchnorrSignature(msg, privKey, auxRand).calc();
}
function $5b8ab42334210395$var$schnorrSignSync(msg, privKey, auxRand) {
    return new $5b8ab42334210395$var$InternalSchnorrSignature(msg, privKey, auxRand).calcSync();
}
function $5b8ab42334210395$var$initSchnorrVerify(signature, message, publicKey) {
    const raw = signature instanceof $5b8ab42334210395$var$SchnorrSignature;
    const sig = raw ? signature : $5b8ab42334210395$var$SchnorrSignature.fromHex(signature);
    if (raw) sig.assertValidity();
    return {
        ...sig,
        m: $5b8ab42334210395$var$ensureBytes(message),
        P: $5b8ab42334210395$var$normalizePublicKey(publicKey)
    };
}
function $5b8ab42334210395$var$finalizeSchnorrVerify(r, P, s, e) {
    const R = $5b8ab42334210395$export$baf26146a414f24a.BASE.multiplyAndAddUnsafe(P, $5b8ab42334210395$var$normalizePrivateKey(s), $5b8ab42334210395$var$mod(-e, $5b8ab42334210395$export$8ff8607b70325343.n));
    if (!R || !R.hasEvenY() || R.x !== r) return false;
    return true;
}
async function $5b8ab42334210395$var$schnorrVerify(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $5b8ab42334210395$var$initSchnorrVerify(signature, message, publicKey);
        const e = $5b8ab42334210395$var$schnorrChallengeFinalize(await $5b8ab42334210395$export$eab97d15b1788b8d.taggedHash($5b8ab42334210395$var$TAGS.challenge, $5b8ab42334210395$var$numTo32b(r), P.toRawX(), m));
        return $5b8ab42334210395$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        return false;
    }
}
function $5b8ab42334210395$var$schnorrVerifySync(signature, message, publicKey) {
    try {
        const { r: r, s: s, m: m, P: P } = $5b8ab42334210395$var$initSchnorrVerify(signature, message, publicKey);
        const e = $5b8ab42334210395$var$schnorrChallengeFinalize($5b8ab42334210395$export$eab97d15b1788b8d.taggedHashSync($5b8ab42334210395$var$TAGS.challenge, $5b8ab42334210395$var$numTo32b(r), P.toRawX(), m));
        return $5b8ab42334210395$var$finalizeSchnorrVerify(r, P, s, e);
    } catch (error) {
        if (error instanceof $5b8ab42334210395$var$ShaError) throw error;
        return false;
    }
}
const $5b8ab42334210395$export$1f2401df071be9f = {
    Signature: $5b8ab42334210395$var$SchnorrSignature,
    getPublicKey: $5b8ab42334210395$var$schnorrGetPublicKey,
    sign: $5b8ab42334210395$var$schnorrSign,
    verify: $5b8ab42334210395$var$schnorrVerify,
    signSync: $5b8ab42334210395$var$schnorrSignSync,
    verifySync: $5b8ab42334210395$var$schnorrVerifySync
};
$5b8ab42334210395$export$baf26146a414f24a.BASE._setWindowSize(8);
const $5b8ab42334210395$var$crypto = {
    node: $kjyEk,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};
const $5b8ab42334210395$var$TAGS = {
    challenge: "BIP0340/challenge",
    aux: "BIP0340/aux",
    nonce: "BIP0340/nonce"
};
const $5b8ab42334210395$var$TAGGED_HASH_PREFIXES = {};
const $5b8ab42334210395$export$eab97d15b1788b8d = {
    bytesToHex: $5b8ab42334210395$var$bytesToHex,
    hexToBytes: $5b8ab42334210395$var$hexToBytes,
    concatBytes: $5b8ab42334210395$var$concatBytes,
    mod: $5b8ab42334210395$var$mod,
    invert: $5b8ab42334210395$var$invert,
    isValidPrivateKey (privateKey) {
        try {
            $5b8ab42334210395$var$normalizePrivateKey(privateKey);
            return true;
        } catch (error) {
            return false;
        }
    },
    _bigintTo32Bytes: $5b8ab42334210395$var$numTo32b,
    _normalizePrivateKey: $5b8ab42334210395$var$normalizePrivateKey,
    hashToPrivateKey: (hash)=>{
        hash = $5b8ab42334210395$var$ensureBytes(hash);
        const minLen = $5b8ab42334210395$var$groupLen + 8;
        if (hash.length < minLen || hash.length > 1024) throw new Error(`Expected valid bytes of private key as per FIPS 186`);
        const num = $5b8ab42334210395$var$mod($5b8ab42334210395$var$bytesToNumber(hash), $5b8ab42334210395$export$8ff8607b70325343.n - $5b8ab42334210395$var$_1n) + $5b8ab42334210395$var$_1n;
        return $5b8ab42334210395$var$numTo32b(num);
    },
    randomBytes: (bytesLength = 32)=>{
        if ($5b8ab42334210395$var$crypto.web) return $5b8ab42334210395$var$crypto.web.getRandomValues(new Uint8Array(bytesLength));
        else if ($5b8ab42334210395$var$crypto.node) {
            const { randomBytes: randomBytes } = $5b8ab42334210395$var$crypto.node;
            return Uint8Array.from(randomBytes(bytesLength));
        } else throw new Error("The environment doesn't have randomBytes function");
    },
    randomPrivateKey: ()=>$5b8ab42334210395$export$eab97d15b1788b8d.hashToPrivateKey($5b8ab42334210395$export$eab97d15b1788b8d.randomBytes($5b8ab42334210395$var$groupLen + 8)),
    precompute (windowSize = 8, point = $5b8ab42334210395$export$baf26146a414f24a.BASE) {
        const cached = point === $5b8ab42334210395$export$baf26146a414f24a.BASE ? point : new $5b8ab42334210395$export$baf26146a414f24a(point.x, point.y);
        cached._setWindowSize(windowSize);
        cached.multiply($5b8ab42334210395$var$_3n);
        return cached;
    },
    sha256: async (...messages)=>{
        if ($5b8ab42334210395$var$crypto.web) {
            const buffer = await $5b8ab42334210395$var$crypto.web.subtle.digest("SHA-256", $5b8ab42334210395$var$concatBytes(...messages));
            return new Uint8Array(buffer);
        } else if ($5b8ab42334210395$var$crypto.node) {
            const { createHash: createHash } = $5b8ab42334210395$var$crypto.node;
            const hash = createHash("sha256");
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have sha256 function");
    },
    hmacSha256: async (key, ...messages)=>{
        if ($5b8ab42334210395$var$crypto.web) {
            const ckey = await $5b8ab42334210395$var$crypto.web.subtle.importKey("raw", key, {
                name: "HMAC",
                hash: {
                    name: "SHA-256"
                }
            }, false, [
                "sign"
            ]);
            const message = $5b8ab42334210395$var$concatBytes(...messages);
            const buffer = await $5b8ab42334210395$var$crypto.web.subtle.sign("HMAC", ckey, message);
            return new Uint8Array(buffer);
        } else if ($5b8ab42334210395$var$crypto.node) {
            const { createHmac: createHmac } = $5b8ab42334210395$var$crypto.node;
            const hash = createHmac("sha256", key);
            messages.forEach((m)=>hash.update(m));
            return Uint8Array.from(hash.digest());
        } else throw new Error("The environment doesn't have hmac-sha256 function");
    },
    sha256Sync: undefined,
    hmacSha256Sync: undefined,
    taggedHash: async (tag, ...messages)=>{
        let tagP = $5b8ab42334210395$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = await $5b8ab42334210395$export$eab97d15b1788b8d.sha256(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $5b8ab42334210395$var$concatBytes(tagH, tagH);
            $5b8ab42334210395$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return $5b8ab42334210395$export$eab97d15b1788b8d.sha256(tagP, ...messages);
    },
    taggedHashSync: (tag, ...messages)=>{
        if (typeof $5b8ab42334210395$var$_sha256Sync !== "function") throw new $5b8ab42334210395$var$ShaError("sha256Sync is undefined, you need to set it");
        let tagP = $5b8ab42334210395$var$TAGGED_HASH_PREFIXES[tag];
        if (tagP === undefined) {
            const tagH = $5b8ab42334210395$var$_sha256Sync(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
            tagP = $5b8ab42334210395$var$concatBytes(tagH, tagH);
            $5b8ab42334210395$var$TAGGED_HASH_PREFIXES[tag] = tagP;
        }
        return $5b8ab42334210395$var$_sha256Sync(tagP, ...messages);
    },
    _JacobianPoint: $5b8ab42334210395$var$JacobianPoint
};
Object.defineProperties($5b8ab42334210395$export$eab97d15b1788b8d, {
    sha256Sync: {
        configurable: false,
        get () {
            return $5b8ab42334210395$var$_sha256Sync;
        },
        set (val) {
            if (!$5b8ab42334210395$var$_sha256Sync) $5b8ab42334210395$var$_sha256Sync = val;
        }
    },
    hmacSha256Sync: {
        configurable: false,
        get () {
            return $5b8ab42334210395$var$_hmacSha256Sync;
        },
        set (val) {
            if (!$5b8ab42334210395$var$_hmacSha256Sync) $5b8ab42334210395$var$_hmacSha256Sync = val;
        }
    }
});


/**
 *  Some mathematic operations.
 *
 *  @_subsection: api/utils:Math Helpers  [about-maths]
 */ 

const $6fa405e57bb6371e$var$BN_0 = BigInt(0);
const $6fa405e57bb6371e$var$BN_1 = BigInt(1);
//const BN_Max256 = (BN_1 << BigInt(256)) - BN_1;
// IEEE 754 support 53-bits of mantissa
const $6fa405e57bb6371e$var$maxValue = 0x1fffffffffffff;
function $6fa405e57bb6371e$export$92182edcfa20e5bc(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    (0, $634aa51198273feb$export$a7a9523472993e97)(value >> width === $6fa405e57bb6371e$var$BN_0, "overflow", "NUMERIC_FAULT", {
        operation: "fromTwos",
        fault: "overflow",
        value: _value
    });
    // Top bit set; treat as a negative value
    if (value >> width - $6fa405e57bb6371e$var$BN_1) {
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return -((~value & mask) + $6fa405e57bb6371e$var$BN_1);
    }
    return value;
}
function $6fa405e57bb6371e$export$7101cd4e6275351c(_value, _width) {
    let value = $6fa405e57bb6371e$export$61fe455e2b1e28a4(_value, "value");
    const width = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_width, "width"));
    const limit = $6fa405e57bb6371e$var$BN_1 << width - $6fa405e57bb6371e$var$BN_1;
    if (value < $6fa405e57bb6371e$var$BN_0) {
        value = -value;
        (0, $634aa51198273feb$export$a7a9523472993e97)(value <= limit, "too low", "NUMERIC_FAULT", {
            operation: "toTwos",
            fault: "overflow",
            value: _value
        });
        const mask = ($6fa405e57bb6371e$var$BN_1 << width) - $6fa405e57bb6371e$var$BN_1;
        return (~value & mask) + $6fa405e57bb6371e$var$BN_1;
    } else (0, $634aa51198273feb$export$a7a9523472993e97)(value < limit, "too high", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: _value
    });
    return value;
}
function $6fa405e57bb6371e$export$d99f0801a68bbcf1(_value, _bits) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    const bits = BigInt($6fa405e57bb6371e$export$b14f2714108df84(_bits, "bits"));
    return value & ($6fa405e57bb6371e$var$BN_1 << bits) - $6fa405e57bb6371e$var$BN_1;
}
function $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name) {
    switch(typeof value){
        case "bigint":
            return value;
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return BigInt(value);
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                if (value[0] === "-" && value[1] !== "-") return -BigInt(value.substring(1));
                return BigInt(value);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid BigNumberish string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid BigNumberish value", name || "value", value);
}
function $6fa405e57bb6371e$export$8677d6ca9282a154(value, name) {
    const result = $6fa405e57bb6371e$export$61fe455e2b1e28a4(value, name);
    (0, $634aa51198273feb$export$a7a9523472993e97)(result >= $6fa405e57bb6371e$var$BN_0, "unsigned value cannot be negative", "NUMERIC_FAULT", {
        fault: "overflow",
        operation: "getUint",
        value: value
    });
    return result;
}
const $6fa405e57bb6371e$var$Nibbles = "0123456789abcdef";
function $6fa405e57bb6371e$export$c221a145703ab783(value) {
    if (value instanceof Uint8Array) {
        let result = "0x0";
        for (const v of value){
            result += $6fa405e57bb6371e$var$Nibbles[v >> 4];
            result += $6fa405e57bb6371e$var$Nibbles[v & 0x0f];
        }
        return BigInt(result);
    }
    return $6fa405e57bb6371e$export$61fe455e2b1e28a4(value);
}
function $6fa405e57bb6371e$export$b14f2714108df84(value, name) {
    switch(typeof value){
        case "bigint":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return Number(value);
        case "number":
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(value), "underflow", name || "value", value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= -$6fa405e57bb6371e$var$maxValue && value <= $6fa405e57bb6371e$var$maxValue, "overflow", name || "value", value);
            return value;
        case "string":
            try {
                if (value === "") throw new Error("empty string");
                return $6fa405e57bb6371e$export$b14f2714108df84(BigInt(value), name);
            } catch (e) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid numeric string: ${e.message}`, name || "value", value);
            }
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid numeric value", name || "value", value);
}
function $6fa405e57bb6371e$export$a0a81dc3380ce7d3(value) {
    return $6fa405e57bb6371e$export$b14f2714108df84($6fa405e57bb6371e$export$c221a145703ab783(value));
}
function $6fa405e57bb6371e$export$c6ebe05badb16181(_value, _width) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    let result = value.toString(16);
    if (_width == null) // Ensure the value is of even length
    {
        if (result.length % 2) result = "0" + result;
    } else {
        const width = $6fa405e57bb6371e$export$b14f2714108df84(_width, "width");
        (0, $634aa51198273feb$export$a7a9523472993e97)(width * 2 >= result.length, `value exceeds width (${width} bits)`, "NUMERIC_FAULT", {
            operation: "toBeHex",
            fault: "overflow",
            value: _value
        });
        // Pad the value to the required width
        while(result.length < width * 2)result = "0" + result;
    }
    return "0x" + result;
}
function $6fa405e57bb6371e$export$b627fcfb5ea68cb0(_value) {
    const value = $6fa405e57bb6371e$export$8677d6ca9282a154(_value, "value");
    if (value === $6fa405e57bb6371e$var$BN_0) return new Uint8Array([]);
    let hex = value.toString(16);
    if (hex.length % 2) hex = "0" + hex;
    const result = new Uint8Array(hex.length / 2);
    for(let i = 0; i < result.length; i++){
        const offset = i * 2;
        result[i] = parseInt(hex.substring(offset, offset + 2), 16);
    }
    return result;
}
function $6fa405e57bb6371e$export$d9c067986dbc68dd(value) {
    let result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$9a14abb1a440cd5e)(value) ? value : $6fa405e57bb6371e$export$b627fcfb5ea68cb0(value)).substring(2);
    while(result.startsWith("0"))result = result.substring(1);
    if (result === "") result = "0";
    return "0x" + result;
}



/**
 *  A constant for the zero hash.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000000000000000000000000000"``)
 */ const $dd46242704dbba3d$export$89c2533b29c23a61 = "0x0000000000000000000000000000000000000000000000000000000000000000";



// Constants
const $b48bc2308ad845a5$var$BN_0 = BigInt(0);
const $b48bc2308ad845a5$var$BN_1 = BigInt(1);
const $b48bc2308ad845a5$var$BN_2 = BigInt(2);
const $b48bc2308ad845a5$var$BN_27 = BigInt(27);
const $b48bc2308ad845a5$var$BN_28 = BigInt(28);
const $b48bc2308ad845a5$var$BN_35 = BigInt(35);
const $b48bc2308ad845a5$var$_guard = {};
function $b48bc2308ad845a5$var$toUint256(value) {
    return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value), 32);
}
class $b48bc2308ad845a5$export$848620f5f2f26e86 {
    #r;
    #s;
    #v;
    #networkV;
    /**
     *  The ``r`` value for a signautre.
     *
     *  This represents the ``x`` coordinate of a "reference" or
     *  challenge point, from which the ``y`` can be computed.
     */ get r() {
        return this.#r;
    }
    set r(value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(value) === 32, "invalid r", "value", value);
        this.#r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The ``s`` value for a signature.
     */ get s() {
        return this.#s;
    }
    set s(_value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(_value) === 32, "invalid s", "value", _value);
        const value = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(_value);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(parseInt(value.substring(0, 3)) < 8, "non-canonical s", "value", value);
        this.#s = value;
    }
    /**
     *  The ``v`` value for a signature.
     *
     *  Since a given ``x`` value for ``r`` has two possible values for
     *  its correspondin ``y``, the ``v`` indicates which of the two ``y``
     *  values to use.
     *
     *  It is normalized to the values ``27`` or ``28`` for legacy
     *  purposes.
     */ get v() {
        return this.#v;
    }
    set v(value) {
        const v = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value, "value");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(v === 27 || v === 28, "invalid v", "v", value);
        this.#v = v;
    }
    /**
     *  The EIP-155 ``v`` for legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get networkV() {
        return this.#networkV;
    }
    /**
     *  The chain ID for EIP-155 legacy transactions. For non-legacy
     *  transactions, this value is ``null``.
     */ get legacyChainId() {
        const v = this.networkV;
        if (v == null) return null;
        return $b48bc2308ad845a5$export$848620f5f2f26e86.getChainId(v);
    }
    /**
     *  The ``yParity`` for the signature.
     *
     *  See ``v`` for more details on how this value is used.
     */ get yParity() {
        return this.v === 27 ? 0 : 1;
    }
    /**
     *  The [[link-eip-2098]] compact representation of the ``yParity``
     *  and ``s`` compacted into a single ``bytes32``.
     */ get yParityAndS() {
        // The EIP-2098 compact representation
        const yParityAndS = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(this.s);
        if (this.yParity) yParityAndS[0] |= 0x80;
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(yParityAndS);
    }
    /**
     *  The [[link-eip-2098]] compact representation.
     */ get compactSerialized() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            this.r,
            this.yParityAndS
        ]);
    }
    /**
     *  The serialized representation.
     */ get serialized() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            this.r,
            this.s,
            this.yParity ? "0x1c" : "0x1b"
        ]);
    }
    /**
     *  @private
     */ constructor(guard, r, s, v){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $b48bc2308ad845a5$var$_guard, "Signature");
        this.#r = r;
        this.#s = s;
        this.#v = v;
        this.#networkV = null;
    }
    [Symbol.for("nodejs.util.inspect.custom")]() {
        return `Signature { r: "${this.r}", s: "${this.s}", yParity: ${this.yParity}, networkV: ${this.networkV} }`;
    }
    /**
     *  Returns a new identical [[Signature]].
     */ clone() {
        const clone = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, this.r, this.s, this.v);
        if (this.networkV) clone.#networkV = this.networkV;
        return clone;
    }
    /**
     *  Returns a representation that is compatible with ``JSON.stringify``.
     */ toJSON() {
        const networkV = this.networkV;
        return {
            _type: "signature",
            networkV: networkV != null ? networkV.toString() : null,
            r: this.r,
            s: this.s,
            v: this.v
        };
    }
    /**
     *  Compute the chain ID from the ``v`` in a legacy EIP-155 transactions.
     *
     *  @example:
     *    Signature.getChainId(45)
     *    //_result:
     *
     *    Signature.getChainId(46)
     *    //_result:
     */ static getChainId(v) {
        const bv = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(v, "v");
        // The v is not an EIP-155 v, so it is the unspecified chain ID
        if (bv == $b48bc2308ad845a5$var$BN_27 || bv == $b48bc2308ad845a5$var$BN_28) return $b48bc2308ad845a5$var$BN_0;
        // Bad value for an EIP-155 v
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid EIP-155 v", "v", v);
        return (bv - $b48bc2308ad845a5$var$BN_35) / $b48bc2308ad845a5$var$BN_2;
    }
    /**
     *  Compute the ``v`` for a chain ID for a legacy EIP-155 transactions.
     *
     *  Legacy transactions which use [[link-eip-155]] hijack the ``v``
     *  property to include the chain ID.
     *
     *  @example:
     *    Signature.getChainIdV(5, 27)
     *    //_result:
     *
     *    Signature.getChainIdV(5, 28)
     *    //_result:
     *
     */ static getChainIdV(chainId, v) {
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(chainId) * $b48bc2308ad845a5$var$BN_2 + BigInt(35 + v - 27);
    }
    /**
     *  Compute the normalized legacy transaction ``v`` from a ``yParirty``,
     *  a legacy transaction ``v`` or a legacy [[link-eip-155]] transaction.
     *
     *  @example:
     *    // The values 0 and 1 imply v is actually yParity
     *    Signature.getNormalizedV(0)
     *    //_result:
     *
     *    // Legacy non-EIP-1559 transaction (i.e. 27 or 28)
     *    Signature.getNormalizedV(27)
     *    //_result:
     *
     *    // Legacy EIP-155 transaction (i.e. >= 35)
     *    Signature.getNormalizedV(46)
     *    //_result:
     *
     *    // Invalid values throw
     *    Signature.getNormalizedV(5)
     *    //_error:
     */ static getNormalizedV(v) {
        const bv = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(v);
        if (bv === $b48bc2308ad845a5$var$BN_0 || bv === $b48bc2308ad845a5$var$BN_27) return 27;
        if (bv === $b48bc2308ad845a5$var$BN_1 || bv === $b48bc2308ad845a5$var$BN_28) return 28;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bv >= $b48bc2308ad845a5$var$BN_35, "invalid v", "v", v);
        // Otherwise, EIP-155 v means odd is 27 and even is 28
        return bv & $b48bc2308ad845a5$var$BN_1 ? 27 : 28;
    }
    /**
     *  Creates a new [[Signature]].
     *
     *  If no %%sig%% is provided, a new [[Signature]] is created
     *  with default values.
     *
     *  If %%sig%% is a string, it is parsed.
     */ static from(sig) {
        function assertError(check, message) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(check, message, "signature", sig);
        }
        if (sig == null) return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, (0, $dd46242704dbba3d$export$89c2533b29c23a61), (0, $dd46242704dbba3d$export$89c2533b29c23a61), 27);
        if (typeof sig === "string") {
            const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(sig, "signature");
            if (bytes.length === 64) {
                const r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                const v = s[0] & 0x80 ? 28 : 27;
                s[0] &= 0x7f;
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(s), v);
            }
            if (bytes.length === 65) {
                const r = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 32));
                const s = bytes.slice(32, 64);
                assertError((s[0] & 0x80) === 0, "non-canonical s");
                const v = $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(bytes[64]);
                return new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(s), v);
            }
            assertError(false, "invalid raw signature length");
        }
        if (sig instanceof $b48bc2308ad845a5$export$848620f5f2f26e86) return sig.clone();
        // Get r
        const _r = sig.r;
        assertError(_r != null, "missing r");
        const r = $b48bc2308ad845a5$var$toUint256(_r);
        // Get s; by any means necessary (we check consistency below)
        const s = function(s, yParityAndS) {
            if (s != null) return $b48bc2308ad845a5$var$toUint256(s);
            if (yParityAndS != null) {
                assertError((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(yParityAndS);
                bytes[0] &= 0x7f;
                return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
            }
            assertError(false, "missing s");
        }(sig.s, sig.yParityAndS);
        assertError(((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(s)[0] & 0x80) == 0, "non-canonical s");
        // Get v; by any means necessary (we check consistency below)
        const { networkV: networkV, v: v } = function(_v, yParityAndS, yParity) {
            if (_v != null) {
                const v = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_v);
                return {
                    networkV: v >= $b48bc2308ad845a5$var$BN_35 ? v : undefined,
                    v: $b48bc2308ad845a5$export$848620f5f2f26e86.getNormalizedV(v)
                };
            }
            if (yParityAndS != null) {
                assertError((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(yParityAndS, 32), "invalid yParityAndS");
                return {
                    v: (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(yParityAndS)[0] & 0x80 ? 28 : 27
                };
            }
            if (yParity != null) {
                switch((0, $6fa405e57bb6371e$export$b14f2714108df84)(yParity, "sig.yParity")){
                    case 0:
                        return {
                            v: 27
                        };
                    case 1:
                        return {
                            v: 28
                        };
                }
                assertError(false, "invalid yParity");
            }
            assertError(false, "missing v");
        }(sig.v, sig.yParityAndS, sig.yParity);
        const result = new $b48bc2308ad845a5$export$848620f5f2f26e86($b48bc2308ad845a5$var$_guard, r, s, v);
        if (networkV) result.#networkV = networkV;
        // If multiple of v, yParity, yParityAndS we given, check they match
        assertError(sig.yParity == null || (0, $6fa405e57bb6371e$export$b14f2714108df84)(sig.yParity, "sig.yParity") === result.yParity, "yParity mismatch");
        assertError(sig.yParityAndS == null || sig.yParityAndS === result.yParityAndS, "yParityAndS mismatch");
        return result;
    }
}


//const N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// Make noble-secp256k1 sync
$5b8ab42334210395$export$eab97d15b1788b8d.hmacSha256Sync = function(key, ...messages) {
    return (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff)("sha256", key, (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(messages)));
};
class $015cdebda6711d1b$export$21643ca94aed3e83 {
    #privateKey;
    /**
     *  Creates a new **SigningKey** for %%privateKey%%.
     */ constructor(privateKey){
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(privateKey) === 32, "invalid private key", "privateKey", "[REDACTED]");
        this.#privateKey = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(privateKey);
    }
    /**
     *  The private key.
     */ get privateKey() {
        return this.#privateKey;
    }
    /**
     *  The uncompressed public key.
     *
     * This will always begin with the prefix ``0x04`` and be 132
     * characters long (the ``0x`` prefix and 130 hexadecimal nibbles).
     */ get publicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey);
    }
    /**
     *  The compressed public key.
     *
     *  This will always begin with either the prefix ``0x02`` or ``0x03``
     *  and be 68 characters long (the ``0x`` prefix and 33 hexadecimal
     *  nibbles)
     */ get compressedPublicKey() {
        return $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(this.#privateKey, true);
    }
    /**
     *  Return the signature of the signed %%digest%%.
     */ sign(digest) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const [sigDer, recid] = $5b8ab42334210395$export$6ff6692656050317((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(digest), (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#privateKey), {
            recovered: true,
            canonical: true
        });
        const sig = $5b8ab42334210395$export$848620f5f2f26e86.fromHex(sigDer);
        return (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
            r: (0, $6fa405e57bb6371e$export$c6ebe05badb16181)("0x" + sig.r.toString(16), 32),
            s: (0, $6fa405e57bb6371e$export$c6ebe05badb16181)("0x" + sig.s.toString(16), 32),
            v: recid ? 0x1c : 0x1b
        });
    }
    /**
     *  Returns the [[link-wiki-ecdh]] shared secret between this
     *  private key and the %%other%% key.
     *
     *  The %%other%% key may be any type of key, a raw public key,
     *  a compressed/uncompressed pubic key or aprivate key.
     *
     *  Best practice is usually to use a cryptographic hash on the
     *  returned value before using it as a symetric secret.
     *
     *  @example:
     *    sign1 = new SigningKey(id("some-secret-1"))
     *    sign2 = new SigningKey(id("some-secret-2"))
     *
     *    // Notice that privA.computeSharedSecret(pubB)...
     *    sign1.computeSharedSecret(sign2.publicKey)
     *    //_result:
     *
     *    // ...is equal to privB.computeSharedSecret(pubA).
     *    sign2.computeSharedSecret(sign1.publicKey)
     *    //_result:
     */ computeSharedSecret(other) {
        const pubKey = $015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(other);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)($5b8ab42334210395$export$151f26f9d84a2c64((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#privateKey), (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(pubKey)));
    }
    /**
     *  Compute the public key for %%key%%, optionally %%compressed%%.
     *
     *  The %%key%% may be any type of key, a raw public key, a
     *  compressed/uncompressed public key or private key.
     *
     *  @example:
     *    sign = new SigningKey(id("some-secret"));
     *
     *    // Compute the uncompressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey)
     *    //_result:
     *
     *    // Compute the compressed public key for a private key
     *    SigningKey.computePublicKey(sign.privateKey, true)
     *    //_result:
     *
     *    // Compute the uncompressed public key
     *    SigningKey.computePublicKey(sign.publicKey, false);
     *    //_result:
     *
     *    // Compute the Compressed a public key
     *    SigningKey.computePublicKey(sign.publicKey, true);
     *    //_result:
     */ static computePublicKey(key, compressed) {
        let bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(key, "key");
        // private key
        if (bytes.length === 32) {
            const pubKey = $5b8ab42334210395$export$889def73691f9837(bytes, !!compressed);
            return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(pubKey);
        }
        // raw public key; use uncompressed key with 0x04 prefix
        if (bytes.length === 64) {
            const pub = new Uint8Array(65);
            pub[0] = 0x04;
            pub.set(bytes, 1);
            bytes = pub;
        }
        const point = $5b8ab42334210395$export$baf26146a414f24a.fromHex(bytes);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(point.toRawBytes(compressed));
    }
    /**
     *  Returns the public key for the private key which produced the
     *  %%signature%% for the given %%digest%%.
     *
     *  @example:
     *    key = new SigningKey(id("some-secret"))
     *    digest = id("hello world")
     *    sig = key.sign(digest)
     *
     *    // Notice the signer public key...
     *    key.publicKey
     *    //_result:
     *
     *    // ...is equal to the recovered public key
     *    SigningKey.recoverPublicKey(digest, sig)
     *    //_result:
     *
     */ static recoverPublicKey(digest, signature) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(digest) === 32, "invalid digest length", "digest", digest);
        const sig = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(signature);
        const der = $5b8ab42334210395$export$848620f5f2f26e86.fromCompact((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            sig.r,
            sig.s
        ]))).toDERRawBytes();
        const pubKey = $5b8ab42334210395$export$952dd09fbe0232b7((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(digest), der, sig.yParity);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(pubKey != null, "invalid signature for digest", "signature", signature);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(pubKey);
    }
    /**
     *  Returns the point resulting from adding the ellipic curve points
     *  %%p0%% and %%p1%%.
     *
     *  This is not a common function most developers should require, but
     *  can be useful for certain privacy-specific techniques.
     *
     *  For example, it is used by [[HDNodeWallet]] to compute child
     *  addresses from parent public keys and chain codes.
     */ static addPoints(p0, p1, compressed) {
        const pub0 = $5b8ab42334210395$export$baf26146a414f24a.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p0).substring(2));
        const pub1 = $5b8ab42334210395$export$baf26146a414f24a.fromHex($015cdebda6711d1b$export$21643ca94aed3e83.computePublicKey(p1).substring(2));
        return "0x" + pub0.add(pub1).toHex(!!compressed);
    }
}



/**
 *  Once called, prevents any future change to the underlying cryptographic
 *  primitives using the ``.register`` feature for hooks.
 */ function $0c0373556082ea84$export$6a9f04c98a658ecb() {
    (0, $be13a0f2e0d9ad05$export$967075d2f3b8e7ff).lock();
    (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35).lock();
    (0, $9092348e8cf65603$export$448fa22aedc9dbca).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
    (0, $76bdf8351c5898c8$export$d1cea0ee4e3f0d3e).lock();
    (0, $e794241b1cb9b0d3$export$7cf7c2f1ec457bf3).lock();
    (0, $e794241b1cb9b0d3$export$86c79e0734c26a76).lock();
    (0, $c1049352abb4e7c6$export$bced8d2aada2d1c9).lock();
    (0, $c1049352abb4e7c6$export$a888d2532e6dc7bb).lock();
    (0, $90bc03290273a6e1$export$5f828d93ff035aa8).lock();
}



/**
 *  Using strings in Ethereum (or any security-basd system) requires
 *  additional care. These utilities attempt to mitigate some of the
 *  safety issues as well as provide the ability to recover and analyse
 *  strings.
 *
 *  @_subsection api/utils:Strings and UTF-8  [about-strings]
 */ 

function $50aa15ceb128a952$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === "BAD_PREFIX" || reason === "UNEXPECTED_CONTINUE") {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === "OVERRUN") return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $50aa15ceb128a952$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === "OVERLONG") {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof badCodepoint === "number", "invalid bad code point for replacement", "badCodepoint", badCodepoint);
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $50aa15ceb128a952$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $50aa15ceb128a952$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $50aa15ceb128a952$var$errorFunc,
    ignore: $50aa15ceb128a952$var$ignoreFunc,
    replace: $50aa15ceb128a952$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $50aa15ceb128a952$var$getUtf8CodePoints(_bytes, onError) {
    if (onError == null) onError = $50aa15ceb128a952$export$c6e2180c5bb5bc05.error;
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_bytes, "bytes");
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError("UNEXPECTED_CONTINUE", i - 1, bytes, result);
            else i += onError("BAD_PREFIX", i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError("OVERRUN", i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError("MISSING_CONTINUE", i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError("OUT_OF_RANGE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError("UTF16_SURROGATE", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError("OVERLONG", i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $50aa15ceb128a952$export$8feeb310b4b4752f(str, form) {
    if (form != null) {
        (0, $634aa51198273feb$export$d993e67fefdfecda)(form);
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(i < str.length && (c2 & 0xfc00) === 0xdc00, "invalid surrogate pair", "str", str);
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return new Uint8Array(result);
}
//export 
function $50aa15ceb128a952$var$_toUtf8String(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $50aa15ceb128a952$export$7643a1dc2c38d5eb(bytes, onError) {
    return $50aa15ceb128a952$var$_toUtf8String($50aa15ceb128a952$var$getUtf8CodePoints(bytes, onError));
}
function $50aa15ceb128a952$export$ae470a36a31b28c2(str, form) {
    return $50aa15ceb128a952$var$getUtf8CodePoints($50aa15ceb128a952$export$8feeb310b4b4752f(str, form));
}


function $697215a61e1ccd96$export$d560c7e4a29451c2(value) {
    return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(value));
}



/**
 *  When sending values to or receiving values from a [[Contract]], the
 *  data is generally encoded using the [ABI standard](link-solc-abi).
 *
 *  The AbiCoder provides a utility to encode values to ABI data and
 *  decode values from ABI data.
 *
 *  Most of the time, developers should favour the [[Contract]] class,
 *  which further abstracts a lot of the finer details of ABI data.
 *
 *  @_section api/abi/abi-coder:ABI Encoding
 */ // See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI


const $6b2ae433bec33333$export$b4b1d1fba463e69c = 32;
const $6b2ae433bec33333$var$Padding = new Uint8Array($6b2ae433bec33333$export$b4b1d1fba463e69c);
// Properties used to immediate pass through to the underlying object
// - `then` is used to detect if an object is a Promise for await
const $6b2ae433bec33333$var$passProperties = [
    "then"
];
const $6b2ae433bec33333$var$_guard = {};
function $6b2ae433bec33333$var$throwError(name, error) {
    const wrapped = new Error(`deferred error during ABI decoding triggered accessing ${name}`);
    wrapped.error = error;
    throw wrapped;
}
class $6b2ae433bec33333$export$8fdcabde73f49165 extends Array {
    #names;
    /**
     *  @private
     */ constructor(...args){
        // To properly sub-class Array so the other built-in
        // functions work, the constructor has to behave fairly
        // well. So, in the event we are created via fromItems()
        // we build the read-only Result object we want, but on
        // any other input, we use the default constructor
        // constructor(guard: any, items: Array<any>, keys?: Array<null | string>);
        const guard = args[0];
        let items = args[1];
        let names = (args[2] || []).slice();
        let wrap = true;
        if (guard !== $6b2ae433bec33333$var$_guard) {
            items = args;
            names = [];
            wrap = false;
        }
        // Can't just pass in ...items since an array of length 1
        // is a special case in the super.
        super(items.length);
        items.forEach((item, index)=>{
            this[index] = item;
        });
        // Find all unique keys
        const nameCounts = names.reduce((accum, name)=>{
            if (typeof name === "string") accum.set(name, (accum.get(name) || 0) + 1);
            return accum;
        }, new Map());
        // Remove any key thats not unique
        this.#names = Object.freeze(items.map((item, index)=>{
            const name = names[index];
            if (name != null && nameCounts.get(name) === 1) return name;
            return null;
        }));
        if (!wrap) return;
        // A wrapped Result is immutable
        Object.freeze(this);
        // Proxy indices and names so we can trap deferred errors
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "string") {
                    // Index accessor
                    if (prop.match(/^[0-9]+$/)) {
                        const index = (0, $6fa405e57bb6371e$export$b14f2714108df84)(prop, "%index");
                        if (index < 0 || index >= this.length) throw new RangeError("out of result range");
                        const item = target[index];
                        if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
                        return item;
                    }
                    // Pass important checks (like `then` for Promise) through
                    if ($6b2ae433bec33333$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                    const value = target[prop];
                    if (value instanceof Function) // Make sure functions work with private variables
                    // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Proxy#no_private_property_forwarding
                    return function(...args) {
                        return value.apply(this === receiver ? target : this, args);
                    };
                    else if (!(prop in target)) // Possible name accessor
                    return target.getValue.apply(this === receiver ? target : this, [
                        prop
                    ]);
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    /**
     *  Returns the Result as a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */ toArray() {
        const result = [];
        this.forEach((item, index)=>{
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${index}`, item);
            result.push(item);
        });
        return result;
    }
    /**
     *  Returns the Result as an Object with each name-value pair.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */ toObject() {
        return this.#names.reduce((accum, name, index)=>{
            (0, $634aa51198273feb$export$a7a9523472993e97)(name != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
                operation: "toObject()"
            });
            // Add values for names that don't conflict
            if (!(name in accum)) accum[name] = this.getValue(name);
            return accum;
        }, {});
    }
    /**
     *  @_ignore
     */ slice(start, end) {
        if (start == null) start = 0;
        if (start < 0) {
            start += this.length;
            if (start < 0) start = 0;
        }
        if (end == null) end = this.length;
        if (end < 0) {
            end += this.length;
            if (end < 0) end = 0;
        }
        if (end > this.length) end = this.length;
        const result = [], names = [];
        for(let i = start; i < end; i++){
            result.push(this[i]);
            names.push(this.#names[i]);
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ filter(callback, thisArg) {
        const result = [], names = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            if (callback.call(thisArg, item, i, this)) {
                result.push(item);
                names.push(this.#names[i]);
            }
        }
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, result, names);
    }
    /**
     *  @_ignore
     */ map(callback, thisArg) {
        const result = [];
        for(let i = 0; i < this.length; i++){
            const item = this[i];
            if (item instanceof Error) $6b2ae433bec33333$var$throwError(`index ${i}`, item);
            result.push(callback.call(thisArg, item, i, this));
        }
        return result;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */ getValue(name) {
        const index = this.#names.indexOf(name);
        if (index === -1) return undefined;
        const value = this[index];
        if (value instanceof Error) $6b2ae433bec33333$var$throwError(`property ${JSON.stringify(name)}`, value.error);
        return value;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */ static fromItems(items, keys) {
        return new $6b2ae433bec33333$export$8fdcabde73f49165($6b2ae433bec33333$var$_guard, items, keys);
    }
}
function $6b2ae433bec33333$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
function $6b2ae433bec33333$var$getValue(value) {
    let bytes = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    (0, $634aa51198273feb$export$a7a9523472993e97)(bytes.length <= $6b2ae433bec33333$export$b4b1d1fba463e69c, "value out-of-bounds", "BUFFER_OVERRUN", {
        buffer: bytes,
        length: $6b2ae433bec33333$export$b4b1d1fba463e69c,
        offset: bytes.length
    });
    if (bytes.length !== $6b2ae433bec33333$export$b4b1d1fba463e69c) bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        $6b2ae433bec33333$var$Padding.slice(bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c),
        bytes
    ]));
    return bytes;
}
class $6b2ae433bec33333$export$2c0c39526f8bad46 {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    name;
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    type;
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    localName;
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    dynamic;
    constructor(name, type, localName, dynamic){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            localName: localName,
            dynamic: dynamic
        }, {
            name: "string",
            type: "string",
            localName: "string",
            dynamic: "boolean"
        });
    }
    _throwError(message, value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, message, this.localName, value);
    }
}
class $6b2ae433bec33333$export$d7a960146e1a269e {
    // An array of WordSize lengthed objects to concatenation
    #data;
    #dataLength;
    constructor(){
        this.#data = [];
        this.#dataLength = 0;
    }
    get data() {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(this.#data);
    }
    get length() {
        return this.#dataLength;
    }
    #writeData(data) {
        this.#data.push(data);
        this.#dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this.#writeData((0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(writer.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(value) {
        let bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(value);
        const paddingOffset = bytes.length % $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (paddingOffset) bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            bytes,
            $6b2ae433bec33333$var$Padding.slice(paddingOffset)
        ]));
        return this.#writeData(bytes);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(value) {
        return this.#writeData($6b2ae433bec33333$var$getValue(value));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
        const offset = this.#data.length;
        this.#data.push($6b2ae433bec33333$var$Padding);
        this.#dataLength += $6b2ae433bec33333$export$b4b1d1fba463e69c;
        return (value)=>{
            this.#data[offset] = $6b2ae433bec33333$var$getValue(value);
        };
    }
}
class $6b2ae433bec33333$export$2f7a2f0e90c07dc4 {
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    allowLoose;
    #data;
    #offset;
    constructor(data, allowLoose){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            allowLoose: !!allowLoose
        });
        this.#data = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(data);
        this.#offset = 0;
    }
    get data() {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#data);
    }
    get dataLength() {
        return this.#data.length;
    }
    get consumed() {
        return this.#offset;
    }
    get bytes() {
        return new Uint8Array(this.#data);
    }
    #peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / $6b2ae433bec33333$export$b4b1d1fba463e69c) * $6b2ae433bec33333$export$b4b1d1fba463e69c;
        if (this.#offset + alignedLength > this.#data.length) {
            if (this.allowLoose && loose && this.#offset + length <= this.#data.length) alignedLength = length;
            else (0, $634aa51198273feb$export$a7a9523472993e97)(false, "data out-of-bounds", "BUFFER_OVERRUN", {
                buffer: (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(this.#data),
                length: this.#data.length,
                offset: this.#offset + alignedLength
            });
        }
        return this.#data.slice(this.#offset, this.#offset + alignedLength);
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(offset) {
        return new $6b2ae433bec33333$export$2f7a2f0e90c07dc4(this.#data.slice(this.#offset + offset), this.allowLoose);
    }
    // Read bytes
    readBytes(length, loose) {
        let bytes = this.#peekBytes(0, length, !!loose);
        this.#offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    // Read a numeric values
    readValue() {
        return (0, $6fa405e57bb6371e$export$c221a145703ab783)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
    readIndex() {
        return (0, $6fa405e57bb6371e$export$a0a81dc3380ce7d3)(this.readBytes($6b2ae433bec33333$export$b4b1d1fba463e69c));
    }
}




const $69ef3f917ff239a2$var$BN_0 = BigInt(0);
const $69ef3f917ff239a2$var$BN_36 = BigInt(36);
function $69ef3f917ff239a2$var$getChecksumAddress(address) {
    //    if (!isHexString(address, 20)) {
    //        logger.throwArgumentError("invalid address", "address", address);
    //    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $69ef3f917ff239a2$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$69ef3f917ff239a2$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$69ef3f917ff239a2$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
// i.e. Math.floor(Math.log10(Number.MAX_SAFE_INTEGER));
const $69ef3f917ff239a2$var$safeDigits = 15;
function $69ef3f917ff239a2$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $69ef3f917ff239a2$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $69ef3f917ff239a2$var$safeDigits){
        let block = expanded.substring(0, $69ef3f917ff239a2$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
const $69ef3f917ff239a2$var$Base36 = function() {
    const result = {};
    for(let i = 0; i < 36; i++){
        const key = "0123456789abcdefghijklmnopqrstuvwxyz"[i];
        result[key] = BigInt(i);
    }
    return result;
}();
function $69ef3f917ff239a2$var$fromBase36(value) {
    value = value.toLowerCase();
    let result = $69ef3f917ff239a2$var$BN_0;
    for(let i = 0; i < value.length; i++)result = result * $69ef3f917ff239a2$var$BN_36 + $69ef3f917ff239a2$var$Base36[value[i]];
    return result;
}
function $69ef3f917ff239a2$export$88411125f012957a(address) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof address === "string", "invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (!address.startsWith("0x")) address = "0x" + address;
        const result = $69ef3f917ff239a2$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || result === address, "bad address checksum", "address", address);
        return result;
    }
    // Maybe ICAP? (we only support direct mode)
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(address.substring(2, 4) === $69ef3f917ff239a2$var$ibanChecksum(address), "bad icap checksum", "address", address);
        let result = $69ef3f917ff239a2$var$fromBase36(address.substring(4)).toString(16);
        while(result.length < 40)result = "0" + result;
        return $69ef3f917ff239a2$var$getChecksumAddress("0x" + result);
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid address", "address", address);
}
function $69ef3f917ff239a2$export$962c4ddada9f668f(address) {
    //let base36 = _base16To36(getAddress(address).substring(2)).toUpperCase();
    let base36 = BigInt($69ef3f917ff239a2$export$88411125f012957a(address)).toString(36).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $69ef3f917ff239a2$var$ibanChecksum("XE00" + base36) + base36;
}



/**
 *  A Typed object allows a value to have its type explicitly
 *  specified.
 *
 *  For example, in Solidity, the value ``45`` could represent a
 *  ``uint8`` or a ``uint256``. The value ``0x1234`` could represent
 *  a ``bytes2`` or ``bytes``.
 *
 *  Since JavaScript has no meaningful way to explicitly inform any
 *  APIs which what the type is, this allows transparent interoperation
 *  with Soldity.
 *
 *  @_subsection: api/abi:Typed Values
 */ 
const $f832d0621d63460e$var$_gaurd = {};
function $f832d0621d63460e$var$n(value, width) {
    let signed = false;
    if (width < 0) {
        signed = true;
        width *= -1;
    }
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `${signed ? "" : "u"}int${width}`, value, {
        signed: signed,
        width: width
    });
}
function $f832d0621d63460e$var$b(value, size) {
    // @TODO: Check range is valid for value
    return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, `bytes${size ? size : ""}`, value, {
        size: size
    });
}
const $f832d0621d63460e$var$_typedSymbol = Symbol.for("_ethers_typed");
class $f832d0621d63460e$export$af51273277efe223 {
    /**
     *  The type, as a Solidity-compatible type.
     */ type;
    /**
     *  The actual value.
     */ value;
    #options;
    /**
     *  @_ignore:
     */ _typedSymbol;
    /**
     *  @_ignore:
     */ constructor(gaurd, type, value, options){
        if (options == null) options = null;
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)($f832d0621d63460e$var$_gaurd, gaurd, "Typed");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            _typedSymbol: $f832d0621d63460e$var$_typedSymbol,
            type: type,
            value: value
        });
        this.#options = options;
        // Check the value is valid
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */ format() {
        if (this.type === "array") throw new Error("");
        else if (this.type === "dynamicArray") throw new Error("");
        else if (this.type === "tuple") return `tuple(${this.value.map((v)=>v.format()).join(",")})`;
        return this.type;
    }
    /**
     *  The default value returned by this type.
     */ defaultValue() {
        return 0;
    }
    /**
     *  The minimum value for numeric types.
     */ minValue() {
        return 0;
    }
    /**
     *  The maximum value for numeric types.
     */ maxValue() {
        return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */ isBigInt() {
        return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */ isData() {
        return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */ isString() {
        return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */ get tupleName() {
        if (this.type !== "tuple") throw TypeError("not a tuple");
        return this.#options;
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */ get arrayLength() {
        if (this.type !== "array") throw TypeError("not an array");
        if (this.#options === true) return -1;
        if (this.#options === false) return this.value.length;
        return null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */ static from(type, value) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, type, value);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static uint8(v) {
        return $f832d0621d63460e$var$n(v, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */ static uint16(v) {
        return $f832d0621d63460e$var$n(v, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */ static uint24(v) {
        return $f832d0621d63460e$var$n(v, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */ static uint32(v) {
        return $f832d0621d63460e$var$n(v, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */ static uint40(v) {
        return $f832d0621d63460e$var$n(v, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */ static uint48(v) {
        return $f832d0621d63460e$var$n(v, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */ static uint56(v) {
        return $f832d0621d63460e$var$n(v, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */ static uint64(v) {
        return $f832d0621d63460e$var$n(v, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */ static uint72(v) {
        return $f832d0621d63460e$var$n(v, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */ static uint80(v) {
        return $f832d0621d63460e$var$n(v, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */ static uint88(v) {
        return $f832d0621d63460e$var$n(v, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */ static uint96(v) {
        return $f832d0621d63460e$var$n(v, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */ static uint104(v) {
        return $f832d0621d63460e$var$n(v, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */ static uint112(v) {
        return $f832d0621d63460e$var$n(v, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */ static uint120(v) {
        return $f832d0621d63460e$var$n(v, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */ static uint128(v) {
        return $f832d0621d63460e$var$n(v, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */ static uint136(v) {
        return $f832d0621d63460e$var$n(v, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */ static uint144(v) {
        return $f832d0621d63460e$var$n(v, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */ static uint152(v) {
        return $f832d0621d63460e$var$n(v, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */ static uint160(v) {
        return $f832d0621d63460e$var$n(v, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */ static uint168(v) {
        return $f832d0621d63460e$var$n(v, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */ static uint176(v) {
        return $f832d0621d63460e$var$n(v, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */ static uint184(v) {
        return $f832d0621d63460e$var$n(v, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */ static uint192(v) {
        return $f832d0621d63460e$var$n(v, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */ static uint200(v) {
        return $f832d0621d63460e$var$n(v, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */ static uint208(v) {
        return $f832d0621d63460e$var$n(v, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */ static uint216(v) {
        return $f832d0621d63460e$var$n(v, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */ static uint224(v) {
        return $f832d0621d63460e$var$n(v, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */ static uint232(v) {
        return $f832d0621d63460e$var$n(v, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */ static uint240(v) {
        return $f832d0621d63460e$var$n(v, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */ static uint248(v) {
        return $f832d0621d63460e$var$n(v, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint256(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */ static uint(v) {
        return $f832d0621d63460e$var$n(v, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */ static int8(v) {
        return $f832d0621d63460e$var$n(v, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */ static int16(v) {
        return $f832d0621d63460e$var$n(v, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */ static int24(v) {
        return $f832d0621d63460e$var$n(v, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */ static int32(v) {
        return $f832d0621d63460e$var$n(v, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */ static int40(v) {
        return $f832d0621d63460e$var$n(v, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */ static int48(v) {
        return $f832d0621d63460e$var$n(v, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */ static int56(v) {
        return $f832d0621d63460e$var$n(v, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */ static int64(v) {
        return $f832d0621d63460e$var$n(v, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */ static int72(v) {
        return $f832d0621d63460e$var$n(v, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */ static int80(v) {
        return $f832d0621d63460e$var$n(v, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */ static int88(v) {
        return $f832d0621d63460e$var$n(v, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */ static int96(v) {
        return $f832d0621d63460e$var$n(v, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */ static int104(v) {
        return $f832d0621d63460e$var$n(v, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */ static int112(v) {
        return $f832d0621d63460e$var$n(v, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */ static int120(v) {
        return $f832d0621d63460e$var$n(v, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */ static int128(v) {
        return $f832d0621d63460e$var$n(v, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */ static int136(v) {
        return $f832d0621d63460e$var$n(v, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */ static int144(v) {
        return $f832d0621d63460e$var$n(v, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */ static int152(v) {
        return $f832d0621d63460e$var$n(v, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */ static int160(v) {
        return $f832d0621d63460e$var$n(v, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */ static int168(v) {
        return $f832d0621d63460e$var$n(v, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */ static int176(v) {
        return $f832d0621d63460e$var$n(v, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */ static int184(v) {
        return $f832d0621d63460e$var$n(v, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */ static int192(v) {
        return $f832d0621d63460e$var$n(v, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */ static int200(v) {
        return $f832d0621d63460e$var$n(v, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */ static int208(v) {
        return $f832d0621d63460e$var$n(v, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */ static int216(v) {
        return $f832d0621d63460e$var$n(v, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */ static int224(v) {
        return $f832d0621d63460e$var$n(v, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */ static int232(v) {
        return $f832d0621d63460e$var$n(v, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */ static int240(v) {
        return $f832d0621d63460e$var$n(v, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */ static int248(v) {
        return $f832d0621d63460e$var$n(v, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int256(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */ static int(v) {
        return $f832d0621d63460e$var$n(v, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */ static bytes1(v) {
        return $f832d0621d63460e$var$b(v, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */ static bytes2(v) {
        return $f832d0621d63460e$var$b(v, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */ static bytes3(v) {
        return $f832d0621d63460e$var$b(v, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */ static bytes4(v) {
        return $f832d0621d63460e$var$b(v, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */ static bytes5(v) {
        return $f832d0621d63460e$var$b(v, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */ static bytes6(v) {
        return $f832d0621d63460e$var$b(v, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */ static bytes7(v) {
        return $f832d0621d63460e$var$b(v, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */ static bytes8(v) {
        return $f832d0621d63460e$var$b(v, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */ static bytes9(v) {
        return $f832d0621d63460e$var$b(v, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */ static bytes10(v) {
        return $f832d0621d63460e$var$b(v, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */ static bytes11(v) {
        return $f832d0621d63460e$var$b(v, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */ static bytes12(v) {
        return $f832d0621d63460e$var$b(v, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */ static bytes13(v) {
        return $f832d0621d63460e$var$b(v, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */ static bytes14(v) {
        return $f832d0621d63460e$var$b(v, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */ static bytes15(v) {
        return $f832d0621d63460e$var$b(v, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */ static bytes16(v) {
        return $f832d0621d63460e$var$b(v, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */ static bytes17(v) {
        return $f832d0621d63460e$var$b(v, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */ static bytes18(v) {
        return $f832d0621d63460e$var$b(v, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */ static bytes19(v) {
        return $f832d0621d63460e$var$b(v, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */ static bytes20(v) {
        return $f832d0621d63460e$var$b(v, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */ static bytes21(v) {
        return $f832d0621d63460e$var$b(v, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */ static bytes22(v) {
        return $f832d0621d63460e$var$b(v, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */ static bytes23(v) {
        return $f832d0621d63460e$var$b(v, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */ static bytes24(v) {
        return $f832d0621d63460e$var$b(v, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */ static bytes25(v) {
        return $f832d0621d63460e$var$b(v, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */ static bytes26(v) {
        return $f832d0621d63460e$var$b(v, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */ static bytes27(v) {
        return $f832d0621d63460e$var$b(v, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */ static bytes28(v) {
        return $f832d0621d63460e$var$b(v, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */ static bytes29(v) {
        return $f832d0621d63460e$var$b(v, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */ static bytes30(v) {
        return $f832d0621d63460e$var$b(v, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */ static bytes31(v) {
        return $f832d0621d63460e$var$b(v, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */ static bytes32(v) {
        return $f832d0621d63460e$var$b(v, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */ static address(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "address", v);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */ static bool(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bool", !!v);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */ static bytes(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "bytes", v);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */ static string(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "string", v);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */ static array(v, dynamic) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */ static tuple(v, name) {
        throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */ static overrides(v) {
        return new $f832d0621d63460e$export$af51273277efe223($f832d0621d63460e$var$_gaurd, "overrides", Object.assign({}, v));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */ static isTyped(value) {
        return value && typeof value === "object" && "_typedSymbol" in value && value._typedSymbol === $f832d0621d63460e$var$_typedSymbol;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */ static dereference(value, type) {
        if ($f832d0621d63460e$export$af51273277efe223.isTyped(value)) {
            if (value.type !== type) throw new Error(`invalid type: expecetd ${type}, got ${value.type}`);
            return value.value;
        }
        return value;
    }
}



class $cfcca69ef482e07c$export$59dbbded7775bfe7 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, _value) {
        let value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "string");
        try {
            value = (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
        } catch (error) {
            return this._throwError(error.message, _value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $6fa405e57bb6371e$export$c6ebe05badb16181)(reader.readValue(), 20));
    }
}






class $ad85f24c4bcad69a$export$87c41d1139a03fa2 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coder;
    constructor(coder){
        super(coder.name, coder.type, "_", coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


function $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = [];
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            (0, $634aa51198273feb$export$a7a9523472993e97)(name, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            (0, $634aa51198273feb$export$a7a9523472993e97)(!unique[name], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
                argument: "values",
                info: {
                    coder: coder
                },
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid tuple value", "tuple", values);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(coders.length === arrayValues.length, "types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
    let dynamicWriter = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $ea15fb9331abacb9$export$417857010dc9287f(reader, coders) {
    let values = [];
    let keys = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readIndex();
            let offsetReader = baseReader.subReader(offset);
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BUFFER_OVERRUN")) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value == undefined) throw new Error("investigate");
        values.push(value);
        keys.push(coder.localName || null);
    });
    return (0, $6b2ae433bec33333$export$8fdcabde73f49165).fromItems(values, keys);
}
class $ea15fb9331abacb9$export$88bc419d2df11f54 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coder;
    length;
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            coder: coder,
            length: length
        });
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "array");
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        (0, $634aa51198273feb$export$d228410a8a77e4fa)(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $ea15fb9331abacb9$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readIndex();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            (0, $634aa51198273feb$export$a7a9523472993e97)(count * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c) <= reader.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
                buffer: reader.bytes,
                offset: count * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c),
                length: reader.dataLength
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $ad85f24c4bcad69a$export$87c41d1139a03fa2)(this.coder));
        return $ea15fb9331abacb9$export$417857010dc9287f(reader, coders);
    }
}




class $8bb37f15c6403170$export$fe9118d6c093150c extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "bool");
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return !!reader.readValue();
    }
}




class $a77ec8c966f279c9$export$db9eadd8df12ad2e extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readIndex(), true);
    }
}
class $a77ec8c966f279c9$export$e5823e9574df18d2 extends $a77ec8c966f279c9$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(super.decode(reader));
    }
}





class $dc246983eaa4ec58$export$7dec9db68e6bcf5a extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    size;
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            size: size
        }, {
            size: "number"
        });
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, _value) {
        let data = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, this.type));
        if (data.length !== this.size) this._throwError("incorrect data length", _value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(reader.readBytes(this.size));
    }
}



const $720930767e786ee7$var$Empty = new Uint8Array([]);
class $720930767e786ee7$export$70982cadf2d6b4ec extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes($720930767e786ee7$var$Empty);
    }
    decode(reader) {
        reader.readBytes(0);
        return null;
    }
}





const $0cff167f1e2d418f$var$BN_0 = BigInt(0);
const $0cff167f1e2d418f$var$BN_1 = BigInt(1);
const $0cff167f1e2d418f$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class $0cff167f1e2d418f$export$b934dc8cfe13938c extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    size;
    signed;
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            size: size,
            signed: signed
        }, {
            size: "number",
            signed: "boolean"
        });
    }
    defaultValue() {
        return 0;
    }
    encode(writer, _value) {
        let value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, this.type));
        // Check bounds are safe for encoding
        let maxUintValue = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)($0cff167f1e2d418f$var$BN_MAX_UINT256, (0, $6b2ae433bec33333$export$b4b1d1fba463e69c) * 8);
        if (this.signed) {
            let bounds = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8 - 1);
            if (value > bounds || value < -(bounds + $0cff167f1e2d418f$var$BN_1)) this._throwError("value out-of-bounds", _value);
            value = (0, $6fa405e57bb6371e$export$7101cd4e6275351c)(value, 8 * (0, $6b2ae433bec33333$export$b4b1d1fba463e69c));
        } else if (value < $0cff167f1e2d418f$var$BN_0 || value > (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(maxUintValue, this.size * 8)) this._throwError("value out-of-bounds", _value);
        return writer.writeValue(value);
    }
    decode(reader) {
        let value = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)(reader.readValue(), this.size * 8);
        if (this.signed) value = (0, $6fa405e57bb6371e$export$92182edcfa20e5bc)(value, this.size * 8);
        return value;
    }
}





class $b65d6b3f7161a036$export$2d1b854518731426 extends (0, $a77ec8c966f279c9$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, _value) {
        return super.encode(writer, (0, $50aa15ceb128a952$export$8feeb310b4b4752f)((0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "string")));
    }
    decode(reader) {
        return (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}






class $80973df8073baca7$export$e9fceba8f110fea6 extends (0, $6b2ae433bec33333$export$2c0c39526f8bad46) {
    coders;
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            coders: Object.freeze(coders.slice())
        });
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, _value) {
        const value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(_value, "tuple");
        return (0, $ea15fb9331abacb9$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return (0, $ea15fb9331abacb9$export$417857010dc9287f)(reader, this.coders);
    }
}


/**
 *  A fragment is a single item from an ABI, which may represent any of:
 *
 *  - [Functions](FunctionFragment)
 *  - [Events](EventFragment)
 *  - [Constructors](ConstructorFragment)
 *  - Custom [Errors](ErrorFragment)
 *  - [Fallback or Receive](FallbackFragment) functions
 *
 *  @_subsection api/abi/abi-coder:Fragments  [about-fragments]
 */ 

// [ "a", "b" ] => { "a": 1, "b": 1 }
function $7316d9256af52303$var$setify(items) {
    const result = new Set();
    items.forEach((k)=>result.add(k));
    return Object.freeze(result);
}
const $7316d9256af52303$var$_kwVisibDeploy = "external public payable";
const $7316d9256af52303$var$KwVisibDeploy = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisibDeploy.split(" "));
// Visibility Keywords
const $7316d9256af52303$var$_kwVisib = "constant external internal payable private public pure view";
const $7316d9256af52303$var$KwVisib = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwVisib.split(" "));
const $7316d9256af52303$var$_kwTypes = "constructor error event fallback function receive struct";
const $7316d9256af52303$var$KwTypes = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwTypes.split(" "));
const $7316d9256af52303$var$_kwModifiers = "calldata memory storage payable indexed";
const $7316d9256af52303$var$KwModifiers = $7316d9256af52303$var$setify($7316d9256af52303$var$_kwModifiers.split(" "));
const $7316d9256af52303$var$_kwOther = "tuple returns";
// All Keywords
const $7316d9256af52303$var$_keywords = [
    $7316d9256af52303$var$_kwTypes,
    $7316d9256af52303$var$_kwModifiers,
    $7316d9256af52303$var$_kwOther,
    $7316d9256af52303$var$_kwVisib
].join(" ");
const $7316d9256af52303$var$Keywords = $7316d9256af52303$var$setify($7316d9256af52303$var$_keywords.split(" "));
// Single character tokens
const $7316d9256af52303$var$SimpleTokens = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT"
};
// Parser regexes to consume the next token
const $7316d9256af52303$var$regexWhitespacePrefix = new RegExp("^(\\s*)");
const $7316d9256af52303$var$regexNumberPrefix = new RegExp("^([0-9]+)");
const $7316d9256af52303$var$regexIdPrefix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)");
// Parser regexs to check validity
const $7316d9256af52303$var$regexId = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$");
const $7316d9256af52303$var$regexType = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
class $7316d9256af52303$var$TokenString {
    #offset;
    #tokens;
    get offset() {
        return this.#offset;
    }
    get length() {
        return this.#tokens.length - this.#offset;
    }
    constructor(tokens){
        this.#offset = 0;
        this.#tokens = tokens.slice();
    }
    clone() {
        return new $7316d9256af52303$var$TokenString(this.#tokens);
    }
    reset() {
        this.#offset = 0;
    }
    #subTokenString(from = 0, to = 0) {
        return new $7316d9256af52303$var$TokenString(this.#tokens.slice(from, to).map((t)=>{
            return Object.freeze(Object.assign({}, t, {
                match: t.match - from,
                linkBack: t.linkBack - from,
                linkNext: t.linkNext - from
            }));
        }));
    }
    // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
    popKeyword(allowed) {
        const top = this.peek();
        if (top.type !== "KEYWORD" || !allowed.has(top.text)) throw new Error(`expected keyword ${top.text}`);
        return this.pop().text;
    }
    // Pops and returns the value of the next token if it is `type`; throws if out of tokens
    popType(type) {
        if (this.peek().type !== type) throw new Error(`expected ${type}; got ${JSON.stringify(this.peek())}`);
        return this.pop().text;
    }
    // Pops and returns a "(" TOKENS ")"
    popParen() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = this.#subTokenString(this.#offset + 1, top.match + 1);
        this.#offset = top.match + 1;
        return result;
    }
    // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
    popParams() {
        const top = this.peek();
        if (top.type !== "OPEN_PAREN") throw new Error("bad start");
        const result = [];
        while(this.#offset < top.match - 1){
            const link = this.peek().linkNext;
            result.push(this.#subTokenString(this.#offset + 1, link));
            this.#offset = link;
        }
        this.#offset = top.match + 1;
        return result;
    }
    // Returns the top Token, throwing if out of tokens
    peek() {
        if (this.#offset >= this.#tokens.length) throw new Error("out-of-bounds");
        return this.#tokens[this.#offset];
    }
    // Returns the next value, if it is a keyword in `allowed`
    peekKeyword(allowed) {
        const top = this.peekType("KEYWORD");
        return top != null && allowed.has(top) ? top : null;
    }
    // Returns the value of the next token if it is `type`
    peekType(type) {
        if (this.length === 0) return null;
        const top = this.peek();
        return top.type === type ? top.text : null;
    }
    // Returns the next token; throws if out of tokens
    pop() {
        const result = this.peek();
        this.#offset++;
        return result;
    }
    toString() {
        const tokens = [];
        for(let i = this.#offset; i < this.#tokens.length; i++){
            const token = this.#tokens[i];
            tokens.push(`${token.type}:${token.text}`);
        }
        return `<TokenString ${tokens.join(" ")}>`;
    }
}
function $7316d9256af52303$var$lex(text) {
    const tokens = [];
    const throwError = (message)=>{
        const token = offset < text.length ? JSON.stringify(text[offset]) : "$EOI";
        throw new Error(`invalid token ${token} at ${offset}: ${message}`);
    };
    let brackets = [];
    let commas = [];
    let offset = 0;
    while(offset < text.length){
        // Strip off any leading whitespace
        let cur = text.substring(offset);
        let match = cur.match($7316d9256af52303$var$regexWhitespacePrefix);
        if (match) {
            offset += match[1].length;
            cur = text.substring(offset);
        }
        const token = {
            depth: brackets.length,
            linkBack: -1,
            linkNext: -1,
            match: -1,
            type: "",
            text: "",
            offset: offset,
            value: -1
        };
        tokens.push(token);
        let type = $7316d9256af52303$var$SimpleTokens[cur[0]] || "";
        if (type) {
            token.type = type;
            token.text = cur[0];
            offset++;
            if (type === "OPEN_PAREN") {
                brackets.push(tokens.length - 1);
                commas.push(tokens.length - 1);
            } else if (type == "CLOSE_PAREN") {
                if (brackets.length === 0) throwError("no matching open bracket");
                token.match = brackets.pop();
                tokens[token.match].match = tokens.length - 1;
                token.depth--;
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
            } else if (type === "COMMA") {
                token.linkBack = commas.pop();
                tokens[token.linkBack].linkNext = tokens.length - 1;
                commas.push(tokens.length - 1);
            } else if (type === "OPEN_BRACKET") token.type = "BRACKET";
            else if (type === "CLOSE_BRACKET") {
                // Remove the CLOSE_BRACKET
                let suffix = tokens.pop().text;
                if (tokens.length > 0 && tokens[tokens.length - 1].type === "NUMBER") {
                    const value = tokens.pop().text;
                    suffix = value + suffix;
                    tokens[tokens.length - 1].value = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value);
                }
                if (tokens.length === 0 || tokens[tokens.length - 1].type !== "BRACKET") throw new Error("missing opening bracket");
                tokens[tokens.length - 1].text += suffix;
            }
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexIdPrefix);
        if (match) {
            token.text = match[1];
            offset += token.text.length;
            if ($7316d9256af52303$var$Keywords.has(token.text)) {
                token.type = "KEYWORD";
                continue;
            }
            if (token.text.match($7316d9256af52303$var$regexType)) {
                token.type = "TYPE";
                continue;
            }
            token.type = "ID";
            continue;
        }
        match = cur.match($7316d9256af52303$var$regexNumberPrefix);
        if (match) {
            token.text = match[1];
            token.type = "NUMBER";
            offset += token.text.length;
            continue;
        }
        throw new Error(`unexpected token ${JSON.stringify(cur[0])} at position ${offset}`);
    }
    return new $7316d9256af52303$var$TokenString(tokens.map((t)=>Object.freeze(t)));
}
// Check only one of `allowed` is in `set`
function $7316d9256af52303$var$allowSingle(set, allowed) {
    let included = [];
    for(const key in allowed.keys())if (set.has(key)) included.push(key);
    if (included.length > 1) throw new Error(`conflicting types: ${included.join(", ")}`);
}
// Functions to process a Solidity Signature TokenString from left-to-right for...
// ...the name with an optional type, returning the name
function $7316d9256af52303$var$consumeName(type, tokens) {
    if (tokens.peekKeyword($7316d9256af52303$var$KwTypes)) {
        const keyword = tokens.pop().text;
        if (keyword !== type) throw new Error(`expected ${type}, got ${keyword}`);
    }
    return tokens.popType("ID");
}
// ...all keywords matching allowed, returning the keywords
function $7316d9256af52303$var$consumeKeywords(tokens, allowed) {
    const keywords = new Set();
    while(true){
        const keyword = tokens.peekType("KEYWORD");
        if (keyword == null || allowed && !allowed.has(keyword)) break;
        tokens.pop();
        if (keywords.has(keyword)) throw new Error(`duplicate keywords: ${JSON.stringify(keyword)}`);
        keywords.add(keyword);
    }
    return Object.freeze(keywords);
}
// ...all visibility keywords, returning the coalesced mutability
function $7316d9256af52303$var$consumeMutability(tokens) {
    let modifiers = $7316d9256af52303$var$consumeKeywords(tokens, $7316d9256af52303$var$KwVisib);
    // Detect conflicting modifiers
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("constant payable nonpayable".split(" ")));
    $7316d9256af52303$var$allowSingle(modifiers, $7316d9256af52303$var$setify("pure view payable nonpayable".split(" ")));
    // Process mutability states
    if (modifiers.has("view")) return "view";
    if (modifiers.has("pure")) return "pure";
    if (modifiers.has("payable")) return "payable";
    if (modifiers.has("nonpayable")) return "nonpayable";
    // Process legacy `constant` last
    if (modifiers.has("constant")) return "view";
    return "nonpayable";
}
// ...a parameter list, returning the ParamType list
function $7316d9256af52303$var$consumeParams(tokens, allowIndexed) {
    return tokens.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t, allowIndexed));
}
// ...a gas limit, returning a BigNumber or null if none
function $7316d9256af52303$var$consumeGas(tokens) {
    if (tokens.peekType("AT")) {
        tokens.pop();
        if (tokens.peekType("NUMBER")) return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tokens.pop().text);
        throw new Error("invalid gas");
    }
    return null;
}
function $7316d9256af52303$var$consumeEoi(tokens) {
    if (tokens.length) throw new Error(`unexpected tokens: ${tokens.toString()}`);
}
const $7316d9256af52303$var$regexArrayType = new RegExp(/^(.*)\[([0-9]*)\]$/);
function $7316d9256af52303$var$verifyBasicType(type) {
    const match = type.match($7316d9256af52303$var$regexType);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(match, "invalid type", "type", type);
    if (type === "uint") return "uint256";
    if (type === "int") return "int256";
    if (match[2]) {
        // bytesXX
        const length = parseInt(match[2]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(length !== 0 && length <= 32, "invalid bytes length", "type", type);
    } else if (match[3]) {
        // intXX or uintXX
        const size = parseInt(match[3]);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid numeric width", "type", type);
    }
    return type;
}
// Make the Fragment constructors effectively private
const $7316d9256af52303$var$_guard = {};
const $7316d9256af52303$var$internal = Symbol.for("_ethers_internal");
const $7316d9256af52303$var$ParamTypeInternal = "_ParamTypeInternal";
const $7316d9256af52303$var$ErrorFragmentInternal = "_ErrorInternal";
const $7316d9256af52303$var$EventFragmentInternal = "_EventInternal";
const $7316d9256af52303$var$ConstructorFragmentInternal = "_ConstructorInternal";
const $7316d9256af52303$var$FallbackFragmentInternal = "_FallbackInternal";
const $7316d9256af52303$var$FunctionFragmentInternal = "_FunctionInternal";
const $7316d9256af52303$var$StructFragmentInternal = "_StructInternal";
class $7316d9256af52303$export$426dc07f493a4c47 {
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */ name;
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */ type;
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */ baseType;
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */ indexed;
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */ components;
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */ arrayLength;
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */ arrayChildren;
    /**
     *  @private
     */ constructor(guard, name, type, baseType, indexed, components, arrayLength, arrayChildren){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "ParamType");
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ParamTypeInternal
        });
        if (components) components = Object.freeze(components.slice());
        if (baseType === "array") {
            if (arrayLength == null || arrayChildren == null) throw new Error("");
        } else if (arrayLength != null || arrayChildren != null) throw new Error("");
        if (baseType === "tuple") {
            if (components == null) throw new Error("");
        } else if (components != null) throw new Error("");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name,
            type: type,
            baseType: baseType,
            indexed: indexed,
            components: components,
            arrayLength: arrayLength,
            arrayChildren: arrayChildren
        });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") {
            const name = this.name || "";
            if (this.isArray()) {
                const result = JSON.parse(this.arrayChildren.format("json"));
                result.name = name;
                result.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
                return JSON.stringify(result);
            }
            const result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: name
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.isTuple()) result.components = this.components.map((c)=>JSON.parse(c.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.isArray()) {
            result += this.arrayChildren.format(format);
            result += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`;
        } else if (this.isTuple()) {
            if (format !== "sighash") result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === "full" ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== "sighash") {
            if (this.indexed === true) result += " indexed";
            if (format === "full" && this.name) result += " " + this.name;
        }
        return result;
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */ isArray() {
        return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */ isTuple() {
        return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */ isIndexable() {
        return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */ walk(value, process) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v)=>_this.arrayChildren.walk(v, process));
        }
        if (this.isTuple()) {
            if (!Array.isArray(value)) throw new Error("invalid tuple value");
            if (value.length !== this.components.length) throw new Error("array is wrong length");
            const _this = this;
            return value.map((v, i)=>_this.components[i].walk(v, process));
        }
        return process(this.type, value);
    }
    #walkAsync(promises, value, process, setValue) {
        if (this.isArray()) {
            if (!Array.isArray(value)) throw new Error("invalid array value");
            if (this.arrayLength !== -1 && value.length !== this.arrayLength) throw new Error("array is wrong length");
            const childType = this.arrayChildren;
            const result = value.slice();
            result.forEach((value, index)=>{
                childType.#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        if (this.isTuple()) {
            const components = this.components;
            // Convert the object into an array
            let result;
            if (Array.isArray(value)) result = value.slice();
            else {
                if (value == null || typeof value !== "object") throw new Error("invalid tuple value");
                result = components.map((param)=>{
                    if (!param.name) throw new Error("cannot use object value with unnamed components");
                    if (!(param.name in value)) throw new Error(`missing value for component ${param.name}`);
                    return value[param.name];
                });
            }
            if (result.length !== this.components.length) throw new Error("array is wrong length");
            result.forEach((value, index)=>{
                components[index].#walkAsync(promises, value, process, (value)=>{
                    result[index] = value;
                });
            });
            setValue(result);
            return;
        }
        const result = process(this.type, value);
        if (result.then) promises.push(async function() {
            setValue(await result);
        }());
        else setValue(result);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */ async walkAsync(value, process) {
        const promises = [];
        const result = [
            value
        ];
        this.#walkAsync(promises, value, process, (value)=>{
            result[0] = value;
        });
        if (promises.length) await Promise.all(promises);
        return result[0];
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */ static from(obj, allowIndexed) {
        if ($7316d9256af52303$export$426dc07f493a4c47.isParamType(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$426dc07f493a4c47.from($7316d9256af52303$var$lex(obj), allowIndexed);
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid param type", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            let type = "", baseType = "";
            let comps = null;
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "tuple"
            ])).has("tuple") || obj.peekType("OPEN_PAREN")) {
                // Tuple
                baseType = "tuple";
                comps = obj.popParams().map((t)=>$7316d9256af52303$export$426dc07f493a4c47.from(t));
                type = `tuple(${comps.map((c)=>c.format()).join(",")})`;
            } else {
                // Normal
                type = $7316d9256af52303$var$verifyBasicType(obj.popType("TYPE"));
                baseType = type;
            }
            // Check for Array
            let arrayChildren = null;
            let arrayLength = null;
            while(obj.length && obj.peekType("BRACKET")){
                const bracket = obj.pop(); //arrays[i];
                arrayChildren = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, "", type, baseType, null, comps, arrayLength, arrayChildren);
                arrayLength = bracket.value;
                type += bracket.text;
                baseType = "array";
                comps = null;
            }
            let indexed = null;
            const keywords = $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwModifiers);
            if (keywords.has("indexed")) {
                if (!allowIndexed) throw new Error("");
                indexed = true;
            }
            const name = obj.peekType("ID") ? obj.pop().text : "";
            if (obj.length) throw new Error("leftover tokens");
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name, type, baseType, indexed, comps, arrayLength, arrayChildren);
        }
        const name = obj.name;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!name || typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid name", "obj.name", name);
        let indexed = obj.indexed;
        if (indexed != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(allowIndexed, "parameter cannot be indexed", "obj.indexed", obj.indexed);
            indexed = !!indexed;
        }
        let type = obj.type;
        let arrayMatch = type.match($7316d9256af52303$var$regexArrayType);
        if (arrayMatch) {
            const arrayLength = parseInt(arrayMatch[2] || "-1");
            const arrayChildren = $7316d9256af52303$export$426dc07f493a4c47.from({
                type: arrayMatch[1],
                components: obj.components
            });
            return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "array", indexed, null, arrayLength, arrayChildren);
        }
        if (type === "tuple" || type.startsWith("tuple(" /* fix: ) */ ) || type.startsWith("(" /* fix: ) */ )) {
            const comps = obj.components != null ? obj.components.map((c)=>$7316d9256af52303$export$426dc07f493a4c47.from(c)) : null;
            const tuple = new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, "tuple", indexed, comps, null, null);
            // @TODO: use lexer to validate and normalize type
            return tuple;
        }
        type = $7316d9256af52303$var$verifyBasicType(obj.type);
        return new $7316d9256af52303$export$426dc07f493a4c47($7316d9256af52303$var$_guard, name || "", type, type, indexed, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */ static isParamType(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ParamTypeInternal;
    }
}
class $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The type of the fragment.
     */ type;
    /**
     *  The inputs for the fragment.
     */ inputs;
    /**
     *  @private
     */ constructor(guard, type, inputs){
        (0, $634aa51198273feb$export$ac1a938d48ec8c7b)(guard, $7316d9256af52303$var$_guard, "Fragment");
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            type: type,
            inputs: inputs
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */ static from(obj) {
        if (typeof obj === "string") {
            // Try parsing JSON...
            try {
                $7316d9256af52303$export$ffb0004e005737fa.from(JSON.parse(obj));
            } catch (e) {}
            // ...otherwise, use the human-readable lexer
            return $7316d9256af52303$export$ffb0004e005737fa.from($7316d9256af52303$var$lex(obj));
        }
        if (obj instanceof $7316d9256af52303$var$TokenString) {
            // Human-readable ABI (already lexed)
            const type = obj.peekKeyword($7316d9256af52303$var$KwTypes);
            switch(type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
        } else if (typeof obj === "object") {
            // JSON ABI
            switch(obj.type){
                case "constructor":
                    return $7316d9256af52303$export$3ac5c9504f801ea4.from(obj);
                case "error":
                    return $7316d9256af52303$export$2c42c6d543aa9b59.from(obj);
                case "event":
                    return $7316d9256af52303$export$958548f08bac2833.from(obj);
                case "fallback":
                case "receive":
                    return $7316d9256af52303$export$71b1ea64c89c20fc.from(obj);
                case "function":
                    return $7316d9256af52303$export$8d576c928b93668f.from(obj);
                case "struct":
                    return $7316d9256af52303$export$9f91ba10bb234ec7.from(obj);
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `unsupported type: ${obj.type}`, "UNSUPPORTED_OPERATION", {
                operation: "Fragment.from"
            });
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported frgament object", "obj", obj);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */ static isConstructor(value) {
        return $7316d9256af52303$export$3ac5c9504f801ea4.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */ static isError(value) {
        return $7316d9256af52303$export$2c42c6d543aa9b59.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */ static isEvent(value) {
        return $7316d9256af52303$export$958548f08bac2833.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */ static isFunction(value) {
        return $7316d9256af52303$export$8d576c928b93668f.isFragment(value);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */ static isStruct(value) {
        return $7316d9256af52303$export$9f91ba10bb234ec7.isFragment(value);
    }
}
class $7316d9256af52303$export$85c6fc53d6299173 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  The name of the fragment.
     */ name;
    /**
     *  @private
     */ constructor(guard, type, name, inputs){
        super(guard, type, inputs);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof name === "string" && name.match($7316d9256af52303$var$regexId), "invalid identifier", "name", name);
        inputs = Object.freeze(inputs.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
}
function $7316d9256af52303$var$joinParams(format, params) {
    return "(" + params.map((p)=>p.format(format)).join(format === "full" ? ", " : ",") + ")";
}
class $7316d9256af52303$export$2c42c6d543aa9b59 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "error", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ErrorFragmentInternal
        });
    }
    /**
     *  The Custom Error selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this fragment as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("error");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        return result.join(" ");
    }
    /**
     *  Returns a new **ErrorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$2c42c6d543aa9b59.isFragment(obj)) return obj;
        if (typeof obj === "string") return $7316d9256af52303$export$2c42c6d543aa9b59.from($7316d9256af52303$var$lex(obj));
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("error", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$2c42c6d543aa9b59($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **ErrorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ErrorFragmentInternal;
    }
}
class $7316d9256af52303$export$958548f08bac2833 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  Whether this event is anonymous.
     */ anonymous;
    /**
     *  @private
     */ constructor(guard, name, inputs, anonymous){
        super(guard, "event", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$EventFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            anonymous: anonymous
        });
    }
    /**
     *  The Event topic hash.
     */ get topicHash() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("event");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash" && this.anonymous) result.push("anonymous");
        return result.join(" ");
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */ static getTopicHash(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, params, false);
        return fragment.topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$958548f08bac2833.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$958548f08bac2833.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid event fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("event", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj, true);
            const anonymous = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "anonymous"
            ])).has("anonymous");
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, name, inputs, anonymous);
        }
        return new $7316d9256af52303$export$958548f08bac2833($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p, true)) : [], !!obj.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$EventFragmentInternal;
    }
}
class $7316d9256af52303$export$3ac5c9504f801ea4 extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  Whether the constructor can receive an endowment.
     */ payable;
    /**
     *  The recommended gas limit for deployment or ``null``.
     */ gas;
    /**
     *  @private
     */ constructor(guard, type, inputs, payable, gas){
        super(guard, type, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$ConstructorFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable,
            gas: gas
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */ format(format) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(format != null && format !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
            operation: "format(sighash)"
        });
        if (format === "json") return JSON.stringify({
            type: "constructor",
            stateMutability: this.payable ? "payable" : "undefined",
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format)))
        });
        const result = [
            `constructor${$7316d9256af52303$var$joinParams(format, this.inputs)}`
        ];
        result.push(this.payable ? "payable" : "nonpayable");
        if (this.gas != null) result.push(`@${this.gas.toString()}`);
        return result.join(" ");
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$3ac5c9504f801ea4.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$3ac5c9504f801ea4.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid constuctor fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "constructor"
            ]));
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const payable = !!$7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$KwVisibDeploy).has("payable");
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", inputs, payable, gas);
        }
        return new $7316d9256af52303$export$3ac5c9504f801ea4($7316d9256af52303$var$_guard, "constructor", obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], !!obj.payable, obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$ConstructorFragmentInternal;
    }
}
class $7316d9256af52303$export$71b1ea64c89c20fc extends $7316d9256af52303$export$ffb0004e005737fa {
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    constructor(guard, inputs, payable){
        super(guard, "fallback", inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FallbackFragmentInternal
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            payable: payable
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */ format(format) {
        const type = this.inputs.length === 0 ? "receive" : "fallback";
        if (format === "json") {
            const stateMutability = this.payable ? "payable" : "nonpayable";
            return JSON.stringify({
                type: type,
                stateMutability: stateMutability
            });
        }
        return `${type}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$71b1ea64c89c20fc.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$71b1ea64c89c20fc.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const errorObj = obj.toString();
            const topIsValid = obj.peekKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(topIsValid, "type must be fallback or receive", "obj", errorObj);
            const type = obj.popKeyword($7316d9256af52303$var$setify([
                "fallback",
                "receive"
            ]));
            // receive()
            if (type === "receive") {
                const inputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 0, `receive cannot have arguments`, "obj.inputs", inputs);
                $7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                    "payable"
                ]));
                $7316d9256af52303$var$consumeEoi(obj);
                return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
            }
            // fallback() [payable]
            // fallback(bytes) [payable] returns (bytes)
            let inputs = $7316d9256af52303$var$consumeParams(obj);
            if (inputs.length) (0, $634aa51198273feb$export$c3d31707e5030f5e)(inputs.length === 1 && inputs[0].type === "bytes", "invalid fallback inputs", "obj.inputs", inputs.map((i)=>i.format("minimal")).join(", "));
            else inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(mutability === "nonpayable" || mutability === "payable", "fallback cannot be constants", "obj.stateMutability", mutability);
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) {
                const outputs = $7316d9256af52303$var$consumeParams(obj);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(outputs.length === 1 && outputs[0].type === "bytes", "invalid fallback outputs", "obj.outputs", outputs.map((i)=>i.format("minimal")).join(", "));
            }
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, mutability === "payable");
        }
        if (obj.type === "receive") return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, [], true);
        if (obj.type === "fallback") {
            const inputs = [
                $7316d9256af52303$export$426dc07f493a4c47.from("bytes")
            ];
            const payable = obj.stateMutability === "payable";
            return new $7316d9256af52303$export$71b1ea64c89c20fc($7316d9256af52303$var$_guard, inputs, payable);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid fallback description", "obj", obj);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FallbackFragmentInternal;
    }
}
class $7316d9256af52303$export$8d576c928b93668f extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */ constant;
    /**
     *  The returned types for the result of calling this function.
     */ outputs;
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */ stateMutability;
    /**
     *  If the function can be sent value during invocation.
     */ payable;
    /**
     *  The recommended gas limit to send when calling this function.
     */ gas;
    /**
     *  @private
     */ constructor(guard, name, stateMutability, inputs, outputs, gas){
        super(guard, "function", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$FunctionFragmentInternal
        });
        outputs = Object.freeze(outputs.slice());
        const constant = stateMutability === "view" || stateMutability === "pure";
        const payable = stateMutability === "payable";
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            constant: constant,
            gas: gas,
            outputs: outputs,
            payable: payable,
            stateMutability: stateMutability
        });
    }
    /**
     *  The Function selector.
     */ get selector() {
        return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */ format(format) {
        if (format == null) format = "sighash";
        if (format === "json") return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas != null ? this.gas : undefined,
            inputs: this.inputs.map((i)=>JSON.parse(i.format(format))),
            outputs: this.outputs.map((o)=>JSON.parse(o.format(format)))
        });
        const result = [];
        if (format !== "sighash") result.push("function");
        result.push(this.name + $7316d9256af52303$var$joinParams(format, this.inputs));
        if (format !== "sighash") {
            if (this.stateMutability !== "nonpayable") result.push(this.stateMutability);
            if (this.outputs && this.outputs.length) {
                result.push("returns");
                result.push($7316d9256af52303$var$joinParams(format, this.outputs));
            }
            if (this.gas != null) result.push(`@${this.gas.toString()}`);
        }
        return result.join(" ");
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */ static getSelector(name, params) {
        params = (params || []).map((p)=>$7316d9256af52303$export$426dc07f493a4c47.from(p));
        const fragment = new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, "view", params, [], null);
        return fragment.selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */ static from(obj) {
        if ($7316d9256af52303$export$8d576c928b93668f.isFragment(obj)) return obj;
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$8d576c928b93668f.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid function fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("function", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            const mutability = $7316d9256af52303$var$consumeMutability(obj);
            let outputs = [];
            if ($7316d9256af52303$var$consumeKeywords(obj, $7316d9256af52303$var$setify([
                "returns"
            ])).has("returns")) outputs = $7316d9256af52303$var$consumeParams(obj);
            const gas = $7316d9256af52303$var$consumeGas(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, name, mutability, inputs, outputs, gas);
        }
        let stateMutability = obj.stateMutability;
        // Use legacy Solidity ABI logic if stateMutability is missing
        if (stateMutability == null) {
            stateMutability = "payable";
            if (typeof obj.constant === "boolean") {
                stateMutability = "view";
                if (!obj.constant) {
                    stateMutability = "payable";
                    if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
                }
            } else if (typeof obj.payable === "boolean" && !obj.payable) stateMutability = "nonpayable";
        }
        // @TODO: verifyState for stateMutability (e.g. throw if
        //        payable: false but stateMutability is "nonpayable")
        return new $7316d9256af52303$export$8d576c928b93668f($7316d9256af52303$var$_guard, obj.name, stateMutability, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.outputs ? obj.outputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : [], obj.gas != null ? obj.gas : null);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$FunctionFragmentInternal;
    }
}
class $7316d9256af52303$export$9f91ba10bb234ec7 extends $7316d9256af52303$export$85c6fc53d6299173 {
    /**
     *  @private
     */ constructor(guard, name, inputs){
        super(guard, "struct", name, inputs);
        Object.defineProperty(this, $7316d9256af52303$var$internal, {
            value: $7316d9256af52303$var$StructFragmentInternal
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */ format() {
        throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */ static from(obj) {
        if (typeof obj === "string") try {
            return $7316d9256af52303$export$9f91ba10bb234ec7.from($7316d9256af52303$var$lex(obj));
        } catch (error) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid struct fragment", "obj", obj);
        }
        else if (obj instanceof $7316d9256af52303$var$TokenString) {
            const name = $7316d9256af52303$var$consumeName("struct", obj);
            const inputs = $7316d9256af52303$var$consumeParams(obj);
            $7316d9256af52303$var$consumeEoi(obj);
            return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, name, inputs);
        }
        return new $7316d9256af52303$export$9f91ba10bb234ec7($7316d9256af52303$var$_guard, obj.name, obj.inputs ? obj.inputs.map($7316d9256af52303$export$426dc07f493a4c47.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */ static isFragment(value) {
        return value && value[$7316d9256af52303$var$internal] === $7316d9256af52303$var$StructFragmentInternal;
    }
}



// https://docs.soliditylang.org/en/v0.8.17/control-structures.html
const $816d2d9d4a0a65b4$var$PanicReasons = new Map();
$816d2d9d4a0a65b4$var$PanicReasons.set(0x00, "GENERIC_PANIC");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x01, "ASSERT_FALSE");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x11, "OVERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x12, "DIVIDE_BY_ZERO");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x21, "ENUM_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x22, "BAD_STORAGE_DATA");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x31, "STACK_UNDERFLOW");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x32, "ARRAY_RANGE_ERROR");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x41, "OUT_OF_MEMORY");
$816d2d9d4a0a65b4$var$PanicReasons.set(0x51, "UNINITIALIZED_FUNCTION_CALL");
const $816d2d9d4a0a65b4$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $816d2d9d4a0a65b4$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
let $816d2d9d4a0a65b4$var$defaultCoder = null;
function $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, abiCoder) {
    let message = "missing revert data";
    let reason = null;
    const invocation = null;
    let revert = null;
    if (data) {
        message = "execution reverted";
        const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data);
        data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data);
        if (bytes.length === 0) {
            message += " (no data present; likely require(false) occurred";
            reason = "require(false)";
        } else if (bytes.length % 32 !== 4) message += " (could not decode reason; invalid data length)";
        else if ((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") // Error(string)
        try {
            reason = abiCoder.decode([
                "string"
            ], bytes.slice(4))[0];
            revert = {
                signature: "Error(string)",
                name: "Error",
                args: [
                    reason
                ]
            };
            message += `: ${JSON.stringify(reason)}`;
        } catch (error) {
            message += " (could not decode reason; invalid string data)";
        }
        else if ((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x4e487b71") // Panic(uint256)
        try {
            const code = Number(abiCoder.decode([
                "uint256"
            ], bytes.slice(4))[0]);
            revert = {
                signature: "Panic(uint256)",
                name: "Panic",
                args: [
                    code
                ]
            };
            reason = `Panic due to ${$816d2d9d4a0a65b4$var$PanicReasons.get(code) || "UNKNOWN"}(${code})`;
            message += `: ${reason}`;
        } catch (error) {
            message += " (could not decode panic code)";
        }
        else message += " (unknown custom error)";
    }
    const transaction = {
        to: tx.to ? (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.to) : null,
        data: tx.data || "0x"
    };
    if (tx.from) transaction.from = (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.from);
    return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)(message, "CALL_EXCEPTION", {
        action: action,
        data: data,
        reason: reason,
        transaction: transaction,
        invocation: invocation,
        revert: revert
    });
}
class $816d2d9d4a0a65b4$export$fe041e1a83d3efc6 {
    #getCoder(param) {
        if (param.isArray()) return new (0, $ea15fb9331abacb9$export$88bc419d2df11f54)(this.#getCoder(param.arrayChildren), param.arrayLength, param.name);
        if (param.isTuple()) return new (0, $80973df8073baca7$export$e9fceba8f110fea6)(param.components.map((c)=>this.#getCoder(c)), param.name);
        switch(param.baseType){
            case "address":
                return new (0, $cfcca69ef482e07c$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $8bb37f15c6403170$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $b65d6b3f7161a036$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $a77ec8c966f279c9$export$e5823e9574df18d2)(param.name);
            case "":
                return new (0, $720930767e786ee7$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($816d2d9d4a0a65b4$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 256 && size % 8 === 0, "invalid " + match[1] + " bit length", "param", param);
            return new (0, $0cff167f1e2d418f$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($816d2d9d4a0a65b4$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(size !== 0 && size <= 32, "invalid bytes length", "param", param);
            return new (0, $dc246983eaa4ec58$export$7dec9db68e6bcf5a)(size, param.name);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid type", "type", param.type);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */ getDefaultValue(types) {
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */ encode(types, values) {
        (0, $634aa51198273feb$export$d228410a8a77e4fa)(values.length, types.length, "types/values length mismatch");
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        const writer = new (0, $6b2ae433bec33333$export$d7a960146e1a269e)();
        coder.encode(writer, values);
        return writer.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */ decode(types, data, loose) {
        const coders = types.map((type)=>this.#getCoder((0, $7316d9256af52303$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $80973df8073baca7$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(new (0, $6b2ae433bec33333$export$2f7a2f0e90c07dc4)(data, loose));
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */ static defaultAbiCoder() {
        if ($816d2d9d4a0a65b4$var$defaultCoder == null) $816d2d9d4a0a65b4$var$defaultCoder = new $816d2d9d4a0a65b4$export$fe041e1a83d3efc6();
        return $816d2d9d4a0a65b4$var$defaultCoder;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */ static getBuiltinCallException(action, tx, data) {
        return $816d2d9d4a0a65b4$var$getBuiltinCallException(action, tx, data, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6.defaultAbiCoder());
    }
}





class $fcb356ece91f4842$export$c2ab6499be98b3c5 {
    /**
     *  The matching fragment for the ``topic0``.
     */ fragment;
    /**
     *  The name of the Event.
     */ name;
    /**
     *  The full Event signature.
     */ signature;
    /**
     *  The topic hash for the Event.
     */ topic;
    /**
     *  The arguments passed into the Event with ``emit``.
     */ args;
    /**
     *  @_ignore:
     */ constructor(fragment, topic, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            signature: signature,
            topic: topic,
            args: args
        });
    }
}
class $fcb356ece91f4842$export$7a3223b0fadb690b {
    /**
     *  The matching fragment from the transaction ``data``.
     */ fragment;
    /**
     *  The name of the Function from the transaction ``data``.
     */ name;
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */ args;
    /**
     *  The full Function signature from the transaction ``data``.
     */ signature;
    /**
     *  The selector for the Function from the transaction ``data``.
     */ selector;
    /**
     *  The ``value`` (in wei) from the transaction.
     */ value;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args, value){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector,
            value: value
        });
    }
}
class $fcb356ece91f4842$export$cfba08fc0e40e2ab {
    /**
     *  The matching fragment.
     */ fragment;
    /**
     *  The name of the Error.
     */ name;
    /**
     *  The arguments passed to the Error with ``revert``.
     */ args;
    /**
     *  The full Error signature.
     */ signature;
    /**
     *  The selector for the Error.
     */ selector;
    /**
     *  @_ignore:
     */ constructor(fragment, selector, args){
        const name = fragment.name, signature = fragment.format();
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment,
            name: name,
            args: args,
            signature: signature,
            selector: selector
        });
    }
}
class $fcb356ece91f4842$export$8ef99100a3c56f8c {
    /**
     *  The ``keccak256`` of the value logged.
     */ hash;
    /**
     *  @_ignore:
     */ _isIndexed;
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */ static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
    /**
     *  @_ignore:
     */ constructor(hash){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            hash: hash,
            _isIndexed: true
        });
    }
}
// https://docs.soliditylang.org/en/v0.8.13/control-structures.html?highlight=panic#panic-via-assert-and-error-via-require
const $fcb356ece91f4842$var$PanicReasons = {
    "0": "generic panic",
    "1": "assert(false)",
    "17": "arithmetic overflow",
    "18": "division or modulo by zero",
    "33": "enum overflow",
    "34": "invalid encoded storage byte array accessed",
    "49": "out-of-bounds array access; popping on an empty array",
    "50": "out-of-bounds access of an array or bytesN",
    "65": "out of memory",
    "81": "uninitialized function"
};
const $fcb356ece91f4842$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: (message)=>{
            return `reverted with reason string ${JSON.stringify(message)}`;
        }
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ],
        reason: (code)=>{
            let reason = "unknown panic code";
            if (code >= 0 && code <= 0xff && $fcb356ece91f4842$var$PanicReasons[code.toString()]) reason = $fcb356ece91f4842$var$PanicReasons[code.toString()];
            return `reverted with panic code 0x${code.toString(16)} (${reason})`;
        }
    }
};
class $fcb356ece91f4842$export$48cefb51a4e315b2 {
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */ fragments;
    /**
     *  The Contract constructor.
     */ deploy;
    /**
     *  The Fallback method, if any.
     */ fallback;
    /**
     *  If receiving ether is supported.
     */ receive;
    #errors;
    #events;
    #functions;
    //    #structs: Map<string, StructFragment>;
    #abiCoder;
    /**
     *  Create a new Interface for the %%fragments%%.
     */ constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        this.#functions = new Map();
        this.#errors = new Map();
        this.#events = new Map();
        //        this.#structs = new Map();
        const frags = [];
        for (const a of abi)try {
            frags.push((0, $7316d9256af52303$export$ffb0004e005737fa).from(a));
        } catch (error) {
            console.log("EE", error);
        }
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragments: Object.freeze(frags)
        });
        let fallback = null;
        let receive = false;
        this.#abiCoder = this.getAbiCoder();
        // Add all fragments by their signature
        this.fragments.forEach((fragment, index)=>{
            let bucket;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        console.log("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
                        deploy: fragment
                    });
                    return;
                case "fallback":
                    if (fragment.inputs.length === 0) receive = true;
                    else {
                        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!fallback || fragment.payable !== fallback.payable, "conflicting fallback fragments", `fragments[${index}]`, fragment);
                        fallback = fragment;
                        receive = fallback.payable;
                    }
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.#functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.#events;
                    break;
                case "error":
                    bucket = this.#errors;
                    break;
                default:
                    return;
            }
            // Two identical entries; ignore it
            const signature = fragment.format();
            if (bucket.has(signature)) return;
            bucket.set(signature, fragment);
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            deploy: (0, $7316d9256af52303$export$3ac5c9504f801ea4).from("constructor()")
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fallback: fallback,
            receive: receive
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */ format(minimal) {
        const format = minimal ? "minimal" : "full";
        const abi = this.fragments.map((f)=>f.format(format));
        return abi;
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */ formatJson() {
        const abi = this.fragments.map((f)=>f.format("json"));
        // We need to re-bundle the JSON fragments a bit
        return JSON.stringify(abi.map((j)=>JSON.parse(j)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */ getAbiCoder() {
        return (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).defaultAbiCoder();
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    #getFunction(key, values, forceUnique) {
        // Selector
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            for (const fragment of this.#functions.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#functions)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                const lastValue = values.length > 0 ? values[values.length - 1] : null;
                let valueLength = values.length;
                let allowOptions = true;
                if ((0, $f832d0621d63460e$export$af51273277efe223).isTyped(lastValue) && lastValue.type === "overrides") {
                    allowOptions = false;
                    valueLength--;
                }
                // Remove all matches that don't have a compatible length. The args
                // may contain an overrides, so the match may have n or n - 1 parameters
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs.length;
                    if (inputs !== valueLength && (!allowOptions || inputs !== valueLength - 1)) matching.splice(i, 1);
                }
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $f832d0621d63460e$export$af51273277efe223).isTyped(values[j])) continue;
                        // We are past the inputs
                        if (j >= inputs.length) {
                            if (values[j].type === "overrides") continue;
                            matching.splice(i, 1);
                            break;
                        }
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            // We found a single matching signature with an overrides, but the
            // last value is something that cannot possibly be an options
            if (matching.length === 1 && values && values.length !== matching[0].inputs.length) {
                const lastArg = values[values.length - 1];
                if (lastArg == null || Array.isArray(lastArg) || typeof lastArg !== "object") matching.splice(0, 1);
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous function description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#functions.get((0, $7316d9256af52303$export$8d576c928b93668f).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */ getFunctionName(key) {
        const fragment = this.#getFunction(key, null, false);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "no matching function", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */ hasFunction(key) {
        return !!this.#getFunction(key, null, false);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */ getFunction(key, values) {
        return this.#getFunction(key, values || null, true);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */ forEachFunction(callback) {
        const names = Array.from(this.#functions.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#functions.get(name), i);
        }
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    #getEvent(key, values, forceUnique) {
        // EventTopic
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const eventTopic = key.toLowerCase();
            for (const fragment of this.#events.values()){
                if (eventTopic === fragment.topicHash) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#events)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (values) {
                // Remove all matches that don't have a compatible length.
                for(let i = matching.length - 1; i >= 0; i--)if (matching[i].inputs.length < values.length) matching.splice(i, 1);
                // Remove all matches that don't match the Typed signature
                for(let i = matching.length - 1; i >= 0; i--){
                    const inputs = matching[i].inputs;
                    for(let j = 0; j < values.length; j++){
                        // Not a typed value
                        if (!(0, $f832d0621d63460e$export$af51273277efe223).isTyped(values[j])) continue;
                        // Make sure the value type matches the input type
                        if (values[j].type !== inputs[j].baseType) {
                            matching.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            if (matching.length === 0) return null;
            if (matching.length > 1 && forceUnique) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous event description (i.e. matches ${matchStr})`, "key", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        const result = this.#events.get((0, $7316d9256af52303$export$958548f08bac2833).from(key).format());
        if (result) return result;
        return null;
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */ getEventName(key) {
        const fragment = this.#getEvent(key, null, false);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "no matching event", "key", key);
        return fragment.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */ hasEvent(key) {
        return !!this.#getEvent(key, null, false);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */ getEvent(key, values) {
        return this.#getEvent(key, values || null, true);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */ forEachEvent(callback) {
        const names = Array.from(this.#events.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#events.get(name), i);
        }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */ getError(key, values) {
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(key)) {
            const selector = key.toLowerCase();
            if ($fcb356ece91f4842$var$BuiltinErrors[selector]) return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from($fcb356ece91f4842$var$BuiltinErrors[selector].signature);
            for (const fragment of this.#errors.values()){
                if (selector === fragment.selector) return fragment;
            }
            return null;
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (key.indexOf("(") === -1) {
            const matching = [];
            for (const [name, fragment] of this.#errors)if (name.split("(" /* fix:) */ )[0] === key) matching.push(fragment);
            if (matching.length === 0) {
                if (key === "Error") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Error(string)");
                if (key === "Panic") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Panic(uint256)");
                return null;
            } else if (matching.length > 1) {
                const matchStr = matching.map((m)=>JSON.stringify(m.format())).join(", ");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `ambiguous error description (i.e. ${matchStr})`, "name", key);
            }
            return matching[0];
        }
        // Normalize the signature and lookup the function
        key = (0, $7316d9256af52303$export$2c42c6d543aa9b59).from(key).format();
        if (key === "Error(string)") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Error(string)");
        if (key === "Panic(uint256)") return (0, $7316d9256af52303$export$2c42c6d543aa9b59).from("error Panic(uint256)");
        const result = this.#errors.get(key);
        if (result) return result;
        return null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */ forEachError(callback) {
        const names = Array.from(this.#errors.keys());
        names.sort((a, b)=>a.localeCompare(b));
        for(let i = 0; i < names.length; i++){
            const name = names[i];
            callback(this.#errors.get(name), i);
        }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
getSelector(fragment: ErrorFragment | FunctionFragment): string {
    if (typeof(fragment) === "string") {
        const matches: Array<Fragment> = [ ];

        try { matches.push(this.getFunction(fragment)); } catch (error) { }
        try { matches.push(this.getError(<string>fragment)); } catch (_) { }

        if (matches.length === 0) {
            logger.throwArgumentError("unknown fragment", "key", fragment);
        } else if (matches.length > 1) {
            logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
        }

        fragment = matches[0];
    }

    return dataSlice(id(fragment.format()), 0, 4);
}
    */ // Get the 32-byte topic hash used by Solidity to identify an event
    /*
    getEventTopic(fragment: EventFragment): string {
        //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
        return id(fragment.format());
    }
    */ _decodeParams(params, data) {
        return this.#abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this.#abiCoder.encode(params, values);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */ encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match error ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getError(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown error", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */ decodeFunctionData(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 4) === fragment.selector, `data signature does not match function ${fragment.name}.`, "data", data);
        return this._decodeParams(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 4));
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */ encodeFunctionData(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            fragment.selector,
            this._encodeParams(fragment.inputs, values || [])
        ]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */ decodeFunctionResult(fragment, data) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        let message = "invalid length for result data";
        const bytes = (0, $fd3872da8feed9cb$export$37110e7fee0af4ad)(data);
        if (bytes.length % 32 === 0) try {
            return this.#abiCoder.decode(fragment.outputs, bytes);
        } catch (error) {
            message = "could not decode result data";
        }
        // Call returned data with no error, but the data is junk
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, message, "BAD_DATA", {
            value: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes),
            info: {
                method: fragment.name,
                signature: fragment.format()
            }
        });
    }
    makeError(_data, tx) {
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
        const error = (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).getBuiltinCallException("call", tx, data);
        // Not a built-in error; try finding a custom error
        const customPrefix = "execution reverted (unknown custom error)";
        if (error.message.startsWith(customPrefix)) {
            const selector = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(0, 4));
            const ef = this.getError(selector);
            if (ef) try {
                const args = this.#abiCoder.decode(ef.inputs, data.slice(4));
                error.revert = {
                    name: ef.name,
                    signature: ef.format(),
                    args: args
                };
                error.reason = error.revert.signature;
                error.message = `execution reverted: ${error.reason}`;
            } catch (e) {
                error.message = `execution reverted (coult not decode custom error)`;
            }
        }
        // Add the invocation, if available
        const parsed = this.parseTransaction(tx);
        if (parsed) error.invocation = {
            method: parsed.name,
            signature: parsed.signature,
            args: parsed.args
        };
        return error;
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */ encodeFunctionResult(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getFunction(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown function", "fragment", fragment);
            fragment = f;
        }
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#abiCoder.encode(fragment.outputs, values || []));
    }
    /*
        spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
            const promises: Array<Promise<>> = [ ];
            const process = function(type: ParamType, value: any): any {
                if (type.baseType === "array") {
                    return descend(type.child
                }
                if (type. === "address") {
                }
            };
    
            const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
                if (inputs.length !== values.length) { throw new Error("length mismatch"); }
                
            };
    
            const result: Array<any> = [ ];
            values.forEach((value, index) => {
                if (value == null) {
                    topics.push(null);
                } else if (param.baseType === "array" || param.baseType === "tuple") {
                    logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
                } else if (Array.isArray(value)) {
                    topics.push(value.map((value) => encodeTopic(param, value)));
                } else {
                    topics.push(encodeTopic(param, value));
                }
            });
        }
    */ // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(values.length <= fragment.inputs.length, `too many arguments for ${fragment.format()}`, "UNEXPECTED_ARGUMENT", {
            count: values.length,
            expectedCount: fragment.inputs.length
        });
        const topics = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        // @TODO: Use the coders for this; to properly support tuples, etc.
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            else if (param.type.match(/^u?int/)) value = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(value); // @TODO: Should this toTwos??
            else if (param.type.match(/^bytes/)) value = (0, $fd3872da8feed9cb$export$1dc7fbe1b8738fe7)(value, 32);
            else if (param.type === "address") // Check addresses are valid
            this.#abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            const param = fragment.inputs[index];
            if (!param.indexed) {
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(value == null, "cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(fragment, values) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!fragment.anonymous) topics.push(fragment.topicHash);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(values.length === fragment.inputs.length, "event arguments/values mismatch", "values", values);
        fragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this.#abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this.#abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(fragment, data, topics) {
        if (typeof fragment === "string") {
            const f = this.getEvent(fragment);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(f, "unknown event", "eventFragment", fragment);
            fragment = f;
        }
        if (topics != null && !fragment.anonymous) {
            const eventTopic = fragment.topicHash;
            (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(topics[0], 32) && topics[0].toLowerCase() === eventTopic, "fragment/topic mismatch", "topics[0]", topics[0]);
            topics = topics.slice(1);
        }
        const indexed = [];
        const nonIndexed = [];
        const dynamic = [];
        fragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $7316d9256af52303$export$426dc07f493a4c47).from({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        const resultIndexed = topics != null ? this.#abiCoder.decode(indexed, (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(topics)) : null;
        const resultNonIndexed = this.#abiCoder.decode(nonIndexed, data, true);
        //const result: (Array<any> & { [ key: string ]: any }) = [ ];
        const values = [];
        const keys = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        fragment.inputs.forEach((param, index)=>{
            let value = null;
            if (param.indexed) {
                if (resultIndexed == null) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(null);
                else if (dynamic[index]) value = new $fcb356ece91f4842$export$8ef99100a3c56f8c(resultIndexed[indexedIndex++]);
                else try {
                    value = resultIndexed[indexedIndex++];
                } catch (error) {
                    value = error;
                }
            } else try {
                value = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                value = error;
            }
            values.push(value);
            keys.push(param.name || null);
        });
        return (0, $6b2ae433bec33333$export$8fdcabde73f49165).fromItems(values, keys);
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */ parseTransaction(tx) {
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(tx.data, "tx.data");
        const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.value != null ? tx.value : 0, "tx.value");
        const fragment = this.getFunction((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(0, 4)));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, data.slice(4));
        return new $fcb356ece91f4842$export$7a3223b0fadb690b(fragment, fragment.selector, args, value);
    }
    parseCallResult(data) {
        throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseLog(log) {
        const fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $fcb356ece91f4842$export$c2ab6499be98b3c5(fragment, fragment.topicHash, this.decodeEventLog(fragment, log.data, log.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching event cannot be found, returns null.
     */ parseError(data) {
        const hexData = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data);
        const fragment = this.getError((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(hexData, 0, 4));
        if (!fragment) return null;
        const args = this.#abiCoder.decode(fragment.inputs, (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(hexData, 4));
        return new $fcb356ece91f4842$export$cfba08fc0e40e2ab(fragment, fragment.selector, args);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */ static from(value) {
        // Already an Interface, which is immutable
        if (value instanceof $fcb356ece91f4842$export$48cefb51a4e315b2) return value;
        // JSON
        if (typeof value === "string") return new $fcb356ece91f4842$export$48cefb51a4e315b2(JSON.parse(value));
        // Maybe an interface from an older version, or from a symlinked copy
        if (typeof value.format === "function") return new $fcb356ece91f4842$export$48cefb51a4e315b2(value.format("json"));
        // Array of fragments
        return new $fcb356ece91f4842$export$48cefb51a4e315b2(value);
    }
}




function $ed11119eb2f9aa0c$export$6a88e03bca5eb759(value) {
    return value && typeof value.getAddress === "function";
}
function $ed11119eb2f9aa0c$export$977e255126d763d6(value) {
    try {
        (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
        return true;
    } catch (error) {}
    return false;
}
async function $ed11119eb2f9aa0c$var$checkAddress(target, promise) {
    const result = await promise;
    if (result == null || result === "0x0000000000000000000000000000000000000000") {
        (0, $634aa51198273feb$export$a7a9523472993e97)(typeof target !== "string", "unconfigured name", "UNCONFIGURED_NAME", {
            value: target
        });
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid AddressLike value; did not resolve to a value address", "target", target);
    }
    return (0, $69ef3f917ff239a2$export$88411125f012957a)(result);
}
function $ed11119eb2f9aa0c$export$687eed6b344123c9(target, resolver) {
    if (typeof target === "string") {
        if (target.match(/^0x[0-9a-f]{40}$/i)) return (0, $69ef3f917ff239a2$export$88411125f012957a)(target);
        (0, $634aa51198273feb$export$a7a9523472993e97)(resolver != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
        });
        return $ed11119eb2f9aa0c$var$checkAddress(target, resolver.resolveName(target));
    } else if ($ed11119eb2f9aa0c$export$6a88e03bca5eb759(target)) return $ed11119eb2f9aa0c$var$checkAddress(target, target.getAddress());
    else if (target && typeof target.then === "function") return $ed11119eb2f9aa0c$var$checkAddress(target, target);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported addressable value", "target", target);
}


//import { resolveAddress } from "@ethersproject/address";



function $c254de3831dd58ea$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $69ef3f917ff239a2$export$88411125f012957a)(addr),
        storageKeys: storageKeys.map((storageKey, index)=>{
            (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(storageKey, 32), "invalid slot", `storageKeys[${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $c254de3831dd58ea$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(set.length === 2, "invalid slot set", `value[${index}]`, set);
            return $c254de3831dd58ea$var$accessSetify(set[0], set[1]);
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(set != null && typeof set === "object", "invalid address-slot set", "value", value);
        return $c254de3831dd58ea$var$accessSetify(set.address, set.storageKeys);
    });
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(value != null && typeof value === "object", "invalid access list", "value", value);
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $c254de3831dd58ea$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}


const $425e3311db5fb4d1$var$BN_0 = BigInt(0);
// -----------------------
function $425e3311db5fb4d1$var$getValue(value) {
    if (value == null) return null;
    return value;
}
function $425e3311db5fb4d1$var$toJson(value) {
    if (value == null) return null;
    return value.toString();
}
class $425e3311db5fb4d1$export$116c49c1e2a96a78 {
    /**
     *  The gas price for legacy networks.
     */ gasPrice;
    /**
     *  The maximum fee to pay per gas.
     *
     *  The base fee per gas is defined by the network and based on
     *  congestion, increasing the cost during times of heavy load
     *  and lowering when less busy.
     *
     *  The actual fee per gas will be the base fee for the block
     *  and the priority fee, up to the max fee per gas.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxFeePerGas;
    /**
     *  The additional amout to pay per gas to encourage a validator
     *  to include the transaction.
     *
     *  The purpose of this is to compensate the validator for the
     *  adjusted risk for including a given transaction.
     *
     *  This will be ``null`` on legacy networks (i.e. [pre-EIP-1559](link-eip-1559))
     */ maxPriorityFeePerGas;
    /**
     *  Creates a new FeeData for %%gasPrice%%, %%maxFeePerGas%% and
     *  %%maxPriorityFeePerGas%%.
     */ constructor(gasPrice, maxFeePerGas, maxPriorityFeePerGas){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            gasPrice: $425e3311db5fb4d1$var$getValue(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$getValue(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$getValue(maxPriorityFeePerGas)
        });
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = this;
        return {
            _type: "FeeData",
            gasPrice: $425e3311db5fb4d1$var$toJson(gasPrice),
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(maxPriorityFeePerGas)
        };
    }
}
function $425e3311db5fb4d1$export$607b34cdac162b7f(req) {
    const result = {};
    // These could be addresses, ENS names or Addressables
    if (req.to) result.to = req.to;
    if (req.from) result.from = req.from;
    if (req.data) result.data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(req.data);
    const bigIntKeys = "chainId,gasLimit,gasPrice,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
    for (const key of bigIntKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(req[key], `request.${key}`);
    }
    const numberKeys = "type,nonce".split(/,/);
    for (const key of numberKeys){
        if (!(key in req) || req[key] == null) continue;
        result[key] = (0, $6fa405e57bb6371e$export$b14f2714108df84)(req[key], `request.${key}`);
    }
    if (req.accessList) result.accessList = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(req.accessList);
    if ("blockTag" in req) result.blockTag = req.blockTag;
    if ("enableCcipRead" in req) result.enableCcipRead = !!req.enableCcipRead;
    if ("customData" in req) result.customData = req.customData;
    return result;
}
class $425e3311db5fb4d1$export$d96a8827a60d6b69 {
    /**
     *  The provider connected to the block used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The block number, sometimes called the block height. This is a
     *  sequential number that is one higher than the parent block.
     */ number;
    /**
     *  The block hash.
     *
     *  This hash includes all properties, so can be safely used to identify
     *  an exact set of block properties.
     */ hash;
    /**
     *  The timestamp for this block, which is the number of seconds since
     *  epoch that this block was included.
     */ timestamp;
    /**
     *  The block hash of the parent block.
     */ parentHash;
    /**
     *  The nonce.
     *
     *  On legacy networks, this is the random number inserted which
     *  permitted the difficulty target to be reached.
     */ nonce;
    /**
     *  The difficulty target.
     *
     *  On legacy networks, this is the proof-of-work target required
     *  for a block to meet the protocol rules to be included.
     *
     *  On modern networks, this is a random number arrived at using
     *  randao.  @TODO: Find links?
     */ difficulty;
    /**
     *  The total gas limit for this block.
     */ gasLimit;
    /**
     *  The total gas used in this block.
     */ gasUsed;
    /**
     *  The miner coinbase address, wihch receives any subsidies for
     *  including this block.
     */ miner;
    /**
     *  Any extra data the validator wished to include.
     */ extraData;
    /**
     *  The base fee per gas that all transactions in this block were
     *  charged.
     *
     *  This adjusts after each block, depending on how congested the network
     *  is.
     */ baseFeePerGas;
    #transactions;
    /**
     *  Create a new **Block** object.
     *
     *  This should generally not be necessary as the unless implementing a
     *  low-level library.
     */ constructor(block, provider){
        this.#transactions = block.transactions.map((tx)=>{
            if (typeof tx !== "string") return new $425e3311db5fb4d1$export$70966cdb3bfc0785(tx, provider);
            return tx;
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            hash: $425e3311db5fb4d1$var$getValue(block.hash),
            number: block.number,
            timestamp: block.timestamp,
            parentHash: block.parentHash,
            nonce: block.nonce,
            difficulty: block.difficulty,
            gasLimit: block.gasLimit,
            gasUsed: block.gasUsed,
            miner: block.miner,
            extraData: block.extraData,
            baseFeePerGas: $425e3311db5fb4d1$var$getValue(block.baseFeePerGas)
        });
    }
    /**
     *  Returns the list of transaction hashes.
     */ get transactions() {
        return this.#transactions.map((tx)=>{
            if (typeof tx === "string") return tx;
            return tx.hash;
        });
    }
    /**
     *  Returns the complete transactions for blocks which
     *  prefetched them, by passing ``true`` to %%prefetchTxs%%
     *  into [[Provider-getBlock]].
     */ get prefetchedTransactions() {
        const txs = this.#transactions.slice();
        // Doesn't matter...
        if (txs.length === 0) return [];
        // Make sure we prefetched the transactions
        (0, $634aa51198273feb$export$a7a9523472993e97)(typeof txs[0] === "object", "transactions were not prefetched with block request", "UNSUPPORTED_OPERATION", {
            operation: "transactionResponses()"
        });
        return txs;
    }
    /**
     *  Returns a JSON-friendly value.
     */ toJSON() {
        const { baseFeePerGas: baseFeePerGas, difficulty: difficulty, extraData: extraData, gasLimit: gasLimit, gasUsed: gasUsed, hash: hash, miner: miner, nonce: nonce, number: number, parentHash: parentHash, timestamp: timestamp, transactions: transactions } = this;
        return {
            _type: "Block",
            baseFeePerGas: $425e3311db5fb4d1$var$toJson(baseFeePerGas),
            difficulty: $425e3311db5fb4d1$var$toJson(difficulty),
            extraData: extraData,
            gasLimit: $425e3311db5fb4d1$var$toJson(gasLimit),
            gasUsed: $425e3311db5fb4d1$var$toJson(gasUsed),
            hash: hash,
            miner: miner,
            nonce: nonce,
            number: number,
            parentHash: parentHash,
            timestamp: timestamp,
            transactions: transactions
        };
    }
    [Symbol.iterator]() {
        let index = 0;
        const txs = this.transactions;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: txs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The number of transactions in this block.
     */ get length() {
        return this.#transactions.length;
    }
    /**
     *  The [[link-js-date]] this block was included at.
     */ get date() {
        if (this.timestamp == null) return null;
        return new Date(this.timestamp * 1000);
    }
    /**
     *  Get the transaction at %%indexe%% within this block.
     */ async getTransaction(indexOrHash) {
        // Find the internal value by its index or hash
        let tx = undefined;
        if (typeof indexOrHash === "number") tx = this.#transactions[indexOrHash];
        else {
            const hash = indexOrHash.toLowerCase();
            for (const v of this.#transactions)if (typeof v === "string") {
                if (v !== hash) continue;
                tx = v;
                break;
            } else {
                if (v.hash === hash) continue;
                tx = v;
                break;
            }
        }
        if (tx == null) throw new Error("no such tx");
        if (typeof tx === "string") return await this.provider.getTransaction(tx);
        else return tx;
    }
    /**
     *  If a **Block** was fetched with a request to include the transactions
     *  this will allow synchronous access to those transactions.
     *
     *  If the transactions were not prefetched, this will throw.
     */ getPrefetchedTransaction(indexOrHash) {
        const txs = this.prefetchedTransactions;
        if (typeof indexOrHash === "number") return txs[indexOrHash];
        indexOrHash = indexOrHash.toLowerCase();
        for (const tx of txs){
            if (tx.hash === indexOrHash) return tx;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "no matching transaction", "indexOrHash", indexOrHash);
    }
    /**
     *  Returns true if this block been mined. This provides a type guard
     *  for all properties on a [[MinedBlock]].
     */ isMined() {
        return !!this.hash;
    }
    /**
     *  Returns true if this block is an [[link-eip-2930]] block.
     */ isLondon() {
        return !!this.baseFeePerGas;
    }
    /**
     *  @_ignore:
     */ orphanedEvent() {
        if (!this.isMined()) throw new Error("");
        return $425e3311db5fb4d1$var$createOrphanedBlockFilter(this);
    }
}
class $425e3311db5fb4d1$export$ce30dbb46644d06c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */ transactionHash;
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */ blockHash;
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */ blockNumber;
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */ removed;
    /**
     *  The address of the contract that emitted this log.
     */ address;
    /**
     *  The data included in this log when it was emitted.
     */ data;
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */ topics;
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */ index;
    /**
     *  The index within the transaction of this log.
     */ transactionIndex;
    /**
     *  @_ignore:
     */ constructor(log, provider){
        this.provider = provider;
        const topics = Object.freeze(log.topics.slice());
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            removed: log.removed,
            address: log.address,
            data: log.data,
            topics: topics,
            index: log.index,
            transactionIndex: log.transactionIndex
        });
    }
    /**
     *  Returns a JSON-compatible object.
     */ toJSON() {
        const { address: address, blockHash: blockHash, blockNumber: blockNumber, data: data, index: index, removed: removed, topics: topics, transactionHash: transactionHash, transactionIndex: transactionIndex } = this;
        return {
            _type: "log",
            address: address,
            blockHash: blockHash,
            blockNumber: blockNumber,
            data: data,
            index: index,
            removed: removed,
            topics: topics,
            transactionHash: transactionHash,
            transactionIndex: transactionIndex
        };
    }
    /**
     *  Returns the block that this log occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!block, "failed to find transaction", "UNKNOWN_ERROR", {});
        return block;
    }
    /**
     *  Returns the transaction that this log occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.transactionHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!tx, "failed to find transaction", "UNKNOWN_ERROR", {});
        return tx;
    }
    /**
     *  Returns the transaction receipt fot the transaction that this
     *  log occurred in.
     */ async getTransactionReceipt() {
        const receipt = await this.provider.getTransactionReceipt(this.transactionHash);
        (0, $634aa51198273feb$export$a7a9523472993e97)(!!receipt, "failed to find transaction receipt", "UNKNOWN_ERROR", {});
        return receipt;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedLogFilter(this);
    }
}
class $425e3311db5fb4d1$export$375ffd5683aa5c1c {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */ provider;
    /**
     *  The address the transaction was send to.
     */ to;
    /**
     *  The sender of the transaction.
     */ from;
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */ contractAddress;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The index of this transaction within the block transactions.
     */ index;
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */ blockHash;
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */ blockNumber;
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */ logsBloom;
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */ gasUsed;
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */ cumulativeGasUsed;
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */ gasPrice;
    /**
     *  The [[link-eip-2718]] transaction type.
     */ type;
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */ status;
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */ root;
    #logs;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.#logs = Object.freeze(tx.logs.map((log)=>{
            return new $425e3311db5fb4d1$export$ce30dbb46644d06c(log, provider);
        }));
        let gasPrice = $425e3311db5fb4d1$var$BN_0;
        if (tx.effectiveGasPrice != null) gasPrice = tx.effectiveGasPrice;
        else if (tx.gasPrice != null) gasPrice = tx.gasPrice;
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            to: tx.to,
            from: tx.from,
            contractAddress: tx.contractAddress,
            hash: tx.hash,
            index: tx.index,
            blockHash: tx.blockHash,
            blockNumber: tx.blockNumber,
            logsBloom: tx.logsBloom,
            gasUsed: tx.gasUsed,
            cumulativeGasUsed: tx.cumulativeGasUsed,
            gasPrice: gasPrice,
            type: tx.type,
            //byzantium: tx.byzantium,
            status: tx.status,
            root: tx.root
        });
    }
    /**
     *  The logs for this transaction.
     */ get logs() {
        return this.#logs;
    }
    /**
     *  Returns a JSON-compatible representation.
     */ toJSON() {
        const { to: to, from: from, contractAddress: contractAddress, hash: hash, index: index, blockHash: blockHash, blockNumber: blockNumber, logsBloom: logsBloom, logs: logs, status: status, root: root } = this;
        return {
            _type: "TransactionReceipt",
            blockHash: blockHash,
            blockNumber: blockNumber,
            contractAddress: //byzantium, 
            contractAddress,
            cumulativeGasUsed: $425e3311db5fb4d1$var$toJson(this.cumulativeGasUsed),
            from: from,
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            gasUsed: $425e3311db5fb4d1$var$toJson(this.gasUsed),
            hash: hash,
            index: index,
            logs: logs,
            logsBloom: logsBloom,
            root: root,
            status: status,
            to: to
        };
    }
    /**
     *  @_ignore:
     */ get length() {
        return this.logs.length;
    }
    [Symbol.iterator]() {
        let index = 0;
        return {
            next: ()=>{
                if (index < this.length) return {
                    value: this.logs[index++],
                    done: false
                };
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The total fee for this transaction, in wei.
     */ get fee() {
        return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */ async getBlock() {
        const block = await this.provider.getBlock(this.blockHash);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */ async getTransaction() {
        const tx = await this.provider.getTransaction(this.hash);
        if (tx == null) throw new Error("TODO");
        return tx;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */ async getResult() {
        return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */ async confirmations() {
        return await this.provider.getBlockNumber() - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */ removedEvent() {
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  @_ignore:
     */ reorderedEvent(other) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "reorderedEvent(other)"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
}
class $425e3311db5fb4d1$export$70966cdb3bfc0785 {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */ provider;
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockNumber;
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */ blockHash;
    /**
     *  The index within the block that this transaction resides at.
     */ index;
    /**
     *  The transaction hash.
     */ hash;
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */ type;
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */ to;
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */ from;
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */ nonce;
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */ gasLimit;
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */ gasPrice;
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */ maxPriorityFeePerGas;
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */ maxFeePerGas;
    /**
     *  The data.
     */ data;
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */ value;
    /**
     *  The chain ID.
     */ chainId;
    /**
     *  The signature.
     */ signature;
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */ accessList;
    #startBlock;
    /**
     *  @_ignore:
     */ constructor(tx, provider){
        this.provider = provider;
        this.blockNumber = tx.blockNumber != null ? tx.blockNumber : null;
        this.blockHash = tx.blockHash != null ? tx.blockHash : null;
        this.hash = tx.hash;
        this.index = tx.index;
        this.type = tx.type;
        this.from = tx.from;
        this.to = tx.to || null;
        this.gasLimit = tx.gasLimit;
        this.nonce = tx.nonce;
        this.data = tx.data;
        this.value = tx.value;
        this.gasPrice = tx.gasPrice;
        this.maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? tx.maxPriorityFeePerGas : null;
        this.maxFeePerGas = tx.maxFeePerGas != null ? tx.maxFeePerGas : null;
        this.chainId = tx.chainId;
        this.signature = tx.signature;
        this.accessList = tx.accessList != null ? tx.accessList : null;
        this.#startBlock = -1;
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */ toJSON() {
        const { blockNumber: blockNumber, blockHash: blockHash, index: index, hash: hash, type: type, to: to, from: from, nonce: nonce, data: data, signature: signature, accessList: accessList } = this;
        return {
            _type: "TransactionReceipt",
            accessList: accessList,
            blockNumber: blockNumber,
            blockHash: blockHash,
            chainId: $425e3311db5fb4d1$var$toJson(this.chainId),
            data: data,
            from: from,
            gasLimit: $425e3311db5fb4d1$var$toJson(this.gasLimit),
            gasPrice: $425e3311db5fb4d1$var$toJson(this.gasPrice),
            hash: hash,
            maxFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxFeePerGas),
            maxPriorityFeePerGas: $425e3311db5fb4d1$var$toJson(this.maxPriorityFeePerGas),
            nonce: nonce,
            signature: signature,
            to: to,
            index: index,
            type: type,
            value: $425e3311db5fb4d1$var$toJson(this.value)
        };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */ async getBlock() {
        let blockNumber = this.blockNumber;
        if (blockNumber == null) {
            const tx = await this.getTransaction();
            if (tx) blockNumber = tx.blockNumber;
        }
        if (blockNumber == null) return null;
        const block = this.provider.getBlock(blockNumber);
        if (block == null) throw new Error("TODO");
        return block;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */ async getTransaction() {
        return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */ async confirmations() {
        if (this.blockNumber == null) {
            const { tx: tx, blockNumber: blockNumber } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                tx: this.getTransaction(),
                blockNumber: this.provider.getBlockNumber()
            });
            // Not mined yet...
            if (tx == null || tx.blockNumber == null) return 0;
            return blockNumber - tx.blockNumber + 1;
        }
        const blockNumber = await this.provider.getBlockNumber();
        return blockNumber - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(_confirms, _timeout) {
        const confirms = _confirms == null ? 1 : _confirms;
        const timeout = _timeout == null ? 0 : _timeout;
        let startBlock = this.#startBlock;
        let nextScan = -1;
        let stopScanning = startBlock === -1 ? true : false;
        const checkReplacement = async ()=>{
            // Get the current transaction count for this sender
            if (stopScanning) return null;
            const { blockNumber: blockNumber, nonce: nonce } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                blockNumber: this.provider.getBlockNumber(),
                nonce: this.provider.getTransactionCount(this.from)
            });
            // No transaction or our nonce has not been mined yet; but we
            // can start scanning later when we do start
            if (nonce < this.nonce) {
                startBlock = blockNumber;
                return;
            }
            // We were mined; no replacement
            if (stopScanning) return null;
            const mined = await this.getTransaction();
            if (mined && mined.blockNumber != null) return;
            // We were replaced; start scanning for that transaction
            // Starting to scan; look back a few extra blocks for safety
            if (nextScan === -1) {
                nextScan = startBlock - 3;
                if (nextScan < this.#startBlock) nextScan = this.#startBlock;
            }
            while(nextScan <= blockNumber){
                // Get the next block to scan
                if (stopScanning) return null;
                const block = await this.provider.getBlock(nextScan, true);
                // This should not happen; but we'll try again shortly
                if (block == null) return;
                // We were mined; no replacement
                for (const hash of block){
                    if (hash === this.hash) return;
                }
                // Search for the transaction that replaced us
                for(let i = 0; i < block.length; i++){
                    const tx = await block.getTransaction(i);
                    if (tx.from === this.from && tx.nonce === this.nonce) {
                        // Get the receipt
                        if (stopScanning) return null;
                        const receipt = await this.provider.getTransactionReceipt(tx.hash);
                        // This should not happen; but we'll try again shortly
                        if (receipt == null) return;
                        // We will retry this on the next block (this case could be optimized)
                        if (blockNumber - receipt.blockNumber + 1 < confirms) return;
                        // The reason we were replaced
                        let reason = "replaced";
                        if (tx.data === this.data && tx.to === this.to && tx.value === this.value) reason = "repriced";
                        else if (tx.data === "0x" && tx.from === tx.to && tx.value === $425e3311db5fb4d1$var$BN_0) reason = "cancelled";
                        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "transaction was replaced", "TRANSACTION_REPLACED", {
                            cancelled: reason === "replaced" || reason === "cancelled",
                            reason: reason,
                            replacement: tx.replaceableTransaction(startBlock),
                            hash: tx.hash,
                            receipt: receipt
                        });
                    }
                }
                nextScan++;
            }
            return;
        };
        const checkReceipt = (receipt)=>{
            if (receipt == null || receipt.status !== 0) return receipt;
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "transaction execution reverted", "CALL_EXCEPTION", {
                action: "sendTransaction",
                data: null,
                reason: null,
                invocation: null,
                revert: null,
                transaction: {
                    to: receipt.to,
                    from: receipt.from,
                    data: "" // @TODO: in v7, split out sendTransaction properties
                },
                receipt: receipt
            });
        };
        const receipt = await this.provider.getTransactionReceipt(this.hash);
        if (confirms === 0) return checkReceipt(receipt);
        if (receipt) {
            if (await receipt.confirmations() >= confirms) return checkReceipt(receipt);
        } else {
            // Check for a replacement; throws if a replacement was found
            await checkReplacement();
            // Allow null only when the confirms is 0
            if (confirms === 0) return null;
        }
        const waiter = new Promise((resolve, reject)=>{
            // List of things to cancel when we have a result (one way or the other)
            const cancellers = [];
            const cancel = ()=>{
                cancellers.forEach((c)=>c());
            };
            // On cancel, stop scanning for replacements
            cancellers.push(()=>{
                stopScanning = true;
            });
            // Set up any timeout requested
            if (timeout > 0) {
                const timer = setTimeout(()=>{
                    cancel();
                    reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("wait for transaction timeout", "TIMEOUT"));
                }, timeout);
                cancellers.push(()=>{
                    clearTimeout(timer);
                });
            }
            const txListener = async (receipt)=>{
                // Done; return it!
                if (await receipt.confirmations() >= confirms) {
                    cancel();
                    try {
                        resolve(checkReceipt(receipt));
                    } catch (error) {
                        reject(error);
                    }
                }
            };
            cancellers.push(()=>{
                this.provider.off(this.hash, txListener);
            });
            this.provider.on(this.hash, txListener);
            // We support replacement detection; start checking
            if (startBlock >= 0) {
                const replaceListener = async ()=>{
                    try {
                        // Check for a replacement; this throws only if one is found
                        await checkReplacement();
                    } catch (error) {
                        // We were replaced (with enough confirms); re-throw the error
                        if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "TRANSACTION_REPLACED")) {
                            cancel();
                            reject(error);
                            return;
                        }
                    }
                    // Rescheudle a check on the next block
                    if (!stopScanning) this.provider.once("block", replaceListener);
                };
                cancellers.push(()=>{
                    this.provider.off("block", replaceListener);
                });
                this.provider.once("block", replaceListener);
            }
        });
        return await waiter;
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */ isMined() {
        return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */ removedEvent() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createRemovedTransactionFilter(this);
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */ reorderedEvent(other) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        (0, $634aa51198273feb$export$a7a9523472993e97)(!other || other.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
            operation: "removeEvent()"
        });
        return $425e3311db5fb4d1$var$createReorderedTransactionFilter(this, other);
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */ replaceableTransaction(startBlock) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(startBlock) && startBlock >= 0, "invalid startBlock", "startBlock", startBlock);
        const tx = new $425e3311db5fb4d1$export$70966cdb3bfc0785(this, this.provider);
        tx.#startBlock = startBlock;
        return tx;
    }
}
function $425e3311db5fb4d1$var$createOrphanedBlockFilter(block) {
    return {
        orphan: "drop-block",
        hash: block.hash,
        number: block.number
    };
}
function $425e3311db5fb4d1$var$createReorderedTransactionFilter(tx, other) {
    return {
        orphan: "reorder-transaction",
        tx: tx,
        other: other
    };
}
function $425e3311db5fb4d1$var$createRemovedTransactionFilter(tx) {
    return {
        orphan: "drop-transaction",
        tx: tx
    };
}
function $425e3311db5fb4d1$var$createRemovedLogFilter(log) {
    return {
        orphan: "drop-log",
        log: {
            transactionHash: log.transactionHash,
            blockHash: log.blockHash,
            blockNumber: log.blockNumber,
            address: log.address,
            data: log.data,
            topics: Object.freeze(log.topics.slice()),
            index: log.index
        }
    };
}



// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider

/**
 *  Events allow for applications to use the observer pattern, which
 *  allows subscribing and publishing events, outside the normal
 *  execution paths.
 *
 *  @_section api/utils/events:Events  [about-events]
 */ 
class $62d6becaa0dab02c$export$9cec82196983b278 {
    /**
     *  The event filter.
     */ filter;
    /**
     *  The **EventEmitterable**.
     */ emitter;
    #listener;
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */ constructor(emitter, listener, filter){
        this.#listener = listener;
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            emitter: emitter,
            filter: filter
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */ async removeListener() {
        if (this.#listener == null) return;
        await this.emitter.off(this.filter, this.#listener);
    }
}


class $0ab0dbf63d0f506e$export$f8203d08df5cd081 extends (0, $425e3311db5fb4d1$export$ce30dbb46644d06c) {
    /**
     *  The Contract Interface.
     */ interface;
    /**
     *  The matching event.
     */ fragment;
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */ args;
    /**
     * @_ignore:
     */ constructor(log, iface, fragment){
        super(log, log.provider);
        const args = iface.decodeEventLog(fragment, log.data, log.topics);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment,
            interface: iface
        });
    }
    /**
     *  The name of the event.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */ get eventSignature() {
        return this.fragment.format();
    }
}
class $0ab0dbf63d0f506e$export$53f6e6acc02bf489 extends (0, $425e3311db5fb4d1$export$ce30dbb46644d06c) {
    /**
     *  The error encounted when trying to decode the log.
     */ error;
    /**
     * @_ignore:
     */ constructor(log, error){
        super(log, log.provider);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            error: error
        });
    }
}
class $0ab0dbf63d0f506e$export$86bdc83e93503686 extends (0, $425e3311db5fb4d1$export$375ffd5683aa5c1c) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */ get logs() {
        return super.logs.map((log)=>{
            const fragment = log.topics.length ? this.#iface.getEvent(log.topics[0]) : null;
            if (fragment) try {
                return new $0ab0dbf63d0f506e$export$f8203d08df5cd081(log, this.#iface, fragment);
            } catch (error) {
                return new $0ab0dbf63d0f506e$export$53f6e6acc02bf489(log, error);
            }
            return log;
        });
    }
}
class $0ab0dbf63d0f506e$export$853f7e2df34220ff extends (0, $425e3311db5fb4d1$export$70966cdb3bfc0785) {
    #iface;
    /**
     *  @_ignore:
     */ constructor(iface, provider, tx){
        super(tx, provider);
        this.#iface = iface;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */ async wait(confirms) {
        const receipt = await super.wait(confirms);
        if (receipt == null) return null;
        return new $0ab0dbf63d0f506e$export$86bdc83e93503686(this.#iface, this.provider, receipt);
    }
}
class $0ab0dbf63d0f506e$export$54be5ec94ad26a69 extends (0, $62d6becaa0dab02c$export$9cec82196983b278) {
    /**
     *  The log with no matching events.
     */ log;
    /**
     *  @_event:
     */ constructor(contract, listener, filter, log){
        super(contract, listener, filter);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            log: log
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */ async getBlock() {
        return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */ async getTransaction() {
        return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */ async getTransactionReceipt() {
        return await this.log.getTransactionReceipt();
    }
}
class $0ab0dbf63d0f506e$export$35f9272dc1c07dee extends $0ab0dbf63d0f506e$export$54be5ec94ad26a69 {
    /**
     *  @_ignore:
     */ constructor(contract, listener, filter, fragment, _log){
        super(contract, listener, filter, new $0ab0dbf63d0f506e$export$f8203d08df5cd081(_log, contract.interface, fragment));
        const args = contract.interface.decodeEventLog(fragment, this.log.data, this.log.topics);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            args: args,
            fragment: fragment
        });
    }
    /**
     *  The event name.
     */ get eventName() {
        return this.fragment.name;
    }
    /**
     *  The event signature.
     */ get eventSignature() {
        return this.fragment.format();
    }
}


const $0e40c93799a724b3$var$BN_0 = BigInt(0);
function $0e40c93799a724b3$var$canCall(value) {
    return value && typeof value.call === "function";
}
function $0e40c93799a724b3$var$canEstimate(value) {
    return value && typeof value.estimateGas === "function";
}
function $0e40c93799a724b3$var$canResolve(value) {
    return value && typeof value.resolveName === "function";
}
function $0e40c93799a724b3$var$canSend(value) {
    return value && typeof value.sendTransaction === "function";
}
class $0e40c93799a724b3$var$PreparedTopicFilter {
    #filter;
    fragment;
    constructor(contract, fragment, args){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fragment: fragment
        });
        if (fragment.inputs.length < args.length) throw new Error("too many arguments");
        // Recursively descend into args and resolve any addresses
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "resolveName");
        const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
        this.#filter = async function() {
            const resolvedArgs = await Promise.all(fragment.inputs.map((param, index)=>{
                const arg = args[index];
                if (arg == null) return null;
                return param.walkAsync(args[index], (type, value)=>{
                    if (type === "address") {
                        if (Array.isArray(value)) return Promise.all(value.map((v)=>(0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(v, resolver)));
                        return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value, resolver);
                    }
                    return value;
                });
            }));
            return contract.interface.encodeFilterTopics(fragment, resolvedArgs);
        }();
    }
    getTopicFilter() {
        return this.#filter;
    }
}
// A = Arguments passed in as a tuple
// R = The result type of the call (i.e. if only one return type,
//     the qualified type, otherwise Result)
// D = The type the default call will return (i.e. R for view/pure,
//     TransactionResponse otherwise)
//export interface ContractMethod<A extends Array<any> = Array<any>, R = any, D extends R | ContractTransactionResponse = ContractTransactionResponse> {
function $0e40c93799a724b3$var$getRunner(value, feature) {
    if (value == null) return null;
    if (typeof value[feature] === "function") return value;
    if (value.provider && typeof value.provider[feature] === "function") return value.provider;
    return null;
}
function $0e40c93799a724b3$var$getProvider(value) {
    if (value == null) return null;
    return value.provider || null;
}
async function $0e40c93799a724b3$export$fc358dcec4fec380(arg, allowed) {
    // Make sure the overrides passed in are a valid overrides object
    const _overrides = (0, $f832d0621d63460e$export$af51273277efe223).dereference(arg, "overrides");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof _overrides === "object", "invalid overrides parameter", "overrides", arg);
    // Create a shallow copy (we'll deep-ify anything needed during normalizing)
    const overrides = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(_overrides);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(overrides.to == null || (allowed || []).indexOf("to") >= 0, "cannot override to", "overrides.to", overrides.to);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(overrides.data == null || (allowed || []).indexOf("data") >= 0, "cannot override data", "overrides.data", overrides.data);
    // Resolve any from
    if (overrides.from) overrides.from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(overrides.from);
    return overrides;
}
async function $0e40c93799a724b3$export$32e61c94d45e7108(_runner, inputs, args) {
    // Recursively descend into args and resolve any addresses
    const runner = $0e40c93799a724b3$var$getRunner(_runner, "resolveName");
    const resolver = $0e40c93799a724b3$var$canResolve(runner) ? runner : null;
    return await Promise.all(inputs.map((param, index)=>{
        return param.walkAsync(args[index], (type, value)=>{
            value = (0, $f832d0621d63460e$export$af51273277efe223).dereference(value, type);
            if (type === "address") return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value, resolver);
            return value;
        });
    }));
}
function $0e40c93799a724b3$var$buildWrappedFallback(contract) {
    const populateTransaction = async function(overrides) {
        // If an overrides was passed in, copy it and normalize the values
        const tx = await $0e40c93799a724b3$export$fc358dcec4fec380(overrides, [
            "data"
        ]);
        tx.to = await contract.getAddress();
        const iface = contract.interface;
        const noValue = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.value || $0e40c93799a724b3$var$BN_0, "overrides.value") === $0e40c93799a724b3$var$BN_0;
        const noData = (tx.data || "0x") === "0x";
        if (iface.fallback && !iface.fallback.payable && iface.receive && !noData && !noValue) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "cannot send data to receive or send value to non-payable fallback", "overrides", overrides);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        // Only allow payable contracts to set non-zero value
        const payable = iface.receive || iface.fallback && iface.fallback.payable;
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(payable || noValue, "cannot send value to non-payable fallback", "overrides.value", tx.value);
        // Only allow fallback contracts to set non-empty data
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(iface.fallback || noData, "cannot send data to receive-only contract", "overrides.data", tx.data);
        return tx;
    };
    const staticCall = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(overrides);
        try {
            return await runner.call(tx);
        } catch (error) {
            if ((0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
    };
    const send = async function(overrides) {
        const runner = contract.runner;
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(overrides));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(overrides) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(overrides));
    };
    const method = async (overrides)=>{
        return await send(overrides);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        _contract: contract,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedMethod(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getFunction(key, args);
        (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const populateTransaction = async function(...args) {
        const fragment = getFragment(...args);
        // If an overrides was passed in, copy it and normalize the values
        let overrides = {};
        if (fragment.inputs.length + 1 === args.length) overrides = await $0e40c93799a724b3$export$fc358dcec4fec380(args.pop());
        if (fragment.inputs.length !== args.length) throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
        const resolvedArgs = await $0e40c93799a724b3$export$32e61c94d45e7108(contract.runner, fragment.inputs, args);
        return Object.assign({}, overrides, await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            to: contract.getAddress(),
            data: contract.interface.encodeFunctionData(fragment, resolvedArgs)
        }));
    };
    const staticCall = async function(...args) {
        const result = await staticCallResult(...args);
        if (result.length === 1) return result[0];
        return result;
    };
    const send = async function(...args) {
        const runner = contract.runner;
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canSend(runner), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
            operation: "sendTransaction"
        });
        const tx = await runner.sendTransaction(await populateTransaction(...args));
        const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
        // @TODO: the provider can be null; make a custom dummy provider that will throw a
        // meaningful error
        return new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(contract.interface, provider, tx);
    };
    const estimateGas = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "estimateGas");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canEstimate(runner), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
            operation: "estimateGas"
        });
        return await runner.estimateGas(await populateTransaction(...args));
    };
    const staticCallResult = async function(...args) {
        const runner = $0e40c93799a724b3$var$getRunner(contract.runner, "call");
        (0, $634aa51198273feb$export$a7a9523472993e97)($0e40c93799a724b3$var$canCall(runner), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
            operation: "call"
        });
        const tx = await populateTransaction(...args);
        let result = "0x";
        try {
            result = await runner.call(tx);
        } catch (error) {
            if ((0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data) throw contract.interface.makeError(error.data, tx);
            throw error;
        }
        const fragment = getFragment(...args);
        return contract.interface.decodeFunctionResult(fragment, result);
    };
    const method = async (...args)=>{
        const fragment = getFragment(...args);
        if (fragment.constant) return await staticCall(...args);
        return await send(...args);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getFunctionName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment,
        estimateGas: estimateGas,
        populateTransaction: populateTransaction,
        send: send,
        staticCall: staticCall,
        staticCallResult: staticCallResult
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getFunction(key);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
function $0e40c93799a724b3$var$buildWrappedEvent(contract, key) {
    const getFragment = function(...args) {
        const fragment = contract.interface.getEvent(key, args);
        (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
                key: key,
                args: args
            }
        });
        return fragment;
    };
    const method = function(...args) {
        return new $0e40c93799a724b3$var$PreparedTopicFilter(contract, getFragment(...args), args);
    };
    (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(method, {
        name: contract.interface.getEventName(key),
        _contract: contract,
        _key: key,
        getFragment: getFragment
    });
    // Only works on non-ambiguous keys (refined fragment is always non-ambiguous)
    Object.defineProperty(method, "fragment", {
        configurable: false,
        enumerable: true,
        get: ()=>{
            const fragment = contract.interface.getEvent(key);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "no matching fragment", "UNSUPPORTED_OPERATION", {
                operation: "fragment",
                info: {
                    key: key
                }
            });
            return fragment;
        }
    });
    return method;
}
// The combination of TypeScrype, Private Fields and Proxies makes
// the world go boom; so we hide variables with some trickery keeping
// a symbol attached to each BaseContract which its sub-class (even
// via a Proxy) can reach and use to look up its internal values.
const $0e40c93799a724b3$var$internal = Symbol.for("_ethersInternal_contract");
const $0e40c93799a724b3$var$internalValues = new WeakMap();
function $0e40c93799a724b3$var$setInternal(contract, values) {
    $0e40c93799a724b3$var$internalValues.set(contract[$0e40c93799a724b3$var$internal], values);
}
function $0e40c93799a724b3$var$getInternal(contract) {
    return $0e40c93799a724b3$var$internalValues.get(contract[$0e40c93799a724b3$var$internal]);
}
function $0e40c93799a724b3$var$isDeferred(value) {
    return value && typeof value === "object" && "getTopicFilter" in value && typeof value.getTopicFilter === "function" && value.fragment;
}
async function $0e40c93799a724b3$var$getSubInfo(contract, event) {
    let topics;
    let fragment = null;
    // Convert named events to topicHash and get the fragment for
    // events which need deconstructing.
    if (Array.isArray(event)) {
        const topicHashify = function(name) {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(name, 32)) return name;
            const fragment = contract.interface.getEvent(name);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "unknown fragment", "name", name);
            return fragment.topicHash;
        };
        // Array of Topics and Names; e.g. `[ "0x1234...89ab", "Transfer(address)" ]`
        topics = event.map((e)=>{
            if (e == null) return null;
            if (Array.isArray(e)) return e.map(topicHashify);
            return topicHashify(e);
        });
    } else if (event === "*") topics = [
        null
    ];
    else if (typeof event === "string") {
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(event, 32)) // Topic Hash
        topics = [
            event
        ];
        else {
            // Name or Signature; e.g. `"Transfer", `"Transfer(address)"`
            fragment = contract.interface.getEvent(event);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(fragment, "unknown fragment", "event", event);
            topics = [
                fragment.topicHash
            ];
        }
    } else if ($0e40c93799a724b3$var$isDeferred(event)) // Deferred Topic Filter; e.g. `contract.filter.Transfer(from)`
    topics = await event.getTopicFilter();
    else if ("fragment" in event) {
        // ContractEvent; e.g. `contract.filter.Transfer`
        fragment = event.fragment;
        topics = [
            fragment.topicHash
        ];
    } else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown event name", "event", event);
    // Normalize topics and sort TopicSets
    topics = topics.map((t)=>{
        if (t == null) return null;
        if (Array.isArray(t)) {
            const items = Array.from(new Set(t.map((t)=>t.toLowerCase())).values());
            if (items.length === 1) return items[0];
            items.sort();
            return items;
        }
        return t.toLowerCase();
    });
    const tag = topics.map((t)=>{
        if (t == null) return "null";
        if (Array.isArray(t)) return t.join("|");
        return t;
    }).join("&");
    return {
        fragment: fragment,
        tag: tag,
        topics: topics
    };
}
async function $0e40c93799a724b3$var$hasSub(contract, event) {
    const { subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    return subs.get((await $0e40c93799a724b3$var$getSubInfo(contract, event)).tag) || null;
}
async function $0e40c93799a724b3$var$getSub(contract, operation, event) {
    // Make sure our runner can actually subscribe to events
    const provider = $0e40c93799a724b3$var$getProvider(contract.runner);
    (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
    const { fragment: fragment, tag: tag, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(contract, event);
    const { addr: addr, subs: subs } = $0e40c93799a724b3$var$getInternal(contract);
    let sub = subs.get(tag);
    if (!sub) {
        const address = addr ? addr : contract;
        const filter = {
            address: address,
            topics: topics
        };
        const listener = (log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = contract.interface.getEvent(log.topics[0]);
            } catch (error) {}
            // If fragment is null, we do not deconstruct the args to emit
            if (foundFragment) {
                const _foundFragment = foundFragment;
                const args = fragment ? contract.interface.decodeEventLog(fragment, log.data, log.topics) : [];
                $0e40c93799a724b3$var$emit(contract, event, args, (listener)=>{
                    return new (0, $0ab0dbf63d0f506e$export$35f9272dc1c07dee)(contract, listener, event, _foundFragment, log);
                });
            } else $0e40c93799a724b3$var$emit(contract, event, [], (listener)=>{
                return new (0, $0ab0dbf63d0f506e$export$54be5ec94ad26a69)(contract, listener, event, log);
            });
        };
        let starting = [];
        const start = ()=>{
            if (starting.length) return;
            starting.push(provider.on(filter, listener));
        };
        const stop = async ()=>{
            if (starting.length == 0) return;
            let started = starting;
            starting = [];
            await Promise.all(started);
            provider.off(filter, listener);
        };
        sub = {
            tag: tag,
            listeners: [],
            start: start,
            stop: stop
        };
        subs.set(tag, sub);
    }
    return sub;
}
// We use this to ensure one emit resolves before firing the next to
// ensure correct ordering (note this cannot throw and just adds the
// notice to the event queu using setTimeout).
let $0e40c93799a724b3$var$lastEmit = Promise.resolve();
async function $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc) {
    await $0e40c93799a724b3$var$lastEmit;
    const sub = await $0e40c93799a724b3$var$hasSub(contract, event);
    if (!sub) return false;
    const count = sub.listeners.length;
    sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
        const passArgs = Array.from(args);
        if (payloadFunc) passArgs.push(payloadFunc(once ? null : listener));
        try {
            listener.call(contract, ...passArgs);
        } catch (error) {}
        return !once;
    });
    if (sub.listeners.length === 0) {
        sub.stop();
        $0e40c93799a724b3$var$getInternal(contract).subs.delete(sub.tag);
    }
    return count > 0;
}
async function $0e40c93799a724b3$var$emit(contract, event, args, payloadFunc) {
    try {
        await $0e40c93799a724b3$var$lastEmit;
    } catch (error) {}
    const resultPromise = $0e40c93799a724b3$var$_emit(contract, event, args, payloadFunc);
    $0e40c93799a724b3$var$lastEmit = resultPromise;
    return await resultPromise;
}
const $0e40c93799a724b3$var$passProperties = [
    "then"
];
class $0e40c93799a724b3$export$304faa4fc17528db {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */ target;
    /**
     *  The contract Interface.
     */ interface;
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */ runner;
    /**
     *  All the Events available on this contract.
     */ filters;
    /**
     *  @_ignore:
     */ [$0e40c93799a724b3$var$internal];
    /**
     *  The fallback or receive function if any.
     */ fallback;
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */ constructor(target, abi, runner, _deployTx){
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof target === "string" || (0, $ed11119eb2f9aa0c$export$6a88e03bca5eb759)(target), "invalid value for Contract target", "target", target);
        if (runner == null) runner = null;
        const iface = (0, $fcb356ece91f4842$export$48cefb51a4e315b2).from(abi);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            target: target,
            runner: runner,
            interface: iface
        });
        Object.defineProperty(this, $0e40c93799a724b3$var$internal, {
            value: {}
        });
        let addrPromise;
        let addr = null;
        let deployTx = null;
        if (_deployTx) {
            const provider = $0e40c93799a724b3$var$getProvider(runner);
            // @TODO: the provider can be null; make a custom dummy provider that will throw a
            // meaningful error
            deployTx = new (0, $0ab0dbf63d0f506e$export$853f7e2df34220ff)(this.interface, provider, _deployTx);
        }
        let subs = new Map();
        // Resolve the target as the address
        if (typeof target === "string") {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(target)) {
                addr = target;
                addrPromise = Promise.resolve(target);
            } else {
                const resolver = $0e40c93799a724b3$var$getRunner(runner, "resolveName");
                if (!$0e40c93799a724b3$var$canResolve(resolver)) throw (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
                    operation: "resolveName"
                });
                addrPromise = resolver.resolveName(target).then((addr)=>{
                    if (addr == null) throw (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
                        value: target
                    });
                    $0e40c93799a724b3$var$getInternal(this).addr = addr;
                    return addr;
                });
            }
        } else addrPromise = target.getAddress().then((addr)=>{
            if (addr == null) throw new Error("TODO");
            $0e40c93799a724b3$var$getInternal(this).addr = addr;
            return addr;
        });
        // Set our private values
        $0e40c93799a724b3$var$setInternal(this, {
            addrPromise: addrPromise,
            addr: addr,
            deployTx: deployTx,
            subs: subs
        });
        // Add the event filters
        const filters = new Proxy({}, {
            get: (target, prop, receiver)=>{
                // Pass important checks (like `then` for Promise) through
                if (typeof prop === "symbol" || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                try {
                    return this.getEvent(prop);
                } catch (error) {
                    if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                // Pass important checks (like `then` for Promise) through
                if ($0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return Reflect.has(target, prop) || this.interface.hasEvent(String(prop));
            }
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            filters: filters
        });
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            fallback: iface.receive || iface.fallback ? $0e40c93799a724b3$var$buildWrappedFallback(this) : null
        });
        // Return a Proxy that will respond to functions
        return new Proxy(this, {
            get: (target, prop, receiver)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.get(target, prop, receiver);
                // Undefined properties should return undefined
                try {
                    return target.getFunction(prop);
                } catch (error) {
                    if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "INVALID_ARGUMENT") || error.argument !== "key") throw error;
                }
                return undefined;
            },
            has: (target, prop)=>{
                if (typeof prop === "symbol" || prop in target || $0e40c93799a724b3$var$passProperties.indexOf(prop) >= 0) return Reflect.has(target, prop);
                return target.interface.hasFunction(prop);
            }
        });
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */ connect(runner) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(this.target, this.interface, runner);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */ attach(target) {
        return new $0e40c93799a724b3$export$304faa4fc17528db(target, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */ async getAddress() {
        return await $0e40c93799a724b3$var$getInternal(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */ async getDeployedCode() {
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "getDeployedCode"
        });
        const code = await provider.getCode(await this.getAddress());
        if (code === "0x") return null;
        return code;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */ async waitForDeployment() {
        // We have the deployement transaction; just use that (throws if deployement fails)
        const deployTx = this.deploymentTransaction();
        if (deployTx) {
            await deployTx.wait();
            return this;
        }
        // Check for code
        const code = await this.getDeployedCode();
        if (code != null) return this;
        // Make sure we can subscribe to a provider event
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
            operation: "waitForDeployment"
        });
        return new Promise((resolve, reject)=>{
            const checkCode = async ()=>{
                try {
                    const code = await this.getDeployedCode();
                    if (code != null) return resolve(this);
                    provider.once("block", checkCode);
                } catch (error) {
                    reject(error);
                }
            };
            checkCode();
        });
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */ deploymentTransaction() {
        return $0e40c93799a724b3$var$getInternal(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getFunction(key) {
        if (typeof key !== "string") key = key.format();
        const func = $0e40c93799a724b3$var$buildWrappedMethod(this, key);
        return func;
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */ getEvent(key) {
        if (typeof key !== "string") key = key.format();
        return $0e40c93799a724b3$var$buildWrappedEvent(this, key);
    }
    /**
     *  @_ignore:
     */ async queryTransaction(hash) {
        throw new Error("@TODO");
    }
    /*
    // @TODO: this is a non-backwards compatible change, but will be added
    //        in v7 and in a potential SmartContract class in an upcoming
    //        v6 release
    async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
        const provider = getProvider(this.runner);
        assert(provider, "contract runner does not have a provider",
            "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

        const receipt = await provider.getTransactionReceipt(hash);
        if (receipt == null) { return null; }

        return new ContractTransactionReceipt(this.interface, provider, receipt);
    }
    */ /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */ async queryFilter(event, fromBlock, toBlock) {
        if (fromBlock == null) fromBlock = 0;
        if (toBlock == null) toBlock = "latest";
        const { addr: addr, addrPromise: addrPromise } = $0e40c93799a724b3$var$getInternal(this);
        const address = addr ? addr : await addrPromise;
        const { fragment: fragment, topics: topics } = await $0e40c93799a724b3$var$getSubInfo(this, event);
        const filter = {
            address: address,
            topics: topics,
            fromBlock: fromBlock,
            toBlock: toBlock
        };
        const provider = $0e40c93799a724b3$var$getProvider(this.runner);
        (0, $634aa51198273feb$export$a7a9523472993e97)(provider, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
            operation: "queryFilter"
        });
        return (await provider.getLogs(filter)).map((log)=>{
            let foundFragment = fragment;
            if (foundFragment == null) try {
                foundFragment = this.interface.getEvent(log.topics[0]);
            } catch (error) {}
            if (foundFragment) try {
                return new (0, $0ab0dbf63d0f506e$export$f8203d08df5cd081)(log, this.interface, foundFragment);
            } catch (error) {
                return new (0, $0ab0dbf63d0f506e$export$53f6e6acc02bf489)(log, error);
            }
            return new (0, $425e3311db5fb4d1$export$ce30dbb46644d06c)(log, provider);
        });
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */ async on(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "on", event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        sub.start();
        return this;
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */ async once(event, listener) {
        const sub = await $0e40c93799a724b3$var$getSub(this, "once", event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        sub.start();
        return this;
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */ async emit(event, ...args) {
        return await $0e40c93799a724b3$var$emit(this, event, args, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */ async listenerCount(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let total = 0;
        for (const { listeners: listeners } of subs.values())total += listeners.length;
        return total;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */ async listeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
        let result = [];
        for (const { listeners: listeners } of subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */ async off(event, listener) {
        const sub = await $0e40c93799a724b3$var$hasSub(this, event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (listener == null || sub.listeners.length === 0) {
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        }
        return this;
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */ async removeAllListeners(event) {
        if (event) {
            const sub = await $0e40c93799a724b3$var$hasSub(this, event);
            if (!sub) return this;
            sub.stop();
            $0e40c93799a724b3$var$getInternal(this).subs.delete(sub.tag);
        } else {
            const { subs: subs } = $0e40c93799a724b3$var$getInternal(this);
            for (const { tag: tag, stop: stop } of subs.values()){
                stop();
                subs.delete(tag);
            }
        }
        return this;
    }
    /**
     *  Alias for [on].
     */ async addListener(event, listener) {
        return await this.on(event, listener);
    }
    /**
     *  Alias for [off].
     */ async removeListener(event, listener) {
        return await this.off(event, listener);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */ static buildClass(abi) {
        class CustomContract extends $0e40c93799a724b3$export$304faa4fc17528db {
            constructor(address, runner = null){
                super(address, abi, runner);
            }
        }
        return CustomContract;
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */ static from(target, abi, runner) {
        if (runner == null) runner = null;
        const contract = new this(target, abi, runner);
        return contract;
    }
}
function $0e40c93799a724b3$var$_ContractBase() {
    return $0e40c93799a724b3$export$304faa4fc17528db;
}
class $0e40c93799a724b3$export$8517d80acf00e19a extends $0e40c93799a724b3$var$_ContractBase() {
}



/**
 *  One of the most common ways to interact with the blockchain is
 *  by a node running a JSON-RPC interface which can be connected to,
 *  based on the transport, using:
 *
 *  - HTTP or HTTPS - [[JsonRpcProvider]]
 *  - WebSocket - [[WebSocketProvider]]
 *  - IPC - [[IpcSocketProvider]]
 *
 * @_section: api/providers/jsonrpc:JSON-RPC Provider  [about-jsonrpcProvider]
 */ // @TODO:
// - Add the batching API
// https://playground.open-rpc.org/?schemaUrl=https://raw.githubusercontent.com/ethereum/eth1.0-apis/assembled-spec/openrpc.json&uiSchema%5BappBar%5D%5Bui:splitView%5D=true&uiSchema%5BappBar%5D%5Bui:input%5D=false&uiSchema%5BappBar%5D%5Bui:examplesDropdown%5D=false


//import { TypedDataDomain, TypedDataField } from "@ethersproject/providerabstract-signer";




function $e25c0939af0d847b$export$e67e2732ba9803f9(key) {
    let pubkey;
    if (typeof key === "string") pubkey = (0, $015cdebda6711d1b$export$21643ca94aed3e83).computePublicKey(key, false);
    else pubkey = key.publicKey;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)("0x" + pubkey.substring(4)).substring(26));
}
function $e25c0939af0d847b$export$23cc18f96d8510e2(digest, signature) {
    return $e25c0939af0d847b$export$e67e2732ba9803f9((0, $015cdebda6711d1b$export$21643ca94aed3e83).recoverPublicKey(digest, signature));
}




const $23f01ceb797ea4ad$var$padding = new Uint8Array(32);
$23f01ceb797ea4ad$var$padding.fill(0);
const $23f01ceb797ea4ad$var$BN__1 = BigInt(-1);
const $23f01ceb797ea4ad$var$BN_0 = BigInt(0);
const $23f01ceb797ea4ad$var$BN_1 = BigInt(1);
const $23f01ceb797ea4ad$var$BN_MAX_UINT256 = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $23f01ceb797ea4ad$var$hexPadRight(value) {
    const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        bytes,
        $23f01ceb797ea4ad$var$padding.slice(padOffset)
    ]);
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
}
const $23f01ceb797ea4ad$var$hexTrue = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)($23f01ceb797ea4ad$var$BN_1, 32);
const $23f01ceb797ea4ad$var$hexFalse = (0, $6fa405e57bb6371e$export$c6ebe05badb16181)($23f01ceb797ea4ad$var$BN_0, 32);
const $23f01ceb797ea4ad$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $23f01ceb797ea4ad$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $23f01ceb797ea4ad$var$checkString(key) {
    return function(value) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "string", `invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $23f01ceb797ea4ad$var$domainChecks = {
    name: $23f01ceb797ea4ad$var$checkString("name"),
    version: $23f01ceb797ea4ad$var$checkString("version"),
    chainId: function(_value) {
        const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "domain.chainId");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= 0, "invalid chain ID", "domain.chainId", _value);
        if (Number.isSafeInteger(value)) return Number(value);
        return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $69ef3f917ff239a2$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value, "domain.salt");
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(bytes.length === 32, `invalid domain value "salt"`, "domain.salt", value);
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes);
    }
};
function $23f01ceb797ea4ad$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(width % 8 === 0 && width !== 0 && width <= 256 && (match[2] == null || match[2] === String(width)), "invalid numeric width", "type", type);
            const boundsUpper = (0, $6fa405e57bb6371e$export$d99f0801a68bbcf1)($23f01ceb797ea4ad$var$BN_MAX_UINT256, signed ? width - 1 : width);
            const boundsLower = signed ? (boundsUpper + $23f01ceb797ea4ad$var$BN_1) * $23f01ceb797ea4ad$var$BN__1 : $23f01ceb797ea4ad$var$BN_0;
            return function(_value) {
                const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "value");
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(value >= boundsLower && value <= boundsUpper, `value out-of-bounds for ${type}`, "value", value);
                return (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(signed ? (0, $6fa405e57bb6371e$export$7101cd4e6275351c)(value, 256) : value, 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(width !== 0 && width <= 32 && match[1] === String(width), "invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(bytes.length === width, `invalid length for ${type}`, "value", value);
                return $23f01ceb797ea4ad$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $fd3872da8feed9cb$export$4473860254365feb)((0, $69ef3f917ff239a2$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $23f01ceb797ea4ad$var$hexFalse : $23f01ceb797ea4ad$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $23f01ceb797ea4ad$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $23f01ceb797ea4ad$export$458ab927ae635c3 {
    /**
     *  The primary type for the structured [[types]].
     *
     *  This is derived automatically from the [[types]], since no
     *  recursion is possible, once the DAG for the types is consturcted
     *  internally, the primary type must be the only remaining type with
     *  no parent nodes.
     */ primaryType;
    #types;
    /**
     *  The types.
     */ get types() {
        return JSON.parse(this.#types);
    }
    #fullTypes;
    #encoderCache;
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     *
     *  This performs all necessary checking that types are valid and
     *  do not violate the [[link-eip-712]] structural constraints as
     *  well as computes the [[primaryType]].
     */ constructor(types){
        this.#types = JSON.stringify(types);
        this.#fullTypes = new Map();
        this.#encoderCache = new Map();
        // Link struct types to their direct child structs
        const links = new Map();
        // Link structs to structs which contain them as a child
        const parents = new Map();
        // Link all subtypes within a given struct
        const subtypes = new Map();
        Object.keys(types).forEach((type)=>{
            links.set(type, new Set());
            parents.set(type, []);
            subtypes.set(type, new Set());
        });
        for(const name in types){
            const uniqueNames = new Set();
            for (const field of types[name]){
                // Check each field has a unique name
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(!uniqueNames.has(field.name), `duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames.add(field.name);
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1] || null;
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(baseType !== name, `circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(baseType);
                if (encoder) continue;
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(parents.has(baseType), `unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents.get(baseType).push(name);
                links.get(name).add(baseType);
            }
        }
        // Deduce the primary type
        const primaryTypes = Array.from(parents.keys()).filter((n)=>parents.get(n).length === 0);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(primaryTypes.length !== 0, "missing primary type", "types", types);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(primaryTypes.length === 1, `ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            primaryType: primaryTypes[0]
        });
        // Check for circular type references
        function checkCircular(type, found) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(!found.has(type), `circular type reference to ${JSON.stringify(type)}`, "types", types);
            found.add(type);
            for (const child of links.get(type)){
                if (!parents.has(child)) continue;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                for (const subtype of found)subtypes.get(subtype).add(child);
            }
            found.delete(type);
        }
        checkCircular(this.primaryType, new Set());
        // Compute each fully describe type
        for (const [name, set] of subtypes){
            const st = Array.from(set);
            st.sort();
            this.#fullTypes.set(name, $23f01ceb797ea4ad$var$encodeType(name, types[name]) + st.map((t)=>$23f01ceb797ea4ad$var$encodeType(t, types[t])).join(""));
        }
    }
    /**
     *  Returnthe encoder for the specific %%type%%.
     */ getEncoder(type) {
        let encoder = this.#encoderCache.get(type);
        if (!encoder) {
            encoder = this.#getEncoder(type);
            this.#encoderCache.set(type, encoder);
        }
        return encoder;
    }
    #getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            return (value)=>{
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(!match[3] || parseInt(match[3]) === value.length, `array length mismatch; expected length ${parseInt(match[3])}`, "value", value);
                let result = value.map(subEncoder);
                if (this.#fullTypes.has(subtype)) result = result.map((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35));
                return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $697215a61e1ccd96$export$d560c7e4a29451c2)(this.#fullTypes.get(type));
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this.#fullTypes.has(type)) return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(values);
            };
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Return the full type for %%name%%.
     */ encodeType(name) {
        const result = this.#fullTypes.get(name);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(result, `unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    /**
     *  Return the encoded %%value%% for the %%type%%.
     */ encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    /**
     *  Returns the hash of %%value%% for the type of %%name%%.
     */ hashStruct(name, value) {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    /**
     *  Return the fulled encoded %%value%% for the [[types]].
     */ encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    /**
     *  Return the hash of the fully encoded %%value%% for the [[types]].
     */ hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    /**
     *  @_ignore:
     */ _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $23f01ceb797ea4ad$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(!match[3] || parseInt(match[3]) === value.length, `array length mismatch; expected length ${parseInt(match[3])}`, "value", value);
            return value.map((v)=>this._visit(match[1], v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `unknown type: ${type}`, "type", type);
    }
    /**
     *  Call %%calback%% for each value in %%value%%, passing the type and
     *  component within %%value%%.
     *
     *  This is useful for replacing addresses or other transformation that
     *  may be desired on each component, based on its type.
     */ visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    /**
     *  Create a new **TypedDataEncoder** for %%types%%.
     */ static from(types) {
        return new $23f01ceb797ea4ad$export$458ab927ae635c3(types);
    }
    /**
     *  Return the primary type for %%types%%.
     */ static getPrimaryType(types) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).primaryType;
    }
    /**
     *  Return the hashed struct for %%value%% using %%types%% and %%name%%.
     */ static hashStruct(name, types, value) {
        return $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    /**
     *  Return the domain hash for %%domain%%.
     */ static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            if (domain[name] == null) continue;
            const type = $23f01ceb797ea4ad$var$domainFieldTypes[name];
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(type, `invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $23f01ceb797ea4ad$var$domainFieldNames.indexOf(a.name) - $23f01ceb797ea4ad$var$domainFieldNames.indexOf(b.name);
        });
        return $23f01ceb797ea4ad$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    /**
     *  Return the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static encode(domain, types, value) {
        return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
            "0x1901",
            $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain),
            $23f01ceb797ea4ad$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    /**
     *  Return the hash of the fully encoded [[link-eip-712]] %%value%% for %%types%% with %%domain%%.
     */ static hash(domain, types, value) {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)($23f01ceb797ea4ad$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    /**
     * Resolves to the value from resolving all addresses in %%value%% for
     * %%types%% and the %%domain%%.
     */ static async resolveNames(domain, types, value, resolveName) {
        // Make a copy to isolate it from the object passed in
        domain = Object.assign({}, domain);
        // Allow passing null to ignore value
        for(const key in domain)if (domain[key] == null) delete domain[key];
        // Look up all ENS names
        const ensCache = {};
        // Do we need to look up the domain's verifyingContract?
        if (domain.verifyingContract && !(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
        // We are going to use the encoder to visit all the base values
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        // Get a list of all the addresses
        encoder.visit(value, (type, value)=>{
            if (type === "address" && !(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
            return value;
        });
        // Lookup each name
        for(const name in ensCache)ensCache[name] = await resolveName(name);
        // Replace the domain verifyingContract if needed
        if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
        // Replace all ENS names with their address
        value = encoder.visit(value, (type, value)=>{
            if (type === "address" && ensCache[value]) return ensCache[value];
            return value;
        });
        return {
            domain: domain,
            value: value
        };
    }
    /**
     *  Returns the JSON-encoded payload expected by nodes which implement
     *  the JSON-RPC [[link-eip-712]] method.
     */ static getPayload(domain, types, value) {
        // Validate the domain fields
        $23f01ceb797ea4ad$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $23f01ceb797ea4ad$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $23f01ceb797ea4ad$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $23f01ceb797ea4ad$var$domainFieldTypes[name]
            });
        });
        const encoder = $23f01ceb797ea4ad$export$458ab927ae635c3.from(types);
        const typesWithDomain = Object.assign({}, types);
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typesWithDomain.EIP712Domain == null, "types must not contain EIP712Domain type", "types.EIP712Domain", types);
        typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "string", "invalid string", "value", value);
                        return value;
                }
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported type", "type", type);
            })
        };
    }
}
function $23f01ceb797ea4ad$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $e25c0939af0d847b$export$23cc18f96d8510e2)($23f01ceb797ea4ad$export$458ab927ae635c3.hash(domain, types, value), signature);
}



/**
 *  Fetching content from the web is environment-specific, so Ethers
 *  provides an abstraction the each environment can implement to provide
 *  this service.
 *
 *  On [Node.js](link-node), the ``http`` and ``https`` libs are used to
 *  create a request object, register event listeners and process data
 *  and populate the [[FetchResponse]].
 *
 *  In a browser, the [DOM fetch](link-js-fetch) is used, and the resulting
 *  ``Promise`` is waited on to retreive the payload.
 *
 *  The [[FetchRequest]] is responsible for handling many common situations,
 *  such as redirects, server throttling, authentcation, etc.
 *
 *  It also handles common gateways, such as IPFS and data URIs.
 *
 *  @_section api/utils/fetching:Fetching Web Content  [about-fetch]
 */ // utils/base64-browser

function $4d58342a3bfda827$export$94fdf11bafc8de6b(textData) {
    textData = atob(textData);
    const data = new Uint8Array(textData.length);
    for(let i = 0; i < textData.length; i++)data[i] = textData.charCodeAt(i);
    return (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data);
}
function $4d58342a3bfda827$export$8fb536984ec8b4d7(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}







async function $9834edf3ba75eaa8$export$94df0e59ebebf4a7(req, _signal) {
    const protocol = req.url.split(":")[0].toLowerCase();
    (0, $634aa51198273feb$export$a7a9523472993e97)(protocol === "http" || protocol === "https", `unsupported protocol ${protocol}`, "UNSUPPORTED_OPERATION", {
        info: {
            protocol: protocol
        },
        operation: "request"
    });
    (0, $634aa51198273feb$export$a7a9523472993e97)(protocol === "https" || !req.credentials || req.allowInsecureAuthentication, "insecure authorized connections unsupported", "UNSUPPORTED_OPERATION", {
        operation: "request"
    });
    let signal = undefined;
    if (_signal) {
        const controller = new AbortController();
        signal = controller.signal;
        _signal.addListener(()=>{
            controller.abort();
        });
    }
    const init = {
        method: req.method,
        headers: new Headers(Array.from(req)),
        body: req.body || undefined,
        signal: signal
    };
    const resp = await fetch(req.url, init);
    const headers = {};
    resp.headers.forEach((value, key)=>{
        headers[key.toLowerCase()] = value;
    });
    const respBody = await resp.arrayBuffer();
    const body = respBody == null ? null : new Uint8Array(respBody);
    return {
        statusCode: resp.status,
        statusMessage: resp.statusText,
        headers: headers,
        body: body
    };
}


const $2cb10defc4f72334$var$MAX_ATTEMPTS = 12;
const $2cb10defc4f72334$var$SLOT_INTERVAL = 250;
// The global FetchGetUrlFunc implementation.
let $2cb10defc4f72334$var$getUrlFunc = (0, $9834edf3ba75eaa8$export$94df0e59ebebf4a7);
const $2cb10defc4f72334$var$reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
const $2cb10defc4f72334$var$reIpfs = new RegExp("^ipfs://(ipfs/)?(.*)$", "i");
// If locked, new Gateways cannot be added
let $2cb10defc4f72334$var$locked = false;
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URLs
async function $2cb10defc4f72334$var$dataGatewayFunc(url, signal) {
    try {
        const match = url.match($2cb10defc4f72334$var$reData);
        if (!match) throw new Error("invalid data");
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(200, "OK", {
            "content-type": match[1] || "text/plain"
        }, match[2] ? (0, $4d58342a3bfda827$export$94fdf11bafc8de6b)(match[3]) : $2cb10defc4f72334$var$unpercent(match[3]));
    } catch (error) {
        return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid data: URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
    }
}
/**
 *  Returns a [[FetchGatewayFunc]] for fetching content from a standard
 *  IPFS gateway hosted at %%baseUrl%%.
 */ function $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl) {
    async function gatewayIpfs(url, signal) {
        try {
            const match = url.match($2cb10defc4f72334$var$reIpfs);
            if (!match) throw new Error("invalid link");
            return new $2cb10defc4f72334$export$319b96fe59834522(`${baseUrl}${match[2]}`);
        } catch (error) {
            return new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, "BAD REQUEST (invalid IPFS URI)", {}, null, new $2cb10defc4f72334$export$319b96fe59834522(url));
        }
    }
    return gatewayIpfs;
}
const $2cb10defc4f72334$var$Gateways = {
    "data": $2cb10defc4f72334$var$dataGatewayFunc,
    "ipfs": $2cb10defc4f72334$var$getIpfsGatewayFunc("https://gateway.ipfs.io/ipfs/")
};
const $2cb10defc4f72334$var$fetchSignals = new WeakMap();
class $2cb10defc4f72334$export$ef5e7a6febaa4c8b {
    #listeners;
    #cancelled;
    constructor(request){
        this.#listeners = [];
        this.#cancelled = false;
        $2cb10defc4f72334$var$fetchSignals.set(request, ()=>{
            if (this.#cancelled) return;
            this.#cancelled = true;
            for (const listener of this.#listeners)setTimeout(()=>{
                listener();
            }, 0);
            this.#listeners = [];
        });
    }
    addListener(listener) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!this.#cancelled, "singal already cancelled", "UNSUPPORTED_OPERATION", {
            operation: "fetchCancelSignal.addCancelListener"
        });
        this.#listeners.push(listener);
    }
    get cancelled() {
        return this.#cancelled;
    }
    checkSignal() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(!this.cancelled, "cancelled", "CANCELLED", {});
    }
}
// Check the signal, throwing if it is cancelled
function $2cb10defc4f72334$var$checkSignal(signal) {
    if (signal == null) throw new Error("missing signal; should not happen");
    signal.checkSignal();
    return signal;
}
class $2cb10defc4f72334$export$319b96fe59834522 {
    #allowInsecure;
    #gzip;
    #headers;
    #method;
    #timeout;
    #url;
    #body;
    #bodyType;
    #creds;
    // Hooks
    #preflight;
    #process;
    #retry;
    #signal;
    #throttle;
    /**
     *  The fetch URI to requrest.
     */ get url() {
        return this.#url;
    }
    set url(url) {
        this.#url = String(url);
    }
    /**
     *  The fetch body, if any, to send as the request body. //(default: null)//
     *
     *  When setting a body, the intrinsic ``Content-Type`` is automatically
     *  set and will be used if **not overridden** by setting a custom
     *  header.
     *
     *  If %%body%% is null, the body is cleared (along with the
     *  intrinsic ``Content-Type``) and the .
     *
     *  If %%body%% is a string, the intrincis ``Content-Type`` is set to
     *  ``text/plain``.
     *
     *  If %%body%% is a Uint8Array, the intrincis ``Content-Type`` is set to
     *  ``application/octet-stream``.
     *
     *  If %%body%% is any other object, the intrincis ``Content-Type`` is
     *  set to ``application/json``.
     */ get body() {
        if (this.#body == null) return null;
        return new Uint8Array(this.#body);
    }
    set body(body) {
        if (body == null) {
            this.#body = undefined;
            this.#bodyType = undefined;
        } else if (typeof body === "string") {
            this.#body = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(body);
            this.#bodyType = "text/plain";
        } else if (body instanceof Uint8Array) {
            this.#body = body;
            this.#bodyType = "application/octet-stream";
        } else if (typeof body === "object") {
            this.#body = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(JSON.stringify(body));
            this.#bodyType = "application/json";
        } else throw new Error("invalid body");
    }
    /**
     *  Returns true if the request has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The HTTP method to use when requesting the URI. If no method
     *  has been explicitly set, then ``GET`` is used if the body is
     *  null and ``POST`` otherwise.
     */ get method() {
        if (this.#method) return this.#method;
        if (this.hasBody()) return "POST";
        return "GET";
    }
    set method(method) {
        if (method == null) method = "";
        this.#method = String(method).toUpperCase();
    }
    /**
     *  The headers that will be used when requesting the URI. All
     *  keys are lower-case.
     *
     *  This object is a copy, so any chnages will **NOT** be reflected
     *  in the ``FetchRequest``.
     *
     *  To set a header entry, use the ``setHeader`` method.
     */ get headers() {
        const headers = Object.assign({}, this.#headers);
        if (this.#creds) headers["authorization"] = `Basic ${(0, $4d58342a3bfda827$export$8fb536984ec8b4d7)((0, $50aa15ceb128a952$export$8feeb310b4b4752f)(this.#creds))}`;
        if (this.allowGzip) headers["accept-encoding"] = "gzip";
        if (headers["content-type"] == null && this.#bodyType) headers["content-type"] = this.#bodyType;
        if (this.body) headers["content-length"] = String(this.body.length);
        return headers;
    }
    /**
     *  Get the header for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Set the header for %%key%% to %%value%%. All values are coerced
     *  to a string.
     */ setHeader(key, value) {
        this.#headers[String(key).toLowerCase()] = String(value);
    }
    /**
     *  Clear all headers, resetting all intrinsic headers.
     */ clearHeaders() {
        this.#headers = {};
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     *  The value that will be sent for the ``Authorization`` header.
     *
     *  To set the credentials, use the ``setCredentials`` method.
     */ get credentials() {
        return this.#creds || null;
    }
    /**
     *  Sets an ``Authorization`` for %%username%% with %%password%%.
     */ setCredentials(username, password) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!username.match(/:/), "invalid basic authentication username", "username", "[REDACTED]");
        this.#creds = `${username}:${password}`;
    }
    /**
     *  Enable and request gzip-encoded responses. The response will
     *  automatically be decompressed. //(default: true)//
     */ get allowGzip() {
        return this.#gzip;
    }
    set allowGzip(value) {
        this.#gzip = !!value;
    }
    /**
     *  Allow ``Authentication`` credentials to be sent over insecure
     *  channels. //(default: false)//
     */ get allowInsecureAuthentication() {
        return !!this.#allowInsecure;
    }
    set allowInsecureAuthentication(value) {
        this.#allowInsecure = !!value;
    }
    /**
     *  The timeout (in milliseconds) to wait for a complere response.
     *  //(default: 5 minutes)//
     */ get timeout() {
        return this.#timeout;
    }
    set timeout(timeout) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(timeout >= 0, "timeout must be non-zero", "timeout", timeout);
        this.#timeout = timeout;
    }
    /**
     *  This function is called prior to each request, for example
     *  during a redirection or retry in case of server throttling.
     *
     *  This offers an opportunity to populate headers or update
     *  content before sending a request.
     */ get preflightFunc() {
        return this.#preflight || null;
    }
    set preflightFunc(preflight) {
        this.#preflight = preflight;
    }
    /**
     *  This function is called after each response, offering an
     *  opportunity to provide client-level throttling or updating
     *  response data.
     *
     *  Any error thrown in this causes the ``send()`` to throw.
     *
     *  To schedule a retry attempt (assuming the maximum retry limit
     *  has not been reached), use [[response.throwThrottleError]].
     */ get processFunc() {
        return this.#process || null;
    }
    set processFunc(process) {
        this.#process = process;
    }
    /**
     *  This function is called on each retry attempt.
     */ get retryFunc() {
        return this.#retry || null;
    }
    set retryFunc(retry) {
        this.#retry = retry;
    }
    /**
     *  Create a new FetchRequest instance with default values.
     *
     *  Once created, each property may be set before issuing a
     *  ``.send()`` to make the request.
     */ constructor(url){
        this.#url = String(url);
        this.#allowInsecure = false;
        this.#gzip = true;
        this.#headers = {};
        this.#method = "";
        this.#timeout = 300000;
        this.#throttle = {
            slotInterval: $2cb10defc4f72334$var$SLOT_INTERVAL,
            maxAttempts: $2cb10defc4f72334$var$MAX_ATTEMPTS
        };
    }
    toString() {
        return `<FetchRequest method=${JSON.stringify(this.method)} url=${JSON.stringify(this.url)} headers=${JSON.stringify(this.headers)} body=${this.#body ? (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  Update the throttle parameters used to determine maximum
     *  attempts and exponential-backoff properties.
     */ setThrottleParams(params) {
        if (params.slotInterval != null) this.#throttle.slotInterval = params.slotInterval;
        if (params.maxAttempts != null) this.#throttle.maxAttempts = params.maxAttempts;
    }
    async #send(attempt, expires, delay, _request, _response) {
        if (attempt >= this.#throttle.maxAttempts) return _response.makeServerError("exceeded maximum retry limit");
        (0, $634aa51198273feb$export$a7a9523472993e97)($2cb10defc4f72334$var$getTime() <= expires, "timeout", "TIMEOUT", {
            operation: "request.send",
            reason: "timeout",
            request: _request
        });
        if (delay > 0) await $2cb10defc4f72334$var$wait(delay);
        let req = this.clone();
        const scheme = (req.url.split(":")[0] || "").toLowerCase();
        // Process any Gateways
        if (scheme in $2cb10defc4f72334$var$Gateways) {
            const result = await $2cb10defc4f72334$var$Gateways[scheme](req.url, $2cb10defc4f72334$var$checkSignal(_request.#signal));
            if (result instanceof $2cb10defc4f72334$export$3ae09bba5b6b906e) {
                let response = result;
                if (this.processFunc) {
                    $2cb10defc4f72334$var$checkSignal(_request.#signal);
                    try {
                        response = await this.processFunc(req, response);
                    } catch (error) {
                        // Something went wrong during processing; throw a 5xx server error
                        if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                    // Ignore throttling
                    }
                }
                return response;
            }
            req = result;
        }
        // We have a preflight function; update the request
        if (this.preflightFunc) req = await this.preflightFunc(req);
        const resp = await $2cb10defc4f72334$var$getUrlFunc(req, $2cb10defc4f72334$var$checkSignal(_request.#signal));
        let response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(resp.statusCode, resp.statusMessage, resp.headers, resp.body, _request);
        if (response.statusCode === 301 || response.statusCode === 302) {
            // Redirect
            try {
                const location = response.headers.location || "";
                return req.redirect(location).#send(attempt + 1, expires, 0, _request, response);
            } catch (error) {}
            // Things won't get any better on another attempt; abort
            return response;
        } else if (response.statusCode === 429) // Throttle
        {
            if (this.retryFunc == null || await this.retryFunc(req, response, attempt)) {
                const retryAfter = response.headers["retry-after"];
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) delay = parseInt(retryAfter);
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        if (this.processFunc) {
            $2cb10defc4f72334$var$checkSignal(_request.#signal);
            try {
                response = await this.processFunc(req, response);
            } catch (error) {
                // Something went wrong during processing; throw a 5xx server error
                if (error.throttle == null || typeof error.stall !== "number") response.makeServerError("error in post-processing function", error).assertOk();
                // Throttle
                let delay = this.#throttle.slotInterval * Math.trunc(Math.random() * Math.pow(2, attempt));
                if (error.stall >= 0) delay = error.stall;
                return req.clone().#send(attempt + 1, expires, delay, _request, response);
            }
        }
        return response;
    }
    /**
     *  Resolves to the response by sending the request.
     */ send() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#signal == null, "request already sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.send"
        });
        this.#signal = new $2cb10defc4f72334$export$ef5e7a6febaa4c8b(this);
        return this.#send(0, $2cb10defc4f72334$var$getTime() + this.timeout, 0, this, new $2cb10defc4f72334$export$3ae09bba5b6b906e(0, "", {}, null, this));
    }
    /**
     *  Cancels the inflight response, causing a ``CANCELLED``
     *  error to be rejected from the [[send]].
     */ cancel() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#signal != null, "request has not been sent", "UNSUPPORTED_OPERATION", {
            operation: "fetchRequest.cancel"
        });
        const signal = $2cb10defc4f72334$var$fetchSignals.get(this);
        if (!signal) throw new Error("missing signal; should not happen");
        signal();
    }
    /**
     *  Returns a new [[FetchRequest]] that represents the redirection
     *  to %%location%%.
     */ redirect(location) {
        // Redirection; for now we only support absolute locataions
        const current = this.url.split(":")[0].toLowerCase();
        const target = location.split(":")[0].toLowerCase();
        // Don't allow redirecting:
        // - non-GET requests
        // - downgrading the security (e.g. https => http)
        // - to non-HTTP (or non-HTTPS) protocols [this could be relaxed?]
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.method === "GET" && (current !== "https" || target !== "http") && location.match(/^https?:/), `unsupported redirect`, "UNSUPPORTED_OPERATION", {
            operation: `redirect(${this.method} ${JSON.stringify(this.url)} => ${JSON.stringify(location)})`
        });
        // Create a copy of this request, with a new URL
        const req = new $2cb10defc4f72334$export$319b96fe59834522(location);
        req.method = "GET";
        req.allowGzip = this.allowGzip;
        req.timeout = this.timeout;
        req.#headers = Object.assign({}, this.#headers);
        if (this.#body) req.#body = new Uint8Array(this.#body);
        req.#bodyType = this.#bodyType;
        // Do not forward credentials unless on the same domain; only absolute
        //req.allowInsecure = false;
        // paths are currently supported; may want a way to specify to forward?
        //setStore(req.#props, "creds", getStore(this.#pros, "creds"));
        return req;
    }
    /**
     *  Create a new copy of this request.
     */ clone() {
        const clone = new $2cb10defc4f72334$export$319b96fe59834522(this.url);
        // Preserve "default method" (i.e. null)
        clone.#method = this.#method;
        // Preserve "default body" with type, copying the Uint8Array is present
        if (this.#body) clone.#body = this.#body;
        clone.#bodyType = this.#bodyType;
        // Preserve "default headers"
        clone.#headers = Object.assign({}, this.#headers);
        // Credentials is readonly, so we copy internally
        clone.#creds = this.#creds;
        if (this.allowGzip) clone.allowGzip = true;
        clone.timeout = this.timeout;
        if (this.allowInsecureAuthentication) clone.allowInsecureAuthentication = true;
        clone.#preflight = this.#preflight;
        clone.#process = this.#process;
        clone.#retry = this.#retry;
        return clone;
    }
    /**
     *  Locks all static configuration for gateways and FetchGetUrlFunc
     *  registration.
     */ static lockConfig() {
        $2cb10defc4f72334$var$locked = true;
    }
    /**
     *  Get the current Gateway function for %%scheme%%.
     */ static getGateway(scheme) {
        return $2cb10defc4f72334$var$Gateways[scheme.toLowerCase()] || null;
    }
    /**
     *  Use the %%func%% when fetching URIs using %%scheme%%.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGateway(scheme, func) {
        scheme = scheme.toLowerCase();
        if (scheme === "http" || scheme === "https") throw new Error(`cannot intercept ${scheme}; use registerGetUrl`);
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$Gateways[scheme] = func;
    }
    /**
     *  Use %%getUrl%% when fetching URIs over HTTP and HTTPS requests.
     *
     *  This method affects all requests globally.
     *
     *  If [[lockConfig]] has been called, no change is made and this
     *  throws.
     */ static registerGetUrl(getUrl) {
        if ($2cb10defc4f72334$var$locked) throw new Error("gateways locked");
        $2cb10defc4f72334$var$getUrlFunc = getUrl;
    }
    /**
     *  Creates a function that can "fetch" data URIs.
     *
     *  Note that this is automatically done internally to support
     *  data URIs, so it is not necessary to register it.
     *
     *  This is not generally something that is needed, but may
     *  be useful in a wrapper to perfom custom data URI functionality.
     */ static createDataGateway() {
        return $2cb10defc4f72334$var$dataGatewayFunc;
    }
    /**
     *  Creates a function that will fetch IPFS (unvalidated) from
     *  a custom gateway baseUrl.
     *
     *  The default IPFS gateway used internally is
     *  ``"https:/\/gateway.ipfs.io/ipfs/"``.
     */ static createIpfsGatewayFunc(baseUrl) {
        return $2cb10defc4f72334$var$getIpfsGatewayFunc(baseUrl);
    }
}
class $2cb10defc4f72334$export$3ae09bba5b6b906e {
    #statusCode;
    #statusMessage;
    #headers;
    #body;
    #request;
    #error;
    toString() {
        return `<FetchResponse status=${this.statusCode} body=${this.#body ? (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(this.#body) : "null"}>`;
    }
    /**
     *  The response status code.
     */ get statusCode() {
        return this.#statusCode;
    }
    /**
     *  The response status message.
     */ get statusMessage() {
        return this.#statusMessage;
    }
    /**
     *  The response headers. All keys are lower-case.
     */ get headers() {
        return Object.assign({}, this.#headers);
    }
    /**
     *  The response body, or ``null`` if there was no body.
     */ get body() {
        return this.#body == null ? null : new Uint8Array(this.#body);
    }
    /**
     *  The response body as a UTF-8 encoded string, or the empty
     *  string (i.e. ``""``) if there was no body.
     *
     *  An error is thrown if the body is invalid UTF-8 data.
     */ get bodyText() {
        try {
            return this.#body == null ? "" : (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(this.#body);
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "response body is not valid UTF-8 data", "UNSUPPORTED_OPERATION", {
                operation: "bodyText",
                info: {
                    response: this
                }
            });
        }
    }
    /**
     *  The response body, decoded as JSON.
     *
     *  An error is thrown if the body is invalid JSON-encoded data
     *  or if there was no body.
     */ get bodyJson() {
        try {
            return JSON.parse(this.bodyText);
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "response body is not valid JSON", "UNSUPPORTED_OPERATION", {
                operation: "bodyJson",
                info: {
                    response: this
                }
            });
        }
    }
    [Symbol.iterator]() {
        const headers = this.headers;
        const keys = Object.keys(headers);
        let index = 0;
        return {
            next: ()=>{
                if (index < keys.length) {
                    const key = keys[index++];
                    return {
                        value: [
                            key,
                            headers[key]
                        ],
                        done: false
                    };
                }
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    constructor(statusCode, statusMessage, headers, body, request){
        this.#statusCode = statusCode;
        this.#statusMessage = statusMessage;
        this.#headers = Object.keys(headers).reduce((accum, k)=>{
            accum[k.toLowerCase()] = String(headers[k]);
            return accum;
        }, {});
        this.#body = body == null ? null : new Uint8Array(body);
        this.#request = request || null;
        this.#error = {
            message: ""
        };
    }
    /**
     *  Return a Response with matching headers and body, but with
     *  an error status code (i.e. 599) and %%message%% with an
     *  optional %%error%%.
     */ makeServerError(message, error) {
        let statusMessage;
        if (!message) {
            message = `${this.statusCode} ${this.statusMessage}`;
            statusMessage = `CLIENT ESCALATED SERVER ERROR (${message})`;
        } else statusMessage = `CLIENT ESCALATED SERVER ERROR (${this.statusCode} ${this.statusMessage}; ${message})`;
        const response = new $2cb10defc4f72334$export$3ae09bba5b6b906e(599, statusMessage, this.headers, this.body, this.#request || undefined);
        response.#error = {
            message: message,
            error: error
        };
        return response;
    }
    /**
     *  If called within a [request.processFunc](FetchRequest-processFunc)
     *  call, causes the request to retry as if throttled for %%stall%%
     *  milliseconds.
     */ throwThrottleError(message, stall) {
        if (stall == null) stall = -1;
        else (0, $634aa51198273feb$export$c3d31707e5030f5e)(Number.isInteger(stall) && stall >= 0, "invalid stall timeout", "stall", stall);
        const error = new Error(message || "throttling requests");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(error, {
            stall: stall,
            throttle: true
        });
        throw error;
    }
    /**
     *  Get the header value for %%key%%, ignoring case.
     */ getHeader(key) {
        return this.headers[key.toLowerCase()];
    }
    /**
     *  Returns true of the response has a body.
     */ hasBody() {
        return this.#body != null;
    }
    /**
     *  The request made for this response.
     */ get request() {
        return this.#request;
    }
    /**
     *  Returns true if this response was a success statusCode.
     */ ok() {
        return this.#error.message === "" && this.statusCode >= 200 && this.statusCode < 300;
    }
    /**
     *  Throws a ``SERVER_ERROR`` if this response is not ok.
     */ assertOk() {
        if (this.ok()) return;
        let { message: message, error: error } = this.#error;
        if (message === "") message = `server response ${this.statusCode} ${this.statusMessage}`;
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, message, "SERVER_ERROR", {
            request: this.request || "unknown request",
            response: this,
            error: error
        });
    }
}
function $2cb10defc4f72334$var$getTime() {
    return new Date().getTime();
}
function $2cb10defc4f72334$var$unpercent(value) {
    return (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $2cb10defc4f72334$var$wait(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}


/**
 *  The available providers should suffice for most developers purposes,
 *  but the [[AbstractProvider]] class has many features which enable
 *  sub-classing it for specific purposes.
 *
 *  @_section: api/providers/abstract-provider: Subclassing Provider  [abstract-provider]
 */ // @TODO
// Event coalescence
//   When we register an event with an async value (e.g. address is a Signer
//   or ENS name), we need to add it immeidately for the Event API, but also
//   need time to resolve the address. Upon resolving the address, we need to
//   migrate the listener to the static event. We also need to maintain a map
//   of Signer/ENS name to address so we can sync respond to listenerCount.

/**
 *  A constant for the zero address.
 *
 *  (**i.e.** ``"0x0000000000000000000000000000000000000000"``)
 */ const $5b8e64dd3cc782dc$export$b7cbe423ba83da17 = "0x0000000000000000000000000000000000000000";





function $e006ee16d99d0706$var$decode_arithmetic(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = 2 ** N;
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function $e006ee16d99d0706$var$read_payload(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $e006ee16d99d0706$var$read_compressed_payload(s) {
    return $e006ee16d99d0706$var$read_payload($e006ee16d99d0706$var$decode_arithmetic($e006ee16d99d0706$var$unsafe_atob(s)));
}
// unsafe in the sense:
// expected well-formed Base64 w/o padding 
function $e006ee16d99d0706$var$unsafe_atob(s) {
    let lookup = [];
    [
        ..."ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ].forEach((c, i)=>lookup[c.charCodeAt(0)] = i);
    let n = s.length;
    let ret = new Uint8Array(6 * n >> 3);
    for(let i = 0, pos = 0, width = 0, carry = 0; i < n; i++){
        carry = carry << 6 | lookup[s.charCodeAt(i)];
        width += 6;
        if (width >= 8) ret[pos++] = carry >> (width -= 8);
    }
    return ret;
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function $e006ee16d99d0706$var$signed(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $e006ee16d99d0706$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $e006ee16d99d0706$var$signed(next());
    return v;
}
// [123][5] => [0 3] [1 1] [0 0]
function $e006ee16d99d0706$var$read_sorted(next, prev = 0) {
    let ret = [];
    while(true){
        let x = next();
        let n = next();
        if (!n) break;
        prev += x;
        for(let i = 0; i < n; i++)ret.push(prev + i);
        prev += n + 1;
    }
    return ret;
}
function $e006ee16d99d0706$var$read_sorted_arrays(next) {
    return $e006ee16d99d0706$var$read_array_while(()=>{
        let v = $e006ee16d99d0706$var$read_sorted(next);
        if (v.length) return v;
    });
}
// returns map of x => ys
function $e006ee16d99d0706$var$read_mapped(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($e006ee16d99d0706$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($e006ee16d99d0706$var$read_replacement_table(w, next));
    }
    return ret.flat();
}
// read until next is falsy
// return array of read values
function $e006ee16d99d0706$var$read_array_while(next) {
    let v = [];
    while(true){
        let x = next(v.length);
        if (!x) break;
        v.push(x);
    }
    return v;
}
// read w columns of length n
// return as n rows of length w
function $e006ee16d99d0706$var$read_transposed(n, w, next) {
    let m = Array(n).fill().map(()=>[]);
    for(let i = 0; i < w; i++)$e006ee16d99d0706$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
// returns [[x, ys], [x+dx, ys+dy], [x+2*dx, ys+2*dy], ...]
// where dx/dy = steps, n = run size, w = length of y
function $e006ee16d99d0706$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $e006ee16d99d0706$var$read_array_while(next);
    let m = $e006ee16d99d0706$var$read_transposed(vN.length, 1 + w, next);
    return m.flatMap((v, i)=>{
        let [x, ...ys] = v;
        return Array(vN[i]).fill().map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    });
}
// return [[x, ys...], ...]
// where w = length of y
function $e006ee16d99d0706$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $e006ee16d99d0706$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
// created 2023-02-21T09:18:13.549Z
var $e006ee16d99d0706$var$r$1 = $e006ee16d99d0706$var$read_compressed_payload("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");
const $e006ee16d99d0706$var$FENCED = new Map([
    [
        8217,
        "apostrophe"
    ],
    [
        8260,
        "fraction slash"
    ],
    [
        12539,
        "middle dot"
    ]
]);
const $e006ee16d99d0706$var$NSM_MAX = 4;
function $e006ee16d99d0706$var$hex_cp(cp) {
    return cp.toString(16).toUpperCase().padStart(2, "0");
}
function $e006ee16d99d0706$var$quote_cp(cp) {
    return `{${$e006ee16d99d0706$var$hex_cp(cp)}}`; // raffy convention: like "\u{X}" w/o the "\u"
}
/*
export function explode_cp(s) {
	return [...s].map(c => c.codePointAt(0));
}
*/ function $e006ee16d99d0706$var$explode_cp(s) {
    let cps = [];
    for(let pos = 0, len = s.length; pos < len;){
        let cp = s.codePointAt(pos);
        pos += cp < 0x10000 ? 1 : 2;
        cps.push(cp);
    }
    return cps;
}
function $e006ee16d99d0706$var$str_from_cps(cps) {
    const chunk = 4096;
    let len = cps.length;
    if (len < chunk) return String.fromCodePoint(...cps);
    let buf = [];
    for(let i = 0; i < len;)buf.push(String.fromCodePoint(...cps.slice(i, i += chunk)));
    return buf.join("");
}
function $e006ee16d99d0706$var$compare_arrays(a, b) {
    let n = a.length;
    let c = n - b.length;
    for(let i = 0; c == 0 && i < n; i++)c = a[i] - b[i];
    return c;
}
// created 2023-02-21T09:18:13.549Z
var $e006ee16d99d0706$var$r = $e006ee16d99d0706$var$read_compressed_payload("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");
// https://unicode.org/reports/tr15/
function $e006ee16d99d0706$var$unpack_cc(packed) {
    return packed >> 24 & 0xFF;
}
function $e006ee16d99d0706$var$unpack_cp(packed) {
    return packed & 0xFFFFFF;
}
const $e006ee16d99d0706$var$SHIFTED_RANK = new Map($e006ee16d99d0706$var$read_sorted_arrays($e006ee16d99d0706$var$r).flatMap((v, i)=>v.map((x)=>[
            x,
            i + 1 << 24
        ]))); // pre-shifted
const $e006ee16d99d0706$var$EXCLUSIONS = new Set($e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r));
const $e006ee16d99d0706$var$DECOMP = new Map();
const $e006ee16d99d0706$var$RECOMP = new Map();
for (let [cp, cps] of $e006ee16d99d0706$var$read_mapped($e006ee16d99d0706$var$r)){
    if (!$e006ee16d99d0706$var$EXCLUSIONS.has(cp) && cps.length == 2) {
        let [a, b] = cps;
        let bucket = $e006ee16d99d0706$var$RECOMP.get(a);
        if (!bucket) {
            bucket = new Map();
            $e006ee16d99d0706$var$RECOMP.set(a, bucket);
        }
        bucket.set(b, cp);
    }
    $e006ee16d99d0706$var$DECOMP.set(cp, cps.reverse()); // stored reversed
}
// algorithmic hangul
// https://www.unicode.org/versions/Unicode15.0.0/ch03.pdf (page 144)
const $e006ee16d99d0706$var$S0 = 0xAC00;
const $e006ee16d99d0706$var$L0 = 0x1100;
const $e006ee16d99d0706$var$V0 = 0x1161;
const $e006ee16d99d0706$var$T0 = 0x11A7;
const $e006ee16d99d0706$var$L_COUNT = 19;
const $e006ee16d99d0706$var$V_COUNT = 21;
const $e006ee16d99d0706$var$T_COUNT = 28;
const $e006ee16d99d0706$var$N_COUNT = $e006ee16d99d0706$var$V_COUNT * $e006ee16d99d0706$var$T_COUNT;
const $e006ee16d99d0706$var$S_COUNT = $e006ee16d99d0706$var$L_COUNT * $e006ee16d99d0706$var$N_COUNT;
const $e006ee16d99d0706$var$S1 = $e006ee16d99d0706$var$S0 + $e006ee16d99d0706$var$S_COUNT;
const $e006ee16d99d0706$var$L1 = $e006ee16d99d0706$var$L0 + $e006ee16d99d0706$var$L_COUNT;
const $e006ee16d99d0706$var$V1 = $e006ee16d99d0706$var$V0 + $e006ee16d99d0706$var$V_COUNT;
const $e006ee16d99d0706$var$T1 = $e006ee16d99d0706$var$T0 + $e006ee16d99d0706$var$T_COUNT;
function $e006ee16d99d0706$var$is_hangul(cp) {
    return cp >= $e006ee16d99d0706$var$S0 && cp < $e006ee16d99d0706$var$S1;
}
function $e006ee16d99d0706$var$compose_pair(a, b) {
    if (a >= $e006ee16d99d0706$var$L0 && a < $e006ee16d99d0706$var$L1 && b >= $e006ee16d99d0706$var$V0 && b < $e006ee16d99d0706$var$V1) return $e006ee16d99d0706$var$S0 + (a - $e006ee16d99d0706$var$L0) * $e006ee16d99d0706$var$N_COUNT + (b - $e006ee16d99d0706$var$V0) * $e006ee16d99d0706$var$T_COUNT;
    else if ($e006ee16d99d0706$var$is_hangul(a) && b > $e006ee16d99d0706$var$T0 && b < $e006ee16d99d0706$var$T1 && (a - $e006ee16d99d0706$var$S0) % $e006ee16d99d0706$var$T_COUNT == 0) return a + (b - $e006ee16d99d0706$var$T0);
    else {
        let recomp = $e006ee16d99d0706$var$RECOMP.get(a);
        if (recomp) {
            recomp = recomp.get(b);
            if (recomp) return recomp;
        }
        return -1;
    }
}
function $e006ee16d99d0706$var$decomposed(cps) {
    let ret = [];
    let buf = [];
    let check_order = false;
    function add(cp) {
        let cc = $e006ee16d99d0706$var$SHIFTED_RANK.get(cp);
        if (cc) {
            check_order = true;
            cp |= cc;
        }
        ret.push(cp);
    }
    for (let cp of cps)while(true){
        if (cp < 0x80) ret.push(cp);
        else if ($e006ee16d99d0706$var$is_hangul(cp)) {
            let s_index = cp - $e006ee16d99d0706$var$S0;
            let l_index = s_index / $e006ee16d99d0706$var$N_COUNT | 0;
            let v_index = s_index % $e006ee16d99d0706$var$N_COUNT / $e006ee16d99d0706$var$T_COUNT | 0;
            let t_index = s_index % $e006ee16d99d0706$var$T_COUNT;
            add($e006ee16d99d0706$var$L0 + l_index);
            add($e006ee16d99d0706$var$V0 + v_index);
            if (t_index > 0) add($e006ee16d99d0706$var$T0 + t_index);
        } else {
            let mapped = $e006ee16d99d0706$var$DECOMP.get(cp);
            if (mapped) buf.push(...mapped);
            else add(cp);
        }
        if (!buf.length) break;
        cp = buf.pop();
    }
    if (check_order && ret.length > 1) {
        let prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[0]);
        for(let i = 1; i < ret.length; i++){
            let cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
            if (cc == 0 || prev_cc <= cc) {
                prev_cc = cc;
                continue;
            }
            let j = i - 1;
            while(true){
                let tmp = ret[j + 1];
                ret[j + 1] = ret[j];
                ret[j] = tmp;
                if (!j) break;
                prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[--j]);
                if (prev_cc <= cc) break;
            }
            prev_cc = $e006ee16d99d0706$var$unpack_cc(ret[i]);
        }
    }
    return ret;
}
function $e006ee16d99d0706$var$composed_from_decomposed(v) {
    let ret = [];
    let stack = [];
    let prev_cp = -1;
    let prev_cc = 0;
    for (let packed of v){
        let cc = $e006ee16d99d0706$var$unpack_cc(packed);
        let cp = $e006ee16d99d0706$var$unpack_cp(packed);
        if (prev_cp == -1) {
            if (cc == 0) prev_cp = cp;
            else ret.push(cp);
        } else if (prev_cc > 0 && prev_cc >= cc) {
            if (cc == 0) {
                ret.push(prev_cp, ...stack);
                stack.length = 0;
                prev_cp = cp;
            } else stack.push(cp);
            prev_cc = cc;
        } else {
            let composed = $e006ee16d99d0706$var$compose_pair(prev_cp, cp);
            if (composed >= 0) prev_cp = composed;
            else if (prev_cc == 0 && cc == 0) {
                ret.push(prev_cp);
                prev_cp = cp;
            } else {
                stack.push(cp);
                prev_cc = cc;
            }
        }
    }
    if (prev_cp >= 0) ret.push(prev_cp, ...stack);
    return ret;
}
// note: cps can be iterable
function $e006ee16d99d0706$export$9d0d896b286a3dba(cps) {
    return $e006ee16d99d0706$var$decomposed(cps).map($e006ee16d99d0706$var$unpack_cp);
}
function $e006ee16d99d0706$export$f42252642e08449(cps) {
    return $e006ee16d99d0706$var$composed_from_decomposed($e006ee16d99d0706$var$decomposed(cps));
}
//const t0 = performance.now();
const $e006ee16d99d0706$var$STOP = 0x2E;
const $e006ee16d99d0706$var$FE0F = 0xFE0F;
const $e006ee16d99d0706$var$STOP_CH = ".";
const $e006ee16d99d0706$var$UNIQUE_PH = 1;
const $e006ee16d99d0706$var$HYPHEN = 0x2D;
function $e006ee16d99d0706$var$read_set() {
    return new Set($e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1));
}
const $e006ee16d99d0706$var$MAPPED = new Map($e006ee16d99d0706$var$read_mapped($e006ee16d99d0706$var$r$1));
const $e006ee16d99d0706$var$IGNORED = $e006ee16d99d0706$var$read_set(); // ignored characters are not valid, so just read raw codepoints
/*
// direct include from payload is smaller that the decompression code
const FENCED = new Map(read_array_while(() => {
	let cp = r();
	if (cp) return [cp, read_str(r())];
}));
*/ // 20230217: we still need all CM for proper error formatting
// but norm only needs NSM subset that are potentially-valid
const $e006ee16d99d0706$var$CM = $e006ee16d99d0706$var$read_set();
const $e006ee16d99d0706$var$NSM = new Set($e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1).map(function(i) {
    return this[i];
}, [
    ...$e006ee16d99d0706$var$CM
]));
/*
const CM_SORTED = read_sorted(r);
const NSM = new Set(read_sorted(r).map(i => CM_SORTED[i]));
const CM = new Set(CM_SORTED);
*/ const $e006ee16d99d0706$var$ESCAPE = $e006ee16d99d0706$var$read_set(); // characters that should not be printed
const $e006ee16d99d0706$var$NFC_CHECK = $e006ee16d99d0706$var$read_set();
const $e006ee16d99d0706$var$CHUNKS = $e006ee16d99d0706$var$read_sorted_arrays($e006ee16d99d0706$var$r$1);
function $e006ee16d99d0706$var$read_chunked() {
    // deduplicated sets + uniques
    return new Set([
        $e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1).map((i)=>$e006ee16d99d0706$var$CHUNKS[i]),
        $e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1)
    ].flat(2));
}
const $e006ee16d99d0706$var$UNRESTRICTED = $e006ee16d99d0706$var$r$1();
const $e006ee16d99d0706$var$GROUPS = $e006ee16d99d0706$var$read_array_while((i)=>{
    // minifier property mangling seems unsafe
    // so these are manually renamed to single chars
    let N = $e006ee16d99d0706$var$read_array_while($e006ee16d99d0706$var$r$1).map((x)=>x + 0x60);
    if (N.length) {
        let R = i >= $e006ee16d99d0706$var$UNRESTRICTED; // first arent restricted
        N[0] -= 32; // capitalize
        N = $e006ee16d99d0706$var$str_from_cps(N);
        if (R) N = `Restricted[${N}]`;
        let P = $e006ee16d99d0706$var$read_chunked(); // primary
        let Q = $e006ee16d99d0706$var$read_chunked(); // secondary
        let V = [
            ...P,
            ...Q
        ].sort((a, b)=>a - b); // derive: sorted valid
        //let M = r()-1; // combining mark
        let M = !$e006ee16d99d0706$var$r$1(); // not-whitelisted, check for NSM
        // code currently isn't needed
        /*if (M < 0) { // whitelisted
			M = new Map(read_array_while(() => {
				let i = r();
				if (i) return [V[i-1], read_array_while(() => {
					let v = read_array_while(r);
					if (v.length) return v.map(x => x-1);
				})];
			}));
		}*/ return {
            N: N,
            P: P,
            M: M,
            R: R,
            V: new Set(V)
        };
    }
});
const $e006ee16d99d0706$var$WHOLE_VALID = $e006ee16d99d0706$var$read_set();
const $e006ee16d99d0706$var$WHOLE_MAP = new Map();
// decode compressed wholes
[
    ...$e006ee16d99d0706$var$WHOLE_VALID,
    ...$e006ee16d99d0706$var$read_set()
].sort((a, b)=>a - b).map((cp, i, v)=>{
    let d = $e006ee16d99d0706$var$r$1();
    let w = v[i] = d ? v[i - d] : {
        V: [],
        M: new Map()
    };
    w.V.push(cp); // add to member set
    if (!$e006ee16d99d0706$var$WHOLE_VALID.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, w); // register with whole map
});
// compute confusable-extent complements
for (let { V: V, M: M } of new Set($e006ee16d99d0706$var$WHOLE_MAP.values())){
    // connect all groups that have each whole character
    let recs = [];
    for (let cp of V){
        let gs = $e006ee16d99d0706$var$GROUPS.filter((g)=>g.V.has(cp));
        let rec = recs.find(({ G: G })=>gs.some((g)=>G.has(g)));
        if (!rec) {
            rec = {
                G: new Set(),
                V: []
            };
            recs.push(rec);
        }
        rec.V.push(cp);
        gs.forEach((g)=>rec.G.add(g));
    }
    // per character cache groups which are not a member of the extent
    let union = recs.flatMap(({ G: G })=>[
            ...G
        ]);
    for (let { G: G, V: V } of recs){
        let complement = new Set(union.filter((g)=>!G.has(g)));
        for (let cp of V)M.set(cp, complement);
    }
}
let $e006ee16d99d0706$var$union = new Set(); // exists in 1+ groups
let $e006ee16d99d0706$var$multi = new Set(); // exists in 2+ groups
for (let g of $e006ee16d99d0706$var$GROUPS)for (let cp of g.V)($e006ee16d99d0706$var$union.has(cp) ? $e006ee16d99d0706$var$multi : $e006ee16d99d0706$var$union).add(cp);
// dual purpose WHOLE_MAP: return placeholder if unique non-confusable
for (let cp of $e006ee16d99d0706$var$union)if (!$e006ee16d99d0706$var$WHOLE_MAP.has(cp) && !$e006ee16d99d0706$var$multi.has(cp)) $e006ee16d99d0706$var$WHOLE_MAP.set(cp, $e006ee16d99d0706$var$UNIQUE_PH);
const $e006ee16d99d0706$var$VALID = new Set([
    ...$e006ee16d99d0706$var$union,
    ...$e006ee16d99d0706$export$9d0d896b286a3dba($e006ee16d99d0706$var$union)
]); // possibly valid
// decode emoji
const $e006ee16d99d0706$var$EMOJI_SORTED = $e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1); // temporary
//const EMOJI_SOLO = new Set(read_sorted(r).map(i => EMOJI_SORTED[i])); // not needed
const $e006ee16d99d0706$var$EMOJI_ROOT = $e006ee16d99d0706$var$read_emoji_trie([]);
function $e006ee16d99d0706$var$read_emoji_trie(cps) {
    let B = $e006ee16d99d0706$var$read_array_while(()=>{
        let keys = $e006ee16d99d0706$var$read_sorted($e006ee16d99d0706$var$r$1).map((i)=>$e006ee16d99d0706$var$EMOJI_SORTED[i]);
        if (keys.length) return $e006ee16d99d0706$var$read_emoji_trie(keys);
    }).sort((a, b)=>b.Q.size - a.Q.size); // sort by likelihood
    let temp = $e006ee16d99d0706$var$r$1();
    let V = temp % 3; // valid (0 = false, 1 = true, 2 = weird)
    temp = temp / 3 | 0;
    let F = temp & 1; // allow FE0F
    temp >>= 1;
    let S = temp & 1; // save
    let C = temp & 2; // check
    return {
        B: B,
        V: V,
        F: F,
        S: S,
        C: C,
        Q: new Set(cps)
    };
}
//console.log(performance.now() - t0);
// free tagging system
class $e006ee16d99d0706$var$Emoji extends Array {
    get is_emoji() {
        return true;
    }
}
// create a safe to print string 
// invisibles are escaped
// leading cm uses placeholder
// quoter(cp) => string, eg. 3000 => "{3000}"
// note: in html, you'd call this function then replace [<>&] with entities
function $e006ee16d99d0706$export$6ec6f9a7f89f00db(cps, quoter = $e006ee16d99d0706$var$quote_cp) {
    //if (Number.isInteger(cps)) cps = [cps];
    //if (!Array.isArray(cps)) throw new TypeError(`expected codepoints`);
    let buf = [];
    if ($e006ee16d99d0706$export$e29a9e4d2573411c(cps[0])) buf.push("◌");
    let prev = 0;
    let n = cps.length;
    for(let i = 0; i < n; i++){
        let cp = cps[i];
        if ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp)) {
            buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, i)));
            buf.push(quoter(cp));
            prev = i + 1;
        }
    }
    buf.push($e006ee16d99d0706$var$str_from_cps(cps.slice(prev, n)));
    return buf.join("");
}
// if escaped: {HEX}
//       else: "x" {HEX}
function $e006ee16d99d0706$var$quoted_cp(cp) {
    return ($e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) ? "" : `${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db([
        cp
    ]))} `) + $e006ee16d99d0706$var$quote_cp(cp);
}
// 20230211: some messages can be mixed-directional and result in spillover
// use 200E after a quoted string to force the remainder of a string from 
// acquring the direction of the quote
// https://www.w3.org/International/questions/qa-bidi-unicode-controls#exceptions
function $e006ee16d99d0706$var$bidi_qq(s) {
    return `"${s}"\u200E`; // strong LTR
}
function $e006ee16d99d0706$var$check_label_extension(cps) {
    if (cps.length >= 4 && cps[2] == $e006ee16d99d0706$var$HYPHEN && cps[3] == $e006ee16d99d0706$var$HYPHEN) throw new Error("invalid label extension");
}
function $e006ee16d99d0706$var$check_leading_underscore(cps) {
    const UNDERSCORE = 0x5F;
    for(let i = cps.lastIndexOf(UNDERSCORE); i > 0;){
        if (cps[--i] !== UNDERSCORE) throw new Error("underscore allowed only at start");
    }
}
// check that a fenced cp is not leading, trailing, or touching another fenced cp
function $e006ee16d99d0706$var$check_fenced(cps) {
    let cp = cps[0];
    let prev = $e006ee16d99d0706$var$FENCED.get(cp);
    if (prev) throw $e006ee16d99d0706$var$error_placement(`leading ${prev}`);
    let n = cps.length;
    let last = -1; // prevents trailing from throwing
    for(let i = 1; i < n; i++){
        cp = cps[i];
        let match = $e006ee16d99d0706$var$FENCED.get(cp);
        if (match) {
            // since cps[0] isn't fenced, cps[1] cannot throw
            if (last == i) throw $e006ee16d99d0706$var$error_placement(`${prev} + ${match}`);
            last = i + 1;
            prev = match;
        }
    }
    if (last == n) throw $e006ee16d99d0706$var$error_placement(`trailing ${prev}`);
}
// note: set(s) cannot be exposed because they can be modified
function $e006ee16d99d0706$export$e29a9e4d2573411c(cp) {
    return $e006ee16d99d0706$var$CM.has(cp);
}
function $e006ee16d99d0706$export$4b1c9c18c687e5e9(cp) {
    return $e006ee16d99d0706$var$ESCAPE.has(cp);
}
function $e006ee16d99d0706$export$f4e6b2721065fb3d(frag, decompose) {
    let nf = decompose ? $e006ee16d99d0706$export$9d0d896b286a3dba : $e006ee16d99d0706$export$f42252642e08449;
    return frag.split($e006ee16d99d0706$var$STOP_CH).map((label)=>$e006ee16d99d0706$var$str_from_cps($e006ee16d99d0706$var$process($e006ee16d99d0706$var$explode_cp(label), nf).flatMap((x)=>x.is_emoji ? $e006ee16d99d0706$var$filter_fe0f(x) : x))).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$export$499f715881831a51(name) {
    return $e006ee16d99d0706$var$flatten($e006ee16d99d0706$export$d2ba335951b08421(name));
}
function $e006ee16d99d0706$export$d2ee080f6ab2341d(name) {
    let split = $e006ee16d99d0706$export$d2ba335951b08421(name, true);
    // this is experimental
    for (let { type: type, output: output, error: error } of split){
        if (error) continue;
        // replace leading/trailing hyphen
        // 20230121: consider beautifing all or leading/trailing hyphen to unicode variant
        // not exactly the same in every font, but very similar: "-" vs "‐"
        /*
		const UNICODE_HYPHEN = 0x2010;
		// maybe this should replace all for visual consistancy?
		// `node tools/reg-count.js regex ^-\{2,\}` => 592
		//for (let i = 0; i < output.length; i++) if (output[i] == 0x2D) output[i] = 0x2010;
		if (output[0] == HYPHEN) output[0] = UNICODE_HYPHEN;
		let end = output.length-1;
		if (output[end] == HYPHEN) output[end] = UNICODE_HYPHEN;
		*/ // 20230123: WHATWG URL uses "CheckHyphens" false
        // https://url.spec.whatwg.org/#idna
        // update ethereum symbol
        // ξ => Ξ if not greek
        if (type !== "Greek") {
            let prev = 0;
            while(true){
                let next = output.indexOf(0x3BE, prev);
                if (next < 0) break;
                output[next] = 0x39E;
                prev = next + 1;
            }
        }
    // 20221213: fixes bidi subdomain issue, but breaks invariant (200E is disallowed)
    // could be fixed with special case for: 2D (.) + 200E (LTR)
    //output.splice(0, 0, 0x200E);
    }
    return $e006ee16d99d0706$var$flatten(split);
}
function $e006ee16d99d0706$export$d2ba335951b08421(name, preserve_emoji) {
    let offset = 0;
    // https://unicode.org/reports/tr46/#Validity_Criteria
    // 4.) "The label must not contain a U+002E ( . ) FULL STOP."
    return name.split($e006ee16d99d0706$var$STOP_CH).map((label)=>{
        let input = $e006ee16d99d0706$var$explode_cp(label);
        let info = {
            input: input,
            offset: offset
        };
        offset += input.length + 1; // + stop
        let norm;
        try {
            // 1.) "The label must be in Unicode Normalization Form NFC"
            let tokens = info.tokens = $e006ee16d99d0706$var$process(input, $e006ee16d99d0706$export$f42252642e08449); // if we parse, we get [norm and mapped]
            let token_count = tokens.length;
            let type;
            if (!token_count) // 20230120: change to strict
            // https://discuss.ens.domains/t/ens-name-normalization-2nd/14564/59
            //norm = [];
            //type = 'None'; // use this instead of next match, "ASCII"
            throw new Error(`empty label`);
            else {
                let chars = tokens[0];
                let emoji = token_count > 1 || chars.is_emoji;
                if (!emoji && chars.every((cp)=>cp < 0x80)) {
                    norm = chars;
                    $e006ee16d99d0706$var$check_leading_underscore(norm);
                    // only needed for ascii
                    // 20230123: matches matches WHATWG, see note 3.3
                    $e006ee16d99d0706$var$check_label_extension(norm);
                    // cant have fenced
                    // cant have cm
                    // cant have wholes
                    // see derive: "Fastpath ASCII"
                    type = "ASCII";
                } else {
                    if (emoji) {
                        info.emoji = true;
                        chars = tokens.flatMap((x)=>x.is_emoji ? [] : x); // all of the nfc tokens concat together
                    }
                    norm = tokens.flatMap((x)=>!preserve_emoji && x.is_emoji ? $e006ee16d99d0706$var$filter_fe0f(x) : x);
                    $e006ee16d99d0706$var$check_leading_underscore(norm);
                    if (!chars.length) type = "Emoji";
                    else {
                        // 5. "The label must not begin with a combining mark, that is: General_Category=Mark."
                        if ($e006ee16d99d0706$var$CM.has(norm[0])) throw $e006ee16d99d0706$var$error_placement("leading combining mark");
                        for(let i = 1; i < token_count; i++){
                            let cps = tokens[i];
                            if (!cps.is_emoji && $e006ee16d99d0706$var$CM.has(cps[0])) // bidi_qq() not needed since emoji is LTR and cps is a CM
                            throw $e006ee16d99d0706$var$error_placement(`emoji + combining mark: "${$e006ee16d99d0706$var$str_from_cps(tokens[i - 1])} + ${$e006ee16d99d0706$export$6ec6f9a7f89f00db([
                                cps[0]
                            ])}"`);
                        }
                        $e006ee16d99d0706$var$check_fenced(norm);
                        let unique = [
                            ...new Set(chars)
                        ];
                        let [g] = $e006ee16d99d0706$var$determine_group(unique); // take the first match
                        // see derive: "Matching Groups have Same CM Style"
                        // alternative: could form a hybrid type: Latin/Japanese/...	
                        $e006ee16d99d0706$var$check_group(g, chars); // need text in order
                        $e006ee16d99d0706$var$check_whole(g, unique); // only need unique text (order would be required for multiple-char confusables)
                        type = g.N;
                    // 20230121: consider exposing restricted flag
                    // it's simpler to just check for 'Restricted'
                    // or even better: type.endsWith(']')
                    //if (g.R) info.restricted = true;
                    }
                }
            }
            info.type = type;
        } catch (err) {
            info.error = err; // use full error object
        }
        info.output = norm;
        return info;
    });
}
function $e006ee16d99d0706$var$check_whole(group, unique) {
    let maker;
    let shared = []; // TODO: can this be avoided?
    for (let cp of unique){
        let whole = $e006ee16d99d0706$var$WHOLE_MAP.get(cp);
        if (whole === $e006ee16d99d0706$var$UNIQUE_PH) return; // unique, non-confusable
        if (whole) {
            let set = whole.M.get(cp); // groups which have a character that look-like this character
            maker = maker ? maker.filter((g)=>set.has(g)) : [
                ...set
            ];
            if (!maker.length) return; // confusable intersection is empty
        } else shared.push(cp);
    }
    if (maker) // we have 1+ confusable
    // check if any of the remaning groups
    // contain the shared characters too
    for (let g of maker){
        if (shared.every((cp)=>g.V.has(cp))) throw new Error(`whole-script confusable: ${group.N}/${g.N}`);
    }
}
// assumption: unique.size > 0
// returns list of matching groups
function $e006ee16d99d0706$var$determine_group(unique) {
    let groups = $e006ee16d99d0706$var$GROUPS;
    for (let cp of unique){
        // note: we need to dodge CM that are whitelisted
        // but that code isn't currently necessary
        let gs = groups.filter((g)=>g.V.has(cp));
        if (!gs.length) {
            if (groups === $e006ee16d99d0706$var$GROUPS) // the character was composed of valid parts
            // but it's NFC form is invalid
            throw $e006ee16d99d0706$var$error_disallowed(cp); // this should be rare
            else // there is no group that contains all these characters
            // throw using the highest priority group that matched
            // https://www.unicode.org/reports/tr39/#mixed_script_confusables
            throw $e006ee16d99d0706$var$error_group_member(groups[0], cp);
        }
        groups = gs;
        if (gs.length == 1) break; // there is only one group left
    }
    // there are at least 1 group(s) with all of these characters
    return groups;
}
// throw on first error
function $e006ee16d99d0706$var$flatten(split) {
    return split.map(({ input: input, error: error, output: output })=>{
        if (error) {
            // don't print label again if just a single label
            let msg = error.message;
            // bidi_qq() only necessary if msg is digits
            throw new Error(split.length == 1 ? msg : `Invalid label ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(input))}: ${msg}`);
        }
        return $e006ee16d99d0706$var$str_from_cps(output);
    }).join($e006ee16d99d0706$var$STOP_CH);
}
function $e006ee16d99d0706$var$error_disallowed(cp) {
    // TODO: add cp to error?
    return new Error(`disallowed character: ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
}
function $e006ee16d99d0706$var$error_group_member(g, cp) {
    let quoted = $e006ee16d99d0706$var$quoted_cp(cp);
    let gg = $e006ee16d99d0706$var$GROUPS.find((g)=>g.P.has(cp));
    if (gg) quoted = `${gg.N} ${quoted}`;
    return new Error(`illegal mixture: ${g.N} + ${quoted}`);
}
function $e006ee16d99d0706$var$error_placement(where) {
    return new Error(`illegal placement: ${where}`);
}
// assumption: cps.length > 0
// assumption: cps[0] isn't a CM
// assumption: the previous character isn't an emoji
function $e006ee16d99d0706$var$check_group(g, cps) {
    let { V: V, M: M } = g;
    for (let cp of cps){
        if (!V.has(cp)) // for whitelisted scripts, this will throw illegal mixture on invalid cm, eg. "e{300}{300}"
        // at the moment, it's unnecessary to introduce an extra error type
        // until there exists a whitelisted multi-character
        //   eg. if (M < 0 && is_combining_mark(cp)) { ... }
        // there are 3 cases:
        //   1. illegal cm for wrong group => mixture error
        //   2. illegal cm for same group => cm error
        //       requires set of whitelist cm per group: 
        //        eg. new Set([...g.V].flatMap(nfc).filter(cp => CM.has(cp)))
        //   3. wrong group => mixture error
        throw $e006ee16d99d0706$var$error_group_member(g, cp);
    }
    //if (M >= 0) { // we have a known fixed cm count
    if (M) {
        let decomposed = $e006ee16d99d0706$export$9d0d896b286a3dba(cps);
        for(let i = 1, e = decomposed.length; i < e; i++)// 20230210: bugfix: using cps instead of decomposed h/t Carbon225
        /*
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: ${g.N} ${bidi_qq(str_from_cps(decomposed.slice(i-1, j)))} (${j-i}/${M})`);
				}
				i = j;
			}
			*/ // 20230217: switch to NSM counting
        // https://www.unicode.org/reports/tr39/#Optional_Detection
        if ($e006ee16d99d0706$var$NSM.has(decomposed[i])) {
            let j = i + 1;
            for(let cp; j < e && $e006ee16d99d0706$var$NSM.has(cp = decomposed[j]); j++)// a. Forbid sequences of the same nonspacing mark.
            for(let k = i; k < j; k++){
                if (decomposed[k] == cp) throw new Error(`non-spacing marks: repeated ${$e006ee16d99d0706$var$quoted_cp(cp)}`);
            }
            // parse to end so we have full nsm count
            // b. Forbid sequences of more than 4 nonspacing marks (gc=Mn or gc=Me).
            if (j - i > $e006ee16d99d0706$var$NSM_MAX) // note: this slice starts with a base char or spacing-mark cm
            throw new Error(`non-spacing marks: too many ${$e006ee16d99d0706$var$bidi_qq($e006ee16d99d0706$export$6ec6f9a7f89f00db(decomposed.slice(i - 1, j)))} (${j - i}/${$e006ee16d99d0706$var$NSM_MAX})`);
            i = j;
        }
    }
// *** this code currently isn't needed ***
/*
	let cm_whitelist = M instanceof Map;
	for (let i = 0, e = cps.length; i < e; ) {
		let cp = cps[i++];
		let seqs = cm_whitelist && M.get(cp);
		if (seqs) { 
			// list of codepoints that can follow
			// if this exists, this will always be 1+
			let j = i;
			while (j < e && CM.has(cps[j])) j++;
			let cms = cps.slice(i, j);
			let match = seqs.find(seq => !compare_arrays(seq, cms));
			if (!match) throw new Error(`disallowed combining mark sequence: "${safe_str_from_cps([cp, ...cms])}"`);
			i = j;
		} else if (!V.has(cp)) {
			// https://www.unicode.org/reports/tr39/#mixed_script_confusables
			let quoted = quoted_cp(cp);
			for (let cp of cps) {
				let u = UNIQUE.get(cp);
				if (u && u !== g) {
					// if both scripts are restricted this error is confusing
					// because we don't differentiate RestrictedA from RestrictedB 
					if (!u.R) quoted = `${quoted} is ${u.N}`;
					break;
				}
			}
			throw new Error(`disallowed ${g.N} character: ${quoted}`);
			//throw new Error(`disallowed character: ${quoted} (expected ${g.N})`);
			//throw new Error(`${g.N} does not allow: ${quoted}`);
		}
	}
	if (!cm_whitelist) {
		let decomposed = nfd(cps);
		for (let i = 1, e = decomposed.length; i < e; i++) { // we know it can't be cm leading
			if (CM.has(decomposed[i])) {
				let j = i + 1;
				while (j < e && CM.has(decomposed[j])) j++;
				if (j - i > M) {
					throw new Error(`too many combining marks: "${str_from_cps(decomposed.slice(i-1, j))}" (${j-i}/${M})`);
				}
				i = j;
			}
		}
	}
	*/ }
// given a list of codepoints
// returns a list of lists, where emoji are a fully-qualified (as Array subclass)
// eg. explode_cp("abc💩d") => [[61, 62, 63], Emoji[1F4A9, FE0F], [64]]
function $e006ee16d99d0706$var$process(input, nf) {
    let ret = [];
    let chars = [];
    input = input.slice().reverse(); // flip so we can pop
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input);
        if (emoji) {
            if (chars.length) {
                ret.push(nf(chars));
                chars = [];
            }
            ret.push(emoji);
        } else {
            let cp = input.pop();
            if ($e006ee16d99d0706$var$VALID.has(cp)) chars.push(cp);
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) chars.push(...cps);
                else if (!$e006ee16d99d0706$var$IGNORED.has(cp)) throw $e006ee16d99d0706$var$error_disallowed(cp);
            }
        }
    }
    if (chars.length) ret.push(nf(chars));
    return ret;
}
function $e006ee16d99d0706$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != $e006ee16d99d0706$var$FE0F);
}
// given array of codepoints
// returns the longest valid emoji sequence (or undefined if no match)
// *MUTATES* the supplied array
// allows optional FE0F
// disallows interleaved ignored characters
// fills (optional) eaten array with matched codepoints
function $e006ee16d99d0706$var$consume_emoji_reversed(cps, eaten) {
    let node = $e006ee16d99d0706$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = node.B.find((x)=>x.Q.has(cp));
        if (!node) break;
        if (node.S) saved = cp;
        else if (node.C) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.F) {
            stack.push($e006ee16d99d0706$var$FE0F);
            if (pos > 0 && cps[pos - 1] == $e006ee16d99d0706$var$FE0F) pos--; // consume optional FE0F
        }
        if (node.V) {
            emoji = $e006ee16d99d0706$var$conform_emoji_copy(stack, node);
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    /*
	// *** this code currently isn't needed ***
	if (!emoji) {
		let cp = cps[cps.length-1];
		if (EMOJI_SOLO.has(cp)) {
			if (eaten) eaten.push(cp);
			emoji = Emoji.of(cp);
			cps.pop();
		}
	}
	*/ return emoji;
}
// create a copy and fix any unicode quirks
function $e006ee16d99d0706$var$conform_emoji_copy(cps, node) {
    let copy = $e006ee16d99d0706$var$Emoji.from(cps); // copy stack
    if (node.V == 2) copy.splice(1, 1); // delete FE0F at position 1 (see: make.js)
    return copy;
}
// return all supported emoji as fully-qualified emoji 
// ordered by length then lexicographic 
function $e006ee16d99d0706$export$95d5ea4de7964366() {
    // *** this code currently isn't needed ***
    //let ret = [...EMOJI_SOLO].map(x => [x]);
    let ret = [];
    build($e006ee16d99d0706$var$EMOJI_ROOT, []);
    return ret.sort($e006ee16d99d0706$var$compare_arrays);
    function build(node, cps, saved) {
        if (node.S) saved = cps[cps.length - 1];
        else if (node.C) {
            if (saved === cps[cps.length - 1]) return;
        }
        if (node.F) cps.push($e006ee16d99d0706$var$FE0F);
        if (node.V) ret.push($e006ee16d99d0706$var$conform_emoji_copy(cps, node));
        for (let br of node.B)for (let cp of br.Q)build(br, [
            ...cps,
            cp
        ], saved);
    }
}
// ************************************************************
// tokenizer 
const $e006ee16d99d0706$var$TY_VALID = "valid";
const $e006ee16d99d0706$var$TY_MAPPED = "mapped";
const $e006ee16d99d0706$var$TY_IGNORED = "ignored";
const $e006ee16d99d0706$var$TY_DISALLOWED = "disallowed";
const $e006ee16d99d0706$var$TY_EMOJI = "emoji";
const $e006ee16d99d0706$var$TY_NFC = "nfc";
const $e006ee16d99d0706$var$TY_STOP = "stop";
function $e006ee16d99d0706$export$bac129d8210aa825(name, { nf: nf = true } = {}) {
    let input = $e006ee16d99d0706$var$explode_cp(name).reverse();
    let eaten = [];
    let tokens = [];
    while(input.length){
        let emoji = $e006ee16d99d0706$var$consume_emoji_reversed(input, eaten);
        if (emoji) tokens.push({
            type: $e006ee16d99d0706$var$TY_EMOJI,
            emoji: emoji,
            input: eaten.slice(),
            cps: $e006ee16d99d0706$var$filter_fe0f(emoji)
        });
        else {
            let cp = input.pop();
            if (cp == $e006ee16d99d0706$var$STOP) tokens.push({
                type: $e006ee16d99d0706$var$TY_STOP,
                cp: cp
            });
            else if ($e006ee16d99d0706$var$VALID.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_VALID,
                cps: [
                    cp
                ]
            });
            else if ($e006ee16d99d0706$var$IGNORED.has(cp)) tokens.push({
                type: $e006ee16d99d0706$var$TY_IGNORED,
                cp: cp
            });
            else {
                let cps = $e006ee16d99d0706$var$MAPPED.get(cp);
                if (cps) tokens.push({
                    type: $e006ee16d99d0706$var$TY_MAPPED,
                    cp: cp,
                    cps: cps.slice()
                });
                else tokens.push({
                    type: $e006ee16d99d0706$var$TY_DISALLOWED,
                    cp: cp
                });
            }
        }
    }
    if (nf) for(let i = 0, start = -1; i < tokens.length; i++){
        let token = tokens[i];
        if ($e006ee16d99d0706$var$is_valid_or_mapped(token.type)) {
            if ($e006ee16d99d0706$var$requires_check(token.cps)) {
                let end = i + 1;
                for(let pos = end; pos < tokens.length; pos++){
                    let { type: type, cps: cps } = tokens[pos];
                    if ($e006ee16d99d0706$var$is_valid_or_mapped(type)) {
                        if (!$e006ee16d99d0706$var$requires_check(cps)) break;
                        end = pos + 1;
                    } else if (type !== $e006ee16d99d0706$var$TY_IGNORED) break;
                }
                if (start < 0) start = i;
                let slice = tokens.slice(start, end);
                let cps0 = slice.flatMap((x)=>$e006ee16d99d0706$var$is_valid_or_mapped(x.type) ? x.cps : []); // strip junk tokens
                let cps = $e006ee16d99d0706$export$f42252642e08449(cps0);
                if ($e006ee16d99d0706$var$compare_arrays(cps, cps0)) {
                    tokens.splice(start, end - start, {
                        type: $e006ee16d99d0706$var$TY_NFC,
                        input: cps0,
                        cps: cps,
                        tokens0: $e006ee16d99d0706$var$collapse_valid_tokens(slice),
                        tokens: $e006ee16d99d0706$export$bac129d8210aa825($e006ee16d99d0706$var$str_from_cps(cps), {
                            nf: false
                        })
                    });
                    i = start;
                } else i = end - 1; // skip to end of slice
                start = -1; // reset
            } else start = i; // remember last
        } else if (token.type !== $e006ee16d99d0706$var$TY_IGNORED) start = -1; // reset
    }
    return $e006ee16d99d0706$var$collapse_valid_tokens(tokens);
}
function $e006ee16d99d0706$var$is_valid_or_mapped(type) {
    return type == $e006ee16d99d0706$var$TY_VALID || type == $e006ee16d99d0706$var$TY_MAPPED;
}
function $e006ee16d99d0706$var$requires_check(cps) {
    return cps.some((cp)=>$e006ee16d99d0706$var$NFC_CHECK.has(cp));
}
function $e006ee16d99d0706$var$collapse_valid_tokens(tokens) {
    for(let i = 0; i < tokens.length; i++)if (tokens[i].type == $e006ee16d99d0706$var$TY_VALID) {
        let j = i + 1;
        while(j < tokens.length && tokens[j].type == $e006ee16d99d0706$var$TY_VALID)j++;
        tokens.splice(i, j - i, {
            type: $e006ee16d99d0706$var$TY_VALID,
            cps: tokens.slice(i, j).flatMap((x)=>x.cps)
        });
    }
    return tokens;
}


const $574ce7342d53bcf4$var$Zeros = new Uint8Array(32);
$574ce7342d53bcf4$var$Zeros.fill(0);
function $574ce7342d53bcf4$var$checkComponent(comp) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(comp.length !== 0, "invalid ENS name; empty component", "comp", comp);
    return comp;
}
function $574ce7342d53bcf4$var$ensNameSplit(name) {
    const bytes = (0, $50aa15ceb128a952$export$8feeb310b4b4752f)($574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(last < bytes.length, "invalid ENS name; empty component", "name", name);
    comps.push($574ce7342d53bcf4$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $574ce7342d53bcf4$export$5f232fd2f1a1e8ac(name) {
    try {
        return (0, $e006ee16d99d0706$export$499f715881831a51)(name);
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid ENS name (${error.message})`, "name", name);
    }
}
function $574ce7342d53bcf4$export$cce2300886e7ace6(name) {
    try {
        return $574ce7342d53bcf4$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $574ce7342d53bcf4$export$91d651ee363e1209(name) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof name === "string", "invalid ENS name; not a string", "name", name);
    let result = $574ce7342d53bcf4$var$Zeros;
    const comps = $574ce7342d53bcf4$var$ensNameSplit(name);
    while(comps.length)result = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        result,
        (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(result);
}
function $574ce7342d53bcf4$export$6c0a8cdae51cb512(name) {
    return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)($574ce7342d53bcf4$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}




//See: https://github.com/ethereum/wiki/wiki/RLP


function $c465ec7edc0c99d6$var$hexlifyByte(value) {
    let result = value.toString(16);
    while(result.length < 2)result = "0" + result;
    return "0x" + result;
}
function $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $c465ec7edc0c99d6$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $c465ec7edc0c99d6$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        (0, $634aa51198273feb$export$a7a9523472993e97)(childOffset <= offset + 1 + length, "child data too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: length,
            offset: offset
        });
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $c465ec7edc0c99d6$var$_decode(data, offset) {
    (0, $634aa51198273feb$export$a7a9523472993e97)(data.length !== 0, "data too short", "BUFFER_OVERRUN", {
        buffer: data,
        length: 0,
        offset: 1
    });
    const checkOffset = (offset)=>{
        (0, $634aa51198273feb$export$a7a9523472993e97)(offset <= data.length, "data short segment too short", "BUFFER_OVERRUN", {
            buffer: data,
            length: data.length,
            offset: offset
        });
    };
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        checkOffset(offset + 1 + length);
        return $c465ec7edc0c99d6$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        checkOffset(offset + 1 + lengthLength);
        const length = $c465ec7edc0c99d6$var$unarrayifyInteger(data, offset + 1, lengthLength);
        checkOffset(offset + 1 + lengthLength + length);
        const result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        checkOffset(offset + 1 + length);
        const result = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: $c465ec7edc0c99d6$var$hexlifyByte(data[offset])
    };
}
function $c465ec7edc0c99d6$export$7dc021e13b2aa20d(_data) {
    const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_data, "data");
    const decoded = $c465ec7edc0c99d6$var$_decode(data, 0);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(decoded.consumed === data.length, "unexpected junk after rlp payload", "data", _data);
    return decoded.result;
}

//See: https://github.com/ethereum/wiki/wiki/RLP

function $caedcf6749fe63e5$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $caedcf6749fe63e5$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($caedcf6749fe63e5$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $caedcf6749fe63e5$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    const data = Array.prototype.slice.call((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(object, "object"));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $caedcf6749fe63e5$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
const $caedcf6749fe63e5$var$nibbles = "0123456789abcdef";
function $caedcf6749fe63e5$export$aea7770274d28b7(object) {
    let result = "0x";
    for (const v of $caedcf6749fe63e5$var$_encode(object)){
        result += $caedcf6749fe63e5$var$nibbles[v >> 4];
        result += $caedcf6749fe63e5$var$nibbles[v & 0xf];
    }
    return result;
}




const $154b040c27f48330$var$BN_0 = BigInt(0);
const $154b040c27f48330$var$BN_2 = BigInt(2);
const $154b040c27f48330$var$BN_27 = BigInt(27);
const $154b040c27f48330$var$BN_28 = BigInt(28);
const $154b040c27f48330$var$BN_35 = BigInt(35);
const $154b040c27f48330$var$BN_MAX_UINT = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $154b040c27f48330$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
}
function $154b040c27f48330$var$handleAccessList(value, param) {
    try {
        return (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value);
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, error.message, param, value);
    }
}
function $154b040c27f48330$var$handleNumber(_value, param) {
    if (_value === "0x") return 0;
    return (0, $6fa405e57bb6371e$export$b14f2714108df84)(_value, param);
}
function $154b040c27f48330$var$handleUint(_value, param) {
    if (_value === "0x") return $154b040c27f48330$var$BN_0;
    const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, param);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(value <= $154b040c27f48330$var$BN_MAX_UINT, "value exceeds uint size", param, value);
    return value;
}
function $154b040c27f48330$var$formatNumber(_value, name) {
    const value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_value, "value");
    const result = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.length <= 32, `value too large`, `tx.${name}`, value);
    return result;
}
function $154b040c27f48330$var$formatAccessList(value) {
    return (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $154b040c27f48330$var$_parseLegacy(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)(data);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 6), "invalid field count for legacy transaction", "data", data);
    const tx = {
        type: 0,
        nonce: $154b040c27f48330$var$handleNumber(fields[0], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[1], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[2], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[3]),
        value: $154b040c27f48330$var$handleUint(fields[4], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[5]),
        chainId: $154b040c27f48330$var$BN_0
    };
    // Legacy unsigned transaction
    if (fields.length === 6) return tx;
    const v = $154b040c27f48330$var$handleUint(fields[6], "v");
    const r = $154b040c27f48330$var$handleUint(fields[7], "r");
    const s = $154b040c27f48330$var$handleUint(fields[8], "s");
    if (r === $154b040c27f48330$var$BN_0 && s === $154b040c27f48330$var$BN_0) // EIP-155 unsigned transaction
    tx.chainId = v;
    else {
        // Compute the EIP-155 chain ID (or 0 for legacy)
        let chainId = (v - $154b040c27f48330$var$BN_35) / $154b040c27f48330$var$BN_2;
        if (chainId < $154b040c27f48330$var$BN_0) chainId = $154b040c27f48330$var$BN_0;
        tx.chainId = chainId;
        // Signed Legacy Transaction
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(chainId !== $154b040c27f48330$var$BN_0 || v === $154b040c27f48330$var$BN_27 || v === $154b040c27f48330$var$BN_28, "non-canonical legacy v", "v", fields[6]);
        tx.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
            r: (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[7], 32),
            s: (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[8], 32),
            v: v
        });
        tx.hash = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(data);
    }
    return tx;
}
function $154b040c27f48330$var$_serializeLegacy(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.nonce || 0, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit || 0, "gasLimit"),
        tx.to != null ? (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.to) : "0x",
        $154b040c27f48330$var$formatNumber(tx.value || 0, "value"),
        tx.data || "0x"
    ];
    let chainId = $154b040c27f48330$var$BN_0;
    if (tx.chainId != $154b040c27f48330$var$BN_0) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.chainId, "tx.chainId");
        // We have a chainId in the tx and an EIP-155 v in the signature,
        // make sure they agree with each other
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!sig || sig.networkV == null || sig.legacyChainId === chainId, "tx.chainId/sig.v mismatch", "sig", sig);
    } else if (tx.signature) {
        // No explicit chainId, but EIP-155 have a derived implicit chainId
        const legacy = tx.signature.legacyChainId;
        if (legacy != null) chainId = legacy;
    }
    // Requesting an unsigned transaction
    if (!sig) {
        // We have an EIP-155 transaction (chainId was specified and non-zero)
        if (chainId !== $154b040c27f48330$var$BN_0) {
            fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(chainId));
            fields.push("0x");
            fields.push("0x");
        }
        return (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields);
    }
    // @TODO: We should probably check that tx.signature, chainId, and sig
    //        match but that logic could break existing code, so schedule
    //        this for the next major bump.
    // Compute the EIP-155 v
    let v = BigInt(27 + sig.yParity);
    if (chainId !== $154b040c27f48330$var$BN_0) v = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).getChainIdV(chainId, sig.v);
    else if (BigInt(sig.v) !== v) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "tx.chainId/sig.v mismatch", "sig", sig);
    // Add the signature
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(v));
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
    fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    return (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields);
}
function $154b040c27f48330$var$_parseEipSignature(tx, fields) {
    let yParity;
    try {
        yParity = $154b040c27f48330$var$handleNumber(fields[0], "yParity");
        if (yParity !== 0 && yParity !== 1) throw new Error("bad yParity");
    } catch (error) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid yParity", "yParity", fields[0]);
    }
    const r = (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[1], 32);
    const s = (0, $fd3872da8feed9cb$export$4473860254365feb)(fields[2], 32);
    const signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from({
        r: r,
        s: s,
        yParity: yParity
    });
    tx.signature = signature;
}
function $154b040c27f48330$var$_parseEip1559(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data).slice(1));
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 9 || fields.length === 12), "invalid field count for transaction type: 2", "data", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data));
    const maxPriorityFeePerGas = $154b040c27f48330$var$handleUint(fields[2], "maxPriorityFeePerGas");
    const maxFeePerGas = $154b040c27f48330$var$handleUint(fields[3], "maxFeePerGas");
    const tx = {
        type: 2,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $154b040c27f48330$var$handleUint(fields[4], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[5]),
        value: $154b040c27f48330$var$handleUint(fields[6], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[7]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[8], "accessList")
    };
    // Unsigned EIP-1559 Transaction
    if (fields.length === 9) return tx;
    tx.hash = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(9));
    return tx;
}
function $154b040c27f48330$var$_serializeEip1559(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId || 0, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce || 0, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.maxFeePerGas || 0, "maxFeePerGas"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit || 0, "gasLimit"),
        tx.to != null ? (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.to) : "0x",
        $154b040c27f48330$var$formatNumber(tx.value || 0, "value"),
        tx.data || "0x",
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "yParity"));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0x02",
        (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields)
    ]);
}
function $154b040c27f48330$var$_parseEip2930(data) {
    const fields = (0, $c465ec7edc0c99d6$export$7dc021e13b2aa20d)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(data).slice(1));
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(Array.isArray(fields) && (fields.length === 8 || fields.length === 11), "invalid field count for transaction type: 1", "data", (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(data));
    const tx = {
        type: 1,
        chainId: $154b040c27f48330$var$handleUint(fields[0], "chainId"),
        nonce: $154b040c27f48330$var$handleNumber(fields[1], "nonce"),
        gasPrice: $154b040c27f48330$var$handleUint(fields[2], "gasPrice"),
        gasLimit: $154b040c27f48330$var$handleUint(fields[3], "gasLimit"),
        to: $154b040c27f48330$var$handleAddress(fields[4]),
        value: $154b040c27f48330$var$handleUint(fields[5], "value"),
        data: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(fields[6]),
        accessList: $154b040c27f48330$var$handleAccessList(fields[7], "accessList")
    };
    // Unsigned EIP-2930 Transaction
    if (fields.length === 8) return tx;
    tx.hash = (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(data);
    $154b040c27f48330$var$_parseEipSignature(tx, fields.slice(8));
    return tx;
}
function $154b040c27f48330$var$_serializeEip2930(tx, sig) {
    const fields = [
        $154b040c27f48330$var$formatNumber(tx.chainId || 0, "chainId"),
        $154b040c27f48330$var$formatNumber(tx.nonce || 0, "nonce"),
        $154b040c27f48330$var$formatNumber(tx.gasPrice || 0, "gasPrice"),
        $154b040c27f48330$var$formatNumber(tx.gasLimit || 0, "gasLimit"),
        tx.to != null ? (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.to) : "0x",
        $154b040c27f48330$var$formatNumber(tx.value || 0, "value"),
        tx.data || "0x",
        $154b040c27f48330$var$formatAccessList(tx.accessList || [])
    ];
    if (sig) {
        fields.push($154b040c27f48330$var$formatNumber(sig.yParity, "recoveryParam"));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.r));
        fields.push((0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(sig.s));
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0x01",
        (0, $caedcf6749fe63e5$export$aea7770274d28b7)(fields)
    ]);
}
class $154b040c27f48330$export$febc5573c75cefb0 {
    #type;
    #to;
    #data;
    #nonce;
    #gasLimit;
    #gasPrice;
    #maxPriorityFeePerGas;
    #maxFeePerGas;
    #value;
    #chainId;
    #sig;
    #accessList;
    /**
     *  The transaction type.
     *
     *  If null, the type will be automatically inferred based on
     *  explicit properties.
     */ get type() {
        return this.#type;
    }
    set type(value) {
        switch(value){
            case null:
                this.#type = null;
                break;
            case 0:
            case "legacy":
                this.#type = 0;
                break;
            case 1:
            case "berlin":
            case "eip-2930":
                this.#type = 1;
                break;
            case 2:
            case "london":
            case "eip-1559":
                this.#type = 2;
                break;
            default:
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported transaction type", "type", value);
        }
    }
    /**
     *  The name of the transaction type.
     */ get typeName() {
        switch(this.type){
            case 0:
                return "legacy";
            case 1:
                return "eip-2930";
            case 2:
                return "eip-1559";
        }
        return null;
    }
    /**
     *  The ``to`` address for the transaction or ``null`` if the
     *  transaction is an ``init`` transaction.
     */ get to() {
        return this.#to;
    }
    set to(value) {
        this.#to = value == null ? null : (0, $69ef3f917ff239a2$export$88411125f012957a)(value);
    }
    /**
     *  The transaction nonce.
     */ get nonce() {
        return this.#nonce;
    }
    set nonce(value) {
        this.#nonce = (0, $6fa405e57bb6371e$export$b14f2714108df84)(value, "value");
    }
    /**
     *  The gas limit.
     */ get gasLimit() {
        return this.#gasLimit;
    }
    set gasLimit(value) {
        this.#gasLimit = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  The gas price.
     *
     *  On legacy networks this defines the fee that will be paid. On
     *  EIP-1559 networks, this should be ``null``.
     */ get gasPrice() {
        const value = this.#gasPrice;
        if (value == null && (this.type === 0 || this.type === 1)) return $154b040c27f48330$var$BN_0;
        return value;
    }
    set gasPrice(value) {
        this.#gasPrice = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "gasPrice");
    }
    /**
     *  The maximum priority fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxPriorityFeePerGas() {
        const value = this.#maxPriorityFeePerGas;
        if (value == null) {
            if (this.type === 2) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxPriorityFeePerGas(value) {
        this.#maxPriorityFeePerGas = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "maxPriorityFeePerGas");
    }
    /**
     *  The maximum total fee per unit of gas to pay. On legacy
     *  networks this should be ``null``.
     */ get maxFeePerGas() {
        const value = this.#maxFeePerGas;
        if (value == null) {
            if (this.type === 2) return $154b040c27f48330$var$BN_0;
            return null;
        }
        return value;
    }
    set maxFeePerGas(value) {
        this.#maxFeePerGas = value == null ? null : (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "maxFeePerGas");
    }
    /**
     *  The transaction data. For ``init`` transactions this is the
     *  deployment code.
     */ get data() {
        return this.#data;
    }
    set data(value) {
        this.#data = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(value);
    }
    /**
     *  The amount of ether (in wei) to send in this transactions.
     */ get value() {
        return this.#value;
    }
    set value(value) {
        this.#value = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "value");
    }
    /**
     *  The chain ID this transaction is valid on.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value);
    }
    /**
     *  If signed, the signature for this transaction.
     */ get signature() {
        return this.#sig || null;
    }
    set signature(value) {
        this.#sig = value == null ? null : (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value);
    }
    /**
     *  The access list.
     *
     *  An access list permits discounted (but pre-paid) access to
     *  bytecode and state variable access within contract execution.
     */ get accessList() {
        const value = this.#accessList || null;
        if (value == null) {
            if (this.type === 1 || this.type === 2) return [];
            return null;
        }
        return value;
    }
    set accessList(value) {
        this.#accessList = value == null ? null : (0, $c254de3831dd58ea$export$6c8662b1600dce2)(value);
    }
    /**
     *  Creates a new Transaction with default values.
     */ constructor(){
        this.#type = null;
        this.#to = null;
        this.#nonce = 0;
        this.#gasLimit = BigInt(0);
        this.#gasPrice = null;
        this.#maxPriorityFeePerGas = null;
        this.#maxFeePerGas = null;
        this.#data = "0x";
        this.#value = BigInt(0);
        this.#chainId = BigInt(0);
        this.#sig = null;
        this.#accessList = null;
    }
    /**
     *  The transaction hash, if signed. Otherwise, ``null``.
     */ get hash() {
        if (this.signature == null) return null;
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.serialized);
    }
    /**
     *  The pre-image hash of this transaction.
     *
     *  This is the digest that a [[Signer]] must sign to authorize
     *  this transaction.
     */ get unsignedHash() {
        return (0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)(this.unsignedSerialized);
    }
    /**
     *  The sending address, if signed. Otherwise, ``null``.
     */ get from() {
        if (this.signature == null) return null;
        return (0, $e25c0939af0d847b$export$23cc18f96d8510e2)(this.unsignedHash, this.signature);
    }
    /**
     *  The public key of the sender, if signed. Otherwise, ``null``.
     */ get fromPublicKey() {
        if (this.signature == null) return null;
        return (0, $015cdebda6711d1b$export$21643ca94aed3e83).recoverPublicKey(this.unsignedHash, this.signature);
    }
    /**
     *  Returns true if signed.
     *
     *  This provides a Type Guard that properties requiring a signed
     *  transaction are non-null.
     */ isSigned() {
        //isSigned(): this is SignedTransaction {
        return this.signature != null;
    }
    /**
     *  The serialized transaction.
     *
     *  This throws if the transaction is unsigned. For the pre-image,
     *  use [[unsignedSerialized]].
     */ get serialized() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.signature != null, "cannot serialize unsigned transaction; maybe you meant .unsignedSerialized", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
        switch(this.inferType()){
            case 0:
                return $154b040c27f48330$var$_serializeLegacy(this, this.signature);
            case 1:
                return $154b040c27f48330$var$_serializeEip2930(this, this.signature);
            case 2:
                return $154b040c27f48330$var$_serializeEip1559(this, this.signature);
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".serialized"
        });
    }
    /**
     *  The transaction pre-image.
     *
     *  The hash of this is the digest which needs to be signed to
     *  authorize this transaction.
     */ get unsignedSerialized() {
        switch(this.inferType()){
            case 0:
                return $154b040c27f48330$var$_serializeLegacy(this);
            case 1:
                return $154b040c27f48330$var$_serializeEip2930(this);
            case 2:
                return $154b040c27f48330$var$_serializeEip1559(this);
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
            operation: ".unsignedSerialized"
        });
    }
    /**
     *  Return the most "likely" type; currently the highest
     *  supported transaction type.
     */ inferType() {
        return this.inferTypes().pop();
    }
    /**
     *  Validates the explicit properties and returns a list of compatible
     *  transaction types.
     */ inferTypes() {
        // Checks that there are no conflicting properties set
        const hasGasPrice = this.gasPrice != null;
        const hasFee = this.maxFeePerGas != null || this.maxPriorityFeePerGas != null;
        const hasAccessList = this.accessList != null;
        //if (hasGasPrice && hasFee) {
        //    throw new Error("transaction cannot have gasPrice and maxFeePerGas");
        //}
        if (this.maxFeePerGas != null && this.maxPriorityFeePerGas != null) (0, $634aa51198273feb$export$a7a9523472993e97)(this.maxFeePerGas >= this.maxPriorityFeePerGas, "priorityFee cannot be more than maxFee", "BAD_DATA", {
            value: this
        });
        //if (this.type === 2 && hasGasPrice) {
        //    throw new Error("eip-1559 transaction cannot have gasPrice");
        //}
        (0, $634aa51198273feb$export$a7a9523472993e97)(!hasFee || this.type !== 0 && this.type !== 1, "transaction type cannot have maxFeePerGas or maxPriorityFeePerGas", "BAD_DATA", {
            value: this
        });
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.type !== 0 || !hasAccessList, "legacy transaction cannot have accessList", "BAD_DATA", {
            value: this
        });
        const types = [];
        // Explicit type
        if (this.type != null) types.push(this.type);
        else {
            if (hasFee) types.push(2);
            else if (hasGasPrice) {
                types.push(1);
                if (!hasAccessList) types.push(0);
            } else if (hasAccessList) {
                types.push(1);
                types.push(2);
            } else {
                types.push(0);
                types.push(1);
                types.push(2);
            }
        }
        types.sort();
        return types;
    }
    /**
     *  Returns true if this transaction is a legacy transaction (i.e.
     *  ``type === 0``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLegacy() {
        return this.type === 0;
    }
    /**
     *  Returns true if this transaction is berlin hardform transaction (i.e.
     *  ``type === 1``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isBerlin() {
        return this.type === 1;
    }
    /**
     *  Returns true if this transaction is london hardform transaction (i.e.
     *  ``type === 2``).
     *
     *  This provides a Type Guard that the related properties are
     *  non-null.
     */ isLondon() {
        return this.type === 2;
    }
    /**
     *  Create a copy of this transaciton.
     */ clone() {
        return $154b040c27f48330$export$febc5573c75cefb0.from(this);
    }
    /**
     *  Return a JSON-friendly object.
     */ toJSON() {
        const s = (v)=>{
            if (v == null) return null;
            return v.toString();
        };
        return {
            type: this.type,
            to: this.to,
            //            from: this.from,
            data: this.data,
            nonce: this.nonce,
            gasLimit: s(this.gasLimit),
            gasPrice: s(this.gasPrice),
            maxPriorityFeePerGas: s(this.maxPriorityFeePerGas),
            maxFeePerGas: s(this.maxFeePerGas),
            value: s(this.value),
            chainId: s(this.chainId),
            sig: this.signature ? this.signature.toJSON() : null,
            accessList: this.accessList
        };
    }
    /**
     *  Create a **Transaction** from a serialized transaction or a
     *  Transaction-like object.
     */ static from(tx) {
        if (tx == null) return new $154b040c27f48330$export$febc5573c75cefb0();
        if (typeof tx === "string") {
            const payload = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(tx);
            if (payload[0] >= 0x7f) return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseLegacy(payload));
            switch(payload[0]){
                case 1:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip2930(payload));
                case 2:
                    return $154b040c27f48330$export$febc5573c75cefb0.from($154b040c27f48330$var$_parseEip1559(payload));
            }
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported transaction type", "UNSUPPORTED_OPERATION", {
                operation: "from"
            });
        }
        const result = new $154b040c27f48330$export$febc5573c75cefb0();
        if (tx.type != null) result.type = tx.type;
        if (tx.to != null) result.to = tx.to;
        if (tx.nonce != null) result.nonce = tx.nonce;
        if (tx.gasLimit != null) result.gasLimit = tx.gasLimit;
        if (tx.gasPrice != null) result.gasPrice = tx.gasPrice;
        if (tx.maxPriorityFeePerGas != null) result.maxPriorityFeePerGas = tx.maxPriorityFeePerGas;
        if (tx.maxFeePerGas != null) result.maxFeePerGas = tx.maxFeePerGas;
        if (tx.data != null) result.data = tx.data;
        if (tx.value != null) result.value = tx.value;
        if (tx.chainId != null) result.chainId = tx.chainId;
        if (tx.signature != null) result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(tx.signature);
        if (tx.accessList != null) result.accessList = tx.accessList;
        if (tx.hash != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define hash", "tx", tx);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.hash === tx.hash, "hash mismatch", "tx", tx);
        }
        if (tx.from != null) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.isSigned(), "unsigned transaction cannot define from", "tx", tx);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(result.from.toLowerCase() === (tx.from || "").toLowerCase(), "from mismatch", "tx", tx);
        }
        return result;
    }
}



/**
 *  ENS is a service which allows easy-to-remember names to map to
 *  network addresses.
 *
 *  @_section: api/providers/ens-resolver:ENS Resolver  [about-ens-rsolver]
 */ 



/**
 *  The [Base58 Encoding](link-base58) scheme allows a **numeric** value
 *  to be encoded as a compact string using a radix of 58 using only
 *  alpha-numeric characters. Confusingly similar characters are omitted
 *  (i.e. ``"l0O"``).
 *
 *  Note that Base58 encodes a **numeric** value, not arbitrary bytes,
 *  since any zero-bytes on the left would get removed. To mitigate this
 *  issue most schemes that use Base58 choose specific high-order values
 *  to ensure non-zero prefixes.
 *
 *  @_subsection: api/utils:Base58 Encoding [about-base58]
 */ 


const $afe06f2b2ad79fd5$var$Alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
let $afe06f2b2ad79fd5$var$Lookup = null;
function $afe06f2b2ad79fd5$var$getAlpha(letter) {
    if ($afe06f2b2ad79fd5$var$Lookup == null) {
        $afe06f2b2ad79fd5$var$Lookup = {};
        for(let i = 0; i < $afe06f2b2ad79fd5$var$Alphabet.length; i++)$afe06f2b2ad79fd5$var$Lookup[$afe06f2b2ad79fd5$var$Alphabet[i]] = BigInt(i);
    }
    const result = $afe06f2b2ad79fd5$var$Lookup[letter];
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(result != null, `invalid base58 value`, "letter", letter);
    return result;
}
const $afe06f2b2ad79fd5$var$BN_0 = BigInt(0);
const $afe06f2b2ad79fd5$var$BN_58 = BigInt(58);
function $afe06f2b2ad79fd5$export$743e6bddc3282b13(_value) {
    let value = (0, $6fa405e57bb6371e$export$c221a145703ab783)((0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_value));
    let result = "";
    while(value){
        result = $afe06f2b2ad79fd5$var$Alphabet[Number(value % $afe06f2b2ad79fd5$var$BN_58)] + result;
        value /= $afe06f2b2ad79fd5$var$BN_58;
    }
    return result;
}
function $afe06f2b2ad79fd5$export$63d430871b22e3d9(value) {
    let result = $afe06f2b2ad79fd5$var$BN_0;
    for(let i = 0; i < value.length; i++){
        result *= $afe06f2b2ad79fd5$var$BN_58;
        result += $afe06f2b2ad79fd5$var$getAlpha(value[i]);
    }
    return result;
}


// @TODO: This should use the fetch-data:ipfs gateway
// Trim off the ipfs:// prefix and return the default gateway URL
function $280d6641ec976e99$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
class $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  The name.
     */ name;
    /**
     *  Creates a new **MulticoinProviderPluing** for %%name%%.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    connect(proivder) {
        return this;
    }
    /**
     *  Returns ``true`` if %%coinType%% is supported by this plugin.
     */ supportsCoinType(coinType) {
        return false;
    }
    /**
     *  Resovles to the encoded %%address%% for %%coinType%%.
     */ async encodeAddress(coinType, address) {
        throw new Error("unsupported coin");
    }
    /**
     *  Resovles to the decoded %%data%% for %%coinType%%.
     */ async decodeAddress(coinType, data) {
        throw new Error("unsupported coin");
    }
}
const $280d6641ec976e99$var$BasicMulticoinPluginId = "org.ethers.plugins.provider.BasicMulticoin";
class $280d6641ec976e99$export$dcf63b2028a708b5 extends $280d6641ec976e99$export$1e6016d1bbd92d2c {
    /**
     *  Creates a new **BasicMulticoinProviderPlugin**.
     */ constructor(){
        super($280d6641ec976e99$var$BasicMulticoinPluginId);
    }
}
const $280d6641ec976e99$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $280d6641ec976e99$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $280d6641ec976e99$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
class $280d6641ec976e99$export$d04afd034a0a53ae {
    /**
     *  The connected provider.
     */ provider;
    /**
     *  The address of the resolver.
     */ address;
    /**
     *  The name this resolver was resolved against.
     */ name;
    // For EIP-2544 names, the ancestor that provided the resolver
    #supports2544;
    #resolver;
    constructor(provider, address, name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider,
            address: address,
            name: name
        });
        this.#supports2544 = null;
        this.#resolver = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(address, [
            "function supportsInterface(bytes4) view returns (bool)",
            "function resolve(bytes, bytes) view returns (bytes)",
            "function addr(bytes32) view returns (address)",
            "function addr(bytes32, uint) view returns (bytes)",
            "function text(bytes32, string) view returns (string)",
            "function contenthash(bytes32) view returns (bytes)"
        ], provider);
    }
    /**
     *  Resolves to true if the resolver supports wildcard resolution.
     */ async supportsWildcard() {
        if (this.#supports2544 == null) this.#supports2544 = (async ()=>{
            try {
                return await this.#resolver.supportsInterface("0x9061b923");
            } catch (error) {
                // Wildcard resolvers must understand supportsInterface
                // and return true.
                if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return false;
                // Let future attempts try again...
                this.#supports2544 = null;
                throw error;
            }
        })();
        return await this.#supports2544;
    }
    async #fetch(funcName, params) {
        params = (params || []).slice();
        const iface = this.#resolver.interface;
        // The first parameters is always the nodehash
        params.unshift((0, $574ce7342d53bcf4$export$91d651ee363e1209)(this.name));
        let fragment = null;
        if (await this.supportsWildcard()) {
            fragment = iface.getFunction(funcName);
            (0, $634aa51198273feb$export$a7a9523472993e97)(fragment, "missing fragment", "UNKNOWN_ERROR", {
                info: {
                    funcName: funcName
                }
            });
            params = [
                (0, $574ce7342d53bcf4$export$6c0a8cdae51cb512)(this.name),
                iface.encodeFunctionData(fragment, params)
            ];
            funcName = "resolve(bytes,bytes)";
        }
        params.push({
            enableCcipRead: true
        });
        try {
            const result = await this.#resolver[funcName](...params);
            if (fragment) return iface.decodeFunctionResult(fragment, result)[0];
            return result;
        } catch (error) {
            if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) throw error;
        }
        return null;
    }
    /**
     *  Resolves to the address for %%coinType%% or null if the
     *  provided %%coinType%% has not been configured.
     */ async getAddress(coinType) {
        if (coinType == null) coinType = 60;
        if (coinType === 60) try {
            const result = await this.#fetch("addr(bytes32)");
            // No address
            if (result == null || result === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            return result;
        } catch (error) {
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        // Try decoding its EVM canonical chain as an EVM chain address first
        if (coinType >= 0 && coinType < 0x80000000) {
            let ethCoinType = coinType + 0x80000000;
            const data = await this.#fetch("addr(bytes32,uint)", [
                ethCoinType
            ]);
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(data, 20)) return (0, $69ef3f917ff239a2$export$88411125f012957a)(data);
        }
        let coinPlugin = null;
        for (const plugin of this.provider.plugins){
            if (!(plugin instanceof $280d6641ec976e99$export$1e6016d1bbd92d2c)) continue;
            if (plugin.supportsCoinType(coinType)) {
                coinPlugin = plugin;
                break;
            }
        }
        if (coinPlugin == null) return null;
        // keccak256("addr(bytes32,uint256")
        const data = await this.#fetch("addr(bytes32,uint)", [
            coinType
        ]);
        // No address
        if (data == null || data === "0x") return null;
        // Compute the address
        const address = await coinPlugin.decodeAddress(coinType, data);
        if (address != null) return address;
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid coin data`, "UNSUPPORTED_OPERATION", {
            operation: `getAddress(${coinType})`,
            info: {
                coinType: coinType,
                data: data
            }
        });
    }
    /**
     *  Resolves to the EIP-634 text record for %%key%%, or ``null``
     *  if unconfigured.
     */ async getText(key) {
        const data = await this.#fetch("text(bytes32,string)", [
            key
        ]);
        if (data == null || data === "0x") return null;
        return data;
    }
    /**
     *  Rsolves to the content-hash or ``null`` if unconfigured.
     */ async getContentHash() {
        // keccak256("contenthash()")
        const data = await this.#fetch("contenthash(bytes32)");
        // No contenthash
        if (data == null || data === "0x") return null;
        // IPFS (CID: 1, Type: 70=DAG-PB, 72=libp2p-key)
        const ipfs = data.match(/^0x(e3010170|e5010172)(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
        if (ipfs) {
            const scheme = ipfs[1] === "e3010170" ? "ipfs" : "ipns";
            const length = parseInt(ipfs[4], 16);
            if (ipfs[5].length === length * 2) return `${scheme}:/\/${(0, $afe06f2b2ad79fd5$export$743e6bddc3282b13)("0x" + ipfs[2])}`;
        }
        // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
        const swarm = data.match(/^0xe40101fa011b20([0-9a-f]*)$/);
        if (swarm && swarm[1].length === 64) return `bzz:/\/${swarm[1]}`;
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid or unsupported content hash data`, "UNSUPPORTED_OPERATION", {
            operation: "getContentHash()",
            info: {
                data: data
            }
        });
    }
    /**
     *  Resolves to the avatar url or ``null`` if the avatar is either
     *  unconfigured or incorrectly configured (e.g. references an NFT
     *  not owned by the address).
     *
     *  If diagnosing issues with configurations, the [[_getAvatar]]
     *  method may be useful.
     */ async getAvatar() {
        const avatar = await this._getAvatar();
        return avatar.url;
    }
    /**
     *  When resolving an avatar, there are many steps involved, such
     *  fetching metadata and possibly validating ownership of an
     *  NFT.
     *
     *  This method can be used to examine each step and the value it
     *  was working from.
     */ async _getAvatar() {
        const linkage = [
            {
                type: "name",
                value: this.name
            }
        ];
        try {
            // test data for ricmoo.eth
            //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
            const avatar = await this.getText("avatar");
            if (avatar == null) {
                linkage.push({
                    type: "!avatar",
                    value: ""
                });
                return {
                    url: null,
                    linkage: linkage
                };
            }
            linkage.push({
                type: "avatar",
                value: avatar
            });
            for(let i = 0; i < $280d6641ec976e99$var$matchers.length; i++){
                const match = avatar.match($280d6641ec976e99$var$matchers[i]);
                if (match == null) continue;
                const scheme = match[1].toLowerCase();
                switch(scheme){
                    case "https":
                    case "data":
                        linkage.push({
                            type: "url",
                            value: avatar
                        });
                        return {
                            linkage: linkage,
                            url: avatar
                        };
                    case "ipfs":
                        {
                            const url = $280d6641ec976e99$var$getIpfsLink(avatar);
                            linkage.push({
                                type: "ipfs",
                                value: avatar
                            });
                            linkage.push({
                                type: "url",
                                value: url
                            });
                            return {
                                linkage: linkage,
                                url: url
                            };
                        }
                    case "erc721":
                    case "erc1155":
                        {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = scheme === "erc721" ? "tokenURI(uint256)" : "uri(uint256)";
                            linkage.push({
                                type: scheme,
                                value: avatar
                            });
                            // The owner of this name
                            const owner = await this.getAddress();
                            if (owner == null) {
                                linkage.push({
                                    type: "!owner",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                linkage.push({
                                    type: `!${scheme}caip`,
                                    value: match[2] || ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            const tokenId = comps[1];
                            const contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(comps[0], [
                                // ERC-721
                                "function tokenURI(uint) view returns (string)",
                                "function ownerOf(uint) view returns (address)",
                                // ERC-1155
                                "function uri(uint) view returns (string)",
                                "function balanceOf(address, uint256) view returns (uint)"
                            ], this.provider);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                const tokenOwner = await contract.ownerOf(tokenId);
                                if (owner !== tokenOwner) {
                                    linkage.push({
                                        type: "!owner",
                                        value: tokenOwner
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "owner",
                                    value: tokenOwner
                                });
                            } else if (scheme === "erc1155") {
                                const balance = await contract.balanceOf(owner, tokenId);
                                if (!balance) {
                                    linkage.push({
                                        type: "!balance",
                                        value: "0"
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "balance",
                                    value: balance.toString()
                                });
                            }
                            // Call the token contract for the metadata URL
                            let metadataUrl = await contract[selector](tokenId);
                            if (metadataUrl == null || metadataUrl === "0x") {
                                linkage.push({
                                    type: "!metadata-url",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata-url-base",
                                value: metadataUrl
                            });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", (0, $6fa405e57bb6371e$export$c6ebe05badb16181)(tokenId, 32).substring(2));
                                linkage.push({
                                    type: "metadata-url-expanded",
                                    value: metadataUrl
                                });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $280d6641ec976e99$var$getIpfsLink(metadataUrl);
                            linkage.push({
                                type: "metadata-url",
                                value: metadataUrl
                            });
                            // Get the token metadata
                            let metadata = {};
                            const response = await new (0, $2cb10defc4f72334$export$319b96fe59834522)(metadataUrl).send();
                            response.assertOk();
                            try {
                                metadata = response.bodyJson;
                            } catch (error) {
                                try {
                                    linkage.push({
                                        type: "!metadata",
                                        value: response.bodyText
                                    });
                                } catch (error) {
                                    const bytes = response.body;
                                    if (bytes) linkage.push({
                                        type: "!metadata",
                                        value: (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(bytes)
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (!metadata) {
                                linkage.push({
                                    type: "!metadata",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            linkage.push({
                                type: "metadata",
                                value: JSON.stringify(metadata)
                            });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof imageUrl !== "string") {
                                linkage.push({
                                    type: "!imageUrl",
                                    value: ""
                                });
                                return {
                                    url: null,
                                    linkage: linkage
                                };
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match($280d6641ec976e99$var$matcherIpfs);
                                if (ipfs == null) {
                                    linkage.push({
                                        type: "!imageUrl-ipfs",
                                        value: imageUrl
                                    });
                                    return {
                                        url: null,
                                        linkage: linkage
                                    };
                                }
                                linkage.push({
                                    type: "imageUrl-ipfs",
                                    value: imageUrl
                                });
                                imageUrl = $280d6641ec976e99$var$getIpfsLink(imageUrl);
                            }
                            linkage.push({
                                type: "url",
                                value: imageUrl
                            });
                            return {
                                linkage: linkage,
                                url: imageUrl
                            };
                        }
                }
            }
        } catch (error) {}
        return {
            linkage: linkage,
            url: null
        };
    }
    static async getEnsAddress(provider) {
        const network = await provider.getNetwork();
        const ensPlugin = network.getPlugin("org.ethers.plugins.network.Ens");
        // No ENS...
        (0, $634aa51198273feb$export$a7a9523472993e97)(ensPlugin, "network does not support ENS", "UNSUPPORTED_OPERATION", {
            operation: "getEnsAddress",
            info: {
                network: network
            }
        });
        return ensPlugin.address;
    }
    static async #getResolver(provider, name) {
        const ensAddr = await $280d6641ec976e99$export$d04afd034a0a53ae.getEnsAddress(provider);
        try {
            const contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], provider);
            const addr = await contract.resolver((0, $574ce7342d53bcf4$export$91d651ee363e1209)(name), {
                enableCcipRead: true
            });
            if (addr === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            return addr;
        } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32),
            // so probably a link error
            throw error;
        }
        return null;
    }
    /**
     *  Resolve to the ENS resolver for %%name%% using %%provider%% or
     *  ``null`` if unconfigured.
     */ static async fromName(provider, name) {
        let currentName = name;
        while(true){
            if (currentName === "" || currentName === ".") return null;
            // Optimization since the eth node cannot change and does
            // not have a wildcard resolver
            if (name !== "eth" && currentName === "eth") return null;
            // Check the current node for a resolver
            const addr = await $280d6641ec976e99$export$d04afd034a0a53ae.#getResolver(provider, currentName);
            // Found a resolver!
            if (addr != null) {
                const resolver = new $280d6641ec976e99$export$d04afd034a0a53ae(provider, addr, name);
                // Legacy resolver found, using EIP-2544 so it isn't safe to use
                if (currentName !== name && !await resolver.supportsWildcard()) return null;
                return resolver;
            }
            // Get the parent node
            currentName = currentName.split(".").slice(1).join(".");
        }
    }
}


/**
 *  @_ignore
 */ 


function $ffd6543f65258923$export$769b627a7e45189e(tx) {
    const from = (0, $69ef3f917ff239a2$export$88411125f012957a)(tx.from);
    const nonce = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.nonce, "tx.nonce");
    let nonceHex = nonce.toString(16);
    if (nonceHex === "0") nonceHex = "0x";
    else if (nonceHex.length % 2) nonceHex = "0x0" + nonceHex;
    else nonceHex = "0x" + nonceHex;
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $caedcf6749fe63e5$export$aea7770274d28b7)([
        from,
        nonceHex
    ])), 12));
}
function $ffd6543f65258923$export$e0b22d96621f73a2(_from, _salt, _initCodeHash) {
    const from = (0, $69ef3f917ff239a2$export$88411125f012957a)(_from);
    const salt = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_salt, "salt");
    const initCodeHash = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(_initCodeHash, "initCodeHash");
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(salt.length === 32, "salt must be 32 bytes", "salt", _salt);
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(initCodeHash.length === 32, "initCodeHash must be 32 bytes", "initCodeHash", _initCodeHash);
    return (0, $69ef3f917ff239a2$export$88411125f012957a)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)((0, $9bdec2813ce7c52b$export$f8151fce47ad1c35)((0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
        "0xff",
        from,
        salt,
        initCodeHash
    ])), 12));
}





const $8c8b15350cbd9f48$var$BN_0 = BigInt(0);
function $8c8b15350cbd9f48$export$4b08254e38b74fcd(format, nullValue) {
    return function(value) {
        if (value == null) return nullValue;
        return format(value);
    };
}
function $8c8b15350cbd9f48$export$e57ff0f701c44363(format) {
    return (array)=>{
        if (!Array.isArray(array)) throw new Error("not an array");
        return array.map((i)=>format(i));
    };
}
function $8c8b15350cbd9f48$export$be5493f9613cbbe(format, altNames) {
    return (value)=>{
        const result = {};
        for(const key in format){
            let srcKey = key;
            if (altNames && key in altNames && !(srcKey in value)) {
                for (const altKey of altNames[key])if (altKey in value) {
                    srcKey = altKey;
                    break;
                }
            }
            try {
                const nv = format[key](value[srcKey]);
                if (nv !== undefined) result[key] = nv;
            } catch (error) {
                const message = error instanceof Error ? error.message : "not-an-error";
                (0, $634aa51198273feb$export$a7a9523472993e97)(false, `invalid value for value.${key} (${message})`, "BAD_DATA", {
                    value: value
                });
            }
        }
        return result;
    };
}
function $8c8b15350cbd9f48$export$7a3be81718959bda(value) {
    switch(value){
        case true:
        case "true":
            return true;
        case false:
        case "false":
            return false;
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `invalid boolean; ${JSON.stringify(value)}`, "value", value);
}
function $8c8b15350cbd9f48$export$1f26277db27165ba(value) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, true), "invalid data", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$bb5bc852e1c64b88(value) {
    (0, $634aa51198273feb$export$c3d31707e5030f5e)((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value, 32), "invalid hash", "value", value);
    return value;
}
function $8c8b15350cbd9f48$export$aff4fda55e7ac0d6(value) {
    if (!(0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
    return (0, $fd3872da8feed9cb$export$4473860254365feb)(value, 32);
}
const $8c8b15350cbd9f48$var$_formatLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    address: (0, $69ef3f917ff239a2$export$88411125f012957a),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    removed: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$7a3be81718959bda, false),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    transactionIndex: (0, $6fa405e57bb6371e$export$b14f2714108df84)
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$fccdbdc2b9d7893(value) {
    return $8c8b15350cbd9f48$var$_formatLog(value);
}
const $8c8b15350cbd9f48$var$_formatBlock = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    hash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    parentHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    number: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    timestamp: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    nonce: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    difficulty: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    gasLimit: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    gasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    miner: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a)),
    extraData: $8c8b15350cbd9f48$export$1f26277db27165ba,
    baseFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4))
});
function $8c8b15350cbd9f48$export$ba1152bc4017d62a(value) {
    const result = $8c8b15350cbd9f48$var$_formatBlock(value);
    result.transactions = value.transactions.map((tx)=>{
        if (typeof tx === "string") return tx;
        return $8c8b15350cbd9f48$export$fe50e42b325965d(tx);
    });
    return result;
}
const $8c8b15350cbd9f48$var$_formatReceiptLog = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    transactionIndex: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    transactionHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    address: (0, $69ef3f917ff239a2$export$88411125f012957a),
    topics: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$bb5bc852e1c64b88),
    data: $8c8b15350cbd9f48$export$1f26277db27165ba,
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88
}, {
    index: [
        "logIndex"
    ]
});
function $8c8b15350cbd9f48$export$5ec2fc59e0e92b87(value) {
    return $8c8b15350cbd9f48$var$_formatReceiptLog(value);
}
const $8c8b15350cbd9f48$var$_formatTransactionReceipt = $8c8b15350cbd9f48$export$be5493f9613cbbe({
    to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    from: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    contractAddress: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
    // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
    index: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    root: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)),
    gasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    logsBloom: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$1f26277db27165ba),
    blockHash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
    logs: $8c8b15350cbd9f48$export$e57ff0f701c44363($8c8b15350cbd9f48$export$5ec2fc59e0e92b87),
    blockNumber: (0, $6fa405e57bb6371e$export$b14f2714108df84),
    //confirmations: allowNull(getNumber, null),
    cumulativeGasUsed: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
    effectiveGasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
    status: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84)),
    type: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), 0)
}, {
    effectiveGasPrice: [
        "gasPrice"
    ],
    hash: [
        "transactionHash"
    ],
    index: [
        "transactionIndex"
    ]
});
function $8c8b15350cbd9f48$export$30da670e49d6fc31(value) {
    return $8c8b15350cbd9f48$var$_formatTransactionReceipt(value);
}
function $8c8b15350cbd9f48$export$fe50e42b325965d(value) {
    // Some clients (TestRPC) do strange things like return 0x0 for the
    // 0 address; correct this to be a real address
    if (value.to && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value.to) === $8c8b15350cbd9f48$var$BN_0) value.to = "0x0000000000000000000000000000000000000000";
    const result = $8c8b15350cbd9f48$export$be5493f9613cbbe({
        hash: $8c8b15350cbd9f48$export$bb5bc852e1c64b88,
        type: (value)=>{
            if (value === "0x" || value == null) return 0;
            return (0, $6fa405e57bb6371e$export$b14f2714108df84)(value);
        },
        accessList: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $c254de3831dd58ea$export$6c8662b1600dce2), null),
        blockHash: $8c8b15350cbd9f48$export$4b08254e38b74fcd($8c8b15350cbd9f48$export$bb5bc852e1c64b88, null),
        blockNumber: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), null),
        transactionIndex: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$b14f2714108df84), null),
        //confirmations: allowNull(getNumber, null),
        from: (0, $69ef3f917ff239a2$export$88411125f012957a),
        // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas) must be set
        gasPrice: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        maxPriorityFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        maxFeePerGas: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)),
        gasLimit: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
        to: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
        value: (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4),
        nonce: (0, $6fa405e57bb6371e$export$b14f2714108df84),
        data: $8c8b15350cbd9f48$export$1f26277db27165ba,
        creates: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $69ef3f917ff239a2$export$88411125f012957a), null),
        chainId: $8c8b15350cbd9f48$export$4b08254e38b74fcd((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4), null)
    }, {
        data: [
            "input"
        ],
        gasLimit: [
            "gas"
        ]
    })(value);
    // If to and creates are empty, populate the creates from the value
    if (result.to == null && result.creates == null) result.creates = (0, $ffd6543f65258923$export$769b627a7e45189e)(result);
    // @TODO: Check fee data
    // Add an access list to supported transaction types
    if ((value.type === 1 || value.type === 2) && value.accessList == null) result.accessList = [];
    // Compute the signature
    if (value.signature) result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value.signature);
    else result.signature = (0, $b48bc2308ad845a5$export$848620f5f2f26e86).from(value);
    // Some backends omit ChainId on legacy transactions, but we can compute it
    if (result.chainId == null) {
        const chainId = result.signature.legacyChainId;
        if (chainId != null) result.chainId = chainId;
    }
    // @TODO: check chainID
    /*
    if (value.chainId != null) {
        let chainId = value.chainId;

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        result.chainId = chainId;

    } else {
        let chainId = value.networkId;

        // geth-etc returns chainId
        if (chainId == null && result.v == null) {
            chainId = value.chainId;
        }

        if (isHexString(chainId)) {
            chainId = BigNumber.from(chainId).toNumber();
        }

        if (typeof(chainId) !== "number" && result.v != null) {
            chainId = (result.v - 35) / 2;
            if (chainId < 0) { chainId = 0; }
            chainId = parseInt(chainId);
        }

        if (typeof(chainId) !== "number") { chainId = 0; }

        result.chainId = chainId;
    }
    */ // 0x0000... should actually be null
    if (result.blockHash && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(result.blockHash) === $8c8b15350cbd9f48$var$BN_0) result.blockHash = null;
    return result;
}


/**
 *  A **Network** encapsulates the various properties required to
 *  interact with a specific chain.
 *
 *  @_subsection: api/providers:Networks  [networks]
 */ 



const $86932e930ca5c8a5$var$EnsAddress = "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e";
class $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The name of the plugin.
     *
     *  It is recommended to use reverse-domain-notation, which permits
     *  unique names with a known authority as well as hierarchal entries.
     */ name;
    /**
     *  Creates a new **NetworkPlugin**.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    /**
     *  Creates a copy of this plugin.
     */ clone() {
        return new $86932e930ca5c8a5$export$10ae60faeb7e2196(this.name);
    }
}
class $86932e930ca5c8a5$export$f2b0810a2dd50377 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The block number to treat these values as valid from.
     *
     *  This allows a hardfork to have updated values included as well as
     *  mulutiple hardforks to be supported.
     */ effectiveBlock;
    /**
     *  The transactions base fee.
     */ txBase;
    /**
     *  The fee for creating a new account.
     */ txCreate;
    /**
     *  The fee per zero-byte in the data.
     */ txDataZero;
    /**
     *  The fee per non-zero-byte in the data.
     */ txDataNonzero;
    /**
     *  The fee per storage key in the [[link-eip-2930]] access list.
     */ txAccessListStorageKey;
    /**
     *  The fee per address in the [[link-eip-2930]] access list.
     */ txAccessListAddress;
    /**
     *  Creates a new GasCostPlugin from %%effectiveBlock%% until the
     *  latest block or another GasCostPlugin supercedes that block number,
     *  with the associated %%costs%%.
     */ constructor(effectiveBlock, costs){
        if (effectiveBlock == null) effectiveBlock = 0;
        super(`org.ethers.network.plugins.GasCost#${effectiveBlock || 0}`);
        const props = {
            effectiveBlock: effectiveBlock
        };
        function set(name, nullish) {
            let value = (costs || {})[name];
            if (value == null) value = nullish;
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof value === "number", `invalud value for ${name}`, "costs", costs);
            props[name] = value;
        }
        set("txBase", 21000);
        set("txCreate", 32000);
        set("txDataZero", 4);
        set("txDataNonzero", 16);
        set("txAccessListStorageKey", 1900);
        set("txAccessListAddress", 2400);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, props);
    }
    clone() {
        return new $86932e930ca5c8a5$export$f2b0810a2dd50377(this.effectiveBlock, this);
    }
}
class $86932e930ca5c8a5$export$9be0b2c573890879 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    /**
     *  The ENS Registrty Contract address.
     */ address;
    /**
     *  The chain ID that the ENS contract lives on.
     */ targetNetwork;
    /**
     *  Creates a new **EnsPlugin** connected to %%address%% on the
     *  %%targetNetwork%%. The default ENS address and mainnet is used
     *  if unspecified.
     */ constructor(address, targetNetwork){
        super("org.ethers.plugins.network.Ens");
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address || $86932e930ca5c8a5$var$EnsAddress,
            targetNetwork: targetNetwork == null ? 1 : targetNetwork
        });
    }
    clone() {
        return new $86932e930ca5c8a5$export$9be0b2c573890879(this.address, this.targetNetwork);
    }
}
class $86932e930ca5c8a5$export$dd49482b7e9ea2da extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #feeDataFunc;
    /**
     *  The fee data function provided to the constructor.
     */ get feeDataFunc() {
        return this.#feeDataFunc;
    }
    /**
     *  Creates a new **FeeDataNetworkPlugin**.
     */ constructor(feeDataFunc){
        super("org.ethers.plugins.network.FeeData");
        this.#feeDataFunc = feeDataFunc;
    }
    /**
     *  Resolves to the fee data.
     */ async getFeeData(provider) {
        return await this.#feeDataFunc(provider);
    }
    clone() {
        return new $86932e930ca5c8a5$export$dd49482b7e9ea2da(this.#feeDataFunc);
    }
}
class $86932e930ca5c8a5$export$3bee30f9880d72e8 extends $86932e930ca5c8a5$export$10ae60faeb7e2196 {
    #url;
    #processFunc;
    /**
     *  The URL to initialize the FetchRequest with in %%processFunc%%.
     */ get url() {
        return this.#url;
    }
    /**
     *  The callback to use when computing the FeeData.
     */ get processFunc() {
        return this.#processFunc;
    }
    /**
     *  Creates a new **FetchUrlFeeDataNetworkPlugin** which will
     *  be used when computing the fee data for the network.
     */ constructor(url, processFunc){
        super("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        this.#url = url;
        this.#processFunc = processFunc;
    }
    // We are immutable, so we can serve as our own clone
    clone() {
        return this;
    }
} /*
export class CustomBlockNetworkPlugin extends NetworkPlugin {
    readonly #blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>;
    readonly #blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>;

    constructor(blockFunc: (provider: Provider, block: BlockParams<string>) => Block<string>, blockWithTxsFunc: (provider: Provider, block: BlockParams<TransactionResponseParams>) => Block<TransactionResponse>) {
        super("org.ethers.network-plugins.custom-block");
        this.#blockFunc = blockFunc;
        this.#blockWithTxsFunc = blockWithTxsFunc;
    }

    async getBlock(provider: Provider, block: BlockParams<string>): Promise<Block<string>> {
        return await this.#blockFunc(provider, block);
    }

    async getBlockions(provider: Provider, block: BlockParams<TransactionResponseParams>): Promise<Block<TransactionResponse>> {
        return await this.#blockWithTxsFunc(provider, block);
    }

    clone(): CustomBlockNetworkPlugin {
        return new CustomBlockNetworkPlugin(this.#blockFunc, this.#blockWithTxsFunc);
    }
}
*/ 


/* * * *
// Networks which operation against an L2 can use this plugin to
// specify how to access L1, for the purpose of resolving ENS,
// for example.
export class LayerOneConnectionPlugin extends NetworkPlugin {
    readonly provider!: Provider;
// @TODO: Rename to ChainAccess and allow for connecting to any chain
    constructor(provider: Provider) {
        super("org.ethers.plugins.layer-one-connection");
        defineProperties<LayerOneConnectionPlugin>(this, { provider });
    }

    clone(): LayerOneConnectionPlugin {
        return new LayerOneConnectionPlugin(this.provider);
    }
}
*/ const $4945f77db30f37e3$var$Networks = new Map();
class $4945f77db30f37e3$export$95be4ae94445245a {
    #name;
    #chainId;
    #plugins;
    /**
     *  Creates a new **Network** for %%name%% and %%chainId%%.
     */ constructor(name, chainId){
        this.#name = name;
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(chainId);
        this.#plugins = new Map();
    }
    /**
     *  Returns a JSON-compatible representation of a Network.
     */ toJSON() {
        return {
            name: this.name,
            chainId: String(this.chainId)
        };
    }
    /**
     *  The network common name.
     *
     *  This is the canonical name, as networks migh have multiple
     *  names.
     */ get name() {
        return this.#name;
    }
    set name(value) {
        this.#name = value;
    }
    /**
     *  The network chain ID.
     */ get chainId() {
        return this.#chainId;
    }
    set chainId(value) {
        this.#chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(value, "chainId");
    }
    /**
     *  Returns true if %%other%% matches this network. Any chain ID
     *  must match, and if no chain ID is present, the name must match.
     *
     *  This method does not currently check for additional properties,
     *  such as ENS address or plug-in compatibility.
     */ matches(other) {
        if (other == null) return false;
        if (typeof other === "string") {
            try {
                return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return this.name === other;
        }
        if (typeof other === "number" || typeof other === "bigint") {
            try {
                return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other);
            } catch (error) {}
            return false;
        }
        if (typeof other === "object") {
            if (other.chainId != null) {
                try {
                    return this.chainId === (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(other.chainId);
                } catch (error) {}
                return false;
            }
            if (other.name != null) return this.name === other.name;
            return false;
        }
        return false;
    }
    /**
     *  Returns the list of plugins currently attached to this Network.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new %%plugin%% to this Network. The network name
     *  must be unique, excluding any fragment.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.clone());
        return this;
    }
    /**
     *  Return the plugin, if any, matching %%name%% exactly. Plugins
     *  with fragments will not be returned unless %%name%% includes
     *  a fragment.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Gets a list of all plugins that match %%name%%, with otr without
     *  a fragment.
     */ getPlugins(basename) {
        return this.plugins.filter((p)=>p.name.split("#")[0] === basename);
    }
    /**
     *  Create a copy of this Network.
     */ clone() {
        const clone = new $4945f77db30f37e3$export$95be4ae94445245a(this.name, this.chainId);
        this.plugins.forEach((plugin)=>{
            clone.attachPlugin(plugin.clone());
        });
        return clone;
    }
    /**
     *  Compute the intrinsic gas required for a transaction.
     *
     *  A GasCostPlugin can be attached to override the default
     *  values.
     */ computeIntrinsicGas(tx) {
        const costs = this.getPlugin("org.ethers.plugins.network.GasCost") || new (0, $86932e930ca5c8a5$export$f2b0810a2dd50377)();
        let gas = costs.txBase;
        if (tx.to == null) gas += costs.txCreate;
        if (tx.data) {
            for(let i = 2; i < tx.data.length; i += 2)if (tx.data.substring(i, i + 2) === "00") gas += costs.txDataZero;
            else gas += costs.txDataNonzero;
        }
        if (tx.accessList) {
            const accessList = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(tx.accessList);
            for(const addr in accessList)gas += costs.txAccessListAddress + costs.txAccessListStorageKey * accessList[addr].storageKeys.length;
        }
        return gas;
    }
    /**
     *  Returns a new Network for the %%network%% name or chainId.
     */ static from(network) {
        $4945f77db30f37e3$var$injectCommonNetworks();
        // Default network
        if (network == null) return $4945f77db30f37e3$export$95be4ae94445245a.from("mainnet");
        // Canonical name or chain ID
        if (typeof network === "number") network = BigInt(network);
        if (typeof network === "string" || typeof network === "bigint") {
            const networkFunc = $4945f77db30f37e3$var$Networks.get(network);
            if (networkFunc) return networkFunc();
            if (typeof network === "bigint") return new $4945f77db30f37e3$export$95be4ae94445245a("unknown", network);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown network", "network", network);
        }
        // Clonable with network-like abilities
        if (typeof network.clone === "function") {
            const clone = network.clone();
            //if (typeof(network.name) !== "string" || typeof(network.chainId) !== "number") {
            //}
            return clone;
        }
        // Networkish
        if (typeof network === "object") {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(typeof network.name === "string" && typeof network.chainId === "number", "invalid network object name or chainId", "network", network);
            const custom = new $4945f77db30f37e3$export$95be4ae94445245a(network.name, network.chainId);
            if (network.ensAddress || network.ensNetwork != null) custom.attachPlugin(new (0, $86932e930ca5c8a5$export$9be0b2c573890879)(network.ensAddress, network.ensNetwork));
            //if ((<any>network).layerOneConnection) {
            //    custom.attachPlugin(new LayerOneConnectionPlugin((<any>network).layerOneConnection));
            //}
            return custom;
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid network", "network", network);
    }
    /**
     *  Register %%nameOrChainId%% with a function which returns
     *  an instance of a Network representing that chain.
     */ static register(nameOrChainId, networkFunc) {
        if (typeof nameOrChainId === "number") nameOrChainId = BigInt(nameOrChainId);
        const existing = $4945f77db30f37e3$var$Networks.get(nameOrChainId);
        if (existing) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, `conflicting network for ${JSON.stringify(existing.name)}`, "nameOrChainId", nameOrChainId);
        $4945f77db30f37e3$var$Networks.set(nameOrChainId, networkFunc);
    }
}
// We don't want to bring in formatUnits because it is backed by
// FixedNumber and we want to keep Networks tiny. The values
// included by the Gas Stations are also IEEE 754 with lots of
// rounding issues and exceed the strict checks formatUnits has.
function $4945f77db30f37e3$var$parseUnits(_value, decimals) {
    const value = String(_value);
    if (!value.match(/^[0-9.]+$/)) throw new Error(`invalid gwei value: ${_value}`);
    // Break into [ whole, fraction ]
    const comps = value.split(".");
    if (comps.length === 1) comps.push("");
    // More than 1 decimal point or too many fractional positions
    if (comps.length !== 2) throw new Error(`invalid gwei value: ${_value}`);
    // Pad the fraction to 9 decimalplaces
    while(comps[1].length < decimals)comps[1] += "0";
    // Too many decimals and some non-zero ending, take the ceiling
    if (comps[1].length > 9) {
        let frac = BigInt(comps[1].substring(0, 9));
        if (!comps[1].substring(9).match(/^0+$/)) frac++;
        comps[1] = frac.toString();
    }
    return BigInt(comps[0] + comps[1]);
}
// Used by Polygon to use a gas station for fee data
function $4945f77db30f37e3$var$getGasStationPlugin(url) {
    return new (0, $86932e930ca5c8a5$export$3bee30f9880d72e8)(url, async (fetchFeeData, provider, request)=>{
        // Prevent Cloudflare from blocking our request in node.js
        request.setHeader("User-Agent", "ethers");
        let response;
        try {
            const [_response, _feeData] = await Promise.all([
                request.send(),
                fetchFeeData()
            ]);
            response = _response;
            const payload = response.bodyJson.standard;
            const feeData = {
                gasPrice: _feeData.gasPrice,
                maxFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxFee, 9),
                maxPriorityFeePerGas: $4945f77db30f37e3$var$parseUnits(payload.maxPriorityFee, 9)
            };
            return feeData;
        } catch (error) {
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `error encountered with polygon gas station (${JSON.stringify(request.url)})`, "SERVER_ERROR", {
                request: request,
                response: response,
                error: error
            });
        }
    });
}
// Used by Optimism for a custom priority fee
function $4945f77db30f37e3$var$getPriorityFeePlugin(maxPriorityFeePerGas) {
    return new (0, $86932e930ca5c8a5$export$3bee30f9880d72e8)("data:", async (fetchFeeData, provider, request)=>{
        const feeData = await fetchFeeData();
        // This should always fail
        if (feeData.maxFeePerGas == null || feeData.maxPriorityFeePerGas == null) return feeData;
        // Compute the corrected baseFee to recompute the updated values
        const baseFee = feeData.maxFeePerGas - feeData.maxPriorityFeePerGas;
        return {
            gasPrice: feeData.gasPrice,
            maxFeePerGas: baseFee + maxPriorityFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    });
}
// See: https://chainlist.org
let $4945f77db30f37e3$var$injected = false;
function $4945f77db30f37e3$var$injectCommonNetworks() {
    if ($4945f77db30f37e3$var$injected) return;
    $4945f77db30f37e3$var$injected = true;
    /// Register popular Ethereum networks
    function registerEth(name, chainId, options) {
        const func = function() {
            const network = new $4945f77db30f37e3$export$95be4ae94445245a(name, chainId);
            // We use 0 to disable ENS
            if (options.ensNetwork != null) network.attachPlugin(new (0, $86932e930ca5c8a5$export$9be0b2c573890879)(null, options.ensNetwork));
            network.attachPlugin(new (0, $86932e930ca5c8a5$export$f2b0810a2dd50377)());
            (options.plugins || []).forEach((plugin)=>{
                network.attachPlugin(plugin);
            });
            return network;
        };
        // Register the network by name and chain ID
        $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        $4945f77db30f37e3$export$95be4ae94445245a.register(chainId, func);
        if (options.altNames) options.altNames.forEach((name)=>{
            $4945f77db30f37e3$export$95be4ae94445245a.register(name, func);
        });
    }
    registerEth("mainnet", 1, {
        ensNetwork: 1,
        altNames: [
            "homestead"
        ]
    });
    registerEth("ropsten", 3, {
        ensNetwork: 3
    });
    registerEth("rinkeby", 4, {
        ensNetwork: 4
    });
    registerEth("goerli", 5, {
        ensNetwork: 5
    });
    registerEth("kovan", 42, {
        ensNetwork: 42
    });
    registerEth("sepolia", 11155111, {});
    registerEth("classic", 61, {});
    registerEth("classicKotti", 6, {});
    registerEth("arbitrum", 42161, {
        ensNetwork: 1
    });
    registerEth("arbitrum-goerli", 421613, {});
    registerEth("bnb", 56, {
        ensNetwork: 1
    });
    registerEth("bnbt", 97, {});
    registerEth("linea", 59144, {
        ensNetwork: 1
    });
    registerEth("linea-goerli", 59140, {});
    registerEth("matic", 137, {
        ensNetwork: 1,
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gasstation.polygon.technology/v2")
        ]
    });
    registerEth("matic-mumbai", 80001, {
        altNames: [
            "maticMumbai",
            "maticmum"
        ],
        plugins: [
            $4945f77db30f37e3$var$getGasStationPlugin("https://gasstation-testnet.polygon.technology/v2")
        ]
    });
    registerEth("optimism", 10, {
        ensNetwork: 1,
        plugins: [
            $4945f77db30f37e3$var$getPriorityFeePlugin(BigInt("1000000"))
        ]
    });
    registerEth("optimism-goerli", 420, {});
    registerEth("xdai", 100, {
        ensNetwork: 1
    });
}




function $f484c23113a92e9e$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
function $f484c23113a92e9e$export$c1d4f1f6d1988b77(provider, event) {
    if (event === "block") return new $f484c23113a92e9e$export$aaf796a16ac1a157(provider);
    if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(event, 32)) return new $f484c23113a92e9e$export$4fe8a9740765f97e(provider, event);
    (0, $634aa51198273feb$export$a7a9523472993e97)(false, "unsupported polling event", "UNSUPPORTED_OPERATION", {
        operation: "getPollingSubscriber",
        info: {
            event: event
        }
    });
}
class $f484c23113a92e9e$export$aaf796a16ac1a157 {
    #provider;
    #poller;
    #interval;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#poller = null;
        this.#interval = 4000;
        this.#blockNumber = -2;
    }
    /**
     *  The polling interval.
     */ get pollingInterval() {
        return this.#interval;
    }
    set pollingInterval(value) {
        this.#interval = value;
    }
    async #poll() {
        try {
            const blockNumber = await this.#provider.getBlockNumber();
            // Bootstrap poll to setup our initial block number
            if (this.#blockNumber === -2) {
                this.#blockNumber = blockNumber;
                return;
            }
            // @TODO: Put a cap on the maximum number of events per loop?
            if (blockNumber !== this.#blockNumber) {
                for(let b = this.#blockNumber + 1; b <= blockNumber; b++){
                    // We have been stopped
                    if (this.#poller == null) return;
                    await this.#provider.emit("block", b);
                }
                this.#blockNumber = blockNumber;
            }
        } catch (error) {
        // @TODO: Minor bump, add an "error" event to let subscribers
        //        know things went awry.
        //console.log(error);
        }
        // We have been stopped
        if (this.#poller == null) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
    }
    start() {
        if (this.#poller) return;
        this.#poller = this.#provider._setTimeout(this.#poll.bind(this), this.#interval);
        this.#poll();
    }
    stop() {
        if (!this.#poller) return;
        this.#provider._clearTimeout(this.#poller);
        this.#poller = null;
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #provider;
    #poll;
    #running;
    /**
     *  Create a new **OnBlockSubscriber** attached to %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#running = false;
        this.#poll = (blockNumber)=>{
            this._poll(blockNumber, this.#provider);
        };
    }
    /**
     *  Called on every new block.
     */ async _poll(blockNumber, provider) {
        throw new Error("sub-classes must override this");
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
        this.#provider.on("block", this.#poll);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poll);
    }
    pause(dropWhilePaused) {
        this.stop();
    }
    resume() {
        this.start();
    }
}
class $f484c23113a92e9e$export$e4ed5c6414dc4e9e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #filter;
    constructor(provider, filter){
        super(provider);
        this.#filter = $f484c23113a92e9e$var$copy(filter);
    }
    async _poll(blockNumber, provider) {
        throw new Error("@TODO");
    }
}
class $f484c23113a92e9e$export$4fe8a9740765f97e extends $f484c23113a92e9e$export$e8024646c9bd1a27 {
    #hash;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%hash%%.
     */ constructor(provider, hash){
        super(provider);
        this.#hash = hash;
    }
    async _poll(blockNumber, provider) {
        const tx = await provider.getTransactionReceipt(this.#hash);
        if (tx) provider.emit(this.#hash, tx);
    }
}
class $f484c23113a92e9e$export$bdb759dc2fe68c72 {
    #provider;
    #filter;
    #poller;
    #running;
    // The most recent block we have scanned for events. The value -2
    // indicates we still need to fetch an initial block number
    #blockNumber;
    /**
     *  Create a new **PollingTransactionSubscriber** attached to
     *  %%provider%%, listening for %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = $f484c23113a92e9e$var$copy(filter);
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#blockNumber = -2;
    }
    async #poll(blockNumber) {
        // The initial block hasn't been determined yet
        if (this.#blockNumber === -2) return;
        const filter = $f484c23113a92e9e$var$copy(this.#filter);
        filter.fromBlock = this.#blockNumber + 1;
        filter.toBlock = blockNumber;
        const logs = await this.#provider.getLogs(filter);
        // No logs could just mean the node has not indexed them yet,
        // so we keep a sliding window of 60 blocks to keep scanning
        if (logs.length === 0) {
            if (this.#blockNumber < blockNumber - 60) this.#blockNumber = blockNumber - 60;
            return;
        }
        for (const log of logs){
            this.#provider.emit(this.#filter, log);
            // Only advance the block number when logs were found to
            // account for networks (like BNB and Polygon) which may
            // sacrifice event consistency for block event speed
            this.#blockNumber = log.blockNumber;
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        if (this.#blockNumber === -2) this.#provider.getBlockNumber().then((blockNumber)=>{
            this.#blockNumber = blockNumber;
        });
        this.#provider.on("block", this.#poller);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        this.stop();
        if (dropWhilePaused) this.#blockNumber = -2;
    }
    resume() {
        this.start();
    }
}


// Constants
const $a447d5c12fd5aa4c$var$BN_2 = BigInt(2);
const $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS = 10;
function $a447d5c12fd5aa4c$var$isPromise(value) {
    return value && typeof value.then === "function";
}
function $a447d5c12fd5aa4c$var$getTag(prefix, value) {
    return prefix + ":" + JSON.stringify(value, (k, v)=>{
        if (v == null) return "null";
        if (typeof v === "bigint") return `bigint:${v.toString()}`;
        if (typeof v === "string") return v.toLowerCase();
        // Sort object keys
        if (typeof v === "object" && !Array.isArray(v)) {
            const keys = Object.keys(v);
            keys.sort();
            return keys.reduce((accum, key)=>{
                accum[key] = v[key];
                return accum;
            }, {});
        }
        return v;
    });
}
class $a447d5c12fd5aa4c$export$f255b979f86248fa {
    /**
     *  The name fof the event.
     */ name;
    /**
     *  Create a new UnmanagedSubscriber with %%name%%.
     */ constructor(name){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            name: name
        });
    }
    start() {}
    stop() {}
    pause(dropWhilePaused) {}
    resume() {}
}
function $a447d5c12fd5aa4c$var$copy(value) {
    return JSON.parse(JSON.stringify(value));
}
function $a447d5c12fd5aa4c$var$concisify(items) {
    items = Array.from(new Set(items).values());
    items.sort();
    return items;
}
async function $a447d5c12fd5aa4c$var$getSubscription(_event, provider) {
    if (_event == null) throw new Error("invalid event");
    // Normalize topic array info an EventFilter
    if (Array.isArray(_event)) _event = {
        topics: _event
    };
    if (typeof _event === "string") switch(_event){
        case "block":
        case "pending":
        case "debug":
        case "error":
        case "network":
            return {
                type: _event,
                tag: _event
            };
    }
    if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(_event, 32)) {
        const hash = _event.toLowerCase();
        return {
            type: "transaction",
            tag: $a447d5c12fd5aa4c$var$getTag("tx", {
                hash: hash
            }),
            hash: hash
        };
    }
    if (_event.orphan) {
        const event = _event;
        // @TODO: Should lowercase and whatnot things here instead of copy...
        return {
            type: "orphan",
            tag: $a447d5c12fd5aa4c$var$getTag("orphan", event),
            filter: $a447d5c12fd5aa4c$var$copy(event)
        };
    }
    if (_event.address || _event.topics) {
        const event = _event;
        const filter = {
            topics: (event.topics || []).map((t)=>{
                if (t == null) return null;
                if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
                return t.toLowerCase();
            })
        };
        if (event.address) {
            const addresses = [];
            const promises = [];
            const addAddress = (addr)=>{
                if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(addr)) addresses.push(addr);
                else promises.push((async ()=>{
                    addresses.push(await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(addr, provider));
                })());
            };
            if (Array.isArray(event.address)) event.address.forEach(addAddress);
            else addAddress(event.address);
            if (promises.length) await Promise.all(promises);
            filter.address = $a447d5c12fd5aa4c$var$concisify(addresses.map((a)=>a.toLowerCase()));
        }
        return {
            filter: filter,
            tag: $a447d5c12fd5aa4c$var$getTag("event", filter),
            type: "event"
        };
    }
    (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "unknown ProviderEvent", "event", _event);
}
function $a447d5c12fd5aa4c$var$getTime() {
    return new Date().getTime();
}
const $a447d5c12fd5aa4c$var$defaultOptions = {
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $a447d5c12fd5aa4c$export$ae9650e85fb229fe {
    #subs;
    #plugins;
    // null=unpaused, true=paused+dropWhilePaused, false=paused
    #pausedState;
    #destroyed;
    #networkPromise;
    #anyNetwork;
    #performCache;
    // The most recent block number if running an event or -1 if no "block" event
    #lastBlockNumber;
    #nextTimer;
    #timers;
    #disableCcipRead;
    #options;
    /**
     *  Create a new **AbstractProvider** connected to %%network%%, or
     *  use the various network detection capabilities to discover the
     *  [[Network]] if necessary.
     */ constructor(_network, options){
        this.#options = Object.assign({}, $a447d5c12fd5aa4c$var$defaultOptions, options || {});
        if (_network === "any") {
            this.#anyNetwork = true;
            this.#networkPromise = null;
        } else if (_network) {
            const network = (0, $4945f77db30f37e3$export$95be4ae94445245a).from(_network);
            this.#anyNetwork = false;
            this.#networkPromise = Promise.resolve(network);
            setTimeout(()=>{
                this.emit("network", network, null);
            }, 0);
        } else {
            this.#anyNetwork = false;
            this.#networkPromise = null;
        }
        this.#lastBlockNumber = -1;
        this.#performCache = new Map();
        this.#subs = new Map();
        this.#plugins = new Map();
        this.#pausedState = null;
        this.#destroyed = false;
        this.#nextTimer = 1;
        this.#timers = new Map();
        this.#disableCcipRead = false;
    }
    get pollingInterval() {
        return this.#options.pollingInterval;
    }
    /**
     *  Returns ``this``, to allow an **AbstractProvider** to implement
     *  the [[ContractRunner]] interface.
     */ get provider() {
        return this;
    }
    /**
     *  Returns all the registered plug-ins.
     */ get plugins() {
        return Array.from(this.#plugins.values());
    }
    /**
     *  Attach a new plug-in.
     */ attachPlugin(plugin) {
        if (this.#plugins.get(plugin.name)) throw new Error(`cannot replace existing plugin: ${plugin.name} `);
        this.#plugins.set(plugin.name, plugin.connect(this));
        return this;
    }
    /**
     *  Get a plugin by name.
     */ getPlugin(name) {
        return this.#plugins.get(name) || null;
    }
    /**
     *  Prevent any CCIP-read operation, regardless of whether requested
     *  in a [[call]] using ``enableCcipRead``.
     */ get disableCcipRead() {
        return this.#disableCcipRead;
    }
    set disableCcipRead(value) {
        this.#disableCcipRead = !!value;
    }
    // Shares multiple identical requests made during the same 250ms
    async #perform(req) {
        const timeout = this.#options.cacheTimeout;
        // Caching disabled
        if (timeout < 0) return await this._perform(req);
        // Create a tag
        const tag = $a447d5c12fd5aa4c$var$getTag(req.method, req);
        let perform = this.#performCache.get(tag);
        if (!perform) {
            perform = this._perform(req);
            this.#performCache.set(tag, perform);
            setTimeout(()=>{
                if (this.#performCache.get(tag) === perform) this.#performCache.delete(tag);
            }, timeout);
        }
        return await perform;
    }
    /**
     *  Resolves to the data for executing the CCIP-read operations.
     */ async ccipReadFetch(tx, calldata, urls) {
        if (this.disableCcipRead || urls.length === 0 || tx.to == null) return null;
        const sender = tx.to.toLowerCase();
        const data = calldata.toLowerCase();
        const errorMessages = [];
        for(let i = 0; i < urls.length; i++){
            const url = urls[i];
            // URL expansion
            const href = url.replace("{sender}", sender).replace("{data}", data);
            // If no {data} is present, use POST; otherwise GET
            //const json: string | null = (url.indexOf("{data}") >= 0) ? null: JSON.stringify({ data, sender });
            //const result = await fetchJson({ url: href, errorPassThrough: true }, json, (value, response) => {
            //    value.status = response.statusCode;
            //    return value;
            //});
            const request = new (0, $2cb10defc4f72334$export$319b96fe59834522)(href);
            if (url.indexOf("{data}") === -1) request.body = {
                data: data,
                sender: sender
            };
            this.emit("debug", {
                action: "sendCcipReadFetchRequest",
                request: request,
                index: i,
                urls: urls
            });
            let errorMessage = "unknown error";
            const resp = await request.send();
            try {
                const result = resp.bodyJson;
                if (result.data) {
                    this.emit("debug", {
                        action: "receiveCcipReadFetchResult",
                        request: request,
                        result: result
                    });
                    return result.data;
                }
                if (result.message) errorMessage = result.message;
                this.emit("debug", {
                    action: "receiveCcipReadFetchError",
                    request: request,
                    result: result
                });
            } catch (error) {}
            // 4xx indicates the result is not present; stop
            (0, $634aa51198273feb$export$a7a9523472993e97)(resp.statusCode < 400 || resp.statusCode >= 500, `response not found during CCIP fetch: ${errorMessage}`, "OFFCHAIN_FAULT", {
                reason: "404_MISSING_RESOURCE",
                transaction: tx,
                info: {
                    url: url,
                    errorMessage: errorMessage
                }
            });
            // 5xx indicates server issue; try the next url
            errorMessages.push(errorMessage);
        }
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, "OFFCHAIN_FAULT", {
            reason: "500_SERVER_ERROR",
            transaction: tx,
            info: {
                urls: urls,
                errorMessages: errorMessages
            }
        });
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a block before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Block]].
     */ _wrapBlock(value, network) {
        return new (0, $425e3311db5fb4d1$export$d96a8827a60d6b69)((0, $8c8b15350cbd9f48$export$ba1152bc4017d62a)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a log before
     *  returning it, to add additional properties or an alternate
     *  sub-class of [[Log]].
     */ _wrapLog(value, network) {
        return new (0, $425e3311db5fb4d1$export$ce30dbb46644d06c)((0, $8c8b15350cbd9f48$export$fccdbdc2b9d7893)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  receipt before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionReceipt]].
     */ _wrapTransactionReceipt(value, network) {
        return new (0, $425e3311db5fb4d1$export$375ffd5683aa5c1c)((0, $8c8b15350cbd9f48$export$30da670e49d6fc31)(value), this);
    }
    /**
     *  Provides the opportunity for a sub-class to wrap a transaction
     *  response before returning it, to add additional properties or an
     *  alternate sub-class of [[TransactionResponse]].
     */ _wrapTransactionResponse(tx, network) {
        return new (0, $425e3311db5fb4d1$export$70966cdb3bfc0785)((0, $8c8b15350cbd9f48$export$fe50e42b325965d)(tx), this);
    }
    /**
     *  Resolves to the Network, forcing a network detection using whatever
     *  technique the sub-class requires.
     *
     *  Sub-classes **must** override this.
     */ _detectNetwork() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "sub-classes must implement this", "UNSUPPORTED_OPERATION", {
            operation: "_detectNetwork"
        });
    }
    /**
     *  Sub-classes should use this to perform all built-in operations. All
     *  methods sanitizes and normalizes the values passed into this.
     *
     *  Sub-classes **must** override this.
     */ async _perform(req) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `unsupported method: ${req.method}`, "UNSUPPORTED_OPERATION", {
            operation: req.method,
            info: req
        });
    }
    // State
    async getBlockNumber() {
        const blockNumber = (0, $6fa405e57bb6371e$export$b14f2714108df84)(await this.#perform({
            method: "getBlockNumber"
        }), "%response");
        if (this.#lastBlockNumber >= 0) this.#lastBlockNumber = blockNumber;
        return blockNumber;
    }
    /**
     *  Returns or resolves to the address for %%address%%, resolving ENS
     *  names and [[Addressable]] objects and returning if already an
     *  address.
     */ _getAddress(address) {
        return (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(address, this);
    }
    /**
     *  Returns or resolves to a valid block tag for %%blockTag%%, resolving
     *  negative values and returning if already a valid block tag.
     */ _getBlockTag(blockTag) {
        if (blockTag == null) return "latest";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(blockTag)) {
            if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(blockTag, 32)) return blockTag;
            return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(blockTag);
        }
        if (typeof blockTag === "bigint") blockTag = (0, $6fa405e57bb6371e$export$b14f2714108df84)(blockTag, "blockTag");
        if (typeof blockTag === "number") {
            if (blockTag >= 0) return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(blockTag);
            if (this.#lastBlockNumber >= 0) return (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(this.#lastBlockNumber + blockTag);
            return this.getBlockNumber().then((b)=>(0, $6fa405e57bb6371e$export$d9c067986dbc68dd)(b + blockTag));
        }
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "invalid blockTag", "blockTag", blockTag);
    }
    /**
     *  Returns or resolves to a filter for %%filter%%, resolving any ENS
     *  names or [[Addressable]] object and returning if already a valid
     *  filter.
     */ _getFilter(filter) {
        // Create a canonical representation of the topics
        const topics = (filter.topics || []).map((t)=>{
            if (t == null) return null;
            if (Array.isArray(t)) return $a447d5c12fd5aa4c$var$concisify(t.map((t)=>t.toLowerCase()));
            return t.toLowerCase();
        });
        const blockHash = "blockHash" in filter ? filter.blockHash : undefined;
        const resolve = (_address, fromBlock, toBlock)=>{
            let address = undefined;
            switch(_address.length){
                case 0:
                    break;
                case 1:
                    address = _address[0];
                    break;
                default:
                    _address.sort();
                    address = _address;
            }
            if (blockHash) {
                if (fromBlock != null || toBlock != null) throw new Error("invalid filter");
            }
            const filter = {};
            if (address) filter.address = address;
            if (topics.length) filter.topics = topics;
            if (fromBlock) filter.fromBlock = fromBlock;
            if (toBlock) filter.toBlock = toBlock;
            if (blockHash) filter.blockHash = blockHash;
            return filter;
        };
        // Addresses could be async (ENS names or Addressables)
        let address = [];
        if (filter.address) {
            if (Array.isArray(filter.address)) for (const addr of filter.address)address.push(this._getAddress(addr));
            else address.push(this._getAddress(filter.address));
        }
        let fromBlock = undefined;
        if ("fromBlock" in filter) fromBlock = this._getBlockTag(filter.fromBlock);
        let toBlock = undefined;
        if ("toBlock" in filter) toBlock = this._getBlockTag(filter.toBlock);
        if (address.filter((a)=>typeof a !== "string").length || fromBlock != null && typeof fromBlock !== "string" || toBlock != null && typeof toBlock !== "string") return Promise.all([
            Promise.all(address),
            fromBlock,
            toBlock
        ]).then((result)=>{
            return resolve(result[0], result[1], result[2]);
        });
        return resolve(address, fromBlock, toBlock);
    }
    /**
     *  Returns or resovles to a transaction for %%request%%, resolving
     *  any ENS names or [[Addressable]] and returning if already a valid
     *  transaction.
     */ _getTransactionRequest(_request) {
        const request = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(_request);
        const promises = [];
        [
            "to",
            "from"
        ].forEach((key)=>{
            if (request[key] == null) return;
            const addr = (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(request[key]);
            if ($a447d5c12fd5aa4c$var$isPromise(addr)) promises.push(async function() {
                request[key] = await addr;
            }());
            else request[key] = addr;
        });
        if (request.blockTag != null) {
            const blockTag = this._getBlockTag(request.blockTag);
            if ($a447d5c12fd5aa4c$var$isPromise(blockTag)) promises.push(async function() {
                request.blockTag = await blockTag;
            }());
            else request.blockTag = blockTag;
        }
        if (promises.length) return async function() {
            await Promise.all(promises);
            return request;
        }();
        return request;
    }
    async getNetwork() {
        // No explicit network was set and this is our first time
        if (this.#networkPromise == null) {
            // Detect the current network (shared with all calls)
            const detectNetwork = this._detectNetwork().then((network)=>{
                this.emit("network", network, null);
                return network;
            }, (error)=>{
                // Reset the networkPromise on failure, so we will try again
                if (this.#networkPromise === detectNetwork) this.#networkPromise = null;
                throw error;
            });
            this.#networkPromise = detectNetwork;
            return (await detectNetwork).clone();
        }
        const networkPromise = this.#networkPromise;
        const [expected, actual] = await Promise.all([
            networkPromise,
            this._detectNetwork() // The actual connected network
        ]);
        if (expected.chainId !== actual.chainId) {
            if (this.#anyNetwork) {
                // The "any" network can change, so notify listeners
                this.emit("network", actual, expected);
                // Update the network if something else hasn't already changed it
                if (this.#networkPromise === networkPromise) this.#networkPromise = Promise.resolve(actual);
            } else // Otherwise, we do not allow changes to the underlying network
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, `network changed: ${expected.chainId} => ${actual.chainId} `, "NETWORK_ERROR", {
                event: "changed"
            });
        }
        return expected.clone();
    }
    async getFeeData() {
        const network = await this.getNetwork();
        const getFeeDataFunc = async ()=>{
            const { _block: _block, gasPrice: gasPrice } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
                _block: this.#getBlock("latest", false),
                gasPrice: (async ()=>{
                    try {
                        const gasPrice = await this.#perform({
                            method: "getGasPrice"
                        });
                        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(gasPrice, "%response");
                    } catch (error) {}
                    return null;
                })()
            });
            let maxFeePerGas = null;
            let maxPriorityFeePerGas = null;
            // These are the recommended EIP-1559 heuristics for fee data
            const block = this._wrapBlock(_block, network);
            if (block && block.baseFeePerGas) {
                maxPriorityFeePerGas = BigInt("1000000000");
                maxFeePerGas = block.baseFeePerGas * $a447d5c12fd5aa4c$var$BN_2 + maxPriorityFeePerGas;
            }
            return new (0, $425e3311db5fb4d1$export$116c49c1e2a96a78)(gasPrice, maxFeePerGas, maxPriorityFeePerGas);
        };
        // Check for a FeeDataNetWorkPlugin
        const plugin = network.getPlugin("org.ethers.plugins.network.FetchUrlFeeDataPlugin");
        if (plugin) {
            const req = new (0, $2cb10defc4f72334$export$319b96fe59834522)(plugin.url);
            const feeData = await plugin.processFunc(getFeeDataFunc, this, req);
            return new (0, $425e3311db5fb4d1$export$116c49c1e2a96a78)(feeData.gasPrice, feeData.maxFeePerGas, feeData.maxPriorityFeePerGas);
        }
        return await getFeeDataFunc();
    }
    async estimateGas(_tx) {
        let tx = this._getTransactionRequest(_tx);
        if ($a447d5c12fd5aa4c$var$isPromise(tx)) tx = await tx;
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.#perform({
            method: "estimateGas",
            transaction: tx
        }), "%response");
    }
    async #call(tx, blockTag, attempt) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(attempt < $a447d5c12fd5aa4c$var$MAX_CCIP_REDIRECTS, "CCIP read exceeded maximum redirections", "OFFCHAIN_FAULT", {
            reason: "TOO_MANY_REDIRECTS",
            transaction: Object.assign({}, tx, {
                blockTag: blockTag,
                enableCcipRead: true
            })
        });
        // This came in as a PerformActionTransaction, so to/from are safe; we can cast
        const transaction = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(tx);
        try {
            return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this._perform({
                method: "call",
                transaction: transaction,
                blockTag: blockTag
            }));
        } catch (error) {
            // CCIP Read OffchainLookup
            if (!this.disableCcipRead && (0, $634aa51198273feb$export$748c4fa78f31ff35)(error) && error.data && attempt >= 0 && blockTag === "latest" && transaction.to != null && (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(error.data, 0, 4) === "0x556f1830") {
                const data = error.data;
                const txSender = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(transaction.to, this);
                // Parse the CCIP Read Arguments
                let ccipArgs;
                try {
                    ccipArgs = $a447d5c12fd5aa4c$var$parseOffchainLookup((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(error.data, 4));
                } catch (error) {
                    (0, $634aa51198273feb$export$a7a9523472993e97)(false, error.message, "OFFCHAIN_FAULT", {
                        reason: "BAD_DATA",
                        transaction: transaction,
                        info: {
                            data: data
                        }
                    });
                }
                // Check the sender of the OffchainLookup matches the transaction
                (0, $634aa51198273feb$export$a7a9523472993e97)(ccipArgs.sender.toLowerCase() === txSender.toLowerCase(), "CCIP Read sender mismatch", "CALL_EXCEPTION", {
                    action: "call",
                    data: data,
                    reason: "OffchainLookup",
                    transaction: transaction,
                    invocation: null,
                    revert: {
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        name: "OffchainLookup",
                        args: ccipArgs.errorArgs
                    }
                });
                const ccipResult = await this.ccipReadFetch(transaction, ccipArgs.calldata, ccipArgs.urls);
                (0, $634aa51198273feb$export$a7a9523472993e97)(ccipResult != null, "CCIP Read failed to fetch data", "OFFCHAIN_FAULT", {
                    reason: "FETCH_FAILED",
                    transaction: transaction,
                    info: {
                        data: error.data,
                        errorArgs: ccipArgs.errorArgs
                    }
                });
                const tx = {
                    to: txSender,
                    data: (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)([
                        ccipArgs.selector,
                        $a447d5c12fd5aa4c$var$encodeBytes([
                            ccipResult,
                            ccipArgs.extraData
                        ])
                    ])
                };
                this.emit("debug", {
                    action: "sendCcipReadCall",
                    transaction: tx
                });
                try {
                    const result = await this.#call(tx, blockTag, attempt + 1);
                    this.emit("debug", {
                        action: "receiveCcipReadCallResult",
                        transaction: Object.assign({}, tx),
                        result: result
                    });
                    return result;
                } catch (error) {
                    this.emit("debug", {
                        action: "receiveCcipReadCallError",
                        transaction: Object.assign({}, tx),
                        error: error
                    });
                    throw error;
                }
            }
            throw error;
        }
    }
    async #checkNetwork(promise) {
        const { value: value } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            value: promise
        });
        return value;
    }
    async call(_tx) {
        const { tx: tx, blockTag: blockTag } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            tx: this._getTransactionRequest(_tx),
            blockTag: this._getBlockTag(_tx.blockTag)
        });
        return await this.#checkNetwork(this.#call(tx, blockTag, _tx.enableCcipRead ? 0 : -1));
    }
    // Account
    async #getAccountValue(request, _address, _blockTag) {
        let address = this._getAddress(_address);
        let blockTag = this._getBlockTag(_blockTag);
        if (typeof address !== "string" || typeof blockTag !== "string") [address, blockTag] = await Promise.all([
            address,
            blockTag
        ]);
        return await this.#checkNetwork(this.#perform(Object.assign(request, {
            address: address,
            blockTag: blockTag
        })));
    }
    async getBalance(address, blockTag) {
        return (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.#getAccountValue({
            method: "getBalance"
        }, address, blockTag), "%response");
    }
    async getTransactionCount(address, blockTag) {
        return (0, $6fa405e57bb6371e$export$b14f2714108df84)(await this.#getAccountValue({
            method: "getTransactionCount"
        }, address, blockTag), "%response");
    }
    async getCode(address, blockTag) {
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getCode"
        }, address, blockTag));
    }
    async getStorage(address, _position, blockTag) {
        const position = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(_position, "position");
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(await this.#getAccountValue({
            method: "getStorage",
            position: position
        }, address, blockTag));
    }
    // Write
    async broadcastTransaction(signedTx) {
        const { blockNumber: blockNumber, hash: hash, network: network } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            blockNumber: this.getBlockNumber(),
            hash: this._perform({
                method: "broadcastTransaction",
                signedTransaction: signedTx
            }),
            network: this.getNetwork()
        });
        const tx = (0, $154b040c27f48330$export$febc5573c75cefb0).from(signedTx);
        if (tx.hash !== hash) throw new Error("@TODO: the returned hash did not match");
        return this._wrapTransactionResponse(tx, network).replaceableTransaction(blockNumber);
    }
    async #getBlock(block, includeTransactions) {
        // @TODO: Add CustomBlockPlugin check
        if ((0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(block, 32)) return await this.#perform({
            method: "getBlock",
            blockHash: block,
            includeTransactions: includeTransactions
        });
        let blockTag = this._getBlockTag(block);
        if (typeof blockTag !== "string") blockTag = await blockTag;
        return await this.#perform({
            method: "getBlock",
            blockTag: blockTag,
            includeTransactions: includeTransactions
        });
    }
    // Queries
    async getBlock(block, prefetchTxs) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#getBlock(block, !!prefetchTxs)
        });
        if (params == null) return null;
        return this._wrapBlock(params, network);
    }
    async getTransaction(hash) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransaction",
                hash: hash
            })
        });
        if (params == null) return null;
        return this._wrapTransactionResponse(params, network);
    }
    async getTransactionReceipt(hash) {
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getTransactionReceipt",
                hash: hash
            })
        });
        if (params == null) return null;
        // Some backends did not backfill the effectiveGasPrice into old transactions
        // in the receipt, so we look it up manually and inject it.
        if (params.gasPrice == null && params.effectiveGasPrice == null) {
            const tx = await this.#perform({
                method: "getTransaction",
                hash: hash
            });
            if (tx == null) throw new Error("report this; could not find tx or effectiveGasPrice");
            params.effectiveGasPrice = tx.gasPrice;
        }
        return this._wrapTransactionReceipt(params, network);
    }
    async getTransactionResult(hash) {
        const { result: result } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            result: this.#perform({
                method: "getTransactionResult",
                hash: hash
            })
        });
        if (result == null) return null;
        return (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(result);
    }
    // Bloom-filter Queries
    async getLogs(_filter) {
        let filter = this._getFilter(_filter);
        if ($a447d5c12fd5aa4c$var$isPromise(filter)) filter = await filter;
        const { network: network, params: params } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            params: this.#perform({
                method: "getLogs",
                filter: filter
            })
        });
        return params.map((p)=>this._wrapLog(p, network));
    }
    // ENS
    _getProvider(chainId) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "provider cannot connect to target network", "UNSUPPORTED_OPERATION", {
            operation: "_getProvider()"
        });
    }
    async getResolver(name) {
        return await (0, $280d6641ec976e99$export$d04afd034a0a53ae).fromName(this, name);
    }
    async getAvatar(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAvatar();
        return null;
    }
    async resolveName(name) {
        const resolver = await this.getResolver(name);
        if (resolver) return await resolver.getAddress();
        return null;
    }
    async lookupAddress(address) {
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        const node = (0, $574ce7342d53bcf4$export$91d651ee363e1209)(address.substring(2).toLowerCase() + ".addr.reverse");
        try {
            const ensAddr = await (0, $280d6641ec976e99$export$d04afd034a0a53ae).getEnsAddress(this);
            const ensContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(ensAddr, [
                "function resolver(bytes32) view returns (address)"
            ], this);
            const resolver = await ensContract.resolver(node);
            if (resolver == null || resolver === (0, $5b8e64dd3cc782dc$export$b7cbe423ba83da17)) return null;
            const resolverContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(resolver, [
                "function name(bytes32) view returns (string)"
            ], this);
            const name = await resolverContract.name(node);
            // Failed forward resolution
            const check = await this.resolveName(name);
            if (check !== address) return null;
            return name;
        } catch (error) {
            // No data was returned from the resolver
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "BAD_DATA") && error.value === "0x") return null;
            // Something reerted
            if ((0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "CALL_EXCEPTION")) return null;
            throw error;
        }
        return null;
    }
    async waitForTransaction(hash, _confirms, timeout) {
        const confirms = _confirms != null ? _confirms : 1;
        if (confirms === 0) return this.getTransactionReceipt(hash);
        return new Promise(async (resolve, reject)=>{
            let timer = null;
            const listener = async (blockNumber)=>{
                try {
                    const receipt = await this.getTransactionReceipt(hash);
                    if (receipt != null) {
                        if (blockNumber - receipt.blockNumber + 1 >= confirms) {
                            resolve(receipt);
                            //this.off("block", listener);
                            if (timer) {
                                clearTimeout(timer);
                                timer = null;
                            }
                            return;
                        }
                    }
                } catch (error) {
                    console.log("EEE", error);
                }
                this.once("block", listener);
            };
            if (timeout != null) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                this.off("block", listener);
                reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("timeout", "TIMEOUT", {
                    reason: "timeout"
                }));
            }, timeout);
            listener(await this.getBlockNumber());
        });
    }
    async waitForBlock(blockTag) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "not implemented yet", "NOT_IMPLEMENTED", {
            operation: "waitForBlock"
        });
    }
    /**
     *  Clear a timer created using the [[_setTimeout]] method.
     */ _clearTimeout(timerId) {
        const timer = this.#timers.get(timerId);
        if (!timer) return;
        if (timer.timer) clearTimeout(timer.timer);
        this.#timers.delete(timerId);
    }
    /**
     *  Create a timer that will execute %%func%% after at least %%timeout%%
     *  (in ms). If %%timeout%% is unspecified, then %%func%% will execute
     *  in the next event loop.
     *
     *  [Pausing](AbstractProvider-paused) the provider will pause any
     *  associated timers.
     */ _setTimeout(_func, timeout) {
        if (timeout == null) timeout = 0;
        const timerId = this.#nextTimer++;
        const func = ()=>{
            this.#timers.delete(timerId);
            _func();
        };
        if (this.paused) this.#timers.set(timerId, {
            timer: null,
            func: func,
            time: timeout
        });
        else {
            const timer = setTimeout(func, timeout);
            this.#timers.set(timerId, {
                timer: timer,
                func: func,
                time: $a447d5c12fd5aa4c$var$getTime()
            });
        }
        return timerId;
    }
    /**
     *  Perform %%func%% on each subscriber.
     */ _forEachSubscriber(func) {
        for (const sub of this.#subs.values())func(sub.subscriber);
    }
    /**
     *  Sub-classes may override this to customize subscription
     *  implementations.
     */ _getSubscriber(sub) {
        switch(sub.type){
            case "debug":
            case "error":
            case "network":
                return new $a447d5c12fd5aa4c$export$f255b979f86248fa(sub.type);
            case "block":
                {
                    const subscriber = new (0, $f484c23113a92e9e$export$aaf796a16ac1a157)(this);
                    subscriber.pollingInterval = this.pollingInterval;
                    return subscriber;
                }
            case "event":
                return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(this, sub.filter);
            case "transaction":
                return new (0, $f484c23113a92e9e$export$4fe8a9740765f97e)(this, sub.hash);
            case "orphan":
                return new (0, $f484c23113a92e9e$export$e4ed5c6414dc4e9e)(this, sub.filter);
        }
        throw new Error(`unsupported event: ${sub.type}`);
    }
    /**
     *  If a [[Subscriber]] fails and needs to replace itself, this
     *  method may be used.
     *
     *  For example, this is used for providers when using the
     *  ``eth_getFilterChanges`` method, which can return null if state
     *  filters are not supported by the backend, allowing the Subscriber
     *  to swap in a [[PollingEventSubscriber]].
     */ _recoverSubscriber(oldSub, newSub) {
        for (const sub of this.#subs.values())if (sub.subscriber === oldSub) {
            if (sub.started) sub.subscriber.stop();
            sub.subscriber = newSub;
            if (sub.started) newSub.start();
            if (this.#pausedState != null) newSub.pause(this.#pausedState);
            break;
        }
    }
    async #hasSub(event, emitArgs) {
        let sub = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // This is a log that is removing an existing log; we actually want
        // to emit an orphan event for the removed log
        if (sub.type === "event" && emitArgs && emitArgs.length > 0 && emitArgs[0].removed === true) sub = await $a447d5c12fd5aa4c$var$getSubscription({
            orphan: "drop-log",
            log: emitArgs[0]
        }, this);
        return this.#subs.get(sub.tag) || null;
    }
    async #getSub(event) {
        const subscription = await $a447d5c12fd5aa4c$var$getSubscription(event, this);
        // Prevent tampering with our tag in any subclass' _getSubscriber
        const tag = subscription.tag;
        let sub = this.#subs.get(tag);
        if (!sub) {
            const subscriber = this._getSubscriber(subscription);
            const addressableMap = new WeakMap();
            const nameMap = new Map();
            sub = {
                subscriber: subscriber,
                tag: tag,
                addressableMap: addressableMap,
                nameMap: nameMap,
                started: false,
                listeners: []
            };
            this.#subs.set(tag, sub);
        }
        return sub;
    }
    async on(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: false
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async once(event, listener) {
        const sub = await this.#getSub(event);
        sub.listeners.push({
            listener: listener,
            once: true
        });
        if (!sub.started) {
            sub.subscriber.start();
            sub.started = true;
            if (this.#pausedState != null) sub.subscriber.pause(this.#pausedState);
        }
        return this;
    }
    async emit(event, ...args) {
        const sub = await this.#hasSub(event, args);
        // If there is not subscription or if a recent emit removed
        // the last of them (which also deleted the sub) do nothing
        if (!sub || sub.listeners.length === 0) return false;
        const count = sub.listeners.length;
        sub.listeners = sub.listeners.filter(({ listener: listener, once: once })=>{
            const payload = new (0, $62d6becaa0dab02c$export$9cec82196983b278)(this, once ? null : listener, event);
            try {
                listener.call(this, ...args, payload);
            } catch (error) {}
            return !once;
        });
        if (sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return count > 0;
    }
    async listenerCount(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return 0;
            return sub.listeners.length;
        }
        let total = 0;
        for (const { listeners: listeners } of this.#subs.values())total += listeners.length;
        return total;
    }
    async listeners(event) {
        if (event) {
            const sub = await this.#hasSub(event);
            if (!sub) return [];
            return sub.listeners.map(({ listener: listener })=>listener);
        }
        let result = [];
        for (const { listeners: listeners } of this.#subs.values())result = result.concat(listeners.map(({ listener: listener })=>listener));
        return result;
    }
    async off(event, listener) {
        const sub = await this.#hasSub(event);
        if (!sub) return this;
        if (listener) {
            const index = sub.listeners.map(({ listener: listener })=>listener).indexOf(listener);
            if (index >= 0) sub.listeners.splice(index, 1);
        }
        if (!listener || sub.listeners.length === 0) {
            if (sub.started) sub.subscriber.stop();
            this.#subs.delete(sub.tag);
        }
        return this;
    }
    async removeAllListeners(event) {
        if (event) {
            const { tag: tag, started: started, subscriber: subscriber } = await this.#getSub(event);
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        } else for (const [tag, { started: started, subscriber: subscriber }] of this.#subs){
            if (started) subscriber.stop();
            this.#subs.delete(tag);
        }
        return this;
    }
    // Alias for "on"
    async addListener(event, listener) {
        return await this.on(event, listener);
    }
    // Alias for "off"
    async removeListener(event, listener) {
        return this.off(event, listener);
    }
    /**
     *  If this provider has been destroyed using the [[destroy]] method.
     *
     *  Once destroyed, all resources are reclaimed, internal event loops
     *  and timers are cleaned up and no further requests may be sent to
     *  the provider.
     */ get destroyed() {
        return this.#destroyed;
    }
    /**
     *  Sub-classes may use this to shutdown any sockets or release their
     *  resources and reject any pending requests.
     *
     *  Sub-classes **must** call ``super.destroy()``.
     */ destroy() {
        // Stop all listeners
        this.removeAllListeners();
        // Shut down all tiemrs
        for (const timerId of this.#timers.keys())this._clearTimeout(timerId);
        this.#destroyed = true;
    }
    /**
     *  Whether the provider is currently paused.
     *
     *  A paused provider will not emit any events, and generally should
     *  not make any requests to the network, but that is up to sub-classes
     *  to manage.
     *
     *  Setting ``paused = true`` is identical to calling ``.pause(false)``,
     *  which will buffer any events that occur while paused until the
     *  provider is unpaused.
     */ get paused() {
        return this.#pausedState != null;
    }
    set paused(pause) {
        if (!!pause === this.paused) return;
        if (this.paused) this.resume();
        else this.pause(false);
    }
    /**
     *  Pause the provider. If %%dropWhilePaused%%, any events that occur
     *  while paused are dropped, otherwise all events will be emitted once
     *  the provider is unpaused.
     */ pause(dropWhilePaused) {
        this.#lastBlockNumber = -1;
        if (this.#pausedState != null) {
            if (this.#pausedState == !!dropWhilePaused) return;
            (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot change pause type; resume first", "UNSUPPORTED_OPERATION", {
                operation: "pause"
            });
        }
        this._forEachSubscriber((s)=>s.pause(dropWhilePaused));
        this.#pausedState = !!dropWhilePaused;
        for (const timer of this.#timers.values()){
            // Clear the timer
            if (timer.timer) clearTimeout(timer.timer);
            // Remaining time needed for when we become unpaused
            timer.time = $a447d5c12fd5aa4c$var$getTime() - timer.time;
        }
    }
    /**
     *  Resume the provider.
     */ resume() {
        if (this.#pausedState == null) return;
        this._forEachSubscriber((s)=>s.resume());
        this.#pausedState = null;
        for (const timer of this.#timers.values()){
            // Remaining time when we were paused
            let timeout = timer.time;
            if (timeout < 0) timeout = 0;
            // Start time (in cause paused, so we con compute remaininf time)
            timer.time = $a447d5c12fd5aa4c$var$getTime();
            // Start the timer
            setTimeout(timer.func, timeout);
        }
    }
}
function $a447d5c12fd5aa4c$var$_parseString(result, start) {
    try {
        const bytes = $a447d5c12fd5aa4c$var$_parseBytes(result, start);
        if (bytes) return (0, $50aa15ceb128a952$export$7643a1dc2c38d5eb)(bytes);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    try {
        const offset = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, start, start + 32));
        const length = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, offset, offset + 32));
        return (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(result, offset + 32, offset + 32 + length);
    } catch (error) {}
    return null;
}
function $a447d5c12fd5aa4c$var$numPad(value) {
    const result = (0, $6fa405e57bb6371e$export$b627fcfb5ea68cb0)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $a447d5c12fd5aa4c$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
const $a447d5c12fd5aa4c$var$empty = new Uint8Array([]);
// ABI Encodes a series of (bytes, bytes, ...)
function $a447d5c12fd5aa4c$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push($a447d5c12fd5aa4c$var$empty);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $fd3872da8feed9cb$export$a3521add2594f3c8)(datas[i]);
        // Update the bytes offset
        result[i] = $a447d5c12fd5aa4c$var$numPad(byteCount);
        // The length and padded value of data
        result.push($a447d5c12fd5aa4c$var$numPad(data.length));
        result.push($a447d5c12fd5aa4c$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $fd3872da8feed9cb$export$ee1b3e54f0441b22)(result);
}
const $a447d5c12fd5aa4c$var$zeros = "0x0000000000000000000000000000000000000000000000000000000000000000";
function $a447d5c12fd5aa4c$var$parseOffchainLookup(data) {
    const result = {
        sender: "",
        urls: [],
        calldata: "",
        selector: "",
        extraData: "",
        errorArgs: []
    };
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$2321cd91b99770ff)(data) >= 160, "insufficient OffchainLookup data", "OFFCHAIN_FAULT", {
        reason: "insufficient OffchainLookup data"
    });
    const sender = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 0, 32);
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(sender, 0, 12) === (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)($a447d5c12fd5aa4c$var$zeros, 0, 12), "corrupt OffchainLookup sender", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup sender"
    });
    result.sender = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(sender, 12);
    // Read the URLs from the response
    try {
        const urls = [];
        const urlsOffset = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 32, 64));
        const urlsLength = (0, $6fa405e57bb6371e$export$b14f2714108df84)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, urlsOffset, urlsOffset + 32));
        const urlsData = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, urlsOffset + 32);
        for(let u = 0; u < urlsLength; u++){
            const url = $a447d5c12fd5aa4c$var$_parseString(urlsData, u * 32);
            if (url == null) throw new Error("abort");
            urls.push(url);
        }
        result.urls = urls;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup urls", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup urls"
        });
    }
    // Get the CCIP calldata to forward
    try {
        const calldata = $a447d5c12fd5aa4c$var$_parseBytes(data, 64);
        if (calldata == null) throw new Error("abort");
        result.calldata = calldata;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup calldata", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup calldata"
        });
    }
    // Get the callbackSelector (bytes4)
    (0, $634aa51198273feb$export$a7a9523472993e97)((0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 100, 128) === (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)($a447d5c12fd5aa4c$var$zeros, 0, 28), "corrupt OffchainLookup callbaackSelector", "OFFCHAIN_FAULT", {
        reason: "corrupt OffchainLookup callbaackSelector"
    });
    result.selector = (0, $fd3872da8feed9cb$export$f6d845ffb449edc9)(data, 96, 100);
    // Get the extra data to send back to the contract as context
    try {
        const extraData = $a447d5c12fd5aa4c$var$_parseBytes(data, 128);
        if (extraData == null) throw new Error("abort");
        result.extraData = extraData;
    } catch (error) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "corrupt OffchainLookup extraData", "OFFCHAIN_FAULT", {
            reason: "corrupt OffchainLookup extraData"
        });
    }
    result.errorArgs = "sender,urls,calldata,selector,extraData".split(/,/).map((k)=>result[k]);
    return result;
}


/**
 *  Generally the [[Wallet]] and [[JsonRpcSigner]] and their sub-classes
 *  are sufficent for most developers, but this is provided to
 *  fascilitate more complex Signers.
 *
 *  @_section: api/providers/abstract-signer: Subclassing Signer [abstract-signer]
 */ 



function $0e0b4a0a5741b830$var$checkProvider(signer, operation) {
    if (signer.provider) return signer.provider;
    (0, $634aa51198273feb$export$a7a9523472993e97)(false, "missing provider", "UNSUPPORTED_OPERATION", {
        operation: operation
    });
}
async function $0e0b4a0a5741b830$var$populate(signer, tx) {
    let pop = (0, $425e3311db5fb4d1$export$607b34cdac162b7f)(tx);
    if (pop.to != null) pop.to = (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(pop.to, signer);
    if (pop.from != null) {
        const from = pop.from;
        pop.from = Promise.all([
            signer.getAddress(),
            (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(from, signer)
        ]).then(([address, from])=>{
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(address.toLowerCase() === from.toLowerCase(), "transaction from mismatch", "tx.from", from);
            return address;
        });
    } else pop.from = signer.getAddress();
    return await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)(pop);
}
class $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The provider this signer is connected to.
     */ provider;
    /**
     *  Creates a new Signer connected to %%provider%%.
     */ constructor(provider){
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            provider: provider || null
        });
    }
    async getNonce(blockTag) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "getTransactionCount").getTransactionCount(await this.getAddress(), blockTag);
    }
    async populateCall(tx) {
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        return pop;
    }
    async populateTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "populateTransaction");
        const pop = await $0e0b4a0a5741b830$var$populate(this, tx);
        if (pop.nonce == null) pop.nonce = await this.getNonce("pending");
        if (pop.gasLimit == null) pop.gasLimit = await this.estimateGas(pop);
        // Populate the chain ID
        const network = await this.provider.getNetwork();
        if (pop.chainId != null) {
            const chainId = (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(pop.chainId);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(chainId === network.chainId, "transaction chainId mismatch", "tx.chainId", tx.chainId);
        } else pop.chainId = network.chainId;
        // Do not allow mixing pre-eip-1559 and eip-1559 properties
        const hasEip1559 = pop.maxFeePerGas != null || pop.maxPriorityFeePerGas != null;
        if (pop.gasPrice != null && (pop.type === 2 || hasEip1559)) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "eip-1559 transaction do not support gasPrice", "tx", tx);
        else if ((pop.type === 0 || pop.type === 1) && hasEip1559) (0, $634aa51198273feb$export$c3d31707e5030f5e)(false, "pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "tx", tx);
        if ((pop.type === 2 || pop.type == null) && pop.maxFeePerGas != null && pop.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
        pop.type = 2;
        else if (pop.type === 0 || pop.type === 1) {
            // Explicit Legacy or EIP-2930 transaction
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            (0, $634aa51198273feb$export$a7a9523472993e97)(feeData.gasPrice != null, "network does not support gasPrice", "UNSUPPORTED_OPERATION", {
                operation: "getGasPrice"
            });
            // Populate missing gasPrice
            if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
        } else {
            // We need to get fee data to determine things
            const feeData = await provider.getFeeData();
            if (pop.type == null) {
                // We need to auto-detect the intended type of this transaction...
                if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                    // The network supports EIP-1559!
                    // Upgrade transaction from null to eip-1559
                    pop.type = 2;
                    if (pop.gasPrice != null) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        const gasPrice = pop.gasPrice;
                        delete pop.gasPrice;
                        pop.maxFeePerGas = gasPrice;
                        pop.maxPriorityFeePerGas = gasPrice;
                    } else {
                        // Populate missing fee data
                        if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                        if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                } else if (feeData.gasPrice != null) {
                    // Network doesn't support EIP-1559...
                    // ...but they are trying to use EIP-1559 properties
                    (0, $634aa51198273feb$export$a7a9523472993e97)(!hasEip1559, "network does not support EIP-1559", "UNSUPPORTED_OPERATION", {
                        operation: "populateTransaction"
                    });
                    // Populate missing fee data
                    if (pop.gasPrice == null) pop.gasPrice = feeData.gasPrice;
                    // Explicitly set untyped transaction to legacy
                    // @TODO: Maybe this shold allow type 1?
                    pop.type = 0;
                } else // getFeeData has failed us.
                (0, $634aa51198273feb$export$a7a9523472993e97)(false, "failed to get consistent fee data", "UNSUPPORTED_OPERATION", {
                    operation: "signer.getFeeData"
                });
            } else if (pop.type === 2) {
                // Explicitly using EIP-1559
                // Populate missing fee data
                if (pop.maxFeePerGas == null) pop.maxFeePerGas = feeData.maxFeePerGas;
                if (pop.maxPriorityFeePerGas == null) pop.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
            }
        }
        //@TOOD: Don't await all over the place; save them up for
        // the end for better batching
        return await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)(pop);
    }
    async estimateGas(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "estimateGas").estimateGas(await this.populateCall(tx));
    }
    async call(tx) {
        return $0e0b4a0a5741b830$var$checkProvider(this, "call").call(await this.populateCall(tx));
    }
    async resolveName(name) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "resolveName");
        return await provider.resolveName(name);
    }
    async sendTransaction(tx) {
        const provider = $0e0b4a0a5741b830$var$checkProvider(this, "sendTransaction");
        const pop = await this.populateTransaction(tx);
        delete pop.from;
        const txObj = (0, $154b040c27f48330$export$febc5573c75cefb0).from(pop);
        return await provider.broadcastTransaction(await this.signTransaction(txObj));
    }
}
class $0e0b4a0a5741b830$export$7dbc56d9b9612bad extends $0e0b4a0a5741b830$export$6c02143914c373f1 {
    /**
     *  The signer address.
     */ address;
    /**
     *  Creates a new **VoidSigner** with %%address%% attached to
     *  %%provider%%.
     */ constructor(address, provider){
        super(provider);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    async getAddress() {
        return this.address;
    }
    connect(provider) {
        return new $0e0b4a0a5741b830$export$7dbc56d9b9612bad(this.address, provider);
    }
    #throwUnsupported(suffix, operation) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, `VoidSigner cannot sign ${suffix}`, "UNSUPPORTED_OPERATION", {
            operation: operation
        });
    }
    async signTransaction(tx) {
        this.#throwUnsupported("transactions", "signTransaction");
    }
    async signMessage(message) {
        this.#throwUnsupported("messages", "signMessage");
    }
    async signTypedData(domain, types, value) {
        this.#throwUnsupported("typed-data", "signTypedData");
    }
}





function $028eec70d03d6cd8$var$copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
class $028eec70d03d6cd8$export$a51133e713c99bbe {
    #provider;
    #filterIdPromise;
    #poller;
    #running;
    #network;
    #hault;
    /**
     *  Creates a new **FilterIdSubscriber** which will used [[_subscribe]]
     *  and [[_emitResults]] to setup the subscription and provide the event
     *  to the %%provider%%.
     */ constructor(provider){
        this.#provider = provider;
        this.#filterIdPromise = null;
        this.#poller = this.#poll.bind(this);
        this.#running = false;
        this.#network = null;
        this.#hault = false;
    }
    /**
     *  Sub-classes **must** override this to begin the subscription.
     */ _subscribe(provider) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle the events.
     */ _emitResults(provider, result) {
        throw new Error("subclasses must override this");
    }
    /**
     *  Sub-classes **must** override this handle recovery on errors.
     */ _recover(provider) {
        throw new Error("subclasses must override this");
    }
    async #poll(blockNumber) {
        try {
            // Subscribe if necessary
            if (this.#filterIdPromise == null) this.#filterIdPromise = this._subscribe(this.#provider);
            // Get the Filter ID
            let filterId = null;
            try {
                filterId = await this.#filterIdPromise;
            } catch (error) {
                if (!(0, $634aa51198273feb$export$e6127cc7fe7395c3)(error, "UNSUPPORTED_OPERATION") || error.operation !== "eth_newFilter") throw error;
            }
            // The backend does not support Filter ID; downgrade to
            // polling
            if (filterId == null) {
                this.#filterIdPromise = null;
                this.#provider._recoverSubscriber(this, this._recover(this.#provider));
                return;
            }
            const network = await this.#provider.getNetwork();
            if (!this.#network) this.#network = network;
            if (this.#network.chainId !== network.chainId) throw new Error("chaid changed");
            if (this.#hault) return;
            const result = await this.#provider.send("eth_getFilterChanges", [
                filterId
            ]);
            await this._emitResults(this.#provider, result);
        } catch (error) {
            console.log("@TODO", error);
        }
        this.#provider.once("block", this.#poller);
    }
    #teardown() {
        const filterIdPromise = this.#filterIdPromise;
        if (filterIdPromise) {
            this.#filterIdPromise = null;
            filterIdPromise.then((filterId)=>{
                this.#provider.send("eth_uninstallFilter", [
                    filterId
                ]);
            });
        }
    }
    start() {
        if (this.#running) return;
        this.#running = true;
        this.#poll(-2);
    }
    stop() {
        if (!this.#running) return;
        this.#running = false;
        this.#hault = true;
        this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    pause(dropWhilePaused) {
        if (dropWhilePaused) this.#teardown();
        this.#provider.off("block", this.#poller);
    }
    resume() {
        this.start();
    }
}
class $028eec70d03d6cd8$export$60f65cdabb3c5771 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    #event;
    /**
     *  Creates a new **FilterIdEventSubscriber** attached to %%provider%%
     *  listening for %%filter%%.
     */ constructor(provider, filter){
        super(provider);
        this.#event = $028eec70d03d6cd8$var$copy(filter);
    }
    _recover(provider) {
        return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(provider, this.#event);
    }
    async _subscribe(provider) {
        const filterId = await provider.send("eth_newFilter", [
            this.#event
        ]);
        return filterId;
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit(this.#event, provider._wrapLog(result, provider._network));
    }
}
class $028eec70d03d6cd8$export$285511066b2a5499 extends $028eec70d03d6cd8$export$a51133e713c99bbe {
    async _subscribe(provider) {
        return await provider.send("eth_newPendingTransactionFilter", []);
    }
    async _emitResults(provider, results) {
        for (const result of results)provider.emit("pending", result);
    }
}



const $80daf019a5520af5$var$Primitive = "bigint,boolean,function,number,string,symbol".split(/,/g);
//const Methods = "getAddress,then".split(/,/g);
function $80daf019a5520af5$var$deepCopy(value) {
    if (value == null || $80daf019a5520af5$var$Primitive.indexOf(typeof value) >= 0) return value;
    // Keep any Addressable
    if (typeof value.getAddress === "function") return value;
    if (Array.isArray(value)) return value.map($80daf019a5520af5$var$deepCopy);
    if (typeof value === "object") return Object.keys(value).reduce((accum, key)=>{
        accum[key] = value[key];
        return accum;
    }, {});
    throw new Error(`should not happen: ${value} (${typeof value})`);
}
function $80daf019a5520af5$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $80daf019a5520af5$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
function $80daf019a5520af5$var$isPollable(value) {
    return value && typeof value.pollingInterval === "number";
}
const $80daf019a5520af5$var$defaultOptions = {
    polling: false,
    staticNetwork: null,
    batchStallTime: 10,
    batchMaxSize: 1048576,
    batchMaxCount: 100,
    cacheTimeout: 250,
    pollingInterval: 4000
};
class $80daf019a5520af5$export$5f7b5fca3508545a extends (0, $0e0b4a0a5741b830$export$6c02143914c373f1) {
    address;
    constructor(provider, address){
        super(provider);
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        (0, $5ac0677dd70fe0c6$export$b61bda4fbca264f2)(this, {
            address: address
        });
    }
    connect(provider) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(false, "cannot reconnect JsonRpcSigner", "UNSUPPORTED_OPERATION", {
            operation: "signer.connect"
        });
    }
    async getAddress() {
        return this.address;
    }
    // JSON-RPC will automatially fill in nonce, etc. so we just check from
    async populateTransaction(tx) {
        return await this.populateCall(tx);
    }
    // Returns just the hash of the transaction after sent, which is what
    // the bare JSON-RPC API does;
    async sendUncheckedTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        const promises = [];
        // Make sure the from matches the sender
        if (tx.from) {
            const _from = tx.from;
            promises.push((async ()=>{
                const from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(_from, this.provider);
                (0, $634aa51198273feb$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
                tx.from = from;
            })());
        } else tx.from = this.address;
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (tx.gasLimit == null) promises.push((async ()=>{
            tx.gasLimit = await this.provider.estimateGas({
                ...tx,
                from: this.address
            });
        })());
        // The address may be an ENS name or Addressable
        if (tx.to != null) {
            const _to = tx.to;
            promises.push((async ()=>{
                tx.to = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(_to, this.provider);
            })());
        }
        // Wait until all of our properties are filled in
        if (promises.length) await Promise.all(promises);
        const hexTx = this.provider.getRpcTransaction(tx);
        return this.provider.send("eth_sendTransaction", [
            hexTx
        ]);
    }
    async sendTransaction(tx) {
        // This cannot be mined any earlier than any recent block
        const blockNumber = await this.provider.getBlockNumber();
        // Send the transaction
        const hash = await this.sendUncheckedTransaction(tx);
        // Unfortunately, JSON-RPC only provides and opaque transaction hash
        // for a response, and we need the actual transaction, so we poll
        // for it; it should show up very quickly
        return await new Promise((resolve, reject)=>{
            const timeouts = [
                1000,
                100
            ];
            const checkTx = async ()=>{
                // Try getting the transaction
                const tx = await this.provider.getTransaction(hash);
                if (tx != null) {
                    resolve(tx.replaceableTransaction(blockNumber));
                    return;
                }
                // Wait another 4 seconds
                this.provider._setTimeout(()=>{
                    checkTx();
                }, timeouts.pop() || 4000);
            };
            checkTx();
        });
    }
    async signTransaction(_tx) {
        const tx = $80daf019a5520af5$var$deepCopy(_tx);
        // Make sure the from matches the sender
        if (tx.from) {
            const from = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(tx.from, this.provider);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(from != null && from.toLowerCase() === this.address.toLowerCase(), "from address mismatch", "transaction", _tx);
            tx.from = from;
        } else tx.from = this.address;
        const hexTx = this.provider.getRpcTransaction(tx);
        return await this.provider.send("eth_signTransaction", [
            hexTx
        ]);
    }
    async signMessage(_message) {
        const message = typeof _message === "string" ? (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("personal_sign", [
            (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(message),
            this.address.toLowerCase()
        ]);
    }
    async signTypedData(domain, types, _value) {
        const value = $80daf019a5520af5$var$deepCopy(_value);
        // Populate any ENS names (in-place)
        const populated = await (0, $23f01ceb797ea4ad$export$458ab927ae635c3).resolveNames(domain, types, value, async (value)=>{
            const address = await (0, $ed11119eb2f9aa0c$export$687eed6b344123c9)(value);
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(address != null, "TypedData does not support null address", "value", value);
            return address;
        });
        return await this.provider.send("eth_signTypedData_v4", [
            this.address.toLowerCase(),
            JSON.stringify((0, $23f01ceb797ea4ad$export$458ab927ae635c3).getPayload(populated.domain, types, populated.value))
        ]);
    }
    async unlock(password) {
        return this.provider.send("personal_unlockAccount", [
            this.address.toLowerCase(),
            password,
            null
        ]);
    }
    // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
    async _legacySignMessage(_message) {
        const message = typeof _message === "string" ? (0, $50aa15ceb128a952$export$8feeb310b4b4752f)(_message) : _message;
        return await this.provider.send("eth_sign", [
            this.address.toLowerCase(),
            (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(message)
        ]);
    }
}
class $80daf019a5520af5$export$5afe35a44ca7ff9a extends (0, $a447d5c12fd5aa4c$export$ae9650e85fb229fe) {
    #options;
    // The next ID to use for the JSON-RPC ID field
    #nextId;
    // Payloads are queued and triggered in batches using the drainTimer
    #payloads;
    #drainTimer;
    #notReady;
    #network;
    #scheduleDrain() {
        if (this.#drainTimer) return;
        // If we aren't using batching, no hard in sending it immeidately
        const stallTime = this._getOption("batchMaxCount") === 1 ? 0 : this._getOption("batchStallTime");
        this.#drainTimer = setTimeout(()=>{
            this.#drainTimer = null;
            const payloads = this.#payloads;
            this.#payloads = [];
            while(payloads.length){
                // Create payload batches that satisfy our batch constraints
                const batch = [
                    payloads.shift()
                ];
                while(payloads.length){
                    if (batch.length === this.#options.batchMaxCount) break;
                    batch.push(payloads.shift());
                    const bytes = JSON.stringify(batch.map((p)=>p.payload));
                    if (bytes.length > this.#options.batchMaxSize) {
                        payloads.unshift(batch.pop());
                        break;
                    }
                }
                // Process the result to each payload
                (async ()=>{
                    const payload = batch.length === 1 ? batch[0].payload : batch.map((p)=>p.payload);
                    this.emit("debug", {
                        action: "sendRpcPayload",
                        payload: payload
                    });
                    try {
                        const result = await this._send(payload);
                        this.emit("debug", {
                            action: "receiveRpcResult",
                            result: result
                        });
                        // Process results in batch order
                        for (const { resolve: resolve, reject: reject, payload: payload } of batch){
                            if (this.destroyed) {
                                reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
                                    operation: payload.method
                                }));
                                continue;
                            }
                            // Find the matching result
                            const resp = result.filter((r)=>r.id === payload.id)[0];
                            // No result; the node failed us in unexpected ways
                            if (resp == null) {
                                const error = (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("missing response for request", "BAD_DATA", {
                                    value: result,
                                    info: {
                                        payload: payload
                                    }
                                });
                                this.emit("error", error);
                                reject(error);
                                continue;
                            }
                            // The response is an error
                            if ("error" in resp) {
                                reject(this.getRpcError(payload, resp));
                                continue;
                            }
                            // All good; send the result
                            resolve(resp.result);
                        }
                    } catch (error) {
                        this.emit("debug", {
                            action: "receiveRpcError",
                            error: error
                        });
                        for (const { reject: reject } of batch)// @TODO: augment the error with the payload
                        reject(error);
                    }
                })();
            }
        }, stallTime);
    }
    constructor(network, options){
        super(network, options);
        this.#nextId = 1;
        this.#options = Object.assign({}, $80daf019a5520af5$var$defaultOptions, options || {});
        this.#payloads = [];
        this.#drainTimer = null;
        this.#network = null;
        {
            let resolve = null;
            const promise = new Promise((_resolve)=>{
                resolve = _resolve;
            });
            this.#notReady = {
                promise: promise,
                resolve: resolve
            };
        }
        // Make sure any static network is compatbile with the provided netwrok
        const staticNetwork = this._getOption("staticNetwork");
        if (staticNetwork) {
            (0, $634aa51198273feb$export$c3d31707e5030f5e)(network == null || staticNetwork.matches(network), "staticNetwork MUST match network object", "options", options);
            this.#network = staticNetwork;
        }
    }
    /**
     *  Returns the value associated with the option %%key%%.
     *
     *  Sub-classes can use this to inquire about configuration options.
     */ _getOption(key) {
        return this.#options[key];
    }
    /**
     *  Gets the [[Network]] this provider has committed to. On each call, the network
     *  is detected, and if it has changed, the call will reject.
     */ get _network() {
        (0, $634aa51198273feb$export$a7a9523472993e97)(this.#network, "network is not available yet", "NETWORK_ERROR");
        return this.#network;
    }
    /**
     *  Resolves to the non-normalized value by performing %%req%%.
     *
     *  Sub-classes may override this to modify behavior of actions,
     *  and should generally call ``super._perform`` as a fallback.
     */ async _perform(req) {
        // Legacy networks do not like the type field being passed along (which
        // is fair), so we delete type if it is 0 and a non-EIP-1559 network
        if (req.method === "call" || req.method === "estimateGas") {
            let tx = req.transaction;
            if (tx && tx.type != null && (0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx.type)) // If there are no EIP-1559 properties, it might be non-EIP-a559
            {
                if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                    const feeData = await this.getFeeData();
                    if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) // Network doesn't know about EIP-1559 (and hence type)
                    req = Object.assign({}, req, {
                        transaction: Object.assign({}, tx, {
                            type: undefined
                        })
                    });
                }
            }
        }
        const request = this.getRpcRequest(req);
        if (request != null) return await this.send(request.method, request.args);
        return super._perform(req);
    }
    /**
     *  Sub-classes may override this; it detects the *actual* network that
     *  we are **currently** connected to.
     *
     *  Keep in mind that [[send]] may only be used once [[ready]], otherwise the
     *  _send primitive must be used instead.
     */ async _detectNetwork() {
        const network = this._getOption("staticNetwork");
        if (network) return network;
        // If we are ready, use ``send``, which enabled requests to be batched
        if (this.ready) return (0, $4945f77db30f37e3$export$95be4ae94445245a).from((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(await this.send("eth_chainId", [])));
        // We are not ready yet; use the primitive _send
        const payload = {
            id: this.#nextId++,
            method: "eth_chainId",
            params: [],
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "sendRpcPayload",
            payload: payload
        });
        let result;
        try {
            result = (await this._send(payload))[0];
        } catch (error) {
            this.emit("debug", {
                action: "receiveRpcError",
                error: error
            });
            throw error;
        }
        this.emit("debug", {
            action: "receiveRpcResult",
            result: result
        });
        if ("result" in result) return (0, $4945f77db30f37e3$export$95be4ae94445245a).from((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(result.result));
        throw this.getRpcError(payload, result);
    }
    /**
     *  Sub-classes **MUST** call this. Until [[_start]] has been called, no calls
     *  will be passed to [[_send]] from [[send]]. If it is overridden, then
     *  ``super._start()`` **MUST** be called.
     *
     *  Calling it multiple times is safe and has no effect.
     */ _start() {
        if (this.#notReady == null || this.#notReady.resolve == null) return;
        this.#notReady.resolve();
        this.#notReady = null;
        (async ()=>{
            // Bootstrap the network
            while(this.#network == null && !this.destroyed)try {
                this.#network = await this._detectNetwork();
            } catch (error) {
                if (this.destroyed) break;
                console.log("JsonRpcProvider failed to detect network and cannot start up; retry in 1s (perhaps the URL is wrong or the node is not started)");
                this.emit("error", (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("failed to bootstrap network detection", "NETWORK_ERROR", {
                    event: "initial-network-discovery",
                    info: {
                        error: error
                    }
                }));
                await $80daf019a5520af5$var$stall(1000);
            }
            // Start dispatching requests
            this.#scheduleDrain();
        })();
    }
    /**
     *  Resolves once the [[_start]] has been called. This can be used in
     *  sub-classes to defer sending data until the connection has been
     *  established.
     */ async _waitUntilReady() {
        if (this.#notReady == null) return;
        return await this.#notReady.promise;
    }
    /**
     *  Return a Subscriber that will manage the %%sub%%.
     *
     *  Sub-classes may override this to modify the behavior of
     *  subscription management.
     */ _getSubscriber(sub) {
        // Pending Filters aren't availble via polling
        if (sub.type === "pending") return new (0, $028eec70d03d6cd8$export$285511066b2a5499)(this);
        if (sub.type === "event") {
            if (this._getOption("polling")) return new (0, $f484c23113a92e9e$export$bdb759dc2fe68c72)(this, sub.filter);
            return new (0, $028eec70d03d6cd8$export$60f65cdabb3c5771)(this, sub.filter);
        }
        // Orphaned Logs are handled automatically, by the filter, since
        // logs with removed are emitted by it
        if (sub.type === "orphan" && sub.filter.orphan === "drop-log") return new (0, $a447d5c12fd5aa4c$export$f255b979f86248fa)("orphan");
        return super._getSubscriber(sub);
    }
    /**
     *  Returns true only if the [[_start]] has been called.
     */ get ready() {
        return this.#notReady == null;
    }
    /**
     *  Returns %%tx%% as a normalized JSON-RPC transaction request,
     *  which has all values hexlified and any numeric values converted
     *  to Quantity values.
     */ getRpcTransaction(tx) {
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            let dstKey = key;
            if (key === "gasLimit") dstKey = "gas";
            result[dstKey] = (0, $6fa405e57bb6371e$export$d9c067986dbc68dd)((0, $6fa405e57bb6371e$export$61fe455e2b1e28a4)(tx[key], `tx.${key}`));
        });
        // Make sure addresses and data are lowercase
        [
            "from",
            "to",
            "data"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            result[key] = (0, $fd3872da8feed9cb$export$2b0d6b5fbe698c70)(tx[key]);
        });
        // Normalize the access list object
        if (tx.accessList) result["accessList"] = (0, $c254de3831dd58ea$export$6c8662b1600dce2)(tx.accessList);
        return result;
    }
    /**
     *  Returns the request method and arguments required to perform
     *  %%req%%.
     */ getRpcRequest(req) {
        switch(req.method){
            case "chainId":
                return {
                    method: "eth_chainId",
                    args: []
                };
            case "getBlockNumber":
                return {
                    method: "eth_blockNumber",
                    args: []
                };
            case "getGasPrice":
                return {
                    method: "eth_gasPrice",
                    args: []
                };
            case "getBalance":
                return {
                    method: "eth_getBalance",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getTransactionCount":
                return {
                    method: "eth_getTransactionCount",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getCode":
                return {
                    method: "eth_getCode",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        req.blockTag
                    ]
                };
            case "getStorage":
                return {
                    method: "eth_getStorageAt",
                    args: [
                        $80daf019a5520af5$var$getLowerCase(req.address),
                        "0x" + req.position.toString(16),
                        req.blockTag
                    ]
                };
            case "broadcastTransaction":
                return {
                    method: "eth_sendRawTransaction",
                    args: [
                        req.signedTransaction
                    ]
                };
            case "getBlock":
                if ("blockTag" in req) return {
                    method: "eth_getBlockByNumber",
                    args: [
                        req.blockTag,
                        !!req.includeTransactions
                    ]
                };
                else if ("blockHash" in req) return {
                    method: "eth_getBlockByHash",
                    args: [
                        req.blockHash,
                        !!req.includeTransactions
                    ]
                };
                break;
            case "getTransaction":
                return {
                    method: "eth_getTransactionByHash",
                    args: [
                        req.hash
                    ]
                };
            case "getTransactionReceipt":
                return {
                    method: "eth_getTransactionReceipt",
                    args: [
                        req.hash
                    ]
                };
            case "call":
                return {
                    method: "eth_call",
                    args: [
                        this.getRpcTransaction(req.transaction),
                        req.blockTag
                    ]
                };
            case "estimateGas":
                return {
                    method: "eth_estimateGas",
                    args: [
                        this.getRpcTransaction(req.transaction)
                    ]
                };
            case "getLogs":
                if (req.filter && req.filter.address != null) {
                    if (Array.isArray(req.filter.address)) req.filter.address = req.filter.address.map($80daf019a5520af5$var$getLowerCase);
                    else req.filter.address = $80daf019a5520af5$var$getLowerCase(req.filter.address);
                }
                return {
                    method: "eth_getLogs",
                    args: [
                        req.filter
                    ]
                };
        }
        return null;
    }
    /**
     *  Returns an ethers-style Error for the given JSON-RPC error
     *  %%payload%%, coalescing the various strings and error shapes
     *  that different nodes return, coercing them into a machine-readable
     *  standardized error.
     */ getRpcError(payload, _error) {
        const { method: method } = payload;
        const { error: error } = _error;
        if (method === "eth_estimateGas" && error.message) {
            const msg = error.message;
            if (!msg.match(/revert/i) && msg.match(/insufficient funds/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("insufficient funds", "INSUFFICIENT_FUNDS", {
                transaction: payload.params[0],
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_call" || method === "eth_estimateGas") {
            const result = $80daf019a5520af5$var$spelunkData(error);
            const e = (0, $816d2d9d4a0a65b4$export$fe041e1a83d3efc6).getBuiltinCallException(method === "eth_call" ? "call" : "estimateGas", payload.params[0], result ? result.data : null);
            e.info = {
                error: error,
                payload: payload
            };
            return e;
        }
        // Only estimateGas and call can return arbitrary contract-defined text, so now we
        // we can process text safely.
        const message = JSON.stringify($80daf019a5520af5$var$spelunkMessage(error));
        if (typeof error.message === "string" && error.message.match(/user denied|ethers-user-denied/i)) {
            const actionMap = {
                eth_sign: "signMessage",
                personal_sign: "signMessage",
                eth_signTypedData_v4: "signTypedData",
                eth_signTransaction: "signTransaction",
                eth_sendTransaction: "sendTransaction",
                eth_requestAccounts: "requestAccess",
                wallet_requestAccounts: "requestAccess"
            };
            return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)(`user rejected action`, "ACTION_REJECTED", {
                action: actionMap[method] || "unknown",
                reason: "rejected",
                info: {
                    payload: payload,
                    error: error
                }
            });
        }
        if (method === "eth_sendRawTransaction" || method === "eth_sendTransaction") {
            const transaction = payload.params[0];
            if (message.match(/insufficient funds|base fee exceeds gas limit/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("insufficient funds for intrinsic transaction cost", "INSUFFICIENT_FUNDS", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/nonce/i) && message.match(/too low/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("nonce has already been used", "NONCE_EXPIRED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            // "replacement transaction underpriced"
            if (message.match(/replacement transaction/i) && message.match(/underpriced/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("replacement fee too low", "REPLACEMENT_UNDERPRICED", {
                transaction: transaction,
                info: {
                    error: error
                }
            });
            if (message.match(/only replay-protected/i)) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("legacy pre-eip-155 transactions not supported", "UNSUPPORTED_OPERATION", {
                operation: method,
                info: {
                    transaction: transaction,
                    info: {
                        error: error
                    }
                }
            });
        }
        let unsupported = !!message.match(/the method .* does not exist/i);
        if (!unsupported) {
            if (error && error.details && error.details.startsWith("Unauthorized method:")) unsupported = true;
        }
        if (unsupported) return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("unsupported operation", "UNSUPPORTED_OPERATION", {
            operation: payload.method,
            info: {
                error: error,
                payload: payload
            }
        });
        return (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("could not coalesce error", "UNKNOWN_ERROR", {
            error: error,
            payload: payload
        });
    }
    /**
     *  Requests the %%method%% with %%params%% via the JSON-RPC protocol
     *  over the underlying channel. This can be used to call methods
     *  on the backend that do not have a high-level API within the Provider
     *  API.
     *
     *  This method queues requests according to the batch constraints
     *  in the options, assigns the request a unique ID.
     *
     *  **Do NOT override** this method in sub-classes; instead
     *  override [[_send]] or force the options values in the
     *  call to the constructor to modify this method's behavior.
     */ send(method, params) {
        // @TODO: cache chainId?? purge on switch_networks
        // We have been destroyed; no operations are supported anymore
        if (this.destroyed) return Promise.reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: method
        }));
        const id = this.#nextId++;
        const promise = new Promise((resolve, reject)=>{
            this.#payloads.push({
                resolve: resolve,
                reject: reject,
                payload: {
                    method: method,
                    params: params,
                    id: id,
                    jsonrpc: "2.0"
                }
            });
        });
        // If there is not a pending drainTimer, set one
        this.#scheduleDrain();
        return promise;
    }
    /**
     *  Resolves to the [[Signer]] account for  %%address%% managed by
     *  the client.
     *
     *  If the %%address%% is a number, it is used as an index in the
     *  the accounts from [[listAccounts]].
     *
     *  This can only be used on clients which manage accounts (such as
     *  Geth with imported account or MetaMask).
     *
     *  Throws if the account doesn't exist.
     */ async getSigner(address) {
        if (address == null) address = 0;
        const accountsPromise = this.send("eth_accounts", []);
        // Account index
        if (typeof address === "number") {
            const accounts = await accountsPromise;
            if (address >= accounts.length) throw new Error("no such account");
            return new $80daf019a5520af5$export$5f7b5fca3508545a(this, accounts[address]);
        }
        const { accounts: accounts } = await (0, $5ac0677dd70fe0c6$export$d503dd157d963b60)({
            network: this.getNetwork(),
            accounts: accountsPromise
        });
        // Account address
        address = (0, $69ef3f917ff239a2$export$88411125f012957a)(address);
        for (const account of accounts){
            if ((0, $69ef3f917ff239a2$export$88411125f012957a)(account) === address) return new $80daf019a5520af5$export$5f7b5fca3508545a(this, address);
        }
        throw new Error("invalid account");
    }
    async listAccounts() {
        const accounts = await this.send("eth_accounts", []);
        return accounts.map((a)=>new $80daf019a5520af5$export$5f7b5fca3508545a(this, a));
    }
    destroy() {
        // Stop processing requests
        if (this.#drainTimer) {
            clearTimeout(this.#drainTimer);
            this.#drainTimer = null;
        }
        // Cancel all pending requests
        for (const { payload: payload, reject: reject } of this.#payloads)reject((0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("provider destroyed; cancelled request", "UNSUPPORTED_OPERATION", {
            operation: payload.method
        }));
        this.#payloads = [];
        // Parent clean-up
        super.destroy();
    }
}
class $80daf019a5520af5$export$e16ffa1aa36d1432 extends $80daf019a5520af5$export$5afe35a44ca7ff9a {
    #pollingInterval;
    constructor(network, options){
        super(network, options);
        this.#pollingInterval = 4000;
    }
    _getSubscriber(sub) {
        const subscriber = super._getSubscriber(sub);
        if ($80daf019a5520af5$var$isPollable(subscriber)) subscriber.pollingInterval = this.#pollingInterval;
        return subscriber;
    }
    /**
     *  The polling interval (default: 4000 ms)
     */ get pollingInterval() {
        return this.#pollingInterval;
    }
    set pollingInterval(value) {
        if (!Number.isInteger(value) || value < 0) throw new Error("invalid interval");
        this.#pollingInterval = value;
        this._forEachSubscriber((sub)=>{
            if ($80daf019a5520af5$var$isPollable(sub)) sub.pollingInterval = this.#pollingInterval;
        });
    }
}
class $80daf019a5520af5$export$da28308012bf6748 extends $80daf019a5520af5$export$e16ffa1aa36d1432 {
    #connect;
    constructor(url, network, options){
        if (url == null) url = "http://localhost:8545";
        super(network, options);
        if (typeof url === "string") this.#connect = new (0, $2cb10defc4f72334$export$319b96fe59834522)(url);
        else this.#connect = url.clone();
    }
    _getConnection() {
        return this.#connect.clone();
    }
    async send(method, params) {
        // All requests are over HTTP, so we can just start handling requests
        // We do this here rather than the constructor so that we don't send any
        // requests to the network (i.e. eth_chainId) until we absolutely have to.
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        // Configure a POST connection for the requested method
        const request = this._getConnection();
        request.body = JSON.stringify(payload);
        request.setHeader("content-type", "application/json");
        const response = await request.send();
        response.assertOk();
        let resp = response.bodyJson;
        if (!Array.isArray(resp)) resp = [
            resp
        ];
        return resp;
    }
}
function $80daf019a5520af5$var$spelunkData(value) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match(/revert/i) && (0, $fd3872da8feed9cb$export$b02a40aff8e4ad18)(value.data)) return {
        message: value.message,
        data: value.data
    };
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $80daf019a5520af5$var$spelunkData(value[key]);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$spelunkData(JSON.parse(value));
    } catch (error) {}
    return null;
}
function $80daf019a5520af5$var$_spelunkMessage(value, result) {
    if (value == null) return;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string") result.push(value.message);
    // Spelunk further...
    if (typeof value === "object") for(const key in value)$80daf019a5520af5$var$_spelunkMessage(value[key], result);
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $80daf019a5520af5$var$_spelunkMessage(JSON.parse(value), result);
    } catch (error) {}
}
function $80daf019a5520af5$var$spelunkMessage(value) {
    const result = [];
    $80daf019a5520af5$var$_spelunkMessage(value, result);
    return result;
}


class $d5687dfa6bc29fec$export$8d50d0931f78dec8 extends (0, $80daf019a5520af5$export$e16ffa1aa36d1432) {
    #request;
    /**
     *  Connnect to the %%ethereum%% provider, optionally forcing the
     *  %%network%%.
     */ constructor(ethereum, network){
        super(network, {
            batchMaxCount: 1
        });
        this.#request = async (method, params)=>{
            const payload = {
                method: method,
                params: params
            };
            this.emit("debug", {
                action: "sendEip1193Request",
                payload: payload
            });
            try {
                const result = await ethereum.request(payload);
                this.emit("debug", {
                    action: "receiveEip1193Result",
                    result: result
                });
                return result;
            } catch (e) {
                const error = new Error(e.message);
                error.code = e.code;
                error.data = e.data;
                error.payload = payload;
                this.emit("debug", {
                    action: "receiveEip1193Error",
                    error: error
                });
                throw error;
            }
        };
    }
    async send(method, params) {
        await this._start();
        return await super.send(method, params);
    }
    async _send(payload) {
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!Array.isArray(payload), "EIP-1193 does not support batch request", "payload", payload);
        try {
            const result = await this.#request(payload.method, payload.params || []);
            return [
                {
                    id: payload.id,
                    result: result
                }
            ];
        } catch (e) {
            return [
                {
                    id: payload.id,
                    error: {
                        code: e.code,
                        data: e.data,
                        message: e.message
                    }
                }
            ];
        }
    }
    getRpcError(payload, error) {
        error = JSON.parse(JSON.stringify(error));
        // EIP-1193 gives us some machine-readable error codes, so rewrite
        // them into 
        switch(error.error.code || -1){
            case 4001:
                error.error.message = `ethers-user-denied: ${error.error.message}`;
                break;
            case 4200:
                error.error.message = `ethers-unsupported: ${error.error.message}`;
                break;
        }
        return super.getRpcError(payload, error);
    }
    /**
     *  Resolves to ``true`` if the provider manages the %%address%%.
     */ async hasSigner(address) {
        if (address == null) address = 0;
        const accounts = await this.send("eth_accounts", []);
        if (typeof address === "number") return accounts.length > address;
        address = address.toLowerCase();
        return accounts.filter((a)=>a.toLowerCase() === address).length !== 0;
    }
    async getSigner(address) {
        if (address == null) address = 0;
        if (!await this.hasSigner(address)) try {
            //const resp = 
            await this.#request("eth_requestAccounts", []);
        //console.log("RESP", resp);
        } catch (error) {
            const payload = error.payload;
            throw this.getRpcError(payload, {
                id: payload.id,
                error: error
            });
        }
        return await super.getSigner(address);
    }
}

function $1ac063f746decd00$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $1ac063f746decd00$export$3909fb301d3dc8c9 = $1ac063f746decd00$var$getGlobal().WebSocket;


/**
 *  Generic long-lived socket provider.
 *
 *  Sub-classing notes
 *  - a sub-class MUST call the `_start()` method once connected
 *  - a sub-class MUST override the `_write(string)` method
 *  - a sub-class MUST call `_processMessage(string)` for each message
 *
 *  @_subsection: api/providers/abstract-provider:Socket Providers  [about-socketProvider]
 */ 


class $f5c7ec5fba95f5a4$export$93f3aca769b589e9 {
    #provider;
    #filter;
    /**
     *  The filter.
     */ get filter() {
        return JSON.parse(this.#filter);
    }
    #filterId;
    #paused;
    #emitPromise;
    /**
     *  Creates a new **SocketSubscriber** attached to %%provider%% listening
     *  to %%filter%%.
     */ constructor(provider, filter){
        this.#provider = provider;
        this.#filter = JSON.stringify(filter);
        this.#filterId = null;
        this.#paused = null;
        this.#emitPromise = null;
    }
    start() {
        this.#filterId = this.#provider.send("eth_subscribe", this.filter).then((filterId)=>{
            this.#provider._register(filterId, this);
            return filterId;
        });
    }
    stop() {
        this.#filterId.then((filterId)=>{
            this.#provider.send("eth_unsubscribe", [
                filterId
            ]);
        });
        this.#filterId = null;
    }
    // @TODO: pause should trap the current blockNumber, unsub, and on resume use getLogs
    //        and resume
    pause(dropWhilePaused) {
        (0, $634aa51198273feb$export$a7a9523472993e97)(dropWhilePaused, "preserve logs while paused not supported by SocketSubscriber yet", "UNSUPPORTED_OPERATION", {
            operation: "pause(false)"
        });
        this.#paused = !!dropWhilePaused;
    }
    resume() {
        this.#paused = null;
    }
    /**
     *  @_ignore:
     */ _handleMessage(message) {
        if (this.#filterId == null) return;
        if (this.#paused === null) {
            let emitPromise = this.#emitPromise;
            if (emitPromise == null) emitPromise = this._emit(this.#provider, message);
            else emitPromise = emitPromise.then(async ()=>{
                await this._emit(this.#provider, message);
            });
            this.#emitPromise = emitPromise.then(()=>{
                if (this.#emitPromise === emitPromise) this.#emitPromise = null;
            });
        }
    }
    /**
     *  Sub-classes **must** override this to emit the events on the
     *  provider.
     */ async _emit(provider, message) {
        throw new Error("sub-classes must implemente this; _emit");
    }
}
class $f5c7ec5fba95f5a4$export$c41c8e39180b7cbc extends $f5c7ec5fba95f5a4$export$93f3aca769b589e9 {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newHeads"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("block", parseInt(message.number));
    }
}
class $f5c7ec5fba95f5a4$export$a974d62bd7e1dc1f extends $f5c7ec5fba95f5a4$export$93f3aca769b589e9 {
    /**
     *  @_ignore:
     */ constructor(provider){
        super(provider, [
            "newPendingTransactions"
        ]);
    }
    async _emit(provider, message) {
        provider.emit("pending", message);
    }
}
class $f5c7ec5fba95f5a4$export$5b6129c1da6053f0 extends $f5c7ec5fba95f5a4$export$93f3aca769b589e9 {
    #logFilter;
    /**
     *  The filter.
     */ get logFilter() {
        return JSON.parse(this.#logFilter);
    }
    /**
     *  @_ignore:
     */ constructor(provider, filter){
        super(provider, [
            "logs",
            filter
        ]);
        this.#logFilter = JSON.stringify(filter);
    }
    async _emit(provider, message) {
        provider.emit(this.logFilter, provider._wrapLog(message, provider._network));
    }
}
class $f5c7ec5fba95f5a4$export$783b29abdab77db7 extends (0, $80daf019a5520af5$export$5afe35a44ca7ff9a) {
    #callbacks;
    // Maps each filterId to its subscriber
    #subs;
    // If any events come in before a subscriber has finished
    // registering, queue them
    #pending;
    /**
     *  Creates a new **SocketProvider** connected to %%network%%.
     *
     *  If unspecified, the network will be discovered.
     */ constructor(network){
        super(network, {
            batchMaxCount: 1
        });
        this.#callbacks = new Map();
        this.#subs = new Map();
        this.#pending = new Map();
    }
    // This value is only valid after _start has been called
    /*
    get _network(): Network {
        if (this.#network == null) {
            throw new Error("this shouldn't happen");
        }
        return this.#network.clone();
    }
    */ _getSubscriber(sub) {
        switch(sub.type){
            case "close":
                return new (0, $a447d5c12fd5aa4c$export$f255b979f86248fa)("close");
            case "block":
                return new $f5c7ec5fba95f5a4$export$c41c8e39180b7cbc(this);
            case "pending":
                return new $f5c7ec5fba95f5a4$export$a974d62bd7e1dc1f(this);
            case "event":
                return new $f5c7ec5fba95f5a4$export$5b6129c1da6053f0(this, sub.filter);
            case "orphan":
                // Handled auto-matically within AbstractProvider
                // when the log.removed = true
                if (sub.filter.orphan === "drop-log") return new (0, $a447d5c12fd5aa4c$export$f255b979f86248fa)("drop-log");
        }
        return super._getSubscriber(sub);
    }
    /**
     *  Register a new subscriber. This is used internalled by Subscribers
     *  and generally is unecessary unless extending capabilities.
     */ _register(filterId, subscriber) {
        this.#subs.set(filterId, subscriber);
        const pending = this.#pending.get(filterId);
        if (pending) {
            for (const message of pending)subscriber._handleMessage(message);
            this.#pending.delete(filterId);
        }
    }
    async _send(payload) {
        // WebSocket provider doesn't accept batches
        (0, $634aa51198273feb$export$c3d31707e5030f5e)(!Array.isArray(payload), "WebSocket does not support batch send", "payload", payload);
        // @TODO: stringify payloads here and store to prevent mutations
        // Prepare a promise to respond to
        const promise = new Promise((resolve, reject)=>{
            this.#callbacks.set(payload.id, {
                payload: payload,
                resolve: resolve,
                reject: reject
            });
        });
        // Wait until the socket is connected before writing to it
        await this._waitUntilReady();
        // Write the request to the socket
        await this._write(JSON.stringify(payload));
        return [
            await promise
        ];
    }
    // Sub-classes must call this once they are connected
    /*
    async _start(): Promise<void> {
        if (this.#ready) { return; }

        for (const { payload } of this.#callbacks.values()) {
            await this._write(JSON.stringify(payload));
        }

        this.#ready = (async function() {
            await super._start();
        })();
    }
    */ /**
     *  Sub-classes **must** call this with messages received over their
     *  transport to be processed and dispatched.
     */ async _processMessage(message) {
        const result = JSON.parse(message);
        if (result && typeof result === "object" && "id" in result) {
            const callback = this.#callbacks.get(result.id);
            if (callback == null) {
                this.emit("error", (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("received result for unknown id", "UNKNOWN_ERROR", {
                    reasonCode: "UNKNOWN_ID",
                    result: result
                }));
                return;
            }
            this.#callbacks.delete(result.id);
            callback.resolve(result);
        } else if (result && result.method === "eth_subscription") {
            const filterId = result.params.subscription;
            const subscriber = this.#subs.get(filterId);
            if (subscriber) subscriber._handleMessage(result.params.result);
            else {
                let pending = this.#pending.get(filterId);
                if (pending == null) {
                    pending = [];
                    this.#pending.set(filterId, pending);
                }
                pending.push(result.params.result);
            }
        } else {
            this.emit("error", (0, $634aa51198273feb$export$5a4bb2b1c89bdce7)("received unexpected message", "UNKNOWN_ERROR", {
                reasonCode: "UNEXPECTED_MESSAGE",
                result: result
            }));
            return;
        }
    }
    /**
     *  Sub-classes **must** override this to send %%message%% over their
     *  transport.
     */ async _write(message) {
        throw new Error("sub-classes must override this");
    }
}


class $a4b2d0e19089cb78$export$bfafe629242f30bd extends (0, $f5c7ec5fba95f5a4$export$783b29abdab77db7) {
    #connect;
    #websocket;
    get websocket() {
        if (this.#websocket == null) throw new Error("websocket closed");
        return this.#websocket;
    }
    constructor(url, network){
        super(network);
        if (typeof url === "string") {
            this.#connect = ()=>{
                return new (0, $1ac063f746decd00$export$3909fb301d3dc8c9)(url);
            };
            this.#websocket = this.#connect();
        } else if (typeof url === "function") {
            this.#connect = url;
            this.#websocket = url();
        } else {
            this.#connect = null;
            this.#websocket = url;
        }
        this.websocket.onopen = async ()=>{
            try {
                await this._start();
                this.resume();
            } catch (error) {
                console.log("failed to start WebsocketProvider", error);
            // @TODO: now what? Attempt reconnect?
            }
        };
        this.websocket.onmessage = (message)=>{
            this._processMessage(message.data);
        };
    /*
                this.websocket.onclose = (event) => {
                    // @TODO: What event.code should we reconnect on?
                    const reconnect = false;
                    if (reconnect) {
                        this.pause(true);
                        if (this.#connect) {
                            this.#websocket = this.#connect();
                            this.#websocket.onopen = ...
                            // @TODO: this requires the super class to rebroadcast; move it there
                        }
                        this._reconnect();
                    }
                };
        */ }
    async _write(message) {
        this.websocket.send(message);
    }
    async destroy() {
        if (this.#websocket != null) {
            this.#websocket.close();
            this.#websocket = null;
        }
        super.destroy();
    }
}


var $c791a81b37c8c0da$exports = {};
$c791a81b37c8c0da$exports = JSON.parse('{"contractName":"Pixelflux1","abi":[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyLayer","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"numLayersToAdd","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyMultipleLayers","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[],"name":"calculateTotalValue","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"colorValues","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllCellStates","outputs":[{"components":[{"internalType":"uint256","name":"baseValue","type":"uint256"},{"components":[{"internalType":"address payable","name":"owner","type":"address"},{"internalType":"string","name":"color","type":"string"}],"internalType":"struct BaseContract.Layer[]","name":"layers","type":"tuple[]"}],"internalType":"struct BaseContract.Cell[][]","name":"","type":"tuple[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllTopLayers","outputs":[{"internalType":"address payable[][]","name":"","type":"address[][]"},{"internalType":"string[][]","name":"","type":"string[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getCellState","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"string","name":"","type":"string"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getTopLayerOfCell","outputs":[{"internalType":"address payable","name":"","type":"address"},{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"grid","outputs":[{"internalType":"uint256","name":"baseValue","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridHeight","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridWidth","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"initialValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"layerIndex","type":"uint256"},{"internalType":"string","name":"newColor","type":"string"}],"name":"setLayerColor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawFunds","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isContractEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true}],"metadata":"{\\"compiler\\":{\\"version\\":\\"0.8.13+commit.abaa5c0e\\"},\\"language\\":\\"Solidity\\",\\"output\\":{\\"abi\\":[{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"buyer\\",\\"type\\":\\"address\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayers\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"LayerPurchased\\",\\"type\\":\\"event\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyLayer\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayersToAdd\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyMultipleLayers\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"calculateTotalValue\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"colorValues\\",\\"outputs\\":[{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllCellStates\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"},{\\"components\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"owner\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"internalType\\":\\"struct BaseContract.Layer[]\\",\\"name\\":\\"layers\\",\\"type\\":\\"tuple[]\\"}],\\"internalType\\":\\"struct BaseContract.Cell[][]\\",\\"name\\":\\"\\",\\"type\\":\\"tuple[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllTopLayers\\",\\"outputs\\":[{\\"internalType\\":\\"address payable[][]\\",\\"name\\":\\"\\",\\"type\\":\\"address[][]\\"},{\\"internalType\\":\\"string[][]\\",\\"name\\":\\"\\",\\"type\\":\\"string[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getCellState\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getTopLayerOfCell\\",\\"outputs\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"grid\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridHeight\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridWidth\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"initialValues\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"isContractEnabled\\",\\"outputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"owner\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"layerIndex\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"newColor\\",\\"type\\":\\"string\\"}],\\"name\\":\\"setLayerColor\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"withdrawFunds\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"}],\\"devdoc\\":{\\"kind\\":\\"dev\\",\\"methods\\":{},\\"version\\":1},\\"userdoc\\":{\\"kind\\":\\"user\\",\\"methods\\":{},\\"version\\":1}},\\"settings\\":{\\"compilationTarget\\":{\\"project:/contracts/Pixelflux1.sol\\":\\"Pixelflux1\\"},\\"evmVersion\\":\\"london\\",\\"libraries\\":{},\\"metadata\\":{\\"bytecodeHash\\":\\"ipfs\\"},\\"optimizer\\":{\\"enabled\\":false,\\"runs\\":200},\\"remappings\\":[]},\\"sources\\":{\\"project:/contracts/BaseContract.sol\\":{\\"keccak256\\":\\"0x7d0f9ba810e1d7cf1721920a8797ef253ce9a9cf71129aaa1c263e3de4dde3e8\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://5fdfd3c2b7e7f8684d628a5e35b6c13f2eeced22dbf20b16aff49e676a775228\\",\\"dweb:/ipfs/QmRExf7WwUASUu7ZxuPu3bXSri2tnSzooLR3s6fdmZ4wzz\\"]},\\"project:/contracts/DataStorage1.sol\\":{\\"keccak256\\":\\"0xc14061a8724ef83dfcc6ea8bdac087874ea8a4776778fda7c8de5fddfdf3319d\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://462df3e3b8aa8f510e36cec70b19a347994be80b257b8fca8efb13774ca01100\\",\\"dweb:/ipfs/QmbRPAdPjMrV1MBkUVBGsRvnWego2PFR8ueHRqa7NdtPcm\\"]},\\"project:/contracts/Pixelflux1.sol\\":{\\"keccak256\\":\\"0x5e7b019070e9fe4c635c08c147f3bbac6515823ce3acc14b99172b2ddb0375c8\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://372fee8fcfe831583e06bad4fe55a9329e759aba8e36c84170a6bcf2ac76d85d\\",\\"dweb:/ipfs/Qmf4GMnwLRo6QSjdaoCgAheam1AJ2zQpjVbgoPZEpBpBd4\\"]}},\\"version\\":1}","bytecode":"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","deployedBytecode":"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","immutableReferences":{},"generatedSources":[{"ast":{"nodeType":"YulBlock","src":"0:702:7","statements":[{"body":{"nodeType":"YulBlock","src":"35:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"52:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"55:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"45:6:7"},"nodeType":"YulFunctionCall","src":"45:88:7"},"nodeType":"YulExpressionStatement","src":"45:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"149:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"152:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"142:6:7"},"nodeType":"YulFunctionCall","src":"142:15:7"},"nodeType":"YulExpressionStatement","src":"142:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"173:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"176:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"166:6:7"},"nodeType":"YulFunctionCall","src":"166:15:7"},"nodeType":"YulExpressionStatement","src":"166:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"7:180:7"},{"body":{"nodeType":"YulBlock","src":"221:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"238:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"241:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"231:6:7"},"nodeType":"YulFunctionCall","src":"231:88:7"},"nodeType":"YulExpressionStatement","src":"231:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"335:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"338:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"328:6:7"},"nodeType":"YulFunctionCall","src":"328:15:7"},"nodeType":"YulExpressionStatement","src":"328:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"359:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"362:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"352:6:7"},"nodeType":"YulFunctionCall","src":"352:15:7"},"nodeType":"YulExpressionStatement","src":"352:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"193:180:7"},{"body":{"nodeType":"YulBlock","src":"430:269:7","statements":[{"nodeType":"YulAssignment","src":"440:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"454:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"460:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"450:3:7"},"nodeType":"YulFunctionCall","src":"450:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"440:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"471:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"501:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"507:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"497:3:7"},"nodeType":"YulFunctionCall","src":"497:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"475:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"548:51:7","statements":[{"nodeType":"YulAssignment","src":"562:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"576:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"584:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"572:3:7"},"nodeType":"YulFunctionCall","src":"572:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"562:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"528:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"521:6:7"},"nodeType":"YulFunctionCall","src":"521:26:7"},"nodeType":"YulIf","src":"518:81:7"},{"body":{"nodeType":"YulBlock","src":"651:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"665:16:7"},"nodeType":"YulFunctionCall","src":"665:18:7"},"nodeType":"YulExpressionStatement","src":"665:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"615:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"638:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"646:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"635:2:7"},"nodeType":"YulFunctionCall","src":"635:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"612:2:7"},"nodeType":"YulFunctionCall","src":"612:38:7"},"nodeType":"YulIf","src":"609:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"414:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"423:6:7","type":""}],"src":"379:320:7"}]},"contents":"{\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"deployedGeneratedSources":[{"ast":{"nodeType":"YulBlock","src":"0:39876:7","statements":[{"body":{"nodeType":"YulBlock","src":"114:40:7","statements":[{"nodeType":"YulAssignment","src":"125:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"141:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"135:5:7"},"nodeType":"YulFunctionCall","src":"135:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"125:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"97:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"107:6:7","type":""}],"src":"7:147:7"},{"body":{"nodeType":"YulBlock","src":"304:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"321:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"326:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"314:6:7"},"nodeType":"YulFunctionCall","src":"314:19:7"},"nodeType":"YulExpressionStatement","src":"314:19:7"},{"nodeType":"YulAssignment","src":"342:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"361:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"366:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"357:3:7"},"nodeType":"YulFunctionCall","src":"357:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"342:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"276:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"281:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"292:11:7","type":""}],"src":"160:217:7"},{"body":{"nodeType":"YulBlock","src":"488:60:7","statements":[{"nodeType":"YulAssignment","src":"498:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"506:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"498:4:7"}]},{"nodeType":"YulAssignment","src":"519:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"531:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"536:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"527:3:7"},"nodeType":"YulFunctionCall","src":"527:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"519:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"475:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"483:4:7","type":""}],"src":"383:165:7"},{"body":{"nodeType":"YulBlock","src":"636:40:7","statements":[{"nodeType":"YulAssignment","src":"647:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"663:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"657:5:7"},"nodeType":"YulFunctionCall","src":"657:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"647:6:7"}]}]},"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"619:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"629:6:7","type":""}],"src":"554:122:7"},{"body":{"nodeType":"YulBlock","src":"791:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"808:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"813:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"801:6:7"},"nodeType":"YulFunctionCall","src":"801:19:7"},"nodeType":"YulExpressionStatement","src":"801:19:7"},{"nodeType":"YulAssignment","src":"829:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"848:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"853:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"844:3:7"},"nodeType":"YulFunctionCall","src":"844:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"829:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"763:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"768:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"779:11:7","type":""}],"src":"682:182:7"},{"body":{"nodeType":"YulBlock","src":"950:60:7","statements":[{"nodeType":"YulAssignment","src":"960:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"968:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"960:4:7"}]},{"nodeType":"YulAssignment","src":"981:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"993:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"989:3:7"},"nodeType":"YulFunctionCall","src":"989:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"981:4:7"}]}]},"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"937:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"945:4:7","type":""}],"src":"870:140:7"},{"body":{"nodeType":"YulBlock","src":"1061:81:7","statements":[{"nodeType":"YulAssignment","src":"1071:65:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1086:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"1093:42:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1082:3:7"},"nodeType":"YulFunctionCall","src":"1082:54:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1071:7:7"}]}]},"name":"cleanup_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1043:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1053:7:7","type":""}],"src":"1016:126:7"},{"body":{"nodeType":"YulBlock","src":"1201:51:7","statements":[{"nodeType":"YulAssignment","src":"1211:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1240:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"1222:17:7"},"nodeType":"YulFunctionCall","src":"1222:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1211:7:7"}]}]},"name":"cleanup_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1183:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1193:7:7","type":""}],"src":"1148:104:7"},{"body":{"nodeType":"YulBlock","src":"1329:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1346:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1377:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"1351:25:7"},"nodeType":"YulFunctionCall","src":"1351:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1339:6:7"},"nodeType":"YulFunctionCall","src":"1339:45:7"},"nodeType":"YulExpressionStatement","src":"1339:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1317:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1324:3:7","type":""}],"src":"1258:132:7"},{"body":{"nodeType":"YulBlock","src":"1492:115:7","statements":[{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"1552:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"1560:3:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"1502:49:7"},"nodeType":"YulFunctionCall","src":"1502:62:7"},"nodeType":"YulExpressionStatement","src":"1502:62:7"},{"nodeType":"YulAssignment","src":"1573:28:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1591:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1596:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1587:3:7"},"nodeType":"YulFunctionCall","src":"1587:14:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"1573:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"1465:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1473:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"1481:10:7","type":""}],"src":"1396:211:7"},{"body":{"nodeType":"YulBlock","src":"1696:38:7","statements":[{"nodeType":"YulAssignment","src":"1706:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"1718:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1723:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1714:3:7"},"nodeType":"YulFunctionCall","src":"1714:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"1706:4:7"}]}]},"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"1683:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"1691:4:7","type":""}],"src":"1613:121:7"},{"body":{"nodeType":"YulBlock","src":"1916:646:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1926:76:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1996:5:7"}],"functionName":{"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"1940:55:7"},"nodeType":"YulFunctionCall","src":"1940:62:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"1930:6:7","type":""}]},{"nodeType":"YulAssignment","src":"2011:91:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"2090:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"2095:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2018:71:7"},"nodeType":"YulFunctionCall","src":"2018:84:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2011:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"2111:79:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"2184:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2126:57:7"},"nodeType":"YulFunctionCall","src":"2126:64:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"2115:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"2199:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"2213:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"2203:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"2289:248:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2303:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2330:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"2324:5:7"},"nodeType":"YulFunctionCall","src":"2324:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"2307:13:7","type":""}]},{"nodeType":"YulAssignment","src":"2350:86:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"2417:13:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2432:3:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"2357:59:7"},"nodeType":"YulFunctionCall","src":"2357:79:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2350:3:7"}]},{"nodeType":"YulAssignment","src":"2449:78:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2520:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2459:60:7"},"nodeType":"YulFunctionCall","src":"2459:68:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2449:6:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2251:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"2254:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"2248:2:7"},"nodeType":"YulFunctionCall","src":"2248:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"2262:18:7","statements":[{"nodeType":"YulAssignment","src":"2264:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2273:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"2276:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2269:3:7"},"nodeType":"YulFunctionCall","src":"2269:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"2264:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"2233:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2235:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"2244:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"2239:1:7","type":""}]}]},"src":"2229:308:7"},{"nodeType":"YulAssignment","src":"2546:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"2553:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"2546:3:7"}]}]},"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1895:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1902:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"1911:3:7","type":""}],"src":"1786:776:7"},{"body":{"nodeType":"YulBlock","src":"2714:142:7","statements":[{"nodeType":"YulAssignment","src":"2724:126:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"2838:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2846:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2738:99:7"},"nodeType":"YulFunctionCall","src":"2738:112:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"2724:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"2687:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"2695:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"2703:10:7","type":""}],"src":"2568:288:7"},{"body":{"nodeType":"YulBlock","src":"2970:38:7","statements":[{"nodeType":"YulAssignment","src":"2980:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"2992:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"2997:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2988:3:7"},"nodeType":"YulFunctionCall","src":"2988:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"2980:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"2957:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"2965:4:7","type":""}],"src":"2862:146:7"},{"body":{"nodeType":"YulBlock","src":"3254:985:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3264:101:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3359:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3278:80:7"},"nodeType":"YulFunctionCall","src":"3278:87:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"3268:6:7","type":""}]},{"nodeType":"YulAssignment","src":"3374:126:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3488:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"3493:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"3381:106:7"},"nodeType":"YulFunctionCall","src":"3381:119:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"3374:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"3509:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"3526:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"3513:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3538:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3554:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"3563:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"3571:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"3559:3:7"},"nodeType":"YulFunctionCall","src":"3559:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3550:3:7"},"nodeType":"YulFunctionCall","src":"3550:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"3542:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3586:104:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3684:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3601:82:7"},"nodeType":"YulFunctionCall","src":"3601:89:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"3590:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3699:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"3713:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"3703:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"3789:405:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3810:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"3819:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"3825:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"3815:3:7"},"nodeType":"YulFunctionCall","src":"3815:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"3803:6:7"},"nodeType":"YulFunctionCall","src":"3803:33:7"},"nodeType":"YulExpressionStatement","src":"3803:33:7"},{"nodeType":"YulVariableDeclaration","src":"3849:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"3876:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"3870:5:7"},"nodeType":"YulFunctionCall","src":"3870:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"3853:13:7","type":""}]},{"nodeType":"YulAssignment","src":"3896:138:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"4014:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"4029:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3904:109:7"},"nodeType":"YulFunctionCall","src":"3904:130:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"3896:4:7"}]},{"nodeType":"YulAssignment","src":"4047:103:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4143:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"4057:85:7"},"nodeType":"YulFunctionCall","src":"4057:93:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4047:6:7"}]},{"nodeType":"YulAssignment","src":"4163:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4174:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4179:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4170:3:7"},"nodeType":"YulFunctionCall","src":"4170:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4163:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3751:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"3754:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"3748:2:7"},"nodeType":"YulFunctionCall","src":"3748:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"3762:18:7","statements":[{"nodeType":"YulAssignment","src":"3764:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3773:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"3776:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3769:3:7"},"nodeType":"YulFunctionCall","src":"3769:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"3764:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"3733:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3735:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"3744:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"3739:1:7","type":""}]}]},"src":"3729:465:7"},{"nodeType":"YulAssignment","src":"4203:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"4210:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4203:3:7"}]},{"nodeType":"YulAssignment","src":"4223:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"4230:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"4223:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"3233:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"3240:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"3249:3:7","type":""}],"src":"3064:1175:7"},{"body":{"nodeType":"YulBlock","src":"4354:40:7","statements":[{"nodeType":"YulAssignment","src":"4365:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4381:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4375:5:7"},"nodeType":"YulFunctionCall","src":"4375:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4365:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4337:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4347:6:7","type":""}],"src":"4245:149:7"},{"body":{"nodeType":"YulBlock","src":"4546:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"4568:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"4556:6:7"},"nodeType":"YulFunctionCall","src":"4556:19:7"},"nodeType":"YulExpressionStatement","src":"4556:19:7"},{"nodeType":"YulAssignment","src":"4584:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4603:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4608:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4599:3:7"},"nodeType":"YulFunctionCall","src":"4599:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"4584:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"4518:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"4523:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"4534:11:7","type":""}],"src":"4400:219:7"},{"body":{"nodeType":"YulBlock","src":"4732:60:7","statements":[{"nodeType":"YulAssignment","src":"4742:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"4750:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4742:4:7"}]},{"nodeType":"YulAssignment","src":"4763:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"4775:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4780:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4771:3:7"},"nodeType":"YulFunctionCall","src":"4771:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4763:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"4719:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"4727:4:7","type":""}],"src":"4625:167:7"},{"body":{"nodeType":"YulBlock","src":"4882:40:7","statements":[{"nodeType":"YulAssignment","src":"4893:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4909:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4903:5:7"},"nodeType":"YulFunctionCall","src":"4903:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4893:6:7"}]}]},"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4865:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4875:6:7","type":""}],"src":"4798:124:7"},{"body":{"nodeType":"YulBlock","src":"5039:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5056:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5061:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5049:6:7"},"nodeType":"YulFunctionCall","src":"5049:19:7"},"nodeType":"YulExpressionStatement","src":"5049:19:7"},{"nodeType":"YulAssignment","src":"5077:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5096:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5101:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5092:3:7"},"nodeType":"YulFunctionCall","src":"5092:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5077:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5011:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5016:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5027:11:7","type":""}],"src":"4928:184:7"},{"body":{"nodeType":"YulBlock","src":"5200:60:7","statements":[{"nodeType":"YulAssignment","src":"5210:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"5218:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5210:4:7"}]},{"nodeType":"YulAssignment","src":"5231:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"5243:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5248:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5239:3:7"},"nodeType":"YulFunctionCall","src":"5239:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5231:4:7"}]}]},"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"5187:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"5195:4:7","type":""}],"src":"5118:142:7"},{"body":{"nodeType":"YulBlock","src":"5325:40:7","statements":[{"nodeType":"YulAssignment","src":"5336:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5352:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5346:5:7"},"nodeType":"YulFunctionCall","src":"5346:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"5336:6:7"}]}]},"name":"array_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5308:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"5318:6:7","type":""}],"src":"5266:99:7"},{"body":{"nodeType":"YulBlock","src":"5457:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5474:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5479:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5467:6:7"},"nodeType":"YulFunctionCall","src":"5467:19:7"},"nodeType":"YulExpressionStatement","src":"5467:19:7"},{"nodeType":"YulAssignment","src":"5495:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5514:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5519:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5510:3:7"},"nodeType":"YulFunctionCall","src":"5510:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5495:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5429:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5434:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5445:11:7","type":""}],"src":"5371:159:7"},{"body":{"nodeType":"YulBlock","src":"5585:258:7","statements":[{"nodeType":"YulVariableDeclaration","src":"5595:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"5604:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"5599:1:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"5664:63:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5689:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5694:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5685:3:7"},"nodeType":"YulFunctionCall","src":"5685:11:7"},{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"5708:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5713:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5704:3:7"},"nodeType":"YulFunctionCall","src":"5704:11:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5698:5:7"},"nodeType":"YulFunctionCall","src":"5698:18:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5678:6:7"},"nodeType":"YulFunctionCall","src":"5678:39:7"},"nodeType":"YulExpressionStatement","src":"5678:39:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5625:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5628:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"5622:2:7"},"nodeType":"YulFunctionCall","src":"5622:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"5636:19:7","statements":[{"nodeType":"YulAssignment","src":"5638:15:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5647:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"5650:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5643:3:7"},"nodeType":"YulFunctionCall","src":"5643:10:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"5638:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"5618:3:7","statements":[]},"src":"5614:113:7"},{"body":{"nodeType":"YulBlock","src":"5761:76:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5811:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5816:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5807:3:7"},"nodeType":"YulFunctionCall","src":"5807:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"5825:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5800:6:7"},"nodeType":"YulFunctionCall","src":"5800:27:7"},"nodeType":"YulExpressionStatement","src":"5800:27:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5742:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5745:6:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"5739:2:7"},"nodeType":"YulFunctionCall","src":"5739:13:7"},"nodeType":"YulIf","src":"5736:101:7"}]},"name":"copy_memory_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"5567:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"5572:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5577:6:7","type":""}],"src":"5536:307:7"},{"body":{"nodeType":"YulBlock","src":"5897:54:7","statements":[{"nodeType":"YulAssignment","src":"5907:38:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5925:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"5932:2:7","type":"","value":"31"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5921:3:7"},"nodeType":"YulFunctionCall","src":"5921:14:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"5941:2:7","type":"","value":"31"}],"functionName":{"name":"not","nodeType":"YulIdentifier","src":"5937:3:7"},"nodeType":"YulFunctionCall","src":"5937:7:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"5917:3:7"},"nodeType":"YulFunctionCall","src":"5917:28:7"},"variableNames":[{"name":"result","nodeType":"YulIdentifier","src":"5907:6:7"}]}]},"name":"round_up_to_mul_of_32","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5880:5:7","type":""}],"returnVariables":[{"name":"result","nodeType":"YulTypedName","src":"5890:6:7","type":""}],"src":"5849:102:7"},{"body":{"nodeType":"YulBlock","src":"6039:262:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6049:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6096:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6063:32:7"},"nodeType":"YulFunctionCall","src":"6063:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6053:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6111:68:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6167:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6172:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6118:48:7"},"nodeType":"YulFunctionCall","src":"6118:61:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6111:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6214:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"6221:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6210:3:7"},"nodeType":"YulFunctionCall","src":"6210:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6228:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6233:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"6188:21:7"},"nodeType":"YulFunctionCall","src":"6188:52:7"},"nodeType":"YulExpressionStatement","src":"6188:52:7"},{"nodeType":"YulAssignment","src":"6249:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6260:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"6287:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"6265:21:7"},"nodeType":"YulFunctionCall","src":"6265:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6256:3:7"},"nodeType":"YulFunctionCall","src":"6256:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"6249:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6020:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6027:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6035:3:7","type":""}],"src":"5957:344:7"},{"body":{"nodeType":"YulBlock","src":"6407:96:7","statements":[{"nodeType":"YulAssignment","src":"6417:80:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"6485:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6493:3:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6431:53:7"},"nodeType":"YulFunctionCall","src":"6431:66:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"6417:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"6380:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6388:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"6396:10:7","type":""}],"src":"6307:196:7"},{"body":{"nodeType":"YulBlock","src":"6594:38:7","statements":[{"nodeType":"YulAssignment","src":"6604:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"6616:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"6621:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6612:3:7"},"nodeType":"YulFunctionCall","src":"6612:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"6604:4:7"}]}]},"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"6581:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"6589:4:7","type":""}],"src":"6509:123:7"},{"body":{"nodeType":"YulBlock","src":"6800:837:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6810:78:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6882:5:7"}],"functionName":{"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6824:57:7"},"nodeType":"YulFunctionCall","src":"6824:64:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6814:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6897:93:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6978:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6983:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6904:73:7"},"nodeType":"YulFunctionCall","src":"6904:86:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6897:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"6999:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7016:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"7003:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7028:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7044:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"7053:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"7061:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"7049:3:7"},"nodeType":"YulFunctionCall","src":"7049:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7040:3:7"},"nodeType":"YulFunctionCall","src":"7040:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"7032:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7076:81:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"7151:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7091:59:7"},"nodeType":"YulFunctionCall","src":"7091:66:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"7080:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7166:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"7180:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"7170:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"7256:336:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7277:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"7286:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"7292:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"7282:3:7"},"nodeType":"YulFunctionCall","src":"7282:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"7270:6:7"},"nodeType":"YulFunctionCall","src":"7270:33:7"},"nodeType":"YulExpressionStatement","src":"7270:33:7"},{"nodeType":"YulVariableDeclaration","src":"7316:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7343:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"7337:5:7"},"nodeType":"YulFunctionCall","src":"7337:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"7320:13:7","type":""}]},{"nodeType":"YulAssignment","src":"7363:92:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"7435:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"7450:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"7371:63:7"},"nodeType":"YulFunctionCall","src":"7371:84:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"7363:4:7"}]},{"nodeType":"YulAssignment","src":"7468:80:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7541:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7478:62:7"},"nodeType":"YulFunctionCall","src":"7478:70:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7468:6:7"}]},{"nodeType":"YulAssignment","src":"7561:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7572:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"7577:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7568:3:7"},"nodeType":"YulFunctionCall","src":"7568:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7561:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7218:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"7221:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"7215:2:7"},"nodeType":"YulFunctionCall","src":"7215:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"7229:18:7","statements":[{"nodeType":"YulAssignment","src":"7231:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7240:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"7243:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7236:3:7"},"nodeType":"YulFunctionCall","src":"7236:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"7231:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"7200:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"7202:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"7211:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"7206:1:7","type":""}]}]},"src":"7196:396:7"},{"nodeType":"YulAssignment","src":"7601:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"7608:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7601:3:7"}]},{"nodeType":"YulAssignment","src":"7621:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7628:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"7621:3:7"}]}]},"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6779:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6786:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6795:3:7","type":""}],"src":"6666:971:7"},{"body":{"nodeType":"YulBlock","src":"7793:146:7","statements":[{"nodeType":"YulAssignment","src":"7803:130:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"7921:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"7929:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7817:103:7"},"nodeType":"YulFunctionCall","src":"7817:116:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"7803:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"7766:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"7774:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"7782:10:7","type":""}],"src":"7643:296:7"},{"body":{"nodeType":"YulBlock","src":"8055:38:7","statements":[{"nodeType":"YulAssignment","src":"8065:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"8077:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"8082:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8073:3:7"},"nodeType":"YulFunctionCall","src":"8073:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"8065:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"8042:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"8050:4:7","type":""}],"src":"7945:148:7"},{"body":{"nodeType":"YulBlock","src":"8325:997:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8335:103:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8432:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8349:82:7"},"nodeType":"YulFunctionCall","src":"8349:89:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"8339:6:7","type":""}]},{"nodeType":"YulAssignment","src":"8447:128:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"8568:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"8454:108:7"},"nodeType":"YulFunctionCall","src":"8454:121:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"8447:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"8584:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"8601:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"8588:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8613:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8629:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"8638:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"8646:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"8634:3:7"},"nodeType":"YulFunctionCall","src":"8634:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8625:3:7"},"nodeType":"YulFunctionCall","src":"8625:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"8617:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8661:106:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8761:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8676:84:7"},"nodeType":"YulFunctionCall","src":"8676:91:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"8665:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8776:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"8790:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"8780:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"8866:411:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8887:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"8896:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"8902:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"8892:3:7"},"nodeType":"YulFunctionCall","src":"8892:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"8880:6:7"},"nodeType":"YulFunctionCall","src":"8880:33:7"},"nodeType":"YulExpressionStatement","src":"8880:33:7"},{"nodeType":"YulVariableDeclaration","src":"8926:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"8953:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"8947:5:7"},"nodeType":"YulFunctionCall","src":"8947:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"8930:13:7","type":""}]},{"nodeType":"YulAssignment","src":"8973:142:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"9095:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9110:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8981:113:7"},"nodeType":"YulFunctionCall","src":"8981:134:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"8973:4:7"}]},{"nodeType":"YulAssignment","src":"9128:105:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9226:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"9138:87:7"},"nodeType":"YulFunctionCall","src":"9138:95:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9128:6:7"}]},{"nodeType":"YulAssignment","src":"9246:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"9257:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"9262:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9253:3:7"},"nodeType":"YulFunctionCall","src":"9253:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9246:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8828:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"8831:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"8825:2:7"},"nodeType":"YulFunctionCall","src":"8825:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"8839:18:7","statements":[{"nodeType":"YulAssignment","src":"8841:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8850:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"8853:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8846:3:7"},"nodeType":"YulFunctionCall","src":"8846:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"8841:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"8810:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8812:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"8821:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"8816:1:7","type":""}]}]},"src":"8806:471:7"},{"nodeType":"YulAssignment","src":"9286:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"9293:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9286:3:7"}]},{"nodeType":"YulAssignment","src":"9306:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"9313:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"9306:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"8304:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"8311:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"8320:3:7","type":""}],"src":"8131:1191:7"},{"body":{"nodeType":"YulBlock","src":"9690:544:7","statements":[{"nodeType":"YulAssignment","src":"9700:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9712:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9723:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9708:3:7"},"nodeType":"YulFunctionCall","src":"9708:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9700:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9747:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9758:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9743:3:7"},"nodeType":"YulFunctionCall","src":"9743:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"9766:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"9772:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"9762:3:7"},"nodeType":"YulFunctionCall","src":"9762:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9736:6:7"},"nodeType":"YulFunctionCall","src":"9736:47:7"},"nodeType":"YulExpressionStatement","src":"9736:47:7"},{"nodeType":"YulAssignment","src":"9792:182:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"9960:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9969:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"9800:159:7"},"nodeType":"YulFunctionCall","src":"9800:174:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9792:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9995:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"10006:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9991:3:7"},"nodeType":"YulFunctionCall","src":"9991:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"10015:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"10021:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"10011:3:7"},"nodeType":"YulFunctionCall","src":"10011:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9984:6:7"},"nodeType":"YulFunctionCall","src":"9984:48:7"},"nodeType":"YulExpressionStatement","src":"9984:48:7"},{"nodeType":"YulAssignment","src":"10041:186:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"10213:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"10222:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"10049:163:7"},"nodeType":"YulFunctionCall","src":"10049:178:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"10041:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"9654:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"9666:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"9674:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"9685:4:7","type":""}],"src":"9328:906:7"},{"body":{"nodeType":"YulBlock","src":"10280:35:7","statements":[{"nodeType":"YulAssignment","src":"10290:19:7","value":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10306:2:7","type":"","value":"64"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"10300:5:7"},"nodeType":"YulFunctionCall","src":"10300:9:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"10290:6:7"}]}]},"name":"allocate_unbounded","nodeType":"YulFunctionDefinition","returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"10273:6:7","type":""}],"src":"10240:75:7"},{"body":{"nodeType":"YulBlock","src":"10410:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10427:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10430:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10420:6:7"},"nodeType":"YulFunctionCall","src":"10420:12:7"},"nodeType":"YulExpressionStatement","src":"10420:12:7"}]},"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulFunctionDefinition","src":"10321:117:7"},{"body":{"nodeType":"YulBlock","src":"10533:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10550:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10553:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10543:6:7"},"nodeType":"YulFunctionCall","src":"10543:12:7"},"nodeType":"YulExpressionStatement","src":"10543:12:7"}]},"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulFunctionDefinition","src":"10444:117:7"},{"body":{"nodeType":"YulBlock","src":"10612:32:7","statements":[{"nodeType":"YulAssignment","src":"10622:16:7","value":{"name":"value","nodeType":"YulIdentifier","src":"10633:5:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"10622:7:7"}]}]},"name":"cleanup_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10594:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"10604:7:7","type":""}],"src":"10567:77:7"},{"body":{"nodeType":"YulBlock","src":"10693:79:7","statements":[{"body":{"nodeType":"YulBlock","src":"10750:16:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10759:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10762:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10752:6:7"},"nodeType":"YulFunctionCall","src":"10752:12:7"},"nodeType":"YulExpressionStatement","src":"10752:12:7"}]},"condition":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10716:5:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10741:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"10723:17:7"},"nodeType":"YulFunctionCall","src":"10723:24:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"10713:2:7"},"nodeType":"YulFunctionCall","src":"10713:35:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"10706:6:7"},"nodeType":"YulFunctionCall","src":"10706:43:7"},"nodeType":"YulIf","src":"10703:63:7"}]},"name":"validator_revert_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10686:5:7","type":""}],"src":"10650:122:7"},{"body":{"nodeType":"YulBlock","src":"10830:87:7","statements":[{"nodeType":"YulAssignment","src":"10840:29:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"10862:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"10849:12:7"},"nodeType":"YulFunctionCall","src":"10849:20:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"10840:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10905:5:7"}],"functionName":{"name":"validator_revert_t_uint256","nodeType":"YulIdentifier","src":"10878:26:7"},"nodeType":"YulFunctionCall","src":"10878:33:7"},"nodeType":"YulExpressionStatement","src":"10878:33:7"}]},"name":"abi_decode_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"10808:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"10816:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"10824:5:7","type":""}],"src":"10778:139:7"},{"body":{"nodeType":"YulBlock","src":"11012:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11029:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11032:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11022:6:7"},"nodeType":"YulFunctionCall","src":"11022:12:7"},"nodeType":"YulExpressionStatement","src":"11022:12:7"}]},"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulFunctionDefinition","src":"10923:117:7"},{"body":{"nodeType":"YulBlock","src":"11135:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11152:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11155:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11145:6:7"},"nodeType":"YulFunctionCall","src":"11145:12:7"},"nodeType":"YulExpressionStatement","src":"11145:12:7"}]},"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulFunctionDefinition","src":"11046:117:7"},{"body":{"nodeType":"YulBlock","src":"11197:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11214:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11217:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11207:6:7"},"nodeType":"YulFunctionCall","src":"11207:88:7"},"nodeType":"YulExpressionStatement","src":"11207:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11311:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"11314:4:7","type":"","value":"0x41"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11304:6:7"},"nodeType":"YulFunctionCall","src":"11304:15:7"},"nodeType":"YulExpressionStatement","src":"11304:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11335:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11338:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11328:6:7"},"nodeType":"YulFunctionCall","src":"11328:15:7"},"nodeType":"YulExpressionStatement","src":"11328:15:7"}]},"name":"panic_error_0x41","nodeType":"YulFunctionDefinition","src":"11169:180:7"},{"body":{"nodeType":"YulBlock","src":"11398:238:7","statements":[{"nodeType":"YulVariableDeclaration","src":"11408:58:7","value":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11430:6:7"},{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"11460:4:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11438:21:7"},"nodeType":"YulFunctionCall","src":"11438:27:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"11426:3:7"},"nodeType":"YulFunctionCall","src":"11426:40:7"},"variables":[{"name":"newFreePtr","nodeType":"YulTypedName","src":"11412:10:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"11577:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11579:16:7"},"nodeType":"YulFunctionCall","src":"11579:18:7"},"nodeType":"YulExpressionStatement","src":"11579:18:7"}]},"condition":{"arguments":[{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11520:10:7"},{"kind":"number","nodeType":"YulLiteral","src":"11532:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11517:2:7"},"nodeType":"YulFunctionCall","src":"11517:34:7"},{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11556:10:7"},{"name":"memPtr","nodeType":"YulIdentifier","src":"11568:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"11553:2:7"},"nodeType":"YulFunctionCall","src":"11553:22:7"}],"functionName":{"name":"or","nodeType":"YulIdentifier","src":"11514:2:7"},"nodeType":"YulFunctionCall","src":"11514:62:7"},"nodeType":"YulIf","src":"11511:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11615:2:7","type":"","value":"64"},{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11619:10:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11608:6:7"},"nodeType":"YulFunctionCall","src":"11608:22:7"},"nodeType":"YulExpressionStatement","src":"11608:22:7"}]},"name":"finalize_allocation","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"11384:6:7","type":""},{"name":"size","nodeType":"YulTypedName","src":"11392:4:7","type":""}],"src":"11355:281:7"},{"body":{"nodeType":"YulBlock","src":"11683:88:7","statements":[{"nodeType":"YulAssignment","src":"11693:30:7","value":{"arguments":[],"functionName":{"name":"allocate_unbounded","nodeType":"YulIdentifier","src":"11703:18:7"},"nodeType":"YulFunctionCall","src":"11703:20:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11693:6:7"}]},{"expression":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11752:6:7"},{"name":"size","nodeType":"YulIdentifier","src":"11760:4:7"}],"functionName":{"name":"finalize_allocation","nodeType":"YulIdentifier","src":"11732:19:7"},"nodeType":"YulFunctionCall","src":"11732:33:7"},"nodeType":"YulExpressionStatement","src":"11732:33:7"}]},"name":"allocate_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"size","nodeType":"YulTypedName","src":"11667:4:7","type":""}],"returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"11676:6:7","type":""}],"src":"11642:129:7"},{"body":{"nodeType":"YulBlock","src":"11844:241:7","statements":[{"body":{"nodeType":"YulBlock","src":"11949:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11951:16:7"},"nodeType":"YulFunctionCall","src":"11951:18:7"},"nodeType":"YulExpressionStatement","src":"11951:18:7"}]},"condition":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"11921:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"11929:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11918:2:7"},"nodeType":"YulFunctionCall","src":"11918:30:7"},"nodeType":"YulIf","src":"11915:56:7"},{"nodeType":"YulAssignment","src":"11981:37:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12011:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11989:21:7"},"nodeType":"YulFunctionCall","src":"11989:29:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"11981:4:7"}]},{"nodeType":"YulAssignment","src":"12055:23:7","value":{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"12067:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"12073:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12063:3:7"},"nodeType":"YulFunctionCall","src":"12063:15:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"12055:4:7"}]}]},"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"length","nodeType":"YulTypedName","src":"11828:6:7","type":""}],"returnVariables":[{"name":"size","nodeType":"YulTypedName","src":"11839:4:7","type":""}],"src":"11777:308:7"},{"body":{"nodeType":"YulBlock","src":"12142:103:7","statements":[{"expression":{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12165:3:7"},{"name":"src","nodeType":"YulIdentifier","src":"12170:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12175:6:7"}],"functionName":{"name":"calldatacopy","nodeType":"YulIdentifier","src":"12152:12:7"},"nodeType":"YulFunctionCall","src":"12152:30:7"},"nodeType":"YulExpressionStatement","src":"12152:30:7"},{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12223:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12228:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12219:3:7"},"nodeType":"YulFunctionCall","src":"12219:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"12237:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12212:6:7"},"nodeType":"YulFunctionCall","src":"12212:27:7"},"nodeType":"YulExpressionStatement","src":"12212:27:7"}]},"name":"copy_calldata_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12124:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"12129:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12134:6:7","type":""}],"src":"12091:154:7"},{"body":{"nodeType":"YulBlock","src":"12335:328:7","statements":[{"nodeType":"YulAssignment","src":"12345:75:7","value":{"arguments":[{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12412:6:7"}],"functionName":{"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12370:41:7"},"nodeType":"YulFunctionCall","src":"12370:49:7"}],"functionName":{"name":"allocate_memory","nodeType":"YulIdentifier","src":"12354:15:7"},"nodeType":"YulFunctionCall","src":"12354:66:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12345:5:7"}]},{"expression":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12436:5:7"},{"name":"length","nodeType":"YulIdentifier","src":"12443:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12429:6:7"},"nodeType":"YulFunctionCall","src":"12429:21:7"},"nodeType":"YulExpressionStatement","src":"12429:21:7"},{"nodeType":"YulVariableDeclaration","src":"12459:27:7","value":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12474:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"12481:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12470:3:7"},"nodeType":"YulFunctionCall","src":"12470:16:7"},"variables":[{"name":"dst","nodeType":"YulTypedName","src":"12463:3:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"12524:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulIdentifier","src":"12526:77:7"},"nodeType":"YulFunctionCall","src":"12526:79:7"},"nodeType":"YulExpressionStatement","src":"12526:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12505:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12510:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12501:3:7"},"nodeType":"YulFunctionCall","src":"12501:16:7"},{"name":"end","nodeType":"YulIdentifier","src":"12519:3:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"12498:2:7"},"nodeType":"YulFunctionCall","src":"12498:25:7"},"nodeType":"YulIf","src":"12495:112:7"},{"expression":{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12640:3:7"},{"name":"dst","nodeType":"YulIdentifier","src":"12645:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12650:6:7"}],"functionName":{"name":"copy_calldata_to_memory","nodeType":"YulIdentifier","src":"12616:23:7"},"nodeType":"YulFunctionCall","src":"12616:41:7"},"nodeType":"YulExpressionStatement","src":"12616:41:7"}]},"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12308:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12313:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12321:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12329:5:7","type":""}],"src":"12251:412:7"},{"body":{"nodeType":"YulBlock","src":"12745:278:7","statements":[{"body":{"nodeType":"YulBlock","src":"12794:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulIdentifier","src":"12796:77:7"},"nodeType":"YulFunctionCall","src":"12796:79:7"},"nodeType":"YulExpressionStatement","src":"12796:79:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12773:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12781:4:7","type":"","value":"0x1f"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12769:3:7"},"nodeType":"YulFunctionCall","src":"12769:17:7"},{"name":"end","nodeType":"YulIdentifier","src":"12788:3:7"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"12765:3:7"},"nodeType":"YulFunctionCall","src":"12765:27:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"12758:6:7"},"nodeType":"YulFunctionCall","src":"12758:35:7"},"nodeType":"YulIf","src":"12755:122:7"},{"nodeType":"YulVariableDeclaration","src":"12886:34:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12913:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"12900:12:7"},"nodeType":"YulFunctionCall","src":"12900:20:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"12890:6:7","type":""}]},{"nodeType":"YulAssignment","src":"12929:88:7","value":{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12990:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12986:3:7"},"nodeType":"YulFunctionCall","src":"12986:17:7"},{"name":"length","nodeType":"YulIdentifier","src":"13005:6:7"},{"name":"end","nodeType":"YulIdentifier","src":"13013:3:7"}],"functionName":{"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12938:47:7"},"nodeType":"YulFunctionCall","src":"12938:79:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12929:5:7"}]}]},"name":"abi_decode_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"12723:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12731:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12739:5:7","type":""}],"src":"12683:340:7"},{"body":{"nodeType":"YulBlock","src":"13139:689:7","statements":[{"body":{"nodeType":"YulBlock","src":"13185:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"13187:77:7"},"nodeType":"YulFunctionCall","src":"13187:79:7"},"nodeType":"YulExpressionStatement","src":"13187:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"13160:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"13169:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"13156:3:7"},"nodeType":"YulFunctionCall","src":"13156:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"13181:2:7","type":"","value":"96"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"13152:3:7"},"nodeType":"YulFunctionCall","src":"13152:32:7"},"nodeType":"YulIf","src":"13149:119:7"},{"nodeType":"YulBlock","src":"13278:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13293:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13307:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13297:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13322:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13357:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13368:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13353:3:7"},"nodeType":"YulFunctionCall","src":"13353:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13377:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13332:20:7"},"nodeType":"YulFunctionCall","src":"13332:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"13322:6:7"}]}]},{"nodeType":"YulBlock","src":"13405:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13420:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13434:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13424:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13450:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13485:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13496:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13481:3:7"},"nodeType":"YulFunctionCall","src":"13481:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13505:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13460:20:7"},"nodeType":"YulFunctionCall","src":"13460:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"13450:6:7"}]}]},{"nodeType":"YulBlock","src":"13533:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13548:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13579:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"13590:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13575:3:7"},"nodeType":"YulFunctionCall","src":"13575:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"13562:12:7"},"nodeType":"YulFunctionCall","src":"13562:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13552:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"13641:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"13643:77:7"},"nodeType":"YulFunctionCall","src":"13643:79:7"},"nodeType":"YulExpressionStatement","src":"13643:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"13613:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"13621:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"13610:2:7"},"nodeType":"YulFunctionCall","src":"13610:30:7"},"nodeType":"YulIf","src":"13607:117:7"},{"nodeType":"YulAssignment","src":"13738:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13783:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13794:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13779:3:7"},"nodeType":"YulFunctionCall","src":"13779:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13803:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"13748:30:7"},"nodeType":"YulFunctionCall","src":"13748:63:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"13738:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"13093:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"13104:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"13116:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"13124:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"13132:6:7","type":""}],"src":"13029:799:7"},{"body":{"nodeType":"YulBlock","src":"13899:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"13916:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"13939:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"13921:17:7"},"nodeType":"YulFunctionCall","src":"13921:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"13909:6:7"},"nodeType":"YulFunctionCall","src":"13909:37:7"},"nodeType":"YulExpressionStatement","src":"13909:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"13887:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"13894:3:7","type":""}],"src":"13834:118:7"},{"body":{"nodeType":"YulBlock","src":"14056:124:7","statements":[{"nodeType":"YulAssignment","src":"14066:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14078:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14089:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14074:3:7"},"nodeType":"YulFunctionCall","src":"14074:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"14066:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"14146:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14159:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14170:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14155:3:7"},"nodeType":"YulFunctionCall","src":"14155:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"14102:43:7"},"nodeType":"YulFunctionCall","src":"14102:71:7"},"nodeType":"YulExpressionStatement","src":"14102:71:7"}]},"name":"abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14028:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"14040:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"14051:4:7","type":""}],"src":"13958:222:7"},{"body":{"nodeType":"YulBlock","src":"14269:391:7","statements":[{"body":{"nodeType":"YulBlock","src":"14315:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14317:77:7"},"nodeType":"YulFunctionCall","src":"14317:79:7"},"nodeType":"YulExpressionStatement","src":"14317:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14290:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14299:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14286:3:7"},"nodeType":"YulFunctionCall","src":"14286:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14311:2:7","type":"","value":"64"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14282:3:7"},"nodeType":"YulFunctionCall","src":"14282:32:7"},"nodeType":"YulIf","src":"14279:119:7"},{"nodeType":"YulBlock","src":"14408:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14423:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14437:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14427:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14452:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14487:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14498:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14483:3:7"},"nodeType":"YulFunctionCall","src":"14483:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14507:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14462:20:7"},"nodeType":"YulFunctionCall","src":"14462:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14452:6:7"}]}]},{"nodeType":"YulBlock","src":"14535:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14550:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14564:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14554:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14580:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14615:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14626:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14611:3:7"},"nodeType":"YulFunctionCall","src":"14611:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14635:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14590:20:7"},"nodeType":"YulFunctionCall","src":"14590:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"14580:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14231:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14242:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14254:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14262:6:7","type":""}],"src":"14186:474:7"},{"body":{"nodeType":"YulBlock","src":"14793:818:7","statements":[{"body":{"nodeType":"YulBlock","src":"14840:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14842:77:7"},"nodeType":"YulFunctionCall","src":"14842:79:7"},"nodeType":"YulExpressionStatement","src":"14842:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14814:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14823:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14810:3:7"},"nodeType":"YulFunctionCall","src":"14810:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14835:3:7","type":"","value":"128"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14806:3:7"},"nodeType":"YulFunctionCall","src":"14806:33:7"},"nodeType":"YulIf","src":"14803:120:7"},{"nodeType":"YulBlock","src":"14933:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14948:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14962:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14952:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14977:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15012:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15023:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15008:3:7"},"nodeType":"YulFunctionCall","src":"15008:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15032:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14987:20:7"},"nodeType":"YulFunctionCall","src":"14987:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14977:6:7"}]}]},{"nodeType":"YulBlock","src":"15060:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15075:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15089:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15079:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15105:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15140:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15151:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15136:3:7"},"nodeType":"YulFunctionCall","src":"15136:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15160:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15115:20:7"},"nodeType":"YulFunctionCall","src":"15115:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"15105:6:7"}]}]},{"nodeType":"YulBlock","src":"15188:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15203:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15217:2:7","type":"","value":"64"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15207:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15233:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15268:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15279:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15264:3:7"},"nodeType":"YulFunctionCall","src":"15264:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15288:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15243:20:7"},"nodeType":"YulFunctionCall","src":"15243:53:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"15233:6:7"}]}]},{"nodeType":"YulBlock","src":"15316:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15331:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15362:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"15373:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15358:3:7"},"nodeType":"YulFunctionCall","src":"15358:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"15345:12:7"},"nodeType":"YulFunctionCall","src":"15345:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15335:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"15424:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"15426:77:7"},"nodeType":"YulFunctionCall","src":"15426:79:7"},"nodeType":"YulExpressionStatement","src":"15426:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"15396:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"15404:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"15393:2:7"},"nodeType":"YulFunctionCall","src":"15393:30:7"},"nodeType":"YulIf","src":"15390:117:7"},{"nodeType":"YulAssignment","src":"15521:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15566:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15577:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15562:3:7"},"nodeType":"YulFunctionCall","src":"15562:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15586:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"15531:30:7"},"nodeType":"YulFunctionCall","src":"15531:63:7"},"variableNames":[{"name":"value3","nodeType":"YulIdentifier","src":"15521:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14739:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14750:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14762:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14770:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"14778:6:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"14786:6:7","type":""}],"src":"14666:945:7"},{"body":{"nodeType":"YulBlock","src":"15736:40:7","statements":[{"nodeType":"YulAssignment","src":"15747:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"15763:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"15757:5:7"},"nodeType":"YulFunctionCall","src":"15757:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"15747:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"15719:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"15729:6:7","type":""}],"src":"15617:159:7"},{"body":{"nodeType":"YulBlock","src":"15938:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"15955:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"15960:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"15948:6:7"},"nodeType":"YulFunctionCall","src":"15948:19:7"},"nodeType":"YulExpressionStatement","src":"15948:19:7"},{"nodeType":"YulAssignment","src":"15976:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"15995:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16000:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15991:3:7"},"nodeType":"YulFunctionCall","src":"15991:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"15976:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"15910:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"15915:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"15926:11:7","type":""}],"src":"15782:229:7"},{"body":{"nodeType":"YulBlock","src":"16134:60:7","statements":[{"nodeType":"YulAssignment","src":"16144:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"16152:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16144:4:7"}]},{"nodeType":"YulAssignment","src":"16165:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"16177:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16182:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16173:3:7"},"nodeType":"YulFunctionCall","src":"16173:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16165:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"16121:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"16129:4:7","type":""}],"src":"16017:177:7"},{"body":{"nodeType":"YulBlock","src":"16294:40:7","statements":[{"nodeType":"YulAssignment","src":"16305:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16321:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"16315:5:7"},"nodeType":"YulFunctionCall","src":"16315:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"16305:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16277:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"16287:6:7","type":""}],"src":"16200:134:7"},{"body":{"nodeType":"YulBlock","src":"16461:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16478:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"16483:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16471:6:7"},"nodeType":"YulFunctionCall","src":"16471:19:7"},"nodeType":"YulExpressionStatement","src":"16471:19:7"},{"nodeType":"YulAssignment","src":"16499:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16518:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16523:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16514:3:7"},"nodeType":"YulFunctionCall","src":"16514:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"16499:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"16433:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"16438:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"16449:11:7","type":""}],"src":"16340:194:7"},{"body":{"nodeType":"YulBlock","src":"16632:60:7","statements":[{"nodeType":"YulAssignment","src":"16642:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"16650:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16642:4:7"}]},{"nodeType":"YulAssignment","src":"16663:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"16675:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16680:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16671:3:7"},"nodeType":"YulFunctionCall","src":"16671:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16663:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"16619:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"16627:4:7","type":""}],"src":"16540:152:7"},{"body":{"nodeType":"YulBlock","src":"16753:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16770:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16793:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"16775:17:7"},"nodeType":"YulFunctionCall","src":"16775:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16763:6:7"},"nodeType":"YulFunctionCall","src":"16763:37:7"},"nodeType":"YulExpressionStatement","src":"16763:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16741:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"16748:3:7","type":""}],"src":"16698:108:7"},{"body":{"nodeType":"YulBlock","src":"16906:40:7","statements":[{"nodeType":"YulAssignment","src":"16917:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16933:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"16927:5:7"},"nodeType":"YulFunctionCall","src":"16927:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"16917:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16889:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"16899:6:7","type":""}],"src":"16812:134:7"},{"body":{"nodeType":"YulBlock","src":"17073:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17090:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"17095:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17083:6:7"},"nodeType":"YulFunctionCall","src":"17083:19:7"},"nodeType":"YulExpressionStatement","src":"17083:19:7"},{"nodeType":"YulAssignment","src":"17111:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17130:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17135:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17126:3:7"},"nodeType":"YulFunctionCall","src":"17126:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"17111:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"17045:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"17050:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"17061:11:7","type":""}],"src":"16952:194:7"},{"body":{"nodeType":"YulBlock","src":"17244:60:7","statements":[{"nodeType":"YulAssignment","src":"17254:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"17262:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17254:4:7"}]},{"nodeType":"YulAssignment","src":"17275:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"17287:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17292:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17283:3:7"},"nodeType":"YulFunctionCall","src":"17283:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17275:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"17231:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"17239:4:7","type":""}],"src":"17152:152:7"},{"body":{"nodeType":"YulBlock","src":"17476:500:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17486:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17502:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17507:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17498:3:7"},"nodeType":"YulFunctionCall","src":"17498:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"17490:4:7","type":""}]},{"nodeType":"YulBlock","src":"17522:181:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17558:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17588:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"17595:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17584:3:7"},"nodeType":"YulFunctionCall","src":"17584:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17578:5:7"},"nodeType":"YulFunctionCall","src":"17578:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"17562:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"17664:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17682:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17687:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17678:3:7"},"nodeType":"YulFunctionCall","src":"17678:14:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"17614:49:7"},"nodeType":"YulFunctionCall","src":"17614:79:7"},"nodeType":"YulExpressionStatement","src":"17614:79:7"}]},{"nodeType":"YulBlock","src":"17713:236:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17749:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17779:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"17786:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17775:3:7"},"nodeType":"YulFunctionCall","src":"17775:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17769:5:7"},"nodeType":"YulFunctionCall","src":"17769:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"17753:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17817:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17822:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17813:3:7"},"nodeType":"YulFunctionCall","src":"17813:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"17833:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"17839:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"17829:3:7"},"nodeType":"YulFunctionCall","src":"17829:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17806:6:7"},"nodeType":"YulFunctionCall","src":"17806:38:7"},"nodeType":"YulExpressionStatement","src":"17806:38:7"},{"nodeType":"YulAssignment","src":"17857:81:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"17919:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"17933:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"17865:53:7"},"nodeType":"YulFunctionCall","src":"17865:73:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"17857:4:7"}]}]},{"nodeType":"YulAssignment","src":"17959:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"17966:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"17959:3:7"}]}]},"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"17455:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"17462:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"17471:3:7","type":""}],"src":"17372:604:7"},{"body":{"nodeType":"YulBlock","src":"18102:116:7","statements":[{"nodeType":"YulAssignment","src":"18112:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"18200:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"18208:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"18126:73:7"},"nodeType":"YulFunctionCall","src":"18126:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"18112:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"18075:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"18083:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"18091:10:7","type":""}],"src":"17982:236:7"},{"body":{"nodeType":"YulBlock","src":"18319:38:7","statements":[{"nodeType":"YulAssignment","src":"18329:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"18341:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18346:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18337:3:7"},"nodeType":"YulFunctionCall","src":"18337:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"18329:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"18306:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"18314:4:7","type":""}],"src":"18224:133:7"},{"body":{"nodeType":"YulBlock","src":"18583:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"18593:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18675:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18607:67:7"},"nodeType":"YulFunctionCall","src":"18607:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"18597:6:7","type":""}]},{"nodeType":"YulAssignment","src":"18690:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18781:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"18786:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18697:83:7"},"nodeType":"YulFunctionCall","src":"18697:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"18690:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"18802:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"18819:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"18806:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18831:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18847:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"18856:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"18864:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"18852:3:7"},"nodeType":"YulFunctionCall","src":"18852:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18843:3:7"},"nodeType":"YulFunctionCall","src":"18843:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"18835:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18879:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18964:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18894:69:7"},"nodeType":"YulFunctionCall","src":"18894:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"18883:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18979:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"18993:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"18983:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"19069:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19090:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"19099:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"19105:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"19095:3:7"},"nodeType":"YulFunctionCall","src":"19095:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"19083:6:7"},"nodeType":"YulFunctionCall","src":"19083:33:7"},"nodeType":"YulExpressionStatement","src":"19083:33:7"},{"nodeType":"YulVariableDeclaration","src":"19129:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19156:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19150:5:7"},"nodeType":"YulFunctionCall","src":"19150:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"19133:13:7","type":""}]},{"nodeType":"YulAssignment","src":"19176:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"19268:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"19283:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"19184:83:7"},"nodeType":"YulFunctionCall","src":"19184:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"19176:4:7"}]},{"nodeType":"YulAssignment","src":"19301:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19384:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"19311:72:7"},"nodeType":"YulFunctionCall","src":"19311:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19301:6:7"}]},{"nodeType":"YulAssignment","src":"19404:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19415:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19420:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19411:3:7"},"nodeType":"YulFunctionCall","src":"19411:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"19404:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"19031:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"19034:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"19028:2:7"},"nodeType":"YulFunctionCall","src":"19028:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"19042:18:7","statements":[{"nodeType":"YulAssignment","src":"19044:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"19053:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"19056:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19049:3:7"},"nodeType":"YulFunctionCall","src":"19049:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"19044:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"19013:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19015:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"19024:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"19019:1:7","type":""}]}]},"src":"19009:426:7"},{"nodeType":"YulAssignment","src":"19444:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"19451:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"19444:3:7"}]},{"nodeType":"YulAssignment","src":"19464:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"19471:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"19464:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"18562:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"18569:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"18578:3:7","type":""}],"src":"18429:1051:7"},{"body":{"nodeType":"YulBlock","src":"19650:559:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19660:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19676:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19681:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19672:3:7"},"nodeType":"YulFunctionCall","src":"19672:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"19664:4:7","type":""}]},{"nodeType":"YulBlock","src":"19696:169:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19736:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19766:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"19773:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19762:3:7"},"nodeType":"YulFunctionCall","src":"19762:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19756:5:7"},"nodeType":"YulFunctionCall","src":"19756:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"19740:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"19826:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19844:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19849:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19840:3:7"},"nodeType":"YulFunctionCall","src":"19840:14:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulIdentifier","src":"19792:33:7"},"nodeType":"YulFunctionCall","src":"19792:63:7"},"nodeType":"YulExpressionStatement","src":"19792:63:7"}]},{"nodeType":"YulBlock","src":"19875:307:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19912:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19942:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"19949:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19938:3:7"},"nodeType":"YulFunctionCall","src":"19938:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19932:5:7"},"nodeType":"YulFunctionCall","src":"19932:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"19916:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19980:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19985:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19976:3:7"},"nodeType":"YulFunctionCall","src":"19976:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"19996:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"20002:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"19992:3:7"},"nodeType":"YulFunctionCall","src":"19992:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"19969:6:7"},"nodeType":"YulFunctionCall","src":"19969:38:7"},"nodeType":"YulExpressionStatement","src":"19969:38:7"},{"nodeType":"YulAssignment","src":"20020:151:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"20152:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"20166:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20028:123:7"},"nodeType":"YulFunctionCall","src":"20028:143:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"20020:4:7"}]}]},{"nodeType":"YulAssignment","src":"20192:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"20199:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"20192:3:7"}]}]},"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"19629:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"19636:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"19645:3:7","type":""}],"src":"19546:663:7"},{"body":{"nodeType":"YulBlock","src":"20335:116:7","statements":[{"nodeType":"YulAssignment","src":"20345:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"20433:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"20441:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"20359:73:7"},"nodeType":"YulFunctionCall","src":"20359:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"20345:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"20308:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"20316:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"20324:10:7","type":""}],"src":"20215:236:7"},{"body":{"nodeType":"YulBlock","src":"20552:38:7","statements":[{"nodeType":"YulAssignment","src":"20562:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"20574:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20579:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20570:3:7"},"nodeType":"YulFunctionCall","src":"20570:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"20562:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"20539:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"20547:4:7","type":""}],"src":"20457:133:7"},{"body":{"nodeType":"YulBlock","src":"20814:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"20824:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"20906:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20838:67:7"},"nodeType":"YulFunctionCall","src":"20838:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"20828:6:7","type":""}]},{"nodeType":"YulAssignment","src":"20921:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21012:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"21017:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20928:83:7"},"nodeType":"YulFunctionCall","src":"20928:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"20921:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"21033:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"21050:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"21037:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21062:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21078:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"21087:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"21095:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"21083:3:7"},"nodeType":"YulFunctionCall","src":"21083:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21074:3:7"},"nodeType":"YulFunctionCall","src":"21074:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"21066:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21110:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"21195:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21125:69:7"},"nodeType":"YulFunctionCall","src":"21125:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"21114:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21210:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"21224:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"21214:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"21300:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21321:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"21330:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"21336:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"21326:3:7"},"nodeType":"YulFunctionCall","src":"21326:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"21314:6:7"},"nodeType":"YulFunctionCall","src":"21314:33:7"},"nodeType":"YulExpressionStatement","src":"21314:33:7"},{"nodeType":"YulVariableDeclaration","src":"21360:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21387:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"21381:5:7"},"nodeType":"YulFunctionCall","src":"21381:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"21364:13:7","type":""}]},{"nodeType":"YulAssignment","src":"21407:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"21499:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"21514:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"21415:83:7"},"nodeType":"YulFunctionCall","src":"21415:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"21407:4:7"}]},{"nodeType":"YulAssignment","src":"21532:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21615:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21542:72:7"},"nodeType":"YulFunctionCall","src":"21542:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21532:6:7"}]},{"nodeType":"YulAssignment","src":"21635:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21646:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"21651:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21642:3:7"},"nodeType":"YulFunctionCall","src":"21642:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"21635:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"21262:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"21265:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"21259:2:7"},"nodeType":"YulFunctionCall","src":"21259:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"21273:18:7","statements":[{"nodeType":"YulAssignment","src":"21275:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"21284:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"21287:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21280:3:7"},"nodeType":"YulFunctionCall","src":"21280:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"21275:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"21244:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"21246:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"21255:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"21250:1:7","type":""}]}]},"src":"21240:426:7"},{"nodeType":"YulAssignment","src":"21675:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"21682:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"21675:3:7"}]},{"nodeType":"YulAssignment","src":"21695:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"21702:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"21695:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"20793:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"20800:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"20809:3:7","type":""}],"src":"20660:1051:7"},{"body":{"nodeType":"YulBlock","src":"21887:166:7","statements":[{"nodeType":"YulAssignment","src":"21897:150:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"22035:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"22043:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21911:123:7"},"nodeType":"YulFunctionCall","src":"21911:136:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"21897:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"21860:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"21868:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"21876:10:7","type":""}],"src":"21717:336:7"},{"body":{"nodeType":"YulBlock","src":"22179:38:7","statements":[{"nodeType":"YulAssignment","src":"22189:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"22201:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"22206:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22197:3:7"},"nodeType":"YulFunctionCall","src":"22197:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"22189:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"22166:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"22174:4:7","type":""}],"src":"22059:158:7"},{"body":{"nodeType":"YulBlock","src":"22505:1057:7","statements":[{"nodeType":"YulVariableDeclaration","src":"22515:113:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"22622:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22529:92:7"},"nodeType":"YulFunctionCall","src":"22529:99:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"22519:6:7","type":""}]},{"nodeType":"YulAssignment","src":"22637:138:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22763:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"22768:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"22644:118:7"},"nodeType":"YulFunctionCall","src":"22644:131:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"22637:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"22784:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"22801:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"22788:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22813:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22829:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"22838:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"22846:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"22834:3:7"},"nodeType":"YulFunctionCall","src":"22834:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22825:3:7"},"nodeType":"YulFunctionCall","src":"22825:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"22817:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22861:116:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"22971:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22876:94:7"},"nodeType":"YulFunctionCall","src":"22876:101:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"22865:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22986:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"23000:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"22990:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"23076:441:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23097:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"23106:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"23112:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"23102:3:7"},"nodeType":"YulFunctionCall","src":"23102:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"23090:6:7"},"nodeType":"YulFunctionCall","src":"23090:33:7"},"nodeType":"YulExpressionStatement","src":"23090:33:7"},{"nodeType":"YulVariableDeclaration","src":"23136:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23163:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"23157:5:7"},"nodeType":"YulFunctionCall","src":"23157:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"23140:13:7","type":""}]},{"nodeType":"YulAssignment","src":"23183:162:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"23325:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"23340:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23191:133:7"},"nodeType":"YulFunctionCall","src":"23191:154:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23183:4:7"}]},{"nodeType":"YulAssignment","src":"23358:115:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23466:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23368:97:7"},"nodeType":"YulFunctionCall","src":"23368:105:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23358:6:7"}]},{"nodeType":"YulAssignment","src":"23486:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23497:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"23502:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23493:3:7"},"nodeType":"YulFunctionCall","src":"23493:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"23486:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"23038:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"23041:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"23035:2:7"},"nodeType":"YulFunctionCall","src":"23035:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"23049:18:7","statements":[{"nodeType":"YulAssignment","src":"23051:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"23060:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"23063:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23056:3:7"},"nodeType":"YulFunctionCall","src":"23056:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"23051:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"23020:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"23022:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"23031:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"23026:1:7","type":""}]}]},"src":"23016:501:7"},{"nodeType":"YulAssignment","src":"23526:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"23533:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"23526:3:7"}]},{"nodeType":"YulAssignment","src":"23546:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"23553:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"23546:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"22484:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"22491:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"22500:3:7","type":""}],"src":"22291:1271:7"},{"body":{"nodeType":"YulBlock","src":"23806:315:7","statements":[{"nodeType":"YulAssignment","src":"23816:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"23828:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"23839:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23824:3:7"},"nodeType":"YulFunctionCall","src":"23824:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23816:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"23863:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"23874:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23859:3:7"},"nodeType":"YulFunctionCall","src":"23859:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"23882:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"23888:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"23878:3:7"},"nodeType":"YulFunctionCall","src":"23878:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"23852:6:7"},"nodeType":"YulFunctionCall","src":"23852:47:7"},"nodeType":"YulExpressionStatement","src":"23852:47:7"},{"nodeType":"YulAssignment","src":"23908:206:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"24100:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"24109:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"23916:183:7"},"nodeType":"YulFunctionCall","src":"23916:198:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23908:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"23778:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"23790:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"23801:4:7","type":""}],"src":"23568:553:7"},{"body":{"nodeType":"YulBlock","src":"24208:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24225:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24256:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"24230:25:7"},"nodeType":"YulFunctionCall","src":"24230:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"24218:6:7"},"nodeType":"YulFunctionCall","src":"24218:45:7"},"nodeType":"YulExpressionStatement","src":"24218:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24196:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"24203:3:7","type":""}],"src":"24127:142:7"},{"body":{"nodeType":"YulBlock","src":"24371:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24388:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"24393:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"24381:6:7"},"nodeType":"YulFunctionCall","src":"24381:19:7"},"nodeType":"YulExpressionStatement","src":"24381:19:7"},{"nodeType":"YulAssignment","src":"24409:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24428:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"24433:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24424:3:7"},"nodeType":"YulFunctionCall","src":"24424:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"24409:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"24343:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"24348:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"24359:11:7","type":""}],"src":"24275:169:7"},{"body":{"nodeType":"YulBlock","src":"24542:272:7","statements":[{"nodeType":"YulVariableDeclaration","src":"24552:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24599:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"24566:32:7"},"nodeType":"YulFunctionCall","src":"24566:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"24556:6:7","type":""}]},{"nodeType":"YulAssignment","src":"24614:78:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24680:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"24685:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"24621:58:7"},"nodeType":"YulFunctionCall","src":"24621:71:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"24614:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24727:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"24734:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24723:3:7"},"nodeType":"YulFunctionCall","src":"24723:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"24741:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"24746:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"24701:21:7"},"nodeType":"YulFunctionCall","src":"24701:52:7"},"nodeType":"YulExpressionStatement","src":"24701:52:7"},{"nodeType":"YulAssignment","src":"24762:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24773:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"24800:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"24778:21:7"},"nodeType":"YulFunctionCall","src":"24778:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24769:3:7"},"nodeType":"YulFunctionCall","src":"24769:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"24762:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24523:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"24530:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"24538:3:7","type":""}],"src":"24450:364:7"},{"body":{"nodeType":"YulBlock","src":"24982:293:7","statements":[{"nodeType":"YulAssignment","src":"24992:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25004:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25015:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25000:3:7"},"nodeType":"YulFunctionCall","src":"25000:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"24992:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25088:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25101:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25112:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25097:3:7"},"nodeType":"YulFunctionCall","src":"25097:17:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulIdentifier","src":"25028:59:7"},"nodeType":"YulFunctionCall","src":"25028:87:7"},"nodeType":"YulExpressionStatement","src":"25028:87:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25136:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25147:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25132:3:7"},"nodeType":"YulFunctionCall","src":"25132:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"25156:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"25162:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"25152:3:7"},"nodeType":"YulFunctionCall","src":"25152:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25125:6:7"},"nodeType":"YulFunctionCall","src":"25125:48:7"},"nodeType":"YulExpressionStatement","src":"25125:48:7"},{"nodeType":"YulAssignment","src":"25182:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"25254:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"25263:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"25190:63:7"},"nodeType":"YulFunctionCall","src":"25190:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"25182:4:7"}]}]},"name":"abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"24946:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"24958:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"24966:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"24977:4:7","type":""}],"src":"24820:455:7"},{"body":{"nodeType":"YulBlock","src":"25326:51:7","statements":[{"nodeType":"YulAssignment","src":"25336:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25365:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"25347:17:7"},"nodeType":"YulFunctionCall","src":"25347:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"25336:7:7"}]}]},"name":"cleanup_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25308:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"25318:7:7","type":""}],"src":"25281:96:7"},{"body":{"nodeType":"YulBlock","src":"25448:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25465:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25488:5:7"}],"functionName":{"name":"cleanup_t_address","nodeType":"YulIdentifier","src":"25470:17:7"},"nodeType":"YulFunctionCall","src":"25470:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25458:6:7"},"nodeType":"YulFunctionCall","src":"25458:37:7"},"nodeType":"YulExpressionStatement","src":"25458:37:7"}]},"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25436:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25443:3:7","type":""}],"src":"25383:118:7"},{"body":{"nodeType":"YulBlock","src":"25605:124:7","statements":[{"nodeType":"YulAssignment","src":"25615:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25627:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25638:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25623:3:7"},"nodeType":"YulFunctionCall","src":"25623:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"25615:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25695:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25708:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25719:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25704:3:7"},"nodeType":"YulFunctionCall","src":"25704:17:7"}],"functionName":{"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulIdentifier","src":"25651:43:7"},"nodeType":"YulFunctionCall","src":"25651:71:7"},"nodeType":"YulExpressionStatement","src":"25651:71:7"}]},"name":"abi_encode_tuple_t_address__to_t_address__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"25577:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"25589:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"25600:4:7","type":""}],"src":"25507:222:7"},{"body":{"nodeType":"YulBlock","src":"25777:48:7","statements":[{"nodeType":"YulAssignment","src":"25787:32:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25812:5:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25805:6:7"},"nodeType":"YulFunctionCall","src":"25805:13:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25798:6:7"},"nodeType":"YulFunctionCall","src":"25798:21:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"25787:7:7"}]}]},"name":"cleanup_t_bool","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25759:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"25769:7:7","type":""}],"src":"25735:90:7"},{"body":{"nodeType":"YulBlock","src":"25890:50:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25907:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25927:5:7"}],"functionName":{"name":"cleanup_t_bool","nodeType":"YulIdentifier","src":"25912:14:7"},"nodeType":"YulFunctionCall","src":"25912:21:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25900:6:7"},"nodeType":"YulFunctionCall","src":"25900:34:7"},"nodeType":"YulExpressionStatement","src":"25900:34:7"}]},"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25878:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25885:3:7","type":""}],"src":"25831:109:7"},{"body":{"nodeType":"YulBlock","src":"26038:118:7","statements":[{"nodeType":"YulAssignment","src":"26048:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26060:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26071:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26056:3:7"},"nodeType":"YulFunctionCall","src":"26056:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26048:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"26122:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26135:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26146:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26131:3:7"},"nodeType":"YulFunctionCall","src":"26131:17:7"}],"functionName":{"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulIdentifier","src":"26084:37:7"},"nodeType":"YulFunctionCall","src":"26084:65:7"},"nodeType":"YulExpressionStatement","src":"26084:65:7"}]},"name":"abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26010:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26022:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26033:4:7","type":""}],"src":"25946:210:7"},{"body":{"nodeType":"YulBlock","src":"26336:359:7","statements":[{"nodeType":"YulAssignment","src":"26346:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26358:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26369:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26354:3:7"},"nodeType":"YulFunctionCall","src":"26354:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26346:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"26426:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26439:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26450:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26435:3:7"},"nodeType":"YulFunctionCall","src":"26435:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"26382:43:7"},"nodeType":"YulFunctionCall","src":"26382:71:7"},"nodeType":"YulExpressionStatement","src":"26382:71:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26474:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26485:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26470:3:7"},"nodeType":"YulFunctionCall","src":"26470:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"26494:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"26500:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"26490:3:7"},"nodeType":"YulFunctionCall","src":"26490:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26463:6:7"},"nodeType":"YulFunctionCall","src":"26463:48:7"},"nodeType":"YulExpressionStatement","src":"26463:48:7"},{"nodeType":"YulAssignment","src":"26520:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"26592:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"26601:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"26528:63:7"},"nodeType":"YulFunctionCall","src":"26528:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26520:4:7"}]},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"26660:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26673:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26684:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26669:3:7"},"nodeType":"YulFunctionCall","src":"26669:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"26616:43:7"},"nodeType":"YulFunctionCall","src":"26616:72:7"},"nodeType":"YulExpressionStatement","src":"26616:72:7"}]},"name":"abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26292:9:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"26304:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"26312:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26320:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26331:4:7","type":""}],"src":"26162:533:7"},{"body":{"nodeType":"YulBlock","src":"26819:195:7","statements":[{"nodeType":"YulAssignment","src":"26829:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26841:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26852:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26837:3:7"},"nodeType":"YulFunctionCall","src":"26837:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26829:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26876:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26887:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26872:3:7"},"nodeType":"YulFunctionCall","src":"26872:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"26895:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"26901:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"26891:3:7"},"nodeType":"YulFunctionCall","src":"26891:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26865:6:7"},"nodeType":"YulFunctionCall","src":"26865:47:7"},"nodeType":"YulExpressionStatement","src":"26865:47:7"},{"nodeType":"YulAssignment","src":"26921:86:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"26993:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"27002:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"26929:63:7"},"nodeType":"YulFunctionCall","src":"26929:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26921:4:7"}]}]},"name":"abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26791:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26803:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26814:4:7","type":""}],"src":"26701:313:7"},{"body":{"nodeType":"YulBlock","src":"27126:67:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"27148:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"27156:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27144:3:7"},"nodeType":"YulFunctionCall","src":"27144:14:7"},{"hexValue":"436f6e7472616374206973206e6f7420656e61626c6564","kind":"string","nodeType":"YulLiteral","src":"27160:25:7","type":"","value":"Contract is not enabled"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27137:6:7"},"nodeType":"YulFunctionCall","src":"27137:49:7"},"nodeType":"YulExpressionStatement","src":"27137:49:7"}]},"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"27118:6:7","type":""}],"src":"27020:173:7"},{"body":{"nodeType":"YulBlock","src":"27345:220:7","statements":[{"nodeType":"YulAssignment","src":"27355:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"27421:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"27426:2:7","type":"","value":"23"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27362:58:7"},"nodeType":"YulFunctionCall","src":"27362:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"27355:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"27527:3:7"}],"functionName":{"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulIdentifier","src":"27438:88:7"},"nodeType":"YulFunctionCall","src":"27438:93:7"},"nodeType":"YulExpressionStatement","src":"27438:93:7"},{"nodeType":"YulAssignment","src":"27540:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"27551:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"27556:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27547:3:7"},"nodeType":"YulFunctionCall","src":"27547:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"27540:3:7"}]}]},"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"27333:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"27341:3:7","type":""}],"src":"27199:366:7"},{"body":{"nodeType":"YulBlock","src":"27742:248:7","statements":[{"nodeType":"YulAssignment","src":"27752:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27764:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27775:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27760:3:7"},"nodeType":"YulFunctionCall","src":"27760:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27752:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27799:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27810:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27795:3:7"},"nodeType":"YulFunctionCall","src":"27795:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27818:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"27824:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"27814:3:7"},"nodeType":"YulFunctionCall","src":"27814:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27788:6:7"},"nodeType":"YulFunctionCall","src":"27788:47:7"},"nodeType":"YulExpressionStatement","src":"27788:47:7"},{"nodeType":"YulAssignment","src":"27844:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27978:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27852:124:7"},"nodeType":"YulFunctionCall","src":"27852:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27844:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"27722:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"27737:4:7","type":""}],"src":"27571:419:7"},{"body":{"nodeType":"YulBlock","src":"28024:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28041:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28044:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28034:6:7"},"nodeType":"YulFunctionCall","src":"28034:88:7"},"nodeType":"YulExpressionStatement","src":"28034:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28138:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"28141:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28131:6:7"},"nodeType":"YulFunctionCall","src":"28131:15:7"},"nodeType":"YulExpressionStatement","src":"28131:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28162:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28165:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"28155:6:7"},"nodeType":"YulFunctionCall","src":"28155:15:7"},"nodeType":"YulExpressionStatement","src":"28155:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"27996:180:7"},{"body":{"nodeType":"YulBlock","src":"28210:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28227:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28230:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28220:6:7"},"nodeType":"YulFunctionCall","src":"28220:88:7"},"nodeType":"YulExpressionStatement","src":"28220:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28324:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"28327:4:7","type":"","value":"0x11"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28317:6:7"},"nodeType":"YulFunctionCall","src":"28317:15:7"},"nodeType":"YulExpressionStatement","src":"28317:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28348:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28351:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"28341:6:7"},"nodeType":"YulFunctionCall","src":"28341:15:7"},"nodeType":"YulExpressionStatement","src":"28341:15:7"}]},"name":"panic_error_0x11","nodeType":"YulFunctionDefinition","src":"28182:180:7"},{"body":{"nodeType":"YulBlock","src":"28411:190:7","statements":[{"nodeType":"YulAssignment","src":"28421:33:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"28448:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"28430:17:7"},"nodeType":"YulFunctionCall","src":"28430:24:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"28421:5:7"}]},{"body":{"nodeType":"YulBlock","src":"28544:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"28546:16:7"},"nodeType":"YulFunctionCall","src":"28546:18:7"},"nodeType":"YulExpressionStatement","src":"28546:18:7"}]},"condition":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"28469:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"28476:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"28466:2:7"},"nodeType":"YulFunctionCall","src":"28466:77:7"},"nodeType":"YulIf","src":"28463:103:7"},{"nodeType":"YulAssignment","src":"28575:20:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"28586:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"28593:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28582:3:7"},"nodeType":"YulFunctionCall","src":"28582:13:7"},"variableNames":[{"name":"ret","nodeType":"YulIdentifier","src":"28575:3:7"}]}]},"name":"increment_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"28397:5:7","type":""}],"returnVariables":[{"name":"ret","nodeType":"YulTypedName","src":"28407:3:7","type":""}],"src":"28368:233:7"},{"body":{"nodeType":"YulBlock","src":"28713:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"28735:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"28743:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28731:3:7"},"nodeType":"YulFunctionCall","src":"28731:14:7"},{"hexValue":"496e76616c6964207820636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"28747:22:7","type":"","value":"Invalid x coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28724:6:7"},"nodeType":"YulFunctionCall","src":"28724:46:7"},"nodeType":"YulExpressionStatement","src":"28724:46:7"}]},"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"28705:6:7","type":""}],"src":"28607:170:7"},{"body":{"nodeType":"YulBlock","src":"28929:220:7","statements":[{"nodeType":"YulAssignment","src":"28939:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29005:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"29010:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"28946:58:7"},"nodeType":"YulFunctionCall","src":"28946:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"28939:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29111:3:7"}],"functionName":{"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulIdentifier","src":"29022:88:7"},"nodeType":"YulFunctionCall","src":"29022:93:7"},"nodeType":"YulExpressionStatement","src":"29022:93:7"},{"nodeType":"YulAssignment","src":"29124:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29135:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"29140:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29131:3:7"},"nodeType":"YulFunctionCall","src":"29131:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"29124:3:7"}]}]},"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"28917:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"28925:3:7","type":""}],"src":"28783:366:7"},{"body":{"nodeType":"YulBlock","src":"29326:248:7","statements":[{"nodeType":"YulAssignment","src":"29336:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"29348:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"29359:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29344:3:7"},"nodeType":"YulFunctionCall","src":"29344:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"29336:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"29383:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"29394:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29379:3:7"},"nodeType":"YulFunctionCall","src":"29379:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"29402:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"29408:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"29398:3:7"},"nodeType":"YulFunctionCall","src":"29398:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29372:6:7"},"nodeType":"YulFunctionCall","src":"29372:47:7"},"nodeType":"YulExpressionStatement","src":"29372:47:7"},{"nodeType":"YulAssignment","src":"29428:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"29562:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"29436:124:7"},"nodeType":"YulFunctionCall","src":"29436:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"29428:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"29306:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"29321:4:7","type":""}],"src":"29155:419:7"},{"body":{"nodeType":"YulBlock","src":"29686:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"29708:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"29716:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29704:3:7"},"nodeType":"YulFunctionCall","src":"29704:14:7"},{"hexValue":"496e76616c6964207920636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"29720:22:7","type":"","value":"Invalid y coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29697:6:7"},"nodeType":"YulFunctionCall","src":"29697:46:7"},"nodeType":"YulExpressionStatement","src":"29697:46:7"}]},"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"29678:6:7","type":""}],"src":"29580:170:7"},{"body":{"nodeType":"YulBlock","src":"29902:220:7","statements":[{"nodeType":"YulAssignment","src":"29912:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29978:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"29983:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"29919:58:7"},"nodeType":"YulFunctionCall","src":"29919:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"29912:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30084:3:7"}],"functionName":{"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulIdentifier","src":"29995:88:7"},"nodeType":"YulFunctionCall","src":"29995:93:7"},"nodeType":"YulExpressionStatement","src":"29995:93:7"},{"nodeType":"YulAssignment","src":"30097:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30108:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30113:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30104:3:7"},"nodeType":"YulFunctionCall","src":"30104:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"30097:3:7"}]}]},"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"29890:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"29898:3:7","type":""}],"src":"29756:366:7"},{"body":{"nodeType":"YulBlock","src":"30299:248:7","statements":[{"nodeType":"YulAssignment","src":"30309:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30321:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30332:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30317:3:7"},"nodeType":"YulFunctionCall","src":"30317:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30309:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30356:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30367:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30352:3:7"},"nodeType":"YulFunctionCall","src":"30352:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30375:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"30381:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"30371:3:7"},"nodeType":"YulFunctionCall","src":"30371:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30345:6:7"},"nodeType":"YulFunctionCall","src":"30345:47:7"},"nodeType":"YulExpressionStatement","src":"30345:47:7"},{"nodeType":"YulAssignment","src":"30401:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30535:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30409:124:7"},"nodeType":"YulFunctionCall","src":"30409:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30401:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"30279:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"30294:4:7","type":""}],"src":"30128:419:7"},{"body":{"nodeType":"YulBlock","src":"30659:71:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"30681:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"30689:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30677:3:7"},"nodeType":"YulFunctionCall","src":"30677:14:7"},{"hexValue":"4e6f7420746865206f776e6572206f662074686973206c61796572","kind":"string","nodeType":"YulLiteral","src":"30693:29:7","type":"","value":"Not the owner of this layer"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30670:6:7"},"nodeType":"YulFunctionCall","src":"30670:53:7"},"nodeType":"YulExpressionStatement","src":"30670:53:7"}]},"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"30651:6:7","type":""}],"src":"30553:177:7"},{"body":{"nodeType":"YulBlock","src":"30882:220:7","statements":[{"nodeType":"YulAssignment","src":"30892:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30958:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30963:2:7","type":"","value":"27"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30899:58:7"},"nodeType":"YulFunctionCall","src":"30899:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"30892:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31064:3:7"}],"functionName":{"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulIdentifier","src":"30975:88:7"},"nodeType":"YulFunctionCall","src":"30975:93:7"},"nodeType":"YulExpressionStatement","src":"30975:93:7"},{"nodeType":"YulAssignment","src":"31077:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31088:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31093:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31084:3:7"},"nodeType":"YulFunctionCall","src":"31084:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"31077:3:7"}]}]},"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"30870:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"30878:3:7","type":""}],"src":"30736:366:7"},{"body":{"nodeType":"YulBlock","src":"31279:248:7","statements":[{"nodeType":"YulAssignment","src":"31289:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31301:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31312:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31297:3:7"},"nodeType":"YulFunctionCall","src":"31297:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31289:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31336:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31347:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31332:3:7"},"nodeType":"YulFunctionCall","src":"31332:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31355:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"31361:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"31351:3:7"},"nodeType":"YulFunctionCall","src":"31351:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31325:6:7"},"nodeType":"YulFunctionCall","src":"31325:47:7"},"nodeType":"YulExpressionStatement","src":"31325:47:7"},{"nodeType":"YulAssignment","src":"31381:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31515:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31389:124:7"},"nodeType":"YulFunctionCall","src":"31389:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31381:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"31259:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"31274:4:7","type":""}],"src":"31108:419:7"},{"body":{"nodeType":"YulBlock","src":"31639:118:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"31661:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"31669:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31657:3:7"},"nodeType":"YulFunctionCall","src":"31657:14:7"},{"hexValue":"4f6e6c7920746865206f776e65722063616e2063616c6c20746869732066756e","kind":"string","nodeType":"YulLiteral","src":"31673:34:7","type":"","value":"Only the owner can call this fun"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31650:6:7"},"nodeType":"YulFunctionCall","src":"31650:58:7"},"nodeType":"YulExpressionStatement","src":"31650:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"31729:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"31737:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31725:3:7"},"nodeType":"YulFunctionCall","src":"31725:15:7"},{"hexValue":"6374696f6e","kind":"string","nodeType":"YulLiteral","src":"31742:7:7","type":"","value":"ction"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31718:6:7"},"nodeType":"YulFunctionCall","src":"31718:32:7"},"nodeType":"YulExpressionStatement","src":"31718:32:7"}]},"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"31631:6:7","type":""}],"src":"31533:224:7"},{"body":{"nodeType":"YulBlock","src":"31909:220:7","statements":[{"nodeType":"YulAssignment","src":"31919:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31985:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31990:2:7","type":"","value":"37"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31926:58:7"},"nodeType":"YulFunctionCall","src":"31926:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"31919:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32091:3:7"}],"functionName":{"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulIdentifier","src":"32002:88:7"},"nodeType":"YulFunctionCall","src":"32002:93:7"},"nodeType":"YulExpressionStatement","src":"32002:93:7"},{"nodeType":"YulAssignment","src":"32104:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32115:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32120:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32111:3:7"},"nodeType":"YulFunctionCall","src":"32111:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"32104:3:7"}]}]},"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"31897:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"31905:3:7","type":""}],"src":"31763:366:7"},{"body":{"nodeType":"YulBlock","src":"32306:248:7","statements":[{"nodeType":"YulAssignment","src":"32316:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32328:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32339:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32324:3:7"},"nodeType":"YulFunctionCall","src":"32324:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32316:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32363:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32374:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32359:3:7"},"nodeType":"YulFunctionCall","src":"32359:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32382:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"32388:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"32378:3:7"},"nodeType":"YulFunctionCall","src":"32378:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32352:6:7"},"nodeType":"YulFunctionCall","src":"32352:47:7"},"nodeType":"YulExpressionStatement","src":"32352:47:7"},{"nodeType":"YulAssignment","src":"32408:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32542:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32416:124:7"},"nodeType":"YulFunctionCall","src":"32416:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32408:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"32286:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"32301:4:7","type":""}],"src":"32135:419:7"},{"body":{"nodeType":"YulBlock","src":"32666:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"32688:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"32696:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32684:3:7"},"nodeType":"YulFunctionCall","src":"32684:14:7"},{"hexValue":"4e6f2066756e647320746f207769746864726177","kind":"string","nodeType":"YulLiteral","src":"32700:22:7","type":"","value":"No funds to withdraw"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32677:6:7"},"nodeType":"YulFunctionCall","src":"32677:46:7"},"nodeType":"YulExpressionStatement","src":"32677:46:7"}]},"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"32658:6:7","type":""}],"src":"32560:170:7"},{"body":{"nodeType":"YulBlock","src":"32882:220:7","statements":[{"nodeType":"YulAssignment","src":"32892:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32958:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32963:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32899:58:7"},"nodeType":"YulFunctionCall","src":"32899:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"32892:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33064:3:7"}],"functionName":{"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulIdentifier","src":"32975:88:7"},"nodeType":"YulFunctionCall","src":"32975:93:7"},"nodeType":"YulExpressionStatement","src":"32975:93:7"},{"nodeType":"YulAssignment","src":"33077:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33088:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"33093:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33084:3:7"},"nodeType":"YulFunctionCall","src":"33084:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"33077:3:7"}]}]},"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"32870:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"32878:3:7","type":""}],"src":"32736:366:7"},{"body":{"nodeType":"YulBlock","src":"33279:248:7","statements":[{"nodeType":"YulAssignment","src":"33289:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33301:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33312:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33297:3:7"},"nodeType":"YulFunctionCall","src":"33297:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33289:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33336:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33347:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33332:3:7"},"nodeType":"YulFunctionCall","src":"33332:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33355:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"33361:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"33351:3:7"},"nodeType":"YulFunctionCall","src":"33351:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33325:6:7"},"nodeType":"YulFunctionCall","src":"33325:47:7"},"nodeType":"YulExpressionStatement","src":"33325:47:7"},{"nodeType":"YulAssignment","src":"33381:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33515:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"33389:124:7"},"nodeType":"YulFunctionCall","src":"33389:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33381:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"33259:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"33274:4:7","type":""}],"src":"33108:419:7"},{"body":{"nodeType":"YulBlock","src":"33561:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"33578:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"33581:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33571:6:7"},"nodeType":"YulFunctionCall","src":"33571:88:7"},"nodeType":"YulExpressionStatement","src":"33571:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"33675:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"33678:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33668:6:7"},"nodeType":"YulFunctionCall","src":"33668:15:7"},"nodeType":"YulExpressionStatement","src":"33668:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"33699:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"33702:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"33692:6:7"},"nodeType":"YulFunctionCall","src":"33692:15:7"},"nodeType":"YulExpressionStatement","src":"33692:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"33533:180:7"},{"body":{"nodeType":"YulBlock","src":"33770:269:7","statements":[{"nodeType":"YulAssignment","src":"33780:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"33794:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"33800:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"33790:3:7"},"nodeType":"YulFunctionCall","src":"33790:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"33780:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"33811:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"33841:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"33847:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"33837:3:7"},"nodeType":"YulFunctionCall","src":"33837:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"33815:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"33888:51:7","statements":[{"nodeType":"YulAssignment","src":"33902:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"33916:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"33924:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"33912:3:7"},"nodeType":"YulFunctionCall","src":"33912:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"33902:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"33868:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"33861:6:7"},"nodeType":"YulFunctionCall","src":"33861:26:7"},"nodeType":"YulIf","src":"33858:81:7"},{"body":{"nodeType":"YulBlock","src":"33991:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"34005:16:7"},"nodeType":"YulFunctionCall","src":"34005:18:7"},"nodeType":"YulExpressionStatement","src":"34005:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"33955:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"33978:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"33986:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"33975:2:7"},"nodeType":"YulFunctionCall","src":"33975:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"33952:2:7"},"nodeType":"YulFunctionCall","src":"33952:38:7"},"nodeType":"YulIf","src":"33949:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"33754:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"33763:6:7","type":""}],"src":"33719:320:7"},{"body":{"nodeType":"YulBlock","src":"34090:146:7","statements":[{"nodeType":"YulAssignment","src":"34100:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34123:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34105:17:7"},"nodeType":"YulFunctionCall","src":"34105:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"34100:1:7"}]},{"nodeType":"YulAssignment","src":"34134:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"34157:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34139:17:7"},"nodeType":"YulFunctionCall","src":"34139:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"34134:1:7"}]},{"body":{"nodeType":"YulBlock","src":"34181:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"34183:16:7"},"nodeType":"YulFunctionCall","src":"34183:18:7"},"nodeType":"YulExpressionStatement","src":"34183:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34175:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"34178:1:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"34172:2:7"},"nodeType":"YulFunctionCall","src":"34172:8:7"},"nodeType":"YulIf","src":"34169:34:7"},{"nodeType":"YulAssignment","src":"34213:17:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34225:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"34228:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"34221:3:7"},"nodeType":"YulFunctionCall","src":"34221:9:7"},"variableNames":[{"name":"diff","nodeType":"YulIdentifier","src":"34213:4:7"}]}]},"name":"checked_sub_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"34076:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"34079:1:7","type":""}],"returnVariables":[{"name":"diff","nodeType":"YulTypedName","src":"34085:4:7","type":""}],"src":"34045:191:7"},{"body":{"nodeType":"YulBlock","src":"34290:300:7","statements":[{"nodeType":"YulAssignment","src":"34300:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34323:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34305:17:7"},"nodeType":"YulFunctionCall","src":"34305:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"34300:1:7"}]},{"nodeType":"YulAssignment","src":"34334:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"34357:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34339:17:7"},"nodeType":"YulFunctionCall","src":"34339:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"34334:1:7"}]},{"body":{"nodeType":"YulBlock","src":"34532:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"34534:16:7"},"nodeType":"YulFunctionCall","src":"34534:18:7"},"nodeType":"YulExpressionStatement","src":"34534:18:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34444:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"34437:6:7"},"nodeType":"YulFunctionCall","src":"34437:9:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"34430:6:7"},"nodeType":"YulFunctionCall","src":"34430:17:7"},{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"34452:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34459:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"x","nodeType":"YulIdentifier","src":"34527:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"34455:3:7"},"nodeType":"YulFunctionCall","src":"34455:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"34449:2:7"},"nodeType":"YulFunctionCall","src":"34449:81:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"34426:3:7"},"nodeType":"YulFunctionCall","src":"34426:105:7"},"nodeType":"YulIf","src":"34423:131:7"},{"nodeType":"YulAssignment","src":"34564:20:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34579:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"34582:1:7"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"34575:3:7"},"nodeType":"YulFunctionCall","src":"34575:9:7"},"variableNames":[{"name":"product","nodeType":"YulIdentifier","src":"34564:7:7"}]}]},"name":"checked_mul_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"34273:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"34276:1:7","type":""}],"returnVariables":[{"name":"product","nodeType":"YulTypedName","src":"34282:7:7","type":""}],"src":"34242:348:7"},{"body":{"nodeType":"YulBlock","src":"34640:261:7","statements":[{"nodeType":"YulAssignment","src":"34650:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34673:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34655:17:7"},"nodeType":"YulFunctionCall","src":"34655:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"34650:1:7"}]},{"nodeType":"YulAssignment","src":"34684:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"34707:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"34689:17:7"},"nodeType":"YulFunctionCall","src":"34689:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"34684:1:7"}]},{"body":{"nodeType":"YulBlock","src":"34847:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"34849:16:7"},"nodeType":"YulFunctionCall","src":"34849:18:7"},"nodeType":"YulExpressionStatement","src":"34849:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34768:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34775:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"y","nodeType":"YulIdentifier","src":"34843:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"34771:3:7"},"nodeType":"YulFunctionCall","src":"34771:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"34765:2:7"},"nodeType":"YulFunctionCall","src":"34765:81:7"},"nodeType":"YulIf","src":"34762:107:7"},{"nodeType":"YulAssignment","src":"34879:16:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"34890:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"34893:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34886:3:7"},"nodeType":"YulFunctionCall","src":"34886:9:7"},"variableNames":[{"name":"sum","nodeType":"YulIdentifier","src":"34879:3:7"}]}]},"name":"checked_add_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"34627:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"34630:1:7","type":""}],"returnVariables":[{"name":"sum","nodeType":"YulTypedName","src":"34636:3:7","type":""}],"src":"34596:305:7"},{"body":{"nodeType":"YulBlock","src":"35013:119:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35035:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35043:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35031:3:7"},"nodeType":"YulFunctionCall","src":"35031:14:7"},{"hexValue":"43616e6e6f7420627579206d6f7265207468616e203130206c61796572732061","kind":"string","nodeType":"YulLiteral","src":"35047:34:7","type":"","value":"Cannot buy more than 10 layers a"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35024:6:7"},"nodeType":"YulFunctionCall","src":"35024:58:7"},"nodeType":"YulExpressionStatement","src":"35024:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35103:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35111:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35099:3:7"},"nodeType":"YulFunctionCall","src":"35099:15:7"},{"hexValue":"74206f6e6365","kind":"string","nodeType":"YulLiteral","src":"35116:8:7","type":"","value":"t once"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35092:6:7"},"nodeType":"YulFunctionCall","src":"35092:33:7"},"nodeType":"YulExpressionStatement","src":"35092:33:7"}]},"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"35005:6:7","type":""}],"src":"34907:225:7"},{"body":{"nodeType":"YulBlock","src":"35284:220:7","statements":[{"nodeType":"YulAssignment","src":"35294:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"35360:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"35365:2:7","type":"","value":"38"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"35301:58:7"},"nodeType":"YulFunctionCall","src":"35301:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"35294:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"35466:3:7"}],"functionName":{"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulIdentifier","src":"35377:88:7"},"nodeType":"YulFunctionCall","src":"35377:93:7"},"nodeType":"YulExpressionStatement","src":"35377:93:7"},{"nodeType":"YulAssignment","src":"35479:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"35490:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"35495:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35486:3:7"},"nodeType":"YulFunctionCall","src":"35486:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"35479:3:7"}]}]},"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"35272:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"35280:3:7","type":""}],"src":"35138:366:7"},{"body":{"nodeType":"YulBlock","src":"35681:248:7","statements":[{"nodeType":"YulAssignment","src":"35691:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"35703:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"35714:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35699:3:7"},"nodeType":"YulFunctionCall","src":"35699:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"35691:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"35738:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"35749:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35734:3:7"},"nodeType":"YulFunctionCall","src":"35734:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"35757:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"35763:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"35753:3:7"},"nodeType":"YulFunctionCall","src":"35753:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35727:6:7"},"nodeType":"YulFunctionCall","src":"35727:47:7"},"nodeType":"YulExpressionStatement","src":"35727:47:7"},{"nodeType":"YulAssignment","src":"35783:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"35917:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"35791:124:7"},"nodeType":"YulFunctionCall","src":"35791:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"35783:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"35661:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"35676:4:7","type":""}],"src":"35510:419:7"},{"body":{"nodeType":"YulBlock","src":"35963:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"35980:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"35983:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35973:6:7"},"nodeType":"YulFunctionCall","src":"35973:88:7"},"nodeType":"YulExpressionStatement","src":"35973:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"36077:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"36080:4:7","type":"","value":"0x12"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36070:6:7"},"nodeType":"YulFunctionCall","src":"36070:15:7"},"nodeType":"YulExpressionStatement","src":"36070:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"36101:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"36104:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"36094:6:7"},"nodeType":"YulFunctionCall","src":"36094:15:7"},"nodeType":"YulExpressionStatement","src":"36094:15:7"}]},"name":"panic_error_0x12","nodeType":"YulFunctionDefinition","src":"35935:180:7"},{"body":{"nodeType":"YulBlock","src":"36163:143:7","statements":[{"nodeType":"YulAssignment","src":"36173:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36196:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36178:17:7"},"nodeType":"YulFunctionCall","src":"36178:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"36173:1:7"}]},{"nodeType":"YulAssignment","src":"36207:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"36230:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36212:17:7"},"nodeType":"YulFunctionCall","src":"36212:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"36207:1:7"}]},{"body":{"nodeType":"YulBlock","src":"36254:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x12","nodeType":"YulIdentifier","src":"36256:16:7"},"nodeType":"YulFunctionCall","src":"36256:18:7"},"nodeType":"YulExpressionStatement","src":"36256:18:7"}]},"condition":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"36251:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"36244:6:7"},"nodeType":"YulFunctionCall","src":"36244:9:7"},"nodeType":"YulIf","src":"36241:35:7"},{"nodeType":"YulAssignment","src":"36286:14:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36295:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"36298:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"36291:3:7"},"nodeType":"YulFunctionCall","src":"36291:9:7"},"variableNames":[{"name":"r","nodeType":"YulIdentifier","src":"36286:1:7"}]}]},"name":"checked_div_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"36152:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"36155:1:7","type":""}],"returnVariables":[{"name":"r","nodeType":"YulTypedName","src":"36161:1:7","type":""}],"src":"36121:185:7"},{"body":{"nodeType":"YulBlock","src":"36418:62:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"36440:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"36448:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36436:3:7"},"nodeType":"YulFunctionCall","src":"36436:14:7"},{"hexValue":"496e636f727265637420504f4c2073656e74","kind":"string","nodeType":"YulLiteral","src":"36452:20:7","type":"","value":"Incorrect POL sent"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36429:6:7"},"nodeType":"YulFunctionCall","src":"36429:44:7"},"nodeType":"YulExpressionStatement","src":"36429:44:7"}]},"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"36410:6:7","type":""}],"src":"36312:168:7"},{"body":{"nodeType":"YulBlock","src":"36632:220:7","statements":[{"nodeType":"YulAssignment","src":"36642:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36708:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"36713:2:7","type":"","value":"18"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"36649:58:7"},"nodeType":"YulFunctionCall","src":"36649:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"36642:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36814:3:7"}],"functionName":{"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulIdentifier","src":"36725:88:7"},"nodeType":"YulFunctionCall","src":"36725:93:7"},"nodeType":"YulExpressionStatement","src":"36725:93:7"},{"nodeType":"YulAssignment","src":"36827:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36838:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"36843:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36834:3:7"},"nodeType":"YulFunctionCall","src":"36834:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"36827:3:7"}]}]},"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"36620:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"36628:3:7","type":""}],"src":"36486:366:7"},{"body":{"nodeType":"YulBlock","src":"37029:248:7","statements":[{"nodeType":"YulAssignment","src":"37039:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37051:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37062:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37047:3:7"},"nodeType":"YulFunctionCall","src":"37047:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37039:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37086:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37097:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37082:3:7"},"nodeType":"YulFunctionCall","src":"37082:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"37105:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"37111:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"37101:3:7"},"nodeType":"YulFunctionCall","src":"37101:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"37075:6:7"},"nodeType":"YulFunctionCall","src":"37075:47:7"},"nodeType":"YulExpressionStatement","src":"37075:47:7"},{"nodeType":"YulAssignment","src":"37131:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"37265:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"37139:124:7"},"nodeType":"YulFunctionCall","src":"37139:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37131:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"37009:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"37024:4:7","type":""}],"src":"36858:419:7"},{"body":{"nodeType":"YulBlock","src":"37485:442:7","statements":[{"nodeType":"YulAssignment","src":"37495:27:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37507:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37518:3:7","type":"","value":"128"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37503:3:7"},"nodeType":"YulFunctionCall","src":"37503:19:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37495:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"37576:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37589:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37600:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37585:3:7"},"nodeType":"YulFunctionCall","src":"37585:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"37532:43:7"},"nodeType":"YulFunctionCall","src":"37532:71:7"},"nodeType":"YulExpressionStatement","src":"37532:71:7"},{"expression":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"37657:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37670:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37681:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37666:3:7"},"nodeType":"YulFunctionCall","src":"37666:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"37613:43:7"},"nodeType":"YulFunctionCall","src":"37613:72:7"},"nodeType":"YulExpressionStatement","src":"37613:72:7"},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"37739:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37752:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37763:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37748:3:7"},"nodeType":"YulFunctionCall","src":"37748:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"37695:43:7"},"nodeType":"YulFunctionCall","src":"37695:72:7"},"nodeType":"YulExpressionStatement","src":"37695:72:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37788:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37799:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37784:3:7"},"nodeType":"YulFunctionCall","src":"37784:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"37808:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"37814:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"37804:3:7"},"nodeType":"YulFunctionCall","src":"37804:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"37777:6:7"},"nodeType":"YulFunctionCall","src":"37777:48:7"},"nodeType":"YulExpressionStatement","src":"37777:48:7"},{"nodeType":"YulAssignment","src":"37834:86:7","value":{"arguments":[{"name":"value3","nodeType":"YulIdentifier","src":"37906:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"37915:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"37842:63:7"},"nodeType":"YulFunctionCall","src":"37842:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37834:4:7"}]}]},"name":"abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"37433:9:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"37445:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"37453:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"37461:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"37469:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"37480:4:7","type":""}],"src":"37283:644:7"},{"body":{"nodeType":"YulBlock","src":"38039:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"38061:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"38069:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38057:3:7"},"nodeType":"YulFunctionCall","src":"38057:14:7"},{"hexValue":"496e76616c696420782d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"38073:22:7","type":"","value":"Invalid x-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38050:6:7"},"nodeType":"YulFunctionCall","src":"38050:46:7"},"nodeType":"YulExpressionStatement","src":"38050:46:7"}]},"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"38031:6:7","type":""}],"src":"37933:170:7"},{"body":{"nodeType":"YulBlock","src":"38255:220:7","statements":[{"nodeType":"YulAssignment","src":"38265:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38331:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"38336:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"38272:58:7"},"nodeType":"YulFunctionCall","src":"38272:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"38265:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38437:3:7"}],"functionName":{"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulIdentifier","src":"38348:88:7"},"nodeType":"YulFunctionCall","src":"38348:93:7"},"nodeType":"YulExpressionStatement","src":"38348:93:7"},{"nodeType":"YulAssignment","src":"38450:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38461:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"38466:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38457:3:7"},"nodeType":"YulFunctionCall","src":"38457:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"38450:3:7"}]}]},"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"38243:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"38251:3:7","type":""}],"src":"38109:366:7"},{"body":{"nodeType":"YulBlock","src":"38652:248:7","statements":[{"nodeType":"YulAssignment","src":"38662:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"38674:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"38685:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38670:3:7"},"nodeType":"YulFunctionCall","src":"38670:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"38662:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"38709:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"38720:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38705:3:7"},"nodeType":"YulFunctionCall","src":"38705:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"38728:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"38734:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"38724:3:7"},"nodeType":"YulFunctionCall","src":"38724:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38698:6:7"},"nodeType":"YulFunctionCall","src":"38698:47:7"},"nodeType":"YulExpressionStatement","src":"38698:47:7"},{"nodeType":"YulAssignment","src":"38754:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"38888:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"38762:124:7"},"nodeType":"YulFunctionCall","src":"38762:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"38754:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"38632:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"38647:4:7","type":""}],"src":"38481:419:7"},{"body":{"nodeType":"YulBlock","src":"39012:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"39034:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"39042:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39030:3:7"},"nodeType":"YulFunctionCall","src":"39030:14:7"},{"hexValue":"496e76616c696420792d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"39046:22:7","type":"","value":"Invalid y-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39023:6:7"},"nodeType":"YulFunctionCall","src":"39023:46:7"},"nodeType":"YulExpressionStatement","src":"39023:46:7"}]},"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"39004:6:7","type":""}],"src":"38906:170:7"},{"body":{"nodeType":"YulBlock","src":"39228:220:7","statements":[{"nodeType":"YulAssignment","src":"39238:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39304:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"39309:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"39245:58:7"},"nodeType":"YulFunctionCall","src":"39245:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"39238:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39410:3:7"}],"functionName":{"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulIdentifier","src":"39321:88:7"},"nodeType":"YulFunctionCall","src":"39321:93:7"},"nodeType":"YulExpressionStatement","src":"39321:93:7"},{"nodeType":"YulAssignment","src":"39423:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39434:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"39439:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39430:3:7"},"nodeType":"YulFunctionCall","src":"39430:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"39423:3:7"}]}]},"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"39216:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"39224:3:7","type":""}],"src":"39082:366:7"},{"body":{"nodeType":"YulBlock","src":"39625:248:7","statements":[{"nodeType":"YulAssignment","src":"39635:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39647:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39658:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39643:3:7"},"nodeType":"YulFunctionCall","src":"39643:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39635:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39682:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39693:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39678:3:7"},"nodeType":"YulFunctionCall","src":"39678:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39701:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"39707:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"39697:3:7"},"nodeType":"YulFunctionCall","src":"39697:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39671:6:7"},"nodeType":"YulFunctionCall","src":"39671:47:7"},"nodeType":"YulExpressionStatement","src":"39671:47:7"},{"nodeType":"YulAssignment","src":"39727:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39861:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"39735:124:7"},"nodeType":"YulFunctionCall","src":"39735:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39727:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"39605:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"39620:4:7","type":""}],"src":"39454:419:7"}]},"contents":"{\\n\\n    function array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_address_payable_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function cleanup_t_uint160(value) -> cleaned {\\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\\n    }\\n\\n    function cleanup_t_address_payable(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(value0, pos) -> updatedPos {\\n        abi_encode_t_address_payable_to_t_address_payable(value0, pos)\\n        updatedPos := add(pos, 0x20)\\n    }\\n\\n    function array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[] -> address payable[]\\n    function abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length)\\n        let baseRef := array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            let elementValue0 := mload(srcPtr)\\n            pos := abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(elementValue0, pos)\\n            srcPtr := array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(srcPtr)\\n        }\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[][] -> address payable[][]\\n    function abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_string_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function copy_memory_to_memory(src, dst, length) {\\n        let i := 0\\n        for { } lt(i, length) { i := add(i, 32) }\\n        {\\n            mstore(add(dst, i), mload(add(src, i)))\\n        }\\n        if gt(i, length)\\n        {\\n            // clear end\\n            mstore(add(dst, length), 0)\\n        }\\n    }\\n\\n    function round_up_to_mul_of_32(value) -> result {\\n        result := and(add(value, 31), not(31))\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[] -> string[]\\n    function abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[][] -> string[][]\\n    function abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function allocate_unbounded() -> memPtr {\\n        memPtr := mload(64)\\n    }\\n\\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\\n        revert(0, 0)\\n    }\\n\\n    function cleanup_t_uint256(value) -> cleaned {\\n        cleaned := value\\n    }\\n\\n    function validator_revert_t_uint256(value) {\\n        if iszero(eq(value, cleanup_t_uint256(value))) { revert(0, 0) }\\n    }\\n\\n    function abi_decode_t_uint256(offset, end) -> value {\\n        value := calldataload(offset)\\n        validator_revert_t_uint256(value)\\n    }\\n\\n    function revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() {\\n        revert(0, 0)\\n    }\\n\\n    function panic_error_0x41() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x41)\\n        revert(0, 0x24)\\n    }\\n\\n    function finalize_allocation(memPtr, size) {\\n        let newFreePtr := add(memPtr, round_up_to_mul_of_32(size))\\n        // protect against overflow\\n        if or(gt(newFreePtr, 0xffffffffffffffff), lt(newFreePtr, memPtr)) { panic_error_0x41() }\\n        mstore(64, newFreePtr)\\n    }\\n\\n    function allocate_memory(size) -> memPtr {\\n        memPtr := allocate_unbounded()\\n        finalize_allocation(memPtr, size)\\n    }\\n\\n    function array_allocation_size_t_string_memory_ptr(length) -> size {\\n        // Make sure we can allocate memory without overflow\\n        if gt(length, 0xffffffffffffffff) { panic_error_0x41() }\\n\\n        size := round_up_to_mul_of_32(length)\\n\\n        // add length slot\\n        size := add(size, 0x20)\\n\\n    }\\n\\n    function copy_calldata_to_memory(src, dst, length) {\\n        calldatacopy(dst, src, length)\\n        // clear end\\n        mstore(add(dst, length), 0)\\n    }\\n\\n    function abi_decode_available_length_t_string_memory_ptr(src, length, end) -> array {\\n        array := allocate_memory(array_allocation_size_t_string_memory_ptr(length))\\n        mstore(array, length)\\n        let dst := add(array, 0x20)\\n        if gt(add(src, length), end) { revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() }\\n        copy_calldata_to_memory(src, dst, length)\\n    }\\n\\n    // string\\n    function abi_decode_t_string_memory_ptr(offset, end) -> array {\\n        if iszero(slt(add(offset, 0x1f), end)) { revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() }\\n        let length := calldataload(offset)\\n        array := abi_decode_available_length_t_string_memory_ptr(add(offset, 0x20), length, end)\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2 {\\n        if slt(sub(dataEnd, headStart), 96) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 64))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value2 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1 {\\n        if slt(sub(dataEnd, headStart), 64) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3 {\\n        if slt(sub(dataEnd, headStart), 128) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 64\\n\\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 96))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value3 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    // struct BaseContract.Layer -> struct BaseContract.Layer\\n    function abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // owner\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_address_payable_to_t_address_payable(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // color\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Layer[] -> struct BaseContract.Layer[]\\n    function abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    // struct BaseContract.Cell -> struct BaseContract.Cell\\n    function abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // baseValue\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // layers\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[] -> struct BaseContract.Cell[]\\n    function abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[][] -> struct BaseContract.Cell[][]\\n    function abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        abi_encode_t_address_payable_to_t_address_payable_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function cleanup_t_address(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address(value))\\n    }\\n\\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function cleanup_t_bool(value) -> cleaned {\\n        cleaned := iszero(iszero(value))\\n    }\\n\\n    function abi_encode_t_bool_to_t_bool_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_bool(value))\\n    }\\n\\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_bool_to_t_bool_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed(headStart , value2, value1, value0) -> tail {\\n        tail := add(headStart, 96)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n    }\\n\\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Contract is not enabled\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 23)\\n        store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x11() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x11)\\n        revert(0, 0x24)\\n    }\\n\\n    function increment_t_uint256(value) -> ret {\\n        value := cleanup_t_uint256(value)\\n        if eq(value, 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff) { panic_error_0x11() }\\n        ret := add(value, 1)\\n    }\\n\\n    function store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not the owner of this layer\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 27)\\n        store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Only the owner can call this fun\\")\\n\\n        mstore(add(memPtr, 32), \\"ction\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 37)\\n        store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"No funds to withdraw\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n    function checked_sub_t_uint256(x, y) -> diff {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        if lt(x, y) { panic_error_0x11() }\\n\\n        diff := sub(x, y)\\n    }\\n\\n    function checked_mul_t_uint256(x, y) -> product {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x != 0 and y > (maxValue / x)\\n        if and(iszero(iszero(x)), gt(y, div(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, x))) { panic_error_0x11() }\\n\\n        product := mul(x, y)\\n    }\\n\\n    function checked_add_t_uint256(x, y) -> sum {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x > (maxValue - y)\\n        if gt(x, sub(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, y)) { panic_error_0x11() }\\n\\n        sum := add(x, y)\\n    }\\n\\n    function store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Cannot buy more than 10 layers a\\")\\n\\n        mstore(add(memPtr, 32), \\"t once\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 38)\\n        store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x12() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x12)\\n        revert(0, 0x24)\\n    }\\n\\n    function checked_div_t_uint256(x, y) -> r {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n        if iszero(y) { panic_error_0x12() }\\n\\n        r := div(x, y)\\n    }\\n\\n    function store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Incorrect POL sent\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 18)\\n        store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed(headStart , value3, value2, value1, value0) -> tail {\\n        tail := add(headStart, 128)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value1,  add(headStart, 32))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n        mstore(add(headStart, 96), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value3,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"sourceMap":"125:644:4:-:0;;;2924:2673:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;125:644:4;;;;;;;;;;519:10:0;511:5;;:18;;;;;;;;;;;;;;;;;;262:116:1;;;;;;;;282:1;262:116;;;;;;284:1;262:116;;;;;;286:1;262:116;;;;;;288:2;262:116;;;;;;291:2;262:116;;;;;;294:2;262:116;;;;;;297:2;262:116;;;;;;300:2;262:116;;;;;;303:2;262:116;;;;;;306:2;262:116;;;;;;309:2;262:116;;;;;;312:2;262:116;;;;;;315:2;262:116;;;;;;318:2;262:116;;;;;;321:2;262:116;;;;;;324:2;262:116;;;;;;327:2;262:116;;;;;;330:2;262:116;;;;;;333:2;262:116;;;;;;336:2;262:116;;;;;;339:2;262:116;;;;;;342:2;262:116;;;;;;345:2;262:116;;;;;;348:2;262:116;;;;;;351:2;262:116;;;;;;354:2;262:116;;;;;;357:2;262:116;;;;;;360:2;262:116;;;;;;363:2;262:116;;;;;;366:2;262:116;;;;;;369:2;262:116;;;;;;372:2;262:116;;;;;;375:2;262:116;;;;;:13;276:1;262:16;;;;;;;:::i;:::-;;;;;:116;;;;;;;:::i;:::-;;386:135;;;;;;;;406:1;386:135;;;;;;408:2;386:135;;;;;;411:2;386:135;;;;;;414:2;386:135;;;;;;417:2;386:135;;;;;;420:2;386:135;;;;;;423:2;386:135;;;;;;426:2;386:135;;;;;;429:2;386:135;;;;;;432:2;386:135;;;;;;435:2;386:135;;;;;;438:2;386:135;;;;;;441:2;386:135;;;;;;444:2;386:135;;;;;;447:2;386:135;;;;;;450:2;386:135;;;;;;453:3;386:135;;;;;;457:3;386:135;;;;;;461:3;386:135;;;;;;465:3;386:135;;;;;;469:3;386:135;;;;;;473:3;386:135;;;;;;477:3;386:135;;;;;;481:3;386:135;;;;;;485:3;386:135;;;;;;489:3;386:135;;;;;;493:3;386:135;;;;;;497:3;386:135;;;;;;501:3;386:135;;;;;;505:3;386:135;;;;;;509:3;386:135;;;;;;513:3;386:135;;;;;;517:3;386:135;;;;;:13;400:1;386:16;;;;;;;:::i;:::-;;;;;:135;;;;;;;:::i;:::-;;529:147;;;;;;;;549:1;529:147;;;;;;551:2;529:147;;;;;;554:2;529:147;;;;;;557:2;529:147;;;;;;560:2;529:147;;;;;;563:3;529:147;;;;;;567:3;529:147;;;;;;571:3;529:147;;;;;;575:3;529:147;;;;;;579:3;529:147;;;;;;583:4;529:147;;;;;;588:3;529:147;;;;;;592:3;529:147;;;;;;596:3;529:147;;;;;;600:3;529:147;;;;;;604:3;529:147;;;;;;608:3;529:147;;;;;;612:3;529:147;;;;;;616:3;529:147;;;;;;620:3;529:147;;;;;;624:3;529:147;;;;;;628:3;529:147;;;;;;632:3;529:147;;;;;;636:3;529:147;;;;;;640:3;529:147;;;;;;644:3;529:147;;;;;;648:3;529:147;;;;;;652:3;529:147;;;;;;656:3;529:147;;;;;;660:3;529:147;;;;;;664:3;529:147;;;;;;668:3;529:147;;;;;;672:3;529:147;;;;;:13;543:1;529:16;;;;;;;:::i;:::-;;;;;:147;;;;;;;:::i;:::-;;684:156;;;;;;;;704:2;684:156;;;;;;707:2;684:156;;;;;;710:2;684:156;;;;;;713:2;684:156;;;;;;716:2;684:156;;;;;;719:3;684:156;;;;;;723:2;684:156;;;;;;726:2;684:156;;;;;;729:4;684:156;;;;;;734:3;684:156;;;;;;738:3;684:156;;;;;;742:4;684:156;;;;;;747:3;684:156;;;;;;751:3;684:156;;;;;;755:3;684:156;;;;;;759:4;684:156;;;;;;764:4;684:156;;;;;;769:4;684:156;;;;;;774:4;684:156;;;;;;779:4;684:156;;;;;;784:3;684:156;;;;;;788:3;684:156;;;;;;792:4;684:156;;;;;;797:4;684:156;;;;;;802:4;684:156;;;;;;807:4;684:156;;;;;;812:3;684:156;;;;;;816:3;684:156;;;;;;820:3;684:156;;;;;;824:3;684:156;;;;;;828:3;684:156;;;;;;832:3;684:156;;;;;;836:3;684:156;;;;;:13;698:1;684:16;;;;;;;:::i;:::-;;;;;:156;;;;;;;:::i;:::-;;848:155;;;;;;;;868:2;848:155;;;;;;871:2;848:155;;;;;;874:2;848:155;;;;;;877:2;848:155;;;;;;880:2;848:155;;;;;;883:3;848:155;;;;;;887:3;848:155;;;;;;891:4;848:155;;;;;;896:3;848:155;;;;;;900:3;848:155;;;;;;904:3;848:155;;;;;;908:3;848:155;;;;;;912:4;848:155;;;;;;917:3;848:155;;;;;;921:4;848:155;;;;;;926:3;848:155;;;;;;930:4;848:155;;;;;;935:3;848:155;;;;;;939:3;848:155;;;;;;943:3;848:155;;;;;;947:4;848:155;;;;;;952:4;848:155;;;;;;957:3;848:155;;;;;;961:4;848:155;;;;;;966:3;848:155;;;;;;970:4;848:155;;;;;;975:3;848:155;;;;;;979:3;848:155;;;;;;983:3;848:155;;;;;;987:3;848:155;;;;;;991:3;848:155;;;;;;995:3;848:155;;;;;;999:3;848:155;;;;;:13;862:1;848:16;;;;;;;:::i;:::-;;;;;:155;;;;;;;:::i;:::-;;1011:159;;;;;;;;1031:2;1011:159;;;;;;1034:2;1011:159;;;;;;1037:2;1011:159;;;;;;1040:2;1011:159;;;;;;1043:2;1011:159;;;;;;1046:4;1011:159;;;;;;1051:3;1011:159;;;;;;1055:4;1011:159;;;;;;1060:3;1011:159;;;;;;1064:3;1011:159;;;;;;1068:4;1011:159;;;;;;1073:4;1011:159;;;;;;1078:3;1011:159;;;;;;1082:4;1011:159;;;;;;1087:3;1011:159;;;;;;1091:4;1011:159;;;;;;1096:3;1011:159;;;;;;1100:4;1011:159;;;;;;1105:4;1011:159;;;;;;1110:3;1011:159;;;;;;1114:4;1011:159;;;;;;1119:4;1011:159;;;;;;1124:3;1011:159;;;;;;1128:4;1011:159;;;;;;1133:3;1011:159;;;;;;1137:4;1011:159;;;;;;1142:3;1011:159;;;;;;1146:3;1011:159;;;;;;1150:3;1011:159;;;;;;1154:3;1011:159;;;;;;1158:3;1011:159;;;;;;1162:3;1011:159;;;;;;1166:3;1011:159;;;;;:13;1025:1;1011:16;;;;;;;:::i;:::-;;;;;:159;;;;;;;:::i;:::-;;1178;;;;;;;;1198:2;1178:159;;;;;;1201:2;1178:159;;;;;;1204:2;1178:159;;;;;;1207:2;1178:159;;;;;;1210:3;1178:159;;;;;;1214:4;1178:159;;;;;;1219:3;1178:159;;;;;;1223:4;1178:159;;;;;;1228:3;1178:159;;;;;;1232:3;1178:159;;;;;;1236:4;1178:159;;;;;;1241:4;1178:159;;;;;;1246:3;1178:159;;;;;;1250:4;1178:159;;;;;;1255:3;1178:159;;;;;;1259:4;1178:159;;;;;;1264:3;1178:159;;;;;;1268:4;1178:159;;;;;;1273:3;1178:159;;;;;;1277:4;1178:159;;;;;;1282:3;1178:159;;;;;;1286:4;1178:159;;;;;;1291:3;1178:159;;;;;;1295:4;1178:159;;;;;;1300:3;1178:159;;;;;;1304:4;1178:159;;;;;;1309:3;1178:159;;;;;;1313:3;1178:159;;;;;;1317:3;1178:159;;;;;;1321:3;1178:159;;;;;;1325:3;1178:159;;;;;;1329:3;1178:159;;;;;;1333:3;1178:159;;;;;:13;1192:1;1178:16;;;;;;;:::i;:::-;;;;;:159;;;;;;;:::i;:::-;;1345:164;;;;;;;;1365:2;1345:164;;;;;;1368:2;1345:164;;;;;;1371:2;1345:164;;;;;;1374:2;1345:164;;;;;;1377:3;1345:164;;;;;;1381:4;1345:164;;;;;;1386:3;1345:164;;;;;;1390:4;1345:164;;;;;;1395:3;1345:164;;;;;;1399:3;1345:164;;;;;;1403:4;1345:164;;;;;;1408:3;1345:164;;;;;;1412:4;1345:164;;;;;;1417:4;1345:164;;;;;;1422:3;1345:164;;;;;;1426:4;1345:164;;;;;;1431:3;1345:164;;;;;;1435:4;1345:164;;;;;;1440:3;1345:164;;;;;;1444:4;1345:164;;;;;;1449:3;1345:164;;;;;;1453:4;1345:164;;;;;;1458:3;1345:164;;;;;;1462:4;1345:164;;;;;;1467:3;1345:164;;;;;;1471:5;1345:164;;;;;;1477:5;1345:164;;;;;;1483:5;1345:164;;;;;;1489:3;1345:164;;;;;;1493:3;1345:164;;;;;;1497:3;1345:164;;;;;;1501:3;1345:164;;;;;;1505:3;1345:164;;;;;:13;1359:1;1345:16;;;;;;;:::i;:::-;;;;;:164;;;;;;;:::i;:::-;;1517:166;;;;;;;;1537:2;1517:166;;;;;;1540:2;1517:166;;;;;;1543:2;1517:166;;;;;;1546:3;1517:166;;;;;;1550:3;1517:166;;;;;;1554:4;1517:166;;;;;;1559:3;1517:166;;;;;;1563:4;1517:166;;;;;;1568:3;1517:166;;;;;;1572:4;1517:166;;;;;;1577:3;1517:166;;;;;;1581:3;1517:166;;;;;;1585:4;1517:166;;;;;;1590:4;1517:166;;;;;;1595:3;1517:166;;;;;;1599:4;1517:166;;;;;;1604:3;1517:166;;;;;;1608:4;1517:166;;;;;;1613:3;1517:166;;;;;;1617:4;1517:166;;;;;;1622:3;1517:166;;;;;;1626:4;1517:166;;;;;;1631:3;1517:166;;;;;;1635:5;1517:166;;;;;;1641:3;1517:166;;;;;;1645:5;1517:166;;;;;;1651:5;1517:166;;;;;;1657:5;1517:166;;;;;;1663:3;1517:166;;;;;;1667:3;1517:166;;;;;;1671:3;1517:166;;;;;;1675:3;1517:166;;;;;;1679:3;1517:166;;;;;:13;1531:1;1517:16;;;;;;;:::i;:::-;;;;;:166;;;;;;;:::i;:::-;;1691;;;;;;;;1711:2;1691:166;;;;;;1714:2;1691:166;;;;;;1717:2;1691:166;;;;;;1720:3;1691:166;;;;;;1724:3;1691:166;;;;;;1728:4;1691:166;;;;;;1733:3;1691:166;;;;;;1737:4;1691:166;;;;;;1742:3;1691:166;;;;;;1746:4;1691:166;;;;;;1751:4;1691:166;;;;;;1756:4;1691:166;;;;;;1761:4;1691:166;;;;;;1766:4;1691:166;;;;;;1771:3;1691:166;;;;;;1775:4;1691:166;;;;;;1780:3;1691:166;;;;;;1784:4;1691:166;;;;;;1789:4;1691:166;;;;;;1794:4;1691:166;;;;;;1799:3;1691:166;;;;;;1803:5;1691:166;;;;;;1809:3;1691:166;;;;;;1813:5;1691:166;;;;;;1819:3;1691:166;;;;;;1823:3;1691:166;;;;;;1827:3;1691:166;;;;;;1831:5;1691:166;;;;;;1837:3;1691:166;;;;;;1841:3;1691:166;;;;;;1845:3;1691:166;;;;;;1849:3;1691:166;;;;;;1853:3;1691:166;;;;;:13;1705:1;1691:16;;;;;;;:::i;:::-;;;;;:166;;;;;;;:::i;:::-;;1865;;;;;;;;1886:2;1865:166;;;;;;1889:2;1865:166;;;;;;1892:2;1865:166;;;;;;1895:3;1865:166;;;;;;1899:3;1865:166;;;;;;1903:4;1865:166;;;;;;1908:3;1865:166;;;;;;1912:4;1865:166;;;;;;1917:3;1865:166;;;;;;1921:4;1865:166;;;;;;1926:3;1865:166;;;;;;1930:3;1865:166;;;;;;1934:3;1865:166;;;;;;1938:4;1865:166;;;;;;1943:3;1865:166;;;;;;1947:4;1865:166;;;;;;1952:3;1865:166;;;;;;1956:3;1865:166;;;;;;1960:3;1865:166;;;;;;1964:3;1865:166;;;;;;1968:3;1865:166;;;;;;1972:5;1865:166;;;;;;1978:5;1865:166;;;;;;1984:3;1865:166;;;;;;1988:5;1865:166;;;;;;1994:3;1865:166;;;;;;1998:3;1865:166;;;;;;2002:5;1865:166;;;;;;2008:3;1865:166;;;;;;2012:3;1865:166;;;;;;2016:4;1865:166;;;;;;2021:4;1865:166;;;;;;2026:4;1865:166;;;;;:13;1879:2;1865:17;;;;;;;:::i;:::-;;;;;:166;;;;;;;:::i;:::-;;2039:174;;;;;;;;2060:2;2039:174;;;;;;2063:2;2039:174;;;;;;2066:3;2039:174;;;;;;2070:3;2039:174;;;;;;2074:3;2039:174;;;;;;2078:4;2039:174;;;;;;2083:3;2039:174;;;;;;2087:4;2039:174;;;;;;2092:3;2039:174;;;;;;2096:4;2039:174;;;;;;2101:3;2039:174;;;;;;2105:3;2039:174;;;;;;2109:3;2039:174;;;;;;2113:3;2039:174;;;;;;2117:4;2039:174;;;;;;2122:3;2039:174;;;;;;2126:4;2039:174;;;;;;2131:3;2039:174;;;;;;2135:3;2039:174;;;;;;2139:3;2039:174;;;;;;2143:5;2039:174;;;;;;2149:3;2039:174;;;;;;2153:5;2039:174;;;;;;2159:5;2039:174;;;;;;2165:5;2039:174;;;;;;2171:5;2039:174;;;;;;2177:5;2039:174;;;;;;2183:4;2039:174;;;;;;2188:4;2039:174;;;;;;2193:4;2039:174;;;;;;2198:4;2039:174;;;;;;2203:4;2039:174;;;;;;2208:4;2039:174;;;;;:13;2053:2;2039:17;;;;;;;:::i;:::-;;;;;:174;;;;;;;:::i;:::-;;2221:170;;;;;;;;2242:2;2221:170;;;;;;2245:2;2221:170;;;;;;2248:3;2221:170;;;;;;2252:3;2221:170;;;;;;2256:3;2221:170;;;;;;2260:4;2221:170;;;;;;2265:3;2221:170;;;;;;2269:4;2221:170;;;;;;2274:3;2221:170;;;;;;2278:4;2221:170;;;;;;2283:3;2221:170;;;;;;2287:3;2221:170;;;;;;2291:3;2221:170;;;;;;2295:3;2221:170;;;;;;2299:3;2221:170;;;;;;2303:4;2221:170;;;;;;2308:4;2221:170;;;;;;2313:5;2221:170;;;;;;2319:5;2221:170;;;;;;2325:5;2221:170;;;;;;2331:3;2221:170;;;;;;2335:3;2221:170;;;;;;2339:3;2221:170;;;;;;2343:3;2221:170;;;;;;2347:3;2221:170;;;;;;2351:4;2221:170;;;;;;2356:4;2221:170;;;;;;2361:4;2221:170;;;;;;2366:4;2221:170;;;;;;2371:4;2221:170;;;;;;2376:4;2221:170;;;;;;2381:4;2221:170;;;;;;2386:4;2221:170;;;;;:13;2235:2;2221:17;;;;;;;:::i;:::-;;;;;:170;;;;;;;:::i;:::-;;2399:166;;;;;;;;2420:2;2399:166;;;;;;2423:2;2399:166;;;;;;2426:3;2399:166;;;;;;2430:3;2399:166;;;;;;2434:3;2399:166;;;;;;2438:4;2399:166;;;;;;2443:4;2399:166;;;;;;2448:4;2399:166;;;;;;2453:4;2399:166;;;;;;2458:4;2399:166;;;;;;2463:3;2399:166;;;;;;2467:3;2399:166;;;;;;2471:3;2399:166;;;;;;2475:3;2399:166;;;;;;2479:3;2399:166;;;;;;2483:3;2399:166;;;;;;2487:3;2399:166;;;;;;2491:3;2399:166;;;;;;2495:3;2399:166;;;;;;2499:3;2399:166;;;;;;2503:3;2399:166;;;;;;2507:3;2399:166;;;;;;2511:3;2399:166;;;;;;2515:4;2399:166;;;;;;2520:4;2399:166;;;;;;2525:4;2399:166;;;;;;2530:4;2399:166;;;;;;2535:4;2399:166;;;;;;2540:4;2399:166;;;;;;2545:4;2399:166;;;;;;2550:4;2399:166;;;;;;2555:4;2399:166;;;;;;2560:4;2399:166;;;;;:13;2413:2;2399:17;;;;;;;:::i;:::-;;;;;:166;;;;;;;:::i;:::-;;2573;;;;;;;;2594:2;2573:166;;;;;;2597:2;2573:166;;;;;;2600:3;2573:166;;;;;;2604:3;2573:166;;;;;;2608:3;2573:166;;;;;;2612:3;2573:166;;;;;;2616:4;2573:166;;;;;;2621:4;2573:166;;;;;;2626:4;2573:166;;;;;;2631:4;2573:166;;;;;;2636:3;2573:166;;;;;;2640:3;2573:166;;;;;;2644:3;2573:166;;;;;;2648:3;2573:166;;;;;;2652:3;2573:166;;;;;;2656:3;2573:166;;;;;;2660:3;2573:166;;;;;;2664:3;2573:166;;;;;;2668:3;2573:166;;;;;;2672:3;2573:166;;;;;;2676:3;2573:166;;;;;;2680:3;2573:166;;;;;;2684:4;2573:166;;;;;;2689:4;2573:166;;;;;;2694:4;2573:166;;;;;;2699:4;2573:166;;;;;;2704:4;2573:166;;;;;;2709:4;2573:166;;;;;;2714:4;2573:166;;;;;;2719:4;2573:166;;;;;;2724:4;2573:166;;;;;;2729:4;2573:166;;;;;;2734:4;2573:166;;;;;:13;2587:2;2573:17;;;;;;;:::i;:::-;;;;;:166;;;;;;;:::i;:::-;;2747:164;;;;;;;;2768:2;2747:164;;;;;;2771:2;2747:164;;;;;;2774:3;2747:164;;;;;;2778:3;2747:164;;;;;;2782:3;2747:164;;;;;;2786:3;2747:164;;;;;;2790:3;2747:164;;;;;;2794:3;2747:164;;;;;;2798:3;2747:164;;;;;;2802:3;2747:164;;;;;;2806:3;2747:164;;;;;;2810:3;2747:164;;;;;;2814:3;2747:164;;;;;;2818:3;2747:164;;;;;;2822:3;2747:164;;;;;;2826:3;2747:164;;;;;;2830:3;2747:164;;;;;;2834:3;2747:164;;;;;;2838:3;2747:164;;;;;;2842:3;2747:164;;;;;;2846:4;2747:164;;;;;;2851:4;2747:164;;;;;;2856:4;2747:164;;;;;;2861:4;2747:164;;;;;;2866:4;2747:164;;;;;;2871:4;2747:164;;;;;;2876:4;2747:164;;;;;;2881:4;2747:164;;;;;;2886:4;2747:164;;;;;;2891:4;2747:164;;;;;;2896:4;2747:164;;;;;;2901:4;2747:164;;;;;;2906:4;2747:164;;;;;:13;2761:2;2747:17;;;;;;;:::i;:::-;;;;;:164;;;;;;;:::i;:::-;;125:644:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;:::i;:::-;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;7:180:7:-;55:77;52:1;45:88;152:4;149:1;142:15;176:4;173:1;166:15;193:180;241:77;238:1;231:88;338:4;335:1;328:15;362:4;359:1;352:15;379:320;423:6;460:1;454:4;450:12;440:22;;507:1;501:4;497:12;528:18;518:81;;584:4;576:6;572:17;562:27;;518:81;646:2;638:6;635:14;615:18;612:38;609:84;;665:18;;:::i;:::-;609:84;430:269;379:320;;;:::o;125:644:4:-;;;;;;;","deployedSourceMap":"125:644:4:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6303:809:0;;;;;;;;;;;;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;2094:161;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;138:39:1;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;289:50:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1274:227;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;7118:220;;;;;;;;;;;;;:::i;:::-;;4877:939;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;94:38:1;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;5822:471:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;103:20;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;181:92:4;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;3888:487:0;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4382:489;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;184:50:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2260:1250:0;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;2924:2673:1;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;6303:809:0;6369:26;6397:17;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;6426:13:::1;6442:14;:12;:14::i;:::-;6426:30;;6466:14;6483:15;:13;:15::i;:::-;6466:32;;6509:39;6575:6;6551:31;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6509:73;;6592:30;6640:6;6625:22;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6592:55;;6663:6;6658:402;6679:6;6675:1;:10;6658:402;;;6706:34;6765:5;6743:28;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6706:65;;6785:25;6826:5;6813:19;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6785:47;;6852:6;6847:120;6868:5;6864:1;:9;6847:120;;;6929:23;6947:1;6950;6929:17;:23::i;:::-;6899:9;6909:1;6899:12;;;;;;;;:::i;:::-;;;;;;;6913:9;6923:1;6913:12;;;;;;;;:::i;:::-;;;;;;;6898:54;;;;;;;;;;::::0;::::1;;6875:3;;;;;:::i;:::-;;;;6847:120;;;;6999:9;6981:12;6994:1;6981:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;7040:9;7022:12;7035:1;7022:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;6692:368;;6687:3;;;;;:::i;:::-;;;;6658:402;;;;7078:12;7092;7070:35;;;;;;;;6303:809:::0;;:::o;2094:161::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2199:1:::1;2202;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2215:33:::2;2233:1;2236;2239;2242:5;2215:17;:33::i;:::-;953:1:::1;;2094:161:::0;;;:::o;138:39:1:-;175:2;138:39;:::o;289:50:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1274:227::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;1399:1:::1;1402;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;1420:1:::2;1423;1426:10;1208;1169:49;;:4;:7;1174:1;1169:7;;;;;;;;;;;:10;1177:1;1169:10;;;;;;;;;;;:17;;1187:10;1169:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;;;;;;;;;;;:49;;;1161:89;;;;;;;;;;;;:::i;:::-;;;;;;;;;1486:8:::3;1448:4;:7;1453:1;1448:7;;;;;;;;;;;:10;1456:1;1448:10;;;;;;;;;;;:17;;1466:10;1448:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;:46;;;;;;;;;;;;:::i;:::-;;2080:1:::2;;;953::::1;;1274:227:::0;;;;:::o;7118:220::-;1020:5;;;;;;;;;;1006:19;;:10;:19;;;998:69;;;;;;;;;;;;:::i;:::-;;;;;;;;;7172:23:::1;7198:21;7172:47;;7255:1;7237:15;:19;7229:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;7299:5;::::0;::::1;;;;;;;;7291:23;;:40;7315:15;7291:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;7162:176;7118:220::o:0;4877:939::-;4944:15;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4971:13:::1;4987:14;:12;:14::i;:::-;4971:30;;5011:14;5028:15;:13;:15::i;:::-;5011:32;;5053:24;5093:6;5080:20;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5053:47;;5116:6;5111:673;5132:6;5128:1;:10;5111:673;;;5159:17;5190:5;5179:17;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5159:37;;5215:6;5210:533;5231:5;5227:1;:9;5210:533;;;5262:13;5277:19:::0;5298::::1;5321:18;5334:1;5337;5321:12;:18::i;:::-;5261:78;;;;;;5377:5;5358:3;5362:1;5358:6;;;;;;;;:::i;:::-;;;;;;;;:16;;:24;;;::::0;::::1;5420:1;5405:11;:16:::0;5401:328:::1;;5473:1;5461:14;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5445:3;5449:1;5445:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:30;;;;5516:114;;;;;;;;5563:5;::::0;::::1;;;;;;;;5516:114;;;;;;5602:5;5516:114;;::::0;5497:3:::1;5501:1;5497:6;;;;;;;;:::i;:::-;;;;;;;;:13;;;5511:1;5497:16;;;;;;;;:::i;:::-;;;;;;;:133;;;;5401:328;;;5693:4;:7;5698:1;5693:7;;;;;;;;;;;:10;5701:1;5693:10;;;;;;;;;;;:17;;5677:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;:3;5681:1;5677:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:33;;;;5401:328;5243:500;;;5238:3;;;;;:::i;:::-;;;;5210:533;;;;5770:3;5756:8;5765:1;5756:11;;;;;;;;:::i;:::-;;;;;;;:17;;;;5145:639;5140:3;;;;;:::i;:::-;;;;5111:673;;;;5801:8;5794:15;;;;;4877:939:::0;:::o;94:38:1:-;130:2;94:38;:::o;5822:471:0:-;5927:15;5944:13;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;5912:1:::1;5915;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;5969:16:::2;5988:4;:7;5993:1;5988:7;;;;;;;;;;;:10;5996:1;5988:10;;;;;;;;;;;5969:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;6035:1;6013:4;:11;;;:18;:23:::0;6009:159:::2;;6055:26;6085:21;6101:1;6104;6085:15;:21::i;:::-;6052:54;;;6136:5;::::0;::::2;;;;;;;;6144:12;6120:37;;;;;;;;6009:159;6178:21;6202:4;:11;;;6235:1;6214:4;:11;;;:18;:22;;;;:::i;:::-;6202:35;;;;;;;;:::i;:::-;;;;;;;;6178:59;;6255:8;:14;;;6271:8;:14;;;6247:39;;;;;;2080:1;953::::1;;5822:471:::0;;;;;:::o;103:20::-;;;;;;;;;;;;:::o;181:92:4:-;239:4;262;255:11;;181:92;:::o;3888:487:0:-;3940:7;3959:18;3980:1;3959:22;;3991:13;4007:14;:12;:14::i;:::-;3991:30;;4031:14;4048:15;:13;:15::i;:::-;4031:32;;4079:6;4074:267;4095:6;4091:1;:10;4074:267;;;4127:6;4122:209;4143:5;4139:1;:9;4122:209;;;4173:16;4192:4;:7;4197:1;4192:7;;;;;;;;;;;:10;4200:1;4192:10;;;;;;;;;;;4173:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4220:17;4257:4;:11;;;:18;4240:4;:14;;;:35;;;;:::i;:::-;4220:55;;4307:9;4293:23;;;;;:::i;:::-;;;4155:176;;4150:3;;;;;:::i;:::-;;;;4122:209;;;;4103:3;;;;;:::i;:::-;;;;4074:267;;;;4358:10;4351:17;;;;;3888:487;:::o;4382:489::-;4482:7;4491:13;4506:7;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4467:1:::1;4470;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;4525:16:::2;4544:4;:7;4549:1;4544:7;;;;;;;;;;;:10;4552:1;4544:10;;;;;;;;;;;4525:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;4598:1;4576:4;:11;;;:18;:23:::0;4573:187:::2;;4616:20;4638:26:::0;4668:21:::2;4684:1;4687;4668:15;:21::i;:::-;4615:74;;;;4726:5;4711:12;:20;;;;:::i;:::-;4733:12;4747:1;4703:46;;;;;;;;;;;4573:187;4786:4;:14;;;4802:4;:11;;;4835:1;4814:4;:11;;;:18;:22;;;;:::i;:::-;4802:35;;;;;;;;:::i;:::-;;;;;;;;:41;;;4845:4;:11;;;:18;4778:86;;;;;;;2080:1;953::::1;;4382:489:::0;;;;;:::o;184:50:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2260:1250:0:-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2398:1:::1;2401;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2440:2:::2;2422:14;:20;;2414:71;;;;;;;;;;;;:::i;:::-;;;;;;;;;2496:20;2511:1;2514;2496:14;:20::i;:::-;2527:29;2582:5;2559:4;:7;2564:1;2559:7;;;;;;;;;;;:10;2567:1;2559:10;;;;;;;;;;;:20;;;:28;;;;:::i;:::-;2527:60;;2597:26;2626:4;:7;2631:1;2626:7;;;;;;;;;;;:10;2634:1;2626:10;;;;;;;;;;;:17;;:24;;;;2597:53;;2660:19;2747:1;2742;2725:14;2704:18;2700:1;:22;;;;:::i;:::-;:39;;;;:::i;:::-;:43;;;;:::i;:::-;2682:14;:62;;;;:::i;:::-;:66;;;;:::i;:::-;2660:88;;2759:20;2847:1;2842;2825:14;:18;;;;:::i;:::-;2807:14;:37;;;;:::i;:::-;:41;;;;:::i;:::-;2782:21;:67;;;;:::i;:::-;2759:90;;2860:17;2920:12;2905:11;2881:21;:35;;;;:::i;:::-;2880:52;;;;:::i;:::-;2860:72;;2964:9;2951;:22;2943:53;;;;;;;;;;;;:::i;:::-;;;;;;;;;3012:9;3007:198;3031:18;3027:1;:22;3007:198;;;3070:18;3091:4;:7;3096:1;3091:7;;;;;;;;;;;:10;3099:1;3091:10;;;;;;;;;;;:17;;3109:1;3091:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3070:47;;3180:14;3156:21;:38;;;;:::i;:::-;3131:9;:21;3141:10;3131:21;;;;;;;;;;;;;;;;:63;;;;;;;:::i;:::-;;;;;;;;3056:149;3051:3;;;;;:::i;:::-;;;;3007:198;;;;3215:18;3228:1;3231;3215:12;:18::i;:::-;3249:9;3244:189;3268:14;3264:1;:18;3244:189;;;3303:4;:7;3308:1;3303:7;;;;;;;;;;;:10;3311:1;3303:10;;;;;;;;;;;:17;;3326:95;;;;;;;;3365:10;3326:95;;;;;;3401:5;3326:95;;::::0;3303:119:::2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;3284:3;;;;;:::i;:::-;;;;3244:189;;;;3463:10;3448:55;;;3475:1;3478;3481:14;3497:5;3448:55;;;;;;;;;:::i;:::-;;;;;;;;2404:1106;;;;;953:1:::1;;2260:1250:::0;;;;:::o;2924:2673:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;563:98:4:-;619:7;130:2:1;638:16:4;;563:98;:::o;667:100::-;724:7;175:2:1;743:17:4;;667:100;:::o;283:274::-;356:7;365:13;130:2:1;398:1:4;:13;390:46;;;;;;;;;;;;:::i;:::-;;;;;;;;;175:2:1;454:1:4;:14;446:47;;;;;;;;;;;;:::i;:::-;;;;;;;;;511:13;525:1;511:16;;;;;;;:::i;:::-;;;;;528:1;511:19;;;;;;;:::i;:::-;;;;532:11;544:1;532:14;;;;;;;:::i;:::-;;;;;547:1;532:17;;;;;;;:::i;:::-;;;503:47;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;283:274;;;;;:::o;1507:392:0:-;1594:1;1570:4;:7;1575:1;1570:7;;;;;;;;;;;:10;1578:1;1570:10;;;;;;;;;;;:20;;;:25;:58;;;;;1627:1;1599:4;:7;1604:1;1599:7;;;;;;;;;;;:10;1607:1;1599:10;;;;;;;;;;;:17;;:24;;;;:29;1570:58;1566:327;;;1645:13;1660:19;1683:21;1699:1;1702;1683:15;:21::i;:::-;1644:60;;;;1749:5;1741;:13;;;;:::i;:::-;1718:4;:7;1723:1;1718:7;;;;;;;;;;;:10;1726:1;1718:10;;;;;;;;;;;:20;;:36;;;;1768:4;:7;1773:1;1768:7;;;;;;;;;;;:10;1776:1;1768:10;;;;;;;;;;;:17;;1791:90;;;;;;;;1830:5;;;;;;;;;;1791:90;;;;;;1861:5;1791:90;;;1768:114;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;1630:263;;1566:327;1507:392;;:::o;3517:361::-;3579:9;3574:298;3598:4;:7;3603:1;3598:7;;;;;;;;;;;:10;3606:1;3598:10;;;;;;;;;;;:17;;:24;;;;3594:1;:28;3574:298;;;3643:18;3664:4;:7;3669:1;3664:7;;;;;;;;;;;:10;3672:1;3664:10;;;;;;;;;;;:17;;3682:1;3664:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3643:47;;3732:1;3708:9;:21;3718:10;3708:21;;;;;;;;;;;;;;;;:25;3704:158;;;3761:10;3753:28;;:51;3782:9;:21;3792:10;3782:21;;;;;;;;;;;;;;;;3753:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3846:1;3822:9;:21;3832:10;3822:21;;;;;;;;;;;;;;;:25;;;;3704:158;3629:243;3624:3;;;;;:::i;:::-;;;;3574:298;;;;3517:361;;:::o;-1:-1:-1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;7:147:7:-;107:6;141:5;135:12;125:22;;7:147;;;:::o;160:217::-;292:11;326:6;321:3;314:19;366:4;361:3;357:14;342:29;;160:217;;;;:::o;383:165::-;483:4;506:3;498:11;;536:4;531:3;527:14;519:22;;383:165;;;:::o;554:122::-;629:6;663:5;657:12;647:22;;554:122;;;:::o;682:182::-;779:11;813:6;808:3;801:19;853:4;848:3;844:14;829:29;;682:182;;;;:::o;870:140::-;945:4;968:3;960:11;;998:4;993:3;989:14;981:22;;870:140;;;:::o;1016:126::-;1053:7;1093:42;1086:5;1082:54;1071:65;;1016:126;;;:::o;1148:104::-;1193:7;1222:24;1240:5;1222:24;:::i;:::-;1211:35;;1148:104;;;:::o;1258:132::-;1351:32;1377:5;1351:32;:::i;:::-;1346:3;1339:45;1258:132;;:::o;1396:211::-;1481:10;1502:62;1560:3;1552:6;1502:62;:::i;:::-;1596:4;1591:3;1587:14;1573:28;;1396:211;;;;:::o;1613:121::-;1691:4;1723;1718:3;1714:14;1706:22;;1613:121;;;:::o;1786:776::-;1911:3;1940:62;1996:5;1940:62;:::i;:::-;2018:84;2095:6;2090:3;2018:84;:::i;:::-;2011:91;;2126:64;2184:5;2126:64;:::i;:::-;2213:7;2244:1;2229:308;2254:6;2251:1;2248:13;2229:308;;;2330:6;2324:13;2357:79;2432:3;2417:13;2357:79;:::i;:::-;2350:86;;2459:68;2520:6;2459:68;:::i;:::-;2449:78;;2289:248;2276:1;2273;2269:9;2264:14;;2229:308;;;2233:14;2553:3;2546:10;;1916:646;;;1786:776;;;;:::o;2568:288::-;2703:10;2738:112;2846:3;2838:6;2738:112;:::i;:::-;2724:126;;2568:288;;;;:::o;2862:146::-;2965:4;2997;2992:3;2988:14;2980:22;;2862:146;;;:::o;3064:1175::-;3249:3;3278:87;3359:5;3278:87;:::i;:::-;3381:119;3493:6;3488:3;3381:119;:::i;:::-;3374:126;;3526:3;3571:4;3563:6;3559:17;3554:3;3550:27;3601:89;3684:5;3601:89;:::i;:::-;3713:7;3744:1;3729:465;3754:6;3751:1;3748:13;3729:465;;;3825:9;3819:4;3815:20;3810:3;3803:33;3876:6;3870:13;3904:130;4029:4;4014:13;3904:130;:::i;:::-;3896:138;;4057:93;4143:6;4057:93;:::i;:::-;4047:103;;4179:4;4174:3;4170:14;4163:21;;3789:405;3776:1;3773;3769:9;3764:14;;3729:465;;;3733:14;4210:4;4203:11;;4230:3;4223:10;;3254:985;;;;;3064:1175;;;;:::o;4245:149::-;4347:6;4381:5;4375:12;4365:22;;4245:149;;;:::o;4400:219::-;4534:11;4568:6;4563:3;4556:19;4608:4;4603:3;4599:14;4584:29;;4400:219;;;;:::o;4625:167::-;4727:4;4750:3;4742:11;;4780:4;4775:3;4771:14;4763:22;;4625:167;;;:::o;4798:124::-;4875:6;4909:5;4903:12;4893:22;;4798:124;;;:::o;4928:184::-;5027:11;5061:6;5056:3;5049:19;5101:4;5096:3;5092:14;5077:29;;4928:184;;;;:::o;5118:142::-;5195:4;5218:3;5210:11;;5248:4;5243:3;5239:14;5231:22;;5118:142;;;:::o;5266:99::-;5318:6;5352:5;5346:12;5336:22;;5266:99;;;:::o;5371:159::-;5445:11;5479:6;5474:3;5467:19;5519:4;5514:3;5510:14;5495:29;;5371:159;;;;:::o;5536:307::-;5604:1;5614:113;5628:6;5625:1;5622:13;5614:113;;;5713:1;5708:3;5704:11;5698:18;5694:1;5689:3;5685:11;5678:39;5650:2;5647:1;5643:10;5638:15;;5614:113;;;5745:6;5742:1;5739:13;5736:101;;;5825:1;5816:6;5811:3;5807:16;5800:27;5736:101;5585:258;5536:307;;;:::o;5849:102::-;5890:6;5941:2;5937:7;5932:2;5925:5;5921:14;5917:28;5907:38;;5849:102;;;:::o;5957:344::-;6035:3;6063:39;6096:5;6063:39;:::i;:::-;6118:61;6172:6;6167:3;6118:61;:::i;:::-;6111:68;;6188:52;6233:6;6228:3;6221:4;6214:5;6210:16;6188:52;:::i;:::-;6265:29;6287:6;6265:29;:::i;:::-;6260:3;6256:39;6249:46;;6039:262;5957:344;;;;:::o;6307:196::-;6396:10;6431:66;6493:3;6485:6;6431:66;:::i;:::-;6417:80;;6307:196;;;;:::o;6509:123::-;6589:4;6621;6616:3;6612:14;6604:22;;6509:123;;;:::o;6666:971::-;6795:3;6824:64;6882:5;6824:64;:::i;:::-;6904:86;6983:6;6978:3;6904:86;:::i;:::-;6897:93;;7016:3;7061:4;7053:6;7049:17;7044:3;7040:27;7091:66;7151:5;7091:66;:::i;:::-;7180:7;7211:1;7196:396;7221:6;7218:1;7215:13;7196:396;;;7292:9;7286:4;7282:20;7277:3;7270:33;7343:6;7337:13;7371:84;7450:4;7435:13;7371:84;:::i;:::-;7363:92;;7478:70;7541:6;7478:70;:::i;:::-;7468:80;;7577:4;7572:3;7568:14;7561:21;;7256:336;7243:1;7240;7236:9;7231:14;;7196:396;;;7200:14;7608:4;7601:11;;7628:3;7621:10;;6800:837;;;;;6666:971;;;;:::o;7643:296::-;7782:10;7817:116;7929:3;7921:6;7817:116;:::i;:::-;7803:130;;7643:296;;;;:::o;7945:148::-;8050:4;8082;8077:3;8073:14;8065:22;;7945:148;;;:::o;8131:1191::-;8320:3;8349:89;8432:5;8349:89;:::i;:::-;8454:121;8568:6;8563:3;8454:121;:::i;:::-;8447:128;;8601:3;8646:4;8638:6;8634:17;8629:3;8625:27;8676:91;8761:5;8676:91;:::i;:::-;8790:7;8821:1;8806:471;8831:6;8828:1;8825:13;8806:471;;;8902:9;8896:4;8892:20;8887:3;8880:33;8953:6;8947:13;8981:134;9110:4;9095:13;8981:134;:::i;:::-;8973:142;;9138:95;9226:6;9138:95;:::i;:::-;9128:105;;9262:4;9257:3;9253:14;9246:21;;8866:411;8853:1;8850;8846:9;8841:14;;8806:471;;;8810:14;9293:4;9286:11;;9313:3;9306:10;;8325:997;;;;;8131:1191;;;;:::o;9328:906::-;9685:4;9723:2;9712:9;9708:18;9700:26;;9772:9;9766:4;9762:20;9758:1;9747:9;9743:17;9736:47;9800:174;9969:4;9960:6;9800:174;:::i;:::-;9792:182;;10021:9;10015:4;10011:20;10006:2;9995:9;9991:18;9984:48;10049:178;10222:4;10213:6;10049:178;:::i;:::-;10041:186;;9328:906;;;;;:::o;10240:75::-;10273:6;10306:2;10300:9;10290:19;;10240:75;:::o;10321:117::-;10430:1;10427;10420:12;10444:117;10553:1;10550;10543:12;10567:77;10604:7;10633:5;10622:16;;10567:77;;;:::o;10650:122::-;10723:24;10741:5;10723:24;:::i;:::-;10716:5;10713:35;10703:63;;10762:1;10759;10752:12;10703:63;10650:122;:::o;10778:139::-;10824:5;10862:6;10849:20;10840:29;;10878:33;10905:5;10878:33;:::i;:::-;10778:139;;;;:::o;10923:117::-;11032:1;11029;11022:12;11046:117;11155:1;11152;11145:12;11169:180;11217:77;11214:1;11207:88;11314:4;11311:1;11304:15;11338:4;11335:1;11328:15;11355:281;11438:27;11460:4;11438:27;:::i;:::-;11430:6;11426:40;11568:6;11556:10;11553:22;11532:18;11520:10;11517:34;11514:62;11511:88;;;11579:18;;:::i;:::-;11511:88;11619:10;11615:2;11608:22;11398:238;11355:281;;:::o;11642:129::-;11676:6;11703:20;;:::i;:::-;11693:30;;11732:33;11760:4;11752:6;11732:33;:::i;:::-;11642:129;;;:::o;11777:308::-;11839:4;11929:18;11921:6;11918:30;11915:56;;;11951:18;;:::i;:::-;11915:56;11989:29;12011:6;11989:29;:::i;:::-;11981:37;;12073:4;12067;12063:15;12055:23;;11777:308;;;:::o;12091:154::-;12175:6;12170:3;12165;12152:30;12237:1;12228:6;12223:3;12219:16;12212:27;12091:154;;;:::o;12251:412::-;12329:5;12354:66;12370:49;12412:6;12370:49;:::i;:::-;12354:66;:::i;:::-;12345:75;;12443:6;12436:5;12429:21;12481:4;12474:5;12470:16;12519:3;12510:6;12505:3;12501:16;12498:25;12495:112;;;12526:79;;:::i;:::-;12495:112;12616:41;12650:6;12645:3;12640;12616:41;:::i;:::-;12335:328;12251:412;;;;;:::o;12683:340::-;12739:5;12788:3;12781:4;12773:6;12769:17;12765:27;12755:122;;12796:79;;:::i;:::-;12755:122;12913:6;12900:20;12938:79;13013:3;13005:6;12998:4;12990:6;12986:17;12938:79;:::i;:::-;12929:88;;12745:278;12683:340;;;;:::o;13029:799::-;13116:6;13124;13132;13181:2;13169:9;13160:7;13156:23;13152:32;13149:119;;;13187:79;;:::i;:::-;13149:119;13307:1;13332:53;13377:7;13368:6;13357:9;13353:22;13332:53;:::i;:::-;13322:63;;13278:117;13434:2;13460:53;13505:7;13496:6;13485:9;13481:22;13460:53;:::i;:::-;13450:63;;13405:118;13590:2;13579:9;13575:18;13562:32;13621:18;13613:6;13610:30;13607:117;;;13643:79;;:::i;:::-;13607:117;13748:63;13803:7;13794:6;13783:9;13779:22;13748:63;:::i;:::-;13738:73;;13533:288;13029:799;;;;;:::o;13834:118::-;13921:24;13939:5;13921:24;:::i;:::-;13916:3;13909:37;13834:118;;:::o;13958:222::-;14051:4;14089:2;14078:9;14074:18;14066:26;;14102:71;14170:1;14159:9;14155:17;14146:6;14102:71;:::i;:::-;13958:222;;;;:::o;14186:474::-;14254:6;14262;14311:2;14299:9;14290:7;14286:23;14282:32;14279:119;;;14317:79;;:::i;:::-;14279:119;14437:1;14462:53;14507:7;14498:6;14487:9;14483:22;14462:53;:::i;:::-;14452:63;;14408:117;14564:2;14590:53;14635:7;14626:6;14615:9;14611:22;14590:53;:::i;:::-;14580:63;;14535:118;14186:474;;;;;:::o;14666:945::-;14762:6;14770;14778;14786;14835:3;14823:9;14814:7;14810:23;14806:33;14803:120;;;14842:79;;:::i;:::-;14803:120;14962:1;14987:53;15032:7;15023:6;15012:9;15008:22;14987:53;:::i;:::-;14977:63;;14933:117;15089:2;15115:53;15160:7;15151:6;15140:9;15136:22;15115:53;:::i;:::-;15105:63;;15060:118;15217:2;15243:53;15288:7;15279:6;15268:9;15264:22;15243:53;:::i;:::-;15233:63;;15188:118;15373:2;15362:9;15358:18;15345:32;15404:18;15396:6;15393:30;15390:117;;;15426:79;;:::i;:::-;15390:117;15531:63;15586:7;15577:6;15566:9;15562:22;15531:63;:::i;:::-;15521:73;;15316:288;14666:945;;;;;;;:::o;15617:159::-;15729:6;15763:5;15757:12;15747:22;;15617:159;;;:::o;15782:229::-;15926:11;15960:6;15955:3;15948:19;16000:4;15995:3;15991:14;15976:29;;15782:229;;;;:::o;16017:177::-;16129:4;16152:3;16144:11;;16182:4;16177:3;16173:14;16165:22;;16017:177;;;:::o;16200:134::-;16287:6;16321:5;16315:12;16305:22;;16200:134;;;:::o;16340:194::-;16449:11;16483:6;16478:3;16471:19;16523:4;16518:3;16514:14;16499:29;;16340:194;;;;:::o;16540:152::-;16627:4;16650:3;16642:11;;16680:4;16675:3;16671:14;16663:22;;16540:152;;;:::o;16698:108::-;16775:24;16793:5;16775:24;:::i;:::-;16770:3;16763:37;16698:108;;:::o;16812:134::-;16899:6;16933:5;16927:12;16917:22;;16812:134;;;:::o;16952:194::-;17061:11;17095:6;17090:3;17083:19;17135:4;17130:3;17126:14;17111:29;;16952:194;;;;:::o;17152:152::-;17239:4;17262:3;17254:11;;17292:4;17287:3;17283:14;17275:22;;17152:152;;;:::o;17372:604::-;17471:3;17507:4;17502:3;17498:14;17595:4;17588:5;17584:16;17578:23;17614:79;17687:4;17682:3;17678:14;17664:12;17614:79;:::i;:::-;17522:181;17786:4;17779:5;17775:16;17769:23;17839:3;17833:4;17829:14;17822:4;17817:3;17813:14;17806:38;17865:73;17933:4;17919:12;17865:73;:::i;:::-;17857:81;;17713:236;17966:4;17959:11;;17476:500;17372:604;;;;:::o;17982:236::-;18091:10;18126:86;18208:3;18200:6;18126:86;:::i;:::-;18112:100;;17982:236;;;;:::o;18224:133::-;18314:4;18346;18341:3;18337:14;18329:22;;18224:133;;;:::o;18429:1051::-;18578:3;18607:74;18675:5;18607:74;:::i;:::-;18697:96;18786:6;18781:3;18697:96;:::i;:::-;18690:103;;18819:3;18864:4;18856:6;18852:17;18847:3;18843:27;18894:76;18964:5;18894:76;:::i;:::-;18993:7;19024:1;19009:426;19034:6;19031:1;19028:13;19009:426;;;19105:9;19099:4;19095:20;19090:3;19083:33;19156:6;19150:13;19184:104;19283:4;19268:13;19184:104;:::i;:::-;19176:112;;19311:80;19384:6;19311:80;:::i;:::-;19301:90;;19420:4;19415:3;19411:14;19404:21;;19069:366;19056:1;19053;19049:9;19044:14;;19009:426;;;19013:14;19451:4;19444:11;;19471:3;19464:10;;18583:897;;;;;18429:1051;;;;:::o;19546:663::-;19645:3;19681:4;19676:3;19672:14;19773:4;19766:5;19762:16;19756:23;19792:63;19849:4;19844:3;19840:14;19826:12;19792:63;:::i;:::-;19696:169;19949:4;19942:5;19938:16;19932:23;20002:3;19996:4;19992:14;19985:4;19980:3;19976:14;19969:38;20028:143;20166:4;20152:12;20028:143;:::i;:::-;20020:151;;19875:307;20199:4;20192:11;;19650:559;19546:663;;;;:::o;20215:236::-;20324:10;20359:86;20441:3;20433:6;20359:86;:::i;:::-;20345:100;;20215:236;;;;:::o;20457:133::-;20547:4;20579;20574:3;20570:14;20562:22;;20457:133;;;:::o;20660:1051::-;20809:3;20838:74;20906:5;20838:74;:::i;:::-;20928:96;21017:6;21012:3;20928:96;:::i;:::-;20921:103;;21050:3;21095:4;21087:6;21083:17;21078:3;21074:27;21125:76;21195:5;21125:76;:::i;:::-;21224:7;21255:1;21240:426;21265:6;21262:1;21259:13;21240:426;;;21336:9;21330:4;21326:20;21321:3;21314:33;21387:6;21381:13;21415:104;21514:4;21499:13;21415:104;:::i;:::-;21407:112;;21542:80;21615:6;21542:80;:::i;:::-;21532:90;;21651:4;21646:3;21642:14;21635:21;;21300:366;21287:1;21284;21280:9;21275:14;;21240:426;;;21244:14;21682:4;21675:11;;21702:3;21695:10;;20814:897;;;;;20660:1051;;;;:::o;21717:336::-;21876:10;21911:136;22043:3;22035:6;21911:136;:::i;:::-;21897:150;;21717:336;;;;:::o;22059:158::-;22174:4;22206;22201:3;22197:14;22189:22;;22059:158;;;:::o;22291:1271::-;22500:3;22529:99;22622:5;22529:99;:::i;:::-;22644:131;22768:6;22763:3;22644:131;:::i;:::-;22637:138;;22801:3;22846:4;22838:6;22834:17;22829:3;22825:27;22876:101;22971:5;22876:101;:::i;:::-;23000:7;23031:1;23016:501;23041:6;23038:1;23035:13;23016:501;;;23112:9;23106:4;23102:20;23097:3;23090:33;23163:6;23157:13;23191:154;23340:4;23325:13;23191:154;:::i;:::-;23183:162;;23368:105;23466:6;23368:105;:::i;:::-;23358:115;;23502:4;23497:3;23493:14;23486:21;;23076:441;23063:1;23060;23056:9;23051:14;;23016:501;;;23020:14;23533:4;23526:11;;23553:3;23546:10;;22505:1057;;;;;22291:1271;;;;:::o;23568:553::-;23801:4;23839:2;23828:9;23824:18;23816:26;;23888:9;23882:4;23878:20;23874:1;23863:9;23859:17;23852:47;23916:198;24109:4;24100:6;23916:198;:::i;:::-;23908:206;;23568:553;;;;:::o;24127:142::-;24230:32;24256:5;24230:32;:::i;:::-;24225:3;24218:45;24127:142;;:::o;24275:169::-;24359:11;24393:6;24388:3;24381:19;24433:4;24428:3;24424:14;24409:29;;24275:169;;;;:::o;24450:364::-;24538:3;24566:39;24599:5;24566:39;:::i;:::-;24621:71;24685:6;24680:3;24621:71;:::i;:::-;24614:78;;24701:52;24746:6;24741:3;24734:4;24727:5;24723:16;24701:52;:::i;:::-;24778:29;24800:6;24778:29;:::i;:::-;24773:3;24769:39;24762:46;;24542:272;24450:364;;;;:::o;24820:455::-;24977:4;25015:2;25004:9;25000:18;24992:26;;25028:87;25112:1;25101:9;25097:17;25088:6;25028:87;:::i;:::-;25162:9;25156:4;25152:20;25147:2;25136:9;25132:18;25125:48;25190:78;25263:4;25254:6;25190:78;:::i;:::-;25182:86;;24820:455;;;;;:::o;25281:96::-;25318:7;25347:24;25365:5;25347:24;:::i;:::-;25336:35;;25281:96;;;:::o;25383:118::-;25470:24;25488:5;25470:24;:::i;:::-;25465:3;25458:37;25383:118;;:::o;25507:222::-;25600:4;25638:2;25627:9;25623:18;25615:26;;25651:71;25719:1;25708:9;25704:17;25695:6;25651:71;:::i;:::-;25507:222;;;;:::o;25735:90::-;25769:7;25812:5;25805:13;25798:21;25787:32;;25735:90;;;:::o;25831:109::-;25912:21;25927:5;25912:21;:::i;:::-;25907:3;25900:34;25831:109;;:::o;25946:210::-;26033:4;26071:2;26060:9;26056:18;26048:26;;26084:65;26146:1;26135:9;26131:17;26122:6;26084:65;:::i;:::-;25946:210;;;;:::o;26162:533::-;26331:4;26369:2;26358:9;26354:18;26346:26;;26382:71;26450:1;26439:9;26435:17;26426:6;26382:71;:::i;:::-;26500:9;26494:4;26490:20;26485:2;26474:9;26470:18;26463:48;26528:78;26601:4;26592:6;26528:78;:::i;:::-;26520:86;;26616:72;26684:2;26673:9;26669:18;26660:6;26616:72;:::i;:::-;26162:533;;;;;;:::o;26701:313::-;26814:4;26852:2;26841:9;26837:18;26829:26;;26901:9;26895:4;26891:20;26887:1;26876:9;26872:17;26865:47;26929:78;27002:4;26993:6;26929:78;:::i;:::-;26921:86;;26701:313;;;;:::o;27020:173::-;27160:25;27156:1;27148:6;27144:14;27137:49;27020:173;:::o;27199:366::-;27341:3;27362:67;27426:2;27421:3;27362:67;:::i;:::-;27355:74;;27438:93;27527:3;27438:93;:::i;:::-;27556:2;27551:3;27547:12;27540:19;;27199:366;;;:::o;27571:419::-;27737:4;27775:2;27764:9;27760:18;27752:26;;27824:9;27818:4;27814:20;27810:1;27799:9;27795:17;27788:47;27852:131;27978:4;27852:131;:::i;:::-;27844:139;;27571:419;;;:::o;27996:180::-;28044:77;28041:1;28034:88;28141:4;28138:1;28131:15;28165:4;28162:1;28155:15;28182:180;28230:77;28227:1;28220:88;28327:4;28324:1;28317:15;28351:4;28348:1;28341:15;28368:233;28407:3;28430:24;28448:5;28430:24;:::i;:::-;28421:33;;28476:66;28469:5;28466:77;28463:103;;28546:18;;:::i;:::-;28463:103;28593:1;28586:5;28582:13;28575:20;;28368:233;;;:::o;28607:170::-;28747:22;28743:1;28735:6;28731:14;28724:46;28607:170;:::o;28783:366::-;28925:3;28946:67;29010:2;29005:3;28946:67;:::i;:::-;28939:74;;29022:93;29111:3;29022:93;:::i;:::-;29140:2;29135:3;29131:12;29124:19;;28783:366;;;:::o;29155:419::-;29321:4;29359:2;29348:9;29344:18;29336:26;;29408:9;29402:4;29398:20;29394:1;29383:9;29379:17;29372:47;29436:131;29562:4;29436:131;:::i;:::-;29428:139;;29155:419;;;:::o;29580:170::-;29720:22;29716:1;29708:6;29704:14;29697:46;29580:170;:::o;29756:366::-;29898:3;29919:67;29983:2;29978:3;29919:67;:::i;:::-;29912:74;;29995:93;30084:3;29995:93;:::i;:::-;30113:2;30108:3;30104:12;30097:19;;29756:366;;;:::o;30128:419::-;30294:4;30332:2;30321:9;30317:18;30309:26;;30381:9;30375:4;30371:20;30367:1;30356:9;30352:17;30345:47;30409:131;30535:4;30409:131;:::i;:::-;30401:139;;30128:419;;;:::o;30553:177::-;30693:29;30689:1;30681:6;30677:14;30670:53;30553:177;:::o;30736:366::-;30878:3;30899:67;30963:2;30958:3;30899:67;:::i;:::-;30892:74;;30975:93;31064:3;30975:93;:::i;:::-;31093:2;31088:3;31084:12;31077:19;;30736:366;;;:::o;31108:419::-;31274:4;31312:2;31301:9;31297:18;31289:26;;31361:9;31355:4;31351:20;31347:1;31336:9;31332:17;31325:47;31389:131;31515:4;31389:131;:::i;:::-;31381:139;;31108:419;;;:::o;31533:224::-;31673:34;31669:1;31661:6;31657:14;31650:58;31742:7;31737:2;31729:6;31725:15;31718:32;31533:224;:::o;31763:366::-;31905:3;31926:67;31990:2;31985:3;31926:67;:::i;:::-;31919:74;;32002:93;32091:3;32002:93;:::i;:::-;32120:2;32115:3;32111:12;32104:19;;31763:366;;;:::o;32135:419::-;32301:4;32339:2;32328:9;32324:18;32316:26;;32388:9;32382:4;32378:20;32374:1;32363:9;32359:17;32352:47;32416:131;32542:4;32416:131;:::i;:::-;32408:139;;32135:419;;;:::o;32560:170::-;32700:22;32696:1;32688:6;32684:14;32677:46;32560:170;:::o;32736:366::-;32878:3;32899:67;32963:2;32958:3;32899:67;:::i;:::-;32892:74;;32975:93;33064:3;32975:93;:::i;:::-;33093:2;33088:3;33084:12;33077:19;;32736:366;;;:::o;33108:419::-;33274:4;33312:2;33301:9;33297:18;33289:26;;33361:9;33355:4;33351:20;33347:1;33336:9;33332:17;33325:47;33389:131;33515:4;33389:131;:::i;:::-;33381:139;;33108:419;;;:::o;33533:180::-;33581:77;33578:1;33571:88;33678:4;33675:1;33668:15;33702:4;33699:1;33692:15;33719:320;33763:6;33800:1;33794:4;33790:12;33780:22;;33847:1;33841:4;33837:12;33868:18;33858:81;;33924:4;33916:6;33912:17;33902:27;;33858:81;33986:2;33978:6;33975:14;33955:18;33952:38;33949:84;;34005:18;;:::i;:::-;33949:84;33770:269;33719:320;;;:::o;34045:191::-;34085:4;34105:20;34123:1;34105:20;:::i;:::-;34100:25;;34139:20;34157:1;34139:20;:::i;:::-;34134:25;;34178:1;34175;34172:8;34169:34;;;34183:18;;:::i;:::-;34169:34;34228:1;34225;34221:9;34213:17;;34045:191;;;;:::o;34242:348::-;34282:7;34305:20;34323:1;34305:20;:::i;:::-;34300:25;;34339:20;34357:1;34339:20;:::i;:::-;34334:25;;34527:1;34459:66;34455:74;34452:1;34449:81;34444:1;34437:9;34430:17;34426:105;34423:131;;;34534:18;;:::i;:::-;34423:131;34582:1;34579;34575:9;34564:20;;34242:348;;;;:::o;34596:305::-;34636:3;34655:20;34673:1;34655:20;:::i;:::-;34650:25;;34689:20;34707:1;34689:20;:::i;:::-;34684:25;;34843:1;34775:66;34771:74;34768:1;34765:81;34762:107;;;34849:18;;:::i;:::-;34762:107;34893:1;34890;34886:9;34879:16;;34596:305;;;;:::o;34907:225::-;35047:34;35043:1;35035:6;35031:14;35024:58;35116:8;35111:2;35103:6;35099:15;35092:33;34907:225;:::o;35138:366::-;35280:3;35301:67;35365:2;35360:3;35301:67;:::i;:::-;35294:74;;35377:93;35466:3;35377:93;:::i;:::-;35495:2;35490:3;35486:12;35479:19;;35138:366;;;:::o;35510:419::-;35676:4;35714:2;35703:9;35699:18;35691:26;;35763:9;35757:4;35753:20;35749:1;35738:9;35734:17;35727:47;35791:131;35917:4;35791:131;:::i;:::-;35783:139;;35510:419;;;:::o;35935:180::-;35983:77;35980:1;35973:88;36080:4;36077:1;36070:15;36104:4;36101:1;36094:15;36121:185;36161:1;36178:20;36196:1;36178:20;:::i;:::-;36173:25;;36212:20;36230:1;36212:20;:::i;:::-;36207:25;;36251:1;36241:35;;36256:18;;:::i;:::-;36241:35;36298:1;36295;36291:9;36286:14;;36121:185;;;;:::o;36312:168::-;36452:20;36448:1;36440:6;36436:14;36429:44;36312:168;:::o;36486:366::-;36628:3;36649:67;36713:2;36708:3;36649:67;:::i;:::-;36642:74;;36725:93;36814:3;36725:93;:::i;:::-;36843:2;36838:3;36834:12;36827:19;;36486:366;;;:::o;36858:419::-;37024:4;37062:2;37051:9;37047:18;37039:26;;37111:9;37105:4;37101:20;37097:1;37086:9;37082:17;37075:47;37139:131;37265:4;37139:131;:::i;:::-;37131:139;;36858:419;;;:::o;37283:644::-;37480:4;37518:3;37507:9;37503:19;37495:27;;37532:71;37600:1;37589:9;37585:17;37576:6;37532:71;:::i;:::-;37613:72;37681:2;37670:9;37666:18;37657:6;37613:72;:::i;:::-;37695;37763:2;37752:9;37748:18;37739:6;37695:72;:::i;:::-;37814:9;37808:4;37804:20;37799:2;37788:9;37784:18;37777:48;37842:78;37915:4;37906:6;37842:78;:::i;:::-;37834:86;;37283:644;;;;;;;:::o;37933:170::-;38073:22;38069:1;38061:6;38057:14;38050:46;37933:170;:::o;38109:366::-;38251:3;38272:67;38336:2;38331:3;38272:67;:::i;:::-;38265:74;;38348:93;38437:3;38348:93;:::i;:::-;38466:2;38461:3;38457:12;38450:19;;38109:366;;;:::o;38481:419::-;38647:4;38685:2;38674:9;38670:18;38662:26;;38734:9;38728:4;38724:20;38720:1;38709:9;38705:17;38698:47;38762:131;38888:4;38762:131;:::i;:::-;38754:139;;38481:419;;;:::o;38906:170::-;39046:22;39042:1;39034:6;39030:14;39023:46;38906:170;:::o;39082:366::-;39224:3;39245:67;39309:2;39304:3;39245:67;:::i;:::-;39238:74;;39321:93;39410:3;39321:93;:::i;:::-;39439:2;39434:3;39430:12;39423:19;;39082:366;;;:::o;39454:419::-;39620:4;39658:2;39647:9;39643:18;39635:26;;39707:9;39701:4;39697:20;39693:1;39682:9;39678:17;39671:47;39735:131;39861:4;39735:131;:::i;:::-;39727:139;;39454:419;;;:::o","source":"// SPDX-License-Identifier: MIT\\npragma solidity >=0.4.22 <0.9.0;\\n\\nimport \\"./BaseContract.sol\\";\\nimport \\"./DataStorage1.sol\\";\\n\\ncontract Pixelflux1 is BaseContract, DataStorage1 {\\n    function isContractEnabled() public override view returns(bool) {\\n        return true;\\n    }\\n    \\n    function getInitialValue(uint x, uint y) internal override view returns (uint256, string memory) {\\n        require(x < gridWidth, \\"Invalid x-coordinate\\");\\n        require(y < gridHeight, \\"Invalid y-coordinate\\");\\n        return (initialValues[y][x], colorValues[y][x]);\\n    }\\n\\n    function getGridWidth() internal override pure returns (uint256) {\\n        return gridWidth;\\n    }\\n\\n    function getGridHeight() internal override pure returns (uint256) {\\n        return gridHeight;\\n    }\\n}\\n","sourcePath":"/home/wao/Meteor/Workspace/Sao/polygon/contracts/Pixelflux1.sol","ast":{"absolutePath":"project:/contracts/Pixelflux1.sol","exportedSymbols":{"BaseContract":[1001],"DataStorage1":[2195],"Pixelflux1":[4877]},"id":4878,"license":"MIT","nodeType":"SourceUnit","nodes":[{"id":4804,"literals":["solidity",">=","0.4",".22","<","0.9",".0"],"nodeType":"PragmaDirective","src":"32:32:4"},{"absolutePath":"project:/contracts/BaseContract.sol","file":"./BaseContract.sol","id":4805,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":4878,"sourceUnit":1002,"src":"66:28:4","symbolAliases":[],"unitAlias":""},{"absolutePath":"project:/contracts/DataStorage1.sol","file":"./DataStorage1.sol","id":4806,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":4878,"sourceUnit":2196,"src":"95:28:4","symbolAliases":[],"unitAlias":""},{"abstract":false,"baseContracts":[{"baseName":{"id":4807,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"148:12:4"},"id":4808,"nodeType":"InheritanceSpecifier","src":"148:12:4"},{"baseName":{"id":4809,"name":"DataStorage1","nodeType":"IdentifierPath","referencedDeclaration":2195,"src":"162:12:4"},"id":4810,"nodeType":"InheritanceSpecifier","src":"162:12:4"}],"canonicalName":"Pixelflux1","contractDependencies":[],"contractKind":"contract","fullyImplemented":true,"id":4877,"linearizedBaseContracts":[4877,2195,1001],"name":"Pixelflux1","nameLocation":"134:10:4","nodeType":"ContractDefinition","nodes":[{"baseFunctions":[52],"body":{"id":4818,"nodeType":"Block","src":"245:28:4","statements":[{"expression":{"hexValue":"74727565","id":4816,"isConstant":false,"isLValue":false,"isPure":true,"kind":"bool","lValueRequested":false,"nodeType":"Literal","src":"262:4:4","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"value":"true"},"functionReturnParameters":4815,"id":4817,"nodeType":"Return","src":"255:11:4"}]},"functionSelector":"9d602d2d","id":4819,"implemented":true,"kind":"function","modifiers":[],"name":"isContractEnabled","nameLocation":"190:17:4","nodeType":"FunctionDefinition","overrides":{"id":4812,"nodeType":"OverrideSpecifier","overrides":[],"src":"217:8:4"},"parameters":{"id":4811,"nodeType":"ParameterList","parameters":[],"src":"207:2:4"},"returnParameters":{"id":4815,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4814,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4819,"src":"239:4:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":4813,"name":"bool","nodeType":"ElementaryTypeName","src":"239:4:4","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"visibility":"internal"}],"src":"238:6:4"},"scope":4877,"src":"181:92:4","stateMutability":"view","virtual":false,"visibility":"public"},{"baseFunctions":[63],"body":{"id":4857,"nodeType":"Block","src":"380:177:4","statements":[{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":4834,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":4832,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4821,"src":"398:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":4833,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1006,"src":"402:9:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"398:13:4","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420782d636f6f7264696e617465","id":4835,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"413:22:4","typeDescriptions":{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""},"value":"Invalid x-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""}],"id":4831,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"390:7:4","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":4836,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"390:46:4","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4837,"nodeType":"ExpressionStatement","src":"390:46:4"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":4841,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":4839,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4823,"src":"454:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":4840,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1009,"src":"458:10:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"454:14:4","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420792d636f6f7264696e617465","id":4842,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"470:22:4","typeDescriptions":{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""},"value":"Invalid y-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""}],"id":4838,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"446:7:4","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":4843,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"446:47:4","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4844,"nodeType":"ExpressionStatement","src":"446:47:4"},{"expression":{"components":[{"baseExpression":{"baseExpression":{"id":4845,"name":"initialValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1015,"src":"511:13:4","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_uint256_$33_storage_$33_storage","typeString":"uint256[33] storage ref[33] storage ref"}},"id":4847,"indexExpression":{"id":4846,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4823,"src":"525:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"511:16:4","typeDescriptions":{"typeIdentifier":"t_array$_t_uint256_$33_storage","typeString":"uint256[33] storage ref"}},"id":4849,"indexExpression":{"id":4848,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4821,"src":"528:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"511:19:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},{"baseExpression":{"baseExpression":{"id":4850,"name":"colorValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2194,"src":"532:11:4","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_string_storage_$33_storage_$33_storage","typeString":"string storage ref[33] storage ref[33] storage ref"}},"id":4852,"indexExpression":{"id":4851,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4823,"src":"544:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"532:14:4","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$33_storage","typeString":"string storage ref[33] storage ref"}},"id":4854,"indexExpression":{"id":4853,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4821,"src":"547:1:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"532:17:4","typeDescriptions":{"typeIdentifier":"t_string_storage","typeString":"string storage ref"}}],"id":4855,"isConstant":false,"isInlineArray":false,"isLValue":false,"isPure":false,"lValueRequested":false,"nodeType":"TupleExpression","src":"510:40:4","typeDescriptions":{"typeIdentifier":"t_tuple$_t_uint256_$_t_string_storage_$","typeString":"tuple(uint256,string storage ref)"}},"functionReturnParameters":4830,"id":4856,"nodeType":"Return","src":"503:47:4"}]},"id":4858,"implemented":true,"kind":"function","modifiers":[],"name":"getInitialValue","nameLocation":"292:15:4","nodeType":"FunctionDefinition","overrides":{"id":4825,"nodeType":"OverrideSpecifier","overrides":[],"src":"333:8:4"},"parameters":{"id":4824,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4821,"mutability":"mutable","name":"x","nameLocation":"313:1:4","nodeType":"VariableDeclaration","scope":4858,"src":"308:6:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4820,"name":"uint","nodeType":"ElementaryTypeName","src":"308:4:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":4823,"mutability":"mutable","name":"y","nameLocation":"321:1:4","nodeType":"VariableDeclaration","scope":4858,"src":"316:6:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4822,"name":"uint","nodeType":"ElementaryTypeName","src":"316:4:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"307:16:4"},"returnParameters":{"id":4830,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4827,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4858,"src":"356:7:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4826,"name":"uint256","nodeType":"ElementaryTypeName","src":"356:7:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":4829,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4858,"src":"365:13:4","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string"},"typeName":{"id":4828,"name":"string","nodeType":"ElementaryTypeName","src":"365:6:4","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"visibility":"internal"}],"src":"355:24:4"},"scope":4877,"src":"283:274:4","stateMutability":"view","virtual":false,"visibility":"internal"},{"baseFunctions":[68],"body":{"id":4866,"nodeType":"Block","src":"628:33:4","statements":[{"expression":{"id":4864,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1006,"src":"645:9:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":4863,"id":4865,"nodeType":"Return","src":"638:16:4"}]},"id":4867,"implemented":true,"kind":"function","modifiers":[],"name":"getGridWidth","nameLocation":"572:12:4","nodeType":"FunctionDefinition","overrides":{"id":4860,"nodeType":"OverrideSpecifier","overrides":[],"src":"596:8:4"},"parameters":{"id":4859,"nodeType":"ParameterList","parameters":[],"src":"584:2:4"},"returnParameters":{"id":4863,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4862,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4867,"src":"619:7:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4861,"name":"uint256","nodeType":"ElementaryTypeName","src":"619:7:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"618:9:4"},"scope":4877,"src":"563:98:4","stateMutability":"pure","virtual":false,"visibility":"internal"},{"baseFunctions":[73],"body":{"id":4875,"nodeType":"Block","src":"733:34:4","statements":[{"expression":{"id":4873,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1009,"src":"750:10:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":4872,"id":4874,"nodeType":"Return","src":"743:17:4"}]},"id":4876,"implemented":true,"kind":"function","modifiers":[],"name":"getGridHeight","nameLocation":"676:13:4","nodeType":"FunctionDefinition","overrides":{"id":4869,"nodeType":"OverrideSpecifier","overrides":[],"src":"701:8:4"},"parameters":{"id":4868,"nodeType":"ParameterList","parameters":[],"src":"689:2:4"},"returnParameters":{"id":4872,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4871,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4876,"src":"724:7:4","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4870,"name":"uint256","nodeType":"ElementaryTypeName","src":"724:7:4","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"723:9:4"},"scope":4877,"src":"667:100:4","stateMutability":"pure","virtual":false,"visibility":"internal"}],"scope":4878,"src":"125:644:4","usedErrors":[]}],"src":"32:738:4"},"compiler":{"name":"solc","version":"0.8.13+commit.abaa5c0e.Emscripten.clang"},"networks":{"137":{"events":{"0xe658510eab96e65991bb68ee771137bf387eaa3dc4a16189ea0f525766e76b2a":{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"}},"links":{},"address":"0xf8561640FA9E7EE295D9B6C4DD59FD9826374d6b","transactionHash":"0xfed588f347cb98265b4bfe5626812386b605e135e44e0de52fed7404f7896929"},"5777":{"events":{"0x74835083a92d7d0acad57e178b18330365b1b26c97ea060802582e61f95b54d2":{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"width","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"height","type":"uint256"}],"name":"LogGridDimensions","type":"event"}},"links":{},"address":"0xE5931358B91A1a1Fc75c3fa304cc634FACB02424","transactionHash":"0xe6d27aac75bb49f05ab01d0b4e41bcff804c0a101416bc4735650fba73747493"}},"schemaVersion":"3.4.13","updatedAt":"2023-09-30T04:41:41.123Z","networkType":"ethereum","devdoc":{"kind":"dev","methods":{},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}}');


var $7b13ea3ecd89623e$exports = {};
$7b13ea3ecd89623e$exports = JSON.parse('{"contractName":"Pixelflux2","abi":[{"inputs":[{"internalType":"address","name":"_baseContractAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[],"name":"ContractEnabled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"},{"inputs":[],"name":"baseContract","outputs":[{"internalType":"contract BaseContract","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyLayer","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"numLayersToAdd","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyMultipleLayers","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[],"name":"calculateTotalValue","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"colorValues","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllCellStates","outputs":[{"components":[{"internalType":"uint256","name":"baseValue","type":"uint256"},{"components":[{"internalType":"address payable","name":"owner","type":"address"},{"internalType":"string","name":"color","type":"string"}],"internalType":"struct BaseContract.Layer[]","name":"layers","type":"tuple[]"}],"internalType":"struct BaseContract.Cell[][]","name":"","type":"tuple[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllTopLayers","outputs":[{"internalType":"address payable[][]","name":"","type":"address[][]"},{"internalType":"string[][]","name":"","type":"string[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getCellState","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"string","name":"","type":"string"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getTopLayerOfCell","outputs":[{"internalType":"address payable","name":"","type":"address"},{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"grid","outputs":[{"internalType":"uint256","name":"baseValue","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridHeight","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridWidth","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"initialValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"isEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"layerIndex","type":"uint256"},{"internalType":"string","name":"newColor","type":"string"}],"name":"setLayerColor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawFunds","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isContractEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"enableContract","outputs":[],"stateMutability":"nonpayable","type":"function"}],"metadata":"{\\"compiler\\":{\\"version\\":\\"0.8.13+commit.abaa5c0e\\"},\\"language\\":\\"Solidity\\",\\"output\\":{\\"abi\\":[{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"_baseContractAddress\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"constructor\\"},{\\"anonymous\\":false,\\"inputs\\":[],\\"name\\":\\"ContractEnabled\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"buyer\\",\\"type\\":\\"address\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayers\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"LayerPurchased\\",\\"type\\":\\"event\\"},{\\"inputs\\":[],\\"name\\":\\"baseContract\\",\\"outputs\\":[{\\"internalType\\":\\"contract BaseContract\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyLayer\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayersToAdd\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyMultipleLayers\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"calculateTotalValue\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"colorValues\\",\\"outputs\\":[{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"enableContract\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllCellStates\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"},{\\"components\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"owner\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"internalType\\":\\"struct BaseContract.Layer[]\\",\\"name\\":\\"layers\\",\\"type\\":\\"tuple[]\\"}],\\"internalType\\":\\"struct BaseContract.Cell[][]\\",\\"name\\":\\"\\",\\"type\\":\\"tuple[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllTopLayers\\",\\"outputs\\":[{\\"internalType\\":\\"address payable[][]\\",\\"name\\":\\"\\",\\"type\\":\\"address[][]\\"},{\\"internalType\\":\\"string[][]\\",\\"name\\":\\"\\",\\"type\\":\\"string[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getCellState\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getTopLayerOfCell\\",\\"outputs\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"grid\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridHeight\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridWidth\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"initialValues\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"isContractEnabled\\",\\"outputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"isEnabled\\",\\"outputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"owner\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"layerIndex\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"newColor\\",\\"type\\":\\"string\\"}],\\"name\\":\\"setLayerColor\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"withdrawFunds\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"}],\\"devdoc\\":{\\"kind\\":\\"dev\\",\\"methods\\":{},\\"version\\":1},\\"userdoc\\":{\\"kind\\":\\"user\\",\\"methods\\":{},\\"version\\":1}},\\"settings\\":{\\"compilationTarget\\":{\\"project:/contracts/Pixelflux2.sol\\":\\"Pixelflux2\\"},\\"evmVersion\\":\\"london\\",\\"libraries\\":{},\\"metadata\\":{\\"bytecodeHash\\":\\"ipfs\\"},\\"optimizer\\":{\\"enabled\\":false,\\"runs\\":200},\\"remappings\\":[]},\\"sources\\":{\\"project:/contracts/BaseContract.sol\\":{\\"keccak256\\":\\"0x7d0f9ba810e1d7cf1721920a8797ef253ce9a9cf71129aaa1c263e3de4dde3e8\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://5fdfd3c2b7e7f8684d628a5e35b6c13f2eeced22dbf20b16aff49e676a775228\\",\\"dweb:/ipfs/QmRExf7WwUASUu7ZxuPu3bXSri2tnSzooLR3s6fdmZ4wzz\\"]},\\"project:/contracts/DataStorage2.sol\\":{\\"keccak256\\":\\"0xf03179f8f74231ea7d934657fd83d31b04cae03b07d58e9406a623ab603687d7\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://4a8e9d735f671ce1a6f408812dbb7c8f67b788de6eb6802084d67bf5bef5074b\\",\\"dweb:/ipfs/QmTNTRXS1q5De9mMEkyzosUxjgvKnREm6H4zrpeSb7zui6\\"]},\\"project:/contracts/Pixelflux2.sol\\":{\\"keccak256\\":\\"0xfad714bc122f0439785fcf3204d723efcf4964701896fc30d6c02b5f6ec0d5ed\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://2b68b4ef42fcb6cf46daf1e7f4072b7a9d14194c78506b5e77c7357c3bf09e9e\\",\\"dweb:/ipfs/Qmbpwdr7rASrPpPiNCYeEXcYe5ZH5ryNrevTWCZ4maBtzn\\"]}},\\"version\\":1}","bytecode":"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","deployedBytecode":"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","immutableReferences":{},"generatedSources":[{"ast":{"nodeType":"YulBlock","src":"0:1897:7","statements":[{"body":{"nodeType":"YulBlock","src":"47:35:7","statements":[{"nodeType":"YulAssignment","src":"57:19:7","value":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"73:2:7","type":"","value":"64"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"67:5:7"},"nodeType":"YulFunctionCall","src":"67:9:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"57:6:7"}]}]},"name":"allocate_unbounded","nodeType":"YulFunctionDefinition","returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"40:6:7","type":""}],"src":"7:75:7"},{"body":{"nodeType":"YulBlock","src":"177:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"194:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"197:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"187:6:7"},"nodeType":"YulFunctionCall","src":"187:12:7"},"nodeType":"YulExpressionStatement","src":"187:12:7"}]},"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulFunctionDefinition","src":"88:117:7"},{"body":{"nodeType":"YulBlock","src":"300:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"317:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"320:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"310:6:7"},"nodeType":"YulFunctionCall","src":"310:12:7"},"nodeType":"YulExpressionStatement","src":"310:12:7"}]},"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulFunctionDefinition","src":"211:117:7"},{"body":{"nodeType":"YulBlock","src":"379:81:7","statements":[{"nodeType":"YulAssignment","src":"389:65:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"404:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"411:42:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"400:3:7"},"nodeType":"YulFunctionCall","src":"400:54:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"389:7:7"}]}]},"name":"cleanup_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"361:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"371:7:7","type":""}],"src":"334:126:7"},{"body":{"nodeType":"YulBlock","src":"511:51:7","statements":[{"nodeType":"YulAssignment","src":"521:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"550:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"532:17:7"},"nodeType":"YulFunctionCall","src":"532:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"521:7:7"}]}]},"name":"cleanup_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"493:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"503:7:7","type":""}],"src":"466:96:7"},{"body":{"nodeType":"YulBlock","src":"611:79:7","statements":[{"body":{"nodeType":"YulBlock","src":"668:16:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"677:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"680:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"670:6:7"},"nodeType":"YulFunctionCall","src":"670:12:7"},"nodeType":"YulExpressionStatement","src":"670:12:7"}]},"condition":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"634:5:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"659:5:7"}],"functionName":{"name":"cleanup_t_address","nodeType":"YulIdentifier","src":"641:17:7"},"nodeType":"YulFunctionCall","src":"641:24:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"631:2:7"},"nodeType":"YulFunctionCall","src":"631:35:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"624:6:7"},"nodeType":"YulFunctionCall","src":"624:43:7"},"nodeType":"YulIf","src":"621:63:7"}]},"name":"validator_revert_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"604:5:7","type":""}],"src":"568:122:7"},{"body":{"nodeType":"YulBlock","src":"759:80:7","statements":[{"nodeType":"YulAssignment","src":"769:22:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"784:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"778:5:7"},"nodeType":"YulFunctionCall","src":"778:13:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"769:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"827:5:7"}],"functionName":{"name":"validator_revert_t_address","nodeType":"YulIdentifier","src":"800:26:7"},"nodeType":"YulFunctionCall","src":"800:33:7"},"nodeType":"YulExpressionStatement","src":"800:33:7"}]},"name":"abi_decode_t_address_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"737:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"745:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"753:5:7","type":""}],"src":"696:143:7"},{"body":{"nodeType":"YulBlock","src":"922:274:7","statements":[{"body":{"nodeType":"YulBlock","src":"968:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"970:77:7"},"nodeType":"YulFunctionCall","src":"970:79:7"},"nodeType":"YulExpressionStatement","src":"970:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"943:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"952:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"939:3:7"},"nodeType":"YulFunctionCall","src":"939:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"964:2:7","type":"","value":"32"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"935:3:7"},"nodeType":"YulFunctionCall","src":"935:32:7"},"nodeType":"YulIf","src":"932:119:7"},{"nodeType":"YulBlock","src":"1061:128:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1076:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"1090:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"1080:6:7","type":""}]},{"nodeType":"YulAssignment","src":"1105:74:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"1151:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"1162:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1147:3:7"},"nodeType":"YulFunctionCall","src":"1147:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"1171:7:7"}],"functionName":{"name":"abi_decode_t_address_fromMemory","nodeType":"YulIdentifier","src":"1115:31:7"},"nodeType":"YulFunctionCall","src":"1115:64:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"1105:6:7"}]}]}]},"name":"abi_decode_tuple_t_address_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"892:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"903:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"915:6:7","type":""}],"src":"845:351:7"},{"body":{"nodeType":"YulBlock","src":"1230:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1247:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1250:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1240:6:7"},"nodeType":"YulFunctionCall","src":"1240:88:7"},"nodeType":"YulExpressionStatement","src":"1240:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1344:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"1347:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1337:6:7"},"nodeType":"YulFunctionCall","src":"1337:15:7"},"nodeType":"YulExpressionStatement","src":"1337:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1368:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1371:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"1361:6:7"},"nodeType":"YulFunctionCall","src":"1361:15:7"},"nodeType":"YulExpressionStatement","src":"1361:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"1202:180:7"},{"body":{"nodeType":"YulBlock","src":"1416:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1433:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1436:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1426:6:7"},"nodeType":"YulFunctionCall","src":"1426:88:7"},"nodeType":"YulExpressionStatement","src":"1426:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1530:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"1533:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1523:6:7"},"nodeType":"YulFunctionCall","src":"1523:15:7"},"nodeType":"YulExpressionStatement","src":"1523:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1554:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1557:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"1547:6:7"},"nodeType":"YulFunctionCall","src":"1547:15:7"},"nodeType":"YulExpressionStatement","src":"1547:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"1388:180:7"},{"body":{"nodeType":"YulBlock","src":"1625:269:7","statements":[{"nodeType":"YulAssignment","src":"1635:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"1649:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"1655:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"1645:3:7"},"nodeType":"YulFunctionCall","src":"1645:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"1635:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"1666:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"1696:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"1702:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1692:3:7"},"nodeType":"YulFunctionCall","src":"1692:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"1670:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"1743:51:7","statements":[{"nodeType":"YulAssignment","src":"1757:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"1771:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"1779:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1767:3:7"},"nodeType":"YulFunctionCall","src":"1767:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"1757:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"1723:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"1716:6:7"},"nodeType":"YulFunctionCall","src":"1716:26:7"},"nodeType":"YulIf","src":"1713:81:7"},{"body":{"nodeType":"YulBlock","src":"1846:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"1860:16:7"},"nodeType":"YulFunctionCall","src":"1860:18:7"},"nodeType":"YulExpressionStatement","src":"1860:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"1810:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"1833:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"1841:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"1830:2:7"},"nodeType":"YulFunctionCall","src":"1830:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"1807:2:7"},"nodeType":"YulFunctionCall","src":"1807:38:7"},"nodeType":"YulIf","src":"1804:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"1609:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"1618:6:7","type":""}],"src":"1574:320:7"}]},"contents":"{\\n\\n    function allocate_unbounded() -> memPtr {\\n        memPtr := mload(64)\\n    }\\n\\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\\n        revert(0, 0)\\n    }\\n\\n    function cleanup_t_uint160(value) -> cleaned {\\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\\n    }\\n\\n    function cleanup_t_address(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function validator_revert_t_address(value) {\\n        if iszero(eq(value, cleanup_t_address(value))) { revert(0, 0) }\\n    }\\n\\n    function abi_decode_t_address_fromMemory(offset, end) -> value {\\n        value := mload(offset)\\n        validator_revert_t_address(value)\\n    }\\n\\n    function abi_decode_tuple_t_address_fromMemory(headStart, dataEnd) -> value0 {\\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_address_fromMemory(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"deployedGeneratedSources":[{"ast":{"nodeType":"YulBlock","src":"0:42353:7","statements":[{"body":{"nodeType":"YulBlock","src":"114:40:7","statements":[{"nodeType":"YulAssignment","src":"125:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"141:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"135:5:7"},"nodeType":"YulFunctionCall","src":"135:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"125:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"97:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"107:6:7","type":""}],"src":"7:147:7"},{"body":{"nodeType":"YulBlock","src":"304:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"321:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"326:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"314:6:7"},"nodeType":"YulFunctionCall","src":"314:19:7"},"nodeType":"YulExpressionStatement","src":"314:19:7"},{"nodeType":"YulAssignment","src":"342:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"361:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"366:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"357:3:7"},"nodeType":"YulFunctionCall","src":"357:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"342:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"276:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"281:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"292:11:7","type":""}],"src":"160:217:7"},{"body":{"nodeType":"YulBlock","src":"488:60:7","statements":[{"nodeType":"YulAssignment","src":"498:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"506:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"498:4:7"}]},{"nodeType":"YulAssignment","src":"519:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"531:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"536:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"527:3:7"},"nodeType":"YulFunctionCall","src":"527:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"519:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"475:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"483:4:7","type":""}],"src":"383:165:7"},{"body":{"nodeType":"YulBlock","src":"636:40:7","statements":[{"nodeType":"YulAssignment","src":"647:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"663:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"657:5:7"},"nodeType":"YulFunctionCall","src":"657:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"647:6:7"}]}]},"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"619:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"629:6:7","type":""}],"src":"554:122:7"},{"body":{"nodeType":"YulBlock","src":"791:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"808:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"813:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"801:6:7"},"nodeType":"YulFunctionCall","src":"801:19:7"},"nodeType":"YulExpressionStatement","src":"801:19:7"},{"nodeType":"YulAssignment","src":"829:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"848:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"853:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"844:3:7"},"nodeType":"YulFunctionCall","src":"844:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"829:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"763:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"768:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"779:11:7","type":""}],"src":"682:182:7"},{"body":{"nodeType":"YulBlock","src":"950:60:7","statements":[{"nodeType":"YulAssignment","src":"960:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"968:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"960:4:7"}]},{"nodeType":"YulAssignment","src":"981:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"993:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"989:3:7"},"nodeType":"YulFunctionCall","src":"989:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"981:4:7"}]}]},"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"937:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"945:4:7","type":""}],"src":"870:140:7"},{"body":{"nodeType":"YulBlock","src":"1061:81:7","statements":[{"nodeType":"YulAssignment","src":"1071:65:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1086:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"1093:42:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1082:3:7"},"nodeType":"YulFunctionCall","src":"1082:54:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1071:7:7"}]}]},"name":"cleanup_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1043:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1053:7:7","type":""}],"src":"1016:126:7"},{"body":{"nodeType":"YulBlock","src":"1201:51:7","statements":[{"nodeType":"YulAssignment","src":"1211:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1240:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"1222:17:7"},"nodeType":"YulFunctionCall","src":"1222:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1211:7:7"}]}]},"name":"cleanup_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1183:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1193:7:7","type":""}],"src":"1148:104:7"},{"body":{"nodeType":"YulBlock","src":"1329:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1346:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1377:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"1351:25:7"},"nodeType":"YulFunctionCall","src":"1351:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1339:6:7"},"nodeType":"YulFunctionCall","src":"1339:45:7"},"nodeType":"YulExpressionStatement","src":"1339:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1317:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1324:3:7","type":""}],"src":"1258:132:7"},{"body":{"nodeType":"YulBlock","src":"1492:115:7","statements":[{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"1552:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"1560:3:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"1502:49:7"},"nodeType":"YulFunctionCall","src":"1502:62:7"},"nodeType":"YulExpressionStatement","src":"1502:62:7"},{"nodeType":"YulAssignment","src":"1573:28:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1591:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1596:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1587:3:7"},"nodeType":"YulFunctionCall","src":"1587:14:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"1573:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"1465:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1473:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"1481:10:7","type":""}],"src":"1396:211:7"},{"body":{"nodeType":"YulBlock","src":"1696:38:7","statements":[{"nodeType":"YulAssignment","src":"1706:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"1718:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1723:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1714:3:7"},"nodeType":"YulFunctionCall","src":"1714:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"1706:4:7"}]}]},"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"1683:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"1691:4:7","type":""}],"src":"1613:121:7"},{"body":{"nodeType":"YulBlock","src":"1916:646:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1926:76:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1996:5:7"}],"functionName":{"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"1940:55:7"},"nodeType":"YulFunctionCall","src":"1940:62:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"1930:6:7","type":""}]},{"nodeType":"YulAssignment","src":"2011:91:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"2090:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"2095:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2018:71:7"},"nodeType":"YulFunctionCall","src":"2018:84:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2011:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"2111:79:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"2184:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2126:57:7"},"nodeType":"YulFunctionCall","src":"2126:64:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"2115:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"2199:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"2213:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"2203:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"2289:248:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2303:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2330:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"2324:5:7"},"nodeType":"YulFunctionCall","src":"2324:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"2307:13:7","type":""}]},{"nodeType":"YulAssignment","src":"2350:86:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"2417:13:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2432:3:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"2357:59:7"},"nodeType":"YulFunctionCall","src":"2357:79:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2350:3:7"}]},{"nodeType":"YulAssignment","src":"2449:78:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2520:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2459:60:7"},"nodeType":"YulFunctionCall","src":"2459:68:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2449:6:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2251:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"2254:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"2248:2:7"},"nodeType":"YulFunctionCall","src":"2248:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"2262:18:7","statements":[{"nodeType":"YulAssignment","src":"2264:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2273:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"2276:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2269:3:7"},"nodeType":"YulFunctionCall","src":"2269:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"2264:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"2233:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2235:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"2244:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"2239:1:7","type":""}]}]},"src":"2229:308:7"},{"nodeType":"YulAssignment","src":"2546:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"2553:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"2546:3:7"}]}]},"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1895:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1902:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"1911:3:7","type":""}],"src":"1786:776:7"},{"body":{"nodeType":"YulBlock","src":"2714:142:7","statements":[{"nodeType":"YulAssignment","src":"2724:126:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"2838:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2846:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2738:99:7"},"nodeType":"YulFunctionCall","src":"2738:112:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"2724:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"2687:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"2695:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"2703:10:7","type":""}],"src":"2568:288:7"},{"body":{"nodeType":"YulBlock","src":"2970:38:7","statements":[{"nodeType":"YulAssignment","src":"2980:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"2992:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"2997:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2988:3:7"},"nodeType":"YulFunctionCall","src":"2988:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"2980:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"2957:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"2965:4:7","type":""}],"src":"2862:146:7"},{"body":{"nodeType":"YulBlock","src":"3254:985:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3264:101:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3359:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3278:80:7"},"nodeType":"YulFunctionCall","src":"3278:87:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"3268:6:7","type":""}]},{"nodeType":"YulAssignment","src":"3374:126:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3488:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"3493:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"3381:106:7"},"nodeType":"YulFunctionCall","src":"3381:119:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"3374:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"3509:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"3526:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"3513:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3538:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3554:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"3563:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"3571:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"3559:3:7"},"nodeType":"YulFunctionCall","src":"3559:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3550:3:7"},"nodeType":"YulFunctionCall","src":"3550:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"3542:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3586:104:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3684:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3601:82:7"},"nodeType":"YulFunctionCall","src":"3601:89:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"3590:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3699:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"3713:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"3703:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"3789:405:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3810:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"3819:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"3825:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"3815:3:7"},"nodeType":"YulFunctionCall","src":"3815:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"3803:6:7"},"nodeType":"YulFunctionCall","src":"3803:33:7"},"nodeType":"YulExpressionStatement","src":"3803:33:7"},{"nodeType":"YulVariableDeclaration","src":"3849:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"3876:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"3870:5:7"},"nodeType":"YulFunctionCall","src":"3870:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"3853:13:7","type":""}]},{"nodeType":"YulAssignment","src":"3896:138:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"4014:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"4029:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3904:109:7"},"nodeType":"YulFunctionCall","src":"3904:130:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"3896:4:7"}]},{"nodeType":"YulAssignment","src":"4047:103:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4143:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"4057:85:7"},"nodeType":"YulFunctionCall","src":"4057:93:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4047:6:7"}]},{"nodeType":"YulAssignment","src":"4163:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4174:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4179:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4170:3:7"},"nodeType":"YulFunctionCall","src":"4170:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4163:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3751:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"3754:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"3748:2:7"},"nodeType":"YulFunctionCall","src":"3748:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"3762:18:7","statements":[{"nodeType":"YulAssignment","src":"3764:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3773:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"3776:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3769:3:7"},"nodeType":"YulFunctionCall","src":"3769:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"3764:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"3733:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3735:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"3744:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"3739:1:7","type":""}]}]},"src":"3729:465:7"},{"nodeType":"YulAssignment","src":"4203:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"4210:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4203:3:7"}]},{"nodeType":"YulAssignment","src":"4223:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"4230:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"4223:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"3233:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"3240:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"3249:3:7","type":""}],"src":"3064:1175:7"},{"body":{"nodeType":"YulBlock","src":"4354:40:7","statements":[{"nodeType":"YulAssignment","src":"4365:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4381:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4375:5:7"},"nodeType":"YulFunctionCall","src":"4375:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4365:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4337:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4347:6:7","type":""}],"src":"4245:149:7"},{"body":{"nodeType":"YulBlock","src":"4546:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"4568:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"4556:6:7"},"nodeType":"YulFunctionCall","src":"4556:19:7"},"nodeType":"YulExpressionStatement","src":"4556:19:7"},{"nodeType":"YulAssignment","src":"4584:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4603:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4608:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4599:3:7"},"nodeType":"YulFunctionCall","src":"4599:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"4584:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"4518:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"4523:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"4534:11:7","type":""}],"src":"4400:219:7"},{"body":{"nodeType":"YulBlock","src":"4732:60:7","statements":[{"nodeType":"YulAssignment","src":"4742:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"4750:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4742:4:7"}]},{"nodeType":"YulAssignment","src":"4763:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"4775:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4780:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4771:3:7"},"nodeType":"YulFunctionCall","src":"4771:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4763:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"4719:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"4727:4:7","type":""}],"src":"4625:167:7"},{"body":{"nodeType":"YulBlock","src":"4882:40:7","statements":[{"nodeType":"YulAssignment","src":"4893:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4909:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4903:5:7"},"nodeType":"YulFunctionCall","src":"4903:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4893:6:7"}]}]},"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4865:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4875:6:7","type":""}],"src":"4798:124:7"},{"body":{"nodeType":"YulBlock","src":"5039:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5056:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5061:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5049:6:7"},"nodeType":"YulFunctionCall","src":"5049:19:7"},"nodeType":"YulExpressionStatement","src":"5049:19:7"},{"nodeType":"YulAssignment","src":"5077:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5096:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5101:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5092:3:7"},"nodeType":"YulFunctionCall","src":"5092:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5077:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5011:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5016:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5027:11:7","type":""}],"src":"4928:184:7"},{"body":{"nodeType":"YulBlock","src":"5200:60:7","statements":[{"nodeType":"YulAssignment","src":"5210:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"5218:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5210:4:7"}]},{"nodeType":"YulAssignment","src":"5231:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"5243:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5248:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5239:3:7"},"nodeType":"YulFunctionCall","src":"5239:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5231:4:7"}]}]},"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"5187:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"5195:4:7","type":""}],"src":"5118:142:7"},{"body":{"nodeType":"YulBlock","src":"5325:40:7","statements":[{"nodeType":"YulAssignment","src":"5336:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5352:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5346:5:7"},"nodeType":"YulFunctionCall","src":"5346:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"5336:6:7"}]}]},"name":"array_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5308:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"5318:6:7","type":""}],"src":"5266:99:7"},{"body":{"nodeType":"YulBlock","src":"5457:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5474:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5479:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5467:6:7"},"nodeType":"YulFunctionCall","src":"5467:19:7"},"nodeType":"YulExpressionStatement","src":"5467:19:7"},{"nodeType":"YulAssignment","src":"5495:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5514:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5519:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5510:3:7"},"nodeType":"YulFunctionCall","src":"5510:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5495:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5429:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5434:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5445:11:7","type":""}],"src":"5371:159:7"},{"body":{"nodeType":"YulBlock","src":"5585:258:7","statements":[{"nodeType":"YulVariableDeclaration","src":"5595:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"5604:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"5599:1:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"5664:63:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5689:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5694:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5685:3:7"},"nodeType":"YulFunctionCall","src":"5685:11:7"},{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"5708:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5713:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5704:3:7"},"nodeType":"YulFunctionCall","src":"5704:11:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5698:5:7"},"nodeType":"YulFunctionCall","src":"5698:18:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5678:6:7"},"nodeType":"YulFunctionCall","src":"5678:39:7"},"nodeType":"YulExpressionStatement","src":"5678:39:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5625:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5628:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"5622:2:7"},"nodeType":"YulFunctionCall","src":"5622:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"5636:19:7","statements":[{"nodeType":"YulAssignment","src":"5638:15:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5647:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"5650:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5643:3:7"},"nodeType":"YulFunctionCall","src":"5643:10:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"5638:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"5618:3:7","statements":[]},"src":"5614:113:7"},{"body":{"nodeType":"YulBlock","src":"5761:76:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5811:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5816:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5807:3:7"},"nodeType":"YulFunctionCall","src":"5807:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"5825:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5800:6:7"},"nodeType":"YulFunctionCall","src":"5800:27:7"},"nodeType":"YulExpressionStatement","src":"5800:27:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5742:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5745:6:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"5739:2:7"},"nodeType":"YulFunctionCall","src":"5739:13:7"},"nodeType":"YulIf","src":"5736:101:7"}]},"name":"copy_memory_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"5567:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"5572:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5577:6:7","type":""}],"src":"5536:307:7"},{"body":{"nodeType":"YulBlock","src":"5897:54:7","statements":[{"nodeType":"YulAssignment","src":"5907:38:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5925:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"5932:2:7","type":"","value":"31"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5921:3:7"},"nodeType":"YulFunctionCall","src":"5921:14:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"5941:2:7","type":"","value":"31"}],"functionName":{"name":"not","nodeType":"YulIdentifier","src":"5937:3:7"},"nodeType":"YulFunctionCall","src":"5937:7:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"5917:3:7"},"nodeType":"YulFunctionCall","src":"5917:28:7"},"variableNames":[{"name":"result","nodeType":"YulIdentifier","src":"5907:6:7"}]}]},"name":"round_up_to_mul_of_32","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5880:5:7","type":""}],"returnVariables":[{"name":"result","nodeType":"YulTypedName","src":"5890:6:7","type":""}],"src":"5849:102:7"},{"body":{"nodeType":"YulBlock","src":"6039:262:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6049:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6096:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6063:32:7"},"nodeType":"YulFunctionCall","src":"6063:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6053:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6111:68:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6167:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6172:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6118:48:7"},"nodeType":"YulFunctionCall","src":"6118:61:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6111:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6214:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"6221:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6210:3:7"},"nodeType":"YulFunctionCall","src":"6210:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6228:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6233:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"6188:21:7"},"nodeType":"YulFunctionCall","src":"6188:52:7"},"nodeType":"YulExpressionStatement","src":"6188:52:7"},{"nodeType":"YulAssignment","src":"6249:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6260:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"6287:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"6265:21:7"},"nodeType":"YulFunctionCall","src":"6265:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6256:3:7"},"nodeType":"YulFunctionCall","src":"6256:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"6249:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6020:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6027:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6035:3:7","type":""}],"src":"5957:344:7"},{"body":{"nodeType":"YulBlock","src":"6407:96:7","statements":[{"nodeType":"YulAssignment","src":"6417:80:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"6485:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6493:3:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6431:53:7"},"nodeType":"YulFunctionCall","src":"6431:66:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"6417:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"6380:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6388:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"6396:10:7","type":""}],"src":"6307:196:7"},{"body":{"nodeType":"YulBlock","src":"6594:38:7","statements":[{"nodeType":"YulAssignment","src":"6604:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"6616:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"6621:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6612:3:7"},"nodeType":"YulFunctionCall","src":"6612:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"6604:4:7"}]}]},"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"6581:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"6589:4:7","type":""}],"src":"6509:123:7"},{"body":{"nodeType":"YulBlock","src":"6800:837:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6810:78:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6882:5:7"}],"functionName":{"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6824:57:7"},"nodeType":"YulFunctionCall","src":"6824:64:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6814:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6897:93:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6978:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6983:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6904:73:7"},"nodeType":"YulFunctionCall","src":"6904:86:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6897:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"6999:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7016:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"7003:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7028:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7044:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"7053:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"7061:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"7049:3:7"},"nodeType":"YulFunctionCall","src":"7049:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7040:3:7"},"nodeType":"YulFunctionCall","src":"7040:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"7032:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7076:81:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"7151:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7091:59:7"},"nodeType":"YulFunctionCall","src":"7091:66:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"7080:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7166:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"7180:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"7170:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"7256:336:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7277:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"7286:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"7292:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"7282:3:7"},"nodeType":"YulFunctionCall","src":"7282:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"7270:6:7"},"nodeType":"YulFunctionCall","src":"7270:33:7"},"nodeType":"YulExpressionStatement","src":"7270:33:7"},{"nodeType":"YulVariableDeclaration","src":"7316:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7343:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"7337:5:7"},"nodeType":"YulFunctionCall","src":"7337:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"7320:13:7","type":""}]},{"nodeType":"YulAssignment","src":"7363:92:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"7435:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"7450:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"7371:63:7"},"nodeType":"YulFunctionCall","src":"7371:84:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"7363:4:7"}]},{"nodeType":"YulAssignment","src":"7468:80:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7541:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7478:62:7"},"nodeType":"YulFunctionCall","src":"7478:70:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7468:6:7"}]},{"nodeType":"YulAssignment","src":"7561:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7572:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"7577:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7568:3:7"},"nodeType":"YulFunctionCall","src":"7568:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7561:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7218:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"7221:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"7215:2:7"},"nodeType":"YulFunctionCall","src":"7215:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"7229:18:7","statements":[{"nodeType":"YulAssignment","src":"7231:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7240:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"7243:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7236:3:7"},"nodeType":"YulFunctionCall","src":"7236:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"7231:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"7200:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"7202:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"7211:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"7206:1:7","type":""}]}]},"src":"7196:396:7"},{"nodeType":"YulAssignment","src":"7601:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"7608:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7601:3:7"}]},{"nodeType":"YulAssignment","src":"7621:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7628:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"7621:3:7"}]}]},"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6779:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6786:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6795:3:7","type":""}],"src":"6666:971:7"},{"body":{"nodeType":"YulBlock","src":"7793:146:7","statements":[{"nodeType":"YulAssignment","src":"7803:130:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"7921:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"7929:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7817:103:7"},"nodeType":"YulFunctionCall","src":"7817:116:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"7803:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"7766:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"7774:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"7782:10:7","type":""}],"src":"7643:296:7"},{"body":{"nodeType":"YulBlock","src":"8055:38:7","statements":[{"nodeType":"YulAssignment","src":"8065:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"8077:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"8082:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8073:3:7"},"nodeType":"YulFunctionCall","src":"8073:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"8065:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"8042:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"8050:4:7","type":""}],"src":"7945:148:7"},{"body":{"nodeType":"YulBlock","src":"8325:997:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8335:103:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8432:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8349:82:7"},"nodeType":"YulFunctionCall","src":"8349:89:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"8339:6:7","type":""}]},{"nodeType":"YulAssignment","src":"8447:128:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"8568:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"8454:108:7"},"nodeType":"YulFunctionCall","src":"8454:121:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"8447:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"8584:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"8601:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"8588:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8613:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8629:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"8638:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"8646:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"8634:3:7"},"nodeType":"YulFunctionCall","src":"8634:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8625:3:7"},"nodeType":"YulFunctionCall","src":"8625:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"8617:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8661:106:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8761:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8676:84:7"},"nodeType":"YulFunctionCall","src":"8676:91:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"8665:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8776:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"8790:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"8780:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"8866:411:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8887:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"8896:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"8902:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"8892:3:7"},"nodeType":"YulFunctionCall","src":"8892:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"8880:6:7"},"nodeType":"YulFunctionCall","src":"8880:33:7"},"nodeType":"YulExpressionStatement","src":"8880:33:7"},{"nodeType":"YulVariableDeclaration","src":"8926:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"8953:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"8947:5:7"},"nodeType":"YulFunctionCall","src":"8947:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"8930:13:7","type":""}]},{"nodeType":"YulAssignment","src":"8973:142:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"9095:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9110:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8981:113:7"},"nodeType":"YulFunctionCall","src":"8981:134:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"8973:4:7"}]},{"nodeType":"YulAssignment","src":"9128:105:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9226:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"9138:87:7"},"nodeType":"YulFunctionCall","src":"9138:95:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9128:6:7"}]},{"nodeType":"YulAssignment","src":"9246:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"9257:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"9262:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9253:3:7"},"nodeType":"YulFunctionCall","src":"9253:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9246:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8828:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"8831:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"8825:2:7"},"nodeType":"YulFunctionCall","src":"8825:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"8839:18:7","statements":[{"nodeType":"YulAssignment","src":"8841:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8850:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"8853:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8846:3:7"},"nodeType":"YulFunctionCall","src":"8846:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"8841:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"8810:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8812:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"8821:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"8816:1:7","type":""}]}]},"src":"8806:471:7"},{"nodeType":"YulAssignment","src":"9286:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"9293:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9286:3:7"}]},{"nodeType":"YulAssignment","src":"9306:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"9313:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"9306:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"8304:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"8311:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"8320:3:7","type":""}],"src":"8131:1191:7"},{"body":{"nodeType":"YulBlock","src":"9690:544:7","statements":[{"nodeType":"YulAssignment","src":"9700:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9712:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9723:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9708:3:7"},"nodeType":"YulFunctionCall","src":"9708:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9700:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9747:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9758:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9743:3:7"},"nodeType":"YulFunctionCall","src":"9743:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"9766:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"9772:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"9762:3:7"},"nodeType":"YulFunctionCall","src":"9762:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9736:6:7"},"nodeType":"YulFunctionCall","src":"9736:47:7"},"nodeType":"YulExpressionStatement","src":"9736:47:7"},{"nodeType":"YulAssignment","src":"9792:182:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"9960:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9969:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"9800:159:7"},"nodeType":"YulFunctionCall","src":"9800:174:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9792:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9995:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"10006:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9991:3:7"},"nodeType":"YulFunctionCall","src":"9991:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"10015:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"10021:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"10011:3:7"},"nodeType":"YulFunctionCall","src":"10011:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9984:6:7"},"nodeType":"YulFunctionCall","src":"9984:48:7"},"nodeType":"YulExpressionStatement","src":"9984:48:7"},{"nodeType":"YulAssignment","src":"10041:186:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"10213:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"10222:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"10049:163:7"},"nodeType":"YulFunctionCall","src":"10049:178:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"10041:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"9654:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"9666:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"9674:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"9685:4:7","type":""}],"src":"9328:906:7"},{"body":{"nodeType":"YulBlock","src":"10280:35:7","statements":[{"nodeType":"YulAssignment","src":"10290:19:7","value":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10306:2:7","type":"","value":"64"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"10300:5:7"},"nodeType":"YulFunctionCall","src":"10300:9:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"10290:6:7"}]}]},"name":"allocate_unbounded","nodeType":"YulFunctionDefinition","returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"10273:6:7","type":""}],"src":"10240:75:7"},{"body":{"nodeType":"YulBlock","src":"10410:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10427:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10430:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10420:6:7"},"nodeType":"YulFunctionCall","src":"10420:12:7"},"nodeType":"YulExpressionStatement","src":"10420:12:7"}]},"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulFunctionDefinition","src":"10321:117:7"},{"body":{"nodeType":"YulBlock","src":"10533:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10550:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10553:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10543:6:7"},"nodeType":"YulFunctionCall","src":"10543:12:7"},"nodeType":"YulExpressionStatement","src":"10543:12:7"}]},"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulFunctionDefinition","src":"10444:117:7"},{"body":{"nodeType":"YulBlock","src":"10612:32:7","statements":[{"nodeType":"YulAssignment","src":"10622:16:7","value":{"name":"value","nodeType":"YulIdentifier","src":"10633:5:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"10622:7:7"}]}]},"name":"cleanup_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10594:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"10604:7:7","type":""}],"src":"10567:77:7"},{"body":{"nodeType":"YulBlock","src":"10693:79:7","statements":[{"body":{"nodeType":"YulBlock","src":"10750:16:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10759:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10762:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10752:6:7"},"nodeType":"YulFunctionCall","src":"10752:12:7"},"nodeType":"YulExpressionStatement","src":"10752:12:7"}]},"condition":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10716:5:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10741:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"10723:17:7"},"nodeType":"YulFunctionCall","src":"10723:24:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"10713:2:7"},"nodeType":"YulFunctionCall","src":"10713:35:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"10706:6:7"},"nodeType":"YulFunctionCall","src":"10706:43:7"},"nodeType":"YulIf","src":"10703:63:7"}]},"name":"validator_revert_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10686:5:7","type":""}],"src":"10650:122:7"},{"body":{"nodeType":"YulBlock","src":"10830:87:7","statements":[{"nodeType":"YulAssignment","src":"10840:29:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"10862:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"10849:12:7"},"nodeType":"YulFunctionCall","src":"10849:20:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"10840:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10905:5:7"}],"functionName":{"name":"validator_revert_t_uint256","nodeType":"YulIdentifier","src":"10878:26:7"},"nodeType":"YulFunctionCall","src":"10878:33:7"},"nodeType":"YulExpressionStatement","src":"10878:33:7"}]},"name":"abi_decode_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"10808:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"10816:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"10824:5:7","type":""}],"src":"10778:139:7"},{"body":{"nodeType":"YulBlock","src":"11012:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11029:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11032:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11022:6:7"},"nodeType":"YulFunctionCall","src":"11022:12:7"},"nodeType":"YulExpressionStatement","src":"11022:12:7"}]},"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulFunctionDefinition","src":"10923:117:7"},{"body":{"nodeType":"YulBlock","src":"11135:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11152:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11155:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11145:6:7"},"nodeType":"YulFunctionCall","src":"11145:12:7"},"nodeType":"YulExpressionStatement","src":"11145:12:7"}]},"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulFunctionDefinition","src":"11046:117:7"},{"body":{"nodeType":"YulBlock","src":"11197:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11214:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11217:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11207:6:7"},"nodeType":"YulFunctionCall","src":"11207:88:7"},"nodeType":"YulExpressionStatement","src":"11207:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11311:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"11314:4:7","type":"","value":"0x41"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11304:6:7"},"nodeType":"YulFunctionCall","src":"11304:15:7"},"nodeType":"YulExpressionStatement","src":"11304:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11335:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11338:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11328:6:7"},"nodeType":"YulFunctionCall","src":"11328:15:7"},"nodeType":"YulExpressionStatement","src":"11328:15:7"}]},"name":"panic_error_0x41","nodeType":"YulFunctionDefinition","src":"11169:180:7"},{"body":{"nodeType":"YulBlock","src":"11398:238:7","statements":[{"nodeType":"YulVariableDeclaration","src":"11408:58:7","value":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11430:6:7"},{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"11460:4:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11438:21:7"},"nodeType":"YulFunctionCall","src":"11438:27:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"11426:3:7"},"nodeType":"YulFunctionCall","src":"11426:40:7"},"variables":[{"name":"newFreePtr","nodeType":"YulTypedName","src":"11412:10:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"11577:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11579:16:7"},"nodeType":"YulFunctionCall","src":"11579:18:7"},"nodeType":"YulExpressionStatement","src":"11579:18:7"}]},"condition":{"arguments":[{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11520:10:7"},{"kind":"number","nodeType":"YulLiteral","src":"11532:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11517:2:7"},"nodeType":"YulFunctionCall","src":"11517:34:7"},{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11556:10:7"},{"name":"memPtr","nodeType":"YulIdentifier","src":"11568:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"11553:2:7"},"nodeType":"YulFunctionCall","src":"11553:22:7"}],"functionName":{"name":"or","nodeType":"YulIdentifier","src":"11514:2:7"},"nodeType":"YulFunctionCall","src":"11514:62:7"},"nodeType":"YulIf","src":"11511:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11615:2:7","type":"","value":"64"},{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11619:10:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11608:6:7"},"nodeType":"YulFunctionCall","src":"11608:22:7"},"nodeType":"YulExpressionStatement","src":"11608:22:7"}]},"name":"finalize_allocation","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"11384:6:7","type":""},{"name":"size","nodeType":"YulTypedName","src":"11392:4:7","type":""}],"src":"11355:281:7"},{"body":{"nodeType":"YulBlock","src":"11683:88:7","statements":[{"nodeType":"YulAssignment","src":"11693:30:7","value":{"arguments":[],"functionName":{"name":"allocate_unbounded","nodeType":"YulIdentifier","src":"11703:18:7"},"nodeType":"YulFunctionCall","src":"11703:20:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11693:6:7"}]},{"expression":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11752:6:7"},{"name":"size","nodeType":"YulIdentifier","src":"11760:4:7"}],"functionName":{"name":"finalize_allocation","nodeType":"YulIdentifier","src":"11732:19:7"},"nodeType":"YulFunctionCall","src":"11732:33:7"},"nodeType":"YulExpressionStatement","src":"11732:33:7"}]},"name":"allocate_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"size","nodeType":"YulTypedName","src":"11667:4:7","type":""}],"returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"11676:6:7","type":""}],"src":"11642:129:7"},{"body":{"nodeType":"YulBlock","src":"11844:241:7","statements":[{"body":{"nodeType":"YulBlock","src":"11949:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11951:16:7"},"nodeType":"YulFunctionCall","src":"11951:18:7"},"nodeType":"YulExpressionStatement","src":"11951:18:7"}]},"condition":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"11921:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"11929:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11918:2:7"},"nodeType":"YulFunctionCall","src":"11918:30:7"},"nodeType":"YulIf","src":"11915:56:7"},{"nodeType":"YulAssignment","src":"11981:37:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12011:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11989:21:7"},"nodeType":"YulFunctionCall","src":"11989:29:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"11981:4:7"}]},{"nodeType":"YulAssignment","src":"12055:23:7","value":{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"12067:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"12073:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12063:3:7"},"nodeType":"YulFunctionCall","src":"12063:15:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"12055:4:7"}]}]},"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"length","nodeType":"YulTypedName","src":"11828:6:7","type":""}],"returnVariables":[{"name":"size","nodeType":"YulTypedName","src":"11839:4:7","type":""}],"src":"11777:308:7"},{"body":{"nodeType":"YulBlock","src":"12142:103:7","statements":[{"expression":{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12165:3:7"},{"name":"src","nodeType":"YulIdentifier","src":"12170:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12175:6:7"}],"functionName":{"name":"calldatacopy","nodeType":"YulIdentifier","src":"12152:12:7"},"nodeType":"YulFunctionCall","src":"12152:30:7"},"nodeType":"YulExpressionStatement","src":"12152:30:7"},{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12223:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12228:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12219:3:7"},"nodeType":"YulFunctionCall","src":"12219:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"12237:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12212:6:7"},"nodeType":"YulFunctionCall","src":"12212:27:7"},"nodeType":"YulExpressionStatement","src":"12212:27:7"}]},"name":"copy_calldata_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12124:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"12129:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12134:6:7","type":""}],"src":"12091:154:7"},{"body":{"nodeType":"YulBlock","src":"12335:328:7","statements":[{"nodeType":"YulAssignment","src":"12345:75:7","value":{"arguments":[{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12412:6:7"}],"functionName":{"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12370:41:7"},"nodeType":"YulFunctionCall","src":"12370:49:7"}],"functionName":{"name":"allocate_memory","nodeType":"YulIdentifier","src":"12354:15:7"},"nodeType":"YulFunctionCall","src":"12354:66:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12345:5:7"}]},{"expression":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12436:5:7"},{"name":"length","nodeType":"YulIdentifier","src":"12443:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12429:6:7"},"nodeType":"YulFunctionCall","src":"12429:21:7"},"nodeType":"YulExpressionStatement","src":"12429:21:7"},{"nodeType":"YulVariableDeclaration","src":"12459:27:7","value":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12474:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"12481:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12470:3:7"},"nodeType":"YulFunctionCall","src":"12470:16:7"},"variables":[{"name":"dst","nodeType":"YulTypedName","src":"12463:3:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"12524:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulIdentifier","src":"12526:77:7"},"nodeType":"YulFunctionCall","src":"12526:79:7"},"nodeType":"YulExpressionStatement","src":"12526:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12505:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12510:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12501:3:7"},"nodeType":"YulFunctionCall","src":"12501:16:7"},{"name":"end","nodeType":"YulIdentifier","src":"12519:3:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"12498:2:7"},"nodeType":"YulFunctionCall","src":"12498:25:7"},"nodeType":"YulIf","src":"12495:112:7"},{"expression":{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12640:3:7"},{"name":"dst","nodeType":"YulIdentifier","src":"12645:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12650:6:7"}],"functionName":{"name":"copy_calldata_to_memory","nodeType":"YulIdentifier","src":"12616:23:7"},"nodeType":"YulFunctionCall","src":"12616:41:7"},"nodeType":"YulExpressionStatement","src":"12616:41:7"}]},"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12308:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12313:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12321:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12329:5:7","type":""}],"src":"12251:412:7"},{"body":{"nodeType":"YulBlock","src":"12745:278:7","statements":[{"body":{"nodeType":"YulBlock","src":"12794:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulIdentifier","src":"12796:77:7"},"nodeType":"YulFunctionCall","src":"12796:79:7"},"nodeType":"YulExpressionStatement","src":"12796:79:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12773:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12781:4:7","type":"","value":"0x1f"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12769:3:7"},"nodeType":"YulFunctionCall","src":"12769:17:7"},{"name":"end","nodeType":"YulIdentifier","src":"12788:3:7"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"12765:3:7"},"nodeType":"YulFunctionCall","src":"12765:27:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"12758:6:7"},"nodeType":"YulFunctionCall","src":"12758:35:7"},"nodeType":"YulIf","src":"12755:122:7"},{"nodeType":"YulVariableDeclaration","src":"12886:34:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12913:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"12900:12:7"},"nodeType":"YulFunctionCall","src":"12900:20:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"12890:6:7","type":""}]},{"nodeType":"YulAssignment","src":"12929:88:7","value":{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12990:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12986:3:7"},"nodeType":"YulFunctionCall","src":"12986:17:7"},{"name":"length","nodeType":"YulIdentifier","src":"13005:6:7"},{"name":"end","nodeType":"YulIdentifier","src":"13013:3:7"}],"functionName":{"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12938:47:7"},"nodeType":"YulFunctionCall","src":"12938:79:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12929:5:7"}]}]},"name":"abi_decode_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"12723:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12731:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12739:5:7","type":""}],"src":"12683:340:7"},{"body":{"nodeType":"YulBlock","src":"13139:689:7","statements":[{"body":{"nodeType":"YulBlock","src":"13185:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"13187:77:7"},"nodeType":"YulFunctionCall","src":"13187:79:7"},"nodeType":"YulExpressionStatement","src":"13187:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"13160:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"13169:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"13156:3:7"},"nodeType":"YulFunctionCall","src":"13156:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"13181:2:7","type":"","value":"96"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"13152:3:7"},"nodeType":"YulFunctionCall","src":"13152:32:7"},"nodeType":"YulIf","src":"13149:119:7"},{"nodeType":"YulBlock","src":"13278:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13293:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13307:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13297:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13322:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13357:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13368:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13353:3:7"},"nodeType":"YulFunctionCall","src":"13353:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13377:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13332:20:7"},"nodeType":"YulFunctionCall","src":"13332:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"13322:6:7"}]}]},{"nodeType":"YulBlock","src":"13405:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13420:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13434:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13424:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13450:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13485:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13496:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13481:3:7"},"nodeType":"YulFunctionCall","src":"13481:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13505:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13460:20:7"},"nodeType":"YulFunctionCall","src":"13460:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"13450:6:7"}]}]},{"nodeType":"YulBlock","src":"13533:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13548:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13579:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"13590:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13575:3:7"},"nodeType":"YulFunctionCall","src":"13575:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"13562:12:7"},"nodeType":"YulFunctionCall","src":"13562:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13552:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"13641:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"13643:77:7"},"nodeType":"YulFunctionCall","src":"13643:79:7"},"nodeType":"YulExpressionStatement","src":"13643:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"13613:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"13621:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"13610:2:7"},"nodeType":"YulFunctionCall","src":"13610:30:7"},"nodeType":"YulIf","src":"13607:117:7"},{"nodeType":"YulAssignment","src":"13738:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13783:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13794:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13779:3:7"},"nodeType":"YulFunctionCall","src":"13779:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13803:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"13748:30:7"},"nodeType":"YulFunctionCall","src":"13748:63:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"13738:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"13093:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"13104:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"13116:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"13124:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"13132:6:7","type":""}],"src":"13029:799:7"},{"body":{"nodeType":"YulBlock","src":"13899:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"13916:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"13939:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"13921:17:7"},"nodeType":"YulFunctionCall","src":"13921:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"13909:6:7"},"nodeType":"YulFunctionCall","src":"13909:37:7"},"nodeType":"YulExpressionStatement","src":"13909:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"13887:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"13894:3:7","type":""}],"src":"13834:118:7"},{"body":{"nodeType":"YulBlock","src":"14056:124:7","statements":[{"nodeType":"YulAssignment","src":"14066:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14078:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14089:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14074:3:7"},"nodeType":"YulFunctionCall","src":"14074:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"14066:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"14146:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14159:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14170:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14155:3:7"},"nodeType":"YulFunctionCall","src":"14155:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"14102:43:7"},"nodeType":"YulFunctionCall","src":"14102:71:7"},"nodeType":"YulExpressionStatement","src":"14102:71:7"}]},"name":"abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14028:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"14040:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"14051:4:7","type":""}],"src":"13958:222:7"},{"body":{"nodeType":"YulBlock","src":"14269:391:7","statements":[{"body":{"nodeType":"YulBlock","src":"14315:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14317:77:7"},"nodeType":"YulFunctionCall","src":"14317:79:7"},"nodeType":"YulExpressionStatement","src":"14317:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14290:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14299:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14286:3:7"},"nodeType":"YulFunctionCall","src":"14286:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14311:2:7","type":"","value":"64"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14282:3:7"},"nodeType":"YulFunctionCall","src":"14282:32:7"},"nodeType":"YulIf","src":"14279:119:7"},{"nodeType":"YulBlock","src":"14408:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14423:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14437:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14427:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14452:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14487:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14498:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14483:3:7"},"nodeType":"YulFunctionCall","src":"14483:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14507:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14462:20:7"},"nodeType":"YulFunctionCall","src":"14462:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14452:6:7"}]}]},{"nodeType":"YulBlock","src":"14535:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14550:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14564:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14554:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14580:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14615:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14626:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14611:3:7"},"nodeType":"YulFunctionCall","src":"14611:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14635:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14590:20:7"},"nodeType":"YulFunctionCall","src":"14590:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"14580:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14231:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14242:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14254:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14262:6:7","type":""}],"src":"14186:474:7"},{"body":{"nodeType":"YulBlock","src":"14793:818:7","statements":[{"body":{"nodeType":"YulBlock","src":"14840:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14842:77:7"},"nodeType":"YulFunctionCall","src":"14842:79:7"},"nodeType":"YulExpressionStatement","src":"14842:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14814:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14823:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14810:3:7"},"nodeType":"YulFunctionCall","src":"14810:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14835:3:7","type":"","value":"128"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14806:3:7"},"nodeType":"YulFunctionCall","src":"14806:33:7"},"nodeType":"YulIf","src":"14803:120:7"},{"nodeType":"YulBlock","src":"14933:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14948:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14962:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14952:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14977:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15012:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15023:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15008:3:7"},"nodeType":"YulFunctionCall","src":"15008:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15032:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14987:20:7"},"nodeType":"YulFunctionCall","src":"14987:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14977:6:7"}]}]},{"nodeType":"YulBlock","src":"15060:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15075:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15089:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15079:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15105:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15140:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15151:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15136:3:7"},"nodeType":"YulFunctionCall","src":"15136:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15160:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15115:20:7"},"nodeType":"YulFunctionCall","src":"15115:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"15105:6:7"}]}]},{"nodeType":"YulBlock","src":"15188:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15203:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15217:2:7","type":"","value":"64"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15207:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15233:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15268:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15279:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15264:3:7"},"nodeType":"YulFunctionCall","src":"15264:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15288:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15243:20:7"},"nodeType":"YulFunctionCall","src":"15243:53:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"15233:6:7"}]}]},{"nodeType":"YulBlock","src":"15316:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15331:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15362:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"15373:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15358:3:7"},"nodeType":"YulFunctionCall","src":"15358:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"15345:12:7"},"nodeType":"YulFunctionCall","src":"15345:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15335:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"15424:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"15426:77:7"},"nodeType":"YulFunctionCall","src":"15426:79:7"},"nodeType":"YulExpressionStatement","src":"15426:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"15396:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"15404:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"15393:2:7"},"nodeType":"YulFunctionCall","src":"15393:30:7"},"nodeType":"YulIf","src":"15390:117:7"},{"nodeType":"YulAssignment","src":"15521:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15566:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15577:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15562:3:7"},"nodeType":"YulFunctionCall","src":"15562:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15586:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"15531:30:7"},"nodeType":"YulFunctionCall","src":"15531:63:7"},"variableNames":[{"name":"value3","nodeType":"YulIdentifier","src":"15521:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14739:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14750:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14762:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14770:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"14778:6:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"14786:6:7","type":""}],"src":"14666:945:7"},{"body":{"nodeType":"YulBlock","src":"15736:40:7","statements":[{"nodeType":"YulAssignment","src":"15747:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"15763:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"15757:5:7"},"nodeType":"YulFunctionCall","src":"15757:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"15747:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"15719:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"15729:6:7","type":""}],"src":"15617:159:7"},{"body":{"nodeType":"YulBlock","src":"15938:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"15955:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"15960:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"15948:6:7"},"nodeType":"YulFunctionCall","src":"15948:19:7"},"nodeType":"YulExpressionStatement","src":"15948:19:7"},{"nodeType":"YulAssignment","src":"15976:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"15995:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16000:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15991:3:7"},"nodeType":"YulFunctionCall","src":"15991:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"15976:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"15910:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"15915:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"15926:11:7","type":""}],"src":"15782:229:7"},{"body":{"nodeType":"YulBlock","src":"16134:60:7","statements":[{"nodeType":"YulAssignment","src":"16144:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"16152:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16144:4:7"}]},{"nodeType":"YulAssignment","src":"16165:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"16177:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16182:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16173:3:7"},"nodeType":"YulFunctionCall","src":"16173:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16165:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"16121:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"16129:4:7","type":""}],"src":"16017:177:7"},{"body":{"nodeType":"YulBlock","src":"16294:40:7","statements":[{"nodeType":"YulAssignment","src":"16305:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16321:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"16315:5:7"},"nodeType":"YulFunctionCall","src":"16315:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"16305:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16277:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"16287:6:7","type":""}],"src":"16200:134:7"},{"body":{"nodeType":"YulBlock","src":"16461:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16478:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"16483:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16471:6:7"},"nodeType":"YulFunctionCall","src":"16471:19:7"},"nodeType":"YulExpressionStatement","src":"16471:19:7"},{"nodeType":"YulAssignment","src":"16499:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16518:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16523:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16514:3:7"},"nodeType":"YulFunctionCall","src":"16514:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"16499:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"16433:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"16438:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"16449:11:7","type":""}],"src":"16340:194:7"},{"body":{"nodeType":"YulBlock","src":"16632:60:7","statements":[{"nodeType":"YulAssignment","src":"16642:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"16650:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16642:4:7"}]},{"nodeType":"YulAssignment","src":"16663:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"16675:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16680:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16671:3:7"},"nodeType":"YulFunctionCall","src":"16671:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"16663:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"16619:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"16627:4:7","type":""}],"src":"16540:152:7"},{"body":{"nodeType":"YulBlock","src":"16753:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16770:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16793:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"16775:17:7"},"nodeType":"YulFunctionCall","src":"16775:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16763:6:7"},"nodeType":"YulFunctionCall","src":"16763:37:7"},"nodeType":"YulExpressionStatement","src":"16763:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16741:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"16748:3:7","type":""}],"src":"16698:108:7"},{"body":{"nodeType":"YulBlock","src":"16906:40:7","statements":[{"nodeType":"YulAssignment","src":"16917:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16933:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"16927:5:7"},"nodeType":"YulFunctionCall","src":"16927:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"16917:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16889:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"16899:6:7","type":""}],"src":"16812:134:7"},{"body":{"nodeType":"YulBlock","src":"17073:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17090:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"17095:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17083:6:7"},"nodeType":"YulFunctionCall","src":"17083:19:7"},"nodeType":"YulExpressionStatement","src":"17083:19:7"},{"nodeType":"YulAssignment","src":"17111:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17130:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17135:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17126:3:7"},"nodeType":"YulFunctionCall","src":"17126:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"17111:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"17045:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"17050:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"17061:11:7","type":""}],"src":"16952:194:7"},{"body":{"nodeType":"YulBlock","src":"17244:60:7","statements":[{"nodeType":"YulAssignment","src":"17254:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"17262:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17254:4:7"}]},{"nodeType":"YulAssignment","src":"17275:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"17287:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17292:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17283:3:7"},"nodeType":"YulFunctionCall","src":"17283:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17275:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"17231:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"17239:4:7","type":""}],"src":"17152:152:7"},{"body":{"nodeType":"YulBlock","src":"17476:500:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17486:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17502:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17507:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17498:3:7"},"nodeType":"YulFunctionCall","src":"17498:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"17490:4:7","type":""}]},{"nodeType":"YulBlock","src":"17522:181:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17558:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17588:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"17595:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17584:3:7"},"nodeType":"YulFunctionCall","src":"17584:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17578:5:7"},"nodeType":"YulFunctionCall","src":"17578:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"17562:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"17664:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17682:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17687:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17678:3:7"},"nodeType":"YulFunctionCall","src":"17678:14:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"17614:49:7"},"nodeType":"YulFunctionCall","src":"17614:79:7"},"nodeType":"YulExpressionStatement","src":"17614:79:7"}]},{"nodeType":"YulBlock","src":"17713:236:7","statements":[{"nodeType":"YulVariableDeclaration","src":"17749:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17779:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"17786:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17775:3:7"},"nodeType":"YulFunctionCall","src":"17775:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17769:5:7"},"nodeType":"YulFunctionCall","src":"17769:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"17753:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17817:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17822:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17813:3:7"},"nodeType":"YulFunctionCall","src":"17813:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"17833:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"17839:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"17829:3:7"},"nodeType":"YulFunctionCall","src":"17829:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17806:6:7"},"nodeType":"YulFunctionCall","src":"17806:38:7"},"nodeType":"YulExpressionStatement","src":"17806:38:7"},{"nodeType":"YulAssignment","src":"17857:81:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"17919:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"17933:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"17865:53:7"},"nodeType":"YulFunctionCall","src":"17865:73:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"17857:4:7"}]}]},{"nodeType":"YulAssignment","src":"17959:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"17966:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"17959:3:7"}]}]},"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"17455:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"17462:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"17471:3:7","type":""}],"src":"17372:604:7"},{"body":{"nodeType":"YulBlock","src":"18102:116:7","statements":[{"nodeType":"YulAssignment","src":"18112:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"18200:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"18208:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"18126:73:7"},"nodeType":"YulFunctionCall","src":"18126:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"18112:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"18075:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"18083:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"18091:10:7","type":""}],"src":"17982:236:7"},{"body":{"nodeType":"YulBlock","src":"18319:38:7","statements":[{"nodeType":"YulAssignment","src":"18329:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"18341:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18346:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18337:3:7"},"nodeType":"YulFunctionCall","src":"18337:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"18329:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"18306:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"18314:4:7","type":""}],"src":"18224:133:7"},{"body":{"nodeType":"YulBlock","src":"18583:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"18593:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18675:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18607:67:7"},"nodeType":"YulFunctionCall","src":"18607:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"18597:6:7","type":""}]},{"nodeType":"YulAssignment","src":"18690:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18781:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"18786:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18697:83:7"},"nodeType":"YulFunctionCall","src":"18697:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"18690:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"18802:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"18819:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"18806:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18831:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18847:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"18856:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"18864:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"18852:3:7"},"nodeType":"YulFunctionCall","src":"18852:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18843:3:7"},"nodeType":"YulFunctionCall","src":"18843:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"18835:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18879:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18964:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"18894:69:7"},"nodeType":"YulFunctionCall","src":"18894:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"18883:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"18979:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"18993:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"18983:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"19069:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19090:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"19099:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"19105:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"19095:3:7"},"nodeType":"YulFunctionCall","src":"19095:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"19083:6:7"},"nodeType":"YulFunctionCall","src":"19083:33:7"},"nodeType":"YulExpressionStatement","src":"19083:33:7"},{"nodeType":"YulVariableDeclaration","src":"19129:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19156:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19150:5:7"},"nodeType":"YulFunctionCall","src":"19150:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"19133:13:7","type":""}]},{"nodeType":"YulAssignment","src":"19176:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"19268:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"19283:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"19184:83:7"},"nodeType":"YulFunctionCall","src":"19184:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"19176:4:7"}]},{"nodeType":"YulAssignment","src":"19301:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19384:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"19311:72:7"},"nodeType":"YulFunctionCall","src":"19311:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"19301:6:7"}]},{"nodeType":"YulAssignment","src":"19404:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19415:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19420:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19411:3:7"},"nodeType":"YulFunctionCall","src":"19411:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"19404:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"19031:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"19034:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"19028:2:7"},"nodeType":"YulFunctionCall","src":"19028:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"19042:18:7","statements":[{"nodeType":"YulAssignment","src":"19044:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"19053:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"19056:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19049:3:7"},"nodeType":"YulFunctionCall","src":"19049:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"19044:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"19013:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19015:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"19024:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"19019:1:7","type":""}]}]},"src":"19009:426:7"},{"nodeType":"YulAssignment","src":"19444:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"19451:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"19444:3:7"}]},{"nodeType":"YulAssignment","src":"19464:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"19471:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"19464:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"18562:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"18569:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"18578:3:7","type":""}],"src":"18429:1051:7"},{"body":{"nodeType":"YulBlock","src":"19650:559:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19660:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19676:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19681:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19672:3:7"},"nodeType":"YulFunctionCall","src":"19672:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"19664:4:7","type":""}]},{"nodeType":"YulBlock","src":"19696:169:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19736:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19766:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"19773:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19762:3:7"},"nodeType":"YulFunctionCall","src":"19762:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19756:5:7"},"nodeType":"YulFunctionCall","src":"19756:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"19740:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"19826:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19844:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19849:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19840:3:7"},"nodeType":"YulFunctionCall","src":"19840:14:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulIdentifier","src":"19792:33:7"},"nodeType":"YulFunctionCall","src":"19792:63:7"},"nodeType":"YulExpressionStatement","src":"19792:63:7"}]},{"nodeType":"YulBlock","src":"19875:307:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19912:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19942:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"19949:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19938:3:7"},"nodeType":"YulFunctionCall","src":"19938:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"19932:5:7"},"nodeType":"YulFunctionCall","src":"19932:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"19916:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19980:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19985:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19976:3:7"},"nodeType":"YulFunctionCall","src":"19976:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"19996:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"20002:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"19992:3:7"},"nodeType":"YulFunctionCall","src":"19992:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"19969:6:7"},"nodeType":"YulFunctionCall","src":"19969:38:7"},"nodeType":"YulExpressionStatement","src":"19969:38:7"},{"nodeType":"YulAssignment","src":"20020:151:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"20152:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"20166:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20028:123:7"},"nodeType":"YulFunctionCall","src":"20028:143:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"20020:4:7"}]}]},{"nodeType":"YulAssignment","src":"20192:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"20199:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"20192:3:7"}]}]},"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"19629:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"19636:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"19645:3:7","type":""}],"src":"19546:663:7"},{"body":{"nodeType":"YulBlock","src":"20335:116:7","statements":[{"nodeType":"YulAssignment","src":"20345:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"20433:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"20441:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"20359:73:7"},"nodeType":"YulFunctionCall","src":"20359:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"20345:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"20308:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"20316:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"20324:10:7","type":""}],"src":"20215:236:7"},{"body":{"nodeType":"YulBlock","src":"20552:38:7","statements":[{"nodeType":"YulAssignment","src":"20562:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"20574:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20579:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20570:3:7"},"nodeType":"YulFunctionCall","src":"20570:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"20562:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"20539:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"20547:4:7","type":""}],"src":"20457:133:7"},{"body":{"nodeType":"YulBlock","src":"20814:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"20824:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"20906:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20838:67:7"},"nodeType":"YulFunctionCall","src":"20838:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"20828:6:7","type":""}]},{"nodeType":"YulAssignment","src":"20921:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21012:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"21017:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20928:83:7"},"nodeType":"YulFunctionCall","src":"20928:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"20921:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"21033:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"21050:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"21037:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21062:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21078:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"21087:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"21095:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"21083:3:7"},"nodeType":"YulFunctionCall","src":"21083:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21074:3:7"},"nodeType":"YulFunctionCall","src":"21074:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"21066:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21110:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"21195:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21125:69:7"},"nodeType":"YulFunctionCall","src":"21125:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"21114:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"21210:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"21224:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"21214:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"21300:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21321:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"21330:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"21336:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"21326:3:7"},"nodeType":"YulFunctionCall","src":"21326:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"21314:6:7"},"nodeType":"YulFunctionCall","src":"21314:33:7"},"nodeType":"YulExpressionStatement","src":"21314:33:7"},{"nodeType":"YulVariableDeclaration","src":"21360:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21387:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"21381:5:7"},"nodeType":"YulFunctionCall","src":"21381:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"21364:13:7","type":""}]},{"nodeType":"YulAssignment","src":"21407:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"21499:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"21514:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"21415:83:7"},"nodeType":"YulFunctionCall","src":"21415:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"21407:4:7"}]},{"nodeType":"YulAssignment","src":"21532:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21615:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21542:72:7"},"nodeType":"YulFunctionCall","src":"21542:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"21532:6:7"}]},{"nodeType":"YulAssignment","src":"21635:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21646:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"21651:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21642:3:7"},"nodeType":"YulFunctionCall","src":"21642:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"21635:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"21262:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"21265:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"21259:2:7"},"nodeType":"YulFunctionCall","src":"21259:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"21273:18:7","statements":[{"nodeType":"YulAssignment","src":"21275:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"21284:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"21287:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21280:3:7"},"nodeType":"YulFunctionCall","src":"21280:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"21275:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"21244:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"21246:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"21255:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"21250:1:7","type":""}]}]},"src":"21240:426:7"},{"nodeType":"YulAssignment","src":"21675:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"21682:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"21675:3:7"}]},{"nodeType":"YulAssignment","src":"21695:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"21702:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"21695:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"20793:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"20800:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"20809:3:7","type":""}],"src":"20660:1051:7"},{"body":{"nodeType":"YulBlock","src":"21887:166:7","statements":[{"nodeType":"YulAssignment","src":"21897:150:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"22035:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"22043:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21911:123:7"},"nodeType":"YulFunctionCall","src":"21911:136:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"21897:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"21860:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"21868:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"21876:10:7","type":""}],"src":"21717:336:7"},{"body":{"nodeType":"YulBlock","src":"22179:38:7","statements":[{"nodeType":"YulAssignment","src":"22189:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"22201:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"22206:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22197:3:7"},"nodeType":"YulFunctionCall","src":"22197:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"22189:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"22166:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"22174:4:7","type":""}],"src":"22059:158:7"},{"body":{"nodeType":"YulBlock","src":"22505:1057:7","statements":[{"nodeType":"YulVariableDeclaration","src":"22515:113:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"22622:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22529:92:7"},"nodeType":"YulFunctionCall","src":"22529:99:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"22519:6:7","type":""}]},{"nodeType":"YulAssignment","src":"22637:138:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22763:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"22768:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"22644:118:7"},"nodeType":"YulFunctionCall","src":"22644:131:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"22637:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"22784:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"22801:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"22788:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22813:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22829:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"22838:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"22846:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"22834:3:7"},"nodeType":"YulFunctionCall","src":"22834:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22825:3:7"},"nodeType":"YulFunctionCall","src":"22825:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"22817:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22861:116:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"22971:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22876:94:7"},"nodeType":"YulFunctionCall","src":"22876:101:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"22865:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22986:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"23000:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"22990:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"23076:441:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23097:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"23106:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"23112:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"23102:3:7"},"nodeType":"YulFunctionCall","src":"23102:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"23090:6:7"},"nodeType":"YulFunctionCall","src":"23090:33:7"},"nodeType":"YulExpressionStatement","src":"23090:33:7"},{"nodeType":"YulVariableDeclaration","src":"23136:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23163:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"23157:5:7"},"nodeType":"YulFunctionCall","src":"23157:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"23140:13:7","type":""}]},{"nodeType":"YulAssignment","src":"23183:162:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"23325:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"23340:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23191:133:7"},"nodeType":"YulFunctionCall","src":"23191:154:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23183:4:7"}]},{"nodeType":"YulAssignment","src":"23358:115:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23466:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23368:97:7"},"nodeType":"YulFunctionCall","src":"23368:105:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"23358:6:7"}]},{"nodeType":"YulAssignment","src":"23486:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23497:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"23502:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23493:3:7"},"nodeType":"YulFunctionCall","src":"23493:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"23486:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"23038:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"23041:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"23035:2:7"},"nodeType":"YulFunctionCall","src":"23035:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"23049:18:7","statements":[{"nodeType":"YulAssignment","src":"23051:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"23060:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"23063:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23056:3:7"},"nodeType":"YulFunctionCall","src":"23056:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"23051:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"23020:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"23022:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"23031:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"23026:1:7","type":""}]}]},"src":"23016:501:7"},{"nodeType":"YulAssignment","src":"23526:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"23533:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"23526:3:7"}]},{"nodeType":"YulAssignment","src":"23546:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"23553:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"23546:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"22484:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"22491:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"22500:3:7","type":""}],"src":"22291:1271:7"},{"body":{"nodeType":"YulBlock","src":"23806:315:7","statements":[{"nodeType":"YulAssignment","src":"23816:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"23828:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"23839:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23824:3:7"},"nodeType":"YulFunctionCall","src":"23824:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23816:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"23863:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"23874:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23859:3:7"},"nodeType":"YulFunctionCall","src":"23859:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"23882:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"23888:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"23878:3:7"},"nodeType":"YulFunctionCall","src":"23878:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"23852:6:7"},"nodeType":"YulFunctionCall","src":"23852:47:7"},"nodeType":"YulExpressionStatement","src":"23852:47:7"},{"nodeType":"YulAssignment","src":"23908:206:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"24100:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"24109:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"23916:183:7"},"nodeType":"YulFunctionCall","src":"23916:198:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"23908:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"23778:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"23790:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"23801:4:7","type":""}],"src":"23568:553:7"},{"body":{"nodeType":"YulBlock","src":"24159:28:7","statements":[{"nodeType":"YulAssignment","src":"24169:12:7","value":{"name":"value","nodeType":"YulIdentifier","src":"24176:5:7"},"variableNames":[{"name":"ret","nodeType":"YulIdentifier","src":"24169:3:7"}]}]},"name":"identity","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24145:5:7","type":""}],"returnVariables":[{"name":"ret","nodeType":"YulTypedName","src":"24155:3:7","type":""}],"src":"24127:60:7"},{"body":{"nodeType":"YulBlock","src":"24253:82:7","statements":[{"nodeType":"YulAssignment","src":"24263:66:7","value":{"arguments":[{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24321:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"24303:17:7"},"nodeType":"YulFunctionCall","src":"24303:24:7"}],"functionName":{"name":"identity","nodeType":"YulIdentifier","src":"24294:8:7"},"nodeType":"YulFunctionCall","src":"24294:34:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"24276:17:7"},"nodeType":"YulFunctionCall","src":"24276:53:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"24263:9:7"}]}]},"name":"convert_t_uint160_to_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24233:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"24243:9:7","type":""}],"src":"24193:142:7"},{"body":{"nodeType":"YulBlock","src":"24401:66:7","statements":[{"nodeType":"YulAssignment","src":"24411:50:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24455:5:7"}],"functionName":{"name":"convert_t_uint160_to_t_uint160","nodeType":"YulIdentifier","src":"24424:30:7"},"nodeType":"YulFunctionCall","src":"24424:37:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"24411:9:7"}]}]},"name":"convert_t_uint160_to_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24381:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"24391:9:7","type":""}],"src":"24341:126:7"},{"body":{"nodeType":"YulBlock","src":"24554:66:7","statements":[{"nodeType":"YulAssignment","src":"24564:50:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24608:5:7"}],"functionName":{"name":"convert_t_uint160_to_t_address","nodeType":"YulIdentifier","src":"24577:30:7"},"nodeType":"YulFunctionCall","src":"24577:37:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"24564:9:7"}]}]},"name":"convert_t_contract$_BaseContract_$1001_to_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24534:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"24544:9:7","type":""}],"src":"24473:147:7"},{"body":{"nodeType":"YulBlock","src":"24712:87:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24729:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"24786:5:7"}],"functionName":{"name":"convert_t_contract$_BaseContract_$1001_to_t_address","nodeType":"YulIdentifier","src":"24734:51:7"},"nodeType":"YulFunctionCall","src":"24734:58:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"24722:6:7"},"nodeType":"YulFunctionCall","src":"24722:71:7"},"nodeType":"YulExpressionStatement","src":"24722:71:7"}]},"name":"abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"24700:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"24707:3:7","type":""}],"src":"24626:173:7"},{"body":{"nodeType":"YulBlock","src":"24924:145:7","statements":[{"nodeType":"YulAssignment","src":"24934:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"24946:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"24957:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24942:3:7"},"nodeType":"YulFunctionCall","src":"24942:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"24934:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25035:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25048:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25059:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25044:3:7"},"nodeType":"YulFunctionCall","src":"25044:17:7"}],"functionName":{"name":"abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack","nodeType":"YulIdentifier","src":"24970:64:7"},"nodeType":"YulFunctionCall","src":"24970:92:7"},"nodeType":"YulExpressionStatement","src":"24970:92:7"}]},"name":"abi_encode_tuple_t_contract$_BaseContract_$1001__to_t_address__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"24896:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"24908:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"24919:4:7","type":""}],"src":"24805:264:7"},{"body":{"nodeType":"YulBlock","src":"25117:48:7","statements":[{"nodeType":"YulAssignment","src":"25127:32:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25152:5:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25145:6:7"},"nodeType":"YulFunctionCall","src":"25145:13:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25138:6:7"},"nodeType":"YulFunctionCall","src":"25138:21:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"25127:7:7"}]}]},"name":"cleanup_t_bool","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25099:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"25109:7:7","type":""}],"src":"25075:90:7"},{"body":{"nodeType":"YulBlock","src":"25230:50:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25247:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25267:5:7"}],"functionName":{"name":"cleanup_t_bool","nodeType":"YulIdentifier","src":"25252:14:7"},"nodeType":"YulFunctionCall","src":"25252:21:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25240:6:7"},"nodeType":"YulFunctionCall","src":"25240:34:7"},"nodeType":"YulExpressionStatement","src":"25240:34:7"}]},"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25218:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25225:3:7","type":""}],"src":"25171:109:7"},{"body":{"nodeType":"YulBlock","src":"25378:118:7","statements":[{"nodeType":"YulAssignment","src":"25388:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25400:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25411:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25396:3:7"},"nodeType":"YulFunctionCall","src":"25396:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"25388:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25462:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25475:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25486:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25471:3:7"},"nodeType":"YulFunctionCall","src":"25471:17:7"}],"functionName":{"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulIdentifier","src":"25424:37:7"},"nodeType":"YulFunctionCall","src":"25424:65:7"},"nodeType":"YulExpressionStatement","src":"25424:65:7"}]},"name":"abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"25350:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"25362:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"25373:4:7","type":""}],"src":"25286:210:7"},{"body":{"nodeType":"YulBlock","src":"25583:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25600:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25631:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"25605:25:7"},"nodeType":"YulFunctionCall","src":"25605:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25593:6:7"},"nodeType":"YulFunctionCall","src":"25593:45:7"},"nodeType":"YulExpressionStatement","src":"25593:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25571:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25578:3:7","type":""}],"src":"25502:142:7"},{"body":{"nodeType":"YulBlock","src":"25746:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25763:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"25768:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25756:6:7"},"nodeType":"YulFunctionCall","src":"25756:19:7"},"nodeType":"YulExpressionStatement","src":"25756:19:7"},{"nodeType":"YulAssignment","src":"25784:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25803:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"25808:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25799:3:7"},"nodeType":"YulFunctionCall","src":"25799:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"25784:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"25718:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"25723:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"25734:11:7","type":""}],"src":"25650:169:7"},{"body":{"nodeType":"YulBlock","src":"25917:272:7","statements":[{"nodeType":"YulVariableDeclaration","src":"25927:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25974:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"25941:32:7"},"nodeType":"YulFunctionCall","src":"25941:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"25931:6:7","type":""}]},{"nodeType":"YulAssignment","src":"25989:78:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26055:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"26060:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"25996:58:7"},"nodeType":"YulFunctionCall","src":"25996:71:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"25989:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26102:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"26109:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26098:3:7"},"nodeType":"YulFunctionCall","src":"26098:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"26116:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"26121:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"26076:21:7"},"nodeType":"YulFunctionCall","src":"26076:52:7"},"nodeType":"YulExpressionStatement","src":"26076:52:7"},{"nodeType":"YulAssignment","src":"26137:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26148:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"26175:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"26153:21:7"},"nodeType":"YulFunctionCall","src":"26153:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26144:3:7"},"nodeType":"YulFunctionCall","src":"26144:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"26137:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25898:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25905:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"25913:3:7","type":""}],"src":"25825:364:7"},{"body":{"nodeType":"YulBlock","src":"26357:293:7","statements":[{"nodeType":"YulAssignment","src":"26367:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26379:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26390:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26375:3:7"},"nodeType":"YulFunctionCall","src":"26375:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26367:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"26463:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26476:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26487:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26472:3:7"},"nodeType":"YulFunctionCall","src":"26472:17:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulIdentifier","src":"26403:59:7"},"nodeType":"YulFunctionCall","src":"26403:87:7"},"nodeType":"YulExpressionStatement","src":"26403:87:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26511:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26522:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26507:3:7"},"nodeType":"YulFunctionCall","src":"26507:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"26531:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"26537:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"26527:3:7"},"nodeType":"YulFunctionCall","src":"26527:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26500:6:7"},"nodeType":"YulFunctionCall","src":"26500:48:7"},"nodeType":"YulExpressionStatement","src":"26500:48:7"},{"nodeType":"YulAssignment","src":"26557:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"26629:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"26638:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"26565:63:7"},"nodeType":"YulFunctionCall","src":"26565:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26557:4:7"}]}]},"name":"abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26321:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"26333:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26341:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26352:4:7","type":""}],"src":"26195:455:7"},{"body":{"nodeType":"YulBlock","src":"26701:51:7","statements":[{"nodeType":"YulAssignment","src":"26711:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26740:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"26722:17:7"},"nodeType":"YulFunctionCall","src":"26722:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"26711:7:7"}]}]},"name":"cleanup_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"26683:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"26693:7:7","type":""}],"src":"26656:96:7"},{"body":{"nodeType":"YulBlock","src":"26823:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26840:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26863:5:7"}],"functionName":{"name":"cleanup_t_address","nodeType":"YulIdentifier","src":"26845:17:7"},"nodeType":"YulFunctionCall","src":"26845:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26833:6:7"},"nodeType":"YulFunctionCall","src":"26833:37:7"},"nodeType":"YulExpressionStatement","src":"26833:37:7"}]},"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"26811:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"26818:3:7","type":""}],"src":"26758:118:7"},{"body":{"nodeType":"YulBlock","src":"26980:124:7","statements":[{"nodeType":"YulAssignment","src":"26990:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27002:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27013:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26998:3:7"},"nodeType":"YulFunctionCall","src":"26998:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26990:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27070:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27083:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27094:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27079:3:7"},"nodeType":"YulFunctionCall","src":"27079:17:7"}],"functionName":{"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulIdentifier","src":"27026:43:7"},"nodeType":"YulFunctionCall","src":"27026:71:7"},"nodeType":"YulExpressionStatement","src":"27026:71:7"}]},"name":"abi_encode_tuple_t_address__to_t_address__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26952:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26964:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26975:4:7","type":""}],"src":"26882:222:7"},{"body":{"nodeType":"YulBlock","src":"27284:359:7","statements":[{"nodeType":"YulAssignment","src":"27294:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27306:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27317:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27302:3:7"},"nodeType":"YulFunctionCall","src":"27302:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27294:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27374:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27387:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27398:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27383:3:7"},"nodeType":"YulFunctionCall","src":"27383:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"27330:43:7"},"nodeType":"YulFunctionCall","src":"27330:71:7"},"nodeType":"YulExpressionStatement","src":"27330:71:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27422:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27433:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27418:3:7"},"nodeType":"YulFunctionCall","src":"27418:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27442:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"27448:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"27438:3:7"},"nodeType":"YulFunctionCall","src":"27438:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27411:6:7"},"nodeType":"YulFunctionCall","src":"27411:48:7"},"nodeType":"YulExpressionStatement","src":"27411:48:7"},{"nodeType":"YulAssignment","src":"27468:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"27540:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"27549:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27476:63:7"},"nodeType":"YulFunctionCall","src":"27476:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27468:4:7"}]},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"27608:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27621:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27632:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27617:3:7"},"nodeType":"YulFunctionCall","src":"27617:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"27564:43:7"},"nodeType":"YulFunctionCall","src":"27564:72:7"},"nodeType":"YulExpressionStatement","src":"27564:72:7"}]},"name":"abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"27240:9:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"27252:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"27260:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"27268:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"27279:4:7","type":""}],"src":"27110:533:7"},{"body":{"nodeType":"YulBlock","src":"27767:195:7","statements":[{"nodeType":"YulAssignment","src":"27777:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27789:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27800:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27785:3:7"},"nodeType":"YulFunctionCall","src":"27785:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27777:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27824:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27835:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27820:3:7"},"nodeType":"YulFunctionCall","src":"27820:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27843:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"27849:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"27839:3:7"},"nodeType":"YulFunctionCall","src":"27839:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27813:6:7"},"nodeType":"YulFunctionCall","src":"27813:47:7"},"nodeType":"YulExpressionStatement","src":"27813:47:7"},{"nodeType":"YulAssignment","src":"27869:86:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27941:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"27950:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27877:63:7"},"nodeType":"YulFunctionCall","src":"27877:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27869:4:7"}]}]},"name":"abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"27739:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"27751:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"27762:4:7","type":""}],"src":"27649:313:7"},{"body":{"nodeType":"YulBlock","src":"28074:67:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"28096:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"28104:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28092:3:7"},"nodeType":"YulFunctionCall","src":"28092:14:7"},{"hexValue":"436f6e7472616374206973206e6f7420656e61626c6564","kind":"string","nodeType":"YulLiteral","src":"28108:25:7","type":"","value":"Contract is not enabled"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28085:6:7"},"nodeType":"YulFunctionCall","src":"28085:49:7"},"nodeType":"YulExpressionStatement","src":"28085:49:7"}]},"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"28066:6:7","type":""}],"src":"27968:173:7"},{"body":{"nodeType":"YulBlock","src":"28293:220:7","statements":[{"nodeType":"YulAssignment","src":"28303:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28369:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"28374:2:7","type":"","value":"23"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"28310:58:7"},"nodeType":"YulFunctionCall","src":"28310:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"28303:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28475:3:7"}],"functionName":{"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulIdentifier","src":"28386:88:7"},"nodeType":"YulFunctionCall","src":"28386:93:7"},"nodeType":"YulExpressionStatement","src":"28386:93:7"},{"nodeType":"YulAssignment","src":"28488:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28499:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"28504:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28495:3:7"},"nodeType":"YulFunctionCall","src":"28495:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"28488:3:7"}]}]},"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"28281:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"28289:3:7","type":""}],"src":"28147:366:7"},{"body":{"nodeType":"YulBlock","src":"28690:248:7","statements":[{"nodeType":"YulAssignment","src":"28700:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"28712:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"28723:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28708:3:7"},"nodeType":"YulFunctionCall","src":"28708:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"28700:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"28747:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"28758:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28743:3:7"},"nodeType":"YulFunctionCall","src":"28743:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"28766:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"28772:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"28762:3:7"},"nodeType":"YulFunctionCall","src":"28762:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28736:6:7"},"nodeType":"YulFunctionCall","src":"28736:47:7"},"nodeType":"YulExpressionStatement","src":"28736:47:7"},{"nodeType":"YulAssignment","src":"28792:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"28926:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"28800:124:7"},"nodeType":"YulFunctionCall","src":"28800:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"28792:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"28670:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"28685:4:7","type":""}],"src":"28519:419:7"},{"body":{"nodeType":"YulBlock","src":"28972:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28989:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28992:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28982:6:7"},"nodeType":"YulFunctionCall","src":"28982:88:7"},"nodeType":"YulExpressionStatement","src":"28982:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29086:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"29089:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29079:6:7"},"nodeType":"YulFunctionCall","src":"29079:15:7"},"nodeType":"YulExpressionStatement","src":"29079:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29110:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29113:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"29103:6:7"},"nodeType":"YulFunctionCall","src":"29103:15:7"},"nodeType":"YulExpressionStatement","src":"29103:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"28944:180:7"},{"body":{"nodeType":"YulBlock","src":"29158:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29175:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29178:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29168:6:7"},"nodeType":"YulFunctionCall","src":"29168:88:7"},"nodeType":"YulExpressionStatement","src":"29168:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29272:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"29275:4:7","type":"","value":"0x11"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29265:6:7"},"nodeType":"YulFunctionCall","src":"29265:15:7"},"nodeType":"YulExpressionStatement","src":"29265:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29296:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29299:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"29289:6:7"},"nodeType":"YulFunctionCall","src":"29289:15:7"},"nodeType":"YulExpressionStatement","src":"29289:15:7"}]},"name":"panic_error_0x11","nodeType":"YulFunctionDefinition","src":"29130:180:7"},{"body":{"nodeType":"YulBlock","src":"29359:190:7","statements":[{"nodeType":"YulAssignment","src":"29369:33:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29396:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"29378:17:7"},"nodeType":"YulFunctionCall","src":"29378:24:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"29369:5:7"}]},{"body":{"nodeType":"YulBlock","src":"29492:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"29494:16:7"},"nodeType":"YulFunctionCall","src":"29494:18:7"},"nodeType":"YulExpressionStatement","src":"29494:18:7"}]},"condition":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29417:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"29424:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"29414:2:7"},"nodeType":"YulFunctionCall","src":"29414:77:7"},"nodeType":"YulIf","src":"29411:103:7"},{"nodeType":"YulAssignment","src":"29523:20:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29534:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"29541:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29530:3:7"},"nodeType":"YulFunctionCall","src":"29530:13:7"},"variableNames":[{"name":"ret","nodeType":"YulIdentifier","src":"29523:3:7"}]}]},"name":"increment_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"29345:5:7","type":""}],"returnVariables":[{"name":"ret","nodeType":"YulTypedName","src":"29355:3:7","type":""}],"src":"29316:233:7"},{"body":{"nodeType":"YulBlock","src":"29661:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"29683:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"29691:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29679:3:7"},"nodeType":"YulFunctionCall","src":"29679:14:7"},{"hexValue":"496e76616c6964207820636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"29695:22:7","type":"","value":"Invalid x coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29672:6:7"},"nodeType":"YulFunctionCall","src":"29672:46:7"},"nodeType":"YulExpressionStatement","src":"29672:46:7"}]},"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"29653:6:7","type":""}],"src":"29555:170:7"},{"body":{"nodeType":"YulBlock","src":"29877:220:7","statements":[{"nodeType":"YulAssignment","src":"29887:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29953:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"29958:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"29894:58:7"},"nodeType":"YulFunctionCall","src":"29894:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"29887:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30059:3:7"}],"functionName":{"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulIdentifier","src":"29970:88:7"},"nodeType":"YulFunctionCall","src":"29970:93:7"},"nodeType":"YulExpressionStatement","src":"29970:93:7"},{"nodeType":"YulAssignment","src":"30072:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30083:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30088:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30079:3:7"},"nodeType":"YulFunctionCall","src":"30079:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"30072:3:7"}]}]},"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"29865:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"29873:3:7","type":""}],"src":"29731:366:7"},{"body":{"nodeType":"YulBlock","src":"30274:248:7","statements":[{"nodeType":"YulAssignment","src":"30284:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30296:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30307:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30292:3:7"},"nodeType":"YulFunctionCall","src":"30292:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30284:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30331:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30342:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30327:3:7"},"nodeType":"YulFunctionCall","src":"30327:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30350:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"30356:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"30346:3:7"},"nodeType":"YulFunctionCall","src":"30346:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30320:6:7"},"nodeType":"YulFunctionCall","src":"30320:47:7"},"nodeType":"YulExpressionStatement","src":"30320:47:7"},{"nodeType":"YulAssignment","src":"30376:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30510:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30384:124:7"},"nodeType":"YulFunctionCall","src":"30384:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30376:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"30254:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"30269:4:7","type":""}],"src":"30103:419:7"},{"body":{"nodeType":"YulBlock","src":"30634:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"30656:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"30664:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30652:3:7"},"nodeType":"YulFunctionCall","src":"30652:14:7"},{"hexValue":"496e76616c6964207920636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"30668:22:7","type":"","value":"Invalid y coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30645:6:7"},"nodeType":"YulFunctionCall","src":"30645:46:7"},"nodeType":"YulExpressionStatement","src":"30645:46:7"}]},"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"30626:6:7","type":""}],"src":"30528:170:7"},{"body":{"nodeType":"YulBlock","src":"30850:220:7","statements":[{"nodeType":"YulAssignment","src":"30860:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30926:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30931:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30867:58:7"},"nodeType":"YulFunctionCall","src":"30867:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"30860:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31032:3:7"}],"functionName":{"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulIdentifier","src":"30943:88:7"},"nodeType":"YulFunctionCall","src":"30943:93:7"},"nodeType":"YulExpressionStatement","src":"30943:93:7"},{"nodeType":"YulAssignment","src":"31045:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31056:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31061:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31052:3:7"},"nodeType":"YulFunctionCall","src":"31052:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"31045:3:7"}]}]},"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"30838:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"30846:3:7","type":""}],"src":"30704:366:7"},{"body":{"nodeType":"YulBlock","src":"31247:248:7","statements":[{"nodeType":"YulAssignment","src":"31257:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31269:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31280:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31265:3:7"},"nodeType":"YulFunctionCall","src":"31265:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31257:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31304:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31315:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31300:3:7"},"nodeType":"YulFunctionCall","src":"31300:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31323:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"31329:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"31319:3:7"},"nodeType":"YulFunctionCall","src":"31319:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31293:6:7"},"nodeType":"YulFunctionCall","src":"31293:47:7"},"nodeType":"YulExpressionStatement","src":"31293:47:7"},{"nodeType":"YulAssignment","src":"31349:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31483:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31357:124:7"},"nodeType":"YulFunctionCall","src":"31357:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31349:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"31227:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"31242:4:7","type":""}],"src":"31076:419:7"},{"body":{"nodeType":"YulBlock","src":"31607:71:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"31629:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"31637:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31625:3:7"},"nodeType":"YulFunctionCall","src":"31625:14:7"},{"hexValue":"4e6f7420746865206f776e6572206f662074686973206c61796572","kind":"string","nodeType":"YulLiteral","src":"31641:29:7","type":"","value":"Not the owner of this layer"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31618:6:7"},"nodeType":"YulFunctionCall","src":"31618:53:7"},"nodeType":"YulExpressionStatement","src":"31618:53:7"}]},"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"31599:6:7","type":""}],"src":"31501:177:7"},{"body":{"nodeType":"YulBlock","src":"31830:220:7","statements":[{"nodeType":"YulAssignment","src":"31840:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31906:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31911:2:7","type":"","value":"27"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31847:58:7"},"nodeType":"YulFunctionCall","src":"31847:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"31840:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32012:3:7"}],"functionName":{"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulIdentifier","src":"31923:88:7"},"nodeType":"YulFunctionCall","src":"31923:93:7"},"nodeType":"YulExpressionStatement","src":"31923:93:7"},{"nodeType":"YulAssignment","src":"32025:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32036:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32041:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32032:3:7"},"nodeType":"YulFunctionCall","src":"32032:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"32025:3:7"}]}]},"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"31818:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"31826:3:7","type":""}],"src":"31684:366:7"},{"body":{"nodeType":"YulBlock","src":"32227:248:7","statements":[{"nodeType":"YulAssignment","src":"32237:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32249:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32260:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32245:3:7"},"nodeType":"YulFunctionCall","src":"32245:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32237:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32284:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32295:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32280:3:7"},"nodeType":"YulFunctionCall","src":"32280:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32303:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"32309:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"32299:3:7"},"nodeType":"YulFunctionCall","src":"32299:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32273:6:7"},"nodeType":"YulFunctionCall","src":"32273:47:7"},"nodeType":"YulExpressionStatement","src":"32273:47:7"},{"nodeType":"YulAssignment","src":"32329:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32463:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32337:124:7"},"nodeType":"YulFunctionCall","src":"32337:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32329:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"32207:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"32222:4:7","type":""}],"src":"32056:419:7"},{"body":{"nodeType":"YulBlock","src":"32587:118:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"32609:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"32617:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32605:3:7"},"nodeType":"YulFunctionCall","src":"32605:14:7"},{"hexValue":"4f6e6c7920746865206f776e65722063616e2063616c6c20746869732066756e","kind":"string","nodeType":"YulLiteral","src":"32621:34:7","type":"","value":"Only the owner can call this fun"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32598:6:7"},"nodeType":"YulFunctionCall","src":"32598:58:7"},"nodeType":"YulExpressionStatement","src":"32598:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"32677:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"32685:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32673:3:7"},"nodeType":"YulFunctionCall","src":"32673:15:7"},{"hexValue":"6374696f6e","kind":"string","nodeType":"YulLiteral","src":"32690:7:7","type":"","value":"ction"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32666:6:7"},"nodeType":"YulFunctionCall","src":"32666:32:7"},"nodeType":"YulExpressionStatement","src":"32666:32:7"}]},"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"32579:6:7","type":""}],"src":"32481:224:7"},{"body":{"nodeType":"YulBlock","src":"32857:220:7","statements":[{"nodeType":"YulAssignment","src":"32867:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32933:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32938:2:7","type":"","value":"37"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32874:58:7"},"nodeType":"YulFunctionCall","src":"32874:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"32867:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33039:3:7"}],"functionName":{"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulIdentifier","src":"32950:88:7"},"nodeType":"YulFunctionCall","src":"32950:93:7"},"nodeType":"YulExpressionStatement","src":"32950:93:7"},{"nodeType":"YulAssignment","src":"33052:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33063:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"33068:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33059:3:7"},"nodeType":"YulFunctionCall","src":"33059:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"33052:3:7"}]}]},"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"32845:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"32853:3:7","type":""}],"src":"32711:366:7"},{"body":{"nodeType":"YulBlock","src":"33254:248:7","statements":[{"nodeType":"YulAssignment","src":"33264:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33276:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33287:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33272:3:7"},"nodeType":"YulFunctionCall","src":"33272:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33264:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33311:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33322:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33307:3:7"},"nodeType":"YulFunctionCall","src":"33307:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33330:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"33336:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"33326:3:7"},"nodeType":"YulFunctionCall","src":"33326:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33300:6:7"},"nodeType":"YulFunctionCall","src":"33300:47:7"},"nodeType":"YulExpressionStatement","src":"33300:47:7"},{"nodeType":"YulAssignment","src":"33356:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33490:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"33364:124:7"},"nodeType":"YulFunctionCall","src":"33364:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33356:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"33234:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"33249:4:7","type":""}],"src":"33083:419:7"},{"body":{"nodeType":"YulBlock","src":"33614:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"33636:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"33644:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33632:3:7"},"nodeType":"YulFunctionCall","src":"33632:14:7"},{"hexValue":"4e6f2066756e647320746f207769746864726177","kind":"string","nodeType":"YulLiteral","src":"33648:22:7","type":"","value":"No funds to withdraw"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33625:6:7"},"nodeType":"YulFunctionCall","src":"33625:46:7"},"nodeType":"YulExpressionStatement","src":"33625:46:7"}]},"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"33606:6:7","type":""}],"src":"33508:170:7"},{"body":{"nodeType":"YulBlock","src":"33830:220:7","statements":[{"nodeType":"YulAssignment","src":"33840:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33906:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"33911:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"33847:58:7"},"nodeType":"YulFunctionCall","src":"33847:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"33840:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"34012:3:7"}],"functionName":{"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulIdentifier","src":"33923:88:7"},"nodeType":"YulFunctionCall","src":"33923:93:7"},"nodeType":"YulExpressionStatement","src":"33923:93:7"},{"nodeType":"YulAssignment","src":"34025:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"34036:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"34041:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34032:3:7"},"nodeType":"YulFunctionCall","src":"34032:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"34025:3:7"}]}]},"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"33818:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"33826:3:7","type":""}],"src":"33684:366:7"},{"body":{"nodeType":"YulBlock","src":"34227:248:7","statements":[{"nodeType":"YulAssignment","src":"34237:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"34249:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"34260:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34245:3:7"},"nodeType":"YulFunctionCall","src":"34245:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"34237:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"34284:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"34295:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34280:3:7"},"nodeType":"YulFunctionCall","src":"34280:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"34303:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"34309:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"34299:3:7"},"nodeType":"YulFunctionCall","src":"34299:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34273:6:7"},"nodeType":"YulFunctionCall","src":"34273:47:7"},"nodeType":"YulExpressionStatement","src":"34273:47:7"},{"nodeType":"YulAssignment","src":"34329:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"34463:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"34337:124:7"},"nodeType":"YulFunctionCall","src":"34337:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"34329:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"34207:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"34222:4:7","type":""}],"src":"34056:419:7"},{"body":{"nodeType":"YulBlock","src":"34509:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34526:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"34529:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34519:6:7"},"nodeType":"YulFunctionCall","src":"34519:88:7"},"nodeType":"YulExpressionStatement","src":"34519:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34623:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"34626:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34616:6:7"},"nodeType":"YulFunctionCall","src":"34616:15:7"},"nodeType":"YulExpressionStatement","src":"34616:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34647:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"34650:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"34640:6:7"},"nodeType":"YulFunctionCall","src":"34640:15:7"},"nodeType":"YulExpressionStatement","src":"34640:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"34481:180:7"},{"body":{"nodeType":"YulBlock","src":"34718:269:7","statements":[{"nodeType":"YulAssignment","src":"34728:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"34742:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"34748:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"34738:3:7"},"nodeType":"YulFunctionCall","src":"34738:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"34728:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"34759:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"34789:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"34795:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"34785:3:7"},"nodeType":"YulFunctionCall","src":"34785:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"34763:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"34836:51:7","statements":[{"nodeType":"YulAssignment","src":"34850:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"34864:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"34872:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"34860:3:7"},"nodeType":"YulFunctionCall","src":"34860:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"34850:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"34816:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"34809:6:7"},"nodeType":"YulFunctionCall","src":"34809:26:7"},"nodeType":"YulIf","src":"34806:81:7"},{"body":{"nodeType":"YulBlock","src":"34939:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"34953:16:7"},"nodeType":"YulFunctionCall","src":"34953:18:7"},"nodeType":"YulExpressionStatement","src":"34953:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"34903:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"34926:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"34934:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"34923:2:7"},"nodeType":"YulFunctionCall","src":"34923:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"34900:2:7"},"nodeType":"YulFunctionCall","src":"34900:38:7"},"nodeType":"YulIf","src":"34897:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"34702:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"34711:6:7","type":""}],"src":"34667:320:7"},{"body":{"nodeType":"YulBlock","src":"35056:80:7","statements":[{"nodeType":"YulAssignment","src":"35066:22:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"35081:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"35075:5:7"},"nodeType":"YulFunctionCall","src":"35075:13:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"35066:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"35124:5:7"}],"functionName":{"name":"validator_revert_t_uint256","nodeType":"YulIdentifier","src":"35097:26:7"},"nodeType":"YulFunctionCall","src":"35097:33:7"},"nodeType":"YulExpressionStatement","src":"35097:33:7"}]},"name":"abi_decode_t_uint256_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"35034:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"35042:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"35050:5:7","type":""}],"src":"34993:143:7"},{"body":{"nodeType":"YulBlock","src":"35219:274:7","statements":[{"body":{"nodeType":"YulBlock","src":"35265:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"35267:77:7"},"nodeType":"YulFunctionCall","src":"35267:79:7"},"nodeType":"YulExpressionStatement","src":"35267:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"35240:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"35249:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"35236:3:7"},"nodeType":"YulFunctionCall","src":"35236:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"35261:2:7","type":"","value":"32"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"35232:3:7"},"nodeType":"YulFunctionCall","src":"35232:32:7"},"nodeType":"YulIf","src":"35229:119:7"},{"nodeType":"YulBlock","src":"35358:128:7","statements":[{"nodeType":"YulVariableDeclaration","src":"35373:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"35387:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"35377:6:7","type":""}]},{"nodeType":"YulAssignment","src":"35402:74:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"35448:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"35459:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35444:3:7"},"nodeType":"YulFunctionCall","src":"35444:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"35468:7:7"}],"functionName":{"name":"abi_decode_t_uint256_fromMemory","nodeType":"YulIdentifier","src":"35412:31:7"},"nodeType":"YulFunctionCall","src":"35412:64:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"35402:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"35189:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"35200:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"35212:6:7","type":""}],"src":"35142:351:7"},{"body":{"nodeType":"YulBlock","src":"35605:114:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35627:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35635:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35623:3:7"},"nodeType":"YulFunctionCall","src":"35623:14:7"},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e20537461676520","kind":"string","nodeType":"YulLiteral","src":"35639:34:7","type":"","value":"Not enough total value in Stage "}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35616:6:7"},"nodeType":"YulFunctionCall","src":"35616:58:7"},"nodeType":"YulExpressionStatement","src":"35616:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35695:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35703:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35691:3:7"},"nodeType":"YulFunctionCall","src":"35691:15:7"},{"hexValue":"31","kind":"string","nodeType":"YulLiteral","src":"35708:3:7","type":"","value":"1"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35684:6:7"},"nodeType":"YulFunctionCall","src":"35684:28:7"},"nodeType":"YulExpressionStatement","src":"35684:28:7"}]},"name":"store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"35597:6:7","type":""}],"src":"35499:220:7"},{"body":{"nodeType":"YulBlock","src":"35871:220:7","statements":[{"nodeType":"YulAssignment","src":"35881:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"35947:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"35952:2:7","type":"","value":"33"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"35888:58:7"},"nodeType":"YulFunctionCall","src":"35888:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"35881:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36053:3:7"}],"functionName":{"name":"store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","nodeType":"YulIdentifier","src":"35964:88:7"},"nodeType":"YulFunctionCall","src":"35964:93:7"},"nodeType":"YulExpressionStatement","src":"35964:93:7"},{"nodeType":"YulAssignment","src":"36066:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36077:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"36082:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36073:3:7"},"nodeType":"YulFunctionCall","src":"36073:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"36066:3:7"}]}]},"name":"abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"35859:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"35867:3:7","type":""}],"src":"35725:366:7"},{"body":{"nodeType":"YulBlock","src":"36268:248:7","statements":[{"nodeType":"YulAssignment","src":"36278:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"36290:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"36301:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36286:3:7"},"nodeType":"YulFunctionCall","src":"36286:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"36278:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"36325:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"36336:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36321:3:7"},"nodeType":"YulFunctionCall","src":"36321:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"36344:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"36350:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"36340:3:7"},"nodeType":"YulFunctionCall","src":"36340:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36314:6:7"},"nodeType":"YulFunctionCall","src":"36314:47:7"},"nodeType":"YulExpressionStatement","src":"36314:47:7"},{"nodeType":"YulAssignment","src":"36370:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"36504:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"36378:124:7"},"nodeType":"YulFunctionCall","src":"36378:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"36370:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"36248:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"36263:4:7","type":""}],"src":"36097:419:7"},{"body":{"nodeType":"YulBlock","src":"36567:146:7","statements":[{"nodeType":"YulAssignment","src":"36577:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36600:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36582:17:7"},"nodeType":"YulFunctionCall","src":"36582:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"36577:1:7"}]},{"nodeType":"YulAssignment","src":"36611:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"36634:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36616:17:7"},"nodeType":"YulFunctionCall","src":"36616:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"36611:1:7"}]},{"body":{"nodeType":"YulBlock","src":"36658:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"36660:16:7"},"nodeType":"YulFunctionCall","src":"36660:18:7"},"nodeType":"YulExpressionStatement","src":"36660:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36652:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"36655:1:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"36649:2:7"},"nodeType":"YulFunctionCall","src":"36649:8:7"},"nodeType":"YulIf","src":"36646:34:7"},{"nodeType":"YulAssignment","src":"36690:17:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36702:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"36705:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"36698:3:7"},"nodeType":"YulFunctionCall","src":"36698:9:7"},"variableNames":[{"name":"diff","nodeType":"YulIdentifier","src":"36690:4:7"}]}]},"name":"checked_sub_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"36553:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"36556:1:7","type":""}],"returnVariables":[{"name":"diff","nodeType":"YulTypedName","src":"36562:4:7","type":""}],"src":"36522:191:7"},{"body":{"nodeType":"YulBlock","src":"36767:300:7","statements":[{"nodeType":"YulAssignment","src":"36777:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36800:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36782:17:7"},"nodeType":"YulFunctionCall","src":"36782:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"36777:1:7"}]},{"nodeType":"YulAssignment","src":"36811:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"36834:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"36816:17:7"},"nodeType":"YulFunctionCall","src":"36816:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"36811:1:7"}]},{"body":{"nodeType":"YulBlock","src":"37009:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"37011:16:7"},"nodeType":"YulFunctionCall","src":"37011:18:7"},"nodeType":"YulExpressionStatement","src":"37011:18:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"36921:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"36914:6:7"},"nodeType":"YulFunctionCall","src":"36914:9:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"36907:6:7"},"nodeType":"YulFunctionCall","src":"36907:17:7"},{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"36929:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"36936:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"x","nodeType":"YulIdentifier","src":"37004:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"36932:3:7"},"nodeType":"YulFunctionCall","src":"36932:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"36926:2:7"},"nodeType":"YulFunctionCall","src":"36926:81:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"36903:3:7"},"nodeType":"YulFunctionCall","src":"36903:105:7"},"nodeType":"YulIf","src":"36900:131:7"},{"nodeType":"YulAssignment","src":"37041:20:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37056:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"37059:1:7"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"37052:3:7"},"nodeType":"YulFunctionCall","src":"37052:9:7"},"variableNames":[{"name":"product","nodeType":"YulIdentifier","src":"37041:7:7"}]}]},"name":"checked_mul_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"36750:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"36753:1:7","type":""}],"returnVariables":[{"name":"product","nodeType":"YulTypedName","src":"36759:7:7","type":""}],"src":"36719:348:7"},{"body":{"nodeType":"YulBlock","src":"37117:261:7","statements":[{"nodeType":"YulAssignment","src":"37127:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37150:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37132:17:7"},"nodeType":"YulFunctionCall","src":"37132:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"37127:1:7"}]},{"nodeType":"YulAssignment","src":"37161:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"37184:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37166:17:7"},"nodeType":"YulFunctionCall","src":"37166:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"37161:1:7"}]},{"body":{"nodeType":"YulBlock","src":"37324:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"37326:16:7"},"nodeType":"YulFunctionCall","src":"37326:18:7"},"nodeType":"YulExpressionStatement","src":"37326:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37245:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"37252:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"y","nodeType":"YulIdentifier","src":"37320:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"37248:3:7"},"nodeType":"YulFunctionCall","src":"37248:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"37242:2:7"},"nodeType":"YulFunctionCall","src":"37242:81:7"},"nodeType":"YulIf","src":"37239:107:7"},{"nodeType":"YulAssignment","src":"37356:16:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37367:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"37370:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37363:3:7"},"nodeType":"YulFunctionCall","src":"37363:9:7"},"variableNames":[{"name":"sum","nodeType":"YulIdentifier","src":"37356:3:7"}]}]},"name":"checked_add_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"37104:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"37107:1:7","type":""}],"returnVariables":[{"name":"sum","nodeType":"YulTypedName","src":"37113:3:7","type":""}],"src":"37073:305:7"},{"body":{"nodeType":"YulBlock","src":"37490:119:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"37512:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"37520:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37508:3:7"},"nodeType":"YulFunctionCall","src":"37508:14:7"},{"hexValue":"43616e6e6f7420627579206d6f7265207468616e203130206c61796572732061","kind":"string","nodeType":"YulLiteral","src":"37524:34:7","type":"","value":"Cannot buy more than 10 layers a"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"37501:6:7"},"nodeType":"YulFunctionCall","src":"37501:58:7"},"nodeType":"YulExpressionStatement","src":"37501:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"37580:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"37588:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37576:3:7"},"nodeType":"YulFunctionCall","src":"37576:15:7"},{"hexValue":"74206f6e6365","kind":"string","nodeType":"YulLiteral","src":"37593:8:7","type":"","value":"t once"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"37569:6:7"},"nodeType":"YulFunctionCall","src":"37569:33:7"},"nodeType":"YulExpressionStatement","src":"37569:33:7"}]},"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"37482:6:7","type":""}],"src":"37384:225:7"},{"body":{"nodeType":"YulBlock","src":"37761:220:7","statements":[{"nodeType":"YulAssignment","src":"37771:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"37837:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"37842:2:7","type":"","value":"38"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"37778:58:7"},"nodeType":"YulFunctionCall","src":"37778:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"37771:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"37943:3:7"}],"functionName":{"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulIdentifier","src":"37854:88:7"},"nodeType":"YulFunctionCall","src":"37854:93:7"},"nodeType":"YulExpressionStatement","src":"37854:93:7"},{"nodeType":"YulAssignment","src":"37956:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"37967:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"37972:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37963:3:7"},"nodeType":"YulFunctionCall","src":"37963:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"37956:3:7"}]}]},"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"37749:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"37757:3:7","type":""}],"src":"37615:366:7"},{"body":{"nodeType":"YulBlock","src":"38158:248:7","statements":[{"nodeType":"YulAssignment","src":"38168:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"38180:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"38191:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38176:3:7"},"nodeType":"YulFunctionCall","src":"38176:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"38168:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"38215:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"38226:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38211:3:7"},"nodeType":"YulFunctionCall","src":"38211:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"38234:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"38240:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"38230:3:7"},"nodeType":"YulFunctionCall","src":"38230:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38204:6:7"},"nodeType":"YulFunctionCall","src":"38204:47:7"},"nodeType":"YulExpressionStatement","src":"38204:47:7"},{"nodeType":"YulAssignment","src":"38260:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"38394:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"38268:124:7"},"nodeType":"YulFunctionCall","src":"38268:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"38260:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"38138:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"38153:4:7","type":""}],"src":"37987:419:7"},{"body":{"nodeType":"YulBlock","src":"38440:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"38457:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"38460:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38450:6:7"},"nodeType":"YulFunctionCall","src":"38450:88:7"},"nodeType":"YulExpressionStatement","src":"38450:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"38554:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"38557:4:7","type":"","value":"0x12"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38547:6:7"},"nodeType":"YulFunctionCall","src":"38547:15:7"},"nodeType":"YulExpressionStatement","src":"38547:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"38578:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"38581:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"38571:6:7"},"nodeType":"YulFunctionCall","src":"38571:15:7"},"nodeType":"YulExpressionStatement","src":"38571:15:7"}]},"name":"panic_error_0x12","nodeType":"YulFunctionDefinition","src":"38412:180:7"},{"body":{"nodeType":"YulBlock","src":"38640:143:7","statements":[{"nodeType":"YulAssignment","src":"38650:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38673:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"38655:17:7"},"nodeType":"YulFunctionCall","src":"38655:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"38650:1:7"}]},{"nodeType":"YulAssignment","src":"38684:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"38707:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"38689:17:7"},"nodeType":"YulFunctionCall","src":"38689:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"38684:1:7"}]},{"body":{"nodeType":"YulBlock","src":"38731:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x12","nodeType":"YulIdentifier","src":"38733:16:7"},"nodeType":"YulFunctionCall","src":"38733:18:7"},"nodeType":"YulExpressionStatement","src":"38733:18:7"}]},"condition":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"38728:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"38721:6:7"},"nodeType":"YulFunctionCall","src":"38721:9:7"},"nodeType":"YulIf","src":"38718:35:7"},{"nodeType":"YulAssignment","src":"38763:14:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38772:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"38775:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"38768:3:7"},"nodeType":"YulFunctionCall","src":"38768:9:7"},"variableNames":[{"name":"r","nodeType":"YulIdentifier","src":"38763:1:7"}]}]},"name":"checked_div_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"38629:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"38632:1:7","type":""}],"returnVariables":[{"name":"r","nodeType":"YulTypedName","src":"38638:1:7","type":""}],"src":"38598:185:7"},{"body":{"nodeType":"YulBlock","src":"38895:62:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"38917:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"38925:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38913:3:7"},"nodeType":"YulFunctionCall","src":"38913:14:7"},{"hexValue":"496e636f727265637420504f4c2073656e74","kind":"string","nodeType":"YulLiteral","src":"38929:20:7","type":"","value":"Incorrect POL sent"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38906:6:7"},"nodeType":"YulFunctionCall","src":"38906:44:7"},"nodeType":"YulExpressionStatement","src":"38906:44:7"}]},"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"38887:6:7","type":""}],"src":"38789:168:7"},{"body":{"nodeType":"YulBlock","src":"39109:220:7","statements":[{"nodeType":"YulAssignment","src":"39119:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39185:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"39190:2:7","type":"","value":"18"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"39126:58:7"},"nodeType":"YulFunctionCall","src":"39126:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"39119:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39291:3:7"}],"functionName":{"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulIdentifier","src":"39202:88:7"},"nodeType":"YulFunctionCall","src":"39202:93:7"},"nodeType":"YulExpressionStatement","src":"39202:93:7"},{"nodeType":"YulAssignment","src":"39304:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"39315:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"39320:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39311:3:7"},"nodeType":"YulFunctionCall","src":"39311:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"39304:3:7"}]}]},"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"39097:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"39105:3:7","type":""}],"src":"38963:366:7"},{"body":{"nodeType":"YulBlock","src":"39506:248:7","statements":[{"nodeType":"YulAssignment","src":"39516:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39528:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39539:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39524:3:7"},"nodeType":"YulFunctionCall","src":"39524:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39516:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39563:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39574:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39559:3:7"},"nodeType":"YulFunctionCall","src":"39559:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39582:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"39588:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"39578:3:7"},"nodeType":"YulFunctionCall","src":"39578:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39552:6:7"},"nodeType":"YulFunctionCall","src":"39552:47:7"},"nodeType":"YulExpressionStatement","src":"39552:47:7"},{"nodeType":"YulAssignment","src":"39608:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39742:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"39616:124:7"},"nodeType":"YulFunctionCall","src":"39616:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39608:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"39486:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"39501:4:7","type":""}],"src":"39335:419:7"},{"body":{"nodeType":"YulBlock","src":"39962:442:7","statements":[{"nodeType":"YulAssignment","src":"39972:27:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39984:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39995:3:7","type":"","value":"128"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39980:3:7"},"nodeType":"YulFunctionCall","src":"39980:19:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39972:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"40053:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40066:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40077:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40062:3:7"},"nodeType":"YulFunctionCall","src":"40062:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"40009:43:7"},"nodeType":"YulFunctionCall","src":"40009:71:7"},"nodeType":"YulExpressionStatement","src":"40009:71:7"},{"expression":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"40134:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40147:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40158:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40143:3:7"},"nodeType":"YulFunctionCall","src":"40143:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"40090:43:7"},"nodeType":"YulFunctionCall","src":"40090:72:7"},"nodeType":"YulExpressionStatement","src":"40090:72:7"},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"40216:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40229:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40240:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40225:3:7"},"nodeType":"YulFunctionCall","src":"40225:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"40172:43:7"},"nodeType":"YulFunctionCall","src":"40172:72:7"},"nodeType":"YulExpressionStatement","src":"40172:72:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40265:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40276:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40261:3:7"},"nodeType":"YulFunctionCall","src":"40261:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"40285:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"40291:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"40281:3:7"},"nodeType":"YulFunctionCall","src":"40281:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"40254:6:7"},"nodeType":"YulFunctionCall","src":"40254:48:7"},"nodeType":"YulExpressionStatement","src":"40254:48:7"},{"nodeType":"YulAssignment","src":"40311:86:7","value":{"arguments":[{"name":"value3","nodeType":"YulIdentifier","src":"40383:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"40392:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"40319:63:7"},"nodeType":"YulFunctionCall","src":"40319:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"40311:4:7"}]}]},"name":"abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"39910:9:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"39922:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"39930:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"39938:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"39946:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"39957:4:7","type":""}],"src":"39760:644:7"},{"body":{"nodeType":"YulBlock","src":"40516:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"40538:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"40546:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40534:3:7"},"nodeType":"YulFunctionCall","src":"40534:14:7"},{"hexValue":"496e76616c696420782d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"40550:22:7","type":"","value":"Invalid x-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"40527:6:7"},"nodeType":"YulFunctionCall","src":"40527:46:7"},"nodeType":"YulExpressionStatement","src":"40527:46:7"}]},"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"40508:6:7","type":""}],"src":"40410:170:7"},{"body":{"nodeType":"YulBlock","src":"40732:220:7","statements":[{"nodeType":"YulAssignment","src":"40742:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40808:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"40813:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"40749:58:7"},"nodeType":"YulFunctionCall","src":"40749:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"40742:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40914:3:7"}],"functionName":{"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulIdentifier","src":"40825:88:7"},"nodeType":"YulFunctionCall","src":"40825:93:7"},"nodeType":"YulExpressionStatement","src":"40825:93:7"},{"nodeType":"YulAssignment","src":"40927:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40938:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"40943:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40934:3:7"},"nodeType":"YulFunctionCall","src":"40934:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"40927:3:7"}]}]},"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"40720:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"40728:3:7","type":""}],"src":"40586:366:7"},{"body":{"nodeType":"YulBlock","src":"41129:248:7","statements":[{"nodeType":"YulAssignment","src":"41139:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41151:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41162:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41147:3:7"},"nodeType":"YulFunctionCall","src":"41147:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"41139:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41186:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41197:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41182:3:7"},"nodeType":"YulFunctionCall","src":"41182:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"41205:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"41211:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"41201:3:7"},"nodeType":"YulFunctionCall","src":"41201:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"41175:6:7"},"nodeType":"YulFunctionCall","src":"41175:47:7"},"nodeType":"YulExpressionStatement","src":"41175:47:7"},{"nodeType":"YulAssignment","src":"41231:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"41365:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"41239:124:7"},"nodeType":"YulFunctionCall","src":"41239:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"41231:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"41109:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"41124:4:7","type":""}],"src":"40958:419:7"},{"body":{"nodeType":"YulBlock","src":"41489:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"41511:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"41519:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41507:3:7"},"nodeType":"YulFunctionCall","src":"41507:14:7"},{"hexValue":"496e76616c696420792d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"41523:22:7","type":"","value":"Invalid y-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"41500:6:7"},"nodeType":"YulFunctionCall","src":"41500:46:7"},"nodeType":"YulExpressionStatement","src":"41500:46:7"}]},"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"41481:6:7","type":""}],"src":"41383:170:7"},{"body":{"nodeType":"YulBlock","src":"41705:220:7","statements":[{"nodeType":"YulAssignment","src":"41715:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41781:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"41786:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"41722:58:7"},"nodeType":"YulFunctionCall","src":"41722:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"41715:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41887:3:7"}],"functionName":{"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulIdentifier","src":"41798:88:7"},"nodeType":"YulFunctionCall","src":"41798:93:7"},"nodeType":"YulExpressionStatement","src":"41798:93:7"},{"nodeType":"YulAssignment","src":"41900:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41911:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"41916:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41907:3:7"},"nodeType":"YulFunctionCall","src":"41907:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"41900:3:7"}]}]},"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"41693:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"41701:3:7","type":""}],"src":"41559:366:7"},{"body":{"nodeType":"YulBlock","src":"42102:248:7","statements":[{"nodeType":"YulAssignment","src":"42112:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"42124:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"42135:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42120:3:7"},"nodeType":"YulFunctionCall","src":"42120:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"42112:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"42159:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"42170:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42155:3:7"},"nodeType":"YulFunctionCall","src":"42155:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"42178:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"42184:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"42174:3:7"},"nodeType":"YulFunctionCall","src":"42174:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"42148:6:7"},"nodeType":"YulFunctionCall","src":"42148:47:7"},"nodeType":"YulExpressionStatement","src":"42148:47:7"},{"nodeType":"YulAssignment","src":"42204:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"42338:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"42212:124:7"},"nodeType":"YulFunctionCall","src":"42212:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"42204:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"42082:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"42097:4:7","type":""}],"src":"41931:419:7"}]},"contents":"{\\n\\n    function array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_address_payable_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function cleanup_t_uint160(value) -> cleaned {\\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\\n    }\\n\\n    function cleanup_t_address_payable(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(value0, pos) -> updatedPos {\\n        abi_encode_t_address_payable_to_t_address_payable(value0, pos)\\n        updatedPos := add(pos, 0x20)\\n    }\\n\\n    function array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[] -> address payable[]\\n    function abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length)\\n        let baseRef := array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            let elementValue0 := mload(srcPtr)\\n            pos := abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(elementValue0, pos)\\n            srcPtr := array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(srcPtr)\\n        }\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[][] -> address payable[][]\\n    function abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_string_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function copy_memory_to_memory(src, dst, length) {\\n        let i := 0\\n        for { } lt(i, length) { i := add(i, 32) }\\n        {\\n            mstore(add(dst, i), mload(add(src, i)))\\n        }\\n        if gt(i, length)\\n        {\\n            // clear end\\n            mstore(add(dst, length), 0)\\n        }\\n    }\\n\\n    function round_up_to_mul_of_32(value) -> result {\\n        result := and(add(value, 31), not(31))\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[] -> string[]\\n    function abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[][] -> string[][]\\n    function abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function allocate_unbounded() -> memPtr {\\n        memPtr := mload(64)\\n    }\\n\\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\\n        revert(0, 0)\\n    }\\n\\n    function cleanup_t_uint256(value) -> cleaned {\\n        cleaned := value\\n    }\\n\\n    function validator_revert_t_uint256(value) {\\n        if iszero(eq(value, cleanup_t_uint256(value))) { revert(0, 0) }\\n    }\\n\\n    function abi_decode_t_uint256(offset, end) -> value {\\n        value := calldataload(offset)\\n        validator_revert_t_uint256(value)\\n    }\\n\\n    function revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() {\\n        revert(0, 0)\\n    }\\n\\n    function panic_error_0x41() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x41)\\n        revert(0, 0x24)\\n    }\\n\\n    function finalize_allocation(memPtr, size) {\\n        let newFreePtr := add(memPtr, round_up_to_mul_of_32(size))\\n        // protect against overflow\\n        if or(gt(newFreePtr, 0xffffffffffffffff), lt(newFreePtr, memPtr)) { panic_error_0x41() }\\n        mstore(64, newFreePtr)\\n    }\\n\\n    function allocate_memory(size) -> memPtr {\\n        memPtr := allocate_unbounded()\\n        finalize_allocation(memPtr, size)\\n    }\\n\\n    function array_allocation_size_t_string_memory_ptr(length) -> size {\\n        // Make sure we can allocate memory without overflow\\n        if gt(length, 0xffffffffffffffff) { panic_error_0x41() }\\n\\n        size := round_up_to_mul_of_32(length)\\n\\n        // add length slot\\n        size := add(size, 0x20)\\n\\n    }\\n\\n    function copy_calldata_to_memory(src, dst, length) {\\n        calldatacopy(dst, src, length)\\n        // clear end\\n        mstore(add(dst, length), 0)\\n    }\\n\\n    function abi_decode_available_length_t_string_memory_ptr(src, length, end) -> array {\\n        array := allocate_memory(array_allocation_size_t_string_memory_ptr(length))\\n        mstore(array, length)\\n        let dst := add(array, 0x20)\\n        if gt(add(src, length), end) { revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() }\\n        copy_calldata_to_memory(src, dst, length)\\n    }\\n\\n    // string\\n    function abi_decode_t_string_memory_ptr(offset, end) -> array {\\n        if iszero(slt(add(offset, 0x1f), end)) { revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() }\\n        let length := calldataload(offset)\\n        array := abi_decode_available_length_t_string_memory_ptr(add(offset, 0x20), length, end)\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2 {\\n        if slt(sub(dataEnd, headStart), 96) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 64))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value2 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1 {\\n        if slt(sub(dataEnd, headStart), 64) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3 {\\n        if slt(sub(dataEnd, headStart), 128) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 64\\n\\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 96))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value3 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    // struct BaseContract.Layer -> struct BaseContract.Layer\\n    function abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // owner\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_address_payable_to_t_address_payable(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // color\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Layer[] -> struct BaseContract.Layer[]\\n    function abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    // struct BaseContract.Cell -> struct BaseContract.Cell\\n    function abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // baseValue\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // layers\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[] -> struct BaseContract.Cell[]\\n    function abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[][] -> struct BaseContract.Cell[][]\\n    function abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function identity(value) -> ret {\\n        ret := value\\n    }\\n\\n    function convert_t_uint160_to_t_uint160(value) -> converted {\\n        converted := cleanup_t_uint160(identity(cleanup_t_uint160(value)))\\n    }\\n\\n    function convert_t_uint160_to_t_address(value) -> converted {\\n        converted := convert_t_uint160_to_t_uint160(value)\\n    }\\n\\n    function convert_t_contract$_BaseContract_$1001_to_t_address(value) -> converted {\\n        converted := convert_t_uint160_to_t_address(value)\\n    }\\n\\n    function abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack(value, pos) {\\n        mstore(pos, convert_t_contract$_BaseContract_$1001_to_t_address(value))\\n    }\\n\\n    function abi_encode_tuple_t_contract$_BaseContract_$1001__to_t_address__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function cleanup_t_bool(value) -> cleaned {\\n        cleaned := iszero(iszero(value))\\n    }\\n\\n    function abi_encode_t_bool_to_t_bool_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_bool(value))\\n    }\\n\\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_bool_to_t_bool_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        abi_encode_t_address_payable_to_t_address_payable_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function cleanup_t_address(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address(value))\\n    }\\n\\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed(headStart , value2, value1, value0) -> tail {\\n        tail := add(headStart, 96)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n    }\\n\\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Contract is not enabled\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 23)\\n        store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x11() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x11)\\n        revert(0, 0x24)\\n    }\\n\\n    function increment_t_uint256(value) -> ret {\\n        value := cleanup_t_uint256(value)\\n        if eq(value, 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff) { panic_error_0x11() }\\n        ret := add(value, 1)\\n    }\\n\\n    function store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not the owner of this layer\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 27)\\n        store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Only the owner can call this fun\\")\\n\\n        mstore(add(memPtr, 32), \\"ction\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 37)\\n        store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"No funds to withdraw\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n    function abi_decode_t_uint256_fromMemory(offset, end) -> value {\\n        value := mload(offset)\\n        validator_revert_t_uint256(value)\\n    }\\n\\n    function abi_decode_tuple_t_uint256_fromMemory(headStart, dataEnd) -> value0 {\\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256_fromMemory(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not enough total value in Stage \\")\\n\\n        mstore(add(memPtr, 32), \\"1\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 33)\\n        store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function checked_sub_t_uint256(x, y) -> diff {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        if lt(x, y) { panic_error_0x11() }\\n\\n        diff := sub(x, y)\\n    }\\n\\n    function checked_mul_t_uint256(x, y) -> product {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x != 0 and y > (maxValue / x)\\n        if and(iszero(iszero(x)), gt(y, div(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, x))) { panic_error_0x11() }\\n\\n        product := mul(x, y)\\n    }\\n\\n    function checked_add_t_uint256(x, y) -> sum {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x > (maxValue - y)\\n        if gt(x, sub(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, y)) { panic_error_0x11() }\\n\\n        sum := add(x, y)\\n    }\\n\\n    function store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Cannot buy more than 10 layers a\\")\\n\\n        mstore(add(memPtr, 32), \\"t once\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 38)\\n        store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x12() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x12)\\n        revert(0, 0x24)\\n    }\\n\\n    function checked_div_t_uint256(x, y) -> r {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n        if iszero(y) { panic_error_0x12() }\\n\\n        r := div(x, y)\\n    }\\n\\n    function store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Incorrect POL sent\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 18)\\n        store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed(headStart , value3, value2, value1, value0) -> tail {\\n        tail := add(headStart, 128)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value1,  add(headStart, 32))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n        mstore(add(headStart, 96), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value3,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"sourceMap":"125:1123:5:-:0;;;3629:2740:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;205:5:5;181:29;;;;;;;;;;;;;;;;;;;;388:108;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;519:10:0;511:5;;:18;;;;;;;;;;;;;;;;;;262:165:2;;;;;;;;282:2;262:165;;;;;;285:3;262:165;;;;;;289:3;262:165;;;;;;293:3;262:165;;;;;;297:3;262:165;;;;;;301:3;262:165;;;;;;305:3;262:165;;;;;;309:3;262:165;;;;;;313:3;262:165;;;;;;317:3;262:165;;;;;;321:3;262:165;;;;;;325:3;262:165;;;;;;329:3;262:165;;;;;;333:3;262:165;;;;;;337:3;262:165;;;;;;341:3;262:165;;;;;;345:3;262:165;;;;;;349:3;262:165;;;;;;353:3;262:165;;;;;;357:4;262:165;;;;;;362:4;262:165;;;;;;367:4;262:165;;;;;;372:4;262:165;;;;;;377:4;262:165;;;;;;382:4;262:165;;;;;;387:4;262:165;;;;;;392:4;262:165;;;;;;397:4;262:165;;;;;;402:4;262:165;;;;;;407:4;262:165;;;;;;412:4;262:165;;;;;;417:4;262:165;;;;;;422:4;262:165;;;;;:13;276:1;262:16;;;;;;;:::i;:::-;;;;;:165;;;;;;;:::i;:::-;;435:169;;;;;;;;455:2;435:169;;;;;;458:3;435:169;;;;;;462:3;435:169;;;;;;466:3;435:169;;;;;;470:3;435:169;;;;;;474:3;435:169;;;;;;478:3;435:169;;;;;;482:3;435:169;;;;;;486:3;435:169;;;;;;490:3;435:169;;;;;;494:3;435:169;;;;;;498:3;435:169;;;;;;502:3;435:169;;;;;;506:3;435:169;;;;;;510:3;435:169;;;;;;514:3;435:169;;;;;;518:3;435:169;;;;;;522:5;435:169;;;;;;528:5;435:169;;;;;;534:4;435:169;;;;;;539:4;435:169;;;;;;544:4;435:169;;;;;;549:4;435:169;;;;;;554:4;435:169;;;;;;559:4;435:169;;;;;;564:4;435:169;;;;;;569:4;435:169;;;;;;574:4;435:169;;;;;;579:4;435:169;;;;;;584:4;435:169;;;;;;589:4;435:169;;;;;;594:4;435:169;;;;;;599:4;435:169;;;;;:13;449:1;435:16;;;;;;;:::i;:::-;;;;;:169;;;;;;;:::i;:::-;;612:171;;;;;;;;632:2;612:171;;;;;;635:3;612:171;;;;;;639:3;612:171;;;;;;643:3;612:171;;;;;;647:3;612:171;;;;;;651:3;612:171;;;;;;655:3;612:171;;;;;;659:3;612:171;;;;;;663:3;612:171;;;;;;667:3;612:171;;;;;;671:3;612:171;;;;;;675:3;612:171;;;;;;679:3;612:171;;;;;;683:3;612:171;;;;;;687:3;612:171;;;;;;691:3;612:171;;;;;;695:5;612:171;;;;;;701:5;612:171;;;;;;707:5;612:171;;;;;;713:4;612:171;;;;;;718:4;612:171;;;;;;723:4;612:171;;;;;;728:4;612:171;;;;;;733:4;612:171;;;;;;738:4;612:171;;;;;;743:4;612:171;;;;;;748:4;612:171;;;;;;753:4;612:171;;;;;;758:4;612:171;;;;;;763:4;612:171;;;;;;768:4;612:171;;;;;;773:4;612:171;;;;;;778:4;612:171;;;;;:13;626:1;612:16;;;;;;;:::i;:::-;;;;;:171;;;;;;;:::i;:::-;;791:178;;;;;;;;811:2;791:178;;;;;;814:3;791:178;;;;;;818:3;791:178;;;;;;822:3;791:178;;;;;;826:3;791:178;;;;;;830:3;791:178;;;;;;834:3;791:178;;;;;;838:3;791:178;;;;;;842:3;791:178;;;;;;846:3;791:178;;;;;;850:3;791:178;;;;;;854:5;791:178;;;;;;860:5;791:178;;;;;;866:5;791:178;;;;;;872:5;791:178;;;;;;878:3;791:178;;;;;;882:5;791:178;;;;;;888:4;791:178;;;;;;893:5;791:178;;;;;;899:4;791:178;;;;;;904:4;791:178;;;;;;909:4;791:178;;;;;;914:4;791:178;;;;;;919:4;791:178;;;;;;924:4;791:178;;;;;;929:4;791:178;;;;;;934:4;791:178;;;;;;939:4;791:178;;;;;;944:4;791:178;;;;;;949:4;791:178;;;;;;954:4;791:178;;;;;;959:4;791:178;;;;;;964:4;791:178;;;;;:13;805:1;791:16;;;;;;;:::i;:::-;;;;;:178;;;;;;;:::i;:::-;;977:179;;;;;;;;997:2;977:179;;;;;;1000:3;977:179;;;;;;1004:3;977:179;;;;;;1008:3;977:179;;;;;;1012:3;977:179;;;;;;1016:3;977:179;;;;;;1020:3;977:179;;;;;;1024:3;977:179;;;;;;1028:3;977:179;;;;;;1032:3;977:179;;;;;;1036:4;977:179;;;;;;1041:5;977:179;;;;;;1047:5;977:179;;;;;;1053:5;977:179;;;;;;1059:3;977:179;;;;;;1063:5;977:179;;;;;;1069:5;977:179;;;;;;1075:4;977:179;;;;;;1080:5;977:179;;;;;;1086:4;977:179;;;;;;1091:4;977:179;;;;;;1096:4;977:179;;;;;;1101:4;977:179;;;;;;1106:4;977:179;;;;;;1111:4;977:179;;;;;;1116:4;977:179;;;;;;1121:4;977:179;;;;;;1126:4;977:179;;;;;;1131:4;977:179;;;;;;1136:4;977:179;;;;;;1141:4;977:179;;;;;;1146:4;977:179;;;;;;1151:4;977:179;;;;;:13;991:1;977:16;;;;;;;:::i;:::-;;;;;:179;;;;;;;:::i;:::-;;1164:177;;;;;;;;1184:2;1164:177;;;;;;1187:3;1164:177;;;;;;1191:3;1164:177;;;;;;1195:3;1164:177;;;;;;1199:3;1164:177;;;;;;1203:3;1164:177;;;;;;1207:3;1164:177;;;;;;1211:3;1164:177;;;;;;1215:3;1164:177;;;;;;1219:3;1164:177;;;;;;1223:5;1164:177;;;;;;1229:5;1164:177;;;;;;1235:3;1164:177;;;;;;1239:5;1164:177;;;;;;1245:3;1164:177;;;;;;1249:4;1164:177;;;;;;1254:5;1164:177;;;;;;1260:4;1164:177;;;;;;1265:5;1164:177;;;;;;1271:4;1164:177;;;;;;1276:4;1164:177;;;;;;1281:4;1164:177;;;;;;1286:4;1164:177;;;;;;1291:4;1164:177;;;;;;1296:4;1164:177;;;;;;1301:4;1164:177;;;;;;1306:4;1164:177;;;;;;1311:4;1164:177;;;;;;1316:4;1164:177;;;;;;1321:4;1164:177;;;;;;1326:4;1164:177;;;;;;1331:4;1164:177;;;;;;1336:4;1164:177;;;;;:13;1178:1;1164:16;;;;;;;:::i;:::-;;;;;:177;;;;;;;:::i;:::-;;1349:176;;;;;;;;1369:2;1349:176;;;;;;1372:3;1349:176;;;;;;1376:3;1349:176;;;;;;1380:3;1349:176;;;;;;1384:3;1349:176;;;;;;1388:3;1349:176;;;;;;1392:3;1349:176;;;;;;1396:3;1349:176;;;;;;1400:3;1349:176;;;;;;1404:3;1349:176;;;;;;1408:3;1349:176;;;;;;1412:5;1349:176;;;;;;1418:3;1349:176;;;;;;1422:5;1349:176;;;;;;1428:4;1349:176;;;;;;1433:4;1349:176;;;;;;1438:5;1349:176;;;;;;1444:4;1349:176;;;;;;1449:5;1349:176;;;;;;1455:4;1349:176;;;;;;1460:4;1349:176;;;;;;1465:4;1349:176;;;;;;1470:4;1349:176;;;;;;1475:4;1349:176;;;;;;1480:4;1349:176;;;;;;1485:4;1349:176;;;;;;1490:4;1349:176;;;;;;1495:4;1349:176;;;;;;1500:4;1349:176;;;;;;1505:4;1349:176;;;;;;1510:4;1349:176;;;;;;1515:4;1349:176;;;;;;1520:4;1349:176;;;;;:13;1363:1;1349:16;;;;;;;:::i;:::-;;;;;:176;;;;;;;:::i;:::-;;1533:175;;;;;;;;1553:2;1533:175;;;;;;1556:3;1533:175;;;;;;1560:3;1533:175;;;;;;1564:3;1533:175;;;;;;1568:3;1533:175;;;;;;1572:3;1533:175;;;;;;1576:3;1533:175;;;;;;1580:3;1533:175;;;;;;1584:3;1533:175;;;;;;1588:3;1533:175;;;;;;1592:3;1533:175;;;;;;1596:3;1533:175;;;;;;1600:5;1533:175;;;;;;1606:4;1533:175;;;;;;1611:5;1533:175;;;;;;1617:4;1533:175;;;;;;1622:4;1533:175;;;;;;1627:4;1533:175;;;;;;1632:5;1533:175;;;;;;1638:4;1533:175;;;;;;1643:4;1533:175;;;;;;1648:4;1533:175;;;;;;1653:4;1533:175;;;;;;1658:4;1533:175;;;;;;1663:4;1533:175;;;;;;1668:4;1533:175;;;;;;1673:4;1533:175;;;;;;1678:4;1533:175;;;;;;1683:4;1533:175;;;;;;1688:4;1533:175;;;;;;1693:4;1533:175;;;;;;1698:4;1533:175;;;;;;1703:4;1533:175;;;;;:13;1547:1;1533:16;;;;;;;:::i;:::-;;;;;:175;;;;;;;:::i;:::-;;1716:174;;;;;;;;1736:2;1716:174;;;;;;1739:3;1716:174;;;;;;1743:3;1716:174;;;;;;1747:3;1716:174;;;;;;1751:3;1716:174;;;;;;1755:3;1716:174;;;;;;1759:3;1716:174;;;;;;1763:3;1716:174;;;;;;1767:3;1716:174;;;;;;1771:3;1716:174;;;;;;1775:3;1716:174;;;;;;1779:3;1716:174;;;;;;1783:3;1716:174;;;;;;1787:5;1716:174;;;;;;1793:4;1716:174;;;;;;1798:5;1716:174;;;;;;1804:4;1716:174;;;;;;1809:4;1716:174;;;;;;1814:5;1716:174;;;;;;1820:4;1716:174;;;;;;1825:4;1716:174;;;;;;1830:4;1716:174;;;;;;1835:4;1716:174;;;;;;1840:4;1716:174;;;;;;1845:4;1716:174;;;;;;1850:4;1716:174;;;;;;1855:4;1716:174;;;;;;1860:4;1716:174;;;;;;1865:4;1716:174;;;;;;1870:4;1716:174;;;;;;1875:4;1716:174;;;;;;1880:4;1716:174;;;;;;1885:4;1716:174;;;;;:13;1730:1;1716:16;;;;;;;:::i;:::-;;;;;:174;;;;;;;:::i;:::-;;1898:184;;;;;;;;1918:2;1898:184;;;;;;1921:3;1898:184;;;;;;1925:3;1898:184;;;;;;1929:3;1898:184;;;;;;1933:3;1898:184;;;;;;1937:3;1898:184;;;;;;1941:3;1898:184;;;;;;1945:3;1898:184;;;;;;1949:3;1898:184;;;;;;1953:3;1898:184;;;;;;1957:5;1898:184;;;;;;1963:5;1898:184;;;;;;1969:5;1898:184;;;;;;1975:5;1898:184;;;;;;1981:5;1898:184;;;;;;1987:4;1898:184;;;;;;1992:5;1898:184;;;;;;1998:4;1898:184;;;;;;2003:5;1898:184;;;;;;2009:5;1898:184;;;;;;2015:5;1898:184;;;;;;2021:5;1898:184;;;;;;2027:4;1898:184;;;;;;2032:4;1898:184;;;;;;2037:4;1898:184;;;;;;2042:4;1898:184;;;;;;2047:4;1898:184;;;;;;2052:4;1898:184;;;;;;2057:4;1898:184;;;;;;2062:4;1898:184;;;;;;2067:4;1898:184;;;;;;2072:4;1898:184;;;;;;2077:4;1898:184;;;;;:13;1912:1;1898:16;;;;;;;:::i;:::-;;;;;:184;;;;;;;:::i;:::-;;2090:191;;;;;;;;2111:2;2090:191;;;;;;2114:3;2090:191;;;;;;2118:3;2090:191;;;;;;2122:3;2090:191;;;;;;2126:3;2090:191;;;;;;2130:3;2090:191;;;;;;2134:3;2090:191;;;;;;2138:3;2090:191;;;;;;2142:3;2090:191;;;;;;2146:5;2090:191;;;;;;2152:5;2090:191;;;;;;2158:5;2090:191;;;;;;2164:5;2090:191;;;;;;2170:5;2090:191;;;;;;2176:5;2090:191;;;;;;2182:5;2090:191;;;;;;2188:5;2090:191;;;;;;2194:5;2090:191;;;;;;2200:5;2090:191;;;;;;2206:5;2090:191;;;;;;2212:5;2090:191;;;;;;2218:5;2090:191;;;;;;2224:5;2090:191;;;;;;2230:5;2090:191;;;;;;2236:4;2090:191;;;;;;2241:4;2090:191;;;;;;2246:4;2090:191;;;;;;2251:4;2090:191;;;;;;2256:4;2090:191;;;;;;2261:4;2090:191;;;;;;2266:4;2090:191;;;;;;2271:4;2090:191;;;;;;2276:4;2090:191;;;;;:13;2104:2;2090:17;;;;;;;:::i;:::-;;;;;:191;;;;;;;:::i;:::-;;2289:183;;;;;;;;2310:2;2289:183;;;;;;2313:3;2289:183;;;;;;2317:3;2289:183;;;;;;2321:3;2289:183;;;;;;2325:3;2289:183;;;;;;2329:3;2289:183;;;;;;2333:3;2289:183;;;;;;2337:3;2289:183;;;;;;2341:5;2289:183;;;;;;2347:5;2289:183;;;;;;2353:3;2289:183;;;;;;2357:4;2289:183;;;;;;2362:4;2289:183;;;;;;2367:4;2289:183;;;;;;2372:4;2289:183;;;;;;2377:5;2289:183;;;;;;2383:5;2289:183;;;;;;2389:5;2289:183;;;;;;2395:4;2289:183;;;;;;2400:4;2289:183;;;;;;2405:4;2289:183;;;;;;2410:4;2289:183;;;;;;2415:4;2289:183;;;;;;2420:5;2289:183;;;;;;2426:5;2289:183;;;;;;2432:4;2289:183;;;;;;2437:4;2289:183;;;;;;2442:4;2289:183;;;;;;2447:4;2289:183;;;;;;2452:4;2289:183;;;;;;2457:4;2289:183;;;;;;2462:4;2289:183;;;;;;2467:4;2289:183;;;;;:13;2303:2;2289:17;;;;;;;:::i;:::-;;;;;:183;;;;;;;:::i;:::-;;2480:181;;;;;;;;2501:2;2480:181;;;;;;2504:3;2480:181;;;;;;2508:3;2480:181;;;;;;2512:3;2480:181;;;;;;2516:3;2480:181;;;;;;2520:3;2480:181;;;;;;2524:3;2480:181;;;;;;2528:5;2480:181;;;;;;2534:5;2480:181;;;;;;2540:3;2480:181;;;;;;2544:3;2480:181;;;;;;2548:4;2480:181;;;;;;2553:4;2480:181;;;;;;2558:4;2480:181;;;;;;2563:4;2480:181;;;;;;2568:4;2480:181;;;;;;2573:5;2480:181;;;;;;2579:4;2480:181;;;;;;2584:4;2480:181;;;;;;2589:4;2480:181;;;;;;2594:4;2480:181;;;;;;2599:4;2480:181;;;;;;2604:4;2480:181;;;;;;2609:4;2480:181;;;;;;2614:5;2480:181;;;;;;2620:5;2480:181;;;;;;2626:4;2480:181;;;;;;2631:4;2480:181;;;;;;2636:4;2480:181;;;;;;2641:4;2480:181;;;;;;2646:4;2480:181;;;;;;2651:4;2480:181;;;;;;2656:4;2480:181;;;;;:13;2494:2;2480:17;;;;;;;:::i;:::-;;;;;:181;;;;;;;:::i;:::-;;2669;;;;;;;;2690:2;2669:181;;;;;;2693:3;2669:181;;;;;;2697:3;2669:181;;;;;;2701:3;2669:181;;;;;;2705:3;2669:181;;;;;;2709:3;2669:181;;;;;;2713:3;2669:181;;;;;;2717:5;2669:181;;;;;;2723:5;2669:181;;;;;;2729:3;2669:181;;;;;;2733:3;2669:181;;;;;;2737:4;2669:181;;;;;;2742:4;2669:181;;;;;;2747:4;2669:181;;;;;;2752:4;2669:181;;;;;;2757:4;2669:181;;;;;;2762:5;2669:181;;;;;;2768:4;2669:181;;;;;;2773:4;2669:181;;;;;;2778:4;2669:181;;;;;;2783:4;2669:181;;;;;;2788:4;2669:181;;;;;;2793:4;2669:181;;;;;;2798:4;2669:181;;;;;;2803:5;2669:181;;;;;;2809:5;2669:181;;;;;;2815:4;2669:181;;;;;;2820:4;2669:181;;;;;;2825:4;2669:181;;;;;;2830:4;2669:181;;;;;;2835:4;2669:181;;;;;;2840:4;2669:181;;;;;;2845:4;2669:181;;;;;:13;2683:2;2669:17;;;;;;;:::i;:::-;;;;;:181;;;;;;;:::i;:::-;;2858:184;;;;;;;;2879:2;2858:184;;;;;;2882:3;2858:184;;;;;;2886:3;2858:184;;;;;;2890:3;2858:184;;;;;;2894:3;2858:184;;;;;;2898:3;2858:184;;;;;;2902:3;2858:184;;;;;;2906:3;2858:184;;;;;;2910:5;2858:184;;;;;;2916:5;2858:184;;;;;;2922:4;2858:184;;;;;;2927:4;2858:184;;;;;;2932:4;2858:184;;;;;;2937:4;2858:184;;;;;;2942:4;2858:184;;;;;;2947:5;2858:184;;;;;;2953:5;2858:184;;;;;;2959:5;2858:184;;;;;;2965:4;2858:184;;;;;;2970:4;2858:184;;;;;;2975:4;2858:184;;;;;;2980:4;2858:184;;;;;;2985:4;2858:184;;;;;;2990:5;2858:184;;;;;;2996:5;2858:184;;;;;;3002:4;2858:184;;;;;;3007:4;2858:184;;;;;;3012:4;2858:184;;;;;;3017:4;2858:184;;;;;;3022:4;2858:184;;;;;;3027:4;2858:184;;;;;;3032:4;2858:184;;;;;;3037:4;2858:184;;;;;:13;2872:2;2858:17;;;;;;;:::i;:::-;;;;;:184;;;;;;;:::i;:::-;;3050:190;;;;;;;;3071:2;3050:190;;;;;;3074:3;3050:190;;;;;;3078:3;3050:190;;;;;;3082:3;3050:190;;;;;;3086:3;3050:190;;;;;;3090:3;3050:190;;;;;;3094:3;3050:190;;;;;;3098:3;3050:190;;;;;;3102:3;3050:190;;;;;;3106:5;3050:190;;;;;;3112:5;3050:190;;;;;;3118:5;3050:190;;;;;;3124:5;3050:190;;;;;;3130:5;3050:190;;;;;;3136:5;3050:190;;;;;;3142:5;3050:190;;;;;;3148:4;3050:190;;;;;;3153:5;3050:190;;;;;;3159:5;3050:190;;;;;;3165:5;3050:190;;;;;;3171:5;3050:190;;;;;;3177:5;3050:190;;;;;;3183:5;3050:190;;;;;;3189:5;3050:190;;;;;;3195:4;3050:190;;;;;;3200:4;3050:190;;;;;;3205:4;3050:190;;;;;;3210:4;3050:190;;;;;;3215:4;3050:190;;;;;;3220:4;3050:190;;;;;;3225:4;3050:190;;;;;;3230:4;3050:190;;;;;;3235:4;3050:190;;;;;:13;3064:2;3050:17;;;;;;;:::i;:::-;;;;;:190;;;;;;;:::i;:::-;;3248:185;;;;;;;;3269:2;3248:185;;;;;;3272:3;3248:185;;;;;;3276:3;3248:185;;;;;;3280:3;3248:185;;;;;;3284:3;3248:185;;;;;;3288:3;3248:185;;;;;;3292:3;3248:185;;;;;;3296:3;3248:185;;;;;;3300:3;3248:185;;;;;;3304:3;3248:185;;;;;;3308:5;3248:185;;;;;;3314:5;3248:185;;;;;;3320:5;3248:185;;;;;;3326:5;3248:185;;;;;;3332:5;3248:185;;;;;;3338:4;3248:185;;;;;;3343:4;3248:185;;;;;;3348:4;3248:185;;;;;;3353:5;3248:185;;;;;;3359:5;3248:185;;;;;;3365:5;3248:185;;;;;;3371:5;3248:185;;;;;;3377:5;3248:185;;;;;;3383:4;3248:185;;;;;;3388:4;3248:185;;;;;;3393:4;3248:185;;;;;;3398:4;3248:185;;;;;;3403:4;3248:185;;;;;;3408:4;3248:185;;;;;;3413:4;3248:185;;;;;;3418:4;3248:185;;;;;;3423:4;3248:185;;;;;;3428:4;3248:185;;;;;:13;3262:2;3248:17;;;;;;;:::i;:::-;;;;;:185;;;;;;;:::i;:::-;;3441:177;;;;;;;;3462:3;3441:177;;;;;;3466:3;3441:177;;;;;;3470:3;3441:177;;;;;;3474:3;3441:177;;;;;;3478:3;3441:177;;;;;;3482:3;3441:177;;;;;;3486:3;3441:177;;;;;;3490:3;3441:177;;;;;;3494:3;3441:177;;;;;;3498:4;3441:177;;;;;;3503:4;3441:177;;;;;;3508:4;3441:177;;;;;;3513:4;3441:177;;;;;;3518:4;3441:177;;;;;;3523:4;3441:177;;;;;;3528:4;3441:177;;;;;;3533:4;3441:177;;;;;;3538:4;3441:177;;;;;;3543:4;3441:177;;;;;;3548:4;3441:177;;;;;;3553:4;3441:177;;;;;;3558:4;3441:177;;;;;;3563:4;3441:177;;;;;;3568:4;3441:177;;;;;;3573:4;3441:177;;;;;;3578:4;3441:177;;;;;;3583:4;3441:177;;;;;;3588:4;3441:177;;;;;;3593:4;3441:177;;;;;;3598:4;3441:177;;;;;;3603:4;3441:177;;;;;;3608:4;3441:177;;;;;;3613:4;3441:177;;;;;:13;3455:2;3441:17;;;;;;;:::i;:::-;;;;;:177;;;;;;;:::i;:::-;;468:20:5;440:12;;:49;;;;;;;;;;;;;;;;;;388:108;125:1123;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;:::i;:::-;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;88:117:7:-;197:1;194;187:12;334:126;371:7;411:42;404:5;400:54;389:65;;334:126;;;:::o;466:96::-;503:7;532:24;550:5;532:24;:::i;:::-;521:35;;466:96;;;:::o;568:122::-;641:24;659:5;641:24;:::i;:::-;634:5;631:35;621:63;;680:1;677;670:12;621:63;568:122;:::o;696:143::-;753:5;784:6;778:13;769:22;;800:33;827:5;800:33;:::i;:::-;696:143;;;;:::o;845:351::-;915:6;964:2;952:9;943:7;939:23;935:32;932:119;;;970:79;;:::i;:::-;932:119;1090:1;1115:64;1171:7;1162:6;1151:9;1147:22;1115:64;:::i;:::-;1105:74;;1061:128;845:351;;;;:::o;1202:180::-;1250:77;1247:1;1240:88;1347:4;1344:1;1337:15;1371:4;1368:1;1361:15;1388:180;1436:77;1433:1;1426:88;1533:4;1530:1;1523:15;1557:4;1554:1;1547:15;1574:320;1618:6;1655:1;1649:4;1645:12;1635:22;;1702:1;1696:4;1692:12;1723:18;1713:81;;1779:4;1771:6;1767:17;1757:27;;1713:81;1841:2;1833:6;1830:14;1810:18;1807:38;1804:84;;1860:18;;:::i;:::-;1804:84;1625:269;1574:320;;;:::o;125:1123:5:-;;;;;;;","deployedSourceMap":"125:1123:5:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6303:809:0;;;;;;;;;;;;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;2094:161;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;138:39:2;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;289:50:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1274:227;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;7118:220;;;;;;;;;;;;;:::i;:::-;;4877:939;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;502:255:5;;;;;;;;;;;;;:::i;:::-;;94:38:2;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;216:32:5;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;181:29;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;5822:471:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;103:20;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;285:97:5;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;3888:487:0;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4382:489;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;184:50:2;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2260:1250:0;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;3629:2740:2;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;6303:809:0;6369:26;6397:17;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;6426:13:::1;6442:14;:12;:14::i;:::-;6426:30;;6466:14;6483:15;:13;:15::i;:::-;6466:32;;6509:39;6575:6;6551:31;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6509:73;;6592:30;6640:6;6625:22;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6592:55;;6663:6;6658:402;6679:6;6675:1;:10;6658:402;;;6706:34;6765:5;6743:28;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6706:65;;6785:25;6826:5;6813:19;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6785:47;;6852:6;6847:120;6868:5;6864:1;:9;6847:120;;;6929:23;6947:1;6950;6929:17;:23::i;:::-;6899:9;6909:1;6899:12;;;;;;;;:::i;:::-;;;;;;;6913:9;6923:1;6913:12;;;;;;;;:::i;:::-;;;;;;;6898:54;;;;;;;;;;::::0;::::1;;6875:3;;;;;:::i;:::-;;;;6847:120;;;;6999:9;6981:12;6994:1;6981:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;7040:9;7022:12;7035:1;7022:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;6692:368;;6687:3;;;;;:::i;:::-;;;;6658:402;;;;7078:12;7092;7070:35;;;;;;;;6303:809:::0;;:::o;2094:161::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2199:1:::1;2202;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2215:33:::2;2233:1;2236;2239;2242:5;2215:17;:33::i;:::-;953:1:::1;;2094:161:::0;;;:::o;138:39:2:-;175:2;138:39;:::o;289:50:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1274:227::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;1399:1:::1;1402;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;1420:1:::2;1423;1426:10;1208;1169:49;;:4;:7;1174:1;1169:7;;;;;;;;;;;:10;1177:1;1169:10;;;;;;;;;;;:17;;1187:10;1169:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;;;;;;;;;;;:49;;;1161:89;;;;;;;;;;;;:::i;:::-;;;;;;;;;1486:8:::3;1448:4;:7;1453:1;1448:7;;;;;;;;;;;:10;1456:1;1448:10;;;;;;;;;;;:17;;1466:10;1448:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;:46;;;;;;;;;;;;:::i;:::-;;2080:1:::2;;;953::::1;;1274:227:::0;;;;:::o;7118:220::-;1020:5;;;;;;;;;;1006:19;;:10;:19;;;998:69;;;;;;;;;;;;:::i;:::-;;;;;;;;;7172:23:::1;7198:21;7172:47;;7255:1;7237:15;:19;7229:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;7299:5;::::0;::::1;;;;;;;;7291:23;;:40;7315:15;7291:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;7162:176;7118:220::o:0;4877:939::-;4944:15;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4971:13:::1;4987:14;:12;:14::i;:::-;4971:30;;5011:14;5028:15;:13;:15::i;:::-;5011:32;;5053:24;5093:6;5080:20;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5053:47;;5116:6;5111:673;5132:6;5128:1;:10;5111:673;;;5159:17;5190:5;5179:17;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5159:37;;5215:6;5210:533;5231:5;5227:1;:9;5210:533;;;5262:13;5277:19:::0;5298::::1;5321:18;5334:1;5337;5321:12;:18::i;:::-;5261:78;;;;;;5377:5;5358:3;5362:1;5358:6;;;;;;;;:::i;:::-;;;;;;;;:16;;:24;;;::::0;::::1;5420:1;5405:11;:16:::0;5401:328:::1;;5473:1;5461:14;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5445:3;5449:1;5445:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:30;;;;5516:114;;;;;;;;5563:5;::::0;::::1;;;;;;;;5516:114;;;;;;5602:5;5516:114;;::::0;5497:3:::1;5501:1;5497:6;;;;;;;;:::i;:::-;;;;;;;;:13;;;5511:1;5497:16;;;;;;;;:::i;:::-;;;;;;;:133;;;;5401:328;;;5693:4;:7;5698:1;5693:7;;;;;;;;;;;:10;5701:1;5693:10;;;;;;;;;;;:17;;5677:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;:3;5681:1;5677:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:33;;;;5401:328;5243:500;;;5238:3;;;;;:::i;:::-;;;;5210:533;;;;5770:3;5756:8;5765:1;5756:11;;;;;;;;:::i;:::-;;;;;;;:17;;;;5145:639;5140:3;;;;;:::i;:::-;;;;5111:673;;;;5801:8;5794:15;;;;;4877:939:::0;:::o;502:255:5:-;1020:5:0;;;;;;;;;;1006:19;;:10;:19;;;998:69;;;;;;;;;;;;:::i;:::-;;;;;;;;;555:18:5::1;576:12;;;;;;;;;;;:32;;;:34;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;555:55;;642:12;628:10;:26;;620:72;;;;;;;;;;;;:::i;:::-;;;;;;;;;714:4;702:9;;:16;;;;;;;;;;;;;;;;;;733:17;;;;;;;;;;545:212;502:255::o:0;94:38:2:-;130:2;94:38;:::o;216:32:5:-;;;;;;;;;;;;;:::o;181:29::-;;;;;;;;;;;;;:::o;5822:471:0:-;5927:15;5944:13;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;5912:1:::1;5915;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;5969:16:::2;5988:4;:7;5993:1;5988:7;;;;;;;;;;;:10;5996:1;5988:10;;;;;;;;;;;5969:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;6035:1;6013:4;:11;;;:18;:23:::0;6009:159:::2;;6055:26;6085:21;6101:1;6104;6085:15;:21::i;:::-;6052:54;;;6136:5;::::0;::::2;;;;;;;;6144:12;6120:37;;;;;;;;6009:159;6178:21;6202:4;:11;;;6235:1;6214:4;:11;;;:18;:22;;;;:::i;:::-;6202:35;;;;;;;;:::i;:::-;;;;;;;;6178:59;;6255:8;:14;;;6271:8;:14;;;6247:39;;;;;;2080:1;953::::1;;5822:471:::0;;;;;:::o;103:20::-;;;;;;;;;;;;:::o;285:97:5:-;343:4;366:9;;;;;;;;;;;359:16;;285:97;:::o;3888:487:0:-;3940:7;3959:18;3980:1;3959:22;;3991:13;4007:14;:12;:14::i;:::-;3991:30;;4031:14;4048:15;:13;:15::i;:::-;4031:32;;4079:6;4074:267;4095:6;4091:1;:10;4074:267;;;4127:6;4122:209;4143:5;4139:1;:9;4122:209;;;4173:16;4192:4;:7;4197:1;4192:7;;;;;;;;;;;:10;4200:1;4192:10;;;;;;;;;;;4173:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4220:17;4257:4;:11;;;:18;4240:4;:14;;;:35;;;;:::i;:::-;4220:55;;4307:9;4293:23;;;;;:::i;:::-;;;4155:176;;4150:3;;;;;:::i;:::-;;;;4122:209;;;;4103:3;;;;;:::i;:::-;;;;4074:267;;;;4358:10;4351:17;;;;;3888:487;:::o;4382:489::-;4482:7;4491:13;4506:7;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4467:1:::1;4470;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;4525:16:::2;4544:4;:7;4549:1;4544:7;;;;;;;;;;;:10;4552:1;4544:10;;;;;;;;;;;4525:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;4598:1;4576:4;:11;;;:18;:23:::0;4573:187:::2;;4616:20;4638:26:::0;4668:21:::2;4684:1;4687;4668:15;:21::i;:::-;4615:74;;;;4726:5;4711:12;:20;;;;:::i;:::-;4733:12;4747:1;4703:46;;;;;;;;;;;4573:187;4786:4;:14;;;4802:4;:11;;;4835:1;4814:4;:11;;;:18;:22;;;;:::i;:::-;4802:35;;;;;;;;:::i;:::-;;;;;;;;:41;;;4845:4;:11;;;:18;4778:86;;;;;;;2080:1;953::::1;;4382:489:::0;;;;;:::o;184:50:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2260:1250:0:-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2398:1:::1;2401;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2440:2:::2;2422:14;:20;;2414:71;;;;;;;;;;;;:::i;:::-;;;;;;;;;2496:20;2511:1;2514;2496:14;:20::i;:::-;2527:29;2582:5;2559:4;:7;2564:1;2559:7;;;;;;;;;;;:10;2567:1;2559:10;;;;;;;;;;;:20;;;:28;;;;:::i;:::-;2527:60;;2597:26;2626:4;:7;2631:1;2626:7;;;;;;;;;;;:10;2634:1;2626:10;;;;;;;;;;;:17;;:24;;;;2597:53;;2660:19;2747:1;2742;2725:14;2704:18;2700:1;:22;;;;:::i;:::-;:39;;;;:::i;:::-;:43;;;;:::i;:::-;2682:14;:62;;;;:::i;:::-;:66;;;;:::i;:::-;2660:88;;2759:20;2847:1;2842;2825:14;:18;;;;:::i;:::-;2807:14;:37;;;;:::i;:::-;:41;;;;:::i;:::-;2782:21;:67;;;;:::i;:::-;2759:90;;2860:17;2920:12;2905:11;2881:21;:35;;;;:::i;:::-;2880:52;;;;:::i;:::-;2860:72;;2964:9;2951;:22;2943:53;;;;;;;;;;;;:::i;:::-;;;;;;;;;3012:9;3007:198;3031:18;3027:1;:22;3007:198;;;3070:18;3091:4;:7;3096:1;3091:7;;;;;;;;;;;:10;3099:1;3091:10;;;;;;;;;;;:17;;3109:1;3091:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3070:47;;3180:14;3156:21;:38;;;;:::i;:::-;3131:9;:21;3141:10;3131:21;;;;;;;;;;;;;;;;:63;;;;;;;:::i;:::-;;;;;;;;3056:149;3051:3;;;;;:::i;:::-;;;;3007:198;;;;3215:18;3228:1;3231;3215:12;:18::i;:::-;3249:9;3244:189;3268:14;3264:1;:18;3244:189;;;3303:4;:7;3308:1;3303:7;;;;;;;;;;;:10;3311:1;3303:10;;;;;;;;;;;:17;;3326:95;;;;;;;;3365:10;3326:95;;;;;;3401:5;3326:95;;::::0;3303:119:::2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;3284:3;;;;;:::i;:::-;;;;3244:189;;;;3463:10;3448:55;;;3475:1;3478;3481:14;3497:5;3448:55;;;;;;;;;:::i;:::-;;;;;;;;2404:1106;;;;;953:1:::1;;2260:1250:::0;;;;:::o;3629:2740:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1042:98:5:-;1098:7;130:2:2;1117:16:5;;1042:98;:::o;1146:100::-;1203:7;175:2:2;1222:17:5;;1146:100;:::o;763:274::-;836:7;845:13;130:2:2;878:1:5;:13;870:46;;;;;;;;;;;;:::i;:::-;;;;;;;;;175:2:2;934:1:5;:14;926:47;;;;;;;;;;;;:::i;:::-;;;;;;;;;991:13;1005:1;991:16;;;;;;;:::i;:::-;;;;;1008:1;991:19;;;;;;;:::i;:::-;;;;1012:11;1024:1;1012:14;;;;;;;:::i;:::-;;;;;1027:1;1012:17;;;;;;;:::i;:::-;;;983:47;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;763:274;;;;;:::o;1507:392:0:-;1594:1;1570:4;:7;1575:1;1570:7;;;;;;;;;;;:10;1578:1;1570:10;;;;;;;;;;;:20;;;:25;:58;;;;;1627:1;1599:4;:7;1604:1;1599:7;;;;;;;;;;;:10;1607:1;1599:10;;;;;;;;;;;:17;;:24;;;;:29;1570:58;1566:327;;;1645:13;1660:19;1683:21;1699:1;1702;1683:15;:21::i;:::-;1644:60;;;;1749:5;1741;:13;;;;:::i;:::-;1718:4;:7;1723:1;1718:7;;;;;;;;;;;:10;1726:1;1718:10;;;;;;;;;;;:20;;:36;;;;1768:4;:7;1773:1;1768:7;;;;;;;;;;;:10;1776:1;1768:10;;;;;;;;;;;:17;;1791:90;;;;;;;;1830:5;;;;;;;;;;1791:90;;;;;;1861:5;1791:90;;;1768:114;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;1630:263;;1566:327;1507:392;;:::o;3517:361::-;3579:9;3574:298;3598:4;:7;3603:1;3598:7;;;;;;;;;;;:10;3606:1;3598:10;;;;;;;;;;;:17;;:24;;;;3594:1;:28;3574:298;;;3643:18;3664:4;:7;3669:1;3664:7;;;;;;;;;;;:10;3672:1;3664:10;;;;;;;;;;;:17;;3682:1;3664:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3643:47;;3732:1;3708:9;:21;3718:10;3708:21;;;;;;;;;;;;;;;;:25;3704:158;;;3761:10;3753:28;;:51;3782:9;:21;3792:10;3782:21;;;;;;;;;;;;;;;;3753:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3846:1;3822:9;:21;3832:10;3822:21;;;;;;;;;;;;;;;:25;;;;3704:158;3629:243;3624:3;;;;;:::i;:::-;;;;3574:298;;;;3517:361;;:::o;-1:-1:-1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;7:147:7:-;107:6;141:5;135:12;125:22;;7:147;;;:::o;160:217::-;292:11;326:6;321:3;314:19;366:4;361:3;357:14;342:29;;160:217;;;;:::o;383:165::-;483:4;506:3;498:11;;536:4;531:3;527:14;519:22;;383:165;;;:::o;554:122::-;629:6;663:5;657:12;647:22;;554:122;;;:::o;682:182::-;779:11;813:6;808:3;801:19;853:4;848:3;844:14;829:29;;682:182;;;;:::o;870:140::-;945:4;968:3;960:11;;998:4;993:3;989:14;981:22;;870:140;;;:::o;1016:126::-;1053:7;1093:42;1086:5;1082:54;1071:65;;1016:126;;;:::o;1148:104::-;1193:7;1222:24;1240:5;1222:24;:::i;:::-;1211:35;;1148:104;;;:::o;1258:132::-;1351:32;1377:5;1351:32;:::i;:::-;1346:3;1339:45;1258:132;;:::o;1396:211::-;1481:10;1502:62;1560:3;1552:6;1502:62;:::i;:::-;1596:4;1591:3;1587:14;1573:28;;1396:211;;;;:::o;1613:121::-;1691:4;1723;1718:3;1714:14;1706:22;;1613:121;;;:::o;1786:776::-;1911:3;1940:62;1996:5;1940:62;:::i;:::-;2018:84;2095:6;2090:3;2018:84;:::i;:::-;2011:91;;2126:64;2184:5;2126:64;:::i;:::-;2213:7;2244:1;2229:308;2254:6;2251:1;2248:13;2229:308;;;2330:6;2324:13;2357:79;2432:3;2417:13;2357:79;:::i;:::-;2350:86;;2459:68;2520:6;2459:68;:::i;:::-;2449:78;;2289:248;2276:1;2273;2269:9;2264:14;;2229:308;;;2233:14;2553:3;2546:10;;1916:646;;;1786:776;;;;:::o;2568:288::-;2703:10;2738:112;2846:3;2838:6;2738:112;:::i;:::-;2724:126;;2568:288;;;;:::o;2862:146::-;2965:4;2997;2992:3;2988:14;2980:22;;2862:146;;;:::o;3064:1175::-;3249:3;3278:87;3359:5;3278:87;:::i;:::-;3381:119;3493:6;3488:3;3381:119;:::i;:::-;3374:126;;3526:3;3571:4;3563:6;3559:17;3554:3;3550:27;3601:89;3684:5;3601:89;:::i;:::-;3713:7;3744:1;3729:465;3754:6;3751:1;3748:13;3729:465;;;3825:9;3819:4;3815:20;3810:3;3803:33;3876:6;3870:13;3904:130;4029:4;4014:13;3904:130;:::i;:::-;3896:138;;4057:93;4143:6;4057:93;:::i;:::-;4047:103;;4179:4;4174:3;4170:14;4163:21;;3789:405;3776:1;3773;3769:9;3764:14;;3729:465;;;3733:14;4210:4;4203:11;;4230:3;4223:10;;3254:985;;;;;3064:1175;;;;:::o;4245:149::-;4347:6;4381:5;4375:12;4365:22;;4245:149;;;:::o;4400:219::-;4534:11;4568:6;4563:3;4556:19;4608:4;4603:3;4599:14;4584:29;;4400:219;;;;:::o;4625:167::-;4727:4;4750:3;4742:11;;4780:4;4775:3;4771:14;4763:22;;4625:167;;;:::o;4798:124::-;4875:6;4909:5;4903:12;4893:22;;4798:124;;;:::o;4928:184::-;5027:11;5061:6;5056:3;5049:19;5101:4;5096:3;5092:14;5077:29;;4928:184;;;;:::o;5118:142::-;5195:4;5218:3;5210:11;;5248:4;5243:3;5239:14;5231:22;;5118:142;;;:::o;5266:99::-;5318:6;5352:5;5346:12;5336:22;;5266:99;;;:::o;5371:159::-;5445:11;5479:6;5474:3;5467:19;5519:4;5514:3;5510:14;5495:29;;5371:159;;;;:::o;5536:307::-;5604:1;5614:113;5628:6;5625:1;5622:13;5614:113;;;5713:1;5708:3;5704:11;5698:18;5694:1;5689:3;5685:11;5678:39;5650:2;5647:1;5643:10;5638:15;;5614:113;;;5745:6;5742:1;5739:13;5736:101;;;5825:1;5816:6;5811:3;5807:16;5800:27;5736:101;5585:258;5536:307;;;:::o;5849:102::-;5890:6;5941:2;5937:7;5932:2;5925:5;5921:14;5917:28;5907:38;;5849:102;;;:::o;5957:344::-;6035:3;6063:39;6096:5;6063:39;:::i;:::-;6118:61;6172:6;6167:3;6118:61;:::i;:::-;6111:68;;6188:52;6233:6;6228:3;6221:4;6214:5;6210:16;6188:52;:::i;:::-;6265:29;6287:6;6265:29;:::i;:::-;6260:3;6256:39;6249:46;;6039:262;5957:344;;;;:::o;6307:196::-;6396:10;6431:66;6493:3;6485:6;6431:66;:::i;:::-;6417:80;;6307:196;;;;:::o;6509:123::-;6589:4;6621;6616:3;6612:14;6604:22;;6509:123;;;:::o;6666:971::-;6795:3;6824:64;6882:5;6824:64;:::i;:::-;6904:86;6983:6;6978:3;6904:86;:::i;:::-;6897:93;;7016:3;7061:4;7053:6;7049:17;7044:3;7040:27;7091:66;7151:5;7091:66;:::i;:::-;7180:7;7211:1;7196:396;7221:6;7218:1;7215:13;7196:396;;;7292:9;7286:4;7282:20;7277:3;7270:33;7343:6;7337:13;7371:84;7450:4;7435:13;7371:84;:::i;:::-;7363:92;;7478:70;7541:6;7478:70;:::i;:::-;7468:80;;7577:4;7572:3;7568:14;7561:21;;7256:336;7243:1;7240;7236:9;7231:14;;7196:396;;;7200:14;7608:4;7601:11;;7628:3;7621:10;;6800:837;;;;;6666:971;;;;:::o;7643:296::-;7782:10;7817:116;7929:3;7921:6;7817:116;:::i;:::-;7803:130;;7643:296;;;;:::o;7945:148::-;8050:4;8082;8077:3;8073:14;8065:22;;7945:148;;;:::o;8131:1191::-;8320:3;8349:89;8432:5;8349:89;:::i;:::-;8454:121;8568:6;8563:3;8454:121;:::i;:::-;8447:128;;8601:3;8646:4;8638:6;8634:17;8629:3;8625:27;8676:91;8761:5;8676:91;:::i;:::-;8790:7;8821:1;8806:471;8831:6;8828:1;8825:13;8806:471;;;8902:9;8896:4;8892:20;8887:3;8880:33;8953:6;8947:13;8981:134;9110:4;9095:13;8981:134;:::i;:::-;8973:142;;9138:95;9226:6;9138:95;:::i;:::-;9128:105;;9262:4;9257:3;9253:14;9246:21;;8866:411;8853:1;8850;8846:9;8841:14;;8806:471;;;8810:14;9293:4;9286:11;;9313:3;9306:10;;8325:997;;;;;8131:1191;;;;:::o;9328:906::-;9685:4;9723:2;9712:9;9708:18;9700:26;;9772:9;9766:4;9762:20;9758:1;9747:9;9743:17;9736:47;9800:174;9969:4;9960:6;9800:174;:::i;:::-;9792:182;;10021:9;10015:4;10011:20;10006:2;9995:9;9991:18;9984:48;10049:178;10222:4;10213:6;10049:178;:::i;:::-;10041:186;;9328:906;;;;;:::o;10240:75::-;10273:6;10306:2;10300:9;10290:19;;10240:75;:::o;10321:117::-;10430:1;10427;10420:12;10444:117;10553:1;10550;10543:12;10567:77;10604:7;10633:5;10622:16;;10567:77;;;:::o;10650:122::-;10723:24;10741:5;10723:24;:::i;:::-;10716:5;10713:35;10703:63;;10762:1;10759;10752:12;10703:63;10650:122;:::o;10778:139::-;10824:5;10862:6;10849:20;10840:29;;10878:33;10905:5;10878:33;:::i;:::-;10778:139;;;;:::o;10923:117::-;11032:1;11029;11022:12;11046:117;11155:1;11152;11145:12;11169:180;11217:77;11214:1;11207:88;11314:4;11311:1;11304:15;11338:4;11335:1;11328:15;11355:281;11438:27;11460:4;11438:27;:::i;:::-;11430:6;11426:40;11568:6;11556:10;11553:22;11532:18;11520:10;11517:34;11514:62;11511:88;;;11579:18;;:::i;:::-;11511:88;11619:10;11615:2;11608:22;11398:238;11355:281;;:::o;11642:129::-;11676:6;11703:20;;:::i;:::-;11693:30;;11732:33;11760:4;11752:6;11732:33;:::i;:::-;11642:129;;;:::o;11777:308::-;11839:4;11929:18;11921:6;11918:30;11915:56;;;11951:18;;:::i;:::-;11915:56;11989:29;12011:6;11989:29;:::i;:::-;11981:37;;12073:4;12067;12063:15;12055:23;;11777:308;;;:::o;12091:154::-;12175:6;12170:3;12165;12152:30;12237:1;12228:6;12223:3;12219:16;12212:27;12091:154;;;:::o;12251:412::-;12329:5;12354:66;12370:49;12412:6;12370:49;:::i;:::-;12354:66;:::i;:::-;12345:75;;12443:6;12436:5;12429:21;12481:4;12474:5;12470:16;12519:3;12510:6;12505:3;12501:16;12498:25;12495:112;;;12526:79;;:::i;:::-;12495:112;12616:41;12650:6;12645:3;12640;12616:41;:::i;:::-;12335:328;12251:412;;;;;:::o;12683:340::-;12739:5;12788:3;12781:4;12773:6;12769:17;12765:27;12755:122;;12796:79;;:::i;:::-;12755:122;12913:6;12900:20;12938:79;13013:3;13005:6;12998:4;12990:6;12986:17;12938:79;:::i;:::-;12929:88;;12745:278;12683:340;;;;:::o;13029:799::-;13116:6;13124;13132;13181:2;13169:9;13160:7;13156:23;13152:32;13149:119;;;13187:79;;:::i;:::-;13149:119;13307:1;13332:53;13377:7;13368:6;13357:9;13353:22;13332:53;:::i;:::-;13322:63;;13278:117;13434:2;13460:53;13505:7;13496:6;13485:9;13481:22;13460:53;:::i;:::-;13450:63;;13405:118;13590:2;13579:9;13575:18;13562:32;13621:18;13613:6;13610:30;13607:117;;;13643:79;;:::i;:::-;13607:117;13748:63;13803:7;13794:6;13783:9;13779:22;13748:63;:::i;:::-;13738:73;;13533:288;13029:799;;;;;:::o;13834:118::-;13921:24;13939:5;13921:24;:::i;:::-;13916:3;13909:37;13834:118;;:::o;13958:222::-;14051:4;14089:2;14078:9;14074:18;14066:26;;14102:71;14170:1;14159:9;14155:17;14146:6;14102:71;:::i;:::-;13958:222;;;;:::o;14186:474::-;14254:6;14262;14311:2;14299:9;14290:7;14286:23;14282:32;14279:119;;;14317:79;;:::i;:::-;14279:119;14437:1;14462:53;14507:7;14498:6;14487:9;14483:22;14462:53;:::i;:::-;14452:63;;14408:117;14564:2;14590:53;14635:7;14626:6;14615:9;14611:22;14590:53;:::i;:::-;14580:63;;14535:118;14186:474;;;;;:::o;14666:945::-;14762:6;14770;14778;14786;14835:3;14823:9;14814:7;14810:23;14806:33;14803:120;;;14842:79;;:::i;:::-;14803:120;14962:1;14987:53;15032:7;15023:6;15012:9;15008:22;14987:53;:::i;:::-;14977:63;;14933:117;15089:2;15115:53;15160:7;15151:6;15140:9;15136:22;15115:53;:::i;:::-;15105:63;;15060:118;15217:2;15243:53;15288:7;15279:6;15268:9;15264:22;15243:53;:::i;:::-;15233:63;;15188:118;15373:2;15362:9;15358:18;15345:32;15404:18;15396:6;15393:30;15390:117;;;15426:79;;:::i;:::-;15390:117;15531:63;15586:7;15577:6;15566:9;15562:22;15531:63;:::i;:::-;15521:73;;15316:288;14666:945;;;;;;;:::o;15617:159::-;15729:6;15763:5;15757:12;15747:22;;15617:159;;;:::o;15782:229::-;15926:11;15960:6;15955:3;15948:19;16000:4;15995:3;15991:14;15976:29;;15782:229;;;;:::o;16017:177::-;16129:4;16152:3;16144:11;;16182:4;16177:3;16173:14;16165:22;;16017:177;;;:::o;16200:134::-;16287:6;16321:5;16315:12;16305:22;;16200:134;;;:::o;16340:194::-;16449:11;16483:6;16478:3;16471:19;16523:4;16518:3;16514:14;16499:29;;16340:194;;;;:::o;16540:152::-;16627:4;16650:3;16642:11;;16680:4;16675:3;16671:14;16663:22;;16540:152;;;:::o;16698:108::-;16775:24;16793:5;16775:24;:::i;:::-;16770:3;16763:37;16698:108;;:::o;16812:134::-;16899:6;16933:5;16927:12;16917:22;;16812:134;;;:::o;16952:194::-;17061:11;17095:6;17090:3;17083:19;17135:4;17130:3;17126:14;17111:29;;16952:194;;;;:::o;17152:152::-;17239:4;17262:3;17254:11;;17292:4;17287:3;17283:14;17275:22;;17152:152;;;:::o;17372:604::-;17471:3;17507:4;17502:3;17498:14;17595:4;17588:5;17584:16;17578:23;17614:79;17687:4;17682:3;17678:14;17664:12;17614:79;:::i;:::-;17522:181;17786:4;17779:5;17775:16;17769:23;17839:3;17833:4;17829:14;17822:4;17817:3;17813:14;17806:38;17865:73;17933:4;17919:12;17865:73;:::i;:::-;17857:81;;17713:236;17966:4;17959:11;;17476:500;17372:604;;;;:::o;17982:236::-;18091:10;18126:86;18208:3;18200:6;18126:86;:::i;:::-;18112:100;;17982:236;;;;:::o;18224:133::-;18314:4;18346;18341:3;18337:14;18329:22;;18224:133;;;:::o;18429:1051::-;18578:3;18607:74;18675:5;18607:74;:::i;:::-;18697:96;18786:6;18781:3;18697:96;:::i;:::-;18690:103;;18819:3;18864:4;18856:6;18852:17;18847:3;18843:27;18894:76;18964:5;18894:76;:::i;:::-;18993:7;19024:1;19009:426;19034:6;19031:1;19028:13;19009:426;;;19105:9;19099:4;19095:20;19090:3;19083:33;19156:6;19150:13;19184:104;19283:4;19268:13;19184:104;:::i;:::-;19176:112;;19311:80;19384:6;19311:80;:::i;:::-;19301:90;;19420:4;19415:3;19411:14;19404:21;;19069:366;19056:1;19053;19049:9;19044:14;;19009:426;;;19013:14;19451:4;19444:11;;19471:3;19464:10;;18583:897;;;;;18429:1051;;;;:::o;19546:663::-;19645:3;19681:4;19676:3;19672:14;19773:4;19766:5;19762:16;19756:23;19792:63;19849:4;19844:3;19840:14;19826:12;19792:63;:::i;:::-;19696:169;19949:4;19942:5;19938:16;19932:23;20002:3;19996:4;19992:14;19985:4;19980:3;19976:14;19969:38;20028:143;20166:4;20152:12;20028:143;:::i;:::-;20020:151;;19875:307;20199:4;20192:11;;19650:559;19546:663;;;;:::o;20215:236::-;20324:10;20359:86;20441:3;20433:6;20359:86;:::i;:::-;20345:100;;20215:236;;;;:::o;20457:133::-;20547:4;20579;20574:3;20570:14;20562:22;;20457:133;;;:::o;20660:1051::-;20809:3;20838:74;20906:5;20838:74;:::i;:::-;20928:96;21017:6;21012:3;20928:96;:::i;:::-;20921:103;;21050:3;21095:4;21087:6;21083:17;21078:3;21074:27;21125:76;21195:5;21125:76;:::i;:::-;21224:7;21255:1;21240:426;21265:6;21262:1;21259:13;21240:426;;;21336:9;21330:4;21326:20;21321:3;21314:33;21387:6;21381:13;21415:104;21514:4;21499:13;21415:104;:::i;:::-;21407:112;;21542:80;21615:6;21542:80;:::i;:::-;21532:90;;21651:4;21646:3;21642:14;21635:21;;21300:366;21287:1;21284;21280:9;21275:14;;21240:426;;;21244:14;21682:4;21675:11;;21702:3;21695:10;;20814:897;;;;;20660:1051;;;;:::o;21717:336::-;21876:10;21911:136;22043:3;22035:6;21911:136;:::i;:::-;21897:150;;21717:336;;;;:::o;22059:158::-;22174:4;22206;22201:3;22197:14;22189:22;;22059:158;;;:::o;22291:1271::-;22500:3;22529:99;22622:5;22529:99;:::i;:::-;22644:131;22768:6;22763:3;22644:131;:::i;:::-;22637:138;;22801:3;22846:4;22838:6;22834:17;22829:3;22825:27;22876:101;22971:5;22876:101;:::i;:::-;23000:7;23031:1;23016:501;23041:6;23038:1;23035:13;23016:501;;;23112:9;23106:4;23102:20;23097:3;23090:33;23163:6;23157:13;23191:154;23340:4;23325:13;23191:154;:::i;:::-;23183:162;;23368:105;23466:6;23368:105;:::i;:::-;23358:115;;23502:4;23497:3;23493:14;23486:21;;23076:441;23063:1;23060;23056:9;23051:14;;23016:501;;;23020:14;23533:4;23526:11;;23553:3;23546:10;;22505:1057;;;;;22291:1271;;;;:::o;23568:553::-;23801:4;23839:2;23828:9;23824:18;23816:26;;23888:9;23882:4;23878:20;23874:1;23863:9;23859:17;23852:47;23916:198;24109:4;24100:6;23916:198;:::i;:::-;23908:206;;23568:553;;;;:::o;24127:60::-;24155:3;24176:5;24169:12;;24127:60;;;:::o;24193:142::-;24243:9;24276:53;24294:34;24303:24;24321:5;24303:24;:::i;:::-;24294:34;:::i;:::-;24276:53;:::i;:::-;24263:66;;24193:142;;;:::o;24341:126::-;24391:9;24424:37;24455:5;24424:37;:::i;:::-;24411:50;;24341:126;;;:::o;24473:147::-;24544:9;24577:37;24608:5;24577:37;:::i;:::-;24564:50;;24473:147;;;:::o;24626:173::-;24734:58;24786:5;24734:58;:::i;:::-;24729:3;24722:71;24626:173;;:::o;24805:264::-;24919:4;24957:2;24946:9;24942:18;24934:26;;24970:92;25059:1;25048:9;25044:17;25035:6;24970:92;:::i;:::-;24805:264;;;;:::o;25075:90::-;25109:7;25152:5;25145:13;25138:21;25127:32;;25075:90;;;:::o;25171:109::-;25252:21;25267:5;25252:21;:::i;:::-;25247:3;25240:34;25171:109;;:::o;25286:210::-;25373:4;25411:2;25400:9;25396:18;25388:26;;25424:65;25486:1;25475:9;25471:17;25462:6;25424:65;:::i;:::-;25286:210;;;;:::o;25502:142::-;25605:32;25631:5;25605:32;:::i;:::-;25600:3;25593:45;25502:142;;:::o;25650:169::-;25734:11;25768:6;25763:3;25756:19;25808:4;25803:3;25799:14;25784:29;;25650:169;;;;:::o;25825:364::-;25913:3;25941:39;25974:5;25941:39;:::i;:::-;25996:71;26060:6;26055:3;25996:71;:::i;:::-;25989:78;;26076:52;26121:6;26116:3;26109:4;26102:5;26098:16;26076:52;:::i;:::-;26153:29;26175:6;26153:29;:::i;:::-;26148:3;26144:39;26137:46;;25917:272;25825:364;;;;:::o;26195:455::-;26352:4;26390:2;26379:9;26375:18;26367:26;;26403:87;26487:1;26476:9;26472:17;26463:6;26403:87;:::i;:::-;26537:9;26531:4;26527:20;26522:2;26511:9;26507:18;26500:48;26565:78;26638:4;26629:6;26565:78;:::i;:::-;26557:86;;26195:455;;;;;:::o;26656:96::-;26693:7;26722:24;26740:5;26722:24;:::i;:::-;26711:35;;26656:96;;;:::o;26758:118::-;26845:24;26863:5;26845:24;:::i;:::-;26840:3;26833:37;26758:118;;:::o;26882:222::-;26975:4;27013:2;27002:9;26998:18;26990:26;;27026:71;27094:1;27083:9;27079:17;27070:6;27026:71;:::i;:::-;26882:222;;;;:::o;27110:533::-;27279:4;27317:2;27306:9;27302:18;27294:26;;27330:71;27398:1;27387:9;27383:17;27374:6;27330:71;:::i;:::-;27448:9;27442:4;27438:20;27433:2;27422:9;27418:18;27411:48;27476:78;27549:4;27540:6;27476:78;:::i;:::-;27468:86;;27564:72;27632:2;27621:9;27617:18;27608:6;27564:72;:::i;:::-;27110:533;;;;;;:::o;27649:313::-;27762:4;27800:2;27789:9;27785:18;27777:26;;27849:9;27843:4;27839:20;27835:1;27824:9;27820:17;27813:47;27877:78;27950:4;27941:6;27877:78;:::i;:::-;27869:86;;27649:313;;;;:::o;27968:173::-;28108:25;28104:1;28096:6;28092:14;28085:49;27968:173;:::o;28147:366::-;28289:3;28310:67;28374:2;28369:3;28310:67;:::i;:::-;28303:74;;28386:93;28475:3;28386:93;:::i;:::-;28504:2;28499:3;28495:12;28488:19;;28147:366;;;:::o;28519:419::-;28685:4;28723:2;28712:9;28708:18;28700:26;;28772:9;28766:4;28762:20;28758:1;28747:9;28743:17;28736:47;28800:131;28926:4;28800:131;:::i;:::-;28792:139;;28519:419;;;:::o;28944:180::-;28992:77;28989:1;28982:88;29089:4;29086:1;29079:15;29113:4;29110:1;29103:15;29130:180;29178:77;29175:1;29168:88;29275:4;29272:1;29265:15;29299:4;29296:1;29289:15;29316:233;29355:3;29378:24;29396:5;29378:24;:::i;:::-;29369:33;;29424:66;29417:5;29414:77;29411:103;;29494:18;;:::i;:::-;29411:103;29541:1;29534:5;29530:13;29523:20;;29316:233;;;:::o;29555:170::-;29695:22;29691:1;29683:6;29679:14;29672:46;29555:170;:::o;29731:366::-;29873:3;29894:67;29958:2;29953:3;29894:67;:::i;:::-;29887:74;;29970:93;30059:3;29970:93;:::i;:::-;30088:2;30083:3;30079:12;30072:19;;29731:366;;;:::o;30103:419::-;30269:4;30307:2;30296:9;30292:18;30284:26;;30356:9;30350:4;30346:20;30342:1;30331:9;30327:17;30320:47;30384:131;30510:4;30384:131;:::i;:::-;30376:139;;30103:419;;;:::o;30528:170::-;30668:22;30664:1;30656:6;30652:14;30645:46;30528:170;:::o;30704:366::-;30846:3;30867:67;30931:2;30926:3;30867:67;:::i;:::-;30860:74;;30943:93;31032:3;30943:93;:::i;:::-;31061:2;31056:3;31052:12;31045:19;;30704:366;;;:::o;31076:419::-;31242:4;31280:2;31269:9;31265:18;31257:26;;31329:9;31323:4;31319:20;31315:1;31304:9;31300:17;31293:47;31357:131;31483:4;31357:131;:::i;:::-;31349:139;;31076:419;;;:::o;31501:177::-;31641:29;31637:1;31629:6;31625:14;31618:53;31501:177;:::o;31684:366::-;31826:3;31847:67;31911:2;31906:3;31847:67;:::i;:::-;31840:74;;31923:93;32012:3;31923:93;:::i;:::-;32041:2;32036:3;32032:12;32025:19;;31684:366;;;:::o;32056:419::-;32222:4;32260:2;32249:9;32245:18;32237:26;;32309:9;32303:4;32299:20;32295:1;32284:9;32280:17;32273:47;32337:131;32463:4;32337:131;:::i;:::-;32329:139;;32056:419;;;:::o;32481:224::-;32621:34;32617:1;32609:6;32605:14;32598:58;32690:7;32685:2;32677:6;32673:15;32666:32;32481:224;:::o;32711:366::-;32853:3;32874:67;32938:2;32933:3;32874:67;:::i;:::-;32867:74;;32950:93;33039:3;32950:93;:::i;:::-;33068:2;33063:3;33059:12;33052:19;;32711:366;;;:::o;33083:419::-;33249:4;33287:2;33276:9;33272:18;33264:26;;33336:9;33330:4;33326:20;33322:1;33311:9;33307:17;33300:47;33364:131;33490:4;33364:131;:::i;:::-;33356:139;;33083:419;;;:::o;33508:170::-;33648:22;33644:1;33636:6;33632:14;33625:46;33508:170;:::o;33684:366::-;33826:3;33847:67;33911:2;33906:3;33847:67;:::i;:::-;33840:74;;33923:93;34012:3;33923:93;:::i;:::-;34041:2;34036:3;34032:12;34025:19;;33684:366;;;:::o;34056:419::-;34222:4;34260:2;34249:9;34245:18;34237:26;;34309:9;34303:4;34299:20;34295:1;34284:9;34280:17;34273:47;34337:131;34463:4;34337:131;:::i;:::-;34329:139;;34056:419;;;:::o;34481:180::-;34529:77;34526:1;34519:88;34626:4;34623:1;34616:15;34650:4;34647:1;34640:15;34667:320;34711:6;34748:1;34742:4;34738:12;34728:22;;34795:1;34789:4;34785:12;34816:18;34806:81;;34872:4;34864:6;34860:17;34850:27;;34806:81;34934:2;34926:6;34923:14;34903:18;34900:38;34897:84;;34953:18;;:::i;:::-;34897:84;34718:269;34667:320;;;:::o;34993:143::-;35050:5;35081:6;35075:13;35066:22;;35097:33;35124:5;35097:33;:::i;:::-;34993:143;;;;:::o;35142:351::-;35212:6;35261:2;35249:9;35240:7;35236:23;35232:32;35229:119;;;35267:79;;:::i;:::-;35229:119;35387:1;35412:64;35468:7;35459:6;35448:9;35444:22;35412:64;:::i;:::-;35402:74;;35358:128;35142:351;;;;:::o;35499:220::-;35639:34;35635:1;35627:6;35623:14;35616:58;35708:3;35703:2;35695:6;35691:15;35684:28;35499:220;:::o;35725:366::-;35867:3;35888:67;35952:2;35947:3;35888:67;:::i;:::-;35881:74;;35964:93;36053:3;35964:93;:::i;:::-;36082:2;36077:3;36073:12;36066:19;;35725:366;;;:::o;36097:419::-;36263:4;36301:2;36290:9;36286:18;36278:26;;36350:9;36344:4;36340:20;36336:1;36325:9;36321:17;36314:47;36378:131;36504:4;36378:131;:::i;:::-;36370:139;;36097:419;;;:::o;36522:191::-;36562:4;36582:20;36600:1;36582:20;:::i;:::-;36577:25;;36616:20;36634:1;36616:20;:::i;:::-;36611:25;;36655:1;36652;36649:8;36646:34;;;36660:18;;:::i;:::-;36646:34;36705:1;36702;36698:9;36690:17;;36522:191;;;;:::o;36719:348::-;36759:7;36782:20;36800:1;36782:20;:::i;:::-;36777:25;;36816:20;36834:1;36816:20;:::i;:::-;36811:25;;37004:1;36936:66;36932:74;36929:1;36926:81;36921:1;36914:9;36907:17;36903:105;36900:131;;;37011:18;;:::i;:::-;36900:131;37059:1;37056;37052:9;37041:20;;36719:348;;;;:::o;37073:305::-;37113:3;37132:20;37150:1;37132:20;:::i;:::-;37127:25;;37166:20;37184:1;37166:20;:::i;:::-;37161:25;;37320:1;37252:66;37248:74;37245:1;37242:81;37239:107;;;37326:18;;:::i;:::-;37239:107;37370:1;37367;37363:9;37356:16;;37073:305;;;;:::o;37384:225::-;37524:34;37520:1;37512:6;37508:14;37501:58;37593:8;37588:2;37580:6;37576:15;37569:33;37384:225;:::o;37615:366::-;37757:3;37778:67;37842:2;37837:3;37778:67;:::i;:::-;37771:74;;37854:93;37943:3;37854:93;:::i;:::-;37972:2;37967:3;37963:12;37956:19;;37615:366;;;:::o;37987:419::-;38153:4;38191:2;38180:9;38176:18;38168:26;;38240:9;38234:4;38230:20;38226:1;38215:9;38211:17;38204:47;38268:131;38394:4;38268:131;:::i;:::-;38260:139;;37987:419;;;:::o;38412:180::-;38460:77;38457:1;38450:88;38557:4;38554:1;38547:15;38581:4;38578:1;38571:15;38598:185;38638:1;38655:20;38673:1;38655:20;:::i;:::-;38650:25;;38689:20;38707:1;38689:20;:::i;:::-;38684:25;;38728:1;38718:35;;38733:18;;:::i;:::-;38718:35;38775:1;38772;38768:9;38763:14;;38598:185;;;;:::o;38789:168::-;38929:20;38925:1;38917:6;38913:14;38906:44;38789:168;:::o;38963:366::-;39105:3;39126:67;39190:2;39185:3;39126:67;:::i;:::-;39119:74;;39202:93;39291:3;39202:93;:::i;:::-;39320:2;39315:3;39311:12;39304:19;;38963:366;;;:::o;39335:419::-;39501:4;39539:2;39528:9;39524:18;39516:26;;39588:9;39582:4;39578:20;39574:1;39563:9;39559:17;39552:47;39616:131;39742:4;39616:131;:::i;:::-;39608:139;;39335:419;;;:::o;39760:644::-;39957:4;39995:3;39984:9;39980:19;39972:27;;40009:71;40077:1;40066:9;40062:17;40053:6;40009:71;:::i;:::-;40090:72;40158:2;40147:9;40143:18;40134:6;40090:72;:::i;:::-;40172;40240:2;40229:9;40225:18;40216:6;40172:72;:::i;:::-;40291:9;40285:4;40281:20;40276:2;40265:9;40261:18;40254:48;40319:78;40392:4;40383:6;40319:78;:::i;:::-;40311:86;;39760:644;;;;;;;:::o;40410:170::-;40550:22;40546:1;40538:6;40534:14;40527:46;40410:170;:::o;40586:366::-;40728:3;40749:67;40813:2;40808:3;40749:67;:::i;:::-;40742:74;;40825:93;40914:3;40825:93;:::i;:::-;40943:2;40938:3;40934:12;40927:19;;40586:366;;;:::o;40958:419::-;41124:4;41162:2;41151:9;41147:18;41139:26;;41211:9;41205:4;41201:20;41197:1;41186:9;41182:17;41175:47;41239:131;41365:4;41239:131;:::i;:::-;41231:139;;40958:419;;;:::o;41383:170::-;41523:22;41519:1;41511:6;41507:14;41500:46;41383:170;:::o;41559:366::-;41701:3;41722:67;41786:2;41781:3;41722:67;:::i;:::-;41715:74;;41798:93;41887:3;41798:93;:::i;:::-;41916:2;41911:3;41907:12;41900:19;;41559:366;;;:::o;41931:419::-;42097:4;42135:2;42124:9;42120:18;42112:26;;42184:9;42178:4;42174:20;42170:1;42159:9;42155:17;42148:47;42212:131;42338:4;42212:131;:::i;:::-;42204:139;;41931:419;;;:::o","source":"// SPDX-License-Identifier: MIT\\npragma solidity >=0.4.22 <0.9.0;\\n\\nimport \\"./BaseContract.sol\\";\\nimport \\"./DataStorage2.sol\\";\\n\\ncontract Pixelflux2 is BaseContract, DataStorage2 {\\n    bool public isEnabled = false;\\n    BaseContract public baseContract;\\n\\n    event ContractEnabled();\\n\\n    function isContractEnabled() public override view returns(bool) {\\n        return isEnabled;\\n    }\\n\\n    constructor(address _baseContractAddress) {\\n        baseContract = BaseContract(_baseContractAddress);\\n    }\\n\\n    function enableContract() public onlyOwner {\\n        uint256 totalValue = baseContract.calculateTotalValue();\\n        require(totalValue >= 3200 * 10**9, \\"Not enough total value in Stage 1\\");\\n        isEnabled = true;\\n        emit ContractEnabled();\\n    }\\n\\n    function getInitialValue(uint x, uint y) internal override view returns (uint256, string memory) {\\n        require(x < gridWidth, \\"Invalid x-coordinate\\");\\n        require(y < gridHeight, \\"Invalid y-coordinate\\");\\n        return (initialValues[y][x], colorValues[y][x]);\\n    }\\n    function getGridWidth() internal override pure returns (uint256) {\\n        return gridWidth;\\n    }\\n\\n    function getGridHeight() internal override pure returns (uint256) {\\n        return gridHeight;\\n    }\\n}\\n","sourcePath":"/home/wao/Meteor/Workspace/Sao/polygon/contracts/Pixelflux2.sol","ast":{"absolutePath":"project:/contracts/Pixelflux2.sol","exportedSymbols":{"BaseContract":[1001],"DataStorage2":[3535],"Pixelflux2":[5002]},"id":5003,"license":"MIT","nodeType":"SourceUnit","nodes":[{"id":4879,"literals":["solidity",">=","0.4",".22","<","0.9",".0"],"nodeType":"PragmaDirective","src":"32:32:5"},{"absolutePath":"project:/contracts/BaseContract.sol","file":"./BaseContract.sol","id":4880,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":5003,"sourceUnit":1002,"src":"66:28:5","symbolAliases":[],"unitAlias":""},{"absolutePath":"project:/contracts/DataStorage2.sol","file":"./DataStorage2.sol","id":4881,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":5003,"sourceUnit":3536,"src":"95:28:5","symbolAliases":[],"unitAlias":""},{"abstract":false,"baseContracts":[{"baseName":{"id":4882,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"148:12:5"},"id":4883,"nodeType":"InheritanceSpecifier","src":"148:12:5"},{"baseName":{"id":4884,"name":"DataStorage2","nodeType":"IdentifierPath","referencedDeclaration":3535,"src":"162:12:5"},"id":4885,"nodeType":"InheritanceSpecifier","src":"162:12:5"}],"canonicalName":"Pixelflux2","contractDependencies":[],"contractKind":"contract","fullyImplemented":true,"id":5002,"linearizedBaseContracts":[5002,3535,1001],"name":"Pixelflux2","nameLocation":"134:10:5","nodeType":"ContractDefinition","nodes":[{"constant":false,"functionSelector":"6aa633b6","id":4888,"mutability":"mutable","name":"isEnabled","nameLocation":"193:9:5","nodeType":"VariableDeclaration","scope":5002,"src":"181:29:5","stateVariable":true,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":4886,"name":"bool","nodeType":"ElementaryTypeName","src":"181:4:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"value":{"hexValue":"66616c7365","id":4887,"isConstant":false,"isLValue":false,"isPure":true,"kind":"bool","lValueRequested":false,"nodeType":"Literal","src":"205:5:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"value":"false"},"visibility":"public"},{"constant":false,"functionSelector":"5b32619c","id":4891,"mutability":"mutable","name":"baseContract","nameLocation":"236:12:5","nodeType":"VariableDeclaration","scope":5002,"src":"216:32:5","stateVariable":true,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"},"typeName":{"id":4890,"nodeType":"UserDefinedTypeName","pathNode":{"id":4889,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"216:12:5"},"referencedDeclaration":1001,"src":"216:12:5","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"visibility":"public"},{"anonymous":false,"eventSelector":"961479333f7baab3eea2ead54f4113612e06058e0f3cdd932672aa14bcd831c2","id":4893,"name":"ContractEnabled","nameLocation":"261:15:5","nodeType":"EventDefinition","parameters":{"id":4892,"nodeType":"ParameterList","parameters":[],"src":"276:2:5"},"src":"255:24:5"},{"baseFunctions":[52],"body":{"id":4901,"nodeType":"Block","src":"349:33:5","statements":[{"expression":{"id":4899,"name":"isEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4888,"src":"366:9:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"functionReturnParameters":4898,"id":4900,"nodeType":"Return","src":"359:16:5"}]},"functionSelector":"9d602d2d","id":4902,"implemented":true,"kind":"function","modifiers":[],"name":"isContractEnabled","nameLocation":"294:17:5","nodeType":"FunctionDefinition","overrides":{"id":4895,"nodeType":"OverrideSpecifier","overrides":[],"src":"321:8:5"},"parameters":{"id":4894,"nodeType":"ParameterList","parameters":[],"src":"311:2:5"},"returnParameters":{"id":4898,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4897,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4902,"src":"343:4:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":4896,"name":"bool","nodeType":"ElementaryTypeName","src":"343:4:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"visibility":"internal"}],"src":"342:6:5"},"scope":5002,"src":"285:97:5","stateMutability":"view","virtual":false,"visibility":"public"},{"body":{"id":4913,"nodeType":"Block","src":"430:66:5","statements":[{"expression":{"id":4911,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"id":4907,"name":"baseContract","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4891,"src":"440:12:5","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"arguments":[{"id":4909,"name":"_baseContractAddress","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4904,"src":"468:20:5","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_address","typeString":"address"}],"id":4908,"name":"BaseContract","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1001,"src":"455:12:5","typeDescriptions":{"typeIdentifier":"t_type$_t_contract$_BaseContract_$1001_$","typeString":"type(contract BaseContract)"}},"id":4910,"isConstant":false,"isLValue":false,"isPure":false,"kind":"typeConversion","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"455:34:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"src":"440:49:5","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":4912,"nodeType":"ExpressionStatement","src":"440:49:5"}]},"id":4914,"implemented":true,"kind":"constructor","modifiers":[],"name":"","nameLocation":"-1:-1:-1","nodeType":"FunctionDefinition","parameters":{"id":4905,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4904,"mutability":"mutable","name":"_baseContractAddress","nameLocation":"408:20:5","nodeType":"VariableDeclaration","scope":4914,"src":"400:28:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"},"typeName":{"id":4903,"name":"address","nodeType":"ElementaryTypeName","src":"400:7:5","stateMutability":"nonpayable","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},"visibility":"internal"}],"src":"399:30:5"},"returnParameters":{"id":4906,"nodeType":"ParameterList","parameters":[],"src":"430:0:5"},"scope":5002,"src":"388:108:5","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"body":{"id":4943,"nodeType":"Block","src":"545:212:5","statements":[{"assignments":[4920],"declarations":[{"constant":false,"id":4920,"mutability":"mutable","name":"totalValue","nameLocation":"563:10:5","nodeType":"VariableDeclaration","scope":4943,"src":"555:18:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4919,"name":"uint256","nodeType":"ElementaryTypeName","src":"555:7:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"id":4924,"initialValue":{"arguments":[],"expression":{"argumentTypes":[],"expression":{"id":4921,"name":"baseContract","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4891,"src":"576:12:5","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":4922,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"memberName":"calculateTotalValue","nodeType":"MemberAccess","referencedDeclaration":572,"src":"576:32:5","typeDescriptions":{"typeIdentifier":"t_function_external_view$__$returns$_t_uint256_$","typeString":"function () view external returns (uint256)"}},"id":4923,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"576:34:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"VariableDeclarationStatement","src":"555:55:5"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":4932,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":4926,"name":"totalValue","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4920,"src":"628:10:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":">=","rightExpression":{"commonType":{"typeIdentifier":"t_rational_3200000000000_by_1","typeString":"int_const 3200000000000"},"id":4931,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"33323030","id":4927,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"642:4:5","typeDescriptions":{"typeIdentifier":"t_rational_3200_by_1","typeString":"int_const 3200"},"value":"3200"},"nodeType":"BinaryOperation","operator":"*","rightExpression":{"commonType":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"},"id":4930,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"3130","id":4928,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"649:2:5","typeDescriptions":{"typeIdentifier":"t_rational_10_by_1","typeString":"int_const 10"},"value":"10"},"nodeType":"BinaryOperation","operator":"**","rightExpression":{"hexValue":"39","id":4929,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"653:1:5","typeDescriptions":{"typeIdentifier":"t_rational_9_by_1","typeString":"int_const 9"},"value":"9"},"src":"649:5:5","typeDescriptions":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"}},"src":"642:12:5","typeDescriptions":{"typeIdentifier":"t_rational_3200000000000_by_1","typeString":"int_const 3200000000000"}},"src":"628:26:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e2053746167652031","id":4933,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"656:35:5","typeDescriptions":{"typeIdentifier":"t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","typeString":"literal_string \\"Not enough total value in Stage 1\\""},"value":"Not enough total value in Stage 1"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","typeString":"literal_string \\"Not enough total value in Stage 1\\""}],"id":4925,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"620:7:5","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":4934,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"620:72:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4935,"nodeType":"ExpressionStatement","src":"620:72:5"},{"expression":{"id":4938,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"id":4936,"name":"isEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4888,"src":"702:9:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"hexValue":"74727565","id":4937,"isConstant":false,"isLValue":false,"isPure":true,"kind":"bool","lValueRequested":false,"nodeType":"Literal","src":"714:4:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"value":"true"},"src":"702:16:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"id":4939,"nodeType":"ExpressionStatement","src":"702:16:5"},{"eventCall":{"arguments":[],"expression":{"argumentTypes":[],"id":4940,"name":"ContractEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4893,"src":"733:15:5","typeDescriptions":{"typeIdentifier":"t_function_event_nonpayable$__$returns$__$","typeString":"function ()"}},"id":4941,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"733:17:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4942,"nodeType":"EmitStatement","src":"728:22:5"}]},"functionSelector":"367edd32","id":4944,"implemented":true,"kind":"function","modifiers":[{"id":4917,"kind":"modifierInvocation","modifierName":{"id":4916,"name":"onlyOwner","nodeType":"IdentifierPath","referencedDeclaration":95,"src":"535:9:5"},"nodeType":"ModifierInvocation","src":"535:9:5"}],"name":"enableContract","nameLocation":"511:14:5","nodeType":"FunctionDefinition","parameters":{"id":4915,"nodeType":"ParameterList","parameters":[],"src":"525:2:5"},"returnParameters":{"id":4918,"nodeType":"ParameterList","parameters":[],"src":"545:0:5"},"scope":5002,"src":"502:255:5","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"baseFunctions":[63],"body":{"id":4982,"nodeType":"Block","src":"860:177:5","statements":[{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":4959,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":4957,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4946,"src":"878:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":4958,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2200,"src":"882:9:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"878:13:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420782d636f6f7264696e617465","id":4960,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"893:22:5","typeDescriptions":{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""},"value":"Invalid x-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""}],"id":4956,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"870:7:5","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":4961,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"870:46:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4962,"nodeType":"ExpressionStatement","src":"870:46:5"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":4966,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":4964,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4948,"src":"934:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":4965,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2203,"src":"938:10:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"934:14:5","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420792d636f6f7264696e617465","id":4967,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"950:22:5","typeDescriptions":{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""},"value":"Invalid y-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""}],"id":4963,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"926:7:5","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":4968,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"926:47:5","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":4969,"nodeType":"ExpressionStatement","src":"926:47:5"},{"expression":{"components":[{"baseExpression":{"baseExpression":{"id":4970,"name":"initialValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2209,"src":"991:13:5","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_uint256_$33_storage_$33_storage","typeString":"uint256[33] storage ref[33] storage ref"}},"id":4972,"indexExpression":{"id":4971,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4948,"src":"1005:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"991:16:5","typeDescriptions":{"typeIdentifier":"t_array$_t_uint256_$33_storage","typeString":"uint256[33] storage ref"}},"id":4974,"indexExpression":{"id":4973,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4946,"src":"1008:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"991:19:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},{"baseExpression":{"baseExpression":{"id":4975,"name":"colorValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3534,"src":"1012:11:5","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_string_storage_$33_storage_$33_storage","typeString":"string storage ref[33] storage ref[33] storage ref"}},"id":4977,"indexExpression":{"id":4976,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4948,"src":"1024:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1012:14:5","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$33_storage","typeString":"string storage ref[33] storage ref"}},"id":4979,"indexExpression":{"id":4978,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4946,"src":"1027:1:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1012:17:5","typeDescriptions":{"typeIdentifier":"t_string_storage","typeString":"string storage ref"}}],"id":4980,"isConstant":false,"isInlineArray":false,"isLValue":false,"isPure":false,"lValueRequested":false,"nodeType":"TupleExpression","src":"990:40:5","typeDescriptions":{"typeIdentifier":"t_tuple$_t_uint256_$_t_string_storage_$","typeString":"tuple(uint256,string storage ref)"}},"functionReturnParameters":4955,"id":4981,"nodeType":"Return","src":"983:47:5"}]},"id":4983,"implemented":true,"kind":"function","modifiers":[],"name":"getInitialValue","nameLocation":"772:15:5","nodeType":"FunctionDefinition","overrides":{"id":4950,"nodeType":"OverrideSpecifier","overrides":[],"src":"813:8:5"},"parameters":{"id":4949,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4946,"mutability":"mutable","name":"x","nameLocation":"793:1:5","nodeType":"VariableDeclaration","scope":4983,"src":"788:6:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4945,"name":"uint","nodeType":"ElementaryTypeName","src":"788:4:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":4948,"mutability":"mutable","name":"y","nameLocation":"801:1:5","nodeType":"VariableDeclaration","scope":4983,"src":"796:6:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4947,"name":"uint","nodeType":"ElementaryTypeName","src":"796:4:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"787:16:5"},"returnParameters":{"id":4955,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4952,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4983,"src":"836:7:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4951,"name":"uint256","nodeType":"ElementaryTypeName","src":"836:7:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":4954,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4983,"src":"845:13:5","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string"},"typeName":{"id":4953,"name":"string","nodeType":"ElementaryTypeName","src":"845:6:5","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"visibility":"internal"}],"src":"835:24:5"},"scope":5002,"src":"763:274:5","stateMutability":"view","virtual":false,"visibility":"internal"},{"baseFunctions":[68],"body":{"id":4991,"nodeType":"Block","src":"1107:33:5","statements":[{"expression":{"id":4989,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2200,"src":"1124:9:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":4988,"id":4990,"nodeType":"Return","src":"1117:16:5"}]},"id":4992,"implemented":true,"kind":"function","modifiers":[],"name":"getGridWidth","nameLocation":"1051:12:5","nodeType":"FunctionDefinition","overrides":{"id":4985,"nodeType":"OverrideSpecifier","overrides":[],"src":"1075:8:5"},"parameters":{"id":4984,"nodeType":"ParameterList","parameters":[],"src":"1063:2:5"},"returnParameters":{"id":4988,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4987,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":4992,"src":"1098:7:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4986,"name":"uint256","nodeType":"ElementaryTypeName","src":"1098:7:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"1097:9:5"},"scope":5002,"src":"1042:98:5","stateMutability":"pure","virtual":false,"visibility":"internal"},{"baseFunctions":[73],"body":{"id":5000,"nodeType":"Block","src":"1212:34:5","statements":[{"expression":{"id":4998,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":2203,"src":"1229:10:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":4997,"id":4999,"nodeType":"Return","src":"1222:17:5"}]},"id":5001,"implemented":true,"kind":"function","modifiers":[],"name":"getGridHeight","nameLocation":"1155:13:5","nodeType":"FunctionDefinition","overrides":{"id":4994,"nodeType":"OverrideSpecifier","overrides":[],"src":"1180:8:5"},"parameters":{"id":4993,"nodeType":"ParameterList","parameters":[],"src":"1168:2:5"},"returnParameters":{"id":4997,"nodeType":"ParameterList","parameters":[{"constant":false,"id":4996,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5001,"src":"1203:7:5","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":4995,"name":"uint256","nodeType":"ElementaryTypeName","src":"1203:7:5","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"1202:9:5"},"scope":5002,"src":"1146:100:5","stateMutability":"pure","virtual":false,"visibility":"internal"}],"scope":5003,"src":"125:1123:5","usedErrors":[]}],"src":"32:1217:5"},"compiler":{"name":"solc","version":"0.8.13+commit.abaa5c0e.Emscripten.clang"},"networks":{"137":{"events":{"0x961479333f7baab3eea2ead54f4113612e06058e0f3cdd932672aa14bcd831c2":{"anonymous":false,"inputs":[],"name":"ContractEnabled","type":"event"},"0xe658510eab96e65991bb68ee771137bf387eaa3dc4a16189ea0f525766e76b2a":{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"}},"links":{},"address":"0x538D71D91a9301c0231fFC643fAdB829d15B06Bd","transactionHash":"0x4b6a18d53cad5351427dcd82b0cc12b181e1aab5be99909be37714d454b3b372"},"5777":{"events":{"0x74835083a92d7d0acad57e178b18330365b1b26c97ea060802582e61f95b54d2":{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"width","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"height","type":"uint256"}],"name":"LogGridDimensions","type":"event"}},"links":{},"address":"0xc5e1BEb78aD51Ff0855e620f880A07999710d0f8","transactionHash":"0x6ad71d5d232ea808452c36cc70c6756c4b7200757f40caeea805512b309d4f52"}},"schemaVersion":"3.4.13","updatedAt":"2023-09-30T04:41:41.219Z","networkType":"ethereum","devdoc":{"kind":"dev","methods":{},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}}');


var $bcf0a78d52f6143d$exports = {};
$bcf0a78d52f6143d$exports = JSON.parse('{"contractName":"Pixelflux3","abi":[{"inputs":[{"internalType":"address","name":"_baseContractAddress1","type":"address"},{"internalType":"address","name":"_baseContractAddress2","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[],"name":"ContractEnabled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"},{"inputs":[],"name":"baseContract1","outputs":[{"internalType":"contract BaseContract","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"baseContract2","outputs":[{"internalType":"contract BaseContract","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyLayer","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"numLayersToAdd","type":"uint256"},{"internalType":"string","name":"color","type":"string"}],"name":"buyMultipleLayers","outputs":[],"stateMutability":"payable","type":"function","payable":true},{"inputs":[],"name":"calculateTotalValue","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"colorValues","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllCellStates","outputs":[{"components":[{"internalType":"uint256","name":"baseValue","type":"uint256"},{"components":[{"internalType":"address payable","name":"owner","type":"address"},{"internalType":"string","name":"color","type":"string"}],"internalType":"struct BaseContract.Layer[]","name":"layers","type":"tuple[]"}],"internalType":"struct BaseContract.Cell[][]","name":"","type":"tuple[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"getAllTopLayers","outputs":[{"internalType":"address payable[][]","name":"","type":"address[][]"},{"internalType":"string[][]","name":"","type":"string[][]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getCellState","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"string","name":"","type":"string"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"name":"getTopLayerOfCell","outputs":[{"internalType":"address payable","name":"","type":"address"},{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"grid","outputs":[{"internalType":"uint256","name":"baseValue","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridHeight","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"gridWidth","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"initialValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"isEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"},{"internalType":"uint256","name":"layerIndex","type":"uint256"},{"internalType":"string","name":"newColor","type":"string"}],"name":"setLayerColor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawFunds","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isContractEnabled","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"enableContract","outputs":[],"stateMutability":"nonpayable","type":"function"}],"metadata":"{\\"compiler\\":{\\"version\\":\\"0.8.13+commit.abaa5c0e\\"},\\"language\\":\\"Solidity\\",\\"output\\":{\\"abi\\":[{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"_baseContractAddress1\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"address\\",\\"name\\":\\"_baseContractAddress2\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"constructor\\"},{\\"anonymous\\":false,\\"inputs\\":[],\\"name\\":\\"ContractEnabled\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"buyer\\",\\"type\\":\\"address\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayers\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"LayerPurchased\\",\\"type\\":\\"event\\"},{\\"inputs\\":[],\\"name\\":\\"baseContract1\\",\\"outputs\\":[{\\"internalType\\":\\"contract BaseContract\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"baseContract2\\",\\"outputs\\":[{\\"internalType\\":\\"contract BaseContract\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyLayer\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"numLayersToAdd\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"name\\":\\"buyMultipleLayers\\",\\"outputs\\":[],\\"stateMutability\\":\\"payable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"calculateTotalValue\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"colorValues\\",\\"outputs\\":[{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"enableContract\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllCellStates\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"},{\\"components\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"owner\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"color\\",\\"type\\":\\"string\\"}],\\"internalType\\":\\"struct BaseContract.Layer[]\\",\\"name\\":\\"layers\\",\\"type\\":\\"tuple[]\\"}],\\"internalType\\":\\"struct BaseContract.Cell[][]\\",\\"name\\":\\"\\",\\"type\\":\\"tuple[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getAllTopLayers\\",\\"outputs\\":[{\\"internalType\\":\\"address payable[][]\\",\\"name\\":\\"\\",\\"type\\":\\"address[][]\\"},{\\"internalType\\":\\"string[][]\\",\\"name\\":\\"\\",\\"type\\":\\"string[][]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getCellState\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getTopLayerOfCell\\",\\"outputs\\":[{\\"internalType\\":\\"address payable\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"\\",\\"type\\":\\"string\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"grid\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"baseValue\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridHeight\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"gridWidth\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"initialValues\\",\\"outputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"\\",\\"type\\":\\"uint256\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"isContractEnabled\\",\\"outputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"isEnabled\\",\\"outputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"owner\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"x\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"y\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"layerIndex\\",\\"type\\":\\"uint256\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"newColor\\",\\"type\\":\\"string\\"}],\\"name\\":\\"setLayerColor\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"withdrawFunds\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"}],\\"devdoc\\":{\\"kind\\":\\"dev\\",\\"methods\\":{},\\"version\\":1},\\"userdoc\\":{\\"kind\\":\\"user\\",\\"methods\\":{},\\"version\\":1}},\\"settings\\":{\\"compilationTarget\\":{\\"project:/contracts/Pixelflux3.sol\\":\\"Pixelflux3\\"},\\"evmVersion\\":\\"london\\",\\"libraries\\":{},\\"metadata\\":{\\"bytecodeHash\\":\\"ipfs\\"},\\"optimizer\\":{\\"enabled\\":false,\\"runs\\":200},\\"remappings\\":[]},\\"sources\\":{\\"project:/contracts/BaseContract.sol\\":{\\"keccak256\\":\\"0x7d0f9ba810e1d7cf1721920a8797ef253ce9a9cf71129aaa1c263e3de4dde3e8\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://5fdfd3c2b7e7f8684d628a5e35b6c13f2eeced22dbf20b16aff49e676a775228\\",\\"dweb:/ipfs/QmRExf7WwUASUu7ZxuPu3bXSri2tnSzooLR3s6fdmZ4wzz\\"]},\\"project:/contracts/DataStorage3.sol\\":{\\"keccak256\\":\\"0x58ee1f0b07afb492a1cf452d1b318ad6f125f660ce7477e3ba998b67dc2de16e\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://4ea568648da420a111b652776caba4f741a78f746a814f09fd53e13cafb465e1\\",\\"dweb:/ipfs/Qmdhi5sPH5sVRYKno9eA4QjuTfJgKJ1s6QbPR2EvJGAsmb\\"]},\\"project:/contracts/Pixelflux3.sol\\":{\\"keccak256\\":\\"0x16336c036edd8c4a92d0b9dec5902d31a9d203322604e00bf6b88486ad7743e9\\",\\"license\\":\\"MIT\\",\\"urls\\":[\\"bzz-raw://968b5f5dc4344d0f55f8dc3d0f5136d359253e164fcbe923f33d8ade3c268115\\",\\"dweb:/ipfs/QmNpLidA3MicWtcf4EHgsLCgr8hDrsKP74wtS1Sca1BhYr\\"]}},\\"version\\":1}","bytecode":"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","deployedBytecode":"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","immutableReferences":{},"generatedSources":[{"ast":{"nodeType":"YulBlock","src":"0:2053:7","statements":[{"body":{"nodeType":"YulBlock","src":"47:35:7","statements":[{"nodeType":"YulAssignment","src":"57:19:7","value":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"73:2:7","type":"","value":"64"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"67:5:7"},"nodeType":"YulFunctionCall","src":"67:9:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"57:6:7"}]}]},"name":"allocate_unbounded","nodeType":"YulFunctionDefinition","returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"40:6:7","type":""}],"src":"7:75:7"},{"body":{"nodeType":"YulBlock","src":"177:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"194:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"197:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"187:6:7"},"nodeType":"YulFunctionCall","src":"187:12:7"},"nodeType":"YulExpressionStatement","src":"187:12:7"}]},"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulFunctionDefinition","src":"88:117:7"},{"body":{"nodeType":"YulBlock","src":"300:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"317:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"320:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"310:6:7"},"nodeType":"YulFunctionCall","src":"310:12:7"},"nodeType":"YulExpressionStatement","src":"310:12:7"}]},"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulFunctionDefinition","src":"211:117:7"},{"body":{"nodeType":"YulBlock","src":"379:81:7","statements":[{"nodeType":"YulAssignment","src":"389:65:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"404:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"411:42:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"400:3:7"},"nodeType":"YulFunctionCall","src":"400:54:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"389:7:7"}]}]},"name":"cleanup_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"361:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"371:7:7","type":""}],"src":"334:126:7"},{"body":{"nodeType":"YulBlock","src":"511:51:7","statements":[{"nodeType":"YulAssignment","src":"521:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"550:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"532:17:7"},"nodeType":"YulFunctionCall","src":"532:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"521:7:7"}]}]},"name":"cleanup_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"493:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"503:7:7","type":""}],"src":"466:96:7"},{"body":{"nodeType":"YulBlock","src":"611:79:7","statements":[{"body":{"nodeType":"YulBlock","src":"668:16:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"677:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"680:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"670:6:7"},"nodeType":"YulFunctionCall","src":"670:12:7"},"nodeType":"YulExpressionStatement","src":"670:12:7"}]},"condition":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"634:5:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"659:5:7"}],"functionName":{"name":"cleanup_t_address","nodeType":"YulIdentifier","src":"641:17:7"},"nodeType":"YulFunctionCall","src":"641:24:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"631:2:7"},"nodeType":"YulFunctionCall","src":"631:35:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"624:6:7"},"nodeType":"YulFunctionCall","src":"624:43:7"},"nodeType":"YulIf","src":"621:63:7"}]},"name":"validator_revert_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"604:5:7","type":""}],"src":"568:122:7"},{"body":{"nodeType":"YulBlock","src":"759:80:7","statements":[{"nodeType":"YulAssignment","src":"769:22:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"784:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"778:5:7"},"nodeType":"YulFunctionCall","src":"778:13:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"769:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"827:5:7"}],"functionName":{"name":"validator_revert_t_address","nodeType":"YulIdentifier","src":"800:26:7"},"nodeType":"YulFunctionCall","src":"800:33:7"},"nodeType":"YulExpressionStatement","src":"800:33:7"}]},"name":"abi_decode_t_address_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"737:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"745:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"753:5:7","type":""}],"src":"696:143:7"},{"body":{"nodeType":"YulBlock","src":"939:413:7","statements":[{"body":{"nodeType":"YulBlock","src":"985:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"987:77:7"},"nodeType":"YulFunctionCall","src":"987:79:7"},"nodeType":"YulExpressionStatement","src":"987:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"960:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"969:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"956:3:7"},"nodeType":"YulFunctionCall","src":"956:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"981:2:7","type":"","value":"64"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"952:3:7"},"nodeType":"YulFunctionCall","src":"952:32:7"},"nodeType":"YulIf","src":"949:119:7"},{"nodeType":"YulBlock","src":"1078:128:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1093:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"1107:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"1097:6:7","type":""}]},{"nodeType":"YulAssignment","src":"1122:74:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"1168:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"1179:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1164:3:7"},"nodeType":"YulFunctionCall","src":"1164:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"1188:7:7"}],"functionName":{"name":"abi_decode_t_address_fromMemory","nodeType":"YulIdentifier","src":"1132:31:7"},"nodeType":"YulFunctionCall","src":"1132:64:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"1122:6:7"}]}]},{"nodeType":"YulBlock","src":"1216:129:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1231:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"1245:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"1235:6:7","type":""}]},{"nodeType":"YulAssignment","src":"1261:74:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"1307:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"1318:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1303:3:7"},"nodeType":"YulFunctionCall","src":"1303:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"1327:7:7"}],"functionName":{"name":"abi_decode_t_address_fromMemory","nodeType":"YulIdentifier","src":"1271:31:7"},"nodeType":"YulFunctionCall","src":"1271:64:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"1261:6:7"}]}]}]},"name":"abi_decode_tuple_t_addresst_address_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"901:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"912:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"924:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"932:6:7","type":""}],"src":"845:507:7"},{"body":{"nodeType":"YulBlock","src":"1386:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1403:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1406:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1396:6:7"},"nodeType":"YulFunctionCall","src":"1396:88:7"},"nodeType":"YulExpressionStatement","src":"1396:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1500:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"1503:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1493:6:7"},"nodeType":"YulFunctionCall","src":"1493:15:7"},"nodeType":"YulExpressionStatement","src":"1493:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1524:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1527:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"1517:6:7"},"nodeType":"YulFunctionCall","src":"1517:15:7"},"nodeType":"YulExpressionStatement","src":"1517:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"1358:180:7"},{"body":{"nodeType":"YulBlock","src":"1572:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1589:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1592:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1582:6:7"},"nodeType":"YulFunctionCall","src":"1582:88:7"},"nodeType":"YulExpressionStatement","src":"1582:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1686:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"1689:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1679:6:7"},"nodeType":"YulFunctionCall","src":"1679:15:7"},"nodeType":"YulExpressionStatement","src":"1679:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"1710:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"1713:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"1703:6:7"},"nodeType":"YulFunctionCall","src":"1703:15:7"},"nodeType":"YulExpressionStatement","src":"1703:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"1544:180:7"},{"body":{"nodeType":"YulBlock","src":"1781:269:7","statements":[{"nodeType":"YulAssignment","src":"1791:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"1805:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"1811:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"1801:3:7"},"nodeType":"YulFunctionCall","src":"1801:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"1791:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"1822:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"1852:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"1858:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1848:3:7"},"nodeType":"YulFunctionCall","src":"1848:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"1826:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"1899:51:7","statements":[{"nodeType":"YulAssignment","src":"1913:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"1927:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"1935:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1923:3:7"},"nodeType":"YulFunctionCall","src":"1923:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"1913:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"1879:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"1872:6:7"},"nodeType":"YulFunctionCall","src":"1872:26:7"},"nodeType":"YulIf","src":"1869:81:7"},{"body":{"nodeType":"YulBlock","src":"2002:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"2016:16:7"},"nodeType":"YulFunctionCall","src":"2016:18:7"},"nodeType":"YulExpressionStatement","src":"2016:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"1966:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"1989:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"1997:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"1986:2:7"},"nodeType":"YulFunctionCall","src":"1986:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"1963:2:7"},"nodeType":"YulFunctionCall","src":"1963:38:7"},"nodeType":"YulIf","src":"1960:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"1765:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"1774:6:7","type":""}],"src":"1730:320:7"}]},"contents":"{\\n\\n    function allocate_unbounded() -> memPtr {\\n        memPtr := mload(64)\\n    }\\n\\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\\n        revert(0, 0)\\n    }\\n\\n    function cleanup_t_uint160(value) -> cleaned {\\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\\n    }\\n\\n    function cleanup_t_address(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function validator_revert_t_address(value) {\\n        if iszero(eq(value, cleanup_t_address(value))) { revert(0, 0) }\\n    }\\n\\n    function abi_decode_t_address_fromMemory(offset, end) -> value {\\n        value := mload(offset)\\n        validator_revert_t_address(value)\\n    }\\n\\n    function abi_decode_tuple_t_addresst_address_fromMemory(headStart, dataEnd) -> value0, value1 {\\n        if slt(sub(dataEnd, headStart), 64) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_address_fromMemory(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_address_fromMemory(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"deployedGeneratedSources":[{"ast":{"nodeType":"YulBlock","src":"0:43376:7","statements":[{"body":{"nodeType":"YulBlock","src":"114:40:7","statements":[{"nodeType":"YulAssignment","src":"125:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"141:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"135:5:7"},"nodeType":"YulFunctionCall","src":"135:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"125:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"97:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"107:6:7","type":""}],"src":"7:147:7"},{"body":{"nodeType":"YulBlock","src":"304:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"321:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"326:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"314:6:7"},"nodeType":"YulFunctionCall","src":"314:19:7"},"nodeType":"YulExpressionStatement","src":"314:19:7"},{"nodeType":"YulAssignment","src":"342:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"361:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"366:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"357:3:7"},"nodeType":"YulFunctionCall","src":"357:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"342:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"276:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"281:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"292:11:7","type":""}],"src":"160:217:7"},{"body":{"nodeType":"YulBlock","src":"488:60:7","statements":[{"nodeType":"YulAssignment","src":"498:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"506:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"498:4:7"}]},{"nodeType":"YulAssignment","src":"519:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"531:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"536:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"527:3:7"},"nodeType":"YulFunctionCall","src":"527:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"519:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"475:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"483:4:7","type":""}],"src":"383:165:7"},{"body":{"nodeType":"YulBlock","src":"636:40:7","statements":[{"nodeType":"YulAssignment","src":"647:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"663:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"657:5:7"},"nodeType":"YulFunctionCall","src":"657:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"647:6:7"}]}]},"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"619:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"629:6:7","type":""}],"src":"554:122:7"},{"body":{"nodeType":"YulBlock","src":"791:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"808:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"813:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"801:6:7"},"nodeType":"YulFunctionCall","src":"801:19:7"},"nodeType":"YulExpressionStatement","src":"801:19:7"},{"nodeType":"YulAssignment","src":"829:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"848:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"853:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"844:3:7"},"nodeType":"YulFunctionCall","src":"844:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"829:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"763:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"768:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"779:11:7","type":""}],"src":"682:182:7"},{"body":{"nodeType":"YulBlock","src":"950:60:7","statements":[{"nodeType":"YulAssignment","src":"960:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"968:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"960:4:7"}]},{"nodeType":"YulAssignment","src":"981:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"993:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"989:3:7"},"nodeType":"YulFunctionCall","src":"989:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"981:4:7"}]}]},"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"937:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"945:4:7","type":""}],"src":"870:140:7"},{"body":{"nodeType":"YulBlock","src":"1061:81:7","statements":[{"nodeType":"YulAssignment","src":"1071:65:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1086:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"1093:42:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"1082:3:7"},"nodeType":"YulFunctionCall","src":"1082:54:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1071:7:7"}]}]},"name":"cleanup_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1043:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1053:7:7","type":""}],"src":"1016:126:7"},{"body":{"nodeType":"YulBlock","src":"1201:51:7","statements":[{"nodeType":"YulAssignment","src":"1211:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1240:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"1222:17:7"},"nodeType":"YulFunctionCall","src":"1222:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"1211:7:7"}]}]},"name":"cleanup_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1183:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"1193:7:7","type":""}],"src":"1148:104:7"},{"body":{"nodeType":"YulBlock","src":"1329:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1346:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1377:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"1351:25:7"},"nodeType":"YulFunctionCall","src":"1351:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"1339:6:7"},"nodeType":"YulFunctionCall","src":"1339:45:7"},"nodeType":"YulExpressionStatement","src":"1339:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1317:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1324:3:7","type":""}],"src":"1258:132:7"},{"body":{"nodeType":"YulBlock","src":"1492:115:7","statements":[{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"1552:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"1560:3:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"1502:49:7"},"nodeType":"YulFunctionCall","src":"1502:62:7"},"nodeType":"YulExpressionStatement","src":"1502:62:7"},{"nodeType":"YulAssignment","src":"1573:28:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"1591:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1596:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1587:3:7"},"nodeType":"YulFunctionCall","src":"1587:14:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"1573:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"1465:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1473:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"1481:10:7","type":""}],"src":"1396:211:7"},{"body":{"nodeType":"YulBlock","src":"1696:38:7","statements":[{"nodeType":"YulAssignment","src":"1706:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"1718:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"1723:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"1714:3:7"},"nodeType":"YulFunctionCall","src":"1714:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"1706:4:7"}]}]},"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"1683:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"1691:4:7","type":""}],"src":"1613:121:7"},{"body":{"nodeType":"YulBlock","src":"1916:646:7","statements":[{"nodeType":"YulVariableDeclaration","src":"1926:76:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"1996:5:7"}],"functionName":{"name":"array_length_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"1940:55:7"},"nodeType":"YulFunctionCall","src":"1940:62:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"1930:6:7","type":""}]},{"nodeType":"YulAssignment","src":"2011:91:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"2090:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"2095:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2018:71:7"},"nodeType":"YulFunctionCall","src":"2018:84:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2011:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"2111:79:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"2184:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2126:57:7"},"nodeType":"YulFunctionCall","src":"2126:64:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"2115:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"2199:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"2213:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"2203:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"2289:248:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2303:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2330:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"2324:5:7"},"nodeType":"YulFunctionCall","src":"2324:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"2307:13:7","type":""}]},{"nodeType":"YulAssignment","src":"2350:86:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"2417:13:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2432:3:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"2357:59:7"},"nodeType":"YulFunctionCall","src":"2357:79:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"2350:3:7"}]},{"nodeType":"YulAssignment","src":"2449:78:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2520:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2459:60:7"},"nodeType":"YulFunctionCall","src":"2459:68:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"2449:6:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2251:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"2254:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"2248:2:7"},"nodeType":"YulFunctionCall","src":"2248:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"2262:18:7","statements":[{"nodeType":"YulAssignment","src":"2264:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"2273:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"2276:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2269:3:7"},"nodeType":"YulFunctionCall","src":"2269:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"2264:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"2233:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"2235:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"2244:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"2239:1:7","type":""}]}]},"src":"2229:308:7"},{"nodeType":"YulAssignment","src":"2546:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"2553:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"2546:3:7"}]}]},"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"1895:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"1902:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"1911:3:7","type":""}],"src":"1786:776:7"},{"body":{"nodeType":"YulBlock","src":"2714:142:7","statements":[{"nodeType":"YulAssignment","src":"2724:126:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"2838:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"2846:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"2738:99:7"},"nodeType":"YulFunctionCall","src":"2738:112:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"2724:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"2687:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"2695:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"2703:10:7","type":""}],"src":"2568:288:7"},{"body":{"nodeType":"YulBlock","src":"2970:38:7","statements":[{"nodeType":"YulAssignment","src":"2980:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"2992:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"2997:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"2988:3:7"},"nodeType":"YulFunctionCall","src":"2988:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"2980:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"2957:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"2965:4:7","type":""}],"src":"2862:146:7"},{"body":{"nodeType":"YulBlock","src":"3254:985:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3264:101:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3359:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3278:80:7"},"nodeType":"YulFunctionCall","src":"3278:87:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"3268:6:7","type":""}]},{"nodeType":"YulAssignment","src":"3374:126:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3488:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"3493:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"3381:106:7"},"nodeType":"YulFunctionCall","src":"3381:119:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"3374:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"3509:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"3526:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"3513:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3538:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3554:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"3563:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"3571:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"3559:3:7"},"nodeType":"YulFunctionCall","src":"3559:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3550:3:7"},"nodeType":"YulFunctionCall","src":"3550:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"3542:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3586:104:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"3684:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3601:82:7"},"nodeType":"YulFunctionCall","src":"3601:89:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"3590:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"3699:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"3713:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"3703:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"3789:405:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"3810:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"3819:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"3825:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"3815:3:7"},"nodeType":"YulFunctionCall","src":"3815:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"3803:6:7"},"nodeType":"YulFunctionCall","src":"3803:33:7"},"nodeType":"YulExpressionStatement","src":"3803:33:7"},{"nodeType":"YulVariableDeclaration","src":"3849:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"3876:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"3870:5:7"},"nodeType":"YulFunctionCall","src":"3870:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"3853:13:7","type":""}]},{"nodeType":"YulAssignment","src":"3896:138:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"4014:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"4029:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"3904:109:7"},"nodeType":"YulFunctionCall","src":"3904:130:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"3896:4:7"}]},{"nodeType":"YulAssignment","src":"4047:103:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4143:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"4057:85:7"},"nodeType":"YulFunctionCall","src":"4057:93:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"4047:6:7"}]},{"nodeType":"YulAssignment","src":"4163:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4174:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4179:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4170:3:7"},"nodeType":"YulFunctionCall","src":"4170:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4163:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3751:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"3754:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"3748:2:7"},"nodeType":"YulFunctionCall","src":"3748:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"3762:18:7","statements":[{"nodeType":"YulAssignment","src":"3764:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"3773:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"3776:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"3769:3:7"},"nodeType":"YulFunctionCall","src":"3769:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"3764:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"3733:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"3735:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"3744:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"3739:1:7","type":""}]}]},"src":"3729:465:7"},{"nodeType":"YulAssignment","src":"4203:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"4210:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"4203:3:7"}]},{"nodeType":"YulAssignment","src":"4223:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"4230:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"4223:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"3233:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"3240:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"3249:3:7","type":""}],"src":"3064:1175:7"},{"body":{"nodeType":"YulBlock","src":"4354:40:7","statements":[{"nodeType":"YulAssignment","src":"4365:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4381:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4375:5:7"},"nodeType":"YulFunctionCall","src":"4375:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4365:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4337:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4347:6:7","type":""}],"src":"4245:149:7"},{"body":{"nodeType":"YulBlock","src":"4546:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"4568:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"4556:6:7"},"nodeType":"YulFunctionCall","src":"4556:19:7"},"nodeType":"YulExpressionStatement","src":"4556:19:7"},{"nodeType":"YulAssignment","src":"4584:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"4603:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4608:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4599:3:7"},"nodeType":"YulFunctionCall","src":"4599:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"4584:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"4518:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"4523:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"4534:11:7","type":""}],"src":"4400:219:7"},{"body":{"nodeType":"YulBlock","src":"4732:60:7","statements":[{"nodeType":"YulAssignment","src":"4742:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"4750:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4742:4:7"}]},{"nodeType":"YulAssignment","src":"4763:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"4775:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"4780:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"4771:3:7"},"nodeType":"YulFunctionCall","src":"4771:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"4763:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"4719:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"4727:4:7","type":""}],"src":"4625:167:7"},{"body":{"nodeType":"YulBlock","src":"4882:40:7","statements":[{"nodeType":"YulAssignment","src":"4893:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"4909:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"4903:5:7"},"nodeType":"YulFunctionCall","src":"4903:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"4893:6:7"}]}]},"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"4865:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"4875:6:7","type":""}],"src":"4798:124:7"},{"body":{"nodeType":"YulBlock","src":"5039:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5056:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5061:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5049:6:7"},"nodeType":"YulFunctionCall","src":"5049:19:7"},"nodeType":"YulExpressionStatement","src":"5049:19:7"},{"nodeType":"YulAssignment","src":"5077:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5096:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5101:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5092:3:7"},"nodeType":"YulFunctionCall","src":"5092:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5077:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5011:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5016:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5027:11:7","type":""}],"src":"4928:184:7"},{"body":{"nodeType":"YulBlock","src":"5200:60:7","statements":[{"nodeType":"YulAssignment","src":"5210:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"5218:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5210:4:7"}]},{"nodeType":"YulAssignment","src":"5231:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"5243:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5248:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5239:3:7"},"nodeType":"YulFunctionCall","src":"5239:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"5231:4:7"}]}]},"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"5187:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"5195:4:7","type":""}],"src":"5118:142:7"},{"body":{"nodeType":"YulBlock","src":"5325:40:7","statements":[{"nodeType":"YulAssignment","src":"5336:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5352:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5346:5:7"},"nodeType":"YulFunctionCall","src":"5346:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"5336:6:7"}]}]},"name":"array_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5308:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"5318:6:7","type":""}],"src":"5266:99:7"},{"body":{"nodeType":"YulBlock","src":"5457:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5474:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5479:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5467:6:7"},"nodeType":"YulFunctionCall","src":"5467:19:7"},"nodeType":"YulExpressionStatement","src":"5467:19:7"},{"nodeType":"YulAssignment","src":"5495:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"5514:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"5519:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5510:3:7"},"nodeType":"YulFunctionCall","src":"5510:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"5495:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"5429:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5434:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"5445:11:7","type":""}],"src":"5371:159:7"},{"body":{"nodeType":"YulBlock","src":"5585:258:7","statements":[{"nodeType":"YulVariableDeclaration","src":"5595:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"5604:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"5599:1:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"5664:63:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5689:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5694:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5685:3:7"},"nodeType":"YulFunctionCall","src":"5685:11:7"},{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"5708:3:7"},{"name":"i","nodeType":"YulIdentifier","src":"5713:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5704:3:7"},"nodeType":"YulFunctionCall","src":"5704:11:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"5698:5:7"},"nodeType":"YulFunctionCall","src":"5698:18:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5678:6:7"},"nodeType":"YulFunctionCall","src":"5678:39:7"},"nodeType":"YulExpressionStatement","src":"5678:39:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5625:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5628:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"5622:2:7"},"nodeType":"YulFunctionCall","src":"5622:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"5636:19:7","statements":[{"nodeType":"YulAssignment","src":"5638:15:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5647:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"5650:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5643:3:7"},"nodeType":"YulFunctionCall","src":"5643:10:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"5638:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"5618:3:7","statements":[]},"src":"5614:113:7"},{"body":{"nodeType":"YulBlock","src":"5761:76:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"5811:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"5816:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5807:3:7"},"nodeType":"YulFunctionCall","src":"5807:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"5825:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"5800:6:7"},"nodeType":"YulFunctionCall","src":"5800:27:7"},"nodeType":"YulExpressionStatement","src":"5800:27:7"}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"5742:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"5745:6:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"5739:2:7"},"nodeType":"YulFunctionCall","src":"5739:13:7"},"nodeType":"YulIf","src":"5736:101:7"}]},"name":"copy_memory_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"5567:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"5572:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"5577:6:7","type":""}],"src":"5536:307:7"},{"body":{"nodeType":"YulBlock","src":"5897:54:7","statements":[{"nodeType":"YulAssignment","src":"5907:38:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"5925:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"5932:2:7","type":"","value":"31"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"5921:3:7"},"nodeType":"YulFunctionCall","src":"5921:14:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"5941:2:7","type":"","value":"31"}],"functionName":{"name":"not","nodeType":"YulIdentifier","src":"5937:3:7"},"nodeType":"YulFunctionCall","src":"5937:7:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"5917:3:7"},"nodeType":"YulFunctionCall","src":"5917:28:7"},"variableNames":[{"name":"result","nodeType":"YulIdentifier","src":"5907:6:7"}]}]},"name":"round_up_to_mul_of_32","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"5880:5:7","type":""}],"returnVariables":[{"name":"result","nodeType":"YulTypedName","src":"5890:6:7","type":""}],"src":"5849:102:7"},{"body":{"nodeType":"YulBlock","src":"6039:262:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6049:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6096:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6063:32:7"},"nodeType":"YulFunctionCall","src":"6063:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6053:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6111:68:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6167:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6172:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6118:48:7"},"nodeType":"YulFunctionCall","src":"6118:61:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6111:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6214:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"6221:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6210:3:7"},"nodeType":"YulFunctionCall","src":"6210:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6228:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6233:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"6188:21:7"},"nodeType":"YulFunctionCall","src":"6188:52:7"},"nodeType":"YulExpressionStatement","src":"6188:52:7"},{"nodeType":"YulAssignment","src":"6249:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6260:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"6287:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"6265:21:7"},"nodeType":"YulFunctionCall","src":"6265:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6256:3:7"},"nodeType":"YulFunctionCall","src":"6256:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"6249:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6020:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6027:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6035:3:7","type":""}],"src":"5957:344:7"},{"body":{"nodeType":"YulBlock","src":"6407:96:7","statements":[{"nodeType":"YulAssignment","src":"6417:80:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"6485:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"6493:3:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"6431:53:7"},"nodeType":"YulFunctionCall","src":"6431:66:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"6417:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"6380:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6388:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"6396:10:7","type":""}],"src":"6307:196:7"},{"body":{"nodeType":"YulBlock","src":"6594:38:7","statements":[{"nodeType":"YulAssignment","src":"6604:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"6616:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"6621:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"6612:3:7"},"nodeType":"YulFunctionCall","src":"6612:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"6604:4:7"}]}]},"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"6581:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"6589:4:7","type":""}],"src":"6509:123:7"},{"body":{"nodeType":"YulBlock","src":"6800:837:7","statements":[{"nodeType":"YulVariableDeclaration","src":"6810:78:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"6882:5:7"}],"functionName":{"name":"array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6824:57:7"},"nodeType":"YulFunctionCall","src":"6824:64:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"6814:6:7","type":""}]},{"nodeType":"YulAssignment","src":"6897:93:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"6978:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"6983:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"6904:73:7"},"nodeType":"YulFunctionCall","src":"6904:86:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"6897:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"6999:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7016:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"7003:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7028:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7044:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"7053:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"7061:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"7049:3:7"},"nodeType":"YulFunctionCall","src":"7049:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7040:3:7"},"nodeType":"YulFunctionCall","src":"7040:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"7032:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7076:81:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"7151:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7091:59:7"},"nodeType":"YulFunctionCall","src":"7091:66:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"7080:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"7166:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"7180:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"7170:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"7256:336:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7277:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"7286:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"7292:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"7282:3:7"},"nodeType":"YulFunctionCall","src":"7282:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"7270:6:7"},"nodeType":"YulFunctionCall","src":"7270:33:7"},"nodeType":"YulExpressionStatement","src":"7270:33:7"},{"nodeType":"YulVariableDeclaration","src":"7316:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7343:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"7337:5:7"},"nodeType":"YulFunctionCall","src":"7337:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"7320:13:7","type":""}]},{"nodeType":"YulAssignment","src":"7363:92:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"7435:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"7450:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"7371:63:7"},"nodeType":"YulFunctionCall","src":"7371:84:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"7363:4:7"}]},{"nodeType":"YulAssignment","src":"7468:80:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7541:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7478:62:7"},"nodeType":"YulFunctionCall","src":"7478:70:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"7468:6:7"}]},{"nodeType":"YulAssignment","src":"7561:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"7572:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"7577:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7568:3:7"},"nodeType":"YulFunctionCall","src":"7568:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7561:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7218:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"7221:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"7215:2:7"},"nodeType":"YulFunctionCall","src":"7215:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"7229:18:7","statements":[{"nodeType":"YulAssignment","src":"7231:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"7240:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"7243:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"7236:3:7"},"nodeType":"YulFunctionCall","src":"7236:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"7231:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"7200:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"7202:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"7211:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"7206:1:7","type":""}]}]},"src":"7196:396:7"},{"nodeType":"YulAssignment","src":"7601:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"7608:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"7601:3:7"}]},{"nodeType":"YulAssignment","src":"7621:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"7628:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"7621:3:7"}]}]},"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"6779:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"6786:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"6795:3:7","type":""}],"src":"6666:971:7"},{"body":{"nodeType":"YulBlock","src":"7793:146:7","statements":[{"nodeType":"YulAssignment","src":"7803:130:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"7921:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"7929:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"7817:103:7"},"nodeType":"YulFunctionCall","src":"7817:116:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"7803:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"7766:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"7774:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"7782:10:7","type":""}],"src":"7643:296:7"},{"body":{"nodeType":"YulBlock","src":"8055:38:7","statements":[{"nodeType":"YulAssignment","src":"8065:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"8077:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"8082:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8073:3:7"},"nodeType":"YulFunctionCall","src":"8073:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"8065:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"8042:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"8050:4:7","type":""}],"src":"7945:148:7"},{"body":{"nodeType":"YulBlock","src":"8325:997:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8335:103:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8432:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8349:82:7"},"nodeType":"YulFunctionCall","src":"8349:89:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"8339:6:7","type":""}]},{"nodeType":"YulAssignment","src":"8447:128:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8563:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"8568:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"8454:108:7"},"nodeType":"YulFunctionCall","src":"8454:121:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"8447:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"8584:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"8601:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"8588:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8613:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8629:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"8638:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"8646:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"8634:3:7"},"nodeType":"YulFunctionCall","src":"8634:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8625:3:7"},"nodeType":"YulFunctionCall","src":"8625:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"8617:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8661:106:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"8761:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8676:84:7"},"nodeType":"YulFunctionCall","src":"8676:91:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"8665:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"8776:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"8790:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"8780:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"8866:411:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"8887:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"8896:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"8902:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"8892:3:7"},"nodeType":"YulFunctionCall","src":"8892:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"8880:6:7"},"nodeType":"YulFunctionCall","src":"8880:33:7"},"nodeType":"YulExpressionStatement","src":"8880:33:7"},{"nodeType":"YulVariableDeclaration","src":"8926:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"8953:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"8947:5:7"},"nodeType":"YulFunctionCall","src":"8947:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"8930:13:7","type":""}]},{"nodeType":"YulAssignment","src":"8973:142:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"9095:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9110:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"8981:113:7"},"nodeType":"YulFunctionCall","src":"8981:134:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"8973:4:7"}]},{"nodeType":"YulAssignment","src":"9128:105:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9226:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"9138:87:7"},"nodeType":"YulFunctionCall","src":"9138:95:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"9128:6:7"}]},{"nodeType":"YulAssignment","src":"9246:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"9257:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"9262:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9253:3:7"},"nodeType":"YulFunctionCall","src":"9253:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9246:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8828:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"8831:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"8825:2:7"},"nodeType":"YulFunctionCall","src":"8825:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"8839:18:7","statements":[{"nodeType":"YulAssignment","src":"8841:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"8850:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"8853:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"8846:3:7"},"nodeType":"YulFunctionCall","src":"8846:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"8841:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"8810:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"8812:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"8821:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"8816:1:7","type":""}]}]},"src":"8806:471:7"},{"nodeType":"YulAssignment","src":"9286:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"9293:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"9286:3:7"}]},{"nodeType":"YulAssignment","src":"9306:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"9313:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"9306:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"8304:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"8311:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"8320:3:7","type":""}],"src":"8131:1191:7"},{"body":{"nodeType":"YulBlock","src":"9690:544:7","statements":[{"nodeType":"YulAssignment","src":"9700:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9712:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9723:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9708:3:7"},"nodeType":"YulFunctionCall","src":"9708:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9700:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9747:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"9758:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9743:3:7"},"nodeType":"YulFunctionCall","src":"9743:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"9766:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"9772:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"9762:3:7"},"nodeType":"YulFunctionCall","src":"9762:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9736:6:7"},"nodeType":"YulFunctionCall","src":"9736:47:7"},"nodeType":"YulExpressionStatement","src":"9736:47:7"},{"nodeType":"YulAssignment","src":"9792:182:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"9960:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"9969:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"9800:159:7"},"nodeType":"YulFunctionCall","src":"9800:174:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"9792:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"9995:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"10006:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"9991:3:7"},"nodeType":"YulFunctionCall","src":"9991:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"10015:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"10021:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"10011:3:7"},"nodeType":"YulFunctionCall","src":"10011:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"9984:6:7"},"nodeType":"YulFunctionCall","src":"9984:48:7"},"nodeType":"YulExpressionStatement","src":"9984:48:7"},{"nodeType":"YulAssignment","src":"10041:186:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"10213:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"10222:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"10049:163:7"},"nodeType":"YulFunctionCall","src":"10049:178:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"10041:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"9654:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"9666:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"9674:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"9685:4:7","type":""}],"src":"9328:906:7"},{"body":{"nodeType":"YulBlock","src":"10280:35:7","statements":[{"nodeType":"YulAssignment","src":"10290:19:7","value":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10306:2:7","type":"","value":"64"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"10300:5:7"},"nodeType":"YulFunctionCall","src":"10300:9:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"10290:6:7"}]}]},"name":"allocate_unbounded","nodeType":"YulFunctionDefinition","returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"10273:6:7","type":""}],"src":"10240:75:7"},{"body":{"nodeType":"YulBlock","src":"10410:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10427:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10430:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10420:6:7"},"nodeType":"YulFunctionCall","src":"10420:12:7"},"nodeType":"YulExpressionStatement","src":"10420:12:7"}]},"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulFunctionDefinition","src":"10321:117:7"},{"body":{"nodeType":"YulBlock","src":"10533:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10550:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10553:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10543:6:7"},"nodeType":"YulFunctionCall","src":"10543:12:7"},"nodeType":"YulExpressionStatement","src":"10543:12:7"}]},"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulFunctionDefinition","src":"10444:117:7"},{"body":{"nodeType":"YulBlock","src":"10612:32:7","statements":[{"nodeType":"YulAssignment","src":"10622:16:7","value":{"name":"value","nodeType":"YulIdentifier","src":"10633:5:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"10622:7:7"}]}]},"name":"cleanup_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10594:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"10604:7:7","type":""}],"src":"10567:77:7"},{"body":{"nodeType":"YulBlock","src":"10693:79:7","statements":[{"body":{"nodeType":"YulBlock","src":"10750:16:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"10759:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"10762:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"10752:6:7"},"nodeType":"YulFunctionCall","src":"10752:12:7"},"nodeType":"YulExpressionStatement","src":"10752:12:7"}]},"condition":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10716:5:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10741:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"10723:17:7"},"nodeType":"YulFunctionCall","src":"10723:24:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"10713:2:7"},"nodeType":"YulFunctionCall","src":"10713:35:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"10706:6:7"},"nodeType":"YulFunctionCall","src":"10706:43:7"},"nodeType":"YulIf","src":"10703:63:7"}]},"name":"validator_revert_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"10686:5:7","type":""}],"src":"10650:122:7"},{"body":{"nodeType":"YulBlock","src":"10830:87:7","statements":[{"nodeType":"YulAssignment","src":"10840:29:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"10862:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"10849:12:7"},"nodeType":"YulFunctionCall","src":"10849:20:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"10840:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"10905:5:7"}],"functionName":{"name":"validator_revert_t_uint256","nodeType":"YulIdentifier","src":"10878:26:7"},"nodeType":"YulFunctionCall","src":"10878:33:7"},"nodeType":"YulExpressionStatement","src":"10878:33:7"}]},"name":"abi_decode_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"10808:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"10816:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"10824:5:7","type":""}],"src":"10778:139:7"},{"body":{"nodeType":"YulBlock","src":"11012:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11029:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11032:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11022:6:7"},"nodeType":"YulFunctionCall","src":"11022:12:7"},"nodeType":"YulExpressionStatement","src":"11022:12:7"}]},"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulFunctionDefinition","src":"10923:117:7"},{"body":{"nodeType":"YulBlock","src":"11135:28:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11152:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11155:1:7","type":"","value":"0"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11145:6:7"},"nodeType":"YulFunctionCall","src":"11145:12:7"},"nodeType":"YulExpressionStatement","src":"11145:12:7"}]},"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulFunctionDefinition","src":"11046:117:7"},{"body":{"nodeType":"YulBlock","src":"11197:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11214:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11217:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11207:6:7"},"nodeType":"YulFunctionCall","src":"11207:88:7"},"nodeType":"YulExpressionStatement","src":"11207:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11311:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"11314:4:7","type":"","value":"0x41"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11304:6:7"},"nodeType":"YulFunctionCall","src":"11304:15:7"},"nodeType":"YulExpressionStatement","src":"11304:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11335:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"11338:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"11328:6:7"},"nodeType":"YulFunctionCall","src":"11328:15:7"},"nodeType":"YulExpressionStatement","src":"11328:15:7"}]},"name":"panic_error_0x41","nodeType":"YulFunctionDefinition","src":"11169:180:7"},{"body":{"nodeType":"YulBlock","src":"11398:238:7","statements":[{"nodeType":"YulVariableDeclaration","src":"11408:58:7","value":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11430:6:7"},{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"11460:4:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11438:21:7"},"nodeType":"YulFunctionCall","src":"11438:27:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"11426:3:7"},"nodeType":"YulFunctionCall","src":"11426:40:7"},"variables":[{"name":"newFreePtr","nodeType":"YulTypedName","src":"11412:10:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"11577:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11579:16:7"},"nodeType":"YulFunctionCall","src":"11579:18:7"},"nodeType":"YulExpressionStatement","src":"11579:18:7"}]},"condition":{"arguments":[{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11520:10:7"},{"kind":"number","nodeType":"YulLiteral","src":"11532:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11517:2:7"},"nodeType":"YulFunctionCall","src":"11517:34:7"},{"arguments":[{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11556:10:7"},{"name":"memPtr","nodeType":"YulIdentifier","src":"11568:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"11553:2:7"},"nodeType":"YulFunctionCall","src":"11553:22:7"}],"functionName":{"name":"or","nodeType":"YulIdentifier","src":"11514:2:7"},"nodeType":"YulFunctionCall","src":"11514:62:7"},"nodeType":"YulIf","src":"11511:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"11615:2:7","type":"","value":"64"},{"name":"newFreePtr","nodeType":"YulIdentifier","src":"11619:10:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"11608:6:7"},"nodeType":"YulFunctionCall","src":"11608:22:7"},"nodeType":"YulExpressionStatement","src":"11608:22:7"}]},"name":"finalize_allocation","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"11384:6:7","type":""},{"name":"size","nodeType":"YulTypedName","src":"11392:4:7","type":""}],"src":"11355:281:7"},{"body":{"nodeType":"YulBlock","src":"11683:88:7","statements":[{"nodeType":"YulAssignment","src":"11693:30:7","value":{"arguments":[],"functionName":{"name":"allocate_unbounded","nodeType":"YulIdentifier","src":"11703:18:7"},"nodeType":"YulFunctionCall","src":"11703:20:7"},"variableNames":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11693:6:7"}]},{"expression":{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"11752:6:7"},{"name":"size","nodeType":"YulIdentifier","src":"11760:4:7"}],"functionName":{"name":"finalize_allocation","nodeType":"YulIdentifier","src":"11732:19:7"},"nodeType":"YulFunctionCall","src":"11732:33:7"},"nodeType":"YulExpressionStatement","src":"11732:33:7"}]},"name":"allocate_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"size","nodeType":"YulTypedName","src":"11667:4:7","type":""}],"returnVariables":[{"name":"memPtr","nodeType":"YulTypedName","src":"11676:6:7","type":""}],"src":"11642:129:7"},{"body":{"nodeType":"YulBlock","src":"11844:241:7","statements":[{"body":{"nodeType":"YulBlock","src":"11949:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x41","nodeType":"YulIdentifier","src":"11951:16:7"},"nodeType":"YulFunctionCall","src":"11951:18:7"},"nodeType":"YulExpressionStatement","src":"11951:18:7"}]},"condition":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"11921:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"11929:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"11918:2:7"},"nodeType":"YulFunctionCall","src":"11918:30:7"},"nodeType":"YulIf","src":"11915:56:7"},{"nodeType":"YulAssignment","src":"11981:37:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12011:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"11989:21:7"},"nodeType":"YulFunctionCall","src":"11989:29:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"11981:4:7"}]},{"nodeType":"YulAssignment","src":"12055:23:7","value":{"arguments":[{"name":"size","nodeType":"YulIdentifier","src":"12067:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"12073:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12063:3:7"},"nodeType":"YulFunctionCall","src":"12063:15:7"},"variableNames":[{"name":"size","nodeType":"YulIdentifier","src":"12055:4:7"}]}]},"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"length","nodeType":"YulTypedName","src":"11828:6:7","type":""}],"returnVariables":[{"name":"size","nodeType":"YulTypedName","src":"11839:4:7","type":""}],"src":"11777:308:7"},{"body":{"nodeType":"YulBlock","src":"12142:103:7","statements":[{"expression":{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12165:3:7"},{"name":"src","nodeType":"YulIdentifier","src":"12170:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12175:6:7"}],"functionName":{"name":"calldatacopy","nodeType":"YulIdentifier","src":"12152:12:7"},"nodeType":"YulFunctionCall","src":"12152:30:7"},"nodeType":"YulExpressionStatement","src":"12152:30:7"},{"expression":{"arguments":[{"arguments":[{"name":"dst","nodeType":"YulIdentifier","src":"12223:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12228:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12219:3:7"},"nodeType":"YulFunctionCall","src":"12219:16:7"},{"kind":"number","nodeType":"YulLiteral","src":"12237:1:7","type":"","value":"0"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12212:6:7"},"nodeType":"YulFunctionCall","src":"12212:27:7"},"nodeType":"YulExpressionStatement","src":"12212:27:7"}]},"name":"copy_calldata_to_memory","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12124:3:7","type":""},{"name":"dst","nodeType":"YulTypedName","src":"12129:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12134:6:7","type":""}],"src":"12091:154:7"},{"body":{"nodeType":"YulBlock","src":"12335:328:7","statements":[{"nodeType":"YulAssignment","src":"12345:75:7","value":{"arguments":[{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"12412:6:7"}],"functionName":{"name":"array_allocation_size_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12370:41:7"},"nodeType":"YulFunctionCall","src":"12370:49:7"}],"functionName":{"name":"allocate_memory","nodeType":"YulIdentifier","src":"12354:15:7"},"nodeType":"YulFunctionCall","src":"12354:66:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12345:5:7"}]},{"expression":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12436:5:7"},{"name":"length","nodeType":"YulIdentifier","src":"12443:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"12429:6:7"},"nodeType":"YulFunctionCall","src":"12429:21:7"},"nodeType":"YulExpressionStatement","src":"12429:21:7"},{"nodeType":"YulVariableDeclaration","src":"12459:27:7","value":{"arguments":[{"name":"array","nodeType":"YulIdentifier","src":"12474:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"12481:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12470:3:7"},"nodeType":"YulFunctionCall","src":"12470:16:7"},"variables":[{"name":"dst","nodeType":"YulTypedName","src":"12463:3:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"12524:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae","nodeType":"YulIdentifier","src":"12526:77:7"},"nodeType":"YulFunctionCall","src":"12526:79:7"},"nodeType":"YulExpressionStatement","src":"12526:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12505:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12510:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12501:3:7"},"nodeType":"YulFunctionCall","src":"12501:16:7"},{"name":"end","nodeType":"YulIdentifier","src":"12519:3:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"12498:2:7"},"nodeType":"YulFunctionCall","src":"12498:25:7"},"nodeType":"YulIf","src":"12495:112:7"},{"expression":{"arguments":[{"name":"src","nodeType":"YulIdentifier","src":"12640:3:7"},{"name":"dst","nodeType":"YulIdentifier","src":"12645:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"12650:6:7"}],"functionName":{"name":"copy_calldata_to_memory","nodeType":"YulIdentifier","src":"12616:23:7"},"nodeType":"YulFunctionCall","src":"12616:41:7"},"nodeType":"YulExpressionStatement","src":"12616:41:7"}]},"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"src","nodeType":"YulTypedName","src":"12308:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"12313:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12321:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12329:5:7","type":""}],"src":"12251:412:7"},{"body":{"nodeType":"YulBlock","src":"12745:278:7","statements":[{"body":{"nodeType":"YulBlock","src":"12794:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d","nodeType":"YulIdentifier","src":"12796:77:7"},"nodeType":"YulFunctionCall","src":"12796:79:7"},"nodeType":"YulExpressionStatement","src":"12796:79:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12773:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12781:4:7","type":"","value":"0x1f"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12769:3:7"},"nodeType":"YulFunctionCall","src":"12769:17:7"},{"name":"end","nodeType":"YulIdentifier","src":"12788:3:7"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"12765:3:7"},"nodeType":"YulFunctionCall","src":"12765:27:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"12758:6:7"},"nodeType":"YulFunctionCall","src":"12758:35:7"},"nodeType":"YulIf","src":"12755:122:7"},{"nodeType":"YulVariableDeclaration","src":"12886:34:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12913:6:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"12900:12:7"},"nodeType":"YulFunctionCall","src":"12900:20:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"12890:6:7","type":""}]},{"nodeType":"YulAssignment","src":"12929:88:7","value":{"arguments":[{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"12990:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"12998:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"12986:3:7"},"nodeType":"YulFunctionCall","src":"12986:17:7"},{"name":"length","nodeType":"YulIdentifier","src":"13005:6:7"},{"name":"end","nodeType":"YulIdentifier","src":"13013:3:7"}],"functionName":{"name":"abi_decode_available_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"12938:47:7"},"nodeType":"YulFunctionCall","src":"12938:79:7"},"variableNames":[{"name":"array","nodeType":"YulIdentifier","src":"12929:5:7"}]}]},"name":"abi_decode_t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"12723:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"12731:3:7","type":""}],"returnVariables":[{"name":"array","nodeType":"YulTypedName","src":"12739:5:7","type":""}],"src":"12683:340:7"},{"body":{"nodeType":"YulBlock","src":"13139:689:7","statements":[{"body":{"nodeType":"YulBlock","src":"13185:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"13187:77:7"},"nodeType":"YulFunctionCall","src":"13187:79:7"},"nodeType":"YulExpressionStatement","src":"13187:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"13160:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"13169:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"13156:3:7"},"nodeType":"YulFunctionCall","src":"13156:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"13181:2:7","type":"","value":"96"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"13152:3:7"},"nodeType":"YulFunctionCall","src":"13152:32:7"},"nodeType":"YulIf","src":"13149:119:7"},{"nodeType":"YulBlock","src":"13278:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13293:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13307:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13297:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13322:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13357:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13368:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13353:3:7"},"nodeType":"YulFunctionCall","src":"13353:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13377:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13332:20:7"},"nodeType":"YulFunctionCall","src":"13332:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"13322:6:7"}]}]},{"nodeType":"YulBlock","src":"13405:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13420:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"13434:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13424:6:7","type":""}]},{"nodeType":"YulAssignment","src":"13450:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13485:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13496:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13481:3:7"},"nodeType":"YulFunctionCall","src":"13481:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13505:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"13460:20:7"},"nodeType":"YulFunctionCall","src":"13460:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"13450:6:7"}]}]},{"nodeType":"YulBlock","src":"13533:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"13548:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13579:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"13590:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13575:3:7"},"nodeType":"YulFunctionCall","src":"13575:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"13562:12:7"},"nodeType":"YulFunctionCall","src":"13562:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"13552:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"13641:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"13643:77:7"},"nodeType":"YulFunctionCall","src":"13643:79:7"},"nodeType":"YulExpressionStatement","src":"13643:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"13613:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"13621:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"13610:2:7"},"nodeType":"YulFunctionCall","src":"13610:30:7"},"nodeType":"YulIf","src":"13607:117:7"},{"nodeType":"YulAssignment","src":"13738:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"13783:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"13794:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"13779:3:7"},"nodeType":"YulFunctionCall","src":"13779:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"13803:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"13748:30:7"},"nodeType":"YulFunctionCall","src":"13748:63:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"13738:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"13093:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"13104:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"13116:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"13124:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"13132:6:7","type":""}],"src":"13029:799:7"},{"body":{"nodeType":"YulBlock","src":"13899:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"13916:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"13939:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"13921:17:7"},"nodeType":"YulFunctionCall","src":"13921:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"13909:6:7"},"nodeType":"YulFunctionCall","src":"13909:37:7"},"nodeType":"YulExpressionStatement","src":"13909:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"13887:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"13894:3:7","type":""}],"src":"13834:118:7"},{"body":{"nodeType":"YulBlock","src":"14056:124:7","statements":[{"nodeType":"YulAssignment","src":"14066:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14078:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14089:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14074:3:7"},"nodeType":"YulFunctionCall","src":"14074:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"14066:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"14146:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14159:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"14170:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14155:3:7"},"nodeType":"YulFunctionCall","src":"14155:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"14102:43:7"},"nodeType":"YulFunctionCall","src":"14102:71:7"},"nodeType":"YulExpressionStatement","src":"14102:71:7"}]},"name":"abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14028:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"14040:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"14051:4:7","type":""}],"src":"13958:222:7"},{"body":{"nodeType":"YulBlock","src":"14269:391:7","statements":[{"body":{"nodeType":"YulBlock","src":"14315:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14317:77:7"},"nodeType":"YulFunctionCall","src":"14317:79:7"},"nodeType":"YulExpressionStatement","src":"14317:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14290:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14299:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14286:3:7"},"nodeType":"YulFunctionCall","src":"14286:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14311:2:7","type":"","value":"64"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14282:3:7"},"nodeType":"YulFunctionCall","src":"14282:32:7"},"nodeType":"YulIf","src":"14279:119:7"},{"nodeType":"YulBlock","src":"14408:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14423:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14437:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14427:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14452:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14487:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14498:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14483:3:7"},"nodeType":"YulFunctionCall","src":"14483:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14507:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14462:20:7"},"nodeType":"YulFunctionCall","src":"14462:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14452:6:7"}]}]},{"nodeType":"YulBlock","src":"14535:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14550:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14564:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14554:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14580:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"14615:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"14626:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"14611:3:7"},"nodeType":"YulFunctionCall","src":"14611:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"14635:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14590:20:7"},"nodeType":"YulFunctionCall","src":"14590:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"14580:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14231:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14242:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14254:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14262:6:7","type":""}],"src":"14186:474:7"},{"body":{"nodeType":"YulBlock","src":"14793:818:7","statements":[{"body":{"nodeType":"YulBlock","src":"14840:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"14842:77:7"},"nodeType":"YulFunctionCall","src":"14842:79:7"},"nodeType":"YulExpressionStatement","src":"14842:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"14814:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"14823:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"14810:3:7"},"nodeType":"YulFunctionCall","src":"14810:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"14835:3:7","type":"","value":"128"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"14806:3:7"},"nodeType":"YulFunctionCall","src":"14806:33:7"},"nodeType":"YulIf","src":"14803:120:7"},{"nodeType":"YulBlock","src":"14933:117:7","statements":[{"nodeType":"YulVariableDeclaration","src":"14948:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"14962:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"14952:6:7","type":""}]},{"nodeType":"YulAssignment","src":"14977:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15012:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15023:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15008:3:7"},"nodeType":"YulFunctionCall","src":"15008:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15032:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"14987:20:7"},"nodeType":"YulFunctionCall","src":"14987:53:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"14977:6:7"}]}]},{"nodeType":"YulBlock","src":"15060:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15075:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15089:2:7","type":"","value":"32"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15079:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15105:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15140:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15151:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15136:3:7"},"nodeType":"YulFunctionCall","src":"15136:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15160:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15115:20:7"},"nodeType":"YulFunctionCall","src":"15115:53:7"},"variableNames":[{"name":"value1","nodeType":"YulIdentifier","src":"15105:6:7"}]}]},{"nodeType":"YulBlock","src":"15188:118:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15203:16:7","value":{"kind":"number","nodeType":"YulLiteral","src":"15217:2:7","type":"","value":"64"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15207:6:7","type":""}]},{"nodeType":"YulAssignment","src":"15233:63:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15268:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15279:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15264:3:7"},"nodeType":"YulFunctionCall","src":"15264:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15288:7:7"}],"functionName":{"name":"abi_decode_t_uint256","nodeType":"YulIdentifier","src":"15243:20:7"},"nodeType":"YulFunctionCall","src":"15243:53:7"},"variableNames":[{"name":"value2","nodeType":"YulIdentifier","src":"15233:6:7"}]}]},{"nodeType":"YulBlock","src":"15316:288:7","statements":[{"nodeType":"YulVariableDeclaration","src":"15331:46:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15362:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"15373:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15358:3:7"},"nodeType":"YulFunctionCall","src":"15358:18:7"}],"functionName":{"name":"calldataload","nodeType":"YulIdentifier","src":"15345:12:7"},"nodeType":"YulFunctionCall","src":"15345:32:7"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"15335:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"15424:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db","nodeType":"YulIdentifier","src":"15426:77:7"},"nodeType":"YulFunctionCall","src":"15426:79:7"},"nodeType":"YulExpressionStatement","src":"15426:79:7"}]},"condition":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"15396:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"15404:18:7","type":"","value":"0xffffffffffffffff"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"15393:2:7"},"nodeType":"YulFunctionCall","src":"15393:30:7"},"nodeType":"YulIf","src":"15390:117:7"},{"nodeType":"YulAssignment","src":"15521:73:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"15566:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"15577:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"15562:3:7"},"nodeType":"YulFunctionCall","src":"15562:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"15586:7:7"}],"functionName":{"name":"abi_decode_t_string_memory_ptr","nodeType":"YulIdentifier","src":"15531:30:7"},"nodeType":"YulFunctionCall","src":"15531:63:7"},"variableNames":[{"name":"value3","nodeType":"YulIdentifier","src":"15521:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"14739:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"14750:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"14762:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"14770:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"14778:6:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"14786:6:7","type":""}],"src":"14666:945:7"},{"body":{"nodeType":"YulBlock","src":"15649:28:7","statements":[{"nodeType":"YulAssignment","src":"15659:12:7","value":{"name":"value","nodeType":"YulIdentifier","src":"15666:5:7"},"variableNames":[{"name":"ret","nodeType":"YulIdentifier","src":"15659:3:7"}]}]},"name":"identity","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"15635:5:7","type":""}],"returnVariables":[{"name":"ret","nodeType":"YulTypedName","src":"15645:3:7","type":""}],"src":"15617:60:7"},{"body":{"nodeType":"YulBlock","src":"15743:82:7","statements":[{"nodeType":"YulAssignment","src":"15753:66:7","value":{"arguments":[{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"15811:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"15793:17:7"},"nodeType":"YulFunctionCall","src":"15793:24:7"}],"functionName":{"name":"identity","nodeType":"YulIdentifier","src":"15784:8:7"},"nodeType":"YulFunctionCall","src":"15784:34:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"15766:17:7"},"nodeType":"YulFunctionCall","src":"15766:53:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"15753:9:7"}]}]},"name":"convert_t_uint160_to_t_uint160","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"15723:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"15733:9:7","type":""}],"src":"15683:142:7"},{"body":{"nodeType":"YulBlock","src":"15891:66:7","statements":[{"nodeType":"YulAssignment","src":"15901:50:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"15945:5:7"}],"functionName":{"name":"convert_t_uint160_to_t_uint160","nodeType":"YulIdentifier","src":"15914:30:7"},"nodeType":"YulFunctionCall","src":"15914:37:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"15901:9:7"}]}]},"name":"convert_t_uint160_to_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"15871:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"15881:9:7","type":""}],"src":"15831:126:7"},{"body":{"nodeType":"YulBlock","src":"16044:66:7","statements":[{"nodeType":"YulAssignment","src":"16054:50:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16098:5:7"}],"functionName":{"name":"convert_t_uint160_to_t_address","nodeType":"YulIdentifier","src":"16067:30:7"},"nodeType":"YulFunctionCall","src":"16067:37:7"},"variableNames":[{"name":"converted","nodeType":"YulIdentifier","src":"16054:9:7"}]}]},"name":"convert_t_contract$_BaseContract_$1001_to_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16024:5:7","type":""}],"returnVariables":[{"name":"converted","nodeType":"YulTypedName","src":"16034:9:7","type":""}],"src":"15963:147:7"},{"body":{"nodeType":"YulBlock","src":"16202:87:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16219:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16276:5:7"}],"functionName":{"name":"convert_t_contract$_BaseContract_$1001_to_t_address","nodeType":"YulIdentifier","src":"16224:51:7"},"nodeType":"YulFunctionCall","src":"16224:58:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16212:6:7"},"nodeType":"YulFunctionCall","src":"16212:71:7"},"nodeType":"YulExpressionStatement","src":"16212:71:7"}]},"name":"abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16190:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"16197:3:7","type":""}],"src":"16116:173:7"},{"body":{"nodeType":"YulBlock","src":"16414:145:7","statements":[{"nodeType":"YulAssignment","src":"16424:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"16436:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"16447:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16432:3:7"},"nodeType":"YulFunctionCall","src":"16432:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"16424:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"16525:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"16538:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"16549:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16534:3:7"},"nodeType":"YulFunctionCall","src":"16534:17:7"}],"functionName":{"name":"abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack","nodeType":"YulIdentifier","src":"16460:64:7"},"nodeType":"YulFunctionCall","src":"16460:92:7"},"nodeType":"YulExpressionStatement","src":"16460:92:7"}]},"name":"abi_encode_tuple_t_contract$_BaseContract_$1001__to_t_address__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"16386:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"16398:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"16409:4:7","type":""}],"src":"16295:264:7"},{"body":{"nodeType":"YulBlock","src":"16684:40:7","statements":[{"nodeType":"YulAssignment","src":"16695:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"16711:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"16705:5:7"},"nodeType":"YulFunctionCall","src":"16705:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"16695:6:7"}]}]},"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"16667:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"16677:6:7","type":""}],"src":"16565:159:7"},{"body":{"nodeType":"YulBlock","src":"16886:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16903:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"16908:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"16896:6:7"},"nodeType":"YulFunctionCall","src":"16896:19:7"},"nodeType":"YulExpressionStatement","src":"16896:19:7"},{"nodeType":"YulAssignment","src":"16924:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"16943:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"16948:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"16939:3:7"},"nodeType":"YulFunctionCall","src":"16939:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"16924:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"16858:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"16863:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"16874:11:7","type":""}],"src":"16730:229:7"},{"body":{"nodeType":"YulBlock","src":"17082:60:7","statements":[{"nodeType":"YulAssignment","src":"17092:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"17100:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17092:4:7"}]},{"nodeType":"YulAssignment","src":"17113:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"17125:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17130:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17121:3:7"},"nodeType":"YulFunctionCall","src":"17121:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17113:4:7"}]}]},"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"17069:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"17077:4:7","type":""}],"src":"16965:177:7"},{"body":{"nodeType":"YulBlock","src":"17242:40:7","statements":[{"nodeType":"YulAssignment","src":"17253:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17269:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17263:5:7"},"nodeType":"YulFunctionCall","src":"17263:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"17253:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"17225:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"17235:6:7","type":""}],"src":"17148:134:7"},{"body":{"nodeType":"YulBlock","src":"17409:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17426:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"17431:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17419:6:7"},"nodeType":"YulFunctionCall","src":"17419:19:7"},"nodeType":"YulExpressionStatement","src":"17419:19:7"},{"nodeType":"YulAssignment","src":"17447:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17466:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17471:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17462:3:7"},"nodeType":"YulFunctionCall","src":"17462:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"17447:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"17381:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"17386:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"17397:11:7","type":""}],"src":"17288:194:7"},{"body":{"nodeType":"YulBlock","src":"17580:60:7","statements":[{"nodeType":"YulAssignment","src":"17590:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"17598:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17590:4:7"}]},{"nodeType":"YulAssignment","src":"17611:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"17623:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"17628:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"17619:3:7"},"nodeType":"YulFunctionCall","src":"17619:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"17611:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"17567:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"17575:4:7","type":""}],"src":"17488:152:7"},{"body":{"nodeType":"YulBlock","src":"17701:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"17718:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17741:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"17723:17:7"},"nodeType":"YulFunctionCall","src":"17723:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"17711:6:7"},"nodeType":"YulFunctionCall","src":"17711:37:7"},"nodeType":"YulExpressionStatement","src":"17711:37:7"}]},"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"17689:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"17696:3:7","type":""}],"src":"17646:108:7"},{"body":{"nodeType":"YulBlock","src":"17854:40:7","statements":[{"nodeType":"YulAssignment","src":"17865:22:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"17881:5:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"17875:5:7"},"nodeType":"YulFunctionCall","src":"17875:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"17865:6:7"}]}]},"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"17837:5:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"17847:6:7","type":""}],"src":"17760:134:7"},{"body":{"nodeType":"YulBlock","src":"18021:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18038:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"18043:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"18031:6:7"},"nodeType":"YulFunctionCall","src":"18031:19:7"},"nodeType":"YulExpressionStatement","src":"18031:19:7"},{"nodeType":"YulAssignment","src":"18059:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18078:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18083:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18074:3:7"},"nodeType":"YulFunctionCall","src":"18074:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"18059:11:7"}]}]},"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"17993:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"17998:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"18009:11:7","type":""}],"src":"17900:194:7"},{"body":{"nodeType":"YulBlock","src":"18192:60:7","statements":[{"nodeType":"YulAssignment","src":"18202:11:7","value":{"name":"ptr","nodeType":"YulIdentifier","src":"18210:3:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"18202:4:7"}]},{"nodeType":"YulAssignment","src":"18223:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"18235:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18240:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18231:3:7"},"nodeType":"YulFunctionCall","src":"18231:14:7"},"variableNames":[{"name":"data","nodeType":"YulIdentifier","src":"18223:4:7"}]}]},"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"18179:3:7","type":""}],"returnVariables":[{"name":"data","nodeType":"YulTypedName","src":"18187:4:7","type":""}],"src":"18100:152:7"},{"body":{"nodeType":"YulBlock","src":"18424:500:7","statements":[{"nodeType":"YulVariableDeclaration","src":"18434:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18450:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18455:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18446:3:7"},"nodeType":"YulFunctionCall","src":"18446:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"18438:4:7","type":""}]},{"nodeType":"YulBlock","src":"18470:181:7","statements":[{"nodeType":"YulVariableDeclaration","src":"18506:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18536:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"18543:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18532:3:7"},"nodeType":"YulFunctionCall","src":"18532:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"18526:5:7"},"nodeType":"YulFunctionCall","src":"18526:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"18510:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"18612:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18630:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18635:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18626:3:7"},"nodeType":"YulFunctionCall","src":"18626:14:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable","nodeType":"YulIdentifier","src":"18562:49:7"},"nodeType":"YulFunctionCall","src":"18562:79:7"},"nodeType":"YulExpressionStatement","src":"18562:79:7"}]},{"nodeType":"YulBlock","src":"18661:236:7","statements":[{"nodeType":"YulVariableDeclaration","src":"18697:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"18727:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"18734:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18723:3:7"},"nodeType":"YulFunctionCall","src":"18723:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"18717:5:7"},"nodeType":"YulFunctionCall","src":"18717:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"18701:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"18765:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"18770:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"18761:3:7"},"nodeType":"YulFunctionCall","src":"18761:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"18781:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"18787:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"18777:3:7"},"nodeType":"YulFunctionCall","src":"18777:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"18754:6:7"},"nodeType":"YulFunctionCall","src":"18754:38:7"},"nodeType":"YulExpressionStatement","src":"18754:38:7"},{"nodeType":"YulAssignment","src":"18805:81:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"18867:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"18881:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr","nodeType":"YulIdentifier","src":"18813:53:7"},"nodeType":"YulFunctionCall","src":"18813:73:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"18805:4:7"}]}]},{"nodeType":"YulAssignment","src":"18907:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"18914:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"18907:3:7"}]}]},"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"18403:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"18410:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"18419:3:7","type":""}],"src":"18320:604:7"},{"body":{"nodeType":"YulBlock","src":"19050:116:7","statements":[{"nodeType":"YulAssignment","src":"19060:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"19148:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"19156:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"19074:73:7"},"nodeType":"YulFunctionCall","src":"19074:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"19060:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"19023:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"19031:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"19039:10:7","type":""}],"src":"18930:236:7"},{"body":{"nodeType":"YulBlock","src":"19267:38:7","statements":[{"nodeType":"YulAssignment","src":"19277:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"19289:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"19294:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19285:3:7"},"nodeType":"YulFunctionCall","src":"19285:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"19277:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"19254:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"19262:4:7","type":""}],"src":"19172:133:7"},{"body":{"nodeType":"YulBlock","src":"19531:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19541:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19623:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"19555:67:7"},"nodeType":"YulFunctionCall","src":"19555:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"19545:6:7","type":""}]},{"nodeType":"YulAssignment","src":"19638:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19729:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"19734:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"19645:83:7"},"nodeType":"YulFunctionCall","src":"19645:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"19638:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"19750:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"19767:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"19754:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"19779:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"19795:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"19804:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"19812:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"19800:3:7"},"nodeType":"YulFunctionCall","src":"19800:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19791:3:7"},"nodeType":"YulFunctionCall","src":"19791:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"19783:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"19827:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"19912:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"19842:69:7"},"nodeType":"YulFunctionCall","src":"19842:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"19831:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"19927:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"19941:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"19931:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"20017:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"20038:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"20047:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"20053:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"20043:3:7"},"nodeType":"YulFunctionCall","src":"20043:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"20031:6:7"},"nodeType":"YulFunctionCall","src":"20031:33:7"},"nodeType":"YulExpressionStatement","src":"20031:33:7"},{"nodeType":"YulVariableDeclaration","src":"20077:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"20104:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"20098:5:7"},"nodeType":"YulFunctionCall","src":"20098:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"20081:13:7","type":""}]},{"nodeType":"YulAssignment","src":"20124:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"20216:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"20231:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr","nodeType":"YulIdentifier","src":"20132:83:7"},"nodeType":"YulFunctionCall","src":"20132:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"20124:4:7"}]},{"nodeType":"YulAssignment","src":"20249:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"20332:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20259:72:7"},"nodeType":"YulFunctionCall","src":"20259:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"20249:6:7"}]},{"nodeType":"YulAssignment","src":"20352:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"20363:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20368:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20359:3:7"},"nodeType":"YulFunctionCall","src":"20359:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"20352:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"19979:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"19982:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"19976:2:7"},"nodeType":"YulFunctionCall","src":"19976:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"19990:18:7","statements":[{"nodeType":"YulAssignment","src":"19992:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"20001:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"20004:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"19997:3:7"},"nodeType":"YulFunctionCall","src":"19997:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"19992:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"19961:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"19963:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"19972:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"19967:1:7","type":""}]}]},"src":"19957:426:7"},{"nodeType":"YulAssignment","src":"20392:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"20399:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"20392:3:7"}]},{"nodeType":"YulAssignment","src":"20412:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"20419:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"20412:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"19510:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"19517:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"19526:3:7","type":""}],"src":"19377:1051:7"},{"body":{"nodeType":"YulBlock","src":"20598:559:7","statements":[{"nodeType":"YulVariableDeclaration","src":"20608:26:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"20624:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20629:4:7","type":"","value":"0x40"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20620:3:7"},"nodeType":"YulFunctionCall","src":"20620:14:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"20612:4:7","type":""}]},{"nodeType":"YulBlock","src":"20644:169:7","statements":[{"nodeType":"YulVariableDeclaration","src":"20684:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"20714:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"20721:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20710:3:7"},"nodeType":"YulFunctionCall","src":"20710:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"20704:5:7"},"nodeType":"YulFunctionCall","src":"20704:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"20688:12:7","type":""}]},{"expression":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"20774:12:7"},{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"20792:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20797:4:7","type":"","value":"0x00"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20788:3:7"},"nodeType":"YulFunctionCall","src":"20788:14:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256","nodeType":"YulIdentifier","src":"20740:33:7"},"nodeType":"YulFunctionCall","src":"20740:63:7"},"nodeType":"YulExpressionStatement","src":"20740:63:7"}]},{"nodeType":"YulBlock","src":"20823:307:7","statements":[{"nodeType":"YulVariableDeclaration","src":"20860:43:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"20890:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"20897:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20886:3:7"},"nodeType":"YulFunctionCall","src":"20886:16:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"20880:5:7"},"nodeType":"YulFunctionCall","src":"20880:23:7"},"variables":[{"name":"memberValue0","nodeType":"YulTypedName","src":"20864:12:7","type":""}]},{"expression":{"arguments":[{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"20928:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"20933:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"20924:3:7"},"nodeType":"YulFunctionCall","src":"20924:14:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"20944:4:7"},{"name":"pos","nodeType":"YulIdentifier","src":"20950:3:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"20940:3:7"},"nodeType":"YulFunctionCall","src":"20940:14:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"20917:6:7"},"nodeType":"YulFunctionCall","src":"20917:38:7"},"nodeType":"YulExpressionStatement","src":"20917:38:7"},{"nodeType":"YulAssignment","src":"20968:151:7","value":{"arguments":[{"name":"memberValue0","nodeType":"YulIdentifier","src":"21100:12:7"},{"name":"tail","nodeType":"YulIdentifier","src":"21114:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"20976:123:7"},"nodeType":"YulFunctionCall","src":"20976:143:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"20968:4:7"}]}]},{"nodeType":"YulAssignment","src":"21140:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"21147:4:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"21140:3:7"}]}]},"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"20577:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"20584:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"20593:3:7","type":""}],"src":"20494:663:7"},{"body":{"nodeType":"YulBlock","src":"21283:116:7","statements":[{"nodeType":"YulAssignment","src":"21293:100:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"21381:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"21389:3:7"}],"functionName":{"name":"abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"21307:73:7"},"nodeType":"YulFunctionCall","src":"21307:86:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"21293:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"21256:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"21264:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"21272:10:7","type":""}],"src":"21163:236:7"},{"body":{"nodeType":"YulBlock","src":"21500:38:7","statements":[{"nodeType":"YulAssignment","src":"21510:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"21522:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"21527:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"21518:3:7"},"nodeType":"YulFunctionCall","src":"21518:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"21510:4:7"}]}]},"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"21487:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"21495:4:7","type":""}],"src":"21405:133:7"},{"body":{"nodeType":"YulBlock","src":"21762:897:7","statements":[{"nodeType":"YulVariableDeclaration","src":"21772:88:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"21854:5:7"}],"functionName":{"name":"array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21786:67:7"},"nodeType":"YulFunctionCall","src":"21786:74:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"21776:6:7","type":""}]},{"nodeType":"YulAssignment","src":"21869:103:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"21960:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"21965:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"21876:83:7"},"nodeType":"YulFunctionCall","src":"21876:96:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"21869:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"21981:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"21998:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"21985:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22010:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22026:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"22035:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"22043:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"22031:3:7"},"nodeType":"YulFunctionCall","src":"22031:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22022:3:7"},"nodeType":"YulFunctionCall","src":"22022:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"22014:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22058:91:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"22143:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22073:69:7"},"nodeType":"YulFunctionCall","src":"22073:76:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"22062:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"22158:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"22172:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"22162:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"22248:366:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22269:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"22278:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"22284:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"22274:3:7"},"nodeType":"YulFunctionCall","src":"22274:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"22262:6:7"},"nodeType":"YulFunctionCall","src":"22262:33:7"},"nodeType":"YulExpressionStatement","src":"22262:33:7"},{"nodeType":"YulVariableDeclaration","src":"22308:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"22335:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"22329:5:7"},"nodeType":"YulFunctionCall","src":"22329:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"22312:13:7","type":""}]},{"nodeType":"YulAssignment","src":"22355:112:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"22447:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"22462:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr","nodeType":"YulIdentifier","src":"22363:83:7"},"nodeType":"YulFunctionCall","src":"22363:104:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"22355:4:7"}]},{"nodeType":"YulAssignment","src":"22480:90:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"22563:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22490:72:7"},"nodeType":"YulFunctionCall","src":"22490:80:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"22480:6:7"}]},{"nodeType":"YulAssignment","src":"22583:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"22594:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"22599:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22590:3:7"},"nodeType":"YulFunctionCall","src":"22590:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"22583:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"22210:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"22213:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"22207:2:7"},"nodeType":"YulFunctionCall","src":"22207:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"22221:18:7","statements":[{"nodeType":"YulAssignment","src":"22223:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"22232:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"22235:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"22228:3:7"},"nodeType":"YulFunctionCall","src":"22228:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"22223:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"22192:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"22194:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"22203:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"22198:1:7","type":""}]}]},"src":"22188:426:7"},{"nodeType":"YulAssignment","src":"22623:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"22630:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"22623:3:7"}]},{"nodeType":"YulAssignment","src":"22643:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"22650:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"22643:3:7"}]}]},"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"21741:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"21748:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"21757:3:7","type":""}],"src":"21608:1051:7"},{"body":{"nodeType":"YulBlock","src":"22835:166:7","statements":[{"nodeType":"YulAssignment","src":"22845:150:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"22983:6:7"},{"name":"pos","nodeType":"YulIdentifier","src":"22991:3:7"}],"functionName":{"name":"abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"22859:123:7"},"nodeType":"YulFunctionCall","src":"22859:136:7"},"variableNames":[{"name":"updatedPos","nodeType":"YulIdentifier","src":"22845:10:7"}]}]},"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"value0","nodeType":"YulTypedName","src":"22808:6:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"22816:3:7","type":""}],"returnVariables":[{"name":"updatedPos","nodeType":"YulTypedName","src":"22824:10:7","type":""}],"src":"22665:336:7"},{"body":{"nodeType":"YulBlock","src":"23127:38:7","statements":[{"nodeType":"YulAssignment","src":"23137:22:7","value":{"arguments":[{"name":"ptr","nodeType":"YulIdentifier","src":"23149:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"23154:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23145:3:7"},"nodeType":"YulFunctionCall","src":"23145:14:7"},"variableNames":[{"name":"next","nodeType":"YulIdentifier","src":"23137:4:7"}]}]},"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulFunctionDefinition","parameters":[{"name":"ptr","nodeType":"YulTypedName","src":"23114:3:7","type":""}],"returnVariables":[{"name":"next","nodeType":"YulTypedName","src":"23122:4:7","type":""}],"src":"23007:158:7"},{"body":{"nodeType":"YulBlock","src":"23453:1057:7","statements":[{"nodeType":"YulVariableDeclaration","src":"23463:113:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"23570:5:7"}],"functionName":{"name":"array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23477:92:7"},"nodeType":"YulFunctionCall","src":"23477:99:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"23467:6:7","type":""}]},{"nodeType":"YulAssignment","src":"23585:138:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23711:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"23716:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"23592:118:7"},"nodeType":"YulFunctionCall","src":"23592:131:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"23585:3:7"}]},{"nodeType":"YulVariableDeclaration","src":"23732:20:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"23749:3:7"},"variables":[{"name":"headStart","nodeType":"YulTypedName","src":"23736:9:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"23761:39:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"23777:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"23786:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"23794:4:7","type":"","value":"0x20"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"23782:3:7"},"nodeType":"YulFunctionCall","src":"23782:17:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"23773:3:7"},"nodeType":"YulFunctionCall","src":"23773:27:7"},"variables":[{"name":"tail","nodeType":"YulTypedName","src":"23765:4:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"23809:116:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"23919:5:7"}],"functionName":{"name":"array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"23824:94:7"},"nodeType":"YulFunctionCall","src":"23824:101:7"},"variables":[{"name":"baseRef","nodeType":"YulTypedName","src":"23813:7:7","type":""}]},{"nodeType":"YulVariableDeclaration","src":"23934:21:7","value":{"name":"baseRef","nodeType":"YulIdentifier","src":"23948:7:7"},"variables":[{"name":"srcPtr","nodeType":"YulTypedName","src":"23938:6:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"24024:441:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24045:3:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"24054:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"24060:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"24050:3:7"},"nodeType":"YulFunctionCall","src":"24050:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"24038:6:7"},"nodeType":"YulFunctionCall","src":"24038:33:7"},"nodeType":"YulExpressionStatement","src":"24038:33:7"},{"nodeType":"YulVariableDeclaration","src":"24084:34:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"24111:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"24105:5:7"},"nodeType":"YulFunctionCall","src":"24105:13:7"},"variables":[{"name":"elementValue0","nodeType":"YulTypedName","src":"24088:13:7","type":""}]},{"nodeType":"YulAssignment","src":"24131:162:7","value":{"arguments":[{"name":"elementValue0","nodeType":"YulIdentifier","src":"24273:13:7"},{"name":"tail","nodeType":"YulIdentifier","src":"24288:4:7"}],"functionName":{"name":"abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"24139:133:7"},"nodeType":"YulFunctionCall","src":"24139:154:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"24131:4:7"}]},{"nodeType":"YulAssignment","src":"24306:115:7","value":{"arguments":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"24414:6:7"}],"functionName":{"name":"array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr","nodeType":"YulIdentifier","src":"24316:97:7"},"nodeType":"YulFunctionCall","src":"24316:105:7"},"variableNames":[{"name":"srcPtr","nodeType":"YulIdentifier","src":"24306:6:7"}]},{"nodeType":"YulAssignment","src":"24434:21:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"24445:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"24450:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24441:3:7"},"nodeType":"YulFunctionCall","src":"24441:14:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"24434:3:7"}]}]},"condition":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"23986:1:7"},{"name":"length","nodeType":"YulIdentifier","src":"23989:6:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"23983:2:7"},"nodeType":"YulFunctionCall","src":"23983:13:7"},"nodeType":"YulForLoop","post":{"nodeType":"YulBlock","src":"23997:18:7","statements":[{"nodeType":"YulAssignment","src":"23999:14:7","value":{"arguments":[{"name":"i","nodeType":"YulIdentifier","src":"24008:1:7"},{"kind":"number","nodeType":"YulLiteral","src":"24011:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24004:3:7"},"nodeType":"YulFunctionCall","src":"24004:9:7"},"variableNames":[{"name":"i","nodeType":"YulIdentifier","src":"23999:1:7"}]}]},"pre":{"nodeType":"YulBlock","src":"23968:14:7","statements":[{"nodeType":"YulVariableDeclaration","src":"23970:10:7","value":{"kind":"number","nodeType":"YulLiteral","src":"23979:1:7","type":"","value":"0"},"variables":[{"name":"i","nodeType":"YulTypedName","src":"23974:1:7","type":""}]}]},"src":"23964:501:7"},{"nodeType":"YulAssignment","src":"24474:11:7","value":{"name":"tail","nodeType":"YulIdentifier","src":"24481:4:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"24474:3:7"}]},{"nodeType":"YulAssignment","src":"24494:10:7","value":{"name":"pos","nodeType":"YulIdentifier","src":"24501:3:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"24494:3:7"}]}]},"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"23432:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"23439:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"23448:3:7","type":""}],"src":"23239:1271:7"},{"body":{"nodeType":"YulBlock","src":"24754:315:7","statements":[{"nodeType":"YulAssignment","src":"24764:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"24776:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"24787:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24772:3:7"},"nodeType":"YulFunctionCall","src":"24772:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"24764:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"24811:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"24822:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"24807:3:7"},"nodeType":"YulFunctionCall","src":"24807:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"24830:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"24836:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"24826:3:7"},"nodeType":"YulFunctionCall","src":"24826:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"24800:6:7"},"nodeType":"YulFunctionCall","src":"24800:47:7"},"nodeType":"YulExpressionStatement","src":"24800:47:7"},{"nodeType":"YulAssignment","src":"24856:206:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25048:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"25057:4:7"}],"functionName":{"name":"abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"24864:183:7"},"nodeType":"YulFunctionCall","src":"24864:198:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"24856:4:7"}]}]},"name":"abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"24726:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"24738:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"24749:4:7","type":""}],"src":"24516:553:7"},{"body":{"nodeType":"YulBlock","src":"25117:48:7","statements":[{"nodeType":"YulAssignment","src":"25127:32:7","value":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25152:5:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25145:6:7"},"nodeType":"YulFunctionCall","src":"25145:13:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"25138:6:7"},"nodeType":"YulFunctionCall","src":"25138:21:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"25127:7:7"}]}]},"name":"cleanup_t_bool","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25099:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"25109:7:7","type":""}],"src":"25075:90:7"},{"body":{"nodeType":"YulBlock","src":"25230:50:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25247:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25267:5:7"}],"functionName":{"name":"cleanup_t_bool","nodeType":"YulIdentifier","src":"25252:14:7"},"nodeType":"YulFunctionCall","src":"25252:21:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25240:6:7"},"nodeType":"YulFunctionCall","src":"25240:34:7"},"nodeType":"YulExpressionStatement","src":"25240:34:7"}]},"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25218:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25225:3:7","type":""}],"src":"25171:109:7"},{"body":{"nodeType":"YulBlock","src":"25378:118:7","statements":[{"nodeType":"YulAssignment","src":"25388:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25400:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25411:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25396:3:7"},"nodeType":"YulFunctionCall","src":"25396:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"25388:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"25462:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"25475:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"25486:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25471:3:7"},"nodeType":"YulFunctionCall","src":"25471:17:7"}],"functionName":{"name":"abi_encode_t_bool_to_t_bool_fromStack","nodeType":"YulIdentifier","src":"25424:37:7"},"nodeType":"YulFunctionCall","src":"25424:65:7"},"nodeType":"YulExpressionStatement","src":"25424:65:7"}]},"name":"abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"25350:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"25362:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"25373:4:7","type":""}],"src":"25286:210:7"},{"body":{"nodeType":"YulBlock","src":"25583:61:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25600:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25631:5:7"}],"functionName":{"name":"cleanup_t_address_payable","nodeType":"YulIdentifier","src":"25605:25:7"},"nodeType":"YulFunctionCall","src":"25605:32:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25593:6:7"},"nodeType":"YulFunctionCall","src":"25593:45:7"},"nodeType":"YulExpressionStatement","src":"25593:45:7"}]},"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25571:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25578:3:7","type":""}],"src":"25502:142:7"},{"body":{"nodeType":"YulBlock","src":"25746:73:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25763:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"25768:6:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"25756:6:7"},"nodeType":"YulFunctionCall","src":"25756:19:7"},"nodeType":"YulExpressionStatement","src":"25756:19:7"},{"nodeType":"YulAssignment","src":"25784:29:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"25803:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"25808:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"25799:3:7"},"nodeType":"YulFunctionCall","src":"25799:14:7"},"variableNames":[{"name":"updated_pos","nodeType":"YulIdentifier","src":"25784:11:7"}]}]},"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"25718:3:7","type":""},{"name":"length","nodeType":"YulTypedName","src":"25723:6:7","type":""}],"returnVariables":[{"name":"updated_pos","nodeType":"YulTypedName","src":"25734:11:7","type":""}],"src":"25650:169:7"},{"body":{"nodeType":"YulBlock","src":"25917:272:7","statements":[{"nodeType":"YulVariableDeclaration","src":"25927:53:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"25974:5:7"}],"functionName":{"name":"array_length_t_string_memory_ptr","nodeType":"YulIdentifier","src":"25941:32:7"},"nodeType":"YulFunctionCall","src":"25941:39:7"},"variables":[{"name":"length","nodeType":"YulTypedName","src":"25931:6:7","type":""}]},{"nodeType":"YulAssignment","src":"25989:78:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26055:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"26060:6:7"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"25996:58:7"},"nodeType":"YulFunctionCall","src":"25996:71:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"25989:3:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26102:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"26109:4:7","type":"","value":"0x20"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26098:3:7"},"nodeType":"YulFunctionCall","src":"26098:16:7"},{"name":"pos","nodeType":"YulIdentifier","src":"26116:3:7"},{"name":"length","nodeType":"YulIdentifier","src":"26121:6:7"}],"functionName":{"name":"copy_memory_to_memory","nodeType":"YulIdentifier","src":"26076:21:7"},"nodeType":"YulFunctionCall","src":"26076:52:7"},"nodeType":"YulExpressionStatement","src":"26076:52:7"},{"nodeType":"YulAssignment","src":"26137:46:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26148:3:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"26175:6:7"}],"functionName":{"name":"round_up_to_mul_of_32","nodeType":"YulIdentifier","src":"26153:21:7"},"nodeType":"YulFunctionCall","src":"26153:29:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26144:3:7"},"nodeType":"YulFunctionCall","src":"26144:39:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"26137:3:7"}]}]},"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"25898:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"25905:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"25913:3:7","type":""}],"src":"25825:364:7"},{"body":{"nodeType":"YulBlock","src":"26357:293:7","statements":[{"nodeType":"YulAssignment","src":"26367:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26379:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26390:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26375:3:7"},"nodeType":"YulFunctionCall","src":"26375:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26367:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"26463:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26476:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26487:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26472:3:7"},"nodeType":"YulFunctionCall","src":"26472:17:7"}],"functionName":{"name":"abi_encode_t_address_payable_to_t_address_payable_fromStack","nodeType":"YulIdentifier","src":"26403:59:7"},"nodeType":"YulFunctionCall","src":"26403:87:7"},"nodeType":"YulExpressionStatement","src":"26403:87:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"26511:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"26522:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26507:3:7"},"nodeType":"YulFunctionCall","src":"26507:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"26531:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"26537:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"26527:3:7"},"nodeType":"YulFunctionCall","src":"26527:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26500:6:7"},"nodeType":"YulFunctionCall","src":"26500:48:7"},"nodeType":"YulExpressionStatement","src":"26500:48:7"},{"nodeType":"YulAssignment","src":"26557:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"26629:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"26638:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"26565:63:7"},"nodeType":"YulFunctionCall","src":"26565:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26557:4:7"}]}]},"name":"abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26321:9:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"26333:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26341:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26352:4:7","type":""}],"src":"26195:455:7"},{"body":{"nodeType":"YulBlock","src":"26701:51:7","statements":[{"nodeType":"YulAssignment","src":"26711:35:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26740:5:7"}],"functionName":{"name":"cleanup_t_uint160","nodeType":"YulIdentifier","src":"26722:17:7"},"nodeType":"YulFunctionCall","src":"26722:24:7"},"variableNames":[{"name":"cleaned","nodeType":"YulIdentifier","src":"26711:7:7"}]}]},"name":"cleanup_t_address","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"26683:5:7","type":""}],"returnVariables":[{"name":"cleaned","nodeType":"YulTypedName","src":"26693:7:7","type":""}],"src":"26656:96:7"},{"body":{"nodeType":"YulBlock","src":"26823:53:7","statements":[{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"26840:3:7"},{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"26863:5:7"}],"functionName":{"name":"cleanup_t_address","nodeType":"YulIdentifier","src":"26845:17:7"},"nodeType":"YulFunctionCall","src":"26845:24:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"26833:6:7"},"nodeType":"YulFunctionCall","src":"26833:37:7"},"nodeType":"YulExpressionStatement","src":"26833:37:7"}]},"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"26811:5:7","type":""},{"name":"pos","nodeType":"YulTypedName","src":"26818:3:7","type":""}],"src":"26758:118:7"},{"body":{"nodeType":"YulBlock","src":"26980:124:7","statements":[{"nodeType":"YulAssignment","src":"26990:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27002:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27013:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"26998:3:7"},"nodeType":"YulFunctionCall","src":"26998:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"26990:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27070:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27083:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27094:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27079:3:7"},"nodeType":"YulFunctionCall","src":"27079:17:7"}],"functionName":{"name":"abi_encode_t_address_to_t_address_fromStack","nodeType":"YulIdentifier","src":"27026:43:7"},"nodeType":"YulFunctionCall","src":"27026:71:7"},"nodeType":"YulExpressionStatement","src":"27026:71:7"}]},"name":"abi_encode_tuple_t_address__to_t_address__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"26952:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"26964:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"26975:4:7","type":""}],"src":"26882:222:7"},{"body":{"nodeType":"YulBlock","src":"27284:359:7","statements":[{"nodeType":"YulAssignment","src":"27294:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27306:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27317:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27302:3:7"},"nodeType":"YulFunctionCall","src":"27302:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27294:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27374:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27387:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27398:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27383:3:7"},"nodeType":"YulFunctionCall","src":"27383:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"27330:43:7"},"nodeType":"YulFunctionCall","src":"27330:71:7"},"nodeType":"YulExpressionStatement","src":"27330:71:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27422:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27433:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27418:3:7"},"nodeType":"YulFunctionCall","src":"27418:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27442:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"27448:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"27438:3:7"},"nodeType":"YulFunctionCall","src":"27438:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27411:6:7"},"nodeType":"YulFunctionCall","src":"27411:48:7"},"nodeType":"YulExpressionStatement","src":"27411:48:7"},{"nodeType":"YulAssignment","src":"27468:86:7","value":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"27540:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"27549:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27476:63:7"},"nodeType":"YulFunctionCall","src":"27476:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27468:4:7"}]},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"27608:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27621:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27632:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27617:3:7"},"nodeType":"YulFunctionCall","src":"27617:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"27564:43:7"},"nodeType":"YulFunctionCall","src":"27564:72:7"},"nodeType":"YulExpressionStatement","src":"27564:72:7"}]},"name":"abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"27240:9:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"27252:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"27260:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"27268:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"27279:4:7","type":""}],"src":"27110:533:7"},{"body":{"nodeType":"YulBlock","src":"27767:195:7","statements":[{"nodeType":"YulAssignment","src":"27777:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27789:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27800:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27785:3:7"},"nodeType":"YulFunctionCall","src":"27785:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27777:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"27824:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"27835:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"27820:3:7"},"nodeType":"YulFunctionCall","src":"27820:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"27843:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"27849:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"27839:3:7"},"nodeType":"YulFunctionCall","src":"27839:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"27813:6:7"},"nodeType":"YulFunctionCall","src":"27813:47:7"},"nodeType":"YulExpressionStatement","src":"27813:47:7"},{"nodeType":"YulAssignment","src":"27869:86:7","value":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"27941:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"27950:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"27877:63:7"},"nodeType":"YulFunctionCall","src":"27877:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"27869:4:7"}]}]},"name":"abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"27739:9:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"27751:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"27762:4:7","type":""}],"src":"27649:313:7"},{"body":{"nodeType":"YulBlock","src":"28074:67:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"28096:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"28104:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28092:3:7"},"nodeType":"YulFunctionCall","src":"28092:14:7"},{"hexValue":"436f6e7472616374206973206e6f7420656e61626c6564","kind":"string","nodeType":"YulLiteral","src":"28108:25:7","type":"","value":"Contract is not enabled"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28085:6:7"},"nodeType":"YulFunctionCall","src":"28085:49:7"},"nodeType":"YulExpressionStatement","src":"28085:49:7"}]},"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"28066:6:7","type":""}],"src":"27968:173:7"},{"body":{"nodeType":"YulBlock","src":"28293:220:7","statements":[{"nodeType":"YulAssignment","src":"28303:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28369:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"28374:2:7","type":"","value":"23"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"28310:58:7"},"nodeType":"YulFunctionCall","src":"28310:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"28303:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28475:3:7"}],"functionName":{"name":"store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f","nodeType":"YulIdentifier","src":"28386:88:7"},"nodeType":"YulFunctionCall","src":"28386:93:7"},"nodeType":"YulExpressionStatement","src":"28386:93:7"},{"nodeType":"YulAssignment","src":"28488:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"28499:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"28504:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28495:3:7"},"nodeType":"YulFunctionCall","src":"28495:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"28488:3:7"}]}]},"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"28281:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"28289:3:7","type":""}],"src":"28147:366:7"},{"body":{"nodeType":"YulBlock","src":"28690:248:7","statements":[{"nodeType":"YulAssignment","src":"28700:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"28712:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"28723:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28708:3:7"},"nodeType":"YulFunctionCall","src":"28708:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"28700:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"28747:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"28758:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"28743:3:7"},"nodeType":"YulFunctionCall","src":"28743:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"28766:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"28772:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"28762:3:7"},"nodeType":"YulFunctionCall","src":"28762:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28736:6:7"},"nodeType":"YulFunctionCall","src":"28736:47:7"},"nodeType":"YulExpressionStatement","src":"28736:47:7"},{"nodeType":"YulAssignment","src":"28792:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"28926:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"28800:124:7"},"nodeType":"YulFunctionCall","src":"28800:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"28792:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"28670:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"28685:4:7","type":""}],"src":"28519:419:7"},{"body":{"nodeType":"YulBlock","src":"28972:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"28989:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"28992:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"28982:6:7"},"nodeType":"YulFunctionCall","src":"28982:88:7"},"nodeType":"YulExpressionStatement","src":"28982:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29086:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"29089:4:7","type":"","value":"0x32"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29079:6:7"},"nodeType":"YulFunctionCall","src":"29079:15:7"},"nodeType":"YulExpressionStatement","src":"29079:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29110:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29113:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"29103:6:7"},"nodeType":"YulFunctionCall","src":"29103:15:7"},"nodeType":"YulExpressionStatement","src":"29103:15:7"}]},"name":"panic_error_0x32","nodeType":"YulFunctionDefinition","src":"28944:180:7"},{"body":{"nodeType":"YulBlock","src":"29158:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29175:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29178:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29168:6:7"},"nodeType":"YulFunctionCall","src":"29168:88:7"},"nodeType":"YulExpressionStatement","src":"29168:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29272:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"29275:4:7","type":"","value":"0x11"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29265:6:7"},"nodeType":"YulFunctionCall","src":"29265:15:7"},"nodeType":"YulExpressionStatement","src":"29265:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"29296:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"29299:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"29289:6:7"},"nodeType":"YulFunctionCall","src":"29289:15:7"},"nodeType":"YulExpressionStatement","src":"29289:15:7"}]},"name":"panic_error_0x11","nodeType":"YulFunctionDefinition","src":"29130:180:7"},{"body":{"nodeType":"YulBlock","src":"29359:190:7","statements":[{"nodeType":"YulAssignment","src":"29369:33:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29396:5:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"29378:17:7"},"nodeType":"YulFunctionCall","src":"29378:24:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"29369:5:7"}]},{"body":{"nodeType":"YulBlock","src":"29492:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"29494:16:7"},"nodeType":"YulFunctionCall","src":"29494:18:7"},"nodeType":"YulExpressionStatement","src":"29494:18:7"}]},"condition":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29417:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"29424:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"29414:2:7"},"nodeType":"YulFunctionCall","src":"29414:77:7"},"nodeType":"YulIf","src":"29411:103:7"},{"nodeType":"YulAssignment","src":"29523:20:7","value":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"29534:5:7"},{"kind":"number","nodeType":"YulLiteral","src":"29541:1:7","type":"","value":"1"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29530:3:7"},"nodeType":"YulFunctionCall","src":"29530:13:7"},"variableNames":[{"name":"ret","nodeType":"YulIdentifier","src":"29523:3:7"}]}]},"name":"increment_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"value","nodeType":"YulTypedName","src":"29345:5:7","type":""}],"returnVariables":[{"name":"ret","nodeType":"YulTypedName","src":"29355:3:7","type":""}],"src":"29316:233:7"},{"body":{"nodeType":"YulBlock","src":"29661:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"29683:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"29691:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"29679:3:7"},"nodeType":"YulFunctionCall","src":"29679:14:7"},{"hexValue":"496e76616c6964207820636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"29695:22:7","type":"","value":"Invalid x coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"29672:6:7"},"nodeType":"YulFunctionCall","src":"29672:46:7"},"nodeType":"YulExpressionStatement","src":"29672:46:7"}]},"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"29653:6:7","type":""}],"src":"29555:170:7"},{"body":{"nodeType":"YulBlock","src":"29877:220:7","statements":[{"nodeType":"YulAssignment","src":"29887:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"29953:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"29958:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"29894:58:7"},"nodeType":"YulFunctionCall","src":"29894:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"29887:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30059:3:7"}],"functionName":{"name":"store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88","nodeType":"YulIdentifier","src":"29970:88:7"},"nodeType":"YulFunctionCall","src":"29970:93:7"},"nodeType":"YulExpressionStatement","src":"29970:93:7"},{"nodeType":"YulAssignment","src":"30072:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30083:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30088:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30079:3:7"},"nodeType":"YulFunctionCall","src":"30079:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"30072:3:7"}]}]},"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"29865:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"29873:3:7","type":""}],"src":"29731:366:7"},{"body":{"nodeType":"YulBlock","src":"30274:248:7","statements":[{"nodeType":"YulAssignment","src":"30284:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30296:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30307:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30292:3:7"},"nodeType":"YulFunctionCall","src":"30292:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30284:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"30331:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"30342:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30327:3:7"},"nodeType":"YulFunctionCall","src":"30327:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30350:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"30356:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"30346:3:7"},"nodeType":"YulFunctionCall","src":"30346:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30320:6:7"},"nodeType":"YulFunctionCall","src":"30320:47:7"},"nodeType":"YulExpressionStatement","src":"30320:47:7"},{"nodeType":"YulAssignment","src":"30376:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"30510:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30384:124:7"},"nodeType":"YulFunctionCall","src":"30384:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"30376:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"30254:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"30269:4:7","type":""}],"src":"30103:419:7"},{"body":{"nodeType":"YulBlock","src":"30634:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"30656:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"30664:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"30652:3:7"},"nodeType":"YulFunctionCall","src":"30652:14:7"},{"hexValue":"496e76616c6964207920636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"30668:22:7","type":"","value":"Invalid y coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"30645:6:7"},"nodeType":"YulFunctionCall","src":"30645:46:7"},"nodeType":"YulExpressionStatement","src":"30645:46:7"}]},"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"30626:6:7","type":""}],"src":"30528:170:7"},{"body":{"nodeType":"YulBlock","src":"30850:220:7","statements":[{"nodeType":"YulAssignment","src":"30860:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"30926:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"30931:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"30867:58:7"},"nodeType":"YulFunctionCall","src":"30867:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"30860:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31032:3:7"}],"functionName":{"name":"store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3","nodeType":"YulIdentifier","src":"30943:88:7"},"nodeType":"YulFunctionCall","src":"30943:93:7"},"nodeType":"YulExpressionStatement","src":"30943:93:7"},{"nodeType":"YulAssignment","src":"31045:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31056:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31061:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31052:3:7"},"nodeType":"YulFunctionCall","src":"31052:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"31045:3:7"}]}]},"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"30838:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"30846:3:7","type":""}],"src":"30704:366:7"},{"body":{"nodeType":"YulBlock","src":"31247:248:7","statements":[{"nodeType":"YulAssignment","src":"31257:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31269:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31280:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31265:3:7"},"nodeType":"YulFunctionCall","src":"31265:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31257:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"31304:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"31315:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31300:3:7"},"nodeType":"YulFunctionCall","src":"31300:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31323:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"31329:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"31319:3:7"},"nodeType":"YulFunctionCall","src":"31319:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31293:6:7"},"nodeType":"YulFunctionCall","src":"31293:47:7"},"nodeType":"YulExpressionStatement","src":"31293:47:7"},{"nodeType":"YulAssignment","src":"31349:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"31483:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31357:124:7"},"nodeType":"YulFunctionCall","src":"31357:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"31349:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"31227:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"31242:4:7","type":""}],"src":"31076:419:7"},{"body":{"nodeType":"YulBlock","src":"31607:71:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"31629:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"31637:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"31625:3:7"},"nodeType":"YulFunctionCall","src":"31625:14:7"},{"hexValue":"4e6f7420746865206f776e6572206f662074686973206c61796572","kind":"string","nodeType":"YulLiteral","src":"31641:29:7","type":"","value":"Not the owner of this layer"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"31618:6:7"},"nodeType":"YulFunctionCall","src":"31618:53:7"},"nodeType":"YulExpressionStatement","src":"31618:53:7"}]},"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"31599:6:7","type":""}],"src":"31501:177:7"},{"body":{"nodeType":"YulBlock","src":"31830:220:7","statements":[{"nodeType":"YulAssignment","src":"31840:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"31906:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"31911:2:7","type":"","value":"27"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"31847:58:7"},"nodeType":"YulFunctionCall","src":"31847:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"31840:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32012:3:7"}],"functionName":{"name":"store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64","nodeType":"YulIdentifier","src":"31923:88:7"},"nodeType":"YulFunctionCall","src":"31923:93:7"},"nodeType":"YulExpressionStatement","src":"31923:93:7"},{"nodeType":"YulAssignment","src":"32025:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32036:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32041:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32032:3:7"},"nodeType":"YulFunctionCall","src":"32032:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"32025:3:7"}]}]},"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"31818:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"31826:3:7","type":""}],"src":"31684:366:7"},{"body":{"nodeType":"YulBlock","src":"32227:248:7","statements":[{"nodeType":"YulAssignment","src":"32237:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32249:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32260:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32245:3:7"},"nodeType":"YulFunctionCall","src":"32245:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32237:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"32284:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"32295:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32280:3:7"},"nodeType":"YulFunctionCall","src":"32280:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32303:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"32309:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"32299:3:7"},"nodeType":"YulFunctionCall","src":"32299:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32273:6:7"},"nodeType":"YulFunctionCall","src":"32273:47:7"},"nodeType":"YulExpressionStatement","src":"32273:47:7"},{"nodeType":"YulAssignment","src":"32329:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"32463:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32337:124:7"},"nodeType":"YulFunctionCall","src":"32337:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"32329:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"32207:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"32222:4:7","type":""}],"src":"32056:419:7"},{"body":{"nodeType":"YulBlock","src":"32587:118:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"32609:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"32617:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32605:3:7"},"nodeType":"YulFunctionCall","src":"32605:14:7"},{"hexValue":"4f6e6c7920746865206f776e65722063616e2063616c6c20746869732066756e","kind":"string","nodeType":"YulLiteral","src":"32621:34:7","type":"","value":"Only the owner can call this fun"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32598:6:7"},"nodeType":"YulFunctionCall","src":"32598:58:7"},"nodeType":"YulExpressionStatement","src":"32598:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"32677:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"32685:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"32673:3:7"},"nodeType":"YulFunctionCall","src":"32673:15:7"},{"hexValue":"6374696f6e","kind":"string","nodeType":"YulLiteral","src":"32690:7:7","type":"","value":"ction"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"32666:6:7"},"nodeType":"YulFunctionCall","src":"32666:32:7"},"nodeType":"YulExpressionStatement","src":"32666:32:7"}]},"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"32579:6:7","type":""}],"src":"32481:224:7"},{"body":{"nodeType":"YulBlock","src":"32857:220:7","statements":[{"nodeType":"YulAssignment","src":"32867:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"32933:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"32938:2:7","type":"","value":"37"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"32874:58:7"},"nodeType":"YulFunctionCall","src":"32874:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"32867:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33039:3:7"}],"functionName":{"name":"store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face","nodeType":"YulIdentifier","src":"32950:88:7"},"nodeType":"YulFunctionCall","src":"32950:93:7"},"nodeType":"YulExpressionStatement","src":"32950:93:7"},{"nodeType":"YulAssignment","src":"33052:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33063:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"33068:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33059:3:7"},"nodeType":"YulFunctionCall","src":"33059:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"33052:3:7"}]}]},"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"32845:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"32853:3:7","type":""}],"src":"32711:366:7"},{"body":{"nodeType":"YulBlock","src":"33254:248:7","statements":[{"nodeType":"YulAssignment","src":"33264:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33276:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33287:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33272:3:7"},"nodeType":"YulFunctionCall","src":"33272:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33264:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"33311:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"33322:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33307:3:7"},"nodeType":"YulFunctionCall","src":"33307:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33330:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"33336:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"33326:3:7"},"nodeType":"YulFunctionCall","src":"33326:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33300:6:7"},"nodeType":"YulFunctionCall","src":"33300:47:7"},"nodeType":"YulExpressionStatement","src":"33300:47:7"},{"nodeType":"YulAssignment","src":"33356:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"33490:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"33364:124:7"},"nodeType":"YulFunctionCall","src":"33364:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"33356:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"33234:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"33249:4:7","type":""}],"src":"33083:419:7"},{"body":{"nodeType":"YulBlock","src":"33614:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"33636:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"33644:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"33632:3:7"},"nodeType":"YulFunctionCall","src":"33632:14:7"},{"hexValue":"4e6f2066756e647320746f207769746864726177","kind":"string","nodeType":"YulLiteral","src":"33648:22:7","type":"","value":"No funds to withdraw"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"33625:6:7"},"nodeType":"YulFunctionCall","src":"33625:46:7"},"nodeType":"YulExpressionStatement","src":"33625:46:7"}]},"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"33606:6:7","type":""}],"src":"33508:170:7"},{"body":{"nodeType":"YulBlock","src":"33830:220:7","statements":[{"nodeType":"YulAssignment","src":"33840:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"33906:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"33911:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"33847:58:7"},"nodeType":"YulFunctionCall","src":"33847:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"33840:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"34012:3:7"}],"functionName":{"name":"store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9","nodeType":"YulIdentifier","src":"33923:88:7"},"nodeType":"YulFunctionCall","src":"33923:93:7"},"nodeType":"YulExpressionStatement","src":"33923:93:7"},{"nodeType":"YulAssignment","src":"34025:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"34036:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"34041:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34032:3:7"},"nodeType":"YulFunctionCall","src":"34032:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"34025:3:7"}]}]},"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"33818:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"33826:3:7","type":""}],"src":"33684:366:7"},{"body":{"nodeType":"YulBlock","src":"34227:248:7","statements":[{"nodeType":"YulAssignment","src":"34237:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"34249:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"34260:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34245:3:7"},"nodeType":"YulFunctionCall","src":"34245:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"34237:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"34284:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"34295:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"34280:3:7"},"nodeType":"YulFunctionCall","src":"34280:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"34303:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"34309:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"34299:3:7"},"nodeType":"YulFunctionCall","src":"34299:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34273:6:7"},"nodeType":"YulFunctionCall","src":"34273:47:7"},"nodeType":"YulExpressionStatement","src":"34273:47:7"},{"nodeType":"YulAssignment","src":"34329:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"34463:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"34337:124:7"},"nodeType":"YulFunctionCall","src":"34337:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"34329:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"34207:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"34222:4:7","type":""}],"src":"34056:419:7"},{"body":{"nodeType":"YulBlock","src":"34509:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34526:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"34529:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34519:6:7"},"nodeType":"YulFunctionCall","src":"34519:88:7"},"nodeType":"YulExpressionStatement","src":"34519:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34623:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"34626:4:7","type":"","value":"0x22"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"34616:6:7"},"nodeType":"YulFunctionCall","src":"34616:15:7"},"nodeType":"YulExpressionStatement","src":"34616:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"34647:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"34650:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"34640:6:7"},"nodeType":"YulFunctionCall","src":"34640:15:7"},"nodeType":"YulExpressionStatement","src":"34640:15:7"}]},"name":"panic_error_0x22","nodeType":"YulFunctionDefinition","src":"34481:180:7"},{"body":{"nodeType":"YulBlock","src":"34718:269:7","statements":[{"nodeType":"YulAssignment","src":"34728:22:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"34742:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"34748:1:7","type":"","value":"2"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"34738:3:7"},"nodeType":"YulFunctionCall","src":"34738:12:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"34728:6:7"}]},{"nodeType":"YulVariableDeclaration","src":"34759:38:7","value":{"arguments":[{"name":"data","nodeType":"YulIdentifier","src":"34789:4:7"},{"kind":"number","nodeType":"YulLiteral","src":"34795:1:7","type":"","value":"1"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"34785:3:7"},"nodeType":"YulFunctionCall","src":"34785:12:7"},"variables":[{"name":"outOfPlaceEncoding","nodeType":"YulTypedName","src":"34763:18:7","type":""}]},{"body":{"nodeType":"YulBlock","src":"34836:51:7","statements":[{"nodeType":"YulAssignment","src":"34850:27:7","value":{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"34864:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"34872:4:7","type":"","value":"0x7f"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"34860:3:7"},"nodeType":"YulFunctionCall","src":"34860:17:7"},"variableNames":[{"name":"length","nodeType":"YulIdentifier","src":"34850:6:7"}]}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"34816:18:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"34809:6:7"},"nodeType":"YulFunctionCall","src":"34809:26:7"},"nodeType":"YulIf","src":"34806:81:7"},{"body":{"nodeType":"YulBlock","src":"34939:42:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x22","nodeType":"YulIdentifier","src":"34953:16:7"},"nodeType":"YulFunctionCall","src":"34953:18:7"},"nodeType":"YulExpressionStatement","src":"34953:18:7"}]},"condition":{"arguments":[{"name":"outOfPlaceEncoding","nodeType":"YulIdentifier","src":"34903:18:7"},{"arguments":[{"name":"length","nodeType":"YulIdentifier","src":"34926:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"34934:2:7","type":"","value":"32"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"34923:2:7"},"nodeType":"YulFunctionCall","src":"34923:14:7"}],"functionName":{"name":"eq","nodeType":"YulIdentifier","src":"34900:2:7"},"nodeType":"YulFunctionCall","src":"34900:38:7"},"nodeType":"YulIf","src":"34897:84:7"}]},"name":"extract_byte_array_length","nodeType":"YulFunctionDefinition","parameters":[{"name":"data","nodeType":"YulTypedName","src":"34702:4:7","type":""}],"returnVariables":[{"name":"length","nodeType":"YulTypedName","src":"34711:6:7","type":""}],"src":"34667:320:7"},{"body":{"nodeType":"YulBlock","src":"35056:80:7","statements":[{"nodeType":"YulAssignment","src":"35066:22:7","value":{"arguments":[{"name":"offset","nodeType":"YulIdentifier","src":"35081:6:7"}],"functionName":{"name":"mload","nodeType":"YulIdentifier","src":"35075:5:7"},"nodeType":"YulFunctionCall","src":"35075:13:7"},"variableNames":[{"name":"value","nodeType":"YulIdentifier","src":"35066:5:7"}]},{"expression":{"arguments":[{"name":"value","nodeType":"YulIdentifier","src":"35124:5:7"}],"functionName":{"name":"validator_revert_t_uint256","nodeType":"YulIdentifier","src":"35097:26:7"},"nodeType":"YulFunctionCall","src":"35097:33:7"},"nodeType":"YulExpressionStatement","src":"35097:33:7"}]},"name":"abi_decode_t_uint256_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"offset","nodeType":"YulTypedName","src":"35034:6:7","type":""},{"name":"end","nodeType":"YulTypedName","src":"35042:3:7","type":""}],"returnVariables":[{"name":"value","nodeType":"YulTypedName","src":"35050:5:7","type":""}],"src":"34993:143:7"},{"body":{"nodeType":"YulBlock","src":"35219:274:7","statements":[{"body":{"nodeType":"YulBlock","src":"35265:83:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b","nodeType":"YulIdentifier","src":"35267:77:7"},"nodeType":"YulFunctionCall","src":"35267:79:7"},"nodeType":"YulExpressionStatement","src":"35267:79:7"}]},"condition":{"arguments":[{"arguments":[{"name":"dataEnd","nodeType":"YulIdentifier","src":"35240:7:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"35249:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"35236:3:7"},"nodeType":"YulFunctionCall","src":"35236:23:7"},{"kind":"number","nodeType":"YulLiteral","src":"35261:2:7","type":"","value":"32"}],"functionName":{"name":"slt","nodeType":"YulIdentifier","src":"35232:3:7"},"nodeType":"YulFunctionCall","src":"35232:32:7"},"nodeType":"YulIf","src":"35229:119:7"},{"nodeType":"YulBlock","src":"35358:128:7","statements":[{"nodeType":"YulVariableDeclaration","src":"35373:15:7","value":{"kind":"number","nodeType":"YulLiteral","src":"35387:1:7","type":"","value":"0"},"variables":[{"name":"offset","nodeType":"YulTypedName","src":"35377:6:7","type":""}]},{"nodeType":"YulAssignment","src":"35402:74:7","value":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"35448:9:7"},{"name":"offset","nodeType":"YulIdentifier","src":"35459:6:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35444:3:7"},"nodeType":"YulFunctionCall","src":"35444:22:7"},{"name":"dataEnd","nodeType":"YulIdentifier","src":"35468:7:7"}],"functionName":{"name":"abi_decode_t_uint256_fromMemory","nodeType":"YulIdentifier","src":"35412:31:7"},"nodeType":"YulFunctionCall","src":"35412:64:7"},"variableNames":[{"name":"value0","nodeType":"YulIdentifier","src":"35402:6:7"}]}]}]},"name":"abi_decode_tuple_t_uint256_fromMemory","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"35189:9:7","type":""},{"name":"dataEnd","nodeType":"YulTypedName","src":"35200:7:7","type":""}],"returnVariables":[{"name":"value0","nodeType":"YulTypedName","src":"35212:6:7","type":""}],"src":"35142:351:7"},{"body":{"nodeType":"YulBlock","src":"35605:114:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35627:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35635:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35623:3:7"},"nodeType":"YulFunctionCall","src":"35623:14:7"},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e20537461676520","kind":"string","nodeType":"YulLiteral","src":"35639:34:7","type":"","value":"Not enough total value in Stage "}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35616:6:7"},"nodeType":"YulFunctionCall","src":"35616:58:7"},"nodeType":"YulExpressionStatement","src":"35616:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"35695:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"35703:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"35691:3:7"},"nodeType":"YulFunctionCall","src":"35691:15:7"},{"hexValue":"31","kind":"string","nodeType":"YulLiteral","src":"35708:3:7","type":"","value":"1"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"35684:6:7"},"nodeType":"YulFunctionCall","src":"35684:28:7"},"nodeType":"YulExpressionStatement","src":"35684:28:7"}]},"name":"store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"35597:6:7","type":""}],"src":"35499:220:7"},{"body":{"nodeType":"YulBlock","src":"35871:220:7","statements":[{"nodeType":"YulAssignment","src":"35881:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"35947:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"35952:2:7","type":"","value":"33"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"35888:58:7"},"nodeType":"YulFunctionCall","src":"35888:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"35881:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36053:3:7"}],"functionName":{"name":"store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","nodeType":"YulIdentifier","src":"35964:88:7"},"nodeType":"YulFunctionCall","src":"35964:93:7"},"nodeType":"YulExpressionStatement","src":"35964:93:7"},{"nodeType":"YulAssignment","src":"36066:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36077:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"36082:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36073:3:7"},"nodeType":"YulFunctionCall","src":"36073:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"36066:3:7"}]}]},"name":"abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"35859:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"35867:3:7","type":""}],"src":"35725:366:7"},{"body":{"nodeType":"YulBlock","src":"36268:248:7","statements":[{"nodeType":"YulAssignment","src":"36278:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"36290:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"36301:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36286:3:7"},"nodeType":"YulFunctionCall","src":"36286:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"36278:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"36325:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"36336:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36321:3:7"},"nodeType":"YulFunctionCall","src":"36321:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"36344:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"36350:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"36340:3:7"},"nodeType":"YulFunctionCall","src":"36340:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36314:6:7"},"nodeType":"YulFunctionCall","src":"36314:47:7"},"nodeType":"YulExpressionStatement","src":"36314:47:7"},{"nodeType":"YulAssignment","src":"36370:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"36504:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"36378:124:7"},"nodeType":"YulFunctionCall","src":"36378:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"36370:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"36248:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"36263:4:7","type":""}],"src":"36097:419:7"},{"body":{"nodeType":"YulBlock","src":"36628:114:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"36650:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"36658:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36646:3:7"},"nodeType":"YulFunctionCall","src":"36646:14:7"},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e20537461676520","kind":"string","nodeType":"YulLiteral","src":"36662:34:7","type":"","value":"Not enough total value in Stage "}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36639:6:7"},"nodeType":"YulFunctionCall","src":"36639:58:7"},"nodeType":"YulExpressionStatement","src":"36639:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"36718:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"36726:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"36714:3:7"},"nodeType":"YulFunctionCall","src":"36714:15:7"},{"hexValue":"32","kind":"string","nodeType":"YulLiteral","src":"36731:3:7","type":"","value":"2"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"36707:6:7"},"nodeType":"YulFunctionCall","src":"36707:28:7"},"nodeType":"YulExpressionStatement","src":"36707:28:7"}]},"name":"store_literal_in_memory_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"36620:6:7","type":""}],"src":"36522:220:7"},{"body":{"nodeType":"YulBlock","src":"36894:220:7","statements":[{"nodeType":"YulAssignment","src":"36904:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"36970:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"36975:2:7","type":"","value":"33"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"36911:58:7"},"nodeType":"YulFunctionCall","src":"36911:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"36904:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"37076:3:7"}],"functionName":{"name":"store_literal_in_memory_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b","nodeType":"YulIdentifier","src":"36987:88:7"},"nodeType":"YulFunctionCall","src":"36987:93:7"},"nodeType":"YulExpressionStatement","src":"36987:93:7"},{"nodeType":"YulAssignment","src":"37089:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"37100:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"37105:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37096:3:7"},"nodeType":"YulFunctionCall","src":"37096:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"37089:3:7"}]}]},"name":"abi_encode_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"36882:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"36890:3:7","type":""}],"src":"36748:366:7"},{"body":{"nodeType":"YulBlock","src":"37291:248:7","statements":[{"nodeType":"YulAssignment","src":"37301:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37313:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37324:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37309:3:7"},"nodeType":"YulFunctionCall","src":"37309:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37301:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"37348:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"37359:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"37344:3:7"},"nodeType":"YulFunctionCall","src":"37344:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"37367:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"37373:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"37363:3:7"},"nodeType":"YulFunctionCall","src":"37363:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"37337:6:7"},"nodeType":"YulFunctionCall","src":"37337:47:7"},"nodeType":"YulExpressionStatement","src":"37337:47:7"},{"nodeType":"YulAssignment","src":"37393:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"37527:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"37401:124:7"},"nodeType":"YulFunctionCall","src":"37401:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"37393:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"37271:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"37286:4:7","type":""}],"src":"37120:419:7"},{"body":{"nodeType":"YulBlock","src":"37590:146:7","statements":[{"nodeType":"YulAssignment","src":"37600:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37623:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37605:17:7"},"nodeType":"YulFunctionCall","src":"37605:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"37600:1:7"}]},{"nodeType":"YulAssignment","src":"37634:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"37657:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37639:17:7"},"nodeType":"YulFunctionCall","src":"37639:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"37634:1:7"}]},{"body":{"nodeType":"YulBlock","src":"37681:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"37683:16:7"},"nodeType":"YulFunctionCall","src":"37683:18:7"},"nodeType":"YulExpressionStatement","src":"37683:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37675:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"37678:1:7"}],"functionName":{"name":"lt","nodeType":"YulIdentifier","src":"37672:2:7"},"nodeType":"YulFunctionCall","src":"37672:8:7"},"nodeType":"YulIf","src":"37669:34:7"},{"nodeType":"YulAssignment","src":"37713:17:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37725:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"37728:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"37721:3:7"},"nodeType":"YulFunctionCall","src":"37721:9:7"},"variableNames":[{"name":"diff","nodeType":"YulIdentifier","src":"37713:4:7"}]}]},"name":"checked_sub_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"37576:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"37579:1:7","type":""}],"returnVariables":[{"name":"diff","nodeType":"YulTypedName","src":"37585:4:7","type":""}],"src":"37545:191:7"},{"body":{"nodeType":"YulBlock","src":"37790:300:7","statements":[{"nodeType":"YulAssignment","src":"37800:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37823:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37805:17:7"},"nodeType":"YulFunctionCall","src":"37805:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"37800:1:7"}]},{"nodeType":"YulAssignment","src":"37834:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"37857:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"37839:17:7"},"nodeType":"YulFunctionCall","src":"37839:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"37834:1:7"}]},{"body":{"nodeType":"YulBlock","src":"38032:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"38034:16:7"},"nodeType":"YulFunctionCall","src":"38034:18:7"},"nodeType":"YulExpressionStatement","src":"38034:18:7"}]},"condition":{"arguments":[{"arguments":[{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"37944:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"37937:6:7"},"nodeType":"YulFunctionCall","src":"37937:9:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"37930:6:7"},"nodeType":"YulFunctionCall","src":"37930:17:7"},{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"37952:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"37959:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"x","nodeType":"YulIdentifier","src":"38027:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"37955:3:7"},"nodeType":"YulFunctionCall","src":"37955:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"37949:2:7"},"nodeType":"YulFunctionCall","src":"37949:81:7"}],"functionName":{"name":"and","nodeType":"YulIdentifier","src":"37926:3:7"},"nodeType":"YulFunctionCall","src":"37926:105:7"},"nodeType":"YulIf","src":"37923:131:7"},{"nodeType":"YulAssignment","src":"38064:20:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38079:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"38082:1:7"}],"functionName":{"name":"mul","nodeType":"YulIdentifier","src":"38075:3:7"},"nodeType":"YulFunctionCall","src":"38075:9:7"},"variableNames":[{"name":"product","nodeType":"YulIdentifier","src":"38064:7:7"}]}]},"name":"checked_mul_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"37773:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"37776:1:7","type":""}],"returnVariables":[{"name":"product","nodeType":"YulTypedName","src":"37782:7:7","type":""}],"src":"37742:348:7"},{"body":{"nodeType":"YulBlock","src":"38140:261:7","statements":[{"nodeType":"YulAssignment","src":"38150:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38173:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"38155:17:7"},"nodeType":"YulFunctionCall","src":"38155:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"38150:1:7"}]},{"nodeType":"YulAssignment","src":"38184:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"38207:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"38189:17:7"},"nodeType":"YulFunctionCall","src":"38189:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"38184:1:7"}]},{"body":{"nodeType":"YulBlock","src":"38347:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x11","nodeType":"YulIdentifier","src":"38349:16:7"},"nodeType":"YulFunctionCall","src":"38349:18:7"},"nodeType":"YulExpressionStatement","src":"38349:18:7"}]},"condition":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38268:1:7"},{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"38275:66:7","type":"","value":"0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"},{"name":"y","nodeType":"YulIdentifier","src":"38343:1:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"38271:3:7"},"nodeType":"YulFunctionCall","src":"38271:74:7"}],"functionName":{"name":"gt","nodeType":"YulIdentifier","src":"38265:2:7"},"nodeType":"YulFunctionCall","src":"38265:81:7"},"nodeType":"YulIf","src":"38262:107:7"},{"nodeType":"YulAssignment","src":"38379:16:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"38390:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"38393:1:7"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38386:3:7"},"nodeType":"YulFunctionCall","src":"38386:9:7"},"variableNames":[{"name":"sum","nodeType":"YulIdentifier","src":"38379:3:7"}]}]},"name":"checked_add_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"38127:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"38130:1:7","type":""}],"returnVariables":[{"name":"sum","nodeType":"YulTypedName","src":"38136:3:7","type":""}],"src":"38096:305:7"},{"body":{"nodeType":"YulBlock","src":"38513:119:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"38535:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"38543:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38531:3:7"},"nodeType":"YulFunctionCall","src":"38531:14:7"},{"hexValue":"43616e6e6f7420627579206d6f7265207468616e203130206c61796572732061","kind":"string","nodeType":"YulLiteral","src":"38547:34:7","type":"","value":"Cannot buy more than 10 layers a"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38524:6:7"},"nodeType":"YulFunctionCall","src":"38524:58:7"},"nodeType":"YulExpressionStatement","src":"38524:58:7"},{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"38603:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"38611:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38599:3:7"},"nodeType":"YulFunctionCall","src":"38599:15:7"},{"hexValue":"74206f6e6365","kind":"string","nodeType":"YulLiteral","src":"38616:8:7","type":"","value":"t once"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"38592:6:7"},"nodeType":"YulFunctionCall","src":"38592:33:7"},"nodeType":"YulExpressionStatement","src":"38592:33:7"}]},"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"38505:6:7","type":""}],"src":"38407:225:7"},{"body":{"nodeType":"YulBlock","src":"38784:220:7","statements":[{"nodeType":"YulAssignment","src":"38794:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38860:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"38865:2:7","type":"","value":"38"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"38801:58:7"},"nodeType":"YulFunctionCall","src":"38801:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"38794:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38966:3:7"}],"functionName":{"name":"store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229","nodeType":"YulIdentifier","src":"38877:88:7"},"nodeType":"YulFunctionCall","src":"38877:93:7"},"nodeType":"YulExpressionStatement","src":"38877:93:7"},{"nodeType":"YulAssignment","src":"38979:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"38990:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"38995:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"38986:3:7"},"nodeType":"YulFunctionCall","src":"38986:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"38979:3:7"}]}]},"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"38772:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"38780:3:7","type":""}],"src":"38638:366:7"},{"body":{"nodeType":"YulBlock","src":"39181:248:7","statements":[{"nodeType":"YulAssignment","src":"39191:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39203:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39214:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39199:3:7"},"nodeType":"YulFunctionCall","src":"39199:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39191:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"39238:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"39249:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39234:3:7"},"nodeType":"YulFunctionCall","src":"39234:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39257:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"39263:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"39253:3:7"},"nodeType":"YulFunctionCall","src":"39253:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39227:6:7"},"nodeType":"YulFunctionCall","src":"39227:47:7"},"nodeType":"YulExpressionStatement","src":"39227:47:7"},{"nodeType":"YulAssignment","src":"39283:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"39417:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"39291:124:7"},"nodeType":"YulFunctionCall","src":"39291:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"39283:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"39161:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"39176:4:7","type":""}],"src":"39010:419:7"},{"body":{"nodeType":"YulBlock","src":"39463:152:7","statements":[{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"39480:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"39483:77:7","type":"","value":"35408467139433450592217433187231851964531694900788300625387963629091585785856"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39473:6:7"},"nodeType":"YulFunctionCall","src":"39473:88:7"},"nodeType":"YulExpressionStatement","src":"39473:88:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"39577:1:7","type":"","value":"4"},{"kind":"number","nodeType":"YulLiteral","src":"39580:4:7","type":"","value":"0x12"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39570:6:7"},"nodeType":"YulFunctionCall","src":"39570:15:7"},"nodeType":"YulExpressionStatement","src":"39570:15:7"},{"expression":{"arguments":[{"kind":"number","nodeType":"YulLiteral","src":"39601:1:7","type":"","value":"0"},{"kind":"number","nodeType":"YulLiteral","src":"39604:4:7","type":"","value":"0x24"}],"functionName":{"name":"revert","nodeType":"YulIdentifier","src":"39594:6:7"},"nodeType":"YulFunctionCall","src":"39594:15:7"},"nodeType":"YulExpressionStatement","src":"39594:15:7"}]},"name":"panic_error_0x12","nodeType":"YulFunctionDefinition","src":"39435:180:7"},{"body":{"nodeType":"YulBlock","src":"39663:143:7","statements":[{"nodeType":"YulAssignment","src":"39673:25:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"39696:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"39678:17:7"},"nodeType":"YulFunctionCall","src":"39678:20:7"},"variableNames":[{"name":"x","nodeType":"YulIdentifier","src":"39673:1:7"}]},{"nodeType":"YulAssignment","src":"39707:25:7","value":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"39730:1:7"}],"functionName":{"name":"cleanup_t_uint256","nodeType":"YulIdentifier","src":"39712:17:7"},"nodeType":"YulFunctionCall","src":"39712:20:7"},"variableNames":[{"name":"y","nodeType":"YulIdentifier","src":"39707:1:7"}]},{"body":{"nodeType":"YulBlock","src":"39754:22:7","statements":[{"expression":{"arguments":[],"functionName":{"name":"panic_error_0x12","nodeType":"YulIdentifier","src":"39756:16:7"},"nodeType":"YulFunctionCall","src":"39756:18:7"},"nodeType":"YulExpressionStatement","src":"39756:18:7"}]},"condition":{"arguments":[{"name":"y","nodeType":"YulIdentifier","src":"39751:1:7"}],"functionName":{"name":"iszero","nodeType":"YulIdentifier","src":"39744:6:7"},"nodeType":"YulFunctionCall","src":"39744:9:7"},"nodeType":"YulIf","src":"39741:35:7"},{"nodeType":"YulAssignment","src":"39786:14:7","value":{"arguments":[{"name":"x","nodeType":"YulIdentifier","src":"39795:1:7"},{"name":"y","nodeType":"YulIdentifier","src":"39798:1:7"}],"functionName":{"name":"div","nodeType":"YulIdentifier","src":"39791:3:7"},"nodeType":"YulFunctionCall","src":"39791:9:7"},"variableNames":[{"name":"r","nodeType":"YulIdentifier","src":"39786:1:7"}]}]},"name":"checked_div_t_uint256","nodeType":"YulFunctionDefinition","parameters":[{"name":"x","nodeType":"YulTypedName","src":"39652:1:7","type":""},{"name":"y","nodeType":"YulTypedName","src":"39655:1:7","type":""}],"returnVariables":[{"name":"r","nodeType":"YulTypedName","src":"39661:1:7","type":""}],"src":"39621:185:7"},{"body":{"nodeType":"YulBlock","src":"39918:62:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"39940:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"39948:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"39936:3:7"},"nodeType":"YulFunctionCall","src":"39936:14:7"},{"hexValue":"496e636f727265637420504f4c2073656e74","kind":"string","nodeType":"YulLiteral","src":"39952:20:7","type":"","value":"Incorrect POL sent"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"39929:6:7"},"nodeType":"YulFunctionCall","src":"39929:44:7"},"nodeType":"YulExpressionStatement","src":"39929:44:7"}]},"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"39910:6:7","type":""}],"src":"39812:168:7"},{"body":{"nodeType":"YulBlock","src":"40132:220:7","statements":[{"nodeType":"YulAssignment","src":"40142:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40208:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"40213:2:7","type":"","value":"18"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"40149:58:7"},"nodeType":"YulFunctionCall","src":"40149:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"40142:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40314:3:7"}],"functionName":{"name":"store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808","nodeType":"YulIdentifier","src":"40225:88:7"},"nodeType":"YulFunctionCall","src":"40225:93:7"},"nodeType":"YulExpressionStatement","src":"40225:93:7"},{"nodeType":"YulAssignment","src":"40327:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"40338:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"40343:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40334:3:7"},"nodeType":"YulFunctionCall","src":"40334:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"40327:3:7"}]}]},"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"40120:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"40128:3:7","type":""}],"src":"39986:366:7"},{"body":{"nodeType":"YulBlock","src":"40529:248:7","statements":[{"nodeType":"YulAssignment","src":"40539:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40551:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40562:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40547:3:7"},"nodeType":"YulFunctionCall","src":"40547:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"40539:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"40586:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"40597:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"40582:3:7"},"nodeType":"YulFunctionCall","src":"40582:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"40605:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"40611:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"40601:3:7"},"nodeType":"YulFunctionCall","src":"40601:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"40575:6:7"},"nodeType":"YulFunctionCall","src":"40575:47:7"},"nodeType":"YulExpressionStatement","src":"40575:47:7"},{"nodeType":"YulAssignment","src":"40631:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"40765:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"40639:124:7"},"nodeType":"YulFunctionCall","src":"40639:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"40631:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"40509:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"40524:4:7","type":""}],"src":"40358:419:7"},{"body":{"nodeType":"YulBlock","src":"40985:442:7","statements":[{"nodeType":"YulAssignment","src":"40995:27:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41007:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41018:3:7","type":"","value":"128"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41003:3:7"},"nodeType":"YulFunctionCall","src":"41003:19:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"40995:4:7"}]},{"expression":{"arguments":[{"name":"value0","nodeType":"YulIdentifier","src":"41076:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41089:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41100:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41085:3:7"},"nodeType":"YulFunctionCall","src":"41085:17:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"41032:43:7"},"nodeType":"YulFunctionCall","src":"41032:71:7"},"nodeType":"YulExpressionStatement","src":"41032:71:7"},{"expression":{"arguments":[{"name":"value1","nodeType":"YulIdentifier","src":"41157:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41170:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41181:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41166:3:7"},"nodeType":"YulFunctionCall","src":"41166:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"41113:43:7"},"nodeType":"YulFunctionCall","src":"41113:72:7"},"nodeType":"YulExpressionStatement","src":"41113:72:7"},{"expression":{"arguments":[{"name":"value2","nodeType":"YulIdentifier","src":"41239:6:7"},{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41252:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41263:2:7","type":"","value":"64"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41248:3:7"},"nodeType":"YulFunctionCall","src":"41248:18:7"}],"functionName":{"name":"abi_encode_t_uint256_to_t_uint256_fromStack","nodeType":"YulIdentifier","src":"41195:43:7"},"nodeType":"YulFunctionCall","src":"41195:72:7"},"nodeType":"YulExpressionStatement","src":"41195:72:7"},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"41288:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"41299:2:7","type":"","value":"96"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41284:3:7"},"nodeType":"YulFunctionCall","src":"41284:18:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"41308:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"41314:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"41304:3:7"},"nodeType":"YulFunctionCall","src":"41304:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"41277:6:7"},"nodeType":"YulFunctionCall","src":"41277:48:7"},"nodeType":"YulExpressionStatement","src":"41277:48:7"},{"nodeType":"YulAssignment","src":"41334:86:7","value":{"arguments":[{"name":"value3","nodeType":"YulIdentifier","src":"41406:6:7"},{"name":"tail","nodeType":"YulIdentifier","src":"41415:4:7"}],"functionName":{"name":"abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"41342:63:7"},"nodeType":"YulFunctionCall","src":"41342:78:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"41334:4:7"}]}]},"name":"abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"40933:9:7","type":""},{"name":"value3","nodeType":"YulTypedName","src":"40945:6:7","type":""},{"name":"value2","nodeType":"YulTypedName","src":"40953:6:7","type":""},{"name":"value1","nodeType":"YulTypedName","src":"40961:6:7","type":""},{"name":"value0","nodeType":"YulTypedName","src":"40969:6:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"40980:4:7","type":""}],"src":"40783:644:7"},{"body":{"nodeType":"YulBlock","src":"41539:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"41561:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"41569:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41557:3:7"},"nodeType":"YulFunctionCall","src":"41557:14:7"},{"hexValue":"496e76616c696420782d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"41573:22:7","type":"","value":"Invalid x-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"41550:6:7"},"nodeType":"YulFunctionCall","src":"41550:46:7"},"nodeType":"YulExpressionStatement","src":"41550:46:7"}]},"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"41531:6:7","type":""}],"src":"41433:170:7"},{"body":{"nodeType":"YulBlock","src":"41755:220:7","statements":[{"nodeType":"YulAssignment","src":"41765:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41831:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"41836:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"41772:58:7"},"nodeType":"YulFunctionCall","src":"41772:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"41765:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41937:3:7"}],"functionName":{"name":"store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","nodeType":"YulIdentifier","src":"41848:88:7"},"nodeType":"YulFunctionCall","src":"41848:93:7"},"nodeType":"YulExpressionStatement","src":"41848:93:7"},{"nodeType":"YulAssignment","src":"41950:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"41961:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"41966:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"41957:3:7"},"nodeType":"YulFunctionCall","src":"41957:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"41950:3:7"}]}]},"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"41743:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"41751:3:7","type":""}],"src":"41609:366:7"},{"body":{"nodeType":"YulBlock","src":"42152:248:7","statements":[{"nodeType":"YulAssignment","src":"42162:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"42174:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"42185:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42170:3:7"},"nodeType":"YulFunctionCall","src":"42170:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"42162:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"42209:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"42220:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42205:3:7"},"nodeType":"YulFunctionCall","src":"42205:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"42228:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"42234:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"42224:3:7"},"nodeType":"YulFunctionCall","src":"42224:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"42198:6:7"},"nodeType":"YulFunctionCall","src":"42198:47:7"},"nodeType":"YulExpressionStatement","src":"42198:47:7"},{"nodeType":"YulAssignment","src":"42254:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"42388:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"42262:124:7"},"nodeType":"YulFunctionCall","src":"42262:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"42254:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"42132:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"42147:4:7","type":""}],"src":"41981:419:7"},{"body":{"nodeType":"YulBlock","src":"42512:64:7","statements":[{"expression":{"arguments":[{"arguments":[{"name":"memPtr","nodeType":"YulIdentifier","src":"42534:6:7"},{"kind":"number","nodeType":"YulLiteral","src":"42542:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42530:3:7"},"nodeType":"YulFunctionCall","src":"42530:14:7"},{"hexValue":"496e76616c696420792d636f6f7264696e617465","kind":"string","nodeType":"YulLiteral","src":"42546:22:7","type":"","value":"Invalid y-coordinate"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"42523:6:7"},"nodeType":"YulFunctionCall","src":"42523:46:7"},"nodeType":"YulExpressionStatement","src":"42523:46:7"}]},"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulFunctionDefinition","parameters":[{"name":"memPtr","nodeType":"YulTypedName","src":"42504:6:7","type":""}],"src":"42406:170:7"},{"body":{"nodeType":"YulBlock","src":"42728:220:7","statements":[{"nodeType":"YulAssignment","src":"42738:74:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"42804:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"42809:2:7","type":"","value":"20"}],"functionName":{"name":"array_storeLengthForEncoding_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"42745:58:7"},"nodeType":"YulFunctionCall","src":"42745:67:7"},"variableNames":[{"name":"pos","nodeType":"YulIdentifier","src":"42738:3:7"}]},{"expression":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"42910:3:7"}],"functionName":{"name":"store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","nodeType":"YulIdentifier","src":"42821:88:7"},"nodeType":"YulFunctionCall","src":"42821:93:7"},"nodeType":"YulExpressionStatement","src":"42821:93:7"},{"nodeType":"YulAssignment","src":"42923:19:7","value":{"arguments":[{"name":"pos","nodeType":"YulIdentifier","src":"42934:3:7"},{"kind":"number","nodeType":"YulLiteral","src":"42939:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"42930:3:7"},"nodeType":"YulFunctionCall","src":"42930:12:7"},"variableNames":[{"name":"end","nodeType":"YulIdentifier","src":"42923:3:7"}]}]},"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulFunctionDefinition","parameters":[{"name":"pos","nodeType":"YulTypedName","src":"42716:3:7","type":""}],"returnVariables":[{"name":"end","nodeType":"YulTypedName","src":"42724:3:7","type":""}],"src":"42582:366:7"},{"body":{"nodeType":"YulBlock","src":"43125:248:7","statements":[{"nodeType":"YulAssignment","src":"43135:26:7","value":{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"43147:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"43158:2:7","type":"","value":"32"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"43143:3:7"},"nodeType":"YulFunctionCall","src":"43143:18:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"43135:4:7"}]},{"expression":{"arguments":[{"arguments":[{"name":"headStart","nodeType":"YulIdentifier","src":"43182:9:7"},{"kind":"number","nodeType":"YulLiteral","src":"43193:1:7","type":"","value":"0"}],"functionName":{"name":"add","nodeType":"YulIdentifier","src":"43178:3:7"},"nodeType":"YulFunctionCall","src":"43178:17:7"},{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"43201:4:7"},{"name":"headStart","nodeType":"YulIdentifier","src":"43207:9:7"}],"functionName":{"name":"sub","nodeType":"YulIdentifier","src":"43197:3:7"},"nodeType":"YulFunctionCall","src":"43197:20:7"}],"functionName":{"name":"mstore","nodeType":"YulIdentifier","src":"43171:6:7"},"nodeType":"YulFunctionCall","src":"43171:47:7"},"nodeType":"YulExpressionStatement","src":"43171:47:7"},{"nodeType":"YulAssignment","src":"43227:139:7","value":{"arguments":[{"name":"tail","nodeType":"YulIdentifier","src":"43361:4:7"}],"functionName":{"name":"abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack","nodeType":"YulIdentifier","src":"43235:124:7"},"nodeType":"YulFunctionCall","src":"43235:131:7"},"variableNames":[{"name":"tail","nodeType":"YulIdentifier","src":"43227:4:7"}]}]},"name":"abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed","nodeType":"YulFunctionDefinition","parameters":[{"name":"headStart","nodeType":"YulTypedName","src":"43105:9:7","type":""}],"returnVariables":[{"name":"tail","nodeType":"YulTypedName","src":"43120:4:7","type":""}],"src":"42954:419:7"}]},"contents":"{\\n\\n    function array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_address_payable_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function cleanup_t_uint160(value) -> cleaned {\\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\\n    }\\n\\n    function cleanup_t_address_payable(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(value0, pos) -> updatedPos {\\n        abi_encode_t_address_payable_to_t_address_payable(value0, pos)\\n        updatedPos := add(pos, 0x20)\\n    }\\n\\n    function array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[] -> address payable[]\\n    function abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_address_payable_$dyn_memory_ptr(pos, length)\\n        let baseRef := array_dataslot_t_array$_t_address_payable_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            let elementValue0 := mload(srcPtr)\\n            pos := abi_encodeUpdatedPos_t_address_payable_to_t_address_payable(elementValue0, pos)\\n            srcPtr := array_nextElement_t_array$_t_address_payable_$dyn_memory_ptr(srcPtr)\\n        }\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // address payable[][] -> address payable[][]\\n    function abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_address_payable_$dyn_memory_ptr_to_t_array$_t_address_payable_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_string_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function copy_memory_to_memory(src, dst, length) {\\n        let i := 0\\n        for { } lt(i, length) { i := add(i, 32) }\\n        {\\n            mstore(add(dst, i), mload(add(src, i)))\\n        }\\n        if gt(i, length)\\n        {\\n            // clear end\\n            mstore(add(dst, length), 0)\\n        }\\n    }\\n\\n    function round_up_to_mul_of_32(value) -> result {\\n        result := and(add(value, 31), not(31))\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[] -> string[]\\n    function abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_string_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_string_memory_ptr_to_t_string_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_string_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // string[][] -> string[][]\\n    function abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_string_memory_ptr_$dyn_memory_ptr_to_t_array$_t_string_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_address_payable_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function allocate_unbounded() -> memPtr {\\n        memPtr := mload(64)\\n    }\\n\\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\\n        revert(0, 0)\\n    }\\n\\n    function cleanup_t_uint256(value) -> cleaned {\\n        cleaned := value\\n    }\\n\\n    function validator_revert_t_uint256(value) {\\n        if iszero(eq(value, cleanup_t_uint256(value))) { revert(0, 0) }\\n    }\\n\\n    function abi_decode_t_uint256(offset, end) -> value {\\n        value := calldataload(offset)\\n        validator_revert_t_uint256(value)\\n    }\\n\\n    function revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() {\\n        revert(0, 0)\\n    }\\n\\n    function revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() {\\n        revert(0, 0)\\n    }\\n\\n    function panic_error_0x41() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x41)\\n        revert(0, 0x24)\\n    }\\n\\n    function finalize_allocation(memPtr, size) {\\n        let newFreePtr := add(memPtr, round_up_to_mul_of_32(size))\\n        // protect against overflow\\n        if or(gt(newFreePtr, 0xffffffffffffffff), lt(newFreePtr, memPtr)) { panic_error_0x41() }\\n        mstore(64, newFreePtr)\\n    }\\n\\n    function allocate_memory(size) -> memPtr {\\n        memPtr := allocate_unbounded()\\n        finalize_allocation(memPtr, size)\\n    }\\n\\n    function array_allocation_size_t_string_memory_ptr(length) -> size {\\n        // Make sure we can allocate memory without overflow\\n        if gt(length, 0xffffffffffffffff) { panic_error_0x41() }\\n\\n        size := round_up_to_mul_of_32(length)\\n\\n        // add length slot\\n        size := add(size, 0x20)\\n\\n    }\\n\\n    function copy_calldata_to_memory(src, dst, length) {\\n        calldatacopy(dst, src, length)\\n        // clear end\\n        mstore(add(dst, length), 0)\\n    }\\n\\n    function abi_decode_available_length_t_string_memory_ptr(src, length, end) -> array {\\n        array := allocate_memory(array_allocation_size_t_string_memory_ptr(length))\\n        mstore(array, length)\\n        let dst := add(array, 0x20)\\n        if gt(add(src, length), end) { revert_error_987264b3b1d58a9c7f8255e93e81c77d86d6299019c33110a076957a3e06e2ae() }\\n        copy_calldata_to_memory(src, dst, length)\\n    }\\n\\n    // string\\n    function abi_decode_t_string_memory_ptr(offset, end) -> array {\\n        if iszero(slt(add(offset, 0x1f), end)) { revert_error_1b9f4a0a5773e33b91aa01db23bf8c55fce1411167c872835e7fa00a4f17d46d() }\\n        let length := calldataload(offset)\\n        array := abi_decode_available_length_t_string_memory_ptr(add(offset, 0x20), length, end)\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2 {\\n        if slt(sub(dataEnd, headStart), 96) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 64))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value2 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1 {\\n        if slt(sub(dataEnd, headStart), 64) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function abi_decode_tuple_t_uint256t_uint256t_uint256t_string_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3 {\\n        if slt(sub(dataEnd, headStart), 128) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 32\\n\\n            value1 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := 64\\n\\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\\n        }\\n\\n        {\\n\\n            let offset := calldataload(add(headStart, 96))\\n            if gt(offset, 0xffffffffffffffff) { revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() }\\n\\n            value3 := abi_decode_t_string_memory_ptr(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function identity(value) -> ret {\\n        ret := value\\n    }\\n\\n    function convert_t_uint160_to_t_uint160(value) -> converted {\\n        converted := cleanup_t_uint160(identity(cleanup_t_uint160(value)))\\n    }\\n\\n    function convert_t_uint160_to_t_address(value) -> converted {\\n        converted := convert_t_uint160_to_t_uint160(value)\\n    }\\n\\n    function convert_t_contract$_BaseContract_$1001_to_t_address(value) -> converted {\\n        converted := convert_t_uint160_to_t_address(value)\\n    }\\n\\n    function abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack(value, pos) {\\n        mstore(pos, convert_t_contract$_BaseContract_$1001_to_t_address(value))\\n    }\\n\\n    function abi_encode_tuple_t_contract$_BaseContract_$1001__to_t_address__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_contract$_BaseContract_$1001_to_t_address_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    function abi_encode_t_uint256_to_t_uint256(value, pos) {\\n        mstore(pos, cleanup_t_uint256(value))\\n    }\\n\\n    function array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value) -> length {\\n\\n        length := mload(value)\\n\\n    }\\n\\n    function array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> data {\\n        data := ptr\\n\\n        data := add(ptr, 0x20)\\n\\n    }\\n\\n    // struct BaseContract.Layer -> struct BaseContract.Layer\\n    function abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // owner\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_address_payable_to_t_address_payable(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // color\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Layer[] -> struct BaseContract.Layer[]\\n    function abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Layer_$8_memory_ptr_to_t_struct$_Layer_$8_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    // struct BaseContract.Cell -> struct BaseContract.Cell\\n    function abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value, pos)  -> end  {\\n        let tail := add(pos, 0x40)\\n\\n        {\\n            // baseValue\\n\\n            let memberValue0 := mload(add(value, 0x00))\\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x00))\\n        }\\n\\n        {\\n            // layers\\n\\n            let memberValue0 := mload(add(value, 0x20))\\n\\n            mstore(add(pos, 0x20), sub(tail, pos))\\n            tail := abi_encode_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Layer_$8_memory_ptr_$dyn_memory_ptr(memberValue0, tail)\\n\\n        }\\n\\n        end := tail\\n    }\\n\\n    function abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[] -> struct BaseContract.Cell[]\\n    function abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_struct$_Cell_$15_memory_ptr_to_t_struct$_Cell_$15_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos) -> updatedPos {\\n        updatedPos := abi_encode_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(value0, pos)\\n    }\\n\\n    function array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(ptr) -> next {\\n        next := add(ptr, 0x20)\\n    }\\n\\n    // struct BaseContract.Cell[][] -> struct BaseContract.Cell[][]\\n    function abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\\n        let length := array_length_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\\n        let headStart := pos\\n        let tail := add(pos, mul(length, 0x20))\\n        let baseRef := array_dataslot_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(value)\\n        let srcPtr := baseRef\\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\\n        {\\n            mstore(pos, sub(tail, headStart))\\n            let elementValue0 := mload(srcPtr)\\n            tail := abi_encodeUpdatedPos_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr(elementValue0, tail)\\n            srcPtr := array_nextElement_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr(srcPtr)\\n            pos := add(pos, 0x20)\\n        }\\n        pos := tail\\n        end := pos\\n    }\\n\\n    function abi_encode_tuple_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_to_t_array$_t_array$_t_struct$_Cell_$15_memory_ptr_$dyn_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function cleanup_t_bool(value) -> cleaned {\\n        cleaned := iszero(iszero(value))\\n    }\\n\\n    function abi_encode_t_bool_to_t_bool_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_bool(value))\\n    }\\n\\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_bool_to_t_bool_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_encode_t_address_payable_to_t_address_payable_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address_payable(value))\\n    }\\n\\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\\n        mstore(pos, length)\\n        updated_pos := add(pos, 0x20)\\n    }\\n\\n    function abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value, pos) -> end {\\n        let length := array_length_t_string_memory_ptr(value)\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length)\\n        copy_memory_to_memory(add(value, 0x20), pos, length)\\n        end := add(pos, round_up_to_mul_of_32(length))\\n    }\\n\\n    function abi_encode_tuple_t_address_payable_t_string_memory_ptr__to_t_address_payable_t_string_memory_ptr__fromStack_reversed(headStart , value1, value0) -> tail {\\n        tail := add(headStart, 64)\\n\\n        abi_encode_t_address_payable_to_t_address_payable_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n    }\\n\\n    function cleanup_t_address(value) -> cleaned {\\n        cleaned := cleanup_t_uint160(value)\\n    }\\n\\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\\n        mstore(pos, cleanup_t_address(value))\\n    }\\n\\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_string_memory_ptr_t_uint256__to_t_uint256_t_string_memory_ptr_t_uint256__fromStack_reversed(headStart , value2, value1, value0) -> tail {\\n        tail := add(headStart, 96)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        mstore(add(headStart, 32), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value1,  tail)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n    }\\n\\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value0,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Contract is not enabled\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 23)\\n        store_literal_in_memory_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_52aef6ed738d9d9e3d81a2eeaaacdf0b9c8dbde4610058bea0db7c82c195210f_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x32() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x32)\\n        revert(0, 0x24)\\n    }\\n\\n    function panic_error_0x11() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x11)\\n        revert(0, 0x24)\\n    }\\n\\n    function increment_t_uint256(value) -> ret {\\n        value := cleanup_t_uint256(value)\\n        if eq(value, 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff) { panic_error_0x11() }\\n        ret := add(value, 1)\\n    }\\n\\n    function store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1e2a0d6412e324cf4990f76832f3b3e4995aa940d15ac36793f9277ebdd53b88_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_72230a027063e40f6922a9111157bc510a8ef9bca2209083f31094cd2b297db3_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not the owner of this layer\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 27)\\n        store_literal_in_memory_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_adebf4c4fa7ba08f0cc26e273b7b1e578421c93a0076dcca15576386975c5b64_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Only the owner can call this fun\\")\\n\\n        mstore(add(memPtr, 32), \\"ction\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 37)\\n        store_literal_in_memory_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_02c4ea565ba5dd10ca7507fa4aece08fe60d2b6b945dff193cdbce1647b7face_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"No funds to withdraw\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_4b4cc99522fdcee4d97d6d2d3cbabeb353d40433850bd46ba29c08dbfba843f9_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x22() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x22)\\n        revert(0, 0x24)\\n    }\\n\\n    function extract_byte_array_length(data) -> length {\\n        length := div(data, 2)\\n        let outOfPlaceEncoding := and(data, 1)\\n        if iszero(outOfPlaceEncoding) {\\n            length := and(length, 0x7f)\\n        }\\n\\n        if eq(outOfPlaceEncoding, lt(length, 32)) {\\n            panic_error_0x22()\\n        }\\n    }\\n\\n    function abi_decode_t_uint256_fromMemory(offset, end) -> value {\\n        value := mload(offset)\\n        validator_revert_t_uint256(value)\\n    }\\n\\n    function abi_decode_tuple_t_uint256_fromMemory(headStart, dataEnd) -> value0 {\\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\\n\\n        {\\n\\n            let offset := 0\\n\\n            value0 := abi_decode_t_uint256_fromMemory(add(headStart, offset), dataEnd)\\n        }\\n\\n    }\\n\\n    function store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not enough total value in Stage \\")\\n\\n        mstore(add(memPtr, 32), \\"1\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 33)\\n        store_literal_in_memory_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Not enough total value in Stage \\")\\n\\n        mstore(add(memPtr, 32), \\"2\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 33)\\n        store_literal_in_memory_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function checked_sub_t_uint256(x, y) -> diff {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        if lt(x, y) { panic_error_0x11() }\\n\\n        diff := sub(x, y)\\n    }\\n\\n    function checked_mul_t_uint256(x, y) -> product {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x != 0 and y > (maxValue / x)\\n        if and(iszero(iszero(x)), gt(y, div(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, x))) { panic_error_0x11() }\\n\\n        product := mul(x, y)\\n    }\\n\\n    function checked_add_t_uint256(x, y) -> sum {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n\\n        // overflow, if x > (maxValue - y)\\n        if gt(x, sub(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, y)) { panic_error_0x11() }\\n\\n        sum := add(x, y)\\n    }\\n\\n    function store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Cannot buy more than 10 layers a\\")\\n\\n        mstore(add(memPtr, 32), \\"t once\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 38)\\n        store_literal_in_memory_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229(pos)\\n        end := add(pos, 64)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_a952c4ae6ef262d0763da0fab69ca221dafcd754e0b8dc6c5b14f22c2c004229_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function panic_error_0x12() {\\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\\n        mstore(4, 0x12)\\n        revert(0, 0x24)\\n    }\\n\\n    function checked_div_t_uint256(x, y) -> r {\\n        x := cleanup_t_uint256(x)\\n        y := cleanup_t_uint256(y)\\n        if iszero(y) { panic_error_0x12() }\\n\\n        r := div(x, y)\\n    }\\n\\n    function store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Incorrect POL sent\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 18)\\n        store_literal_in_memory_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_1bb2a632fbf9214b76f9c6da3c81d7952b47a8b056ef75dd8e2995f96db59808_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function abi_encode_tuple_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__to_t_uint256_t_uint256_t_uint256_t_string_memory_ptr__fromStack_reversed(headStart , value3, value2, value1, value0) -> tail {\\n        tail := add(headStart, 128)\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value1,  add(headStart, 32))\\n\\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\\n\\n        mstore(add(headStart, 96), sub(tail, headStart))\\n        tail := abi_encode_t_string_memory_ptr_to_t_string_memory_ptr_fromStack(value3,  tail)\\n\\n    }\\n\\n    function store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid x-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n    function store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(memPtr) {\\n\\n        mstore(add(memPtr, 0), \\"Invalid y-coordinate\\")\\n\\n    }\\n\\n    function abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack(pos) -> end {\\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 20)\\n        store_literal_in_memory_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72(pos)\\n        end := add(pos, 32)\\n    }\\n\\n    function abi_encode_tuple_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\\n        tail := add(headStart, 32)\\n\\n        mstore(add(headStart, 0), sub(tail, headStart))\\n        tail := abi_encode_t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72_to_t_string_memory_ptr_fromStack( tail)\\n\\n    }\\n\\n}\\n","id":7,"language":"Yul","name":"#utility.yul"}],"sourceMap":"125:1422:6:-:0;;;3684:3074:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;205:5:6;181:29;;;;;;;;;;;;;;;;;;;;428:203;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;519:10:0;511:5;;:18;;;;;;;;;;;;;;;;;;262:176:3;;;;;;;;282:3;262:176;;;;;;286:3;262:176;;;;;;290:3;262:176;;;;;;294:3;262:176;;;;;;298:3;262:176;;;;;;302:3;262:176;;;;;;306:3;262:176;;;;;;310:3;262:176;;;;;;314:3;262:176;;;;;;318:4;262:176;;;;;;323:4;262:176;;;;;;328:4;262:176;;;;;;333:4;262:176;;;;;;338:4;262:176;;;;;;343:4;262:176;;;;;;348:4;262:176;;;;;;353:4;262:176;;;;;;358:4;262:176;;;;;;363:4;262:176;;;;;;368:4;262:176;;;;;;373:4;262:176;;;;;;378:4;262:176;;;;;;383:4;262:176;;;;;;388:4;262:176;;;;;;393:4;262:176;;;;;;398:4;262:176;;;;;;403:4;262:176;;;;;;408:4;262:176;;;;;;413:4;262:176;;;;;;418:4;262:176;;;;;;423:4;262:176;;;;;;428:4;262:176;;;;;;433:4;262:176;;;;;:13;276:1;262:16;;;;;;;:::i;:::-;;;;;:176;;;;;;;:::i;:::-;;446:180;;;;;;;;466:3;446:180;;;;;;470:3;446:180;;;;;;474:3;446:180;;;;;;478:3;446:180;;;;;;482:3;446:180;;;;;;486:3;446:180;;;;;;490:3;446:180;;;;;;494:3;446:180;;;;;;498:3;446:180;;;;;;502:4;446:180;;;;;;507:4;446:180;;;;;;512:4;446:180;;;;;;517:4;446:180;;;;;;522:4;446:180;;;;;;527:4;446:180;;;;;;532:4;446:180;;;;;;537:4;446:180;;;;;;542:4;446:180;;;;;;547:4;446:180;;;;;;552:4;446:180;;;;;;557:4;446:180;;;;;;562:4;446:180;;;;;;567:4;446:180;;;;;;572:4;446:180;;;;;;577:4;446:180;;;;;;582:4;446:180;;;;;;587:4;446:180;;;;;;592:4;446:180;;;;;;597:4;446:180;;;;;;602:6;446:180;;;;;;609:6;446:180;;;;;;616:4;446:180;;;;;;621:4;446:180;;;;;:13;460:1;446:16;;;;;;;:::i;:::-;;;;;:180;;;;;;;:::i;:::-;;634:188;;;;;;;;654:3;634:188;;;;;;658:3;634:188;;;;;;662:3;634:188;;;;;;666:3;634:188;;;;;;670:3;634:188;;;;;;674:3;634:188;;;;;;678:3;634:188;;;;;;682:3;634:188;;;;;;686:4;634:188;;;;;;691:4;634:188;;;;;;696:4;634:188;;;;;;701:4;634:188;;;;;;706:4;634:188;;;;;;711:4;634:188;;;;;;716:4;634:188;;;;;;721:5;634:188;;;;;;727:5;634:188;;;;;;733:5;634:188;;;;;;739:5;634:188;;;;;;745:5;634:188;;;;;;751:4;634:188;;;;;;756:4;634:188;;;;;;761:4;634:188;;;;;;766:4;634:188;;;;;;771:4;634:188;;;;;;776:4;634:188;;;;;;781:4;634:188;;;;;;786:4;634:188;;;;;;791:6;634:188;;;;;;798:6;634:188;;;;;;805:6;634:188;;;;;;812:4;634:188;;;;;;817:4;634:188;;;;;:13;648:1;634:16;;;;;;;:::i;:::-;;;;;:188;;;;;;;:::i;:::-;;830:196;;;;;;;;850:3;830:196;;;;;;854:3;830:196;;;;;;858:3;830:196;;;;;;862:3;830:196;;;;;;866:3;830:196;;;;;;870:5;830:196;;;;;;876:5;830:196;;;;;;882:5;830:196;;;;;;888:5;830:196;;;;;;894:4;830:196;;;;;;899:4;830:196;;;;;;904:4;830:196;;;;;;909:4;830:196;;;;;;914:4;830:196;;;;;;919:5;830:196;;;;;;925:4;830:196;;;;;;930:5;830:196;;;;;;936:4;830:196;;;;;;941:4;830:196;;;;;;946:4;830:196;;;;;;951:5;830:196;;;;;;957:4;830:196;;;;;;962:4;830:196;;;;;;967:4;830:196;;;;;;972:5;830:196;;;;;;978:6;830:196;;;;;;985:6;830:196;;;;;;992:4;830:196;;;;;;997:6;830:196;;;;;;1004:4;830:196;;;;;;1009:6;830:196;;;;;;1016:4;830:196;;;;;;1021:4;830:196;;;;;:13;844:1;830:16;;;;;;;:::i;:::-;;;;;:196;;;;;;;:::i;:::-;;1034:202;;;;;;;;1054:3;1034:202;;;;;;1058:3;1034:202;;;;;;1062:3;1034:202;;;;;;1066:3;1034:202;;;;;;1070:4;1034:202;;;;;;1075:5;1034:202;;;;;;1081:5;1034:202;;;;;;1087:5;1034:202;;;;;;1093:5;1034:202;;;;;;1099:5;1034:202;;;;;;1105:4;1034:202;;;;;;1110:4;1034:202;;;;;;1115:4;1034:202;;;;;;1120:5;1034:202;;;;;;1126:4;1034:202;;;;;;1131:5;1034:202;;;;;;1137:4;1034:202;;;;;;1142:5;1034:202;;;;;;1148:5;1034:202;;;;;;1154:4;1034:202;;;;;;1159:4;1034:202;;;;;;1164:5;1034:202;;;;;;1170:5;1034:202;;;;;;1176:5;1034:202;;;;;;1182:5;1034:202;;;;;;1188:6;1034:202;;;;;;1195:6;1034:202;;;;;;1202:4;1034:202;;;;;;1207:6;1034:202;;;;;;1214:4;1034:202;;;;;;1219:6;1034:202;;;;;;1226:4;1034:202;;;;;;1231:4;1034:202;;;;;:13;1048:1;1034:16;;;;;;;:::i;:::-;;;;;:202;;;;;;;:::i;:::-;;1244:195;;;;;;;;1264:3;1244:195;;;;;;1268:3;1244:195;;;;;;1272:4;1244:195;;;;;;1277:4;1244:195;;;;;;1282:4;1244:195;;;;;;1287:3;1244:195;;;;;;1291:3;1244:195;;;;;;1295:3;1244:195;;;;;;1299:4;1244:195;;;;;;1304:4;1244:195;;;;;;1309:5;1244:195;;;;;;1315:4;1244:195;;;;;;1320:5;1244:195;;;;;;1326:4;1244:195;;;;;;1331:5;1244:195;;;;;;1337:4;1244:195;;;;;;1342:5;1244:195;;;;;;1348:4;1244:195;;;;;;1353:4;1244:195;;;;;;1358:5;1244:195;;;;;;1364:4;1244:195;;;;;;1369:5;1244:195;;;;;;1375:5;1244:195;;;;;;1381:4;1244:195;;;;;;1386:6;1244:195;;;;;;1393:4;1244:195;;;;;;1398:6;1244:195;;;;;;1405:4;1244:195;;;;;;1410:6;1244:195;;;;;;1417:4;1244:195;;;;;;1422:6;1244:195;;;;;;1429:4;1244:195;;;;;;1434:4;1244:195;;;;;:13;1258:1;1244:16;;;;;;;:::i;:::-;;;;;:195;;;;;;;:::i;:::-;;1447:199;;;;;;;;1467:3;1447:199;;;;;;1471:3;1447:199;;;;;;1475:4;1447:199;;;;;;1480:3;1447:199;;;;;;1484:5;1447:199;;;;;;1490:3;1447:199;;;;;;1494:5;1447:199;;;;;;1500:5;1447:199;;;;;;1506:5;1447:199;;;;;;1512:5;1447:199;;;;;;1518:4;1447:199;;;;;;1523:4;1447:199;;;;;;1528:5;1447:199;;;;;;1534:4;1447:199;;;;;;1539:5;1447:199;;;;;;1545:4;1447:199;;;;;;1550:5;1447:199;;;;;;1556:4;1447:199;;;;;;1561:4;1447:199;;;;;;1566:5;1447:199;;;;;;1572:4;1447:199;;;;;;1577:5;1447:199;;;;;;1583:4;1447:199;;;;;;1588:6;1447:199;;;;;;1595:4;1447:199;;;;;;1600:4;1447:199;;;;;;1605:6;1447:199;;;;;;1612:4;1447:199;;;;;;1617:6;1447:199;;;;;;1624:4;1447:199;;;;;;1629:6;1447:199;;;;;;1636:4;1447:199;;;;;;1641:4;1447:199;;;;;:13;1461:1;1447:16;;;;;;;:::i;:::-;;;;;:199;;;;;;;:::i;:::-;;1654:200;;;;;;;;1674:3;1654:200;;;;;;1678:3;1654:200;;;;;;1682:4;1654:200;;;;;;1687:3;1654:200;;;;;;1691:5;1654:200;;;;;;1697:3;1654:200;;;;;;1701:5;1654:200;;;;;;1707:4;1654:200;;;;;;1712:4;1654:200;;;;;;1717:5;1654:200;;;;;;1723:5;1654:200;;;;;;1729:4;1654:200;;;;;;1734:5;1654:200;;;;;;1740:4;1654:200;;;;;;1745:5;1654:200;;;;;;1751:4;1654:200;;;;;;1756:5;1654:200;;;;;;1762:4;1654:200;;;;;;1767:4;1654:200;;;;;;1772:5;1654:200;;;;;;1778:4;1654:200;;;;;;1783:5;1654:200;;;;;;1789:4;1654:200;;;;;;1794:6;1654:200;;;;;;1801:4;1654:200;;;;;;1806:6;1654:200;;;;;;1813:4;1654:200;;;;;;1818:6;1654:200;;;;;;1825:6;1654:200;;;;;;1832:4;1654:200;;;;;;1837:6;1654:200;;;;;;1844:4;1654:200;;;;;;1849:4;1654:200;;;;;:13;1668:1;1654:16;;;;;;;:::i;:::-;;;;;:200;;;;;;;:::i;:::-;;1862;;;;;;;;1882:3;1862:200;;;;;;1886:3;1862:200;;;;;;1890:4;1862:200;;;;;;1895:3;1862:200;;;;;;1899:5;1862:200;;;;;;1905:3;1862:200;;;;;;1909:5;1862:200;;;;;;1915:5;1862:200;;;;;;1921:5;1862:200;;;;;;1927:4;1862:200;;;;;;1932:5;1862:200;;;;;;1938:5;1862:200;;;;;;1944:5;1862:200;;;;;;1950:4;1862:200;;;;;;1955:5;1862:200;;;;;;1961:4;1862:200;;;;;;1966:5;1862:200;;;;;;1972:4;1862:200;;;;;;1977:4;1862:200;;;;;;1982:5;1862:200;;;;;;1988:4;1862:200;;;;;;1993:5;1862:200;;;;;;1999:4;1862:200;;;;;;2004:6;1862:200;;;;;;2011:4;1862:200;;;;;;2016:6;1862:200;;;;;;2023:6;1862:200;;;;;;2030:4;1862:200;;;;;;2035:4;1862:200;;;;;;2040:4;1862:200;;;;;;2045:6;1862:200;;;;;;2052:4;1862:200;;;;;;2057:4;1862:200;;;;;:13;1876:1;1862:16;;;;;;;:::i;:::-;;;;;:200;;;;;;;:::i;:::-;;2070:199;;;;;;;;2090:3;2070:199;;;;;;2094:3;2070:199;;;;;;2098:4;2070:199;;;;;;2103:3;2070:199;;;;;;2107:5;2070:199;;;;;;2113:3;2070:199;;;;;;2117:5;2070:199;;;;;;2123:4;2070:199;;;;;;2128:5;2070:199;;;;;;2134:5;2070:199;;;;;;2140:4;2070:199;;;;;;2145:5;2070:199;;;;;;2151:5;2070:199;;;;;;2157:4;2070:199;;;;;;2162:5;2070:199;;;;;;2168:4;2070:199;;;;;;2173:4;2070:199;;;;;;2178:5;2070:199;;;;;;2184:5;2070:199;;;;;;2190:4;2070:199;;;;;;2195:4;2070:199;;;;;;2200:5;2070:199;;;;;;2206:4;2070:199;;;;;;2211:6;2070:199;;;;;;2218:4;2070:199;;;;;;2223:6;2070:199;;;;;;2230:4;2070:199;;;;;;2235:6;2070:199;;;;;;2242:4;2070:199;;;;;;2247:4;2070:199;;;;;;2252:6;2070:199;;;;;;2259:4;2070:199;;;;;;2264:4;2070:199;;;;;:13;2084:1;2070:16;;;;;;;:::i;:::-;;;;;:199;;;;;;;:::i;:::-;;2277:200;;;;;;;;2298:3;2277:200;;;;;;2302:3;2277:200;;;;;;2306:4;2277:200;;;;;;2311:3;2277:200;;;;;;2315:5;2277:200;;;;;;2321:3;2277:200;;;;;;2325:5;2277:200;;;;;;2331:4;2277:200;;;;;;2336:5;2277:200;;;;;;2342:4;2277:200;;;;;;2347:4;2277:200;;;;;;2352:5;2277:200;;;;;;2358:4;2277:200;;;;;;2363:5;2277:200;;;;;;2369:4;2277:200;;;;;;2374:5;2277:200;;;;;;2380:4;2277:200;;;;;;2385:4;2277:200;;;;;;2390:4;2277:200;;;;;;2395:4;2277:200;;;;;;2400:4;2277:200;;;;;;2405:6;2277:200;;;;;;2412:4;2277:200;;;;;;2417:6;2277:200;;;;;;2424:4;2277:200;;;;;;2429:6;2277:200;;;;;;2436:4;2277:200;;;;;;2441:6;2277:200;;;;;;2448:4;2277:200;;;;;;2453:6;2277:200;;;;;;2460:6;2277:200;;;;;;2467:4;2277:200;;;;;;2472:4;2277:200;;;;;:13;2291:2;2277:17;;;;;;;:::i;:::-;;;;;:200;;;;;;;:::i;:::-;;2485:206;;;;;;;;2506:3;2485:206;;;;;;2510:3;2485:206;;;;;;2514:4;2485:206;;;;;;2519:3;2485:206;;;;;;2523:5;2485:206;;;;;;2529:3;2485:206;;;;;;2533:5;2485:206;;;;;;2539:5;2485:206;;;;;;2545:4;2485:206;;;;;;2550:4;2485:206;;;;;;2555:5;2485:206;;;;;;2561:5;2485:206;;;;;;2567:4;2485:206;;;;;;2572:4;2485:206;;;;;;2577:5;2485:206;;;;;;2583:4;2485:206;;;;;;2588:5;2485:206;;;;;;2594:4;2485:206;;;;;;2599:4;2485:206;;;;;;2604:5;2485:206;;;;;;2610:6;2485:206;;;;;;2617:6;2485:206;;;;;;2624:4;2485:206;;;;;;2629:6;2485:206;;;;;;2636:4;2485:206;;;;;;2641:6;2485:206;;;;;;2648:4;2485:206;;;;;;2653:6;2485:206;;;;;;2660:6;2485:206;;;;;;2667:6;2485:206;;;;;;2674:6;2485:206;;;;;;2681:4;2485:206;;;;;;2686:4;2485:206;;;;;:13;2499:2;2485:17;;;;;;;:::i;:::-;;;;;:206;;;;;;;:::i;:::-;;2699:194;;;;;;;;2720:3;2699:194;;;;;;2724:3;2699:194;;;;;;2728:4;2699:194;;;;;;2733:3;2699:194;;;;;;2737:5;2699:194;;;;;;2743:3;2699:194;;;;;;2747:3;2699:194;;;;;;2751:4;2699:194;;;;;;2756:4;2699:194;;;;;;2761:5;2699:194;;;;;;2767:4;2699:194;;;;;;2772:4;2699:194;;;;;;2777:4;2699:194;;;;;;2782:4;2699:194;;;;;;2787:4;2699:194;;;;;;2792:5;2699:194;;;;;;2798:5;2699:194;;;;;;2804:5;2699:194;;;;;;2810:5;2699:194;;;;;;2816:5;2699:194;;;;;;2822:4;2699:194;;;;;;2827:6;2699:194;;;;;;2834:4;2699:194;;;;;;2839:6;2699:194;;;;;;2846:4;2699:194;;;;;;2851:6;2699:194;;;;;;2858:4;2699:194;;;;;;2863:4;2699:194;;;;;;2868:4;2699:194;;;;;;2873:4;2699:194;;;;;;2878:4;2699:194;;;;;;2883:4;2699:194;;;;;;2888:4;2699:194;;;;;:13;2713:2;2699:17;;;;;;;:::i;:::-;;;;;:194;;;;;;;:::i;:::-;;2901:192;;;;;;;;2922:3;2901:192;;;;;;2926:3;2901:192;;;;;;2930:4;2901:192;;;;;;2935:3;2901:192;;;;;;2939:5;2901:192;;;;;;2945:3;2901:192;;;;;;2949:5;2901:192;;;;;;2955:5;2901:192;;;;;;2961:5;2901:192;;;;;;2967:4;2901:192;;;;;;2972:4;2901:192;;;;;;2977:4;2901:192;;;;;;2982:4;2901:192;;;;;;2987:4;2901:192;;;;;;2992:4;2901:192;;;;;;2997:4;2901:192;;;;;;3002:4;2901:192;;;;;;3007:4;2901:192;;;;;;3012:4;2901:192;;;;;;3017:4;2901:192;;;;;;3022:4;2901:192;;;;;;3027:6;2901:192;;;;;;3034:4;2901:192;;;;;;3039:6;2901:192;;;;;;3046:4;2901:192;;;;;;3051:6;2901:192;;;;;;3058:4;2901:192;;;;;;3063:4;2901:192;;;;;;3068:4;2901:192;;;;;;3073:4;2901:192;;;;;;3078:4;2901:192;;;;;;3083:4;2901:192;;;;;;3088:4;2901:192;;;;;:13;2915:2;2901:17;;;;;;;:::i;:::-;;;;;:192;;;;;;;:::i;:::-;;3101:198;;;;;;;;3122:3;3101:198;;;;;;3126:3;3101:198;;;;;;3130:3;3101:198;;;;;;3134:5;3101:198;;;;;;3140:5;3101:198;;;;;;3146:5;3101:198;;;;;;3152:5;3101:198;;;;;;3158:5;3101:198;;;;;;3164:4;3101:198;;;;;;3169:4;3101:198;;;;;;3174:4;3101:198;;;;;;3179:4;3101:198;;;;;;3184:4;3101:198;;;;;;3189:4;3101:198;;;;;;3194:4;3101:198;;;;;;3199:4;3101:198;;;;;;3204:4;3101:198;;;;;;3209:4;3101:198;;;;;;3214:4;3101:198;;;;;;3219:4;3101:198;;;;;;3224:4;3101:198;;;;;;3229:6;3101:198;;;;;;3236:6;3101:198;;;;;;3243:6;3101:198;;;;;;3250:6;3101:198;;;;;;3257:6;3101:198;;;;;;3264:4;3101:198;;;;;;3269:4;3101:198;;;;;;3274:4;3101:198;;;;;;3279:4;3101:198;;;;;;3284:4;3101:198;;;;;;3289:4;3101:198;;;;;;3294:4;3101:198;;;;;:13;3115:2;3101:17;;;;;;;:::i;:::-;;;;;:198;;;;;;;:::i;:::-;;3307:180;;;;;;;;3328:3;3307:180;;;;;;3332:3;3307:180;;;;;;3336:3;3307:180;;;;;;3340:3;3307:180;;;;;;3344:3;3307:180;;;;;;3348:3;3307:180;;;;;;3352:4;3307:180;;;;;;3357:4;3307:180;;;;;;3362:4;3307:180;;;;;;3367:4;3307:180;;;;;;3372:4;3307:180;;;;;;3377:4;3307:180;;;;;;3382:4;3307:180;;;;;;3387:4;3307:180;;;;;;3392:4;3307:180;;;;;;3397:4;3307:180;;;;;;3402:4;3307:180;;;;;;3407:4;3307:180;;;;;;3412:4;3307:180;;;;;;3417:4;3307:180;;;;;;3422:4;3307:180;;;;;;3427:4;3307:180;;;;;;3432:4;3307:180;;;;;;3437:4;3307:180;;;;;;3442:4;3307:180;;;;;;3447:4;3307:180;;;;;;3452:4;3307:180;;;;;;3457:4;3307:180;;;;;;3462:4;3307:180;;;;;;3467:4;3307:180;;;;;;3472:4;3307:180;;;;;;3477:4;3307:180;;;;;;3482:4;3307:180;;;;;:13;3321:2;3307:17;;;;;;;:::i;:::-;;;;;:180;;;;;;;:::i;:::-;;3495;;;;;;;;3516:3;3495:180;;;;;;3520:3;3495:180;;;;;;3524:3;3495:180;;;;;;3528:3;3495:180;;;;;;3532:3;3495:180;;;;;;3536:3;3495:180;;;;;;3540:4;3495:180;;;;;;3545:4;3495:180;;;;;;3550:4;3495:180;;;;;;3555:4;3495:180;;;;;;3560:4;3495:180;;;;;;3565:4;3495:180;;;;;;3570:4;3495:180;;;;;;3575:4;3495:180;;;;;;3580:4;3495:180;;;;;;3585:4;3495:180;;;;;;3590:4;3495:180;;;;;;3595:4;3495:180;;;;;;3600:4;3495:180;;;;;;3605:4;3495:180;;;;;;3610:4;3495:180;;;;;;3615:4;3495:180;;;;;;3620:4;3495:180;;;;;;3625:4;3495:180;;;;;;3630:4;3495:180;;;;;;3635:4;3495:180;;;;;;3640:4;3495:180;;;;;;3645:4;3495:180;;;;;;3650:4;3495:180;;;;;;3655:4;3495:180;;;;;;3660:4;3495:180;;;;;;3665:4;3495:180;;;;;;3670:4;3495:180;;;;;:13;3509:2;3495:17;;;;;;;:::i;:::-;;;;;:180;;;;;;;:::i;:::-;;541:21:6;512:13;;:51;;;;;;;;;;;;;;;;;;602:21;573:13;;:51;;;;;;;;;;;;;;;;;;428:203;;125:1422;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::o;:::-;;;;;;;;;;:::i;:::-;;:::o;:::-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;88:117:7:-;197:1;194;187:12;334:126;371:7;411:42;404:5;400:54;389:65;;334:126;;;:::o;466:96::-;503:7;532:24;550:5;532:24;:::i;:::-;521:35;;466:96;;;:::o;568:122::-;641:24;659:5;641:24;:::i;:::-;634:5;631:35;621:63;;680:1;677;670:12;621:63;568:122;:::o;696:143::-;753:5;784:6;778:13;769:22;;800:33;827:5;800:33;:::i;:::-;696:143;;;;:::o;845:507::-;924:6;932;981:2;969:9;960:7;956:23;952:32;949:119;;;987:79;;:::i;:::-;949:119;1107:1;1132:64;1188:7;1179:6;1168:9;1164:22;1132:64;:::i;:::-;1122:74;;1078:128;1245:2;1271:64;1327:7;1318:6;1307:9;1303:22;1271:64;:::i;:::-;1261:74;;1216:129;845:507;;;;;:::o;1358:180::-;1406:77;1403:1;1396:88;1503:4;1500:1;1493:15;1527:4;1524:1;1517:15;1544:180;1592:77;1589:1;1582:88;1689:4;1686:1;1679:15;1713:4;1710:1;1703:15;1730:320;1774:6;1811:1;1805:4;1801:12;1791:22;;1858:1;1852:4;1848:12;1879:18;1869:81;;1935:4;1927:6;1923:17;1913:27;;1869:81;1997:2;1989:6;1986:14;1966:18;1963:38;1960:84;;2016:18;;:::i;:::-;1960:84;1781:269;1730:320;;;:::o;125:1422:6:-;;;;;;;","deployedSourceMap":"125:1422:6:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6303:809:0;;;;;;;;;;;;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;2094:161;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;138:39:3;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;289:50:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1274:227;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;7118:220;;;;;;;;;;;;;:::i;:::-;;216:33:6;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4877:939:0;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;637:418:6;;;;;;;;;;;;;:::i;:::-;;94:38:3;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;181:29:6;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;255:33;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;5822:471:0;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;103:20;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;325:97:6;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;3888:487:0;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;4382:489;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;184:50:3;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2260:1250:0;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;3684:3074:3;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;6303:809:0;6369:26;6397:17;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;6426:13:::1;6442:14;:12;:14::i;:::-;6426:30;;6466:14;6483:15;:13;:15::i;:::-;6466:32;;6509:39;6575:6;6551:31;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6509:73;;6592:30;6640:6;6625:22;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6592:55;;6663:6;6658:402;6679:6;6675:1;:10;6658:402;;;6706:34;6765:5;6743:28;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6706:65;;6785:25;6826:5;6813:19;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6785:47;;6852:6;6847:120;6868:5;6864:1;:9;6847:120;;;6929:23;6947:1;6950;6929:17;:23::i;:::-;6899:9;6909:1;6899:12;;;;;;;;:::i;:::-;;;;;;;6913:9;6923:1;6913:12;;;;;;;;:::i;:::-;;;;;;;6898:54;;;;;;;;;;::::0;::::1;;6875:3;;;;;:::i;:::-;;;;6847:120;;;;6999:9;6981:12;6994:1;6981:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;7040:9;7022:12;7035:1;7022:15;;;;;;;;:::i;:::-;;;;;;;:27;;;;6692:368;;6687:3;;;;;:::i;:::-;;;;6658:402;;;;7078:12;7092;7070:35;;;;;;;;6303:809:::0;;:::o;2094:161::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2199:1:::1;2202;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2215:33:::2;2233:1;2236;2239;2242:5;2215:17;:33::i;:::-;953:1:::1;;2094:161:::0;;;:::o;138:39:3:-;175:2;138:39;:::o;289:50:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1274:227::-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;1399:1:::1;1402;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;1420:1:::2;1423;1426:10;1208;1169:49;;:4;:7;1174:1;1169:7;;;;;;;;;;;:10;1177:1;1169:10;;;;;;;;;;;:17;;1187:10;1169:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;;;;;;;;;;;:49;;;1161:89;;;;;;;;;;;;:::i;:::-;;;;;;;;;1486:8:::3;1448:4;:7;1453:1;1448:7;;;;;;;;;;;:10;1456:1;1448:10;;;;;;;;;;;:17;;1466:10;1448:29;;;;;;;;:::i;:::-;;;;;;;;;;;;:35;;:46;;;;;;;;;;;;:::i;:::-;;2080:1:::2;;;953::::1;;1274:227:::0;;;;:::o;7118:220::-;1020:5;;;;;;;;;;1006:19;;:10;:19;;;998:69;;;;;;;;;;;;:::i;:::-;;;;;;;;;7172:23:::1;7198:21;7172:47;;7255:1;7237:15;:19;7229:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;7299:5;::::0;::::1;;;;;;;;7291:23;;:40;7315:15;7291:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;7162:176;7118:220::o:0;216:33:6:-;;;;;;;;;;;;;:::o;4877:939:0:-;4944:15;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4971:13:::1;4987:14;:12;:14::i;:::-;4971:30;;5011:14;5028:15;:13;:15::i;:::-;5011:32;;5053:24;5093:6;5080:20;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5053:47;;5116:6;5111:673;5132:6;5128:1;:10;5111:673;;;5159:17;5190:5;5179:17;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5159:37;;5215:6;5210:533;5231:5;5227:1;:9;5210:533;;;5262:13;5277:19:::0;5298::::1;5321:18;5334:1;5337;5321:12;:18::i;:::-;5261:78;;;;;;5377:5;5358:3;5362:1;5358:6;;;;;;;;:::i;:::-;;;;;;;;:16;;:24;;;::::0;::::1;5420:1;5405:11;:16:::0;5401:328:::1;;5473:1;5461:14;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;5445:3;5449:1;5445:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:30;;;;5516:114;;;;;;;;5563:5;::::0;::::1;;;;;;;;5516:114;;;;;;5602:5;5516:114;;::::0;5497:3:::1;5501:1;5497:6;;;;;;;;:::i;:::-;;;;;;;;:13;;;5511:1;5497:16;;;;;;;;:::i;:::-;;;;;;;:133;;;;5401:328;;;5693:4;:7;5698:1;5693:7;;;;;;;;;;;:10;5701:1;5693:10;;;;;;;;;;;:17;;5677:33;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;:3;5681:1;5677:6;;;;;;;;:::i;:::-;;;;;;;;:13;;:33;;;;5401:328;5243:500;;;5238:3;;;;;:::i;:::-;;;;5210:533;;;;5770:3;5756:8;5765:1;5756:11;;;;;;;;:::i;:::-;;;;;;;:17;;;;5145:639;5140:3;;;;;:::i;:::-;;;;5111:673;;;;5801:8;5794:15;;;;;4877:939:::0;:::o;637:418:6:-;1020:5:0;;;;;;;;;;1006:19;;:10;:19;;;998:69;;;;;;;;;;;;:::i;:::-;;;;;;;;;690:19:6::1;712:13;;;;;;;;;;;:33;;;:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;690:57;;757:19;779:13;;;;;;;;;;;:33;;;:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;757:57;;847:12;832:11;:27;;824:73;;;;;;;;;;;;:::i;:::-;;;;;;;;;930:13;915:11;:28;;907:74;;;;;;;;;;;;:::i;:::-;;;;;;;;;1003:4;991:9;;:16;;;;;;;;;;;;;;;;;;1031:17;;;;;;;;;;680:375;;637:418::o:0;94:38:3:-;130:2;94:38;:::o;181:29:6:-;;;;;;;;;;;;;:::o;255:33::-;;;;;;;;;;;;;:::o;5822:471:0:-;5927:15;5944:13;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;5912:1:::1;5915;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;5969:16:::2;5988:4;:7;5993:1;5988:7;;;;;;;;;;;:10;5996:1;5988:10;;;;;;;;;;;5969:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;6035:1;6013:4;:11;;;:18;:23:::0;6009:159:::2;;6055:26;6085:21;6101:1;6104;6085:15;:21::i;:::-;6052:54;;;6136:5;::::0;::::2;;;;;;;;6144:12;6120:37;;;;;;;;6009:159;6178:21;6202:4;:11;;;6235:1;6214:4;:11;;;:18;:22;;;;:::i;:::-;6202:35;;;;;;;;:::i;:::-;;;;;;;;6178:59;;6255:8;:14;;;6271:8;:14;;;6247:39;;;;;;2080:1;953::::1;;5822:471:::0;;;;;:::o;103:20::-;;;;;;;;;;;;:::o;325:97:6:-;383:4;406:9;;;;;;;;;;;399:16;;325:97;:::o;3888:487:0:-;3940:7;3959:18;3980:1;3959:22;;3991:13;4007:14;:12;:14::i;:::-;3991:30;;4031:14;4048:15;:13;:15::i;:::-;4031:32;;4079:6;4074:267;4095:6;4091:1;:10;4074:267;;;4127:6;4122:209;4143:5;4139:1;:9;4122:209;;;4173:16;4192:4;:7;4197:1;4192:7;;;;;;;;;;;:10;4200:1;4192:10;;;;;;;;;;;4173:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4220:17;4257:4;:11;;;:18;4240:4;:14;;;:35;;;;:::i;:::-;4220:55;;4307:9;4293:23;;;;;:::i;:::-;;;4155:176;;4150:3;;;;;:::i;:::-;;;;4122:209;;;;4103:3;;;;;:::i;:::-;;;;4074:267;;;;4358:10;4351:17;;;;;3888:487;:::o;4382:489::-;4482:7;4491:13;4506:7;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;4467:1:::1;4470;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;4525:16:::2;4544:4;:7;4549:1;4544:7;;;;;;;;;;;:10;4552:1;4544:10;;;;;;;;;;;4525:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;::::0;::::2;;;4598:1;4576:4;:11;;;:18;:23:::0;4573:187:::2;;4616:20;4638:26:::0;4668:21:::2;4684:1;4687;4668:15;:21::i;:::-;4615:74;;;;4726:5;4711:12;:20;;;;:::i;:::-;4733:12;4747:1;4703:46;;;;;;;;;;;4573:187;4786:4;:14;;;4802:4;:11;;;4835:1;4814:4;:11;;;:18;:22;;;;:::i;:::-;4802:35;;;;;;;;:::i;:::-;;;;;;;;:41;;;4845:4;:11;;;:18;4778:86;;;;;;;2080:1;953::::1;;4382:489:::0;;;;;:::o;184:50:3:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2260:1250:0:-;896:19;:17;:19::i;:::-;888:55;;;;;;;;;;;;:::i;:::-;;;;;;;;;2398:1:::1;2401;1969:14;:12;:14::i;:::-;1965:1;:18;1957:51;;;;;;;;;;;;:::i;:::-;;;;;;;;;2030:15;:13;:15::i;:::-;2026:1;:19;2018:52;;;;;;;;;;;;:::i;:::-;;;;;;;;;2440:2:::2;2422:14;:20;;2414:71;;;;;;;;;;;;:::i;:::-;;;;;;;;;2496:20;2511:1;2514;2496:14;:20::i;:::-;2527:29;2582:5;2559:4;:7;2564:1;2559:7;;;;;;;;;;;:10;2567:1;2559:10;;;;;;;;;;;:20;;;:28;;;;:::i;:::-;2527:60;;2597:26;2626:4;:7;2631:1;2626:7;;;;;;;;;;;:10;2634:1;2626:10;;;;;;;;;;;:17;;:24;;;;2597:53;;2660:19;2747:1;2742;2725:14;2704:18;2700:1;:22;;;;:::i;:::-;:39;;;;:::i;:::-;:43;;;;:::i;:::-;2682:14;:62;;;;:::i;:::-;:66;;;;:::i;:::-;2660:88;;2759:20;2847:1;2842;2825:14;:18;;;;:::i;:::-;2807:14;:37;;;;:::i;:::-;:41;;;;:::i;:::-;2782:21;:67;;;;:::i;:::-;2759:90;;2860:17;2920:12;2905:11;2881:21;:35;;;;:::i;:::-;2880:52;;;;:::i;:::-;2860:72;;2964:9;2951;:22;2943:53;;;;;;;;;;;;:::i;:::-;;;;;;;;;3012:9;3007:198;3031:18;3027:1;:22;3007:198;;;3070:18;3091:4;:7;3096:1;3091:7;;;;;;;;;;;:10;3099:1;3091:10;;;;;;;;;;;:17;;3109:1;3091:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3070:47;;3180:14;3156:21;:38;;;;:::i;:::-;3131:9;:21;3141:10;3131:21;;;;;;;;;;;;;;;;:63;;;;;;;:::i;:::-;;;;;;;;3056:149;3051:3;;;;;:::i;:::-;;;;3007:198;;;;3215:18;3228:1;3231;3215:12;:18::i;:::-;3249:9;3244:189;3268:14;3264:1;:18;3244:189;;;3303:4;:7;3308:1;3303:7;;;;;;;;;;;:10;3311:1;3303:10;;;;;;;;;;;:17;;3326:95;;;;;;;;3365:10;3326:95;;;;;;3401:5;3326:95;;::::0;3303:119:::2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;3284:3;;;;;:::i;:::-;;;;3244:189;;;;3463:10;3448:55;;;3475:1;3478;3481:14;3497:5;3448:55;;;;;;;;;:::i;:::-;;;;;;;;2404:1106;;;;;953:1:::1;;2260:1250:::0;;;;:::o;3684:3074:3:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1341:98:6:-;1397:7;130:2:3;1416:16:6;;1341:98;:::o;1445:100::-;1502:7;175:2:3;1521:17:6;;1445:100;:::o;1061:274::-;1134:7;1143:13;130:2:3;1176:1:6;:13;1168:46;;;;;;;;;;;;:::i;:::-;;;;;;;;;175:2:3;1232:1:6;:14;1224:47;;;;;;;;;;;;:::i;:::-;;;;;;;;;1289:13;1303:1;1289:16;;;;;;;:::i;:::-;;;;;1306:1;1289:19;;;;;;;:::i;:::-;;;;1310:11;1322:1;1310:14;;;;;;;:::i;:::-;;;;;1325:1;1310:17;;;;;;;:::i;:::-;;;1281:47;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1061:274;;;;;:::o;1507:392:0:-;1594:1;1570:4;:7;1575:1;1570:7;;;;;;;;;;;:10;1578:1;1570:10;;;;;;;;;;;:20;;;:25;:58;;;;;1627:1;1599:4;:7;1604:1;1599:7;;;;;;;;;;;:10;1607:1;1599:10;;;;;;;;;;;:17;;:24;;;;:29;1570:58;1566:327;;;1645:13;1660:19;1683:21;1699:1;1702;1683:15;:21::i;:::-;1644:60;;;;1749:5;1741;:13;;;;:::i;:::-;1718:4;:7;1723:1;1718:7;;;;;;;;;;;:10;1726:1;1718:10;;;;;;;;;;;:20;;:36;;;;1768:4;:7;1773:1;1768:7;;;;;;;;;;;:10;1776:1;1768:10;;;;;;;;;;;:17;;1791:90;;;;;;;;1830:5;;;;;;;;;;1791:90;;;;;;1861:5;1791:90;;;1768:114;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;1630:263;;1566:327;1507:392;;:::o;3517:361::-;3579:9;3574:298;3598:4;:7;3603:1;3598:7;;;;;;;;;;;:10;3606:1;3598:10;;;;;;;;;;;:17;;:24;;;;3594:1;:28;3574:298;;;3643:18;3664:4;:7;3669:1;3664:7;;;;;;;;;;;:10;3672:1;3664:10;;;;;;;;;;;:17;;3682:1;3664:20;;;;;;;;:::i;:::-;;;;;;;;;;;;:26;;;;;;;;;;;;3643:47;;3732:1;3708:9;:21;3718:10;3708:21;;;;;;;;;;;;;;;;:25;3704:158;;;3761:10;3753:28;;:51;3782:9;:21;3792:10;3782:21;;;;;;;;;;;;;;;;3753:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3846:1;3822:9;:21;3832:10;3822:21;;;;;;;;;;;;;;;:25;;;;3704:158;3629:243;3624:3;;;;;:::i;:::-;;;;3574:298;;;;3517:361;;:::o;-1:-1:-1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;:::o;7:147:7:-;107:6;141:5;135:12;125:22;;7:147;;;:::o;160:217::-;292:11;326:6;321:3;314:19;366:4;361:3;357:14;342:29;;160:217;;;;:::o;383:165::-;483:4;506:3;498:11;;536:4;531:3;527:14;519:22;;383:165;;;:::o;554:122::-;629:6;663:5;657:12;647:22;;554:122;;;:::o;682:182::-;779:11;813:6;808:3;801:19;853:4;848:3;844:14;829:29;;682:182;;;;:::o;870:140::-;945:4;968:3;960:11;;998:4;993:3;989:14;981:22;;870:140;;;:::o;1016:126::-;1053:7;1093:42;1086:5;1082:54;1071:65;;1016:126;;;:::o;1148:104::-;1193:7;1222:24;1240:5;1222:24;:::i;:::-;1211:35;;1148:104;;;:::o;1258:132::-;1351:32;1377:5;1351:32;:::i;:::-;1346:3;1339:45;1258:132;;:::o;1396:211::-;1481:10;1502:62;1560:3;1552:6;1502:62;:::i;:::-;1596:4;1591:3;1587:14;1573:28;;1396:211;;;;:::o;1613:121::-;1691:4;1723;1718:3;1714:14;1706:22;;1613:121;;;:::o;1786:776::-;1911:3;1940:62;1996:5;1940:62;:::i;:::-;2018:84;2095:6;2090:3;2018:84;:::i;:::-;2011:91;;2126:64;2184:5;2126:64;:::i;:::-;2213:7;2244:1;2229:308;2254:6;2251:1;2248:13;2229:308;;;2330:6;2324:13;2357:79;2432:3;2417:13;2357:79;:::i;:::-;2350:86;;2459:68;2520:6;2459:68;:::i;:::-;2449:78;;2289:248;2276:1;2273;2269:9;2264:14;;2229:308;;;2233:14;2553:3;2546:10;;1916:646;;;1786:776;;;;:::o;2568:288::-;2703:10;2738:112;2846:3;2838:6;2738:112;:::i;:::-;2724:126;;2568:288;;;;:::o;2862:146::-;2965:4;2997;2992:3;2988:14;2980:22;;2862:146;;;:::o;3064:1175::-;3249:3;3278:87;3359:5;3278:87;:::i;:::-;3381:119;3493:6;3488:3;3381:119;:::i;:::-;3374:126;;3526:3;3571:4;3563:6;3559:17;3554:3;3550:27;3601:89;3684:5;3601:89;:::i;:::-;3713:7;3744:1;3729:465;3754:6;3751:1;3748:13;3729:465;;;3825:9;3819:4;3815:20;3810:3;3803:33;3876:6;3870:13;3904:130;4029:4;4014:13;3904:130;:::i;:::-;3896:138;;4057:93;4143:6;4057:93;:::i;:::-;4047:103;;4179:4;4174:3;4170:14;4163:21;;3789:405;3776:1;3773;3769:9;3764:14;;3729:465;;;3733:14;4210:4;4203:11;;4230:3;4223:10;;3254:985;;;;;3064:1175;;;;:::o;4245:149::-;4347:6;4381:5;4375:12;4365:22;;4245:149;;;:::o;4400:219::-;4534:11;4568:6;4563:3;4556:19;4608:4;4603:3;4599:14;4584:29;;4400:219;;;;:::o;4625:167::-;4727:4;4750:3;4742:11;;4780:4;4775:3;4771:14;4763:22;;4625:167;;;:::o;4798:124::-;4875:6;4909:5;4903:12;4893:22;;4798:124;;;:::o;4928:184::-;5027:11;5061:6;5056:3;5049:19;5101:4;5096:3;5092:14;5077:29;;4928:184;;;;:::o;5118:142::-;5195:4;5218:3;5210:11;;5248:4;5243:3;5239:14;5231:22;;5118:142;;;:::o;5266:99::-;5318:6;5352:5;5346:12;5336:22;;5266:99;;;:::o;5371:159::-;5445:11;5479:6;5474:3;5467:19;5519:4;5514:3;5510:14;5495:29;;5371:159;;;;:::o;5536:307::-;5604:1;5614:113;5628:6;5625:1;5622:13;5614:113;;;5713:1;5708:3;5704:11;5698:18;5694:1;5689:3;5685:11;5678:39;5650:2;5647:1;5643:10;5638:15;;5614:113;;;5745:6;5742:1;5739:13;5736:101;;;5825:1;5816:6;5811:3;5807:16;5800:27;5736:101;5585:258;5536:307;;;:::o;5849:102::-;5890:6;5941:2;5937:7;5932:2;5925:5;5921:14;5917:28;5907:38;;5849:102;;;:::o;5957:344::-;6035:3;6063:39;6096:5;6063:39;:::i;:::-;6118:61;6172:6;6167:3;6118:61;:::i;:::-;6111:68;;6188:52;6233:6;6228:3;6221:4;6214:5;6210:16;6188:52;:::i;:::-;6265:29;6287:6;6265:29;:::i;:::-;6260:3;6256:39;6249:46;;6039:262;5957:344;;;;:::o;6307:196::-;6396:10;6431:66;6493:3;6485:6;6431:66;:::i;:::-;6417:80;;6307:196;;;;:::o;6509:123::-;6589:4;6621;6616:3;6612:14;6604:22;;6509:123;;;:::o;6666:971::-;6795:3;6824:64;6882:5;6824:64;:::i;:::-;6904:86;6983:6;6978:3;6904:86;:::i;:::-;6897:93;;7016:3;7061:4;7053:6;7049:17;7044:3;7040:27;7091:66;7151:5;7091:66;:::i;:::-;7180:7;7211:1;7196:396;7221:6;7218:1;7215:13;7196:396;;;7292:9;7286:4;7282:20;7277:3;7270:33;7343:6;7337:13;7371:84;7450:4;7435:13;7371:84;:::i;:::-;7363:92;;7478:70;7541:6;7478:70;:::i;:::-;7468:80;;7577:4;7572:3;7568:14;7561:21;;7256:336;7243:1;7240;7236:9;7231:14;;7196:396;;;7200:14;7608:4;7601:11;;7628:3;7621:10;;6800:837;;;;;6666:971;;;;:::o;7643:296::-;7782:10;7817:116;7929:3;7921:6;7817:116;:::i;:::-;7803:130;;7643:296;;;;:::o;7945:148::-;8050:4;8082;8077:3;8073:14;8065:22;;7945:148;;;:::o;8131:1191::-;8320:3;8349:89;8432:5;8349:89;:::i;:::-;8454:121;8568:6;8563:3;8454:121;:::i;:::-;8447:128;;8601:3;8646:4;8638:6;8634:17;8629:3;8625:27;8676:91;8761:5;8676:91;:::i;:::-;8790:7;8821:1;8806:471;8831:6;8828:1;8825:13;8806:471;;;8902:9;8896:4;8892:20;8887:3;8880:33;8953:6;8947:13;8981:134;9110:4;9095:13;8981:134;:::i;:::-;8973:142;;9138:95;9226:6;9138:95;:::i;:::-;9128:105;;9262:4;9257:3;9253:14;9246:21;;8866:411;8853:1;8850;8846:9;8841:14;;8806:471;;;8810:14;9293:4;9286:11;;9313:3;9306:10;;8325:997;;;;;8131:1191;;;;:::o;9328:906::-;9685:4;9723:2;9712:9;9708:18;9700:26;;9772:9;9766:4;9762:20;9758:1;9747:9;9743:17;9736:47;9800:174;9969:4;9960:6;9800:174;:::i;:::-;9792:182;;10021:9;10015:4;10011:20;10006:2;9995:9;9991:18;9984:48;10049:178;10222:4;10213:6;10049:178;:::i;:::-;10041:186;;9328:906;;;;;:::o;10240:75::-;10273:6;10306:2;10300:9;10290:19;;10240:75;:::o;10321:117::-;10430:1;10427;10420:12;10444:117;10553:1;10550;10543:12;10567:77;10604:7;10633:5;10622:16;;10567:77;;;:::o;10650:122::-;10723:24;10741:5;10723:24;:::i;:::-;10716:5;10713:35;10703:63;;10762:1;10759;10752:12;10703:63;10650:122;:::o;10778:139::-;10824:5;10862:6;10849:20;10840:29;;10878:33;10905:5;10878:33;:::i;:::-;10778:139;;;;:::o;10923:117::-;11032:1;11029;11022:12;11046:117;11155:1;11152;11145:12;11169:180;11217:77;11214:1;11207:88;11314:4;11311:1;11304:15;11338:4;11335:1;11328:15;11355:281;11438:27;11460:4;11438:27;:::i;:::-;11430:6;11426:40;11568:6;11556:10;11553:22;11532:18;11520:10;11517:34;11514:62;11511:88;;;11579:18;;:::i;:::-;11511:88;11619:10;11615:2;11608:22;11398:238;11355:281;;:::o;11642:129::-;11676:6;11703:20;;:::i;:::-;11693:30;;11732:33;11760:4;11752:6;11732:33;:::i;:::-;11642:129;;;:::o;11777:308::-;11839:4;11929:18;11921:6;11918:30;11915:56;;;11951:18;;:::i;:::-;11915:56;11989:29;12011:6;11989:29;:::i;:::-;11981:37;;12073:4;12067;12063:15;12055:23;;11777:308;;;:::o;12091:154::-;12175:6;12170:3;12165;12152:30;12237:1;12228:6;12223:3;12219:16;12212:27;12091:154;;;:::o;12251:412::-;12329:5;12354:66;12370:49;12412:6;12370:49;:::i;:::-;12354:66;:::i;:::-;12345:75;;12443:6;12436:5;12429:21;12481:4;12474:5;12470:16;12519:3;12510:6;12505:3;12501:16;12498:25;12495:112;;;12526:79;;:::i;:::-;12495:112;12616:41;12650:6;12645:3;12640;12616:41;:::i;:::-;12335:328;12251:412;;;;;:::o;12683:340::-;12739:5;12788:3;12781:4;12773:6;12769:17;12765:27;12755:122;;12796:79;;:::i;:::-;12755:122;12913:6;12900:20;12938:79;13013:3;13005:6;12998:4;12990:6;12986:17;12938:79;:::i;:::-;12929:88;;12745:278;12683:340;;;;:::o;13029:799::-;13116:6;13124;13132;13181:2;13169:9;13160:7;13156:23;13152:32;13149:119;;;13187:79;;:::i;:::-;13149:119;13307:1;13332:53;13377:7;13368:6;13357:9;13353:22;13332:53;:::i;:::-;13322:63;;13278:117;13434:2;13460:53;13505:7;13496:6;13485:9;13481:22;13460:53;:::i;:::-;13450:63;;13405:118;13590:2;13579:9;13575:18;13562:32;13621:18;13613:6;13610:30;13607:117;;;13643:79;;:::i;:::-;13607:117;13748:63;13803:7;13794:6;13783:9;13779:22;13748:63;:::i;:::-;13738:73;;13533:288;13029:799;;;;;:::o;13834:118::-;13921:24;13939:5;13921:24;:::i;:::-;13916:3;13909:37;13834:118;;:::o;13958:222::-;14051:4;14089:2;14078:9;14074:18;14066:26;;14102:71;14170:1;14159:9;14155:17;14146:6;14102:71;:::i;:::-;13958:222;;;;:::o;14186:474::-;14254:6;14262;14311:2;14299:9;14290:7;14286:23;14282:32;14279:119;;;14317:79;;:::i;:::-;14279:119;14437:1;14462:53;14507:7;14498:6;14487:9;14483:22;14462:53;:::i;:::-;14452:63;;14408:117;14564:2;14590:53;14635:7;14626:6;14615:9;14611:22;14590:53;:::i;:::-;14580:63;;14535:118;14186:474;;;;;:::o;14666:945::-;14762:6;14770;14778;14786;14835:3;14823:9;14814:7;14810:23;14806:33;14803:120;;;14842:79;;:::i;:::-;14803:120;14962:1;14987:53;15032:7;15023:6;15012:9;15008:22;14987:53;:::i;:::-;14977:63;;14933:117;15089:2;15115:53;15160:7;15151:6;15140:9;15136:22;15115:53;:::i;:::-;15105:63;;15060:118;15217:2;15243:53;15288:7;15279:6;15268:9;15264:22;15243:53;:::i;:::-;15233:63;;15188:118;15373:2;15362:9;15358:18;15345:32;15404:18;15396:6;15393:30;15390:117;;;15426:79;;:::i;:::-;15390:117;15531:63;15586:7;15577:6;15566:9;15562:22;15531:63;:::i;:::-;15521:73;;15316:288;14666:945;;;;;;;:::o;15617:60::-;15645:3;15666:5;15659:12;;15617:60;;;:::o;15683:142::-;15733:9;15766:53;15784:34;15793:24;15811:5;15793:24;:::i;:::-;15784:34;:::i;:::-;15766:53;:::i;:::-;15753:66;;15683:142;;;:::o;15831:126::-;15881:9;15914:37;15945:5;15914:37;:::i;:::-;15901:50;;15831:126;;;:::o;15963:147::-;16034:9;16067:37;16098:5;16067:37;:::i;:::-;16054:50;;15963:147;;;:::o;16116:173::-;16224:58;16276:5;16224:58;:::i;:::-;16219:3;16212:71;16116:173;;:::o;16295:264::-;16409:4;16447:2;16436:9;16432:18;16424:26;;16460:92;16549:1;16538:9;16534:17;16525:6;16460:92;:::i;:::-;16295:264;;;;:::o;16565:159::-;16677:6;16711:5;16705:12;16695:22;;16565:159;;;:::o;16730:229::-;16874:11;16908:6;16903:3;16896:19;16948:4;16943:3;16939:14;16924:29;;16730:229;;;;:::o;16965:177::-;17077:4;17100:3;17092:11;;17130:4;17125:3;17121:14;17113:22;;16965:177;;;:::o;17148:134::-;17235:6;17269:5;17263:12;17253:22;;17148:134;;;:::o;17288:194::-;17397:11;17431:6;17426:3;17419:19;17471:4;17466:3;17462:14;17447:29;;17288:194;;;;:::o;17488:152::-;17575:4;17598:3;17590:11;;17628:4;17623:3;17619:14;17611:22;;17488:152;;;:::o;17646:108::-;17723:24;17741:5;17723:24;:::i;:::-;17718:3;17711:37;17646:108;;:::o;17760:134::-;17847:6;17881:5;17875:12;17865:22;;17760:134;;;:::o;17900:194::-;18009:11;18043:6;18038:3;18031:19;18083:4;18078:3;18074:14;18059:29;;17900:194;;;;:::o;18100:152::-;18187:4;18210:3;18202:11;;18240:4;18235:3;18231:14;18223:22;;18100:152;;;:::o;18320:604::-;18419:3;18455:4;18450:3;18446:14;18543:4;18536:5;18532:16;18526:23;18562:79;18635:4;18630:3;18626:14;18612:12;18562:79;:::i;:::-;18470:181;18734:4;18727:5;18723:16;18717:23;18787:3;18781:4;18777:14;18770:4;18765:3;18761:14;18754:38;18813:73;18881:4;18867:12;18813:73;:::i;:::-;18805:81;;18661:236;18914:4;18907:11;;18424:500;18320:604;;;;:::o;18930:236::-;19039:10;19074:86;19156:3;19148:6;19074:86;:::i;:::-;19060:100;;18930:236;;;;:::o;19172:133::-;19262:4;19294;19289:3;19285:14;19277:22;;19172:133;;;:::o;19377:1051::-;19526:3;19555:74;19623:5;19555:74;:::i;:::-;19645:96;19734:6;19729:3;19645:96;:::i;:::-;19638:103;;19767:3;19812:4;19804:6;19800:17;19795:3;19791:27;19842:76;19912:5;19842:76;:::i;:::-;19941:7;19972:1;19957:426;19982:6;19979:1;19976:13;19957:426;;;20053:9;20047:4;20043:20;20038:3;20031:33;20104:6;20098:13;20132:104;20231:4;20216:13;20132:104;:::i;:::-;20124:112;;20259:80;20332:6;20259:80;:::i;:::-;20249:90;;20368:4;20363:3;20359:14;20352:21;;20017:366;20004:1;20001;19997:9;19992:14;;19957:426;;;19961:14;20399:4;20392:11;;20419:3;20412:10;;19531:897;;;;;19377:1051;;;;:::o;20494:663::-;20593:3;20629:4;20624:3;20620:14;20721:4;20714:5;20710:16;20704:23;20740:63;20797:4;20792:3;20788:14;20774:12;20740:63;:::i;:::-;20644:169;20897:4;20890:5;20886:16;20880:23;20950:3;20944:4;20940:14;20933:4;20928:3;20924:14;20917:38;20976:143;21114:4;21100:12;20976:143;:::i;:::-;20968:151;;20823:307;21147:4;21140:11;;20598:559;20494:663;;;;:::o;21163:236::-;21272:10;21307:86;21389:3;21381:6;21307:86;:::i;:::-;21293:100;;21163:236;;;;:::o;21405:133::-;21495:4;21527;21522:3;21518:14;21510:22;;21405:133;;;:::o;21608:1051::-;21757:3;21786:74;21854:5;21786:74;:::i;:::-;21876:96;21965:6;21960:3;21876:96;:::i;:::-;21869:103;;21998:3;22043:4;22035:6;22031:17;22026:3;22022:27;22073:76;22143:5;22073:76;:::i;:::-;22172:7;22203:1;22188:426;22213:6;22210:1;22207:13;22188:426;;;22284:9;22278:4;22274:20;22269:3;22262:33;22335:6;22329:13;22363:104;22462:4;22447:13;22363:104;:::i;:::-;22355:112;;22490:80;22563:6;22490:80;:::i;:::-;22480:90;;22599:4;22594:3;22590:14;22583:21;;22248:366;22235:1;22232;22228:9;22223:14;;22188:426;;;22192:14;22630:4;22623:11;;22650:3;22643:10;;21762:897;;;;;21608:1051;;;;:::o;22665:336::-;22824:10;22859:136;22991:3;22983:6;22859:136;:::i;:::-;22845:150;;22665:336;;;;:::o;23007:158::-;23122:4;23154;23149:3;23145:14;23137:22;;23007:158;;;:::o;23239:1271::-;23448:3;23477:99;23570:5;23477:99;:::i;:::-;23592:131;23716:6;23711:3;23592:131;:::i;:::-;23585:138;;23749:3;23794:4;23786:6;23782:17;23777:3;23773:27;23824:101;23919:5;23824:101;:::i;:::-;23948:7;23979:1;23964:501;23989:6;23986:1;23983:13;23964:501;;;24060:9;24054:4;24050:20;24045:3;24038:33;24111:6;24105:13;24139:154;24288:4;24273:13;24139:154;:::i;:::-;24131:162;;24316:105;24414:6;24316:105;:::i;:::-;24306:115;;24450:4;24445:3;24441:14;24434:21;;24024:441;24011:1;24008;24004:9;23999:14;;23964:501;;;23968:14;24481:4;24474:11;;24501:3;24494:10;;23453:1057;;;;;23239:1271;;;;:::o;24516:553::-;24749:4;24787:2;24776:9;24772:18;24764:26;;24836:9;24830:4;24826:20;24822:1;24811:9;24807:17;24800:47;24864:198;25057:4;25048:6;24864:198;:::i;:::-;24856:206;;24516:553;;;;:::o;25075:90::-;25109:7;25152:5;25145:13;25138:21;25127:32;;25075:90;;;:::o;25171:109::-;25252:21;25267:5;25252:21;:::i;:::-;25247:3;25240:34;25171:109;;:::o;25286:210::-;25373:4;25411:2;25400:9;25396:18;25388:26;;25424:65;25486:1;25475:9;25471:17;25462:6;25424:65;:::i;:::-;25286:210;;;;:::o;25502:142::-;25605:32;25631:5;25605:32;:::i;:::-;25600:3;25593:45;25502:142;;:::o;25650:169::-;25734:11;25768:6;25763:3;25756:19;25808:4;25803:3;25799:14;25784:29;;25650:169;;;;:::o;25825:364::-;25913:3;25941:39;25974:5;25941:39;:::i;:::-;25996:71;26060:6;26055:3;25996:71;:::i;:::-;25989:78;;26076:52;26121:6;26116:3;26109:4;26102:5;26098:16;26076:52;:::i;:::-;26153:29;26175:6;26153:29;:::i;:::-;26148:3;26144:39;26137:46;;25917:272;25825:364;;;;:::o;26195:455::-;26352:4;26390:2;26379:9;26375:18;26367:26;;26403:87;26487:1;26476:9;26472:17;26463:6;26403:87;:::i;:::-;26537:9;26531:4;26527:20;26522:2;26511:9;26507:18;26500:48;26565:78;26638:4;26629:6;26565:78;:::i;:::-;26557:86;;26195:455;;;;;:::o;26656:96::-;26693:7;26722:24;26740:5;26722:24;:::i;:::-;26711:35;;26656:96;;;:::o;26758:118::-;26845:24;26863:5;26845:24;:::i;:::-;26840:3;26833:37;26758:118;;:::o;26882:222::-;26975:4;27013:2;27002:9;26998:18;26990:26;;27026:71;27094:1;27083:9;27079:17;27070:6;27026:71;:::i;:::-;26882:222;;;;:::o;27110:533::-;27279:4;27317:2;27306:9;27302:18;27294:26;;27330:71;27398:1;27387:9;27383:17;27374:6;27330:71;:::i;:::-;27448:9;27442:4;27438:20;27433:2;27422:9;27418:18;27411:48;27476:78;27549:4;27540:6;27476:78;:::i;:::-;27468:86;;27564:72;27632:2;27621:9;27617:18;27608:6;27564:72;:::i;:::-;27110:533;;;;;;:::o;27649:313::-;27762:4;27800:2;27789:9;27785:18;27777:26;;27849:9;27843:4;27839:20;27835:1;27824:9;27820:17;27813:47;27877:78;27950:4;27941:6;27877:78;:::i;:::-;27869:86;;27649:313;;;;:::o;27968:173::-;28108:25;28104:1;28096:6;28092:14;28085:49;27968:173;:::o;28147:366::-;28289:3;28310:67;28374:2;28369:3;28310:67;:::i;:::-;28303:74;;28386:93;28475:3;28386:93;:::i;:::-;28504:2;28499:3;28495:12;28488:19;;28147:366;;;:::o;28519:419::-;28685:4;28723:2;28712:9;28708:18;28700:26;;28772:9;28766:4;28762:20;28758:1;28747:9;28743:17;28736:47;28800:131;28926:4;28800:131;:::i;:::-;28792:139;;28519:419;;;:::o;28944:180::-;28992:77;28989:1;28982:88;29089:4;29086:1;29079:15;29113:4;29110:1;29103:15;29130:180;29178:77;29175:1;29168:88;29275:4;29272:1;29265:15;29299:4;29296:1;29289:15;29316:233;29355:3;29378:24;29396:5;29378:24;:::i;:::-;29369:33;;29424:66;29417:5;29414:77;29411:103;;29494:18;;:::i;:::-;29411:103;29541:1;29534:5;29530:13;29523:20;;29316:233;;;:::o;29555:170::-;29695:22;29691:1;29683:6;29679:14;29672:46;29555:170;:::o;29731:366::-;29873:3;29894:67;29958:2;29953:3;29894:67;:::i;:::-;29887:74;;29970:93;30059:3;29970:93;:::i;:::-;30088:2;30083:3;30079:12;30072:19;;29731:366;;;:::o;30103:419::-;30269:4;30307:2;30296:9;30292:18;30284:26;;30356:9;30350:4;30346:20;30342:1;30331:9;30327:17;30320:47;30384:131;30510:4;30384:131;:::i;:::-;30376:139;;30103:419;;;:::o;30528:170::-;30668:22;30664:1;30656:6;30652:14;30645:46;30528:170;:::o;30704:366::-;30846:3;30867:67;30931:2;30926:3;30867:67;:::i;:::-;30860:74;;30943:93;31032:3;30943:93;:::i;:::-;31061:2;31056:3;31052:12;31045:19;;30704:366;;;:::o;31076:419::-;31242:4;31280:2;31269:9;31265:18;31257:26;;31329:9;31323:4;31319:20;31315:1;31304:9;31300:17;31293:47;31357:131;31483:4;31357:131;:::i;:::-;31349:139;;31076:419;;;:::o;31501:177::-;31641:29;31637:1;31629:6;31625:14;31618:53;31501:177;:::o;31684:366::-;31826:3;31847:67;31911:2;31906:3;31847:67;:::i;:::-;31840:74;;31923:93;32012:3;31923:93;:::i;:::-;32041:2;32036:3;32032:12;32025:19;;31684:366;;;:::o;32056:419::-;32222:4;32260:2;32249:9;32245:18;32237:26;;32309:9;32303:4;32299:20;32295:1;32284:9;32280:17;32273:47;32337:131;32463:4;32337:131;:::i;:::-;32329:139;;32056:419;;;:::o;32481:224::-;32621:34;32617:1;32609:6;32605:14;32598:58;32690:7;32685:2;32677:6;32673:15;32666:32;32481:224;:::o;32711:366::-;32853:3;32874:67;32938:2;32933:3;32874:67;:::i;:::-;32867:74;;32950:93;33039:3;32950:93;:::i;:::-;33068:2;33063:3;33059:12;33052:19;;32711:366;;;:::o;33083:419::-;33249:4;33287:2;33276:9;33272:18;33264:26;;33336:9;33330:4;33326:20;33322:1;33311:9;33307:17;33300:47;33364:131;33490:4;33364:131;:::i;:::-;33356:139;;33083:419;;;:::o;33508:170::-;33648:22;33644:1;33636:6;33632:14;33625:46;33508:170;:::o;33684:366::-;33826:3;33847:67;33911:2;33906:3;33847:67;:::i;:::-;33840:74;;33923:93;34012:3;33923:93;:::i;:::-;34041:2;34036:3;34032:12;34025:19;;33684:366;;;:::o;34056:419::-;34222:4;34260:2;34249:9;34245:18;34237:26;;34309:9;34303:4;34299:20;34295:1;34284:9;34280:17;34273:47;34337:131;34463:4;34337:131;:::i;:::-;34329:139;;34056:419;;;:::o;34481:180::-;34529:77;34526:1;34519:88;34626:4;34623:1;34616:15;34650:4;34647:1;34640:15;34667:320;34711:6;34748:1;34742:4;34738:12;34728:22;;34795:1;34789:4;34785:12;34816:18;34806:81;;34872:4;34864:6;34860:17;34850:27;;34806:81;34934:2;34926:6;34923:14;34903:18;34900:38;34897:84;;34953:18;;:::i;:::-;34897:84;34718:269;34667:320;;;:::o;34993:143::-;35050:5;35081:6;35075:13;35066:22;;35097:33;35124:5;35097:33;:::i;:::-;34993:143;;;;:::o;35142:351::-;35212:6;35261:2;35249:9;35240:7;35236:23;35232:32;35229:119;;;35267:79;;:::i;:::-;35229:119;35387:1;35412:64;35468:7;35459:6;35448:9;35444:22;35412:64;:::i;:::-;35402:74;;35358:128;35142:351;;;;:::o;35499:220::-;35639:34;35635:1;35627:6;35623:14;35616:58;35708:3;35703:2;35695:6;35691:15;35684:28;35499:220;:::o;35725:366::-;35867:3;35888:67;35952:2;35947:3;35888:67;:::i;:::-;35881:74;;35964:93;36053:3;35964:93;:::i;:::-;36082:2;36077:3;36073:12;36066:19;;35725:366;;;:::o;36097:419::-;36263:4;36301:2;36290:9;36286:18;36278:26;;36350:9;36344:4;36340:20;36336:1;36325:9;36321:17;36314:47;36378:131;36504:4;36378:131;:::i;:::-;36370:139;;36097:419;;;:::o;36522:220::-;36662:34;36658:1;36650:6;36646:14;36639:58;36731:3;36726:2;36718:6;36714:15;36707:28;36522:220;:::o;36748:366::-;36890:3;36911:67;36975:2;36970:3;36911:67;:::i;:::-;36904:74;;36987:93;37076:3;36987:93;:::i;:::-;37105:2;37100:3;37096:12;37089:19;;36748:366;;;:::o;37120:419::-;37286:4;37324:2;37313:9;37309:18;37301:26;;37373:9;37367:4;37363:20;37359:1;37348:9;37344:17;37337:47;37401:131;37527:4;37401:131;:::i;:::-;37393:139;;37120:419;;;:::o;37545:191::-;37585:4;37605:20;37623:1;37605:20;:::i;:::-;37600:25;;37639:20;37657:1;37639:20;:::i;:::-;37634:25;;37678:1;37675;37672:8;37669:34;;;37683:18;;:::i;:::-;37669:34;37728:1;37725;37721:9;37713:17;;37545:191;;;;:::o;37742:348::-;37782:7;37805:20;37823:1;37805:20;:::i;:::-;37800:25;;37839:20;37857:1;37839:20;:::i;:::-;37834:25;;38027:1;37959:66;37955:74;37952:1;37949:81;37944:1;37937:9;37930:17;37926:105;37923:131;;;38034:18;;:::i;:::-;37923:131;38082:1;38079;38075:9;38064:20;;37742:348;;;;:::o;38096:305::-;38136:3;38155:20;38173:1;38155:20;:::i;:::-;38150:25;;38189:20;38207:1;38189:20;:::i;:::-;38184:25;;38343:1;38275:66;38271:74;38268:1;38265:81;38262:107;;;38349:18;;:::i;:::-;38262:107;38393:1;38390;38386:9;38379:16;;38096:305;;;;:::o;38407:225::-;38547:34;38543:1;38535:6;38531:14;38524:58;38616:8;38611:2;38603:6;38599:15;38592:33;38407:225;:::o;38638:366::-;38780:3;38801:67;38865:2;38860:3;38801:67;:::i;:::-;38794:74;;38877:93;38966:3;38877:93;:::i;:::-;38995:2;38990:3;38986:12;38979:19;;38638:366;;;:::o;39010:419::-;39176:4;39214:2;39203:9;39199:18;39191:26;;39263:9;39257:4;39253:20;39249:1;39238:9;39234:17;39227:47;39291:131;39417:4;39291:131;:::i;:::-;39283:139;;39010:419;;;:::o;39435:180::-;39483:77;39480:1;39473:88;39580:4;39577:1;39570:15;39604:4;39601:1;39594:15;39621:185;39661:1;39678:20;39696:1;39678:20;:::i;:::-;39673:25;;39712:20;39730:1;39712:20;:::i;:::-;39707:25;;39751:1;39741:35;;39756:18;;:::i;:::-;39741:35;39798:1;39795;39791:9;39786:14;;39621:185;;;;:::o;39812:168::-;39952:20;39948:1;39940:6;39936:14;39929:44;39812:168;:::o;39986:366::-;40128:3;40149:67;40213:2;40208:3;40149:67;:::i;:::-;40142:74;;40225:93;40314:3;40225:93;:::i;:::-;40343:2;40338:3;40334:12;40327:19;;39986:366;;;:::o;40358:419::-;40524:4;40562:2;40551:9;40547:18;40539:26;;40611:9;40605:4;40601:20;40597:1;40586:9;40582:17;40575:47;40639:131;40765:4;40639:131;:::i;:::-;40631:139;;40358:419;;;:::o;40783:644::-;40980:4;41018:3;41007:9;41003:19;40995:27;;41032:71;41100:1;41089:9;41085:17;41076:6;41032:71;:::i;:::-;41113:72;41181:2;41170:9;41166:18;41157:6;41113:72;:::i;:::-;41195;41263:2;41252:9;41248:18;41239:6;41195:72;:::i;:::-;41314:9;41308:4;41304:20;41299:2;41288:9;41284:18;41277:48;41342:78;41415:4;41406:6;41342:78;:::i;:::-;41334:86;;40783:644;;;;;;;:::o;41433:170::-;41573:22;41569:1;41561:6;41557:14;41550:46;41433:170;:::o;41609:366::-;41751:3;41772:67;41836:2;41831:3;41772:67;:::i;:::-;41765:74;;41848:93;41937:3;41848:93;:::i;:::-;41966:2;41961:3;41957:12;41950:19;;41609:366;;;:::o;41981:419::-;42147:4;42185:2;42174:9;42170:18;42162:26;;42234:9;42228:4;42224:20;42220:1;42209:9;42205:17;42198:47;42262:131;42388:4;42262:131;:::i;:::-;42254:139;;41981:419;;;:::o;42406:170::-;42546:22;42542:1;42534:6;42530:14;42523:46;42406:170;:::o;42582:366::-;42724:3;42745:67;42809:2;42804:3;42745:67;:::i;:::-;42738:74;;42821:93;42910:3;42821:93;:::i;:::-;42939:2;42934:3;42930:12;42923:19;;42582:366;;;:::o;42954:419::-;43120:4;43158:2;43147:9;43143:18;43135:26;;43207:9;43201:4;43197:20;43193:1;43182:9;43178:17;43171:47;43235:131;43361:4;43235:131;:::i;:::-;43227:139;;42954:419;;;:::o","source":"// SPDX-License-Identifier: MIT\\npragma solidity >=0.4.22 <0.9.0;\\n\\nimport \\"./BaseContract.sol\\";\\nimport \\"./DataStorage3.sol\\";\\n\\ncontract Pixelflux3 is BaseContract, DataStorage3 {\\n    bool public isEnabled = false;\\n    BaseContract public baseContract1;\\n    BaseContract public baseContract2;\\n\\n    event ContractEnabled();\\n\\n    function isContractEnabled() public override view returns(bool) {\\n        return isEnabled;\\n    }\\n\\n    constructor(address _baseContractAddress1, address _baseContractAddress2) {\\n        baseContract1 = BaseContract(_baseContractAddress1);\\n        baseContract2 = BaseContract(_baseContractAddress2);\\n    }\\n\\n    function enableContract() public onlyOwner {\\n        uint256 totalValue1 = baseContract1.calculateTotalValue();\\n        uint256 totalValue2 = baseContract2.calculateTotalValue();\\n        require(totalValue1 >= 9000 * 10**9, \\"Not enough total value in Stage 1\\");\\n        require(totalValue2 >= 25000 * 10**9, \\"Not enough total value in Stage 2\\");\\n        isEnabled = true;\\n        \\n        emit ContractEnabled();\\n    }\\n\\n    function getInitialValue(uint x, uint y) internal override view returns (uint256, string memory) {\\n        require(x < gridWidth, \\"Invalid x-coordinate\\");\\n        require(y < gridHeight, \\"Invalid y-coordinate\\");\\n        return (initialValues[y][x], colorValues[y][x]);\\n    }\\n\\n    function getGridWidth() internal override pure returns (uint256) {\\n        return gridWidth;\\n    }\\n\\n    function getGridHeight() internal override pure returns (uint256) {\\n        return gridHeight;\\n    }\\n}\\n","sourcePath":"/home/wao/Meteor/Workspace/Sao/polygon/contracts/Pixelflux3.sol","ast":{"absolutePath":"project:/contracts/Pixelflux3.sol","exportedSymbols":{"BaseContract":[1001],"DataStorage3":[4802],"Pixelflux3":[5155]},"id":5156,"license":"MIT","nodeType":"SourceUnit","nodes":[{"id":5004,"literals":["solidity",">=","0.4",".22","<","0.9",".0"],"nodeType":"PragmaDirective","src":"32:32:6"},{"absolutePath":"project:/contracts/BaseContract.sol","file":"./BaseContract.sol","id":5005,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":5156,"sourceUnit":1002,"src":"66:28:6","symbolAliases":[],"unitAlias":""},{"absolutePath":"project:/contracts/DataStorage3.sol","file":"./DataStorage3.sol","id":5006,"nameLocation":"-1:-1:-1","nodeType":"ImportDirective","scope":5156,"sourceUnit":4803,"src":"95:28:6","symbolAliases":[],"unitAlias":""},{"abstract":false,"baseContracts":[{"baseName":{"id":5007,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"148:12:6"},"id":5008,"nodeType":"InheritanceSpecifier","src":"148:12:6"},{"baseName":{"id":5009,"name":"DataStorage3","nodeType":"IdentifierPath","referencedDeclaration":4802,"src":"162:12:6"},"id":5010,"nodeType":"InheritanceSpecifier","src":"162:12:6"}],"canonicalName":"Pixelflux3","contractDependencies":[],"contractKind":"contract","fullyImplemented":true,"id":5155,"linearizedBaseContracts":[5155,4802,1001],"name":"Pixelflux3","nameLocation":"134:10:6","nodeType":"ContractDefinition","nodes":[{"constant":false,"functionSelector":"6aa633b6","id":5013,"mutability":"mutable","name":"isEnabled","nameLocation":"193:9:6","nodeType":"VariableDeclaration","scope":5155,"src":"181:29:6","stateVariable":true,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":5011,"name":"bool","nodeType":"ElementaryTypeName","src":"181:4:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"value":{"hexValue":"66616c7365","id":5012,"isConstant":false,"isLValue":false,"isPure":true,"kind":"bool","lValueRequested":false,"nodeType":"Literal","src":"205:5:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"value":"false"},"visibility":"public"},{"constant":false,"functionSelector":"25247c01","id":5016,"mutability":"mutable","name":"baseContract1","nameLocation":"236:13:6","nodeType":"VariableDeclaration","scope":5155,"src":"216:33:6","stateVariable":true,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"},"typeName":{"id":5015,"nodeType":"UserDefinedTypeName","pathNode":{"id":5014,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"216:12:6"},"referencedDeclaration":1001,"src":"216:12:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"visibility":"public"},{"constant":false,"functionSelector":"7d63215c","id":5019,"mutability":"mutable","name":"baseContract2","nameLocation":"275:13:6","nodeType":"VariableDeclaration","scope":5155,"src":"255:33:6","stateVariable":true,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"},"typeName":{"id":5018,"nodeType":"UserDefinedTypeName","pathNode":{"id":5017,"name":"BaseContract","nodeType":"IdentifierPath","referencedDeclaration":1001,"src":"255:12:6"},"referencedDeclaration":1001,"src":"255:12:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"visibility":"public"},{"anonymous":false,"eventSelector":"961479333f7baab3eea2ead54f4113612e06058e0f3cdd932672aa14bcd831c2","id":5021,"name":"ContractEnabled","nameLocation":"301:15:6","nodeType":"EventDefinition","parameters":{"id":5020,"nodeType":"ParameterList","parameters":[],"src":"316:2:6"},"src":"295:24:6"},{"baseFunctions":[52],"body":{"id":5029,"nodeType":"Block","src":"389:33:6","statements":[{"expression":{"id":5027,"name":"isEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5013,"src":"406:9:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"functionReturnParameters":5026,"id":5028,"nodeType":"Return","src":"399:16:6"}]},"functionSelector":"9d602d2d","id":5030,"implemented":true,"kind":"function","modifiers":[],"name":"isContractEnabled","nameLocation":"334:17:6","nodeType":"FunctionDefinition","overrides":{"id":5023,"nodeType":"OverrideSpecifier","overrides":[],"src":"361:8:6"},"parameters":{"id":5022,"nodeType":"ParameterList","parameters":[],"src":"351:2:6"},"returnParameters":{"id":5026,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5025,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5030,"src":"383:4:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":5024,"name":"bool","nodeType":"ElementaryTypeName","src":"383:4:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"visibility":"internal"}],"src":"382:6:6"},"scope":5155,"src":"325:97:6","stateMutability":"view","virtual":false,"visibility":"public"},{"body":{"id":5049,"nodeType":"Block","src":"502:129:6","statements":[{"expression":{"id":5041,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"id":5037,"name":"baseContract1","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5016,"src":"512:13:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"arguments":[{"id":5039,"name":"_baseContractAddress1","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5032,"src":"541:21:6","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_address","typeString":"address"}],"id":5038,"name":"BaseContract","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1001,"src":"528:12:6","typeDescriptions":{"typeIdentifier":"t_type$_t_contract$_BaseContract_$1001_$","typeString":"type(contract BaseContract)"}},"id":5040,"isConstant":false,"isLValue":false,"isPure":false,"kind":"typeConversion","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"528:35:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"src":"512:51:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":5042,"nodeType":"ExpressionStatement","src":"512:51:6"},{"expression":{"id":5047,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"id":5043,"name":"baseContract2","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5019,"src":"573:13:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"arguments":[{"id":5045,"name":"_baseContractAddress2","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5034,"src":"602:21:6","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_address","typeString":"address"}],"id":5044,"name":"BaseContract","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":1001,"src":"589:12:6","typeDescriptions":{"typeIdentifier":"t_type$_t_contract$_BaseContract_$1001_$","typeString":"type(contract BaseContract)"}},"id":5046,"isConstant":false,"isLValue":false,"isPure":false,"kind":"typeConversion","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"589:35:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"src":"573:51:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":5048,"nodeType":"ExpressionStatement","src":"573:51:6"}]},"id":5050,"implemented":true,"kind":"constructor","modifiers":[],"name":"","nameLocation":"-1:-1:-1","nodeType":"FunctionDefinition","parameters":{"id":5035,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5032,"mutability":"mutable","name":"_baseContractAddress1","nameLocation":"448:21:6","nodeType":"VariableDeclaration","scope":5050,"src":"440:29:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"},"typeName":{"id":5031,"name":"address","nodeType":"ElementaryTypeName","src":"440:7:6","stateMutability":"nonpayable","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},"visibility":"internal"},{"constant":false,"id":5034,"mutability":"mutable","name":"_baseContractAddress2","nameLocation":"479:21:6","nodeType":"VariableDeclaration","scope":5050,"src":"471:29:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"},"typeName":{"id":5033,"name":"address","nodeType":"ElementaryTypeName","src":"471:7:6","stateMutability":"nonpayable","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},"visibility":"internal"}],"src":"439:62:6"},"returnParameters":{"id":5036,"nodeType":"ParameterList","parameters":[],"src":"502:0:6"},"scope":5155,"src":"428:203:6","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"body":{"id":5096,"nodeType":"Block","src":"680:375:6","statements":[{"assignments":[5056],"declarations":[{"constant":false,"id":5056,"mutability":"mutable","name":"totalValue1","nameLocation":"698:11:6","nodeType":"VariableDeclaration","scope":5096,"src":"690:19:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5055,"name":"uint256","nodeType":"ElementaryTypeName","src":"690:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"id":5060,"initialValue":{"arguments":[],"expression":{"argumentTypes":[],"expression":{"id":5057,"name":"baseContract1","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5016,"src":"712:13:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":5058,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"memberName":"calculateTotalValue","nodeType":"MemberAccess","referencedDeclaration":572,"src":"712:33:6","typeDescriptions":{"typeIdentifier":"t_function_external_view$__$returns$_t_uint256_$","typeString":"function () view external returns (uint256)"}},"id":5059,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"712:35:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"VariableDeclarationStatement","src":"690:57:6"},{"assignments":[5062],"declarations":[{"constant":false,"id":5062,"mutability":"mutable","name":"totalValue2","nameLocation":"765:11:6","nodeType":"VariableDeclaration","scope":5096,"src":"757:19:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5061,"name":"uint256","nodeType":"ElementaryTypeName","src":"757:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"id":5066,"initialValue":{"arguments":[],"expression":{"argumentTypes":[],"expression":{"id":5063,"name":"baseContract2","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5019,"src":"779:13:6","typeDescriptions":{"typeIdentifier":"t_contract$_BaseContract_$1001","typeString":"contract BaseContract"}},"id":5064,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"memberName":"calculateTotalValue","nodeType":"MemberAccess","referencedDeclaration":572,"src":"779:33:6","typeDescriptions":{"typeIdentifier":"t_function_external_view$__$returns$_t_uint256_$","typeString":"function () view external returns (uint256)"}},"id":5065,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"779:35:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"VariableDeclarationStatement","src":"757:57:6"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":5074,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":5068,"name":"totalValue1","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5056,"src":"832:11:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":">=","rightExpression":{"commonType":{"typeIdentifier":"t_rational_9000000000000_by_1","typeString":"int_const 9000000000000"},"id":5073,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"39303030","id":5069,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"847:4:6","typeDescriptions":{"typeIdentifier":"t_rational_9000_by_1","typeString":"int_const 9000"},"value":"9000"},"nodeType":"BinaryOperation","operator":"*","rightExpression":{"commonType":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"},"id":5072,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"3130","id":5070,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"854:2:6","typeDescriptions":{"typeIdentifier":"t_rational_10_by_1","typeString":"int_const 10"},"value":"10"},"nodeType":"BinaryOperation","operator":"**","rightExpression":{"hexValue":"39","id":5071,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"858:1:6","typeDescriptions":{"typeIdentifier":"t_rational_9_by_1","typeString":"int_const 9"},"value":"9"},"src":"854:5:6","typeDescriptions":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"}},"src":"847:12:6","typeDescriptions":{"typeIdentifier":"t_rational_9000000000000_by_1","typeString":"int_const 9000000000000"}},"src":"832:27:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e2053746167652031","id":5075,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"861:35:6","typeDescriptions":{"typeIdentifier":"t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","typeString":"literal_string \\"Not enough total value in Stage 1\\""},"value":"Not enough total value in Stage 1"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_16cd1976b42f68813986f4cc271fa5415dadb99fcd5967be2f5793046eebec50","typeString":"literal_string \\"Not enough total value in Stage 1\\""}],"id":5067,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"824:7:6","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":5076,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"824:73:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":5077,"nodeType":"ExpressionStatement","src":"824:73:6"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":5085,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":5079,"name":"totalValue2","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5062,"src":"915:11:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":">=","rightExpression":{"commonType":{"typeIdentifier":"t_rational_25000000000000_by_1","typeString":"int_const 25000000000000"},"id":5084,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"3235303030","id":5080,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"930:5:6","typeDescriptions":{"typeIdentifier":"t_rational_25000_by_1","typeString":"int_const 25000"},"value":"25000"},"nodeType":"BinaryOperation","operator":"*","rightExpression":{"commonType":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"},"id":5083,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"leftExpression":{"hexValue":"3130","id":5081,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"938:2:6","typeDescriptions":{"typeIdentifier":"t_rational_10_by_1","typeString":"int_const 10"},"value":"10"},"nodeType":"BinaryOperation","operator":"**","rightExpression":{"hexValue":"39","id":5082,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"942:1:6","typeDescriptions":{"typeIdentifier":"t_rational_9_by_1","typeString":"int_const 9"},"value":"9"},"src":"938:5:6","typeDescriptions":{"typeIdentifier":"t_rational_1000000000_by_1","typeString":"int_const 1000000000"}},"src":"930:13:6","typeDescriptions":{"typeIdentifier":"t_rational_25000000000000_by_1","typeString":"int_const 25000000000000"}},"src":"915:28:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"4e6f7420656e6f75676820746f74616c2076616c756520696e2053746167652032","id":5086,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"945:35:6","typeDescriptions":{"typeIdentifier":"t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b","typeString":"literal_string \\"Not enough total value in Stage 2\\""},"value":"Not enough total value in Stage 2"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_1f11d65fba2a1475e0765683c638121c3a99b79891c4e63e13734daa549cf56b","typeString":"literal_string \\"Not enough total value in Stage 2\\""}],"id":5078,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"907:7:6","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":5087,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"907:74:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":5088,"nodeType":"ExpressionStatement","src":"907:74:6"},{"expression":{"id":5091,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"id":5089,"name":"isEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5013,"src":"991:9:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"hexValue":"74727565","id":5090,"isConstant":false,"isLValue":false,"isPure":true,"kind":"bool","lValueRequested":false,"nodeType":"Literal","src":"1003:4:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"value":"true"},"src":"991:16:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"id":5092,"nodeType":"ExpressionStatement","src":"991:16:6"},{"eventCall":{"arguments":[],"expression":{"argumentTypes":[],"id":5093,"name":"ContractEnabled","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5021,"src":"1031:15:6","typeDescriptions":{"typeIdentifier":"t_function_event_nonpayable$__$returns$__$","typeString":"function ()"}},"id":5094,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"1031:17:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":5095,"nodeType":"EmitStatement","src":"1026:22:6"}]},"functionSelector":"367edd32","id":5097,"implemented":true,"kind":"function","modifiers":[{"id":5053,"kind":"modifierInvocation","modifierName":{"id":5052,"name":"onlyOwner","nodeType":"IdentifierPath","referencedDeclaration":95,"src":"670:9:6"},"nodeType":"ModifierInvocation","src":"670:9:6"}],"name":"enableContract","nameLocation":"646:14:6","nodeType":"FunctionDefinition","parameters":{"id":5051,"nodeType":"ParameterList","parameters":[],"src":"660:2:6"},"returnParameters":{"id":5054,"nodeType":"ParameterList","parameters":[],"src":"680:0:6"},"scope":5155,"src":"637:418:6","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"baseFunctions":[63],"body":{"id":5135,"nodeType":"Block","src":"1158:177:6","statements":[{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":5112,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":5110,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5099,"src":"1176:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":5111,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3540,"src":"1180:9:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"1176:13:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420782d636f6f7264696e617465","id":5113,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"1191:22:6","typeDescriptions":{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""},"value":"Invalid x-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_39236833f0316578a84fba08672edb571b28cf4e8033efcaf5040bec0344830a","typeString":"literal_string \\"Invalid x-coordinate\\""}],"id":5109,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"1168:7:6","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":5114,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"1168:46:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":5115,"nodeType":"ExpressionStatement","src":"1168:46:6"},{"expression":{"arguments":[{"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":5119,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"id":5117,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5101,"src":"1232:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"<","rightExpression":{"id":5118,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3543,"src":"1236:10:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"src":"1232:14:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},{"hexValue":"496e76616c696420792d636f6f7264696e617465","id":5120,"isConstant":false,"isLValue":false,"isPure":true,"kind":"string","lValueRequested":false,"nodeType":"Literal","src":"1248:22:6","typeDescriptions":{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""},"value":"Invalid y-coordinate"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bool","typeString":"bool"},{"typeIdentifier":"t_stringliteral_6f8f2e05fd603c02dc5aa8ae6695cbe7036d500161df65cd6f8958f5f63a4b72","typeString":"literal_string \\"Invalid y-coordinate\\""}],"id":5116,"name":"require","nodeType":"Identifier","overloadedDeclarations":[4294967278,4294967278],"referencedDeclaration":4294967278,"src":"1224:7:6","typeDescriptions":{"typeIdentifier":"t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$","typeString":"function (bool,string memory) pure"}},"id":5121,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"1224:47:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_tuple$__$","typeString":"tuple()"}},"id":5122,"nodeType":"ExpressionStatement","src":"1224:47:6"},{"expression":{"components":[{"baseExpression":{"baseExpression":{"id":5123,"name":"initialValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3549,"src":"1289:13:6","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_uint256_$33_storage_$33_storage","typeString":"uint256[33] storage ref[33] storage ref"}},"id":5125,"indexExpression":{"id":5124,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5101,"src":"1303:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1289:16:6","typeDescriptions":{"typeIdentifier":"t_array$_t_uint256_$33_storage","typeString":"uint256[33] storage ref"}},"id":5127,"indexExpression":{"id":5126,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5099,"src":"1306:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1289:19:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},{"baseExpression":{"baseExpression":{"id":5128,"name":"colorValues","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":4801,"src":"1310:11:6","typeDescriptions":{"typeIdentifier":"t_array$_t_array$_t_string_storage_$33_storage_$33_storage","typeString":"string storage ref[33] storage ref[33] storage ref"}},"id":5130,"indexExpression":{"id":5129,"name":"y","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5101,"src":"1322:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1310:14:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$33_storage","typeString":"string storage ref[33] storage ref"}},"id":5132,"indexExpression":{"id":5131,"name":"x","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":5099,"src":"1325:1:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"nodeType":"IndexAccess","src":"1310:17:6","typeDescriptions":{"typeIdentifier":"t_string_storage","typeString":"string storage ref"}}],"id":5133,"isConstant":false,"isInlineArray":false,"isLValue":false,"isPure":false,"lValueRequested":false,"nodeType":"TupleExpression","src":"1288:40:6","typeDescriptions":{"typeIdentifier":"t_tuple$_t_uint256_$_t_string_storage_$","typeString":"tuple(uint256,string storage ref)"}},"functionReturnParameters":5108,"id":5134,"nodeType":"Return","src":"1281:47:6"}]},"id":5136,"implemented":true,"kind":"function","modifiers":[],"name":"getInitialValue","nameLocation":"1070:15:6","nodeType":"FunctionDefinition","overrides":{"id":5103,"nodeType":"OverrideSpecifier","overrides":[],"src":"1111:8:6"},"parameters":{"id":5102,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5099,"mutability":"mutable","name":"x","nameLocation":"1091:1:6","nodeType":"VariableDeclaration","scope":5136,"src":"1086:6:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5098,"name":"uint","nodeType":"ElementaryTypeName","src":"1086:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":5101,"mutability":"mutable","name":"y","nameLocation":"1099:1:6","nodeType":"VariableDeclaration","scope":5136,"src":"1094:6:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5100,"name":"uint","nodeType":"ElementaryTypeName","src":"1094:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"1085:16:6"},"returnParameters":{"id":5108,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5105,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5136,"src":"1134:7:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5104,"name":"uint256","nodeType":"ElementaryTypeName","src":"1134:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"},{"constant":false,"id":5107,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5136,"src":"1143:13:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string"},"typeName":{"id":5106,"name":"string","nodeType":"ElementaryTypeName","src":"1143:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"visibility":"internal"}],"src":"1133:24:6"},"scope":5155,"src":"1061:274:6","stateMutability":"view","virtual":false,"visibility":"internal"},{"baseFunctions":[68],"body":{"id":5144,"nodeType":"Block","src":"1406:33:6","statements":[{"expression":{"id":5142,"name":"gridWidth","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3540,"src":"1423:9:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":5141,"id":5143,"nodeType":"Return","src":"1416:16:6"}]},"id":5145,"implemented":true,"kind":"function","modifiers":[],"name":"getGridWidth","nameLocation":"1350:12:6","nodeType":"FunctionDefinition","overrides":{"id":5138,"nodeType":"OverrideSpecifier","overrides":[],"src":"1374:8:6"},"parameters":{"id":5137,"nodeType":"ParameterList","parameters":[],"src":"1362:2:6"},"returnParameters":{"id":5141,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5140,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5145,"src":"1397:7:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5139,"name":"uint256","nodeType":"ElementaryTypeName","src":"1397:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"1396:9:6"},"scope":5155,"src":"1341:98:6","stateMutability":"pure","virtual":false,"visibility":"internal"},{"baseFunctions":[73],"body":{"id":5153,"nodeType":"Block","src":"1511:34:6","statements":[{"expression":{"id":5151,"name":"gridHeight","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":3543,"src":"1528:10:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"functionReturnParameters":5150,"id":5152,"nodeType":"Return","src":"1521:17:6"}]},"id":5154,"implemented":true,"kind":"function","modifiers":[],"name":"getGridHeight","nameLocation":"1454:13:6","nodeType":"FunctionDefinition","overrides":{"id":5147,"nodeType":"OverrideSpecifier","overrides":[],"src":"1479:8:6"},"parameters":{"id":5146,"nodeType":"ParameterList","parameters":[],"src":"1467:2:6"},"returnParameters":{"id":5150,"nodeType":"ParameterList","parameters":[{"constant":false,"id":5149,"mutability":"mutable","name":"","nameLocation":"-1:-1:-1","nodeType":"VariableDeclaration","scope":5154,"src":"1502:7:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":5148,"name":"uint256","nodeType":"ElementaryTypeName","src":"1502:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"visibility":"internal"}],"src":"1501:9:6"},"scope":5155,"src":"1445:100:6","stateMutability":"pure","virtual":false,"visibility":"internal"}],"scope":5156,"src":"125:1422:6","usedErrors":[]}],"src":"32:1516:6"},"compiler":{"name":"solc","version":"0.8.13+commit.abaa5c0e.Emscripten.clang"},"networks":{"137":{"events":{"0x961479333f7baab3eea2ead54f4113612e06058e0f3cdd932672aa14bcd831c2":{"anonymous":false,"inputs":[],"name":"ContractEnabled","type":"event"},"0xe658510eab96e65991bb68ee771137bf387eaa3dc4a16189ea0f525766e76b2a":{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"x","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"y","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numLayers","type":"uint256"},{"indexed":false,"internalType":"string","name":"color","type":"string"}],"name":"LayerPurchased","type":"event"}},"links":{},"address":"0x065cFc82218186e7113c476C23F201227639f2C4","transactionHash":"0xa3e5075b3f61d259867d521279b05b3a724b439db03a23dbe228b50f4638ebea"},"5777":{"events":{"0x74835083a92d7d0acad57e178b18330365b1b26c97ea060802582e61f95b54d2":{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"width","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"height","type":"uint256"}],"name":"LogGridDimensions","type":"event"}},"links":{},"address":"0xA2a4Bd2Bf5E9810bE57EEee09B9bfc8375ef3F11","transactionHash":"0xcfffa343d718b67354ea5a4da93c313268f52a26ad710366c0e5c8edd9b4088a"}},"schemaVersion":"3.4.13","updatedAt":"2023-09-30T04:41:41.298Z","networkType":"ethereum","devdoc":{"kind":"dev","methods":{},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}}');



(parcelRequire("8vghX")).config();
const $6deeaebb6b882581$export$7dd38ebc09442f7b = ()=>{
    if (!window.ethereum) {
        console.error("MetaMask or a similar wallet provider is required.");
        return null;
    }
    return new (0, $d5687dfa6bc29fec$export$8d50d0931f78dec8)(window.ethereum);
};
const $6deeaebb6b882581$var$getInfuraProvider = ()=>{
    const infuraUrl = `https://polygon-mainnet.infura.io/v3/${"6bf2f93bed234e55a182167c7da7835e"}`;
    return new (0, $80daf019a5520af5$export$da28308012bf6748)(infuraUrl);
};
const $6deeaebb6b882581$export$1bb129efd98f6f31 = ()=>{
    const ankrUrl = `https://rpc.ankr.com/polygon/${"82a07ea383e66b04ee22afc48cf92d1a871e83d4c8cc95276841cc2faca13d08"}`;
    return new (0, $80daf019a5520af5$export$da28308012bf6748)(ankrUrl);
};
const $6deeaebb6b882581$export$a8620f89e8a22f4 = ()=>{
    const quikUrl = `wss://icy-lively-wildflower.matic.discover.quiknode.pro/${"ede586f9a41e6c36428b055bbbde074deb3e522e"}/`;
    console.log("Creating WebSocketProvider with URL:", quikUrl);
    return new (0, $a4b2d0e19089cb78$export$bfafe629242f30bd)(quikUrl);
};
const $6deeaebb6b882581$export$57632def5536cb24 = async ()=>{
    let provider = $6deeaebb6b882581$export$7dd38ebc09442f7b();
    provider = $6deeaebb6b882581$var$getInfuraProvider();
    if (provider) try {
        await provider.getNetwork();
        return provider;
    } catch (error) {
        console.error("InfuraProvider not supported:", error);
    }
    provider = $6deeaebb6b882581$export$1bb129efd98f6f31();
    if (provider) try {
        await provider.getNetwork();
        return provider;
    } catch (error) {
        console.error("AnkrProvider not supported:", error);
    }
    return null;
};
const $6deeaebb6b882581$export$37dfb5da6ccd2bd = [
    (0, (/*@__PURE__*/$parcel$interopDefault($c791a81b37c8c0da$exports))).abi,
    (0, (/*@__PURE__*/$parcel$interopDefault($7b13ea3ecd89623e$exports))).abi,
    (0, (/*@__PURE__*/$parcel$interopDefault($bcf0a78d52f6143d$exports))).abi
];



var $764f9992fc55bca0$exports = {};
$764f9992fc55bca0$exports = JSON.parse('{"polygon":{"Pixelflux":["0xf8561640FA9E7EE295D9B6C4DD59FD9826374d6b","0x538D71D91a9301c0231fFC643fAdB829d15B06Bd","0x065cFc82218186e7113c476C23F201227639f2C4"]}}');


const $3f60ff68fab9c0db$export$f7dc72e91f29c7d7 = (message)=>{
    const notificationModal = document.getElementById("notification-modal");
    const notificationMessage = document.getElementById("notification-message");
    if (notificationModal && notificationMessage) {
        notificationMessage.textContent = message;
        notificationModal.style.display = "block";
    }
};
const $3f60ff68fab9c0db$export$87f1090575f0067e = ()=>{
    const notificationModal = document.getElementById("notification-modal");
    if (notificationModal) notificationModal.style.display = "none";
};




const $6130628d7489df3b$var$BASE_GAS = 500000;
const $6130628d7489df3b$var$GAS_PER_EXISTING_LAYER = 20000;
const $6130628d7489df3b$var$GAS_PER_NEW_LAYER = 15000;
const $6130628d7489df3b$var$BUFFER_MULTIPLIER = 1.20;
const $6130628d7489df3b$export$73acce2ca81cd7df = (numLayersToAdd)=>{
    const currentLayersCount = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareLayers.length;
    const baseValueInWei = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))((0, $b25678c505cad7eb$export$52fb33e3b26411c)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareValue));
    const sumOfSeries = new (0, (/*@__PURE__*/$parcel$interopDefault($42f5864281cc433e$exports)))(numLayersToAdd).multipliedBy(2 * currentLayersCount + numLayersToAdd - 1).dividedBy(2);
    const refundAmount = baseValueInWei.multipliedBy(numLayersToAdd * (numLayersToAdd - 1)).dividedBy(2);
    return baseValueInWei.multipliedBy(sumOfSeries).minus(refundAmount);
};
const $6130628d7489df3b$var$estimateGas = (numLayersToAdd)=>{
    const currentLayersCount = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareLayers.length;
    return Math.ceil(($6130628d7489df3b$var$BASE_GAS + $6130628d7489df3b$var$GAS_PER_EXISTING_LAYER * currentLayersCount + $6130628d7489df3b$var$GAS_PER_NEW_LAYER * numLayersToAdd) * $6130628d7489df3b$var$BUFFER_MULTIPLIER);
};
const $6130628d7489df3b$var$buyLayers = async (provider, userAddress, contractAddress, x, y, numLayersToAdd, color, stage)=>{
    try {
        const signer = await provider.getSigner(userAddress);
        const contract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(contractAddress, (0, $6deeaebb6b882581$export$37dfb5da6ccd2bd)[stage], signer);
        const totalValueToSend = $6130628d7489df3b$export$73acce2ca81cd7df(numLayersToAdd);
        let gasEstimation;
        try {
            gasEstimation = await contract.buyMultipleLayers.estimateGas(x, y, numLayersToAdd, color, {
                value: totalValueToSend.toString()
            });
        } catch (error) {
            console.log("could not estimate gas", error);
        }
        if (!gasEstimation) gasEstimation = $6130628d7489df3b$var$estimateGas(numLayersToAdd);
        if (numLayersToAdd === 1) await contract.buyLayer(x, y, color, {
            value: totalValueToSend.toString(),
            gasLimit: gasEstimation,
            gas: gasEstimation
        });
        else await contract.buyMultipleLayers(x, y, numLayersToAdd, color, {
            value: totalValueToSend.toString(),
            gasLimit: gasEstimation,
            gas: gasEstimation
        });
    } catch (error) {
        if (error.info && error.info.error && error.info.error.code === 4001) console.log("User cancelled the transaction.");
        else console.error("Contract interaction error:", error);
    }
};
const $6130628d7489df3b$export$3ae1631d8cfdd256 = async ()=>{
    const provider = (0, $6deeaebb6b882581$export$7dd38ebc09442f7b)();
    let userAddress = "";
    if (typeof window.ethereum !== "undefined") {
        const accounts = await window.ethereum.request({
            method: "eth_accounts"
        });
        if (accounts.length > 0) userAddress = accounts[0];
    }
    if (!userAddress) {
        (0, $3f60ff68fab9c0db$export$f7dc72e91f29c7d7)("No user address found. Please connect to a wallet.");
        return;
    }
    const contractAddress = (0, (/*@__PURE__*/$parcel$interopDefault($764f9992fc55bca0$exports))).polygon.Pixelflux[(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.stage];
    const layerSlider = document.getElementById("layer-slider");
    const numLayersToAdd = parseInt(layerSlider.value);
    const color = typeof (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill === "string" ? (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill : "";
    const x = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridX;
    const y = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridY;
    const stage = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.stage;
    $6130628d7489df3b$var$buyLayers(provider, userAddress, contractAddress, x, y, numLayersToAdd, color, stage);
};


const $ea628fd0157746c4$export$b417d3d391131840 = ()=>{
    const layerSlider = document.getElementById("layer-slider");
    const sliderValue = document.getElementById("slider-value");
    const purchaseLayerButton = document.getElementById("purchase-button");
    sliderValue.textContent = layerSlider.value;
    purchaseLayerButton.disabled = layerSlider.value === "0";
    purchaseLayerButton.textContent = parseInt(layerSlider.value) <= 1 ? "Buy Layer" : "Buy Layers";
    (0, $729ea772109e18d1$export$e86f0fa91534afd1)();
    $ea628fd0157746c4$var$updateTotalValueDisplay();
};
const $ea628fd0157746c4$var$updateTotalValueDisplay = ()=>{
    const layerSlider = document.getElementById("layer-slider");
    const numLayersToAdd = parseInt(layerSlider.value);
    const totalValue = (0, $b25678c505cad7eb$export$462d8f843f9309b)((0, $6130628d7489df3b$export$73acce2ca81cd7df)(numLayersToAdd));
    const totalValueElement = document.querySelector("#current-cost");
    totalValueElement.innerText = `${totalValue} Matic`;
};
const $ea628fd0157746c4$export$df59ff80389de45e = ()=>{
    const layerSlider = document.getElementById("layer-slider");
    const sliderValue = document.getElementById("slider-value");
    const decreaseBtn = document.getElementById("decrease-btn");
    const increaseBtn = document.getElementById("increase-btn");
    const maxSliderValue = parseInt(layerSlider.max);
    const minSliderValue = parseInt(layerSlider.min);
    if (decreaseBtn) decreaseBtn.addEventListener("click", function() {
        let currentValue = parseInt(layerSlider.value);
        if (currentValue > minSliderValue) {
            layerSlider.value = (currentValue - 1).toString();
            if (layerSlider.value === "0" && (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill !== (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill) (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill;
            $ea628fd0157746c4$export$b417d3d391131840();
        }
    });
    if (increaseBtn) increaseBtn.addEventListener("click", function() {
        let currentValue = parseInt(layerSlider.value);
        if (currentValue < maxSliderValue) {
            layerSlider.value = (currentValue + 1).toString();
            $ea628fd0157746c4$export$b417d3d391131840();
        }
    });
    if (layerSlider && sliderValue) layerSlider.addEventListener("input", function() {
        $ea628fd0157746c4$export$b417d3d391131840();
    });
};
const $ea628fd0157746c4$export$14816fc4ad80748c = (canvas, color, isPicker, pickerIndex)=>{
    const colorOptionsContainer = document.getElementById("color-options");
    if (isPicker && typeof pickerIndex !== "undefined") {
        const element = document.createElement("input");
        element.type = "color";
        element.value = (0, $b25678c505cad7eb$export$d6ac4b4f164d4064)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).colorPicker[pickerIndex]);
        const handleEvent = (event)=>{
            if (event.type === "input" || event.type === "change") (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).colorPicker[pickerIndex] = element.value;
            $ea628fd0157746c4$var$setColorAndUpdateSidebar(canvas, element.value);
        };
        element.addEventListener("click", handleEvent);
        element.addEventListener("change", handleEvent);
        colorOptionsContainer.appendChild(element);
    } else if (!isPicker) {
        const element = document.createElement("div");
        element.classList.add("color-option");
        element.style.backgroundColor = color;
        element.addEventListener("click", function() {
            $ea628fd0157746c4$var$setColorAndUpdateSidebar(canvas, color);
        });
        colorOptionsContainer.appendChild(element);
    }
};
const $ea628fd0157746c4$var$setColorAndUpdateSidebar = (canvas, color)=>{
    if ((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare !== null) {
        (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.set("fill", color);
        (0, $729ea772109e18d1$export$e86f0fa91534afd1)();
        canvas.renderAll();
    }
};
const $ea628fd0157746c4$export$5d86846761fd15df = (canvas)=>{
    const colorOptionsContainer = document.getElementById("color-options");
    colorOptionsContainer.innerHTML = "";
    if ((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare) $ea628fd0157746c4$export$14816fc4ad80748c(canvas, (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill ? (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill : "#000");
    (0, (/*@__PURE__*/$parcel$interopDefault($d68fe5b824f21b3a$exports))).forEach(function(color) {
        $ea628fd0157746c4$export$14816fc4ad80748c(canvas, color);
    });
    $ea628fd0157746c4$export$14816fc4ad80748c(canvas, "", true, 0);
    $ea628fd0157746c4$export$14816fc4ad80748c(canvas, "", true, 1);
};


let $729ea772109e18d1$var$currentPage = 1;
const $729ea772109e18d1$export$6b9419ea3588c2ce = (show)=>{
    const element = document.querySelector(".square-content");
    if (element) element.style.display = show ? "flex" : "none";
};
const $729ea772109e18d1$export$e86f0fa91534afd1 = ()=>{
    const pixelCard = document.querySelector(".pixel-card");
    const pixelDisplayContainer = pixelCard.querySelector(".pixel-display-container");
    const pixelCurrent = pixelCard.querySelector(".pixel-current");
    const pixelPreview = pixelCard.querySelector(".pixel-preview");
    const pixelPropertiesElement = pixelCard.querySelector(".pixel-properties");
    const layerSlider = document.getElementById("layer-slider");
    const arrowSpan = pixelCard.querySelector(".pixel-display-container > span");
    const currentLayerNumber = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareLayers.length;
    if (pixelPreview && typeof (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill === "string") pixelPreview.style.backgroundColor = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill ? (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill : "#000";
    if (pixelCurrent && typeof (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill === "string") pixelCurrent.style.backgroundColor = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill ? (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill : "#000";
    const currentValue = (0, $b25678c505cad7eb$export$b416d5a4e0e94cd)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareValue * currentLayerNumber);
    let layerValue = parseInt(layerSlider.value);
    if (layerValue > 0 || (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.fill !== (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill) {
        if (layerValue === 0) {
            const layerSlider = document.getElementById("layer-slider");
            layerSlider.value = "1";
            (0, $ea628fd0157746c4$export$b417d3d391131840)();
            layerValue = 1;
        }
        pixelDisplayContainer.style.display = "flex";
        pixelPreview.style.display = "block";
        arrowSpan.style.display = "inline-block";
        const newLayerNumber = currentLayerNumber + layerValue;
        const newValue = (0, $b25678c505cad7eb$export$b416d5a4e0e94cd)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareValue * (currentLayerNumber + layerValue));
        pixelPropertiesElement.innerHTML = `
      <p>L ${currentLayerNumber - 1} ->  <span class="new-value">L ${newLayerNumber - 1}</span</p>
      <br/>
      <p>${currentValue} Matic</p>
      <p>&#x2B07;</p>
      <p class="new-value">${newValue} Matic</p>
      <br/>
      <p>x: ${(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridX}, y: ${(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridY + (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.yOffset}</p>
      `;
    } else {
        arrowSpan.style.display = "none";
        pixelDisplayContainer.style.display = "flex";
        pixelPreview.style.display = "none";
        pixelPropertiesElement.innerHTML = `
      <p>L ${currentLayerNumber - 1}</p>
      <p>${currentValue} Matic</p>
      <p>x: ${(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridX}, y: ${(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridY + (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.yOffset}</p>
      `;
    }
    const colorPickers = document.querySelectorAll('input[type="color"]');
    if (colorPickers && colorPickers.length >= 2) {
        colorPickers[0].value = (0, $b25678c505cad7eb$export$d6ac4b4f164d4064)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).colorPicker[0]);
        colorPickers[1].value = (0, $b25678c505cad7eb$export$d6ac4b4f164d4064)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).colorPicker[1]);
    }
};
let $729ea772109e18d1$var$isCloseButtonEventAdded = false;
const $729ea772109e18d1$var$handleModalDisplay = ()=>{
    const sidebar = document.getElementById("sidebar");
    const closeButton = sidebar.querySelector("#close-modal");
    if (closeButton && !$729ea772109e18d1$var$isCloseButtonEventAdded) {
        closeButton.addEventListener("click", ()=>{
            sidebar.style.display = "none";
        });
        $729ea772109e18d1$var$isCloseButtonEventAdded = true;
    }
    const useModal = ()=>window.innerWidth <= 520;
    if (useModal()) {
        if (!sidebar.classList.contains("modal-content")) sidebar.classList.add("modal-content");
    } else if (sidebar.classList.contains("modal-content")) sidebar.classList.remove("modal-content");
};
window.addEventListener("resize", ()=>{
    const sidebar = document.getElementById("sidebar");
    if (window.innerWidth <= 520 && !sidebar.classList.contains("modal-content")) sidebar.style.display = "none";
    else if (window.innerWidth >= 520 && sidebar.classList.contains("modal-content")) sidebar.style.display = "block";
    $729ea772109e18d1$var$handleModalDisplay();
});
const $729ea772109e18d1$export$3b6a950eac59b37b = (canvas)=>{
    $729ea772109e18d1$export$6b9419ea3588c2ce(true);
    const layerSlider = document.getElementById("layer-slider");
    layerSlider.value = "0";
    (0, $ea628fd0157746c4$export$b417d3d391131840)();
    $729ea772109e18d1$export$e86f0fa91534afd1();
    $729ea772109e18d1$var$currentPage = 1;
    (0, $a7e5cc371a81d091$export$a104c684a09de9be)($729ea772109e18d1$var$currentPage);
    (0, $ea628fd0157746c4$export$5d86846761fd15df)(canvas);
    $729ea772109e18d1$var$handleModalDisplay();
    const sidebar = document.getElementById("sidebar");
    sidebar.style.display = "block";
};








const $e24c02b8466da3c0$export$1a8a2ed04f3f885c = async ()=>{
    if (typeof window.ethereum !== "undefined" && window.ethereum.isConnected()) return await window.ethereum.request({
        method: "eth_accounts"
    });
    return [];
};
const $e24c02b8466da3c0$export$ea813f19c3e0b982 = async ()=>{
    const provider = await (0, $6deeaebb6b882581$export$57632def5536cb24)();
    if (!provider) throw new Error("Failed to get a provider.");
    const wssProvider = (0, $6deeaebb6b882581$export$a8620f89e8a22f4)();
    const stages = [];
    const totalValues = [];
    const loading = document.getElementById("loading");
    const progressBar = document.getElementById("progress-bar");
    const progressFill = progressBar.querySelector(".progress-fill");
    const loadingText = document.getElementById("loading-text");
    loading.style.display = "block";
    const contractAddresses = (0, (/*@__PURE__*/$parcel$interopDefault($764f9992fc55bca0$exports))).polygon.Pixelflux;
    for (const [index, address] of contractAddresses.entries()){
        const jsonContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(address, (0, $6deeaebb6b882581$export$37dfb5da6ccd2bd)[index], provider);
        const wssContract = new (0, $0e40c93799a724b3$export$8517d80acf00e19a)(address, (0, $6deeaebb6b882581$export$37dfb5da6ccd2bd)[index], wssProvider);
        wssContract.on("LayerPurchased", async (buyer, x, y, numLayers, color)=>{
            const updatedTotalValue = await jsonContract.calculateTotalValue();
            totalValues[index] = updatedTotalValue;
            (0, $545c6c66f40f4e90$export$29974350ada22cc)(buyer, Number(x), Number(y), Number(numLayers), color, index, totalValues);
        });
        if (index !== 0) try {
            wssContract.on("ContractEnabled", ()=>{
                (0, $545c6c66f40f4e90$export$215bb1a35ab734b)();
            });
        } catch (error) {
            console.log("contract on failed:", error);
        }
        const isEnabled = await jsonContract.isContractEnabled();
        const stageData = {
            isEnabled: isEnabled,
            cells: isEnabled ? await jsonContract.getAllCellStates() : []
        };
        const totalValue = await jsonContract.calculateTotalValue();
        totalValues.push(totalValue);
        const progressPercentage = (index + 1) / contractAddresses.length * 100;
        progressFill.style.width = `${progressPercentage}%`;
        loadingText.textContent = `Loading stage ${index + 1} of ${contractAddresses.length}...`;
        stages.push(stageData);
    }
    loading.style.display = "none";
    return {
        stages: stages,
        totalValues: totalValues
    };
};


const $545c6c66f40f4e90$export$a5d6226c8a043d43 = (gridWidth, gridHeight)=>{
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = gridWidth * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE;
    tempCanvas.height = gridHeight * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE;
    const ctx = tempCanvas.getContext("2d");
    for(let x = 0; x <= gridWidth; x += (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE){
        ctx.moveTo(x, 0);
        ctx.lineTo(x, gridWidth);
    }
    for(let y = 0; y <= gridHeight; y += (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE){
        ctx.moveTo(0, y);
        ctx.lineTo(gridHeight, y);
    }
    ctx.stroke();
    return tempCanvas.toDataURL();
};
const $545c6c66f40f4e90$export$59b33278b5b2fc8a = (canvas, gridWidth, gridHeight)=>{
    const canvasContainer = document.getElementById("canvas-container");
    if (canvasContainer) {
        const width = canvasContainer.clientWidth;
        const height = canvasContainer.clientHeight;
        const scaleX = width / (gridWidth * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE);
        const scaleY = height / (gridHeight * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE);
        const scale = Math.min(scaleX, scaleY);
        canvas.setZoom(scale);
        canvas.setWidth(gridWidth * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE * scale);
        canvas.setHeight(gridHeight * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE * scale);
        const gridImageUrl = $545c6c66f40f4e90$export$a5d6226c8a043d43(gridWidth, gridHeight);
        canvas.setBackgroundColor(gridImageUrl, ()=>canvas.renderAll());
        canvas.renderAll();
        canvas.backgroundColor = "#000";
        canvas.calcOffset();
    }
};
const $545c6c66f40f4e90$export$29974350ada22cc = (buyer, x, y, numLayers, color, stageIndex, updatedTotalValues)=>{
    const canvas = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).canvas;
    const square = canvas.getObjects().find((obj)=>obj.gridX === x && obj.gridY === y && obj.stage === stageIndex);
    if (square) {
        square.set("fill", color);
        square.originalFill = color;
        const updatedLayers = [
            ...square.squareLayers
        ];
        for(let i = 0; i < numLayers; i++)updatedLayers.push({
            owner: buyer,
            color: color
        });
        square.set("squareLayers", updatedLayers);
        if ((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare && (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridX === x && (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.gridY === y && (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.stage === stageIndex) {
            (0, $21f5148a80ac224a$export$23be2efcbc791729)(square);
            (0, $729ea772109e18d1$export$3b6a950eac59b37b)(canvas);
        }
    }
    const stage1Value = Number((0, $b25678c505cad7eb$export$65957730cfdf9e4a)(updatedTotalValues[0]));
    const stage2Value = Number((0, $b25678c505cad7eb$export$65957730cfdf9e4a)(updatedTotalValues[1]));
    const requiredValueLabel = $545c6c66f40f4e90$var$getTextLabelById(canvas, "requiredLabel");
    if (requiredValueLabel) requiredValueLabel.text = $545c6c66f40f4e90$export$9079447489a9f8f0(stageIndex + 1, stage1Value, stage2Value);
    if ($545c6c66f40f4e90$export$4091f382b0699a77(stageIndex + 1, stage1Value, stage2Value)) {
        const notEnabledLabel = $545c6c66f40f4e90$var$getTextLabelById(canvas, "lockedLabel");
        if (notEnabledLabel) {
            notEnabledLabel.text = "Waiting for owner unlock";
            notEnabledLabel.fill = "green";
        }
    }
    canvas.renderAll();
};
const $545c6c66f40f4e90$export$215bb1a35ab734b = async ()=>{
    const canvas = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).canvas;
    canvas.clear();
    const { stages: stages, totalValues: totalValues } = await (0, $e24c02b8466da3c0$export$ea813f19c3e0b982)();
    (0, $9cbf3eecf538ac51$export$c6141e7c4932b646)(stages, totalValues);
};
const $545c6c66f40f4e90$export$4091f382b0699a77 = (stageIndex, stage1Value, stage2Value)=>{
    if (stageIndex === 1) return stage1Value >= (0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE2_ACTIVATION;
    else if (stageIndex === 2) return stage1Value >= (0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE3_STAGE1_ACTIVATION && stage2Value >= (0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE3_STAGE2_ACTIVATION;
    return false;
};
const $545c6c66f40f4e90$export$9079447489a9f8f0 = (stageIndex, stage1Value, stage2Value)=>{
    if (stageIndex === 1) return $545c6c66f40f4e90$export$4091f382b0699a77(stageIndex, stage1Value, stage2Value) ? "Requirement Completed" : `Stage 1 Total Value: ${stage1Value}/${(0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE2_ACTIVATION} Matic`;
    else if (stageIndex === 2) {
        const stage1Text = $545c6c66f40f4e90$export$4091f382b0699a77(1, stage1Value, 0) ? "Requirement 1 Completed" : `Stage 1 Total Value: ${stage1Value}/${(0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE3_STAGE1_ACTIVATION} Matic`;
        const stage2Text = $545c6c66f40f4e90$export$4091f382b0699a77(2, stage1Value, stage2Value) ? "Requirement 2 Completed" : `Stage 2 Total Value: ${stage2Value}/${(0, $ebeb53aaa150c8a5$export$724cfc3c1832d401).STAGE3_STAGE2_ACTIVATION} Matic`;
        return `${stage1Text}\n${stage2Text}`;
    }
    return "";
};
const $545c6c66f40f4e90$export$ff001dbd3f9c7192 = (text, options, id)=>{
    const defaultOptions = {
        fontFamily: "kirbyss",
        originX: "center",
        selectable: false
    };
    const textLabel = new (0, $d47795690082d4de$exports.fabric).Text(text, {
        ...defaultOptions,
        ...options
    });
    if (id) textLabel.id = id;
    return textLabel;
};
// 3. Provide a function to get a text label by its ID
const $545c6c66f40f4e90$var$getTextLabelById = (canvas, id)=>{
    return canvas.getObjects().find((obj)=>obj.type === "text" && obj.id === id);
};


var $f9bbb86703865016$exports = {};

$f9bbb86703865016$exports = new URL((parcelRequire("27Lyk")).resolve("52UL3"), import.meta.url).toString();


var $ff48ac64f72838e4$exports = {};

$ff48ac64f72838e4$exports = new URL((parcelRequire("27Lyk")).resolve("dZYA4"), import.meta.url).toString();





const $9cbf3eecf538ac51$var$getGridWidth = (stages)=>stages[0]?.cells[0]?.length || 0;
const $9cbf3eecf538ac51$var$getTotalHeight = (stages)=>{
    const contentHeight = stages.reduce((acc, stage)=>acc + stage.cells.length, 0);
    const hasDisabledStage = stages.some((stage)=>!stage.isEnabled);
    return contentHeight + (hasDisabledStage ? (0, $ebeb53aaa150c8a5$export$2b0b8facff24bd81) : 0);
};
const $9cbf3eecf538ac51$var$setCanvasDimensions = (canvas, gridWidth, totalHeight)=>{
    canvas.setWidth(gridWidth * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE);
    canvas.setHeight(totalHeight * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE);
};
const $9cbf3eecf538ac51$var$createCanvas = (stages)=>{
    const gridWidth = $9cbf3eecf538ac51$var$getGridWidth(stages);
    const totalHeight = $9cbf3eecf538ac51$var$getTotalHeight(stages);
    const canvas = (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).canvas;
    $9cbf3eecf538ac51$var$setCanvasDimensions(canvas, gridWidth, totalHeight);
    canvas.backgroundColor = (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).BACKGROUND_COLOR;
    canvas.renderAll();
    const handleResize = ()=>{
        (0, $545c6c66f40f4e90$export$59b33278b5b2fc8a)((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).canvas, $9cbf3eecf538ac51$var$getGridWidth(stages), $9cbf3eecf538ac51$var$getTotalHeight(stages));
    };
    window.removeEventListener("resize", handleResize);
    window.addEventListener("resize", handleResize);
    (0, $545c6c66f40f4e90$export$59b33278b5b2fc8a)(canvas, gridWidth, totalHeight);
    return canvas;
};
const $9cbf3eecf538ac51$var$setupCanvasContent = (canvas, allCells, yOffset, stage)=>{
    const gridHeight = allCells.length;
    const gridWidth = allCells[0].length;
    const gridImageUrl = (0, $545c6c66f40f4e90$export$a5d6226c8a043d43)(gridWidth, gridHeight);
    canvas.setBackgroundColor(gridImageUrl, ()=>canvas.renderAll());
    canvas.backgroundColor = "#000";
    const squares = [];
    for(let y = 0; y < gridHeight; y++)for(let x = 0; x < gridWidth; x++){
        let fillColor = "#000";
        let cell = allCells[y][x];
        let currentValue = Number((0, $b25678c505cad7eb$export$65957730cfdf9e4a)(cell.baseValue));
        if (cell.layers.length > 0) fillColor = cell.layers[cell.layers.length - 1].color;
        const square = new (0, $d47795690082d4de$exports.fabric).Rect({
            squareLayers: cell.layers,
            width: (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE,
            height: (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE,
            stroke: (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).GRID_COLOR,
            fill: fillColor,
            gridX: x,
            gridY: y,
            stage: stage,
            yOffset: yOffset,
            top: (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE * y + yOffset * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE,
            left: (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE * x,
            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hoverCursor: "pointer",
            originalFill: fillColor,
            squareValue: currentValue
        });
        square.on("mousedown", function(e) {
            if (!e.target) return;
            const clickedSquare = e.target;
            if ((0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare && (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare !== clickedSquare) {
                (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.set("strokeWidth", 1);
                (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.set("fill", (0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.originalFill);
            }
            e.target.set("strokeWidth", 4);
            (0, $21f5148a80ac224a$export$23be2efcbc791729)(clickedSquare);
            if (!(0, $21f5148a80ac224a$export$6f57813fe9f31bf9).selectedSquare.squareValue) return;
            (0, $729ea772109e18d1$export$3b6a950eac59b37b)(canvas);
        });
        squares.push(square);
    }
    canvas.add(...squares);
    return canvas;
};
const $9cbf3eecf538ac51$export$c6141e7c4932b646 = (stages, totalValues)=>{
    (0, $729ea772109e18d1$export$6b9419ea3588c2ce)(false);
    const canvas = $9cbf3eecf538ac51$var$createCanvas(stages);
    let yOffset = 0;
    for (const [index, stage] of stages.entries())if (stage.isEnabled) {
        $9cbf3eecf538ac51$var$setupCanvasContent(canvas, stage.cells, yOffset, index);
        yOffset += stage.cells.length;
    } else {
        $9cbf3eecf538ac51$var$setupDisabledStageContent(stages, canvas, index, totalValues, yOffset);
        break;
    }
    return canvas;
};
const $9cbf3eecf538ac51$var$setupDisabledStageContent = (stages, canvas, stageIndex, totalValues, yOffset)=>{
    const imageUrl = stageIndex === 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($f9bbb86703865016$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ff48ac64f72838e4$exports)));
    const gridWidth = $9cbf3eecf538ac51$var$getGridWidth(stages);
    (0, $d47795690082d4de$exports.fabric).Image.fromURL(imageUrl, (img)=>{
        const scaleFactor = (0, $ebeb53aaa150c8a5$export$2b0b8facff24bd81) * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE / img.height;
        img.set({
            left: 0,
            top: yOffset * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE,
            selectable: false,
            scaleX: scaleFactor,
            scaleY: scaleFactor
        });
        const overlayRect = new (0, $d47795690082d4de$exports.fabric).Rect({
            left: -1,
            top: img.top,
            width: img.width * scaleFactor,
            height: img.height * scaleFactor,
            fill: "rgba(0, 0, 0, 0.5)",
            selectable: false
        });
        canvas.add(img, overlayRect);
        const middleY = img.top + img.height * scaleFactor / 2;
        const labelLeftPosition = gridWidth * (0, $ebeb53aaa150c8a5$export$3fea9e4a2e457811).CELL_SIZE * 0.5;
        const stageLabel = (0, $545c6c66f40f4e90$export$ff001dbd3f9c7192)(`STAGE ${stageIndex + 1}`, {
            left: labelLeftPosition,
            top: middleY - 140,
            fontSize: 60,
            fill: "white"
        }, "stageLabel");
        const notEnabledLabel = (0, $545c6c66f40f4e90$export$ff001dbd3f9c7192)("Locked", {
            left: labelLeftPosition,
            top: middleY + 60,
            fontSize: 60,
            fill: "red"
        }, "lockedLabel");
        const stage1Value = Number((0, $b25678c505cad7eb$export$65957730cfdf9e4a)(totalValues[0]));
        const stage2Value = Number((0, $b25678c505cad7eb$export$65957730cfdf9e4a)(totalValues[1]));
        const requiredTotalValueText = (0, $545c6c66f40f4e90$export$9079447489a9f8f0)(stageIndex, stage1Value, stage2Value);
        if ((0, $545c6c66f40f4e90$export$4091f382b0699a77)(stageIndex, stage1Value, stage2Value)) {
            notEnabledLabel.text = "Waiting for owner unlock";
            notEnabledLabel.fill = "green";
        }
        const requiredValueLabel = (0, $545c6c66f40f4e90$export$ff001dbd3f9c7192)(requiredTotalValueText, {
            left: labelLeftPosition,
            top: middleY - 50,
            fontSize: 30,
            fill: "yellow"
        }, "requiredLabel");
        canvas.add(stageLabel, notEnabledLabel, requiredValueLabel);
    });
};






const $1ec729470124f9df$export$2646d8d5d7490e88 = (message)=>{
    const walletModal = document.getElementById("wallet-modal");
    const modalMessage = document.getElementById("modal-message");
    if (walletModal && modalMessage) {
        if (message) modalMessage.textContent = message;
        else modalMessage.textContent = "";
        walletModal.style.display = "block";
    }
};
const $1ec729470124f9df$export$1424ed3c498486d6 = ()=>{
    const walletModal = document.getElementById("wallet-modal");
    if (walletModal) walletModal.style.display = "none";
};


const $0f8ff9c1160a302e$var$displayConnectedAddress = (address)=>{
    document.getElementById("connect-text").style.display = "none";
    document.getElementById("address-text").style.display = "flex";
    document.getElementById("account-address").textContent = `${address.slice(0, 4)}...${address.slice(-4)}`;
};
const $0f8ff9c1160a302e$export$361f7c0427aa77bf = async ()=>{
    (0, $ea628fd0157746c4$export$df59ff80389de45e)();
    const closeNotificationButton = document.getElementById("close-notification");
    if (closeNotificationButton) closeNotificationButton.addEventListener("click", (0, $3f60ff68fab9c0db$export$87f1090575f0067e));
    const connectButton = document.getElementById("connect-wallet");
    const closeModalButton = document.getElementById("close-modal");
    const metamaskOption = document.getElementById("metamask-option");
    const purchaseLayerButton = document.getElementById("purchase-button");
    if (purchaseLayerButton) purchaseLayerButton.addEventListener("click", (0, $6130628d7489df3b$export$3ae1631d8cfdd256));
    if (connectButton) connectButton.addEventListener("click", ()=>{
        (0, $1ec729470124f9df$export$2646d8d5d7490e88)("");
    });
    if (closeModalButton) closeModalButton.addEventListener("click", (0, $1ec729470124f9df$export$1424ed3c498486d6));
    if (metamaskOption) {
        metamaskOption.addEventListener("click", async ()=>{
            console.log("Connecting with MetaMask...");
            if (typeof window.ethereum !== "undefined") try {
                const accounts = await window.ethereum.request({
                    method: "eth_requestAccounts"
                });
                if (accounts.length > 0) {
                    console.log("Account access granted.");
                    const connectedAddress = accounts[0];
                    console.log("Connected address:", connectedAddress);
                    try {
                        await window.ethereum.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: "0x89"
                                }
                            ]
                        });
                        console.log("Switched to the Polygon network.");
                    } catch (switchError) {
                        console.error("Error switching to Polygon:", switchError);
                    }
                    $0f8ff9c1160a302e$var$displayConnectedAddress(connectedAddress);
                    (0, $1ec729470124f9df$export$1424ed3c498486d6)();
                } else console.log("Account access denied.");
            } catch (err) {
                console.error("Error connecting to MetaMask:", err);
            }
            else console.log("MetaMask is not installed.");
        });
        if (typeof window.ethereum !== "undefined" && window.ethereum.isConnected()) {
            const accounts = await window.ethereum.request({
                method: "eth_accounts"
            });
            if (accounts.length > 0) {
                const connectedAddress = accounts[0];
                $0f8ff9c1160a302e$var$displayConnectedAddress(connectedAddress);
            }
        }
    }
};




document.addEventListener("DOMContentLoaded", async ()=>{
    let stages, totalValues;
    (0, $0f8ff9c1160a302e$export$361f7c0427aa77bf)();
    try {
        ({ stages: stages, totalValues: totalValues } = await (0, $e24c02b8466da3c0$export$ea813f19c3e0b982)());
    } catch (error) {
        if (error.message === "Failed to get a provider.") (0, $1ec729470124f9df$export$2646d8d5d7490e88)();
        else (0, $3f60ff68fab9c0db$export$f7dc72e91f29c7d7)("Error fetching data from provider. Please retry again later.");
    }
    if (stages && stages.length > 0) (0, $9cbf3eecf538ac51$export$c6141e7c4932b646)(stages, totalValues);
});


//# sourceMappingURL=index.21dbb052.js.map
